var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __require = /* @__PURE__ */ ((x23) => typeof require !== "undefined" ? require : typeof Proxy !== "undefined" ? new Proxy(x23, {
  get: (a7, b25) => (typeof require !== "undefined" ? require : a7)[b25]
}) : x23)(function(x23) {
  if (typeof require !== "undefined") return require.apply(this, arguments);
  throw Error('Dynamic require of "' + x23 + '" is not supported');
});
var __esm = (fn4, res) => function __init() {
  return fn4 && (res = (0, fn4[__getOwnPropNames(fn4)[0]])(fn4 = 0)), res;
};
var __commonJS = (cb, mod) => function __require2() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to2, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to2, key) && key !== except)
        __defProp(to2, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to2;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-YNYSPYQ5.js
function T1(n23) {
  let t6 = 0;
  return n23.includes("i") && (t6 |= y.CASE_INSENSITIVE), n23.includes("m") && (t6 |= y.MULTILINE), n23.includes("s") && (t6 |= y.DOTALL), t6;
}
function N1(n23) {
  return y.translateRegExp(n23);
}
function b1(n23, t6 = "") {
  return new B(n23, t6);
}
var g, u, a, b, w, O, R1, I, F, X, P, _, m, v, U, z, V, L, $, j, N, E, W, Y, M, c, q, D, K, Z, d, n1, r1, a1, o1, l1, h1, u1, c1, p1, f1, g1, A1, w1, E1, d1, O1, C1, m1, S1, x, H, Q, J, t1, e1, s1, y, B, i1;
var init_chunk_YNYSPYQ5 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-YNYSPYQ5.js"() {
    g = class n {
      static FOLD_CASE = 1;
      static LITERAL = 2;
      static CLASS_NL = 4;
      static DOT_NL = 8;
      static ONE_LINE = 16;
      static NON_GREEDY = 32;
      static PERL_X = 64;
      static UNICODE_GROUPS = 128;
      static WAS_DOLLAR = 256;
      static MATCH_NL = n.CLASS_NL | n.DOT_NL;
      static PERL = n.CLASS_NL | n.ONE_LINE | n.PERL_X | n.UNICODE_GROUPS;
      static POSIX = 0;
      static UNANCHORED = 0;
      static ANCHOR_START = 1;
      static ANCHOR_BOTH = 2;
    };
    u = class {
      static CODES = /* @__PURE__ */ new Map([["\x07", 7], ["\b", 8], ["	", 9], [`
`, 10], ["\v", 11], ["\f", 12], ["\r", 13], [" ", 32], ['"', 34], ["$", 36], ["&", 38], ["(", 40], [")", 41], ["*", 42], ["+", 43], ["-", 45], [".", 46], ["0", 48], ["1", 49], ["2", 50], ["3", 51], ["4", 52], ["5", 53], ["6", 54], ["7", 55], ["8", 56], ["9", 57], [":", 58], ["<", 60], [">", 62], ["?", 63], ["A", 65], ["B", 66], ["C", 67], ["F", 70], ["P", 80], ["Q", 81], ["U", 85], ["Z", 90], ["[", 91], ["\\", 92], ["]", 93], ["^", 94], ["_", 95], ["a", 97], ["b", 98], ["f", 102], ["i", 105], ["m", 109], ["n", 110], ["r", 114], ["s", 115], ["t", 116], ["v", 118], ["x", 120], ["z", 122], ["{", 123], ["|", 124], ["}", 125]]);
      static toUpperCase(t6) {
        let e7 = String.fromCodePoint(t6).toUpperCase();
        if (e7.length > 1) return t6;
        let s9 = String.fromCodePoint(e7.codePointAt(0)).toLowerCase();
        return s9.length > 1 || s9.codePointAt(0) !== t6 ? t6 : e7.codePointAt(0);
      }
      static toLowerCase(t6) {
        let e7 = String.fromCodePoint(t6).toLowerCase();
        if (e7.length > 1) return t6;
        let s9 = String.fromCodePoint(e7.codePointAt(0)).toUpperCase();
        return s9.length > 1 || s9.codePointAt(0) !== t6 ? t6 : e7.codePointAt(0);
      }
    };
    a = class {
      SIZE = 3;
      constructor(t6) {
        this.data = t6;
      }
      getLo(t6) {
        return this.data[t6 * this.SIZE];
      }
      getHi(t6) {
        return this.data[t6 * this.SIZE + 1];
      }
      getStride(t6) {
        return this.data[t6 * this.SIZE + 2];
      }
      get(t6) {
        let e7 = t6 * this.SIZE;
        return [this.data[e7], this.data[e7 + 1], this.data[e7 + 2]];
      }
      get length() {
        return this.data.length / this.SIZE;
      }
    };
    b = class n2 {
      static CASE_ORBIT = /* @__PURE__ */ new Map([[75, 107], [107, 8490], [8490, 75], [83, 115], [115, 383], [383, 83], [181, 924], [924, 956], [956, 181], [197, 229], [229, 8491], [8491, 197], [452, 453], [453, 454], [454, 452], [455, 456], [456, 457], [457, 455], [458, 459], [459, 460], [460, 458], [497, 498], [498, 499], [499, 497], [837, 921], [921, 953], [953, 8126], [8126, 837], [914, 946], [946, 976], [976, 914], [917, 949], [949, 1013], [1013, 917], [920, 952], [952, 977], [977, 1012], [1012, 920], [922, 954], [954, 1008], [1008, 922], [928, 960], [960, 982], [982, 928], [929, 961], [961, 1009], [1009, 929], [931, 962], [962, 963], [963, 931], [934, 966], [966, 981], [981, 934], [937, 969], [969, 8486], [8486, 937], [1042, 1074], [1074, 7296], [7296, 1042], [1044, 1076], [1076, 7297], [7297, 1044], [1054, 1086], [1086, 7298], [7298, 1054], [1057, 1089], [1089, 7299], [7299, 1057], [1058, 1090], [1090, 7300], [7300, 7301], [7301, 1058], [1066, 1098], [1098, 7302], [7302, 1066], [1122, 1123], [1123, 7303], [7303, 1122], [7304, 42570], [42570, 42571], [42571, 7304], [7776, 7777], [7777, 7835], [7835, 7776], [223, 7838], [7838, 223], [8064, 8072], [8072, 8064], [8065, 8073], [8073, 8065], [8066, 8074], [8074, 8066], [8067, 8075], [8075, 8067], [8068, 8076], [8076, 8068], [8069, 8077], [8077, 8069], [8070, 8078], [8078, 8070], [8071, 8079], [8079, 8071], [8080, 8088], [8088, 8080], [8081, 8089], [8089, 8081], [8082, 8090], [8090, 8082], [8083, 8091], [8091, 8083], [8084, 8092], [8092, 8084], [8085, 8093], [8093, 8085], [8086, 8094], [8094, 8086], [8087, 8095], [8095, 8087], [8096, 8104], [8104, 8096], [8097, 8105], [8105, 8097], [8098, 8106], [8106, 8098], [8099, 8107], [8107, 8099], [8100, 8108], [8108, 8100], [8101, 8109], [8109, 8101], [8102, 8110], [8110, 8102], [8103, 8111], [8111, 8103], [8115, 8124], [8124, 8115], [8131, 8140], [8140, 8131], [912, 8147], [8147, 912], [944, 8163], [8163, 944], [8179, 8188], [8188, 8179], [64261, 64262], [64262, 64261], [66560, 66600], [66600, 66560], [66561, 66601], [66601, 66561], [66562, 66602], [66602, 66562], [66563, 66603], [66603, 66563], [66564, 66604], [66604, 66564], [66565, 66605], [66605, 66565], [66566, 66606], [66606, 66566], [66567, 66607], [66607, 66567], [66568, 66608], [66608, 66568], [66569, 66609], [66609, 66569], [66570, 66610], [66610, 66570], [66571, 66611], [66611, 66571], [66572, 66612], [66612, 66572], [66573, 66613], [66613, 66573], [66574, 66614], [66614, 66574], [66575, 66615], [66615, 66575], [66576, 66616], [66616, 66576], [66577, 66617], [66617, 66577], [66578, 66618], [66618, 66578], [66579, 66619], [66619, 66579], [66580, 66620], [66620, 66580], [66581, 66621], [66621, 66581], [66582, 66622], [66622, 66582], [66583, 66623], [66623, 66583], [66584, 66624], [66624, 66584], [66585, 66625], [66625, 66585], [66586, 66626], [66626, 66586], [66587, 66627], [66627, 66587], [66588, 66628], [66628, 66588], [66589, 66629], [66629, 66589], [66590, 66630], [66630, 66590], [66591, 66631], [66631, 66591], [66592, 66632], [66632, 66592], [66593, 66633], [66633, 66593], [66594, 66634], [66634, 66594], [66595, 66635], [66635, 66595], [66596, 66636], [66636, 66596], [66597, 66637], [66637, 66597], [66598, 66638], [66638, 66598], [66599, 66639], [66639, 66599], [66736, 66776], [66776, 66736], [66737, 66777], [66777, 66737], [66738, 66778], [66778, 66738], [66739, 66779], [66779, 66739], [66740, 66780], [66780, 66740], [66741, 66781], [66781, 66741], [66742, 66782], [66782, 66742], [66743, 66783], [66783, 66743], [66744, 66784], [66784, 66744], [66745, 66785], [66785, 66745], [66746, 66786], [66786, 66746], [66747, 66787], [66787, 66747], [66748, 66788], [66788, 66748], [66749, 66789], [66789, 66749], [66750, 66790], [66790, 66750], [66751, 66791], [66791, 66751], [66752, 66792], [66792, 66752], [66753, 66793], [66793, 66753], [66754, 66794], [66794, 66754], [66755, 66795], [66795, 66755], [66756, 66796], [66796, 66756], [66757, 66797], [66797, 66757], [66758, 66798], [66798, 66758], [66759, 66799], [66799, 66759], [66760, 66800], [66800, 66760], [66761, 66801], [66801, 66761], [66762, 66802], [66802, 66762], [66763, 66803], [66803, 66763], [66764, 66804], [66804, 66764], [66765, 66805], [66805, 66765], [66766, 66806], [66806, 66766], [66767, 66807], [66807, 66767], [66768, 66808], [66808, 66768], [66769, 66809], [66809, 66769], [66770, 66810], [66810, 66770], [66771, 66811], [66811, 66771], [66928, 66967], [66967, 66928], [66929, 66968], [66968, 66929], [66930, 66969], [66969, 66930], [66931, 66970], [66970, 66931], [66932, 66971], [66971, 66932], [66933, 66972], [66972, 66933], [66934, 66973], [66973, 66934], [66935, 66974], [66974, 66935], [66936, 66975], [66975, 66936], [66937, 66976], [66976, 66937], [66938, 66977], [66977, 66938], [66940, 66979], [66979, 66940], [66941, 66980], [66980, 66941], [66942, 66981], [66981, 66942], [66943, 66982], [66982, 66943], [66944, 66983], [66983, 66944], [66945, 66984], [66984, 66945], [66946, 66985], [66985, 66946], [66947, 66986], [66986, 66947], [66948, 66987], [66987, 66948], [66949, 66988], [66988, 66949], [66950, 66989], [66989, 66950], [66951, 66990], [66990, 66951], [66952, 66991], [66991, 66952], [66953, 66992], [66992, 66953], [66954, 66993], [66993, 66954], [66956, 66995], [66995, 66956], [66957, 66996], [66996, 66957], [66958, 66997], [66997, 66958], [66959, 66998], [66998, 66959], [66960, 66999], [66999, 66960], [66961, 67e3], [67e3, 66961], [66962, 67001], [67001, 66962], [66964, 67003], [67003, 66964], [66965, 67004], [67004, 66965], [68736, 68800], [68800, 68736], [68737, 68801], [68801, 68737], [68738, 68802], [68802, 68738], [68739, 68803], [68803, 68739], [68740, 68804], [68804, 68740], [68741, 68805], [68805, 68741], [68742, 68806], [68806, 68742], [68743, 68807], [68807, 68743], [68744, 68808], [68808, 68744], [68745, 68809], [68809, 68745], [68746, 68810], [68810, 68746], [68747, 68811], [68811, 68747], [68748, 68812], [68812, 68748], [68749, 68813], [68813, 68749], [68750, 68814], [68814, 68750], [68751, 68815], [68815, 68751], [68752, 68816], [68816, 68752], [68753, 68817], [68817, 68753], [68754, 68818], [68818, 68754], [68755, 68819], [68819, 68755], [68756, 68820], [68820, 68756], [68757, 68821], [68821, 68757], [68758, 68822], [68822, 68758], [68759, 68823], [68823, 68759], [68760, 68824], [68824, 68760], [68761, 68825], [68825, 68761], [68762, 68826], [68826, 68762], [68763, 68827], [68827, 68763], [68764, 68828], [68828, 68764], [68765, 68829], [68829, 68765], [68766, 68830], [68830, 68766], [68767, 68831], [68831, 68767], [68768, 68832], [68832, 68768], [68769, 68833], [68833, 68769], [68770, 68834], [68834, 68770], [68771, 68835], [68835, 68771], [68772, 68836], [68836, 68772], [68773, 68837], [68837, 68773], [68774, 68838], [68838, 68774], [68775, 68839], [68839, 68775], [68776, 68840], [68840, 68776], [68777, 68841], [68841, 68777], [68778, 68842], [68842, 68778], [68779, 68843], [68843, 68779], [68780, 68844], [68844, 68780], [68781, 68845], [68845, 68781], [68782, 68846], [68846, 68782], [68783, 68847], [68847, 68783], [68784, 68848], [68848, 68784], [68785, 68849], [68849, 68785], [68786, 68850], [68850, 68786], [68944, 68976], [68976, 68944], [68945, 68977], [68977, 68945], [68946, 68978], [68978, 68946], [68947, 68979], [68979, 68947], [68948, 68980], [68980, 68948], [68949, 68981], [68981, 68949], [68950, 68982], [68982, 68950], [68951, 68983], [68983, 68951], [68952, 68984], [68984, 68952], [68953, 68985], [68985, 68953], [68954, 68986], [68986, 68954], [68955, 68987], [68987, 68955], [68956, 68988], [68988, 68956], [68957, 68989], [68989, 68957], [68958, 68990], [68990, 68958], [68959, 68991], [68991, 68959], [68960, 68992], [68992, 68960], [68961, 68993], [68993, 68961], [68962, 68994], [68994, 68962], [68963, 68995], [68995, 68963], [68964, 68996], [68996, 68964], [68965, 68997], [68997, 68965], [71840, 71872], [71872, 71840], [71841, 71873], [71873, 71841], [71842, 71874], [71874, 71842], [71843, 71875], [71875, 71843], [71844, 71876], [71876, 71844], [71845, 71877], [71877, 71845], [71846, 71878], [71878, 71846], [71847, 71879], [71879, 71847], [71848, 71880], [71880, 71848], [71849, 71881], [71881, 71849], [71850, 71882], [71882, 71850], [71851, 71883], [71883, 71851], [71852, 71884], [71884, 71852], [71853, 71885], [71885, 71853], [71854, 71886], [71886, 71854], [71855, 71887], [71887, 71855], [71856, 71888], [71888, 71856], [71857, 71889], [71889, 71857], [71858, 71890], [71890, 71858], [71859, 71891], [71891, 71859], [71860, 71892], [71892, 71860], [71861, 71893], [71893, 71861], [71862, 71894], [71894, 71862], [71863, 71895], [71895, 71863], [71864, 71896], [71896, 71864], [71865, 71897], [71897, 71865], [71866, 71898], [71898, 71866], [71867, 71899], [71899, 71867], [71868, 71900], [71900, 71868], [71869, 71901], [71901, 71869], [71870, 71902], [71902, 71870], [71871, 71903], [71903, 71871], [93760, 93792], [93792, 93760], [93761, 93793], [93793, 93761], [93762, 93794], [93794, 93762], [93763, 93795], [93795, 93763], [93764, 93796], [93796, 93764], [93765, 93797], [93797, 93765], [93766, 93798], [93798, 93766], [93767, 93799], [93799, 93767], [93768, 93800], [93800, 93768], [93769, 93801], [93801, 93769], [93770, 93802], [93802, 93770], [93771, 93803], [93803, 93771], [93772, 93804], [93804, 93772], [93773, 93805], [93805, 93773], [93774, 93806], [93806, 93774], [93775, 93807], [93807, 93775], [93776, 93808], [93808, 93776], [93777, 93809], [93809, 93777], [93778, 93810], [93810, 93778], [93779, 93811], [93811, 93779], [93780, 93812], [93812, 93780], [93781, 93813], [93813, 93781], [93782, 93814], [93814, 93782], [93783, 93815], [93815, 93783], [93784, 93816], [93816, 93784], [93785, 93817], [93817, 93785], [93786, 93818], [93818, 93786], [93787, 93819], [93819, 93787], [93788, 93820], [93820, 93788], [93789, 93821], [93821, 93789], [93790, 93822], [93822, 93790], [93791, 93823], [93823, 93791], [125184, 125218], [125218, 125184], [125185, 125219], [125219, 125185], [125186, 125220], [125220, 125186], [125187, 125221], [125221, 125187], [125188, 125222], [125222, 125188], [125189, 125223], [125223, 125189], [125190, 125224], [125224, 125190], [125191, 125225], [125225, 125191], [125192, 125226], [125226, 125192], [125193, 125227], [125227, 125193], [125194, 125228], [125228, 125194], [125195, 125229], [125229, 125195], [125196, 125230], [125230, 125196], [125197, 125231], [125231, 125197], [125198, 125232], [125232, 125198], [125199, 125233], [125233, 125199], [125200, 125234], [125234, 125200], [125201, 125235], [125235, 125201], [125202, 125236], [125236, 125202], [125203, 125237], [125237, 125203], [125204, 125238], [125238, 125204], [125205, 125239], [125239, 125205], [125206, 125240], [125240, 125206], [125207, 125241], [125241, 125207], [125208, 125242], [125242, 125208], [125209, 125243], [125243, 125209], [125210, 125244], [125244, 125210], [125211, 125245], [125245, 125211], [125212, 125246], [125246, 125212], [125213, 125247], [125247, 125213], [125214, 125248], [125248, 125214], [125215, 125249], [125249, 125215], [125216, 125250], [125250, 125216], [125217, 125251], [125251, 125217]]);
      static C = new a(new Uint32Array([0, 31, 1, 127, 159, 1, 173, 888, 715, 889, 896, 7, 897, 899, 1, 907, 909, 2, 930, 1328, 398, 1367, 1368, 1, 1419, 1420, 1, 1424, 1480, 56, 1481, 1487, 1, 1515, 1518, 1, 1525, 1541, 1, 1564, 1757, 193, 1806, 1807, 1, 1867, 1868, 1, 1970, 1983, 1, 2043, 2044, 1, 2094, 2095, 1, 2111, 2140, 29, 2141, 2143, 2, 2155, 2159, 1, 2191, 2198, 1, 2274, 2436, 162, 2445, 2446, 1, 2449, 2450, 1, 2473, 2481, 8, 2483, 2485, 1, 2490, 2491, 1, 2501, 2502, 1, 2505, 2506, 1, 2511, 2518, 1, 2520, 2523, 1, 2526, 2532, 6, 2533, 2559, 26, 2560, 2564, 4, 2571, 2574, 1, 2577, 2578, 1, 2601, 2609, 8, 2612, 2618, 3, 2619, 2621, 2, 2627, 2630, 1, 2633, 2634, 1, 2638, 2640, 1, 2642, 2648, 1, 2653, 2655, 2, 2656, 2661, 1, 2679, 2688, 1, 2692, 2702, 10, 2706, 2729, 23, 2737, 2740, 3, 2746, 2747, 1, 2758, 2766, 4, 2767, 2769, 2, 2770, 2783, 1, 2788, 2789, 1, 2802, 2808, 1, 2816, 2820, 4, 2829, 2830, 1, 2833, 2834, 1, 2857, 2865, 8, 2868, 2874, 6, 2875, 2885, 10, 2886, 2889, 3, 2890, 2894, 4, 2895, 2900, 1, 2904, 2907, 1, 2910, 2916, 6, 2917, 2936, 19, 2937, 2945, 1, 2948, 2955, 7, 2956, 2957, 1, 2961, 2966, 5, 2967, 2968, 1, 2971, 2973, 2, 2976, 2978, 1, 2981, 2983, 1, 2987, 2989, 1, 3002, 3005, 1, 3011, 3013, 1, 3017, 3022, 5, 3023, 3025, 2, 3026, 3030, 1, 3032, 3045, 1, 3067, 3071, 1, 3085, 3089, 4, 3113, 3130, 17, 3131, 3141, 10, 3145, 3150, 5, 3151, 3156, 1, 3159, 3163, 4, 3164, 3166, 2, 3167, 3172, 5, 3173, 3184, 11, 3185, 3190, 1, 3213, 3217, 4, 3241, 3252, 11, 3258, 3259, 1, 3269, 3273, 4, 3278, 3284, 1, 3287, 3292, 1, 3295, 3300, 5, 3301, 3312, 11, 3316, 3327, 1, 3341, 3345, 4, 3397, 3401, 4, 3408, 3411, 1, 3428, 3429, 1, 3456, 3460, 4, 3479, 3481, 1, 3506, 3516, 10, 3518, 3519, 1, 3527, 3529, 1, 3531, 3534, 1, 3541, 3543, 2, 3552, 3557, 1, 3568, 3569, 1, 3573, 3584, 1, 3643, 3646, 1, 3676, 3712, 1, 3715, 3717, 2, 3723, 3748, 25, 3750, 3774, 24, 3775, 3781, 6, 3783, 3791, 8, 3802, 3803, 1, 3808, 3839, 1, 3912, 3949, 37, 3950, 3952, 1, 3992, 4029, 37, 4045, 4059, 14, 4060, 4095, 1, 4294, 4296, 2, 4297, 4300, 1, 4302, 4303, 1, 4681, 4686, 5, 4687, 4695, 8, 4697, 4702, 5, 4703, 4745, 42, 4750, 4751, 1, 4785, 4790, 5, 4791, 4799, 8, 4801, 4806, 5, 4807, 4823, 16, 4881, 4886, 5, 4887, 4955, 68, 4956, 4989, 33, 4990, 4991, 1, 5018, 5023, 1, 5110, 5111, 1, 5118, 5119, 1, 5789, 5791, 1, 5881, 5887, 1, 5910, 5918, 1, 5943, 5951, 1, 5972, 5983, 1, 5997, 6001, 4, 6004, 6015, 1, 6110, 6111, 1, 6122, 6127, 1, 6138, 6143, 1, 6158, 6170, 12, 6171, 6175, 1, 6265, 6271, 1, 6315, 6319, 1, 6390, 6399, 1, 6431, 6444, 13, 6445, 6447, 1, 6460, 6463, 1, 6465, 6467, 1, 6510, 6511, 1, 6517, 6527, 1, 6572, 6575, 1, 6602, 6607, 1, 6619, 6621, 1, 6684, 6685, 1, 6751, 6781, 30, 6782, 6794, 12, 6795, 6799, 1, 6810, 6815, 1, 6830, 6831, 1, 6863, 6911, 1, 6989, 7156, 167, 7157, 7163, 1, 7224, 7226, 1, 7242, 7244, 1, 7307, 7311, 1, 7355, 7356, 1, 7368, 7375, 1, 7419, 7423, 1, 7958, 7959, 1, 7966, 7967, 1, 8006, 8007, 1, 8014, 8015, 1, 8024, 8030, 2, 8062, 8063, 1, 8117, 8133, 16, 8148, 8149, 1, 8156, 8176, 20, 8177, 8181, 4, 8191, 8203, 12, 8204, 8207, 1, 8234, 8238, 1, 8288, 8303, 1, 8306, 8307, 1, 8335, 8349, 14, 8350, 8351, 1, 8385, 8399, 1, 8433, 8447, 1, 8588, 8591, 1, 9258, 9279, 1, 9291, 9311, 1, 11124, 11125, 1, 11158, 11508, 350, 11509, 11512, 1, 11558, 11560, 2, 11561, 11564, 1, 11566, 11567, 1, 11624, 11630, 1, 11633, 11646, 1, 11671, 11679, 1, 11687, 11743, 8, 11870, 11903, 1, 11930, 12020, 90, 12021, 12031, 1, 12246, 12271, 1, 12352, 12439, 87, 12440, 12544, 104, 12545, 12548, 1, 12592, 12687, 95, 12774, 12782, 1, 12831, 42125, 29294, 42126, 42127, 1, 42183, 42191, 1, 42540, 42559, 1, 42744, 42751, 1, 42958, 42959, 1, 42962, 42964, 2, 42973, 42993, 1, 43053, 43055, 1, 43066, 43071, 1, 43128, 43135, 1, 43206, 43213, 1, 43226, 43231, 1, 43348, 43358, 1, 43389, 43391, 1, 43470, 43482, 12, 43483, 43485, 1, 43519, 43575, 56, 43576, 43583, 1, 43598, 43599, 1, 43610, 43611, 1, 43715, 43738, 1, 43767, 43776, 1, 43783, 43784, 1, 43791, 43792, 1, 43799, 43807, 1, 43815, 43823, 8, 43884, 43887, 1, 44014, 44015, 1, 44026, 44031, 1, 55204, 55215, 1, 55239, 55242, 1, 55292, 63743, 1, 64110, 64111, 1, 64218, 64255, 1, 64263, 64274, 1, 64280, 64284, 1, 64311, 64317, 6, 64319, 64325, 3, 64451, 64466, 1, 64912, 64913, 1, 64968, 64974, 1, 64976, 65007, 1, 65050, 65055, 1, 65107, 65127, 20, 65132, 65135, 1, 65141, 65277, 136, 65278, 65280, 1, 65471, 65473, 1, 65480, 65481, 1, 65488, 65489, 1, 65496, 65497, 1, 65501, 65503, 1, 65511, 65519, 8, 65520, 65531, 1, 65534, 65535, 1, 65548, 65575, 27, 65595, 65598, 3, 65614, 65615, 1, 65630, 65663, 1, 65787, 65791, 1, 65795, 65798, 1, 65844, 65846, 1, 65935, 65949, 14, 65950, 65951, 1, 65953, 65999, 1, 66046, 66175, 1, 66205, 66207, 1, 66257, 66271, 1, 66300, 66303, 1, 66340, 66348, 1, 66379, 66383, 1, 66427, 66431, 1, 66462, 66500, 38, 66501, 66503, 1, 66518, 66559, 1, 66718, 66719, 1, 66730, 66735, 1, 66772, 66775, 1, 66812, 66815, 1, 66856, 66863, 1, 66916, 66926, 1, 66939, 66955, 16, 66963, 66966, 3, 66978, 66994, 16, 67002, 67005, 3, 67006, 67007, 1, 67060, 67071, 1, 67383, 67391, 1, 67414, 67423, 1, 67432, 67455, 1, 67462, 67505, 43, 67515, 67583, 1, 67590, 67591, 1, 67593, 67638, 45, 67641, 67643, 1, 67645, 67646, 1, 67670, 67743, 73, 67744, 67750, 1, 67760, 67807, 1, 67827, 67830, 3, 67831, 67834, 1, 67868, 67870, 1, 67898, 67902, 1, 67904, 67967, 1, 68024, 68027, 1, 68048, 68049, 1, 68100, 68103, 3, 68104, 68107, 1, 68116, 68120, 4, 68150, 68151, 1, 68155, 68158, 1, 68169, 68175, 1, 68185, 68191, 1, 68256, 68287, 1, 68327, 68330, 1, 68343, 68351, 1, 68406, 68408, 1, 68438, 68439, 1, 68467, 68471, 1, 68498, 68504, 1, 68509, 68520, 1, 68528, 68607, 1, 68681, 68735, 1, 68787, 68799, 1, 68851, 68857, 1, 68904, 68911, 1, 68922, 68927, 1, 68966, 68968, 1, 68998, 69005, 1, 69008, 69215, 1, 69247, 69290, 43, 69294, 69295, 1, 69298, 69313, 1, 69317, 69371, 1, 69416, 69423, 1, 69466, 69487, 1, 69514, 69551, 1, 69580, 69599, 1, 69623, 69631, 1, 69710, 69713, 1, 69750, 69758, 1, 69821, 69827, 6, 69828, 69839, 1, 69865, 69871, 1, 69882, 69887, 1, 69941, 69960, 19, 69961, 69967, 1, 70007, 70015, 1, 70112, 70133, 21, 70134, 70143, 1, 70162, 70210, 48, 70211, 70271, 1, 70279, 70281, 2, 70286, 70302, 16, 70314, 70319, 1, 70379, 70383, 1, 70394, 70399, 1, 70404, 70413, 9, 70414, 70417, 3, 70418, 70441, 23, 70449, 70452, 3, 70458, 70469, 11, 70470, 70473, 3, 70474, 70478, 4, 70479, 70481, 2, 70482, 70486, 1, 70488, 70492, 1, 70500, 70501, 1, 70509, 70511, 1, 70517, 70527, 1, 70538, 70540, 2, 70541, 70543, 2, 70582, 70593, 11, 70595, 70596, 1, 70598, 70603, 5, 70614, 70617, 3, 70618, 70624, 1, 70627, 70655, 1, 70748, 70754, 6, 70755, 70783, 1, 70856, 70863, 1, 70874, 71039, 1, 71094, 71095, 1, 71134, 71167, 1, 71237, 71247, 1, 71258, 71263, 1, 71277, 71295, 1, 71354, 71359, 1, 71370, 71375, 1, 71396, 71423, 1, 71451, 71452, 1, 71468, 71471, 1, 71495, 71679, 1, 71740, 71839, 1, 71923, 71934, 1, 71943, 71944, 1, 71946, 71947, 1, 71956, 71959, 3, 71990, 71993, 3, 71994, 72007, 13, 72008, 72015, 1, 72026, 72095, 1, 72104, 72105, 1, 72152, 72153, 1, 72165, 72191, 1, 72264, 72271, 1, 72355, 72367, 1, 72441, 72447, 1, 72458, 72639, 1, 72674, 72687, 1, 72698, 72703, 1, 72713, 72759, 46, 72774, 72783, 1, 72813, 72815, 1, 72848, 72849, 1, 72872, 72887, 15, 72888, 72959, 1, 72967, 72970, 3, 73015, 73017, 1, 73019, 73022, 3, 73032, 73039, 1, 73050, 73055, 1, 73062, 73065, 3, 73103, 73106, 3, 73113, 73119, 1, 73130, 73439, 1, 73465, 73471, 1, 73489, 73531, 42, 73532, 73533, 1, 73563, 73647, 1, 73649, 73663, 1, 73714, 73726, 1, 74650, 74751, 1, 74863, 74869, 6, 74870, 74879, 1, 75076, 77711, 1, 77811, 77823, 1, 78896, 78911, 1, 78934, 78943, 1, 82939, 82943, 1, 83527, 90367, 1, 90426, 92159, 1, 92729, 92735, 1, 92767, 92778, 11, 92779, 92781, 1, 92863, 92874, 11, 92875, 92879, 1, 92910, 92911, 1, 92918, 92927, 1, 92998, 93007, 1, 93018, 93026, 8, 93048, 93052, 1, 93072, 93503, 1, 93562, 93759, 1, 93851, 93951, 1, 94027, 94030, 1, 94088, 94094, 1, 94112, 94175, 1, 94181, 94191, 1, 94194, 94207, 1, 100344, 100351, 1, 101590, 101630, 1, 101641, 110575, 1, 110580, 110588, 8, 110591, 110883, 292, 110884, 110897, 1, 110899, 110927, 1, 110931, 110932, 1, 110934, 110947, 1, 110952, 110959, 1, 111356, 113663, 1, 113771, 113775, 1, 113789, 113791, 1, 113801, 113807, 1, 113818, 113819, 1, 113824, 117759, 1, 118010, 118015, 1, 118452, 118527, 1, 118574, 118575, 1, 118599, 118607, 1, 118724, 118783, 1, 119030, 119039, 1, 119079, 119080, 1, 119155, 119162, 1, 119275, 119295, 1, 119366, 119487, 1, 119508, 119519, 1, 119540, 119551, 1, 119639, 119647, 1, 119673, 119807, 1, 119893, 119965, 72, 119968, 119969, 1, 119971, 119972, 1, 119975, 119976, 1, 119981, 119994, 13, 119996, 120004, 8, 120070, 120075, 5, 120076, 120085, 9, 120093, 120122, 29, 120127, 120133, 6, 120135, 120137, 1, 120145, 120486, 341, 120487, 120780, 293, 120781, 121484, 703, 121485, 121498, 1, 121504, 121520, 16, 121521, 122623, 1, 122655, 122660, 1, 122667, 122879, 1, 122887, 122905, 18, 122906, 122914, 8, 122917, 122923, 6, 122924, 122927, 1, 122990, 123022, 1, 123024, 123135, 1, 123181, 123183, 1, 123198, 123199, 1, 123210, 123213, 1, 123216, 123535, 1, 123567, 123583, 1, 123642, 123646, 1, 123648, 124111, 1, 124154, 124367, 1, 124411, 124414, 1, 124416, 124895, 1, 124903, 124908, 5, 124911, 124927, 16, 125125, 125126, 1, 125143, 125183, 1, 125260, 125263, 1, 125274, 125277, 1, 125280, 126064, 1, 126133, 126208, 1, 126270, 126463, 1, 126468, 126496, 28, 126499, 126501, 2, 126502, 126504, 2, 126515, 126520, 5, 126522, 126524, 2, 126525, 126529, 1, 126531, 126534, 1, 126536, 126540, 2, 126544, 126547, 3, 126549, 126550, 1, 126552, 126560, 2, 126563, 126565, 2, 126566, 126571, 5, 126579, 126589, 5, 126591, 126602, 11, 126620, 126624, 1, 126628, 126634, 6, 126652, 126703, 1, 126706, 126975, 1, 127020, 127023, 1, 127124, 127135, 1, 127151, 127152, 1, 127168, 127184, 16, 127222, 127231, 1, 127406, 127461, 1, 127491, 127503, 1, 127548, 127551, 1, 127561, 127567, 1, 127570, 127583, 1, 127590, 127743, 1, 128728, 128731, 1, 128749, 128751, 1, 128765, 128767, 1, 128887, 128890, 1, 128986, 128991, 1, 129004, 129007, 1, 129009, 129023, 1, 129036, 129039, 1, 129096, 129103, 1, 129114, 129119, 1, 129160, 129167, 1, 129198, 129199, 1, 129212, 129215, 1, 129218, 129279, 1, 129620, 129631, 1, 129646, 129647, 1, 129661, 129663, 1, 129674, 129678, 1, 129735, 129741, 1, 129757, 129758, 1, 129770, 129775, 1, 129785, 129791, 1, 129939, 130042, 103, 130043, 131071, 1, 173792, 173823, 1, 177978, 177983, 1, 178206, 178207, 1, 183970, 183983, 1, 191457, 191471, 1, 192094, 194559, 1, 195102, 196607, 1, 201547, 201551, 1, 205744, 917759, 1, 918e3, 1114111, 1]));
      static Cc = new a(new Uint32Array([0, 31, 1, 127, 159, 1]));
      static Cf = new a(new Uint32Array([173, 1536, 1363, 1537, 1541, 1, 1564, 1757, 193, 1807, 2192, 385, 2193, 2274, 81, 6158, 8203, 2045, 8204, 8207, 1, 8234, 8238, 1, 8288, 8292, 1, 8294, 8303, 1, 65279, 65529, 250, 65530, 65531, 1, 69821, 69837, 16, 78896, 78911, 1, 113824, 113827, 1, 119155, 119162, 1, 917505, 917536, 31, 917537, 917631, 1]));
      static Co = new a(new Uint32Array([57344, 63743, 1, 983040, 1048573, 1, 1048576, 1114109, 1]));
      static Cs = new a(new Uint32Array([55296, 57343, 1]));
      static L = new a(new Uint32Array([65, 90, 1, 97, 122, 1, 170, 181, 11, 186, 192, 6, 193, 214, 1, 216, 246, 1, 248, 705, 1, 710, 721, 1, 736, 740, 1, 748, 750, 2, 880, 884, 1, 886, 887, 1, 890, 893, 1, 895, 902, 7, 904, 906, 1, 908, 910, 2, 911, 929, 1, 931, 1013, 1, 1015, 1153, 1, 1162, 1327, 1, 1329, 1366, 1, 1369, 1376, 7, 1377, 1416, 1, 1488, 1514, 1, 1519, 1522, 1, 1568, 1610, 1, 1646, 1647, 1, 1649, 1747, 1, 1749, 1765, 16, 1766, 1774, 8, 1775, 1786, 11, 1787, 1788, 1, 1791, 1808, 17, 1810, 1839, 1, 1869, 1957, 1, 1969, 1994, 25, 1995, 2026, 1, 2036, 2037, 1, 2042, 2048, 6, 2049, 2069, 1, 2074, 2084, 10, 2088, 2112, 24, 2113, 2136, 1, 2144, 2154, 1, 2160, 2183, 1, 2185, 2190, 1, 2208, 2249, 1, 2308, 2361, 1, 2365, 2384, 19, 2392, 2401, 1, 2417, 2432, 1, 2437, 2444, 1, 2447, 2448, 1, 2451, 2472, 1, 2474, 2480, 1, 2482, 2486, 4, 2487, 2489, 1, 2493, 2510, 17, 2524, 2525, 1, 2527, 2529, 1, 2544, 2545, 1, 2556, 2565, 9, 2566, 2570, 1, 2575, 2576, 1, 2579, 2600, 1, 2602, 2608, 1, 2610, 2611, 1, 2613, 2614, 1, 2616, 2617, 1, 2649, 2652, 1, 2654, 2674, 20, 2675, 2676, 1, 2693, 2701, 1, 2703, 2705, 1, 2707, 2728, 1, 2730, 2736, 1, 2738, 2739, 1, 2741, 2745, 1, 2749, 2768, 19, 2784, 2785, 1, 2809, 2821, 12, 2822, 2828, 1, 2831, 2832, 1, 2835, 2856, 1, 2858, 2864, 1, 2866, 2867, 1, 2869, 2873, 1, 2877, 2908, 31, 2909, 2911, 2, 2912, 2913, 1, 2929, 2947, 18, 2949, 2954, 1, 2958, 2960, 1, 2962, 2965, 1, 2969, 2970, 1, 2972, 2974, 2, 2975, 2979, 4, 2980, 2984, 4, 2985, 2986, 1, 2990, 3001, 1, 3024, 3077, 53, 3078, 3084, 1, 3086, 3088, 1, 3090, 3112, 1, 3114, 3129, 1, 3133, 3160, 27, 3161, 3162, 1, 3165, 3168, 3, 3169, 3200, 31, 3205, 3212, 1, 3214, 3216, 1, 3218, 3240, 1, 3242, 3251, 1, 3253, 3257, 1, 3261, 3293, 32, 3294, 3296, 2, 3297, 3313, 16, 3314, 3332, 18, 3333, 3340, 1, 3342, 3344, 1, 3346, 3386, 1, 3389, 3406, 17, 3412, 3414, 1, 3423, 3425, 1, 3450, 3455, 1, 3461, 3478, 1, 3482, 3505, 1, 3507, 3515, 1, 3517, 3520, 3, 3521, 3526, 1, 3585, 3632, 1, 3634, 3635, 1, 3648, 3654, 1, 3713, 3714, 1, 3716, 3718, 2, 3719, 3722, 1, 3724, 3747, 1, 3749, 3751, 2, 3752, 3760, 1, 3762, 3763, 1, 3773, 3776, 3, 3777, 3780, 1, 3782, 3804, 22, 3805, 3807, 1, 3840, 3904, 64, 3905, 3911, 1, 3913, 3948, 1, 3976, 3980, 1, 4096, 4138, 1, 4159, 4176, 17, 4177, 4181, 1, 4186, 4189, 1, 4193, 4197, 4, 4198, 4206, 8, 4207, 4208, 1, 4213, 4225, 1, 4238, 4256, 18, 4257, 4293, 1, 4295, 4301, 6, 4304, 4346, 1, 4348, 4680, 1, 4682, 4685, 1, 4688, 4694, 1, 4696, 4698, 2, 4699, 4701, 1, 4704, 4744, 1, 4746, 4749, 1, 4752, 4784, 1, 4786, 4789, 1, 4792, 4798, 1, 4800, 4802, 2, 4803, 4805, 1, 4808, 4822, 1, 4824, 4880, 1, 4882, 4885, 1, 4888, 4954, 1, 4992, 5007, 1, 5024, 5109, 1, 5112, 5117, 1, 5121, 5740, 1, 5743, 5759, 1, 5761, 5786, 1, 5792, 5866, 1, 5873, 5880, 1, 5888, 5905, 1, 5919, 5937, 1, 5952, 5969, 1, 5984, 5996, 1, 5998, 6e3, 1, 6016, 6067, 1, 6103, 6108, 5, 6176, 6264, 1, 6272, 6276, 1, 6279, 6312, 1, 6314, 6320, 6, 6321, 6389, 1, 6400, 6430, 1, 6480, 6509, 1, 6512, 6516, 1, 6528, 6571, 1, 6576, 6601, 1, 6656, 6678, 1, 6688, 6740, 1, 6823, 6917, 94, 6918, 6963, 1, 6981, 6988, 1, 7043, 7072, 1, 7086, 7087, 1, 7098, 7141, 1, 7168, 7203, 1, 7245, 7247, 1, 7258, 7293, 1, 7296, 7306, 1, 7312, 7354, 1, 7357, 7359, 1, 7401, 7404, 1, 7406, 7411, 1, 7413, 7414, 1, 7418, 7424, 6, 7425, 7615, 1, 7680, 7957, 1, 7960, 7965, 1, 7968, 8005, 1, 8008, 8013, 1, 8016, 8023, 1, 8025, 8031, 2, 8032, 8061, 1, 8064, 8116, 1, 8118, 8124, 1, 8126, 8130, 4, 8131, 8132, 1, 8134, 8140, 1, 8144, 8147, 1, 8150, 8155, 1, 8160, 8172, 1, 8178, 8180, 1, 8182, 8188, 1, 8305, 8319, 14, 8336, 8348, 1, 8450, 8455, 5, 8458, 8467, 1, 8469, 8473, 4, 8474, 8477, 1, 8484, 8490, 2, 8491, 8493, 1, 8495, 8505, 1, 8508, 8511, 1, 8517, 8521, 1, 8526, 8579, 53, 8580, 11264, 2684, 11265, 11492, 1, 11499, 11502, 1, 11506, 11507, 1, 11520, 11557, 1, 11559, 11565, 6, 11568, 11623, 1, 11631, 11648, 17, 11649, 11670, 1, 11680, 11686, 1, 11688, 11694, 1, 11696, 11702, 1, 11704, 11710, 1, 11712, 11718, 1, 11720, 11726, 1, 11728, 11734, 1, 11736, 11742, 1, 11823, 12293, 470, 12294, 12337, 43, 12338, 12341, 1, 12347, 12348, 1, 12353, 12438, 1, 12445, 12447, 1, 12449, 12538, 1, 12540, 12543, 1, 12549, 12591, 1, 12593, 12686, 1, 12704, 12735, 1, 12784, 12799, 1, 13312, 19903, 1, 19968, 42124, 1, 42192, 42237, 1, 42240, 42508, 1, 42512, 42527, 1, 42538, 42539, 1, 42560, 42606, 1, 42623, 42653, 1, 42656, 42725, 1, 42775, 42783, 1, 42786, 42888, 1, 42891, 42957, 1, 42960, 42961, 1, 42963, 42965, 2, 42966, 42972, 1, 42994, 43009, 1, 43011, 43013, 1, 43015, 43018, 1, 43020, 43042, 1, 43072, 43123, 1, 43138, 43187, 1, 43250, 43255, 1, 43259, 43261, 2, 43262, 43274, 12, 43275, 43301, 1, 43312, 43334, 1, 43360, 43388, 1, 43396, 43442, 1, 43471, 43488, 17, 43489, 43492, 1, 43494, 43503, 1, 43514, 43518, 1, 43520, 43560, 1, 43584, 43586, 1, 43588, 43595, 1, 43616, 43638, 1, 43642, 43646, 4, 43647, 43695, 1, 43697, 43701, 4, 43702, 43705, 3, 43706, 43709, 1, 43712, 43714, 2, 43739, 43741, 1, 43744, 43754, 1, 43762, 43764, 1, 43777, 43782, 1, 43785, 43790, 1, 43793, 43798, 1, 43808, 43814, 1, 43816, 43822, 1, 43824, 43866, 1, 43868, 43881, 1, 43888, 44002, 1, 44032, 55203, 1, 55216, 55238, 1, 55243, 55291, 1, 63744, 64109, 1, 64112, 64217, 1, 64256, 64262, 1, 64275, 64279, 1, 64285, 64287, 2, 64288, 64296, 1, 64298, 64310, 1, 64312, 64316, 1, 64318, 64320, 2, 64321, 64323, 2, 64324, 64326, 2, 64327, 64433, 1, 64467, 64829, 1, 64848, 64911, 1, 64914, 64967, 1, 65008, 65019, 1, 65136, 65140, 1, 65142, 65276, 1, 65313, 65338, 1, 65345, 65370, 1, 65382, 65470, 1, 65474, 65479, 1, 65482, 65487, 1, 65490, 65495, 1, 65498, 65500, 1, 65536, 65547, 1, 65549, 65574, 1, 65576, 65594, 1, 65596, 65597, 1, 65599, 65613, 1, 65616, 65629, 1, 65664, 65786, 1, 66176, 66204, 1, 66208, 66256, 1, 66304, 66335, 1, 66349, 66368, 1, 66370, 66377, 1, 66384, 66421, 1, 66432, 66461, 1, 66464, 66499, 1, 66504, 66511, 1, 66560, 66717, 1, 66736, 66771, 1, 66776, 66811, 1, 66816, 66855, 1, 66864, 66915, 1, 66928, 66938, 1, 66940, 66954, 1, 66956, 66962, 1, 66964, 66965, 1, 66967, 66977, 1, 66979, 66993, 1, 66995, 67001, 1, 67003, 67004, 1, 67008, 67059, 1, 67072, 67382, 1, 67392, 67413, 1, 67424, 67431, 1, 67456, 67461, 1, 67463, 67504, 1, 67506, 67514, 1, 67584, 67589, 1, 67592, 67594, 2, 67595, 67637, 1, 67639, 67640, 1, 67644, 67647, 3, 67648, 67669, 1, 67680, 67702, 1, 67712, 67742, 1, 67808, 67826, 1, 67828, 67829, 1, 67840, 67861, 1, 67872, 67897, 1, 67968, 68023, 1, 68030, 68031, 1, 68096, 68112, 16, 68113, 68115, 1, 68117, 68119, 1, 68121, 68149, 1, 68192, 68220, 1, 68224, 68252, 1, 68288, 68295, 1, 68297, 68324, 1, 68352, 68405, 1, 68416, 68437, 1, 68448, 68466, 1, 68480, 68497, 1, 68608, 68680, 1, 68736, 68786, 1, 68800, 68850, 1, 68864, 68899, 1, 68938, 68965, 1, 68975, 68997, 1, 69248, 69289, 1, 69296, 69297, 1, 69314, 69316, 1, 69376, 69404, 1, 69415, 69424, 9, 69425, 69445, 1, 69488, 69505, 1, 69552, 69572, 1, 69600, 69622, 1, 69635, 69687, 1, 69745, 69746, 1, 69749, 69763, 14, 69764, 69807, 1, 69840, 69864, 1, 69891, 69926, 1, 69956, 69959, 3, 69968, 70002, 1, 70006, 70019, 13, 70020, 70066, 1, 70081, 70084, 1, 70106, 70108, 2, 70144, 70161, 1, 70163, 70187, 1, 70207, 70208, 1, 70272, 70278, 1, 70280, 70282, 2, 70283, 70285, 1, 70287, 70301, 1, 70303, 70312, 1, 70320, 70366, 1, 70405, 70412, 1, 70415, 70416, 1, 70419, 70440, 1, 70442, 70448, 1, 70450, 70451, 1, 70453, 70457, 1, 70461, 70480, 19, 70493, 70497, 1, 70528, 70537, 1, 70539, 70542, 3, 70544, 70581, 1, 70583, 70609, 26, 70611, 70656, 45, 70657, 70708, 1, 70727, 70730, 1, 70751, 70753, 1, 70784, 70831, 1, 70852, 70853, 1, 70855, 71040, 185, 71041, 71086, 1, 71128, 71131, 1, 71168, 71215, 1, 71236, 71296, 60, 71297, 71338, 1, 71352, 71424, 72, 71425, 71450, 1, 71488, 71494, 1, 71680, 71723, 1, 71840, 71903, 1, 71935, 71942, 1, 71945, 71948, 3, 71949, 71955, 1, 71957, 71958, 1, 71960, 71983, 1, 71999, 72001, 2, 72096, 72103, 1, 72106, 72144, 1, 72161, 72163, 2, 72192, 72203, 11, 72204, 72242, 1, 72250, 72272, 22, 72284, 72329, 1, 72349, 72368, 19, 72369, 72440, 1, 72640, 72672, 1, 72704, 72712, 1, 72714, 72750, 1, 72768, 72818, 50, 72819, 72847, 1, 72960, 72966, 1, 72968, 72969, 1, 72971, 73008, 1, 73030, 73056, 26, 73057, 73061, 1, 73063, 73064, 1, 73066, 73097, 1, 73112, 73440, 328, 73441, 73458, 1, 73474, 73476, 2, 73477, 73488, 1, 73490, 73523, 1, 73648, 73728, 80, 73729, 74649, 1, 74880, 75075, 1, 77712, 77808, 1, 77824, 78895, 1, 78913, 78918, 1, 78944, 82938, 1, 82944, 83526, 1, 90368, 90397, 1, 92160, 92728, 1, 92736, 92766, 1, 92784, 92862, 1, 92880, 92909, 1, 92928, 92975, 1, 92992, 92995, 1, 93027, 93047, 1, 93053, 93071, 1, 93504, 93548, 1, 93760, 93823, 1, 93952, 94026, 1, 94032, 94099, 67, 94100, 94111, 1, 94176, 94177, 1, 94179, 94208, 29, 94209, 100343, 1, 100352, 101589, 1, 101631, 101640, 1, 110576, 110579, 1, 110581, 110587, 1, 110589, 110590, 1, 110592, 110882, 1, 110898, 110928, 30, 110929, 110930, 1, 110933, 110948, 15, 110949, 110951, 1, 110960, 111355, 1, 113664, 113770, 1, 113776, 113788, 1, 113792, 113800, 1, 113808, 113817, 1, 119808, 119892, 1, 119894, 119964, 1, 119966, 119967, 1, 119970, 119973, 3, 119974, 119977, 3, 119978, 119980, 1, 119982, 119993, 1, 119995, 119997, 2, 119998, 120003, 1, 120005, 120069, 1, 120071, 120074, 1, 120077, 120084, 1, 120086, 120092, 1, 120094, 120121, 1, 120123, 120126, 1, 120128, 120132, 1, 120134, 120138, 4, 120139, 120144, 1, 120146, 120485, 1, 120488, 120512, 1, 120514, 120538, 1, 120540, 120570, 1, 120572, 120596, 1, 120598, 120628, 1, 120630, 120654, 1, 120656, 120686, 1, 120688, 120712, 1, 120714, 120744, 1, 120746, 120770, 1, 120772, 120779, 1, 122624, 122654, 1, 122661, 122666, 1, 122928, 122989, 1, 123136, 123180, 1, 123191, 123197, 1, 123214, 123536, 322, 123537, 123565, 1, 123584, 123627, 1, 124112, 124139, 1, 124368, 124397, 1, 124400, 124896, 496, 124897, 124902, 1, 124904, 124907, 1, 124909, 124910, 1, 124912, 124926, 1, 124928, 125124, 1, 125184, 125251, 1, 125259, 126464, 1205, 126465, 126467, 1, 126469, 126495, 1, 126497, 126498, 1, 126500, 126503, 3, 126505, 126514, 1, 126516, 126519, 1, 126521, 126523, 2, 126530, 126535, 5, 126537, 126541, 2, 126542, 126543, 1, 126545, 126546, 1, 126548, 126551, 3, 126553, 126561, 2, 126562, 126564, 2, 126567, 126570, 1, 126572, 126578, 1, 126580, 126583, 1, 126585, 126588, 1, 126590, 126592, 2, 126593, 126601, 1, 126603, 126619, 1, 126625, 126627, 1, 126629, 126633, 1, 126635, 126651, 1, 131072, 173791, 1, 173824, 177977, 1, 177984, 178205, 1, 178208, 183969, 1, 183984, 191456, 1, 191472, 192093, 1, 194560, 195101, 1, 196608, 201546, 1, 201552, 205743, 1]));
      static foldL = new a(new Uint32Array([837, 837, 1]));
      static Ll = new a(new Uint32Array([97, 122, 1, 181, 223, 42, 224, 246, 1, 248, 255, 1, 257, 311, 2, 312, 328, 2, 329, 375, 2, 378, 382, 2, 383, 384, 1, 387, 389, 2, 392, 396, 4, 397, 402, 5, 405, 409, 4, 410, 411, 1, 414, 417, 3, 419, 421, 2, 424, 426, 2, 427, 429, 2, 432, 436, 4, 438, 441, 3, 442, 445, 3, 446, 447, 1, 454, 460, 3, 462, 476, 2, 477, 495, 2, 496, 499, 3, 501, 505, 4, 507, 563, 2, 564, 569, 1, 572, 575, 3, 576, 578, 2, 583, 591, 2, 592, 659, 1, 661, 687, 1, 881, 883, 2, 887, 891, 4, 892, 893, 1, 912, 940, 28, 941, 974, 1, 976, 977, 1, 981, 983, 1, 985, 1007, 2, 1008, 1011, 1, 1013, 1019, 3, 1020, 1072, 52, 1073, 1119, 1, 1121, 1153, 2, 1163, 1215, 2, 1218, 1230, 2, 1231, 1327, 2, 1376, 1416, 1, 4304, 4346, 1, 4349, 4351, 1, 5112, 5117, 1, 7296, 7304, 1, 7306, 7424, 118, 7425, 7467, 1, 7531, 7543, 1, 7545, 7578, 1, 7681, 7829, 2, 7830, 7837, 1, 7839, 7935, 2, 7936, 7943, 1, 7952, 7957, 1, 7968, 7975, 1, 7984, 7991, 1, 8e3, 8005, 1, 8016, 8023, 1, 8032, 8039, 1, 8048, 8061, 1, 8064, 8071, 1, 8080, 8087, 1, 8096, 8103, 1, 8112, 8116, 1, 8118, 8119, 1, 8126, 8130, 4, 8131, 8132, 1, 8134, 8135, 1, 8144, 8147, 1, 8150, 8151, 1, 8160, 8167, 1, 8178, 8180, 1, 8182, 8183, 1, 8458, 8462, 4, 8463, 8467, 4, 8495, 8505, 5, 8508, 8509, 1, 8518, 8521, 1, 8526, 8580, 54, 11312, 11359, 1, 11361, 11365, 4, 11366, 11372, 2, 11377, 11379, 2, 11380, 11382, 2, 11383, 11387, 1, 11393, 11491, 2, 11492, 11500, 8, 11502, 11507, 5, 11520, 11557, 1, 11559, 11565, 6, 42561, 42605, 2, 42625, 42651, 2, 42787, 42799, 2, 42800, 42801, 1, 42803, 42865, 2, 42866, 42872, 1, 42874, 42876, 2, 42879, 42887, 2, 42892, 42894, 2, 42897, 42899, 2, 42900, 42901, 1, 42903, 42921, 2, 42927, 42933, 6, 42935, 42947, 2, 42952, 42954, 2, 42957, 42961, 4, 42963, 42971, 2, 42998, 43002, 4, 43824, 43866, 1, 43872, 43880, 1, 43888, 43967, 1, 64256, 64262, 1, 64275, 64279, 1, 65345, 65370, 1, 66600, 66639, 1, 66776, 66811, 1, 66967, 66977, 1, 66979, 66993, 1, 66995, 67001, 1, 67003, 67004, 1, 68800, 68850, 1, 68976, 68997, 1, 71872, 71903, 1, 93792, 93823, 1, 119834, 119859, 1, 119886, 119892, 1, 119894, 119911, 1, 119938, 119963, 1, 119990, 119993, 1, 119995, 119997, 2, 119998, 120003, 1, 120005, 120015, 1, 120042, 120067, 1, 120094, 120119, 1, 120146, 120171, 1, 120198, 120223, 1, 120250, 120275, 1, 120302, 120327, 1, 120354, 120379, 1, 120406, 120431, 1, 120458, 120485, 1, 120514, 120538, 1, 120540, 120545, 1, 120572, 120596, 1, 120598, 120603, 1, 120630, 120654, 1, 120656, 120661, 1, 120688, 120712, 1, 120714, 120719, 1, 120746, 120770, 1, 120772, 120777, 1, 120779, 122624, 1845, 122625, 122633, 1, 122635, 122654, 1, 122661, 122666, 1, 125218, 125251, 1]));
      static foldLl = new a(new Uint32Array([65, 90, 1, 192, 214, 1, 216, 222, 1, 256, 302, 2, 306, 310, 2, 313, 327, 2, 330, 376, 2, 377, 381, 2, 385, 386, 1, 388, 390, 2, 391, 393, 2, 394, 395, 1, 398, 401, 1, 403, 404, 1, 406, 408, 1, 412, 413, 1, 415, 416, 1, 418, 422, 2, 423, 425, 2, 428, 430, 2, 431, 433, 2, 434, 435, 1, 437, 439, 2, 440, 444, 4, 452, 453, 1, 455, 456, 1, 458, 459, 1, 461, 475, 2, 478, 494, 2, 497, 498, 1, 500, 502, 2, 503, 504, 1, 506, 562, 2, 570, 571, 1, 573, 574, 1, 577, 579, 2, 580, 582, 1, 584, 590, 2, 837, 880, 43, 882, 886, 4, 895, 902, 7, 904, 906, 1, 908, 910, 2, 911, 913, 2, 914, 929, 1, 931, 939, 1, 975, 984, 9, 986, 1006, 2, 1012, 1015, 3, 1017, 1018, 1, 1021, 1071, 1, 1120, 1152, 2, 1162, 1216, 2, 1217, 1229, 2, 1232, 1326, 2, 1329, 1366, 1, 4256, 4293, 1, 4295, 4301, 6, 5024, 5109, 1, 7305, 7312, 7, 7313, 7354, 1, 7357, 7359, 1, 7680, 7828, 2, 7838, 7934, 2, 7944, 7951, 1, 7960, 7965, 1, 7976, 7983, 1, 7992, 7999, 1, 8008, 8013, 1, 8025, 8031, 2, 8040, 8047, 1, 8072, 8079, 1, 8088, 8095, 1, 8104, 8111, 1, 8120, 8124, 1, 8136, 8140, 1, 8152, 8155, 1, 8168, 8172, 1, 8184, 8188, 1, 8486, 8490, 4, 8491, 8498, 7, 8579, 11264, 2685, 11265, 11311, 1, 11360, 11362, 2, 11363, 11364, 1, 11367, 11373, 2, 11374, 11376, 1, 11378, 11381, 3, 11390, 11392, 1, 11394, 11490, 2, 11499, 11501, 2, 11506, 42560, 31054, 42562, 42604, 2, 42624, 42650, 2, 42786, 42798, 2, 42802, 42862, 2, 42873, 42877, 2, 42878, 42886, 2, 42891, 42893, 2, 42896, 42898, 2, 42902, 42922, 2, 42923, 42926, 1, 42928, 42932, 1, 42934, 42948, 2, 42949, 42951, 1, 42953, 42955, 2, 42956, 42960, 4, 42966, 42972, 2, 42997, 65313, 22316, 65314, 65338, 1, 66560, 66599, 1, 66736, 66771, 1, 66928, 66938, 1, 66940, 66954, 1, 66956, 66962, 1, 66964, 66965, 1, 68736, 68786, 1, 68944, 68965, 1, 71840, 71871, 1, 93760, 93791, 1, 125184, 125217, 1]));
      static Lm = new a(new Uint32Array([688, 705, 1, 710, 721, 1, 736, 740, 1, 748, 750, 2, 884, 890, 6, 1369, 1600, 231, 1765, 1766, 1, 2036, 2037, 1, 2042, 2074, 32, 2084, 2088, 4, 2249, 2417, 168, 3654, 3782, 128, 4348, 6103, 1755, 6211, 6823, 612, 7288, 7293, 1, 7468, 7530, 1, 7544, 7579, 35, 7580, 7615, 1, 8305, 8319, 14, 8336, 8348, 1, 11388, 11389, 1, 11631, 11823, 192, 12293, 12337, 44, 12338, 12341, 1, 12347, 12445, 98, 12446, 12540, 94, 12541, 12542, 1, 40981, 42232, 1251, 42233, 42237, 1, 42508, 42623, 115, 42652, 42653, 1, 42775, 42783, 1, 42864, 42888, 24, 42994, 42996, 1, 43e3, 43001, 1, 43471, 43494, 23, 43632, 43741, 109, 43763, 43764, 1, 43868, 43871, 1, 43881, 65392, 21511, 65438, 65439, 1, 67456, 67461, 1, 67463, 67504, 1, 67506, 67514, 1, 68942, 68975, 33, 92992, 92995, 1, 93504, 93506, 1, 93547, 93548, 1, 94099, 94111, 1, 94176, 94177, 1, 94179, 110576, 16397, 110577, 110579, 1, 110581, 110587, 1, 110589, 110590, 1, 122928, 122989, 1, 123191, 123197, 1, 124139, 125259, 1120]));
      static Lo = new a(new Uint32Array([170, 186, 16, 443, 448, 5, 449, 451, 1, 660, 1488, 828, 1489, 1514, 1, 1519, 1522, 1, 1568, 1599, 1, 1601, 1610, 1, 1646, 1647, 1, 1649, 1747, 1, 1749, 1774, 25, 1775, 1786, 11, 1787, 1788, 1, 1791, 1808, 17, 1810, 1839, 1, 1869, 1957, 1, 1969, 1994, 25, 1995, 2026, 1, 2048, 2069, 1, 2112, 2136, 1, 2144, 2154, 1, 2160, 2183, 1, 2185, 2190, 1, 2208, 2248, 1, 2308, 2361, 1, 2365, 2384, 19, 2392, 2401, 1, 2418, 2432, 1, 2437, 2444, 1, 2447, 2448, 1, 2451, 2472, 1, 2474, 2480, 1, 2482, 2486, 4, 2487, 2489, 1, 2493, 2510, 17, 2524, 2525, 1, 2527, 2529, 1, 2544, 2545, 1, 2556, 2565, 9, 2566, 2570, 1, 2575, 2576, 1, 2579, 2600, 1, 2602, 2608, 1, 2610, 2611, 1, 2613, 2614, 1, 2616, 2617, 1, 2649, 2652, 1, 2654, 2674, 20, 2675, 2676, 1, 2693, 2701, 1, 2703, 2705, 1, 2707, 2728, 1, 2730, 2736, 1, 2738, 2739, 1, 2741, 2745, 1, 2749, 2768, 19, 2784, 2785, 1, 2809, 2821, 12, 2822, 2828, 1, 2831, 2832, 1, 2835, 2856, 1, 2858, 2864, 1, 2866, 2867, 1, 2869, 2873, 1, 2877, 2908, 31, 2909, 2911, 2, 2912, 2913, 1, 2929, 2947, 18, 2949, 2954, 1, 2958, 2960, 1, 2962, 2965, 1, 2969, 2970, 1, 2972, 2974, 2, 2975, 2979, 4, 2980, 2984, 4, 2985, 2986, 1, 2990, 3001, 1, 3024, 3077, 53, 3078, 3084, 1, 3086, 3088, 1, 3090, 3112, 1, 3114, 3129, 1, 3133, 3160, 27, 3161, 3162, 1, 3165, 3168, 3, 3169, 3200, 31, 3205, 3212, 1, 3214, 3216, 1, 3218, 3240, 1, 3242, 3251, 1, 3253, 3257, 1, 3261, 3293, 32, 3294, 3296, 2, 3297, 3313, 16, 3314, 3332, 18, 3333, 3340, 1, 3342, 3344, 1, 3346, 3386, 1, 3389, 3406, 17, 3412, 3414, 1, 3423, 3425, 1, 3450, 3455, 1, 3461, 3478, 1, 3482, 3505, 1, 3507, 3515, 1, 3517, 3520, 3, 3521, 3526, 1, 3585, 3632, 1, 3634, 3635, 1, 3648, 3653, 1, 3713, 3714, 1, 3716, 3718, 2, 3719, 3722, 1, 3724, 3747, 1, 3749, 3751, 2, 3752, 3760, 1, 3762, 3763, 1, 3773, 3776, 3, 3777, 3780, 1, 3804, 3807, 1, 3840, 3904, 64, 3905, 3911, 1, 3913, 3948, 1, 3976, 3980, 1, 4096, 4138, 1, 4159, 4176, 17, 4177, 4181, 1, 4186, 4189, 1, 4193, 4197, 4, 4198, 4206, 8, 4207, 4208, 1, 4213, 4225, 1, 4238, 4352, 114, 4353, 4680, 1, 4682, 4685, 1, 4688, 4694, 1, 4696, 4698, 2, 4699, 4701, 1, 4704, 4744, 1, 4746, 4749, 1, 4752, 4784, 1, 4786, 4789, 1, 4792, 4798, 1, 4800, 4802, 2, 4803, 4805, 1, 4808, 4822, 1, 4824, 4880, 1, 4882, 4885, 1, 4888, 4954, 1, 4992, 5007, 1, 5121, 5740, 1, 5743, 5759, 1, 5761, 5786, 1, 5792, 5866, 1, 5873, 5880, 1, 5888, 5905, 1, 5919, 5937, 1, 5952, 5969, 1, 5984, 5996, 1, 5998, 6e3, 1, 6016, 6067, 1, 6108, 6176, 68, 6177, 6210, 1, 6212, 6264, 1, 6272, 6276, 1, 6279, 6312, 1, 6314, 6320, 6, 6321, 6389, 1, 6400, 6430, 1, 6480, 6509, 1, 6512, 6516, 1, 6528, 6571, 1, 6576, 6601, 1, 6656, 6678, 1, 6688, 6740, 1, 6917, 6963, 1, 6981, 6988, 1, 7043, 7072, 1, 7086, 7087, 1, 7098, 7141, 1, 7168, 7203, 1, 7245, 7247, 1, 7258, 7287, 1, 7401, 7404, 1, 7406, 7411, 1, 7413, 7414, 1, 7418, 8501, 1083, 8502, 8504, 1, 11568, 11623, 1, 11648, 11670, 1, 11680, 11686, 1, 11688, 11694, 1, 11696, 11702, 1, 11704, 11710, 1, 11712, 11718, 1, 11720, 11726, 1, 11728, 11734, 1, 11736, 11742, 1, 12294, 12348, 54, 12353, 12438, 1, 12447, 12449, 2, 12450, 12538, 1, 12543, 12549, 6, 12550, 12591, 1, 12593, 12686, 1, 12704, 12735, 1, 12784, 12799, 1, 13312, 19903, 1, 19968, 40980, 1, 40982, 42124, 1, 42192, 42231, 1, 42240, 42507, 1, 42512, 42527, 1, 42538, 42539, 1, 42606, 42656, 50, 42657, 42725, 1, 42895, 42999, 104, 43003, 43009, 1, 43011, 43013, 1, 43015, 43018, 1, 43020, 43042, 1, 43072, 43123, 1, 43138, 43187, 1, 43250, 43255, 1, 43259, 43261, 2, 43262, 43274, 12, 43275, 43301, 1, 43312, 43334, 1, 43360, 43388, 1, 43396, 43442, 1, 43488, 43492, 1, 43495, 43503, 1, 43514, 43518, 1, 43520, 43560, 1, 43584, 43586, 1, 43588, 43595, 1, 43616, 43631, 1, 43633, 43638, 1, 43642, 43646, 4, 43647, 43695, 1, 43697, 43701, 4, 43702, 43705, 3, 43706, 43709, 1, 43712, 43714, 2, 43739, 43740, 1, 43744, 43754, 1, 43762, 43777, 15, 43778, 43782, 1, 43785, 43790, 1, 43793, 43798, 1, 43808, 43814, 1, 43816, 43822, 1, 43968, 44002, 1, 44032, 55203, 1, 55216, 55238, 1, 55243, 55291, 1, 63744, 64109, 1, 64112, 64217, 1, 64285, 64287, 2, 64288, 64296, 1, 64298, 64310, 1, 64312, 64316, 1, 64318, 64320, 2, 64321, 64323, 2, 64324, 64326, 2, 64327, 64433, 1, 64467, 64829, 1, 64848, 64911, 1, 64914, 64967, 1, 65008, 65019, 1, 65136, 65140, 1, 65142, 65276, 1, 65382, 65391, 1, 65393, 65437, 1, 65440, 65470, 1, 65474, 65479, 1, 65482, 65487, 1, 65490, 65495, 1, 65498, 65500, 1, 65536, 65547, 1, 65549, 65574, 1, 65576, 65594, 1, 65596, 65597, 1, 65599, 65613, 1, 65616, 65629, 1, 65664, 65786, 1, 66176, 66204, 1, 66208, 66256, 1, 66304, 66335, 1, 66349, 66368, 1, 66370, 66377, 1, 66384, 66421, 1, 66432, 66461, 1, 66464, 66499, 1, 66504, 66511, 1, 66640, 66717, 1, 66816, 66855, 1, 66864, 66915, 1, 67008, 67059, 1, 67072, 67382, 1, 67392, 67413, 1, 67424, 67431, 1, 67584, 67589, 1, 67592, 67594, 2, 67595, 67637, 1, 67639, 67640, 1, 67644, 67647, 3, 67648, 67669, 1, 67680, 67702, 1, 67712, 67742, 1, 67808, 67826, 1, 67828, 67829, 1, 67840, 67861, 1, 67872, 67897, 1, 67968, 68023, 1, 68030, 68031, 1, 68096, 68112, 16, 68113, 68115, 1, 68117, 68119, 1, 68121, 68149, 1, 68192, 68220, 1, 68224, 68252, 1, 68288, 68295, 1, 68297, 68324, 1, 68352, 68405, 1, 68416, 68437, 1, 68448, 68466, 1, 68480, 68497, 1, 68608, 68680, 1, 68864, 68899, 1, 68938, 68941, 1, 68943, 69248, 305, 69249, 69289, 1, 69296, 69297, 1, 69314, 69316, 1, 69376, 69404, 1, 69415, 69424, 9, 69425, 69445, 1, 69488, 69505, 1, 69552, 69572, 1, 69600, 69622, 1, 69635, 69687, 1, 69745, 69746, 1, 69749, 69763, 14, 69764, 69807, 1, 69840, 69864, 1, 69891, 69926, 1, 69956, 69959, 3, 69968, 70002, 1, 70006, 70019, 13, 70020, 70066, 1, 70081, 70084, 1, 70106, 70108, 2, 70144, 70161, 1, 70163, 70187, 1, 70207, 70208, 1, 70272, 70278, 1, 70280, 70282, 2, 70283, 70285, 1, 70287, 70301, 1, 70303, 70312, 1, 70320, 70366, 1, 70405, 70412, 1, 70415, 70416, 1, 70419, 70440, 1, 70442, 70448, 1, 70450, 70451, 1, 70453, 70457, 1, 70461, 70480, 19, 70493, 70497, 1, 70528, 70537, 1, 70539, 70542, 3, 70544, 70581, 1, 70583, 70609, 26, 70611, 70656, 45, 70657, 70708, 1, 70727, 70730, 1, 70751, 70753, 1, 70784, 70831, 1, 70852, 70853, 1, 70855, 71040, 185, 71041, 71086, 1, 71128, 71131, 1, 71168, 71215, 1, 71236, 71296, 60, 71297, 71338, 1, 71352, 71424, 72, 71425, 71450, 1, 71488, 71494, 1, 71680, 71723, 1, 71935, 71942, 1, 71945, 71948, 3, 71949, 71955, 1, 71957, 71958, 1, 71960, 71983, 1, 71999, 72001, 2, 72096, 72103, 1, 72106, 72144, 1, 72161, 72163, 2, 72192, 72203, 11, 72204, 72242, 1, 72250, 72272, 22, 72284, 72329, 1, 72349, 72368, 19, 72369, 72440, 1, 72640, 72672, 1, 72704, 72712, 1, 72714, 72750, 1, 72768, 72818, 50, 72819, 72847, 1, 72960, 72966, 1, 72968, 72969, 1, 72971, 73008, 1, 73030, 73056, 26, 73057, 73061, 1, 73063, 73064, 1, 73066, 73097, 1, 73112, 73440, 328, 73441, 73458, 1, 73474, 73476, 2, 73477, 73488, 1, 73490, 73523, 1, 73648, 73728, 80, 73729, 74649, 1, 74880, 75075, 1, 77712, 77808, 1, 77824, 78895, 1, 78913, 78918, 1, 78944, 82938, 1, 82944, 83526, 1, 90368, 90397, 1, 92160, 92728, 1, 92736, 92766, 1, 92784, 92862, 1, 92880, 92909, 1, 92928, 92975, 1, 93027, 93047, 1, 93053, 93071, 1, 93507, 93546, 1, 93952, 94026, 1, 94032, 94208, 176, 94209, 100343, 1, 100352, 101589, 1, 101631, 101640, 1, 110592, 110882, 1, 110898, 110928, 30, 110929, 110930, 1, 110933, 110948, 15, 110949, 110951, 1, 110960, 111355, 1, 113664, 113770, 1, 113776, 113788, 1, 113792, 113800, 1, 113808, 113817, 1, 122634, 123136, 502, 123137, 123180, 1, 123214, 123536, 322, 123537, 123565, 1, 123584, 123627, 1, 124112, 124138, 1, 124368, 124397, 1, 124400, 124896, 496, 124897, 124902, 1, 124904, 124907, 1, 124909, 124910, 1, 124912, 124926, 1, 124928, 125124, 1, 126464, 126467, 1, 126469, 126495, 1, 126497, 126498, 1, 126500, 126503, 3, 126505, 126514, 1, 126516, 126519, 1, 126521, 126523, 2, 126530, 126535, 5, 126537, 126541, 2, 126542, 126543, 1, 126545, 126546, 1, 126548, 126551, 3, 126553, 126561, 2, 126562, 126564, 2, 126567, 126570, 1, 126572, 126578, 1, 126580, 126583, 1, 126585, 126588, 1, 126590, 126592, 2, 126593, 126601, 1, 126603, 126619, 1, 126625, 126627, 1, 126629, 126633, 1, 126635, 126651, 1, 131072, 173791, 1, 173824, 177977, 1, 177984, 178205, 1, 178208, 183969, 1, 183984, 191456, 1, 191472, 192093, 1, 194560, 195101, 1, 196608, 201546, 1, 201552, 205743, 1]));
      static Lt = new a(new Uint32Array([453, 459, 3, 498, 8072, 7574, 8073, 8079, 1, 8088, 8095, 1, 8104, 8111, 1, 8124, 8140, 16, 8188, 8188, 1]));
      static foldLt = new a(new Uint32Array([452, 454, 2, 455, 457, 2, 458, 460, 2, 497, 499, 2, 8064, 8071, 1, 8080, 8087, 1, 8096, 8103, 1, 8115, 8131, 16, 8179, 8179, 1]));
      static Lu = new a(new Uint32Array([65, 90, 1, 192, 214, 1, 216, 222, 1, 256, 310, 2, 313, 327, 2, 330, 376, 2, 377, 381, 2, 385, 386, 1, 388, 390, 2, 391, 393, 2, 394, 395, 1, 398, 401, 1, 403, 404, 1, 406, 408, 1, 412, 413, 1, 415, 416, 1, 418, 422, 2, 423, 425, 2, 428, 430, 2, 431, 433, 2, 434, 435, 1, 437, 439, 2, 440, 444, 4, 452, 461, 3, 463, 475, 2, 478, 494, 2, 497, 500, 3, 502, 504, 1, 506, 562, 2, 570, 571, 1, 573, 574, 1, 577, 579, 2, 580, 582, 1, 584, 590, 2, 880, 882, 2, 886, 895, 9, 902, 904, 2, 905, 906, 1, 908, 910, 2, 911, 913, 2, 914, 929, 1, 931, 939, 1, 975, 978, 3, 979, 980, 1, 984, 1006, 2, 1012, 1015, 3, 1017, 1018, 1, 1021, 1071, 1, 1120, 1152, 2, 1162, 1216, 2, 1217, 1229, 2, 1232, 1326, 2, 1329, 1366, 1, 4256, 4293, 1, 4295, 4301, 6, 5024, 5109, 1, 7305, 7312, 7, 7313, 7354, 1, 7357, 7359, 1, 7680, 7828, 2, 7838, 7934, 2, 7944, 7951, 1, 7960, 7965, 1, 7976, 7983, 1, 7992, 7999, 1, 8008, 8013, 1, 8025, 8031, 2, 8040, 8047, 1, 8120, 8123, 1, 8136, 8139, 1, 8152, 8155, 1, 8168, 8172, 1, 8184, 8187, 1, 8450, 8455, 5, 8459, 8461, 1, 8464, 8466, 1, 8469, 8473, 4, 8474, 8477, 1, 8484, 8490, 2, 8491, 8493, 1, 8496, 8499, 1, 8510, 8511, 1, 8517, 8579, 62, 11264, 11311, 1, 11360, 11362, 2, 11363, 11364, 1, 11367, 11373, 2, 11374, 11376, 1, 11378, 11381, 3, 11390, 11392, 1, 11394, 11490, 2, 11499, 11501, 2, 11506, 42560, 31054, 42562, 42604, 2, 42624, 42650, 2, 42786, 42798, 2, 42802, 42862, 2, 42873, 42877, 2, 42878, 42886, 2, 42891, 42893, 2, 42896, 42898, 2, 42902, 42922, 2, 42923, 42926, 1, 42928, 42932, 1, 42934, 42948, 2, 42949, 42951, 1, 42953, 42955, 2, 42956, 42960, 4, 42966, 42972, 2, 42997, 65313, 22316, 65314, 65338, 1, 66560, 66599, 1, 66736, 66771, 1, 66928, 66938, 1, 66940, 66954, 1, 66956, 66962, 1, 66964, 66965, 1, 68736, 68786, 1, 68944, 68965, 1, 71840, 71871, 1, 93760, 93791, 1, 119808, 119833, 1, 119860, 119885, 1, 119912, 119937, 1, 119964, 119966, 2, 119967, 119973, 3, 119974, 119977, 3, 119978, 119980, 1, 119982, 119989, 1, 120016, 120041, 1, 120068, 120069, 1, 120071, 120074, 1, 120077, 120084, 1, 120086, 120092, 1, 120120, 120121, 1, 120123, 120126, 1, 120128, 120132, 1, 120134, 120138, 4, 120139, 120144, 1, 120172, 120197, 1, 120224, 120249, 1, 120276, 120301, 1, 120328, 120353, 1, 120380, 120405, 1, 120432, 120457, 1, 120488, 120512, 1, 120546, 120570, 1, 120604, 120628, 1, 120662, 120686, 1, 120720, 120744, 1, 120778, 125184, 4406, 125185, 125217, 1]));
      static Upper = this.Lu;
      static foldLu = new a(new Uint32Array([97, 122, 1, 181, 223, 42, 224, 246, 1, 248, 255, 1, 257, 303, 2, 307, 311, 2, 314, 328, 2, 331, 375, 2, 378, 382, 2, 383, 384, 1, 387, 389, 2, 392, 396, 4, 402, 405, 3, 409, 411, 1, 414, 417, 3, 419, 421, 2, 424, 429, 5, 432, 436, 4, 438, 441, 3, 445, 447, 2, 453, 454, 1, 456, 457, 1, 459, 460, 1, 462, 476, 2, 477, 495, 2, 498, 499, 1, 501, 505, 4, 507, 543, 2, 547, 563, 2, 572, 575, 3, 576, 578, 2, 583, 591, 2, 592, 596, 1, 598, 599, 1, 601, 603, 2, 604, 608, 4, 609, 611, 2, 612, 614, 1, 616, 620, 1, 623, 625, 2, 626, 629, 3, 637, 640, 3, 642, 643, 1, 647, 652, 1, 658, 669, 11, 670, 837, 167, 881, 883, 2, 887, 891, 4, 892, 893, 1, 940, 943, 1, 945, 974, 1, 976, 977, 1, 981, 983, 1, 985, 1007, 2, 1008, 1011, 1, 1013, 1019, 3, 1072, 1119, 1, 1121, 1153, 2, 1163, 1215, 2, 1218, 1230, 2, 1231, 1327, 2, 1377, 1414, 1, 4304, 4346, 1, 4349, 4351, 1, 5112, 5117, 1, 7296, 7304, 1, 7306, 7545, 239, 7549, 7566, 17, 7681, 7829, 2, 7835, 7841, 6, 7843, 7935, 2, 7936, 7943, 1, 7952, 7957, 1, 7968, 7975, 1, 7984, 7991, 1, 8e3, 8005, 1, 8017, 8023, 2, 8032, 8039, 1, 8048, 8061, 1, 8112, 8113, 1, 8126, 8144, 18, 8145, 8160, 15, 8161, 8165, 4, 8526, 8580, 54, 11312, 11359, 1, 11361, 11365, 4, 11366, 11372, 2, 11379, 11382, 3, 11393, 11491, 2, 11500, 11502, 2, 11507, 11520, 13, 11521, 11557, 1, 11559, 11565, 6, 42561, 42605, 2, 42625, 42651, 2, 42787, 42799, 2, 42803, 42863, 2, 42874, 42876, 2, 42879, 42887, 2, 42892, 42897, 5, 42899, 42900, 1, 42903, 42921, 2, 42933, 42947, 2, 42952, 42954, 2, 42957, 42961, 4, 42967, 42971, 2, 42998, 43859, 861, 43888, 43967, 1, 65345, 65370, 1, 66600, 66639, 1, 66776, 66811, 1, 66967, 66977, 1, 66979, 66993, 1, 66995, 67001, 1, 67003, 67004, 1, 68800, 68850, 1, 68976, 68997, 1, 71872, 71903, 1, 93792, 93823, 1, 125218, 125251, 1]));
      static M = new a(new Uint32Array([768, 879, 1, 1155, 1161, 1, 1425, 1469, 1, 1471, 1473, 2, 1474, 1476, 2, 1477, 1479, 2, 1552, 1562, 1, 1611, 1631, 1, 1648, 1750, 102, 1751, 1756, 1, 1759, 1764, 1, 1767, 1768, 1, 1770, 1773, 1, 1809, 1840, 31, 1841, 1866, 1, 1958, 1968, 1, 2027, 2035, 1, 2045, 2070, 25, 2071, 2073, 1, 2075, 2083, 1, 2085, 2087, 1, 2089, 2093, 1, 2137, 2139, 1, 2199, 2207, 1, 2250, 2273, 1, 2275, 2307, 1, 2362, 2364, 1, 2366, 2383, 1, 2385, 2391, 1, 2402, 2403, 1, 2433, 2435, 1, 2492, 2494, 2, 2495, 2500, 1, 2503, 2504, 1, 2507, 2509, 1, 2519, 2530, 11, 2531, 2558, 27, 2561, 2563, 1, 2620, 2622, 2, 2623, 2626, 1, 2631, 2632, 1, 2635, 2637, 1, 2641, 2672, 31, 2673, 2677, 4, 2689, 2691, 1, 2748, 2750, 2, 2751, 2757, 1, 2759, 2761, 1, 2763, 2765, 1, 2786, 2787, 1, 2810, 2815, 1, 2817, 2819, 1, 2876, 2878, 2, 2879, 2884, 1, 2887, 2888, 1, 2891, 2893, 1, 2901, 2903, 1, 2914, 2915, 1, 2946, 3006, 60, 3007, 3010, 1, 3014, 3016, 1, 3018, 3021, 1, 3031, 3072, 41, 3073, 3076, 1, 3132, 3134, 2, 3135, 3140, 1, 3142, 3144, 1, 3146, 3149, 1, 3157, 3158, 1, 3170, 3171, 1, 3201, 3203, 1, 3260, 3262, 2, 3263, 3268, 1, 3270, 3272, 1, 3274, 3277, 1, 3285, 3286, 1, 3298, 3299, 1, 3315, 3328, 13, 3329, 3331, 1, 3387, 3388, 1, 3390, 3396, 1, 3398, 3400, 1, 3402, 3405, 1, 3415, 3426, 11, 3427, 3457, 30, 3458, 3459, 1, 3530, 3535, 5, 3536, 3540, 1, 3542, 3544, 2, 3545, 3551, 1, 3570, 3571, 1, 3633, 3636, 3, 3637, 3642, 1, 3655, 3662, 1, 3761, 3764, 3, 3765, 3772, 1, 3784, 3790, 1, 3864, 3865, 1, 3893, 3897, 2, 3902, 3903, 1, 3953, 3972, 1, 3974, 3975, 1, 3981, 3991, 1, 3993, 4028, 1, 4038, 4139, 101, 4140, 4158, 1, 4182, 4185, 1, 4190, 4192, 1, 4194, 4196, 1, 4199, 4205, 1, 4209, 4212, 1, 4226, 4237, 1, 4239, 4250, 11, 4251, 4253, 1, 4957, 4959, 1, 5906, 5909, 1, 5938, 5940, 1, 5970, 5971, 1, 6002, 6003, 1, 6068, 6099, 1, 6109, 6155, 46, 6156, 6157, 1, 6159, 6277, 118, 6278, 6313, 35, 6432, 6443, 1, 6448, 6459, 1, 6679, 6683, 1, 6741, 6750, 1, 6752, 6780, 1, 6783, 6832, 49, 6833, 6862, 1, 6912, 6916, 1, 6964, 6980, 1, 7019, 7027, 1, 7040, 7042, 1, 7073, 7085, 1, 7142, 7155, 1, 7204, 7223, 1, 7376, 7378, 1, 7380, 7400, 1, 7405, 7412, 7, 7415, 7417, 1, 7616, 7679, 1, 8400, 8432, 1, 11503, 11505, 1, 11647, 11744, 97, 11745, 11775, 1, 12330, 12335, 1, 12441, 12442, 1, 42607, 42610, 1, 42612, 42621, 1, 42654, 42655, 1, 42736, 42737, 1, 43010, 43014, 4, 43019, 43043, 24, 43044, 43047, 1, 43052, 43136, 84, 43137, 43188, 51, 43189, 43205, 1, 43232, 43249, 1, 43263, 43302, 39, 43303, 43309, 1, 43335, 43347, 1, 43392, 43395, 1, 43443, 43456, 1, 43493, 43561, 68, 43562, 43574, 1, 43587, 43596, 9, 43597, 43643, 46, 43644, 43645, 1, 43696, 43698, 2, 43699, 43700, 1, 43703, 43704, 1, 43710, 43711, 1, 43713, 43755, 42, 43756, 43759, 1, 43765, 43766, 1, 44003, 44010, 1, 44012, 44013, 1, 64286, 65024, 738, 65025, 65039, 1, 65056, 65071, 1, 66045, 66272, 227, 66422, 66426, 1, 68097, 68099, 1, 68101, 68102, 1, 68108, 68111, 1, 68152, 68154, 1, 68159, 68325, 166, 68326, 68900, 574, 68901, 68903, 1, 68969, 68973, 1, 69291, 69292, 1, 69372, 69375, 1, 69446, 69456, 1, 69506, 69509, 1, 69632, 69634, 1, 69688, 69702, 1, 69744, 69747, 3, 69748, 69759, 11, 69760, 69762, 1, 69808, 69818, 1, 69826, 69888, 62, 69889, 69890, 1, 69927, 69940, 1, 69957, 69958, 1, 70003, 70016, 13, 70017, 70018, 1, 70067, 70080, 1, 70089, 70092, 1, 70094, 70095, 1, 70188, 70199, 1, 70206, 70209, 3, 70367, 70378, 1, 70400, 70403, 1, 70459, 70460, 1, 70462, 70468, 1, 70471, 70472, 1, 70475, 70477, 1, 70487, 70498, 11, 70499, 70502, 3, 70503, 70508, 1, 70512, 70516, 1, 70584, 70592, 1, 70594, 70597, 3, 70599, 70602, 1, 70604, 70608, 1, 70610, 70625, 15, 70626, 70709, 83, 70710, 70726, 1, 70750, 70832, 82, 70833, 70851, 1, 71087, 71093, 1, 71096, 71104, 1, 71132, 71133, 1, 71216, 71232, 1, 71339, 71351, 1, 71453, 71467, 1, 71724, 71738, 1, 71984, 71989, 1, 71991, 71992, 1, 71995, 71998, 1, 72e3, 72002, 2, 72003, 72145, 142, 72146, 72151, 1, 72154, 72160, 1, 72164, 72193, 29, 72194, 72202, 1, 72243, 72249, 1, 72251, 72254, 1, 72263, 72273, 10, 72274, 72283, 1, 72330, 72345, 1, 72751, 72758, 1, 72760, 72767, 1, 72850, 72871, 1, 72873, 72886, 1, 73009, 73014, 1, 73018, 73020, 2, 73021, 73023, 2, 73024, 73029, 1, 73031, 73098, 67, 73099, 73102, 1, 73104, 73105, 1, 73107, 73111, 1, 73459, 73462, 1, 73472, 73473, 1, 73475, 73524, 49, 73525, 73530, 1, 73534, 73538, 1, 73562, 78912, 5350, 78919, 78933, 1, 90398, 90415, 1, 92912, 92916, 1, 92976, 92982, 1, 94031, 94033, 2, 94034, 94087, 1, 94095, 94098, 1, 94180, 94192, 12, 94193, 113821, 19628, 113822, 118528, 4706, 118529, 118573, 1, 118576, 118598, 1, 119141, 119145, 1, 119149, 119154, 1, 119163, 119170, 1, 119173, 119179, 1, 119210, 119213, 1, 119362, 119364, 1, 121344, 121398, 1, 121403, 121452, 1, 121461, 121476, 15, 121499, 121503, 1, 121505, 121519, 1, 122880, 122886, 1, 122888, 122904, 1, 122907, 122913, 1, 122915, 122916, 1, 122918, 122922, 1, 123023, 123184, 161, 123185, 123190, 1, 123566, 123628, 62, 123629, 123631, 1, 124140, 124143, 1, 124398, 124399, 1, 125136, 125142, 1, 125252, 125258, 1, 917760, 917999, 1]));
      static foldM = new a(new Uint32Array([921, 953, 32, 8126, 8126, 1]));
      static Mc = new a(new Uint32Array([2307, 2363, 56, 2366, 2368, 1, 2377, 2380, 1, 2382, 2383, 1, 2434, 2435, 1, 2494, 2496, 1, 2503, 2504, 1, 2507, 2508, 1, 2519, 2563, 44, 2622, 2624, 1, 2691, 2750, 59, 2751, 2752, 1, 2761, 2763, 2, 2764, 2818, 54, 2819, 2878, 59, 2880, 2887, 7, 2888, 2891, 3, 2892, 2903, 11, 3006, 3007, 1, 3009, 3010, 1, 3014, 3016, 1, 3018, 3020, 1, 3031, 3073, 42, 3074, 3075, 1, 3137, 3140, 1, 3202, 3203, 1, 3262, 3264, 2, 3265, 3268, 1, 3271, 3272, 1, 3274, 3275, 1, 3285, 3286, 1, 3315, 3330, 15, 3331, 3390, 59, 3391, 3392, 1, 3398, 3400, 1, 3402, 3404, 1, 3415, 3458, 43, 3459, 3535, 76, 3536, 3537, 1, 3544, 3551, 1, 3570, 3571, 1, 3902, 3903, 1, 3967, 4139, 172, 4140, 4145, 5, 4152, 4155, 3, 4156, 4182, 26, 4183, 4194, 11, 4195, 4196, 1, 4199, 4205, 1, 4227, 4228, 1, 4231, 4236, 1, 4239, 4250, 11, 4251, 4252, 1, 5909, 5940, 31, 6070, 6078, 8, 6079, 6085, 1, 6087, 6088, 1, 6435, 6438, 1, 6441, 6443, 1, 6448, 6449, 1, 6451, 6456, 1, 6681, 6682, 1, 6741, 6743, 2, 6753, 6755, 2, 6756, 6765, 9, 6766, 6770, 1, 6916, 6965, 49, 6971, 6973, 2, 6974, 6977, 1, 6979, 6980, 1, 7042, 7073, 31, 7078, 7079, 1, 7082, 7143, 61, 7146, 7148, 1, 7150, 7154, 4, 7155, 7204, 49, 7205, 7211, 1, 7220, 7221, 1, 7393, 7415, 22, 12334, 12335, 1, 43043, 43044, 1, 43047, 43136, 89, 43137, 43188, 51, 43189, 43203, 1, 43346, 43347, 1, 43395, 43444, 49, 43445, 43450, 5, 43451, 43454, 3, 43455, 43456, 1, 43567, 43568, 1, 43571, 43572, 1, 43597, 43643, 46, 43645, 43755, 110, 43758, 43759, 1, 43765, 44003, 238, 44004, 44006, 2, 44007, 44009, 2, 44010, 44012, 2, 69632, 69634, 2, 69762, 69808, 46, 69809, 69810, 1, 69815, 69816, 1, 69932, 69957, 25, 69958, 70018, 60, 70067, 70069, 1, 70079, 70080, 1, 70094, 70188, 94, 70189, 70190, 1, 70194, 70195, 1, 70197, 70368, 171, 70369, 70370, 1, 70402, 70403, 1, 70462, 70463, 1, 70465, 70468, 1, 70471, 70472, 1, 70475, 70477, 1, 70487, 70498, 11, 70499, 70584, 85, 70585, 70586, 1, 70594, 70597, 3, 70599, 70602, 1, 70604, 70605, 1, 70607, 70709, 102, 70710, 70711, 1, 70720, 70721, 1, 70725, 70832, 107, 70833, 70834, 1, 70841, 70843, 2, 70844, 70846, 1, 70849, 71087, 238, 71088, 71089, 1, 71096, 71099, 1, 71102, 71216, 114, 71217, 71218, 1, 71227, 71228, 1, 71230, 71340, 110, 71342, 71343, 1, 71350, 71454, 104, 71456, 71457, 1, 71462, 71724, 262, 71725, 71726, 1, 71736, 71984, 248, 71985, 71989, 1, 71991, 71992, 1, 71997, 72e3, 3, 72002, 72145, 143, 72146, 72147, 1, 72156, 72159, 1, 72164, 72249, 85, 72279, 72280, 1, 72343, 72751, 408, 72766, 72873, 107, 72881, 72884, 3, 73098, 73102, 1, 73107, 73108, 1, 73110, 73461, 351, 73462, 73475, 13, 73524, 73525, 1, 73534, 73535, 1, 73537, 90410, 16873, 90411, 90412, 1, 94033, 94087, 1, 94192, 94193, 1, 119141, 119142, 1, 119149, 119154, 1]));
      static Me = new a(new Uint32Array([1160, 1161, 1, 6846, 8413, 1567, 8414, 8416, 1, 8418, 8420, 1, 42608, 42610, 1]));
      static Mn = new a(new Uint32Array([768, 879, 1, 1155, 1159, 1, 1425, 1469, 1, 1471, 1473, 2, 1474, 1476, 2, 1477, 1479, 2, 1552, 1562, 1, 1611, 1631, 1, 1648, 1750, 102, 1751, 1756, 1, 1759, 1764, 1, 1767, 1768, 1, 1770, 1773, 1, 1809, 1840, 31, 1841, 1866, 1, 1958, 1968, 1, 2027, 2035, 1, 2045, 2070, 25, 2071, 2073, 1, 2075, 2083, 1, 2085, 2087, 1, 2089, 2093, 1, 2137, 2139, 1, 2199, 2207, 1, 2250, 2273, 1, 2275, 2306, 1, 2362, 2364, 2, 2369, 2376, 1, 2381, 2385, 4, 2386, 2391, 1, 2402, 2403, 1, 2433, 2492, 59, 2497, 2500, 1, 2509, 2530, 21, 2531, 2558, 27, 2561, 2562, 1, 2620, 2625, 5, 2626, 2631, 5, 2632, 2635, 3, 2636, 2637, 1, 2641, 2672, 31, 2673, 2677, 4, 2689, 2690, 1, 2748, 2753, 5, 2754, 2757, 1, 2759, 2760, 1, 2765, 2786, 21, 2787, 2810, 23, 2811, 2815, 1, 2817, 2876, 59, 2879, 2881, 2, 2882, 2884, 1, 2893, 2901, 8, 2902, 2914, 12, 2915, 2946, 31, 3008, 3021, 13, 3072, 3076, 4, 3132, 3134, 2, 3135, 3136, 1, 3142, 3144, 1, 3146, 3149, 1, 3157, 3158, 1, 3170, 3171, 1, 3201, 3260, 59, 3263, 3270, 7, 3276, 3277, 1, 3298, 3299, 1, 3328, 3329, 1, 3387, 3388, 1, 3393, 3396, 1, 3405, 3426, 21, 3427, 3457, 30, 3530, 3538, 8, 3539, 3540, 1, 3542, 3633, 91, 3636, 3642, 1, 3655, 3662, 1, 3761, 3764, 3, 3765, 3772, 1, 3784, 3790, 1, 3864, 3865, 1, 3893, 3897, 2, 3953, 3966, 1, 3968, 3972, 1, 3974, 3975, 1, 3981, 3991, 1, 3993, 4028, 1, 4038, 4141, 103, 4142, 4144, 1, 4146, 4151, 1, 4153, 4154, 1, 4157, 4158, 1, 4184, 4185, 1, 4190, 4192, 1, 4209, 4212, 1, 4226, 4229, 3, 4230, 4237, 7, 4253, 4957, 704, 4958, 4959, 1, 5906, 5908, 1, 5938, 5939, 1, 5970, 5971, 1, 6002, 6003, 1, 6068, 6069, 1, 6071, 6077, 1, 6086, 6089, 3, 6090, 6099, 1, 6109, 6155, 46, 6156, 6157, 1, 6159, 6277, 118, 6278, 6313, 35, 6432, 6434, 1, 6439, 6440, 1, 6450, 6457, 7, 6458, 6459, 1, 6679, 6680, 1, 6683, 6742, 59, 6744, 6750, 1, 6752, 6754, 2, 6757, 6764, 1, 6771, 6780, 1, 6783, 6832, 49, 6833, 6845, 1, 6847, 6862, 1, 6912, 6915, 1, 6964, 6966, 2, 6967, 6970, 1, 6972, 6978, 6, 7019, 7027, 1, 7040, 7041, 1, 7074, 7077, 1, 7080, 7081, 1, 7083, 7085, 1, 7142, 7144, 2, 7145, 7149, 4, 7151, 7153, 1, 7212, 7219, 1, 7222, 7223, 1, 7376, 7378, 1, 7380, 7392, 1, 7394, 7400, 1, 7405, 7412, 7, 7416, 7417, 1, 7616, 7679, 1, 8400, 8412, 1, 8417, 8421, 4, 8422, 8432, 1, 11503, 11505, 1, 11647, 11744, 97, 11745, 11775, 1, 12330, 12333, 1, 12441, 12442, 1, 42607, 42612, 5, 42613, 42621, 1, 42654, 42655, 1, 42736, 42737, 1, 43010, 43014, 4, 43019, 43045, 26, 43046, 43052, 6, 43204, 43205, 1, 43232, 43249, 1, 43263, 43302, 39, 43303, 43309, 1, 43335, 43345, 1, 43392, 43394, 1, 43443, 43446, 3, 43447, 43449, 1, 43452, 43453, 1, 43493, 43561, 68, 43562, 43566, 1, 43569, 43570, 1, 43573, 43574, 1, 43587, 43596, 9, 43644, 43696, 52, 43698, 43700, 1, 43703, 43704, 1, 43710, 43711, 1, 43713, 43756, 43, 43757, 43766, 9, 44005, 44008, 3, 44013, 64286, 20273, 65024, 65039, 1, 65056, 65071, 1, 66045, 66272, 227, 66422, 66426, 1, 68097, 68099, 1, 68101, 68102, 1, 68108, 68111, 1, 68152, 68154, 1, 68159, 68325, 166, 68326, 68900, 574, 68901, 68903, 1, 68969, 68973, 1, 69291, 69292, 1, 69372, 69375, 1, 69446, 69456, 1, 69506, 69509, 1, 69633, 69688, 55, 69689, 69702, 1, 69744, 69747, 3, 69748, 69759, 11, 69760, 69761, 1, 69811, 69814, 1, 69817, 69818, 1, 69826, 69888, 62, 69889, 69890, 1, 69927, 69931, 1, 69933, 69940, 1, 70003, 70016, 13, 70017, 70070, 53, 70071, 70078, 1, 70089, 70092, 1, 70095, 70191, 96, 70192, 70193, 1, 70196, 70198, 2, 70199, 70206, 7, 70209, 70367, 158, 70371, 70378, 1, 70400, 70401, 1, 70459, 70460, 1, 70464, 70502, 38, 70503, 70508, 1, 70512, 70516, 1, 70587, 70592, 1, 70606, 70610, 2, 70625, 70626, 1, 70712, 70719, 1, 70722, 70724, 1, 70726, 70750, 24, 70835, 70840, 1, 70842, 70847, 5, 70848, 70850, 2, 70851, 71090, 239, 71091, 71093, 1, 71100, 71101, 1, 71103, 71104, 1, 71132, 71133, 1, 71219, 71226, 1, 71229, 71231, 2, 71232, 71339, 107, 71341, 71344, 3, 71345, 71349, 1, 71351, 71453, 102, 71455, 71458, 3, 71459, 71461, 1, 71463, 71467, 1, 71727, 71735, 1, 71737, 71738, 1, 71995, 71996, 1, 71998, 72003, 5, 72148, 72151, 1, 72154, 72155, 1, 72160, 72193, 33, 72194, 72202, 1, 72243, 72248, 1, 72251, 72254, 1, 72263, 72273, 10, 72274, 72278, 1, 72281, 72283, 1, 72330, 72342, 1, 72344, 72345, 1, 72752, 72758, 1, 72760, 72765, 1, 72767, 72850, 83, 72851, 72871, 1, 72874, 72880, 1, 72882, 72883, 1, 72885, 72886, 1, 73009, 73014, 1, 73018, 73020, 2, 73021, 73023, 2, 73024, 73029, 1, 73031, 73104, 73, 73105, 73109, 4, 73111, 73459, 348, 73460, 73472, 12, 73473, 73526, 53, 73527, 73530, 1, 73536, 73538, 2, 73562, 78912, 5350, 78919, 78933, 1, 90398, 90409, 1, 90413, 90415, 1, 92912, 92916, 1, 92976, 92982, 1, 94031, 94095, 64, 94096, 94098, 1, 94180, 113821, 19641, 113822, 118528, 4706, 118529, 118573, 1, 118576, 118598, 1, 119143, 119145, 1, 119163, 119170, 1, 119173, 119179, 1, 119210, 119213, 1, 119362, 119364, 1, 121344, 121398, 1, 121403, 121452, 1, 121461, 121476, 15, 121499, 121503, 1, 121505, 121519, 1, 122880, 122886, 1, 122888, 122904, 1, 122907, 122913, 1, 122915, 122916, 1, 122918, 122922, 1, 123023, 123184, 161, 123185, 123190, 1, 123566, 123628, 62, 123629, 123631, 1, 124140, 124143, 1, 124398, 124399, 1, 125136, 125142, 1, 125252, 125258, 1, 917760, 917999, 1]));
      static foldMn = new a(new Uint32Array([921, 953, 32, 8126, 8126, 1]));
      static N = new a(new Uint32Array([48, 57, 1, 178, 179, 1, 185, 188, 3, 189, 190, 1, 1632, 1641, 1, 1776, 1785, 1, 1984, 1993, 1, 2406, 2415, 1, 2534, 2543, 1, 2548, 2553, 1, 2662, 2671, 1, 2790, 2799, 1, 2918, 2927, 1, 2930, 2935, 1, 3046, 3058, 1, 3174, 3183, 1, 3192, 3198, 1, 3302, 3311, 1, 3416, 3422, 1, 3430, 3448, 1, 3558, 3567, 1, 3664, 3673, 1, 3792, 3801, 1, 3872, 3891, 1, 4160, 4169, 1, 4240, 4249, 1, 4969, 4988, 1, 5870, 5872, 1, 6112, 6121, 1, 6128, 6137, 1, 6160, 6169, 1, 6470, 6479, 1, 6608, 6618, 1, 6784, 6793, 1, 6800, 6809, 1, 6992, 7001, 1, 7088, 7097, 1, 7232, 7241, 1, 7248, 7257, 1, 8304, 8308, 4, 8309, 8313, 1, 8320, 8329, 1, 8528, 8578, 1, 8581, 8585, 1, 9312, 9371, 1, 9450, 9471, 1, 10102, 10131, 1, 11517, 12295, 778, 12321, 12329, 1, 12344, 12346, 1, 12690, 12693, 1, 12832, 12841, 1, 12872, 12879, 1, 12881, 12895, 1, 12928, 12937, 1, 12977, 12991, 1, 42528, 42537, 1, 42726, 42735, 1, 43056, 43061, 1, 43216, 43225, 1, 43264, 43273, 1, 43472, 43481, 1, 43504, 43513, 1, 43600, 43609, 1, 44016, 44025, 1, 65296, 65305, 1, 65799, 65843, 1, 65856, 65912, 1, 65930, 65931, 1, 66273, 66299, 1, 66336, 66339, 1, 66369, 66378, 9, 66513, 66517, 1, 66720, 66729, 1, 67672, 67679, 1, 67705, 67711, 1, 67751, 67759, 1, 67835, 67839, 1, 67862, 67867, 1, 68028, 68029, 1, 68032, 68047, 1, 68050, 68095, 1, 68160, 68168, 1, 68221, 68222, 1, 68253, 68255, 1, 68331, 68335, 1, 68440, 68447, 1, 68472, 68479, 1, 68521, 68527, 1, 68858, 68863, 1, 68912, 68921, 1, 68928, 68937, 1, 69216, 69246, 1, 69405, 69414, 1, 69457, 69460, 1, 69573, 69579, 1, 69714, 69743, 1, 69872, 69881, 1, 69942, 69951, 1, 70096, 70105, 1, 70113, 70132, 1, 70384, 70393, 1, 70736, 70745, 1, 70864, 70873, 1, 71248, 71257, 1, 71360, 71369, 1, 71376, 71395, 1, 71472, 71483, 1, 71904, 71922, 1, 72016, 72025, 1, 72688, 72697, 1, 72784, 72812, 1, 73040, 73049, 1, 73120, 73129, 1, 73552, 73561, 1, 73664, 73684, 1, 74752, 74862, 1, 90416, 90425, 1, 92768, 92777, 1, 92864, 92873, 1, 93008, 93017, 1, 93019, 93025, 1, 93552, 93561, 1, 93824, 93846, 1, 118e3, 118009, 1, 119488, 119507, 1, 119520, 119539, 1, 119648, 119672, 1, 120782, 120831, 1, 123200, 123209, 1, 123632, 123641, 1, 124144, 124153, 1, 124401, 124410, 1, 125127, 125135, 1, 125264, 125273, 1, 126065, 126123, 1, 126125, 126127, 1, 126129, 126132, 1, 126209, 126253, 1, 126255, 126269, 1, 127232, 127244, 1, 130032, 130041, 1]));
      static Nd = new a(new Uint32Array([48, 57, 1, 1632, 1641, 1, 1776, 1785, 1, 1984, 1993, 1, 2406, 2415, 1, 2534, 2543, 1, 2662, 2671, 1, 2790, 2799, 1, 2918, 2927, 1, 3046, 3055, 1, 3174, 3183, 1, 3302, 3311, 1, 3430, 3439, 1, 3558, 3567, 1, 3664, 3673, 1, 3792, 3801, 1, 3872, 3881, 1, 4160, 4169, 1, 4240, 4249, 1, 6112, 6121, 1, 6160, 6169, 1, 6470, 6479, 1, 6608, 6617, 1, 6784, 6793, 1, 6800, 6809, 1, 6992, 7001, 1, 7088, 7097, 1, 7232, 7241, 1, 7248, 7257, 1, 42528, 42537, 1, 43216, 43225, 1, 43264, 43273, 1, 43472, 43481, 1, 43504, 43513, 1, 43600, 43609, 1, 44016, 44025, 1, 65296, 65305, 1, 66720, 66729, 1, 68912, 68921, 1, 68928, 68937, 1, 69734, 69743, 1, 69872, 69881, 1, 69942, 69951, 1, 70096, 70105, 1, 70384, 70393, 1, 70736, 70745, 1, 70864, 70873, 1, 71248, 71257, 1, 71360, 71369, 1, 71376, 71395, 1, 71472, 71481, 1, 71904, 71913, 1, 72016, 72025, 1, 72688, 72697, 1, 72784, 72793, 1, 73040, 73049, 1, 73120, 73129, 1, 73552, 73561, 1, 90416, 90425, 1, 92768, 92777, 1, 92864, 92873, 1, 93008, 93017, 1, 93552, 93561, 1, 118e3, 118009, 1, 120782, 120831, 1, 123200, 123209, 1, 123632, 123641, 1, 124144, 124153, 1, 124401, 124410, 1, 125264, 125273, 1, 130032, 130041, 1]));
      static Nl = new a(new Uint32Array([5870, 5872, 1, 8544, 8578, 1, 8581, 8584, 1, 12295, 12321, 26, 12322, 12329, 1, 12344, 12346, 1, 42726, 42735, 1, 65856, 65908, 1, 66369, 66378, 9, 66513, 66517, 1, 74752, 74862, 1]));
      static No = new a(new Uint32Array([178, 179, 1, 185, 188, 3, 189, 190, 1, 2548, 2553, 1, 2930, 2935, 1, 3056, 3058, 1, 3192, 3198, 1, 3416, 3422, 1, 3440, 3448, 1, 3882, 3891, 1, 4969, 4988, 1, 6128, 6137, 1, 6618, 8304, 1686, 8308, 8313, 1, 8320, 8329, 1, 8528, 8543, 1, 8585, 9312, 727, 9313, 9371, 1, 9450, 9471, 1, 10102, 10131, 1, 11517, 12690, 1173, 12691, 12693, 1, 12832, 12841, 1, 12872, 12879, 1, 12881, 12895, 1, 12928, 12937, 1, 12977, 12991, 1, 43056, 43061, 1, 65799, 65843, 1, 65909, 65912, 1, 65930, 65931, 1, 66273, 66299, 1, 66336, 66339, 1, 67672, 67679, 1, 67705, 67711, 1, 67751, 67759, 1, 67835, 67839, 1, 67862, 67867, 1, 68028, 68029, 1, 68032, 68047, 1, 68050, 68095, 1, 68160, 68168, 1, 68221, 68222, 1, 68253, 68255, 1, 68331, 68335, 1, 68440, 68447, 1, 68472, 68479, 1, 68521, 68527, 1, 68858, 68863, 1, 69216, 69246, 1, 69405, 69414, 1, 69457, 69460, 1, 69573, 69579, 1, 69714, 69733, 1, 70113, 70132, 1, 71482, 71483, 1, 71914, 71922, 1, 72794, 72812, 1, 73664, 73684, 1, 93019, 93025, 1, 93824, 93846, 1, 119488, 119507, 1, 119520, 119539, 1, 119648, 119672, 1, 125127, 125135, 1, 126065, 126123, 1, 126125, 126127, 1, 126129, 126132, 1, 126209, 126253, 1, 126255, 126269, 1, 127232, 127244, 1]));
      static P = new a(new Uint32Array([33, 35, 1, 37, 42, 1, 44, 47, 1, 58, 59, 1, 63, 64, 1, 91, 93, 1, 95, 123, 28, 125, 161, 36, 167, 171, 4, 182, 183, 1, 187, 191, 4, 894, 903, 9, 1370, 1375, 1, 1417, 1418, 1, 1470, 1472, 2, 1475, 1478, 3, 1523, 1524, 1, 1545, 1546, 1, 1548, 1549, 1, 1563, 1565, 2, 1566, 1567, 1, 1642, 1645, 1, 1748, 1792, 44, 1793, 1805, 1, 2039, 2041, 1, 2096, 2110, 1, 2142, 2404, 262, 2405, 2416, 11, 2557, 2678, 121, 2800, 3191, 391, 3204, 3572, 368, 3663, 3674, 11, 3675, 3844, 169, 3845, 3858, 1, 3860, 3898, 38, 3899, 3901, 1, 3973, 4048, 75, 4049, 4052, 1, 4057, 4058, 1, 4170, 4175, 1, 4347, 4960, 613, 4961, 4968, 1, 5120, 5742, 622, 5787, 5788, 1, 5867, 5869, 1, 5941, 5942, 1, 6100, 6102, 1, 6104, 6106, 1, 6144, 6154, 1, 6468, 6469, 1, 6686, 6687, 1, 6816, 6822, 1, 6824, 6829, 1, 6990, 6991, 1, 7002, 7008, 1, 7037, 7039, 1, 7164, 7167, 1, 7227, 7231, 1, 7294, 7295, 1, 7360, 7367, 1, 7379, 8208, 829, 8209, 8231, 1, 8240, 8259, 1, 8261, 8273, 1, 8275, 8286, 1, 8317, 8318, 1, 8333, 8334, 1, 8968, 8971, 1, 9001, 9002, 1, 10088, 10101, 1, 10181, 10182, 1, 10214, 10223, 1, 10627, 10648, 1, 10712, 10715, 1, 10748, 10749, 1, 11513, 11516, 1, 11518, 11519, 1, 11632, 11776, 144, 11777, 11822, 1, 11824, 11855, 1, 11858, 11869, 1, 12289, 12291, 1, 12296, 12305, 1, 12308, 12319, 1, 12336, 12349, 13, 12448, 12539, 91, 42238, 42239, 1, 42509, 42511, 1, 42611, 42622, 11, 42738, 42743, 1, 43124, 43127, 1, 43214, 43215, 1, 43256, 43258, 1, 43260, 43310, 50, 43311, 43359, 48, 43457, 43469, 1, 43486, 43487, 1, 43612, 43615, 1, 43742, 43743, 1, 43760, 43761, 1, 44011, 64830, 20819, 64831, 65040, 209, 65041, 65049, 1, 65072, 65106, 1, 65108, 65121, 1, 65123, 65128, 5, 65130, 65131, 1, 65281, 65283, 1, 65285, 65290, 1, 65292, 65295, 1, 65306, 65307, 1, 65311, 65312, 1, 65339, 65341, 1, 65343, 65371, 28, 65373, 65375, 2, 65376, 65381, 1, 65792, 65794, 1, 66463, 66512, 49, 66927, 67671, 744, 67871, 67903, 32, 68176, 68184, 1, 68223, 68336, 113, 68337, 68342, 1, 68409, 68415, 1, 68505, 68508, 1, 68974, 69293, 319, 69461, 69465, 1, 69510, 69513, 1, 69703, 69709, 1, 69819, 69820, 1, 69822, 69825, 1, 69952, 69955, 1, 70004, 70005, 1, 70085, 70088, 1, 70093, 70107, 14, 70109, 70111, 1, 70200, 70205, 1, 70313, 70612, 299, 70613, 70615, 2, 70616, 70731, 115, 70732, 70735, 1, 70746, 70747, 1, 70749, 70854, 105, 71105, 71127, 1, 71233, 71235, 1, 71264, 71276, 1, 71353, 71484, 131, 71485, 71486, 1, 71739, 72004, 265, 72005, 72006, 1, 72162, 72255, 93, 72256, 72262, 1, 72346, 72348, 1, 72350, 72354, 1, 72448, 72457, 1, 72673, 72769, 96, 72770, 72773, 1, 72816, 72817, 1, 73463, 73464, 1, 73539, 73551, 1, 73727, 74864, 1137, 74865, 74868, 1, 77809, 77810, 1, 92782, 92783, 1, 92917, 92983, 66, 92984, 92987, 1, 92996, 93549, 553, 93550, 93551, 1, 93847, 93850, 1, 94178, 113823, 19645, 121479, 121483, 1, 124415, 125278, 863, 125279, 125279, 1]));
      static Pc = new a(new Uint32Array([95, 8255, 8160, 8256, 8276, 20, 65075, 65076, 1, 65101, 65103, 1, 65343, 65343, 1]));
      static Pd = new a(new Uint32Array([45, 1418, 1373, 1470, 5120, 3650, 6150, 8208, 2058, 8209, 8213, 1, 11799, 11802, 3, 11834, 11835, 1, 11840, 11869, 29, 12316, 12336, 20, 12448, 65073, 52625, 65074, 65112, 38, 65123, 65293, 170, 68974, 69293, 319]));
      static Pe = new a(new Uint32Array([41, 93, 52, 125, 3899, 3774, 3901, 5788, 1887, 8262, 8318, 56, 8334, 8969, 635, 8971, 9002, 31, 10089, 10101, 2, 10182, 10215, 33, 10217, 10223, 2, 10628, 10648, 2, 10713, 10715, 2, 10749, 11811, 1062, 11813, 11817, 2, 11862, 11868, 2, 12297, 12305, 2, 12309, 12315, 2, 12318, 12319, 1, 64830, 65048, 218, 65078, 65092, 2, 65096, 65114, 18, 65116, 65118, 2, 65289, 65341, 52, 65373, 65379, 3]));
      static Pf = new a(new Uint32Array([187, 8217, 8030, 8221, 8250, 29, 11779, 11781, 2, 11786, 11789, 3, 11805, 11809, 4]));
      static Pi = new a(new Uint32Array([171, 8216, 8045, 8219, 8220, 1, 8223, 8249, 26, 11778, 11780, 2, 11785, 11788, 3, 11804, 11808, 4]));
      static Po = new a(new Uint32Array([33, 35, 1, 37, 39, 1, 42, 46, 2, 47, 58, 11, 59, 63, 4, 64, 92, 28, 161, 167, 6, 182, 183, 1, 191, 894, 703, 903, 1370, 467, 1371, 1375, 1, 1417, 1472, 55, 1475, 1478, 3, 1523, 1524, 1, 1545, 1546, 1, 1548, 1549, 1, 1563, 1565, 2, 1566, 1567, 1, 1642, 1645, 1, 1748, 1792, 44, 1793, 1805, 1, 2039, 2041, 1, 2096, 2110, 1, 2142, 2404, 262, 2405, 2416, 11, 2557, 2678, 121, 2800, 3191, 391, 3204, 3572, 368, 3663, 3674, 11, 3675, 3844, 169, 3845, 3858, 1, 3860, 3973, 113, 4048, 4052, 1, 4057, 4058, 1, 4170, 4175, 1, 4347, 4960, 613, 4961, 4968, 1, 5742, 5867, 125, 5868, 5869, 1, 5941, 5942, 1, 6100, 6102, 1, 6104, 6106, 1, 6144, 6149, 1, 6151, 6154, 1, 6468, 6469, 1, 6686, 6687, 1, 6816, 6822, 1, 6824, 6829, 1, 6990, 6991, 1, 7002, 7008, 1, 7037, 7039, 1, 7164, 7167, 1, 7227, 7231, 1, 7294, 7295, 1, 7360, 7367, 1, 7379, 8214, 835, 8215, 8224, 9, 8225, 8231, 1, 8240, 8248, 1, 8251, 8254, 1, 8257, 8259, 1, 8263, 8273, 1, 8275, 8277, 2, 8278, 8286, 1, 11513, 11516, 1, 11518, 11519, 1, 11632, 11776, 144, 11777, 11782, 5, 11783, 11784, 1, 11787, 11790, 3, 11791, 11798, 1, 11800, 11801, 1, 11803, 11806, 3, 11807, 11818, 11, 11819, 11822, 1, 11824, 11833, 1, 11836, 11839, 1, 11841, 11843, 2, 11844, 11855, 1, 11858, 11860, 1, 12289, 12291, 1, 12349, 12539, 190, 42238, 42239, 1, 42509, 42511, 1, 42611, 42622, 11, 42738, 42743, 1, 43124, 43127, 1, 43214, 43215, 1, 43256, 43258, 1, 43260, 43310, 50, 43311, 43359, 48, 43457, 43469, 1, 43486, 43487, 1, 43612, 43615, 1, 43742, 43743, 1, 43760, 43761, 1, 44011, 65040, 21029, 65041, 65046, 1, 65049, 65072, 23, 65093, 65094, 1, 65097, 65100, 1, 65104, 65106, 1, 65108, 65111, 1, 65119, 65121, 1, 65128, 65130, 2, 65131, 65281, 150, 65282, 65283, 1, 65285, 65287, 1, 65290, 65294, 2, 65295, 65306, 11, 65307, 65311, 4, 65312, 65340, 28, 65377, 65380, 3, 65381, 65792, 411, 65793, 65794, 1, 66463, 66512, 49, 66927, 67671, 744, 67871, 67903, 32, 68176, 68184, 1, 68223, 68336, 113, 68337, 68342, 1, 68409, 68415, 1, 68505, 68508, 1, 69461, 69465, 1, 69510, 69513, 1, 69703, 69709, 1, 69819, 69820, 1, 69822, 69825, 1, 69952, 69955, 1, 70004, 70005, 1, 70085, 70088, 1, 70093, 70107, 14, 70109, 70111, 1, 70200, 70205, 1, 70313, 70612, 299, 70613, 70615, 2, 70616, 70731, 115, 70732, 70735, 1, 70746, 70747, 1, 70749, 70854, 105, 71105, 71127, 1, 71233, 71235, 1, 71264, 71276, 1, 71353, 71484, 131, 71485, 71486, 1, 71739, 72004, 265, 72005, 72006, 1, 72162, 72255, 93, 72256, 72262, 1, 72346, 72348, 1, 72350, 72354, 1, 72448, 72457, 1, 72673, 72769, 96, 72770, 72773, 1, 72816, 72817, 1, 73463, 73464, 1, 73539, 73551, 1, 73727, 74864, 1137, 74865, 74868, 1, 77809, 77810, 1, 92782, 92783, 1, 92917, 92983, 66, 92984, 92987, 1, 92996, 93549, 553, 93550, 93551, 1, 93847, 93850, 1, 94178, 113823, 19645, 121479, 121483, 1, 124415, 125278, 863, 125279, 125279, 1]));
      static Ps = new a(new Uint32Array([40, 91, 51, 123, 3898, 3775, 3900, 5787, 1887, 8218, 8222, 4, 8261, 8317, 56, 8333, 8968, 635, 8970, 9001, 31, 10088, 10100, 2, 10181, 10214, 33, 10216, 10222, 2, 10627, 10647, 2, 10712, 10714, 2, 10748, 11810, 1062, 11812, 11816, 2, 11842, 11861, 19, 11863, 11867, 2, 12296, 12304, 2, 12308, 12314, 2, 12317, 64831, 52514, 65047, 65077, 30, 65079, 65091, 2, 65095, 65113, 18, 65115, 65117, 2, 65288, 65339, 51, 65371, 65375, 4, 65378, 65378, 1]));
      static S = new a(new Uint32Array([36, 43, 7, 60, 62, 1, 94, 96, 2, 124, 126, 2, 162, 166, 1, 168, 169, 1, 172, 174, 2, 175, 177, 1, 180, 184, 4, 215, 247, 32, 706, 709, 1, 722, 735, 1, 741, 747, 1, 749, 751, 2, 752, 767, 1, 885, 900, 15, 901, 1014, 113, 1154, 1421, 267, 1422, 1423, 1, 1542, 1544, 1, 1547, 1550, 3, 1551, 1758, 207, 1769, 1789, 20, 1790, 2038, 248, 2046, 2047, 1, 2184, 2546, 362, 2547, 2554, 7, 2555, 2801, 246, 2928, 3059, 131, 3060, 3066, 1, 3199, 3407, 208, 3449, 3647, 198, 3841, 3843, 1, 3859, 3861, 2, 3862, 3863, 1, 3866, 3871, 1, 3892, 3896, 2, 4030, 4037, 1, 4039, 4044, 1, 4046, 4047, 1, 4053, 4056, 1, 4254, 4255, 1, 5008, 5017, 1, 5741, 6107, 366, 6464, 6622, 158, 6623, 6655, 1, 7009, 7018, 1, 7028, 7036, 1, 8125, 8127, 2, 8128, 8129, 1, 8141, 8143, 1, 8157, 8159, 1, 8173, 8175, 1, 8189, 8190, 1, 8260, 8274, 14, 8314, 8316, 1, 8330, 8332, 1, 8352, 8384, 1, 8448, 8449, 1, 8451, 8454, 1, 8456, 8457, 1, 8468, 8470, 2, 8471, 8472, 1, 8478, 8483, 1, 8485, 8489, 2, 8494, 8506, 12, 8507, 8512, 5, 8513, 8516, 1, 8522, 8525, 1, 8527, 8586, 59, 8587, 8592, 5, 8593, 8967, 1, 8972, 9e3, 1, 9003, 9257, 1, 9280, 9290, 1, 9372, 9449, 1, 9472, 10087, 1, 10132, 10180, 1, 10183, 10213, 1, 10224, 10626, 1, 10649, 10711, 1, 10716, 10747, 1, 10750, 11123, 1, 11126, 11157, 1, 11159, 11263, 1, 11493, 11498, 1, 11856, 11857, 1, 11904, 11929, 1, 11931, 12019, 1, 12032, 12245, 1, 12272, 12287, 1, 12292, 12306, 14, 12307, 12320, 13, 12342, 12343, 1, 12350, 12351, 1, 12443, 12444, 1, 12688, 12689, 1, 12694, 12703, 1, 12736, 12773, 1, 12783, 12800, 17, 12801, 12830, 1, 12842, 12871, 1, 12880, 12896, 16, 12897, 12927, 1, 12938, 12976, 1, 12992, 13311, 1, 19904, 19967, 1, 42128, 42182, 1, 42752, 42774, 1, 42784, 42785, 1, 42889, 42890, 1, 43048, 43051, 1, 43062, 43065, 1, 43639, 43641, 1, 43867, 43882, 15, 43883, 64297, 20414, 64434, 64450, 1, 64832, 64847, 1, 64975, 65020, 45, 65021, 65023, 1, 65122, 65124, 2, 65125, 65126, 1, 65129, 65284, 155, 65291, 65308, 17, 65309, 65310, 1, 65342, 65344, 2, 65372, 65374, 2, 65504, 65510, 1, 65512, 65518, 1, 65532, 65533, 1, 65847, 65855, 1, 65913, 65929, 1, 65932, 65934, 1, 65936, 65948, 1, 65952, 66e3, 48, 66001, 66044, 1, 67703, 67704, 1, 68296, 69006, 710, 69007, 71487, 2480, 73685, 73713, 1, 92988, 92991, 1, 92997, 113820, 20823, 117760, 117999, 1, 118016, 118451, 1, 118608, 118723, 1, 118784, 119029, 1, 119040, 119078, 1, 119081, 119140, 1, 119146, 119148, 1, 119171, 119172, 1, 119180, 119209, 1, 119214, 119274, 1, 119296, 119361, 1, 119365, 119552, 187, 119553, 119638, 1, 120513, 120539, 26, 120571, 120597, 26, 120629, 120655, 26, 120687, 120713, 26, 120745, 120771, 26, 120832, 121343, 1, 121399, 121402, 1, 121453, 121460, 1, 121462, 121475, 1, 121477, 121478, 1, 123215, 123647, 432, 126124, 126128, 4, 126254, 126704, 450, 126705, 126976, 271, 126977, 127019, 1, 127024, 127123, 1, 127136, 127150, 1, 127153, 127167, 1, 127169, 127183, 1, 127185, 127221, 1, 127245, 127405, 1, 127462, 127490, 1, 127504, 127547, 1, 127552, 127560, 1, 127568, 127569, 1, 127584, 127589, 1, 127744, 128727, 1, 128732, 128748, 1, 128752, 128764, 1, 128768, 128886, 1, 128891, 128985, 1, 128992, 129003, 1, 129008, 129024, 16, 129025, 129035, 1, 129040, 129095, 1, 129104, 129113, 1, 129120, 129159, 1, 129168, 129197, 1, 129200, 129211, 1, 129216, 129217, 1, 129280, 129619, 1, 129632, 129645, 1, 129648, 129660, 1, 129664, 129673, 1, 129679, 129734, 1, 129742, 129756, 1, 129759, 129769, 1, 129776, 129784, 1, 129792, 129938, 1, 129940, 130031, 1]));
      static Sc = new a(new Uint32Array([36, 162, 126, 163, 165, 1, 1423, 1547, 124, 2046, 2047, 1, 2546, 2547, 1, 2555, 2801, 246, 3065, 3647, 582, 6107, 8352, 2245, 8353, 8384, 1, 43064, 65020, 21956, 65129, 65284, 155, 65504, 65505, 1, 65509, 65510, 1, 73693, 73696, 1, 123647, 126128, 2481]));
      static Sk = new a(new Uint32Array([94, 96, 2, 168, 175, 7, 180, 184, 4, 706, 709, 1, 722, 735, 1, 741, 747, 1, 749, 751, 2, 752, 767, 1, 885, 900, 15, 901, 2184, 1283, 8125, 8127, 2, 8128, 8129, 1, 8141, 8143, 1, 8157, 8159, 1, 8173, 8175, 1, 8189, 8190, 1, 12443, 12444, 1, 42752, 42774, 1, 42784, 42785, 1, 42889, 42890, 1, 43867, 43882, 15, 43883, 64434, 20551, 64435, 64450, 1, 65342, 65344, 2, 65507, 127995, 62488, 127996, 127999, 1]));
      static Sm = new a(new Uint32Array([43, 60, 17, 61, 62, 1, 124, 126, 2, 172, 177, 5, 215, 247, 32, 1014, 1542, 528, 1543, 1544, 1, 8260, 8274, 14, 8314, 8316, 1, 8330, 8332, 1, 8472, 8512, 40, 8513, 8516, 1, 8523, 8592, 69, 8593, 8596, 1, 8602, 8603, 1, 8608, 8614, 3, 8622, 8654, 32, 8655, 8658, 3, 8660, 8692, 32, 8693, 8959, 1, 8992, 8993, 1, 9084, 9115, 31, 9116, 9139, 1, 9180, 9185, 1, 9655, 9665, 10, 9720, 9727, 1, 9839, 10176, 337, 10177, 10180, 1, 10183, 10213, 1, 10224, 10239, 1, 10496, 10626, 1, 10649, 10711, 1, 10716, 10747, 1, 10750, 11007, 1, 11056, 11076, 1, 11079, 11084, 1, 64297, 65122, 825, 65124, 65126, 1, 65291, 65308, 17, 65309, 65310, 1, 65372, 65374, 2, 65506, 65513, 7, 65514, 65516, 1, 69006, 69007, 1, 120513, 120539, 26, 120571, 120597, 26, 120629, 120655, 26, 120687, 120713, 26, 120745, 120771, 26, 126704, 126705, 1]));
      static So = new a(new Uint32Array([166, 169, 3, 174, 176, 2, 1154, 1421, 267, 1422, 1550, 128, 1551, 1758, 207, 1769, 1789, 20, 1790, 2038, 248, 2554, 2928, 374, 3059, 3064, 1, 3066, 3199, 133, 3407, 3449, 42, 3841, 3843, 1, 3859, 3861, 2, 3862, 3863, 1, 3866, 3871, 1, 3892, 3896, 2, 4030, 4037, 1, 4039, 4044, 1, 4046, 4047, 1, 4053, 4056, 1, 4254, 4255, 1, 5008, 5017, 1, 5741, 6464, 723, 6622, 6655, 1, 7009, 7018, 1, 7028, 7036, 1, 8448, 8449, 1, 8451, 8454, 1, 8456, 8457, 1, 8468, 8470, 2, 8471, 8478, 7, 8479, 8483, 1, 8485, 8489, 2, 8494, 8506, 12, 8507, 8522, 15, 8524, 8525, 1, 8527, 8586, 59, 8587, 8597, 10, 8598, 8601, 1, 8604, 8607, 1, 8609, 8610, 1, 8612, 8613, 1, 8615, 8621, 1, 8623, 8653, 1, 8656, 8657, 1, 8659, 8661, 2, 8662, 8691, 1, 8960, 8967, 1, 8972, 8991, 1, 8994, 9e3, 1, 9003, 9083, 1, 9085, 9114, 1, 9140, 9179, 1, 9186, 9257, 1, 9280, 9290, 1, 9372, 9449, 1, 9472, 9654, 1, 9656, 9664, 1, 9666, 9719, 1, 9728, 9838, 1, 9840, 10087, 1, 10132, 10175, 1, 10240, 10495, 1, 11008, 11055, 1, 11077, 11078, 1, 11085, 11123, 1, 11126, 11157, 1, 11159, 11263, 1, 11493, 11498, 1, 11856, 11857, 1, 11904, 11929, 1, 11931, 12019, 1, 12032, 12245, 1, 12272, 12287, 1, 12292, 12306, 14, 12307, 12320, 13, 12342, 12343, 1, 12350, 12351, 1, 12688, 12689, 1, 12694, 12703, 1, 12736, 12773, 1, 12783, 12800, 17, 12801, 12830, 1, 12842, 12871, 1, 12880, 12896, 16, 12897, 12927, 1, 12938, 12976, 1, 12992, 13311, 1, 19904, 19967, 1, 42128, 42182, 1, 43048, 43051, 1, 43062, 43063, 1, 43065, 43639, 574, 43640, 43641, 1, 64832, 64847, 1, 64975, 65021, 46, 65022, 65023, 1, 65508, 65512, 4, 65517, 65518, 1, 65532, 65533, 1, 65847, 65855, 1, 65913, 65929, 1, 65932, 65934, 1, 65936, 65948, 1, 65952, 66e3, 48, 66001, 66044, 1, 67703, 67704, 1, 68296, 71487, 3191, 73685, 73692, 1, 73697, 73713, 1, 92988, 92991, 1, 92997, 113820, 20823, 117760, 117999, 1, 118016, 118451, 1, 118608, 118723, 1, 118784, 119029, 1, 119040, 119078, 1, 119081, 119140, 1, 119146, 119148, 1, 119171, 119172, 1, 119180, 119209, 1, 119214, 119274, 1, 119296, 119361, 1, 119365, 119552, 187, 119553, 119638, 1, 120832, 121343, 1, 121399, 121402, 1, 121453, 121460, 1, 121462, 121475, 1, 121477, 121478, 1, 123215, 126124, 2909, 126254, 126976, 722, 126977, 127019, 1, 127024, 127123, 1, 127136, 127150, 1, 127153, 127167, 1, 127169, 127183, 1, 127185, 127221, 1, 127245, 127405, 1, 127462, 127490, 1, 127504, 127547, 1, 127552, 127560, 1, 127568, 127569, 1, 127584, 127589, 1, 127744, 127994, 1, 128e3, 128727, 1, 128732, 128748, 1, 128752, 128764, 1, 128768, 128886, 1, 128891, 128985, 1, 128992, 129003, 1, 129008, 129024, 16, 129025, 129035, 1, 129040, 129095, 1, 129104, 129113, 1, 129120, 129159, 1, 129168, 129197, 1, 129200, 129211, 1, 129216, 129217, 1, 129280, 129619, 1, 129632, 129645, 1, 129648, 129660, 1, 129664, 129673, 1, 129679, 129734, 1, 129742, 129756, 1, 129759, 129769, 1, 129776, 129784, 1, 129792, 129938, 1, 129940, 130031, 1]));
      static Z = new a(new Uint32Array([32, 160, 128, 5760, 8192, 2432, 8193, 8202, 1, 8232, 8233, 1, 8239, 8287, 48, 12288, 12288, 1]));
      static Zl = new a(new Uint32Array([8232, 8232, 1]));
      static Zp = new a(new Uint32Array([8233, 8233, 1]));
      static Zs = new a(new Uint32Array([32, 160, 128, 5760, 8192, 2432, 8193, 8202, 1, 8239, 8287, 48, 12288, 12288, 1]));
      static Adlam = new a(new Uint32Array([125184, 125259, 1, 125264, 125273, 1, 125278, 125279, 1]));
      static Ahom = new a(new Uint32Array([71424, 71450, 1, 71453, 71467, 1, 71472, 71494, 1]));
      static Anatolian_Hieroglyphs = new a(new Uint32Array([82944, 83526, 1]));
      static Arabic = new a(new Uint32Array([1536, 1540, 1, 1542, 1547, 1, 1549, 1562, 1, 1564, 1566, 1, 1568, 1599, 1, 1601, 1610, 1, 1622, 1647, 1, 1649, 1756, 1, 1758, 1791, 1, 1872, 1919, 1, 2160, 2190, 1, 2192, 2193, 1, 2199, 2273, 1, 2275, 2303, 1, 64336, 64450, 1, 64467, 64829, 1, 64832, 64911, 1, 64914, 64967, 1, 64975, 65008, 33, 65009, 65023, 1, 65136, 65140, 1, 65142, 65276, 1, 69216, 69246, 1, 69314, 69316, 1, 69372, 69375, 1, 126464, 126467, 1, 126469, 126495, 1, 126497, 126498, 1, 126500, 126503, 3, 126505, 126514, 1, 126516, 126519, 1, 126521, 126523, 2, 126530, 126535, 5, 126537, 126541, 2, 126542, 126543, 1, 126545, 126546, 1, 126548, 126551, 3, 126553, 126561, 2, 126562, 126564, 2, 126567, 126570, 1, 126572, 126578, 1, 126580, 126583, 1, 126585, 126588, 1, 126590, 126592, 2, 126593, 126601, 1, 126603, 126619, 1, 126625, 126627, 1, 126629, 126633, 1, 126635, 126651, 1, 126704, 126705, 1]));
      static Armenian = new a(new Uint32Array([1329, 1366, 1, 1369, 1418, 1, 1421, 1423, 1, 64275, 64279, 1]));
      static Avestan = new a(new Uint32Array([68352, 68405, 1, 68409, 68415, 1]));
      static Balinese = new a(new Uint32Array([6912, 6988, 1, 6990, 7039, 1]));
      static Bamum = new a(new Uint32Array([42656, 42743, 1, 92160, 92728, 1]));
      static Bassa_Vah = new a(new Uint32Array([92880, 92909, 1, 92912, 92917, 1]));
      static Batak = new a(new Uint32Array([7104, 7155, 1, 7164, 7167, 1]));
      static Bengali = new a(new Uint32Array([2432, 2435, 1, 2437, 2444, 1, 2447, 2448, 1, 2451, 2472, 1, 2474, 2480, 1, 2482, 2486, 4, 2487, 2489, 1, 2492, 2500, 1, 2503, 2504, 1, 2507, 2510, 1, 2519, 2524, 5, 2525, 2527, 2, 2528, 2531, 1, 2534, 2558, 1]));
      static Bhaiksuki = new a(new Uint32Array([72704, 72712, 1, 72714, 72758, 1, 72760, 72773, 1, 72784, 72812, 1]));
      static Bopomofo = new a(new Uint32Array([746, 747, 1, 12549, 12591, 1, 12704, 12735, 1]));
      static Brahmi = new a(new Uint32Array([69632, 69709, 1, 69714, 69749, 1, 69759, 69759, 1]));
      static Braille = new a(new Uint32Array([10240, 10495, 1]));
      static Buginese = new a(new Uint32Array([6656, 6683, 1, 6686, 6687, 1]));
      static Buhid = new a(new Uint32Array([5952, 5971, 1]));
      static Canadian_Aboriginal = new a(new Uint32Array([5120, 5759, 1, 6320, 6389, 1, 72368, 72383, 1]));
      static Carian = new a(new Uint32Array([66208, 66256, 1]));
      static Caucasian_Albanian = new a(new Uint32Array([66864, 66915, 1, 66927, 66927, 1]));
      static Chakma = new a(new Uint32Array([69888, 69940, 1, 69942, 69959, 1]));
      static Cham = new a(new Uint32Array([43520, 43574, 1, 43584, 43597, 1, 43600, 43609, 1, 43612, 43615, 1]));
      static Cherokee = new a(new Uint32Array([5024, 5109, 1, 5112, 5117, 1, 43888, 43967, 1]));
      static Chorasmian = new a(new Uint32Array([69552, 69579, 1]));
      static Common = new a(new Uint32Array([0, 64, 1, 91, 96, 1, 123, 169, 1, 171, 185, 1, 187, 191, 1, 215, 247, 32, 697, 735, 1, 741, 745, 1, 748, 767, 1, 884, 894, 10, 901, 903, 2, 1541, 1548, 7, 1563, 1567, 4, 1600, 1757, 157, 2274, 2404, 130, 2405, 3647, 1242, 4053, 4056, 1, 4347, 5867, 1520, 5868, 5869, 1, 5941, 5942, 1, 6146, 6147, 1, 6149, 7379, 1230, 7393, 7401, 8, 7402, 7404, 1, 7406, 7411, 1, 7413, 7415, 1, 7418, 8192, 774, 8193, 8203, 1, 8206, 8292, 1, 8294, 8304, 1, 8308, 8318, 1, 8320, 8334, 1, 8352, 8384, 1, 8448, 8485, 1, 8487, 8489, 1, 8492, 8497, 1, 8499, 8525, 1, 8527, 8543, 1, 8585, 8587, 1, 8592, 9257, 1, 9280, 9290, 1, 9312, 10239, 1, 10496, 11123, 1, 11126, 11157, 1, 11159, 11263, 1, 11776, 11869, 1, 12272, 12292, 1, 12294, 12296, 2, 12297, 12320, 1, 12336, 12343, 1, 12348, 12351, 1, 12443, 12444, 1, 12448, 12539, 91, 12540, 12688, 148, 12689, 12703, 1, 12736, 12773, 1, 12783, 12832, 49, 12833, 12895, 1, 12927, 13007, 1, 13055, 13144, 89, 13145, 13311, 1, 19904, 19967, 1, 42752, 42785, 1, 42888, 42890, 1, 43056, 43065, 1, 43310, 43471, 161, 43867, 43882, 15, 43883, 64830, 20947, 64831, 65040, 209, 65041, 65049, 1, 65072, 65106, 1, 65108, 65126, 1, 65128, 65131, 1, 65279, 65281, 2, 65282, 65312, 1, 65339, 65344, 1, 65371, 65381, 1, 65392, 65438, 46, 65439, 65504, 65, 65505, 65510, 1, 65512, 65518, 1, 65529, 65533, 1, 65792, 65794, 1, 65799, 65843, 1, 65847, 65855, 1, 65936, 65948, 1, 66e3, 66044, 1, 66273, 66299, 1, 113824, 113827, 1, 117760, 118009, 1, 118016, 118451, 1, 118608, 118723, 1, 118784, 119029, 1, 119040, 119078, 1, 119081, 119142, 1, 119146, 119162, 1, 119171, 119172, 1, 119180, 119209, 1, 119214, 119274, 1, 119488, 119507, 1, 119520, 119539, 1, 119552, 119638, 1, 119648, 119672, 1, 119808, 119892, 1, 119894, 119964, 1, 119966, 119967, 1, 119970, 119973, 3, 119974, 119977, 3, 119978, 119980, 1, 119982, 119993, 1, 119995, 119997, 2, 119998, 120003, 1, 120005, 120069, 1, 120071, 120074, 1, 120077, 120084, 1, 120086, 120092, 1, 120094, 120121, 1, 120123, 120126, 1, 120128, 120132, 1, 120134, 120138, 4, 120139, 120144, 1, 120146, 120485, 1, 120488, 120779, 1, 120782, 120831, 1, 126065, 126132, 1, 126209, 126269, 1, 126976, 127019, 1, 127024, 127123, 1, 127136, 127150, 1, 127153, 127167, 1, 127169, 127183, 1, 127185, 127221, 1, 127232, 127405, 1, 127462, 127487, 1, 127489, 127490, 1, 127504, 127547, 1, 127552, 127560, 1, 127568, 127569, 1, 127584, 127589, 1, 127744, 128727, 1, 128732, 128748, 1, 128752, 128764, 1, 128768, 128886, 1, 128891, 128985, 1, 128992, 129003, 1, 129008, 129024, 16, 129025, 129035, 1, 129040, 129095, 1, 129104, 129113, 1, 129120, 129159, 1, 129168, 129197, 1, 129200, 129211, 1, 129216, 129217, 1, 129280, 129619, 1, 129632, 129645, 1, 129648, 129660, 1, 129664, 129673, 1, 129679, 129734, 1, 129742, 129756, 1, 129759, 129769, 1, 129776, 129784, 1, 129792, 129938, 1, 129940, 130041, 1, 917505, 917536, 31, 917537, 917631, 1]));
      static foldCommon = new a(new Uint32Array([924, 956, 32]));
      static Coptic = new a(new Uint32Array([994, 1007, 1, 11392, 11507, 1, 11513, 11519, 1]));
      static Cuneiform = new a(new Uint32Array([73728, 74649, 1, 74752, 74862, 1, 74864, 74868, 1, 74880, 75075, 1]));
      static Cypriot = new a(new Uint32Array([67584, 67589, 1, 67592, 67594, 2, 67595, 67637, 1, 67639, 67640, 1, 67644, 67647, 3]));
      static Cypro_Minoan = new a(new Uint32Array([77712, 77810, 1]));
      static Cyrillic = new a(new Uint32Array([1024, 1156, 1, 1159, 1327, 1, 7296, 7306, 1, 7467, 7544, 77, 11744, 11775, 1, 42560, 42655, 1, 65070, 65071, 1, 122928, 122989, 1, 123023, 123023, 1]));
      static Deseret = new a(new Uint32Array([66560, 66639, 1]));
      static Devanagari = new a(new Uint32Array([2304, 2384, 1, 2389, 2403, 1, 2406, 2431, 1, 43232, 43263, 1, 72448, 72457, 1]));
      static Dives_Akuru = new a(new Uint32Array([71936, 71942, 1, 71945, 71948, 3, 71949, 71955, 1, 71957, 71958, 1, 71960, 71989, 1, 71991, 71992, 1, 71995, 72006, 1, 72016, 72025, 1]));
      static Dogra = new a(new Uint32Array([71680, 71739, 1]));
      static Duployan = new a(new Uint32Array([113664, 113770, 1, 113776, 113788, 1, 113792, 113800, 1, 113808, 113817, 1, 113820, 113823, 1]));
      static Egyptian_Hieroglyphs = new a(new Uint32Array([77824, 78933, 1, 78944, 82938, 1]));
      static Elbasan = new a(new Uint32Array([66816, 66855, 1]));
      static Elymaic = new a(new Uint32Array([69600, 69622, 1]));
      static Ethiopic = new a(new Uint32Array([4608, 4680, 1, 4682, 4685, 1, 4688, 4694, 1, 4696, 4698, 2, 4699, 4701, 1, 4704, 4744, 1, 4746, 4749, 1, 4752, 4784, 1, 4786, 4789, 1, 4792, 4798, 1, 4800, 4802, 2, 4803, 4805, 1, 4808, 4822, 1, 4824, 4880, 1, 4882, 4885, 1, 4888, 4954, 1, 4957, 4988, 1, 4992, 5017, 1, 11648, 11670, 1, 11680, 11686, 1, 11688, 11694, 1, 11696, 11702, 1, 11704, 11710, 1, 11712, 11718, 1, 11720, 11726, 1, 11728, 11734, 1, 11736, 11742, 1, 43777, 43782, 1, 43785, 43790, 1, 43793, 43798, 1, 43808, 43814, 1, 43816, 43822, 1, 124896, 124902, 1, 124904, 124907, 1, 124909, 124910, 1, 124912, 124926, 1]));
      static Garay = new a(new Uint32Array([68928, 68965, 1, 68969, 68997, 1, 69006, 69007, 1]));
      static Georgian = new a(new Uint32Array([4256, 4293, 1, 4295, 4301, 6, 4304, 4346, 1, 4348, 4351, 1, 7312, 7354, 1, 7357, 7359, 1, 11520, 11557, 1, 11559, 11565, 6]));
      static Glagolitic = new a(new Uint32Array([11264, 11359, 1, 122880, 122886, 1, 122888, 122904, 1, 122907, 122913, 1, 122915, 122916, 1, 122918, 122922, 1]));
      static Gothic = new a(new Uint32Array([66352, 66378, 1]));
      static Grantha = new a(new Uint32Array([70400, 70403, 1, 70405, 70412, 1, 70415, 70416, 1, 70419, 70440, 1, 70442, 70448, 1, 70450, 70451, 1, 70453, 70457, 1, 70460, 70468, 1, 70471, 70472, 1, 70475, 70477, 1, 70480, 70487, 7, 70493, 70499, 1, 70502, 70508, 1, 70512, 70516, 1]));
      static Greek = new a(new Uint32Array([880, 883, 1, 885, 887, 1, 890, 893, 1, 895, 900, 5, 902, 904, 2, 905, 906, 1, 908, 910, 2, 911, 929, 1, 931, 993, 1, 1008, 1023, 1, 7462, 7466, 1, 7517, 7521, 1, 7526, 7530, 1, 7615, 7936, 321, 7937, 7957, 1, 7960, 7965, 1, 7968, 8005, 1, 8008, 8013, 1, 8016, 8023, 1, 8025, 8031, 2, 8032, 8061, 1, 8064, 8116, 1, 8118, 8132, 1, 8134, 8147, 1, 8150, 8155, 1, 8157, 8175, 1, 8178, 8180, 1, 8182, 8190, 1, 8486, 43877, 35391, 65856, 65934, 1, 65952, 119296, 53344, 119297, 119365, 1]));
      static foldGreek = new a(new Uint32Array([181, 837, 656]));
      static Gujarati = new a(new Uint32Array([2689, 2691, 1, 2693, 2701, 1, 2703, 2705, 1, 2707, 2728, 1, 2730, 2736, 1, 2738, 2739, 1, 2741, 2745, 1, 2748, 2757, 1, 2759, 2761, 1, 2763, 2765, 1, 2768, 2784, 16, 2785, 2787, 1, 2790, 2801, 1, 2809, 2815, 1]));
      static Gunjala_Gondi = new a(new Uint32Array([73056, 73061, 1, 73063, 73064, 1, 73066, 73102, 1, 73104, 73105, 1, 73107, 73112, 1, 73120, 73129, 1]));
      static Gurmukhi = new a(new Uint32Array([2561, 2563, 1, 2565, 2570, 1, 2575, 2576, 1, 2579, 2600, 1, 2602, 2608, 1, 2610, 2611, 1, 2613, 2614, 1, 2616, 2617, 1, 2620, 2622, 2, 2623, 2626, 1, 2631, 2632, 1, 2635, 2637, 1, 2641, 2649, 8, 2650, 2652, 1, 2654, 2662, 8, 2663, 2678, 1]));
      static Gurung_Khema = new a(new Uint32Array([90368, 90425, 1]));
      static Han = new a(new Uint32Array([11904, 11929, 1, 11931, 12019, 1, 12032, 12245, 1, 12293, 12295, 2, 12321, 12329, 1, 12344, 12347, 1, 13312, 19903, 1, 19968, 40959, 1, 63744, 64109, 1, 64112, 64217, 1, 94178, 94179, 1, 94192, 94193, 1, 131072, 173791, 1, 173824, 177977, 1, 177984, 178205, 1, 178208, 183969, 1, 183984, 191456, 1, 191472, 192093, 1, 194560, 195101, 1, 196608, 201546, 1, 201552, 205743, 1]));
      static Hangul = new a(new Uint32Array([4352, 4607, 1, 12334, 12335, 1, 12593, 12686, 1, 12800, 12830, 1, 12896, 12926, 1, 43360, 43388, 1, 44032, 55203, 1, 55216, 55238, 1, 55243, 55291, 1, 65440, 65470, 1, 65474, 65479, 1, 65482, 65487, 1, 65490, 65495, 1, 65498, 65500, 1]));
      static Hanifi_Rohingya = new a(new Uint32Array([68864, 68903, 1, 68912, 68921, 1]));
      static Hanunoo = new a(new Uint32Array([5920, 5940, 1]));
      static Hatran = new a(new Uint32Array([67808, 67826, 1, 67828, 67829, 1, 67835, 67839, 1]));
      static Hebrew = new a(new Uint32Array([1425, 1479, 1, 1488, 1514, 1, 1519, 1524, 1, 64285, 64310, 1, 64312, 64316, 1, 64318, 64320, 2, 64321, 64323, 2, 64324, 64326, 2, 64327, 64335, 1]));
      static Hiragana = new a(new Uint32Array([12353, 12438, 1, 12445, 12447, 1, 110593, 110879, 1, 110898, 110928, 30, 110929, 110930, 1, 127488, 127488, 1]));
      static Imperial_Aramaic = new a(new Uint32Array([67648, 67669, 1, 67671, 67679, 1]));
      static Inherited = new a(new Uint32Array([768, 879, 1, 1157, 1158, 1, 1611, 1621, 1, 1648, 2385, 737, 2386, 2388, 1, 6832, 6862, 1, 7376, 7378, 1, 7380, 7392, 1, 7394, 7400, 1, 7405, 7412, 7, 7416, 7417, 1, 7616, 7679, 1, 8204, 8205, 1, 8400, 8432, 1, 12330, 12333, 1, 12441, 12442, 1, 65024, 65039, 1, 65056, 65069, 1, 66045, 66272, 227, 70459, 118528, 48069, 118529, 118573, 1, 118576, 118598, 1, 119143, 119145, 1, 119163, 119170, 1, 119173, 119179, 1, 119210, 119213, 1, 917760, 917999, 1]));
      static foldInherited = new a(new Uint32Array([921, 953, 32, 8126, 8126, 1]));
      static Inscriptional_Pahlavi = new a(new Uint32Array([68448, 68466, 1, 68472, 68479, 1]));
      static Inscriptional_Parthian = new a(new Uint32Array([68416, 68437, 1, 68440, 68447, 1]));
      static Javanese = new a(new Uint32Array([43392, 43469, 1, 43472, 43481, 1, 43486, 43487, 1]));
      static Kaithi = new a(new Uint32Array([69760, 69826, 1, 69837, 69837, 1]));
      static Kannada = new a(new Uint32Array([3200, 3212, 1, 3214, 3216, 1, 3218, 3240, 1, 3242, 3251, 1, 3253, 3257, 1, 3260, 3268, 1, 3270, 3272, 1, 3274, 3277, 1, 3285, 3286, 1, 3293, 3294, 1, 3296, 3299, 1, 3302, 3311, 1, 3313, 3315, 1]));
      static Katakana = new a(new Uint32Array([12449, 12538, 1, 12541, 12543, 1, 12784, 12799, 1, 13008, 13054, 1, 13056, 13143, 1, 65382, 65391, 1, 65393, 65437, 1, 110576, 110579, 1, 110581, 110587, 1, 110589, 110590, 1, 110592, 110880, 288, 110881, 110882, 1, 110933, 110948, 15, 110949, 110951, 1]));
      static Kawi = new a(new Uint32Array([73472, 73488, 1, 73490, 73530, 1, 73534, 73562, 1]));
      static Kayah_Li = new a(new Uint32Array([43264, 43309, 1, 43311, 43311, 1]));
      static Kharoshthi = new a(new Uint32Array([68096, 68099, 1, 68101, 68102, 1, 68108, 68115, 1, 68117, 68119, 1, 68121, 68149, 1, 68152, 68154, 1, 68159, 68168, 1, 68176, 68184, 1]));
      static Khitan_Small_Script = new a(new Uint32Array([94180, 101120, 6940, 101121, 101589, 1, 101631, 101631, 1]));
      static Khmer = new a(new Uint32Array([6016, 6109, 1, 6112, 6121, 1, 6128, 6137, 1, 6624, 6655, 1]));
      static Khojki = new a(new Uint32Array([70144, 70161, 1, 70163, 70209, 1]));
      static Khudawadi = new a(new Uint32Array([70320, 70378, 1, 70384, 70393, 1]));
      static Kirat_Rai = new a(new Uint32Array([93504, 93561, 1]));
      static Lao = new a(new Uint32Array([3713, 3714, 1, 3716, 3718, 2, 3719, 3722, 1, 3724, 3747, 1, 3749, 3751, 2, 3752, 3773, 1, 3776, 3780, 1, 3782, 3784, 2, 3785, 3790, 1, 3792, 3801, 1, 3804, 3807, 1]));
      static Latin = new a(new Uint32Array([65, 90, 1, 97, 122, 1, 170, 186, 16, 192, 214, 1, 216, 246, 1, 248, 696, 1, 736, 740, 1, 7424, 7461, 1, 7468, 7516, 1, 7522, 7525, 1, 7531, 7543, 1, 7545, 7614, 1, 7680, 7935, 1, 8305, 8319, 14, 8336, 8348, 1, 8490, 8491, 1, 8498, 8526, 28, 8544, 8584, 1, 11360, 11391, 1, 42786, 42887, 1, 42891, 42957, 1, 42960, 42961, 1, 42963, 42965, 2, 42966, 42972, 1, 42994, 43007, 1, 43824, 43866, 1, 43868, 43876, 1, 43878, 43881, 1, 64256, 64262, 1, 65313, 65338, 1, 65345, 65370, 1, 67456, 67461, 1, 67463, 67504, 1, 67506, 67514, 1, 122624, 122654, 1, 122661, 122666, 1]));
      static Lepcha = new a(new Uint32Array([7168, 7223, 1, 7227, 7241, 1, 7245, 7247, 1]));
      static Limbu = new a(new Uint32Array([6400, 6430, 1, 6432, 6443, 1, 6448, 6459, 1, 6464, 6468, 4, 6469, 6479, 1]));
      static Linear_A = new a(new Uint32Array([67072, 67382, 1, 67392, 67413, 1, 67424, 67431, 1]));
      static Linear_B = new a(new Uint32Array([65536, 65547, 1, 65549, 65574, 1, 65576, 65594, 1, 65596, 65597, 1, 65599, 65613, 1, 65616, 65629, 1, 65664, 65786, 1]));
      static Lisu = new a(new Uint32Array([42192, 42239, 1, 73648, 73648, 1]));
      static Lycian = new a(new Uint32Array([66176, 66204, 1]));
      static Lydian = new a(new Uint32Array([67872, 67897, 1, 67903, 67903, 1]));
      static Mahajani = new a(new Uint32Array([69968, 70006, 1]));
      static Makasar = new a(new Uint32Array([73440, 73464, 1]));
      static Malayalam = new a(new Uint32Array([3328, 3340, 1, 3342, 3344, 1, 3346, 3396, 1, 3398, 3400, 1, 3402, 3407, 1, 3412, 3427, 1, 3430, 3455, 1]));
      static Mandaic = new a(new Uint32Array([2112, 2139, 1, 2142, 2142, 1]));
      static Manichaean = new a(new Uint32Array([68288, 68326, 1, 68331, 68342, 1]));
      static Marchen = new a(new Uint32Array([72816, 72847, 1, 72850, 72871, 1, 72873, 72886, 1]));
      static Masaram_Gondi = new a(new Uint32Array([72960, 72966, 1, 72968, 72969, 1, 72971, 73014, 1, 73018, 73020, 2, 73021, 73023, 2, 73024, 73031, 1, 73040, 73049, 1]));
      static Medefaidrin = new a(new Uint32Array([93760, 93850, 1]));
      static Meetei_Mayek = new a(new Uint32Array([43744, 43766, 1, 43968, 44013, 1, 44016, 44025, 1]));
      static Mende_Kikakui = new a(new Uint32Array([124928, 125124, 1, 125127, 125142, 1]));
      static Meroitic_Cursive = new a(new Uint32Array([68e3, 68023, 1, 68028, 68047, 1, 68050, 68095, 1]));
      static Meroitic_Hieroglyphs = new a(new Uint32Array([67968, 67999, 1]));
      static Miao = new a(new Uint32Array([93952, 94026, 1, 94031, 94087, 1, 94095, 94111, 1]));
      static Modi = new a(new Uint32Array([71168, 71236, 1, 71248, 71257, 1]));
      static Mongolian = new a(new Uint32Array([6144, 6145, 1, 6148, 6150, 2, 6151, 6169, 1, 6176, 6264, 1, 6272, 6314, 1, 71264, 71276, 1]));
      static Mro = new a(new Uint32Array([92736, 92766, 1, 92768, 92777, 1, 92782, 92783, 1]));
      static Multani = new a(new Uint32Array([70272, 70278, 1, 70280, 70282, 2, 70283, 70285, 1, 70287, 70301, 1, 70303, 70313, 1]));
      static Myanmar = new a(new Uint32Array([4096, 4255, 1, 43488, 43518, 1, 43616, 43647, 1, 71376, 71395, 1]));
      static Nabataean = new a(new Uint32Array([67712, 67742, 1, 67751, 67759, 1]));
      static Nag_Mundari = new a(new Uint32Array([124112, 124153, 1]));
      static Nandinagari = new a(new Uint32Array([72096, 72103, 1, 72106, 72151, 1, 72154, 72164, 1]));
      static New_Tai_Lue = new a(new Uint32Array([6528, 6571, 1, 6576, 6601, 1, 6608, 6618, 1, 6622, 6623, 1]));
      static Newa = new a(new Uint32Array([70656, 70747, 1, 70749, 70753, 1]));
      static Nko = new a(new Uint32Array([1984, 2042, 1, 2045, 2047, 1]));
      static Nushu = new a(new Uint32Array([94177, 110960, 16783, 110961, 111355, 1]));
      static Nyiakeng_Puachue_Hmong = new a(new Uint32Array([123136, 123180, 1, 123184, 123197, 1, 123200, 123209, 1, 123214, 123215, 1]));
      static Ogham = new a(new Uint32Array([5760, 5788, 1]));
      static Ol_Chiki = new a(new Uint32Array([7248, 7295, 1]));
      static Ol_Onal = new a(new Uint32Array([124368, 124410, 1, 124415, 124415, 1]));
      static Old_Hungarian = new a(new Uint32Array([68736, 68786, 1, 68800, 68850, 1, 68858, 68863, 1]));
      static Old_Italic = new a(new Uint32Array([66304, 66339, 1, 66349, 66351, 1]));
      static Old_North_Arabian = new a(new Uint32Array([68224, 68255, 1]));
      static Old_Permic = new a(new Uint32Array([66384, 66426, 1]));
      static Old_Persian = new a(new Uint32Array([66464, 66499, 1, 66504, 66517, 1]));
      static Old_Sogdian = new a(new Uint32Array([69376, 69415, 1]));
      static Old_South_Arabian = new a(new Uint32Array([68192, 68223, 1]));
      static Old_Turkic = new a(new Uint32Array([68608, 68680, 1]));
      static Old_Uyghur = new a(new Uint32Array([69488, 69513, 1]));
      static Oriya = new a(new Uint32Array([2817, 2819, 1, 2821, 2828, 1, 2831, 2832, 1, 2835, 2856, 1, 2858, 2864, 1, 2866, 2867, 1, 2869, 2873, 1, 2876, 2884, 1, 2887, 2888, 1, 2891, 2893, 1, 2901, 2903, 1, 2908, 2909, 1, 2911, 2915, 1, 2918, 2935, 1]));
      static Osage = new a(new Uint32Array([66736, 66771, 1, 66776, 66811, 1]));
      static Osmanya = new a(new Uint32Array([66688, 66717, 1, 66720, 66729, 1]));
      static Pahawh_Hmong = new a(new Uint32Array([92928, 92997, 1, 93008, 93017, 1, 93019, 93025, 1, 93027, 93047, 1, 93053, 93071, 1]));
      static Palmyrene = new a(new Uint32Array([67680, 67711, 1]));
      static Pau_Cin_Hau = new a(new Uint32Array([72384, 72440, 1]));
      static Phags_Pa = new a(new Uint32Array([43072, 43127, 1]));
      static Phoenician = new a(new Uint32Array([67840, 67867, 1, 67871, 67871, 1]));
      static Psalter_Pahlavi = new a(new Uint32Array([68480, 68497, 1, 68505, 68508, 1, 68521, 68527, 1]));
      static Rejang = new a(new Uint32Array([43312, 43347, 1, 43359, 43359, 1]));
      static Runic = new a(new Uint32Array([5792, 5866, 1, 5870, 5880, 1]));
      static Samaritan = new a(new Uint32Array([2048, 2093, 1, 2096, 2110, 1]));
      static Saurashtra = new a(new Uint32Array([43136, 43205, 1, 43214, 43225, 1]));
      static Sharada = new a(new Uint32Array([70016, 70111, 1]));
      static Shavian = new a(new Uint32Array([66640, 66687, 1]));
      static Siddham = new a(new Uint32Array([71040, 71093, 1, 71096, 71133, 1]));
      static SignWriting = new a(new Uint32Array([120832, 121483, 1, 121499, 121503, 1, 121505, 121519, 1]));
      static Sinhala = new a(new Uint32Array([3457, 3459, 1, 3461, 3478, 1, 3482, 3505, 1, 3507, 3515, 1, 3517, 3520, 3, 3521, 3526, 1, 3530, 3535, 5, 3536, 3540, 1, 3542, 3544, 2, 3545, 3551, 1, 3558, 3567, 1, 3570, 3572, 1, 70113, 70132, 1]));
      static Sogdian = new a(new Uint32Array([69424, 69465, 1]));
      static Sora_Sompeng = new a(new Uint32Array([69840, 69864, 1, 69872, 69881, 1]));
      static Soyombo = new a(new Uint32Array([72272, 72354, 1]));
      static Sundanese = new a(new Uint32Array([7040, 7103, 1, 7360, 7367, 1]));
      static Sunuwar = new a(new Uint32Array([72640, 72673, 1, 72688, 72697, 1]));
      static Syloti_Nagri = new a(new Uint32Array([43008, 43052, 1]));
      static Syriac = new a(new Uint32Array([1792, 1805, 1, 1807, 1866, 1, 1869, 1871, 1, 2144, 2154, 1]));
      static Tagalog = new a(new Uint32Array([5888, 5909, 1, 5919, 5919, 1]));
      static Tagbanwa = new a(new Uint32Array([5984, 5996, 1, 5998, 6e3, 1, 6002, 6003, 1]));
      static Tai_Le = new a(new Uint32Array([6480, 6509, 1, 6512, 6516, 1]));
      static Tai_Tham = new a(new Uint32Array([6688, 6750, 1, 6752, 6780, 1, 6783, 6793, 1, 6800, 6809, 1, 6816, 6829, 1]));
      static Tai_Viet = new a(new Uint32Array([43648, 43714, 1, 43739, 43743, 1]));
      static Takri = new a(new Uint32Array([71296, 71353, 1, 71360, 71369, 1]));
      static Tamil = new a(new Uint32Array([2946, 2947, 1, 2949, 2954, 1, 2958, 2960, 1, 2962, 2965, 1, 2969, 2970, 1, 2972, 2974, 2, 2975, 2979, 4, 2980, 2984, 4, 2985, 2986, 1, 2990, 3001, 1, 3006, 3010, 1, 3014, 3016, 1, 3018, 3021, 1, 3024, 3031, 7, 3046, 3066, 1, 73664, 73713, 1, 73727, 73727, 1]));
      static Tangsa = new a(new Uint32Array([92784, 92862, 1, 92864, 92873, 1]));
      static Tangut = new a(new Uint32Array([94176, 94208, 32, 94209, 100343, 1, 100352, 101119, 1, 101632, 101640, 1]));
      static Telugu = new a(new Uint32Array([3072, 3084, 1, 3086, 3088, 1, 3090, 3112, 1, 3114, 3129, 1, 3132, 3140, 1, 3142, 3144, 1, 3146, 3149, 1, 3157, 3158, 1, 3160, 3162, 1, 3165, 3168, 3, 3169, 3171, 1, 3174, 3183, 1, 3191, 3199, 1]));
      static Thaana = new a(new Uint32Array([1920, 1969, 1]));
      static Thai = new a(new Uint32Array([3585, 3642, 1, 3648, 3675, 1]));
      static Tibetan = new a(new Uint32Array([3840, 3911, 1, 3913, 3948, 1, 3953, 3991, 1, 3993, 4028, 1, 4030, 4044, 1, 4046, 4052, 1, 4057, 4058, 1]));
      static Tifinagh = new a(new Uint32Array([11568, 11623, 1, 11631, 11632, 1, 11647, 11647, 1]));
      static Tirhuta = new a(new Uint32Array([70784, 70855, 1, 70864, 70873, 1]));
      static Todhri = new a(new Uint32Array([67008, 67059, 1]));
      static Toto = new a(new Uint32Array([123536, 123566, 1]));
      static Tulu_Tigalari = new a(new Uint32Array([70528, 70537, 1, 70539, 70542, 3, 70544, 70581, 1, 70583, 70592, 1, 70594, 70597, 3, 70599, 70602, 1, 70604, 70613, 1, 70615, 70616, 1, 70625, 70626, 1]));
      static Ugaritic = new a(new Uint32Array([66432, 66461, 1, 66463, 66463, 1]));
      static Vai = new a(new Uint32Array([42240, 42539, 1]));
      static Vithkuqi = new a(new Uint32Array([66928, 66938, 1, 66940, 66954, 1, 66956, 66962, 1, 66964, 66965, 1, 66967, 66977, 1, 66979, 66993, 1, 66995, 67001, 1, 67003, 67004, 1]));
      static Wancho = new a(new Uint32Array([123584, 123641, 1, 123647, 123647, 1]));
      static Warang_Citi = new a(new Uint32Array([71840, 71922, 1, 71935, 71935, 1]));
      static Yezidi = new a(new Uint32Array([69248, 69289, 1, 69291, 69293, 1, 69296, 69297, 1]));
      static Yi = new a(new Uint32Array([40960, 42124, 1, 42128, 42182, 1]));
      static Zanabazar_Square = new a(new Uint32Array([72192, 72263, 1]));
      static CATEGORIES = /* @__PURE__ */ new Map([["C", n2.C], ["Cc", n2.Cc], ["Cf", n2.Cf], ["Co", n2.Co], ["Cs", n2.Cs], ["L", n2.L], ["Ll", n2.Ll], ["Lm", n2.Lm], ["Lo", n2.Lo], ["Lt", n2.Lt], ["Lu", n2.Lu], ["M", n2.M], ["Mc", n2.Mc], ["Me", n2.Me], ["Mn", n2.Mn], ["N", n2.N], ["Nd", n2.Nd], ["Nl", n2.Nl], ["No", n2.No], ["P", n2.P], ["Pc", n2.Pc], ["Pd", n2.Pd], ["Pe", n2.Pe], ["Pf", n2.Pf], ["Pi", n2.Pi], ["Po", n2.Po], ["Ps", n2.Ps], ["S", n2.S], ["Sc", n2.Sc], ["Sk", n2.Sk], ["Sm", n2.Sm], ["So", n2.So], ["Z", n2.Z], ["Zl", n2.Zl], ["Zp", n2.Zp], ["Zs", n2.Zs]]);
      static SCRIPTS = /* @__PURE__ */ new Map([["Adlam", n2.Adlam], ["Ahom", n2.Ahom], ["Anatolian_Hieroglyphs", n2.Anatolian_Hieroglyphs], ["Arabic", n2.Arabic], ["Armenian", n2.Armenian], ["Avestan", n2.Avestan], ["Balinese", n2.Balinese], ["Bamum", n2.Bamum], ["Bassa_Vah", n2.Bassa_Vah], ["Batak", n2.Batak], ["Bengali", n2.Bengali], ["Bhaiksuki", n2.Bhaiksuki], ["Bopomofo", n2.Bopomofo], ["Brahmi", n2.Brahmi], ["Braille", n2.Braille], ["Buginese", n2.Buginese], ["Buhid", n2.Buhid], ["Canadian_Aboriginal", n2.Canadian_Aboriginal], ["Carian", n2.Carian], ["Caucasian_Albanian", n2.Caucasian_Albanian], ["Chakma", n2.Chakma], ["Cham", n2.Cham], ["Cherokee", n2.Cherokee], ["Chorasmian", n2.Chorasmian], ["Common", n2.Common], ["Coptic", n2.Coptic], ["Cuneiform", n2.Cuneiform], ["Cypriot", n2.Cypriot], ["Cypro_Minoan", n2.Cypro_Minoan], ["Cyrillic", n2.Cyrillic], ["Deseret", n2.Deseret], ["Devanagari", n2.Devanagari], ["Dives_Akuru", n2.Dives_Akuru], ["Dogra", n2.Dogra], ["Duployan", n2.Duployan], ["Egyptian_Hieroglyphs", n2.Egyptian_Hieroglyphs], ["Elbasan", n2.Elbasan], ["Elymaic", n2.Elymaic], ["Ethiopic", n2.Ethiopic], ["Garay", n2.Garay], ["Georgian", n2.Georgian], ["Glagolitic", n2.Glagolitic], ["Gothic", n2.Gothic], ["Grantha", n2.Grantha], ["Greek", n2.Greek], ["Gujarati", n2.Gujarati], ["Gunjala_Gondi", n2.Gunjala_Gondi], ["Gurmukhi", n2.Gurmukhi], ["Gurung_Khema", n2.Gurung_Khema], ["Han", n2.Han], ["Hangul", n2.Hangul], ["Hanifi_Rohingya", n2.Hanifi_Rohingya], ["Hanunoo", n2.Hanunoo], ["Hatran", n2.Hatran], ["Hebrew", n2.Hebrew], ["Hiragana", n2.Hiragana], ["Imperial_Aramaic", n2.Imperial_Aramaic], ["Inherited", n2.Inherited], ["Inscriptional_Pahlavi", n2.Inscriptional_Pahlavi], ["Inscriptional_Parthian", n2.Inscriptional_Parthian], ["Javanese", n2.Javanese], ["Kaithi", n2.Kaithi], ["Kannada", n2.Kannada], ["Katakana", n2.Katakana], ["Kawi", n2.Kawi], ["Kayah_Li", n2.Kayah_Li], ["Kharoshthi", n2.Kharoshthi], ["Khitan_Small_Script", n2.Khitan_Small_Script], ["Khmer", n2.Khmer], ["Khojki", n2.Khojki], ["Khudawadi", n2.Khudawadi], ["Kirat_Rai", n2.Kirat_Rai], ["Lao", n2.Lao], ["Latin", n2.Latin], ["Lepcha", n2.Lepcha], ["Limbu", n2.Limbu], ["Linear_A", n2.Linear_A], ["Linear_B", n2.Linear_B], ["Lisu", n2.Lisu], ["Lycian", n2.Lycian], ["Lydian", n2.Lydian], ["Mahajani", n2.Mahajani], ["Makasar", n2.Makasar], ["Malayalam", n2.Malayalam], ["Mandaic", n2.Mandaic], ["Manichaean", n2.Manichaean], ["Marchen", n2.Marchen], ["Masaram_Gondi", n2.Masaram_Gondi], ["Medefaidrin", n2.Medefaidrin], ["Meetei_Mayek", n2.Meetei_Mayek], ["Mende_Kikakui", n2.Mende_Kikakui], ["Meroitic_Cursive", n2.Meroitic_Cursive], ["Meroitic_Hieroglyphs", n2.Meroitic_Hieroglyphs], ["Miao", n2.Miao], ["Modi", n2.Modi], ["Mongolian", n2.Mongolian], ["Mro", n2.Mro], ["Multani", n2.Multani], ["Myanmar", n2.Myanmar], ["Nabataean", n2.Nabataean], ["Nag_Mundari", n2.Nag_Mundari], ["Nandinagari", n2.Nandinagari], ["New_Tai_Lue", n2.New_Tai_Lue], ["Newa", n2.Newa], ["Nko", n2.Nko], ["Nushu", n2.Nushu], ["Nyiakeng_Puachue_Hmong", n2.Nyiakeng_Puachue_Hmong], ["Ogham", n2.Ogham], ["Ol_Chiki", n2.Ol_Chiki], ["Ol_Onal", n2.Ol_Onal], ["Old_Hungarian", n2.Old_Hungarian], ["Old_Italic", n2.Old_Italic], ["Old_North_Arabian", n2.Old_North_Arabian], ["Old_Permic", n2.Old_Permic], ["Old_Persian", n2.Old_Persian], ["Old_Sogdian", n2.Old_Sogdian], ["Old_South_Arabian", n2.Old_South_Arabian], ["Old_Turkic", n2.Old_Turkic], ["Old_Uyghur", n2.Old_Uyghur], ["Oriya", n2.Oriya], ["Osage", n2.Osage], ["Osmanya", n2.Osmanya], ["Pahawh_Hmong", n2.Pahawh_Hmong], ["Palmyrene", n2.Palmyrene], ["Pau_Cin_Hau", n2.Pau_Cin_Hau], ["Phags_Pa", n2.Phags_Pa], ["Phoenician", n2.Phoenician], ["Psalter_Pahlavi", n2.Psalter_Pahlavi], ["Rejang", n2.Rejang], ["Runic", n2.Runic], ["Samaritan", n2.Samaritan], ["Saurashtra", n2.Saurashtra], ["Sharada", n2.Sharada], ["Shavian", n2.Shavian], ["Siddham", n2.Siddham], ["SignWriting", n2.SignWriting], ["Sinhala", n2.Sinhala], ["Sogdian", n2.Sogdian], ["Sora_Sompeng", n2.Sora_Sompeng], ["Soyombo", n2.Soyombo], ["Sundanese", n2.Sundanese], ["Sunuwar", n2.Sunuwar], ["Syloti_Nagri", n2.Syloti_Nagri], ["Syriac", n2.Syriac], ["Tagalog", n2.Tagalog], ["Tagbanwa", n2.Tagbanwa], ["Tai_Le", n2.Tai_Le], ["Tai_Tham", n2.Tai_Tham], ["Tai_Viet", n2.Tai_Viet], ["Takri", n2.Takri], ["Tamil", n2.Tamil], ["Tangsa", n2.Tangsa], ["Tangut", n2.Tangut], ["Telugu", n2.Telugu], ["Thaana", n2.Thaana], ["Thai", n2.Thai], ["Tibetan", n2.Tibetan], ["Tifinagh", n2.Tifinagh], ["Tirhuta", n2.Tirhuta], ["Todhri", n2.Todhri], ["Toto", n2.Toto], ["Tulu_Tigalari", n2.Tulu_Tigalari], ["Ugaritic", n2.Ugaritic], ["Vai", n2.Vai], ["Vithkuqi", n2.Vithkuqi], ["Wancho", n2.Wancho], ["Warang_Citi", n2.Warang_Citi], ["Yezidi", n2.Yezidi], ["Yi", n2.Yi], ["Zanabazar_Square", n2.Zanabazar_Square]]);
      static FOLD_CATEGORIES = /* @__PURE__ */ new Map([["L", n2.foldL], ["Ll", n2.foldLl], ["Lt", n2.foldLt], ["Lu", n2.foldLu], ["M", n2.foldM], ["Mn", n2.foldMn]]);
      static FOLD_SCRIPT = /* @__PURE__ */ new Map([["Common", n2.foldCommon], ["Greek", n2.foldGreek], ["Inherited", n2.foldInherited]]);
      static Print = new a(new Uint32Array([33, 126, 1, 161, 172, 1, 174, 887, 1, 890, 895, 1, 900, 906, 1, 908, 910, 2, 911, 929, 1, 931, 1327, 1, 1329, 1366, 1, 1369, 1418, 1, 1421, 1423, 1, 1425, 1479, 1, 1488, 1514, 1, 1519, 1524, 1, 1542, 1563, 1, 1565, 1756, 1, 1758, 1805, 1, 1808, 1866, 1, 1869, 1969, 1, 1984, 2042, 1, 2045, 2093, 1, 2096, 2110, 1, 2112, 2139, 1, 2142, 2144, 2, 2145, 2154, 1, 2160, 2190, 1, 2199, 2273, 1, 2275, 2435, 1, 2437, 2444, 1, 2447, 2448, 1, 2451, 2472, 1, 2474, 2480, 1, 2482, 2486, 4, 2487, 2489, 1, 2492, 2500, 1, 2503, 2504, 1, 2507, 2510, 1, 2519, 2524, 5, 2525, 2527, 2, 2528, 2531, 1, 2534, 2558, 1, 2561, 2563, 1, 2565, 2570, 1, 2575, 2576, 1, 2579, 2600, 1, 2602, 2608, 1, 2610, 2611, 1, 2613, 2614, 1, 2616, 2617, 1, 2620, 2622, 2, 2623, 2626, 1, 2631, 2632, 1, 2635, 2637, 1, 2641, 2649, 8, 2650, 2652, 1, 2654, 2662, 8, 2663, 2678, 1, 2689, 2691, 1, 2693, 2701, 1, 2703, 2705, 1, 2707, 2728, 1, 2730, 2736, 1, 2738, 2739, 1, 2741, 2745, 1, 2748, 2757, 1, 2759, 2761, 1, 2763, 2765, 1, 2768, 2784, 16, 2785, 2787, 1, 2790, 2801, 1, 2809, 2815, 1, 2817, 2819, 1, 2821, 2828, 1, 2831, 2832, 1, 2835, 2856, 1, 2858, 2864, 1, 2866, 2867, 1, 2869, 2873, 1, 2876, 2884, 1, 2887, 2888, 1, 2891, 2893, 1, 2901, 2903, 1, 2908, 2909, 1, 2911, 2915, 1, 2918, 2935, 1, 2946, 2947, 1, 2949, 2954, 1, 2958, 2960, 1, 2962, 2965, 1, 2969, 2970, 1, 2972, 2974, 2, 2975, 2979, 4, 2980, 2984, 4, 2985, 2986, 1, 2990, 3001, 1, 3006, 3010, 1, 3014, 3016, 1, 3018, 3021, 1, 3024, 3031, 7, 3046, 3066, 1, 3072, 3084, 1, 3086, 3088, 1, 3090, 3112, 1, 3114, 3129, 1, 3132, 3140, 1, 3142, 3144, 1, 3146, 3149, 1, 3157, 3158, 1, 3160, 3162, 1, 3165, 3168, 3, 3169, 3171, 1, 3174, 3183, 1, 3191, 3212, 1, 3214, 3216, 1, 3218, 3240, 1, 3242, 3251, 1, 3253, 3257, 1, 3260, 3268, 1, 3270, 3272, 1, 3274, 3277, 1, 3285, 3286, 1, 3293, 3294, 1, 3296, 3299, 1, 3302, 3311, 1, 3313, 3315, 1, 3328, 3340, 1, 3342, 3344, 1, 3346, 3396, 1, 3398, 3400, 1, 3402, 3407, 1, 3412, 3427, 1, 3430, 3455, 1, 3457, 3459, 1, 3461, 3478, 1, 3482, 3505, 1, 3507, 3515, 1, 3517, 3520, 3, 3521, 3526, 1, 3530, 3535, 5, 3536, 3540, 1, 3542, 3544, 2, 3545, 3551, 1, 3558, 3567, 1, 3570, 3572, 1, 3585, 3642, 1, 3647, 3675, 1, 3713, 3714, 1, 3716, 3718, 2, 3719, 3722, 1, 3724, 3747, 1, 3749, 3751, 2, 3752, 3773, 1, 3776, 3780, 1, 3782, 3784, 2, 3785, 3790, 1, 3792, 3801, 1, 3804, 3807, 1, 3840, 3911, 1, 3913, 3948, 1, 3953, 3991, 1, 3993, 4028, 1, 4030, 4044, 1, 4046, 4058, 1, 4096, 4293, 1, 4295, 4301, 6, 4304, 4680, 1, 4682, 4685, 1, 4688, 4694, 1, 4696, 4698, 2, 4699, 4701, 1, 4704, 4744, 1, 4746, 4749, 1, 4752, 4784, 1, 4786, 4789, 1, 4792, 4798, 1, 4800, 4802, 2, 4803, 4805, 1, 4808, 4822, 1, 4824, 4880, 1, 4882, 4885, 1, 4888, 4954, 1, 4957, 4988, 1, 4992, 5017, 1, 5024, 5109, 1, 5112, 5117, 1, 5120, 5759, 1, 5761, 5788, 1, 5792, 5880, 1, 5888, 5909, 1, 5919, 5942, 1, 5952, 5971, 1, 5984, 5996, 1, 5998, 6e3, 1, 6002, 6003, 1, 6016, 6109, 1, 6112, 6121, 1, 6128, 6137, 1, 6144, 6157, 1, 6159, 6169, 1, 6176, 6264, 1, 6272, 6314, 1, 6320, 6389, 1, 6400, 6430, 1, 6432, 6443, 1, 6448, 6459, 1, 6464, 6468, 4, 6469, 6509, 1, 6512, 6516, 1, 6528, 6571, 1, 6576, 6601, 1, 6608, 6618, 1, 6622, 6683, 1, 6686, 6750, 1, 6752, 6780, 1, 6783, 6793, 1, 6800, 6809, 1, 6816, 6829, 1, 6832, 6862, 1, 6912, 6988, 1, 6990, 7155, 1, 7164, 7223, 1, 7227, 7241, 1, 7245, 7306, 1, 7312, 7354, 1, 7357, 7367, 1, 7376, 7418, 1, 7424, 7957, 1, 7960, 7965, 1, 7968, 8005, 1, 8008, 8013, 1, 8016, 8023, 1, 8025, 8031, 2, 8032, 8061, 1, 8064, 8116, 1, 8118, 8132, 1, 8134, 8147, 1, 8150, 8155, 1, 8157, 8175, 1, 8178, 8180, 1, 8182, 8190, 1, 8208, 8231, 1, 8240, 8286, 1, 8304, 8305, 1, 8308, 8334, 1, 8336, 8348, 1, 8352, 8384, 1, 8400, 8432, 1, 8448, 8587, 1, 8592, 9257, 1, 9280, 9290, 1, 9312, 11123, 1, 11126, 11157, 1, 11159, 11507, 1, 11513, 11557, 1, 11559, 11565, 6, 11568, 11623, 1, 11631, 11632, 1, 11647, 11670, 1, 11680, 11686, 1, 11688, 11694, 1, 11696, 11702, 1, 11704, 11710, 1, 11712, 11718, 1, 11720, 11726, 1, 11728, 11734, 1, 11736, 11742, 1, 11744, 11869, 1, 11904, 11929, 1, 11931, 12019, 1, 12032, 12245, 1, 12272, 12287, 1, 12289, 12351, 1, 12353, 12438, 1, 12441, 12543, 1, 12549, 12591, 1, 12593, 12686, 1, 12688, 12773, 1, 12783, 12830, 1, 12832, 42124, 1, 42128, 42182, 1, 42192, 42539, 1, 42560, 42743, 1, 42752, 42957, 1, 42960, 42961, 1, 42963, 42965, 2, 42966, 42972, 1, 42994, 43052, 1, 43056, 43065, 1, 43072, 43127, 1, 43136, 43205, 1, 43214, 43225, 1, 43232, 43347, 1, 43359, 43388, 1, 43392, 43469, 1, 43471, 43481, 1, 43486, 43518, 1, 43520, 43574, 1, 43584, 43597, 1, 43600, 43609, 1, 43612, 43714, 1, 43739, 43766, 1, 43777, 43782, 1, 43785, 43790, 1, 43793, 43798, 1, 43808, 43814, 1, 43816, 43822, 1, 43824, 43883, 1, 43888, 44013, 1, 44016, 44025, 1, 44032, 55203, 1, 55216, 55238, 1, 55243, 55291, 1, 63744, 64109, 1, 64112, 64217, 1, 64256, 64262, 1, 64275, 64279, 1, 64285, 64310, 1, 64312, 64316, 1, 64318, 64320, 2, 64321, 64323, 2, 64324, 64326, 2, 64327, 64450, 1, 64467, 64911, 1, 64914, 64967, 1, 64975, 65008, 33, 65009, 65049, 1, 65056, 65106, 1, 65108, 65126, 1, 65128, 65131, 1, 65136, 65140, 1, 65142, 65276, 1, 65281, 65470, 1, 65474, 65479, 1, 65482, 65487, 1, 65490, 65495, 1, 65498, 65500, 1, 65504, 65510, 1, 65512, 65518, 1, 65532, 65533, 1, 65536, 65547, 1, 65549, 65574, 1, 65576, 65594, 1, 65596, 65597, 1, 65599, 65613, 1, 65616, 65629, 1, 65664, 65786, 1, 65792, 65794, 1, 65799, 65843, 1, 65847, 65934, 1, 65936, 65948, 1, 65952, 66e3, 48, 66001, 66045, 1, 66176, 66204, 1, 66208, 66256, 1, 66272, 66299, 1, 66304, 66339, 1, 66349, 66378, 1, 66384, 66426, 1, 66432, 66461, 1, 66463, 66499, 1, 66504, 66517, 1, 66560, 66717, 1, 66720, 66729, 1, 66736, 66771, 1, 66776, 66811, 1, 66816, 66855, 1, 66864, 66915, 1, 66927, 66938, 1, 66940, 66954, 1, 66956, 66962, 1, 66964, 66965, 1, 66967, 66977, 1, 66979, 66993, 1, 66995, 67001, 1, 67003, 67004, 1, 67008, 67059, 1, 67072, 67382, 1, 67392, 67413, 1, 67424, 67431, 1, 67456, 67461, 1, 67463, 67504, 1, 67506, 67514, 1, 67584, 67589, 1, 67592, 67594, 2, 67595, 67637, 1, 67639, 67640, 1, 67644, 67647, 3, 67648, 67669, 1, 67671, 67742, 1, 67751, 67759, 1, 67808, 67826, 1, 67828, 67829, 1, 67835, 67867, 1, 67871, 67897, 1, 67903, 67968, 65, 67969, 68023, 1, 68028, 68047, 1, 68050, 68099, 1, 68101, 68102, 1, 68108, 68115, 1, 68117, 68119, 1, 68121, 68149, 1, 68152, 68154, 1, 68159, 68168, 1, 68176, 68184, 1, 68192, 68255, 1, 68288, 68326, 1, 68331, 68342, 1, 68352, 68405, 1, 68409, 68437, 1, 68440, 68466, 1, 68472, 68497, 1, 68505, 68508, 1, 68521, 68527, 1, 68608, 68680, 1, 68736, 68786, 1, 68800, 68850, 1, 68858, 68903, 1, 68912, 68921, 1, 68928, 68965, 1, 68969, 68997, 1, 69006, 69007, 1, 69216, 69246, 1, 69248, 69289, 1, 69291, 69293, 1, 69296, 69297, 1, 69314, 69316, 1, 69372, 69415, 1, 69424, 69465, 1, 69488, 69513, 1, 69552, 69579, 1, 69600, 69622, 1, 69632, 69709, 1, 69714, 69749, 1, 69759, 69820, 1, 69822, 69826, 1, 69840, 69864, 1, 69872, 69881, 1, 69888, 69940, 1, 69942, 69959, 1, 69968, 70006, 1, 70016, 70111, 1, 70113, 70132, 1, 70144, 70161, 1, 70163, 70209, 1, 70272, 70278, 1, 70280, 70282, 2, 70283, 70285, 1, 70287, 70301, 1, 70303, 70313, 1, 70320, 70378, 1, 70384, 70393, 1, 70400, 70403, 1, 70405, 70412, 1, 70415, 70416, 1, 70419, 70440, 1, 70442, 70448, 1, 70450, 70451, 1, 70453, 70457, 1, 70459, 70468, 1, 70471, 70472, 1, 70475, 70477, 1, 70480, 70487, 7, 70493, 70499, 1, 70502, 70508, 1, 70512, 70516, 1, 70528, 70537, 1, 70539, 70542, 3, 70544, 70581, 1, 70583, 70592, 1, 70594, 70597, 3, 70599, 70602, 1, 70604, 70613, 1, 70615, 70616, 1, 70625, 70626, 1, 70656, 70747, 1, 70749, 70753, 1, 70784, 70855, 1, 70864, 70873, 1, 71040, 71093, 1, 71096, 71133, 1, 71168, 71236, 1, 71248, 71257, 1, 71264, 71276, 1, 71296, 71353, 1, 71360, 71369, 1, 71376, 71395, 1, 71424, 71450, 1, 71453, 71467, 1, 71472, 71494, 1, 71680, 71739, 1, 71840, 71922, 1, 71935, 71942, 1, 71945, 71948, 3, 71949, 71955, 1, 71957, 71958, 1, 71960, 71989, 1, 71991, 71992, 1, 71995, 72006, 1, 72016, 72025, 1, 72096, 72103, 1, 72106, 72151, 1, 72154, 72164, 1, 72192, 72263, 1, 72272, 72354, 1, 72368, 72440, 1, 72448, 72457, 1, 72640, 72673, 1, 72688, 72697, 1, 72704, 72712, 1, 72714, 72758, 1, 72760, 72773, 1, 72784, 72812, 1, 72816, 72847, 1, 72850, 72871, 1, 72873, 72886, 1, 72960, 72966, 1, 72968, 72969, 1, 72971, 73014, 1, 73018, 73020, 2, 73021, 73023, 2, 73024, 73031, 1, 73040, 73049, 1, 73056, 73061, 1, 73063, 73064, 1, 73066, 73102, 1, 73104, 73105, 1, 73107, 73112, 1, 73120, 73129, 1, 73440, 73464, 1, 73472, 73488, 1, 73490, 73530, 1, 73534, 73562, 1, 73648, 73664, 16, 73665, 73713, 1, 73727, 74649, 1, 74752, 74862, 1, 74864, 74868, 1, 74880, 75075, 1, 77712, 77810, 1, 77824, 78895, 1, 78912, 78933, 1, 78944, 82938, 1, 82944, 83526, 1, 90368, 90425, 1, 92160, 92728, 1, 92736, 92766, 1, 92768, 92777, 1, 92782, 92862, 1, 92864, 92873, 1, 92880, 92909, 1, 92912, 92917, 1, 92928, 92997, 1, 93008, 93017, 1, 93019, 93025, 1, 93027, 93047, 1, 93053, 93071, 1, 93504, 93561, 1, 93760, 93850, 1, 93952, 94026, 1, 94031, 94087, 1, 94095, 94111, 1, 94176, 94180, 1, 94192, 94193, 1, 94208, 100343, 1, 100352, 101589, 1, 101631, 101640, 1, 110576, 110579, 1, 110581, 110587, 1, 110589, 110590, 1, 110592, 110882, 1, 110898, 110928, 30, 110929, 110930, 1, 110933, 110948, 15, 110949, 110951, 1, 110960, 111355, 1, 113664, 113770, 1, 113776, 113788, 1, 113792, 113800, 1, 113808, 113817, 1, 113820, 113823, 1, 117760, 118009, 1, 118016, 118451, 1, 118528, 118573, 1, 118576, 118598, 1, 118608, 118723, 1, 118784, 119029, 1, 119040, 119078, 1, 119081, 119154, 1, 119163, 119274, 1, 119296, 119365, 1, 119488, 119507, 1, 119520, 119539, 1, 119552, 119638, 1, 119648, 119672, 1, 119808, 119892, 1, 119894, 119964, 1, 119966, 119967, 1, 119970, 119973, 3, 119974, 119977, 3, 119978, 119980, 1, 119982, 119993, 1, 119995, 119997, 2, 119998, 120003, 1, 120005, 120069, 1, 120071, 120074, 1, 120077, 120084, 1, 120086, 120092, 1, 120094, 120121, 1, 120123, 120126, 1, 120128, 120132, 1, 120134, 120138, 4, 120139, 120144, 1, 120146, 120485, 1, 120488, 120779, 1, 120782, 121483, 1, 121499, 121503, 1, 121505, 121519, 1, 122624, 122654, 1, 122661, 122666, 1, 122880, 122886, 1, 122888, 122904, 1, 122907, 122913, 1, 122915, 122916, 1, 122918, 122922, 1, 122928, 122989, 1, 123023, 123136, 113, 123137, 123180, 1, 123184, 123197, 1, 123200, 123209, 1, 123214, 123215, 1, 123536, 123566, 1, 123584, 123641, 1, 123647, 124112, 465, 124113, 124153, 1, 124368, 124410, 1, 124415, 124896, 481, 124897, 124902, 1, 124904, 124907, 1, 124909, 124910, 1, 124912, 124926, 1, 124928, 125124, 1, 125127, 125142, 1, 125184, 125259, 1, 125264, 125273, 1, 125278, 125279, 1, 126065, 126132, 1, 126209, 126269, 1, 126464, 126467, 1, 126469, 126495, 1, 126497, 126498, 1, 126500, 126503, 3, 126505, 126514, 1, 126516, 126519, 1, 126521, 126523, 2, 126530, 126535, 5, 126537, 126541, 2, 126542, 126543, 1, 126545, 126546, 1, 126548, 126551, 3, 126553, 126561, 2, 126562, 126564, 2, 126567, 126570, 1, 126572, 126578, 1, 126580, 126583, 1, 126585, 126588, 1, 126590, 126592, 2, 126593, 126601, 1, 126603, 126619, 1, 126625, 126627, 1, 126629, 126633, 1, 126635, 126651, 1, 126704, 126705, 1, 126976, 127019, 1, 127024, 127123, 1, 127136, 127150, 1, 127153, 127167, 1, 127169, 127183, 1, 127185, 127221, 1, 127232, 127405, 1, 127462, 127490, 1, 127504, 127547, 1, 127552, 127560, 1, 127568, 127569, 1, 127584, 127589, 1, 127744, 128727, 1, 128732, 128748, 1, 128752, 128764, 1, 128768, 128886, 1, 128891, 128985, 1, 128992, 129003, 1, 129008, 129024, 16, 129025, 129035, 1, 129040, 129095, 1, 129104, 129113, 1, 129120, 129159, 1, 129168, 129197, 1, 129200, 129211, 1, 129216, 129217, 1, 129280, 129619, 1, 129632, 129645, 1, 129648, 129660, 1, 129664, 129673, 1, 129679, 129734, 1, 129742, 129756, 1, 129759, 129769, 1, 129776, 129784, 1, 129792, 129938, 1, 129940, 130041, 1, 131072, 173791, 1, 173824, 177977, 1, 177984, 178205, 1, 178208, 183969, 1, 183984, 191456, 1, 191472, 192093, 1, 194560, 195101, 1, 196608, 201546, 1, 201552, 205743, 1, 917760, 917999, 1]));
    };
    w = class {
      static MAX_RUNE = 1114111;
      static MAX_ASCII = 127;
      static MAX_LATIN1 = 255;
      static MAX_BMP = 65535;
      static MIN_FOLD = 65;
      static MAX_FOLD = 125251;
      static is32(t6, e7) {
        let s9 = 0, i10 = t6.length;
        for (; s9 < i10; ) {
          let r8 = s9 + Math.floor((i10 - s9) / 2), o9 = t6.getLo(r8), l8 = t6.getHi(r8);
          if (o9 <= e7 && e7 <= l8) {
            let h17 = t6.getStride(r8);
            return (e7 - o9) % h17 === 0;
          }
          e7 < o9 ? i10 = r8 : s9 = r8 + 1;
        }
        return false;
      }
      static is(t6, e7) {
        if (e7 <= this.MAX_LATIN1) {
          for (let s9 = 0; s9 < t6.length; s9++) {
            let i10 = t6.getHi(s9);
            if (e7 > i10) continue;
            let r8 = t6.getLo(s9);
            if (e7 < r8) return false;
            let o9 = t6.getStride(s9);
            return (e7 - r8) % o9 === 0;
          }
          return false;
        }
        return t6.length > 0 && e7 >= t6.getLo(0) && this.is32(t6, e7);
      }
      static isUpper(t6) {
        if (t6 <= this.MAX_LATIN1) {
          let e7 = String.fromCodePoint(t6);
          return e7.toUpperCase() === e7 && e7.toLowerCase() !== e7;
        }
        return this.is(b.Upper, t6);
      }
      static isPrint(t6) {
        return t6 <= this.MAX_LATIN1 ? t6 >= 32 && t6 < this.MAX_ASCII || t6 >= 161 && t6 !== 173 : this.is(b.Print, t6);
      }
      static simpleFold(t6) {
        if (b.CASE_ORBIT.has(t6)) return b.CASE_ORBIT.get(t6);
        let e7 = u.toLowerCase(t6);
        return e7 !== t6 ? e7 : u.toUpperCase(t6);
      }
      static equalsIgnoreCase(t6, e7) {
        if (t6 < 0 || e7 < 0 || t6 === e7) return true;
        if (t6 <= this.MAX_ASCII && e7 <= this.MAX_ASCII) return u.CODES.get("A") <= t6 && t6 <= u.CODES.get("Z") && (t6 |= 32), u.CODES.get("A") <= e7 && e7 <= u.CODES.get("Z") && (e7 |= 32), t6 === e7;
        for (let s9 = this.simpleFold(t6); s9 !== t6; s9 = this.simpleFold(s9)) if (s9 === e7) return true;
        return false;
      }
    };
    O = class {
      static METACHARACTERS = "\\.+*?()|[]{}^$";
      static EMPTY_BEGIN_LINE = 1;
      static EMPTY_END_LINE = 2;
      static EMPTY_BEGIN_TEXT = 4;
      static EMPTY_END_TEXT = 8;
      static EMPTY_WORD_BOUNDARY = 16;
      static EMPTY_NO_WORD_BOUNDARY = 32;
      static EMPTY_ALL = -1;
      static emptyInts() {
        return [];
      }
      static isalnum(t6) {
        return u.CODES.get("0") <= t6 && t6 <= u.CODES.get("9") || u.CODES.get("a") <= t6 && t6 <= u.CODES.get("z") || u.CODES.get("A") <= t6 && t6 <= u.CODES.get("Z");
      }
      static unhex(t6) {
        return u.CODES.get("0") <= t6 && t6 <= u.CODES.get("9") ? t6 - u.CODES.get("0") : u.CODES.get("a") <= t6 && t6 <= u.CODES.get("f") ? t6 - u.CODES.get("a") + 10 : u.CODES.get("A") <= t6 && t6 <= u.CODES.get("F") ? t6 - u.CODES.get("A") + 10 : -1;
      }
      static escapeRune(t6) {
        let e7 = "";
        if (w.isPrint(t6)) this.METACHARACTERS.indexOf(String.fromCodePoint(t6)) >= 0 && (e7 += "\\"), e7 += String.fromCodePoint(t6);
        else switch (t6) {
          case u.CODES.get('"'):
            e7 += '\\"';
            break;
          case u.CODES.get("\\"):
            e7 += "\\\\";
            break;
          case u.CODES.get("	"):
            e7 += "\\t";
            break;
          case u.CODES.get(`
`):
            e7 += "\\n";
            break;
          case u.CODES.get("\r"):
            e7 += "\\r";
            break;
          case u.CODES.get("\b"):
            e7 += "\\b";
            break;
          case u.CODES.get("\f"):
            e7 += "\\f";
            break;
          default: {
            let s9 = t6.toString(16);
            t6 < 256 ? (e7 += "\\x", s9.length === 1 && (e7 += "0"), e7 += s9) : e7 += `\\x{${s9}}`;
            break;
          }
        }
        return e7;
      }
      static stringToRunes(t6) {
        return String(t6).split("").map((e7) => e7.codePointAt(0));
      }
      static runeToString(t6) {
        return String.fromCodePoint(t6);
      }
      static isWordRune(t6) {
        return u.CODES.get("a") <= t6 && t6 <= u.CODES.get("z") || u.CODES.get("A") <= t6 && t6 <= u.CODES.get("Z") || u.CODES.get("0") <= t6 && t6 <= u.CODES.get("9") || t6 === u.CODES.get("_");
      }
      static emptyOpContext(t6, e7) {
        let s9 = 0;
        return t6 < 0 && (s9 |= this.EMPTY_BEGIN_TEXT | this.EMPTY_BEGIN_LINE), t6 === u.CODES.get(`
`) && (s9 |= this.EMPTY_BEGIN_LINE), e7 < 0 && (s9 |= this.EMPTY_END_TEXT | this.EMPTY_END_LINE), e7 === u.CODES.get(`
`) && (s9 |= this.EMPTY_END_LINE), this.isWordRune(t6) !== this.isWordRune(e7) ? s9 |= this.EMPTY_WORD_BOUNDARY : s9 |= this.EMPTY_NO_WORD_BOUNDARY, s9;
      }
      static quoteMeta(t6) {
        return t6.split("").map((e7) => this.METACHARACTERS.indexOf(e7) >= 0 ? `\\${e7}` : e7).join("");
      }
      static charCount(t6) {
        return t6 > w.MAX_BMP ? 2 : 1;
      }
      static stringToUtf8ByteArray(t6) {
        if (globalThis.TextEncoder) return Array.from(new TextEncoder().encode(t6));
        {
          let e7 = [], s9 = 0;
          for (let i10 = 0; i10 < t6.length; i10++) {
            let r8 = t6.charCodeAt(i10);
            r8 < 128 ? e7[s9++] = r8 : r8 < 2048 ? (e7[s9++] = r8 >> 6 | 192, e7[s9++] = r8 & 63 | 128) : (r8 & 64512) === 55296 && i10 + 1 < t6.length && (t6.charCodeAt(i10 + 1) & 64512) === 56320 ? (r8 = 65536 + ((r8 & 1023) << 10) + (t6.charCodeAt(++i10) & 1023), e7[s9++] = r8 >> 18 | 240, e7[s9++] = r8 >> 12 & 63 | 128, e7[s9++] = r8 >> 6 & 63 | 128, e7[s9++] = r8 & 63 | 128) : (e7[s9++] = r8 >> 12 | 224, e7[s9++] = r8 >> 6 & 63 | 128, e7[s9++] = r8 & 63 | 128);
          }
          return e7;
        }
      }
      static utf8ByteArrayToString(t6) {
        if (globalThis.TextDecoder) return new TextDecoder("utf-8").decode(new Uint8Array(t6));
        {
          let e7 = [], s9 = 0, i10 = 0;
          for (; s9 < t6.length; ) {
            let r8 = t6[s9++];
            if (r8 < 128) e7[i10++] = String.fromCharCode(r8);
            else if (r8 > 191 && r8 < 224) {
              let o9 = t6[s9++];
              e7[i10++] = String.fromCharCode((r8 & 31) << 6 | o9 & 63);
            } else if (r8 > 239 && r8 < 365) {
              let o9 = t6[s9++], l8 = t6[s9++], h17 = t6[s9++], p17 = ((r8 & 7) << 18 | (o9 & 63) << 12 | (l8 & 63) << 6 | h17 & 63) - 65536;
              e7[i10++] = String.fromCharCode(55296 + (p17 >> 10)), e7[i10++] = String.fromCharCode(56320 + (p17 & 1023));
            } else {
              let o9 = t6[s9++], l8 = t6[s9++];
              e7[i10++] = String.fromCharCode((r8 & 15) << 12 | (o9 & 63) << 6 | l8 & 63);
            }
          }
          return e7.join("");
        }
      }
    };
    R1 = (n23 = [], t6 = 0) => {
      let e7 = {};
      for (let s9 = 0; s9 < n23.length; s9++) {
        let i10 = n23[s9], r8 = t6 + s9;
        e7[i10] = r8, e7[r8] = i10;
      }
      return Object.freeze(e7);
    };
    I = class n3 {
      static Encoding = R1(["UTF_16", "UTF_8"]);
      getEncoding() {
        throw Error("not implemented");
      }
      isUTF8Encoding() {
        return this.getEncoding() === n3.Encoding.UTF_8;
      }
      isUTF16Encoding() {
        return this.getEncoding() === n3.Encoding.UTF_16;
      }
    };
    F = class extends I {
      constructor(t6 = null) {
        super(), this.bytes = t6;
      }
      getEncoding() {
        return I.Encoding.UTF_8;
      }
      asCharSequence() {
        return O.utf8ByteArrayToString(this.bytes);
      }
      asBytes() {
        return this.bytes;
      }
      length() {
        return this.bytes.length;
      }
    };
    X = class extends I {
      constructor(t6 = null) {
        super(), this.charSequence = t6;
      }
      getEncoding() {
        return I.Encoding.UTF_16;
      }
      asCharSequence() {
        return this.charSequence;
      }
      asBytes() {
        return this.charSequence.toString().split("").map((t6) => t6.codePointAt(0));
      }
      length() {
        return this.charSequence.length;
      }
    };
    P = class {
      static utf16(t6) {
        return new X(t6);
      }
      static utf8(t6) {
        return Array.isArray(t6) ? new F(t6) : new F(O.stringToUtf8ByteArray(t6));
      }
    };
    _ = class extends Error {
      constructor(t6) {
        super(t6), this.name = "RE2JSException";
      }
    };
    m = class extends _ {
      constructor(t6, e7 = null) {
        let s9 = `error parsing regexp: ${t6}`;
        e7 && (s9 += `: \`${e7}\``), super(s9), this.name = "RE2JSSyntaxException", this.message = s9, this.error = t6, this.input = e7;
      }
      getDescription() {
        return this.error;
      }
      getPattern() {
        return this.input;
      }
    };
    v = class extends _ {
      constructor(t6) {
        super(t6), this.name = "RE2JSCompileException";
      }
    };
    U = class extends _ {
      constructor(t6) {
        super(t6), this.name = "RE2JSGroupException";
      }
    };
    z = class extends _ {
      constructor(t6) {
        super(t6), this.name = "RE2JSFlagsException";
      }
    };
    V = class {
      static quoteReplacement(t6) {
        return t6.indexOf("\\") < 0 && t6.indexOf("$") < 0 ? t6 : t6.split("").map((e7) => {
          let s9 = e7.codePointAt(0);
          return s9 === u.CODES["\\"] || s9 === u.CODES.$ ? `\\${e7}` : e7;
        }).join("");
      }
      constructor(t6, e7) {
        if (t6 === null) throw new Error("pattern is null");
        this.patternInput = t6;
        let s9 = this.patternInput.re2();
        this.patternGroupCount = s9.numberOfCapturingGroups(), this.groups = [], this.namedGroups = s9.namedGroups, this.numberOfInstructions = s9.numberOfInstructions(), e7 instanceof I ? this.resetMatcherInput(e7) : Array.isArray(e7) ? this.resetMatcherInput(P.utf8(e7)) : this.resetMatcherInput(P.utf16(e7));
      }
      pattern() {
        return this.patternInput;
      }
      reset() {
        return this.matcherInputLength = this.matcherInput.length(), this.appendPos = 0, this.hasMatch = false, this.hasGroups = false, this.anchorFlag = 0, this;
      }
      resetMatcherInput(t6) {
        if (t6 === null) throw new Error("input is null");
        return this.matcherInput = t6, this.reset(), this;
      }
      start(t6 = 0) {
        if (typeof t6 == "string") {
          let e7 = this.namedGroups[t6];
          if (!Number.isFinite(e7)) throw new U(`group '${t6}' not found`);
          t6 = e7;
        }
        return this.loadGroup(t6), this.groups[2 * t6];
      }
      end(t6 = 0) {
        if (typeof t6 == "string") {
          let e7 = this.namedGroups[t6];
          if (!Number.isFinite(e7)) throw new U(`group '${t6}' not found`);
          t6 = e7;
        }
        return this.loadGroup(t6), this.groups[2 * t6 + 1];
      }
      programSize() {
        return this.numberOfInstructions;
      }
      group(t6 = 0) {
        if (typeof t6 == "string") {
          let i10 = this.namedGroups[t6];
          if (!Number.isFinite(i10)) throw new U(`group '${t6}' not found`);
          t6 = i10;
        }
        let e7 = this.start(t6), s9 = this.end(t6);
        return e7 < 0 && s9 < 0 ? null : this.substring(e7, s9);
      }
      groupCount() {
        return this.patternGroupCount;
      }
      loadGroup(t6) {
        if (t6 < 0 || t6 > this.patternGroupCount) throw new U(`Group index out of bounds: ${t6}`);
        if (!this.hasMatch) throw new U("perhaps no match attempted");
        if (t6 === 0 || this.hasGroups) return;
        let e7 = this.groups[1] + 1;
        e7 > this.matcherInputLength && (e7 = this.matcherInputLength);
        let s9 = this.patternInput.re2().matchMachineInput(this.matcherInput, this.groups[0], e7, this.anchorFlag, 1 + this.patternGroupCount);
        if (!s9[0]) throw new U("inconsistency in matching group data");
        this.groups = s9[1], this.hasGroups = true;
      }
      matches() {
        return this.genMatch(0, g.ANCHOR_BOTH);
      }
      lookingAt() {
        return this.genMatch(0, g.ANCHOR_START);
      }
      find(t6 = null) {
        if (t6 !== null) {
          if (t6 < 0 || t6 > this.matcherInputLength) throw new U(`start index out of bounds: ${t6}`);
          return this.reset(), this.genMatch(t6, 0);
        }
        return t6 = 0, this.hasMatch && (t6 = this.groups[1], this.groups[0] === this.groups[1] && t6++), this.genMatch(t6, g.UNANCHORED);
      }
      genMatch(t6, e7) {
        let s9 = this.patternInput.re2().matchMachineInput(this.matcherInput, t6, this.matcherInputLength, e7, 1);
        return s9[0] ? (this.groups = s9[1], this.hasMatch = true, this.hasGroups = false, this.anchorFlag = e7, true) : false;
      }
      substring(t6, e7) {
        return this.matcherInput.isUTF8Encoding() ? O.utf8ByteArrayToString(this.matcherInput.asBytes().slice(t6, e7)) : this.matcherInput.asCharSequence().substring(t6, e7).toString();
      }
      inputLength() {
        return this.matcherInputLength;
      }
      appendReplacement(t6, e7 = false) {
        let s9 = "", i10 = this.start(), r8 = this.end();
        return this.appendPos < i10 && (s9 += this.substring(this.appendPos, i10)), this.appendPos = r8, s9 += e7 ? this.appendReplacementInternalPerl(t6) : this.appendReplacementInternal(t6), s9;
      }
      appendReplacementInternal(t6) {
        let e7 = "", s9 = 0, i10 = t6.length;
        for (let r8 = 0; r8 < i10 - 1; r8++) {
          if (t6.codePointAt(r8) === u.CODES.get("\\")) {
            s9 < r8 && (e7 += t6.substring(s9, r8)), r8++, s9 = r8;
            continue;
          }
          if (t6.codePointAt(r8) === u.CODES.get("$")) {
            let o9 = t6.codePointAt(r8 + 1);
            if (u.CODES.get("0") <= o9 && o9 <= u.CODES.get("9")) {
              let l8 = o9 - u.CODES.get("0");
              for (s9 < r8 && (e7 += t6.substring(s9, r8)), r8 += 2; r8 < i10 && (o9 = t6.codePointAt(r8), !(o9 < u.CODES.get("0") || o9 > u.CODES.get("9") || l8 * 10 + o9 - u.CODES.get("0") > this.patternGroupCount)); r8++) l8 = l8 * 10 + o9 - u.CODES.get("0");
              if (l8 > this.patternGroupCount) throw new U(`n > number of groups: ${l8}`);
              let h17 = this.group(l8);
              h17 !== null && (e7 += h17), s9 = r8, r8--;
              continue;
            } else if (o9 === u.CODES.get("{")) {
              s9 < r8 && (e7 += t6.substring(s9, r8)), r8++;
              let l8 = r8 + 1;
              for (; l8 < t6.length && t6.codePointAt(l8) !== u.CODES.get("}") && t6.codePointAt(l8) !== u.CODES.get(" "); ) l8++;
              if (l8 === t6.length || t6.codePointAt(l8) !== u.CODES.get("}")) throw new U("named capture group is missing trailing '}'");
              let h17 = t6.substring(r8 + 1, l8);
              e7 += this.group(h17), s9 = l8 + 1;
            }
          }
        }
        return s9 < i10 && (e7 += t6.substring(s9, i10)), e7;
      }
      appendReplacementInternalPerl(t6) {
        let e7 = "", s9 = 0, i10 = t6.length;
        for (let r8 = 0; r8 < i10 - 1; r8++) if (t6.codePointAt(r8) === u.CODES.get("$")) {
          let o9 = t6.codePointAt(r8 + 1);
          if (u.CODES.get("$") === o9) {
            s9 < r8 && (e7 += t6.substring(s9, r8)), e7 += "$", r8++, s9 = r8 + 1;
            continue;
          } else if (u.CODES.get("&") === o9) {
            s9 < r8 && (e7 += t6.substring(s9, r8));
            let l8 = this.group(0);
            l8 !== null ? e7 += l8 : e7 += "$&", r8++, s9 = r8 + 1;
            continue;
          } else if (u.CODES.get("1") <= o9 && o9 <= u.CODES.get("9")) {
            let l8 = o9 - u.CODES.get("0");
            for (s9 < r8 && (e7 += t6.substring(s9, r8)), r8 += 2; r8 < i10 && (o9 = t6.codePointAt(r8), !(o9 < u.CODES.get("0") || o9 > u.CODES.get("9") || l8 * 10 + o9 - u.CODES.get("0") > this.patternGroupCount)); r8++) l8 = l8 * 10 + o9 - u.CODES.get("0");
            if (l8 > this.patternGroupCount) {
              e7 += `$${l8}`, s9 = r8, r8--;
              continue;
            }
            let h17 = this.group(l8);
            h17 !== null && (e7 += h17), s9 = r8, r8--;
            continue;
          } else if (o9 === u.CODES.get("<")) {
            s9 < r8 && (e7 += t6.substring(s9, r8)), r8++;
            let l8 = r8 + 1;
            for (; l8 < t6.length && t6.codePointAt(l8) !== u.CODES.get(">") && t6.codePointAt(l8) !== u.CODES.get(" "); ) l8++;
            if (l8 === t6.length || t6.codePointAt(l8) !== u.CODES.get(">")) {
              e7 += t6.substring(r8 - 1, l8 + 1), s9 = l8 + 1;
              continue;
            }
            let h17 = t6.substring(r8 + 1, l8);
            Object.prototype.hasOwnProperty.call(this.namedGroups, h17) ? e7 += this.group(h17) : e7 += `$<${h17}>`, s9 = l8 + 1;
          }
        }
        return s9 < i10 && (e7 += t6.substring(s9, i10)), e7;
      }
      appendTail() {
        return this.substring(this.appendPos, this.matcherInputLength);
      }
      replaceAll(t6, e7 = false) {
        return this.replace(t6, true, e7);
      }
      replaceFirst(t6, e7 = false) {
        return this.replace(t6, false, e7);
      }
      replace(t6, e7 = true, s9 = false) {
        let i10 = "";
        for (this.reset(); this.find() && (i10 += this.appendReplacement(t6, s9), !!e7); ) ;
        return i10 += this.appendTail(), i10;
      }
    };
    L = class {
      static EOF() {
        return -8;
      }
      canCheckPrefix() {
        return true;
      }
      endPos() {
        return this.end;
      }
    };
    $ = class extends L {
      constructor(t6, e7 = 0, s9 = t6.length) {
        super(), this.bytes = t6, this.start = e7, this.end = s9;
      }
      step(t6) {
        if (t6 += this.start, t6 >= this.end) return L.EOF();
        let e7 = this.bytes[t6++] & 255;
        return (e7 & 128) === 0 ? e7 << 3 | 1 : (e7 & 224) === 192 ? (e7 = e7 & 31, t6 >= this.end ? L.EOF() : (e7 = e7 << 6 | this.bytes[t6++] & 63, e7 << 3 | 2)) : (e7 & 240) === 224 ? (e7 = e7 & 15, t6 + 1 >= this.end ? L.EOF() : (e7 = e7 << 6 | this.bytes[t6++] & 63, e7 = e7 << 6 | this.bytes[t6++] & 63, e7 << 3 | 3)) : (e7 = e7 & 7, t6 + 2 >= this.end ? L.EOF() : (e7 = e7 << 6 | this.bytes[t6++] & 63, e7 = e7 << 6 | this.bytes[t6++] & 63, e7 = e7 << 6 | this.bytes[t6++] & 63, e7 << 3 | 4));
      }
      index(t6, e7) {
        e7 += this.start;
        let s9 = this.indexOf(this.bytes, t6.prefixUTF8, e7);
        return s9 < 0 ? s9 : s9 - e7;
      }
      context(t6) {
        t6 += this.start;
        let e7 = -1;
        if (t6 > this.start && t6 <= this.end) {
          let i10 = t6 - 1;
          if (e7 = this.bytes[i10--], e7 >= 128) {
            let r8 = t6 - 4;
            for (r8 < this.start && (r8 = this.start); i10 >= r8 && (this.bytes[i10] & 192) === 128; ) i10--;
            i10 < this.start && (i10 = this.start), e7 = this.step(i10) >> 3;
          }
        }
        let s9 = t6 < this.end ? this.step(t6) >> 3 : -1;
        return O.emptyOpContext(e7, s9);
      }
      indexOf(t6, e7, s9 = 0) {
        let i10 = e7.length;
        if (i10 === 0) return -1;
        let r8 = t6.length;
        for (let o9 = s9; o9 <= r8 - i10; o9++) for (let l8 = 0; l8 < i10 && t6[o9 + l8] === e7[l8]; l8++) if (l8 === i10 - 1) return o9;
        return -1;
      }
    };
    j = class extends L {
      constructor(t6, e7 = 0, s9 = t6.length) {
        super(), this.charSequence = t6, this.start = e7, this.end = s9;
      }
      step(t6) {
        if (t6 += this.start, t6 < this.end) {
          let e7 = this.charSequence.codePointAt(t6);
          return e7 << 3 | O.charCount(e7);
        } else return L.EOF();
      }
      index(t6, e7) {
        e7 += this.start;
        let s9 = this.charSequence.indexOf(t6.prefix, e7);
        return s9 < 0 ? s9 : s9 - e7;
      }
      context(t6) {
        t6 += this.start;
        let e7 = t6 > 0 && t6 <= this.charSequence.length ? this.charSequence.codePointAt(t6 - 1) : -1, s9 = t6 < this.charSequence.length ? this.charSequence.codePointAt(t6) : -1;
        return O.emptyOpContext(e7, s9);
      }
    };
    N = class {
      static fromUTF8(t6, e7 = 0, s9 = t6.length) {
        return new $(t6, e7, s9);
      }
      static fromUTF16(t6, e7 = 0, s9 = t6.length) {
        return new j(t6, e7, s9);
      }
    };
    E = class n4 {
      static ALT = 1;
      static ALT_MATCH = 2;
      static CAPTURE = 3;
      static EMPTY_WIDTH = 4;
      static FAIL = 5;
      static MATCH = 6;
      static NOP = 7;
      static RUNE = 8;
      static RUNE1 = 9;
      static RUNE_ANY = 10;
      static RUNE_ANY_NOT_NL = 11;
      static isRuneOp(t6) {
        return n4.RUNE <= t6 && t6 <= n4.RUNE_ANY_NOT_NL;
      }
      static escapeRunes(t6) {
        let e7 = '"';
        for (let s9 of t6) e7 += O.escapeRune(s9);
        return e7 += '"', e7;
      }
      constructor(t6) {
        this.op = t6, this.out = 0, this.arg = 0, this.runes = [];
      }
      matchRune(t6) {
        if (this.runes.length === 1) {
          let i10 = this.runes[0];
          return (this.arg & g.FOLD_CASE) !== 0 ? w.equalsIgnoreCase(i10, t6) : t6 === i10;
        }
        for (let i10 = 0; i10 < this.runes.length && i10 <= 8; i10 += 2) {
          if (t6 < this.runes[i10]) return false;
          if (t6 <= this.runes[i10 + 1]) return true;
        }
        let e7 = 0, s9 = this.runes.length / 2 | 0;
        for (; e7 < s9; ) {
          let i10 = e7 + ((s9 - e7) / 2 | 0);
          if (this.runes[2 * i10] <= t6) {
            if (t6 <= this.runes[2 * i10 + 1]) return true;
            e7 = i10 + 1;
          } else s9 = i10;
        }
        return false;
      }
      toString() {
        switch (this.op) {
          case n4.ALT:
            return `alt -> ${this.out}, ${this.arg}`;
          case n4.ALT_MATCH:
            return `altmatch -> ${this.out}, ${this.arg}`;
          case n4.CAPTURE:
            return `cap ${this.arg} -> ${this.out}`;
          case n4.EMPTY_WIDTH:
            return `empty ${this.arg} -> ${this.out}`;
          case n4.MATCH:
            return "match";
          case n4.FAIL:
            return "fail";
          case n4.NOP:
            return `nop -> ${this.out}`;
          case n4.RUNE:
            return this.runes === null ? "rune <null>" : ["rune ", n4.escapeRunes(this.runes), (this.arg & g.FOLD_CASE) !== 0 ? "/i" : "", " -> ", this.out].join("");
          case n4.RUNE1:
            return `rune1 ${n4.escapeRunes(this.runes)} -> ${this.out}`;
          case n4.RUNE_ANY:
            return `any -> ${this.out}`;
          case n4.RUNE_ANY_NOT_NL:
            return `anynotnl -> ${this.out}`;
          default:
            throw new Error("unhandled case in Inst.toString");
        }
      }
    };
    W = class {
      constructor() {
        this.inst = null, this.cap = [];
      }
    };
    Y = class {
      constructor() {
        this.sparse = [], this.densePcs = [], this.denseThreads = [], this.size = 0;
      }
      contains(t6) {
        let e7 = this.sparse[t6];
        return e7 < this.size && this.densePcs[e7] === t6;
      }
      isEmpty() {
        return this.size === 0;
      }
      add(t6) {
        let e7 = this.size++;
        return this.sparse[t6] = e7, this.denseThreads[e7] = null, this.densePcs[e7] = t6, e7;
      }
      clear() {
        this.sparse = [], this.densePcs = [], this.denseThreads = [], this.size = 0;
      }
      toString() {
        let t6 = "{";
        for (let e7 = 0; e7 < this.size; e7++) e7 !== 0 && (t6 += ", "), t6 += this.densePcs[e7];
        return t6 += "}", t6;
      }
    };
    M = class n5 {
      static fromRE2(t6) {
        let e7 = new n5();
        return e7.prog = t6.prog, e7.re2 = t6, e7.q0 = new Y(e7.prog.numInst()), e7.q1 = new Y(e7.prog.numInst()), e7.pool = [], e7.poolSize = 0, e7.matched = false, e7.matchcap = Array(e7.prog.numCap < 2 ? 2 : e7.prog.numCap).fill(0), e7.ncap = 0, e7;
      }
      static fromMachine(t6) {
        let e7 = new n5();
        return e7.re2 = t6.re2, e7.prog = t6.prog, e7.q0 = t6.q0, e7.q1 = t6.q1, e7.pool = t6.pool, e7.poolSize = t6.poolSize, e7.matched = t6.matched, e7.matchcap = t6.matchcap, e7.ncap = t6.ncap, e7;
      }
      init(t6) {
        this.ncap = t6, t6 > this.matchcap.length ? this.initNewCap(t6) : this.resetCap(t6);
      }
      resetCap(t6) {
        for (let e7 = 0; e7 < this.poolSize; e7++) {
          let s9 = this.pool[e7];
          s9.cap = Array(t6).fill(0);
        }
      }
      initNewCap(t6) {
        for (let e7 = 0; e7 < this.poolSize; e7++) {
          let s9 = this.pool[e7];
          s9.cap = Array(t6).fill(0);
        }
        this.matchcap = Array(t6).fill(0);
      }
      submatches() {
        return this.ncap === 0 ? O.emptyInts() : this.matchcap.slice(0, this.ncap);
      }
      alloc(t6) {
        let e7;
        return this.poolSize > 0 ? (this.poolSize--, e7 = this.pool[this.poolSize]) : e7 = new W(), e7.inst = t6, e7;
      }
      freeQueue(t6, e7 = 0) {
        let s9 = t6.size - e7, i10 = this.poolSize + s9;
        this.pool.length < i10 && (this.pool = this.pool.slice(0, Math.max(this.pool.length * 2, i10)));
        for (let r8 = e7; r8 < t6.size; r8++) {
          let o9 = t6.denseThreads[r8];
          o9 !== null && (this.pool[this.poolSize] = o9, this.poolSize++);
        }
        t6.clear();
      }
      freeThread(t6) {
        this.pool.length <= this.poolSize && (this.pool = this.pool.slice(0, this.pool.length * 2)), this.pool[this.poolSize] = t6, this.poolSize++;
      }
      match(t6, e7, s9) {
        let i10 = this.re2.cond;
        if (i10 === O.EMPTY_ALL || (s9 === g.ANCHOR_START || s9 === g.ANCHOR_BOTH) && e7 !== 0) return false;
        this.matched = false, this.matchcap = Array(this.prog.numCap).fill(-1);
        let r8 = this.q0, o9 = this.q1, l8 = t6.step(e7), h17 = l8 >> 3, p17 = l8 & 7, f11 = -1, A14 = 0;
        l8 !== L.EOF() && (l8 = t6.step(e7 + p17), f11 = l8 >> 3, A14 = l8 & 7);
        let T10;
        for (e7 === 0 ? T10 = O.emptyOpContext(-1, h17) : T10 = t6.context(e7); ; ) {
          if (r8.isEmpty()) {
            if ((i10 & O.EMPTY_BEGIN_TEXT) !== 0 && e7 !== 0 || this.matched) break;
            if (this.re2.prefix.length !== 0 && f11 !== this.re2.prefixRune && t6.canCheckPrefix()) {
              let R13 = t6.index(this.re2, e7);
              if (R13 < 0) break;
              e7 += R13, l8 = t6.step(e7), h17 = l8 >> 3, p17 = l8 & 7, l8 = t6.step(e7 + p17), f11 = l8 >> 3, A14 = l8 & 7;
            }
          }
          !this.matched && (e7 === 0 || s9 === g.UNANCHORED) && (this.ncap > 0 && (this.matchcap[0] = e7), this.add(r8, this.prog.start, e7, this.matchcap, T10, null));
          let C19 = e7 + p17;
          if (T10 = t6.context(C19), this.step(r8, o9, e7, C19, h17, T10, s9, e7 === t6.endPos()), p17 === 0 || this.ncap === 0 && this.matched) break;
          e7 += p17, h17 = f11, p17 = A14, h17 !== -1 && (l8 = t6.step(e7 + p17), f11 = l8 >> 3, A14 = l8 & 7);
          let S17 = r8;
          r8 = o9, o9 = S17;
        }
        return this.freeQueue(o9), this.matched;
      }
      step(t6, e7, s9, i10, r8, o9, l8, h17) {
        let p17 = this.re2.longest;
        for (let f11 = 0; f11 < t6.size; f11++) {
          let A14 = t6.denseThreads[f11];
          if (A14 === null) continue;
          if (p17 && this.matched && this.ncap > 0 && this.matchcap[0] < A14.cap[0]) {
            this.freeThread(A14);
            continue;
          }
          let T10 = A14.inst, C19 = false;
          switch (T10.op) {
            case E.MATCH:
              if (l8 === g.ANCHOR_BOTH && !h17) break;
              this.ncap > 0 && (!p17 || !this.matched || this.matchcap[1] < s9) && (A14.cap[1] = s9, this.matchcap = A14.cap.slice(0, this.ncap)), p17 || this.freeQueue(t6, f11 + 1), this.matched = true;
              break;
            case E.RUNE:
              C19 = T10.matchRune(r8);
              break;
            case E.RUNE1:
              C19 = r8 === T10.runes[0];
              break;
            case E.RUNE_ANY:
              C19 = true;
              break;
            case E.RUNE_ANY_NOT_NL:
              C19 = r8 !== u.CODES.get(`
`);
              break;
            default:
              throw new Error("bad inst");
          }
          C19 && (A14 = this.add(e7, T10.out, i10, A14.cap, o9, A14)), A14 !== null && (this.freeThread(A14), t6.denseThreads[f11] = null);
        }
        t6.clear();
      }
      add(t6, e7, s9, i10, r8, o9) {
        if (e7 === 0 || t6.contains(e7)) return o9;
        let l8 = t6.add(e7), h17 = this.prog.inst[e7];
        switch (h17.op) {
          case E.FAIL:
            break;
          case E.ALT:
          case E.ALT_MATCH:
            o9 = this.add(t6, h17.out, s9, i10, r8, o9), o9 = this.add(t6, h17.arg, s9, i10, r8, o9);
            break;
          case E.EMPTY_WIDTH:
            (h17.arg & ~r8) === 0 && (o9 = this.add(t6, h17.out, s9, i10, r8, o9));
            break;
          case E.NOP:
            o9 = this.add(t6, h17.out, s9, i10, r8, o9);
            break;
          case E.CAPTURE:
            if (h17.arg < this.ncap) {
              let p17 = i10[h17.arg];
              i10[h17.arg] = s9, this.add(t6, h17.out, s9, i10, r8, null), i10[h17.arg] = p17;
            } else o9 = this.add(t6, h17.out, s9, i10, r8, o9);
            break;
          case E.MATCH:
          case E.RUNE:
          case E.RUNE1:
          case E.RUNE_ANY:
          case E.RUNE_ANY_NOT_NL:
            o9 === null ? o9 = this.alloc(h17) : o9.inst = h17, this.ncap > 0 && o9.cap !== i10 && (o9.cap = i10.slice(0, this.ncap)), t6.denseThreads[l8] = o9, o9 = null;
            break;
          default:
            throw new Error("unhandled");
        }
        return o9;
      }
    };
    c = class n6 {
      static Op = R1(["NO_MATCH", "EMPTY_MATCH", "LITERAL", "CHAR_CLASS", "ANY_CHAR_NOT_NL", "ANY_CHAR", "BEGIN_LINE", "END_LINE", "BEGIN_TEXT", "END_TEXT", "WORD_BOUNDARY", "NO_WORD_BOUNDARY", "CAPTURE", "STAR", "PLUS", "QUEST", "REPEAT", "CONCAT", "ALTERNATE", "LEFT_PAREN", "VERTICAL_BAR"]);
      static isPseudoOp(t6) {
        return t6 >= n6.Op.LEFT_PAREN;
      }
      static emptySubs() {
        return [];
      }
      static quoteIfHyphen(t6) {
        return t6 === u.CODES.get("-") ? "\\" : "";
      }
      static fromRegexp(t6) {
        let e7 = new n6(t6.op);
        return e7.flags = t6.flags, e7.subs = t6.subs, e7.runes = t6.runes, e7.cap = t6.cap, e7.min = t6.min, e7.max = t6.max, e7.name = t6.name, e7.namedGroups = t6.namedGroups, e7;
      }
      constructor(t6) {
        this.op = t6, this.flags = 0, this.subs = n6.emptySubs(), this.runes = [], this.min = 0, this.max = 0, this.cap = 0, this.name = null, this.namedGroups = {};
      }
      reinit() {
        this.flags = 0, this.subs = n6.emptySubs(), this.runes = [], this.cap = 0, this.min = 0, this.max = 0, this.name = null, this.namedGroups = {};
      }
      toString() {
        return this.appendTo();
      }
      appendTo() {
        let t6 = "";
        switch (this.op) {
          case n6.Op.NO_MATCH:
            t6 += "[^\\x00-\\x{10FFFF}]";
            break;
          case n6.Op.EMPTY_MATCH:
            t6 += "(?:)";
            break;
          case n6.Op.STAR:
          case n6.Op.PLUS:
          case n6.Op.QUEST:
          case n6.Op.REPEAT: {
            let e7 = this.subs[0];
            switch (e7.op > n6.Op.CAPTURE || e7.op === n6.Op.LITERAL && e7.runes.length > 1 ? t6 += `(?:${e7.appendTo()})` : t6 += e7.appendTo(), this.op) {
              case n6.Op.STAR:
                t6 += "*";
                break;
              case n6.Op.PLUS:
                t6 += "+";
                break;
              case n6.Op.QUEST:
                t6 += "?";
                break;
              case n6.Op.REPEAT:
                t6 += `{${this.min}`, this.min !== this.max && (t6 += ",", this.max >= 0 && (t6 += this.max)), t6 += "}";
                break;
            }
            (this.flags & g.NON_GREEDY) !== 0 && (t6 += "?");
            break;
          }
          case n6.Op.CONCAT: {
            for (let e7 of this.subs) e7.op === n6.Op.ALTERNATE ? t6 += `(?:${e7.appendTo()})` : t6 += e7.appendTo();
            break;
          }
          case n6.Op.ALTERNATE: {
            let e7 = "";
            for (let s9 of this.subs) t6 += e7, e7 = "|", t6 += s9.appendTo();
            break;
          }
          case n6.Op.LITERAL:
            (this.flags & g.FOLD_CASE) !== 0 && (t6 += "(?i:");
            for (let e7 of this.runes) t6 += O.escapeRune(e7);
            (this.flags & g.FOLD_CASE) !== 0 && (t6 += ")");
            break;
          case n6.Op.ANY_CHAR_NOT_NL:
            t6 += "(?-s:.)";
            break;
          case n6.Op.ANY_CHAR:
            t6 += "(?s:.)";
            break;
          case n6.Op.CAPTURE:
            this.name === null || this.name.length === 0 ? t6 += "(" : t6 += `(?P<${this.name}>`, this.subs[0].op !== n6.Op.EMPTY_MATCH && (t6 += this.subs[0].appendTo()), t6 += ")";
            break;
          case n6.Op.BEGIN_TEXT:
            t6 += "\\A";
            break;
          case n6.Op.END_TEXT:
            (this.flags & g.WAS_DOLLAR) !== 0 ? t6 += "(?-m:$)" : t6 += "\\z";
            break;
          case n6.Op.BEGIN_LINE:
            t6 += "^";
            break;
          case n6.Op.END_LINE:
            t6 += "$";
            break;
          case n6.Op.WORD_BOUNDARY:
            t6 += "\\b";
            break;
          case n6.Op.NO_WORD_BOUNDARY:
            t6 += "\\B";
            break;
          case n6.Op.CHAR_CLASS:
            if (this.runes.length % 2 !== 0) {
              t6 += "[invalid char class]";
              break;
            }
            if (t6 += "[", this.runes.length === 0) t6 += "^\\x00-\\x{10FFFF}";
            else if (this.runes[0] === 0 && this.runes[this.runes.length - 1] === w.MAX_RUNE) {
              t6 += "^";
              for (let e7 = 1; e7 < this.runes.length - 1; e7 += 2) {
                let s9 = this.runes[e7] + 1, i10 = this.runes[e7 + 1] - 1;
                t6 += n6.quoteIfHyphen(s9), t6 += O.escapeRune(s9), s9 !== i10 && (t6 += "-", t6 += n6.quoteIfHyphen(i10), t6 += O.escapeRune(i10));
              }
            } else for (let e7 = 0; e7 < this.runes.length; e7 += 2) {
              let s9 = this.runes[e7], i10 = this.runes[e7 + 1];
              t6 += n6.quoteIfHyphen(s9), t6 += O.escapeRune(s9), s9 !== i10 && (t6 += "-", t6 += n6.quoteIfHyphen(i10), t6 += O.escapeRune(i10));
            }
            t6 += "]";
            break;
          default:
            t6 += this.op;
            break;
        }
        return t6;
      }
      maxCap() {
        let t6 = 0;
        if (this.op === n6.Op.CAPTURE && (t6 = this.cap), this.subs !== null) for (let e7 of this.subs) {
          let s9 = e7.maxCap();
          t6 < s9 && (t6 = s9);
        }
        return t6;
      }
      equals(t6) {
        if (!(t6 !== null && t6 instanceof n6) || this.op !== t6.op) return false;
        switch (this.op) {
          case n6.Op.END_TEXT: {
            if ((this.flags & g.WAS_DOLLAR) !== (t6.flags & g.WAS_DOLLAR)) return false;
            break;
          }
          case n6.Op.LITERAL:
          case n6.Op.CHAR_CLASS: {
            if (this.runes === null && t6.runes === null) break;
            if (this.runes === null || t6.runes === null || this.runes.length !== t6.runes.length) return false;
            for (let e7 = 0; e7 < this.runes.length; e7++) if (this.runes[e7] !== t6.runes[e7]) return false;
            break;
          }
          case n6.Op.ALTERNATE:
          case n6.Op.CONCAT: {
            if (this.subs.length !== t6.subs.length) return false;
            for (let e7 = 0; e7 < this.subs.length; ++e7) if (!this.subs[e7].equals(t6.subs[e7])) return false;
            break;
          }
          case n6.Op.STAR:
          case n6.Op.PLUS:
          case n6.Op.QUEST: {
            if ((this.flags & g.NON_GREEDY) !== (t6.flags & g.NON_GREEDY) || !this.subs[0].equals(t6.subs[0])) return false;
            break;
          }
          case n6.Op.REPEAT: {
            if ((this.flags & g.NON_GREEDY) !== (t6.flags & g.NON_GREEDY) || this.min !== t6.min || this.max !== t6.max || !this.subs[0].equals(t6.subs[0])) return false;
            break;
          }
          case n6.Op.CAPTURE: {
            if (this.cap !== t6.cap || (this.name === null ? t6.name !== null : this.name !== t6.name) || !this.subs[0].equals(t6.subs[0])) return false;
            break;
          }
        }
        return true;
      }
    };
    q = class {
      constructor() {
        this.inst = [], this.start = 0, this.numCap = 2;
      }
      getInst(t6) {
        return this.inst[t6];
      }
      numInst() {
        return this.inst.length;
      }
      addInst(t6) {
        this.inst.push(new E(t6));
      }
      skipNop(t6) {
        let e7 = this.inst[t6];
        for (; e7.op === E.NOP || e7.op === E.CAPTURE; ) e7 = this.inst[t6], t6 = e7.out;
        return e7;
      }
      prefix() {
        let t6 = "", e7 = this.skipNop(this.start);
        if (!E.isRuneOp(e7.op) || e7.runes.length !== 1) return [e7.op === E.MATCH, t6];
        for (; E.isRuneOp(e7.op) && e7.runes.length === 1 && (e7.arg & g.FOLD_CASE) === 0; ) t6 += String.fromCodePoint(e7.runes[0]), e7 = this.skipNop(e7.out);
        return [e7.op === E.MATCH, t6];
      }
      startCond() {
        let t6 = 0, e7 = this.start;
        t: for (; ; ) {
          let s9 = this.inst[e7];
          switch (s9.op) {
            case E.EMPTY_WIDTH:
              t6 |= s9.arg;
              break;
            case E.FAIL:
              return -1;
            case E.CAPTURE:
            case E.NOP:
              break;
            default:
              break t;
          }
          e7 = s9.out;
        }
        return t6;
      }
      next(t6) {
        let e7 = this.inst[t6 >> 1];
        return (t6 & 1) === 0 ? e7.out : e7.arg;
      }
      patch(t6, e7) {
        for (; t6 !== 0; ) {
          let s9 = this.inst[t6 >> 1];
          (t6 & 1) === 0 ? (t6 = s9.out, s9.out = e7) : (t6 = s9.arg, s9.arg = e7);
        }
      }
      append(t6, e7) {
        if (t6 === 0) return e7;
        if (e7 === 0) return t6;
        let s9 = t6;
        for (; ; ) {
          let r8 = this.next(s9);
          if (r8 === 0) break;
          s9 = r8;
        }
        let i10 = this.inst[s9 >> 1];
        return (s9 & 1) === 0 ? i10.out = e7 : i10.arg = e7, t6;
      }
      toString() {
        let t6 = "";
        for (let e7 = 0; e7 < this.inst.length; e7++) {
          let s9 = t6.length;
          t6 += e7, e7 === this.start && (t6 += "*"), t6 += "        ".substring(t6.length - s9), t6 += this.inst[e7], t6 += `
`;
        }
        return t6;
      }
    };
    D = class {
      constructor(t6 = 0, e7 = 0, s9 = false) {
        this.i = t6, this.out = e7, this.nullable = s9;
      }
    };
    K = class n7 {
      static ANY_RUNE_NOT_NL() {
        return [0, u.CODES.get(`
`) - 1, u.CODES.get(`
`) + 1, w.MAX_RUNE];
      }
      static ANY_RUNE() {
        return [0, w.MAX_RUNE];
      }
      static compileRegexp(t6) {
        let e7 = new n7(), s9 = e7.compile(t6);
        return e7.prog.patch(s9.out, e7.newInst(E.MATCH).i), e7.prog.start = s9.i, e7.prog;
      }
      constructor() {
        this.prog = new q(), this.newInst(E.FAIL);
      }
      newInst(t6) {
        return this.prog.addInst(t6), new D(this.prog.numInst() - 1, 0, true);
      }
      nop() {
        let t6 = this.newInst(E.NOP);
        return t6.out = t6.i << 1, t6;
      }
      fail() {
        return new D();
      }
      cap(t6) {
        let e7 = this.newInst(E.CAPTURE);
        return e7.out = e7.i << 1, this.prog.getInst(e7.i).arg = t6, this.prog.numCap < t6 + 1 && (this.prog.numCap = t6 + 1), e7;
      }
      cat(t6, e7) {
        return t6.i === 0 || e7.i === 0 ? this.fail() : (this.prog.patch(t6.out, e7.i), new D(t6.i, e7.out, t6.nullable && e7.nullable));
      }
      alt(t6, e7) {
        if (t6.i === 0) return e7;
        if (e7.i === 0) return t6;
        let s9 = this.newInst(E.ALT), i10 = this.prog.getInst(s9.i);
        return i10.out = t6.i, i10.arg = e7.i, s9.out = this.prog.append(t6.out, e7.out), s9.nullable = t6.nullable || e7.nullable, s9;
      }
      loop(t6, e7) {
        let s9 = this.newInst(E.ALT), i10 = this.prog.getInst(s9.i);
        return e7 ? (i10.arg = t6.i, s9.out = s9.i << 1) : (i10.out = t6.i, s9.out = s9.i << 1 | 1), this.prog.patch(t6.out, s9.i), s9;
      }
      quest(t6, e7) {
        let s9 = this.newInst(E.ALT), i10 = this.prog.getInst(s9.i);
        return e7 ? (i10.arg = t6.i, s9.out = s9.i << 1) : (i10.out = t6.i, s9.out = s9.i << 1 | 1), s9.out = this.prog.append(s9.out, t6.out), s9;
      }
      star(t6, e7) {
        return t6.nullable ? this.quest(this.plus(t6, e7), e7) : this.loop(t6, e7);
      }
      plus(t6, e7) {
        return new D(t6.i, this.loop(t6, e7).out, t6.nullable);
      }
      empty(t6) {
        let e7 = this.newInst(E.EMPTY_WIDTH);
        return this.prog.getInst(e7.i).arg = t6, e7.out = e7.i << 1, e7;
      }
      rune(t6, e7) {
        let s9 = this.newInst(E.RUNE);
        s9.nullable = false;
        let i10 = this.prog.getInst(s9.i);
        return i10.runes = t6, e7 &= g.FOLD_CASE, (t6.length !== 1 || w.simpleFold(t6[0]) === t6[0]) && (e7 &= -2), i10.arg = e7, s9.out = s9.i << 1, (e7 & g.FOLD_CASE) === 0 && t6.length === 1 || t6.length === 2 && t6[0] === t6[1] ? i10.op = E.RUNE1 : t6.length === 2 && t6[0] === 0 && t6[1] === w.MAX_RUNE ? i10.op = E.RUNE_ANY : t6.length === 4 && t6[0] === 0 && t6[1] === u.CODES.get(`
`) - 1 && t6[2] === u.CODES.get(`
`) + 1 && t6[3] === w.MAX_RUNE && (i10.op = E.RUNE_ANY_NOT_NL), s9;
      }
      compile(t6) {
        switch (t6.op) {
          case c.Op.NO_MATCH:
            return this.fail();
          case c.Op.EMPTY_MATCH:
            return this.nop();
          case c.Op.LITERAL:
            if (t6.runes.length === 0) return this.nop();
            {
              let e7 = null;
              for (let s9 of t6.runes) {
                let i10 = this.rune([s9], t6.flags);
                e7 = e7 === null ? i10 : this.cat(e7, i10);
              }
              return e7;
            }
          case c.Op.CHAR_CLASS:
            return this.rune(t6.runes, t6.flags);
          case c.Op.ANY_CHAR_NOT_NL:
            return this.rune(n7.ANY_RUNE_NOT_NL(), 0);
          case c.Op.ANY_CHAR:
            return this.rune(n7.ANY_RUNE(), 0);
          case c.Op.BEGIN_LINE:
            return this.empty(O.EMPTY_BEGIN_LINE);
          case c.Op.END_LINE:
            return this.empty(O.EMPTY_END_LINE);
          case c.Op.BEGIN_TEXT:
            return this.empty(O.EMPTY_BEGIN_TEXT);
          case c.Op.END_TEXT:
            return this.empty(O.EMPTY_END_TEXT);
          case c.Op.WORD_BOUNDARY:
            return this.empty(O.EMPTY_WORD_BOUNDARY);
          case c.Op.NO_WORD_BOUNDARY:
            return this.empty(O.EMPTY_NO_WORD_BOUNDARY);
          case c.Op.CAPTURE: {
            let e7 = this.cap(t6.cap << 1), s9 = this.compile(t6.subs[0]), i10 = this.cap(t6.cap << 1 | 1);
            return this.cat(this.cat(e7, s9), i10);
          }
          case c.Op.STAR:
            return this.star(this.compile(t6.subs[0]), (t6.flags & g.NON_GREEDY) !== 0);
          case c.Op.PLUS:
            return this.plus(this.compile(t6.subs[0]), (t6.flags & g.NON_GREEDY) !== 0);
          case c.Op.QUEST:
            return this.quest(this.compile(t6.subs[0]), (t6.flags & g.NON_GREEDY) !== 0);
          case c.Op.CONCAT: {
            if (t6.subs.length === 0) return this.nop();
            {
              let e7 = null;
              for (let s9 of t6.subs) {
                let i10 = this.compile(s9);
                e7 = e7 === null ? i10 : this.cat(e7, i10);
              }
              return e7;
            }
          }
          case c.Op.ALTERNATE: {
            if (t6.subs.length === 0) return this.nop();
            {
              let e7 = null;
              for (let s9 of t6.subs) {
                let i10 = this.compile(s9);
                e7 = e7 === null ? i10 : this.alt(e7, i10);
              }
              return e7;
            }
          }
          default:
            throw new v("regexp: unhandled case in compile");
        }
      }
    };
    Z = class n8 {
      static simplify(t6) {
        if (t6 === null) return null;
        switch (t6.op) {
          case c.Op.CAPTURE:
          case c.Op.CONCAT:
          case c.Op.ALTERNATE: {
            let e7 = t6;
            for (let s9 = 0; s9 < t6.subs.length; s9++) {
              let i10 = t6.subs[s9], r8 = n8.simplify(i10);
              e7 === t6 && r8 !== i10 && (e7 = c.fromRegexp(t6), e7.runes = [], e7.subs = t6.subs.slice(0, t6.subs.length)), e7 !== t6 && (e7.subs[s9] = r8);
            }
            return e7;
          }
          case c.Op.STAR:
          case c.Op.PLUS:
          case c.Op.QUEST: {
            let e7 = n8.simplify(t6.subs[0]);
            return n8.simplify1(t6.op, t6.flags, e7, t6);
          }
          case c.Op.REPEAT: {
            if (t6.min === 0 && t6.max === 0) return new c(c.Op.EMPTY_MATCH);
            let e7 = n8.simplify(t6.subs[0]);
            if (t6.max === -1) {
              if (t6.min === 0) return n8.simplify1(c.Op.STAR, t6.flags, e7, null);
              if (t6.min === 1) return n8.simplify1(c.Op.PLUS, t6.flags, e7, null);
              let i10 = new c(c.Op.CONCAT), r8 = [];
              for (let o9 = 0; o9 < t6.min - 1; o9++) r8.push(e7);
              return r8.push(n8.simplify1(c.Op.PLUS, t6.flags, e7, null)), i10.subs = r8.slice(0), i10;
            }
            if (t6.min === 1 && t6.max === 1) return e7;
            let s9 = null;
            if (t6.min > 0) {
              s9 = [];
              for (let i10 = 0; i10 < t6.min; i10++) s9.push(e7);
            }
            if (t6.max > t6.min) {
              let i10 = n8.simplify1(c.Op.QUEST, t6.flags, e7, null);
              for (let r8 = t6.min + 1; r8 < t6.max; r8++) {
                let o9 = new c(c.Op.CONCAT);
                o9.subs = [e7, i10], i10 = n8.simplify1(c.Op.QUEST, t6.flags, o9, null);
              }
              if (s9 === null) return i10;
              s9.push(i10);
            }
            if (s9 !== null) {
              let i10 = new c(c.Op.CONCAT);
              return i10.subs = s9.slice(0), i10;
            }
            return new c(c.Op.NO_MATCH);
          }
        }
        return t6;
      }
      static simplify1(t6, e7, s9, i10) {
        return s9.op === c.Op.EMPTY_MATCH || t6 === s9.op && (e7 & g.NON_GREEDY) === (s9.flags & g.NON_GREEDY) ? s9 : (i10 !== null && i10.op === t6 && (i10.flags & g.NON_GREEDY) === (e7 & g.NON_GREEDY) && s9 === i10.subs[0] || (i10 = new c(t6), i10.flags = e7, i10.subs = [s9]), i10);
      }
    };
    d = class {
      constructor(t6, e7) {
        this.sign = t6, this.cls = e7;
      }
    };
    n1 = [48, 57];
    r1 = [9, 10, 12, 13, 32, 32];
    a1 = [48, 57, 65, 90, 95, 95, 97, 122];
    o1 = /* @__PURE__ */ new Map([["\\d", new d(1, n1)], ["\\D", new d(-1, n1)], ["\\s", new d(1, r1)], ["\\S", new d(-1, r1)], ["\\w", new d(1, a1)], ["\\W", new d(-1, a1)]]);
    l1 = [48, 57, 65, 90, 97, 122];
    h1 = [65, 90, 97, 122];
    u1 = [0, 127];
    c1 = [9, 9, 32, 32];
    p1 = [0, 31, 127, 127];
    f1 = [48, 57];
    g1 = [33, 126];
    A1 = [97, 122];
    w1 = [32, 126];
    E1 = [33, 47, 58, 64, 91, 96, 123, 126];
    d1 = [9, 13, 32, 32];
    O1 = [65, 90];
    C1 = [48, 57, 65, 90, 95, 95, 97, 122];
    m1 = [48, 57, 65, 70, 97, 102];
    S1 = /* @__PURE__ */ new Map([["[:alnum:]", new d(1, l1)], ["[:^alnum:]", new d(-1, l1)], ["[:alpha:]", new d(1, h1)], ["[:^alpha:]", new d(-1, h1)], ["[:ascii:]", new d(1, u1)], ["[:^ascii:]", new d(-1, u1)], ["[:blank:]", new d(1, c1)], ["[:^blank:]", new d(-1, c1)], ["[:cntrl:]", new d(1, p1)], ["[:^cntrl:]", new d(-1, p1)], ["[:digit:]", new d(1, f1)], ["[:^digit:]", new d(-1, f1)], ["[:graph:]", new d(1, g1)], ["[:^graph:]", new d(-1, g1)], ["[:lower:]", new d(1, A1)], ["[:^lower:]", new d(-1, A1)], ["[:print:]", new d(1, w1)], ["[:^print:]", new d(-1, w1)], ["[:punct:]", new d(1, E1)], ["[:^punct:]", new d(-1, E1)], ["[:space:]", new d(1, d1)], ["[:^space:]", new d(-1, d1)], ["[:upper:]", new d(1, O1)], ["[:^upper:]", new d(-1, O1)], ["[:word:]", new d(1, C1)], ["[:^word:]", new d(-1, C1)], ["[:xdigit:]", new d(1, m1)], ["[:^xdigit:]", new d(-1, m1)]]);
    x = class n9 {
      static charClassToString(t6, e7) {
        let s9 = "[";
        for (let i10 = 0; i10 < e7; i10 += 2) {
          i10 > 0 && (s9 += " ");
          let r8 = t6[i10], o9 = t6[i10 + 1];
          r8 === o9 ? s9 += `0x${r8.toString(16)}` : s9 += `0x${r8.toString(16)}-0x${o9.toString(16)}`;
        }
        return s9 += "]", s9;
      }
      static cmp(t6, e7, s9, i10) {
        let r8 = t6[e7] - s9;
        return r8 !== 0 ? r8 : i10 - t6[e7 + 1];
      }
      static qsortIntPair(t6, e7, s9) {
        let i10 = ((e7 + s9) / 2 | 0) & -2, r8 = t6[i10], o9 = t6[i10 + 1], l8 = e7, h17 = s9;
        for (; l8 <= h17; ) {
          for (; l8 < s9 && n9.cmp(t6, l8, r8, o9) < 0; ) l8 += 2;
          for (; h17 > e7 && n9.cmp(t6, h17, r8, o9) > 0; ) h17 -= 2;
          if (l8 <= h17) {
            if (l8 !== h17) {
              let p17 = t6[l8];
              t6[l8] = t6[h17], t6[h17] = p17, p17 = t6[l8 + 1], t6[l8 + 1] = t6[h17 + 1], t6[h17 + 1] = p17;
            }
            l8 += 2, h17 -= 2;
          }
        }
        e7 < h17 && n9.qsortIntPair(t6, e7, h17), l8 < s9 && n9.qsortIntPair(t6, l8, s9);
      }
      constructor(t6 = O.emptyInts()) {
        this.r = t6, this.len = t6.length;
      }
      toArray() {
        return this.len === this.r.length ? this.r : this.r.slice(0, this.len);
      }
      cleanClass() {
        if (this.len < 4) return this;
        n9.qsortIntPair(this.r, 0, this.len - 2);
        let t6 = 2;
        for (let e7 = 2; e7 < this.len; e7 += 2) {
          let s9 = this.r[e7], i10 = this.r[e7 + 1];
          if (s9 <= this.r[t6 - 1] + 1) {
            i10 > this.r[t6 - 1] && (this.r[t6 - 1] = i10);
            continue;
          }
          this.r[t6] = s9, this.r[t6 + 1] = i10, t6 += 2;
        }
        return this.len = t6, this;
      }
      appendLiteral(t6, e7) {
        return (e7 & g.FOLD_CASE) !== 0 ? this.appendFoldedRange(t6, t6) : this.appendRange(t6, t6);
      }
      appendRange(t6, e7) {
        if (this.len > 0) {
          for (let s9 = 2; s9 <= 4; s9 += 2) if (this.len >= s9) {
            let i10 = this.r[this.len - s9], r8 = this.r[this.len - s9 + 1];
            if (t6 <= r8 + 1 && i10 <= e7 + 1) return t6 < i10 && (this.r[this.len - s9] = t6), e7 > r8 && (this.r[this.len - s9 + 1] = e7), this;
          }
        }
        return this.r[this.len++] = t6, this.r[this.len++] = e7, this;
      }
      appendFoldedRange(t6, e7) {
        if (t6 <= w.MIN_FOLD && e7 >= w.MAX_FOLD) return this.appendRange(t6, e7);
        if (e7 < w.MIN_FOLD || t6 > w.MAX_FOLD) return this.appendRange(t6, e7);
        t6 < w.MIN_FOLD && (this.appendRange(t6, w.MIN_FOLD - 1), t6 = w.MIN_FOLD), e7 > w.MAX_FOLD && (this.appendRange(w.MAX_FOLD + 1, e7), e7 = w.MAX_FOLD);
        for (let s9 = t6; s9 <= e7; s9++) {
          this.appendRange(s9, s9);
          for (let i10 = w.simpleFold(s9); i10 !== s9; i10 = w.simpleFold(i10)) this.appendRange(i10, i10);
        }
        return this;
      }
      appendClass(t6) {
        for (let e7 = 0; e7 < t6.length; e7 += 2) this.appendRange(t6[e7], t6[e7 + 1]);
        return this;
      }
      appendFoldedClass(t6) {
        for (let e7 = 0; e7 < t6.length; e7 += 2) this.appendFoldedRange(t6[e7], t6[e7 + 1]);
        return this;
      }
      appendNegatedClass(t6) {
        let e7 = 0;
        for (let s9 = 0; s9 < t6.length; s9 += 2) {
          let i10 = t6[s9], r8 = t6[s9 + 1];
          e7 <= i10 - 1 && this.appendRange(e7, i10 - 1), e7 = r8 + 1;
        }
        return e7 <= w.MAX_RUNE && this.appendRange(e7, w.MAX_RUNE), this;
      }
      appendTable(t6) {
        for (let e7 = 0; e7 < t6.length; ++e7) {
          let s9 = t6.getLo(e7), i10 = t6.getHi(e7), r8 = t6.getStride(e7);
          if (r8 === 1) {
            this.appendRange(s9, i10);
            continue;
          }
          for (let o9 = s9; o9 <= i10; o9 += r8) this.appendRange(o9, o9);
        }
        return this;
      }
      appendNegatedTable(t6) {
        let e7 = 0;
        for (let s9 = 0; s9 < t6.length; ++s9) {
          let i10 = t6.getLo(s9), r8 = t6.getHi(s9), o9 = t6.getStride(s9);
          if (o9 === 1) {
            e7 <= i10 - 1 && this.appendRange(e7, i10 - 1), e7 = r8 + 1;
            continue;
          }
          for (let l8 = i10; l8 <= r8; l8 += o9) e7 <= l8 - 1 && this.appendRange(e7, l8 - 1), e7 = l8 + 1;
        }
        return e7 <= w.MAX_RUNE && this.appendRange(e7, w.MAX_RUNE), this;
      }
      appendTableWithSign(t6, e7) {
        return e7 < 0 ? this.appendNegatedTable(t6) : this.appendTable(t6);
      }
      negateClass() {
        let t6 = 0, e7 = 0;
        for (let s9 = 0; s9 < this.len; s9 += 2) {
          let i10 = this.r[s9], r8 = this.r[s9 + 1];
          t6 <= i10 - 1 && (this.r[e7] = t6, this.r[e7 + 1] = i10 - 1, e7 += 2), t6 = r8 + 1;
        }
        return this.len = e7, t6 <= w.MAX_RUNE && (this.r[this.len++] = t6, this.r[this.len++] = w.MAX_RUNE), this;
      }
      appendClassWithSign(t6, e7) {
        return e7 < 0 ? this.appendNegatedClass(t6) : this.appendClass(t6);
      }
      appendGroup(t6, e7) {
        let s9 = t6.cls;
        return e7 && (s9 = new n9().appendFoldedClass(s9).cleanClass().toArray()), this.appendClassWithSign(s9, t6.sign);
      }
      toString() {
        return n9.charClassToString(this.r, this.len);
      }
    };
    H = class n10 {
      static of(t6, e7) {
        return new n10(t6, e7);
      }
      constructor(t6, e7) {
        this.first = t6, this.second = e7;
      }
    };
    Q = class {
      constructor(t6) {
        this.str = t6, this.position = 0;
      }
      pos() {
        return this.position;
      }
      rewindTo(t6) {
        this.position = t6;
      }
      more() {
        return this.position < this.str.length;
      }
      peek() {
        return this.str.codePointAt(this.position);
      }
      skip(t6) {
        this.position += t6;
      }
      skipString(t6) {
        this.position += t6.length;
      }
      pop() {
        let t6 = this.str.codePointAt(this.position);
        return this.position += O.charCount(t6), t6;
      }
      lookingAt(t6) {
        return this.rest().startsWith(t6);
      }
      rest() {
        return this.str.substring(this.position);
      }
      from(t6) {
        return this.str.substring(t6, this.position);
      }
      toString() {
        return this.rest();
      }
    };
    J = class n11 {
      static ERR_INTERNAL_ERROR = "regexp/syntax: internal error";
      static ERR_INVALID_CHAR_RANGE = "invalid character class range";
      static ERR_INVALID_ESCAPE = "invalid escape sequence";
      static ERR_INVALID_NAMED_CAPTURE = "invalid named capture";
      static ERR_INVALID_PERL_OP = "invalid or unsupported Perl syntax";
      static ERR_INVALID_REPEAT_OP = "invalid nested repetition operator";
      static ERR_INVALID_REPEAT_SIZE = "invalid repeat count";
      static ERR_MISSING_BRACKET = "missing closing ]";
      static ERR_MISSING_PAREN = "missing closing )";
      static ERR_MISSING_REPEAT_ARGUMENT = "missing argument to repetition operator";
      static ERR_TRAILING_BACKSLASH = "trailing backslash at end of expression";
      static ERR_DUPLICATE_NAMED_CAPTURE = "duplicate capture group name";
      static ERR_UNEXPECTED_PAREN = "unexpected )";
      static ERR_NESTING_DEPTH = "expression nests too deeply";
      static ERR_LARGE = "expression too large";
      static MAX_HEIGHT = 1e3;
      static MAX_SIZE = 3355443;
      static MAX_RUNES = 33554432;
      static ANY_TABLE = new a(new Uint32Array([0, w.MAX_RUNE, 1]));
      static unicodeTable(t6) {
        return t6 === "Any" ? H.of(n11.ANY_TABLE, n11.ANY_TABLE) : b.CATEGORIES.has(t6) ? H.of(b.CATEGORIES.get(t6), b.FOLD_CATEGORIES.get(t6)) : b.SCRIPTS.has(t6) ? H.of(b.SCRIPTS.get(t6), b.FOLD_SCRIPT.get(t6)) : null;
      }
      static minFoldRune(t6) {
        if (t6 < w.MIN_FOLD || t6 > w.MAX_FOLD) return t6;
        let e7 = t6, s9 = t6;
        for (t6 = w.simpleFold(t6); t6 !== s9; t6 = w.simpleFold(t6)) e7 > t6 && (e7 = t6);
        return e7;
      }
      static leadingRegexp(t6) {
        if (t6.op === c.Op.EMPTY_MATCH) return null;
        if (t6.op === c.Op.CONCAT && t6.subs.length > 0) {
          let e7 = t6.subs[0];
          return e7.op === c.Op.EMPTY_MATCH ? null : e7;
        }
        return t6;
      }
      static literalRegexp(t6, e7) {
        let s9 = new c(c.Op.LITERAL);
        return s9.flags = e7, s9.runes = O.stringToRunes(t6), s9;
      }
      static parse(t6, e7) {
        return new n11(t6, e7).parseInternal();
      }
      static parseRepeat(t6) {
        let e7 = t6.pos();
        if (!t6.more() || !t6.lookingAt("{")) return -1;
        t6.skip(1);
        let s9 = n11.parseInt(t6);
        if (s9 === -1 || !t6.more()) return -1;
        let i10;
        if (!t6.lookingAt(",")) i10 = s9;
        else {
          if (t6.skip(1), !t6.more()) return -1;
          if (t6.lookingAt("}")) i10 = -1;
          else if ((i10 = n11.parseInt(t6)) === -1) return -1;
        }
        if (!t6.more() || !t6.lookingAt("}")) return -1;
        if (t6.skip(1), s9 < 0 || s9 > 1e3 || i10 === -2 || i10 > 1e3 || i10 >= 0 && s9 > i10) throw new m(n11.ERR_INVALID_REPEAT_SIZE, t6.from(e7));
        return s9 << 16 | i10 & w.MAX_BMP;
      }
      static isValidCaptureName(t6) {
        if (t6.length === 0) return false;
        for (let e7 = 0; e7 < t6.length; e7++) {
          let s9 = t6.codePointAt(e7);
          if (s9 !== u.CODES.get("_") && !O.isalnum(s9)) return false;
        }
        return true;
      }
      static parseInt(t6) {
        let e7 = t6.pos();
        for (; t6.more() && t6.peek() >= u.CODES.get("0") && t6.peek() <= u.CODES.get("9"); ) t6.skip(1);
        let s9 = t6.from(e7);
        return s9.length === 0 || s9.length > 1 && s9.codePointAt(0) === u.CODES.get("0") ? -1 : s9.length > 8 ? -2 : parseFloat(s9, 10);
      }
      static isCharClass(t6) {
        return t6.op === c.Op.LITERAL && t6.runes.length === 1 || t6.op === c.Op.CHAR_CLASS || t6.op === c.Op.ANY_CHAR_NOT_NL || t6.op === c.Op.ANY_CHAR;
      }
      static matchRune(t6, e7) {
        switch (t6.op) {
          case c.Op.LITERAL:
            return t6.runes.length === 1 && t6.runes[0] === e7;
          case c.Op.CHAR_CLASS:
            for (let s9 = 0; s9 < t6.runes.length; s9 += 2) if (t6.runes[s9] <= e7 && e7 <= t6.runes[s9 + 1]) return true;
            return false;
          case c.Op.ANY_CHAR_NOT_NL:
            return e7 !== u.CODES.get(`
`);
          case c.Op.ANY_CHAR:
            return true;
        }
        return false;
      }
      static mergeCharClass(t6, e7) {
        switch (t6.op) {
          case c.Op.ANY_CHAR:
            break;
          case c.Op.ANY_CHAR_NOT_NL:
            n11.matchRune(e7, u.CODES.get(`
`)) && (t6.op = c.Op.ANY_CHAR);
            break;
          case c.Op.CHAR_CLASS:
            e7.op === c.Op.LITERAL ? t6.runes = new x(t6.runes).appendLiteral(e7.runes[0], e7.flags).toArray() : t6.runes = new x(t6.runes).appendClass(e7.runes).toArray();
            break;
          case c.Op.LITERAL:
            if (e7.runes[0] === t6.runes[0] && e7.flags === t6.flags) break;
            t6.op = c.Op.CHAR_CLASS, t6.runes = new x().appendLiteral(t6.runes[0], t6.flags).appendLiteral(e7.runes[0], e7.flags).toArray();
            break;
        }
      }
      static parseEscape(t6) {
        let e7 = t6.pos();
        if (t6.skip(1), !t6.more()) throw new m(n11.ERR_TRAILING_BACKSLASH);
        let s9 = t6.pop();
        t: switch (s9) {
          case u.CODES.get("1"):
          case u.CODES.get("2"):
          case u.CODES.get("3"):
          case u.CODES.get("4"):
          case u.CODES.get("5"):
          case u.CODES.get("6"):
          case u.CODES.get("7"):
            if (!t6.more() || t6.peek() < u.CODES.get("0") || t6.peek() > u.CODES.get("7")) break;
          case u.CODES.get("0"): {
            let i10 = s9 - u.CODES.get("0");
            for (let r8 = 1; r8 < 3 && !(!t6.more() || t6.peek() < u.CODES.get("0") || t6.peek() > u.CODES.get("7")); r8++) i10 = i10 * 8 + t6.peek() - u.CODES.get("0"), t6.skip(1);
            return i10;
          }
          case u.CODES.get("x"): {
            if (!t6.more()) break;
            if (s9 = t6.pop(), s9 === u.CODES.get("{")) {
              let o9 = 0, l8 = 0;
              for (; ; ) {
                if (!t6.more()) break t;
                if (s9 = t6.pop(), s9 === u.CODES.get("}")) break;
                let h17 = O.unhex(s9);
                if (h17 < 0 || (l8 = l8 * 16 + h17, l8 > w.MAX_RUNE)) break t;
                o9++;
              }
              if (o9 === 0) break t;
              return l8;
            }
            let i10 = O.unhex(s9);
            if (!t6.more()) break;
            s9 = t6.pop();
            let r8 = O.unhex(s9);
            if (i10 < 0 || r8 < 0) break;
            return i10 * 16 + r8;
          }
          case u.CODES.get("a"):
            return u.CODES.get("\x07");
          case u.CODES.get("f"):
            return u.CODES.get("\f");
          case u.CODES.get("n"):
            return u.CODES.get(`
`);
          case u.CODES.get("r"):
            return u.CODES.get("\r");
          case u.CODES.get("t"):
            return u.CODES.get("	");
          case u.CODES.get("v"):
            return u.CODES.get("\v");
          default:
            if (s9 <= w.MAX_ASCII && !O.isalnum(s9)) return s9;
            break;
        }
        throw new m(n11.ERR_INVALID_ESCAPE, t6.from(e7));
      }
      static parseClassChar(t6, e7) {
        if (!t6.more()) throw new m(n11.ERR_MISSING_BRACKET, t6.from(e7));
        return t6.lookingAt("\\") ? n11.parseEscape(t6) : t6.pop();
      }
      static concatRunes(t6, e7) {
        return [...t6, ...e7];
      }
      constructor(t6, e7 = 0) {
        this.wholeRegexp = t6, this.flags = e7, this.numCap = 0, this.namedGroups = {}, this.stack = [], this.free = null, this.numRegexp = 0, this.numRunes = 0, this.repeats = 0, this.height = null, this.size = null;
      }
      newRegexp(t6) {
        let e7 = this.free;
        return e7 !== null && e7.subs !== null && e7.subs.length > 0 ? (this.free = e7.subs[0], e7.reinit(), e7.op = t6) : (e7 = new c(t6), this.numRegexp += 1), e7;
      }
      reuse(t6) {
        this.height !== null && Object.prototype.hasOwnProperty.call(this.height, t6) && delete this.height[t6], t6.subs !== null && t6.subs.length > 0 && (t6.subs[0] = this.free), this.free = t6;
      }
      checkLimits(t6) {
        if (this.numRunes > n11.MAX_RUNES) throw new m(n11.ERR_LARGE);
        this.checkSize(t6), this.checkHeight(t6);
      }
      checkSize(t6) {
        if (this.size === null) {
          if (this.repeats === 0 && (this.repeats = 1), t6.op === c.Op.REPEAT) {
            let e7 = t6.max;
            e7 === -1 && (e7 = t6.min), e7 <= 0 && (e7 = 1), e7 > n11.MAX_SIZE / this.repeats ? this.repeats = n11.MAX_SIZE : this.repeats *= e7;
          }
          if (this.numRegexp < n11.MAX_SIZE / this.repeats) return;
          this.size = {};
          for (let e7 of this.stack) this.checkSize(e7);
        }
        if (this.calcSize(t6, true) > n11.MAX_SIZE) throw new m(n11.ERR_LARGE);
      }
      calcSize(t6, e7 = false) {
        if (!e7 && Object.prototype.hasOwnProperty.call(this.size, t6)) return this.size[t6];
        let s9 = 0;
        switch (t6.op) {
          case c.Op.LITERAL: {
            s9 = t6.runes.length;
            break;
          }
          case c.Op.CAPTURE:
          case c.Op.STAR: {
            s9 = 2 + this.calcSize(t6.subs[0]);
            break;
          }
          case c.Op.PLUS:
          case c.Op.QUEST: {
            s9 = 1 + this.calcSize(t6.subs[0]);
            break;
          }
          case c.Op.CONCAT: {
            for (let i10 of t6.subs) s9 = s9 + this.calcSize(i10);
            break;
          }
          case c.Op.ALTERNATE: {
            for (let i10 of t6.subs) s9 = s9 + this.calcSize(i10);
            t6.subs.length > 1 && (s9 = s9 + t6.subs.length - 1);
            break;
          }
          case c.Op.REPEAT: {
            let i10 = this.calcSize(t6.subs[0]);
            if (t6.max === -1) {
              t6.min === 0 ? s9 = 2 + i10 : s9 = 1 + t6.min * i10;
              break;
            }
            s9 = t6.max * i10 + (t6.max - t6.min);
            break;
          }
        }
        return s9 = Math.max(1, s9), this.size[t6] = s9, s9;
      }
      checkHeight(t6) {
        if (!(this.numRegexp < n11.MAX_HEIGHT)) {
          if (this.height === null) {
            this.height = {};
            for (let e7 of this.stack) this.checkHeight(e7);
          }
          if (this.calcHeight(t6, true) > n11.MAX_HEIGHT) throw new m(n11.ERR_NESTING_DEPTH);
        }
      }
      calcHeight(t6, e7 = false) {
        if (!e7 && Object.prototype.hasOwnProperty.call(this.height, t6)) return this.height[t6];
        let s9 = 1;
        for (let i10 of t6.subs) {
          let r8 = this.calcHeight(i10);
          s9 < 1 + r8 && (s9 = 1 + r8);
        }
        return this.height[t6] = s9, s9;
      }
      pop() {
        return this.stack.pop();
      }
      popToPseudo() {
        let t6 = this.stack.length, e7 = t6;
        for (; e7 > 0 && !c.isPseudoOp(this.stack[e7 - 1].op); ) e7--;
        let s9 = this.stack.slice(e7, t6);
        return this.stack = this.stack.slice(0, e7), s9;
      }
      push(t6) {
        if (this.numRunes += t6.runes.length, t6.op === c.Op.CHAR_CLASS && t6.runes.length === 2 && t6.runes[0] === t6.runes[1]) {
          if (this.maybeConcat(t6.runes[0], this.flags & -2)) return null;
          t6.op = c.Op.LITERAL, t6.runes = [t6.runes[0]], t6.flags = this.flags & -2;
        } else if (t6.op === c.Op.CHAR_CLASS && t6.runes.length === 4 && t6.runes[0] === t6.runes[1] && t6.runes[2] === t6.runes[3] && w.simpleFold(t6.runes[0]) === t6.runes[2] && w.simpleFold(t6.runes[2]) === t6.runes[0] || t6.op === c.Op.CHAR_CLASS && t6.runes.length === 2 && t6.runes[0] + 1 === t6.runes[1] && w.simpleFold(t6.runes[0]) === t6.runes[1] && w.simpleFold(t6.runes[1]) === t6.runes[0]) {
          if (this.maybeConcat(t6.runes[0], this.flags | g.FOLD_CASE)) return null;
          t6.op = c.Op.LITERAL, t6.runes = [t6.runes[0]], t6.flags = this.flags | g.FOLD_CASE;
        } else this.maybeConcat(-1, 0);
        return this.stack.push(t6), this.checkLimits(t6), t6;
      }
      maybeConcat(t6, e7) {
        let s9 = this.stack.length;
        if (s9 < 2) return false;
        let i10 = this.stack[s9 - 1], r8 = this.stack[s9 - 2];
        return i10.op !== c.Op.LITERAL || r8.op !== c.Op.LITERAL || (i10.flags & g.FOLD_CASE) !== (r8.flags & g.FOLD_CASE) ? false : (r8.runes = n11.concatRunes(r8.runes, i10.runes), t6 >= 0 ? (i10.runes = [t6], i10.flags = e7, true) : (this.pop(), this.reuse(i10), false));
      }
      newLiteral(t6, e7) {
        let s9 = this.newRegexp(c.Op.LITERAL);
        return s9.flags = e7, (e7 & g.FOLD_CASE) !== 0 && (t6 = n11.minFoldRune(t6)), s9.runes = [t6], s9;
      }
      literal(t6) {
        this.push(this.newLiteral(t6, this.flags));
      }
      op(t6) {
        let e7 = this.newRegexp(t6);
        return e7.flags = this.flags, this.push(e7);
      }
      repeat(t6, e7, s9, i10, r8, o9) {
        let l8 = this.flags;
        if ((l8 & g.PERL_X) !== 0 && (r8.more() && r8.lookingAt("?") && (r8.skip(1), l8 ^= g.NON_GREEDY), o9 !== -1)) throw new m(n11.ERR_INVALID_REPEAT_OP, r8.from(o9));
        let h17 = this.stack.length;
        if (h17 === 0) throw new m(n11.ERR_MISSING_REPEAT_ARGUMENT, r8.from(i10));
        let p17 = this.stack[h17 - 1];
        if (c.isPseudoOp(p17.op)) throw new m(n11.ERR_MISSING_REPEAT_ARGUMENT, r8.from(i10));
        let f11 = this.newRegexp(t6);
        if (f11.min = e7, f11.max = s9, f11.flags = l8, f11.subs = [p17], this.stack[h17 - 1] = f11, this.checkLimits(f11), t6 === c.Op.REPEAT && (e7 >= 2 || s9 >= 2) && !this.repeatIsValid(f11, 1e3)) throw new m(n11.ERR_INVALID_REPEAT_SIZE, r8.from(i10));
      }
      repeatIsValid(t6, e7) {
        if (t6.op === c.Op.REPEAT) {
          let s9 = t6.max;
          if (s9 === 0) return true;
          if (s9 < 0 && (s9 = t6.min), s9 > e7) return false;
          s9 > 0 && (e7 = Math.trunc(e7 / s9));
        }
        for (let s9 of t6.subs) if (!this.repeatIsValid(s9, e7)) return false;
        return true;
      }
      concat() {
        this.maybeConcat(-1, 0);
        let t6 = this.popToPseudo();
        return t6.length === 0 ? this.push(this.newRegexp(c.Op.EMPTY_MATCH)) : this.push(this.collapse(t6, c.Op.CONCAT));
      }
      alternate() {
        let t6 = this.popToPseudo();
        return t6.length > 0 && this.cleanAlt(t6[t6.length - 1]), t6.length === 0 ? this.push(this.newRegexp(c.Op.NO_MATCH)) : this.push(this.collapse(t6, c.Op.ALTERNATE));
      }
      cleanAlt(t6) {
        t6.op === c.Op.CHAR_CLASS && (t6.runes = new x(t6.runes).cleanClass().toArray(), t6.runes.length === 2 && t6.runes[0] === 0 && t6.runes[1] === w.MAX_RUNE ? (t6.runes = [], t6.op = c.Op.ANY_CHAR) : t6.runes.length === 4 && t6.runes[0] === 0 && t6.runes[1] === u.CODES.get(`
`) - 1 && t6.runes[2] === u.CODES.get(`
`) + 1 && t6.runes[3] === w.MAX_RUNE && (t6.runes = [], t6.op = c.Op.ANY_CHAR_NOT_NL));
      }
      collapse(t6, e7) {
        if (t6.length === 1) return t6[0];
        let s9 = 0;
        for (let l8 of t6) s9 += l8.op === e7 ? l8.subs.length : 1;
        let i10 = new Array(s9).fill(null), r8 = 0;
        for (let l8 of t6) l8.op === e7 ? (i10.splice(r8, l8.subs.length, ...l8.subs), r8 += l8.subs.length, this.reuse(l8)) : i10[r8++] = l8;
        let o9 = this.newRegexp(e7);
        if (o9.subs = i10, e7 === c.Op.ALTERNATE && (o9.subs = this.factor(o9.subs), o9.subs.length === 1)) {
          let l8 = o9;
          o9 = o9.subs[0], this.reuse(l8);
        }
        return o9;
      }
      factor(t6) {
        if (t6.length < 2) return t6;
        let e7 = 0, s9 = t6.length, i10 = 0, r8 = null, o9 = 0, l8 = 0, h17 = 0;
        for (let f11 = 0; f11 <= s9; f11++) {
          let A14 = null, T10 = 0, C19 = 0;
          if (f11 < s9) {
            let S17 = t6[e7 + f11];
            if (S17.op === c.Op.CONCAT && S17.subs.length > 0 && (S17 = S17.subs[0]), S17.op === c.Op.LITERAL && (A14 = S17.runes, T10 = S17.runes.length, C19 = S17.flags & g.FOLD_CASE), C19 === l8) {
              let R13 = 0;
              for (; R13 < o9 && R13 < T10 && r8[R13] === A14[R13]; ) R13++;
              if (R13 > 0) {
                o9 = R13;
                continue;
              }
            }
          }
          if (f11 !== h17) if (f11 === h17 + 1) t6[i10++] = t6[e7 + h17];
          else {
            let S17 = this.newRegexp(c.Op.LITERAL);
            S17.flags = l8, S17.runes = r8.slice(0, o9);
            for (let k17 = h17; k17 < f11; k17++) t6[e7 + k17] = this.removeLeadingString(t6[e7 + k17], o9), this.checkLimits(t6[e7 + k17]);
            let R13 = this.collapse(t6.slice(e7 + h17, e7 + f11), c.Op.ALTERNATE), G9 = this.newRegexp(c.Op.CONCAT);
            G9.subs = [S17, R13], t6[i10++] = G9;
          }
          h17 = f11, r8 = A14, o9 = T10, l8 = C19;
        }
        s9 = i10, e7 = 0, h17 = 0, i10 = 0;
        let p17 = null;
        for (let f11 = 0; f11 <= s9; f11++) {
          let A14 = null;
          if (!(f11 < s9 && (A14 = n11.leadingRegexp(t6[e7 + f11]), p17 !== null && p17.equals(A14) && (n11.isCharClass(p17) || p17.op === c.Op.REPEAT && p17.min === p17.max && n11.isCharClass(p17.subs[0]))))) {
            if (f11 !== h17) if (f11 === h17 + 1) t6[i10++] = t6[e7 + h17];
            else {
              let T10 = p17;
              for (let R13 = h17; R13 < f11; R13++) {
                let G9 = R13 !== h17;
                t6[e7 + R13] = this.removeLeadingRegexp(t6[e7 + R13], G9), this.checkLimits(t6[e7 + R13]);
              }
              let C19 = this.collapse(t6.slice(e7 + h17, e7 + f11), c.Op.ALTERNATE), S17 = this.newRegexp(c.Op.CONCAT);
              S17.subs = [T10, C19], t6[i10++] = S17;
            }
            h17 = f11, p17 = A14;
          }
        }
        s9 = i10, e7 = 0, h17 = 0, i10 = 0;
        for (let f11 = 0; f11 <= s9; f11++) if (!(f11 < s9 && n11.isCharClass(t6[e7 + f11]))) {
          if (f11 !== h17) if (f11 === h17 + 1) t6[i10++] = t6[e7 + h17];
          else {
            let A14 = h17;
            for (let C19 = h17 + 1; C19 < f11; C19++) {
              let S17 = t6[e7 + A14], R13 = t6[e7 + C19];
              (S17.op < R13.op || S17.op === R13.op && (S17.runes !== null ? S17.runes.length : 0) < (R13.runes !== null ? R13.runes.length : 0)) && (A14 = C19);
            }
            let T10 = t6[e7 + h17];
            t6[e7 + h17] = t6[e7 + A14], t6[e7 + A14] = T10;
            for (let C19 = h17 + 1; C19 < f11; C19++) n11.mergeCharClass(t6[e7 + h17], t6[e7 + C19]), this.reuse(t6[e7 + C19]);
            this.cleanAlt(t6[e7 + h17]), t6[i10++] = t6[e7 + h17];
          }
          f11 < s9 && (t6[i10++] = t6[e7 + f11]), h17 = f11 + 1;
        }
        s9 = i10, e7 = 0, h17 = 0, i10 = 0;
        for (let f11 = 0; f11 < s9; ++f11) f11 + 1 < s9 && t6[e7 + f11].op === c.Op.EMPTY_MATCH && t6[e7 + f11 + 1].op === c.Op.EMPTY_MATCH || (t6[i10++] = t6[e7 + f11]);
        return s9 = i10, e7 = 0, t6.slice(e7, s9);
      }
      removeLeadingString(t6, e7) {
        if (t6.op === c.Op.CONCAT && t6.subs.length > 0) {
          let s9 = this.removeLeadingString(t6.subs[0], e7);
          if (t6.subs[0] = s9, s9.op === c.Op.EMPTY_MATCH) switch (this.reuse(s9), t6.subs.length) {
            case 0:
            case 1:
              t6.op = c.Op.EMPTY_MATCH, t6.subs = null;
              break;
            case 2: {
              let i10 = t6;
              t6 = t6.subs[1], this.reuse(i10);
              break;
            }
            default:
              t6.subs = t6.subs.slice(1, t6.subs.length);
              break;
          }
          return t6;
        }
        return t6.op === c.Op.LITERAL && (t6.runes = t6.runes.slice(e7, t6.runes.length), t6.runes.length === 0 && (t6.op = c.Op.EMPTY_MATCH)), t6;
      }
      removeLeadingRegexp(t6, e7) {
        if (t6.op === c.Op.CONCAT && t6.subs.length > 0) {
          switch (e7 && this.reuse(t6.subs[0]), t6.subs = t6.subs.slice(1, t6.subs.length), t6.subs.length) {
            case 0: {
              t6.op = c.Op.EMPTY_MATCH, t6.subs = c.emptySubs();
              break;
            }
            case 1: {
              let s9 = t6;
              t6 = t6.subs[0], this.reuse(s9);
              break;
            }
          }
          return t6;
        }
        return e7 && this.reuse(t6), this.newRegexp(c.Op.EMPTY_MATCH);
      }
      parseInternal() {
        if ((this.flags & g.LITERAL) !== 0) return n11.literalRegexp(this.wholeRegexp, this.flags);
        let t6 = -1, e7 = -1, s9 = -1, i10 = new Q(this.wholeRegexp);
        for (; i10.more(); ) {
          let o9 = -1;
          t: switch (i10.peek()) {
            case u.CODES.get("("):
              if ((this.flags & g.PERL_X) !== 0 && i10.lookingAt("(?")) {
                this.parsePerlFlags(i10);
                break;
              }
              this.op(c.Op.LEFT_PAREN).cap = ++this.numCap, i10.skip(1);
              break;
            case u.CODES.get("|"):
              this.parseVerticalBar(), i10.skip(1);
              break;
            case u.CODES.get(")"):
              this.parseRightParen(), i10.skip(1);
              break;
            case u.CODES.get("^"):
              (this.flags & g.ONE_LINE) !== 0 ? this.op(c.Op.BEGIN_TEXT) : this.op(c.Op.BEGIN_LINE), i10.skip(1);
              break;
            case u.CODES.get("$"):
              (this.flags & g.ONE_LINE) !== 0 ? this.op(c.Op.END_TEXT).flags |= g.WAS_DOLLAR : this.op(c.Op.END_LINE), i10.skip(1);
              break;
            case u.CODES.get("."):
              (this.flags & g.DOT_NL) !== 0 ? this.op(c.Op.ANY_CHAR) : this.op(c.Op.ANY_CHAR_NOT_NL), i10.skip(1);
              break;
            case u.CODES.get("["):
              this.parseClass(i10);
              break;
            case u.CODES.get("*"):
            case u.CODES.get("+"):
            case u.CODES.get("?"): {
              o9 = i10.pos();
              let l8 = null;
              switch (i10.pop()) {
                case u.CODES.get("*"):
                  l8 = c.Op.STAR;
                  break;
                case u.CODES.get("+"):
                  l8 = c.Op.PLUS;
                  break;
                case u.CODES.get("?"):
                  l8 = c.Op.QUEST;
                  break;
              }
              this.repeat(l8, e7, s9, o9, i10, t6);
              break;
            }
            case u.CODES.get("{"): {
              o9 = i10.pos();
              let l8 = n11.parseRepeat(i10);
              if (l8 < 0) {
                i10.rewindTo(o9), this.literal(i10.pop());
                break;
              }
              e7 = l8 >> 16, s9 = (l8 & w.MAX_BMP) << 16 >> 16, this.repeat(c.Op.REPEAT, e7, s9, o9, i10, t6);
              break;
            }
            case u.CODES.get("\\"): {
              let l8 = i10.pos();
              if (i10.skip(1), (this.flags & g.PERL_X) !== 0 && i10.more()) switch (i10.pop()) {
                case u.CODES.get("A"):
                  this.op(c.Op.BEGIN_TEXT);
                  break t;
                case u.CODES.get("b"):
                  this.op(c.Op.WORD_BOUNDARY);
                  break t;
                case u.CODES.get("B"):
                  this.op(c.Op.NO_WORD_BOUNDARY);
                  break t;
                case u.CODES.get("C"):
                  throw new m(n11.ERR_INVALID_ESCAPE, "\\C");
                case u.CODES.get("Q"): {
                  let A14 = i10.rest(), T10 = A14.indexOf("\\E");
                  T10 >= 0 && (A14 = A14.substring(0, T10)), i10.skipString(A14), i10.skipString("\\E");
                  let C19 = 0;
                  for (; C19 < A14.length; ) {
                    let S17 = A14.codePointAt(C19);
                    this.literal(S17), C19 += O.charCount(S17);
                  }
                  break t;
                }
                case u.CODES.get("z"):
                  this.op(c.Op.END_TEXT);
                  break t;
                default:
                  i10.rewindTo(l8);
                  break;
              }
              let h17 = this.newRegexp(c.Op.CHAR_CLASS);
              if (h17.flags = this.flags, i10.lookingAt("\\p") || i10.lookingAt("\\P")) {
                let f11 = new x();
                if (this.parseUnicodeClass(i10, f11)) {
                  h17.runes = f11.toArray(), this.push(h17);
                  break t;
                }
              }
              let p17 = new x();
              if (this.parsePerlClassEscape(i10, p17)) {
                h17.runes = p17.toArray(), this.push(h17);
                break t;
              }
              i10.rewindTo(l8), this.reuse(h17), this.literal(n11.parseEscape(i10));
              break;
            }
            default:
              this.literal(i10.pop());
              break;
          }
          t6 = o9;
        }
        if (this.concat(), this.swapVerticalBar() && this.pop(), this.alternate(), this.stack.length !== 1) throw new m(n11.ERR_MISSING_PAREN, this.wholeRegexp);
        return this.stack[0].namedGroups = this.namedGroups, this.stack[0];
      }
      parsePerlFlags(t6) {
        let e7 = t6.pos(), s9 = t6.rest();
        if (s9.startsWith("(?P<") || s9.startsWith("(?<")) {
          let l8 = s9.charAt(2) === "P" ? 4 : 3, h17 = s9.indexOf(">");
          if (h17 < 0) throw new m(n11.ERR_INVALID_NAMED_CAPTURE, s9);
          let p17 = s9.substring(l8, h17);
          if (t6.skipString(p17), t6.skip(l8 + 1), !n11.isValidCaptureName(p17)) throw new m(n11.ERR_INVALID_NAMED_CAPTURE, s9.substring(0, h17 + 1));
          let f11 = this.op(c.Op.LEFT_PAREN);
          if (f11.cap = ++this.numCap, this.namedGroups[p17]) throw new m(n11.ERR_DUPLICATE_NAMED_CAPTURE, p17);
          this.namedGroups[p17] = this.numCap, f11.name = p17;
          return;
        }
        t6.skip(2);
        let i10 = this.flags, r8 = 1, o9 = false;
        t: for (; t6.more(); ) {
          let l8 = t6.pop();
          switch (l8) {
            case u.CODES.get("i"):
              i10 |= g.FOLD_CASE, o9 = true;
              break;
            case u.CODES.get("m"):
              i10 &= -17, o9 = true;
              break;
            case u.CODES.get("s"):
              i10 |= g.DOT_NL, o9 = true;
              break;
            case u.CODES.get("U"):
              i10 |= g.NON_GREEDY, o9 = true;
              break;
            case u.CODES.get("-"):
              if (r8 < 0) break t;
              r8 = -1, i10 = ~i10, o9 = false;
              break;
            case u.CODES.get(":"):
            case u.CODES.get(")"):
              if (r8 < 0) {
                if (!o9) break t;
                i10 = ~i10;
              }
              l8 === u.CODES.get(":") && this.op(c.Op.LEFT_PAREN), this.flags = i10;
              return;
            default:
              break t;
          }
        }
        throw new m(n11.ERR_INVALID_PERL_OP, t6.from(e7));
      }
      parseVerticalBar() {
        this.concat(), this.swapVerticalBar() || this.op(c.Op.VERTICAL_BAR);
      }
      swapVerticalBar() {
        let t6 = this.stack.length;
        if (t6 >= 3 && this.stack[t6 - 2].op === c.Op.VERTICAL_BAR && n11.isCharClass(this.stack[t6 - 1]) && n11.isCharClass(this.stack[t6 - 3])) {
          let e7 = this.stack[t6 - 1], s9 = this.stack[t6 - 3];
          if (e7.op > s9.op) {
            let i10 = s9;
            s9 = e7, e7 = i10, this.stack[t6 - 3] = s9;
          }
          return n11.mergeCharClass(s9, e7), this.reuse(e7), this.pop(), true;
        }
        if (t6 >= 2) {
          let e7 = this.stack[t6 - 1], s9 = this.stack[t6 - 2];
          if (s9.op === c.Op.VERTICAL_BAR) return t6 >= 3 && this.cleanAlt(this.stack[t6 - 3]), this.stack[t6 - 2] = e7, this.stack[t6 - 1] = s9, true;
        }
        return false;
      }
      parseRightParen() {
        if (this.concat(), this.swapVerticalBar() && this.pop(), this.alternate(), this.stack.length < 2) throw new m(n11.ERR_UNEXPECTED_PAREN, this.wholeRegexp);
        let e7 = this.pop(), s9 = this.pop();
        if (s9.op !== c.Op.LEFT_PAREN) throw new m(n11.ERR_UNEXPECTED_PAREN, this.wholeRegexp);
        this.flags = s9.flags, s9.cap === 0 ? this.push(e7) : (s9.op = c.Op.CAPTURE, s9.subs = [e7], this.push(s9));
      }
      parsePerlClassEscape(t6, e7) {
        let s9 = t6.pos();
        if ((this.flags & g.PERL_X) === 0 || !t6.more() || t6.pop() !== u.CODES.get("\\") || !t6.more()) return false;
        t6.pop();
        let i10 = t6.from(s9), r8 = o1.has(i10) ? o1.get(i10) : null;
        return r8 === null ? false : (e7.appendGroup(r8, (this.flags & g.FOLD_CASE) !== 0), true);
      }
      parseNamedClass(t6, e7) {
        let s9 = t6.rest(), i10 = s9.indexOf(":]");
        if (i10 < 0) return false;
        let r8 = s9.substring(0, i10 + 2);
        t6.skipString(r8);
        let o9 = S1.has(r8) ? S1.get(r8) : null;
        if (o9 === null) throw new m(n11.ERR_INVALID_CHAR_RANGE, r8);
        return e7.appendGroup(o9, (this.flags & g.FOLD_CASE) !== 0), true;
      }
      parseUnicodeClass(t6, e7) {
        let s9 = t6.pos();
        if ((this.flags & g.UNICODE_GROUPS) === 0 || !t6.lookingAt("\\p") && !t6.lookingAt("\\P")) return false;
        t6.skip(1);
        let i10 = 1, r8 = t6.pop();
        if (r8 === u.CODES.get("P") && (i10 = -1), !t6.more()) throw t6.rewindTo(s9), new m(n11.ERR_INVALID_CHAR_RANGE, t6.rest());
        r8 = t6.pop();
        let o9;
        if (r8 !== u.CODES.get("{")) o9 = O.runeToString(r8);
        else {
          let f11 = t6.rest(), A14 = f11.indexOf("}");
          if (A14 < 0) throw t6.rewindTo(s9), new m(n11.ERR_INVALID_CHAR_RANGE, t6.rest());
          o9 = f11.substring(0, A14), t6.skipString(o9), t6.skip(1);
        }
        o9.length !== 0 && o9.codePointAt(0) === u.CODES.get("^") && (i10 = 0 - i10, o9 = o9.substring(1));
        let l8 = n11.unicodeTable(o9);
        if (l8 === null) throw new m(n11.ERR_INVALID_CHAR_RANGE, t6.from(s9));
        let h17 = l8.first, p17 = l8.second;
        if ((this.flags & g.FOLD_CASE) === 0 || p17 === null) e7.appendTableWithSign(h17, i10);
        else {
          let f11 = new x().appendTable(h17).appendTable(p17).cleanClass().toArray();
          e7.appendClassWithSign(f11, i10);
        }
        return true;
      }
      parseClass(t6) {
        let e7 = t6.pos();
        t6.skip(1);
        let s9 = this.newRegexp(c.Op.CHAR_CLASS);
        s9.flags = this.flags;
        let i10 = new x(), r8 = 1;
        t6.more() && t6.lookingAt("^") && (r8 = -1, t6.skip(1), (this.flags & g.CLASS_NL) === 0 && i10.appendRange(u.CODES.get(`
`), u.CODES.get(`
`)));
        let o9 = true;
        for (; !t6.more() || t6.peek() !== u.CODES.get("]") || o9; ) {
          if (t6.more() && t6.lookingAt("-") && (this.flags & g.PERL_X) === 0 && !o9) {
            let f11 = t6.rest();
            if (f11 === "-" || !f11.startsWith("-]")) throw t6.rewindTo(e7), new m(n11.ERR_INVALID_CHAR_RANGE, t6.rest());
          }
          o9 = false;
          let l8 = t6.pos();
          if (t6.lookingAt("[:")) {
            if (this.parseNamedClass(t6, i10)) continue;
            t6.rewindTo(l8);
          }
          if (this.parseUnicodeClass(t6, i10) || this.parsePerlClassEscape(t6, i10)) continue;
          t6.rewindTo(l8);
          let h17 = n11.parseClassChar(t6, e7), p17 = h17;
          if (t6.more() && t6.lookingAt("-")) {
            if (t6.skip(1), t6.more() && t6.lookingAt("]")) t6.skip(-1);
            else if (p17 = n11.parseClassChar(t6, e7), p17 < h17) throw new m(n11.ERR_INVALID_CHAR_RANGE, t6.from(l8));
          }
          (this.flags & g.FOLD_CASE) === 0 ? i10.appendRange(h17, p17) : i10.appendFoldedRange(h17, p17);
        }
        t6.skip(1), i10.cleanClass(), r8 < 0 && i10.negateClass(), s9.runes = i10.toArray(), this.push(s9);
      }
    };
    t1 = class {
      constructor(t6) {
        this.value = t6;
      }
      get() {
        return this.value;
      }
      set(t6) {
        this.value = t6;
      }
      compareAndSet(t6, e7) {
        return this.value === t6 ? (this.value = e7, true) : false;
      }
    };
    e1 = class n12 {
      static initTest(t6) {
        let e7 = n12.compile(t6), s9 = new n12(e7.expr, e7.prog, e7.numSubexp, e7.longest);
        return s9.cond = e7.cond, s9.prefix = e7.prefix, s9.prefixUTF8 = e7.prefixUTF8, s9.prefixComplete = e7.prefixComplete, s9.prefixRune = e7.prefixRune, s9;
      }
      static compile(t6) {
        return n12.compileImpl(t6, g.PERL, false);
      }
      static compilePOSIX(t6) {
        return n12.compileImpl(t6, g.POSIX, true);
      }
      static compileImpl(t6, e7, s9) {
        let i10 = J.parse(t6, e7), r8 = i10.maxCap();
        i10 = Z.simplify(i10);
        let o9 = K.compileRegexp(i10), l8 = new n12(t6, o9, r8, s9), [h17, p17] = o9.prefix();
        return l8.prefixComplete = h17, l8.prefix = p17, l8.prefixUTF8 = O.stringToUtf8ByteArray(l8.prefix), l8.prefix.length > 0 && (l8.prefixRune = l8.prefix.codePointAt(0)), l8.namedGroups = i10.namedGroups, l8;
      }
      static match(t6, e7) {
        return n12.compile(t6).match(e7);
      }
      constructor(t6, e7, s9 = 0, i10 = 0) {
        this.expr = t6, this.prog = e7, this.numSubexp = s9, this.longest = i10, this.cond = e7.startCond(), this.prefix = null, this.prefixUTF8 = null, this.prefixComplete = false, this.prefixRune = 0, this.pooled = new t1();
      }
      numberOfCapturingGroups() {
        return this.numSubexp;
      }
      numberOfInstructions() {
        return this.prog.numInst();
      }
      get() {
        let t6;
        do
          t6 = this.pooled.get();
        while (t6 && !this.pooled.compareAndSet(t6, t6.next));
        return t6;
      }
      reset() {
        this.pooled.set(null);
      }
      put(t6, e7) {
        let s9 = this.pooled.get();
        do
          s9 = this.pooled.get(), !e7 && s9 && (t6 = M.fromMachine(t6), e7 = true), t6.next !== s9 && (t6.next = s9);
        while (!this.pooled.compareAndSet(s9, t6));
      }
      toString() {
        return this.expr;
      }
      doExecute(t6, e7, s9, i10) {
        let r8 = this.get(), o9 = false;
        r8 ? r8.next !== null && (r8 = M.fromMachine(r8), o9 = true) : (r8 = M.fromRE2(this), o9 = true), r8.init(i10);
        let l8 = r8.match(t6, e7, s9) ? r8.submatches() : null;
        return this.put(r8, o9), l8;
      }
      match(t6) {
        return this.doExecute(N.fromUTF16(t6), 0, g.UNANCHORED, 0) !== null;
      }
      matchWithGroup(t6, e7, s9, i10, r8) {
        return t6 instanceof I || (t6 = P.utf16(t6)), this.matchMachineInput(t6, e7, s9, i10, r8);
      }
      matchMachineInput(t6, e7, s9, i10, r8) {
        if (e7 > s9) return [false, null];
        let o9 = t6.isUTF16Encoding() ? N.fromUTF16(t6.asCharSequence(), 0, s9) : N.fromUTF8(t6.asBytes(), 0, s9), l8 = this.doExecute(o9, e7, i10, 2 * r8);
        return l8 === null ? [false, null] : [true, l8];
      }
      matchUTF8(t6) {
        return this.doExecute(N.fromUTF8(t6), 0, g.UNANCHORED, 0) !== null;
      }
      replaceAll(t6, e7) {
        return this.replaceAllFunc(t6, () => e7, 2 * t6.length + 1);
      }
      replaceFirst(t6, e7) {
        return this.replaceAllFunc(t6, () => e7, 1);
      }
      replaceAllFunc(t6, e7, s9) {
        let i10 = 0, r8 = 0, o9 = "", l8 = N.fromUTF16(t6), h17 = 0;
        for (; r8 <= t6.length; ) {
          let p17 = this.doExecute(l8, r8, g.UNANCHORED, 2);
          if (p17 === null || p17.length === 0) break;
          o9 += t6.substring(i10, p17[0]), (p17[1] > i10 || p17[0] === 0) && (o9 += e7(t6.substring(p17[0], p17[1])), h17++), i10 = p17[1];
          let f11 = l8.step(r8) & 7;
          if (r8 + f11 > p17[1] ? r8 += f11 : r8 + 1 > p17[1] ? r8++ : r8 = p17[1], h17 >= s9) break;
        }
        return o9 += t6.substring(i10), o9;
      }
      pad(t6) {
        if (t6 === null) return null;
        let e7 = (1 + this.numSubexp) * 2;
        if (t6.length < e7) {
          let s9 = new Array(e7).fill(-1);
          for (let i10 = 0; i10 < t6.length; i10++) s9[i10] = t6[i10];
          t6 = s9;
        }
        return t6;
      }
      allMatches(t6, e7, s9 = (i10) => i10) {
        let i10 = [], r8 = t6.endPos();
        e7 < 0 && (e7 = r8 + 1);
        let o9 = 0, l8 = 0, h17 = -1;
        for (; l8 < e7 && o9 <= r8; ) {
          let p17 = this.doExecute(t6, o9, g.UNANCHORED, this.prog.numCap);
          if (p17 === null || p17.length === 0) break;
          let f11 = true;
          if (p17[1] === o9) {
            p17[0] === h17 && (f11 = false);
            let A14 = t6.step(o9);
            A14 < 0 ? o9 = r8 + 1 : o9 += A14 & 7;
          } else o9 = p17[1];
          h17 = p17[1], f11 && (i10.push(s9(this.pad(p17))), l8++);
        }
        return i10;
      }
      findUTF8(t6) {
        let e7 = this.doExecute(N.fromUTF8(t6), 0, g.UNANCHORED, 2);
        return e7 === null ? null : t6.slice(e7[0], e7[1]);
      }
      findUTF8Index(t6) {
        let e7 = this.doExecute(N.fromUTF8(t6), 0, g.UNANCHORED, 2);
        return e7 === null ? null : e7.slice(0, 2);
      }
      find(t6) {
        let e7 = this.doExecute(N.fromUTF16(t6), 0, g.UNANCHORED, 2);
        return e7 === null ? "" : t6.substring(e7[0], e7[1]);
      }
      findIndex(t6) {
        return this.doExecute(N.fromUTF16(t6), 0, g.UNANCHORED, 2);
      }
      findUTF8Submatch(t6) {
        let e7 = this.doExecute(N.fromUTF8(t6), 0, g.UNANCHORED, this.prog.numCap);
        if (e7 === null) return null;
        let s9 = new Array(1 + this.numSubexp).fill(null);
        for (let i10 = 0; i10 < s9.length; i10++) 2 * i10 < e7.length && e7[2 * i10] >= 0 && (s9[i10] = t6.slice(e7[2 * i10], e7[2 * i10 + 1]));
        return s9;
      }
      findUTF8SubmatchIndex(t6) {
        return this.pad(this.doExecute(N.fromUTF8(t6), 0, g.UNANCHORED, this.prog.numCap));
      }
      findSubmatch(t6) {
        let e7 = this.doExecute(N.fromUTF16(t6), 0, g.UNANCHORED, this.prog.numCap);
        if (e7 === null) return null;
        let s9 = new Array(1 + this.numSubexp).fill(null);
        for (let i10 = 0; i10 < s9.length; i10++) 2 * i10 < e7.length && e7[2 * i10] >= 0 && (s9[i10] = t6.substring(e7[2 * i10], e7[2 * i10 + 1]));
        return s9;
      }
      findSubmatchIndex(t6) {
        return this.pad(this.doExecute(N.fromUTF16(t6), 0, g.UNANCHORED, this.prog.numCap));
      }
      findAllUTF8(t6, e7) {
        let s9 = this.allMatches(N.fromUTF8(t6), e7, (i10) => t6.slice(i10[0], i10[1]));
        return s9.length === 0 ? null : s9;
      }
      findAllUTF8Index(t6, e7) {
        let s9 = this.allMatches(N.fromUTF8(t6), e7, (i10) => i10.slice(0, 2));
        return s9.length === 0 ? null : s9;
      }
      findAll(t6, e7) {
        let s9 = this.allMatches(N.fromUTF16(t6), e7, (i10) => t6.substring(i10[0], i10[1]));
        return s9.length === 0 ? null : s9;
      }
      findAllIndex(t6, e7) {
        let s9 = this.allMatches(N.fromUTF16(t6), e7, (i10) => i10.slice(0, 2));
        return s9.length === 0 ? null : s9;
      }
      findAllUTF8Submatch(t6, e7) {
        let s9 = this.allMatches(N.fromUTF8(t6), e7, (i10) => {
          let r8 = new Array(i10.length / 2 | 0).fill(null);
          for (let o9 = 0; o9 < r8.length; o9++) i10[2 * o9] >= 0 && (r8[o9] = t6.slice(i10[2 * o9], i10[2 * o9 + 1]));
          return r8;
        });
        return s9.length === 0 ? null : s9;
      }
      findAllUTF8SubmatchIndex(t6, e7) {
        let s9 = this.allMatches(N.fromUTF8(t6), e7);
        return s9.length === 0 ? null : s9;
      }
      findAllSubmatch(t6, e7) {
        let s9 = this.allMatches(N.fromUTF16(t6), e7, (i10) => {
          let r8 = new Array(i10.length / 2 | 0).fill(null);
          for (let o9 = 0; o9 < r8.length; o9++) i10[2 * o9] >= 0 && (r8[o9] = t6.substring(i10[2 * o9], i10[2 * o9 + 1]));
          return r8;
        });
        return s9.length === 0 ? null : s9;
      }
      findAllSubmatchIndex(t6, e7) {
        let s9 = this.allMatches(N.fromUTF16(t6), e7);
        return s9.length === 0 ? null : s9;
      }
    };
    s1 = class n13 {
      static isUpperCaseAlpha(t6) {
        return "A" <= t6 && t6 <= "Z";
      }
      static isHexadecimal(t6) {
        return "0" <= t6 && t6 <= "9" || "A" <= t6 && t6 <= "F" || "a" <= t6 && t6 <= "f";
      }
      static getUtf8CharSize(t6) {
        let e7 = t6.charCodeAt(0);
        return e7 < 128 ? 1 : e7 < 2048 ? 2 : e7 < 65536 ? 3 : 4;
      }
      static translate(t6) {
        if (typeof t6 != "string") return t6;
        let e7 = "", s9 = false, i10 = t6.length;
        i10 === 0 && (e7 = "(?:)", s9 = true);
        let r8 = 0;
        for (; r8 < i10; ) {
          let o9 = t6[r8];
          if (o9 === "\\") {
            if (r8 + 1 < i10) switch (o9 = t6[r8 + 1], o9) {
              case "\\": {
                e7 += "\\\\", r8 += 2;
                continue;
              }
              case "c": {
                if (r8 + 2 < i10) {
                  let h17 = t6[r8 + 2];
                  if (n13.isUpperCaseAlpha(h17)) {
                    e7 += "\\x", e7 += (h17.charCodeAt(0) - 64 >> 4).toString(16).toUpperCase(), e7 += (h17.charCodeAt(0) - 64 & 15).toString(16).toUpperCase(), r8 += 3, s9 = true;
                    continue;
                  }
                }
                e7 += "\\c", r8 += 2;
                continue;
              }
              case "u": {
                if (r8 + 2 < i10) {
                  let h17 = t6[r8 + 2];
                  if (n13.isHexadecimal(h17)) {
                    e7 += "\\x{" + h17, r8 += 3;
                    for (let p17 = 0; p17 < 3 && r8 < i10 && (h17 = t6[r8], !!n13.isHexadecimal(h17)); ++r8, ++p17) e7 += h17;
                    e7 += "}", s9 = true;
                    continue;
                  } else if (h17 === "{") {
                    e7 += "\\x", r8 += 2, s9 = true;
                    continue;
                  }
                }
                e7 += "\\u", r8 += 2;
                continue;
              }
              default: {
                e7 += "\\";
                let h17 = n13.getUtf8CharSize(o9);
                e7 += t6.substring(r8 + 1, r8 + 1 + h17), r8 += h17 + 1;
                continue;
              }
            }
          } else if (o9 === "/") {
            e7 += "\\/", r8 += 1, s9 = true;
            continue;
          } else if (o9 === "(" && r8 + 2 < i10 && t6[r8 + 1] === "?" && t6[r8 + 2] === "<" && (r8 + 3 >= i10 || t6[r8 + 3] !== "=" && t6[r8 + 3] !== "!")) {
            e7 += "(?P<", r8 += 3, s9 = true;
            continue;
          }
          let l8 = n13.getUtf8CharSize(o9);
          e7 += t6.substring(r8, r8 + l8), r8 += l8;
        }
        return s9 ? e7 : t6;
      }
    };
    y = class n14 {
      static CASE_INSENSITIVE = 1;
      static DOTALL = 2;
      static MULTILINE = 4;
      static DISABLE_UNICODE_GROUPS = 8;
      static LONGEST_MATCH = 16;
      static quote(t6) {
        return O.quoteMeta(t6);
      }
      static translateRegExp(t6) {
        return s1.translate(t6);
      }
      static compile(t6, e7 = 0) {
        let s9 = t6;
        if ((e7 & n14.CASE_INSENSITIVE) !== 0 && (s9 = `(?i)${s9}`), (e7 & n14.DOTALL) !== 0 && (s9 = `(?s)${s9}`), (e7 & n14.MULTILINE) !== 0 && (s9 = `(?m)${s9}`), (e7 & ~(n14.MULTILINE | n14.DOTALL | n14.CASE_INSENSITIVE | n14.DISABLE_UNICODE_GROUPS | n14.LONGEST_MATCH)) !== 0) throw new z("Flags should only be a combination of MULTILINE, DOTALL, CASE_INSENSITIVE, DISABLE_UNICODE_GROUPS, LONGEST_MATCH");
        let i10 = g.PERL;
        (e7 & n14.DISABLE_UNICODE_GROUPS) !== 0 && (i10 &= -129);
        let r8 = new n14(t6, e7);
        return r8.re2Input = e1.compileImpl(s9, i10, (e7 & n14.LONGEST_MATCH) !== 0), r8;
      }
      static matches(t6, e7) {
        return n14.compile(t6).matcher(e7).matches();
      }
      static initTest(t6, e7, s9) {
        if (t6 == null) throw new Error("pattern is null");
        if (s9 == null) throw new Error("re2 is null");
        let i10 = new n14(t6, e7);
        return i10.re2Input = s9, i10;
      }
      constructor(t6, e7) {
        this.patternInput = t6, this.flagsInput = e7;
      }
      reset() {
        this.re2Input.reset();
      }
      flags() {
        return this.flagsInput;
      }
      pattern() {
        return this.patternInput;
      }
      re2() {
        return this.re2Input;
      }
      matches(t6) {
        return this.matcher(t6).matches();
      }
      matcher(t6) {
        return Array.isArray(t6) && (t6 = P.utf8(t6)), new V(this, t6);
      }
      split(t6, e7 = 0) {
        let s9 = this.matcher(t6), i10 = [], r8 = 0, o9 = 0;
        for (; s9.find(); ) {
          if (o9 === 0 && s9.end() === 0) {
            o9 = s9.end();
            continue;
          }
          if (e7 > 0 && i10.length === e7 - 1) break;
          if (o9 === s9.start()) {
            if (e7 === 0) {
              r8 += 1, o9 = s9.end();
              continue;
            }
          } else for (; r8 > 0; ) i10.push(""), r8 -= 1;
          i10.push(s9.substring(o9, s9.start())), o9 = s9.end();
        }
        if (e7 === 0 && o9 !== s9.inputLength()) {
          for (; r8 > 0; ) i10.push(""), r8 -= 1;
          i10.push(s9.substring(o9, s9.inputLength()));
        }
        return (e7 !== 0 || i10.length === 0) && i10.push(s9.substring(o9, s9.inputLength())), i10;
      }
      toString() {
        return this.patternInput;
      }
      programSize() {
        return this.re2Input.numberOfInstructions();
      }
      groupCount() {
        return this.re2Input.numberOfCapturingGroups();
      }
      namedGroups() {
        return this.re2Input.namedGroups;
      }
      equals(t6) {
        return this === t6 ? true : t6 === null || this.constructor !== t6.constructor ? false : this.flagsInput === t6.flagsInput && this.patternInput === t6.patternInput;
      }
    };
    B = class {
      _re2;
      _pattern;
      _flags;
      _global;
      _ignoreCase;
      _multiline;
      _lastIndex = 0;
      _nativeRegex = null;
      constructor(t6, e7 = "") {
        this._pattern = t6, this._flags = e7, this._global = e7.includes("g"), this._ignoreCase = e7.includes("i"), this._multiline = e7.includes("m");
        try {
          let s9 = N1(t6), i10 = T1(e7);
          this._re2 = y.compile(s9, i10);
        } catch (s9) {
          if (s9 instanceof m) {
            let i10 = s9.message || "", r8 = "";
            throw i10.includes("(?=") || i10.includes("(?!") || i10.includes("(?<") || i10.includes("(?<!") || t6.includes("(?=") || t6.includes("(?!") || t6.includes("(?<=") || t6.includes("(?<!") ? r8 = " Lookahead (?=, ?!) and lookbehind (?<=, ?<!) assertions are not supported in this environment because the regex engine uses RE2 for ReDoS protection. RE2 guarantees linear-time matching but cannot support these features." : (i10.includes("backreference") || /\\[1-9]/.test(t6)) && (r8 = " Backreferences (\\1, \\2, etc.) are not supported in this environment because the regex engine uses RE2 for ReDoS protection. RE2 guarantees linear-time matching but cannot support backreferences."), new SyntaxError(`Invalid regular expression: /${t6}/: ${i10}${r8}`);
          }
          throw s9;
        }
      }
      test(t6) {
        return this._global && (this._lastIndex = 0), this._re2.matcher(t6).find();
      }
      exec(t6) {
        let e7 = this._re2.matcher(t6), s9 = this._global ? this._lastIndex : 0;
        if (!e7.find(s9)) return this._global && (this._lastIndex = 0), null;
        let i10 = this._re2.groupCount(), r8 = [];
        r8.push(e7.group(0) ?? "");
        for (let h17 = 1; h17 <= i10; h17++) {
          let p17 = e7.group(h17);
          r8.push(p17);
        }
        let o9 = r8;
        o9.index = e7.start(0), o9.input = t6;
        let l8 = this._re2.namedGroups();
        if (l8 && Object.keys(l8).length > 0) {
          let h17 = /* @__PURE__ */ Object.create(null);
          for (let [p17, f11] of Object.entries(l8)) {
            let A14 = e7.group(f11);
            A14 !== null && (h17[p17] = A14);
          }
          o9.groups = h17;
        }
        return this._global && (this._lastIndex = e7.end(0), e7.start(0) === e7.end(0) && this._lastIndex++), o9;
      }
      match(t6) {
        if (this._global && (this._lastIndex = 0), !this._global) return this.exec(t6);
        let e7 = [], s9 = this._re2.matcher(t6), i10 = 0;
        for (; s9.find(i10); ) {
          let r8 = s9.group(0) ?? "";
          if (e7.push(r8), i10 = s9.end(0), s9.start(0) === s9.end(0) && i10++, i10 > t6.length) break;
        }
        return e7.length > 0 ? e7 : null;
      }
      replace(t6, e7) {
        if (this._global && (this._lastIndex = 0), typeof e7 == "string") {
          let p17 = this._re2.matcher(t6);
          return this._global ? p17.replaceAll(e7, true) : p17.replaceFirst(e7, true);
        }
        let s9 = [], i10 = this._re2.matcher(t6), r8 = 0, o9 = 0, l8 = this._re2.groupCount(), h17 = this._re2.namedGroups();
        for (; i10.find(o9); ) {
          s9.push(t6.slice(r8, i10.start(0)));
          let p17 = [], f11 = i10.group(0) ?? "";
          for (let A14 = 1; A14 <= l8; A14++) p17.push(i10.group(A14));
          if (p17.push(i10.start(0)), p17.push(t6), h17 && Object.keys(h17).length > 0) {
            let A14 = /* @__PURE__ */ Object.create(null);
            for (let [T10, C19] of Object.entries(h17)) A14[T10] = i10.group(C19) ?? "";
            p17.push(A14);
          }
          if (s9.push(e7(f11, ...p17)), r8 = i10.end(0), o9 = r8, i10.start(0) === i10.end(0) && o9++, !this._global || o9 > t6.length) break;
        }
        return s9.push(t6.slice(r8)), s9.join("");
      }
      split(t6, e7) {
        return e7 === void 0 || e7 < 0 ? this._re2.split(t6, -1) : e7 === 0 ? [] : this._re2.split(t6, -1).slice(0, e7);
      }
      search(t6) {
        let e7 = this._re2.matcher(t6);
        return e7.find() ? e7.start(0) : -1;
      }
      *matchAll(t6) {
        if (!this._global) throw new Error("matchAll requires global flag");
        this._lastIndex = 0;
        let e7 = this._re2.matcher(t6), s9 = this._re2.groupCount(), i10 = this._re2.namedGroups(), r8 = 0;
        for (; e7.find(r8); ) {
          let o9 = [];
          o9.push(e7.group(0) ?? "");
          for (let h17 = 1; h17 <= s9; h17++) o9.push(e7.group(h17));
          let l8 = o9;
          if (l8.index = e7.start(0), l8.input = t6, i10 && Object.keys(i10).length > 0) {
            let h17 = /* @__PURE__ */ Object.create(null);
            for (let [p17, f11] of Object.entries(i10)) {
              let A14 = e7.group(f11);
              A14 !== null && (h17[p17] = A14);
            }
            l8.groups = h17;
          }
          if (yield l8, r8 = e7.end(0), e7.start(0) === e7.end(0) && r8++, r8 > t6.length) break;
        }
      }
      get native() {
        if (!this._nativeRegex) try {
          this._nativeRegex = new RegExp(this._pattern, this._flags);
        } catch {
          this._nativeRegex = new RegExp("", this._flags), Object.defineProperty(this._nativeRegex, "source", { value: this._pattern, writable: false });
        }
        return this._nativeRegex;
      }
      get source() {
        return this._pattern;
      }
      get flags() {
        return this._flags;
      }
      get global() {
        return this._global;
      }
      get ignoreCase() {
        return this._ignoreCase;
      }
      get multiline() {
        return this._multiline;
      }
      get lastIndex() {
        return this._lastIndex;
      }
      set lastIndex(t6) {
        this._lastIndex = t6;
      }
    };
    i1 = class {
      _regex;
      constructor(t6) {
        this._regex = t6;
      }
      test(t6) {
        return this._regex.global && (this._regex.lastIndex = 0), this._regex.test(t6);
      }
      exec(t6) {
        return this._regex.exec(t6);
      }
      match(t6) {
        return this._regex.global && (this._regex.lastIndex = 0), t6.match(this._regex);
      }
      replace(t6, e7) {
        return this._regex.global && (this._regex.lastIndex = 0), t6.replace(this._regex, e7);
      }
      split(t6, e7) {
        return t6.split(this._regex, e7);
      }
      search(t6) {
        return t6.search(this._regex);
      }
      *matchAll(t6) {
        if (!this._regex.global) throw new Error("matchAll requires global flag");
        this._regex.lastIndex = 0;
        let e7 = this._regex.exec(t6);
        for (; e7 !== null; ) yield e7, e7[0].length === 0 && this._regex.lastIndex++, e7 = this._regex.exec(t6);
      }
      get native() {
        return this._regex;
      }
      get source() {
        return this._regex.source;
      }
      get flags() {
        return this._regex.flags;
      }
      get global() {
        return this._regex.global;
      }
      get ignoreCase() {
        return this._regex.ignoreCase;
      }
      get multiline() {
        return this._regex.multiline;
      }
      get lastIndex() {
        return this._regex.lastIndex;
      }
      set lastIndex(t6) {
        this._regex.lastIndex = t6;
      }
    };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-PSW6BMXW.js
function C(r8) {
  return r8 instanceof c2 || r8 instanceof a2 || r8 instanceof i;
}
var n15, c2, a2, i, u2, x2, d2, p, h, l, m2, b2, $2, f;
var init_chunk_PSW6BMXW = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-PSW6BMXW.js"() {
    n15 = class extends Error {
      stdout;
      stderr;
      constructor(t6, s9 = "", e7 = "") {
        super(t6), this.stdout = s9, this.stderr = e7;
      }
      prependOutput(t6, s9) {
        this.stdout = t6 + this.stdout, this.stderr = s9 + this.stderr;
      }
    };
    c2 = class extends n15 {
      levels;
      name = "BreakError";
      constructor(t6 = 1, s9 = "", e7 = "") {
        super("break", s9, e7), this.levels = t6;
      }
    };
    a2 = class extends n15 {
      levels;
      name = "ContinueError";
      constructor(t6 = 1, s9 = "", e7 = "") {
        super("continue", s9, e7), this.levels = t6;
      }
    };
    i = class extends n15 {
      exitCode;
      name = "ReturnError";
      constructor(t6 = 0, s9 = "", e7 = "") {
        super("return", s9, e7), this.exitCode = t6;
      }
    };
    u2 = class extends n15 {
      exitCode;
      name = "ErrexitError";
      constructor(t6, s9 = "", e7 = "") {
        super(`errexit: command exited with status ${t6}`, s9, e7), this.exitCode = t6;
      }
    };
    x2 = class extends n15 {
      varName;
      name = "NounsetError";
      constructor(t6, s9 = "") {
        super(`${t6}: unbound variable`, s9, `bash: ${t6}: unbound variable
`), this.varName = t6;
      }
    };
    d2 = class extends n15 {
      exitCode;
      name = "ExitError";
      constructor(t6, s9 = "", e7 = "") {
        super("exit", s9, e7), this.exitCode = t6;
      }
    };
    p = class extends n15 {
      name = "ArithmeticError";
      fatal;
      constructor(t6, s9 = "", e7 = "", o9 = false) {
        super(t6, s9, e7), this.stderr = e7 || `bash: ${t6}
`, this.fatal = o9;
      }
    };
    h = class extends n15 {
      name = "BadSubstitutionError";
      constructor(t6, s9 = "", e7 = "") {
        super(t6, s9, e7), this.stderr = e7 || `bash: ${t6}: bad substitution
`;
      }
    };
    l = class extends n15 {
      name = "GlobError";
      constructor(t6, s9 = "", e7 = "") {
        super(`no match: ${t6}`, s9, e7), this.stderr = e7 || `bash: no match: ${t6}
`;
      }
    };
    m2 = class extends n15 {
      name = "BraceExpansionError";
      constructor(t6, s9 = "", e7 = "") {
        super(t6, s9, e7), this.stderr = e7 || `bash: ${t6}
`;
      }
    };
    b2 = class extends n15 {
      limitType;
      name = "ExecutionLimitError";
      static EXIT_CODE = 126;
      constructor(t6, s9, e7 = "", o9 = "") {
        super(t6, e7, o9), this.limitType = s9, this.stderr = o9 || `bash: ${t6}
`;
      }
    };
    $2 = class extends n15 {
      name = "SubshellExitError";
      constructor(t6 = "", s9 = "") {
        super("subshell exit", t6, s9);
      }
    };
    f = class extends n15 {
      exitCode;
      name = "PosixFatalError";
      constructor(t6, s9 = "", e7 = "") {
        super("posix fatal error", s9, e7), this.exitCode = t6;
      }
    };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-V4CDPGZH.js
function $3(e7, t6) {
  for (; t6 < e7.length; ) {
    if (e7[t6] === "\\" && e7[t6 + 1] === `
`) {
      t6 += 2;
      continue;
    }
    if (/\s/.test(e7[t6])) {
      t6++;
      continue;
    }
    break;
  }
  return t6;
}
function ge(e7) {
  if (e7.includes("#")) {
    let [r8, s9] = e7.split("#"), n23 = Number.parseInt(r8, 10);
    if (n23 < 2 || n23 > 64) return Number.NaN;
    if (n23 <= 36) {
      let i10 = Number.parseInt(s9, n23);
      return i10 > Number.MAX_SAFE_INTEGER ? Number.MAX_SAFE_INTEGER : i10;
    }
    let a7 = 0;
    for (let i10 of s9) {
      let l8;
      if (/[0-9]/.test(i10)) l8 = i10.charCodeAt(0) - 48;
      else if (/[a-z]/.test(i10)) l8 = i10.charCodeAt(0) - 97 + 10;
      else if (/[A-Z]/.test(i10)) l8 = i10.charCodeAt(0) - 65 + 36;
      else if (i10 === "@") l8 = 62;
      else if (i10 === "_") l8 = 63;
      else return Number.NaN;
      if (l8 >= n23) return Number.NaN;
      if (a7 = a7 * n23 + l8, a7 > Number.MAX_SAFE_INTEGER) return Number.MAX_SAFE_INTEGER;
    }
    return a7;
  }
  if (e7.startsWith("0x") || e7.startsWith("0X")) {
    let r8 = Number.parseInt(e7.slice(2), 16);
    return r8 > Number.MAX_SAFE_INTEGER ? Number.MAX_SAFE_INTEGER : r8;
  }
  if (e7.startsWith("0") && e7.length > 1 && /^[0-9]+$/.test(e7)) {
    if (/[89]/.test(e7)) return Number.NaN;
    let r8 = Number.parseInt(e7, 8);
    return r8 > Number.MAX_SAFE_INTEGER ? Number.MAX_SAFE_INTEGER : r8;
  }
  let t6 = Number.parseInt(e7, 10);
  return t6 > Number.MAX_SAFE_INTEGER ? Number.MAX_SAFE_INTEGER : t6;
}
function It(e7, t6, r8, s9) {
  if (r8.slice(s9, s9 + 3) !== "$((") return null;
  let n23 = s9 + 3, a7 = 1, i10 = n23;
  for (; n23 < r8.length - 1 && a7 > 0; ) r8[n23] === "(" && r8[n23 + 1] === "(" ? (a7++, n23 += 2) : r8[n23] === ")" && r8[n23 + 1] === ")" ? (a7--, a7 > 0 && (n23 += 2)) : n23++;
  let l8 = r8.slice(i10, n23), { expr: o9 } = e7(t6, l8, 0);
  return n23 += 2, { expr: { type: "ArithNested", expression: o9 }, pos: n23 };
}
function vt(e7, t6) {
  if (e7.slice(t6, t6 + 2) !== "$'") return null;
  let r8 = t6 + 2, s9 = "";
  for (; r8 < e7.length && e7[r8] !== "'"; ) if (e7[r8] === "\\" && r8 + 1 < e7.length) {
    let a7 = e7[r8 + 1];
    switch (a7) {
      case "n":
        s9 += `
`;
        break;
      case "t":
        s9 += "	";
        break;
      case "r":
        s9 += "\r";
        break;
      case "\\":
        s9 += "\\";
        break;
      case "'":
        s9 += "'";
        break;
      default:
        s9 += a7;
    }
    r8 += 2;
  } else s9 += e7[r8], r8++;
  e7[r8] === "'" && r8++;
  let n23 = Number.parseInt(s9, 10);
  return { expr: { type: "ArithNumber", value: Number.isNaN(n23) ? 0 : n23 }, pos: r8 };
}
function Dt(e7, t6) {
  if (e7.slice(t6, t6 + 2) !== '$"') return null;
  let r8 = t6 + 2, s9 = "";
  for (; r8 < e7.length && e7[r8] !== '"'; ) e7[r8] === "\\" && r8 + 1 < e7.length ? (s9 += e7[r8 + 1], r8 += 2) : (s9 += e7[r8], r8++);
  e7[r8] === '"' && r8++;
  let n23 = Number.parseInt(s9, 10);
  return { expr: { type: "ArithNumber", value: Number.isNaN(n23) ? 0 : n23 }, pos: r8 };
}
function wr(e7) {
  let t6 = "", r8 = 0;
  for (; r8 < e7.length; ) if (e7[r8] === '"') {
    for (r8++; r8 < e7.length && e7[r8] !== '"'; ) e7[r8] === "\\" && r8 + 1 < e7.length ? (t6 += e7[r8 + 1], r8 += 2) : (t6 += e7[r8], r8++);
    r8 < e7.length && r8++;
  } else t6 += e7[r8], r8++;
  return t6;
}
function M2(e7, t6) {
  let r8 = wr(t6), { expr: s9, pos: n23 } = Z2(e7, r8, 0), a7 = $3(r8, n23);
  if (a7 < r8.length) {
    let i10 = t6.slice(a7).trim();
    if (i10) return { type: "ArithmeticExpression", originalText: t6, expression: { type: "ArithSyntaxError", errorToken: i10, message: `${i10}: syntax error: invalid arithmetic operator (error token is "${i10}")` } };
  }
  return { type: "ArithmeticExpression", expression: s9, originalText: t6 };
}
function F2(e7, t6) {
  return { expr: { type: "ArithSyntaxError", errorToken: e7, message: `syntax error: operand expected (error token is "${e7}")` }, pos: t6 };
}
function z2(e7, t6) {
  return $3(e7, t6) >= e7.length;
}
function Z2(e7, t6, r8) {
  return Nr(e7, t6, r8);
}
function Nr(e7, t6, r8) {
  let { expr: s9, pos: n23 } = ye(e7, t6, r8);
  for (n23 = $3(t6, n23); t6[n23] === ","; ) {
    if (n23++, z2(t6, n23)) return F2(",", n23);
    let { expr: i10, pos: l8 } = ye(e7, t6, n23);
    s9 = { type: "ArithBinary", operator: ",", left: s9, right: i10 }, n23 = $3(t6, l8);
  }
  return { expr: s9, pos: n23 };
}
function ye(e7, t6, r8) {
  let { expr: s9, pos: n23 } = kr(e7, t6, r8);
  if (n23 = $3(t6, n23), t6[n23] === "?") {
    n23++;
    let { expr: a7, pos: i10 } = Z2(e7, t6, n23);
    if (n23 = $3(t6, i10), t6[n23] === ":") {
      n23++;
      let { expr: l8, pos: o9 } = Z2(e7, t6, n23);
      return { expr: { type: "ArithTernary", condition: s9, consequent: a7, alternate: l8 }, pos: o9 };
    }
  }
  return { expr: s9, pos: n23 };
}
function kr(e7, t6, r8) {
  let { expr: s9, pos: n23 } = xt(e7, t6, r8);
  for (; n23 = $3(t6, n23), t6.slice(n23, n23 + 2) === "||"; ) {
    if (n23 += 2, z2(t6, n23)) return F2("||", n23);
    let { expr: i10, pos: l8 } = xt(e7, t6, n23);
    s9 = { type: "ArithBinary", operator: "||", left: s9, right: i10 }, n23 = l8;
  }
  return { expr: s9, pos: n23 };
}
function xt(e7, t6, r8) {
  let { expr: s9, pos: n23 } = _t(e7, t6, r8);
  for (; n23 = $3(t6, n23), t6.slice(n23, n23 + 2) === "&&"; ) {
    if (n23 += 2, z2(t6, n23)) return F2("&&", n23);
    let { expr: i10, pos: l8 } = _t(e7, t6, n23);
    s9 = { type: "ArithBinary", operator: "&&", left: s9, right: i10 }, n23 = l8;
  }
  return { expr: s9, pos: n23 };
}
function _t(e7, t6, r8) {
  let { expr: s9, pos: n23 } = $t(e7, t6, r8);
  for (; n23 = $3(t6, n23), t6[n23] === "|" && t6[n23 + 1] !== "|"; ) {
    if (n23++, z2(t6, n23)) return F2("|", n23);
    let { expr: i10, pos: l8 } = $t(e7, t6, n23);
    s9 = { type: "ArithBinary", operator: "|", left: s9, right: i10 }, n23 = l8;
  }
  return { expr: s9, pos: n23 };
}
function $t(e7, t6, r8) {
  let { expr: s9, pos: n23 } = Ct(e7, t6, r8);
  for (; n23 = $3(t6, n23), t6[n23] === "^"; ) {
    if (n23++, z2(t6, n23)) return F2("^", n23);
    let { expr: i10, pos: l8 } = Ct(e7, t6, n23);
    s9 = { type: "ArithBinary", operator: "^", left: s9, right: i10 }, n23 = l8;
  }
  return { expr: s9, pos: n23 };
}
function Ct(e7, t6, r8) {
  let { expr: s9, pos: n23 } = Ot(e7, t6, r8);
  for (; n23 = $3(t6, n23), t6[n23] === "&" && t6[n23 + 1] !== "&"; ) {
    if (n23++, z2(t6, n23)) return F2("&", n23);
    let { expr: i10, pos: l8 } = Ot(e7, t6, n23);
    s9 = { type: "ArithBinary", operator: "&", left: s9, right: i10 }, n23 = l8;
  }
  return { expr: s9, pos: n23 };
}
function Ot(e7, t6, r8) {
  let { expr: s9, pos: n23 } = Lt(e7, t6, r8);
  for (; n23 = $3(t6, n23), t6.slice(n23, n23 + 2) === "==" || t6.slice(n23, n23 + 2) === "!="; ) {
    let a7 = t6.slice(n23, n23 + 2);
    if (n23 += 2, z2(t6, n23)) return F2(a7, n23);
    let { expr: i10, pos: l8 } = Lt(e7, t6, n23);
    s9 = { type: "ArithBinary", operator: a7, left: s9, right: i10 }, n23 = l8;
  }
  return { expr: s9, pos: n23 };
}
function Lt(e7, t6, r8) {
  let { expr: s9, pos: n23 } = Fe(e7, t6, r8);
  for (; ; ) if (n23 = $3(t6, n23), t6.slice(n23, n23 + 2) === "<=" || t6.slice(n23, n23 + 2) === ">=") {
    let a7 = t6.slice(n23, n23 + 2);
    if (n23 += 2, z2(t6, n23)) return F2(a7, n23);
    let { expr: i10, pos: l8 } = Fe(e7, t6, n23);
    s9 = { type: "ArithBinary", operator: a7, left: s9, right: i10 }, n23 = l8;
  } else if (t6[n23] === "<" || t6[n23] === ">") {
    let a7 = t6[n23];
    if (n23++, z2(t6, n23)) return F2(a7, n23);
    let { expr: i10, pos: l8 } = Fe(e7, t6, n23);
    s9 = { type: "ArithBinary", operator: a7, left: s9, right: i10 }, n23 = l8;
  } else break;
  return { expr: s9, pos: n23 };
}
function Fe(e7, t6, r8) {
  let { expr: s9, pos: n23 } = Wt(e7, t6, r8);
  for (; n23 = $3(t6, n23), t6.slice(n23, n23 + 2) === "<<" || t6.slice(n23, n23 + 2) === ">>"; ) {
    let a7 = t6.slice(n23, n23 + 2);
    if (n23 += 2, z2(t6, n23)) return F2(a7, n23);
    let { expr: i10, pos: l8 } = Wt(e7, t6, n23);
    s9 = { type: "ArithBinary", operator: a7, left: s9, right: i10 }, n23 = l8;
  }
  return { expr: s9, pos: n23 };
}
function Wt(e7, t6, r8) {
  let { expr: s9, pos: n23 } = Tt(e7, t6, r8);
  for (; n23 = $3(t6, n23), (t6[n23] === "+" || t6[n23] === "-") && t6[n23 + 1] !== t6[n23]; ) {
    let a7 = t6[n23];
    if (n23++, z2(t6, n23)) return F2(a7, n23);
    let { expr: i10, pos: l8 } = Tt(e7, t6, n23);
    s9 = { type: "ArithBinary", operator: a7, left: s9, right: i10 }, n23 = l8;
  }
  return { expr: s9, pos: n23 };
}
function Tt(e7, t6, r8) {
  let { expr: s9, pos: n23 } = Re(e7, t6, r8);
  for (; ; ) if (n23 = $3(t6, n23), t6[n23] === "*" && t6[n23 + 1] !== "*") {
    if (n23++, z2(t6, n23)) return F2("*", n23);
    let { expr: i10, pos: l8 } = Re(e7, t6, n23);
    s9 = { type: "ArithBinary", operator: "*", left: s9, right: i10 }, n23 = l8;
  } else if (t6[n23] === "/" || t6[n23] === "%") {
    let a7 = t6[n23];
    if (n23++, z2(t6, n23)) return F2(a7, n23);
    let { expr: i10, pos: l8 } = Re(e7, t6, n23);
    s9 = { type: "ArithBinary", operator: a7, left: s9, right: i10 }, n23 = l8;
  } else break;
  return { expr: s9, pos: n23 };
}
function Re(e7, t6, r8) {
  let { expr: s9, pos: n23 } = ze(e7, t6, r8), a7 = $3(t6, n23);
  if (t6.slice(a7, a7 + 2) === "**") {
    if (a7 += 2, z2(t6, a7)) return F2("**", a7);
    let { expr: l8, pos: o9 } = Re(e7, t6, a7);
    return { expr: { type: "ArithBinary", operator: "**", left: s9, right: l8 }, pos: o9 };
  }
  return { expr: s9, pos: n23 };
}
function ze(e7, t6, r8) {
  let s9 = $3(t6, r8);
  if (t6.slice(s9, s9 + 2) === "++" || t6.slice(s9, s9 + 2) === "--") {
    let n23 = t6.slice(s9, s9 + 2);
    s9 += 2;
    let { expr: a7, pos: i10 } = ze(e7, t6, s9);
    return { expr: { type: "ArithUnary", operator: n23, operand: a7, prefix: true }, pos: i10 };
  }
  if (t6[s9] === "+" || t6[s9] === "-" || t6[s9] === "!" || t6[s9] === "~") {
    let n23 = t6[s9];
    s9++;
    let { expr: a7, pos: i10 } = ze(e7, t6, s9);
    return { expr: { type: "ArithUnary", operator: n23, operand: a7, prefix: true }, pos: i10 };
  }
  return Rr(e7, t6, s9);
}
function Pr(e7, t6) {
  let r8 = e7[t6];
  return r8 === "$" || r8 === "`";
}
function Rr(e7, t6, r8) {
  let { expr: s9, pos: n23 } = Mt(e7, t6, r8, false), a7 = [s9];
  for (; Pr(t6, n23); ) {
    let { expr: l8, pos: o9 } = Mt(e7, t6, n23, true);
    a7.push(l8), n23 = o9;
  }
  a7.length > 1 && (s9 = { type: "ArithConcat", parts: a7 });
  let i10;
  if (t6[n23] === "[" && s9.type === "ArithConcat") {
    n23++;
    let { expr: l8, pos: o9 } = Z2(e7, t6, n23);
    i10 = l8, n23 = o9, t6[n23] === "]" && n23++;
  }
  if (i10 && s9.type === "ArithConcat" && (s9 = { type: "ArithDynamicElement", nameExpr: s9, subscript: i10 }, i10 = void 0), n23 = $3(t6, n23), s9.type === "ArithConcat" || s9.type === "ArithVariable" || s9.type === "ArithDynamicElement") {
    for (let l8 of Pe) if (t6.slice(n23, n23 + l8.length) === l8 && t6.slice(n23, n23 + l8.length + 1) !== "==") {
      n23 += l8.length;
      let { expr: o9, pos: c15 } = ye(e7, t6, n23);
      return s9.type === "ArithDynamicElement" ? { expr: { type: "ArithDynamicAssignment", operator: l8, target: s9.nameExpr, subscript: s9.subscript, value: o9 }, pos: c15 } : s9.type === "ArithConcat" ? { expr: { type: "ArithDynamicAssignment", operator: l8, target: s9, value: o9 }, pos: c15 } : { expr: { type: "ArithAssignment", operator: l8, variable: s9.name, value: o9 }, pos: c15 };
    }
  }
  if (t6.slice(n23, n23 + 2) === "++" || t6.slice(n23, n23 + 2) === "--") {
    let l8 = t6.slice(n23, n23 + 2);
    return n23 += 2, { expr: { type: "ArithUnary", operator: l8, operand: s9, prefix: false }, pos: n23 };
  }
  return { expr: s9, pos: n23 };
}
function Mt(e7, t6, r8, s9 = false) {
  let n23 = $3(t6, r8), a7 = It(Z2, e7, t6, n23);
  if (a7) return a7;
  let i10 = vt(t6, n23);
  if (i10) return i10;
  let l8 = Dt(t6, n23);
  if (l8) return l8;
  if (t6.slice(n23, n23 + 2) === "$(" && t6[n23 + 2] !== "(") {
    n23 += 2;
    let c15 = 1, u11 = n23;
    for (; n23 < t6.length && c15 > 0; ) t6[n23] === "(" ? c15++ : t6[n23] === ")" && c15--, c15 > 0 && n23++;
    let f11 = t6.slice(u11, n23);
    return n23++, { expr: { type: "ArithCommandSubst", command: f11 }, pos: n23 };
  }
  if (t6[n23] === "`") {
    n23++;
    let c15 = n23;
    for (; n23 < t6.length && t6[n23] !== "`"; ) n23++;
    let u11 = t6.slice(c15, n23);
    return t6[n23] === "`" && n23++, { expr: { type: "ArithCommandSubst", command: u11 }, pos: n23 };
  }
  if (t6[n23] === "(") {
    n23++;
    let { expr: c15, pos: u11 } = Z2(e7, t6, n23);
    return n23 = $3(t6, u11), t6[n23] === ")" && n23++, { expr: { type: "ArithGroup", expression: c15 }, pos: n23 };
  }
  if (t6[n23] === "'") {
    n23++;
    let c15 = "";
    for (; n23 < t6.length && t6[n23] !== "'"; ) c15 += t6[n23], n23++;
    t6[n23] === "'" && n23++;
    let u11 = Number.parseInt(c15, 10);
    return { expr: { type: "ArithSingleQuote", content: c15, value: Number.isNaN(u11) ? 0 : u11 }, pos: n23 };
  }
  if (t6[n23] === '"') {
    n23++;
    let c15 = "";
    for (; n23 < t6.length && t6[n23] !== '"'; ) t6[n23] === "\\" && n23 + 1 < t6.length ? (c15 += t6[n23 + 1], n23 += 2) : (c15 += t6[n23], n23++);
    t6[n23] === '"' && n23++;
    let u11 = c15.trim();
    if (!u11) return { expr: { type: "ArithNumber", value: 0 }, pos: n23 };
    let { expr: f11 } = Z2(e7, u11, 0);
    return { expr: f11, pos: n23 };
  }
  if (/[0-9]/.test(t6[n23])) {
    let c15 = "", u11 = false, f11 = false;
    for (; n23 < t6.length; ) {
      let d16 = t6[n23];
      if (u11) if (/[0-9a-zA-Z@_]/.test(d16)) c15 += d16, n23++;
      else break;
      else if (d16 === "#") u11 = true, c15 += d16, n23++;
      else if (c15 === "0" && (d16 === "x" || d16 === "X") && n23 + 1 < t6.length && /[0-9a-fA-F]/.test(t6[n23 + 1])) f11 = true, c15 += d16, n23++;
      else if (f11 && /[0-9a-fA-F]/.test(d16)) c15 += d16, n23++;
      else if (!f11 && /[0-9]/.test(d16)) c15 += d16, n23++;
      else break;
    }
    if (n23 < t6.length && /[a-zA-Z_]/.test(t6[n23])) {
      let d16 = c15;
      for (; n23 < t6.length && /[a-zA-Z0-9_]/.test(t6[n23]); ) d16 += t6[n23], n23++;
      return { expr: { type: "ArithSyntaxError", errorToken: d16, message: `${d16}: value too great for base (error token is "${d16}")` }, pos: n23 };
    }
    if (t6[n23] === "." && /[0-9]/.test(t6[n23 + 1])) throw new p(`${c15}.${t6[n23 + 1]}...: syntax error: invalid arithmetic operator`);
    if (t6[n23] === "[") {
      let d16 = t6.slice(n23).trim();
      return { expr: { type: "ArithNumberSubscript", number: c15, errorToken: d16 }, pos: t6.length };
    }
    return { expr: { type: "ArithNumber", value: ge(c15) }, pos: n23 };
  }
  if (t6[n23] === "$" && t6[n23 + 1] === "{") {
    let c15 = n23 + 2, u11 = 1, f11 = c15;
    for (; f11 < t6.length && u11 > 0; ) t6[f11] === "{" ? u11++ : t6[f11] === "}" && u11--, u11 > 0 && f11++;
    let h17 = t6.slice(c15, f11), d16 = f11 + 1;
    if (t6[d16] === "#") {
      let m25 = d16 + 1;
      for (; m25 < t6.length && /[0-9a-zA-Z@_]/.test(t6[m25]); ) m25++;
      let g18 = t6.slice(d16 + 1, m25);
      return { expr: { type: "ArithDynamicBase", baseExpr: h17, value: g18 }, pos: m25 };
    }
    if (/[0-9]/.test(t6[d16]) || t6[d16] === "x" || t6[d16] === "X") {
      let m25 = d16;
      if (t6[d16] === "x" || t6[d16] === "X") for (m25++; m25 < t6.length && /[0-9a-fA-F]/.test(t6[m25]); ) m25++;
      else for (; m25 < t6.length && /[0-9]/.test(t6[m25]); ) m25++;
      let g18 = t6.slice(d16, m25);
      return { expr: { type: "ArithDynamicNumber", prefix: h17, suffix: g18 }, pos: m25 };
    }
    return n23 = d16, { expr: { type: "ArithBracedExpansion", content: h17 }, pos: n23 };
  }
  if (t6[n23] === "$" && n23 + 1 < t6.length && /[0-9]/.test(t6[n23 + 1])) {
    n23++;
    let c15 = "";
    for (; n23 < t6.length && /[0-9]/.test(t6[n23]); ) c15 += t6[n23], n23++;
    return { expr: { type: "ArithVariable", name: c15, hasDollarPrefix: true }, pos: n23 };
  }
  if (t6[n23] === "$" && n23 + 1 < t6.length && /[*@#?\-!$]/.test(t6[n23 + 1])) {
    let c15 = t6[n23 + 1];
    return n23 += 2, { expr: { type: "ArithSpecialVar", name: c15 }, pos: n23 };
  }
  let o9 = false;
  if (t6[n23] === "$" && n23 + 1 < t6.length && /[a-zA-Z_]/.test(t6[n23 + 1]) && (o9 = true, n23++), n23 < t6.length && /[a-zA-Z_]/.test(t6[n23])) {
    let c15 = "";
    for (; n23 < t6.length && /[a-zA-Z0-9_]/.test(t6[n23]); ) c15 += t6[n23], n23++;
    if (t6[n23] === "[" && !s9) {
      n23++;
      let u11;
      if (t6[n23] === "'" || t6[n23] === '"') {
        let h17 = t6[n23];
        for (n23++, u11 = ""; n23 < t6.length && t6[n23] !== h17; ) u11 += t6[n23], n23++;
        t6[n23] === h17 && n23++, n23 = $3(t6, n23), t6[n23] === "]" && n23++;
      }
      let f11;
      if (u11 === void 0) {
        let { expr: h17, pos: d16 } = Z2(e7, t6, n23);
        f11 = h17, n23 = d16, t6[n23] === "]" && n23++;
      }
      if (n23 = $3(t6, n23), t6[n23] === "[" && f11) return { expr: { type: "ArithDoubleSubscript", array: c15, index: f11 }, pos: n23 };
      if (!s9) {
        for (let h17 of Pe) if (t6.slice(n23, n23 + h17.length) === h17 && t6.slice(n23, n23 + h17.length + 1) !== "==") {
          n23 += h17.length;
          let { expr: d16, pos: m25 } = ye(e7, t6, n23);
          return { expr: { type: "ArithAssignment", operator: h17, variable: c15, subscript: f11, stringKey: u11, value: d16 }, pos: m25 };
        }
      }
      return { expr: { type: "ArithArrayElement", array: c15, index: f11, stringKey: u11 }, pos: n23 };
    }
    if (n23 = $3(t6, n23), !s9) {
      for (let u11 of Pe) if (t6.slice(n23, n23 + u11.length) === u11 && t6.slice(n23, n23 + u11.length + 1) !== "==") {
        n23 += u11.length;
        let { expr: f11, pos: h17 } = ye(e7, t6, n23);
        return { expr: { type: "ArithAssignment", operator: u11, variable: c15, value: f11 }, pos: h17 };
      }
    }
    return { expr: { type: "ArithVariable", name: c15, hasDollarPrefix: o9 }, pos: n23 };
  }
  if (t6[n23] === "#") {
    let c15 = n23 + 1;
    for (; c15 < t6.length && t6[c15] !== `
`; ) c15++;
    let u11 = t6.slice(n23, c15).trim() || "#";
    return { expr: { type: "ArithSyntaxError", errorToken: u11, message: `${u11}: syntax error: invalid arithmetic operator (error token is "${u11}")` }, pos: t6.length };
  }
  return { expr: { type: "ArithNumber", value: 0 }, pos: n23 };
}
function Bt(e7) {
  let t6 = e7.match(/^[a-zA-Z_][a-zA-Z0-9_]*/);
  if (!t6) return false;
  let r8 = e7.slice(t6[0].length);
  if (r8 === "" || r8 === "+") return true;
  if (r8[0] === "[") {
    let s9 = 0, n23 = 0;
    for (; n23 < r8.length; n23++) if (r8[n23] === "[") s9++;
    else if (r8[n23] === "]" && (s9--, s9 === 0)) break;
    if (s9 !== 0 || n23 >= r8.length) return false;
    let a7 = r8.slice(n23 + 1);
    return a7 === "" || a7 === "+";
  }
  return false;
}
function Ft(e7) {
  let t6 = 0;
  for (let r8 = 0; r8 < e7.length; r8++) {
    let s9 = e7[r8];
    if (s9 === "[") t6++;
    else if (s9 === "]") t6--;
    else {
      if (t6 === 0 && s9 === "=") return r8;
      if (t6 === 0 && s9 === "+" && e7[r8 + 1] === "=") return r8 + 1;
    }
  }
  return -1;
}
function xr(e7) {
  return /^[a-zA-Z_][a-zA-Z0-9_]*$/.test(e7);
}
function zt(e7) {
  return e7 === " " || e7 === "	" || e7 === `
` || e7 === ";" || e7 === "&" || e7 === "|" || e7 === "(" || e7 === ")" || e7 === "<" || e7 === ">";
}
function _r(e7) {
  let t6 = "", r8 = 0;
  for (; r8 < e7.length; ) {
    let s9 = e7[r8];
    if (s9 < 128) {
      t6 += String.fromCharCode(s9), r8++;
      continue;
    }
    if ((s9 & 224) === 192) {
      if (r8 + 1 < e7.length && (e7[r8 + 1] & 192) === 128 && s9 >= 194) {
        let n23 = (s9 & 31) << 6 | e7[r8 + 1] & 63;
        t6 += String.fromCharCode(n23), r8 += 2;
        continue;
      }
      t6 += String.fromCharCode(s9), r8++;
      continue;
    }
    if ((s9 & 240) === 224) {
      if (r8 + 2 < e7.length && (e7[r8 + 1] & 192) === 128 && (e7[r8 + 2] & 192) === 128) {
        if (s9 === 224 && e7[r8 + 1] < 160) {
          t6 += String.fromCharCode(s9), r8++;
          continue;
        }
        let n23 = (s9 & 15) << 12 | (e7[r8 + 1] & 63) << 6 | e7[r8 + 2] & 63;
        if (n23 >= 55296 && n23 <= 57343) {
          t6 += String.fromCharCode(s9), r8++;
          continue;
        }
        t6 += String.fromCharCode(n23), r8 += 3;
        continue;
      }
      t6 += String.fromCharCode(s9), r8++;
      continue;
    }
    if ((s9 & 248) === 240 && s9 <= 244) {
      if (r8 + 3 < e7.length && (e7[r8 + 1] & 192) === 128 && (e7[r8 + 2] & 192) === 128 && (e7[r8 + 3] & 192) === 128) {
        if (s9 === 240 && e7[r8 + 1] < 144) {
          t6 += String.fromCharCode(s9), r8++;
          continue;
        }
        let n23 = (s9 & 7) << 18 | (e7[r8 + 1] & 63) << 12 | (e7[r8 + 2] & 63) << 6 | e7[r8 + 3] & 63;
        if (n23 > 1114111) {
          t6 += String.fromCharCode(s9), r8++;
          continue;
        }
        t6 += String.fromCodePoint(n23), r8 += 4;
        continue;
      }
      t6 += String.fromCharCode(s9), r8++;
      continue;
    }
    t6 += String.fromCharCode(s9), r8++;
  }
  return t6;
}
function jt(e7, t6, r8) {
  let s9 = r8 + 1;
  for (; s9 < t6.length && /[a-zA-Z0-9_-]/.test(t6[s9]); ) s9++;
  return s9;
}
function Ue(e7, t6, r8, s9, n23) {
  let a7 = 1, i10 = r8 + 1;
  for (; i10 < t6.length && a7 > 0; ) t6[i10] === s9 ? a7++ : t6[i10] === n23 && a7--, a7 > 0 && i10++;
  return a7 === 0 ? i10 : -1;
}
function fe(e7, t6, r8) {
  let s9 = r8, n23 = 1;
  for (; s9 < t6.length && n23 > 0; ) {
    let a7 = t6[s9];
    if (a7 === "\\" && s9 + 1 < t6.length) {
      s9 += 2;
      continue;
    }
    if (a7 === "'") {
      let i10 = t6.indexOf("'", s9 + 1);
      if (i10 !== -1) {
        s9 = i10 + 1;
        continue;
      }
    }
    if (a7 === '"') {
      for (s9++; s9 < t6.length && t6[s9] !== '"'; ) t6[s9] === "\\" && s9 + 1 < t6.length ? s9 += 2 : s9++;
      s9 < t6.length && s9++;
      continue;
    }
    a7 === "{" ? n23++ : a7 === "}" && n23--, n23 > 0 && s9++;
  }
  return s9;
}
function Kt(e7, t6, r8) {
  let s9 = r8, n23 = false;
  for (; s9 < t6.length; ) {
    let a7 = t6[s9];
    if (a7 === "/" && n23 || a7 === "}") break;
    if (a7 === "'") {
      let i10 = t6.indexOf("'", s9 + 1);
      if (i10 !== -1) {
        s9 = i10 + 1, n23 = true;
        continue;
      }
    }
    if (a7 === '"') {
      for (s9++; s9 < t6.length && t6[s9] !== '"'; ) t6[s9] === "\\" && s9 + 1 < t6.length ? s9 += 2 : s9++;
      s9 < t6.length && s9++, n23 = true;
      continue;
    }
    a7 === "\\" ? (s9 += 2, n23 = true) : (s9++, n23 = true);
  }
  return s9;
}
function Xt(e7, t6, r8) {
  let s9 = r8, n23 = "";
  for (; s9 < t6.length; ) {
    let a7 = t6[s9];
    if (a7 === "*" || a7 === "?") n23 += a7, s9++;
    else if (a7 === "[") {
      let i10 = $r(t6, s9);
      i10 === -1 ? (n23 += a7, s9++) : (n23 += t6.slice(s9, i10 + 1), s9 = i10 + 1);
    } else break;
  }
  return { pattern: n23, endIndex: s9 };
}
function $r(e7, t6) {
  let r8 = t6 + 1;
  for (r8 < e7.length && e7[r8] === "^" && r8++, r8 < e7.length && e7[r8] === "]" && r8++; r8 < e7.length; ) {
    let s9 = e7[r8];
    if (s9 === "\\" && r8 + 1 < e7.length) {
      let n23 = e7[r8 + 1];
      if (n23 === '"' || n23 === "'") return -1;
      r8 += 2;
      continue;
    }
    if (s9 === "]") return r8;
    if (s9 === '"' || s9 === "$" || s9 === "`") return -1;
    if (s9 === "'") {
      let n23 = e7.indexOf("'", r8 + 1);
      if (n23 !== -1) {
        r8 = n23 + 1;
        continue;
      }
    }
    if (s9 === "[" && r8 + 1 < e7.length && e7[r8 + 1] === ":") {
      let n23 = e7.indexOf(":]", r8 + 2);
      if (n23 !== -1) {
        r8 = n23 + 2;
        continue;
      }
    }
    if (s9 === "[" && r8 + 1 < e7.length && (e7[r8 + 1] === "." || e7[r8 + 1] === "=")) {
      let a7 = `${e7[r8 + 1]}]`, i10 = e7.indexOf(a7, r8 + 2);
      if (i10 !== -1) {
        r8 = i10 + 2;
        continue;
      }
    }
    r8++;
  }
  return -1;
}
function Jt(e7, t6, r8) {
  let s9 = "", n23 = r8;
  for (; n23 < t6.length && t6[n23] !== "'"; ) {
    let a7 = t6[n23];
    if (a7 === "\\" && n23 + 1 < t6.length) switch (t6[n23 + 1]) {
      case "n":
        s9 += `
`, n23 += 2;
        break;
      case "t":
        s9 += "	", n23 += 2;
        break;
      case "r":
        s9 += "\r", n23 += 2;
        break;
      case "\\":
        s9 += "\\", n23 += 2;
        break;
      case "'":
        s9 += "'", n23 += 2;
        break;
      case '"':
        s9 += '"', n23 += 2;
        break;
      case "a":
        s9 += "\x07", n23 += 2;
        break;
      case "b":
        s9 += "\b", n23 += 2;
        break;
      case "e":
      case "E":
        s9 += "\x1B", n23 += 2;
        break;
      case "f":
        s9 += "\f", n23 += 2;
        break;
      case "v":
        s9 += "\v", n23 += 2;
        break;
      case "x": {
        let l8 = [], o9 = n23;
        for (; o9 + 1 < t6.length && t6[o9] === "\\" && t6[o9 + 1] === "x"; ) {
          let c15 = t6.slice(o9 + 2, o9 + 4), u11 = parseInt(c15, 16);
          if (!Number.isNaN(u11) && c15.length > 0) l8.push(u11), o9 += 2 + c15.length;
          else break;
        }
        l8.length > 0 ? (s9 += _r(l8), n23 = o9) : (s9 += "\\x", n23 += 2);
        break;
      }
      case "u": {
        let l8 = t6.slice(n23 + 2, n23 + 6), o9 = parseInt(l8, 16);
        Number.isNaN(o9) ? (s9 += "\\u", n23 += 2) : (s9 += String.fromCharCode(o9), n23 += 6);
        break;
      }
      case "c": {
        if (n23 + 2 < t6.length) {
          let o9 = t6[n23 + 2].charCodeAt(0) & 31;
          s9 += String.fromCharCode(o9), n23 += 3;
        } else s9 += "\\c", n23 += 2;
        break;
      }
      case "0":
      case "1":
      case "2":
      case "3":
      case "4":
      case "5":
      case "6":
      case "7": {
        let l8 = "", o9 = n23 + 1;
        for (; o9 < t6.length && o9 < n23 + 4 && /[0-7]/.test(t6[o9]); ) l8 += t6[o9], o9++;
        let c15 = parseInt(l8, 8);
        s9 += String.fromCharCode(c15), n23 = o9;
        break;
      }
      default:
        s9 += a7, n23++;
    }
    else s9 += a7, n23++;
  }
  return n23 < t6.length && t6[n23] === "'" && n23++, { part: w2.literal(s9), endIndex: n23 };
}
function He(e7, t6) {
  let r8 = t6.trim();
  return r8 === "" ? { type: "ArithmeticExpression", expression: { type: "ArithNumber", value: 0 } } : M2(e7, r8);
}
function Ht(e7) {
  let t6 = [], r8 = "", s9 = 0;
  for (let n23 = 0; n23 < e7.length; n23++) {
    let a7 = e7[n23];
    a7 === "{" ? (s9++, r8 += a7) : a7 === "}" ? (s9--, r8 += a7) : a7 === "," && s9 === 0 ? (t6.push(r8), r8 = "") : r8 += a7;
  }
  return t6.push(r8), t6;
}
function Yt(e7, t6, r8, s9) {
  let n23 = Ue(e7, t6, r8, "{", "}");
  if (n23 === -1) return null;
  let a7 = t6.slice(r8 + 1, n23), i10 = a7.match(/^(-?\d+)\.\.(-?\d+)(?:\.\.(-?\d+))?$/);
  if (i10) return { part: { type: "BraceExpansion", items: [{ type: "Range", start: Number.parseInt(i10[1], 10), end: Number.parseInt(i10[2], 10), step: i10[3] ? Number.parseInt(i10[3], 10) : void 0, startStr: i10[1], endStr: i10[2] }] }, endIndex: n23 + 1 };
  let l8 = a7.match(/^([a-zA-Z])\.\.([a-zA-Z])(?:\.\.(-?\d+))?$/);
  return l8 ? { part: { type: "BraceExpansion", items: [{ type: "Range", start: l8[1], end: l8[2], step: l8[3] ? Number.parseInt(l8[3], 10) : void 0 }] }, endIndex: n23 + 1 } : a7.includes(",") && s9 ? { part: { type: "BraceExpansion", items: Ht(a7).map((u11) => ({ type: "Word", word: w2.word(s9(e7, u11, false, false, false)) })) }, endIndex: n23 + 1 } : a7.includes(",") ? { part: { type: "BraceExpansion", items: Ht(a7).map((u11) => ({ type: "Word", word: w2.word([w2.literal(u11)]) })) }, endIndex: n23 + 1 } : null;
}
function je(e7, t6) {
  let r8 = "";
  for (let s9 of t6.parts) switch (s9.type) {
    case "Literal":
      r8 += s9.value;
      break;
    case "SingleQuoted":
      r8 += `'${s9.value}'`;
      break;
    case "Escaped":
      r8 += s9.value;
      break;
    case "DoubleQuoted":
      r8 += '"';
      for (let n23 of s9.parts) n23.type === "Literal" || n23.type === "Escaped" ? r8 += n23.value : n23.type === "ParameterExpansion" && (r8 += `\${${n23.parameter}}`);
      r8 += '"';
      break;
    case "ParameterExpansion":
      r8 += `\${${s9.parameter}}`;
      break;
    case "Glob":
      r8 += s9.pattern;
      break;
    case "TildeExpansion":
      r8 += "~", s9.user && (r8 += s9.user);
      break;
    case "BraceExpansion": {
      r8 += "{";
      let n23 = [];
      for (let a7 of s9.items) if (a7.type === "Range") {
        let i10 = a7.startStr ?? String(a7.start), l8 = a7.endStr ?? String(a7.end);
        a7.step !== void 0 ? n23.push(`${i10}..${l8}..${a7.step}`) : n23.push(`${i10}..${l8}`);
      } else n23.push(je(e7, a7.word));
      n23.length === 1 && s9.items[0].type === "Range" ? r8 += n23[0] : r8 += n23.join(","), r8 += "}";
      break;
    }
    default:
      r8 += s9.type;
  }
  return r8;
}
function en(e7, t6) {
  return { [p2.LESS]: "<", [p2.GREAT]: ">", [p2.DGREAT]: ">>", [p2.LESSAND]: "<&", [p2.GREATAND]: ">&", [p2.LESSGREAT]: "<>", [p2.CLOBBER]: ">|", [p2.TLESS]: "<<<", [p2.AND_GREAT]: "&>", [p2.AND_DGREAT]: "&>>", [p2.DLESS]: "<", [p2.DLESSDASH]: "<" }[t6] || ">";
}
function ve(e7) {
  let t6 = e7.current(), r8 = t6.type;
  if (r8 === p2.NUMBER) {
    let s9 = e7.peek(1);
    return t6.end !== s9.start ? false : Zt.has(s9.type);
  }
  if (r8 === p2.FD_VARIABLE) {
    let s9 = e7.peek(1);
    return Ut.has(s9.type);
  }
  return Gt.has(r8);
}
function De(e7) {
  let t6 = null, r8;
  e7.check(p2.NUMBER) ? t6 = Number.parseInt(e7.advance().value, 10) : e7.check(p2.FD_VARIABLE) && (r8 = e7.advance().value);
  let s9 = e7.advance(), n23 = en(e7, s9.type);
  if (s9.type === p2.DLESS || s9.type === p2.DLESSDASH) return Cr(e7, n23, t6, s9.type === p2.DLESSDASH);
  e7.isWord() || e7.error("Expected redirection target");
  let a7 = e7.parseWord();
  return w2.redirection(n23, a7, t6, r8);
}
function Cr(e7, t6, r8, s9) {
  e7.isWord() || e7.error("Expected here-document delimiter");
  let n23 = e7.advance(), a7 = n23.value, i10 = n23.quoted || false;
  (a7.startsWith("'") && a7.endsWith("'") || a7.startsWith('"') && a7.endsWith('"')) && (a7 = a7.slice(1, -1));
  let l8 = w2.redirection(s9 ? "<<-" : "<<", w2.hereDoc(a7, w2.word([]), s9, i10), r8);
  return e7.addPendingHeredoc(l8, a7, s9, i10), l8;
}
function nn(e7) {
  let t6 = e7.current().line, r8 = [], s9 = null, n23 = [], a7 = [];
  for (; e7.check(p2.ASSIGNMENT_WORD) || ve(e7); ) e7.checkIterationLimit(), e7.check(p2.ASSIGNMENT_WORD) ? r8.push(Or(e7)) : a7.push(De(e7));
  if (e7.isWord()) s9 = e7.parseWord();
  else if (r8.length > 0 && (e7.check(p2.DBRACK_START) || e7.check(p2.DPAREN_START))) {
    let l8 = e7.advance();
    s9 = w2.word([w2.literal(l8.value)]);
  }
  for (; (!e7.isStatementEnd() || e7.check(p2.RBRACE)) && !e7.check(p2.PIPE, p2.PIPE_AMP); ) if (e7.checkIterationLimit(), ve(e7)) a7.push(De(e7));
  else if (e7.check(p2.RBRACE)) {
    let l8 = e7.advance();
    n23.push(e7.parseWordFromString(l8.value, false, false));
  } else if (e7.check(p2.LBRACE)) {
    let l8 = e7.advance();
    n23.push(e7.parseWordFromString(l8.value, false, false));
  } else if (e7.check(p2.DBRACK_END)) {
    let l8 = e7.advance();
    n23.push(e7.parseWordFromString(l8.value, false, false));
  } else if (e7.isWord()) n23.push(e7.parseWord());
  else if (e7.check(p2.ASSIGNMENT_WORD)) {
    let l8 = e7.advance(), o9 = l8.value, c15 = o9.endsWith("="), u11 = o9.endsWith("=(");
    if ((c15 || u11) && (u11 || e7.check(p2.LPAREN))) {
      let f11 = u11 ? o9.slice(0, -2) : o9.slice(0, -1);
      u11 || e7.expect(p2.LPAREN);
      let h17 = Ke(e7);
      e7.expect(p2.RPAREN);
      let d16 = h17.map((g18) => je(e7, g18)), m25 = `${f11}=(${d16.join(" ")})`;
      n23.push(e7.parseWordFromString(m25, false, false));
    } else n23.push(e7.parseWordFromString(o9, l8.quoted, l8.singleQuoted));
  } else if (e7.check(p2.LPAREN)) e7.error("syntax error near unexpected token `('");
  else break;
  let i10 = w2.simpleCommand(s9, n23, r8, a7);
  return i10.line = t6, i10;
}
function Or(e7) {
  let t6 = e7.expect(p2.ASSIGNMENT_WORD), r8 = t6.value, s9 = r8.match(/^[a-zA-Z_][a-zA-Z0-9_]*/);
  s9 || e7.error(`Invalid assignment: ${r8}`);
  let n23 = s9[0], a7, i10 = n23.length;
  if (r8[i10] === "[") {
    let f11 = 0, h17 = i10 + 1;
    for (; i10 < r8.length; i10++) if (r8[i10] === "[") f11++;
    else if (r8[i10] === "]" && (f11--, f11 === 0)) break;
    f11 !== 0 && e7.error(`Invalid assignment: ${r8}`), a7 = r8.slice(h17, i10), i10++;
  }
  let l8 = r8[i10] === "+";
  l8 && i10++, r8[i10] !== "=" && e7.error(`Invalid assignment: ${r8}`), i10++;
  let o9 = r8.slice(i10);
  if (o9 === "(") {
    let f11 = Ke(e7);
    e7.expect(p2.RPAREN);
    let h17 = a7 !== void 0 ? `${n23}[${a7}]` : n23;
    return w2.assignment(h17, null, l8, f11);
  }
  if (o9 === "" && e7.check(p2.LPAREN)) {
    let f11 = e7.current();
    if (t6.end === f11.start) {
      e7.advance();
      let h17 = Ke(e7);
      e7.expect(p2.RPAREN);
      let d16 = a7 !== void 0 ? `${n23}[${a7}]` : n23;
      return w2.assignment(d16, null, l8, h17);
    }
  }
  let c15 = o9 ? e7.parseWordFromString(o9, t6.quoted, t6.singleQuoted, true) : null, u11 = a7 !== void 0 ? `${n23}[${a7}]` : n23;
  return w2.assignment(u11, c15, l8, null);
}
function Ke(e7) {
  let t6 = [];
  for (e7.skipNewlines(); !e7.check(p2.RPAREN, p2.EOF); ) e7.checkIterationLimit(), e7.isWord() ? t6.push(e7.parseWord()) : Lr.has(e7.current().type) ? e7.error(`syntax error near unexpected token \`${e7.current().value}'`) : e7.advance(), e7.skipNewlines();
  return t6;
}
function Xe(e7, t6) {
  e7.expect(p2.IF);
  let r8 = [], s9 = e7.parseCompoundList();
  e7.expect(p2.THEN);
  let n23 = e7.parseCompoundList();
  if (n23.length === 0) {
    let l8 = e7.check(p2.FI) ? "fi" : e7.check(p2.ELSE) ? "else" : e7.check(p2.ELIF) ? "elif" : "fi";
    e7.error(`syntax error near unexpected token \`${l8}'`);
  }
  for (r8.push({ condition: s9, body: n23 }); e7.check(p2.ELIF); ) {
    e7.advance();
    let l8 = e7.parseCompoundList();
    e7.expect(p2.THEN);
    let o9 = e7.parseCompoundList();
    if (o9.length === 0) {
      let c15 = e7.check(p2.FI) ? "fi" : e7.check(p2.ELSE) ? "else" : e7.check(p2.ELIF) ? "elif" : "fi";
      e7.error(`syntax error near unexpected token \`${c15}'`);
    }
    r8.push({ condition: l8, body: o9 });
  }
  let a7 = null;
  e7.check(p2.ELSE) && (e7.advance(), a7 = e7.parseCompoundList(), a7.length === 0 && e7.error("syntax error near unexpected token `fi'")), e7.expect(p2.FI);
  let i10 = t6?.skipRedirections ? [] : e7.parseOptionalRedirections();
  return w2.ifNode(r8, a7, i10);
}
function Je(e7, t6) {
  let r8 = e7.expect(p2.FOR);
  if (e7.check(p2.DPAREN_START)) return Tr(e7, t6, r8.line);
  e7.isWord() || e7.error("Expected variable name in for loop");
  let n23 = e7.advance().value, a7 = null;
  if (e7.skipNewlines(), e7.check(p2.IN)) for (e7.advance(), a7 = []; !e7.check(p2.SEMICOLON, p2.NEWLINE, p2.DO, p2.EOF) && e7.isWord(); ) a7.push(e7.parseWord());
  e7.check(p2.SEMICOLON) && e7.advance(), e7.skipNewlines(), e7.expect(p2.DO);
  let i10 = e7.parseCompoundList();
  e7.expect(p2.DONE);
  let l8 = t6?.skipRedirections ? [] : e7.parseOptionalRedirections();
  return w2.forNode(n23, a7, i10, l8);
}
function Tr(e7, t6, r8) {
  e7.expect(p2.DPAREN_START);
  let s9 = null, n23 = null, a7 = null, i10 = ["", "", ""], l8 = 0, o9 = 0;
  for (; !e7.check(p2.DPAREN_END, p2.EOF); ) {
    let f11 = e7.advance();
    if (f11.type === p2.SEMICOLON && o9 === 0) {
      if (l8++, l8 > 2) break;
    } else f11.value === "(" && o9++, f11.value === ")" && o9--, i10[l8] += f11.value;
  }
  e7.expect(p2.DPAREN_END), i10[0].trim() && (s9 = M2(e7, i10[0].trim())), i10[1].trim() && (n23 = M2(e7, i10[1].trim())), i10[2].trim() && (a7 = M2(e7, i10[2].trim())), e7.skipNewlines(), e7.check(p2.SEMICOLON) && e7.advance(), e7.skipNewlines();
  let c15;
  e7.check(p2.LBRACE) ? (e7.advance(), c15 = e7.parseCompoundList(), e7.expect(p2.RBRACE)) : (e7.expect(p2.DO), c15 = e7.parseCompoundList(), e7.expect(p2.DONE));
  let u11 = t6?.skipRedirections ? [] : e7.parseOptionalRedirections();
  return { type: "CStyleFor", init: s9, condition: n23, update: a7, body: c15, redirections: u11, line: r8 };
}
function Ye(e7, t6) {
  e7.expect(p2.WHILE);
  let r8 = e7.parseCompoundList();
  e7.expect(p2.DO);
  let s9 = e7.parseCompoundList();
  s9.length === 0 && e7.error("syntax error near unexpected token `done'"), e7.expect(p2.DONE);
  let n23 = t6?.skipRedirections ? [] : e7.parseOptionalRedirections();
  return w2.whileNode(r8, s9, n23);
}
function et(e7, t6) {
  e7.expect(p2.UNTIL);
  let r8 = e7.parseCompoundList();
  e7.expect(p2.DO);
  let s9 = e7.parseCompoundList();
  s9.length === 0 && e7.error("syntax error near unexpected token `done'"), e7.expect(p2.DONE);
  let n23 = t6?.skipRedirections ? [] : e7.parseOptionalRedirections();
  return w2.untilNode(r8, s9, n23);
}
function tt(e7, t6) {
  e7.expect(p2.CASE), e7.isWord() || e7.error("Expected word after 'case'");
  let r8 = e7.parseWord();
  e7.skipNewlines(), e7.expect(p2.IN), e7.skipNewlines();
  let s9 = [];
  for (; !e7.check(p2.ESAC, p2.EOF); ) {
    e7.checkIterationLimit();
    let a7 = e7.getPos(), i10 = Mr(e7);
    if (i10 && s9.push(i10), e7.skipNewlines(), e7.getPos() === a7 && !i10) break;
  }
  e7.expect(p2.ESAC);
  let n23 = t6?.skipRedirections ? [] : e7.parseOptionalRedirections();
  return w2.caseNode(r8, s9, n23);
}
function Mr(e7) {
  e7.check(p2.LPAREN) && e7.advance();
  let t6 = [];
  for (; e7.isWord() && (t6.push(e7.parseWord()), e7.check(p2.PIPE)); ) e7.advance();
  if (t6.length === 0) return null;
  e7.expect(p2.RPAREN), e7.skipNewlines();
  let r8 = [];
  for (; !e7.check(p2.DSEMI, p2.SEMI_AND, p2.SEMI_SEMI_AND, p2.ESAC, p2.EOF); ) {
    e7.checkIterationLimit(), e7.isWord() && e7.peek(1).type === p2.RPAREN && e7.error("syntax error near unexpected token `)'"), e7.check(p2.LPAREN) && e7.peek(1).type === p2.WORD && e7.error(`syntax error near unexpected token \`${e7.peek(1).value}'`);
    let n23 = e7.getPos(), a7 = e7.parseStatement();
    if (a7 && r8.push(a7), e7.skipSeparators(false), e7.getPos() === n23 && !a7) break;
  }
  let s9 = ";;";
  return e7.check(p2.DSEMI) ? (e7.advance(), s9 = ";;") : e7.check(p2.SEMI_AND) ? (e7.advance(), s9 = ";&") : e7.check(p2.SEMI_SEMI_AND) && (e7.advance(), s9 = ";;&"), w2.caseItem(t6, r8, s9);
}
function nt(e7, t6) {
  e7.expect(p2.LPAREN);
  let r8 = e7.parseCompoundList();
  e7.expect(p2.RPAREN);
  let s9 = t6?.skipRedirections ? [] : e7.parseOptionalRedirections();
  return w2.subshell(r8, s9);
}
function rt(e7, t6) {
  e7.expect(p2.LBRACE);
  let r8 = e7.parseCompoundList();
  e7.expect(p2.RBRACE);
  let s9 = t6?.skipRedirections ? [] : e7.parseOptionalRedirections();
  return w2.group(r8, s9);
}
function rn(e7) {
  return e7.isWord() || e7.check(p2.LBRACE) || e7.check(p2.RBRACE) || e7.check(p2.ASSIGNMENT_WORD);
}
function sn(e7) {
  if (e7.check(p2.BANG) && e7.peek(1).type === p2.LPAREN) {
    e7.advance(), e7.advance();
    let t6 = 1, r8 = "!(";
    for (; t6 > 0 && !e7.check(p2.EOF); ) if (e7.check(p2.LPAREN)) t6++, r8 += "(", e7.advance();
    else if (e7.check(p2.RPAREN)) t6--, t6 > 0 && (r8 += ")"), e7.advance();
    else if (e7.isWord()) r8 += e7.advance().value;
    else if (e7.check(p2.PIPE)) r8 += "|", e7.advance();
    else break;
    return r8 += ")", e7.parseWordFromString(r8, false, false, false, false, true);
  }
  return e7.parseWordNoBraceExpansion();
}
function it(e7) {
  return e7.skipNewlines(), Fr(e7);
}
function Fr(e7) {
  let t6 = an(e7);
  for (e7.skipNewlines(); e7.check(p2.OR_OR); ) {
    e7.advance(), e7.skipNewlines();
    let r8 = an(e7);
    t6 = { type: "CondOr", left: t6, right: r8 }, e7.skipNewlines();
  }
  return t6;
}
function an(e7) {
  let t6 = st(e7);
  for (e7.skipNewlines(); e7.check(p2.AND_AND); ) {
    e7.advance(), e7.skipNewlines();
    let r8 = st(e7);
    t6 = { type: "CondAnd", left: t6, right: r8 }, e7.skipNewlines();
  }
  return t6;
}
function st(e7) {
  return e7.skipNewlines(), e7.check(p2.BANG) ? (e7.advance(), e7.skipNewlines(), { type: "CondNot", operand: st(e7) }) : zr(e7);
}
function zr(e7) {
  if (e7.check(p2.LPAREN)) {
    e7.advance();
    let t6 = it(e7);
    return e7.expect(p2.RPAREN), { type: "CondGroup", expression: t6 };
  }
  if (rn(e7)) {
    let t6 = e7.current(), r8 = t6.value;
    if (qr.includes(r8) && !t6.quoted) {
      if (e7.advance(), e7.check(p2.DBRACK_END) && e7.error(`Expected operand after ${r8}`), rn(e7)) {
        let a7 = e7.parseWordNoBraceExpansion();
        return { type: "CondUnary", operator: r8, operand: a7 };
      }
      let n23 = e7.current();
      e7.error(`unexpected argument \`${n23.value}' to conditional unary operator`);
    }
    let s9 = e7.parseWordNoBraceExpansion();
    if (e7.isWord() && Br.includes(e7.current().value)) {
      let n23 = e7.advance().value, a7;
      return n23 === "=~" ? a7 = Qr(e7) : n23 === "==" || n23 === "!=" ? a7 = sn(e7) : a7 = e7.parseWordNoBraceExpansion(), { type: "CondBinary", operator: n23, left: s9, right: a7 };
    }
    if (e7.check(p2.LESS)) {
      e7.advance();
      let n23 = e7.parseWordNoBraceExpansion();
      return { type: "CondBinary", operator: "<", left: s9, right: n23 };
    }
    if (e7.check(p2.GREAT)) {
      e7.advance();
      let n23 = e7.parseWordNoBraceExpansion();
      return { type: "CondBinary", operator: ">", left: s9, right: n23 };
    }
    if (e7.isWord() && e7.current().value === "=") {
      e7.advance();
      let n23 = sn(e7);
      return { type: "CondBinary", operator: "==", left: s9, right: n23 };
    }
    return { type: "CondWord", word: s9 };
  }
  e7.error("Expected conditional expression");
}
function Qr(e7) {
  let t6 = [], r8 = 0, s9 = -1, n23 = e7.getInput(), a7 = () => e7.check(p2.DBRACK_END) || e7.check(p2.AND_AND) || e7.check(p2.OR_OR) || e7.check(p2.NEWLINE) || e7.check(p2.EOF);
  for (; !a7(); ) {
    let i10 = e7.current(), l8 = s9 >= 0 && i10.start > s9;
    if (r8 === 0 && l8) break;
    if (r8 > 0 && l8) {
      let o9 = n23.slice(s9, i10.start);
      t6.push({ type: "Literal", value: o9 });
    }
    if (e7.isWord() || e7.check(p2.ASSIGNMENT_WORD)) {
      let o9 = e7.parseWordForRegex();
      t6.push(...o9.parts), s9 = e7.peek(-1).end;
    } else if (e7.check(p2.LPAREN)) {
      let o9 = e7.advance();
      t6.push({ type: "Literal", value: "(" }), r8++, s9 = o9.end;
    } else if (e7.check(p2.DPAREN_START)) {
      let o9 = e7.advance();
      t6.push({ type: "Literal", value: "((" }), r8 += 2, s9 = o9.end;
    } else if (e7.check(p2.DPAREN_END)) if (r8 >= 2) {
      let o9 = e7.advance();
      t6.push({ type: "Literal", value: "))" }), r8 -= 2, s9 = o9.end;
    } else {
      if (r8 === 1) break;
      break;
    }
    else if (e7.check(p2.RPAREN)) if (r8 > 0) {
      let o9 = e7.advance();
      t6.push({ type: "Literal", value: ")" }), r8--, s9 = o9.end;
    } else break;
    else if (e7.check(p2.PIPE)) {
      let o9 = e7.advance();
      t6.push({ type: "Literal", value: "|" }), s9 = o9.end;
    } else if (e7.check(p2.SEMICOLON)) if (r8 > 0) {
      let o9 = e7.advance();
      t6.push({ type: "Literal", value: ";" }), s9 = o9.end;
    } else break;
    else if (r8 > 0 && e7.check(p2.LESS)) {
      let o9 = e7.advance();
      t6.push({ type: "Literal", value: "<" }), s9 = o9.end;
    } else if (r8 > 0 && e7.check(p2.GREAT)) {
      let o9 = e7.advance();
      t6.push({ type: "Literal", value: ">" }), s9 = o9.end;
    } else if (r8 > 0 && e7.check(p2.DGREAT)) {
      let o9 = e7.advance();
      t6.push({ type: "Literal", value: ">>" }), s9 = o9.end;
    } else if (r8 > 0 && e7.check(p2.DLESS)) {
      let o9 = e7.advance();
      t6.push({ type: "Literal", value: "<<" }), s9 = o9.end;
    } else if (r8 > 0 && e7.check(p2.LESSAND)) {
      let o9 = e7.advance();
      t6.push({ type: "Literal", value: "<&" }), s9 = o9.end;
    } else if (r8 > 0 && e7.check(p2.GREATAND)) {
      let o9 = e7.advance();
      t6.push({ type: "Literal", value: ">&" }), s9 = o9.end;
    } else if (r8 > 0 && e7.check(p2.LESSGREAT)) {
      let o9 = e7.advance();
      t6.push({ type: "Literal", value: "<>" }), s9 = o9.end;
    } else if (r8 > 0 && e7.check(p2.CLOBBER)) {
      let o9 = e7.advance();
      t6.push({ type: "Literal", value: ">|" }), s9 = o9.end;
    } else if (r8 > 0 && e7.check(p2.TLESS)) {
      let o9 = e7.advance();
      t6.push({ type: "Literal", value: "<<<" }), s9 = o9.end;
    } else if (r8 > 0 && e7.check(p2.AMP)) {
      let o9 = e7.advance();
      t6.push({ type: "Literal", value: "&" }), s9 = o9.end;
    } else if (r8 > 0 && e7.check(p2.LBRACE)) {
      let o9 = e7.advance();
      t6.push({ type: "Literal", value: "{" }), s9 = o9.end;
    } else if (r8 > 0 && e7.check(p2.RBRACE)) {
      let o9 = e7.advance();
      t6.push({ type: "Literal", value: "}" }), s9 = o9.end;
    } else break;
  }
  return t6.length === 0 && e7.error("Expected regex pattern after =~"), { type: "Word", parts: t6 };
}
function Zr(e7, t6) {
  let r8 = 1, s9 = t6 + 1;
  for (; s9 < e7.length && r8 > 0; ) {
    let n23 = e7[s9];
    if (n23 === "\\") {
      s9 += 2;
      continue;
    }
    if ("@*+?!".includes(n23) && s9 + 1 < e7.length && e7[s9 + 1] === "(") {
      s9++, r8++, s9++;
      continue;
    }
    if (n23 === "(") r8++;
    else if (n23 === ")" && (r8--, r8 === 0)) return s9;
    s9++;
  }
  return -1;
}
function Ur(e7, t6, r8) {
  let s9 = r8 + 1, n23 = t6[s9];
  if ("@*#?$!-0123456789".includes(n23)) return { part: w2.parameterExpansion(n23), endIndex: s9 + 1 };
  let a7 = "";
  for (; s9 < t6.length && /[a-zA-Z0-9_]/.test(t6[s9]); ) a7 += t6[s9], s9++;
  return { part: w2.parameterExpansion(a7), endIndex: s9 };
}
function Hr(e7, t6, r8, s9 = false) {
  let n23 = r8 + 2, a7 = false;
  t6[n23] === "!" && (a7 = true, n23++);
  let i10 = false;
  t6[n23] === "#" && !/[}:#%/^,]/.test(t6[n23 + 1] || "}") && (i10 = true, n23++);
  let l8 = "", o9 = t6[n23];
  if (/[@*#?$!-]/.test(o9) && !/[a-zA-Z0-9_]/.test(t6[n23 + 1] || "")) l8 = o9, n23++;
  else for (; n23 < t6.length && /[a-zA-Z0-9_]/.test(t6[n23]); ) l8 += t6[n23], n23++;
  if (t6[n23] === "[") {
    let u11 = Ue(e7, t6, n23, "[", "]");
    if (l8 += t6.slice(n23, u11 + 1), n23 = u11 + 1, t6[n23] === "[") {
      let f11 = 1, h17 = n23;
      for (; h17 < t6.length && f11 > 0; ) t6[h17] === "{" ? f11++ : t6[h17] === "}" && f11--, f11 > 0 && h17++;
      let d16 = t6.slice(r8 + 2, h17);
      return { part: w2.parameterExpansion("", { type: "BadSubstitution", text: d16 }), endIndex: h17 + 1 };
    }
  }
  if (l8 === "" && !a7 && !i10 && t6[n23] !== "}") {
    let u11 = 1, f11 = n23;
    for (; f11 < t6.length && u11 > 0; ) t6[f11] === "{" ? u11++ : t6[f11] === "}" && u11--, u11 > 0 && f11++;
    if (u11 > 0) throw new Q2("unexpected EOF while looking for matching '}'", 0, 0);
    let h17 = t6.slice(r8 + 2, f11);
    return { part: w2.parameterExpansion("", { type: "BadSubstitution", text: h17 }), endIndex: f11 + 1 };
  }
  let c15 = null;
  if (a7) {
    let u11 = l8.match(/^([a-zA-Z_][a-zA-Z0-9_]*)\[([@*])\]$/);
    if (u11) if (n23 < t6.length && t6[n23] !== "}" && /[:=\-+?#%/^,@]/.test(t6[n23])) {
      let f11 = at(e7, t6, n23, l8, s9);
      f11.operation ? (c15 = { type: "Indirection", innerOp: f11.operation }, n23 = f11.endIndex) : (c15 = { type: "ArrayKeys", array: u11[1], star: u11[2] === "*" }, l8 = "");
    } else c15 = { type: "ArrayKeys", array: u11[1], star: u11[2] === "*" }, l8 = "";
    else if (t6[n23] === "*" || t6[n23] === "@" && !/[QPaAEKkuUL]/.test(t6[n23 + 1] || "")) {
      let f11 = t6[n23];
      n23++, c15 = { type: "VarNamePrefix", prefix: l8, star: f11 === "*" }, l8 = "";
    } else if (n23 < t6.length && t6[n23] !== "}" && /[:=\-+?#%/^,@]/.test(t6[n23])) {
      let f11 = at(e7, t6, n23, l8, s9);
      f11.operation ? (c15 = { type: "Indirection", innerOp: f11.operation }, n23 = f11.endIndex) : c15 = { type: "Indirection" };
    } else c15 = { type: "Indirection" };
  } else if (i10) if (t6[n23] === ":") for (c15 = { type: "LengthSliceError" }; n23 < t6.length && t6[n23] !== "}"; ) n23++;
  else t6[n23] !== "}" && /[-+=?]/.test(t6[n23]) ? e7.error(`\${#${l8}${t6.slice(n23, t6.indexOf("}", n23))}}: bad substitution`) : t6[n23] === "/" ? e7.error(`\${#${l8}${t6.slice(n23, t6.indexOf("}", n23))}}: bad substitution`) : c15 = { type: "Length" };
  if (!c15 && n23 < t6.length && t6[n23] !== "}") {
    let u11 = at(e7, t6, n23, l8, s9);
    c15 = u11.operation, n23 = u11.endIndex;
  }
  if (n23 < t6.length && t6[n23] !== "}") {
    let u11 = t6[n23];
    if (!/[:\-+=?#%/^,@[]/.test(u11)) {
      let f11 = n23;
      for (; f11 < t6.length && t6[f11] !== "}"; ) f11++;
      let h17 = t6.slice(r8, f11 + 1);
      e7.error(`\${${h17.slice(2, -1)}}: bad substitution`);
    }
  }
  for (; n23 < t6.length && t6[n23] !== "}"; ) n23++;
  if (n23 >= t6.length) throw new Q2("unexpected EOF while looking for matching '}'", 0, 0);
  return { part: w2.parameterExpansion(l8, c15), endIndex: n23 + 1 };
}
function at(e7, t6, r8, s9, n23 = false) {
  let a7 = r8, i10 = t6[a7], l8 = t6[a7 + 1] || "";
  if (i10 === ":") {
    let o9 = l8;
    if ("-=?+".includes(o9)) {
      a7 += 2;
      let A14 = fe(e7, t6, a7), S17 = t6.slice(a7, A14), y18 = ae(e7, S17, false, false, true, false, n23, false, false, true), b25 = w2.word(y18.length > 0 ? y18 : [w2.literal("")]);
      if (o9 === "-") return { operation: { type: "DefaultValue", word: b25, checkEmpty: true }, endIndex: A14 };
      if (o9 === "=") return { operation: { type: "AssignDefault", word: b25, checkEmpty: true }, endIndex: A14 };
      if (o9 === "?") return { operation: { type: "ErrorIfUnset", word: b25, checkEmpty: true }, endIndex: A14 };
      if (o9 === "+") return { operation: { type: "UseAlternative", word: b25, checkEmpty: true }, endIndex: A14 };
    }
    a7++;
    let c15 = fe(e7, t6, a7), u11 = t6.slice(a7, c15), f11 = -1, h17 = 0, d16 = 0;
    for (let E13 = 0; E13 < u11.length; E13++) {
      let A14 = u11[E13];
      if (A14 === "(" || A14 === "[") h17++;
      else if (A14 === ")" || A14 === "]") h17--;
      else if (A14 === "?" && h17 === 0) d16++;
      else if (A14 === ":" && h17 === 0) if (d16 > 0) d16--;
      else {
        f11 = E13;
        break;
      }
    }
    let m25 = f11 >= 0 ? u11.slice(0, f11) : u11, g18 = f11 >= 0 ? u11.slice(f11 + 1) : null;
    return { operation: { type: "Substring", offset: He(e7, m25), length: g18 !== null ? He(e7, g18) : null }, endIndex: c15 };
  }
  if ("-=?+".includes(i10)) {
    a7++;
    let o9 = fe(e7, t6, a7), c15 = t6.slice(a7, o9), u11 = ae(e7, c15, false, false, true, false, n23, false, false, true), f11 = w2.word(u11.length > 0 ? u11 : [w2.literal("")]);
    if (i10 === "-") return { operation: { type: "DefaultValue", word: f11, checkEmpty: false }, endIndex: o9 };
    if (i10 === "=") return { operation: { type: "AssignDefault", word: f11, checkEmpty: false }, endIndex: o9 };
    if (i10 === "?") return { operation: { type: "ErrorIfUnset", word: c15 ? f11 : null, checkEmpty: false }, endIndex: o9 };
    if (i10 === "+") return { operation: { type: "UseAlternative", word: f11, checkEmpty: false }, endIndex: o9 };
  }
  if (i10 === "#" || i10 === "%") {
    let o9 = l8 === i10, c15 = i10 === "#" ? "prefix" : "suffix";
    a7 += o9 ? 2 : 1;
    let u11 = fe(e7, t6, a7), f11 = t6.slice(a7, u11), h17 = ae(e7, f11, false, false, false);
    return { operation: { type: "PatternRemoval", pattern: w2.word(h17.length > 0 ? h17 : [w2.literal("")]), side: c15, greedy: o9 }, endIndex: u11 };
  }
  if (i10 === "/") {
    let o9 = l8 === "/";
    a7 += o9 ? 2 : 1;
    let c15 = null;
    t6[a7] === "#" ? (c15 = "start", a7++) : t6[a7] === "%" && (c15 = "end", a7++);
    let u11;
    c15 !== null && (t6[a7] === "/" || t6[a7] === "}") ? u11 = a7 : u11 = Kt(e7, t6, a7);
    let f11 = t6.slice(a7, u11), h17 = ae(e7, f11, false, false, false), d16 = w2.word(h17.length > 0 ? h17 : [w2.literal("")]), m25 = null, g18 = u11;
    if (t6[u11] === "/") {
      let E13 = u11 + 1, A14 = fe(e7, t6, E13), S17 = t6.slice(E13, A14), y18 = ae(e7, S17, false, false, false);
      m25 = w2.word(y18.length > 0 ? y18 : [w2.literal("")]), g18 = A14;
    }
    return { operation: { type: "PatternReplacement", pattern: d16, replacement: m25, all: o9, anchor: c15 }, endIndex: g18 };
  }
  if (i10 === "^" || i10 === ",") {
    let o9 = l8 === i10, c15 = i10 === "^" ? "upper" : "lower";
    a7 += o9 ? 2 : 1;
    let u11 = fe(e7, t6, a7), f11 = t6.slice(a7, u11), h17 = f11 ? w2.word([w2.literal(f11)]) : null;
    return { operation: { type: "CaseModification", direction: c15, all: o9, pattern: h17 }, endIndex: u11 };
  }
  return i10 === "@" && /[QPaAEKkuUL]/.test(l8) ? { operation: { type: "Transform", operator: l8 }, endIndex: a7 + 2 } : { operation: null, endIndex: a7 };
}
function ot(e7, t6, r8, s9 = false) {
  let n23 = r8 + 1;
  if (n23 >= t6.length) return { part: w2.literal("$"), endIndex: n23 };
  let a7 = t6[n23];
  if (a7 === "(" && t6[n23 + 1] === "(") return e7.isDollarDparenSubshell(t6, r8) ? e7.parseCommandSubstitution(t6, r8) : e7.parseArithmeticExpansion(t6, r8);
  if (a7 === "[") {
    let i10 = 1, l8 = n23 + 1;
    for (; l8 < t6.length && i10 > 0; ) t6[l8] === "[" ? i10++ : t6[l8] === "]" && i10--, i10 > 0 && l8++;
    if (i10 === 0) {
      let o9 = t6.slice(n23 + 1, l8), c15 = M2(e7, o9);
      return { part: w2.arithmeticExpansion(c15), endIndex: l8 + 1 };
    }
  }
  return a7 === "(" ? e7.parseCommandSubstitution(t6, r8) : a7 === "{" ? Hr(e7, t6, r8, s9) : /[a-zA-Z_0-9@*#?$!-]/.test(a7) ? Ur(e7, t6, r8) : { part: w2.literal("$"), endIndex: n23 };
}
function on(e7, t6) {
  let r8 = [], s9 = 0, n23 = "", a7 = () => {
    n23 && (r8.push(w2.literal(n23)), n23 = "");
  };
  for (; s9 < t6.length; ) {
    let i10 = t6[s9];
    if (i10 === "\\" && s9 + 1 < t6.length) {
      let l8 = t6[s9 + 1];
      if (l8 === "$" || l8 === "`" || l8 === '"' || l8 === "\\") {
        n23 += l8, s9 += 2;
        continue;
      }
      n23 += i10, s9++;
      continue;
    }
    if (i10 === "$") {
      a7();
      let { part: l8, endIndex: o9 } = ot(e7, t6, s9, true);
      l8 && r8.push(l8), s9 = o9;
      continue;
    }
    if (i10 === "`") {
      a7();
      let { part: l8, endIndex: o9 } = e7.parseBacktickSubstitution(t6, s9, true);
      r8.push(l8), s9 = o9;
      continue;
    }
    n23 += i10, s9++;
  }
  return a7(), r8;
}
function jr(e7, t6, r8) {
  let s9 = [], n23 = r8, a7 = "", i10 = () => {
    a7 && (s9.push(w2.literal(a7)), a7 = "");
  };
  for (; n23 < t6.length && t6[n23] !== '"'; ) {
    let l8 = t6[n23];
    if (l8 === "\\" && n23 + 1 < t6.length) {
      let o9 = t6[n23 + 1];
      if ('"\\$`\n'.includes(o9)) {
        a7 += o9, n23 += 2;
        continue;
      }
      a7 += l8, n23++;
      continue;
    }
    if (l8 === "$") {
      i10();
      let { part: o9, endIndex: c15 } = ot(e7, t6, n23, true);
      o9 && s9.push(o9), n23 = c15;
      continue;
    }
    if (l8 === "`") {
      i10();
      let { part: o9, endIndex: c15 } = e7.parseBacktickSubstitution(t6, n23, true);
      s9.push(o9), n23 = c15;
      continue;
    }
    a7 += l8, n23++;
  }
  return i10(), { part: w2.doubleQuoted(s9), endIndex: n23 };
}
function ae(e7, t6, r8 = false, s9 = false, n23 = false, a7 = false, i10 = false, l8 = false, o9 = false, c15 = false) {
  if (s9) return [w2.singleQuoted(t6)];
  if (r8) {
    let m25 = on(e7, t6);
    return [w2.doubleQuoted(m25)];
  }
  if (t6.length >= 2 && t6[0] === '"' && t6[t6.length - 1] === '"') {
    let m25 = t6.slice(1, -1), g18 = false;
    for (let E13 = 0; E13 < m25.length; E13++) {
      if (m25[E13] === '"') {
        g18 = true;
        break;
      }
      m25[E13] === "\\" && E13 + 1 < m25.length && E13++;
    }
    if (!g18) {
      let E13 = on(e7, m25);
      return [w2.doubleQuoted(E13)];
    }
  }
  let u11 = [], f11 = 0, h17 = "", d16 = () => {
    h17 && (u11.push(w2.literal(h17)), h17 = "");
  };
  for (; f11 < t6.length; ) {
    let m25 = t6[f11];
    if (m25 === "\\" && f11 + 1 < t6.length) {
      let g18 = t6[f11 + 1];
      if (o9) {
        d16(), u11.push(w2.escaped(g18)), f11 += 2;
        continue;
      }
      let E13 = a7 ? g18 === "$" || g18 === "`" || g18 === `
` : g18 === "$" || g18 === "`" || g18 === '"' || g18 === "'" || g18 === `
` || c15 && g18 === "}", A14 = i10 ? "*?[]\\".includes(g18) : "*?[]\\(){}.^+".includes(g18);
      E13 ? h17 += g18 : A14 ? (d16(), u11.push(w2.escaped(g18))) : h17 += `\\${g18}`, f11 += 2;
      continue;
    }
    if (m25 === "'" && !i10 && !a7) {
      d16();
      let g18 = t6.indexOf("'", f11 + 1);
      if (g18 === -1) {
        h17 += t6.slice(f11);
        break;
      }
      u11.push(w2.singleQuoted(t6.slice(f11 + 1, g18))), f11 = g18 + 1;
      continue;
    }
    if (m25 === '"' && !a7) {
      d16();
      let { part: g18, endIndex: E13 } = jr(e7, t6, f11 + 1);
      u11.push(g18), f11 = E13 + 1;
      continue;
    }
    if (m25 === "$" && t6[f11 + 1] === "'") {
      d16();
      let { part: g18, endIndex: E13 } = Jt(e7, t6, f11 + 2);
      u11.push(g18), f11 = E13;
      continue;
    }
    if (m25 === "$") {
      d16();
      let { part: g18, endIndex: E13 } = ot(e7, t6, f11);
      g18 && u11.push(g18), f11 = E13;
      continue;
    }
    if (m25 === "`") {
      d16();
      let { part: g18, endIndex: E13 } = e7.parseBacktickSubstitution(t6, f11);
      u11.push(g18), f11 = E13;
      continue;
    }
    if (m25 === "~") {
      let g18 = f11 > 0 ? t6[f11 - 1] : "";
      if (f11 === 0 || g18 === "=" || n23 && g18 === ":") {
        let A14 = jt(e7, t6, f11), S17 = t6[A14];
        if (S17 === void 0 || S17 === "/" || S17 === ":") {
          d16();
          let y18 = t6.slice(f11 + 1, A14) || null;
          u11.push({ type: "TildeExpansion", user: y18 }), f11 = A14;
          continue;
        }
      }
    }
    if ("@*+?!".includes(m25) && f11 + 1 < t6.length && t6[f11 + 1] === "(") {
      let g18 = Zr(t6, f11 + 1);
      if (g18 !== -1) {
        d16();
        let E13 = t6.slice(f11, g18 + 1);
        u11.push({ type: "Glob", pattern: E13 }), f11 = g18 + 1;
        continue;
      }
    }
    if (m25 === "*" || m25 === "?" || m25 === "[") {
      d16();
      let { pattern: g18, endIndex: E13 } = Xt(e7, t6, f11);
      u11.push({ type: "Glob", pattern: g18 }), f11 = E13;
      continue;
    }
    if (m25 === "{" && !n23 && !l8) {
      let g18 = Yt(e7, t6, f11, ae);
      if (g18) {
        d16(), u11.push(g18.part), f11 = g18.endIndex;
        continue;
      }
    }
    h17 += m25, f11++;
  }
  return d16(), u11;
}
function ln(e7, t6) {
  let r8 = e7.length, s9 = t6 + 3, n23 = 2, a7 = false, i10 = false;
  for (; s9 < r8 && n23 > 0; ) {
    let l8 = e7[s9];
    if (a7) {
      l8 === "'" && (a7 = false), s9++;
      continue;
    }
    if (i10) {
      if (l8 === "\\") {
        s9 += 2;
        continue;
      }
      l8 === '"' && (i10 = false), s9++;
      continue;
    }
    if (l8 === "'") {
      a7 = true, s9++;
      continue;
    }
    if (l8 === '"') {
      i10 = true, s9++;
      continue;
    }
    if (l8 === "\\") {
      s9 += 2;
      continue;
    }
    if (l8 === "(") {
      n23++, s9++;
      continue;
    }
    if (l8 === ")") {
      if (n23--, n23 === 1) {
        let o9 = s9 + 1;
        return !(o9 < r8 && e7[o9] === ")");
      }
      if (n23 === 0) return false;
      s9++;
      continue;
    }
    if (n23 === 1 && (l8 === "|" && s9 + 1 < r8 && e7[s9 + 1] === "|" || l8 === "&" && s9 + 1 < r8 && e7[s9 + 1] === "&" || l8 === "|" && s9 + 1 < r8 && e7[s9 + 1] !== "|")) return true;
    s9++;
  }
  return false;
}
function un(e7, t6, r8, s9) {
  let n23 = t6 + 2, a7 = 1, i10 = n23, l8 = false, o9 = false, c15 = 0, u11 = false, f11 = "";
  for (; i10 < e7.length && a7 > 0; ) {
    let g18 = e7[i10];
    l8 ? g18 === "'" && (l8 = false) : o9 ? g18 === "\\" && i10 + 1 < e7.length ? i10++ : g18 === '"' && (o9 = false) : g18 === "'" ? (l8 = true, f11 = "") : g18 === '"' ? (o9 = true, f11 = "") : g18 === "\\" && i10 + 1 < e7.length ? (i10++, f11 = "") : /[a-zA-Z_]/.test(g18) ? f11 += g18 : (f11 === "case" ? (c15++, u11 = false) : f11 === "in" && c15 > 0 ? u11 = true : f11 === "esac" && c15 > 0 && (c15--, u11 = false), f11 = "", g18 === "(" ? i10 > 0 && e7[i10 - 1] === "$" ? a7++ : u11 || a7++ : g18 === ")" ? u11 ? u11 = false : a7-- : g18 === ";" && c15 > 0 && i10 + 1 < e7.length && e7[i10 + 1] === ";" && (u11 = true)), a7 > 0 && i10++;
  }
  a7 > 0 && s9("unexpected EOF while looking for matching `)'");
  let h17 = e7.slice(n23, i10), m25 = r8().parse(h17);
  return { part: w2.commandSubstitution(m25, false), endIndex: i10 + 1 };
}
function cn(e7, t6, r8, s9, n23) {
  let i10 = t6 + 1, l8 = "";
  for (; i10 < e7.length && e7[i10] !== "`"; ) if (e7[i10] === "\\") {
    let u11 = e7[i10 + 1];
    u11 === "$" || u11 === "`" || u11 === "\\" || u11 === `
` || r8 && u11 === '"' ? (u11 !== `
` && (l8 += u11), i10 += 2) : (l8 += e7[i10], i10++);
  } else l8 += e7[i10], i10++;
  i10 >= e7.length && n23("unexpected EOF while looking for matching ``'");
  let c15 = s9().parse(l8);
  return { part: w2.commandSubstitution(c15, true), endIndex: i10 + 1 };
}
function hi(e7, t6) {
  return new V2().parse(e7, t6);
}
function lt(e7) {
  return Xr.get(e7) ?? "";
}
function fn(e7) {
  let t6 = [], r8 = "", s9 = 0;
  for (; s9 < e7.length; ) {
    let n23 = e7[s9];
    if (n23 === "[") {
      for (r8 += n23, s9++, s9 < e7.length && (e7[s9] === "!" || e7[s9] === "^") && (r8 += e7[s9], s9++), s9 < e7.length && e7[s9] === "]" && (r8 += e7[s9], s9++); s9 < e7.length && e7[s9] !== "]"; ) {
        if (e7[s9] === "[" && s9 + 1 < e7.length && e7[s9 + 1] === ":") {
          let a7 = e7.indexOf(":]", s9 + 2);
          if (a7 !== -1) {
            r8 += e7.slice(s9, a7 + 2), s9 = a7 + 2;
            continue;
          }
        }
        if (e7[s9] === "\\" && s9 + 1 < e7.length) {
          r8 += e7[s9] + e7[s9 + 1], s9 += 2;
          continue;
        }
        r8 += e7[s9], s9++;
      }
      s9 < e7.length && e7[s9] === "]" && (r8 += e7[s9], s9++);
    } else n23 === ":" ? (r8 !== "" && t6.push(r8), r8 = "", s9++) : n23 === "\\" && s9 + 1 < e7.length ? (r8 += n23 + e7[s9 + 1], s9 += 2) : (r8 += n23, s9++);
  }
  return r8 !== "" && t6.push(r8), t6;
}
function hn(e7) {
  let t6 = "^";
  for (let r8 = 0; r8 < e7.length; r8++) {
    let s9 = e7[r8];
    if (s9 === "*") t6 += "[^/]*";
    else if (s9 === "?") t6 += "[^/]";
    else if (s9 === "[") {
      let n23 = r8 + 1, a7 = "[";
      n23 < e7.length && (e7[n23] === "^" || e7[n23] === "!") && (a7 += "^", n23++), n23 < e7.length && e7[n23] === "]" && (a7 += "\\]", n23++);
      let i10 = n23;
      for (; i10 < e7.length; ) {
        if (e7[i10] === "\\" && i10 + 1 < e7.length) {
          i10 += 2;
          continue;
        }
        if (e7[i10] === "[" && i10 + 1 < e7.length && e7[i10 + 1] === ":") {
          let o9 = e7.indexOf(":]", i10 + 2);
          if (o9 !== -1) {
            i10 = o9 + 2;
            continue;
          }
        }
        if (e7[i10] === "]") break;
        i10++;
      }
      let l8 = n23;
      for (; n23 < e7.length && e7[n23] !== "]"; ) {
        if (e7[n23] === "[" && n23 + 1 < e7.length && e7[n23 + 1] === ":") {
          let o9 = e7.indexOf(":]", n23 + 2);
          if (o9 !== -1) {
            let c15 = e7.slice(n23 + 2, o9), u11 = lt(c15);
            a7 += u11, n23 = o9 + 2;
            continue;
          }
        }
        if (e7[n23] === "\\" && n23 + 1 < e7.length) {
          a7 += `\\${e7[n23 + 1]}`, n23 += 2;
          continue;
        }
        if (e7[n23] === "-") {
          let o9 = n23 === l8, c15 = n23 + 1 === i10;
          o9 || c15 ? a7 += "\\-" : a7 += "-";
        } else a7 += e7[n23];
        n23++;
      }
      a7 += "]", t6 += a7, r8 = n23;
    } else if (s9 === "\\" && r8 + 1 < e7.length) {
      let n23 = e7[r8 + 1];
      /[.+^${}()|\\*?[\]]/.test(n23) ? t6 += `\\${n23}` : t6 += n23, r8++;
    } else /[.+^${}()|]/.test(s9) ? t6 += `\\${s9}` : t6 += s9;
  }
  return t6 += "$", b1(t6);
}
function ut(e7, t6) {
  let r8 = 1, s9 = t6 + 1;
  for (; s9 < e7.length && r8 > 0; ) {
    let n23 = e7[s9];
    if (n23 === "\\") {
      s9 += 2;
      continue;
    }
    if (n23 === "(") r8++;
    else if (n23 === ")" && (r8--, r8 === 0)) return s9;
    s9++;
  }
  return -1;
}
function ct(e7) {
  let t6 = [], r8 = "", s9 = 0, n23 = false, a7 = 0;
  for (; a7 < e7.length; ) {
    let i10 = e7[a7];
    if (i10 === "'" && !n23) {
      n23 = true, r8 += "\0QUOTE_START\0", a7++;
      continue;
    }
    if (i10 === "'" && n23) {
      n23 = false, r8 += "\0QUOTE_END\0", a7++;
      continue;
    }
    if (n23) {
      r8 += i10, a7++;
      continue;
    }
    if (i10 === "\\") {
      r8 += i10, a7 + 1 < e7.length ? (r8 += e7[a7 + 1], a7 += 2) : a7++;
      continue;
    }
    i10 === "(" ? (s9++, r8 += i10) : i10 === ")" ? (s9--, r8 += i10) : i10 === "|" && s9 === 0 ? (t6.push(r8), r8 = "") : r8 += i10, a7++;
  }
  return t6.push(r8), t6;
}
function Jr(e7, t6, r8) {
  switch (r8) {
    case "+":
      return e7 + t6;
    case "-":
      return e7 - t6;
    case "*":
      return e7 * t6;
    case "/":
      if (t6 === 0) throw new p("division by 0");
      return Math.trunc(e7 / t6);
    case "%":
      if (t6 === 0) throw new p("division by 0");
      return e7 % t6;
    case "**":
      if (t6 < 0) throw new p("exponent less than 0");
      return e7 ** t6;
    case "<<":
      return e7 << t6;
    case ">>":
      return e7 >> t6;
    case "<":
      return e7 < t6 ? 1 : 0;
    case "<=":
      return e7 <= t6 ? 1 : 0;
    case ">":
      return e7 > t6 ? 1 : 0;
    case ">=":
      return e7 >= t6 ? 1 : 0;
    case "==":
      return e7 === t6 ? 1 : 0;
    case "!=":
      return e7 !== t6 ? 1 : 0;
    case "&":
      return e7 & t6;
    case "|":
      return e7 | t6;
    case "^":
      return e7 ^ t6;
    case ",":
      return t6;
    default:
      return 0;
  }
}
function pn(e7, t6, r8) {
  switch (r8) {
    case "=":
      return t6;
    case "+=":
      return e7 + t6;
    case "-=":
      return e7 - t6;
    case "*=":
      return e7 * t6;
    case "/=":
      return t6 !== 0 ? Math.trunc(e7 / t6) : 0;
    case "%=":
      return t6 !== 0 ? e7 % t6 : 0;
    case "<<=":
      return e7 << t6;
    case ">>=":
      return e7 >> t6;
    case "&=":
      return e7 & t6;
    case "|=":
      return e7 | t6;
    case "^=":
      return e7 ^ t6;
    default:
      return t6;
  }
}
function Yr(e7, t6) {
  switch (t6) {
    case "-":
      return -e7;
    case "+":
      return +e7;
    case "!":
      return e7 === 0 ? 1 : 0;
    case "~":
      return ~e7;
    default:
      return e7;
  }
}
async function es(e7, t6) {
  let r8 = e7.state.env.get(t6);
  if (r8 !== void 0) return r8;
  let s9 = e7.state.env.get(`${t6}_0`);
  return s9 !== void 0 ? s9 : await v2(e7, t6);
}
function ts(e7) {
  if (!e7) return 0;
  let t6 = Number.parseInt(e7, 10);
  if (!Number.isNaN(t6) && /^-?\d+$/.test(e7.trim())) return t6;
  let r8 = e7.trim();
  if (!r8) return 0;
  try {
    let s9 = new V2(), { expr: n23, pos: a7 } = Z2(s9, r8, 0);
    if (a7 < r8.length) {
      let i10 = r8.slice(a7).trim().split(/\s+/)[0];
      throw new p(`${r8}: syntax error in expression (error token is "${i10}")`);
    }
    return n23.type === "ArithNumber" ? n23.value : t6 || 0;
  } catch (s9) {
    if (s9 instanceof p) throw s9;
    let n23 = r8.split(/\s+/).slice(1)[0] || r8;
    throw new p(`${r8}: syntax error in expression (error token is "${n23}")`);
  }
}
async function ft(e7, t6) {
  if (!t6) return 0;
  let r8 = Number.parseInt(t6, 10);
  if (!Number.isNaN(r8) && /^-?\d+$/.test(t6.trim())) return r8;
  let s9 = t6.trim();
  if (!s9) return 0;
  let n23 = new V2(), { expr: a7, pos: i10 } = Z2(n23, s9, 0);
  if (i10 < s9.length) {
    let l8 = s9.slice(i10).trim(), o9 = l8.split(/\s+/)[0] || l8;
    throw new p(`syntax error in expression (error token is "${o9}")`, "", "");
  }
  return await R(e7, a7);
}
async function ht(e7, t6, r8 = /* @__PURE__ */ new Set(), s9 = 0) {
  if (s9 > 100) throw new p("maximum variable indirection depth exceeded");
  if (r8.has(t6)) return 0;
  r8.add(t6);
  let n23 = await es(e7, t6);
  if (!n23) return 0;
  let a7 = Number.parseInt(n23, 10);
  if (!Number.isNaN(a7) && /^-?\d+$/.test(n23.trim())) return a7;
  let i10 = n23.trim();
  if (/^[a-zA-Z_][a-zA-Z0-9_]*$/.test(i10)) return await ht(e7, i10, r8, s9 + 1);
  let l8 = new V2(), { expr: o9, pos: c15 } = Z2(l8, i10, 0);
  if (c15 < i10.length) {
    let u11 = i10.slice(c15).trim(), f11 = u11.split(/\s+/)[0] || u11;
    throw new p(`${i10}: syntax error in expression (error token is "${f11}")`);
  }
  return await R(e7, o9);
}
async function xe(e7, t6) {
  if (t6.startsWith("#")) {
    let f11 = t6.slice(1), h17 = f11.match(/^([a-zA-Z_][a-zA-Z0-9_]*)\[[@*]\]$/);
    if (h17) {
      let m25 = h17[1], g18 = P2(e7, m25);
      return String(g18.length);
    }
    let d16 = e7.state.env.get(f11) || "";
    return String(d16.length);
  }
  if (t6.startsWith("!")) {
    let f11 = t6.slice(1), h17 = e7.state.env.get(f11) || "";
    return e7.state.env.get(h17) || "";
  }
  let r8 = [":-", ":=", ":?", ":+", "-", "=", "?", "+"], s9 = -1, n23 = "";
  for (let f11 of r8) {
    let h17 = t6.indexOf(f11);
    h17 > 0 && (s9 === -1 || h17 < s9) && (s9 = h17, n23 = f11);
  }
  if (s9 === -1) return await v2(e7, t6);
  let a7 = t6.slice(0, s9), i10 = t6.slice(s9 + n23.length), l8 = e7.state.env.get(a7), o9 = l8 === void 0, c15 = l8 === "", u11 = n23.startsWith(":");
  switch (n23) {
    case ":-":
    case "-":
      return o9 || u11 && c15 ? i10 : l8 || "";
    case ":=":
    case "=":
      return o9 || u11 && c15 ? (e7.state.env.set(a7, i10), i10) : l8 || "";
    case ":+":
    case "+":
      return !(o9 || u11 && c15) ? i10 : "";
    case ":?":
    case "?": {
      if (o9 || u11 && c15) throw new Error(i10 || `${a7}: parameter null or not set`);
      return l8 || "";
    }
    default:
      return l8 || "";
  }
}
async function R(e7, t6, r8 = false) {
  switch (t6.type) {
    case "ArithNumber":
      if (Number.isNaN(t6.value)) throw new p("value too great for base");
      return t6.value;
    case "ArithVariable":
      return await ht(e7, t6.name);
    case "ArithSpecialVar": {
      let n23 = (await v2(e7, t6.name)).trim();
      if (!n23) return 0;
      let a7 = Number.parseInt(n23, 10);
      if (!Number.isNaN(a7) && /^-?\d+$/.test(n23)) return a7;
      let i10 = new V2(), { expr: l8 } = Z2(i10, n23, 0);
      return await R(e7, l8);
    }
    case "ArithNested":
      return await R(e7, t6.expression);
    case "ArithCommandSubst": {
      if (e7.execFn) {
        let s9 = await e7.execFn(t6.command);
        s9.stderr && (e7.state.expansionStderr = (e7.state.expansionStderr || "") + s9.stderr);
        let n23 = s9.stdout.trim();
        return Number.parseInt(n23, 10) || 0;
      }
      return 0;
    }
    case "ArithBracedExpansion": {
      let s9 = await xe(e7, t6.content);
      return Number.parseInt(s9, 10) || 0;
    }
    case "ArithDynamicBase": {
      let s9 = await xe(e7, t6.baseExpr), n23 = Number.parseInt(s9, 10);
      if (n23 < 2 || n23 > 64) return 0;
      let a7 = `${n23}#${t6.value}`;
      return ge(a7);
    }
    case "ArithDynamicNumber": {
      let n23 = await xe(e7, t6.prefix) + t6.suffix;
      return ge(n23);
    }
    case "ArithArrayElement": {
      let s9 = e7.state.associativeArrays?.has(t6.array), n23 = async (a7) => {
        let i10 = e7.state.env.get(a7);
        return i10 !== void 0 ? await ft(e7, i10) : 0;
      };
      if (t6.stringKey !== void 0) return await n23(`${t6.array}_${t6.stringKey}`);
      if (s9 && t6.index?.type === "ArithVariable" && !t6.index.hasDollarPrefix) return await n23(`${t6.array}_${t6.index.name}`);
      if (s9 && t6.index?.type === "ArithVariable" && t6.index.hasDollarPrefix) {
        let a7 = await v2(e7, t6.index.name);
        return await n23(`${t6.array}_${a7}`);
      }
      if (t6.index) {
        let a7 = await R(e7, t6.index, r8);
        if (a7 < 0) {
          let o9 = P2(e7, t6.array), c15 = e7.state.currentLine;
          if (o9.length === 0) return e7.state.expansionStderr = (e7.state.expansionStderr || "") + `bash: line ${c15}: ${t6.array}: bad array subscript
`, 0;
          let f11 = Math.max(...o9.map(([h17]) => typeof h17 == "number" ? h17 : 0)) + 1 + a7;
          if (f11 < 0) return e7.state.expansionStderr = (e7.state.expansionStderr || "") + `bash: line ${c15}: ${t6.array}: bad array subscript
`, 0;
          a7 = f11;
        }
        let i10 = `${t6.array}_${a7}`, l8 = e7.state.env.get(i10);
        if (l8 !== void 0) return ft(e7, l8);
        if (a7 === 0) {
          let o9 = e7.state.env.get(t6.array);
          if (o9 !== void 0) return ft(e7, o9);
        }
        if (e7.state.options.nounset && !Array.from(e7.state.env.keys()).some((c15) => c15 === t6.array || c15.startsWith(`${t6.array}_`))) throw new x2(`${t6.array}[${a7}]`);
        return 0;
      }
      return 0;
    }
    case "ArithDoubleSubscript":
      throw new p("double subscript", "", "");
    case "ArithNumberSubscript":
      throw new p(`${t6.number}${t6.errorToken}: syntax error: invalid arithmetic operator (error token is "${t6.errorToken}")`);
    case "ArithSyntaxError":
      throw new p(t6.message, "", "", true);
    case "ArithSingleQuote": {
      if (r8) throw new p(`syntax error: operand expected (error token is "'${t6.content}'")`);
      return t6.value;
    }
    case "ArithBinary": {
      if (t6.operator === "||") return await R(e7, t6.left, r8) || await R(e7, t6.right, r8) ? 1 : 0;
      if (t6.operator === "&&") return await R(e7, t6.left, r8) && await R(e7, t6.right, r8) ? 1 : 0;
      let s9 = await R(e7, t6.left, r8), n23 = await R(e7, t6.right, r8);
      return Jr(s9, n23, t6.operator);
    }
    case "ArithUnary": {
      let s9 = await R(e7, t6.operand, r8);
      if (t6.operator === "++" || t6.operator === "--") {
        if (t6.operand.type === "ArithVariable") {
          let n23 = t6.operand.name, a7 = Number.parseInt(await v2(e7, n23), 10) || 0, i10 = t6.operator === "++" ? a7 + 1 : a7 - 1;
          return e7.state.env.set(n23, String(i10)), t6.prefix ? i10 : a7;
        }
        if (t6.operand.type === "ArithArrayElement") {
          let n23 = t6.operand.array, a7 = e7.state.associativeArrays?.has(n23), i10;
          if (t6.operand.stringKey !== void 0) i10 = `${n23}_${t6.operand.stringKey}`;
          else if (a7 && t6.operand.index?.type === "ArithVariable" && !t6.operand.index.hasDollarPrefix) i10 = `${n23}_${t6.operand.index.name}`;
          else if (a7 && t6.operand.index?.type === "ArithVariable" && t6.operand.index.hasDollarPrefix) {
            let c15 = await v2(e7, t6.operand.index.name);
            i10 = `${n23}_${c15}`;
          } else if (t6.operand.index) {
            let c15 = await R(e7, t6.operand.index, r8);
            i10 = `${n23}_${c15}`;
          } else return s9;
          let l8 = Number.parseInt(e7.state.env.get(i10) || "0", 10) || 0, o9 = t6.operator === "++" ? l8 + 1 : l8 - 1;
          return e7.state.env.set(i10, String(o9)), t6.prefix ? o9 : l8;
        }
        if (t6.operand.type === "ArithConcat") {
          let n23 = "";
          for (let a7 of t6.operand.parts) n23 += await de(e7, a7, r8);
          if (n23 && /^[a-zA-Z_][a-zA-Z0-9_]*$/.test(n23)) {
            let a7 = Number.parseInt(e7.state.env.get(n23) || "0", 10) || 0, i10 = t6.operator === "++" ? a7 + 1 : a7 - 1;
            return e7.state.env.set(n23, String(i10)), t6.prefix ? i10 : a7;
          }
        }
        if (t6.operand.type === "ArithDynamicElement") {
          let n23 = "";
          if (t6.operand.nameExpr.type === "ArithConcat") for (let a7 of t6.operand.nameExpr.parts) n23 += await de(e7, a7, r8);
          else t6.operand.nameExpr.type === "ArithVariable" && (n23 = t6.operand.nameExpr.hasDollarPrefix ? await v2(e7, t6.operand.nameExpr.name) : t6.operand.nameExpr.name);
          if (n23 && /^[a-zA-Z_][a-zA-Z0-9_]*$/.test(n23)) {
            let a7 = await R(e7, t6.operand.subscript, r8), i10 = `${n23}_${a7}`, l8 = Number.parseInt(e7.state.env.get(i10) || "0", 10) || 0, o9 = t6.operator === "++" ? l8 + 1 : l8 - 1;
            return e7.state.env.set(i10, String(o9)), t6.prefix ? o9 : l8;
          }
        }
        return s9;
      }
      return Yr(s9, t6.operator);
    }
    case "ArithTernary":
      return await R(e7, t6.condition, r8) ? await R(e7, t6.consequent, r8) : await R(e7, t6.alternate, r8);
    case "ArithAssignment": {
      let s9 = t6.variable, n23 = s9;
      if (t6.stringKey !== void 0) n23 = `${s9}_${t6.stringKey}`;
      else if (t6.subscript) {
        let o9 = e7.state.associativeArrays?.has(s9);
        if (o9 && t6.subscript.type === "ArithVariable" && !t6.subscript.hasDollarPrefix) n23 = `${s9}_${t6.subscript.name}`;
        else if (o9 && t6.subscript.type === "ArithVariable" && t6.subscript.hasDollarPrefix) {
          let c15 = await v2(e7, t6.subscript.name);
          n23 = `${s9}_${c15 || "\\"}`;
        } else if (o9) {
          let c15 = await R(e7, t6.subscript, r8);
          n23 = `${s9}_${c15}`;
        } else {
          let c15 = await R(e7, t6.subscript, r8);
          if (c15 < 0) {
            let u11 = P2(e7, s9);
            u11.length > 0 && (c15 = Math.max(...u11.map(([h17]) => typeof h17 == "number" ? h17 : 0)) + 1 + c15);
          }
          n23 = `${s9}_${c15}`;
        }
      }
      let a7 = Number.parseInt(e7.state.env.get(n23) || "0", 10) || 0, i10 = await R(e7, t6.value, r8), l8 = pn(a7, i10, t6.operator);
      return e7.state.env.set(n23, String(l8)), l8;
    }
    case "ArithGroup":
      return await R(e7, t6.expression, r8);
    case "ArithConcat": {
      let s9 = "";
      for (let n23 of t6.parts) s9 += await de(e7, n23, r8);
      return /^[a-zA-Z_][a-zA-Z0-9_]*$/.test(s9) ? await ht(e7, s9) : Number.parseInt(s9, 10) || 0;
    }
    case "ArithDynamicAssignment": {
      let s9 = "";
      if (t6.target.type === "ArithConcat") for (let o9 of t6.target.parts) s9 += await de(e7, o9, r8);
      else t6.target.type === "ArithVariable" && (s9 = t6.target.hasDollarPrefix ? await v2(e7, t6.target.name) : t6.target.name);
      if (!s9 || !/^[a-zA-Z_][a-zA-Z0-9_]*$/.test(s9)) return 0;
      let n23 = s9;
      if (t6.subscript) {
        let o9 = await R(e7, t6.subscript, r8);
        n23 = `${s9}_${o9}`;
      }
      let a7 = Number.parseInt(e7.state.env.get(n23) || "0", 10) || 0, i10 = await R(e7, t6.value, r8), l8 = pn(a7, i10, t6.operator);
      return e7.state.env.set(n23, String(l8)), l8;
    }
    case "ArithDynamicElement": {
      let s9 = "";
      if (t6.nameExpr.type === "ArithConcat") for (let l8 of t6.nameExpr.parts) s9 += await de(e7, l8, r8);
      else t6.nameExpr.type === "ArithVariable" && (s9 = t6.nameExpr.hasDollarPrefix ? await v2(e7, t6.nameExpr.name) : t6.nameExpr.name);
      if (!s9 || !/^[a-zA-Z_][a-zA-Z0-9_]*$/.test(s9)) return 0;
      let n23 = await R(e7, t6.subscript, r8), a7 = `${s9}_${n23}`, i10 = e7.state.env.get(a7);
      return i10 !== void 0 ? ts(i10) : 0;
    }
    default:
      return 0;
  }
}
async function de(e7, t6, r8 = false) {
  switch (t6.type) {
    case "ArithNumber":
      return String(t6.value);
    case "ArithSingleQuote":
      return String(await R(e7, t6, r8));
    case "ArithVariable":
      return t6.hasDollarPrefix ? await v2(e7, t6.name) : t6.name;
    case "ArithSpecialVar":
      return await v2(e7, t6.name);
    case "ArithBracedExpansion":
      return await xe(e7, t6.content);
    case "ArithCommandSubst":
      return e7.execFn ? (await e7.execFn(t6.command)).stdout.trim() : "0";
    case "ArithConcat": {
      let s9 = "";
      for (let n23 of t6.parts) s9 += await de(e7, n23, r8);
      return s9;
    }
    default:
      return String(await R(e7, t6, r8));
  }
}
function pt(e7) {
  for (let t6 = 0; t6 < e7.length; t6++) {
    if (e7[t6] === "\\") {
      t6++;
      continue;
    }
    if (e7[t6] === "$") {
      let r8 = e7[t6 + 1];
      if (r8 === "{" || r8 && /[a-zA-Z_]/.test(r8)) return true;
    }
  }
  return false;
}
function ns(e7) {
  if (!e7.operation) return false;
  let t6 = e7.operation, r8;
  if ((t6.type === "DefaultValue" || t6.type === "AssignDefault" || t6.type === "UseAlternative" || t6.type === "ErrorIfUnset") && (r8 = t6.word?.parts), !r8) return false;
  for (let s9 of r8) if (s9.type === "DoubleQuoted" || s9.type === "SingleQuoted") return true;
  return false;
}
function dn(e7) {
  if (!e7.operation) return false;
  let t6 = e7.operation, r8;
  if ((t6.type === "DefaultValue" || t6.type === "AssignDefault" || t6.type === "UseAlternative" || t6.type === "ErrorIfUnset") && (r8 = t6.word?.parts), !r8 || r8.length === 0) return false;
  for (let s9 of r8) if (s9.type !== "DoubleQuoted" && s9.type !== "SingleQuoted") return false;
  return true;
}
function Ee(e7) {
  let t6 = false, r8 = false, s9 = false, n23 = false, a7 = false, i10 = false, l8 = false;
  for (let o9 of e7) {
    if ((o9.type === "SingleQuoted" || o9.type === "DoubleQuoted") && (t6 = true, o9.type === "DoubleQuoted")) for (let c15 of o9.parts) c15.type === "ParameterExpansion" && (c15.parameter.match(/^([a-zA-Z_][a-zA-Z0-9_]*)\[[@*]\]$/) && (!c15.operation || c15.operation.type === "PatternRemoval" || c15.operation.type === "PatternReplacement") && (n23 = true), (c15.operation?.type === "VarNamePrefix" || c15.operation?.type === "ArrayKeys") && (i10 = true), c15.operation?.type === "Indirection" && (l8 = true));
    o9.type === "CommandSubstitution" && (r8 = true), o9.type === "ParameterExpansion" && (a7 = true, (o9.parameter === "@" || o9.parameter === "*") && (s9 = true), ns(o9) && (t6 = true), (o9.operation?.type === "VarNamePrefix" || o9.operation?.type === "ArrayKeys") && (i10 = true), o9.operation?.type === "Indirection" && (l8 = true)), o9.type === "Glob" && pt(o9.pattern) && (a7 = true);
  }
  return { hasQuoted: t6, hasCommandSub: r8, hasArrayVar: s9, hasArrayAtExpansion: n23, hasParamExpansion: a7, hasVarNamePrefixExpansion: i10, hasIndirection: l8 };
}
function Di(e7) {
  let { pid: t6, ppid: r8, uid: s9, gid: n23 } = e7;
  return `Name:	bash
State:	R (running)
Pid:	${t6}
PPid:	${r8}
Uid:	${s9}	${s9}	${s9}	${s9}
Gid:	${n23}	${n23}	${n23}	${n23}
`;
}
function dt(e7, t6) {
  let r8 = `${t6}_`, s9 = [];
  for (let n23 of e7.state.env.keys()) if (n23.startsWith(r8)) {
    let a7 = n23.slice(r8.length), i10 = Number.parseInt(a7, 10);
    !Number.isNaN(i10) && String(i10) === a7 && s9.push(i10);
  }
  return s9.sort((n23, a7) => n23 - a7);
}
function _i(e7, t6) {
  let r8 = `${t6}_`;
  for (let s9 of e7.state.env.keys()) s9.startsWith(r8) && e7.state.env.delete(s9);
}
function mt(e7, t6) {
  let r8 = `${t6}_`, s9 = `${t6}__length`, n23 = [];
  for (let a7 of e7.state.env.keys()) if (a7 !== s9 && a7.startsWith(r8)) {
    let i10 = a7.slice(r8.length);
    if (i10.startsWith("_length")) continue;
    n23.push(i10);
  }
  return n23.sort();
}
function _e(e7) {
  return e7.startsWith("'") && e7.endsWith("'") || e7.startsWith('"') && e7.endsWith('"') ? e7.slice(1, -1) : e7;
}
function $i(e7) {
  if (e7.parts.length < 2) return null;
  let t6 = e7.parts[0], r8 = e7.parts[1];
  if (t6.type !== "Glob" || !t6.pattern.startsWith("[")) return null;
  let s9, n23 = r8, a7 = 1;
  if (r8.type === "Literal" && r8.value.startsWith("]")) {
    let f11 = r8.value.slice(1);
    if (f11.startsWith("+=") || f11.startsWith("=")) s9 = t6.pattern.slice(1);
    else if (f11 === "") {
      if (e7.parts.length < 3) return null;
      let h17 = e7.parts[2];
      if (h17.type !== "Literal" || !h17.value.startsWith("=") && !h17.value.startsWith("+=")) return null;
      s9 = t6.pattern.slice(1), n23 = h17, a7 = 2;
    } else return null;
  } else if (t6.pattern === "[" && (r8.type === "DoubleQuoted" || r8.type === "SingleQuoted")) {
    if (e7.parts.length < 3) return null;
    let f11 = e7.parts[2];
    if (f11.type !== "Literal" || !f11.value.startsWith("]=") && !f11.value.startsWith("]+=")) return null;
    if (r8.type === "SingleQuoted") s9 = r8.value;
    else {
      s9 = "";
      for (let h17 of r8.parts) (h17.type === "Literal" || h17.type === "Escaped") && (s9 += h17.value);
    }
    n23 = f11, a7 = 2;
  } else if (t6.pattern.endsWith("]")) {
    if (r8.type !== "Literal" || !r8.value.startsWith("=") && !r8.value.startsWith("+=")) return null;
    s9 = t6.pattern.slice(1, -1);
  } else return null;
  s9 = _e(s9);
  let i10;
  if (n23.type !== "Literal") return null;
  n23.value.startsWith("]=") || n23.value.startsWith("]+=") ? i10 = n23.value.slice(1) : i10 = n23.value;
  let l8 = i10.startsWith("+=");
  if (!l8 && !i10.startsWith("=")) return null;
  let o9 = [], c15 = l8 ? 2 : 1, u11 = i10.slice(c15);
  u11 && o9.push({ type: "Literal", value: u11 });
  for (let f11 = a7 + 1; f11 < e7.parts.length; f11++) {
    let h17 = e7.parts[f11];
    h17.type === "BraceExpansion" ? o9.push({ type: "Literal", value: rs(h17) }) : o9.push(h17);
  }
  return { key: s9, valueParts: o9, append: l8 };
}
function rs(e7) {
  return `{${e7.items.map((r8) => {
    if (r8.type === "Range") {
      let s9 = r8.startStr ?? String(r8.start), n23 = r8.endStr ?? String(r8.end), a7 = `${s9}..${n23}`;
      return r8.step && (a7 += `..${r8.step}`), a7;
    }
    return gn(r8.word);
  }).join(",")}}`;
}
function gn(e7) {
  let t6 = "";
  for (let r8 of e7.parts) switch (r8.type) {
    case "Literal":
      t6 += r8.value;
      break;
    case "Glob":
      t6 += r8.pattern;
      break;
    case "SingleQuoted":
      t6 += r8.value;
      break;
    case "DoubleQuoted":
      for (let s9 of r8.parts) (s9.type === "Literal" || s9.type === "Escaped") && (t6 += s9.value);
      break;
    case "Escaped":
      t6 += r8.value;
      break;
    case "BraceExpansion":
      t6 += "{", t6 += r8.items.map((s9) => s9.type === "Range" ? `${s9.startStr}..${s9.endStr}${s9.step ? `..${s9.step}` : ""}` : gn(s9.word)).join(","), t6 += "}";
      break;
    case "TildeExpansion":
      t6 += "~", r8.user && (t6 += r8.user);
      break;
  }
  return t6;
}
function T(e7) {
  return e7.get("IFS") ?? ` 	
`;
}
function q2(e7) {
  return e7.get("IFS") === "";
}
function $e(e7) {
  let t6 = T(e7);
  if (t6 === "") return true;
  for (let r8 of t6) if (r8 !== " " && r8 !== "	" && r8 !== `
`) return false;
  return true;
}
function yn(e7) {
  let t6 = false, r8 = [];
  for (let s9 of e7.split("")) s9 === "-" ? t6 = true : /[\\^$.*+?()[\]{}|]/.test(s9) ? r8.push(`\\${s9}`) : s9 === "	" ? r8.push("\\t") : s9 === `
` ? r8.push("\\n") : r8.push(s9);
  return t6 && r8.push("\\-"), r8.join("");
}
function N2(e7) {
  let t6 = e7.get("IFS");
  return t6 === void 0 ? " " : t6[0] || "";
}
function is(e7) {
  return ss.includes(e7);
}
function gt(e7) {
  let t6 = /* @__PURE__ */ new Set(), r8 = /* @__PURE__ */ new Set();
  for (let s9 of e7) is(s9) ? t6.add(s9) : r8.add(s9);
  return { whitespace: t6, nonWhitespace: r8 };
}
function Oi(e7, t6, r8, s9) {
  if (t6 === "") return e7 === "" ? { words: [], wordStarts: [] } : { words: [e7], wordStarts: [0] };
  let { whitespace: n23, nonWhitespace: a7 } = gt(t6), i10 = [], l8 = [], o9 = 0;
  for (; o9 < e7.length && n23.has(e7[o9]); ) o9++;
  if (o9 >= e7.length) return { words: [], wordStarts: [] };
  if (a7.has(e7[o9])) for (i10.push(""), l8.push(o9), o9++; o9 < e7.length && n23.has(e7[o9]); ) o9++;
  for (; o9 < e7.length && !(r8 !== void 0 && i10.length >= r8); ) {
    let c15 = o9;
    for (l8.push(c15); o9 < e7.length; ) {
      let u11 = e7[o9];
      if (!s9 && u11 === "\\") {
        o9++, o9 < e7.length && o9++;
        continue;
      }
      if (n23.has(u11) || a7.has(u11)) break;
      o9++;
    }
    if (i10.push(e7.substring(c15, o9)), o9 >= e7.length) break;
    for (; o9 < e7.length && n23.has(e7[o9]); ) o9++;
    if (o9 < e7.length && a7.has(e7[o9])) {
      for (o9++; o9 < e7.length && n23.has(e7[o9]); ) o9++;
      for (; o9 < e7.length && a7.has(e7[o9]) && !(r8 !== void 0 && i10.length >= r8); ) for (i10.push(""), l8.push(o9), o9++; o9 < e7.length && n23.has(e7[o9]); ) o9++;
    }
  }
  return { words: i10, wordStarts: l8 };
}
function Ce(e7, t6) {
  if (t6 === "") return { words: e7 ? [e7] : [], hadLeadingDelimiter: false, hadTrailingDelimiter: false };
  if (e7 === "") return { words: [], hadLeadingDelimiter: false, hadTrailingDelimiter: false };
  let { whitespace: r8, nonWhitespace: s9 } = gt(t6), n23 = [], a7 = 0, i10 = false, l8 = false, o9 = a7;
  for (; a7 < e7.length && r8.has(e7[a7]); ) a7++;
  if (a7 > o9 && (i10 = true), a7 >= e7.length) return { words: [], hadLeadingDelimiter: true, hadTrailingDelimiter: true };
  if (s9.has(e7[a7])) for (n23.push(""), a7++; a7 < e7.length && r8.has(e7[a7]); ) a7++;
  for (; a7 < e7.length; ) {
    let c15 = a7;
    for (; a7 < e7.length; ) {
      let f11 = e7[a7];
      if (r8.has(f11) || s9.has(f11)) break;
      a7++;
    }
    if (n23.push(e7.substring(c15, a7)), a7 >= e7.length) {
      l8 = false;
      break;
    }
    let u11 = a7;
    for (; a7 < e7.length && r8.has(e7[a7]); ) a7++;
    if (a7 < e7.length && s9.has(e7[a7])) {
      for (a7++; a7 < e7.length && r8.has(e7[a7]); ) a7++;
      for (; a7 < e7.length && s9.has(e7[a7]); ) for (n23.push(""), a7++; a7 < e7.length && r8.has(e7[a7]); ) a7++;
    }
    a7 >= e7.length && a7 > u11 && (l8 = true);
  }
  return { words: n23, hadLeadingDelimiter: i10, hadTrailingDelimiter: l8 };
}
function x3(e7, t6) {
  return Ce(e7, t6).words;
}
function as(e7, t6) {
  for (let r8 of e7) if (t6.has(r8)) return true;
  return false;
}
function Li(e7, t6, r8) {
  if (t6 === "") return e7;
  let { whitespace: s9, nonWhitespace: n23 } = gt(t6), a7 = e7.length;
  for (; a7 > 0 && s9.has(e7[a7 - 1]); ) {
    if (!r8 && a7 >= 2) {
      let l8 = 0, o9 = a7 - 2;
      for (; o9 >= 0 && e7[o9] === "\\"; ) l8++, o9--;
      if (l8 % 2 === 1) break;
    }
    a7--;
  }
  let i10 = e7.substring(0, a7);
  if (i10.length >= 1 && n23.has(i10[i10.length - 1])) {
    if (!r8 && i10.length >= 2) {
      let o9 = 0, c15 = i10.length - 2;
      for (; c15 >= 0 && i10[c15] === "\\"; ) o9++, c15--;
      if (o9 % 2 === 1) return i10;
    }
    let l8 = i10.substring(0, i10.length - 1);
    if (!as(l8, n23)) return l8;
  }
  return i10;
}
function L2(e7, t6) {
  return e7.state.namerefs?.has(t6) ?? false;
}
function Ti(e7, t6) {
  e7.state.namerefs ??= /* @__PURE__ */ new Set(), e7.state.namerefs.add(t6);
}
function Mi(e7, t6) {
  e7.state.namerefs?.delete(t6), e7.state.boundNamerefs?.delete(t6), e7.state.invalidNamerefs?.delete(t6);
}
function Vi(e7, t6) {
  e7.state.invalidNamerefs ??= /* @__PURE__ */ new Set(), e7.state.invalidNamerefs.add(t6);
}
function En(e7, t6) {
  return e7.state.invalidNamerefs?.has(t6) ?? false;
}
function qi(e7, t6) {
  e7.state.boundNamerefs ??= /* @__PURE__ */ new Set(), e7.state.boundNamerefs.add(t6);
}
function os(e7, t6) {
  let r8 = t6.match(/^([a-zA-Z_][a-zA-Z0-9_]*)\[(.+)\]$/);
  if (r8) {
    let n23 = r8[1], a7 = Array.from(e7.state.env.keys()).some((l8) => l8.startsWith(`${n23}_`) && !l8.includes("__")), i10 = e7.state.associativeArrays?.has(n23) ?? false;
    return a7 || i10;
  }
  return Array.from(e7.state.env.keys()).some((n23) => n23.startsWith(`${t6}_`) && !n23.includes("__")) ? true : e7.state.env.has(t6);
}
function he(e7, t6, r8 = 100) {
  if (!L2(e7, t6) || En(e7, t6)) return t6;
  let s9 = /* @__PURE__ */ new Set(), n23 = t6;
  for (; r8-- > 0; ) {
    if (s9.has(n23)) return;
    if (s9.add(n23), !L2(e7, n23)) return n23;
    let a7 = e7.state.env.get(n23);
    if (a7 === void 0 || a7 === "" || !/^[a-zA-Z_][a-zA-Z0-9_]*(\[.+\])?$/.test(a7)) return n23;
    n23 = a7;
  }
}
function Ae(e7, t6) {
  if (L2(e7, t6)) return e7.state.env.get(t6);
}
function Bi(e7, t6, r8, s9 = 100) {
  if (!L2(e7, t6) || En(e7, t6)) return t6;
  let n23 = /* @__PURE__ */ new Set(), a7 = t6;
  for (; s9-- > 0; ) {
    if (n23.has(a7)) return;
    if (n23.add(a7), !L2(e7, a7)) return a7;
    let i10 = e7.state.env.get(a7);
    if (i10 === void 0 || i10 === "") return r8 !== void 0 ? /^[a-zA-Z_][a-zA-Z0-9_]*$/.test(r8) && os(e7, r8) ? a7 : null : a7;
    if (!/^[a-zA-Z_][a-zA-Z0-9_]*(\[.+\])?$/.test(i10)) return a7;
    a7 = i10;
  }
}
function ls(e7, t6) {
  let r8 = t6.replace(/\$\{([a-zA-Z_][a-zA-Z0-9_]*)\}/g, (s9, n23) => e7.state.env.get(n23) ?? "");
  return r8 = r8.replace(/\$([a-zA-Z_][a-zA-Z0-9_]*)/g, (s9, n23) => e7.state.env.get(n23) ?? ""), r8;
}
function P2(e7, t6) {
  return t6 === "FUNCNAME" ? (e7.state.funcNameStack ?? []).map((a7, i10) => [i10, a7]) : t6 === "BASH_LINENO" ? (e7.state.callLineStack ?? []).map((a7, i10) => [i10, String(a7)]) : t6 === "BASH_SOURCE" ? (e7.state.sourceStack ?? []).map((a7, i10) => [i10, a7]) : e7.state.associativeArrays?.has(t6) ? mt(e7, t6).map((a7) => [a7, e7.state.env.get(`${t6}_${a7}`) ?? ""]) : dt(e7, t6).map((n23) => [n23, e7.state.env.get(`${t6}_${n23}`) ?? ""]);
}
function Se(e7, t6) {
  return t6 === "FUNCNAME" ? (e7.state.funcNameStack?.length ?? 0) > 0 : t6 === "BASH_LINENO" ? (e7.state.callLineStack?.length ?? 0) > 0 : t6 === "BASH_SOURCE" ? (e7.state.sourceStack?.length ?? 0) > 0 : e7.state.associativeArrays?.has(t6) ? mt(e7, t6).length > 0 : dt(e7, t6).length > 0;
}
async function v2(e7, t6, r8 = true, s9 = false) {
  switch (t6) {
    case "?":
      return String(e7.state.lastExitCode);
    case "$":
      return String(e7.state.virtualPid);
    case "#":
      return e7.state.env.get("#") || "0";
    case "@":
      return e7.state.env.get("@") || "";
    case "_":
      return e7.state.lastArg;
    case "-": {
      let i10 = "";
      return i10 += "h", e7.state.options.errexit && (i10 += "e"), e7.state.options.noglob && (i10 += "f"), e7.state.options.nounset && (i10 += "u"), e7.state.options.verbose && (i10 += "v"), e7.state.options.xtrace && (i10 += "x"), i10 += "B", e7.state.options.noclobber && (i10 += "C"), i10 += "s", i10;
    }
    case "*": {
      let i10 = Number.parseInt(e7.state.env.get("#") || "0", 10);
      if (i10 === 0) return "";
      let l8 = [];
      for (let o9 = 1; o9 <= i10; o9++) l8.push(e7.state.env.get(String(o9)) || "");
      return l8.join(N2(e7.state.env));
    }
    case "0":
      return e7.state.env.get("0") || "bash";
    case "PWD":
      return e7.state.env.get("PWD") ?? "";
    case "OLDPWD":
      return e7.state.env.get("OLDPWD") ?? "";
    case "PPID":
      return String(e7.state.virtualPpid);
    case "UID":
      return String(e7.state.virtualUid);
    case "EUID":
      return String(e7.state.virtualUid);
    case "RANDOM":
      return String(Math.floor(Math.random() * 32768));
    case "SECONDS":
      return String(Math.floor((Date.now() - e7.state.startTime) / 1e3));
    case "BASH_VERSION":
      return mn;
    case "!":
      return String(e7.state.lastBackgroundPid);
    case "BASHPID":
      return String(e7.state.bashPid);
    case "LINENO":
      return String(e7.state.currentLine);
    case "FUNCNAME": {
      let i10 = e7.state.funcNameStack?.[0];
      if (i10 !== void 0) return i10;
      if (r8 && e7.state.options.nounset) throw new x2("FUNCNAME");
      return "";
    }
    case "BASH_LINENO": {
      let i10 = e7.state.callLineStack?.[0];
      if (i10 !== void 0) return String(i10);
      if (r8 && e7.state.options.nounset) throw new x2("BASH_LINENO");
      return "";
    }
    case "BASH_SOURCE": {
      let i10 = e7.state.sourceStack?.[0];
      if (i10 !== void 0) return i10;
      if (r8 && e7.state.options.nounset) throw new x2("BASH_SOURCE");
      return "";
    }
  }
  if (/^[a-zA-Z_][a-zA-Z0-9_]*\[\]$/.test(t6)) throw new h(`\${${t6}}`);
  let n23 = t6.match(/^([a-zA-Z_][a-zA-Z0-9_]*)\[(.+)\]$/);
  if (n23) {
    let i10 = n23[1], l8 = n23[2];
    if (L2(e7, i10)) {
      let f11 = he(e7, i10);
      if (f11 && f11 !== i10) {
        if (f11.match(/^([a-zA-Z_][a-zA-Z0-9_]*)\[(.+)\]$/)) return "";
        i10 = f11;
      }
    }
    if (l8 === "@" || l8 === "*") {
      let f11 = P2(e7, i10);
      if (f11.length > 0) return f11.map(([, d16]) => d16).join(" ");
      let h17 = e7.state.env.get(i10);
      return h17 !== void 0 ? h17 : "";
    }
    if (i10 === "FUNCNAME") {
      let f11 = Number.parseInt(l8, 10);
      return !Number.isNaN(f11) && f11 >= 0 ? e7.state.funcNameStack?.[f11] ?? "" : "";
    }
    if (i10 === "BASH_LINENO") {
      let f11 = Number.parseInt(l8, 10);
      if (!Number.isNaN(f11) && f11 >= 0) {
        let h17 = e7.state.callLineStack?.[f11];
        return h17 !== void 0 ? String(h17) : "";
      }
      return "";
    }
    if (i10 === "BASH_SOURCE") {
      let f11 = Number.parseInt(l8, 10);
      return !Number.isNaN(f11) && f11 >= 0 ? e7.state.sourceStack?.[f11] ?? "" : "";
    }
    if (e7.state.associativeArrays?.has(i10)) {
      let f11 = _e(l8);
      f11 = ls(e7, f11);
      let h17 = e7.state.env.get(`${i10}_${f11}`);
      if (h17 === void 0 && r8 && e7.state.options.nounset) throw new x2(`${i10}[${l8}]`);
      return h17 || "";
    }
    let c15;
    if (/^-?\d+$/.test(l8)) c15 = Number.parseInt(l8, 10);
    else try {
      let f11 = new V2(), h17 = M2(f11, l8);
      c15 = await R(e7, h17.expression);
    } catch {
      let f11 = e7.state.env.get(l8);
      c15 = f11 ? Number.parseInt(f11, 10) : 0, Number.isNaN(c15) && (c15 = 0);
    }
    if (c15 < 0) {
      let f11 = P2(e7, i10), h17 = e7.state.currentLine;
      if (f11.length === 0) return e7.state.expansionStderr = (e7.state.expansionStderr || "") + `bash: line ${h17}: ${i10}: bad array subscript
`, "";
      let m25 = Math.max(...f11.map(([E13]) => typeof E13 == "number" ? E13 : 0)) + 1 + c15;
      return m25 < 0 ? (e7.state.expansionStderr = (e7.state.expansionStderr || "") + `bash: line ${h17}: ${i10}: bad array subscript
`, "") : e7.state.env.get(`${i10}_${m25}`) || "";
    }
    let u11 = e7.state.env.get(`${i10}_${c15}`);
    if (u11 !== void 0) return u11;
    if (c15 === 0) {
      let f11 = e7.state.env.get(i10);
      if (f11 !== void 0) return f11;
    }
    if (r8 && e7.state.options.nounset) throw new x2(`${i10}[${c15}]`);
    return "";
  }
  if (/^[1-9][0-9]*$/.test(t6)) {
    let i10 = e7.state.env.get(t6);
    if (i10 === void 0 && r8 && e7.state.options.nounset) throw new x2(t6);
    return i10 || "";
  }
  if (L2(e7, t6)) {
    let i10 = he(e7, t6);
    if (i10 === void 0) return "";
    if (i10 !== t6) return await v2(e7, i10, r8, s9);
    let l8 = e7.state.env.get(t6);
    if ((l8 === void 0 || l8 === "") && r8 && e7.state.options.nounset) throw new x2(t6);
    return l8 || "";
  }
  let a7 = e7.state.env.get(t6);
  if (a7 !== void 0) return e7.state.tempEnvBindings?.some((i10) => i10.has(t6)) && (e7.state.accessedTempEnvVars = e7.state.accessedTempEnvVars || /* @__PURE__ */ new Set(), e7.state.accessedTempEnvVars.add(t6)), a7;
  if (Se(e7, t6)) {
    let i10 = e7.state.env.get(`${t6}_0`);
    return i10 !== void 0 ? i10 : "";
  }
  if (r8 && e7.state.options.nounset) throw new x2(t6);
  return "";
}
async function te(e7, t6) {
  if ((/* @__PURE__ */ new Set(["?", "$", "#", "_", "-", "0", "PPID", "UID", "EUID", "RANDOM", "SECONDS", "BASH_VERSION", "!", "BASHPID", "LINENO"])).has(t6)) return true;
  if (t6 === "@" || t6 === "*") return Number.parseInt(e7.state.env.get("#") || "0", 10) > 0;
  if (t6 === "PWD" || t6 === "OLDPWD") return e7.state.env.has(t6);
  let s9 = t6.match(/^([a-zA-Z_][a-zA-Z0-9_]*)\[(.+)\]$/);
  if (s9) {
    let n23 = s9[1], a7 = s9[2];
    if (L2(e7, n23)) {
      let o9 = he(e7, n23);
      if (o9 && o9 !== n23) {
        if (o9.match(/^([a-zA-Z_][a-zA-Z0-9_]*)\[(.+)\]$/)) return false;
        n23 = o9;
      }
    }
    if (a7 === "@" || a7 === "*") return P2(e7, n23).length > 0 ? true : e7.state.env.has(n23);
    if (e7.state.associativeArrays?.has(n23)) {
      let o9 = _e(a7);
      return e7.state.env.has(`${n23}_${o9}`);
    }
    let l8;
    if (/^-?\d+$/.test(a7)) l8 = Number.parseInt(a7, 10);
    else try {
      let o9 = new V2(), c15 = M2(o9, a7);
      l8 = await R(e7, c15.expression);
    } catch {
      let o9 = e7.state.env.get(a7);
      l8 = o9 ? Number.parseInt(o9, 10) : 0, Number.isNaN(l8) && (l8 = 0);
    }
    if (l8 < 0) {
      let o9 = P2(e7, n23);
      if (o9.length === 0) return false;
      let u11 = Math.max(...o9.map(([f11]) => typeof f11 == "number" ? f11 : 0)) + 1 + l8;
      return u11 < 0 ? false : e7.state.env.has(`${n23}_${u11}`);
    }
    return e7.state.env.has(`${n23}_${l8}`);
  }
  if (L2(e7, t6)) {
    let n23 = he(e7, t6);
    return n23 === void 0 || n23 === t6 ? e7.state.env.has(t6) : te(e7, n23);
  }
  return !!(e7.state.env.has(t6) || Se(e7, t6));
}
async function An(e7, t6) {
  let r8 = "", s9 = 0;
  for (; s9 < t6.length; ) {
    if (t6[s9] === "$") {
      if (t6[s9 + 1] === "{") {
        let n23 = 1, a7 = s9 + 2;
        for (; a7 < t6.length && n23 > 0; ) t6[a7] === "{" ? n23++ : t6[a7] === "}" && n23--, a7++;
        r8 += t6.slice(s9, a7), s9 = a7;
        continue;
      }
      if (t6[s9 + 1] === "(") {
        let n23 = 1, a7 = s9 + 2;
        for (; a7 < t6.length && n23 > 0; ) t6[a7] === "(" ? n23++ : t6[a7] === ")" && n23--, a7++;
        r8 += t6.slice(s9, a7), s9 = a7;
        continue;
      }
      if (/[a-zA-Z_]/.test(t6[s9 + 1] || "")) {
        let n23 = s9 + 1;
        for (; n23 < t6.length && /[a-zA-Z0-9_]/.test(t6[n23]); ) n23++;
        let a7 = t6.slice(s9 + 1, n23), i10 = await v2(e7, a7);
        r8 += i10, s9 = n23;
        continue;
      }
      if (/[0-9]/.test(t6[s9 + 1] || "")) {
        let n23 = s9 + 1;
        for (; n23 < t6.length && /[0-9]/.test(t6[n23]); ) n23++;
        let a7 = t6.slice(s9 + 1, n23), i10 = await v2(e7, a7);
        r8 += i10, s9 = n23;
        continue;
      }
      if (/[*@#?\-!$]/.test(t6[s9 + 1] || "")) {
        let n23 = t6[s9 + 1], a7 = await v2(e7, n23);
        r8 += a7, s9 += 2;
        continue;
      }
    }
    if (t6[s9] === '"') {
      for (r8 += '"', s9++; s9 < t6.length && t6[s9] !== '"'; ) if (t6[s9] === "$" && /[a-zA-Z_]/.test(t6[s9 + 1] || "")) {
        let n23 = s9 + 1;
        for (; n23 < t6.length && /[a-zA-Z0-9_]/.test(t6[n23]); ) n23++;
        let a7 = t6.slice(s9 + 1, n23), i10 = await v2(e7, a7);
        r8 += i10, s9 = n23;
      } else t6[s9] === "\\" ? (r8 += t6[s9], s9++, s9 < t6.length && (r8 += t6[s9], s9++)) : (r8 += t6[s9], s9++);
      s9 < t6.length && (r8 += '"', s9++);
      continue;
    }
    r8 += t6[s9], s9++;
  }
  return r8;
}
async function yt(e7, t6) {
  let r8 = t6, s9 = t6.startsWith('"') && t6.endsWith('"'), n23 = t6.startsWith("'") && t6.endsWith("'");
  if ((s9 || n23) && (r8 = t6.slice(1, -1)), n23) return r8;
  let a7 = "", i10 = 0;
  for (; i10 < r8.length; ) if (r8[i10] === "$") if (r8[i10 + 1] === "(") {
    let l8 = 1, o9 = i10 + 2;
    for (; o9 < r8.length && l8 > 0; ) r8[o9] === "(" && r8[o9 - 1] === "$" || r8[o9] === "(" ? l8++ : r8[o9] === ")" && l8--, o9++;
    let c15 = r8.slice(i10 + 2, o9 - 1);
    if (e7.execFn) {
      let u11 = await e7.execFn(c15);
      a7 += u11.stdout.replace(/\n+$/, ""), u11.stderr && (e7.state.expansionStderr = (e7.state.expansionStderr || "") + u11.stderr);
    }
    i10 = o9;
  } else if (r8[i10 + 1] === "{") {
    let l8 = 1, o9 = i10 + 2;
    for (; o9 < r8.length && l8 > 0; ) r8[o9] === "{" ? l8++ : r8[o9] === "}" && l8--, o9++;
    let c15 = r8.slice(i10 + 2, o9 - 1), u11 = await v2(e7, c15);
    a7 += u11, i10 = o9;
  } else if (/[a-zA-Z_]/.test(r8[i10 + 1] || "")) {
    let l8 = i10 + 1;
    for (; l8 < r8.length && /[a-zA-Z0-9_]/.test(r8[l8]); ) l8++;
    let o9 = r8.slice(i10 + 1, l8), c15 = await v2(e7, o9);
    a7 += c15, i10 = l8;
  } else a7 += r8[i10], i10++;
  else if (r8[i10] === "`") {
    let l8 = i10 + 1;
    for (; l8 < r8.length && r8[l8] !== "`"; ) l8++;
    let o9 = r8.slice(i10 + 1, l8);
    if (e7.execFn) {
      let c15 = await e7.execFn(o9);
      a7 += c15.stdout.replace(/\n+$/, ""), c15.stderr && (e7.state.expansionStderr = (e7.state.expansionStderr || "") + c15.stderr);
    }
    i10 = l8 + 1;
  } else a7 += r8[i10], i10++;
  return a7;
}
function us(e7, t6, r8, s9, n23) {
  let a7 = r8 ?? 1;
  a7 === 0 && (a7 = 1);
  let i10 = Math.abs(a7), l8 = [], o9 = 0;
  s9?.match(/^-?0\d/) && (o9 = Math.max(o9, s9.replace(/^-/, "").length)), n23?.match(/^-?0\d/) && (o9 = Math.max(o9, n23.replace(/^-/, "").length));
  let c15 = (u11) => {
    if (o9 > 0) {
      let f11 = u11 < 0, h17 = String(Math.abs(u11)).padStart(o9, "0");
      return f11 ? `-${h17}` : h17;
    }
    return String(u11);
  };
  if (e7 <= t6) for (let u11 = e7, f11 = 0; u11 <= t6 && f11 < Oe; u11 += i10, f11++) l8.push(c15(u11));
  else for (let u11 = e7, f11 = 0; u11 >= t6 && f11 < Oe; u11 -= i10, f11++) l8.push(c15(u11));
  return l8;
}
function cs(e7, t6, r8) {
  let s9 = r8 ?? 1;
  s9 === 0 && (s9 = 1);
  let n23 = e7.charCodeAt(0), a7 = t6.charCodeAt(0), i10 = Math.abs(s9), l8 = e7 >= "A" && e7 <= "Z", o9 = e7 >= "a" && e7 <= "z", c15 = t6 >= "A" && t6 <= "Z", u11 = t6 >= "a" && t6 <= "z";
  if (l8 && u11 || o9 && c15) {
    let h17 = r8 !== void 0 ? `..${r8}` : "";
    throw new m2(`{${e7}..${t6}${h17}}: invalid sequence`);
  }
  let f11 = [];
  if (n23 <= a7) for (let h17 = n23, d16 = 0; h17 <= a7 && d16 < Oe; h17 += i10, d16++) f11.push(String.fromCharCode(h17));
  else for (let h17 = n23, d16 = 0; h17 >= a7 && d16 < Oe; h17 -= i10, d16++) f11.push(String.fromCharCode(h17));
  return f11;
}
function Et(e7, t6, r8, s9, n23) {
  let a7 = r8 !== void 0 ? `..${r8}` : "";
  return typeof e7 == "number" && typeof t6 == "number" ? { expanded: us(e7, t6, r8, s9, n23), literal: `{${e7}..${t6}${a7}}` } : typeof e7 == "string" && typeof t6 == "string" ? { expanded: cs(e7, t6, r8), literal: `{${e7}..${t6}${a7}}` } : { expanded: null, literal: `{${e7}..${t6}${a7}}` };
}
function Sn(e7) {
  if (e7.statements.length !== 1) return null;
  let t6 = e7.statements[0];
  if (t6.operators.length !== 0 || t6.pipelines.length !== 1) return null;
  let r8 = t6.pipelines[0];
  if (r8.negated || r8.commands.length !== 1) return null;
  let s9 = r8.commands[0];
  if (s9.type !== "SimpleCommand") return null;
  let n23 = s9;
  if (n23.name !== null || n23.args.length !== 0 || n23.assignments.length !== 0 || n23.redirections.length !== 1) return null;
  let a7 = n23.redirections[0];
  return a7.operator !== "<" || a7.target.type !== "Word" ? null : { target: a7.target };
}
function ne(e7, t6) {
  return !!(/[*?[]/.test(e7) || t6 && /[@*+?!]\(/.test(e7));
}
function At(e7) {
  let t6 = "", r8 = 0;
  for (; r8 < e7.length; ) e7[r8] === "\\" && r8 + 1 < e7.length ? (t6 += e7[r8 + 1], r8 += 2) : (t6 += e7[r8], r8++);
  return t6;
}
function X2(e7) {
  return e7.replace(/([*?[\]\\()|])/g, "\\$1");
}
function St(e7) {
  return e7.replace(/[\\^$.*+?()[\]{}|]/g, "\\$&");
}
function I2(e7) {
  return e7.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function k(e7, t6, r8 = false) {
  let s9 = "", n23 = 0;
  for (; n23 < e7.length; ) {
    let a7 = e7[n23];
    if (r8 && (a7 === "@" || a7 === "*" || a7 === "+" || a7 === "?" || a7 === "!") && n23 + 1 < e7.length && e7[n23 + 1] === "(") {
      let i10 = fs(e7, n23 + 1);
      if (i10 !== -1) {
        let l8 = e7.slice(n23 + 2, i10), c15 = hs(l8).map((f11) => k(f11, t6, r8)), u11 = c15.length > 0 ? c15.join("|") : "(?:)";
        a7 === "@" ? s9 += `(?:${u11})` : a7 === "*" ? s9 += `(?:${u11})*` : a7 === "+" ? s9 += `(?:${u11})+` : a7 === "?" ? s9 += `(?:${u11})?` : a7 === "!" && (s9 += `(?!(?:${u11})$).*`), n23 = i10 + 1;
        continue;
      }
    }
    if (a7 === "\\") if (n23 + 1 < e7.length) {
      let i10 = e7[n23 + 1];
      /[\\^$.|+(){}[\]*?]/.test(i10) ? s9 += `\\${i10}` : s9 += i10, n23 += 2;
    } else s9 += "\\\\", n23++;
    else if (a7 === "*") s9 += t6 ? ".*" : ".*?", n23++;
    else if (a7 === "?") s9 += ".", n23++;
    else if (a7 === "[") {
      let i10 = ps(e7, n23);
      if (i10 === -1) s9 += "\\[", n23++;
      else {
        let l8 = e7.slice(n23 + 1, i10);
        s9 += ds(l8), n23 = i10 + 1;
      }
    } else /[\^$.|+(){}]/.test(a7) ? (s9 += `\\${a7}`, n23++) : (s9 += a7, n23++);
  }
  return s9;
}
function fs(e7, t6) {
  let r8 = 1, s9 = t6 + 1;
  for (; s9 < e7.length && r8 > 0; ) {
    let n23 = e7[s9];
    if (n23 === "\\") {
      s9 += 2;
      continue;
    }
    if (n23 === "(") r8++;
    else if (n23 === ")" && (r8--, r8 === 0)) return s9;
    s9++;
  }
  return -1;
}
function hs(e7) {
  let t6 = [], r8 = "", s9 = 0, n23 = 0;
  for (; n23 < e7.length; ) {
    let a7 = e7[n23];
    if (a7 === "\\") {
      r8 += a7, n23 + 1 < e7.length ? (r8 += e7[n23 + 1], n23 += 2) : n23++;
      continue;
    }
    a7 === "(" ? (s9++, r8 += a7) : a7 === ")" ? (s9--, r8 += a7) : a7 === "|" && s9 === 0 ? (t6.push(r8), r8 = "") : r8 += a7, n23++;
  }
  return t6.push(r8), t6;
}
function ps(e7, t6) {
  let r8 = t6 + 1;
  for (r8 < e7.length && e7[r8] === "^" && r8++, r8 < e7.length && e7[r8] === "]" && r8++; r8 < e7.length; ) {
    if (e7[r8] === "\\" && r8 + 1 < e7.length) {
      r8 += 2;
      continue;
    }
    if (e7[r8] === "]") return r8;
    if (e7[r8] === "'") {
      let s9 = e7.indexOf("'", r8 + 1);
      if (s9 !== -1) {
        r8 = s9 + 1;
        continue;
      }
    }
    if (e7[r8] === "[" && r8 + 1 < e7.length && e7[r8 + 1] === ":") {
      let s9 = e7.indexOf(":]", r8 + 2);
      if (s9 !== -1) {
        r8 = s9 + 2;
        continue;
      }
    }
    r8++;
  }
  return -1;
}
function ds(e7) {
  let t6 = "[", r8 = 0;
  for ((e7[0] === "^" || e7[0] === "!") && (t6 += "^", r8++); r8 < e7.length; ) {
    if (e7[r8] === "'") {
      let n23 = e7.indexOf("'", r8 + 1);
      if (n23 !== -1) {
        let a7 = e7.slice(r8 + 1, n23);
        for (let i10 of a7) i10 === "\\" ? t6 += "\\\\" : i10 === "]" ? t6 += "\\]" : i10 === "^" && t6 === "[" ? t6 += "\\^" : t6 += i10;
        r8 = n23 + 1;
        continue;
      }
    }
    if (e7[r8] === "[" && r8 + 1 < e7.length && e7[r8 + 1] === ":") {
      let n23 = e7.indexOf(":]", r8 + 2);
      if (n23 !== -1) {
        let a7 = e7.slice(r8 + 2, n23);
        t6 += gs(a7), r8 = n23 + 2;
        continue;
      }
    }
    let s9 = e7[r8];
    s9 === "\\" ? r8 + 1 < e7.length ? (t6 += `\\${e7[r8 + 1]}`, r8 += 2) : (t6 += "\\\\", r8++) : s9 === "-" && r8 > 0 && r8 < e7.length - 1 ? (t6 += "-", r8++) : s9 === "^" && r8 === 0 ? (t6 += "^", r8++) : (s9 === "]" && r8 === 0 ? t6 += "\\]" : t6 += s9, r8++);
  }
  return t6 += "]", t6;
}
function gs(e7) {
  return ms.get(e7) ?? "";
}
function se(e7, t6, r8, s9) {
  if (r8 === "prefix") return b1(`^${t6}`, "s").replace(e7, "");
  let n23 = b1(`${t6}$`, "s");
  if (s9) return n23.replace(e7, "");
  for (let a7 = e7.length; a7 >= 0; a7--) {
    let i10 = e7.slice(a7);
    if (n23.test(i10)) return e7.slice(0, a7);
  }
  return e7;
}
function me(e7, t6) {
  let r8 = Array.from(e7.state.env.keys()), s9 = /* @__PURE__ */ new Set(), n23 = e7.state.associativeArrays ?? /* @__PURE__ */ new Set(), a7 = /* @__PURE__ */ new Set();
  for (let l8 of r8) {
    let o9 = l8.match(/^([a-zA-Z_][a-zA-Z0-9_]*)_\d+$/);
    o9 && a7.add(o9[1]);
    let c15 = l8.match(/^([a-zA-Z_][a-zA-Z0-9_]*)__length$/);
    c15 && a7.add(c15[1]);
  }
  let i10 = (l8) => {
    for (let o9 of n23) {
      let c15 = `${o9}_`;
      if (l8.startsWith(c15) && l8 !== o9) return true;
    }
    return false;
  };
  for (let l8 of r8) if (l8.startsWith(t6)) if (l8.includes("__")) {
    let o9 = l8.match(/^([a-zA-Z_][a-zA-Z0-9_]*)__length$/);
    o9?.[1].startsWith(t6) && s9.add(o9[1]);
  } else if (/_\d+$/.test(l8)) {
    let o9 = l8.match(/^([a-zA-Z_][a-zA-Z0-9_]*)_\d+$/);
    o9?.[1].startsWith(t6) && s9.add(o9[1]);
  } else i10(l8) || s9.add(l8);
  return [...s9].sort();
}
function ys(e7, t6) {
  let r8 = (a7, i10 = 2) => String(a7).padStart(i10, "0");
  if (e7 === "") {
    let a7 = r8(t6.getHours()), i10 = r8(t6.getMinutes()), l8 = r8(t6.getSeconds());
    return `${a7}:${i10}:${l8}`;
  }
  let s9 = "", n23 = 0;
  for (; n23 < e7.length; ) if (e7[n23] === "%") {
    if (n23 + 1 >= e7.length) {
      s9 += "%", n23++;
      continue;
    }
    let a7 = e7[n23 + 1];
    switch (a7) {
      case "H":
        s9 += r8(t6.getHours());
        break;
      case "M":
        s9 += r8(t6.getMinutes());
        break;
      case "S":
        s9 += r8(t6.getSeconds());
        break;
      case "d":
        s9 += r8(t6.getDate());
        break;
      case "m":
        s9 += r8(t6.getMonth() + 1);
        break;
      case "Y":
        s9 += t6.getFullYear();
        break;
      case "y":
        s9 += r8(t6.getFullYear() % 100);
        break;
      case "I": {
        let i10 = t6.getHours() % 12;
        i10 === 0 && (i10 = 12), s9 += r8(i10);
        break;
      }
      case "p":
        s9 += t6.getHours() < 12 ? "AM" : "PM";
        break;
      case "P":
        s9 += t6.getHours() < 12 ? "am" : "pm";
        break;
      case "%":
        s9 += "%";
        break;
      case "a": {
        s9 += ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"][t6.getDay()];
        break;
      }
      case "b": {
        s9 += ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"][t6.getMonth()];
        break;
      }
      default:
        s9 += `%${a7}`;
    }
    n23 += 2;
  } else s9 += e7[n23], n23++;
  return s9;
}
function be(e7, t6) {
  let r8 = "", s9 = 0, n23 = e7.state.env.get("USER") || e7.state.env.get("LOGNAME") || "user", a7 = e7.state.env.get("HOSTNAME") || "localhost", i10 = a7.split(".")[0], l8 = e7.state.env.get("PWD") || "/", o9 = e7.state.env.get("HOME") || "/", c15 = l8.startsWith(o9) ? `~${l8.slice(o9.length)}` : l8, u11 = l8.split("/").pop() || l8, f11 = /* @__PURE__ */ new Date(), h17 = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], d16 = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], m25 = e7.state.env.get("__COMMAND_NUMBER") || "1";
  for (; s9 < t6.length; ) {
    let g18 = t6[s9];
    if (g18 === "\\") {
      if (s9 + 1 >= t6.length) {
        r8 += "\\", s9++;
        continue;
      }
      let E13 = t6[s9 + 1];
      if (E13 >= "0" && E13 <= "7") {
        let A14 = "", S17 = s9 + 1;
        for (; S17 < t6.length && S17 < s9 + 4 && t6[S17] >= "0" && t6[S17] <= "7"; ) A14 += t6[S17], S17++;
        let y18 = Number.parseInt(A14, 8) % 256;
        r8 += String.fromCharCode(y18), s9 = S17;
        continue;
      }
      switch (E13) {
        case "\\":
          r8 += "\\", s9 += 2;
          break;
        case "a":
          r8 += "\x07", s9 += 2;
          break;
        case "e":
          r8 += "\x1B", s9 += 2;
          break;
        case "n":
          r8 += `
`, s9 += 2;
          break;
        case "r":
          r8 += "\r", s9 += 2;
          break;
        case "$":
          r8 += "$", s9 += 2;
          break;
        case "[":
        case "]":
          s9 += 2;
          break;
        case "u":
          r8 += n23, s9 += 2;
          break;
        case "h":
          r8 += i10, s9 += 2;
          break;
        case "H":
          r8 += a7, s9 += 2;
          break;
        case "w":
          r8 += c15, s9 += 2;
          break;
        case "W":
          r8 += u11, s9 += 2;
          break;
        case "d": {
          let A14 = String(f11.getDate()).padStart(2, " ");
          r8 += `${h17[f11.getDay()]} ${d16[f11.getMonth()]} ${A14}`, s9 += 2;
          break;
        }
        case "t": {
          let A14 = String(f11.getHours()).padStart(2, "0"), S17 = String(f11.getMinutes()).padStart(2, "0"), y18 = String(f11.getSeconds()).padStart(2, "0");
          r8 += `${A14}:${S17}:${y18}`, s9 += 2;
          break;
        }
        case "T": {
          let A14 = f11.getHours() % 12;
          A14 === 0 && (A14 = 12);
          let S17 = String(A14).padStart(2, "0"), y18 = String(f11.getMinutes()).padStart(2, "0"), b25 = String(f11.getSeconds()).padStart(2, "0");
          r8 += `${S17}:${y18}:${b25}`, s9 += 2;
          break;
        }
        case "@": {
          let A14 = f11.getHours() % 12;
          A14 === 0 && (A14 = 12);
          let S17 = String(A14).padStart(2, "0"), y18 = String(f11.getMinutes()).padStart(2, "0"), b25 = f11.getHours() < 12 ? "AM" : "PM";
          r8 += `${S17}:${y18} ${b25}`, s9 += 2;
          break;
        }
        case "A": {
          let A14 = String(f11.getHours()).padStart(2, "0"), S17 = String(f11.getMinutes()).padStart(2, "0");
          r8 += `${A14}:${S17}`, s9 += 2;
          break;
        }
        case "D":
          if (s9 + 2 < t6.length && t6[s9 + 2] === "{") {
            let A14 = t6.indexOf("}", s9 + 3);
            if (A14 !== -1) {
              let S17 = t6.slice(s9 + 3, A14);
              r8 += ys(S17, f11), s9 = A14 + 1;
            } else r8 += "\\D", s9 += 2;
          } else r8 += "\\D", s9 += 2;
          break;
        case "s":
          r8 += "bash", s9 += 2;
          break;
        case "v":
          r8 += "5.0", s9 += 2;
          break;
        case "V":
          r8 += "5.0.0", s9 += 2;
          break;
        case "j":
          r8 += "0", s9 += 2;
          break;
        case "l":
          r8 += "tty", s9 += 2;
          break;
        case "#":
          r8 += m25, s9 += 2;
          break;
        case "!":
          r8 += m25, s9 += 2;
          break;
        case "x":
          r8 += "\\x", s9 += 2;
          break;
        default:
          r8 += `\\${E13}`, s9 += 2;
      }
    } else r8 += g18, s9++;
  }
  return r8;
}
function le(e7) {
  if (e7 === "") return "''";
  if (/[\n\r\t\x00-\x1f\x7f']/.test(e7)) {
    let r8 = "$'";
    for (let s9 of e7) switch (s9) {
      case "'":
        r8 += "\\'";
        break;
      case "\\":
        r8 += "\\\\";
        break;
      case `
`:
        r8 += "\\n";
        break;
      case "\r":
        r8 += "\\r";
        break;
      case "	":
        r8 += "\\t";
        break;
      default: {
        let n23 = s9.charCodeAt(0);
        n23 < 32 || n23 === 127 ? r8 += `\\${n23.toString(8).padStart(3, "0")}` : r8 += s9;
      }
    }
    return `${r8}'`;
  }
  return `'${e7}'`;
}
function fa(e7, t6) {
  e7.state.readonlyVars = e7.state.readonlyVars || /* @__PURE__ */ new Set(), e7.state.readonlyVars.add(t6);
}
function bt(e7, t6) {
  return e7.state.readonlyVars?.has(t6) ?? false;
}
function ha(e7, t6, r8 = "bash") {
  if (bt(e7, t6)) {
    let s9 = `${r8}: ${t6}: readonly variable
`;
    throw new d2(1, "", s9);
  }
  return null;
}
function pa(e7, t6) {
  let r8 = e7.state.exportedVars?.has(t6) ?? false;
  if (e7.state.exportedVars = e7.state.exportedVars || /* @__PURE__ */ new Set(), e7.state.exportedVars.add(t6), e7.state.localScopes.length > 0 && e7.state.localScopes[e7.state.localScopes.length - 1].has(t6) && !r8) {
    for (e7.state.localExportedVars || (e7.state.localExportedVars = []); e7.state.localExportedVars.length < e7.state.localScopes.length; ) e7.state.localExportedVars.push(/* @__PURE__ */ new Set());
    e7.state.localExportedVars[e7.state.localExportedVars.length - 1].add(t6);
  }
}
function da(e7, t6) {
  e7.state.exportedVars?.delete(t6);
}
function ue(e7, t6) {
  if (!/^[a-zA-Z_][a-zA-Z0-9_]*$/.test(t6)) return "";
  let r8 = "", s9 = e7.state.env.has(`${t6}__length`) || Array.from(e7.state.env.keys()).some((a7) => a7.startsWith(`${t6}_`) && /^[0-9]+$/.test(a7.slice(t6.length + 1))), n23 = e7.state.associativeArrays?.has(t6) ?? false;
  return s9 && !n23 && (r8 += "a"), n23 && (r8 += "A"), e7.state.integerVars?.has(t6) && (r8 += "i"), L2(e7, t6) && (r8 += "n"), bt(e7, t6) && (r8 += "r"), e7.state.exportedVars?.has(t6) && (r8 += "x"), r8;
}
async function bn(e7, t6, r8, s9) {
  return e7.coverage?.hit("bash:expansion:default_value"), (r8.isUnset || t6.checkEmpty && r8.isEmpty) && t6.word ? s9(e7, t6.word.parts, r8.inDoubleQuotes) : r8.effectiveValue;
}
async function wn(e7, t6, r8, s9, n23) {
  if (e7.coverage?.hit("bash:expansion:assign_default"), (s9.isUnset || r8.checkEmpty && s9.isEmpty) && r8.word) {
    let i10 = await n23(e7, r8.word.parts, s9.inDoubleQuotes), l8 = t6.match(/^([a-zA-Z_][a-zA-Z0-9_]*)\[(.+)\]$/);
    if (l8) {
      let [, o9, c15] = l8, u11;
      if (/^\d+$/.test(c15)) u11 = Number.parseInt(c15, 10);
      else {
        try {
          let h17 = new V2(), d16 = M2(h17, c15);
          u11 = await R(e7, d16.expression);
        } catch {
          let h17 = e7.state.env.get(c15);
          u11 = h17 ? Number.parseInt(h17, 10) : 0;
        }
        Number.isNaN(u11) && (u11 = 0);
      }
      e7.state.env.set(`${o9}_${u11}`, i10);
      let f11 = Number.parseInt(e7.state.env.get(`${o9}__length`) || "0", 10);
      u11 >= f11 && e7.state.env.set(`${o9}__length`, String(u11 + 1));
    } else e7.state.env.set(t6, i10);
    return i10;
  }
  return s9.effectiveValue;
}
async function Nn(e7, t6, r8, s9, n23) {
  if (e7.coverage?.hit("bash:expansion:error_if_unset"), s9.isUnset || r8.checkEmpty && s9.isEmpty) {
    let i10 = r8.word ? await n23(e7, r8.word.parts, s9.inDoubleQuotes) : `${t6}: parameter null or not set`;
    throw new d2(1, "", `bash: ${i10}
`);
  }
  return s9.effectiveValue;
}
async function kn(e7, t6, r8, s9) {
  return e7.coverage?.hit("bash:expansion:use_alternative"), !(r8.isUnset || t6.checkEmpty && r8.isEmpty) && t6.word ? s9(e7, t6.word.parts, r8.inDoubleQuotes) : "";
}
async function Pn(e7, t6, r8, s9, n23) {
  e7.coverage?.hit("bash:expansion:pattern_removal");
  let a7 = "", i10 = e7.state.shoptOptions.extglob;
  if (r8.pattern) for (let o9 of r8.pattern.parts) if (o9.type === "Glob") a7 += k(o9.pattern, r8.greedy, i10);
  else if (o9.type === "Literal") a7 += k(o9.value, r8.greedy, i10);
  else if (o9.type === "SingleQuoted" || o9.type === "Escaped") a7 += I2(o9.value);
  else if (o9.type === "DoubleQuoted") {
    let c15 = await s9(e7, o9.parts);
    a7 += I2(c15);
  } else if (o9.type === "ParameterExpansion") {
    let c15 = await n23(e7, o9);
    a7 += k(c15, r8.greedy, i10);
  } else {
    let c15 = await n23(e7, o9);
    a7 += I2(c15);
  }
  if (r8.side === "prefix") return b1(`^${a7}`, "s").replace(t6, "");
  let l8 = b1(`${a7}$`, "s");
  if (r8.greedy) return l8.replace(t6, "");
  for (let o9 = t6.length; o9 >= 0; o9--) {
    let c15 = t6.slice(o9);
    if (l8.test(c15)) return t6.slice(0, o9);
  }
  return t6;
}
async function Rn(e7, t6, r8, s9, n23) {
  e7.coverage?.hit("bash:expansion:pattern_replacement");
  let a7 = "", i10 = e7.state.shoptOptions.extglob;
  if (r8.pattern) for (let c15 of r8.pattern.parts) if (c15.type === "Glob") a7 += k(c15.pattern, true, i10);
  else if (c15.type === "Literal") a7 += k(c15.value, true, i10);
  else if (c15.type === "SingleQuoted" || c15.type === "Escaped") a7 += I2(c15.value);
  else if (c15.type === "DoubleQuoted") {
    let u11 = await s9(e7, c15.parts);
    a7 += I2(u11);
  } else if (c15.type === "ParameterExpansion") {
    let u11 = await n23(e7, c15);
    a7 += k(u11, true, i10);
  } else {
    let u11 = await n23(e7, c15);
    a7 += I2(u11);
  }
  let l8 = r8.replacement ? await s9(e7, r8.replacement.parts) : "";
  if (r8.anchor === "start" ? a7 = `^${a7}` : r8.anchor === "end" && (a7 = `${a7}$`), a7 === "") return t6;
  let o9 = r8.all ? "gs" : "s";
  try {
    let c15 = b1(a7, o9);
    if (r8.all) {
      let u11 = "", f11 = 0, h17 = 0, d16 = e7.limits.maxStringLength, m25 = c15.exec(t6);
      for (; m25 !== null && !(m25[0].length === 0 && m25.index === t6.length); ) {
        if (u11 += t6.slice(f11, m25.index) + l8, f11 = m25.index + m25[0].length, m25[0].length === 0 && f11++, h17++, h17 % 100 === 0 && u11.length > d16) throw new b2(`pattern replacement: string length limit exceeded (${d16} bytes)`, "string_length");
        m25 = c15.exec(t6);
      }
      return u11 += t6.slice(f11), u11;
    }
    return c15.replace(t6, l8);
  } catch (c15) {
    if (c15 instanceof b2) throw c15;
    return t6;
  }
}
function In(e7, t6, r8) {
  e7.coverage?.hit("bash:expansion:length");
  let s9 = t6.match(/^([a-zA-Z_][a-zA-Z0-9_]*)\[[@*]\]$/);
  if (s9) {
    let n23 = s9[1], a7 = P2(e7, n23);
    return a7.length > 0 ? String(a7.length) : e7.state.env.get(n23) !== void 0 ? "1" : "0";
  }
  if (/^[a-zA-Z_][a-zA-Z0-9_]*$/.test(t6) && Se(e7, t6)) {
    if (t6 === "FUNCNAME") {
      let a7 = e7.state.funcNameStack?.[0] || "";
      return String([...a7].length);
    }
    if (t6 === "BASH_LINENO") {
      let a7 = e7.state.callLineStack?.[0];
      return String(a7 !== void 0 ? [...String(a7)].length : 0);
    }
    let n23 = e7.state.env.get(`${t6}_0`) || "";
    return String([...n23].length);
  }
  return String([...r8].length);
}
async function vn(e7, t6, r8, s9) {
  e7.coverage?.hit("bash:expansion:substring");
  let n23 = await R(e7, s9.offset.expression), a7 = s9.length ? await R(e7, s9.length.expression) : void 0;
  if (t6 === "@" || t6 === "*") {
    let c15 = Number.parseInt(e7.state.env.get("#") || "0", 10), u11 = [];
    for (let m25 = 1; m25 <= c15; m25++) u11.push(e7.state.env.get(String(m25)) || "");
    let f11 = e7.state.env.get("0") || "bash", h17, d16;
    if (n23 <= 0) if (h17 = [f11, ...u11], n23 < 0) {
      if (d16 = h17.length + n23, d16 < 0) return "";
    } else d16 = 0;
    else h17 = u11, d16 = n23 - 1;
    if (d16 < 0 || d16 >= h17.length) return "";
    if (a7 !== void 0) {
      let m25 = a7 < 0 ? h17.length + a7 : d16 + a7;
      return h17.slice(d16, Math.max(d16, m25)).join(" ");
    }
    return h17.slice(d16).join(" ");
  }
  let i10 = t6.match(/^([a-zA-Z_][a-zA-Z0-9_]*)\[[@*]\]$/);
  if (i10) {
    let c15 = i10[1];
    if (e7.state.associativeArrays?.has(c15)) throw new d2(1, "", `bash: \${${c15}[@]: 0: 3}: bad substitution
`);
    let u11 = P2(e7, c15), f11 = 0;
    if (n23 < 0) {
      if (u11.length > 0) {
        let h17 = u11[u11.length - 1][0], m25 = (typeof h17 == "number" ? h17 : 0) + 1 + n23;
        if (m25 < 0 || (f11 = u11.findIndex(([g18]) => typeof g18 == "number" && g18 >= m25), f11 < 0)) return "";
      }
    } else if (f11 = u11.findIndex(([h17]) => typeof h17 == "number" && h17 >= n23), f11 < 0) return "";
    if (a7 !== void 0) {
      if (a7 < 0) throw new p(`${i10[1]}[@]: substring expression < 0`);
      return u11.slice(f11, f11 + a7).map(([, h17]) => h17).join(" ");
    }
    return u11.slice(f11).map(([, h17]) => h17).join(" ");
  }
  let l8 = [...r8], o9 = n23;
  if (o9 < 0 && (o9 = Math.max(0, l8.length + o9)), a7 !== void 0) {
    if (a7 < 0) {
      let c15 = l8.length + a7;
      return l8.slice(o9, Math.max(o9, c15)).join("");
    }
    return l8.slice(o9, o9 + a7).join("");
  }
  return l8.slice(o9).join("");
}
async function Dn(e7, t6, r8, s9, n23) {
  if (e7.coverage?.hit("bash:expansion:case_modification"), r8.pattern) {
    let a7 = e7.state.shoptOptions.extglob, i10 = "";
    for (let f11 of r8.pattern.parts) if (f11.type === "Glob") i10 += k(f11.pattern, true, a7);
    else if (f11.type === "Literal") i10 += k(f11.value, true, a7);
    else if (f11.type === "SingleQuoted" || f11.type === "Escaped") i10 += I2(f11.value);
    else if (f11.type === "DoubleQuoted") {
      let h17 = await s9(e7, f11.parts);
      i10 += I2(h17);
    } else if (f11.type === "ParameterExpansion") {
      let h17 = await n23(e7, f11);
      i10 += k(h17, true, a7);
    }
    let l8 = b1(`^(?:${i10})$`), o9 = r8.direction === "upper" ? (f11) => f11.toUpperCase() : (f11) => f11.toLowerCase(), c15 = "", u11 = false;
    for (let f11 of t6) !r8.all && u11 ? c15 += f11 : l8.test(f11) ? (c15 += o9(f11), u11 = true) : c15 += f11;
    return c15;
  }
  return r8.direction === "upper" ? r8.all ? t6.toUpperCase() : t6.charAt(0).toUpperCase() + t6.slice(1) : r8.all ? t6.toLowerCase() : t6.charAt(0).toLowerCase() + t6.slice(1);
}
function xn(e7, t6, r8, s9, n23) {
  e7.coverage?.hit("bash:expansion:transform");
  let a7 = t6.match(/^([a-zA-Z_][a-zA-Z0-9_]*)\[[@*]\]$/);
  if (a7 && n23.operator === "Q") return P2(e7, a7[1]).map(([, c15]) => le(c15)).join(" ");
  if (a7 && n23.operator === "a") return ue(e7, a7[1]);
  let i10 = t6.match(/^([a-zA-Z_][a-zA-Z0-9_]*)\[.+\]$/);
  if (i10 && n23.operator === "a") return ue(e7, i10[1]);
  switch (n23.operator) {
    case "Q":
      return s9 ? "" : le(r8);
    case "P":
      return be(e7, r8);
    case "a":
      return ue(e7, t6);
    case "A":
      return s9 ? "" : `${t6}=${le(r8)}`;
    case "E":
      return r8.replace(/\\([\\abefnrtv'"?])/g, (l8, o9) => {
        switch (o9) {
          case "\\":
            return "\\";
          case "a":
            return "\x07";
          case "b":
            return "\b";
          case "e":
            return "\x1B";
          case "f":
            return "\f";
          case "n":
            return `
`;
          case "r":
            return "\r";
          case "t":
            return "	";
          case "v":
            return "\v";
          case "'":
            return "'";
          case '"':
            return '"';
          case "?":
            return "?";
          default:
            return o9;
        }
      });
    case "K":
    case "k":
      return s9 ? "" : le(r8);
    case "u":
      return r8.charAt(0).toUpperCase() + r8.slice(1);
    case "U":
      return r8.toUpperCase();
    case "L":
      return r8.toLowerCase();
    default:
      return r8;
  }
}
async function _n(e7, t6, r8, s9, n23, a7, i10 = false) {
  if (e7.coverage?.hit("bash:expansion:indirection"), L2(e7, t6)) return Ae(e7, t6) || "";
  let l8 = /^[a-zA-Z_][a-zA-Z0-9_]*\[([@*])\]$/.test(t6);
  if (s9) {
    if (n23.innerOp?.type === "UseAlternative") return "";
    throw new h(`\${!${t6}}`);
  }
  let o9 = r8;
  if (l8 && (o9 === "" || o9.includes(" "))) throw new h(`\${!${t6}}`);
  let c15 = o9.match(/^[a-zA-Z_][a-zA-Z0-9_]*\[(.+)\]$/);
  if (c15 && c15[1].includes("~")) throw new h(`\${!${t6}}`);
  if (n23.innerOp) {
    let u11 = { type: "ParameterExpansion", parameter: o9, operation: n23.innerOp };
    return a7(e7, u11, i10);
  }
  return await v2(e7, o9);
}
function $n(e7, t6) {
  e7.coverage?.hit("bash:expansion:array_keys");
  let s9 = P2(e7, t6.array).map(([n23]) => String(n23));
  return t6.star ? s9.join(N2(e7.state.env)) : s9.join(" ");
}
function Cn(e7, t6) {
  e7.coverage?.hit("bash:expansion:var_name_prefix");
  let r8 = me(e7, t6.prefix);
  return t6.star ? r8.join(N2(e7.state.env)) : r8.join(" ");
}
function On(e7, t6, r8, s9) {
  let n23 = Number.parseInt(e7.state.env.get("#") || "0", 10), a7 = t6.match(/^([a-zA-Z_][a-zA-Z0-9_]*)\[([@*])\]$/);
  if (t6 === "*") return { isEmpty: n23 === 0, effectiveValue: r8 };
  if (t6 === "@") return { isEmpty: n23 === 0 || n23 === 1 && e7.state.env.get("1") === "", effectiveValue: r8 };
  if (a7) {
    let [, i10, l8] = a7, o9 = P2(e7, i10);
    if (o9.length === 0) return { isEmpty: true, effectiveValue: "" };
    if (l8 === "*") {
      let c15 = N2(e7.state.env), u11 = o9.map(([, f11]) => f11).join(c15);
      return { isEmpty: s9 ? u11 === "" : false, effectiveValue: u11 };
    }
    return { isEmpty: o9.length === 1 && o9.every(([, c15]) => c15 === ""), effectiveValue: o9.map(([, c15]) => c15).join(" ") };
  }
  return { isEmpty: r8 === "", effectiveValue: r8 };
}
function Ln(e7) {
  let t6 = 0;
  for (; t6 < e7.length; ) {
    let r8 = e7[t6];
    if (r8 === "\\" && t6 + 1 < e7.length) {
      t6 += 2;
      continue;
    }
    if (r8 === "'") {
      let s9 = e7.indexOf("'", t6 + 1);
      if (s9 !== -1) {
        t6 = s9 + 1;
        continue;
      }
    }
    if (r8 === "$" && t6 + 1 < e7.length && e7[t6 + 1] === "(" || r8 === "`") return true;
    t6++;
  }
  return false;
}
function Wn(e7, t6) {
  let r8 = 1, s9 = t6, n23 = false, a7 = false;
  for (; s9 < e7.length && r8 > 0; ) {
    let i10 = e7[s9];
    if (i10 === "\\" && !n23 && s9 + 1 < e7.length) {
      s9 += 2;
      continue;
    }
    if (i10 === "'" && !a7) {
      n23 = !n23, s9++;
      continue;
    }
    if (i10 === '"' && !n23) {
      a7 = !a7, s9++;
      continue;
    }
    if (!n23 && !a7) {
      if (i10 === "(") r8++;
      else if (i10 === ")" && (r8--, r8 === 0)) return s9;
    }
    s9++;
  }
  return -1;
}
async function Le(e7, t6) {
  let r8 = new V2(), s9;
  try {
    s9 = r8.parse(t6);
  } catch {
    return "";
  }
  let n23 = e7.state.bashPid;
  e7.state.bashPid = e7.state.nextVirtualPid++;
  let a7 = new Map(e7.state.env), i10 = e7.state.cwd, l8 = e7.state.suppressVerbose;
  e7.state.suppressVerbose = true;
  try {
    let o9 = await e7.executeScript(s9), c15 = o9.exitCode;
    return e7.state.env = a7, e7.state.cwd = i10, e7.state.suppressVerbose = l8, e7.state.lastExitCode = c15, e7.state.env.set("?", String(c15)), o9.stderr && (e7.state.expansionStderr = (e7.state.expansionStderr || "") + o9.stderr), e7.state.bashPid = n23, o9.stdout.replace(/\n+$/, "");
  } catch (o9) {
    if (e7.state.env = a7, e7.state.cwd = i10, e7.state.bashPid = n23, e7.state.suppressVerbose = l8, o9 instanceof b2) throw o9;
    return o9 instanceof d2 ? (e7.state.lastExitCode = o9.exitCode, e7.state.env.set("?", String(o9.exitCode)), o9.stdout?.replace(/\n+$/, "") ?? "") : "";
  }
}
function wt(e7, t6) {
  let r8 = "", s9 = 0;
  for (; s9 < t6.length; ) {
    let n23 = t6[s9];
    if (n23 === "'") {
      let a7 = t6.indexOf("'", s9 + 1);
      if (a7 !== -1) {
        let i10 = t6.slice(s9 + 1, a7);
        r8 += X2(i10), s9 = a7 + 1;
        continue;
      }
    }
    if (n23 === '"') {
      let a7 = -1, i10 = s9 + 1;
      for (; i10 < t6.length; ) {
        if (t6[i10] === "\\") {
          i10 += 2;
          continue;
        }
        if (t6[i10] === '"') {
          a7 = i10;
          break;
        }
        i10++;
      }
      if (a7 !== -1) {
        let l8 = t6.slice(s9 + 1, a7), o9 = Es(e7, l8);
        r8 += X2(o9), s9 = a7 + 1;
        continue;
      }
    }
    if (n23 === "$" && s9 + 1 < t6.length) {
      let a7 = t6[s9 + 1];
      if (a7 === "{") {
        let i10 = t6.indexOf("}", s9 + 2);
        if (i10 !== -1) {
          let l8 = t6.slice(s9 + 2, i10);
          r8 += e7.state.env.get(l8) ?? "", s9 = i10 + 1;
          continue;
        }
      } else if (/[a-zA-Z_]/.test(a7)) {
        let i10 = s9 + 1;
        for (; i10 < t6.length && /[a-zA-Z0-9_]/.test(t6[i10]); ) i10++;
        let l8 = t6.slice(s9 + 1, i10);
        r8 += e7.state.env.get(l8) ?? "", s9 = i10;
        continue;
      }
    }
    if (n23 === "\\" && s9 + 1 < t6.length) {
      r8 += n23 + t6[s9 + 1], s9 += 2;
      continue;
    }
    r8 += n23, s9++;
  }
  return r8;
}
function Es(e7, t6) {
  let r8 = "", s9 = 0;
  for (; s9 < t6.length; ) {
    let n23 = t6[s9];
    if (n23 === "\\" && s9 + 1 < t6.length) {
      let a7 = t6[s9 + 1];
      if (a7 === "$" || a7 === "`" || a7 === "\\" || a7 === '"') {
        r8 += a7, s9 += 2;
        continue;
      }
      r8 += n23, s9++;
      continue;
    }
    if (n23 === "$" && s9 + 1 < t6.length) {
      let a7 = t6[s9 + 1];
      if (a7 === "{") {
        let i10 = t6.indexOf("}", s9 + 2);
        if (i10 !== -1) {
          let l8 = t6.slice(s9 + 2, i10);
          r8 += e7.state.env.get(l8) ?? "", s9 = i10 + 1;
          continue;
        }
      } else if (/[a-zA-Z_]/.test(a7)) {
        let i10 = s9 + 1;
        for (; i10 < t6.length && /[a-zA-Z0-9_]/.test(t6[i10]); ) i10++;
        let l8 = t6.slice(s9 + 1, i10);
        r8 += e7.state.env.get(l8) ?? "", s9 = i10;
        continue;
      }
    }
    r8 += n23, s9++;
  }
  return r8;
}
async function Tn(e7, t6) {
  let r8 = "", s9 = 0;
  for (; s9 < t6.length; ) {
    let n23 = t6[s9];
    if (n23 === "'") {
      let a7 = t6.indexOf("'", s9 + 1);
      if (a7 !== -1) {
        let i10 = t6.slice(s9 + 1, a7);
        r8 += X2(i10), s9 = a7 + 1;
        continue;
      }
    }
    if (n23 === '"') {
      let a7 = -1, i10 = s9 + 1;
      for (; i10 < t6.length; ) {
        if (t6[i10] === "\\") {
          i10 += 2;
          continue;
        }
        if (t6[i10] === '"') {
          a7 = i10;
          break;
        }
        i10++;
      }
      if (a7 !== -1) {
        let l8 = t6.slice(s9 + 1, a7), o9 = await As(e7, l8);
        r8 += X2(o9), s9 = a7 + 1;
        continue;
      }
    }
    if (n23 === "$" && s9 + 1 < t6.length && t6[s9 + 1] === "(") {
      let a7 = Wn(t6, s9 + 2);
      if (a7 !== -1) {
        let i10 = t6.slice(s9 + 2, a7), l8 = await Le(e7, i10);
        r8 += l8, s9 = a7 + 1;
        continue;
      }
    }
    if (n23 === "`") {
      let a7 = t6.indexOf("`", s9 + 1);
      if (a7 !== -1) {
        let i10 = t6.slice(s9 + 1, a7), l8 = await Le(e7, i10);
        r8 += l8, s9 = a7 + 1;
        continue;
      }
    }
    if (n23 === "$" && s9 + 1 < t6.length) {
      let a7 = t6[s9 + 1];
      if (a7 === "{") {
        let i10 = t6.indexOf("}", s9 + 2);
        if (i10 !== -1) {
          let l8 = t6.slice(s9 + 2, i10);
          r8 += e7.state.env.get(l8) ?? "", s9 = i10 + 1;
          continue;
        }
      } else if (/[a-zA-Z_]/.test(a7)) {
        let i10 = s9 + 1;
        for (; i10 < t6.length && /[a-zA-Z0-9_]/.test(t6[i10]); ) i10++;
        let l8 = t6.slice(s9 + 1, i10);
        r8 += e7.state.env.get(l8) ?? "", s9 = i10;
        continue;
      }
    }
    if (n23 === "\\" && s9 + 1 < t6.length) {
      r8 += n23 + t6[s9 + 1], s9 += 2;
      continue;
    }
    r8 += n23, s9++;
  }
  return r8;
}
async function As(e7, t6) {
  let r8 = "", s9 = 0;
  for (; s9 < t6.length; ) {
    let n23 = t6[s9];
    if (n23 === "\\" && s9 + 1 < t6.length) {
      let a7 = t6[s9 + 1];
      if (a7 === "$" || a7 === "`" || a7 === "\\" || a7 === '"') {
        r8 += a7, s9 += 2;
        continue;
      }
      r8 += n23, s9++;
      continue;
    }
    if (n23 === "$" && s9 + 1 < t6.length && t6[s9 + 1] === "(") {
      let a7 = Wn(t6, s9 + 2);
      if (a7 !== -1) {
        let i10 = t6.slice(s9 + 2, a7), l8 = await Le(e7, i10);
        r8 += l8, s9 = a7 + 1;
        continue;
      }
    }
    if (n23 === "`") {
      let a7 = t6.indexOf("`", s9 + 1);
      if (a7 !== -1) {
        let i10 = t6.slice(s9 + 1, a7), l8 = await Le(e7, i10);
        r8 += l8, s9 = a7 + 1;
        continue;
      }
    }
    if (n23 === "$" && s9 + 1 < t6.length) {
      let a7 = t6[s9 + 1];
      if (a7 === "{") {
        let i10 = t6.indexOf("}", s9 + 2);
        if (i10 !== -1) {
          let l8 = t6.slice(s9 + 2, i10);
          r8 += e7.state.env.get(l8) ?? "", s9 = i10 + 1;
          continue;
        }
      } else if (/[a-zA-Z_]/.test(a7)) {
        let i10 = s9 + 1;
        for (; i10 < t6.length && /[a-zA-Z0-9_]/.test(t6[i10]); ) i10++;
        let l8 = t6.slice(s9 + 1, i10);
        r8 += e7.state.env.get(l8) ?? "", s9 = i10;
        continue;
      }
    }
    r8 += n23, s9++;
  }
  return r8;
}
function Mn(e7, t6) {
  if (!t6.startsWith("~")) return t6;
  e7.coverage?.hit("bash:expansion:tilde");
  let r8 = e7.state.env.get("HOME") !== void 0 ? e7.state.env.get("HOME") : "/home/user";
  if (t6 === "~" || t6.startsWith("~/")) return r8 + t6.slice(1);
  let s9 = 1;
  for (; s9 < t6.length && /[a-zA-Z0-9_-]/.test(t6[s9]); ) s9++;
  let n23 = t6.slice(1, s9), a7 = t6.slice(s9);
  return a7 !== "" && !a7.startsWith("/") ? t6 : n23 === "root" ? `/root${a7}` : t6;
}
async function Ss(e7, t6, r8, s9) {
  let n23 = "";
  for (let a7 of t6.parts) if (a7.type === "Glob") n23 += k(a7.pattern, true, e7.state.shoptOptions.extglob);
  else if (a7.type === "Literal") n23 += k(a7.value, true, e7.state.shoptOptions.extglob);
  else if (a7.type === "SingleQuoted" || a7.type === "Escaped") n23 += I2(a7.value);
  else if (a7.type === "DoubleQuoted") {
    let i10 = await r8(e7, a7.parts);
    n23 += I2(i10);
  } else if (a7.type === "ParameterExpansion") {
    let i10 = await s9(e7, a7);
    n23 += k(i10, true, e7.state.shoptOptions.extglob);
  } else {
    let i10 = await s9(e7, a7);
    n23 += I2(i10);
  }
  return n23;
}
async function Vn(e7, t6, r8, s9) {
  if (t6.length !== 1 || t6[0].type !== "DoubleQuoted") return null;
  let n23 = t6[0];
  if (n23.parts.length !== 1 || n23.parts[0].type !== "ParameterExpansion" || n23.parts[0].operation?.type !== "PatternReplacement") return null;
  let a7 = n23.parts[0], i10 = a7.parameter.match(/^([a-zA-Z_][a-zA-Z0-9_]*)\[([@*])\]$/);
  if (!i10) return null;
  let l8 = i10[1], o9 = i10[2] === "*", c15 = a7.operation, u11 = P2(e7, l8), f11 = u11.map(([, E13]) => E13);
  if (u11.length === 0) {
    let E13 = e7.state.env.get(l8);
    E13 !== void 0 && f11.push(E13);
  }
  if (f11.length === 0) return { values: [], quoted: true };
  let h17 = "";
  c15.pattern && (h17 = await Ss(e7, c15.pattern, r8, s9));
  let d16 = c15.replacement ? await r8(e7, c15.replacement.parts) : "", m25 = h17;
  c15.anchor === "start" ? m25 = `^${h17}` : c15.anchor === "end" && (m25 = `${h17}$`);
  let g18 = [];
  try {
    let E13 = b1(m25, c15.all ? "g" : "");
    for (let A14 of f11) g18.push(E13.replace(A14, d16));
  } catch {
    g18.push(...f11);
  }
  if (o9) {
    let E13 = N2(e7.state.env);
    return { values: [g18.join(E13)], quoted: true };
  }
  return { values: g18, quoted: true };
}
async function qn(e7, t6, r8, s9) {
  if (t6.length !== 1 || t6[0].type !== "DoubleQuoted") return null;
  let n23 = t6[0];
  if (n23.parts.length !== 1 || n23.parts[0].type !== "ParameterExpansion" || n23.parts[0].operation?.type !== "PatternRemoval") return null;
  let a7 = n23.parts[0], i10 = a7.parameter.match(/^([a-zA-Z_][a-zA-Z0-9_]*)\[([@*])\]$/);
  if (!i10) return null;
  let l8 = i10[1], o9 = i10[2] === "*", c15 = a7.operation, u11 = P2(e7, l8), f11 = u11.map(([, g18]) => g18);
  if (u11.length === 0) {
    let g18 = e7.state.env.get(l8);
    g18 !== void 0 && f11.push(g18);
  }
  if (f11.length === 0) return { values: [], quoted: true };
  let h17 = "", d16 = e7.state.shoptOptions.extglob;
  if (c15.pattern) for (let g18 of c15.pattern.parts) if (g18.type === "Glob") h17 += k(g18.pattern, c15.greedy, d16);
  else if (g18.type === "Literal") h17 += k(g18.value, c15.greedy, d16);
  else if (g18.type === "SingleQuoted" || g18.type === "Escaped") h17 += I2(g18.value);
  else if (g18.type === "DoubleQuoted") {
    let E13 = await r8(e7, g18.parts);
    h17 += I2(E13);
  } else if (g18.type === "ParameterExpansion") {
    let E13 = await s9(e7, g18);
    h17 += k(E13, c15.greedy, d16);
  } else {
    let E13 = await s9(e7, g18);
    h17 += I2(E13);
  }
  let m25 = [];
  for (let g18 of f11) m25.push(se(g18, h17, c15.side, c15.greedy));
  if (o9) {
    let g18 = N2(e7.state.env);
    return { values: [m25.join(g18)], quoted: true };
  }
  return { values: m25, quoted: true };
}
async function Bn(e7, t6) {
  if (t6.length !== 1 || t6[0].type !== "DoubleQuoted") return null;
  let r8 = t6[0];
  if (r8.parts.length !== 1 || r8.parts[0].type !== "ParameterExpansion" || r8.parts[0].operation?.type !== "DefaultValue" && r8.parts[0].operation?.type !== "UseAlternative" && r8.parts[0].operation?.type !== "AssignDefault") return null;
  let s9 = r8.parts[0], n23 = s9.operation, a7 = s9.parameter.match(/^([a-zA-Z_][a-zA-Z0-9_]*)\[([@*])\]$/), i10, l8 = false;
  if (a7) {
    let o9 = a7[1];
    l8 = a7[2] === "*";
    let c15 = P2(e7, o9), u11 = c15.length > 0 || e7.state.env.has(o9), f11 = c15.length === 0 || c15.length === 1 && c15.every(([, d16]) => d16 === ""), h17 = n23.checkEmpty ?? false;
    if (n23.type === "UseAlternative" ? i10 = u11 && !(h17 && f11) : i10 = !u11 || h17 && f11, !i10) {
      if (c15.length > 0) {
        let m25 = c15.map(([, g18]) => g18);
        if (l8) {
          let g18 = N2(e7.state.env);
          return { values: [m25.join(g18)], quoted: true };
        }
        return { values: m25, quoted: true };
      }
      let d16 = e7.state.env.get(o9);
      return d16 !== void 0 ? { values: [d16], quoted: true } : { values: [], quoted: true };
    }
  } else {
    let o9 = s9.parameter, c15 = await te(e7, o9), u11 = await v2(e7, o9), f11 = u11 === "", h17 = n23.checkEmpty ?? false;
    if (n23.type === "UseAlternative" ? i10 = c15 && !(h17 && f11) : i10 = !c15 || h17 && f11, !i10) return { values: [u11], quoted: true };
  }
  if (i10 && n23.word) {
    let o9 = n23.word.parts, c15 = null, u11 = false;
    for (let f11 of o9) if (f11.type === "ParameterExpansion" && !f11.operation) {
      let h17 = f11.parameter.match(/^([a-zA-Z_][a-zA-Z0-9_]*)\[([@*])\]$/);
      if (h17) {
        c15 = h17[1], u11 = h17[2] === "*";
        break;
      }
    }
    if (c15) {
      let f11 = P2(e7, c15);
      if (f11.length > 0) {
        let d16 = f11.map(([, m25]) => m25);
        if (u11 || l8) {
          let m25 = N2(e7.state.env);
          return { values: [d16.join(m25)], quoted: true };
        }
        return { values: d16, quoted: true };
      }
      let h17 = e7.state.env.get(c15);
      return h17 !== void 0 ? { values: [h17], quoted: true } : { values: [], quoted: true };
    }
  }
  return null;
}
async function Fn(e7, t6, r8, s9, n23) {
  if (!r8 || t6.length !== 1 || t6[0].type !== "DoubleQuoted") return null;
  let a7 = t6[0], i10 = -1, l8 = "", o9 = false, c15 = null;
  for (let g18 = 0; g18 < a7.parts.length; g18++) {
    let E13 = a7.parts[g18];
    if (E13.type === "ParameterExpansion" && (E13.operation?.type === "PatternRemoval" || E13.operation?.type === "PatternReplacement")) {
      let A14 = E13.parameter.match(/^([a-zA-Z_][a-zA-Z0-9_]*)\[([@*])\]$/);
      if (A14) {
        i10 = g18, l8 = A14[1], o9 = A14[2] === "*", c15 = E13.operation;
        break;
      }
    }
  }
  if (i10 === -1 || i10 === 0 && i10 === a7.parts.length - 1) return null;
  let u11 = "";
  for (let g18 = 0; g18 < i10; g18++) u11 += await s9(e7, a7.parts[g18]);
  let f11 = "";
  for (let g18 = i10 + 1; g18 < a7.parts.length; g18++) f11 += await s9(e7, a7.parts[g18]);
  let h17 = P2(e7, l8), d16 = h17.map(([, g18]) => g18);
  if (h17.length === 0) {
    let g18 = e7.state.env.get(l8);
    if (g18 !== void 0) d16 = [g18];
    else {
      if (o9) return { values: [u11 + f11], quoted: true };
      let E13 = u11 + f11;
      return { values: E13 ? [E13] : [], quoted: true };
    }
  }
  if (c15?.type === "PatternRemoval") {
    let g18 = c15, E13 = "", A14 = e7.state.shoptOptions.extglob;
    if (g18.pattern) for (let S17 of g18.pattern.parts) if (S17.type === "Glob") E13 += k(S17.pattern, g18.greedy, A14);
    else if (S17.type === "Literal") E13 += k(S17.value, g18.greedy, A14);
    else if (S17.type === "SingleQuoted" || S17.type === "Escaped") E13 += I2(S17.value);
    else if (S17.type === "DoubleQuoted") {
      let y18 = await n23(e7, S17.parts);
      E13 += I2(y18);
    } else if (S17.type === "ParameterExpansion") {
      let y18 = await s9(e7, S17);
      E13 += k(y18, g18.greedy, A14);
    } else {
      let y18 = await s9(e7, S17);
      E13 += I2(y18);
    }
    d16 = d16.map((S17) => se(S17, E13, g18.side, g18.greedy));
  } else if (c15?.type === "PatternReplacement") {
    let g18 = c15, E13 = "";
    if (g18.pattern) for (let y18 of g18.pattern.parts) if (y18.type === "Glob") E13 += k(y18.pattern, true, e7.state.shoptOptions.extglob);
    else if (y18.type === "Literal") E13 += k(y18.value, true, e7.state.shoptOptions.extglob);
    else if (y18.type === "SingleQuoted" || y18.type === "Escaped") E13 += I2(y18.value);
    else if (y18.type === "DoubleQuoted") {
      let b25 = await n23(e7, y18.parts);
      E13 += I2(b25);
    } else if (y18.type === "ParameterExpansion") {
      let b25 = await s9(e7, y18);
      E13 += k(b25, true, e7.state.shoptOptions.extglob);
    } else {
      let b25 = await s9(e7, y18);
      E13 += I2(b25);
    }
    let A14 = g18.replacement ? await n23(e7, g18.replacement.parts) : "", S17 = E13;
    g18.anchor === "start" ? S17 = `^${E13}` : g18.anchor === "end" && (S17 = `${E13}$`);
    try {
      let y18 = b1(S17, g18.all ? "g" : "");
      d16 = d16.map((b25) => y18.replace(b25, A14));
    } catch {
    }
  }
  if (o9) {
    let g18 = N2(e7.state.env);
    return { values: [u11 + d16.join(g18) + f11], quoted: true };
  }
  return d16.length === 1 ? { values: [u11 + d16[0] + f11], quoted: true } : { values: [u11 + d16[0], ...d16.slice(1, -1), d16[d16.length - 1] + f11], quoted: true };
}
async function zn(e7, t6, r8, s9) {
  if (!r8 || t6.length !== 1 || t6[0].type !== "DoubleQuoted") return null;
  let n23 = t6[0], a7 = -1, i10 = "", l8 = false;
  for (let d16 = 0; d16 < n23.parts.length; d16++) {
    let m25 = n23.parts[d16];
    if (m25.type === "ParameterExpansion" && !m25.operation) {
      let g18 = m25.parameter.match(/^([a-zA-Z_][a-zA-Z0-9_]*)\[([@*])\]$/);
      if (g18) {
        a7 = d16, i10 = g18[1], l8 = g18[2] === "*";
        break;
      }
    }
  }
  if (a7 === -1) return null;
  let o9 = "";
  for (let d16 = 0; d16 < a7; d16++) o9 += await s9(e7, n23.parts[d16]);
  let c15 = "";
  for (let d16 = a7 + 1; d16 < n23.parts.length; d16++) c15 += await s9(e7, n23.parts[d16]);
  let u11 = P2(e7, i10), f11 = u11.map(([, d16]) => d16);
  if (u11.length === 0) {
    let d16 = e7.state.env.get(i10);
    if (d16 !== void 0) return { values: [o9 + d16 + c15], quoted: true };
    if (l8) return { values: [o9 + c15], quoted: true };
    let m25 = o9 + c15;
    return { values: m25 ? [m25] : [], quoted: true };
  }
  if (l8) {
    let d16 = N2(e7.state.env);
    return { values: [o9 + f11.join(d16) + c15], quoted: true };
  }
  return f11.length === 1 ? { values: [o9 + f11[0] + c15], quoted: true } : { values: [o9 + f11[0], ...f11.slice(1, -1), f11[f11.length - 1] + c15], quoted: true };
}
async function Qn(e7, t6, r8) {
  if (t6.length !== 1 || t6[0].type !== "DoubleQuoted") return null;
  let s9 = t6[0];
  if (s9.parts.length !== 1 || s9.parts[0].type !== "ParameterExpansion" || s9.parts[0].operation?.type !== "Substring") return null;
  let n23 = s9.parts[0], a7 = n23.parameter.match(/^([a-zA-Z_][a-zA-Z0-9_]*)\[([@*])\]$/);
  if (!a7) return null;
  let i10 = a7[1], l8 = a7[2] === "*", o9 = n23.operation;
  if (e7.state.associativeArrays?.has(i10)) throw new d2(1, "", `bash: \${${i10}[@]: 0: 3}: bad substitution
`);
  let c15 = o9.offset ? await r8(e7, o9.offset.expression) : 0, u11 = o9.length ? await r8(e7, o9.length.expression) : void 0, f11 = P2(e7, i10), h17 = 0;
  if (c15 < 0) {
    if (f11.length > 0) {
      let m25 = f11[f11.length - 1][0], E13 = (typeof m25 == "number" ? m25 : 0) + 1 + c15;
      if (E13 < 0) return { values: [], quoted: true };
      h17 = f11.findIndex(([A14]) => typeof A14 == "number" && A14 >= E13), h17 < 0 && (h17 = f11.length);
    }
  } else h17 = f11.findIndex(([m25]) => typeof m25 == "number" && m25 >= c15), h17 < 0 && (h17 = f11.length);
  let d16;
  if (u11 !== void 0) {
    if (u11 < 0) throw new p(`${i10}[@]: substring expression < 0`);
    d16 = f11.slice(h17, h17 + u11).map(([, m25]) => m25);
  } else d16 = f11.slice(h17).map(([, m25]) => m25);
  if (d16.length === 0) return { values: [], quoted: true };
  if (l8) {
    let m25 = N2(e7.state.env);
    return { values: [d16.join(m25)], quoted: true };
  }
  return { values: d16, quoted: true };
}
function Gn(e7, t6) {
  if (t6.length !== 1 || t6[0].type !== "DoubleQuoted") return null;
  let r8 = t6[0];
  if (r8.parts.length !== 1 || r8.parts[0].type !== "ParameterExpansion" || r8.parts[0].operation?.type !== "Transform") return null;
  let s9 = r8.parts[0], n23 = s9.parameter.match(/^([a-zA-Z_][a-zA-Z0-9_]*)\[([@*])\]$/);
  if (!n23) return null;
  let a7 = n23[1], i10 = n23[2] === "*", l8 = s9.operation, o9 = P2(e7, a7);
  if (o9.length === 0) {
    let f11 = e7.state.env.get(a7);
    if (f11 !== void 0) {
      let h17;
      switch (l8.operator) {
        case "a":
          h17 = "";
          break;
        case "P":
          h17 = be(e7, f11);
          break;
        case "Q":
          h17 = le(f11);
          break;
        default:
          h17 = f11;
      }
      return { values: [h17], quoted: true };
    }
    return i10 ? { values: [""], quoted: true } : { values: [], quoted: true };
  }
  let c15 = ue(e7, a7), u11;
  switch (l8.operator) {
    case "a":
      u11 = o9.map(() => c15);
      break;
    case "P":
      u11 = o9.map(([, f11]) => be(e7, f11));
      break;
    case "Q":
      u11 = o9.map(([, f11]) => le(f11));
      break;
    case "u":
      u11 = o9.map(([, f11]) => f11.charAt(0).toUpperCase() + f11.slice(1));
      break;
    case "U":
      u11 = o9.map(([, f11]) => f11.toUpperCase());
      break;
    case "L":
      u11 = o9.map(([, f11]) => f11.toLowerCase());
      break;
    default:
      u11 = o9.map(([, f11]) => f11);
  }
  if (i10) {
    let f11 = N2(e7.state.env);
    return { values: [u11.join(f11)], quoted: true };
  }
  return { values: u11, quoted: true };
}
function Zn(e7, t6) {
  if (t6.length !== 1 || t6[0].type !== "DoubleQuoted") return null;
  let r8 = t6[0];
  if (r8.parts.length !== 1 || r8.parts[0].type !== "ParameterExpansion") return null;
  let s9 = r8.parts[0];
  if (s9.operation) return null;
  let n23 = s9.parameter.match(/^([a-zA-Z_][a-zA-Z0-9_]*)\[(@)\]$/);
  if (!n23) return null;
  let a7 = n23[1];
  if (L2(e7, a7)) {
    let o9 = Ae(e7, a7);
    if (o9?.endsWith("[@]") || o9?.endsWith("[*]")) return { values: [], quoted: true };
  }
  let i10 = P2(e7, a7);
  if (i10.length > 0) return { values: i10.map(([, o9]) => o9), quoted: true };
  let l8 = e7.state.env.get(a7);
  return l8 !== void 0 ? { values: [l8], quoted: true } : { values: [], quoted: true };
}
function Un(e7, t6) {
  if (t6.length !== 1 || t6[0].type !== "DoubleQuoted") return null;
  let r8 = t6[0];
  if (r8.parts.length !== 1 || r8.parts[0].type !== "ParameterExpansion" || r8.parts[0].operation) return null;
  let n23 = r8.parts[0].parameter;
  if (!/^[a-zA-Z_][a-zA-Z0-9_]*$/.test(n23) || !L2(e7, n23)) return null;
  let a7 = Ae(e7, n23);
  if (!a7) return null;
  let i10 = a7.match(/^([a-zA-Z_][a-zA-Z0-9_]*)\[(@)\]$/);
  if (!i10) return null;
  let l8 = i10[1], o9 = P2(e7, l8);
  if (o9.length > 0) return { values: o9.map(([, u11]) => u11), quoted: true };
  let c15 = e7.state.env.get(l8);
  return c15 !== void 0 ? { values: [c15], quoted: true } : { values: [], quoted: true };
}
async function Hn(e7, t6, r8, s9, n23) {
  if (!r8 || t6.length !== 1 || t6[0].type !== "DoubleQuoted") return null;
  let a7 = t6[0];
  if (a7.parts.length !== 1 || a7.parts[0].type !== "ParameterExpansion" || a7.parts[0].operation?.type !== "Indirection") return null;
  let i10 = a7.parts[0], l8 = i10.operation, o9 = await v2(e7, i10.parameter), c15 = o9.match(/^([a-zA-Z_][a-zA-Z0-9_]*)\[([@*])\]$/);
  if (!c15) {
    if (!l8.innerOp && (o9 === "@" || o9 === "*")) {
      let m25 = Number.parseInt(e7.state.env.get("#") || "0", 10), g18 = [];
      for (let E13 = 1; E13 <= m25; E13++) g18.push(e7.state.env.get(String(E13)) || "");
      return o9 === "*" ? { values: [g18.join(N2(e7.state.env))], quoted: true } : { values: g18, quoted: true };
    }
    return null;
  }
  let u11 = c15[1], f11 = c15[2] === "*", h17 = P2(e7, u11);
  if (l8.innerOp) {
    if (l8.innerOp.type === "Substring") return bs(e7, h17, u11, f11, l8.innerOp);
    if (l8.innerOp.type === "DefaultValue" || l8.innerOp.type === "UseAlternative" || l8.innerOp.type === "AssignDefault" || l8.innerOp.type === "ErrorIfUnset") return ws(e7, h17, u11, f11, l8.innerOp, n23);
    if (l8.innerOp.type === "Transform" && l8.innerOp.operator === "a") {
      let g18 = ue(e7, u11), E13 = h17.map(() => g18);
      return f11 ? { values: [E13.join(N2(e7.state.env))], quoted: true } : { values: E13, quoted: true };
    }
    let m25 = [];
    for (let [, g18] of h17) {
      let E13 = { type: "ParameterExpansion", parameter: "_indirect_elem_", operation: l8.innerOp }, A14 = e7.state.env.get("_indirect_elem_");
      e7.state.env.set("_indirect_elem_", g18);
      try {
        let S17 = await s9(e7, E13, true);
        m25.push(S17);
      } finally {
        A14 !== void 0 ? e7.state.env.set("_indirect_elem_", A14) : e7.state.env.delete("_indirect_elem_");
      }
    }
    return f11 ? { values: [m25.join(N2(e7.state.env))], quoted: true } : { values: m25, quoted: true };
  }
  if (h17.length > 0) {
    let m25 = h17.map(([, g18]) => g18);
    return f11 ? { values: [m25.join(N2(e7.state.env))], quoted: true } : { values: m25, quoted: true };
  }
  let d16 = e7.state.env.get(u11);
  return d16 !== void 0 ? { values: [d16], quoted: true } : { values: [], quoted: true };
}
async function bs(e7, t6, r8, s9, n23) {
  let a7 = n23.offset ? await R(e7, n23.offset.expression) : 0, i10 = n23.length ? await R(e7, n23.length.expression) : void 0, l8 = 0;
  if (a7 < 0) {
    if (t6.length > 0) {
      let u11 = t6[t6.length - 1][0], h17 = (typeof u11 == "number" ? u11 : 0) + 1 + a7;
      if (h17 < 0) return { values: [], quoted: true };
      if (l8 = t6.findIndex(([d16]) => typeof d16 == "number" && d16 >= h17), l8 < 0) return { values: [], quoted: true };
    }
  } else if (l8 = t6.findIndex(([u11]) => typeof u11 == "number" && u11 >= a7), l8 < 0) return { values: [], quoted: true };
  let o9;
  if (i10 !== void 0) {
    if (i10 < 0) throw new p(`${r8}[@]: substring expression < 0`);
    o9 = t6.slice(l8, l8 + i10);
  } else o9 = t6.slice(l8);
  let c15 = o9.map(([, u11]) => u11);
  return s9 ? { values: [c15.join(N2(e7.state.env))], quoted: true } : { values: c15, quoted: true };
}
async function ws(e7, t6, r8, s9, n23, a7) {
  let i10 = n23.checkEmpty ?? false, l8 = t6.map(([, u11]) => u11), o9 = t6.length === 0, c15 = t6.length === 0;
  if (n23.type === "UseAlternative") return !c15 && !(i10 && o9) && n23.word ? { values: [await a7(e7, n23.word.parts, true)], quoted: true } : { values: [], quoted: true };
  if (n23.type === "DefaultValue") return (c15 || i10 && o9) && n23.word ? { values: [await a7(e7, n23.word.parts, true)], quoted: true } : s9 ? { values: [l8.join(N2(e7.state.env))], quoted: true } : { values: l8, quoted: true };
  if (n23.type === "AssignDefault") {
    if ((c15 || i10 && o9) && n23.word) {
      let f11 = await a7(e7, n23.word.parts, true);
      return e7.state.env.set(`${r8}_0`, f11), e7.state.env.set(`${r8}__length`, "1"), { values: [f11], quoted: true };
    }
    return s9 ? { values: [l8.join(N2(e7.state.env))], quoted: true } : { values: l8, quoted: true };
  }
  return s9 ? { values: [l8.join(N2(e7.state.env))], quoted: true } : { values: l8, quoted: true };
}
async function jn(e7, t6) {
  if (t6.length !== 1 || t6[0].type !== "ParameterExpansion" || t6[0].operation?.type !== "UseAlternative" && t6[0].operation?.type !== "DefaultValue") return null;
  let r8 = t6[0], s9 = r8.operation, n23 = s9?.word;
  if (!n23 || n23.parts.length !== 1 || n23.parts[0].type !== "DoubleQuoted") return null;
  let a7 = n23.parts[0];
  if (a7.parts.length !== 1 || a7.parts[0].type !== "ParameterExpansion" || a7.parts[0].operation?.type !== "Indirection") return null;
  let i10 = a7.parts[0], o9 = (await v2(e7, i10.parameter)).match(/^([a-zA-Z_][a-zA-Z0-9_]*)\[([@*])\]$/);
  if (!o9) return null;
  let c15 = await te(e7, r8.parameter), u11 = await v2(e7, r8.parameter) === "", f11 = s9.checkEmpty ?? false, h17;
  if (s9.type === "UseAlternative" ? h17 = c15 && !(f11 && u11) : h17 = !c15 || f11 && u11, h17) {
    let d16 = o9[1], m25 = o9[2] === "*", g18 = P2(e7, d16);
    if (g18.length > 0) {
      let A14 = g18.map(([, S17]) => S17);
      return m25 ? { values: [A14.join(N2(e7.state.env))], quoted: true } : { values: A14, quoted: true };
    }
    let E13 = e7.state.env.get(d16);
    return E13 !== void 0 ? { values: [E13], quoted: true } : { values: [], quoted: true };
  }
  return { values: [], quoted: false };
}
async function Kn(e7, t6) {
  if (t6.length !== 1 || t6[0].type !== "ParameterExpansion" || t6[0].operation?.type !== "Indirection") return null;
  let r8 = t6[0], n23 = r8.operation.innerOp;
  if (!n23 || n23.type !== "UseAlternative" && n23.type !== "DefaultValue") return null;
  let a7 = n23.word;
  if (!a7 || a7.parts.length !== 1 || a7.parts[0].type !== "DoubleQuoted") return null;
  let i10 = a7.parts[0];
  if (i10.parts.length !== 1 || i10.parts[0].type !== "ParameterExpansion" || i10.parts[0].operation?.type !== "Indirection") return null;
  let l8 = i10.parts[0], c15 = (await v2(e7, l8.parameter)).match(/^([a-zA-Z_][a-zA-Z0-9_]*)\[([@*])\]$/);
  if (!c15) return null;
  let u11 = await v2(e7, r8.parameter), f11 = await te(e7, r8.parameter), h17 = u11 === "", d16 = n23.checkEmpty ?? false, m25;
  if (n23.type === "UseAlternative" ? m25 = f11 && !(d16 && h17) : m25 = !f11 || d16 && h17, m25) {
    let g18 = c15[1], E13 = c15[2] === "*", A14 = P2(e7, g18);
    if (A14.length > 0) {
      let y18 = A14.map(([, b25]) => b25);
      return E13 ? { values: [y18.join(N2(e7.state.env))], quoted: true } : { values: y18, quoted: true };
    }
    let S17 = e7.state.env.get(g18);
    return S17 !== void 0 ? { values: [S17], quoted: true } : { values: [], quoted: true };
  }
  return { values: [], quoted: false };
}
function Xn(e7) {
  let t6 = Number.parseInt(e7.state.env.get("#") || "0", 10), r8 = [];
  for (let s9 = 1; s9 <= t6; s9++) r8.push(e7.state.env.get(String(s9)) || "");
  return r8;
}
async function Jn(e7, t6, r8, s9) {
  if (t6.length !== 1 || t6[0].type !== "DoubleQuoted") return null;
  let n23 = t6[0], a7 = -1, i10 = false;
  for (let S17 = 0; S17 < n23.parts.length; S17++) {
    let y18 = n23.parts[S17];
    if (y18.type === "ParameterExpansion" && (y18.parameter === "@" || y18.parameter === "*") && y18.operation?.type === "Substring") {
      a7 = S17, i10 = y18.parameter === "*";
      break;
    }
  }
  if (a7 === -1) return null;
  let o9 = n23.parts[a7].operation, c15 = o9.offset ? await r8(e7, o9.offset.expression) : 0, u11 = o9.length ? await r8(e7, o9.length.expression) : void 0, f11 = Number.parseInt(e7.state.env.get("#") || "0", 10), h17 = [];
  for (let S17 = 1; S17 <= f11; S17++) h17.push(e7.state.env.get(String(S17)) || "");
  let d16 = e7.state.env.get("0") || "bash", m25;
  if (c15 <= 0) {
    let S17 = [d16, ...h17], y18 = S17.length + c15;
    if (y18 < 0) m25 = [];
    else {
      let b25 = c15 < 0 ? y18 : 0;
      if (u11 !== void 0) {
        let D15 = u11 < 0 ? S17.length + u11 : b25 + u11;
        m25 = S17.slice(b25, Math.max(b25, D15));
      } else m25 = S17.slice(b25);
    }
  } else {
    let S17 = c15 - 1;
    if (S17 >= h17.length) m25 = [];
    else if (u11 !== void 0) {
      let y18 = u11 < 0 ? h17.length + u11 : S17 + u11;
      m25 = h17.slice(S17, Math.max(S17, y18));
    } else m25 = h17.slice(S17);
  }
  let g18 = "";
  for (let S17 = 0; S17 < a7; S17++) g18 += await s9(e7, n23.parts[S17]);
  let E13 = "";
  for (let S17 = a7 + 1; S17 < n23.parts.length; S17++) E13 += await s9(e7, n23.parts[S17]);
  if (m25.length === 0) {
    let S17 = g18 + E13;
    return { values: S17 ? [S17] : [], quoted: true };
  }
  if (i10) {
    let S17 = N2(e7.state.env);
    return { values: [g18 + m25.join(S17) + E13], quoted: true };
  }
  return m25.length === 1 ? { values: [g18 + m25[0] + E13], quoted: true } : { values: [g18 + m25[0], ...m25.slice(1, -1), m25[m25.length - 1] + E13], quoted: true };
}
async function Yn(e7, t6, r8, s9) {
  if (t6.length !== 1 || t6[0].type !== "DoubleQuoted") return null;
  let n23 = t6[0], a7 = -1, i10 = false;
  for (let A14 = 0; A14 < n23.parts.length; A14++) {
    let S17 = n23.parts[A14];
    if (S17.type === "ParameterExpansion" && (S17.parameter === "@" || S17.parameter === "*") && S17.operation?.type === "PatternReplacement") {
      a7 = A14, i10 = S17.parameter === "*";
      break;
    }
  }
  if (a7 === -1) return null;
  let o9 = n23.parts[a7].operation, c15 = Xn(e7), u11 = "";
  for (let A14 = 0; A14 < a7; A14++) u11 += await r8(e7, n23.parts[A14]);
  let f11 = "";
  for (let A14 = a7 + 1; A14 < n23.parts.length; A14++) f11 += await r8(e7, n23.parts[A14]);
  if (c15.length === 0) {
    let A14 = u11 + f11;
    return { values: A14 ? [A14] : [], quoted: true };
  }
  let h17 = "";
  if (o9.pattern) for (let A14 of o9.pattern.parts) if (A14.type === "Glob") h17 += k(A14.pattern, true, e7.state.shoptOptions.extglob);
  else if (A14.type === "Literal") h17 += k(A14.value, true, e7.state.shoptOptions.extglob);
  else if (A14.type === "SingleQuoted" || A14.type === "Escaped") h17 += I2(A14.value);
  else if (A14.type === "DoubleQuoted") {
    let S17 = await s9(e7, A14.parts);
    h17 += I2(S17);
  } else if (A14.type === "ParameterExpansion") {
    let S17 = await r8(e7, A14);
    h17 += k(S17, true, e7.state.shoptOptions.extglob);
  } else {
    let S17 = await r8(e7, A14);
    h17 += I2(S17);
  }
  let d16 = o9.replacement ? await s9(e7, o9.replacement.parts) : "", m25 = h17;
  o9.anchor === "start" ? m25 = `^${h17}` : o9.anchor === "end" && (m25 = `${h17}$`);
  let g18 = [];
  try {
    let A14 = b1(m25, o9.all ? "g" : "");
    for (let S17 of c15) g18.push(A14.replace(S17, d16));
  } catch {
    g18.push(...c15);
  }
  if (i10) {
    let A14 = N2(e7.state.env);
    return { values: [u11 + g18.join(A14) + f11], quoted: true };
  }
  return g18.length === 1 ? { values: [u11 + g18[0] + f11], quoted: true } : { values: [u11 + g18[0], ...g18.slice(1, -1), g18[g18.length - 1] + f11], quoted: true };
}
async function er(e7, t6, r8, s9) {
  if (t6.length !== 1 || t6[0].type !== "DoubleQuoted") return null;
  let n23 = t6[0], a7 = -1, i10 = false;
  for (let E13 = 0; E13 < n23.parts.length; E13++) {
    let A14 = n23.parts[E13];
    if (A14.type === "ParameterExpansion" && (A14.parameter === "@" || A14.parameter === "*") && A14.operation?.type === "PatternRemoval") {
      a7 = E13, i10 = A14.parameter === "*";
      break;
    }
  }
  if (a7 === -1) return null;
  let o9 = n23.parts[a7].operation, c15 = Xn(e7), u11 = "";
  for (let E13 = 0; E13 < a7; E13++) u11 += await r8(e7, n23.parts[E13]);
  let f11 = "";
  for (let E13 = a7 + 1; E13 < n23.parts.length; E13++) f11 += await r8(e7, n23.parts[E13]);
  if (c15.length === 0) {
    let E13 = u11 + f11;
    return { values: E13 ? [E13] : [], quoted: true };
  }
  let h17 = "", d16 = e7.state.shoptOptions.extglob;
  if (o9.pattern) for (let E13 of o9.pattern.parts) if (E13.type === "Glob") h17 += k(E13.pattern, o9.greedy, d16);
  else if (E13.type === "Literal") h17 += k(E13.value, o9.greedy, d16);
  else if (E13.type === "SingleQuoted" || E13.type === "Escaped") h17 += I2(E13.value);
  else if (E13.type === "DoubleQuoted") {
    let A14 = await s9(e7, E13.parts);
    h17 += I2(A14);
  } else if (E13.type === "ParameterExpansion") {
    let A14 = await r8(e7, E13);
    h17 += k(A14, o9.greedy, d16);
  } else {
    let A14 = await r8(e7, E13);
    h17 += I2(A14);
  }
  let m25 = [];
  for (let E13 of c15) m25.push(se(E13, h17, o9.side, o9.greedy));
  if (i10) {
    let E13 = N2(e7.state.env);
    return { values: [u11 + m25.join(E13) + f11], quoted: true };
  }
  return m25.length === 1 ? { values: [u11 + m25[0] + f11], quoted: true } : { values: [u11 + m25[0], ...m25.slice(1, -1), m25[m25.length - 1] + f11], quoted: true };
}
async function tr(e7, t6, r8) {
  if (t6.length !== 1 || t6[0].type !== "DoubleQuoted") return null;
  let s9 = t6[0], n23 = -1, a7 = false;
  for (let h17 = 0; h17 < s9.parts.length; h17++) {
    let d16 = s9.parts[h17];
    if (d16.type === "ParameterExpansion" && (d16.parameter === "@" || d16.parameter === "*")) {
      n23 = h17, a7 = d16.parameter === "*";
      break;
    }
  }
  if (n23 === -1) return null;
  let i10 = s9.parts[n23];
  if (i10.type === "ParameterExpansion" && i10.operation) return null;
  let l8 = Number.parseInt(e7.state.env.get("#") || "0", 10), o9 = "";
  for (let h17 = 0; h17 < n23; h17++) o9 += await r8(e7, s9.parts[h17]);
  let c15 = "";
  for (let h17 = n23 + 1; h17 < s9.parts.length; h17++) c15 += await r8(e7, s9.parts[h17]);
  if (l8 === 0) {
    if (a7) return { values: [o9 + c15], quoted: true };
    let h17 = o9 + c15;
    return { values: h17 ? [h17] : [], quoted: true };
  }
  let u11 = [];
  for (let h17 = 1; h17 <= l8; h17++) u11.push(e7.state.env.get(String(h17)) || "");
  if (a7) {
    let h17 = N2(e7.state.env);
    return { values: [o9 + u11.join(h17) + c15], quoted: true };
  }
  return u11.length === 1 ? { values: [o9 + u11[0] + c15], quoted: true } : { values: [o9 + u11[0], ...u11.slice(1, -1), u11[u11.length - 1] + c15], quoted: true };
}
function Ns(e7) {
  return new oe(e7.fs, e7.state.cwd, e7.state.env, { globstar: e7.state.shoptOptions.globstar, nullglob: e7.state.shoptOptions.nullglob, failglob: e7.state.shoptOptions.failglob, dotglob: e7.state.shoptOptions.dotglob, extglob: e7.state.shoptOptions.extglob, globskipdots: e7.state.shoptOptions.globskipdots, maxGlobOperations: e7.limits.maxGlobOperations });
}
async function We(e7, t6) {
  if (e7.state.options.noglob) return t6;
  let r8 = Ns(e7), s9 = [];
  for (let n23 of t6) if (ne(n23, e7.state.shoptOptions.extglob)) {
    let a7 = await r8.expand(n23);
    if (a7.length > 0) s9.push(...a7);
    else {
      if (r8.hasFailglob()) throw new l(n23);
      r8.hasNullglob() || s9.push(n23);
    }
  } else s9.push(n23);
  return s9;
}
async function nr(e7, t6, r8, s9) {
  let n23 = -1, a7 = "", i10 = false;
  for (let S17 = 0; S17 < t6.length; S17++) {
    let y18 = t6[S17];
    if (y18.type === "ParameterExpansion" && y18.operation?.type === "PatternReplacement") {
      let b25 = y18.parameter.match(/^([a-zA-Z_][a-zA-Z0-9_]*)\[([@*])\]$/);
      if (b25) {
        n23 = S17, a7 = b25[1], i10 = b25[2] === "*";
        break;
      }
    }
  }
  if (n23 === -1) return null;
  let o9 = t6[n23].operation, c15 = P2(e7, a7), u11 = c15.map(([, S17]) => S17);
  if (c15.length === 0) {
    let S17 = e7.state.env.get(a7);
    S17 !== void 0 && (u11 = [S17]);
  }
  if (u11.length === 0) return { values: [], quoted: false };
  let f11 = "";
  if (o9.pattern) for (let S17 of o9.pattern.parts) if (S17.type === "Glob") f11 += k(S17.pattern, true, e7.state.shoptOptions.extglob);
  else if (S17.type === "Literal") f11 += k(S17.value, true, e7.state.shoptOptions.extglob);
  else if (S17.type === "SingleQuoted" || S17.type === "Escaped") f11 += I2(S17.value);
  else if (S17.type === "DoubleQuoted") {
    let y18 = await r8(e7, S17.parts);
    f11 += I2(y18);
  } else if (S17.type === "ParameterExpansion") {
    let y18 = await s9(e7, S17);
    f11 += k(y18, true, e7.state.shoptOptions.extglob);
  } else {
    let y18 = await s9(e7, S17);
    f11 += I2(y18);
  }
  let h17 = o9.replacement ? await r8(e7, o9.replacement.parts) : "", d16 = f11;
  o9.anchor === "start" ? d16 = `^${f11}` : o9.anchor === "end" && (d16 = `${f11}$`);
  let m25 = [];
  try {
    let S17 = b1(d16, o9.all ? "g" : "");
    for (let y18 of u11) m25.push(S17.replace(y18, h17));
  } catch {
    m25.push(...u11);
  }
  let g18 = T(e7.state.env), E13 = q2(e7.state.env);
  if (i10) {
    let S17 = N2(e7.state.env), y18 = m25.join(S17);
    return E13 ? { values: y18 ? [y18] : [], quoted: false } : { values: x3(y18, g18), quoted: false };
  }
  if (E13) return { values: m25, quoted: false };
  let A14 = [];
  for (let S17 of m25) S17 === "" ? A14.push("") : A14.push(...x3(S17, g18));
  return { values: A14, quoted: false };
}
async function rr(e7, t6, r8, s9) {
  let n23 = -1, a7 = "", i10 = false;
  for (let A14 = 0; A14 < t6.length; A14++) {
    let S17 = t6[A14];
    if (S17.type === "ParameterExpansion" && S17.operation?.type === "PatternRemoval") {
      let y18 = S17.parameter.match(/^([a-zA-Z_][a-zA-Z0-9_]*)\[([@*])\]$/);
      if (y18) {
        n23 = A14, a7 = y18[1], i10 = y18[2] === "*";
        break;
      }
    }
  }
  if (n23 === -1) return null;
  let o9 = t6[n23].operation, c15 = P2(e7, a7), u11 = c15.map(([, A14]) => A14);
  if (c15.length === 0) {
    let A14 = e7.state.env.get(a7);
    A14 !== void 0 && (u11 = [A14]);
  }
  if (u11.length === 0) return { values: [], quoted: false };
  let f11 = "", h17 = e7.state.shoptOptions.extglob;
  if (o9.pattern) for (let A14 of o9.pattern.parts) if (A14.type === "Glob") f11 += k(A14.pattern, o9.greedy, h17);
  else if (A14.type === "Literal") f11 += k(A14.value, o9.greedy, h17);
  else if (A14.type === "SingleQuoted" || A14.type === "Escaped") f11 += I2(A14.value);
  else if (A14.type === "DoubleQuoted") {
    let S17 = await r8(e7, A14.parts);
    f11 += I2(S17);
  } else if (A14.type === "ParameterExpansion") {
    let S17 = await s9(e7, A14);
    f11 += k(S17, o9.greedy, h17);
  } else {
    let S17 = await s9(e7, A14);
    f11 += I2(S17);
  }
  let d16 = [];
  for (let A14 of u11) d16.push(se(A14, f11, o9.side, o9.greedy));
  let m25 = T(e7.state.env), g18 = q2(e7.state.env);
  if (i10) {
    let A14 = N2(e7.state.env), S17 = d16.join(A14);
    return g18 ? { values: S17 ? [S17] : [], quoted: false } : { values: x3(S17, m25), quoted: false };
  }
  if (g18) return { values: d16, quoted: false };
  let E13 = [];
  for (let A14 of d16) A14 === "" ? E13.push("") : E13.push(...x3(A14, m25));
  return { values: E13, quoted: false };
}
async function sr(e7, t6, r8, s9) {
  let n23 = -1, a7 = false;
  for (let E13 = 0; E13 < t6.length; E13++) {
    let A14 = t6[E13];
    if (A14.type === "ParameterExpansion" && (A14.parameter === "@" || A14.parameter === "*") && A14.operation?.type === "PatternRemoval") {
      n23 = E13, a7 = A14.parameter === "*";
      break;
    }
  }
  if (n23 === -1) return null;
  let l8 = t6[n23].operation, o9 = Number.parseInt(e7.state.env.get("#") || "0", 10), c15 = [];
  for (let E13 = 1; E13 <= o9; E13++) c15.push(e7.state.env.get(String(E13)) || "");
  if (c15.length === 0) return { values: [], quoted: false };
  let u11 = "", f11 = e7.state.shoptOptions.extglob;
  if (l8.pattern) for (let E13 of l8.pattern.parts) if (E13.type === "Glob") u11 += k(E13.pattern, l8.greedy, f11);
  else if (E13.type === "Literal") u11 += k(E13.value, l8.greedy, f11);
  else if (E13.type === "SingleQuoted" || E13.type === "Escaped") u11 += I2(E13.value);
  else if (E13.type === "DoubleQuoted") {
    let A14 = await r8(e7, E13.parts);
    u11 += I2(A14);
  } else if (E13.type === "ParameterExpansion") {
    let A14 = await s9(e7, E13);
    u11 += k(A14, l8.greedy, f11);
  } else {
    let A14 = await s9(e7, E13);
    u11 += I2(A14);
  }
  let h17 = [];
  for (let E13 of c15) h17.push(se(E13, u11, l8.side, l8.greedy));
  let d16 = T(e7.state.env), m25 = q2(e7.state.env);
  if (a7) {
    let E13 = N2(e7.state.env), A14 = h17.join(E13);
    return m25 ? { values: A14 ? [A14] : [], quoted: false } : { values: x3(A14, d16), quoted: false };
  }
  if (m25) return { values: h17, quoted: false };
  let g18 = [];
  for (let E13 of h17) E13 === "" ? g18.push("") : g18.push(...x3(E13, d16));
  return { values: g18, quoted: false };
}
async function ir(e7, t6, r8, s9) {
  let n23 = -1, a7 = false;
  for (let y18 = 0; y18 < t6.length; y18++) {
    let b25 = t6[y18];
    if (b25.type === "ParameterExpansion" && (b25.parameter === "@" || b25.parameter === "*") && b25.operation?.type === "Substring") {
      n23 = y18, a7 = b25.parameter === "*";
      break;
    }
  }
  if (n23 === -1) return null;
  let l8 = t6[n23].operation, o9 = l8.offset ? await r8(e7, l8.offset.expression) : 0, c15 = l8.length ? await r8(e7, l8.length.expression) : void 0, u11 = Number.parseInt(e7.state.env.get("#") || "0", 10), f11 = [];
  for (let y18 = 1; y18 <= u11; y18++) f11.push(e7.state.env.get(String(y18)) || "");
  let h17 = e7.state.env.get("0") || "bash", d16;
  if (o9 <= 0) {
    let y18 = [h17, ...f11], b25 = y18.length + o9;
    if (b25 < 0) d16 = [];
    else {
      let D15 = o9 < 0 ? b25 : 0;
      if (c15 !== void 0) {
        let G9 = c15 < 0 ? y18.length + c15 : D15 + c15;
        d16 = y18.slice(D15, Math.max(D15, G9));
      } else d16 = y18.slice(D15);
    }
  } else {
    let y18 = o9 - 1;
    if (y18 >= f11.length) d16 = [];
    else if (c15 !== void 0) {
      let b25 = c15 < 0 ? f11.length + c15 : y18 + c15;
      d16 = f11.slice(y18, Math.max(y18, b25));
    } else d16 = f11.slice(y18);
  }
  let m25 = "";
  for (let y18 = 0; y18 < n23; y18++) m25 += await s9(e7, t6[y18]);
  let g18 = "";
  for (let y18 = n23 + 1; y18 < t6.length; y18++) g18 += await s9(e7, t6[y18]);
  let E13 = T(e7.state.env), A14 = q2(e7.state.env);
  if (d16.length === 0) {
    let y18 = m25 + g18;
    return y18 ? A14 ? { values: [y18], quoted: false } : { values: x3(y18, E13), quoted: false } : { values: [], quoted: false };
  }
  let S17;
  if (a7) {
    let y18 = N2(e7.state.env), b25 = m25 + d16.join(y18) + g18;
    A14 ? S17 = b25 ? [b25] : [] : S17 = x3(b25, E13);
  } else if (A14) d16.length === 1 ? S17 = [m25 + d16[0] + g18] : S17 = [m25 + d16[0], ...d16.slice(1, -1), d16[d16.length - 1] + g18];
  else {
    S17 = [];
    for (let y18 = 0; y18 < d16.length; y18++) {
      let b25 = d16[y18];
      if (y18 === 0 && (b25 = m25 + b25), y18 === d16.length - 1 && (b25 = b25 + g18), b25 === "") S17.push("");
      else {
        let D15 = x3(b25, E13);
        S17.push(...D15);
      }
    }
  }
  return { values: await We(e7, S17), quoted: false };
}
async function ar(e7, t6) {
  if (t6.length !== 1 || t6[0].type !== "ParameterExpansion" || t6[0].parameter !== "@" && t6[0].parameter !== "*" || t6[0].operation) return null;
  let r8 = t6[0].parameter === "*", s9 = Number.parseInt(e7.state.env.get("#") || "0", 10);
  if (s9 === 0) return { values: [], quoted: false };
  let n23 = [];
  for (let c15 = 1; c15 <= s9; c15++) n23.push(e7.state.env.get(String(c15)) || "");
  let a7 = T(e7.state.env), i10 = q2(e7.state.env), l8 = $e(e7.state.env), o9;
  if (r8) if (i10) o9 = n23.filter((c15) => c15 !== "");
  else {
    let c15 = N2(e7.state.env), u11 = n23.join(c15);
    o9 = x3(u11, a7);
  }
  else if (i10) o9 = n23.filter((c15) => c15 !== "");
  else if (l8) {
    o9 = [];
    for (let c15 of n23) {
      if (c15 === "") continue;
      let u11 = x3(c15, a7);
      o9.push(...u11);
    }
  } else {
    o9 = [];
    for (let c15 of n23) if (c15 === "") o9.push("");
    else {
      let u11 = x3(c15, a7);
      o9.push(...u11);
    }
    for (; o9.length > 0 && o9[o9.length - 1] === ""; ) o9.pop();
  }
  return { values: await We(e7, o9), quoted: false };
}
async function or(e7, t6) {
  if (t6.length !== 1 || t6[0].type !== "ParameterExpansion" || t6[0].operation) return null;
  let r8 = t6[0].parameter.match(/^([a-zA-Z_][a-zA-Z0-9_]*)\[([@*])\]$/);
  if (!r8) return null;
  let s9 = r8[1], n23 = r8[2] === "*", a7 = P2(e7, s9), i10;
  if (a7.length === 0) {
    let f11 = e7.state.env.get(s9);
    if (f11 !== void 0) i10 = [f11];
    else return { values: [], quoted: false };
  } else i10 = a7.map(([, f11]) => f11);
  let l8 = T(e7.state.env), o9 = q2(e7.state.env), c15 = $e(e7.state.env), u11;
  if (n23) if (o9) u11 = i10.filter((f11) => f11 !== "");
  else {
    let f11 = N2(e7.state.env), h17 = i10.join(f11);
    u11 = x3(h17, l8);
  }
  else if (o9) u11 = i10.filter((f11) => f11 !== "");
  else if (c15) {
    u11 = [];
    for (let f11 of i10) {
      if (f11 === "") continue;
      let h17 = x3(f11, l8);
      u11.push(...h17);
    }
  } else {
    u11 = [];
    for (let f11 of i10) if (f11 === "") u11.push("");
    else {
      let h17 = x3(f11, l8);
      u11.push(...h17);
    }
    for (; u11.length > 0 && u11[u11.length - 1] === ""; ) u11.pop();
  }
  return { values: await We(e7, u11), quoted: false };
}
function lr(e7, t6) {
  if (t6.length !== 1 || t6[0].type !== "ParameterExpansion" || t6[0].operation?.type !== "VarNamePrefix") return null;
  let r8 = t6[0].operation, s9 = me(e7, r8.prefix);
  if (s9.length === 0) return { values: [], quoted: false };
  let n23 = T(e7.state.env), a7 = q2(e7.state.env), i10;
  if (r8.star) if (a7) i10 = s9;
  else {
    let l8 = N2(e7.state.env), o9 = s9.join(l8);
    i10 = x3(o9, n23);
  }
  else if (a7) i10 = s9;
  else {
    i10 = [];
    for (let l8 of s9) {
      let o9 = x3(l8, n23);
      i10.push(...o9);
    }
  }
  return { values: i10, quoted: false };
}
function ur(e7, t6) {
  if (t6.length !== 1 || t6[0].type !== "ParameterExpansion" || t6[0].operation?.type !== "ArrayKeys") return null;
  let r8 = t6[0].operation, n23 = P2(e7, r8.array).map(([o9]) => String(o9));
  if (n23.length === 0) return { values: [], quoted: false };
  let a7 = T(e7.state.env), i10 = q2(e7.state.env), l8;
  if (r8.star) if (i10) l8 = n23;
  else {
    let o9 = N2(e7.state.env), c15 = n23.join(o9);
    l8 = x3(c15, a7);
  }
  else if (i10) l8 = n23;
  else {
    l8 = [];
    for (let o9 of n23) {
      let c15 = x3(o9, a7);
      l8.push(...c15);
    }
  }
  return { values: l8, quoted: false };
}
async function cr(e7, t6, r8) {
  let s9 = -1;
  for (let h17 = 0; h17 < t6.length; h17++) {
    let d16 = t6[h17];
    if (d16.type === "ParameterExpansion" && (d16.parameter === "@" || d16.parameter === "*") && !d16.operation) {
      s9 = h17;
      break;
    }
  }
  if (s9 === -1 || t6.length <= 1) return null;
  let n23 = Number.parseInt(e7.state.env.get("#") || "0", 10), a7 = [];
  for (let h17 = 1; h17 <= n23; h17++) a7.push(e7.state.env.get(String(h17)) || "");
  let i10 = "";
  for (let h17 = 0; h17 < s9; h17++) i10 += await r8(e7, t6[h17]);
  let l8 = "";
  for (let h17 = s9 + 1; h17 < t6.length; h17++) l8 += await r8(e7, t6[h17]);
  let o9 = T(e7.state.env), c15 = q2(e7.state.env), u11 = $e(e7.state.env);
  if (n23 === 0) {
    let h17 = i10 + l8;
    return { values: h17 ? [h17] : [], quoted: false };
  }
  let f11;
  {
    let h17 = [];
    for (let d16 = 0; d16 < a7.length; d16++) {
      let m25 = a7[d16];
      d16 === 0 && (m25 = i10 + m25), d16 === a7.length - 1 && (m25 = m25 + l8), h17.push(m25);
    }
    if (c15) f11 = h17.filter((d16) => d16 !== "");
    else if (u11) {
      f11 = [];
      for (let d16 of h17) {
        if (d16 === "") continue;
        let m25 = x3(d16, o9);
        f11.push(...m25);
      }
    } else {
      f11 = [];
      for (let d16 of h17) if (d16 === "") f11.push("");
      else {
        let m25 = x3(d16, o9);
        f11.push(...m25);
      }
      for (; f11.length > 0 && f11[f11.length - 1] === ""; ) f11.pop();
    }
  }
  return f11.length === 0 ? { values: [], quoted: false } : { values: await We(e7, f11), quoted: false };
}
async function pr(e7, t6, r8) {
  e7.coverage?.hit("bash:expansion:word_glob");
  let s9 = t6.parts, { hasQuoted: n23, hasCommandSub: a7, hasArrayVar: i10, hasArrayAtExpansion: l8, hasParamExpansion: o9, hasVarNamePrefixExpansion: c15, hasIndirection: u11 } = Ee(s9), h17 = r8.hasBraceExpansion(s9) ? await r8.expandWordWithBracesAsync(e7, t6) : null;
  if (h17 && h17.length > 1) return ks(e7, h17, n23);
  let d16 = await Ps(e7, s9, l8, c15, u11, r8);
  if (d16 !== null) return d16;
  let m25 = await Is(e7, s9, r8);
  if (m25 !== null) return m25;
  let g18 = await vs(e7, s9, r8);
  if (g18 !== null) return g18;
  let E13 = await xs(e7, s9, r8.expandPart);
  if (E13 !== null) return hr(e7, E13);
  if ((a7 || i10 || o9) && !q2(e7.state.env)) {
    let S17 = T(e7.state.env), y18 = r8.buildIfsCharClassPattern(S17), b25 = await r8.smartWordSplit(e7, s9, S17, y18, r8.expandPart);
    return hr(e7, b25);
  }
  let A14 = await r8.expandWordAsync(e7, t6);
  return _s(e7, t6, s9, A14, n23, r8.expandWordForGlobbing);
}
async function ks(e7, t6, r8) {
  let s9 = [];
  for (let n23 of t6) if (!(!r8 && n23 === "")) if (!r8 && !e7.state.options.noglob && ne(n23, e7.state.shoptOptions.extglob)) {
    let a7 = await Te(e7, n23);
    s9.push(...a7);
  } else s9.push(n23);
  return { values: s9, quoted: false };
}
async function Ps(e7, t6, r8, s9, n23, a7) {
  if (r8) {
    let i10 = Zn(e7, t6);
    if (i10 !== null) return i10;
  }
  {
    let i10 = Un(e7, t6);
    if (i10 !== null) return i10;
  }
  {
    let i10 = await Bn(e7, t6);
    if (i10 !== null) return i10;
  }
  {
    let i10 = await Fn(e7, t6, r8, a7.expandPart, a7.expandWordPartsAsync);
    if (i10 !== null) return i10;
  }
  {
    let i10 = await zn(e7, t6, r8, a7.expandPart);
    if (i10 !== null) return i10;
  }
  {
    let i10 = await Qn(e7, t6, a7.evaluateArithmetic);
    if (i10 !== null) return i10;
  }
  {
    let i10 = Gn(e7, t6);
    if (i10 !== null) return i10;
  }
  {
    let i10 = await Vn(e7, t6, a7.expandWordPartsAsync, a7.expandPart);
    if (i10 !== null) return i10;
  }
  {
    let i10 = await qn(e7, t6, a7.expandWordPartsAsync, a7.expandPart);
    if (i10 !== null) return i10;
  }
  if (s9 && t6.length === 1 && t6[0].type === "DoubleQuoted") {
    let i10 = Rs(e7, t6);
    if (i10 !== null) return i10;
  }
  {
    let i10 = await Hn(e7, t6, n23, a7.expandParameterAsync, a7.expandWordPartsAsync);
    if (i10 !== null) return i10;
  }
  {
    let i10 = await jn(e7, t6);
    if (i10 !== null) return i10;
  }
  {
    let i10 = await Kn(e7, t6);
    if (i10 !== null) return i10;
  }
  return null;
}
function Rs(e7, t6) {
  let r8 = t6[0];
  if (r8.type !== "DoubleQuoted") return null;
  if (r8.parts.length === 1 && r8.parts[0].type === "ParameterExpansion" && r8.parts[0].operation?.type === "VarNamePrefix") {
    let s9 = r8.parts[0].operation, n23 = me(e7, s9.prefix);
    return s9.star ? { values: [n23.join(N2(e7.state.env))], quoted: true } : { values: n23, quoted: true };
  }
  if (r8.parts.length === 1 && r8.parts[0].type === "ParameterExpansion" && r8.parts[0].operation?.type === "ArrayKeys") {
    let s9 = r8.parts[0].operation, a7 = P2(e7, s9.array).map(([i10]) => String(i10));
    return s9.star ? { values: [a7.join(N2(e7.state.env))], quoted: true } : { values: a7, quoted: true };
  }
  return null;
}
async function Is(e7, t6, r8) {
  {
    let s9 = await Jn(e7, t6, r8.evaluateArithmetic, r8.expandPart);
    if (s9 !== null) return s9;
  }
  {
    let s9 = await Yn(e7, t6, r8.expandPart, r8.expandWordPartsAsync);
    if (s9 !== null) return s9;
  }
  {
    let s9 = await er(e7, t6, r8.expandPart, r8.expandWordPartsAsync);
    if (s9 !== null) return s9;
  }
  {
    let s9 = await tr(e7, t6, r8.expandPart);
    if (s9 !== null) return s9;
  }
  return null;
}
async function vs(e7, t6, r8) {
  {
    let s9 = await nr(e7, t6, r8.expandWordPartsAsync, r8.expandPart);
    if (s9 !== null) return s9;
  }
  {
    let s9 = await rr(e7, t6, r8.expandWordPartsAsync, r8.expandPart);
    if (s9 !== null) return s9;
  }
  {
    let s9 = await sr(e7, t6, r8.expandWordPartsAsync, r8.expandPart);
    if (s9 !== null) return s9;
  }
  {
    let s9 = await ir(e7, t6, r8.evaluateArithmetic, r8.expandPart);
    if (s9 !== null) return s9;
  }
  {
    let s9 = await ar(e7, t6);
    if (s9 !== null) return s9;
  }
  {
    let s9 = await or(e7, t6);
    if (s9 !== null) return s9;
  }
  {
    let s9 = lr(e7, t6);
    if (s9 !== null) return s9;
  }
  {
    let s9 = ur(e7, t6);
    if (s9 !== null) return s9;
  }
  {
    let s9 = await cr(e7, t6, r8.expandPart);
    if (s9 !== null) return s9;
  }
  return null;
}
function fr(e7) {
  if (e7.type !== "DoubleQuoted") return null;
  for (let t6 = 0; t6 < e7.parts.length; t6++) {
    let r8 = e7.parts[t6];
    if (r8.type !== "ParameterExpansion" || r8.operation) continue;
    let s9 = r8.parameter.match(/^([a-zA-Z_][a-zA-Z0-9_]*)\[([@*])\]$/);
    if (s9) return { type: "array", name: s9[1], atIndex: t6, isStar: s9[2] === "*" };
    if (r8.parameter === "@" || r8.parameter === "*") return { type: "positional", atIndex: t6, isStar: r8.parameter === "*" };
  }
  return null;
}
async function Ds(e7, t6, r8, s9) {
  let n23 = "";
  for (let l8 = 0; l8 < r8.atIndex; l8++) n23 += await s9(e7, t6.parts[l8]);
  let a7 = "";
  for (let l8 = r8.atIndex + 1; l8 < t6.parts.length; l8++) a7 += await s9(e7, t6.parts[l8]);
  let i10;
  if (r8.type === "array") {
    if (i10 = P2(e7, r8.name).map(([, o9]) => o9), i10.length === 0) {
      let o9 = e7.state.env.get(r8.name);
      o9 !== void 0 && (i10 = [o9]);
    }
  } else {
    let l8 = Number.parseInt(e7.state.env.get("#") || "0", 10);
    i10 = [];
    for (let o9 = 1; o9 <= l8; o9++) i10.push(e7.state.env.get(String(o9)) || "");
  }
  if (r8.isStar) {
    let l8 = N2(e7.state.env), o9 = i10.join(l8);
    return [n23 + o9 + a7];
  }
  if (i10.length === 0) {
    let l8 = n23 + a7;
    return l8 ? [l8] : [];
  }
  return i10.length === 1 ? [n23 + i10[0] + a7] : [n23 + i10[0], ...i10.slice(1, -1), i10[i10.length - 1] + a7];
}
async function xs(e7, t6, r8) {
  if (t6.length < 2) return null;
  let s9 = false;
  for (let o9 of t6) if (fr(o9)) {
    s9 = true;
    break;
  }
  if (!s9) return null;
  let n23 = T(e7.state.env), a7 = q2(e7.state.env), i10 = [];
  for (let o9 of t6) {
    let c15 = fr(o9);
    if (c15 && o9.type === "DoubleQuoted") {
      let u11 = await Ds(e7, o9, c15, r8);
      i10.push(u11);
    } else if (o9.type === "DoubleQuoted" || o9.type === "SingleQuoted") {
      let u11 = await r8(e7, o9);
      i10.push([u11]);
    } else if (o9.type === "Literal") i10.push([o9.value]);
    else if (o9.type === "ParameterExpansion") {
      let u11 = await r8(e7, o9);
      if (a7) i10.push(u11 ? [u11] : []);
      else {
        let f11 = x3(u11, n23);
        i10.push(f11);
      }
    } else {
      let u11 = await r8(e7, o9);
      if (a7) i10.push(u11 ? [u11] : []);
      else {
        let f11 = x3(u11, n23);
        i10.push(f11);
      }
    }
  }
  let l8 = [];
  for (let o9 of i10) if (o9.length !== 0) if (l8.length === 0) l8.push(...o9);
  else {
    let c15 = l8.length - 1;
    l8[c15] = l8[c15] + o9[0];
    for (let u11 = 1; u11 < o9.length; u11++) l8.push(o9[u11]);
  }
  return l8;
}
async function hr(e7, t6) {
  if (e7.state.options.noglob) return { values: t6, quoted: false };
  let r8 = [];
  for (let s9 of t6) if (ne(s9, e7.state.shoptOptions.extglob)) {
    let n23 = await Te(e7, s9);
    r8.push(...n23);
  } else r8.push(s9);
  return { values: r8, quoted: false };
}
async function Te(e7, t6) {
  let r8 = new oe(e7.fs, e7.state.cwd, e7.state.env, { globstar: e7.state.shoptOptions.globstar, nullglob: e7.state.shoptOptions.nullglob, failglob: e7.state.shoptOptions.failglob, dotglob: e7.state.shoptOptions.dotglob, extglob: e7.state.shoptOptions.extglob, globskipdots: e7.state.shoptOptions.globskipdots, maxGlobOperations: e7.limits.maxGlobOperations }), s9 = await r8.expand(t6);
  if (s9.length > 0) return s9;
  if (r8.hasFailglob()) throw new l(t6);
  return r8.hasNullglob() ? [] : [t6];
}
async function _s(e7, t6, r8, s9, n23, a7) {
  let i10 = r8.some((l8) => l8.type === "Glob");
  if (!e7.state.options.noglob && i10) {
    let l8 = await a7(e7, t6);
    if (ne(l8, e7.state.shoptOptions.extglob)) {
      let c15 = await Te(e7, l8);
      if (c15.length > 0 && c15[0] !== l8) return { values: c15, quoted: false };
      if (c15.length === 0) return { values: [], quoted: false };
    }
    let o9 = At(s9);
    if (!q2(e7.state.env)) {
      let c15 = T(e7.state.env);
      return { values: x3(o9, c15), quoted: false };
    }
    return { values: [o9], quoted: false };
  }
  if (!n23 && !e7.state.options.noglob && ne(s9, e7.state.shoptOptions.extglob)) {
    let l8 = await a7(e7, t6);
    if (ne(l8, e7.state.shoptOptions.extglob)) {
      let o9 = await Te(e7, l8);
      if (o9.length > 0 && o9[0] !== l8) return { values: o9, quoted: false };
    }
  }
  if (s9 === "" && !n23) return { values: [], quoted: false };
  if (i10 && !n23) {
    let l8 = At(s9);
    if (!q2(e7.state.env)) {
      let o9 = T(e7.state.env);
      return { values: x3(l8, o9), quoted: false };
    }
    return { values: [l8], quoted: false };
  }
  return { values: [s9], quoted: n23 };
}
async function mr(e7, t6) {
  let r8 = t6.operation;
  if (!r8 || r8.type !== "DefaultValue" && r8.type !== "AssignDefault" && r8.type !== "UseAlternative") return null;
  let s9 = r8.word;
  if (!s9 || s9.parts.length === 0) return null;
  let n23 = await te(e7, t6.parameter), i10 = await v2(e7, t6.parameter, false) === "", l8 = r8.checkEmpty ?? false, o9;
  return r8.type === "UseAlternative" ? o9 = n23 && !(l8 && i10) : o9 = !n23 || l8 && i10, o9 ? s9.parts : null;
}
function $s(e7) {
  return e7.type === "SingleQuoted" ? true : e7.type === "DoubleQuoted" ? e7.parts.every((r8) => r8.type === "Literal") : false;
}
async function Cs(e7, t6) {
  if (t6.type !== "ParameterExpansion") return null;
  let r8 = await mr(e7, t6);
  if (!r8 || r8.length <= 1) return null;
  let s9 = r8.some((a7) => $s(a7)), n23 = r8.some((a7) => a7.type === "Literal" || a7.type === "ParameterExpansion" || a7.type === "CommandSubstitution" || a7.type === "ArithmeticExpansion");
  return s9 && n23 ? r8 : null;
}
function Os(e7) {
  return e7.type === "DoubleQuoted" || e7.type === "SingleQuoted" || e7.type === "Literal" ? false : e7.type === "Glob" ? pt(e7.pattern) : !(!(e7.type === "ParameterExpansion" || e7.type === "CommandSubstitution" || e7.type === "ArithmeticExpansion") || e7.type === "ParameterExpansion" && dn(e7));
}
async function gr(e7, t6, r8, s9, n23) {
  if (e7.coverage?.hit("bash:expansion:word_split"), t6.length === 1 && t6[0].type === "ParameterExpansion") {
    let h17 = t6[0], d16 = await mr(e7, h17);
    if (d16 && d16.length > 0 && d16.length > 1 && d16.some((g18) => g18.type === "DoubleQuoted" || g18.type === "SingleQuoted") && d16.some((g18) => g18.type === "Literal" || g18.type === "ParameterExpansion" || g18.type === "CommandSubstitution" || g18.type === "ArithmeticExpansion")) return dr(e7, d16, r8, s9, n23);
  }
  let a7 = [], i10 = false;
  for (let h17 of t6) {
    let d16 = Os(h17), m25 = h17.type === "DoubleQuoted" || h17.type === "SingleQuoted", g18 = d16 ? await Cs(e7, h17) : null, E13 = await n23(e7, h17);
    a7.push({ value: E13, isSplittable: d16, isQuoted: m25, mixedDefaultParts: g18 ?? void 0 }), d16 && (i10 = true);
  }
  if (!i10) {
    let h17 = a7.map((d16) => d16.value).join("");
    return h17 ? [h17] : [];
  }
  let l8 = [], o9 = "", c15 = false, u11 = false, f11 = false;
  for (let h17 of a7) if (!h17.isSplittable) u11 ? h17.isQuoted && h17.value === "" ? (o9 !== "" && l8.push(o9), l8.push(""), c15 = true, o9 = "", u11 = false, f11 = true) : h17.value !== "" ? (o9 !== "" && l8.push(o9), o9 = h17.value, u11 = false, f11 = false) : (o9 += h17.value, f11 = false) : (o9 += h17.value, f11 = h17.isQuoted && h17.value === "");
  else if (h17.mixedDefaultParts) {
    let d16 = await dr(e7, h17.mixedDefaultParts, r8, s9, n23);
    if (d16.length !== 0) if (d16.length === 1) o9 += d16[0], c15 = true;
    else {
      o9 += d16[0], l8.push(o9), c15 = true;
      for (let m25 = 1; m25 < d16.length - 1; m25++) l8.push(d16[m25]);
      o9 = d16[d16.length - 1];
    }
    u11 = false, f11 = false;
  } else {
    let { words: d16, hadLeadingDelimiter: m25, hadTrailingDelimiter: g18 } = Ce(h17.value, r8);
    if (f11 && m25 && o9 === "" && (l8.push(""), c15 = true), d16.length === 0) g18 && (u11 = true);
    else if (d16.length === 1) o9 += d16[0], c15 = true, u11 = g18;
    else {
      o9 += d16[0], l8.push(o9), c15 = true;
      for (let E13 = 1; E13 < d16.length - 1; E13++) l8.push(d16[E13]);
      o9 = d16[d16.length - 1], u11 = g18;
    }
    f11 = false;
  }
  return o9 !== "" ? l8.push(o9) : l8.length === 0 && c15 && l8.push(""), l8;
}
function Ls(e7, t6) {
  return e7.length > 0 && t6.includes(e7[0]);
}
async function dr(e7, t6, r8, s9, n23) {
  let a7 = [];
  for (let u11 of t6) {
    let h17 = !(u11.type === "DoubleQuoted" || u11.type === "SingleQuoted"), d16 = await n23(e7, u11);
    a7.push({ value: d16, isSplittable: h17 });
  }
  let i10 = [], l8 = "", o9 = false, c15 = false;
  for (let u11 of a7) if (!u11.isSplittable) c15 && u11.value !== "" ? (l8 !== "" && i10.push(l8), l8 = u11.value, c15 = false) : l8 += u11.value;
  else {
    Ls(u11.value, r8) && l8 !== "" && (i10.push(l8), l8 = "", o9 = true);
    let { words: h17, hadTrailingDelimiter: d16 } = Ce(u11.value, r8);
    if (h17.length === 0) d16 && (c15 = true);
    else if (h17.length === 1) l8 += h17[0], o9 = true, c15 = d16;
    else {
      l8 += h17[0], i10.push(l8), o9 = true;
      for (let m25 = 1; m25 < h17.length - 1; m25++) i10.push(h17[m25]);
      l8 = h17[h17.length - 1], c15 = d16;
    }
  }
  return l8 !== "" ? i10.push(l8) : i10.length === 0 && o9 && i10.push(""), i10;
}
function yr(e7) {
  switch (e7.type) {
    case "Literal":
      return e7.value;
    case "SingleQuoted":
      return e7.value;
    case "Escaped":
      return e7.value;
    default:
      return null;
  }
}
function Er(e7) {
  switch (e7.type) {
    case "SingleQuoted":
    case "Escaped":
    case "DoubleQuoted":
      return true;
    case "Literal":
      return e7.value === "";
    default:
      return false;
  }
}
function ce(e7, t6, r8) {
  if (e7.length > t6) throw new b2(`${r8}: string length limit exceeded (${t6} bytes)`, "string_length");
}
async function J2(e7, t6, r8 = false) {
  let s9 = [];
  for (let n23 of t6) s9.push(await U2(e7, n23, r8));
  return s9.join("");
}
function Ws(e7) {
  return Er(e7);
}
function yl(e7) {
  if (e7.parts.length === 0) return true;
  for (let t6 of e7.parts) if (!Ws(t6)) return false;
  return true;
}
function Ts(e7, t6, r8 = false) {
  let s9 = yr(t6);
  if (s9 !== null) return s9;
  switch (t6.type) {
    case "TildeExpansion":
      return r8 ? t6.user === null ? "~" : `~${t6.user}` : (e7.coverage?.hit("bash:expansion:tilde"), t6.user === null ? e7.state.env.get("HOME") ?? "/home/user" : t6.user === "root" ? "/root" : `~${t6.user}`);
    case "Glob":
      return wt(e7, t6.pattern);
    default:
      return null;
  }
}
async function kt(e7, t6) {
  return Pt(e7, t6);
}
async function El(e7, t6) {
  let r8 = [];
  for (let s9 of t6.parts) if (s9.type === "Escaped") r8.push(`\\${s9.value}`);
  else if (s9.type === "SingleQuoted") r8.push(s9.value);
  else if (s9.type === "DoubleQuoted") {
    let n23 = await J2(e7, s9.parts);
    r8.push(n23);
  } else if (s9.type === "TildeExpansion") {
    let n23 = await U2(e7, s9);
    r8.push(St(n23));
  } else r8.push(await U2(e7, s9));
  return r8.join("");
}
async function Al(e7, t6) {
  let r8 = [];
  for (let s9 of t6.parts) if (s9.type === "Escaped") {
    let n23 = s9.value;
    "()|*?[]".includes(n23) ? r8.push(`\\${n23}`) : r8.push(n23);
  } else if (s9.type === "SingleQuoted") r8.push(X2(s9.value));
  else if (s9.type === "DoubleQuoted") {
    let n23 = await J2(e7, s9.parts);
    r8.push(X2(n23));
  } else r8.push(await U2(e7, s9));
  return r8.join("");
}
async function Ar(e7, t6) {
  let r8 = [];
  for (let s9 of t6.parts) if (s9.type === "SingleQuoted") r8.push(X2(s9.value));
  else if (s9.type === "Escaped") {
    let n23 = s9.value;
    "*?[]\\()|".includes(n23) ? r8.push(`\\${n23}`) : r8.push(n23);
  } else if (s9.type === "DoubleQuoted") {
    let n23 = await J2(e7, s9.parts);
    r8.push(X2(n23));
  } else s9.type === "Glob" ? Ln(s9.pattern) ? r8.push(await Tn(e7, s9.pattern)) : r8.push(wt(e7, s9.pattern)) : s9.type === "Literal" ? r8.push(s9.value) : r8.push(await U2(e7, s9));
  return r8.join("");
}
function Ve(e7) {
  for (let t6 of e7) if (t6.type === "BraceExpansion" || t6.type === "DoubleQuoted" && Ve(t6.parts)) return true;
  return false;
}
async function Sr(e7, t6, r8 = { count: 0 }) {
  if (r8.count > Nt) return [[]];
  let s9 = [[]];
  for (let n23 of t6) if (n23.type === "BraceExpansion") {
    let a7 = [], i10 = false, l8 = "";
    for (let u11 of n23.items) if (u11.type === "Range") {
      let f11 = Et(u11.start, u11.end, u11.step, u11.startStr, u11.endStr);
      if (f11.expanded) for (let h17 of f11.expanded) r8.count++, a7.push(h17);
      else {
        i10 = true, l8 = f11.literal;
        break;
      }
    } else {
      let f11 = await Sr(e7, u11.word.parts, r8);
      for (let h17 of f11) {
        r8.count++;
        let d16 = [];
        for (let m25 of h17) typeof m25 == "string" ? d16.push(m25) : d16.push(await U2(e7, m25));
        a7.push(d16.join(""));
      }
    }
    if (i10) {
      for (let u11 of s9) r8.count++, u11.push(l8);
      continue;
    }
    if (s9.length * a7.length > e7.limits.maxBraceExpansionResults || r8.count > Nt) return s9;
    let c15 = [];
    for (let u11 of s9) for (let f11 of a7) {
      if (r8.count++, r8.count > Nt) return c15.length > 0 ? c15 : s9;
      c15.push([...u11, f11]);
    }
    s9 = c15;
  } else for (let a7 of s9) r8.count++, a7.push(n23);
  return s9;
}
async function br(e7, t6) {
  let r8 = t6.parts;
  if (!Ve(r8)) return [await kt(e7, t6)];
  let s9 = await Sr(e7, r8), n23 = [];
  for (let a7 of s9) {
    let i10 = [];
    for (let l8 of a7) typeof l8 == "string" ? i10.push(l8) : i10.push(await U2(e7, l8));
    n23.push(Mn(e7, i10.join("")));
  }
  return n23;
}
function Ms() {
  return { expandWordAsync: Pt, expandWordForGlobbing: Ar, expandWordWithBracesAsync: br, expandWordPartsAsync: J2, expandPart: U2, expandParameterAsync: Me, hasBraceExpansion: Ve, evaluateArithmetic: R, buildIfsCharClassPattern: yn, smartWordSplit: gr };
}
async function Sl(e7, t6) {
  return pr(e7, t6, Ms());
}
function Vs(e7) {
  for (let t6 of e7) {
    if (t6.type === "ParameterExpansion") return t6.parameter;
    if (t6.type === "Literal") return t6.value;
  }
  return "";
}
function qs(e7, t6) {
  if (Number.parseInt(e7.state.env.get("#") || "0", 10) < 2) return false;
  function s9(n23) {
    for (let a7 of n23) if (a7.type === "DoubleQuoted") {
      for (let i10 of a7.parts) if (i10.type === "ParameterExpansion" && i10.parameter === "@" && !i10.operation) return true;
    }
    return false;
  }
  return s9(t6.parts);
}
async function bl(e7, t6) {
  if (qs(e7, t6)) return { error: `bash: $@: ambiguous redirect
` };
  let r8 = t6.parts, { hasQuoted: s9 } = Ee(r8);
  if (Ve(r8) && (await br(e7, t6)).length > 1) return { error: `bash: ${r8.map((d16) => d16.type === "Literal" ? d16.value : d16.type === "BraceExpansion" ? `{${d16.items.map((g18) => {
    if (g18.type === "Range") {
      let E13 = g18.step ? `..${g18.step}` : "";
      return `${g18.startStr ?? g18.start}..${g18.endStr ?? g18.end}${E13}`;
    }
    return g18.word.parts.map((E13) => E13.type === "Literal" ? E13.value : "").join("");
  }).join(",")}}` : "").join("")}: ambiguous redirect
` };
  let n23 = await Pt(e7, t6), { hasParamExpansion: a7, hasCommandSub: i10 } = Ee(r8);
  if ((a7 || i10) && !s9 && !q2(e7.state.env)) {
    let f11 = T(e7.state.env);
    if (x3(n23, f11).length > 1) return { error: `bash: $${Vs(r8)}: ambiguous redirect
` };
  }
  if (s9 || e7.state.options.noglob) return { target: n23 };
  let o9 = await Ar(e7, t6);
  if (!ne(o9, e7.state.shoptOptions.extglob)) return { target: n23 };
  let c15 = new oe(e7.fs, e7.state.cwd, e7.state.env, { globstar: e7.state.shoptOptions.globstar, nullglob: e7.state.shoptOptions.nullglob, failglob: e7.state.shoptOptions.failglob, dotglob: e7.state.shoptOptions.dotglob, extglob: e7.state.shoptOptions.extglob, globskipdots: e7.state.shoptOptions.globskipdots, maxGlobOperations: e7.limits.maxGlobOperations }), u11 = await c15.expand(o9);
  return u11.length === 0 ? c15.hasFailglob() ? { error: `bash: no match: ${n23}
` } : { target: n23 } : u11.length === 1 ? { target: u11[0] } : { error: `bash: ${n23}: ambiguous redirect
` };
}
async function Pt(e7, t6) {
  let r8 = t6.parts, s9 = r8.length;
  if (s9 === 1) {
    let i10 = await U2(e7, r8[0]);
    return ce(i10, e7.limits.maxStringLength, "word expansion"), i10;
  }
  let n23 = [];
  for (let i10 = 0; i10 < s9; i10++) n23.push(await U2(e7, r8[i10]));
  let a7 = n23.join("");
  return ce(a7, e7.limits.maxStringLength, "word expansion"), a7;
}
async function U2(e7, t6, r8 = false) {
  if (t6.type === "ParameterExpansion") return Me(e7, t6, r8);
  let s9 = Ts(e7, t6, r8);
  if (s9 !== null) return s9;
  switch (t6.type) {
    case "DoubleQuoted": {
      let n23 = [];
      for (let a7 of t6.parts) n23.push(await U2(e7, a7, true));
      return n23.join("");
    }
    case "CommandSubstitution": {
      let n23 = Sn(t6.body);
      if (n23) try {
        let h17 = await kt(e7, n23.target), d16 = h17.startsWith("/") ? h17 : `${e7.state.cwd}/${h17}`, m25 = await e7.fs.readFile(d16);
        e7.state.lastExitCode = 0, e7.state.env.set("?", "0");
        let g18 = m25.replace(/\n+$/, "");
        return ce(g18, e7.limits.maxStringLength, "command substitution"), g18;
      } catch (h17) {
        if (h17 instanceof b2) throw h17;
        return e7.state.lastExitCode = 1, e7.state.env.set("?", "1"), "";
      }
      let a7 = e7.substitutionDepth ?? 0, i10 = e7.limits.maxSubstitutionDepth;
      if (a7 >= i10) throw new b2(`Command substitution nesting limit exceeded (${i10})`, "substitution_depth");
      let l8 = e7.substitutionDepth;
      e7.substitutionDepth = a7 + 1;
      let o9 = e7.state.bashPid;
      e7.state.bashPid = e7.state.nextVirtualPid++;
      let c15 = new Map(e7.state.env), u11 = e7.state.cwd, f11 = e7.state.suppressVerbose;
      e7.state.suppressVerbose = true;
      try {
        let h17 = await e7.executeScript(t6.body), d16 = h17.exitCode;
        e7.state.env = c15, e7.state.cwd = u11, e7.state.suppressVerbose = f11, e7.state.lastExitCode = d16, e7.state.env.set("?", String(d16)), h17.stderr && (e7.state.expansionStderr = (e7.state.expansionStderr || "") + h17.stderr), e7.state.bashPid = o9, e7.substitutionDepth = l8;
        let m25 = h17.stdout.replace(/\n+$/, "");
        return ce(m25, e7.limits.maxStringLength, "command substitution"), m25;
      } catch (h17) {
        if (e7.state.env = c15, e7.state.cwd = u11, e7.state.bashPid = o9, e7.substitutionDepth = l8, e7.state.suppressVerbose = f11, h17 instanceof b2) throw h17;
        if (h17 instanceof d2) {
          e7.state.lastExitCode = h17.exitCode, e7.state.env.set("?", String(h17.exitCode)), h17.stderr && (e7.state.expansionStderr = (e7.state.expansionStderr || "") + h17.stderr);
          let d16 = h17.stdout.replace(/\n+$/, "");
          return ce(d16, e7.limits.maxStringLength, "command substitution"), d16;
        }
        throw h17;
      }
    }
    case "ArithmeticExpansion": {
      let n23 = t6.expression.originalText;
      if (n23 && /\$[a-zA-Z_][a-zA-Z0-9_]*(?![{[(])/.test(n23)) {
        let i10 = await An(e7, n23), l8 = new V2(), o9 = M2(l8, i10);
        return String(await R(e7, o9.expression, true));
      }
      return String(await R(e7, t6.expression.expression, true));
    }
    case "BraceExpansion": {
      let n23 = [];
      for (let a7 of t6.items) if (a7.type === "Range") {
        let i10 = Et(a7.start, a7.end, a7.step, a7.startStr, a7.endStr);
        if (i10.expanded) n23.push(...i10.expanded);
        else return i10.literal;
      } else n23.push(await kt(e7, a7.word));
      return n23.join(" ");
    }
    default:
      return "";
  }
}
async function Me(e7, t6, r8 = false) {
  let { parameter: s9 } = t6, { operation: n23 } = t6, a7 = s9.match(/^([a-zA-Z_][a-zA-Z0-9_]*)\[(.+)\]$/);
  if (a7) {
    let [, h17, d16] = a7;
    if (e7.state.associativeArrays?.has(h17) || d16.includes("$(") || d16.includes("`") || d16.includes("${")) {
      let g18 = await yt(e7, d16);
      s9 = `${h17}[${g18}]`;
    }
  } else if (/^[a-zA-Z_][a-zA-Z0-9_]*$/.test(s9) && L2(e7, s9)) {
    let h17 = he(e7, s9);
    if (h17 && h17 !== s9) {
      let d16 = h17.match(/^([a-zA-Z_][a-zA-Z0-9_]*)\[(.+)\]$/);
      if (d16) {
        let [, m25, g18] = d16;
        if (e7.state.associativeArrays?.has(m25) || g18.includes("$(") || g18.includes("`") || g18.includes("${")) {
          let A14 = await yt(e7, g18);
          s9 = `${m25}[${A14}]`;
        }
      }
    }
  }
  let i10 = n23 && (n23.type === "DefaultValue" || n23.type === "AssignDefault" || n23.type === "UseAlternative" || n23.type === "ErrorIfUnset"), l8 = await v2(e7, s9, !i10);
  if (!n23) return l8;
  let o9 = !await te(e7, s9), { isEmpty: c15, effectiveValue: u11 } = On(e7, s9, l8, r8), f11 = { value: l8, isUnset: o9, isEmpty: c15, effectiveValue: u11, inDoubleQuotes: r8 };
  switch (n23.type) {
    case "DefaultValue":
      return bn(e7, n23, f11, J2);
    case "AssignDefault":
      return wn(e7, s9, n23, f11, J2);
    case "ErrorIfUnset":
      return Nn(e7, s9, n23, f11, J2);
    case "UseAlternative":
      return kn(e7, n23, f11, J2);
    case "PatternRemoval": {
      let h17 = await Pn(e7, l8, n23, J2, U2);
      return ce(h17, e7.limits.maxStringLength, "pattern removal"), h17;
    }
    case "PatternReplacement": {
      let h17 = await Rn(e7, l8, n23, J2, U2);
      return ce(h17, e7.limits.maxStringLength, "pattern replacement"), h17;
    }
    case "Length":
      return In(e7, s9, l8);
    case "LengthSliceError":
      throw new h(s9);
    case "BadSubstitution":
      throw new h(n23.text);
    case "Substring":
      return vn(e7, s9, l8, n23);
    case "CaseModification": {
      let h17 = await Dn(e7, l8, n23, J2, Me);
      return ce(h17, e7.limits.maxStringLength, "case modification"), h17;
    }
    case "Transform":
      return xn(e7, s9, l8, o9, n23);
    case "Indirection":
      return _n(e7, s9, l8, o9, n23, Me, r8);
    case "ArrayKeys":
      return $n(e7, n23);
    case "VarNamePrefix":
      return Cn(e7, n23);
    default:
      return l8;
  }
}
var Pe, w2, p2, pe, qt, Ir, vr, Dr, Ie, Qe, Ge, Qt, Ze, Gt, Zt, Ut, Q2, Lr, qr, Br, V2, Xr, oe, mn, vi, ss, Oe, ms, Nt;
var init_chunk_V4CDPGZH = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-V4CDPGZH.js"() {
    init_chunk_YNYSPYQ5();
    init_chunk_PSW6BMXW();
    Pe = ["=", "+=", "-=", "*=", "/=", "%=", "<<=", ">>=", "&=", "|=", "^="];
    w2 = { script(e7) {
      return { type: "Script", statements: e7 };
    }, statement(e7, t6 = [], r8 = false, s9, n23) {
      let a7 = { type: "Statement", pipelines: e7, operators: t6, background: r8 };
      return s9 && (a7.deferredError = s9), n23 !== void 0 && (a7.sourceText = n23), a7;
    }, pipeline(e7, t6 = false, r8 = false, s9 = false, n23) {
      return { type: "Pipeline", commands: e7, negated: t6, timed: r8, timePosix: s9, pipeStderr: n23 };
    }, simpleCommand(e7, t6 = [], r8 = [], s9 = []) {
      return { type: "SimpleCommand", name: e7, args: t6, assignments: r8, redirections: s9 };
    }, word(e7) {
      return { type: "Word", parts: e7 };
    }, literal(e7) {
      return { type: "Literal", value: e7 };
    }, singleQuoted(e7) {
      return { type: "SingleQuoted", value: e7 };
    }, doubleQuoted(e7) {
      return { type: "DoubleQuoted", parts: e7 };
    }, escaped(e7) {
      return { type: "Escaped", value: e7 };
    }, parameterExpansion(e7, t6 = null) {
      return { type: "ParameterExpansion", parameter: e7, operation: t6 };
    }, commandSubstitution(e7, t6 = false) {
      return { type: "CommandSubstitution", body: e7, legacy: t6 };
    }, arithmeticExpansion(e7) {
      return { type: "ArithmeticExpansion", expression: e7 };
    }, assignment(e7, t6, r8 = false, s9 = null) {
      return { type: "Assignment", name: e7, value: t6, append: r8, array: s9 };
    }, redirection(e7, t6, r8 = null, s9) {
      let n23 = { type: "Redirection", fd: r8, operator: e7, target: t6 };
      return s9 && (n23.fdVariable = s9), n23;
    }, hereDoc(e7, t6, r8 = false, s9 = false) {
      return { type: "HereDoc", delimiter: e7, content: t6, stripTabs: r8, quoted: s9 };
    }, ifNode(e7, t6 = null, r8 = []) {
      return { type: "If", clauses: e7, elseBody: t6, redirections: r8 };
    }, forNode(e7, t6, r8, s9 = []) {
      return { type: "For", variable: e7, words: t6, body: r8, redirections: s9 };
    }, whileNode(e7, t6, r8 = []) {
      return { type: "While", condition: e7, body: t6, redirections: r8 };
    }, untilNode(e7, t6, r8 = []) {
      return { type: "Until", condition: e7, body: t6, redirections: r8 };
    }, caseNode(e7, t6, r8 = []) {
      return { type: "Case", word: e7, items: t6, redirections: r8 };
    }, caseItem(e7, t6, r8 = ";;") {
      return { type: "CaseItem", patterns: e7, body: t6, terminator: r8 };
    }, subshell(e7, t6 = []) {
      return { type: "Subshell", body: e7, redirections: t6 };
    }, group(e7, t6 = []) {
      return { type: "Group", body: e7, redirections: t6 };
    }, functionDef(e7, t6, r8 = [], s9) {
      return { type: "FunctionDef", name: e7, body: t6, redirections: r8, sourceFile: s9 };
    }, conditionalCommand(e7, t6 = [], r8) {
      return { type: "ConditionalCommand", expression: e7, redirections: t6, line: r8 };
    }, arithmeticCommand(e7, t6 = [], r8) {
      return { type: "ArithmeticCommand", expression: e7, redirections: t6, line: r8 };
    } };
    (function(e7) {
      e7.EOF = "EOF", e7.NEWLINE = "NEWLINE", e7.SEMICOLON = "SEMICOLON", e7.AMP = "AMP", e7.PIPE = "PIPE", e7.PIPE_AMP = "PIPE_AMP", e7.AND_AND = "AND_AND", e7.OR_OR = "OR_OR", e7.BANG = "BANG", e7.LESS = "LESS", e7.GREAT = "GREAT", e7.DLESS = "DLESS", e7.DGREAT = "DGREAT", e7.LESSAND = "LESSAND", e7.GREATAND = "GREATAND", e7.LESSGREAT = "LESSGREAT", e7.DLESSDASH = "DLESSDASH", e7.CLOBBER = "CLOBBER", e7.TLESS = "TLESS", e7.AND_GREAT = "AND_GREAT", e7.AND_DGREAT = "AND_DGREAT", e7.LPAREN = "LPAREN", e7.RPAREN = "RPAREN", e7.LBRACE = "LBRACE", e7.RBRACE = "RBRACE", e7.DSEMI = "DSEMI", e7.SEMI_AND = "SEMI_AND", e7.SEMI_SEMI_AND = "SEMI_SEMI_AND", e7.DBRACK_START = "DBRACK_START", e7.DBRACK_END = "DBRACK_END", e7.DPAREN_START = "DPAREN_START", e7.DPAREN_END = "DPAREN_END", e7.IF = "IF", e7.THEN = "THEN", e7.ELSE = "ELSE", e7.ELIF = "ELIF", e7.FI = "FI", e7.FOR = "FOR", e7.WHILE = "WHILE", e7.UNTIL = "UNTIL", e7.DO = "DO", e7.DONE = "DONE", e7.CASE = "CASE", e7.ESAC = "ESAC", e7.IN = "IN", e7.FUNCTION = "FUNCTION", e7.SELECT = "SELECT", e7.TIME = "TIME", e7.COPROC = "COPROC", e7.WORD = "WORD", e7.NAME = "NAME", e7.NUMBER = "NUMBER", e7.ASSIGNMENT_WORD = "ASSIGNMENT_WORD", e7.FD_VARIABLE = "FD_VARIABLE", e7.COMMENT = "COMMENT", e7.HEREDOC_CONTENT = "HEREDOC_CONTENT";
    })(p2 || (p2 = {}));
    pe = class extends Error {
      line;
      column;
      constructor(t6, r8, s9) {
        super(`line ${r8}: ${t6}`), this.line = r8, this.column = s9, this.name = "LexerError";
      }
    };
    qt = /* @__PURE__ */ new Map([["if", p2.IF], ["then", p2.THEN], ["else", p2.ELSE], ["elif", p2.ELIF], ["fi", p2.FI], ["for", p2.FOR], ["while", p2.WHILE], ["until", p2.UNTIL], ["do", p2.DO], ["done", p2.DONE], ["case", p2.CASE], ["esac", p2.ESAC], ["in", p2.IN], ["function", p2.FUNCTION], ["select", p2.SELECT], ["time", p2.TIME], ["coproc", p2.COPROC]]);
    Ir = [[";", ";", "&", p2.SEMI_SEMI_AND], ["<", "<", "<", p2.TLESS], ["&", ">", ">", p2.AND_DGREAT]];
    vr = [["[", "[", p2.DBRACK_START], ["]", "]", p2.DBRACK_END], ["(", "(", p2.DPAREN_START], [")", ")", p2.DPAREN_END], ["&", "&", p2.AND_AND], ["|", "|", p2.OR_OR], [";", ";", p2.DSEMI], [";", "&", p2.SEMI_AND], ["|", "&", p2.PIPE_AMP], [">", ">", p2.DGREAT], ["<", "&", p2.LESSAND], [">", "&", p2.GREATAND], ["<", ">", p2.LESSGREAT], [">", "|", p2.CLOBBER], ["&", ">", p2.AND_GREAT]];
    Dr = /* @__PURE__ */ new Map([["|", p2.PIPE], ["&", p2.AMP], [";", p2.SEMICOLON], ["(", p2.LPAREN], [")", p2.RPAREN], ["<", p2.LESS], [">", p2.GREAT]]);
    Ie = class {
      input;
      pos = 0;
      line = 1;
      column = 1;
      tokens = [];
      pendingHeredocs = [];
      dparenDepth = 0;
      maxHeredocSize;
      constructor(t6, r8) {
        this.input = t6, this.maxHeredocSize = r8?.maxHeredocSize ?? 10485760;
      }
      tokenize() {
        let r8 = this.input.length, s9 = this.tokens, n23 = this.pendingHeredocs;
        for (; this.pos < r8; ) {
          if (n23.length > 0 && s9.length > 0 && s9[s9.length - 1].type === p2.NEWLINE) {
            this.readHeredocContent();
            continue;
          }
          if (this.skipWhitespace(), this.pos >= r8) break;
          let a7 = this.nextToken();
          a7 && s9.push(a7);
        }
        return s9.push({ type: p2.EOF, value: "", start: this.pos, end: this.pos, line: this.line, column: this.column }), s9;
      }
      skipWhitespace() {
        let t6 = this.input, r8 = t6.length, s9 = this.pos, n23 = this.column, a7 = this.line;
        for (; s9 < r8; ) {
          let i10 = t6[s9];
          if (i10 === " " || i10 === "	") s9++, n23++;
          else if (i10 === "\\" && t6[s9 + 1] === `
`) s9 += 2, a7++, n23 = 1;
          else break;
        }
        this.pos = s9, this.column = n23, this.line = a7;
      }
      nextToken() {
        let t6 = this.input, r8 = this.pos, s9 = this.line, n23 = this.column, a7 = t6[r8], i10 = t6[r8 + 1], l8 = t6[r8 + 2];
        if (a7 === "#" && this.dparenDepth === 0) return this.readComment(r8, s9, n23);
        if (a7 === `
`) return this.pos = r8 + 1, this.line++, this.column = 1, { type: p2.NEWLINE, value: `
`, start: r8, end: r8 + 1, line: s9, column: n23 };
        if (a7 === "<" && i10 === "<" && l8 === "-") return this.pos = r8 + 3, this.column = n23 + 3, this.registerHeredocFromLookahead(true), this.makeToken(p2.DLESSDASH, "<<-", r8, s9, n23);
        for (let [c15, u11, f11, h17] of Ir) if (a7 === c15 && i10 === u11 && l8 === f11) return this.pos = r8 + 3, this.column = n23 + 3, this.makeToken(h17, c15 + u11 + f11, r8, s9, n23);
        if (a7 === "<" && i10 === "<") return this.pos = r8 + 2, this.column = n23 + 2, this.registerHeredocFromLookahead(false), this.makeToken(p2.DLESS, "<<", r8, s9, n23);
        if (a7 === "(" && i10 === "(") return this.dparenDepth > 0 ? (this.pos = r8 + 1, this.column = n23 + 1, this.dparenDepth++, this.makeToken(p2.LPAREN, "(", r8, s9, n23)) : this.looksLikeNestedSubshells(r8 + 2) || this.dparenClosesWithSpacedParens(r8 + 2) ? (this.pos = r8 + 1, this.column = n23 + 1, this.makeToken(p2.LPAREN, "(", r8, s9, n23)) : (this.pos = r8 + 2, this.column = n23 + 2, this.dparenDepth = 1, this.makeToken(p2.DPAREN_START, "((", r8, s9, n23));
        if (a7 === ")" && i10 === ")") return this.dparenDepth === 1 ? (this.pos = r8 + 2, this.column = n23 + 2, this.dparenDepth = 0, this.makeToken(p2.DPAREN_END, "))", r8, s9, n23)) : this.dparenDepth > 1 ? (this.pos = r8 + 1, this.column = n23 + 1, this.dparenDepth--, this.makeToken(p2.RPAREN, ")", r8, s9, n23)) : (this.pos = r8 + 1, this.column = n23 + 1, this.makeToken(p2.RPAREN, ")", r8, s9, n23));
        for (let [c15, u11, f11] of vr) if (!(c15 === "(" && u11 === "(" || c15 === ")" && u11 === ")") && !(this.dparenDepth > 0 && c15 === ";" && (f11 === p2.DSEMI || f11 === p2.SEMI_AND || f11 === p2.SEMI_SEMI_AND)) && a7 === c15 && i10 === u11) {
          if (f11 === p2.DBRACK_START || f11 === p2.DBRACK_END) {
            let h17 = t6[r8 + 2];
            if (h17 !== void 0 && h17 !== " " && h17 !== "	" && h17 !== `
` && h17 !== ";" && h17 !== "&" && h17 !== "|" && h17 !== "(" && h17 !== ")" && h17 !== "<" && h17 !== ">") break;
          }
          return this.pos = r8 + 2, this.column = n23 + 2, this.makeToken(f11, c15 + u11, r8, s9, n23);
        }
        if (a7 === "(" && this.dparenDepth > 0) return this.pos = r8 + 1, this.column = n23 + 1, this.dparenDepth++, this.makeToken(p2.LPAREN, "(", r8, s9, n23);
        if (a7 === ")" && this.dparenDepth > 1) return this.pos = r8 + 1, this.column = n23 + 1, this.dparenDepth--, this.makeToken(p2.RPAREN, ")", r8, s9, n23);
        let o9 = Dr.get(a7);
        if (o9 !== void 0) return this.pos = r8 + 1, this.column = n23 + 1, this.makeToken(o9, a7, r8, s9, n23);
        if (a7 === "{") {
          let c15 = this.scanFdVariable(r8);
          return c15 !== null ? (this.pos = c15.end, this.column = n23 + (c15.end - r8), { type: p2.FD_VARIABLE, value: c15.varname, start: r8, end: c15.end, line: s9, column: n23 }) : i10 === "}" ? (this.pos = r8 + 2, this.column = n23 + 2, { type: p2.WORD, value: "{}", start: r8, end: r8 + 2, line: s9, column: n23, quoted: false, singleQuoted: false }) : this.scanBraceExpansion(r8) !== null ? this.readWordWithBraceExpansion(r8, s9, n23) : this.scanLiteralBraceWord(r8) !== null ? this.readWordWithBraceExpansion(r8, s9, n23) : i10 !== void 0 && i10 !== " " && i10 !== "	" && i10 !== `
` ? this.readWord(r8, s9, n23) : (this.pos = r8 + 1, this.column = n23 + 1, this.makeToken(p2.LBRACE, "{", r8, s9, n23));
        }
        return a7 === "}" ? this.isWordCharFollowing(r8 + 1) ? this.readWord(r8, s9, n23) : (this.pos = r8 + 1, this.column = n23 + 1, this.makeToken(p2.RBRACE, "}", r8, s9, n23)) : a7 === "!" ? i10 === "=" ? (this.pos = r8 + 2, this.column = n23 + 2, this.makeToken(p2.WORD, "!=", r8, s9, n23)) : (this.pos = r8 + 1, this.column = n23 + 1, this.makeToken(p2.BANG, "!", r8, s9, n23)) : this.readWord(r8, s9, n23);
      }
      looksLikeNestedSubshells(t6) {
        let r8 = this.input, s9 = r8.length, n23 = t6;
        for (; n23 < s9 && (r8[n23] === " " || r8[n23] === "	"); ) n23++;
        if (n23 >= s9) return false;
        let a7 = r8[n23];
        if (a7 === "(") return this.looksLikeNestedSubshells(n23 + 1);
        let i10 = /[a-zA-Z_]/.test(a7), l8 = a7 === "!" || a7 === "[";
        if (!i10 && !l8) return false;
        let o9 = n23;
        for (; o9 < s9 && /[a-zA-Z0-9_\-.]/.test(r8[o9]); ) o9++;
        if (o9 === n23) return l8;
        let c15 = o9;
        for (; c15 < s9 && (r8[c15] === " " || r8[c15] === "	"); ) c15++;
        if (c15 >= s9) return false;
        let u11 = r8[c15];
        if (u11 === "=" && r8[c15 + 1] !== "=" || u11 === `
` || o9 === c15 && /[+\-*/%<>&|^!~?:]/.test(u11) && u11 !== "-" || u11 === ")" && r8[c15 + 1] === ")") return false;
        if (c15 > o9 && (u11 === "-" || u11 === '"' || u11 === "'" || u11 === "$" || /[a-zA-Z_/.]/.test(u11))) {
          let f11 = c15;
          for (; f11 < s9 && r8[f11] !== `
`; ) {
            if (r8[f11] === ")") return true;
            f11++;
          }
          return false;
        }
        if (u11 === ")") {
          let f11 = c15 + 1;
          for (; f11 < s9 && (r8[f11] === " " || r8[f11] === "	"); ) f11++;
          if (r8[f11] === "|" && r8[f11 + 1] === "|" || r8[f11] === "&" && r8[f11 + 1] === "&" || r8[f11] === ";" || r8[f11] === "|" && r8[f11 + 1] !== "|") return true;
        }
        return false;
      }
      makeToken(t6, r8, s9, n23, a7) {
        return { type: t6, value: r8, start: s9, end: this.pos, line: n23, column: a7 };
      }
      readComment(t6, r8, s9) {
        let n23 = this.input, a7 = n23.length, i10 = this.pos;
        for (; i10 < a7 && n23[i10] !== `
`; ) i10++;
        let l8 = n23.slice(t6, i10);
        return this.pos = i10, this.column = s9 + (i10 - t6), { type: p2.COMMENT, value: l8, start: t6, end: i10, line: r8, column: s9 };
      }
      readWord(t6, r8, s9) {
        let n23 = this.input, a7 = n23.length, i10 = this.pos, l8 = i10;
        for (; i10 < a7; ) {
          let y18 = n23[i10];
          if (y18 === " " || y18 === "	" || y18 === `
` || y18 === ";" || y18 === "&" || y18 === "|" || y18 === "(" || y18 === ")" || y18 === "<" || y18 === ">" || y18 === "'" || y18 === '"' || y18 === "\\" || y18 === "$" || y18 === "`" || y18 === "{" || y18 === "}" || y18 === "~" || y18 === "*" || y18 === "?" || y18 === "[") break;
          i10++;
        }
        if (i10 > l8) {
          let y18 = n23[i10];
          if (!(y18 === "(" && i10 > l8 && "@*+?!".includes(n23[i10 - 1]))) {
            if (i10 >= a7 || y18 === " " || y18 === "	" || y18 === `
` || y18 === ";" || y18 === "&" || y18 === "|" || y18 === "(" || y18 === ")" || y18 === "<" || y18 === ">") {
              let b25 = n23.slice(l8, i10);
              this.pos = i10, this.column = s9 + (i10 - l8);
              let D15 = qt.get(b25);
              if (D15 !== void 0) return { type: D15, value: b25, start: t6, end: i10, line: r8, column: s9 };
              let G9 = Ft(b25);
              return G9 > 0 && Bt(b25.slice(0, G9)) ? { type: p2.ASSIGNMENT_WORD, value: b25, start: t6, end: i10, line: r8, column: s9 } : /^[0-9]+$/.test(b25) ? { type: p2.NUMBER, value: b25, start: t6, end: i10, line: r8, column: s9 } : /^[a-zA-Z_][a-zA-Z0-9_]*$/.test(b25) ? { type: p2.NAME, value: b25, start: t6, end: i10, line: r8, column: s9, quoted: false, singleQuoted: false } : { type: p2.WORD, value: b25, start: t6, end: i10, line: r8, column: s9, quoted: false, singleQuoted: false };
            }
          }
        }
        i10 = this.pos;
        let o9 = this.column, c15 = this.line, u11 = "", f11 = false, h17 = false, d16 = false, m25 = false, g18 = n23[i10] === '"' || n23[i10] === "'", E13 = false, A14 = 0;
        for (; i10 < a7; ) {
          let y18 = n23[i10];
          if (!d16 && !m25) {
            if (y18 === "(" && u11.length > 0 && "@*+?!".includes(u11[u11.length - 1])) {
              let b25 = this.scanExtglobPattern(i10);
              if (b25 !== null) {
                u11 += b25.content, i10 = b25.end, o9 += b25.content.length;
                continue;
              }
            }
            if (y18 === "[" && A14 === 0) {
              if (/^[a-zA-Z_][a-zA-Z0-9_]*$/.test(u11)) {
                let b25 = i10 + 1 < a7 ? n23[i10 + 1] : "";
                if (b25 === "^" || b25 === "!") {
                  u11 += y18, i10++, o9++;
                  continue;
                }
                A14 = 1, u11 += y18, i10++, o9++;
                continue;
              }
            } else if (y18 === "[" && A14 > 0) {
              u11.length > 0 && u11[u11.length - 1] !== "\\" && A14++, u11 += y18, i10++, o9++;
              continue;
            } else if (y18 === "]" && A14 > 0) {
              u11.length > 0 && u11[u11.length - 1] !== "\\" && A14--, u11 += y18, i10++, o9++;
              continue;
            }
            if (A14 > 0) {
              if (y18 === `
`) break;
              u11 += y18, i10++, o9++;
              continue;
            }
            if (y18 === " " || y18 === "	" || y18 === `
` || y18 === ";" || y18 === "&" || y18 === "|" || y18 === "(" || y18 === ")" || y18 === "<" || y18 === ">") break;
          }
          if (y18 === "$" && i10 + 1 < a7 && n23[i10 + 1] === "'" && !d16 && !m25) {
            for (u11 += "$'", i10 += 2, o9 += 2; i10 < a7 && n23[i10] !== "'"; ) n23[i10] === "\\" && i10 + 1 < a7 ? (u11 += n23[i10] + n23[i10 + 1], i10 += 2, o9 += 2) : (u11 += n23[i10], i10++, o9++);
            i10 < a7 && (u11 += "'", i10++, o9++);
            continue;
          }
          if (y18 === "$" && i10 + 1 < a7 && n23[i10 + 1] === '"' && !d16 && !m25) {
            i10++, o9++, m25 = true, f11 = true, u11 === "" && (g18 = true), i10++, o9++;
            continue;
          }
          if (y18 === "'" && !m25) {
            if (d16) if (d16 = false, !g18 || E13) u11 += y18;
            else {
              let b25 = i10 + 1 < a7 ? n23[i10 + 1] : "";
              b25 && !zt(b25) && b25 !== "'" && (b25 === '"' ? (E13 = true, u11 += y18, h17 = false, f11 = false) : (E13 = true, u11 += y18));
            }
            else d16 = true, g18 && !E13 ? (h17 = true, f11 = true) : u11 += y18;
            i10++, o9++;
            continue;
          }
          if (y18 === '"' && !d16) {
            if (m25) if (m25 = false, !g18 || E13) u11 += y18;
            else {
              let b25 = i10 + 1 < a7 ? n23[i10 + 1] : "";
              b25 && !zt(b25) && b25 !== '"' && (b25 === "'" ? (E13 = true, u11 += y18, h17 = false, f11 = false) : (E13 = true, u11 += y18));
            }
            else m25 = true, g18 && !E13 ? f11 = true : u11 += y18;
            i10++, o9++;
            continue;
          }
          if (y18 === "\\" && !d16 && i10 + 1 < a7) {
            let b25 = n23[i10 + 1];
            if (b25 === `
`) {
              i10 += 2, c15++, o9 = 1;
              continue;
            }
            if (m25) {
              if (b25 === '"' || b25 === "\\" || b25 === "$" || b25 === "`" || b25 === `
`) {
                if (b25 === `
`) {
                  i10 += 2, o9 = 1, c15++;
                  continue;
                }
                u11 += y18 + b25, i10 += 2, o9 += 2;
                continue;
              }
            } else {
              b25 === "\\" || b25 === '"' || b25 === "'" || b25 === "`" || b25 === "*" || b25 === "?" || b25 === "[" || b25 === "]" || b25 === "(" || b25 === ")" || b25 === "$" || b25 === "-" || b25 === "." || b25 === "^" || b25 === "+" || b25 === "{" || b25 === "}" ? u11 += y18 + b25 : u11 += b25, i10 += 2, o9 += 2;
              continue;
            }
          }
          if (y18 === "$" && i10 + 1 < a7 && n23[i10 + 1] === "(" && !d16) {
            u11 += y18, i10++, o9++, u11 += n23[i10], i10++, o9++;
            let b25 = 1, D15 = false, G9 = false, ie8 = 0, H16 = false, B12 = "", we6 = n23[i10] === "(" && !this.dollarDparenIsSubshell(i10);
            for (; b25 > 0 && i10 < a7; ) {
              let _15 = n23[i10];
              if (u11 += _15, D15) _15 === "'" && (D15 = false);
              else if (G9) _15 === "\\" && i10 + 1 < a7 ? (u11 += n23[i10 + 1], i10++, o9++) : _15 === '"' && (G9 = false);
              else if (_15 === "'") D15 = true, B12 = "";
              else if (_15 === '"') G9 = true, B12 = "";
              else if (_15 === "\\" && i10 + 1 < a7) u11 += n23[i10 + 1], i10++, o9++, B12 = "";
              else if (_15 === "$" && i10 + 1 < a7 && n23[i10 + 1] === "{") {
                i10++, o9++, u11 += n23[i10], i10++, o9++;
                let qe6 = 1, Ne6 = false, Be6 = false;
                for (; qe6 > 0 && i10 < a7; ) {
                  let Y11 = n23[i10];
                  if (Y11 === "\\" && i10 + 1 < a7 && !Ne6) {
                    u11 += Y11, i10++, o9++, u11 += n23[i10], i10++, o9++;
                    continue;
                  }
                  u11 += Y11, Ne6 ? Y11 === "'" && (Ne6 = false) : Be6 ? Y11 === '"' && (Be6 = false) : Y11 === "'" ? Ne6 = true : Y11 === '"' ? Be6 = true : Y11 === "{" ? qe6++ : Y11 === "}" && qe6--, Y11 === `
` ? (c15++, o9 = 0) : o9++, i10++;
                }
                B12 = "";
                continue;
              } else if (_15 === "#" && !we6 && (B12 === "" || /\s/.test(n23[i10 - 1] || ""))) {
                for (; i10 + 1 < a7 && n23[i10 + 1] !== `
`; ) i10++, o9++, u11 += n23[i10];
                B12 = "";
              } else /[a-zA-Z_]/.test(_15) ? B12 += _15 : (B12 === "case" ? (ie8++, H16 = false) : B12 === "in" && ie8 > 0 ? H16 = true : B12 === "esac" && ie8 > 0 && (ie8--, H16 = false), B12 = "", _15 === "(" ? i10 > 0 && n23[i10 - 1] === "$" ? b25++ : H16 || b25++ : _15 === ")" ? H16 ? H16 = false : b25-- : _15 === ";" && ie8 > 0 && (i10 + 1 < a7 && n23[i10 + 1] === ";" || i10 + 1 < a7 && n23[i10 + 1] === "&") && (H16 = true));
              _15 === `
` && (c15++, o9 = 0, B12 = ""), i10++, o9++;
            }
            continue;
          }
          if (y18 === "$" && i10 + 1 < a7 && n23[i10 + 1] === "[" && !d16) {
            u11 += y18, i10++, o9++, u11 += n23[i10], i10++, o9++;
            let b25 = 1;
            for (; b25 > 0 && i10 < a7; ) {
              let D15 = n23[i10];
              u11 += D15, D15 === "[" ? b25++ : D15 === "]" ? b25-- : D15 === `
` && (c15++, o9 = 0), i10++, o9++;
            }
            continue;
          }
          if (y18 === "$" && i10 + 1 < a7 && n23[i10 + 1] === "{" && !d16) {
            u11 += y18, i10++, o9++, u11 += n23[i10], i10++, o9++;
            let b25 = 1, D15 = false, G9 = false, ie8 = c15, H16 = o9, B12 = c15, we6 = o9;
            for (; b25 > 0 && i10 < a7; ) {
              let _15 = n23[i10];
              if (_15 === "\\" && i10 + 1 < a7 && n23[i10 + 1] === `
`) {
                i10 += 2, c15++, o9 = 1;
                continue;
              }
              if (_15 === "\\" && i10 + 1 < a7 && !D15) {
                u11 += _15, i10++, o9++, u11 += n23[i10], i10++, o9++;
                continue;
              }
              u11 += _15, D15 ? _15 === "'" && (D15 = false) : G9 ? _15 === '"' && (G9 = false) : _15 === "'" ? (D15 = true, ie8 = c15, H16 = o9) : _15 === '"' ? (G9 = true, B12 = c15, we6 = o9) : _15 === "{" ? b25++ : _15 === "}" && b25--, _15 === `
` && (c15++, o9 = 0), i10++, o9++;
            }
            if (D15) throw new pe("unexpected EOF while looking for matching `''", ie8, H16);
            if (G9) throw new pe("unexpected EOF while looking for matching `\"'", B12, we6);
            continue;
          }
          if (y18 === "$" && i10 + 1 < a7 && !d16) {
            let b25 = n23[i10 + 1];
            if (b25 === "#" || b25 === "?" || b25 === "$" || b25 === "!" || b25 === "@" || b25 === "*" || b25 === "-" || b25 >= "0" && b25 <= "9") {
              u11 += y18 + b25, i10 += 2, o9 += 2;
              continue;
            }
          }
          if (y18 === "`" && !d16) {
            for (u11 += y18, i10++, o9++; i10 < a7 && n23[i10] !== "`"; ) {
              let b25 = n23[i10];
              u11 += b25, b25 === "\\" && i10 + 1 < a7 && (u11 += n23[i10 + 1], i10++, o9++), b25 === `
` && (c15++, o9 = 0), i10++, o9++;
            }
            i10 < a7 && (u11 += n23[i10], i10++, o9++);
            continue;
          }
          u11 += y18, i10++, y18 === `
` ? (c15++, o9 = 1) : o9++;
        }
        if (this.pos = i10, this.column = o9, this.line = c15, E13 && g18 && (u11 = n23[t6] + u11, f11 = false, h17 = false), d16 || m25) {
          let y18 = d16 ? "'" : '"';
          throw new pe(`unexpected EOF while looking for matching \`${y18}'`, r8, s9);
        }
        if (!g18 && u11.length >= 2) {
          if (u11[0] === "'" && u11[u11.length - 1] === "'") {
            let y18 = u11.slice(1, -1);
            !y18.includes("'") && !y18.includes('"') && (u11 = y18, f11 = true, h17 = true);
          } else if (u11[0] === '"' && u11[u11.length - 1] === '"') {
            let y18 = u11.slice(1, -1), b25 = false;
            for (let D15 = 0; D15 < y18.length; D15++) {
              if (y18[D15] === '"') {
                b25 = true;
                break;
              }
              y18[D15] === "\\" && D15 + 1 < y18.length && D15++;
            }
            b25 || (u11 = y18, f11 = true, h17 = false);
          }
        }
        if (u11 === "") return { type: p2.WORD, value: "", start: t6, end: i10, line: r8, column: s9, quoted: f11, singleQuoted: h17 };
        let S17 = qt.get(u11);
        if (!f11 && S17 !== void 0) return { type: S17, value: u11, start: t6, end: i10, line: r8, column: s9 };
        if (!g18) {
          let y18 = Ft(u11);
          if (y18 > 0 && Bt(u11.slice(0, y18))) return { type: p2.ASSIGNMENT_WORD, value: u11, start: t6, end: i10, line: r8, column: s9, quoted: f11, singleQuoted: h17 };
        }
        return /^[0-9]+$/.test(u11) ? { type: p2.NUMBER, value: u11, start: t6, end: i10, line: r8, column: s9 } : xr(u11) ? { type: p2.NAME, value: u11, start: t6, end: i10, line: r8, column: s9, quoted: f11, singleQuoted: h17 } : { type: p2.WORD, value: u11, start: t6, end: i10, line: r8, column: s9, quoted: f11, singleQuoted: h17 };
      }
      readHeredocContent() {
        for (; this.pendingHeredocs.length > 0; ) {
          let t6 = this.pendingHeredocs.shift();
          if (!t6) break;
          let r8 = this.pos, s9 = this.line, n23 = this.column, a7 = "";
          for (; this.pos < this.input.length; ) {
            let i10 = this.pos, l8 = "";
            for (; this.pos < this.input.length && this.input[this.pos] !== `
`; ) l8 += this.input[this.pos], this.pos++, this.column++;
            if ((t6.stripTabs ? l8.replace(/^\t+/, "") : l8) === t6.delimiter) {
              this.pos < this.input.length && this.input[this.pos] === `
` && (this.pos++, this.line++, this.column = 1);
              break;
            }
            if (a7 += l8, a7.length > this.maxHeredocSize) throw new pe(`Heredoc size limit exceeded (${this.maxHeredocSize} bytes)`, s9, n23);
            this.pos < this.input.length && this.input[this.pos] === `
` && (a7 += `
`, this.pos++, this.line++, this.column = 1);
          }
          this.tokens.push({ type: p2.HEREDOC_CONTENT, value: a7, start: r8, end: this.pos, line: s9, column: n23 });
        }
      }
      addPendingHeredoc(t6, r8, s9) {
        this.pendingHeredocs.push({ delimiter: t6, stripTabs: r8, quoted: s9 });
      }
      registerHeredocFromLookahead(t6) {
        let r8 = this.pos, s9 = this.column;
        for (; this.pos < this.input.length && (this.input[this.pos] === " " || this.input[this.pos] === "	"); ) this.pos++, this.column++;
        let n23 = "", a7 = false;
        for (; this.pos < this.input.length; ) {
          let i10 = this.input[this.pos];
          if (/[\s;<>&|()]/.test(i10)) break;
          if (i10 === "'" || i10 === '"') {
            a7 = true;
            let l8 = i10;
            for (this.pos++, this.column++; this.pos < this.input.length && this.input[this.pos] !== l8; ) n23 += this.input[this.pos], this.pos++, this.column++;
            this.pos < this.input.length && this.input[this.pos] === l8 && (this.pos++, this.column++);
          } else i10 === "\\" ? (a7 = true, this.pos++, this.column++, this.pos < this.input.length && (n23 += this.input[this.pos], this.pos++, this.column++)) : (n23 += i10, this.pos++, this.column++);
        }
        this.pos = r8, this.column = s9, n23 && this.pendingHeredocs.push({ delimiter: n23, stripTabs: t6, quoted: a7 });
      }
      isWordCharFollowing(t6) {
        if (t6 >= this.input.length) return false;
        let r8 = this.input[t6];
        return !(r8 === " " || r8 === "	" || r8 === `
` || r8 === ";" || r8 === "&" || r8 === "|" || r8 === "(" || r8 === ")" || r8 === "<" || r8 === ">");
      }
      readWordWithBraceExpansion(t6, r8, s9) {
        let n23 = this.input, a7 = n23.length, i10 = t6, l8 = s9;
        for (; i10 < a7; ) {
          let c15 = n23[i10];
          if (c15 === " " || c15 === "	" || c15 === `
` || c15 === ";" || c15 === "&" || c15 === "|" || c15 === "(" || c15 === ")" || c15 === "<" || c15 === ">") break;
          if (c15 === "{") {
            if (this.scanBraceExpansion(i10) !== null) {
              let f11 = 1;
              for (i10++, l8++; i10 < a7 && f11 > 0; ) n23[i10] === "{" ? f11++ : n23[i10] === "}" && f11--, i10++, l8++;
              continue;
            }
            i10++, l8++;
            continue;
          }
          if (c15 === "}") {
            i10++, l8++;
            continue;
          }
          if (c15 === "$" && i10 + 1 < a7 && n23[i10 + 1] === "(") {
            i10++, l8++, i10++, l8++;
            let u11 = 1;
            for (; u11 > 0 && i10 < a7; ) n23[i10] === "(" ? u11++ : n23[i10] === ")" && u11--, i10++, l8++;
            continue;
          }
          if (c15 === "$" && i10 + 1 < a7 && n23[i10 + 1] === "{") {
            i10++, l8++, i10++, l8++;
            let u11 = 1;
            for (; u11 > 0 && i10 < a7; ) n23[i10] === "{" ? u11++ : n23[i10] === "}" && u11--, i10++, l8++;
            continue;
          }
          if (c15 === "`") {
            for (i10++, l8++; i10 < a7 && n23[i10] !== "`"; ) n23[i10] === "\\" && i10 + 1 < a7 ? (i10 += 2, l8 += 2) : (i10++, l8++);
            i10 < a7 && (i10++, l8++);
            continue;
          }
          i10++, l8++;
        }
        let o9 = n23.slice(t6, i10);
        return this.pos = i10, this.column = l8, { type: p2.WORD, value: o9, start: t6, end: i10, line: r8, column: s9, quoted: false, singleQuoted: false };
      }
      scanBraceExpansion(t6) {
        let r8 = this.input, s9 = r8.length, n23 = t6 + 1, a7 = 1, i10 = false, l8 = false;
        for (; n23 < s9 && a7 > 0; ) {
          let o9 = r8[n23];
          if (o9 === "{") a7++, n23++;
          else if (o9 === "}") a7--, n23++;
          else if (o9 === "," && a7 === 1) i10 = true, n23++;
          else if (o9 === "." && n23 + 1 < s9 && r8[n23 + 1] === ".") l8 = true, n23 += 2;
          else {
            if (o9 === " " || o9 === "	" || o9 === `
` || o9 === ";" || o9 === "&" || o9 === "|") return null;
            n23++;
          }
        }
        return a7 === 0 && (i10 || l8) ? r8.slice(t6, n23) : null;
      }
      scanLiteralBraceWord(t6) {
        let r8 = this.input, s9 = r8.length, n23 = t6 + 1, a7 = 1;
        for (; n23 < s9 && a7 > 0; ) {
          let i10 = r8[n23];
          if (i10 === "{") a7++, n23++;
          else if (i10 === "}") {
            if (a7--, a7 === 0) return r8.slice(t6, n23 + 1);
            n23++;
          } else {
            if (i10 === " " || i10 === "	" || i10 === `
` || i10 === ";" || i10 === "&" || i10 === "|") return null;
            n23++;
          }
        }
        return null;
      }
      scanExtglobPattern(t6) {
        let r8 = this.input, s9 = r8.length, n23 = t6 + 1, a7 = 1;
        for (; n23 < s9 && a7 > 0; ) {
          let i10 = r8[n23];
          if (i10 === "\\" && n23 + 1 < s9) {
            n23 += 2;
            continue;
          }
          if ("@*+?!".includes(i10) && n23 + 1 < s9 && r8[n23 + 1] === "(") {
            n23++, a7++, n23++;
            continue;
          }
          if (i10 === "(") a7++, n23++;
          else if (i10 === ")") a7--, n23++;
          else {
            if (i10 === `
`) return null;
            n23++;
          }
        }
        return a7 === 0 ? { content: r8.slice(t6, n23), end: n23 } : null;
      }
      scanFdVariable(t6) {
        let r8 = this.input, s9 = r8.length, n23 = t6 + 1, a7 = n23;
        for (; n23 < s9; ) {
          let u11 = r8[n23];
          if (n23 === a7) {
            if (!(u11 >= "a" && u11 <= "z" || u11 >= "A" && u11 <= "Z" || u11 === "_")) return null;
          } else if (!(u11 >= "a" && u11 <= "z" || u11 >= "A" && u11 <= "Z" || u11 >= "0" && u11 <= "9" || u11 === "_")) break;
          n23++;
        }
        if (n23 === a7) return null;
        let i10 = r8.slice(a7, n23);
        if (n23 >= s9 || r8[n23] !== "}" || (n23++, n23 >= s9)) return null;
        let l8 = r8[n23], o9 = n23 + 1 < s9 ? r8[n23 + 1] : "";
        return l8 === ">" || l8 === "<" || l8 === "&" && (o9 === ">" || o9 === "<") ? { varname: i10, end: n23 } : null;
      }
      dollarDparenIsSubshell(t6) {
        let r8 = this.input, s9 = r8.length, n23 = t6 + 1, a7 = 2, i10 = false, l8 = false, o9 = false;
        for (; n23 < s9 && a7 > 0; ) {
          let c15 = r8[n23];
          if (i10) {
            c15 === "'" && (i10 = false), c15 === `
` && (o9 = true), n23++;
            continue;
          }
          if (l8) {
            if (c15 === "\\") {
              n23 += 2;
              continue;
            }
            c15 === '"' && (l8 = false), c15 === `
` && (o9 = true), n23++;
            continue;
          }
          if (c15 === "'") {
            i10 = true, n23++;
            continue;
          }
          if (c15 === '"') {
            l8 = true, n23++;
            continue;
          }
          if (c15 === "\\") {
            n23 += 2;
            continue;
          }
          if (c15 === `
` && (o9 = true), c15 === "(") {
            a7++, n23++;
            continue;
          }
          if (c15 === ")") {
            if (a7--, a7 === 1) {
              let u11 = n23 + 1;
              if (u11 < s9 && r8[u11] === ")") return false;
              let f11 = u11, h17 = false;
              for (; f11 < s9 && (r8[f11] === " " || r8[f11] === "	" || r8[f11] === `
`); ) h17 = true, f11++;
              if (h17 && f11 < s9 && r8[f11] === ")" || o9) return true;
            }
            if (a7 === 0) return false;
            n23++;
            continue;
          }
          n23++;
        }
        return false;
      }
      dparenClosesWithSpacedParens(t6) {
        let r8 = this.input, s9 = r8.length, n23 = t6, a7 = 2, i10 = false, l8 = false;
        for (; n23 < s9 && a7 > 0; ) {
          let o9 = r8[n23];
          if (i10) {
            o9 === "'" && (i10 = false), n23++;
            continue;
          }
          if (l8) {
            if (o9 === "\\") {
              n23 += 2;
              continue;
            }
            o9 === '"' && (l8 = false), n23++;
            continue;
          }
          if (o9 === "'") {
            i10 = true, n23++;
            continue;
          }
          if (o9 === '"') {
            l8 = true, n23++;
            continue;
          }
          if (o9 === "\\") {
            n23 += 2;
            continue;
          }
          if (o9 === "(") {
            a7++, n23++;
            continue;
          }
          if (o9 === ")") {
            if (a7--, a7 === 1) {
              let c15 = n23 + 1;
              if (c15 < s9 && r8[c15] === ")") return false;
              let u11 = c15, f11 = false;
              for (; u11 < s9 && (r8[u11] === " " || r8[u11] === "	" || r8[u11] === `
`); ) f11 = true, u11++;
              if (f11 && u11 < s9 && r8[u11] === ")") return true;
            }
            if (a7 === 0) return false;
            n23++;
            continue;
          }
          if (a7 === 1 && (o9 === "|" && n23 + 1 < s9 && r8[n23 + 1] === "|" || o9 === "&" && n23 + 1 < s9 && r8[n23 + 1] === "&" || o9 === "|" && n23 + 1 < s9 && r8[n23 + 1] !== "|")) return true;
          n23++;
        }
        return false;
      }
    };
    Qe = 1e6;
    Ge = 1e5;
    Qt = 1e6;
    Ze = 200;
    Gt = /* @__PURE__ */ new Set([p2.LESS, p2.GREAT, p2.DLESS, p2.DGREAT, p2.LESSAND, p2.GREATAND, p2.LESSGREAT, p2.DLESSDASH, p2.CLOBBER, p2.TLESS, p2.AND_GREAT, p2.AND_DGREAT]);
    Zt = /* @__PURE__ */ new Set([p2.LESS, p2.GREAT, p2.DLESS, p2.DGREAT, p2.LESSAND, p2.GREATAND, p2.LESSGREAT, p2.DLESSDASH, p2.CLOBBER, p2.TLESS]);
    Ut = /* @__PURE__ */ new Set([p2.LESS, p2.GREAT, p2.DLESS, p2.DGREAT, p2.LESSAND, p2.GREATAND, p2.LESSGREAT, p2.DLESSDASH, p2.CLOBBER, p2.TLESS, p2.AND_GREAT, p2.AND_DGREAT]);
    Q2 = class extends Error {
      line;
      column;
      token;
      constructor(t6, r8, s9, n23 = void 0) {
        super(`Parse error at ${r8}:${s9}: ${t6}`), this.line = r8, this.column = s9, this.token = n23, this.name = "ParseException";
      }
    };
    Lr = /* @__PURE__ */ new Set([p2.AMP, p2.PIPE, p2.PIPE_AMP, p2.SEMICOLON, p2.AND_AND, p2.OR_OR, p2.DSEMI, p2.SEMI_AND, p2.SEMI_SEMI_AND]);
    qr = ["-a", "-b", "-c", "-d", "-e", "-f", "-g", "-h", "-k", "-p", "-r", "-s", "-t", "-u", "-w", "-x", "-G", "-L", "-N", "-O", "-S", "-z", "-n", "-o", "-v", "-R"];
    Br = ["==", "!=", "=~", "<", ">", "-eq", "-ne", "-lt", "-le", "-gt", "-ge", "-nt", "-ot", "-ef"];
    V2 = class e {
      tokens = [];
      pos = 0;
      pendingHeredocs = [];
      parseIterations = 0;
      parseDepth = 0;
      _input = "";
      getInput() {
        return this._input;
      }
      checkIterationLimit() {
        if (this.parseIterations++, this.parseIterations > Qt) throw new Q2("Maximum parse iterations exceeded (possible infinite loop)", this.current().line, this.current().column);
      }
      enterDepth() {
        if (this.parseDepth++, this.parseDepth > Ze) throw new Q2(`Maximum parser nesting depth exceeded (${Ze})`, this.current().line, this.current().column);
        return () => {
          this.parseDepth--;
        };
      }
      parse(t6, r8) {
        if (t6.length > Qe) throw new Q2(`Input too large: ${t6.length} bytes exceeds limit of ${Qe}`, 1, 1);
        this._input = t6;
        let s9 = new Ie(t6, r8);
        if (this.tokens = s9.tokenize(), this.tokens.length > Ge) throw new Q2(`Too many tokens: ${this.tokens.length} exceeds limit of ${Ge}`, 1, 1);
        return this.pos = 0, this.pendingHeredocs = [], this.parseIterations = 0, this.parseDepth = 0, this.parseScript();
      }
      parseTokens(t6) {
        return this.tokens = t6, this.pos = 0, this.pendingHeredocs = [], this.parseIterations = 0, this.parseDepth = 0, this.parseScript();
      }
      current() {
        return this.tokens[this.pos] || this.tokens[this.tokens.length - 1];
      }
      peek(t6 = 0) {
        return this.tokens[this.pos + t6] || this.tokens[this.tokens.length - 1];
      }
      advance() {
        let t6 = this.current();
        return this.pos < this.tokens.length - 1 && this.pos++, t6;
      }
      getPos() {
        return this.pos;
      }
      check(t6, r8, s9, n23, ...a7) {
        let i10 = this.tokens[this.pos]?.type;
        return i10 === t6 || r8 !== void 0 && i10 === r8 || s9 !== void 0 && i10 === s9 || n23 !== void 0 && i10 === n23 ? true : a7.length > 0 ? a7.includes(i10) : false;
      }
      expect(t6, r8) {
        if (this.check(t6)) return this.advance();
        let s9 = this.current();
        throw new Q2(r8 || `Expected ${t6}, got ${s9.type}`, s9.line, s9.column, s9);
      }
      error(t6) {
        let r8 = this.current();
        throw new Q2(t6, r8.line, r8.column, r8);
      }
      skipNewlines() {
        for (; this.check(p2.NEWLINE, p2.COMMENT); ) this.check(p2.NEWLINE) ? (this.advance(), this.processHeredocs()) : this.advance();
      }
      skipSeparators(t6 = true) {
        for (; ; ) {
          if (this.check(p2.NEWLINE)) {
            this.advance(), this.processHeredocs();
            continue;
          }
          if (this.check(p2.SEMICOLON, p2.COMMENT)) {
            this.advance();
            continue;
          }
          if (t6 && this.check(p2.DSEMI, p2.SEMI_AND, p2.SEMI_SEMI_AND)) {
            this.advance();
            continue;
          }
          break;
        }
      }
      addPendingHeredoc(t6, r8, s9, n23) {
        this.pendingHeredocs.push({ redirect: t6, delimiter: r8, stripTabs: s9, quoted: n23 });
      }
      processHeredocs() {
        for (let t6 of this.pendingHeredocs) if (this.check(p2.HEREDOC_CONTENT)) {
          let r8 = this.advance(), s9;
          t6.quoted ? s9 = w2.word([w2.literal(r8.value)]) : s9 = this.parseWordFromString(r8.value, false, false, false, true), t6.redirect.target = w2.hereDoc(t6.delimiter, s9, t6.stripTabs, t6.quoted);
        }
        this.pendingHeredocs = [];
      }
      isStatementEnd() {
        return this.check(p2.EOF, p2.NEWLINE, p2.SEMICOLON, p2.AMP, p2.AND_AND, p2.OR_OR, p2.RPAREN, p2.RBRACE, p2.DSEMI, p2.SEMI_AND, p2.SEMI_SEMI_AND);
      }
      isCommandStart() {
        let t6 = this.current().type;
        return t6 === p2.WORD || t6 === p2.NAME || t6 === p2.NUMBER || t6 === p2.ASSIGNMENT_WORD || t6 === p2.IF || t6 === p2.FOR || t6 === p2.WHILE || t6 === p2.UNTIL || t6 === p2.CASE || t6 === p2.LPAREN || t6 === p2.LBRACE || t6 === p2.DPAREN_START || t6 === p2.DBRACK_START || t6 === p2.FUNCTION || t6 === p2.BANG || t6 === p2.TIME || t6 === p2.IN || t6 === p2.LESS || t6 === p2.GREAT || t6 === p2.DLESS || t6 === p2.DGREAT || t6 === p2.LESSAND || t6 === p2.GREATAND || t6 === p2.LESSGREAT || t6 === p2.DLESSDASH || t6 === p2.CLOBBER || t6 === p2.TLESS || t6 === p2.AND_GREAT || t6 === p2.AND_DGREAT;
      }
      parseScript() {
        let t6 = [], s9 = 0;
        for (this.skipNewlines(); !this.check(p2.EOF); ) {
          s9++, s9 > 1e4 && this.error("Parser stuck: too many iterations (>10000)");
          let n23 = this.checkUnexpectedToken();
          if (n23) {
            t6.push(n23), this.skipSeparators(false);
            continue;
          }
          let a7 = this.pos, i10 = this.parseStatement();
          i10 && t6.push(i10), this.skipSeparators(false), this.check(p2.DSEMI, p2.SEMI_AND, p2.SEMI_SEMI_AND) && this.error(`syntax error near unexpected token \`${this.current().value}'`), this.pos === a7 && !this.check(p2.EOF) && this.advance();
        }
        return w2.script(t6);
      }
      checkUnexpectedToken() {
        let t6 = this.current().type, r8 = this.current().value;
        if ((t6 === p2.DO || t6 === p2.DONE || t6 === p2.THEN || t6 === p2.ELSE || t6 === p2.ELIF || t6 === p2.FI || t6 === p2.ESAC) && this.error(`syntax error near unexpected token \`${r8}'`), t6 === p2.RBRACE || t6 === p2.RPAREN) {
          let s9 = `syntax error near unexpected token \`${r8}'`;
          return this.advance(), w2.statement([w2.pipeline([w2.simpleCommand(null, [], [], [])])], [], false, { message: s9, token: r8 });
        }
        return (t6 === p2.DSEMI || t6 === p2.SEMI_AND || t6 === p2.SEMI_SEMI_AND) && this.error(`syntax error near unexpected token \`${r8}'`), t6 === p2.SEMICOLON && this.error(`syntax error near unexpected token \`${r8}'`), (t6 === p2.PIPE || t6 === p2.PIPE_AMP) && this.error(`syntax error near unexpected token \`${r8}'`), null;
      }
      parseStatement() {
        if (this.skipNewlines(), !this.isCommandStart()) return null;
        let t6 = this.current().start, r8 = [], s9 = [], n23 = false, a7 = this.parsePipeline();
        for (r8.push(a7); this.check(p2.AND_AND, p2.OR_OR); ) {
          let o9 = this.advance();
          s9.push(o9.type === p2.AND_AND ? "&&" : "||"), this.skipNewlines();
          let c15 = this.parsePipeline();
          r8.push(c15);
        }
        this.check(p2.AMP) && (this.advance(), n23 = true);
        let i10 = this.pos > 0 ? this.tokens[this.pos - 1].end : t6, l8 = this._input.slice(t6, i10);
        return w2.statement(r8, s9, n23, void 0, l8);
      }
      parsePipeline() {
        let t6 = false, r8 = false;
        this.check(p2.TIME) && (this.advance(), t6 = true, this.check(p2.WORD, p2.NAME) && this.current().value === "-p" && (this.advance(), r8 = true));
        let s9 = 0;
        for (; this.check(p2.BANG); ) this.advance(), s9++;
        let n23 = s9 % 2 === 1, a7 = [], i10 = [], l8 = this.parseCommand();
        for (a7.push(l8); this.check(p2.PIPE, p2.PIPE_AMP); ) {
          let o9 = this.advance();
          this.skipNewlines(), i10.push(o9.type === p2.PIPE_AMP);
          let c15 = this.parseCommand();
          a7.push(c15);
        }
        return w2.pipeline(a7, n23, t6, r8, i10.length > 0 ? i10 : void 0);
      }
      parseCommand() {
        return this.check(p2.IF) ? Xe(this) : this.check(p2.FOR) ? Je(this) : this.check(p2.WHILE) ? Ye(this) : this.check(p2.UNTIL) ? et(this) : this.check(p2.CASE) ? tt(this) : this.check(p2.LPAREN) ? nt(this) : this.check(p2.LBRACE) ? rt(this) : this.check(p2.DPAREN_START) ? this.dparenClosesWithSpacedParens() ? this.parseNestedSubshellsFromDparen() : this.parseArithmeticCommand() : this.check(p2.DBRACK_START) ? this.parseConditionalCommand() : this.check(p2.FUNCTION) ? this.parseFunctionDef() : this.check(p2.NAME, p2.WORD) && this.peek(1).type === p2.LPAREN && this.peek(2).type === p2.RPAREN ? this.parseFunctionDef() : nn(this);
      }
      dparenClosesWithSpacedParens() {
        let t6 = 1, r8 = 1;
        for (; r8 < this.tokens.length - this.pos; ) {
          let s9 = this.peek(r8);
          if (s9.type === p2.EOF) return false;
          if (s9.type === p2.DPAREN_START || s9.type === p2.LPAREN) t6++;
          else if (s9.type === p2.DPAREN_END) {
            if (t6 -= 2, t6 <= 0) return false;
          } else if (s9.type === p2.RPAREN && (t6--, t6 === 0 && this.peek(r8 + 1).type === p2.RPAREN)) return true;
          r8++;
        }
        return false;
      }
      parseNestedSubshellsFromDparen() {
        this.advance();
        let t6 = this.parseCompoundList();
        this.expect(p2.RPAREN), this.expect(p2.RPAREN);
        let r8 = this.parseOptionalRedirections(), s9 = w2.subshell(t6, []);
        return w2.subshell([w2.statement([w2.pipeline([s9], false, false, false)])], r8);
      }
      isWord() {
        let t6 = this.current().type;
        return t6 === p2.WORD || t6 === p2.NAME || t6 === p2.NUMBER || t6 === p2.IF || t6 === p2.FOR || t6 === p2.WHILE || t6 === p2.UNTIL || t6 === p2.CASE || t6 === p2.FUNCTION || t6 === p2.ELSE || t6 === p2.ELIF || t6 === p2.FI || t6 === p2.THEN || t6 === p2.DO || t6 === p2.DONE || t6 === p2.ESAC || t6 === p2.IN || t6 === p2.SELECT || t6 === p2.TIME || t6 === p2.COPROC || t6 === p2.BANG;
      }
      parseWord() {
        let t6 = this.advance();
        return this.parseWordFromString(t6.value, t6.quoted, t6.singleQuoted);
      }
      parseWordNoBraceExpansion() {
        let t6 = this.advance();
        return this.parseWordFromString(t6.value, t6.quoted, t6.singleQuoted, false, false, true);
      }
      parseWordForRegex() {
        let t6 = this.advance();
        return this.parseWordFromString(t6.value, t6.quoted, t6.singleQuoted, false, false, true, true);
      }
      parseWordFromString(t6, r8 = false, s9 = false, n23 = false, a7 = false, i10 = false, l8 = false) {
        let o9 = ae(this, t6, r8, s9, n23, a7, false, i10, l8);
        return w2.word(o9);
      }
      parseCommandSubstitution(t6, r8) {
        return un(t6, r8, () => new e(), (s9) => this.error(s9));
      }
      parseBacktickSubstitution(t6, r8, s9 = false) {
        return cn(t6, r8, s9, () => new e(), (n23) => this.error(n23));
      }
      isDollarDparenSubshell(t6, r8) {
        return ln(t6, r8);
      }
      parseArithmeticExpansion(t6, r8) {
        let s9 = r8 + 3, n23 = 1, a7 = 0, i10 = s9;
        for (; i10 < t6.length - 1 && n23 > 0; ) t6[i10] === "$" && t6[i10 + 1] === "(" ? t6[i10 + 2] === "(" ? (n23++, i10 += 3) : (a7++, i10 += 2) : t6[i10] === "(" && t6[i10 + 1] === "(" ? (n23++, i10 += 2) : t6[i10] === ")" && t6[i10 + 1] === ")" ? a7 > 0 ? (a7--, i10++) : (n23--, n23 > 0 && (i10 += 2)) : t6[i10] === "(" ? (a7++, i10++) : (t6[i10] === ")" && a7 > 0 && a7--, i10++);
        let l8 = t6.slice(s9, i10), o9 = this.parseArithmeticExpression(l8);
        return { part: w2.arithmeticExpansion(o9), endIndex: i10 + 2 };
      }
      parseArithmeticCommand() {
        let t6 = this.expect(p2.DPAREN_START), r8 = "", s9 = 1, n23 = 0, a7 = false, i10 = false;
        for (; s9 > 0 && !this.check(p2.EOF); ) {
          if (a7) {
            if (a7 = false, n23 > 0) {
              n23--, r8 += ")";
              continue;
            }
            if (this.check(p2.RPAREN)) {
              s9--, i10 = true, this.advance();
              continue;
            }
            if (this.check(p2.DPAREN_END)) {
              s9--, i10 = true;
              continue;
            }
            r8 += ")";
            continue;
          }
          if (this.check(p2.DPAREN_START)) s9++, r8 += "((", this.advance();
          else if (this.check(p2.DPAREN_END)) n23 >= 2 ? (n23 -= 2, r8 += "))", this.advance()) : n23 === 1 ? (n23--, r8 += ")", a7 = true, this.advance()) : (s9--, i10 = true, s9 > 0 && (r8 += "))"), this.advance());
          else if (this.check(p2.LPAREN)) n23++, r8 += "(", this.advance();
          else if (this.check(p2.RPAREN)) n23 > 0 && n23--, r8 += ")", this.advance();
          else {
            let c15 = this.current().value, u11 = r8.length > 0 ? r8[r8.length - 1] : "";
            r8.length > 0 && !r8.endsWith(" ") && !(c15 === "=" && /[|&^+\-*/%<>]$/.test(r8)) && !(c15 === "<" && u11 === "<") && !(c15 === ">" && u11 === ">") && (r8 += " "), r8 += c15, this.advance();
          }
        }
        i10 || this.expect(p2.DPAREN_END);
        let l8 = this.parseArithmeticExpression(r8.trim()), o9 = this.parseOptionalRedirections();
        return w2.arithmeticCommand(l8, o9, t6.line);
      }
      parseConditionalCommand() {
        let t6 = this.expect(p2.DBRACK_START), r8 = it(this);
        this.expect(p2.DBRACK_END);
        let s9 = this.parseOptionalRedirections();
        return w2.conditionalCommand(r8, s9, t6.line);
      }
      parseFunctionDef() {
        let t6;
        if (this.check(p2.FUNCTION)) {
          if (this.advance(), this.check(p2.NAME) || this.check(p2.WORD)) t6 = this.advance().value;
          else {
            let n23 = this.current();
            throw new Q2("Expected function name", n23.line, n23.column, n23);
          }
          this.check(p2.LPAREN) && (this.advance(), this.expect(p2.RPAREN));
        } else t6 = this.advance().value, t6.includes("$") && this.error(`\`${t6}': not a valid identifier`), this.expect(p2.LPAREN), this.expect(p2.RPAREN);
        this.skipNewlines();
        let r8 = this.parseCompoundCommandBody({ forFunctionBody: true }), s9 = this.parseOptionalRedirections();
        return w2.functionDef(t6, r8, s9);
      }
      parseCompoundCommandBody(t6) {
        let r8 = t6?.forFunctionBody;
        if (this.check(p2.LBRACE)) return rt(this, { skipRedirections: r8 });
        if (this.check(p2.LPAREN)) return nt(this, { skipRedirections: r8 });
        if (this.check(p2.IF)) return Xe(this, { skipRedirections: r8 });
        if (this.check(p2.FOR)) return Je(this, { skipRedirections: r8 });
        if (this.check(p2.WHILE)) return Ye(this, { skipRedirections: r8 });
        if (this.check(p2.UNTIL)) return et(this, { skipRedirections: r8 });
        if (this.check(p2.CASE)) return tt(this, { skipRedirections: r8 });
        this.error("Expected compound command for function body");
      }
      parseCompoundList() {
        let t6 = this.enterDepth(), r8 = [];
        for (this.skipNewlines(); !this.check(p2.EOF, p2.FI, p2.ELSE, p2.ELIF, p2.THEN, p2.DO, p2.DONE, p2.ESAC, p2.RPAREN, p2.RBRACE, p2.DSEMI, p2.SEMI_AND, p2.SEMI_SEMI_AND) && this.isCommandStart(); ) {
          this.checkIterationLimit();
          let s9 = this.pos, n23 = this.parseStatement();
          if (n23 && r8.push(n23), this.skipSeparators(), this.pos === s9 && !n23) break;
        }
        return t6(), r8;
      }
      parseOptionalRedirections() {
        let t6 = [];
        for (; ve(this); ) {
          this.checkIterationLimit();
          let r8 = this.pos;
          if (t6.push(De(this)), this.pos === r8) break;
        }
        return t6;
      }
      parseArithmeticExpression(t6) {
        return M2(this, t6);
      }
    };
    Xr = /* @__PURE__ */ new Map([["alnum", "a-zA-Z0-9"], ["alpha", "a-zA-Z"], ["ascii", "\\x00-\\x7F"], ["blank", " \\t"], ["cntrl", "\\x00-\\x1F\\x7F"], ["digit", "0-9"], ["graph", "!-~"], ["lower", "a-z"], ["print", " -~"], ["punct", "!-/:-@\\[-`{-~"], ["space", " \\t\\n\\r\\f\\v"], ["upper", "A-Z"], ["word", "a-zA-Z0-9_"], ["xdigit", "0-9a-fA-F"]]);
    oe = class {
      fs;
      cwd;
      globignorePatterns = [];
      hasGlobignore = false;
      globstar = false;
      nullglob = false;
      failglob = false;
      dotglob = false;
      extglob = false;
      globskipdots = true;
      ops = { count: 0 };
      maxOps;
      constructor(t6, r8, s9, n23) {
        this.fs = t6, this.cwd = r8, typeof n23 == "boolean" ? (this.globstar = n23, this.maxOps = 1e5) : n23 ? (this.globstar = n23.globstar ?? false, this.nullglob = n23.nullglob ?? false, this.failglob = n23.failglob ?? false, this.dotglob = n23.dotglob ?? false, this.extglob = n23.extglob ?? false, this.globskipdots = n23.globskipdots ?? true, this.maxOps = n23.maxGlobOperations ?? 1e5) : this.maxOps = 1e5;
        let a7 = s9?.get("GLOBIGNORE");
        a7 !== void 0 && a7 !== "" && (this.hasGlobignore = true, this.globignorePatterns = fn(a7));
      }
      checkOpsLimit() {
        if (++this.ops.count > this.maxOps) throw new b2(`Glob operation limit exceeded (${this.maxOps})`, "glob_operations");
      }
      hasNullglob() {
        return this.nullglob;
      }
      hasFailglob() {
        return this.failglob;
      }
      filterGlobignore(t6) {
        return !this.hasGlobignore && !this.globskipdots ? t6 : t6.filter((r8) => {
          let s9 = r8.split("/").pop() || r8;
          if ((this.hasGlobignore || this.globskipdots) && (s9 === "." || s9 === "..")) return false;
          if (this.hasGlobignore) {
            for (let n23 of this.globignorePatterns) if (this.matchGlobignorePattern(r8, n23)) return false;
          }
          return true;
        });
      }
      matchGlobignorePattern(t6, r8) {
        return hn(r8).test(t6);
      }
      isGlobPattern(t6) {
        return !!(t6.includes("*") || t6.includes("?") || /\[.*\]/.test(t6) || this.extglob && /[@*+?!]\(/.test(t6));
      }
      async expandArgs(t6, r8) {
        let s9 = t6.map((i10, l8) => (r8?.[l8] ?? false) || !this.isGlobPattern(i10) ? null : this.expand(i10)), n23 = await Promise.all(s9.map((i10) => i10 || Promise.resolve(null))), a7 = [];
        for (let i10 = 0; i10 < t6.length; i10++) {
          let l8 = n23[i10];
          l8 === null ? a7.push(t6[i10]) : l8.length > 0 ? a7.push(...l8) : a7.push(t6[i10]);
        }
        return a7;
      }
      async expand(t6) {
        let r8;
        if (t6.includes("**") && this.globstar && this.isGlobstarValid(t6)) r8 = await this.expandRecursive(t6);
        else {
          let s9 = t6.replace(/\*\*+/g, "*");
          r8 = await this.expandSimple(s9);
        }
        return this.filterGlobignore(r8);
      }
      isGlobstarValid(t6) {
        let r8 = t6.split("/");
        for (let s9 of r8) if (s9.includes("**") && s9 !== "**") return false;
        return true;
      }
      hasGlobChars(t6) {
        return !!(t6.includes("*") || t6.includes("?") || /\[.*\]/.test(t6) || this.extglob && /[@*+?!]\(/.test(t6));
      }
      async expandSimple(t6) {
        let r8 = t6.startsWith("/"), s9 = t6.split("/").filter((c15) => c15 !== ""), n23 = -1;
        for (let c15 = 0; c15 < s9.length; c15++) if (this.hasGlobChars(s9[c15])) {
          n23 = c15;
          break;
        }
        if (n23 === -1) return [t6];
        let a7, i10;
        if (n23 === 0) r8 ? (a7 = "/", i10 = "/") : (a7 = this.cwd, i10 = "");
        else {
          let c15 = s9.slice(0, n23);
          r8 ? (a7 = `/${c15.join("/")}`, i10 = `/${c15.join("/")}`) : (a7 = this.fs.resolvePath(this.cwd, c15.join("/")), i10 = c15.join("/"));
        }
        let l8 = s9.slice(n23);
        return (await this.expandSegments(a7, i10, l8)).sort();
      }
      async expandSegments(t6, r8, s9) {
        if (this.checkOpsLimit(), s9.length === 0) return [r8];
        let [n23, ...a7] = s9, i10 = [];
        try {
          if (this.fs.readdirWithFileTypes) {
            this.checkOpsLimit();
            let l8 = await this.fs.readdirWithFileTypes(t6), o9 = [], c15 = [...l8], u11 = this.dotglob || this.hasGlobignore;
            if (n23.startsWith(".") || this.dotglob) {
              let h17 = l8.some((m25) => m25.name === "."), d16 = l8.some((m25) => m25.name === "..");
              h17 || c15.push({ name: ".", isFile: false, isDirectory: true, isSymbolicLink: false }), d16 || c15.push({ name: "..", isFile: false, isDirectory: true, isSymbolicLink: false });
            }
            for (let h17 of c15) if (!(h17.name.startsWith(".") && !n23.startsWith(".") && !u11) && this.matchPattern(h17.name, n23)) {
              let d16 = t6 === "/" ? `/${h17.name}` : `${t6}/${h17.name}`, m25;
              r8 === "" ? m25 = h17.name : r8 === "/" ? m25 = `/${h17.name}` : m25 = `${r8}/${h17.name}`, a7.length === 0 ? o9.push(Promise.resolve([m25])) : h17.isDirectory && o9.push(this.expandSegments(d16, m25, a7));
            }
            let f11 = await Promise.all(o9);
            for (let h17 of f11) i10.push(...h17);
          } else {
            this.checkOpsLimit();
            let l8 = await this.fs.readdir(t6), o9 = [], c15 = [...l8], u11 = this.dotglob || this.hasGlobignore;
            (n23.startsWith(".") || this.dotglob) && (l8.includes(".") || c15.push("."), l8.includes("..") || c15.push(".."));
            for (let h17 of c15) if (!(h17.startsWith(".") && !n23.startsWith(".") && !u11) && this.matchPattern(h17, n23)) {
              let d16 = t6 === "/" ? `/${h17}` : `${t6}/${h17}`, m25;
              r8 === "" ? m25 = h17 : r8 === "/" ? m25 = `/${h17}` : m25 = `${r8}/${h17}`, a7.length === 0 ? o9.push(Promise.resolve([m25])) : o9.push((async () => {
                try {
                  if (this.checkOpsLimit(), (await this.fs.stat(d16)).isDirectory) return this.expandSegments(d16, m25, a7);
                } catch (g18) {
                  if (g18 instanceof b2) throw g18;
                }
                return [];
              })());
            }
            let f11 = await Promise.all(o9);
            for (let h17 of f11) i10.push(...h17);
          }
        } catch (l8) {
          if (l8 instanceof b2) throw l8;
        }
        return i10;
      }
      async expandRecursive(t6) {
        let r8 = [], s9 = t6.indexOf("**"), n23 = t6.slice(0, s9).replace(/\/$/, "") || ".", i10 = t6.slice(s9 + 2).replace(/^\//, "");
        return i10.includes("**") && this.isGlobstarValid(i10) ? (await this.walkDirectoryMultiGlobstar(n23, i10, r8), [...new Set(r8)].sort()) : (await this.walkDirectory(n23, i10, r8), r8.sort());
      }
      async walkDirectoryMultiGlobstar(t6, r8, s9) {
        this.checkOpsLimit();
        let n23 = this.fs.resolvePath(this.cwd, t6);
        try {
          this.checkOpsLimit();
          let a7 = this.fs.readdirWithFileTypes ? await this.fs.readdirWithFileTypes(n23) : null;
          if (a7) {
            let i10 = [];
            for (let c15 of a7) {
              let u11 = t6 === "." ? c15.name : `${t6}/${c15.name}`;
              c15.isDirectory && i10.push(u11);
            }
            let l8 = t6 === "." ? r8 : `${t6}/${r8}`, o9 = await this.expandRecursive(l8);
            s9.push(...o9);
            for (let c15 = 0; c15 < i10.length; c15 += 100) {
              let u11 = i10.slice(c15, c15 + 100);
              await Promise.all(u11.map((f11) => this.walkDirectoryMultiGlobstar(f11, r8, s9)));
            }
          } else {
            this.checkOpsLimit();
            let i10 = await this.fs.readdir(n23), l8 = [];
            for (let u11 of i10) {
              let f11 = t6 === "." ? u11 : `${t6}/${u11}`, h17 = this.fs.resolvePath(this.cwd, f11);
              try {
                this.checkOpsLimit(), (await this.fs.stat(h17)).isDirectory && l8.push(f11);
              } catch (d16) {
                if (d16 instanceof b2) throw d16;
              }
            }
            let o9 = t6 === "." ? r8 : `${t6}/${r8}`, c15 = await this.expandRecursive(o9);
            s9.push(...c15);
            for (let u11 = 0; u11 < l8.length; u11 += 100) {
              let f11 = l8.slice(u11, u11 + 100);
              await Promise.all(f11.map((h17) => this.walkDirectoryMultiGlobstar(h17, r8, s9)));
            }
          }
        } catch (a7) {
          if (a7 instanceof b2) throw a7;
        }
      }
      async walkDirectory(t6, r8, s9) {
        this.checkOpsLimit();
        let n23 = this.fs.resolvePath(this.cwd, t6);
        try {
          if (this.fs.readdirWithFileTypes) {
            this.checkOpsLimit();
            let a7 = await this.fs.readdirWithFileTypes(n23), i10 = [], l8 = [];
            for (let o9 of a7) {
              let c15 = t6 === "." ? o9.name : `${t6}/${o9.name}`;
              o9.isDirectory ? l8.push(c15) : r8 && this.matchPattern(o9.name, r8) && i10.push(c15);
            }
            s9.push(...i10);
            for (let o9 = 0; o9 < l8.length; o9 += 100) {
              let c15 = l8.slice(o9, o9 + 100);
              await Promise.all(c15.map((u11) => this.walkDirectory(u11, r8, s9)));
            }
          } else {
            this.checkOpsLimit();
            let a7 = await this.fs.readdir(n23), i10 = [];
            for (let o9 = 0; o9 < a7.length; o9 += 100) {
              let c15 = a7.slice(o9, o9 + 100), u11 = await Promise.all(c15.map(async (f11) => {
                let h17 = t6 === "." ? f11 : `${t6}/${f11}`, d16 = this.fs.resolvePath(this.cwd, h17);
                try {
                  this.checkOpsLimit();
                  let m25 = await this.fs.stat(d16);
                  return { name: f11, path: h17, isDirectory: m25.isDirectory };
                } catch (m25) {
                  if (m25 instanceof b2) throw m25;
                  return null;
                }
              }));
              i10.push(...u11.filter((f11) => f11 !== null));
            }
            for (let o9 of i10) !o9.isDirectory && r8 && this.matchPattern(o9.name, r8) && s9.push(o9.path);
            let l8 = i10.filter((o9) => o9.isDirectory);
            for (let o9 = 0; o9 < l8.length; o9 += 100) {
              let c15 = l8.slice(o9, o9 + 100);
              await Promise.all(c15.map((u11) => this.walkDirectory(u11.path, r8, s9)));
            }
          }
        } catch (a7) {
          if (a7 instanceof b2) throw a7;
        }
      }
      matchPattern(t6, r8) {
        return this.patternToRegex(r8).test(t6);
      }
      patternToRegex(t6) {
        let r8 = this.patternToRegexStr(t6);
        return b1(`^${r8}$`);
      }
      patternToRegexStr(t6) {
        let r8 = "", s9 = false;
        for (let n23 = 0; n23 < t6.length; n23++) {
          if (t6.slice(n23, n23 + 13) === "\0QUOTE_START\0") {
            s9 = true, n23 += 12;
            continue;
          }
          if (t6.slice(n23, n23 + 11) === "\0QUOTE_END\0") {
            s9 = false, n23 += 10;
            continue;
          }
          let a7 = t6[n23];
          if (s9) {
            /[.+^${}()|\\*?[\]]/.test(a7) ? r8 += `\\${a7}` : r8 += a7;
            continue;
          }
          if (this.extglob && (a7 === "@" || a7 === "*" || a7 === "+" || a7 === "?" || a7 === "!") && n23 + 1 < t6.length && t6[n23 + 1] === "(") {
            let i10 = ut(t6, n23 + 1);
            if (i10 !== -1) {
              let l8 = t6.slice(n23 + 2, i10), o9 = ct(l8), c15 = o9.map((f11) => this.patternToRegexStr(f11)), u11 = c15.length > 0 ? c15.join("|") : "(?:)";
              if (a7 === "@") r8 += `(?:${u11})`;
              else if (a7 === "*") r8 += `(?:${u11})*`;
              else if (a7 === "+") r8 += `(?:${u11})+`;
              else if (a7 === "?") r8 += `(?:${u11})?`;
              else if (a7 === "!") if (i10 < t6.length - 1) {
                let h17 = o9.map((m25) => this.computePatternLength(m25));
                if (h17.every((m25) => m25 !== null) && h17.every((m25) => m25 === h17[0]) && h17[0] !== null) {
                  let m25 = h17[0];
                  if (m25 === 0) r8 += "(?:.+)";
                  else {
                    let g18 = [];
                    m25 > 0 && g18.push(`.{0,${m25 - 1}}`), g18.push(`.{${m25 + 1},}`), g18.push(`(?!(?:${u11})).{${m25}}`), r8 += `(?:${g18.join("|")})`;
                  }
                } else r8 += `(?:(?!(?:${u11})).)*?`;
              } else r8 += `(?!(?:${u11})$).*`;
              n23 = i10;
              continue;
            }
          }
          if (a7 === "*") r8 += ".*";
          else if (a7 === "?") r8 += ".";
          else if (a7 === "[") {
            let i10 = n23 + 1, l8 = "[";
            i10 < t6.length && (t6[i10] === "^" || t6[i10] === "!") && (l8 += "^", i10++), i10 < t6.length && t6[i10] === "]" && (l8 += "\\]", i10++);
            let o9 = i10;
            for (; o9 < t6.length; ) {
              if (t6[o9] === "\\" && o9 + 1 < t6.length) {
                o9 += 2;
                continue;
              }
              if (t6[o9] === "[" && o9 + 1 < t6.length && t6[o9 + 1] === ":") {
                let u11 = t6.indexOf(":]", o9 + 2);
                if (u11 !== -1) {
                  o9 = u11 + 2;
                  continue;
                }
              }
              if (t6[o9] === "]") break;
              o9++;
            }
            let c15 = i10;
            for (; i10 < t6.length && t6[i10] !== "]"; ) {
              if (t6[i10] === "[" && i10 + 1 < t6.length && t6[i10 + 1] === ":") {
                let u11 = t6.indexOf(":]", i10 + 2);
                if (u11 !== -1) {
                  let f11 = t6.slice(i10 + 2, u11), h17 = lt(f11);
                  l8 += h17, i10 = u11 + 2;
                  continue;
                }
              }
              if (t6[i10] === "\\" && i10 + 1 < t6.length) {
                l8 += `\\${t6[i10 + 1]}`, i10 += 2;
                continue;
              }
              if (t6[i10] === "-") {
                let u11 = i10 === c15, f11 = i10 + 1 === o9;
                u11 || f11 ? l8 += "\\-" : l8 += "-";
              } else l8 += t6[i10];
              i10++;
            }
            l8 += "]", r8 += l8, n23 = i10;
          } else if (a7 === "\\" && n23 + 1 < t6.length) {
            let i10 = t6[n23 + 1];
            /[.+^${}()|\\*?[\]]/.test(i10) ? r8 += `\\${i10}` : r8 += i10, n23++;
          } else /[.+^${}()|]/.test(a7) ? r8 += `\\${a7}` : r8 += a7;
        }
        return r8;
      }
      computePatternLength(t6) {
        let r8 = 0, s9 = 0, n23 = false;
        for (; s9 < t6.length; ) {
          if (t6.slice(s9, s9 + 13) === "\0QUOTE_START\0") {
            n23 = true, s9 += 13;
            continue;
          }
          if (t6.slice(s9, s9 + 11) === "\0QUOTE_END\0") {
            n23 = false, s9 += 11;
            continue;
          }
          let a7 = t6[s9];
          if (n23) {
            r8 += 1, s9++;
            continue;
          }
          if ((a7 === "@" || a7 === "*" || a7 === "+" || a7 === "?" || a7 === "!") && s9 + 1 < t6.length && t6[s9 + 1] === "(") {
            let i10 = ut(t6, s9 + 1);
            if (i10 !== -1) {
              if (a7 === "@") {
                let l8 = t6.slice(s9 + 2, i10), c15 = ct(l8).map((u11) => this.computePatternLength(u11));
                if (c15.every((u11) => u11 !== null) && c15.every((u11) => u11 === c15[0])) {
                  r8 += c15[0], s9 = i10 + 1;
                  continue;
                }
                return null;
              }
              return null;
            }
          }
          if (a7 === "*") return null;
          if (a7 === "?") {
            r8 += 1, s9++;
            continue;
          }
          if (a7 === "[") {
            let i10 = t6.indexOf("]", s9 + 1);
            if (i10 !== -1) {
              r8 += 1, s9 = i10 + 1;
              continue;
            }
            r8 += 1, s9++;
            continue;
          }
          if (a7 === "\\") {
            r8 += 1, s9 += 2;
            continue;
          }
          r8 += 1, s9++;
        }
        return r8;
      }
    };
    mn = "5.1.0(1)-release";
    vi = "Linux version 5.15.0-generic (just-bash) #1 SMP PREEMPT";
    ss = ` 	
`;
    Oe = 1e4;
    ms = /* @__PURE__ */ new Map([["alnum", "a-zA-Z0-9"], ["alpha", "a-zA-Z"], ["ascii", "\\x00-\\x7F"], ["blank", " \\t"], ["cntrl", "\\x00-\\x1F\\x7F"], ["digit", "0-9"], ["graph", "!-~"], ["lower", "a-z"], ["print", " -~"], ["punct", "!-/:-@\\[-`{-~"], ["space", " \\t\\n\\r\\f\\v"], ["upper", "A-Z"], ["word", "a-zA-Z0-9_"], ["xdigit", "0-9A-Fa-f"]]);
    Nt = 1e5;
  }
});

// stub-node:node:fs
var existsSync, readdirSync, statSync, promises;
var init_node_fs = __esm({
  "stub-node:node:fs"() {
    existsSync = () => false;
    readdirSync = () => [];
    statSync = () => ({});
    promises = {};
  }
});

// stub-node:node:path
var join, dirname, basename, resolve;
var init_node_path = __esm({
  "stub-node:node:path"() {
    join = (...a7) => a7.join("/");
    dirname = (p17) => p17.split("/").slice(0, -1).join("/") || ".";
    basename = (p17) => p17.split("/").pop() || "";
    resolve = (...a7) => a7.join("/");
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-YYAPW4OA.js
function d3(t6) {
  if (!t6) return t6;
  let e7 = t6.replace(/\n\s+at\s.*/g, "");
  return e7 = e7.replace(/(?:\/(?:Users|home|private|var|opt|Library|System|usr|etc|tmp|nix|snap))\b[^\s'",)}\]:]*/g, "<path>"), e7 = e7.replace(/[A-Z]:\\[^\s'",)}\]:]+/g, "<path>"), e7;
}
function y2(t6) {
  if (!t6 || t6 === "/") return "/";
  let e7 = t6.endsWith("/") && t6 !== "/" ? t6.slice(0, -1) : t6;
  e7.startsWith("/") || (e7 = `/${e7}`);
  let n23 = e7.split("/").filter((i10) => i10 && i10 !== "."), s9 = [];
  for (let i10 of n23) i10 === ".." ? s9.pop() : s9.push(i10);
  return `/${s9.join("/")}` || "/";
}
function f2(t6, e7) {
  return t6 === e7 || t6.startsWith(`${e7}/`);
}
function a3(t6, e7) {
  try {
    let n23 = (void 0)(t6);
    return f2(n23, e7) ? n23 : null;
  } catch (n23) {
    if (n23.code === "ENOENT") {
      let s9 = dirname(t6);
      if (s9 === t6) return null;
      let i10 = a3(s9, e7);
      if (i10 === null) return null;
      try {
        if ((void 0)(t6).isSymbolicLink()) {
          let l8 = (void 0)(t6), u11 = (void 0)(l8) ? l8 : resolve(dirname(t6), l8);
          if (a3(u11, e7) === null) return null;
        }
      } catch {
      }
      return join(i10, basename(t6));
    }
    return null;
  }
}
function v3(t6, e7, n23) {
  let s9 = a3(t6, n23);
  if (s9 === null) return null;
  let i10 = resolve(t6), c15 = i10.slice(e7.length), l8 = s9.slice(n23.length);
  if (c15 !== l8) return null;
  try {
    if ((void 0)(i10).isSymbolicLink()) return null;
  } catch {
  }
  return s9;
}
function m3(t6, e7) {
  if (!existsSync(t6)) throw new Error(`${e7} root does not exist`);
  if (!statSync(t6).isDirectory()) throw new Error(`${e7} root is not a directory`);
}
function S(t6, e7) {
  if (t6.includes("\0")) throw new Error(`ENOENT: path contains null byte, ${e7} '${t6}'`);
}
function x4(t6, e7) {
  if (!(void 0)(t6)) return { withinRoot: true, relativePath: t6 };
  let n23;
  try {
    n23 = (void 0)(t6);
  } catch {
    n23 = resolve(t6);
  }
  return f2(n23, e7) ? { withinRoot: true, relativePath: n23.slice(e7.length) || "/" } : { withinRoot: false, safeName: basename(t6) };
}
var init_chunk_YYAPW4OA = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-YYAPW4OA.js"() {
    init_node_fs();
    init_node_path();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-OJDRYQWQ.js
function r(e7) {
  return Object.assign(/* @__PURE__ */ Object.create(null), Object.fromEntries(e7));
}
function n16(e7, t6) {
  return Object.assign(/* @__PURE__ */ Object.create(null), Object.fromEntries(e7), t6);
}
function c3(...e7) {
  return Object.assign(/* @__PURE__ */ Object.create(null), ...e7);
}
var init_chunk_OJDRYQWQ = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-OJDRYQWQ.js"() {
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-44UOCSGV.js
function n17(e7) {
  return e7 instanceof Error ? e7.message : String(e7);
}
var init_chunk_44UOCSGV = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-44UOCSGV.js"() {
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-DXB73IDG.js
var h2, e2, i2, j2, k2, l2, m4, n18, o, p3, g2, q3, r2;
var init_chunk_DXB73IDG = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-DXB73IDG.js"() {
    h2 = Object.create;
    e2 = Object.defineProperty;
    i2 = Object.getOwnPropertyDescriptor;
    j2 = Object.getOwnPropertyNames;
    k2 = Object.getPrototypeOf;
    l2 = Object.prototype.hasOwnProperty;
    m4 = ((a7) => typeof __require < "u" ? __require : typeof Proxy < "u" ? new Proxy(a7, { get: (b25, c15) => (typeof __require < "u" ? __require : b25)[c15] }) : a7)(function(a7) {
      if (typeof __require < "u") return __require.apply(this, arguments);
      throw Error('Dynamic require of "' + a7 + '" is not supported');
    });
    n18 = (a7, b25) => () => (a7 && (b25 = a7(a7 = 0)), b25);
    o = (a7, b25) => () => (b25 || a7((b25 = { exports: {} }).exports, b25), b25.exports);
    p3 = (a7, b25) => {
      for (var c15 in b25) e2(a7, c15, { get: b25[c15], enumerable: true });
    };
    g2 = (a7, b25, c15, f11) => {
      if (b25 && typeof b25 == "object" || typeof b25 == "function") for (let d16 of j2(b25)) !l2.call(a7, d16) && d16 !== c15 && e2(a7, d16, { get: () => b25[d16], enumerable: !(f11 = i2(b25, d16)) || f11.enumerable });
      return a7;
    };
    q3 = (a7, b25, c15) => (c15 = a7 != null ? h2(k2(a7)) : {}, g2(b25 || !a7 || !a7.__esModule ? e2(c15, "default", { value: a7, enumerable: true }) : c15, a7));
    r2 = (a7) => g2(e2({}, "__esModule", { value: true }), a7);
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-GCTKCWKD.js
function n19(r8) {
  let s9 = "", e7 = 0;
  for (; e7 < r8.length; ) if (r8[e7] === "\\") {
    if (e7 + 1 >= r8.length) {
      s9 += "\\";
      break;
    }
    let o9 = r8[e7 + 1];
    switch (o9) {
      case "\\":
        s9 += "\\", e7 += 2;
        break;
      case "n":
        s9 += `
`, e7 += 2;
        break;
      case "t":
        s9 += "	", e7 += 2;
        break;
      case "r":
        s9 += "\r", e7 += 2;
        break;
      case "a":
        s9 += "\x07", e7 += 2;
        break;
      case "b":
        s9 += "\b", e7 += 2;
        break;
      case "f":
        s9 += "\f", e7 += 2;
        break;
      case "v":
        s9 += "\v", e7 += 2;
        break;
      case "e":
      case "E":
        s9 += "\x1B", e7 += 2;
        break;
      case "c":
        return { output: s9, stop: true };
      case "0": {
        let a7 = "", t6 = e7 + 2;
        for (; t6 < r8.length && t6 < e7 + 5 && /[0-7]/.test(r8[t6]); ) a7 += r8[t6], t6++;
        if (a7.length === 0) s9 += "\0";
        else {
          let l8 = parseInt(a7, 8) % 256;
          s9 += String.fromCharCode(l8);
        }
        e7 = t6;
        break;
      }
      case "x": {
        let a7 = "", t6 = e7 + 2;
        for (; t6 < r8.length && t6 < e7 + 4 && /[0-9a-fA-F]/.test(r8[t6]); ) a7 += r8[t6], t6++;
        if (a7.length === 0) s9 += "\\x", e7 += 2;
        else {
          let l8 = parseInt(a7, 16);
          s9 += String.fromCharCode(l8), e7 = t6;
        }
        break;
      }
      case "u": {
        let a7 = "", t6 = e7 + 2;
        for (; t6 < r8.length && t6 < e7 + 6 && /[0-9a-fA-F]/.test(r8[t6]); ) a7 += r8[t6], t6++;
        if (a7.length === 0) s9 += "\\u", e7 += 2;
        else {
          let l8 = parseInt(a7, 16);
          s9 += String.fromCodePoint(l8), e7 = t6;
        }
        break;
      }
      case "U": {
        let a7 = "", t6 = e7 + 2;
        for (; t6 < r8.length && t6 < e7 + 10 && /[0-9a-fA-F]/.test(r8[t6]); ) a7 += r8[t6], t6++;
        if (a7.length === 0) s9 += "\\U", e7 += 2;
        else {
          let l8 = parseInt(a7, 16);
          try {
            s9 += String.fromCodePoint(l8);
          } catch {
            s9 += `\\U${a7}`;
          }
          e7 = t6;
        }
        break;
      }
      default:
        s9 += `\\${o9}`, e7 += 2;
    }
  } else s9 += r8[e7], e7++;
  return { output: s9, stop: false };
}
var c4, f3;
var init_chunk_GCTKCWKD = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-GCTKCWKD.js"() {
    c4 = { name: "echo", async execute(r8, s9) {
      let e7 = false, o9 = s9.xpgEcho ?? false, a7 = 0;
      for (; a7 < r8.length; ) {
        let l8 = r8[a7];
        if (l8 === "-n") e7 = true, a7++;
        else if (l8 === "-e") o9 = true, a7++;
        else if (l8 === "-E") o9 = false, a7++;
        else if (l8 === "-ne" || l8 === "-en") e7 = true, o9 = true, a7++;
        else break;
      }
      let t6 = r8.slice(a7).join(" ");
      if (o9) {
        let l8 = n19(t6);
        if (t6 = l8.output, l8.stop) return { stdout: t6, stderr: "", exitCode: 0 };
      }
      return e7 || (t6 += `
`), { stdout: t6, stderr: "", exitCode: 0 };
    } };
    f3 = { name: "echo", flags: [{ flag: "-n", type: "boolean" }, { flag: "-e", type: "boolean" }, { flag: "-E", type: "boolean" }], stdinType: "none", needsArgs: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/echo-O45JWWI2.js
var echo_O45JWWI2_exports = {};
__export(echo_O45JWWI2_exports, {
  echoCommand: () => c4,
  flagsForFuzzing: () => f3
});
var init_echo_O45JWWI2 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/echo-O45JWWI2.js"() {
    init_chunk_GCTKCWKD();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-7L36YK2X.js
async function y3(t6, n23, s9) {
  let { cmdName: r8, allowStdinMarker: f11 = true, stopOnError: a7 = false, batchSize: u11 = 100 } = s9;
  if (n23.length === 0) return { files: [{ filename: "", content: t6.stdin }], stderr: "", exitCode: 0 };
  let i10 = [], c15 = "", l8 = 0;
  for (let o9 = 0; o9 < n23.length; o9 += u11) {
    let d16 = n23.slice(o9, o9 + u11), m25 = await Promise.all(d16.map(async (e7) => {
      if (f11 && e7 === "-") return { filename: "-", content: t6.stdin, error: null };
      try {
        let h17 = t6.fs.resolvePath(t6.cwd, e7), p17 = await t6.fs.readFile(h17, "binary");
        return { filename: e7, content: p17, error: null };
      } catch {
        return { filename: e7, content: "", error: `${r8}: ${e7}: No such file or directory
` };
      }
    }));
    for (let e7 of m25) if (e7.error) {
      if (c15 += e7.error, l8 = 1, a7) return { files: i10, stderr: c15, exitCode: l8 };
    } else i10.push({ filename: e7.filename, content: e7.content });
  }
  return { files: i10, stderr: c15, exitCode: l8 };
}
async function b3(t6, n23, s9) {
  let r8 = await y3(t6, n23, { ...s9, stopOnError: true });
  return r8.exitCode !== 0 ? { ok: false, error: { stdout: "", stderr: r8.stderr, exitCode: r8.exitCode } } : { ok: true, content: r8.files.map((a7) => a7.content).join("") };
}
var init_chunk_7L36YK2X = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-7L36YK2X.js"() {
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-74CEPOFO.js
function s(t6) {
  let e7 = `${t6.name} - ${t6.summary}

`;
  if (e7 += `Usage: ${t6.usage}
`, t6.description) {
    if (e7 += `
Description:
`, typeof t6.description == "string") for (let n23 of t6.description.split(`
`)) e7 += n23 ? `  ${n23}
` : `
`;
    else if (t6.description.length > 0) for (let n23 of t6.description) e7 += n23 ? `  ${n23}
` : `
`;
  }
  if (t6.options && t6.options.length > 0) {
    e7 += `
Options:
`;
    for (let n23 of t6.options) e7 += `  ${n23}
`;
  }
  if (t6.examples && t6.examples.length > 0) {
    e7 += `
Examples:
`;
    for (let n23 of t6.examples) e7 += `  ${n23}
`;
  }
  if (t6.notes && t6.notes.length > 0) {
    e7 += `
Notes:
`;
    for (let n23 of t6.notes) e7 += `  ${n23}
`;
  }
  return { stdout: e7, stderr: "", exitCode: 0 };
}
function o2(t6) {
  return t6.includes("--help");
}
function r3(t6, e7) {
  return { stdout: "", stderr: e7.startsWith("--") ? `${t6}: unrecognized option '${e7}'
` : `${t6}: invalid option -- '${e7.replace(/^-/, "")}'
`, exitCode: 1 };
}
var init_chunk_74CEPOFO = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-74CEPOFO.js"() {
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-HWKDQ44K.js
function x5(a7, i10, d16) {
  let g18 = /* @__PURE__ */ new Map(), h17 = /* @__PURE__ */ new Map();
  for (let [t6, e7] of Object.entries(d16)) {
    let n23 = { name: t6, type: e7.type };
    e7.short && g18.set(e7.short, n23), e7.long && h17.set(e7.long, n23);
  }
  let s9 = /* @__PURE__ */ Object.create(null);
  for (let [t6, e7] of Object.entries(d16)) e7.default !== void 0 ? s9[t6] = e7.default : e7.type === "boolean" && (s9[t6] = false);
  let b25 = [], k17 = false;
  for (let t6 = 0; t6 < i10.length; t6++) {
    let e7 = i10[t6];
    if (k17 || !e7.startsWith("-") || e7 === "-") {
      b25.push(e7);
      continue;
    }
    if (e7 === "--") {
      k17 = true;
      continue;
    }
    if (e7.startsWith("--")) {
      let n23 = e7.indexOf("="), o9, r8;
      n23 !== -1 ? (o9 = e7.slice(2, n23), r8 = e7.slice(n23 + 1)) : o9 = e7.slice(2);
      let l8 = h17.get(o9);
      if (!l8) return { ok: false, error: r3(a7, e7) };
      let { name: f11, type: u11 } = l8;
      if (u11 === "boolean") s9[f11] = true;
      else {
        if (r8 === void 0) {
          if (t6 + 1 >= i10.length) return { ok: false, error: { stdout: "", stderr: `${a7}: option '--${o9}' requires an argument
`, exitCode: 1 } };
          r8 = i10[++t6];
        }
        s9[f11] = u11 === "number" ? parseInt(r8, 10) : r8;
      }
    } else {
      let n23 = e7.slice(1);
      for (let o9 = 0; o9 < n23.length; o9++) {
        let r8 = n23[o9], l8 = g18.get(r8);
        if (!l8) return { ok: false, error: r3(a7, `-${r8}`) };
        let { name: f11, type: u11 } = l8;
        if (u11 === "boolean") s9[f11] = true;
        else {
          let c15;
          if (o9 + 1 < n23.length) c15 = n23.slice(o9 + 1);
          else if (t6 + 1 < i10.length) c15 = i10[++t6];
          else return { ok: false, error: { stdout: "", stderr: `${a7}: option requires an argument -- '${r8}'
`, exitCode: 1 } };
          s9[f11] = u11 === "number" ? parseInt(c15, 10) : c15;
          break;
        }
      }
    }
  }
  return { ok: true, result: { flags: s9, positional: b25 } };
}
var init_chunk_HWKDQ44K = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-HWKDQ44K.js"() {
    init_chunk_74CEPOFO();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-7DBA735O.js
function g3(t6, o9) {
  let e7 = t6.split(`
`), r8 = t6.endsWith(`
`), a7 = r8 ? e7.slice(0, -1) : e7;
  return { content: a7.map((n23, l8) => `${String(o9 + l8).padStart(6, " ")}	${n23}`).join(`
`) + (r8 ? `
` : ""), nextLineNumber: o9 + a7.length };
}
var f4, b4, N3, F3;
var init_chunk_7DBA735O = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-7DBA735O.js"() {
    init_chunk_7L36YK2X();
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    f4 = { name: "cat", summary: "concatenate files and print on the standard output", usage: "cat [OPTION]... [FILE]...", options: ["-n, --number           number all output lines", "    --help             display this help and exit"] };
    b4 = { number: { short: "n", long: "number", type: "boolean" } };
    N3 = { name: "cat", async execute(t6, o9) {
      if (o2(t6)) return s(f4);
      let e7 = x5("cat", t6, b4);
      if (!e7.ok) return e7.error;
      let r8 = e7.result.flags.number, a7 = e7.result.positional, s9 = await y3(o9, a7, { cmdName: "cat", allowStdinMarker: true, stopOnError: false }), n23 = "", l8 = 1;
      for (let { content: i10 } of s9.files) if (r8) {
        let u11 = g3(i10, l8);
        n23 += u11.content, l8 = u11.nextLineNumber;
      } else n23 += i10;
      return { stdout: n23, stderr: s9.stderr, exitCode: s9.exitCode };
    } };
    F3 = { name: "cat", flags: [{ flag: "-n", type: "boolean" }, { flag: "-A", type: "boolean" }, { flag: "-b", type: "boolean" }, { flag: "-s", type: "boolean" }, { flag: "-v", type: "boolean" }, { flag: "-e", type: "boolean" }, { flag: "-t", type: "boolean" }], stdinType: "text", needsFiles: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/cat-C2OBLGHA.js
var cat_C2OBLGHA_exports = {};
__export(cat_C2OBLGHA_exports, {
  catCommand: () => N3,
  flagsForFuzzing: () => F3
});
var init_cat_C2OBLGHA = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/cat-C2OBLGHA.js"() {
    init_chunk_7DBA735O();
    init_chunk_7L36YK2X();
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-EEXR5ZDP.js
function i3(t6, l8, e7) {
  let c15 = t6;
  e7 >= 0 && c15.length > e7 && (c15 = c15.slice(0, e7));
  let n23 = Math.abs(l8);
  return n23 > c15.length && (l8 < 0 ? c15 = c15.padEnd(n23, " ") : c15 = c15.padStart(n23, " ")), c15;
}
function h3(t6, l8) {
  let e7 = l8, c15 = 0, n23 = -1, a7 = false;
  for (e7 < t6.length && t6[e7] === "-" && (a7 = true, e7++); e7 < t6.length && /\d/.test(t6[e7]); ) c15 = c15 * 10 + parseInt(t6[e7], 10), e7++;
  if (e7 < t6.length && t6[e7] === ".") for (e7++, n23 = 0; e7 < t6.length && /\d/.test(t6[e7]); ) n23 = n23 * 10 + parseInt(t6[e7], 10), e7++;
  return a7 && c15 > 0 && (c15 = -c15), [c15, n23, e7 - l8];
}
function r4(t6) {
  let l8 = "", e7 = 0;
  for (; e7 < t6.length; ) if (t6[e7] === "\\" && e7 + 1 < t6.length) switch (t6[e7 + 1]) {
    case "n":
      l8 += `
`, e7 += 2;
      break;
    case "t":
      l8 += "	", e7 += 2;
      break;
    case "r":
      l8 += "\r", e7 += 2;
      break;
    case "\\":
      l8 += "\\", e7 += 2;
      break;
    case "a":
      l8 += "\x07", e7 += 2;
      break;
    case "b":
      l8 += "\b", e7 += 2;
      break;
    case "f":
      l8 += "\f", e7 += 2;
      break;
    case "v":
      l8 += "\v", e7 += 2;
      break;
    case "e":
    case "E":
      l8 += "\x1B", e7 += 2;
      break;
    case "0":
    case "1":
    case "2":
    case "3":
    case "4":
    case "5":
    case "6":
    case "7": {
      let n23 = "", a7 = e7 + 1;
      for (; a7 < t6.length && a7 < e7 + 4 && /[0-7]/.test(t6[a7]); ) n23 += t6[a7], a7++;
      l8 += String.fromCharCode(parseInt(n23, 8)), e7 = a7;
      break;
    }
    case "x": {
      let n23 = [], a7 = e7;
      for (; a7 + 3 < t6.length && t6[a7] === "\\" && t6[a7 + 1] === "x" && /[0-9a-fA-F]{2}/.test(t6.slice(a7 + 2, a7 + 4)); ) n23.push(parseInt(t6.slice(a7 + 2, a7 + 4), 16)), a7 += 4;
      if (n23.length > 0) {
        try {
          let s9 = new TextDecoder("utf-8", { fatal: true });
          l8 += s9.decode(new Uint8Array(n23));
        } catch {
          for (let s9 of n23) l8 += String.fromCharCode(s9);
        }
        e7 = a7;
      } else l8 += t6[e7], e7++;
      break;
    }
    case "u": {
      let n23 = "", a7 = e7 + 2;
      for (; a7 < t6.length && a7 < e7 + 6 && /[0-9a-fA-F]/.test(t6[a7]); ) n23 += t6[a7], a7++;
      n23 ? (l8 += String.fromCodePoint(parseInt(n23, 16)), e7 = a7) : (l8 += "\\u", e7 += 2);
      break;
    }
    case "U": {
      let n23 = "", a7 = e7 + 2;
      for (; a7 < t6.length && a7 < e7 + 10 && /[0-9a-fA-F]/.test(t6[a7]); ) n23 += t6[a7], a7++;
      n23 ? (l8 += String.fromCodePoint(parseInt(n23, 16)), e7 = a7) : (l8 += "\\U", e7 += 2);
      break;
    }
    default:
      l8 += t6[e7], e7++;
  }
  else l8 += t6[e7], e7++;
  return l8;
}
var init_chunk_EEXR5ZDP = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-EEXR5ZDP.js"() {
  }
});

// ../../node_modules/sprintf-js/src/sprintf.js
var require_sprintf = __commonJS({
  "../../node_modules/sprintf-js/src/sprintf.js"(exports) {
    !function() {
      "use strict";
      var re5 = {
        not_string: /[^s]/,
        not_bool: /[^t]/,
        not_type: /[^T]/,
        not_primitive: /[^v]/,
        number: /[diefg]/,
        numeric_arg: /[bcdiefguxX]/,
        json: /[j]/,
        not_json: /[^j]/,
        text: /^[^\x25]+/,
        modulo: /^\x25{2}/,
        placeholder: /^\x25(?:([1-9]\d*)\$|\(([^)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-gijostTuvxX])/,
        key: /^([a-z_][a-z_\d]*)/i,
        key_access: /^\.([a-z_][a-z_\d]*)/i,
        index_access: /^\[(\d+)\]/,
        sign: /^[+-]/
      };
      function sprintf(key) {
        return sprintf_format(sprintf_parse(key), arguments);
      }
      function vsprintf(fmt, argv) {
        return sprintf.apply(null, [fmt].concat(argv || []));
      }
      function sprintf_format(parse_tree, argv) {
        var cursor = 1, tree_length = parse_tree.length, arg, output = "", i10, k17, ph, pad, pad_character, pad_length, is_positive, sign;
        for (i10 = 0; i10 < tree_length; i10++) {
          if (typeof parse_tree[i10] === "string") {
            output += parse_tree[i10];
          } else if (typeof parse_tree[i10] === "object") {
            ph = parse_tree[i10];
            if (ph.keys) {
              arg = argv[cursor];
              for (k17 = 0; k17 < ph.keys.length; k17++) {
                if (arg == void 0) {
                  throw new Error(sprintf('[sprintf] Cannot access property "%s" of undefined value "%s"', ph.keys[k17], ph.keys[k17 - 1]));
                }
                arg = arg[ph.keys[k17]];
              }
            } else if (ph.param_no) {
              arg = argv[ph.param_no];
            } else {
              arg = argv[cursor++];
            }
            if (re5.not_type.test(ph.type) && re5.not_primitive.test(ph.type) && arg instanceof Function) {
              arg = arg();
            }
            if (re5.numeric_arg.test(ph.type) && (typeof arg !== "number" && isNaN(arg))) {
              throw new TypeError(sprintf("[sprintf] expecting number but found %T", arg));
            }
            if (re5.number.test(ph.type)) {
              is_positive = arg >= 0;
            }
            switch (ph.type) {
              case "b":
                arg = parseInt(arg, 10).toString(2);
                break;
              case "c":
                arg = String.fromCharCode(parseInt(arg, 10));
                break;
              case "d":
              case "i":
                arg = parseInt(arg, 10);
                break;
              case "j":
                arg = JSON.stringify(arg, null, ph.width ? parseInt(ph.width) : 0);
                break;
              case "e":
                arg = ph.precision ? parseFloat(arg).toExponential(ph.precision) : parseFloat(arg).toExponential();
                break;
              case "f":
                arg = ph.precision ? parseFloat(arg).toFixed(ph.precision) : parseFloat(arg);
                break;
              case "g":
                arg = ph.precision ? String(Number(arg.toPrecision(ph.precision))) : parseFloat(arg);
                break;
              case "o":
                arg = (parseInt(arg, 10) >>> 0).toString(8);
                break;
              case "s":
                arg = String(arg);
                arg = ph.precision ? arg.substring(0, ph.precision) : arg;
                break;
              case "t":
                arg = String(!!arg);
                arg = ph.precision ? arg.substring(0, ph.precision) : arg;
                break;
              case "T":
                arg = Object.prototype.toString.call(arg).slice(8, -1).toLowerCase();
                arg = ph.precision ? arg.substring(0, ph.precision) : arg;
                break;
              case "u":
                arg = parseInt(arg, 10) >>> 0;
                break;
              case "v":
                arg = arg.valueOf();
                arg = ph.precision ? arg.substring(0, ph.precision) : arg;
                break;
              case "x":
                arg = (parseInt(arg, 10) >>> 0).toString(16);
                break;
              case "X":
                arg = (parseInt(arg, 10) >>> 0).toString(16).toUpperCase();
                break;
            }
            if (re5.json.test(ph.type)) {
              output += arg;
            } else {
              if (re5.number.test(ph.type) && (!is_positive || ph.sign)) {
                sign = is_positive ? "+" : "-";
                arg = arg.toString().replace(re5.sign, "");
              } else {
                sign = "";
              }
              pad_character = ph.pad_char ? ph.pad_char === "0" ? "0" : ph.pad_char.charAt(1) : " ";
              pad_length = ph.width - (sign + arg).length;
              pad = ph.width ? pad_length > 0 ? pad_character.repeat(pad_length) : "" : "";
              output += ph.align ? sign + arg + pad : pad_character === "0" ? sign + pad + arg : pad + sign + arg;
            }
          }
        }
        return output;
      }
      var sprintf_cache = /* @__PURE__ */ Object.create(null);
      function sprintf_parse(fmt) {
        if (sprintf_cache[fmt]) {
          return sprintf_cache[fmt];
        }
        var _fmt = fmt, match2, parse_tree = [], arg_names = 0;
        while (_fmt) {
          if ((match2 = re5.text.exec(_fmt)) !== null) {
            parse_tree.push(match2[0]);
          } else if ((match2 = re5.modulo.exec(_fmt)) !== null) {
            parse_tree.push("%");
          } else if ((match2 = re5.placeholder.exec(_fmt)) !== null) {
            if (match2[2]) {
              arg_names |= 1;
              var field_list = [], replacement_field = match2[2], field_match = [];
              if ((field_match = re5.key.exec(replacement_field)) !== null) {
                field_list.push(field_match[1]);
                while ((replacement_field = replacement_field.substring(field_match[0].length)) !== "") {
                  if ((field_match = re5.key_access.exec(replacement_field)) !== null) {
                    field_list.push(field_match[1]);
                  } else if ((field_match = re5.index_access.exec(replacement_field)) !== null) {
                    field_list.push(field_match[1]);
                  } else {
                    throw new SyntaxError("[sprintf] failed to parse named argument key");
                  }
                }
              } else {
                throw new SyntaxError("[sprintf] failed to parse named argument key");
              }
              match2[2] = field_list;
            } else {
              arg_names |= 2;
            }
            if (arg_names === 3) {
              throw new Error("[sprintf] mixing positional and named placeholders is not (yet) supported");
            }
            parse_tree.push(
              {
                placeholder: match2[0],
                param_no: match2[1],
                keys: match2[2],
                sign: match2[3],
                pad_char: match2[4],
                align: match2[5],
                width: match2[6],
                precision: match2[7],
                type: match2[8]
              }
            );
          } else {
            throw new SyntaxError("[sprintf] unexpected placeholder");
          }
          _fmt = _fmt.substring(match2[0].length);
        }
        return sprintf_cache[fmt] = parse_tree;
      }
      if (typeof exports !== "undefined") {
        exports["sprintf"] = sprintf;
        exports["vsprintf"] = vsprintf;
      }
      if (typeof window !== "undefined") {
        window["sprintf"] = sprintf;
        window["vsprintf"] = vsprintf;
        if (typeof define === "function" && define["amd"]) {
          define(function() {
            return {
              "sprintf": sprintf,
              "vsprintf": vsprintf
            };
          });
        }
      }
    }();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-L4KW73FJ.js
function z3(t6, s9, r8) {
  let e7 = new Date(s9 * 1e3), a7 = "", n23 = 0;
  for (; n23 < t6.length; ) if (t6[n23] === "%" && n23 + 1 < t6.length) {
    let o9 = t6[n23 + 1], i10 = H2(e7, o9, r8);
    i10 !== null ? (a7 += i10, n23 += 2) : (a7 += t6[n23], n23++);
  } else a7 += t6[n23], n23++;
  return a7;
}
function _2(t6, s9) {
  let r8 = { year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", weekday: "short", hour12: false, timeZone: s9 };
  try {
    let a7 = new Intl.DateTimeFormat("en-US", r8).formatToParts(t6), n23 = (u11) => a7.find((c15) => c15.type === u11)?.value ?? "", o9 = /* @__PURE__ */ new Map([["Sun", 0], ["Mon", 1], ["Tue", 2], ["Wed", 3], ["Thu", 4], ["Fri", 5], ["Sat", 6]]), i10 = n23("weekday");
    return { year: Number.parseInt(n23("year"), 10) || t6.getFullYear(), month: Number.parseInt(n23("month"), 10) || t6.getMonth() + 1, day: Number.parseInt(n23("day"), 10) || t6.getDate(), hour: Number.parseInt(n23("hour"), 10) || t6.getHours(), minute: Number.parseInt(n23("minute"), 10) || t6.getMinutes(), second: Number.parseInt(n23("second"), 10) || t6.getSeconds(), weekday: o9.get(i10) ?? t6.getDay() };
  } catch {
    return { year: t6.getFullYear(), month: t6.getMonth() + 1, day: t6.getDate(), hour: t6.getHours(), minute: t6.getMinutes(), second: t6.getSeconds(), weekday: t6.getDay() };
  }
}
function H2(t6, s9, r8) {
  let e7 = _2(t6, r8), a7 = (u11, c15 = 2) => String(u11).padStart(c15, "0"), n23 = O2(e7.year, e7.month, e7.day), o9 = W2(e7.year, e7.month, e7.day, e7.weekday, 0), i10 = W2(e7.year, e7.month, e7.day, e7.weekday, 1);
  switch (s9) {
    case "a":
      return ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"][e7.weekday];
    case "A":
      return ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"][e7.weekday];
    case "b":
    case "h":
      return ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"][e7.month - 1];
    case "B":
      return ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"][e7.month - 1];
    case "c":
      return `${["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"][e7.weekday]} ${["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"][e7.month - 1]} ${String(e7.day).padStart(2, " ")} ${a7(e7.hour)}:${a7(e7.minute)}:${a7(e7.second)} ${e7.year}`;
    case "C":
      return a7(Math.floor(e7.year / 100));
    case "d":
      return a7(e7.day);
    case "D":
      return `${a7(e7.month)}/${a7(e7.day)}/${a7(e7.year % 100)}`;
    case "e":
      return String(e7.day).padStart(2, " ");
    case "F":
      return `${e7.year}-${a7(e7.month)}-${a7(e7.day)}`;
    case "g":
      return a7(P3(e7.year, e7.month, e7.day) % 100);
    case "G":
      return String(P3(e7.year, e7.month, e7.day));
    case "H":
      return a7(e7.hour);
    case "I":
      return a7(e7.hour % 12 || 12);
    case "j":
      return String(n23).padStart(3, "0");
    case "k":
      return String(e7.hour).padStart(2, " ");
    case "l":
      return String(e7.hour % 12 || 12).padStart(2, " ");
    case "m":
      return a7(e7.month);
    case "M":
      return a7(e7.minute);
    case "n":
      return `
`;
    case "N":
      return "000000000";
    case "p":
      return e7.hour < 12 ? "AM" : "PM";
    case "P":
      return e7.hour < 12 ? "am" : "pm";
    case "r":
      return `${a7(e7.hour % 12 || 12)}:${a7(e7.minute)}:${a7(e7.second)} ${e7.hour < 12 ? "AM" : "PM"}`;
    case "R":
      return `${a7(e7.hour)}:${a7(e7.minute)}`;
    case "s":
      return String(Math.floor(t6.getTime() / 1e3));
    case "S":
      return a7(e7.second);
    case "t":
      return "	";
    case "T":
      return `${a7(e7.hour)}:${a7(e7.minute)}:${a7(e7.second)}`;
    case "u":
      return String(e7.weekday === 0 ? 7 : e7.weekday);
    case "U":
      return a7(o9);
    case "V":
      return a7(R2(e7.year, e7.month, e7.day));
    case "w":
      return String(e7.weekday);
    case "W":
      return a7(i10);
    case "x":
      return `${a7(e7.month)}/${a7(e7.day)}/${a7(e7.year % 100)}`;
    case "X":
      return `${a7(e7.hour)}:${a7(e7.minute)}:${a7(e7.second)}`;
    case "y":
      return a7(e7.year % 100);
    case "Y":
      return String(e7.year);
    case "z":
      return G(t6, r8);
    case "Z":
      return L3(t6, r8);
    case "%":
      return "%";
    default:
      return null;
  }
}
function G(t6, s9) {
  if (!s9) {
    let o9 = -t6.getTimezoneOffset(), i10 = o9 >= 0 ? "+" : "-", u11 = Math.floor(Math.abs(o9) / 60), c15 = Math.abs(o9) % 60;
    return `${i10}${String(u11).padStart(2, "0")}${String(c15).padStart(2, "0")}`;
  }
  try {
    let u11 = new Intl.DateTimeFormat("en-US", { timeZone: s9, timeZoneName: "longOffset" }).formatToParts(t6).find((c15) => c15.type === "timeZoneName");
    if (u11) {
      let c15 = u11.value.match(/GMT([+-])(\d{2}):(\d{2})/);
      if (c15) return `${c15[1]}${c15[2]}${c15[3]}`;
      if (u11.value === "GMT" || u11.value === "UTC") return "+0000";
    }
  } catch {
  }
  let r8 = -t6.getTimezoneOffset(), e7 = r8 >= 0 ? "+" : "-", a7 = Math.floor(Math.abs(r8) / 60), n23 = Math.abs(r8) % 60;
  return `${e7}${String(a7).padStart(2, "0")}${String(n23).padStart(2, "0")}`;
}
function L3(t6, s9) {
  try {
    return new Intl.DateTimeFormat("en-US", { timeZone: s9, timeZoneName: "short" }).formatToParts(t6).find((n23) => n23.type === "timeZoneName")?.value ?? "UTC";
  } catch {
    return "UTC";
  }
}
function O2(t6, s9, r8) {
  let e7 = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  (t6 % 4 === 0 && t6 % 100 !== 0 || t6 % 400 === 0) && (e7[1] = 29);
  let n23 = r8;
  for (let o9 = 0; o9 < s9 - 1; o9++) n23 += e7[o9];
  return n23;
}
function W2(t6, s9, r8, e7, a7) {
  let n23 = O2(t6, s9, r8), u11 = (new Date(t6, 0, 1).getDay() - a7 + 7) % 7, c15 = (e7 - a7 + 7) % 7, l8 = n23 - 1 + u11;
  return Math.floor((l8 - c15 + 7) / 7);
}
function R2(t6, s9, r8) {
  let e7 = new Date(t6, s9 - 1, r8, 12, 0, 0);
  e7.setDate(e7.getDate() + 3 - (e7.getDay() + 6) % 7);
  let a7 = new Date(e7.getFullYear(), 0, 4);
  a7.setDate(a7.getDate() + 3 - (a7.getDay() + 6) % 7);
  let n23 = e7.getTime() - a7.getTime();
  return 1 + Math.round(n23 / (10080 * 60 * 1e3));
}
function P3(t6, s9, r8) {
  let e7 = new Date(t6, s9 - 1, r8, 12, 0, 0);
  return e7.setDate(e7.getDate() + 3 - (e7.getDay() + 6) % 7), e7.getFullYear();
}
function V3(t6) {
  let s9 = "", r8 = 0;
  for (; r8 < t6.length; ) {
    let e7 = t6[r8];
    if (e7 < 128) {
      s9 += String.fromCharCode(e7), r8++;
      continue;
    }
    if ((e7 & 224) === 192) {
      if (r8 + 1 < t6.length && (t6[r8 + 1] & 192) === 128 && e7 >= 194) {
        let a7 = (e7 & 31) << 6 | t6[r8 + 1] & 63;
        s9 += String.fromCharCode(a7), r8 += 2;
        continue;
      }
      s9 += String.fromCharCode(e7), r8++;
      continue;
    }
    if ((e7 & 240) === 224) {
      if (r8 + 2 < t6.length && (t6[r8 + 1] & 192) === 128 && (t6[r8 + 2] & 192) === 128) {
        if (e7 === 224 && t6[r8 + 1] < 160) {
          s9 += String.fromCharCode(e7), r8++;
          continue;
        }
        let a7 = (e7 & 15) << 12 | (t6[r8 + 1] & 63) << 6 | t6[r8 + 2] & 63;
        if (a7 >= 55296 && a7 <= 57343) {
          s9 += String.fromCharCode(e7), r8++;
          continue;
        }
        s9 += String.fromCharCode(a7), r8 += 3;
        continue;
      }
      s9 += String.fromCharCode(e7), r8++;
      continue;
    }
    if ((e7 & 248) === 240 && e7 <= 244) {
      if (r8 + 3 < t6.length && (t6[r8 + 1] & 192) === 128 && (t6[r8 + 2] & 192) === 128 && (t6[r8 + 3] & 192) === 128) {
        if (e7 === 240 && t6[r8 + 1] < 144) {
          s9 += String.fromCharCode(e7), r8++;
          continue;
        }
        let a7 = (e7 & 7) << 18 | (t6[r8 + 1] & 63) << 12 | (t6[r8 + 2] & 63) << 6 | t6[r8 + 3] & 63;
        if (a7 > 1114111) {
          s9 += String.fromCharCode(e7), r8++;
          continue;
        }
        s9 += String.fromCodePoint(a7), r8 += 4;
        continue;
      }
      s9 += String.fromCharCode(e7), r8++;
      continue;
    }
    s9 += String.fromCharCode(e7), r8++;
  }
  return s9;
}
function q4(t6, s9, r8, e7) {
  let a7 = "", n23 = 0, o9 = 0, i10 = false, u11 = "";
  for (; n23 < t6.length; ) if (t6[n23] === "%" && n23 + 1 < t6.length) {
    let c15 = n23;
    if (n23++, t6[n23] === "%") {
      a7 += "%", n23++;
      continue;
    }
    let l8 = t6.slice(c15).match(/^%(-?\d*)(?:\.(\d+))?\(([^)]*)\)T/);
    if (l8) {
      let g18 = l8[1] ? parseInt(l8[1], 10) : 0, b25 = l8[2] ? parseInt(l8[2], 10) : -1, J15 = l8[3], Y11 = l8[0], M15 = s9[r8 + o9] || "";
      o9++;
      let C19;
      M15 === "" || M15 === "-1" || M15 === "-2" ? C19 = Math.floor(Date.now() / 1e3) : C19 = parseInt(M15, 10) || 0;
      let h17 = z3(J15, C19, e7);
      if (b25 >= 0 && h17.length > b25 && (h17 = h17.slice(0, b25)), g18 !== 0) {
        let k17 = Math.abs(g18);
        h17.length < k17 && (g18 < 0 ? h17 = h17.padEnd(k17, " ") : h17 = h17.padStart(k17, " "));
      }
      a7 += h17, n23 = c15 + Y11.length;
      continue;
    }
    for (; n23 < t6.length && "+-0 #'".includes(t6[n23]); ) n23++;
    let y18 = false;
    if (t6[n23] === "*") y18 = true, n23++;
    else for (; n23 < t6.length && /\d/.test(t6[n23]); ) n23++;
    let p17 = false;
    if (t6[n23] === ".") if (n23++, t6[n23] === "*") p17 = true, n23++;
    else for (; n23 < t6.length && /\d/.test(t6[n23]); ) n23++;
    n23 < t6.length && "hlL".includes(t6[n23]) && n23++;
    let m25 = t6[n23] || "";
    n23++;
    let f11 = t6.slice(c15, n23);
    if (y18) {
      let g18 = parseInt(s9[r8 + o9] || "0", 10);
      o9++, f11 = f11.replace("*", String(g18));
    }
    if (p17) {
      let g18 = parseInt(s9[r8 + o9] || "0", 10);
      o9++, f11 = f11.replace(".*", `.${g18}`);
    }
    let x23 = s9[r8 + o9] || "";
    o9++;
    let { value: $18, parseError: j12, parseErrMsg: I18, stopped: U14 } = Q3(f11, m25, x23);
    if (a7 += $18, j12 && (i10 = true, I18 && (u11 = I18)), U14) return { result: a7, argsConsumed: o9, error: i10, errMsg: u11, stopped: true };
  } else a7 += t6[n23], n23++;
  return { result: a7, argsConsumed: o9, error: i10, errMsg: u11, stopped: false };
}
function Q3(t6, s9, r8) {
  let e7 = false, a7 = "";
  switch (s9) {
    case "d":
    case "i": {
      let n23 = v4(r8);
      return e7 = d4, e7 && (a7 = `printf: ${r8}: invalid number
`), { value: Z3(t6, n23), parseError: e7, parseErrMsg: a7 };
    }
    case "o": {
      let n23 = v4(r8);
      return e7 = d4, e7 && (a7 = `printf: ${r8}: invalid number
`), { value: B2(t6, n23), parseError: e7, parseErrMsg: a7 };
    }
    case "u": {
      let n23 = v4(r8);
      e7 = d4, e7 && (a7 = `printf: ${r8}: invalid number
`);
      let o9 = n23 < 0 ? n23 >>> 0 : n23;
      return { value: Z3(t6.replace("u", "d"), o9), parseError: e7, parseErrMsg: a7 };
    }
    case "x":
    case "X": {
      let n23 = v4(r8);
      return e7 = d4, e7 && (a7 = `printf: ${r8}: invalid number
`), { value: K2(t6, n23), parseError: e7, parseErrMsg: a7 };
    }
    case "e":
    case "E":
    case "f":
    case "F":
    case "g":
    case "G": {
      let n23 = parseFloat(r8) || 0;
      return { value: ne2(t6, s9, n23), parseError: false, parseErrMsg: "" };
    }
    case "c": {
      if (r8 === "") return { value: "", parseError: false, parseErrMsg: "" };
      let i10 = new TextEncoder().encode(r8)[0];
      return { value: String.fromCharCode(i10), parseError: false, parseErrMsg: "" };
    }
    case "s":
      return { value: te2(t6, r8), parseError: false, parseErrMsg: "" };
    case "q":
      return { value: re(t6, r8), parseError: false, parseErrMsg: "" };
    case "b": {
      let n23 = ae2(r8);
      return { value: n23.value, parseError: false, parseErrMsg: "", stopped: n23.stopped };
    }
    default:
      try {
        return { value: (0, import_sprintf_js.sprintf)(t6, r8), parseError: false, parseErrMsg: "" };
      } catch {
        return { value: "", parseError: true, parseErrMsg: `printf: [sprintf] unexpected placeholder
` };
      }
  }
}
function v4(t6) {
  d4 = false;
  let s9 = t6.trimStart(), r8 = s9 !== s9.trimEnd();
  if (t6 = s9.trimEnd(), t6.startsWith("'") && t6.length >= 2 || t6.startsWith('"') && t6.length >= 2) return t6.charCodeAt(1);
  if (t6.startsWith("\\'") && t6.length >= 3 || t6.startsWith('\\"') && t6.length >= 3) return t6.charCodeAt(2);
  if (t6.startsWith("+") && (t6 = t6.slice(1)), t6.startsWith("0x") || t6.startsWith("0X")) {
    let e7 = parseInt(t6, 16);
    return Number.isNaN(e7) ? (d4 = true, 0) : (r8 && (d4 = true), e7);
  }
  if (t6.startsWith("0") && t6.length > 1 && /^-?0[0-7]+$/.test(t6)) return r8 && (d4 = true), parseInt(t6, 8) || 0;
  if (/^\d+#/.test(t6)) {
    d4 = true;
    let e7 = t6.match(/^(\d+)#/);
    return e7 ? parseInt(e7[1], 10) : 0;
  }
  if (t6 !== "" && !/^-?\d+$/.test(t6)) {
    d4 = true;
    let e7 = parseInt(t6, 10);
    return Number.isNaN(e7) ? 0 : e7;
  }
  return r8 && (d4 = true), parseInt(t6, 10) || 0;
}
function Z3(t6, s9) {
  let r8 = t6.match(/^%([- +#0']*)(\d*)(\.(\d*))?[diu]$/);
  if (!r8) return (0, import_sprintf_js.sprintf)(t6.replace(/\.\d*/, ""), s9);
  let e7 = r8[1] || "", a7 = r8[2] ? parseInt(r8[2], 10) : 0, n23 = r8[3] !== void 0 ? r8[4] ? parseInt(r8[4], 10) : 0 : -1, o9 = s9 < 0, i10 = Math.abs(s9), u11 = String(i10);
  n23 >= 0 && (u11 = u11.padStart(n23, "0"));
  let c15 = "";
  o9 ? c15 = "-" : e7.includes("+") ? c15 = "+" : e7.includes(" ") && (c15 = " ");
  let l8 = c15 + u11;
  return a7 > l8.length && (e7.includes("-") ? l8 = l8.padEnd(a7, " ") : e7.includes("0") && n23 < 0 ? l8 = c15 + u11.padStart(a7 - c15.length, "0") : l8 = l8.padStart(a7, " ")), l8;
}
function B2(t6, s9) {
  let r8 = t6.match(/^%([- +#0']*)(\d*)(\.(\d*))?o$/);
  if (!r8) return (0, import_sprintf_js.sprintf)(t6, s9);
  let e7 = r8[1] || "", a7 = r8[2] ? parseInt(r8[2], 10) : 0, n23 = r8[3] !== void 0 ? r8[4] ? parseInt(r8[4], 10) : 0 : -1, o9 = Math.abs(s9).toString(8);
  n23 >= 0 && (o9 = o9.padStart(n23, "0")), e7.includes("#") && !o9.startsWith("0") && (o9 = `0${o9}`);
  let i10 = o9;
  return a7 > i10.length && (e7.includes("-") ? i10 = i10.padEnd(a7, " ") : e7.includes("0") && n23 < 0 ? i10 = i10.padStart(a7, "0") : i10 = i10.padStart(a7, " ")), i10;
}
function K2(t6, s9) {
  let r8 = t6.includes("X"), e7 = t6.match(/^%([- +#0']*)(\d*)(\.(\d*))?[xX]$/);
  if (!e7) return (0, import_sprintf_js.sprintf)(t6, s9);
  let a7 = e7[1] || "", n23 = e7[2] ? parseInt(e7[2], 10) : 0, o9 = e7[3] !== void 0 ? e7[4] ? parseInt(e7[4], 10) : 0 : -1, i10 = Math.abs(s9).toString(16);
  r8 && (i10 = i10.toUpperCase()), o9 >= 0 && (i10 = i10.padStart(o9, "0"));
  let u11 = "";
  a7.includes("#") && s9 !== 0 && (u11 = r8 ? "0X" : "0x");
  let c15 = u11 + i10;
  return n23 > c15.length && (a7.includes("-") ? c15 = c15.padEnd(n23, " ") : a7.includes("0") && o9 < 0 ? c15 = u11 + i10.padStart(n23 - u11.length, "0") : c15 = c15.padStart(n23, " ")), c15;
}
function ee(t6) {
  if (t6 === "") return "''";
  if (/^[a-zA-Z0-9_./-]+$/.test(t6)) return t6;
  if (/[\x00-\x1f\x7f-\xff]/.test(t6)) {
    let e7 = "$'";
    for (let a7 of t6) {
      let n23 = a7.charCodeAt(0);
      a7 === "'" ? e7 += "\\'" : a7 === "\\" ? e7 += "\\\\" : a7 === `
` ? e7 += "\\n" : a7 === "	" ? e7 += "\\t" : a7 === "\r" ? e7 += "\\r" : a7 === "\x07" ? e7 += "\\a" : a7 === "\b" ? e7 += "\\b" : a7 === "\f" ? e7 += "\\f" : a7 === "\v" ? e7 += "\\v" : a7 === "\x1B" ? e7 += "\\E" : n23 < 32 || n23 >= 127 && n23 <= 255 ? e7 += `\\${n23.toString(8).padStart(3, "0")}` : a7 === '"' ? e7 += '\\"' : e7 += a7;
    }
    return e7 += "'", e7;
  }
  let r8 = "";
  for (let e7 of t6) " 	|&;<>()$`\\\"'*?[#~=%!{}".includes(e7) ? r8 += `\\${e7}` : r8 += e7;
  return r8;
}
function te2(t6, s9) {
  let r8 = t6.match(/^%(-?)(\d*)(\.(\d*))?s$/);
  if (!r8) return (0, import_sprintf_js.sprintf)(t6.replace(/0+(?=\d)/, ""), s9);
  let e7 = r8[1] === "-", a7 = r8[2] ? parseInt(r8[2], 10) : 0, n23 = r8[3] !== void 0 ? r8[4] ? parseInt(r8[4], 10) : 0 : -1, o9 = e7 ? -a7 : a7;
  return i3(s9, o9, n23);
}
function re(t6, s9) {
  let r8 = ee(s9), e7 = t6.match(/^%(-?)(\d*)q$/);
  if (!e7) return r8;
  let a7 = e7[1] === "-", n23 = e7[2] ? parseInt(e7[2], 10) : 0, o9 = r8;
  return n23 > o9.length && (a7 ? o9 = o9.padEnd(n23, " ") : o9 = o9.padStart(n23, " ")), o9;
}
function ne2(t6, s9, r8) {
  let e7 = t6.match(/^%([- +#0']*)(\d*)(\.(\d*))?[eEfFgG]$/);
  if (!e7) return (0, import_sprintf_js.sprintf)(t6, r8);
  let a7 = e7[1] || "", n23 = e7[2] ? parseInt(e7[2], 10) : 0, o9 = e7[3] !== void 0 ? e7[4] ? parseInt(e7[4], 10) : 0 : 6, i10, u11 = s9.toLowerCase();
  if (u11 === "e" ? (i10 = r8.toExponential(o9), i10 = i10.replace(/e([+-])(\d)$/, "e$10$2"), s9 === "E" && (i10 = i10.toUpperCase())) : u11 === "f" ? (i10 = r8.toFixed(o9), a7.includes("#") && o9 === 0 && !i10.includes(".") && (i10 += ".")) : u11 === "g" ? (i10 = r8.toPrecision(o9 || 1), a7.includes("#") || (i10 = i10.replace(/\.?0+$/, ""), i10 = i10.replace(/\.?0+e/, "e")), i10 = i10.replace(/e([+-])(\d)$/, "e$10$2"), s9 === "G" && (i10 = i10.toUpperCase())) : i10 = r8.toString(), r8 >= 0 && (a7.includes("+") ? i10 = `+${i10}` : a7.includes(" ") && (i10 = ` ${i10}`)), n23 > i10.length) if (a7.includes("-")) i10 = i10.padEnd(n23, " ");
  else if (a7.includes("0")) {
    let c15 = i10.match(/^[+ -]/)?.[0] || "", l8 = c15 ? i10.slice(1) : i10;
    i10 = c15 + l8.padStart(n23 - c15.length, "0");
  } else i10 = i10.padStart(n23, " ");
  return i10;
}
function ae2(t6) {
  let s9 = "", r8 = 0;
  for (; r8 < t6.length; ) if (t6[r8] === "\\" && r8 + 1 < t6.length) switch (t6[r8 + 1]) {
    case "n":
      s9 += `
`, r8 += 2;
      break;
    case "t":
      s9 += "	", r8 += 2;
      break;
    case "r":
      s9 += "\r", r8 += 2;
      break;
    case "\\":
      s9 += "\\", r8 += 2;
      break;
    case "a":
      s9 += "\x07", r8 += 2;
      break;
    case "b":
      s9 += "\b", r8 += 2;
      break;
    case "f":
      s9 += "\f", r8 += 2;
      break;
    case "v":
      s9 += "\v", r8 += 2;
      break;
    case "c":
      return { value: s9, stopped: true };
    case "x": {
      let a7 = [], n23 = r8;
      for (; n23 + 1 < t6.length && t6[n23] === "\\" && t6[n23 + 1] === "x"; ) {
        let o9 = "", i10 = n23 + 2;
        for (; i10 < t6.length && i10 < n23 + 4 && /[0-9a-fA-F]/.test(t6[i10]); ) o9 += t6[i10], i10++;
        if (o9) a7.push(parseInt(o9, 16)), n23 = i10;
        else break;
      }
      a7.length > 0 ? (s9 += V3(a7), r8 = n23) : (s9 += "\\x", r8 += 2);
      break;
    }
    case "u": {
      let a7 = "", n23 = r8 + 2;
      for (; n23 < t6.length && n23 < r8 + 6 && /[0-9a-fA-F]/.test(t6[n23]); ) a7 += t6[n23], n23++;
      a7 ? (s9 += String.fromCodePoint(parseInt(a7, 16)), r8 = n23) : (s9 += "\\u", r8 += 2);
      break;
    }
    case "0": {
      let a7 = "", n23 = r8 + 2;
      for (; n23 < t6.length && n23 < r8 + 5 && /[0-7]/.test(t6[n23]); ) a7 += t6[n23], n23++;
      a7 ? s9 += String.fromCharCode(parseInt(a7, 8)) : s9 += "\0", r8 = n23;
      break;
    }
    case "1":
    case "2":
    case "3":
    case "4":
    case "5":
    case "6":
    case "7": {
      let a7 = "", n23 = r8 + 1;
      for (; n23 < t6.length && n23 < r8 + 4 && /[0-7]/.test(t6[n23]); ) a7 += t6[n23], n23++;
      s9 += String.fromCharCode(parseInt(a7, 8)), r8 = n23;
      break;
    }
    default:
      s9 += t6[r8], r8++;
  }
  else s9 += t6[r8], r8++;
  return { value: s9, stopped: false };
}
var import_sprintf_js, X3, de2, d4, he2;
var init_chunk_L4KW73FJ = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-L4KW73FJ.js"() {
    init_chunk_EEXR5ZDP();
    init_chunk_PSW6BMXW();
    init_chunk_44UOCSGV();
    init_chunk_74CEPOFO();
    import_sprintf_js = __toESM(require_sprintf(), 1);
    X3 = { name: "printf", summary: "format and print data", usage: "printf [-v var] FORMAT [ARGUMENT...]", options: ["    -v var     assign the output to shell variable VAR rather than display it", "    --help     display this help and exit"], notes: ["FORMAT controls the output like in C printf.", "Escape sequences: \\n (newline), \\t (tab), \\\\ (backslash)", "Format specifiers: %s (string), %d (integer), %f (float), %x (hex), %o (octal), %% (literal %)", "Width and precision: %10s (width 10), %.2f (2 decimal places), %010d (zero-padded)", "Flags: %- (left-justify), %+ (show sign), %0 (zero-pad)"] };
    de2 = { name: "printf", async execute(t6, s9) {
      if (o2(t6)) return s(X3);
      if (t6.length === 0) return { stdout: "", stderr: `printf: usage: printf format [arguments]
`, exitCode: 2 };
      let r8 = null, e7 = 0;
      for (; e7 < t6.length; ) {
        let o9 = t6[e7];
        if (o9 === "--") {
          e7++;
          break;
        }
        if (o9 === "-v") {
          if (e7 + 1 >= t6.length) return { stdout: "", stderr: `printf: -v: option requires an argument
`, exitCode: 1 };
          if (r8 = t6[e7 + 1], !/^[a-zA-Z_][a-zA-Z0-9_]*(\[[^\]]+\])?$/.test(r8)) return { stdout: "", stderr: `printf: \`${r8}': not a valid identifier
`, exitCode: 2 };
          e7 += 2;
        } else {
          if (o9.startsWith("-") && o9 !== "-") break;
          break;
        }
      }
      if (e7 >= t6.length) return { stdout: "", stderr: `printf: usage: printf format [arguments]
`, exitCode: 1 };
      let a7 = t6[e7], n23 = t6.slice(e7 + 1);
      try {
        let o9 = r4(a7), i10 = "", u11 = 0, c15 = false, l8 = "", y18 = s9.env.get("TZ"), p17 = s9.limits?.maxStringLength;
        do {
          let { result: m25, argsConsumed: w19, error: f11, errMsg: x23, stopped: $18 } = q4(o9, n23, u11, y18);
          if (i10 += m25, p17 !== void 0 && p17 > 0 && i10.length > p17) throw new b2(`printf: output size limit exceeded (${p17} bytes)`, "string_length");
          if (u11 += w19, f11 && (c15 = true, x23 && (l8 = x23)), $18) break;
        } while (u11 < n23.length && u11 > 0);
        if (u11 === 0 && n23.length > 0, r8) {
          let m25 = r8.match(/^([a-zA-Z_][a-zA-Z0-9_]*)\[(['"]?)(.+?)\2\]$/);
          if (m25) {
            let w19 = m25[1], f11 = m25[3];
            f11 = f11.replace(/\$([a-zA-Z_][a-zA-Z0-9_]*)/g, (x23, $18) => s9.env.get($18) ?? ""), s9.env.set(`${w19}_${f11}`, i10);
          } else s9.env.set(r8, i10);
          return { stdout: "", stderr: l8, exitCode: c15 ? 1 : 0 };
        }
        return { stdout: i10, stderr: l8, exitCode: c15 ? 1 : 0 };
      } catch (o9) {
        if (o9 instanceof b2) throw o9;
        return { stdout: "", stderr: `printf: ${n17(o9)}
`, exitCode: 1 };
      }
    } };
    d4 = false;
    he2 = { name: "printf", flags: [{ flag: "-v", type: "value", valueHint: "string" }], stdinType: "none", needsArgs: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/printf-KGN6BDCY.js
var printf_KGN6BDCY_exports = {};
__export(printf_KGN6BDCY_exports, {
  flagsForFuzzing: () => he2,
  printfCommand: () => de2
});
var init_printf_KGN6BDCY = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/printf-KGN6BDCY.js"() {
    init_chunk_L4KW73FJ();
    init_chunk_EEXR5ZDP();
    init_chunk_PSW6BMXW();
    init_chunk_44UOCSGV();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/node_modules/balanced-match/dist/esm/index.js
var balanced, maybeMatch, range;
var init_esm = __esm({
  "../../node_modules/just-bash/node_modules/balanced-match/dist/esm/index.js"() {
    balanced = (a7, b25, str) => {
      const ma2 = a7 instanceof RegExp ? maybeMatch(a7, str) : a7;
      const mb = b25 instanceof RegExp ? maybeMatch(b25, str) : b25;
      const r8 = ma2 !== null && mb != null && range(ma2, mb, str);
      return r8 && {
        start: r8[0],
        end: r8[1],
        pre: str.slice(0, r8[0]),
        body: str.slice(r8[0] + ma2.length, r8[1]),
        post: str.slice(r8[1] + mb.length)
      };
    };
    maybeMatch = (reg, str) => {
      const m25 = str.match(reg);
      return m25 ? m25[0] : null;
    };
    range = (a7, b25, str) => {
      let begs, beg, left, right = void 0, result;
      let ai2 = str.indexOf(a7);
      let bi2 = str.indexOf(b25, ai2 + 1);
      let i10 = ai2;
      if (ai2 >= 0 && bi2 > 0) {
        if (a7 === b25) {
          return [ai2, bi2];
        }
        begs = [];
        left = str.length;
        while (i10 >= 0 && !result) {
          if (i10 === ai2) {
            begs.push(i10);
            ai2 = str.indexOf(a7, i10 + 1);
          } else if (begs.length === 1) {
            const r8 = begs.pop();
            if (r8 !== void 0)
              result = [r8, bi2];
          } else {
            beg = begs.pop();
            if (beg !== void 0 && beg < left) {
              left = beg;
              right = bi2;
            }
            bi2 = str.indexOf(b25, i10 + 1);
          }
          i10 = ai2 < bi2 && ai2 >= 0 ? ai2 : bi2;
        }
        if (begs.length && right !== void 0) {
          result = [left, right];
        }
      }
      return result;
    };
  }
});

// ../../node_modules/just-bash/node_modules/brace-expansion/dist/esm/index.js
function numeric(str) {
  return !isNaN(str) ? parseInt(str, 10) : str.charCodeAt(0);
}
function escapeBraces(str) {
  return str.replace(slashPattern, escSlash).replace(openPattern, escOpen).replace(closePattern, escClose).replace(commaPattern, escComma).replace(periodPattern, escPeriod);
}
function unescapeBraces(str) {
  return str.replace(escSlashPattern, "\\").replace(escOpenPattern, "{").replace(escClosePattern, "}").replace(escCommaPattern, ",").replace(escPeriodPattern, ".");
}
function parseCommaParts(str) {
  if (!str) {
    return [""];
  }
  const parts = [];
  const m25 = balanced("{", "}", str);
  if (!m25) {
    return str.split(",");
  }
  const { pre, body, post } = m25;
  const p17 = pre.split(",");
  p17[p17.length - 1] += "{" + body + "}";
  const postParts = parseCommaParts(post);
  if (post.length) {
    ;
    p17[p17.length - 1] += postParts.shift();
    p17.push.apply(p17, postParts);
  }
  parts.push.apply(parts, p17);
  return parts;
}
function expand(str, options = {}) {
  if (!str) {
    return [];
  }
  const { max = EXPANSION_MAX } = options;
  if (str.slice(0, 2) === "{}") {
    str = "\\{\\}" + str.slice(2);
  }
  return expand_(escapeBraces(str), max, true).map(unescapeBraces);
}
function embrace(str) {
  return "{" + str + "}";
}
function isPadded(el2) {
  return /^-?0\d/.test(el2);
}
function lte(i10, y18) {
  return i10 <= y18;
}
function gte(i10, y18) {
  return i10 >= y18;
}
function expand_(str, max, isTop) {
  const expansions = [];
  const m25 = balanced("{", "}", str);
  if (!m25)
    return [str];
  const pre = m25.pre;
  const post = m25.post.length ? expand_(m25.post, max, false) : [""];
  if (/\$$/.test(m25.pre)) {
    for (let k17 = 0; k17 < post.length && k17 < max; k17++) {
      const expansion = pre + "{" + m25.body + "}" + post[k17];
      expansions.push(expansion);
    }
  } else {
    const isNumericSequence = /^-?\d+\.\.-?\d+(?:\.\.-?\d+)?$/.test(m25.body);
    const isAlphaSequence = /^[a-zA-Z]\.\.[a-zA-Z](?:\.\.-?\d+)?$/.test(m25.body);
    const isSequence = isNumericSequence || isAlphaSequence;
    const isOptions = m25.body.indexOf(",") >= 0;
    if (!isSequence && !isOptions) {
      if (m25.post.match(/,(?!,).*\}/)) {
        str = m25.pre + "{" + m25.body + escClose + m25.post;
        return expand_(str, max, true);
      }
      return [str];
    }
    let n23;
    if (isSequence) {
      n23 = m25.body.split(/\.\./);
    } else {
      n23 = parseCommaParts(m25.body);
      if (n23.length === 1 && n23[0] !== void 0) {
        n23 = expand_(n23[0], max, false).map(embrace);
        if (n23.length === 1) {
          return post.map((p17) => m25.pre + n23[0] + p17);
        }
      }
    }
    let N15;
    if (isSequence && n23[0] !== void 0 && n23[1] !== void 0) {
      const x23 = numeric(n23[0]);
      const y18 = numeric(n23[1]);
      const width = Math.max(n23[0].length, n23[1].length);
      let incr = n23.length === 3 && n23[2] !== void 0 ? Math.abs(numeric(n23[2])) : 1;
      let test = lte;
      const reverse = y18 < x23;
      if (reverse) {
        incr *= -1;
        test = gte;
      }
      const pad = n23.some(isPadded);
      N15 = [];
      for (let i10 = x23; test(i10, y18); i10 += incr) {
        let c15;
        if (isAlphaSequence) {
          c15 = String.fromCharCode(i10);
          if (c15 === "\\") {
            c15 = "";
          }
        } else {
          c15 = String(i10);
          if (pad) {
            const need = width - c15.length;
            if (need > 0) {
              const z10 = new Array(need + 1).join("0");
              if (i10 < 0) {
                c15 = "-" + z10 + c15.slice(1);
              } else {
                c15 = z10 + c15;
              }
            }
          }
        }
        N15.push(c15);
      }
    } else {
      N15 = [];
      for (let j12 = 0; j12 < n23.length; j12++) {
        N15.push.apply(N15, expand_(n23[j12], max, false));
      }
    }
    for (let j12 = 0; j12 < N15.length; j12++) {
      for (let k17 = 0; k17 < post.length && expansions.length < max; k17++) {
        const expansion = pre + N15[j12] + post[k17];
        if (!isTop || isSequence || expansion) {
          expansions.push(expansion);
        }
      }
    }
  }
  return expansions;
}
var escSlash, escOpen, escClose, escComma, escPeriod, escSlashPattern, escOpenPattern, escClosePattern, escCommaPattern, escPeriodPattern, slashPattern, openPattern, closePattern, commaPattern, periodPattern, EXPANSION_MAX;
var init_esm2 = __esm({
  "../../node_modules/just-bash/node_modules/brace-expansion/dist/esm/index.js"() {
    init_esm();
    escSlash = "\0SLASH" + Math.random() + "\0";
    escOpen = "\0OPEN" + Math.random() + "\0";
    escClose = "\0CLOSE" + Math.random() + "\0";
    escComma = "\0COMMA" + Math.random() + "\0";
    escPeriod = "\0PERIOD" + Math.random() + "\0";
    escSlashPattern = new RegExp(escSlash, "g");
    escOpenPattern = new RegExp(escOpen, "g");
    escClosePattern = new RegExp(escClose, "g");
    escCommaPattern = new RegExp(escComma, "g");
    escPeriodPattern = new RegExp(escPeriod, "g");
    slashPattern = /\\\\/g;
    openPattern = /\\{/g;
    closePattern = /\\}/g;
    commaPattern = /\\,/g;
    periodPattern = /\\\./g;
    EXPANSION_MAX = 1e5;
  }
});

// ../../node_modules/just-bash/node_modules/minimatch/dist/esm/assert-valid-pattern.js
var MAX_PATTERN_LENGTH, assertValidPattern;
var init_assert_valid_pattern = __esm({
  "../../node_modules/just-bash/node_modules/minimatch/dist/esm/assert-valid-pattern.js"() {
    MAX_PATTERN_LENGTH = 1024 * 64;
    assertValidPattern = (pattern) => {
      if (typeof pattern !== "string") {
        throw new TypeError("invalid pattern");
      }
      if (pattern.length > MAX_PATTERN_LENGTH) {
        throw new TypeError("pattern is too long");
      }
    };
  }
});

// ../../node_modules/just-bash/node_modules/minimatch/dist/esm/brace-expressions.js
var posixClasses, braceEscape, regexpEscape, rangesToString, parseClass;
var init_brace_expressions = __esm({
  "../../node_modules/just-bash/node_modules/minimatch/dist/esm/brace-expressions.js"() {
    posixClasses = {
      "[:alnum:]": ["\\p{L}\\p{Nl}\\p{Nd}", true],
      "[:alpha:]": ["\\p{L}\\p{Nl}", true],
      "[:ascii:]": ["\\x00-\\x7f", false],
      "[:blank:]": ["\\p{Zs}\\t", true],
      "[:cntrl:]": ["\\p{Cc}", true],
      "[:digit:]": ["\\p{Nd}", true],
      "[:graph:]": ["\\p{Z}\\p{C}", true, true],
      "[:lower:]": ["\\p{Ll}", true],
      "[:print:]": ["\\p{C}", true],
      "[:punct:]": ["\\p{P}", true],
      "[:space:]": ["\\p{Z}\\t\\r\\n\\v\\f", true],
      "[:upper:]": ["\\p{Lu}", true],
      "[:word:]": ["\\p{L}\\p{Nl}\\p{Nd}\\p{Pc}", true],
      "[:xdigit:]": ["A-Fa-f0-9", false]
    };
    braceEscape = (s9) => s9.replace(/[[\]\\-]/g, "\\$&");
    regexpEscape = (s9) => s9.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
    rangesToString = (ranges) => ranges.join("");
    parseClass = (glob, position) => {
      const pos = position;
      if (glob.charAt(pos) !== "[") {
        throw new Error("not in a brace expression");
      }
      const ranges = [];
      const negs = [];
      let i10 = pos + 1;
      let sawStart = false;
      let uflag = false;
      let escaping = false;
      let negate = false;
      let endPos = pos;
      let rangeStart = "";
      WHILE: while (i10 < glob.length) {
        const c15 = glob.charAt(i10);
        if ((c15 === "!" || c15 === "^") && i10 === pos + 1) {
          negate = true;
          i10++;
          continue;
        }
        if (c15 === "]" && sawStart && !escaping) {
          endPos = i10 + 1;
          break;
        }
        sawStart = true;
        if (c15 === "\\") {
          if (!escaping) {
            escaping = true;
            i10++;
            continue;
          }
        }
        if (c15 === "[" && !escaping) {
          for (const [cls, [unip, u11, neg]] of Object.entries(posixClasses)) {
            if (glob.startsWith(cls, i10)) {
              if (rangeStart) {
                return ["$.", false, glob.length - pos, true];
              }
              i10 += cls.length;
              if (neg)
                negs.push(unip);
              else
                ranges.push(unip);
              uflag = uflag || u11;
              continue WHILE;
            }
          }
        }
        escaping = false;
        if (rangeStart) {
          if (c15 > rangeStart) {
            ranges.push(braceEscape(rangeStart) + "-" + braceEscape(c15));
          } else if (c15 === rangeStart) {
            ranges.push(braceEscape(c15));
          }
          rangeStart = "";
          i10++;
          continue;
        }
        if (glob.startsWith("-]", i10 + 1)) {
          ranges.push(braceEscape(c15 + "-"));
          i10 += 2;
          continue;
        }
        if (glob.startsWith("-", i10 + 1)) {
          rangeStart = c15;
          i10 += 2;
          continue;
        }
        ranges.push(braceEscape(c15));
        i10++;
      }
      if (endPos < i10) {
        return ["", false, 0, false];
      }
      if (!ranges.length && !negs.length) {
        return ["$.", false, glob.length - pos, true];
      }
      if (negs.length === 0 && ranges.length === 1 && /^\\?.$/.test(ranges[0]) && !negate) {
        const r8 = ranges[0].length === 2 ? ranges[0].slice(-1) : ranges[0];
        return [regexpEscape(r8), false, endPos - pos, false];
      }
      const sranges = "[" + (negate ? "^" : "") + rangesToString(ranges) + "]";
      const snegs = "[" + (negate ? "" : "^") + rangesToString(negs) + "]";
      const comb = ranges.length && negs.length ? "(" + sranges + "|" + snegs + ")" : ranges.length ? sranges : snegs;
      return [comb, uflag, endPos - pos, true];
    };
  }
});

// ../../node_modules/just-bash/node_modules/minimatch/dist/esm/unescape.js
var unescape;
var init_unescape = __esm({
  "../../node_modules/just-bash/node_modules/minimatch/dist/esm/unescape.js"() {
    unescape = (s9, { windowsPathsNoEscape = false, magicalBraces = true } = {}) => {
      if (magicalBraces) {
        return windowsPathsNoEscape ? s9.replace(/\[([^\/\\])\]/g, "$1") : s9.replace(/((?!\\).|^)\[([^\/\\])\]/g, "$1$2").replace(/\\([^\/])/g, "$1");
      }
      return windowsPathsNoEscape ? s9.replace(/\[([^\/\\{}])\]/g, "$1") : s9.replace(/((?!\\).|^)\[([^\/\\{}])\]/g, "$1$2").replace(/\\([^\/{}])/g, "$1");
    };
  }
});

// ../../node_modules/just-bash/node_modules/minimatch/dist/esm/ast.js
var _a, types, isExtglobType, isExtglobAST, adoptionMap, adoptionWithSpaceMap, adoptionAnyMap, usurpMap, startNoTraversal, startNoDot, addPatternStart, justDots, reSpecials, regExpEscape, qmark, star, starNoEmpty, ID, AST;
var init_ast = __esm({
  "../../node_modules/just-bash/node_modules/minimatch/dist/esm/ast.js"() {
    init_brace_expressions();
    init_unescape();
    types = /* @__PURE__ */ new Set(["!", "?", "+", "*", "@"]);
    isExtglobType = (c15) => types.has(c15);
    isExtglobAST = (c15) => isExtglobType(c15.type);
    adoptionMap = /* @__PURE__ */ new Map([
      ["!", ["@"]],
      ["?", ["?", "@"]],
      ["@", ["@"]],
      ["*", ["*", "+", "?", "@"]],
      ["+", ["+", "@"]]
    ]);
    adoptionWithSpaceMap = /* @__PURE__ */ new Map([
      ["!", ["?"]],
      ["@", ["?"]],
      ["+", ["?", "*"]]
    ]);
    adoptionAnyMap = /* @__PURE__ */ new Map([
      ["!", ["?", "@"]],
      ["?", ["?", "@"]],
      ["@", ["?", "@"]],
      ["*", ["*", "+", "?", "@"]],
      ["+", ["+", "@", "?", "*"]]
    ]);
    usurpMap = /* @__PURE__ */ new Map([
      ["!", /* @__PURE__ */ new Map([["!", "@"]])],
      [
        "?",
        /* @__PURE__ */ new Map([
          ["*", "*"],
          ["+", "*"]
        ])
      ],
      [
        "@",
        /* @__PURE__ */ new Map([
          ["!", "!"],
          ["?", "?"],
          ["@", "@"],
          ["*", "*"],
          ["+", "+"]
        ])
      ],
      [
        "+",
        /* @__PURE__ */ new Map([
          ["?", "*"],
          ["*", "*"]
        ])
      ]
    ]);
    startNoTraversal = "(?!(?:^|/)\\.\\.?(?:$|/))";
    startNoDot = "(?!\\.)";
    addPatternStart = /* @__PURE__ */ new Set(["[", "."]);
    justDots = /* @__PURE__ */ new Set(["..", "."]);
    reSpecials = new Set("().*{}+?[]^$\\!");
    regExpEscape = (s9) => s9.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
    qmark = "[^/]";
    star = qmark + "*?";
    starNoEmpty = qmark + "+?";
    ID = 0;
    AST = class {
      type;
      #root;
      #hasMagic;
      #uflag = false;
      #parts = [];
      #parent;
      #parentIndex;
      #negs;
      #filledNegs = false;
      #options;
      #toString;
      // set to true if it's an extglob with no children
      // (which really means one child of '')
      #emptyExt = false;
      id = ++ID;
      get depth() {
        return (this.#parent?.depth ?? -1) + 1;
      }
      [Symbol.for("nodejs.util.inspect.custom")]() {
        return {
          "@@type": "AST",
          id: this.id,
          type: this.type,
          root: this.#root.id,
          parent: this.#parent?.id,
          depth: this.depth,
          partsLength: this.#parts.length,
          parts: this.#parts
        };
      }
      constructor(type, parent, options = {}) {
        this.type = type;
        if (type)
          this.#hasMagic = true;
        this.#parent = parent;
        this.#root = this.#parent ? this.#parent.#root : this;
        this.#options = this.#root === this ? options : this.#root.#options;
        this.#negs = this.#root === this ? [] : this.#root.#negs;
        if (type === "!" && !this.#root.#filledNegs)
          this.#negs.push(this);
        this.#parentIndex = this.#parent ? this.#parent.#parts.length : 0;
      }
      get hasMagic() {
        if (this.#hasMagic !== void 0)
          return this.#hasMagic;
        for (const p17 of this.#parts) {
          if (typeof p17 === "string")
            continue;
          if (p17.type || p17.hasMagic)
            return this.#hasMagic = true;
        }
        return this.#hasMagic;
      }
      // reconstructs the pattern
      toString() {
        if (this.#toString !== void 0)
          return this.#toString;
        if (!this.type) {
          return this.#toString = this.#parts.map((p17) => String(p17)).join("");
        } else {
          return this.#toString = this.type + "(" + this.#parts.map((p17) => String(p17)).join("|") + ")";
        }
      }
      #fillNegs() {
        if (this !== this.#root)
          throw new Error("should only call on root");
        if (this.#filledNegs)
          return this;
        this.toString();
        this.#filledNegs = true;
        let n23;
        while (n23 = this.#negs.pop()) {
          if (n23.type !== "!")
            continue;
          let p17 = n23;
          let pp = p17.#parent;
          while (pp) {
            for (let i10 = p17.#parentIndex + 1; !pp.type && i10 < pp.#parts.length; i10++) {
              for (const part of n23.#parts) {
                if (typeof part === "string") {
                  throw new Error("string part in extglob AST??");
                }
                part.copyIn(pp.#parts[i10]);
              }
            }
            p17 = pp;
            pp = p17.#parent;
          }
        }
        return this;
      }
      push(...parts) {
        for (const p17 of parts) {
          if (p17 === "")
            continue;
          if (typeof p17 !== "string" && !(p17 instanceof _a && p17.#parent === this)) {
            throw new Error("invalid part: " + p17);
          }
          this.#parts.push(p17);
        }
      }
      toJSON() {
        const ret = this.type === null ? this.#parts.slice().map((p17) => typeof p17 === "string" ? p17 : p17.toJSON()) : [this.type, ...this.#parts.map((p17) => p17.toJSON())];
        if (this.isStart() && !this.type)
          ret.unshift([]);
        if (this.isEnd() && (this === this.#root || this.#root.#filledNegs && this.#parent?.type === "!")) {
          ret.push({});
        }
        return ret;
      }
      isStart() {
        if (this.#root === this)
          return true;
        if (!this.#parent?.isStart())
          return false;
        if (this.#parentIndex === 0)
          return true;
        const p17 = this.#parent;
        for (let i10 = 0; i10 < this.#parentIndex; i10++) {
          const pp = p17.#parts[i10];
          if (!(pp instanceof _a && pp.type === "!")) {
            return false;
          }
        }
        return true;
      }
      isEnd() {
        if (this.#root === this)
          return true;
        if (this.#parent?.type === "!")
          return true;
        if (!this.#parent?.isEnd())
          return false;
        if (!this.type)
          return this.#parent?.isEnd();
        const pl2 = this.#parent ? this.#parent.#parts.length : 0;
        return this.#parentIndex === pl2 - 1;
      }
      copyIn(part) {
        if (typeof part === "string")
          this.push(part);
        else
          this.push(part.clone(this));
      }
      clone(parent) {
        const c15 = new _a(this.type, parent);
        for (const p17 of this.#parts) {
          c15.copyIn(p17);
        }
        return c15;
      }
      static #parseAST(str, ast, pos, opt, extDepth) {
        const maxDepth = opt.maxExtglobRecursion ?? 2;
        let escaping = false;
        let inBrace = false;
        let braceStart = -1;
        let braceNeg = false;
        if (ast.type === null) {
          let i11 = pos;
          let acc2 = "";
          while (i11 < str.length) {
            const c15 = str.charAt(i11++);
            if (escaping || c15 === "\\") {
              escaping = !escaping;
              acc2 += c15;
              continue;
            }
            if (inBrace) {
              if (i11 === braceStart + 1) {
                if (c15 === "^" || c15 === "!") {
                  braceNeg = true;
                }
              } else if (c15 === "]" && !(i11 === braceStart + 2 && braceNeg)) {
                inBrace = false;
              }
              acc2 += c15;
              continue;
            } else if (c15 === "[") {
              inBrace = true;
              braceStart = i11;
              braceNeg = false;
              acc2 += c15;
              continue;
            }
            const doRecurse = !opt.noext && isExtglobType(c15) && str.charAt(i11) === "(" && extDepth <= maxDepth;
            if (doRecurse) {
              ast.push(acc2);
              acc2 = "";
              const ext2 = new _a(c15, ast);
              i11 = _a.#parseAST(str, ext2, i11, opt, extDepth + 1);
              ast.push(ext2);
              continue;
            }
            acc2 += c15;
          }
          ast.push(acc2);
          return i11;
        }
        let i10 = pos + 1;
        let part = new _a(null, ast);
        const parts = [];
        let acc = "";
        while (i10 < str.length) {
          const c15 = str.charAt(i10++);
          if (escaping || c15 === "\\") {
            escaping = !escaping;
            acc += c15;
            continue;
          }
          if (inBrace) {
            if (i10 === braceStart + 1) {
              if (c15 === "^" || c15 === "!") {
                braceNeg = true;
              }
            } else if (c15 === "]" && !(i10 === braceStart + 2 && braceNeg)) {
              inBrace = false;
            }
            acc += c15;
            continue;
          } else if (c15 === "[") {
            inBrace = true;
            braceStart = i10;
            braceNeg = false;
            acc += c15;
            continue;
          }
          const doRecurse = !opt.noext && isExtglobType(c15) && str.charAt(i10) === "(" && /* c8 ignore start - the maxDepth is sufficient here */
          (extDepth <= maxDepth || ast && ast.#canAdoptType(c15));
          if (doRecurse) {
            const depthAdd = ast && ast.#canAdoptType(c15) ? 0 : 1;
            part.push(acc);
            acc = "";
            const ext2 = new _a(c15, part);
            part.push(ext2);
            i10 = _a.#parseAST(str, ext2, i10, opt, extDepth + depthAdd);
            continue;
          }
          if (c15 === "|") {
            part.push(acc);
            acc = "";
            parts.push(part);
            part = new _a(null, ast);
            continue;
          }
          if (c15 === ")") {
            if (acc === "" && ast.#parts.length === 0) {
              ast.#emptyExt = true;
            }
            part.push(acc);
            acc = "";
            ast.push(...parts, part);
            return i10;
          }
          acc += c15;
        }
        ast.type = null;
        ast.#hasMagic = void 0;
        ast.#parts = [str.substring(pos - 1)];
        return i10;
      }
      #canAdoptWithSpace(child) {
        return this.#canAdopt(child, adoptionWithSpaceMap);
      }
      #canAdopt(child, map = adoptionMap) {
        if (!child || typeof child !== "object" || child.type !== null || child.#parts.length !== 1 || this.type === null) {
          return false;
        }
        const gc = child.#parts[0];
        if (!gc || typeof gc !== "object" || gc.type === null) {
          return false;
        }
        return this.#canAdoptType(gc.type, map);
      }
      #canAdoptType(c15, map = adoptionAnyMap) {
        return !!map.get(this.type)?.includes(c15);
      }
      #adoptWithSpace(child, index) {
        const gc = child.#parts[0];
        const blank = new _a(null, gc, this.options);
        blank.#parts.push("");
        gc.push(blank);
        this.#adopt(child, index);
      }
      #adopt(child, index) {
        const gc = child.#parts[0];
        this.#parts.splice(index, 1, ...gc.#parts);
        for (const p17 of gc.#parts) {
          if (typeof p17 === "object")
            p17.#parent = this;
        }
        this.#toString = void 0;
      }
      #canUsurpType(c15) {
        const m25 = usurpMap.get(this.type);
        return !!m25?.has(c15);
      }
      #canUsurp(child) {
        if (!child || typeof child !== "object" || child.type !== null || child.#parts.length !== 1 || this.type === null || this.#parts.length !== 1) {
          return false;
        }
        const gc = child.#parts[0];
        if (!gc || typeof gc !== "object" || gc.type === null) {
          return false;
        }
        return this.#canUsurpType(gc.type);
      }
      #usurp(child) {
        const m25 = usurpMap.get(this.type);
        const gc = child.#parts[0];
        const nt8 = m25?.get(gc.type);
        if (!nt8)
          return false;
        this.#parts = gc.#parts;
        for (const p17 of this.#parts) {
          if (typeof p17 === "object") {
            p17.#parent = this;
          }
        }
        this.type = nt8;
        this.#toString = void 0;
        this.#emptyExt = false;
      }
      static fromGlob(pattern, options = {}) {
        const ast = new _a(null, void 0, options);
        _a.#parseAST(pattern, ast, 0, options, 0);
        return ast;
      }
      // returns the regular expression if there's magic, or the unescaped
      // string if not.
      toMMPattern() {
        if (this !== this.#root)
          return this.#root.toMMPattern();
        const glob = this.toString();
        const [re5, body, hasMagic, uflag] = this.toRegExpSource();
        const anyMagic = hasMagic || this.#hasMagic || this.#options.nocase && !this.#options.nocaseMagicOnly && glob.toUpperCase() !== glob.toLowerCase();
        if (!anyMagic) {
          return body;
        }
        const flags = (this.#options.nocase ? "i" : "") + (uflag ? "u" : "");
        return Object.assign(new RegExp(`^${re5}$`, flags), {
          _src: re5,
          _glob: glob
        });
      }
      get options() {
        return this.#options;
      }
      // returns the string match, the regexp source, whether there's magic
      // in the regexp (so a regular expression is required) and whether or
      // not the uflag is needed for the regular expression (for posix classes)
      // TODO: instead of injecting the start/end at this point, just return
      // the BODY of the regexp, along with the start/end portions suitable
      // for binding the start/end in either a joined full-path makeRe context
      // (where we bind to (^|/), or a standalone matchPart context (where
      // we bind to ^, and not /).  Otherwise slashes get duped!
      //
      // In part-matching mode, the start is:
      // - if not isStart: nothing
      // - if traversal possible, but not allowed: ^(?!\.\.?$)
      // - if dots allowed or not possible: ^
      // - if dots possible and not allowed: ^(?!\.)
      // end is:
      // - if not isEnd(): nothing
      // - else: $
      //
      // In full-path matching mode, we put the slash at the START of the
      // pattern, so start is:
      // - if first pattern: same as part-matching mode
      // - if not isStart(): nothing
      // - if traversal possible, but not allowed: /(?!\.\.?(?:$|/))
      // - if dots allowed or not possible: /
      // - if dots possible and not allowed: /(?!\.)
      // end is:
      // - if last pattern, same as part-matching mode
      // - else nothing
      //
      // Always put the (?:$|/) on negated tails, though, because that has to be
      // there to bind the end of the negated pattern portion, and it's easier to
      // just stick it in now rather than try to inject it later in the middle of
      // the pattern.
      //
      // We can just always return the same end, and leave it up to the caller
      // to know whether it's going to be used joined or in parts.
      // And, if the start is adjusted slightly, can do the same there:
      // - if not isStart: nothing
      // - if traversal possible, but not allowed: (?:/|^)(?!\.\.?$)
      // - if dots allowed or not possible: (?:/|^)
      // - if dots possible and not allowed: (?:/|^)(?!\.)
      //
      // But it's better to have a simpler binding without a conditional, for
      // performance, so probably better to return both start options.
      //
      // Then the caller just ignores the end if it's not the first pattern,
      // and the start always gets applied.
      //
      // But that's always going to be $ if it's the ending pattern, or nothing,
      // so the caller can just attach $ at the end of the pattern when building.
      //
      // So the todo is:
      // - better detect what kind of start is needed
      // - return both flavors of starting pattern
      // - attach $ at the end of the pattern when creating the actual RegExp
      //
      // Ah, but wait, no, that all only applies to the root when the first pattern
      // is not an extglob. If the first pattern IS an extglob, then we need all
      // that dot prevention biz to live in the extglob portions, because eg
      // +(*|.x*) can match .xy but not .yx.
      //
      // So, return the two flavors if it's #root and the first child is not an
      // AST, otherwise leave it to the child AST to handle it, and there,
      // use the (?:^|/) style of start binding.
      //
      // Even simplified further:
      // - Since the start for a join is eg /(?!\.) and the start for a part
      // is ^(?!\.), we can just prepend (?!\.) to the pattern (either root
      // or start or whatever) and prepend ^ or / at the Regexp construction.
      toRegExpSource(allowDot) {
        const dot = allowDot ?? !!this.#options.dot;
        if (this.#root === this) {
          this.#flatten();
          this.#fillNegs();
        }
        if (!isExtglobAST(this)) {
          const noEmpty = this.isStart() && this.isEnd() && !this.#parts.some((s9) => typeof s9 !== "string");
          const src = this.#parts.map((p17) => {
            const [re5, _15, hasMagic, uflag] = typeof p17 === "string" ? _a.#parseGlob(p17, this.#hasMagic, noEmpty) : p17.toRegExpSource(allowDot);
            this.#hasMagic = this.#hasMagic || hasMagic;
            this.#uflag = this.#uflag || uflag;
            return re5;
          }).join("");
          let start2 = "";
          if (this.isStart()) {
            if (typeof this.#parts[0] === "string") {
              const dotTravAllowed = this.#parts.length === 1 && justDots.has(this.#parts[0]);
              if (!dotTravAllowed) {
                const aps = addPatternStart;
                const needNoTrav = (
                  // dots are allowed, and the pattern starts with [ or .
                  dot && aps.has(src.charAt(0)) || // the pattern starts with \., and then [ or .
                  src.startsWith("\\.") && aps.has(src.charAt(2)) || // the pattern starts with \.\., and then [ or .
                  src.startsWith("\\.\\.") && aps.has(src.charAt(4))
                );
                const needNoDot = !dot && !allowDot && aps.has(src.charAt(0));
                start2 = needNoTrav ? startNoTraversal : needNoDot ? startNoDot : "";
              }
            }
          }
          let end = "";
          if (this.isEnd() && this.#root.#filledNegs && this.#parent?.type === "!") {
            end = "(?:$|\\/)";
          }
          const final2 = start2 + src + end;
          return [
            final2,
            unescape(src),
            this.#hasMagic = !!this.#hasMagic,
            this.#uflag
          ];
        }
        const repeated = this.type === "*" || this.type === "+";
        const start = this.type === "!" ? "(?:(?!(?:" : "(?:";
        let body = this.#partsToRegExp(dot);
        if (this.isStart() && this.isEnd() && !body && this.type !== "!") {
          const s9 = this.toString();
          const me6 = this;
          me6.#parts = [s9];
          me6.type = null;
          me6.#hasMagic = void 0;
          return [s9, unescape(this.toString()), false, false];
        }
        let bodyDotAllowed = !repeated || allowDot || dot || !startNoDot ? "" : this.#partsToRegExp(true);
        if (bodyDotAllowed === body) {
          bodyDotAllowed = "";
        }
        if (bodyDotAllowed) {
          body = `(?:${body})(?:${bodyDotAllowed})*?`;
        }
        let final = "";
        if (this.type === "!" && this.#emptyExt) {
          final = (this.isStart() && !dot ? startNoDot : "") + starNoEmpty;
        } else {
          const close = this.type === "!" ? (
            // !() must match something,but !(x) can match ''
            "))" + (this.isStart() && !dot && !allowDot ? startNoDot : "") + star + ")"
          ) : this.type === "@" ? ")" : this.type === "?" ? ")?" : this.type === "+" && bodyDotAllowed ? ")" : this.type === "*" && bodyDotAllowed ? `)?` : `)${this.type}`;
          final = start + body + close;
        }
        return [
          final,
          unescape(body),
          this.#hasMagic = !!this.#hasMagic,
          this.#uflag
        ];
      }
      #flatten() {
        if (!isExtglobAST(this)) {
          for (const p17 of this.#parts) {
            if (typeof p17 === "object") {
              p17.#flatten();
            }
          }
        } else {
          let iterations = 0;
          let done = false;
          do {
            done = true;
            for (let i10 = 0; i10 < this.#parts.length; i10++) {
              const c15 = this.#parts[i10];
              if (typeof c15 === "object") {
                c15.#flatten();
                if (this.#canAdopt(c15)) {
                  done = false;
                  this.#adopt(c15, i10);
                } else if (this.#canAdoptWithSpace(c15)) {
                  done = false;
                  this.#adoptWithSpace(c15, i10);
                } else if (this.#canUsurp(c15)) {
                  done = false;
                  this.#usurp(c15);
                }
              }
            }
          } while (!done && ++iterations < 10);
        }
        this.#toString = void 0;
      }
      #partsToRegExp(dot) {
        return this.#parts.map((p17) => {
          if (typeof p17 === "string") {
            throw new Error("string type in extglob ast??");
          }
          const [re5, _15, _hasMagic, uflag] = p17.toRegExpSource(dot);
          this.#uflag = this.#uflag || uflag;
          return re5;
        }).filter((p17) => !(this.isStart() && this.isEnd()) || !!p17).join("|");
      }
      static #parseGlob(glob, hasMagic, noEmpty = false) {
        let escaping = false;
        let re5 = "";
        let uflag = false;
        let inStar = false;
        for (let i10 = 0; i10 < glob.length; i10++) {
          const c15 = glob.charAt(i10);
          if (escaping) {
            escaping = false;
            re5 += (reSpecials.has(c15) ? "\\" : "") + c15;
            continue;
          }
          if (c15 === "*") {
            if (inStar)
              continue;
            inStar = true;
            re5 += noEmpty && /^[*]+$/.test(glob) ? starNoEmpty : star;
            hasMagic = true;
            continue;
          } else {
            inStar = false;
          }
          if (c15 === "\\") {
            if (i10 === glob.length - 1) {
              re5 += "\\\\";
            } else {
              escaping = true;
            }
            continue;
          }
          if (c15 === "[") {
            const [src, needUflag, consumed, magic] = parseClass(glob, i10);
            if (consumed) {
              re5 += src;
              uflag = uflag || needUflag;
              i10 += consumed - 1;
              hasMagic = hasMagic || magic;
              continue;
            }
          }
          if (c15 === "?") {
            re5 += qmark;
            hasMagic = true;
            continue;
          }
          re5 += regExpEscape(c15);
        }
        return [re5, unescape(glob), !!hasMagic, uflag];
      }
    };
    _a = AST;
  }
});

// ../../node_modules/just-bash/node_modules/minimatch/dist/esm/escape.js
var escape;
var init_escape = __esm({
  "../../node_modules/just-bash/node_modules/minimatch/dist/esm/escape.js"() {
    escape = (s9, { windowsPathsNoEscape = false, magicalBraces = false } = {}) => {
      if (magicalBraces) {
        return windowsPathsNoEscape ? s9.replace(/[?*()[\]{}]/g, "[$&]") : s9.replace(/[?*()[\]\\{}]/g, "\\$&");
      }
      return windowsPathsNoEscape ? s9.replace(/[?*()[\]]/g, "[$&]") : s9.replace(/[?*()[\]\\]/g, "\\$&");
    };
  }
});

// ../../node_modules/just-bash/node_modules/minimatch/dist/esm/index.js
var minimatch, starDotExtRE, starDotExtTest, starDotExtTestDot, starDotExtTestNocase, starDotExtTestNocaseDot, starDotStarRE, starDotStarTest, starDotStarTestDot, dotStarRE, dotStarTest, starRE, starTest, starTestDot, qmarksRE, qmarksTestNocase, qmarksTestNocaseDot, qmarksTestDot, qmarksTest, qmarksTestNoExt, qmarksTestNoExtDot, defaultPlatform, path, sep, GLOBSTAR, qmark2, star2, twoStarDot, twoStarNoDot, filter, ext, defaults, braceExpand, makeRe, match, globMagic, regExpEscape2, Minimatch;
var init_esm3 = __esm({
  "../../node_modules/just-bash/node_modules/minimatch/dist/esm/index.js"() {
    init_esm2();
    init_assert_valid_pattern();
    init_ast();
    init_escape();
    init_unescape();
    init_ast();
    init_escape();
    init_unescape();
    minimatch = (p17, pattern, options = {}) => {
      assertValidPattern(pattern);
      if (!options.nocomment && pattern.charAt(0) === "#") {
        return false;
      }
      return new Minimatch(pattern, options).match(p17);
    };
    starDotExtRE = /^\*+([^+@!?\*\[\(]*)$/;
    starDotExtTest = (ext2) => (f11) => !f11.startsWith(".") && f11.endsWith(ext2);
    starDotExtTestDot = (ext2) => (f11) => f11.endsWith(ext2);
    starDotExtTestNocase = (ext2) => {
      ext2 = ext2.toLowerCase();
      return (f11) => !f11.startsWith(".") && f11.toLowerCase().endsWith(ext2);
    };
    starDotExtTestNocaseDot = (ext2) => {
      ext2 = ext2.toLowerCase();
      return (f11) => f11.toLowerCase().endsWith(ext2);
    };
    starDotStarRE = /^\*+\.\*+$/;
    starDotStarTest = (f11) => !f11.startsWith(".") && f11.includes(".");
    starDotStarTestDot = (f11) => f11 !== "." && f11 !== ".." && f11.includes(".");
    dotStarRE = /^\.\*+$/;
    dotStarTest = (f11) => f11 !== "." && f11 !== ".." && f11.startsWith(".");
    starRE = /^\*+$/;
    starTest = (f11) => f11.length !== 0 && !f11.startsWith(".");
    starTestDot = (f11) => f11.length !== 0 && f11 !== "." && f11 !== "..";
    qmarksRE = /^\?+([^+@!?\*\[\(]*)?$/;
    qmarksTestNocase = ([$0, ext2 = ""]) => {
      const noext = qmarksTestNoExt([$0]);
      if (!ext2)
        return noext;
      ext2 = ext2.toLowerCase();
      return (f11) => noext(f11) && f11.toLowerCase().endsWith(ext2);
    };
    qmarksTestNocaseDot = ([$0, ext2 = ""]) => {
      const noext = qmarksTestNoExtDot([$0]);
      if (!ext2)
        return noext;
      ext2 = ext2.toLowerCase();
      return (f11) => noext(f11) && f11.toLowerCase().endsWith(ext2);
    };
    qmarksTestDot = ([$0, ext2 = ""]) => {
      const noext = qmarksTestNoExtDot([$0]);
      return !ext2 ? noext : (f11) => noext(f11) && f11.endsWith(ext2);
    };
    qmarksTest = ([$0, ext2 = ""]) => {
      const noext = qmarksTestNoExt([$0]);
      return !ext2 ? noext : (f11) => noext(f11) && f11.endsWith(ext2);
    };
    qmarksTestNoExt = ([$0]) => {
      const len = $0.length;
      return (f11) => f11.length === len && !f11.startsWith(".");
    };
    qmarksTestNoExtDot = ([$0]) => {
      const len = $0.length;
      return (f11) => f11.length === len && f11 !== "." && f11 !== "..";
    };
    defaultPlatform = typeof process === "object" && process ? typeof process.env === "object" && process.env && process.env.__MINIMATCH_TESTING_PLATFORM__ || process.platform : "posix";
    path = {
      win32: { sep: "\\" },
      posix: { sep: "/" }
    };
    sep = defaultPlatform === "win32" ? path.win32.sep : path.posix.sep;
    minimatch.sep = sep;
    GLOBSTAR = Symbol("globstar **");
    minimatch.GLOBSTAR = GLOBSTAR;
    qmark2 = "[^/]";
    star2 = qmark2 + "*?";
    twoStarDot = "(?:(?!(?:\\/|^)(?:\\.{1,2})($|\\/)).)*?";
    twoStarNoDot = "(?:(?!(?:\\/|^)\\.).)*?";
    filter = (pattern, options = {}) => (p17) => minimatch(p17, pattern, options);
    minimatch.filter = filter;
    ext = (a7, b25 = {}) => Object.assign({}, a7, b25);
    defaults = (def) => {
      if (!def || typeof def !== "object" || !Object.keys(def).length) {
        return minimatch;
      }
      const orig = minimatch;
      const m25 = (p17, pattern, options = {}) => orig(p17, pattern, ext(def, options));
      return Object.assign(m25, {
        Minimatch: class Minimatch extends orig.Minimatch {
          constructor(pattern, options = {}) {
            super(pattern, ext(def, options));
          }
          static defaults(options) {
            return orig.defaults(ext(def, options)).Minimatch;
          }
        },
        AST: class AST extends orig.AST {
          /* c8 ignore start */
          constructor(type, parent, options = {}) {
            super(type, parent, ext(def, options));
          }
          /* c8 ignore stop */
          static fromGlob(pattern, options = {}) {
            return orig.AST.fromGlob(pattern, ext(def, options));
          }
        },
        unescape: (s9, options = {}) => orig.unescape(s9, ext(def, options)),
        escape: (s9, options = {}) => orig.escape(s9, ext(def, options)),
        filter: (pattern, options = {}) => orig.filter(pattern, ext(def, options)),
        defaults: (options) => orig.defaults(ext(def, options)),
        makeRe: (pattern, options = {}) => orig.makeRe(pattern, ext(def, options)),
        braceExpand: (pattern, options = {}) => orig.braceExpand(pattern, ext(def, options)),
        match: (list, pattern, options = {}) => orig.match(list, pattern, ext(def, options)),
        sep: orig.sep,
        GLOBSTAR
      });
    };
    minimatch.defaults = defaults;
    braceExpand = (pattern, options = {}) => {
      assertValidPattern(pattern);
      if (options.nobrace || !/\{(?:(?!\{).)*\}/.test(pattern)) {
        return [pattern];
      }
      return expand(pattern, { max: options.braceExpandMax });
    };
    minimatch.braceExpand = braceExpand;
    makeRe = (pattern, options = {}) => new Minimatch(pattern, options).makeRe();
    minimatch.makeRe = makeRe;
    match = (list, pattern, options = {}) => {
      const mm = new Minimatch(pattern, options);
      list = list.filter((f11) => mm.match(f11));
      if (mm.options.nonull && !list.length) {
        list.push(pattern);
      }
      return list;
    };
    minimatch.match = match;
    globMagic = /[?*]|[+@!]\(.*?\)|\[|\]/;
    regExpEscape2 = (s9) => s9.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
    Minimatch = class {
      options;
      set;
      pattern;
      windowsPathsNoEscape;
      nonegate;
      negate;
      comment;
      empty;
      preserveMultipleSlashes;
      partial;
      globSet;
      globParts;
      nocase;
      isWindows;
      platform;
      windowsNoMagicRoot;
      maxGlobstarRecursion;
      regexp;
      constructor(pattern, options = {}) {
        assertValidPattern(pattern);
        options = options || {};
        this.options = options;
        this.maxGlobstarRecursion = options.maxGlobstarRecursion ?? 200;
        this.pattern = pattern;
        this.platform = options.platform || defaultPlatform;
        this.isWindows = this.platform === "win32";
        const awe = "allowWindowsEscape";
        this.windowsPathsNoEscape = !!options.windowsPathsNoEscape || options[awe] === false;
        if (this.windowsPathsNoEscape) {
          this.pattern = this.pattern.replace(/\\/g, "/");
        }
        this.preserveMultipleSlashes = !!options.preserveMultipleSlashes;
        this.regexp = null;
        this.negate = false;
        this.nonegate = !!options.nonegate;
        this.comment = false;
        this.empty = false;
        this.partial = !!options.partial;
        this.nocase = !!this.options.nocase;
        this.windowsNoMagicRoot = options.windowsNoMagicRoot !== void 0 ? options.windowsNoMagicRoot : !!(this.isWindows && this.nocase);
        this.globSet = [];
        this.globParts = [];
        this.set = [];
        this.make();
      }
      hasMagic() {
        if (this.options.magicalBraces && this.set.length > 1) {
          return true;
        }
        for (const pattern of this.set) {
          for (const part of pattern) {
            if (typeof part !== "string")
              return true;
          }
        }
        return false;
      }
      debug(..._15) {
      }
      make() {
        const pattern = this.pattern;
        const options = this.options;
        if (!options.nocomment && pattern.charAt(0) === "#") {
          this.comment = true;
          return;
        }
        if (!pattern) {
          this.empty = true;
          return;
        }
        this.parseNegate();
        this.globSet = [...new Set(this.braceExpand())];
        if (options.debug) {
          this.debug = (...args) => console.error(...args);
        }
        this.debug(this.pattern, this.globSet);
        const rawGlobParts = this.globSet.map((s9) => this.slashSplit(s9));
        this.globParts = this.preprocess(rawGlobParts);
        this.debug(this.pattern, this.globParts);
        let set = this.globParts.map((s9, _15, __) => {
          if (this.isWindows && this.windowsNoMagicRoot) {
            const isUNC = s9[0] === "" && s9[1] === "" && (s9[2] === "?" || !globMagic.test(s9[2])) && !globMagic.test(s9[3]);
            const isDrive = /^[a-z]:/i.test(s9[0]);
            if (isUNC) {
              return [
                ...s9.slice(0, 4),
                ...s9.slice(4).map((ss3) => this.parse(ss3))
              ];
            } else if (isDrive) {
              return [s9[0], ...s9.slice(1).map((ss3) => this.parse(ss3))];
            }
          }
          return s9.map((ss3) => this.parse(ss3));
        });
        this.debug(this.pattern, set);
        this.set = set.filter((s9) => s9.indexOf(false) === -1);
        if (this.isWindows) {
          for (let i10 = 0; i10 < this.set.length; i10++) {
            const p17 = this.set[i10];
            if (p17[0] === "" && p17[1] === "" && this.globParts[i10][2] === "?" && typeof p17[3] === "string" && /^[a-z]:$/i.test(p17[3])) {
              p17[2] = "?";
            }
          }
        }
        this.debug(this.pattern, this.set);
      }
      // various transforms to equivalent pattern sets that are
      // faster to process in a filesystem walk.  The goal is to
      // eliminate what we can, and push all ** patterns as far
      // to the right as possible, even if it increases the number
      // of patterns that we have to process.
      preprocess(globParts) {
        if (this.options.noglobstar) {
          for (let i10 = 0; i10 < globParts.length; i10++) {
            for (let j12 = 0; j12 < globParts[i10].length; j12++) {
              if (globParts[i10][j12] === "**") {
                globParts[i10][j12] = "*";
              }
            }
          }
        }
        const { optimizationLevel = 1 } = this.options;
        if (optimizationLevel >= 2) {
          globParts = this.firstPhasePreProcess(globParts);
          globParts = this.secondPhasePreProcess(globParts);
        } else if (optimizationLevel >= 1) {
          globParts = this.levelOneOptimize(globParts);
        } else {
          globParts = this.adjascentGlobstarOptimize(globParts);
        }
        return globParts;
      }
      // just get rid of adjascent ** portions
      adjascentGlobstarOptimize(globParts) {
        return globParts.map((parts) => {
          let gs2 = -1;
          while (-1 !== (gs2 = parts.indexOf("**", gs2 + 1))) {
            let i10 = gs2;
            while (parts[i10 + 1] === "**") {
              i10++;
            }
            if (i10 !== gs2) {
              parts.splice(gs2, i10 - gs2);
            }
          }
          return parts;
        });
      }
      // get rid of adjascent ** and resolve .. portions
      levelOneOptimize(globParts) {
        return globParts.map((parts) => {
          parts = parts.reduce((set, part) => {
            const prev = set[set.length - 1];
            if (part === "**" && prev === "**") {
              return set;
            }
            if (part === "..") {
              if (prev && prev !== ".." && prev !== "." && prev !== "**") {
                set.pop();
                return set;
              }
            }
            set.push(part);
            return set;
          }, []);
          return parts.length === 0 ? [""] : parts;
        });
      }
      levelTwoFileOptimize(parts) {
        if (!Array.isArray(parts)) {
          parts = this.slashSplit(parts);
        }
        let didSomething = false;
        do {
          didSomething = false;
          if (!this.preserveMultipleSlashes) {
            for (let i10 = 1; i10 < parts.length - 1; i10++) {
              const p17 = parts[i10];
              if (i10 === 1 && p17 === "" && parts[0] === "")
                continue;
              if (p17 === "." || p17 === "") {
                didSomething = true;
                parts.splice(i10, 1);
                i10--;
              }
            }
            if (parts[0] === "." && parts.length === 2 && (parts[1] === "." || parts[1] === "")) {
              didSomething = true;
              parts.pop();
            }
          }
          let dd = 0;
          while (-1 !== (dd = parts.indexOf("..", dd + 1))) {
            const p17 = parts[dd - 1];
            if (p17 && p17 !== "." && p17 !== ".." && p17 !== "**") {
              didSomething = true;
              parts.splice(dd - 1, 2);
              dd -= 2;
            }
          }
        } while (didSomething);
        return parts.length === 0 ? [""] : parts;
      }
      // First phase: single-pattern processing
      // <pre> is 1 or more portions
      // <rest> is 1 or more portions
      // <p> is any portion other than ., .., '', or **
      // <e> is . or ''
      //
      // **/.. is *brutal* for filesystem walking performance, because
      // it effectively resets the recursive walk each time it occurs,
      // and ** cannot be reduced out by a .. pattern part like a regexp
      // or most strings (other than .., ., and '') can be.
      //
      // <pre>/**/../<p>/<p>/<rest> -> {<pre>/../<p>/<p>/<rest>,<pre>/**/<p>/<p>/<rest>}
      // <pre>/<e>/<rest> -> <pre>/<rest>
      // <pre>/<p>/../<rest> -> <pre>/<rest>
      // **/**/<rest> -> **/<rest>
      //
      // **/*/<rest> -> */**/<rest> <== not valid because ** doesn't follow
      // this WOULD be allowed if ** did follow symlinks, or * didn't
      firstPhasePreProcess(globParts) {
        let didSomething = false;
        do {
          didSomething = false;
          for (let parts of globParts) {
            let gs2 = -1;
            while (-1 !== (gs2 = parts.indexOf("**", gs2 + 1))) {
              let gss = gs2;
              while (parts[gss + 1] === "**") {
                gss++;
              }
              if (gss > gs2) {
                parts.splice(gs2 + 1, gss - gs2);
              }
              let next2 = parts[gs2 + 1];
              const p17 = parts[gs2 + 2];
              const p22 = parts[gs2 + 3];
              if (next2 !== "..")
                continue;
              if (!p17 || p17 === "." || p17 === ".." || !p22 || p22 === "." || p22 === "..") {
                continue;
              }
              didSomething = true;
              parts.splice(gs2, 1);
              const other = parts.slice(0);
              other[gs2] = "**";
              globParts.push(other);
              gs2--;
            }
            if (!this.preserveMultipleSlashes) {
              for (let i10 = 1; i10 < parts.length - 1; i10++) {
                const p17 = parts[i10];
                if (i10 === 1 && p17 === "" && parts[0] === "")
                  continue;
                if (p17 === "." || p17 === "") {
                  didSomething = true;
                  parts.splice(i10, 1);
                  i10--;
                }
              }
              if (parts[0] === "." && parts.length === 2 && (parts[1] === "." || parts[1] === "")) {
                didSomething = true;
                parts.pop();
              }
            }
            let dd = 0;
            while (-1 !== (dd = parts.indexOf("..", dd + 1))) {
              const p17 = parts[dd - 1];
              if (p17 && p17 !== "." && p17 !== ".." && p17 !== "**") {
                didSomething = true;
                const needDot = dd === 1 && parts[dd + 1] === "**";
                const splin = needDot ? ["."] : [];
                parts.splice(dd - 1, 2, ...splin);
                if (parts.length === 0)
                  parts.push("");
                dd -= 2;
              }
            }
          }
        } while (didSomething);
        return globParts;
      }
      // second phase: multi-pattern dedupes
      // {<pre>/*/<rest>,<pre>/<p>/<rest>} -> <pre>/*/<rest>
      // {<pre>/<rest>,<pre>/<rest>} -> <pre>/<rest>
      // {<pre>/**/<rest>,<pre>/<rest>} -> <pre>/**/<rest>
      //
      // {<pre>/**/<rest>,<pre>/**/<p>/<rest>} -> <pre>/**/<rest>
      // ^-- not valid because ** doens't follow symlinks
      secondPhasePreProcess(globParts) {
        for (let i10 = 0; i10 < globParts.length - 1; i10++) {
          for (let j12 = i10 + 1; j12 < globParts.length; j12++) {
            const matched = this.partsMatch(globParts[i10], globParts[j12], !this.preserveMultipleSlashes);
            if (matched) {
              globParts[i10] = [];
              globParts[j12] = matched;
              break;
            }
          }
        }
        return globParts.filter((gs2) => gs2.length);
      }
      partsMatch(a7, b25, emptyGSMatch = false) {
        let ai2 = 0;
        let bi2 = 0;
        let result = [];
        let which = "";
        while (ai2 < a7.length && bi2 < b25.length) {
          if (a7[ai2] === b25[bi2]) {
            result.push(which === "b" ? b25[bi2] : a7[ai2]);
            ai2++;
            bi2++;
          } else if (emptyGSMatch && a7[ai2] === "**" && b25[bi2] === a7[ai2 + 1]) {
            result.push(a7[ai2]);
            ai2++;
          } else if (emptyGSMatch && b25[bi2] === "**" && a7[ai2] === b25[bi2 + 1]) {
            result.push(b25[bi2]);
            bi2++;
          } else if (a7[ai2] === "*" && b25[bi2] && (this.options.dot || !b25[bi2].startsWith(".")) && b25[bi2] !== "**") {
            if (which === "b")
              return false;
            which = "a";
            result.push(a7[ai2]);
            ai2++;
            bi2++;
          } else if (b25[bi2] === "*" && a7[ai2] && (this.options.dot || !a7[ai2].startsWith(".")) && a7[ai2] !== "**") {
            if (which === "a")
              return false;
            which = "b";
            result.push(b25[bi2]);
            ai2++;
            bi2++;
          } else {
            return false;
          }
        }
        return a7.length === b25.length && result;
      }
      parseNegate() {
        if (this.nonegate)
          return;
        const pattern = this.pattern;
        let negate = false;
        let negateOffset = 0;
        for (let i10 = 0; i10 < pattern.length && pattern.charAt(i10) === "!"; i10++) {
          negate = !negate;
          negateOffset++;
        }
        if (negateOffset)
          this.pattern = pattern.slice(negateOffset);
        this.negate = negate;
      }
      // set partial to true to test if, for example,
      // "/a/b" matches the start of "/*/b/*/d"
      // Partial means, if you run out of file before you run
      // out of pattern, then that's fine, as long as all
      // the parts match.
      matchOne(file, pattern, partial = false) {
        let fileStartIndex = 0;
        let patternStartIndex = 0;
        if (this.isWindows) {
          const fileDrive = typeof file[0] === "string" && /^[a-z]:$/i.test(file[0]);
          const fileUNC = !fileDrive && file[0] === "" && file[1] === "" && file[2] === "?" && /^[a-z]:$/i.test(file[3]);
          const patternDrive = typeof pattern[0] === "string" && /^[a-z]:$/i.test(pattern[0]);
          const patternUNC = !patternDrive && pattern[0] === "" && pattern[1] === "" && pattern[2] === "?" && typeof pattern[3] === "string" && /^[a-z]:$/i.test(pattern[3]);
          const fdi = fileUNC ? 3 : fileDrive ? 0 : void 0;
          const pdi = patternUNC ? 3 : patternDrive ? 0 : void 0;
          if (typeof fdi === "number" && typeof pdi === "number") {
            const [fd, pd] = [
              file[fdi],
              pattern[pdi]
            ];
            if (fd.toLowerCase() === pd.toLowerCase()) {
              pattern[pdi] = fd;
              patternStartIndex = pdi;
              fileStartIndex = fdi;
            }
          }
        }
        const { optimizationLevel = 1 } = this.options;
        if (optimizationLevel >= 2) {
          file = this.levelTwoFileOptimize(file);
        }
        if (pattern.includes(GLOBSTAR)) {
          return this.#matchGlobstar(file, pattern, partial, fileStartIndex, patternStartIndex);
        }
        return this.#matchOne(file, pattern, partial, fileStartIndex, patternStartIndex);
      }
      #matchGlobstar(file, pattern, partial, fileIndex, patternIndex) {
        const firstgs = pattern.indexOf(GLOBSTAR, patternIndex);
        const lastgs = pattern.lastIndexOf(GLOBSTAR);
        const [head, body, tail] = partial ? [
          pattern.slice(patternIndex, firstgs),
          pattern.slice(firstgs + 1),
          []
        ] : [
          pattern.slice(patternIndex, firstgs),
          pattern.slice(firstgs + 1, lastgs),
          pattern.slice(lastgs + 1)
        ];
        if (head.length) {
          const fileHead = file.slice(fileIndex, fileIndex + head.length);
          if (!this.#matchOne(fileHead, head, partial, 0, 0)) {
            return false;
          }
          fileIndex += head.length;
          patternIndex += head.length;
        }
        let fileTailMatch = 0;
        if (tail.length) {
          if (tail.length + fileIndex > file.length)
            return false;
          let tailStart = file.length - tail.length;
          if (this.#matchOne(file, tail, partial, tailStart, 0)) {
            fileTailMatch = tail.length;
          } else {
            if (file[file.length - 1] !== "" || fileIndex + tail.length === file.length) {
              return false;
            }
            tailStart--;
            if (!this.#matchOne(file, tail, partial, tailStart, 0)) {
              return false;
            }
            fileTailMatch = tail.length + 1;
          }
        }
        if (!body.length) {
          let sawSome = !!fileTailMatch;
          for (let i11 = fileIndex; i11 < file.length - fileTailMatch; i11++) {
            const f11 = String(file[i11]);
            sawSome = true;
            if (f11 === "." || f11 === ".." || !this.options.dot && f11.startsWith(".")) {
              return false;
            }
          }
          return partial || sawSome;
        }
        const bodySegments = [[[], 0]];
        let currentBody = bodySegments[0];
        let nonGsParts = 0;
        const nonGsPartsSums = [0];
        for (const b25 of body) {
          if (b25 === GLOBSTAR) {
            nonGsPartsSums.push(nonGsParts);
            currentBody = [[], 0];
            bodySegments.push(currentBody);
          } else {
            currentBody[0].push(b25);
            nonGsParts++;
          }
        }
        let i10 = bodySegments.length - 1;
        const fileLength = file.length - fileTailMatch;
        for (const b25 of bodySegments) {
          b25[1] = fileLength - (nonGsPartsSums[i10--] + b25[0].length);
        }
        return !!this.#matchGlobStarBodySections(file, bodySegments, fileIndex, 0, partial, 0, !!fileTailMatch);
      }
      // return false for "nope, not matching"
      // return null for "not matching, cannot keep trying"
      #matchGlobStarBodySections(file, bodySegments, fileIndex, bodyIndex, partial, globStarDepth, sawTail) {
        const bs3 = bodySegments[bodyIndex];
        if (!bs3) {
          for (let i10 = fileIndex; i10 < file.length; i10++) {
            sawTail = true;
            const f11 = file[i10];
            if (f11 === "." || f11 === ".." || !this.options.dot && f11.startsWith(".")) {
              return false;
            }
          }
          return sawTail;
        }
        const [body, after] = bs3;
        while (fileIndex <= after) {
          const m25 = this.#matchOne(file.slice(0, fileIndex + body.length), body, partial, fileIndex, 0);
          if (m25 && globStarDepth < this.maxGlobstarRecursion) {
            const sub = this.#matchGlobStarBodySections(file, bodySegments, fileIndex + body.length, bodyIndex + 1, partial, globStarDepth + 1, sawTail);
            if (sub !== false) {
              return sub;
            }
          }
          const f11 = file[fileIndex];
          if (f11 === "." || f11 === ".." || !this.options.dot && f11.startsWith(".")) {
            return false;
          }
          fileIndex++;
        }
        return partial || null;
      }
      #matchOne(file, pattern, partial, fileIndex, patternIndex) {
        let fi2;
        let pi2;
        let pl2;
        let fl2;
        for (fi2 = fileIndex, pi2 = patternIndex, fl2 = file.length, pl2 = pattern.length; fi2 < fl2 && pi2 < pl2; fi2++, pi2++) {
          this.debug("matchOne loop");
          let p17 = pattern[pi2];
          let f11 = file[fi2];
          this.debug(pattern, p17, f11);
          if (p17 === false || p17 === GLOBSTAR) {
            return false;
          }
          let hit;
          if (typeof p17 === "string") {
            hit = f11 === p17;
            this.debug("string match", p17, f11, hit);
          } else {
            hit = p17.test(f11);
            this.debug("pattern match", p17, f11, hit);
          }
          if (!hit)
            return false;
        }
        if (fi2 === fl2 && pi2 === pl2) {
          return true;
        } else if (fi2 === fl2) {
          return partial;
        } else if (pi2 === pl2) {
          return fi2 === fl2 - 1 && file[fi2] === "";
        } else {
          throw new Error("wtf?");
        }
      }
      braceExpand() {
        return braceExpand(this.pattern, this.options);
      }
      parse(pattern) {
        assertValidPattern(pattern);
        const options = this.options;
        if (pattern === "**")
          return GLOBSTAR;
        if (pattern === "")
          return "";
        let m25;
        let fastTest = null;
        if (m25 = pattern.match(starRE)) {
          fastTest = options.dot ? starTestDot : starTest;
        } else if (m25 = pattern.match(starDotExtRE)) {
          fastTest = (options.nocase ? options.dot ? starDotExtTestNocaseDot : starDotExtTestNocase : options.dot ? starDotExtTestDot : starDotExtTest)(m25[1]);
        } else if (m25 = pattern.match(qmarksRE)) {
          fastTest = (options.nocase ? options.dot ? qmarksTestNocaseDot : qmarksTestNocase : options.dot ? qmarksTestDot : qmarksTest)(m25);
        } else if (m25 = pattern.match(starDotStarRE)) {
          fastTest = options.dot ? starDotStarTestDot : starDotStarTest;
        } else if (m25 = pattern.match(dotStarRE)) {
          fastTest = dotStarTest;
        }
        const re5 = AST.fromGlob(pattern, this.options).toMMPattern();
        if (fastTest && typeof re5 === "object") {
          Reflect.defineProperty(re5, "test", { value: fastTest });
        }
        return re5;
      }
      makeRe() {
        if (this.regexp || this.regexp === false)
          return this.regexp;
        const set = this.set;
        if (!set.length) {
          this.regexp = false;
          return this.regexp;
        }
        const options = this.options;
        const twoStar = options.noglobstar ? star2 : options.dot ? twoStarDot : twoStarNoDot;
        const flags = new Set(options.nocase ? ["i"] : []);
        let re5 = set.map((pattern) => {
          const pp = pattern.map((p17) => {
            if (p17 instanceof RegExp) {
              for (const f11 of p17.flags.split(""))
                flags.add(f11);
            }
            return typeof p17 === "string" ? regExpEscape2(p17) : p17 === GLOBSTAR ? GLOBSTAR : p17._src;
          });
          pp.forEach((p17, i10) => {
            const next2 = pp[i10 + 1];
            const prev = pp[i10 - 1];
            if (p17 !== GLOBSTAR || prev === GLOBSTAR) {
              return;
            }
            if (prev === void 0) {
              if (next2 !== void 0 && next2 !== GLOBSTAR) {
                pp[i10 + 1] = "(?:\\/|" + twoStar + "\\/)?" + next2;
              } else {
                pp[i10] = twoStar;
              }
            } else if (next2 === void 0) {
              pp[i10 - 1] = prev + "(?:\\/|\\/" + twoStar + ")?";
            } else if (next2 !== GLOBSTAR) {
              pp[i10 - 1] = prev + "(?:\\/|\\/" + twoStar + "\\/)" + next2;
              pp[i10 + 1] = GLOBSTAR;
            }
          });
          const filtered = pp.filter((p17) => p17 !== GLOBSTAR);
          if (this.partial && filtered.length >= 1) {
            const prefixes = [];
            for (let i10 = 1; i10 <= filtered.length; i10++) {
              prefixes.push(filtered.slice(0, i10).join("/"));
            }
            return "(?:" + prefixes.join("|") + ")";
          }
          return filtered.join("/");
        }).join("|");
        const [open2, close] = set.length > 1 ? ["(?:", ")"] : ["", ""];
        re5 = "^" + open2 + re5 + close + "$";
        if (this.partial) {
          re5 = "^(?:\\/|" + open2 + re5.slice(1, -1) + close + ")$";
        }
        if (this.negate)
          re5 = "^(?!" + re5 + ").+$";
        try {
          this.regexp = new RegExp(re5, [...flags].join(""));
        } catch (ex) {
          this.regexp = false;
        }
        return this.regexp;
      }
      slashSplit(p17) {
        if (this.preserveMultipleSlashes) {
          return p17.split("/");
        } else if (this.isWindows && /^\/\/[^\/]+/.test(p17)) {
          return ["", ...p17.split(/\/+/)];
        } else {
          return p17.split(/\/+/);
        }
      }
      match(f11, partial = this.partial) {
        this.debug("match", f11, this.pattern);
        if (this.comment) {
          return false;
        }
        if (this.empty) {
          return f11 === "";
        }
        if (f11 === "/" && partial) {
          return true;
        }
        const options = this.options;
        if (this.isWindows) {
          f11 = f11.split("\\").join("/");
        }
        const ff = this.slashSplit(f11);
        this.debug(this.pattern, "split", ff);
        const set = this.set;
        this.debug(this.pattern, "set", set);
        let filename = ff[ff.length - 1];
        if (!filename) {
          for (let i10 = ff.length - 2; !filename && i10 >= 0; i10--) {
            filename = ff[i10];
          }
        }
        for (let i10 = 0; i10 < set.length; i10++) {
          const pattern = set[i10];
          let file = ff;
          if (options.matchBase && pattern.length === 1) {
            file = [filename];
          }
          const hit = this.matchOne(file, pattern, partial);
          if (hit) {
            if (options.flipNegate) {
              return true;
            }
            return !this.negate;
          }
        }
        if (options.flipNegate) {
          return false;
        }
        return this.negate;
      }
      static defaults(def) {
        return minimatch.defaults(def).Minimatch;
      }
    };
    minimatch.AST = AST;
    minimatch.Minimatch = Minimatch;
    minimatch.escape = escape;
    minimatch.unescape = unescape;
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-KY5VPZXG.js
function A(a7) {
  if (a7 < 1024) return String(a7);
  if (a7 < 1024 * 1024) {
    let n23 = a7 / 1024;
    return n23 < 10 ? `${n23.toFixed(1)}K` : `${Math.round(n23)}K`;
  }
  if (a7 < 1024 * 1024 * 1024) {
    let n23 = a7 / 1048576;
    return n23 < 10 ? `${n23.toFixed(1)}M` : `${Math.round(n23)}M`;
  }
  let r8 = a7 / (1024 * 1024 * 1024);
  return r8 < 10 ? `${r8.toFixed(1)}G` : `${Math.round(r8)}G`;
}
function F4(a7) {
  let n23 = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"][a7.getMonth()], g18 = String(a7.getDate()).padStart(2, " "), $18 = /* @__PURE__ */ new Date(), y18 = new Date($18.getTime() - 4320 * 60 * 60 * 1e3);
  if (a7 > y18) {
    let w19 = String(a7.getHours()).padStart(2, "0"), S17 = String(a7.getMinutes()).padStart(2, "0");
    return `${n23} ${g18} ${w19}:${S17}`;
  }
  let b25 = a7.getFullYear();
  return `${n23} ${g18}  ${b25}`;
}
async function _3(a7, r8, n23, g18, $18, y18 = false, b25 = false, w19 = false) {
  let S17 = n23 || g18, z10 = r8.fs.getAllPaths(), C19 = r8.fs.resolvePath(r8.cwd, "."), m25 = [];
  for (let o9 of z10) {
    let i10 = o9.startsWith(C19) && o9.slice(C19.length + 1) || o9;
    if (minimatch(i10, a7) || minimatch(o9, a7)) {
      let c15 = i10.split("/").pop() || i10;
      if (!S17 && c15.startsWith(".")) continue;
      m25.push(i10 || o9);
    }
  }
  if (m25.length === 0) return { stdout: "", stderr: `ls: ${a7}: No such file or directory
`, exitCode: 2 };
  if (w19) {
    let o9 = [];
    for (let i10 of m25) {
      let c15 = r8.fs.resolvePath(r8.cwd, i10);
      try {
        let u11 = await r8.fs.stat(c15);
        o9.push({ path: i10, size: u11.size ?? 0 });
      } catch {
        o9.push({ path: i10, size: 0 });
      }
    }
    o9.sort((i10, c15) => c15.size - i10.size), m25.length = 0, m25.push(...o9.map((i10) => i10.path));
  } else m25.sort();
  if (y18 && m25.reverse(), $18) {
    let o9 = [];
    for (let i10 of m25) {
      let c15 = r8.fs.resolvePath(r8.cwd, i10);
      try {
        let u11 = await r8.fs.stat(c15), f11 = u11.isDirectory ? "drwxr-xr-x" : "-rw-r--r--", e7 = u11.isDirectory ? "/" : "", l8 = u11.size ?? 0, s9 = b25 ? A(l8).padStart(5) : String(l8).padStart(5), t6 = u11.mtime ?? /* @__PURE__ */ new Date(0), d16 = F4(t6);
        o9.push(`${f11} 1 user user ${s9} ${d16} ${i10}${e7}`);
      } catch {
        o9.push(`-rw-r--r-- 1 user user     0 Jan  1 00:00 ${i10}`);
      }
    }
    return { stdout: `${o9.join(`
`)}
`, stderr: "", exitCode: 0 };
  }
  return { stdout: `${m25.join(`
`)}
`, stderr: "", exitCode: 0 };
}
async function E2(a7, r8, n23, g18, $18, y18, b25, w19 = false, S17 = false, z10 = false, C19 = false) {
  let m25 = n23 || g18, o9 = r8.fs.resolvePath(r8.cwd, a7);
  try {
    let i10 = await r8.fs.stat(o9);
    if (!i10.isDirectory) {
      if ($18) {
        let f11 = i10.size ?? 0, e7 = S17 ? A(f11).padStart(5) : String(f11).padStart(5), l8 = i10.mtime ?? /* @__PURE__ */ new Date(0), s9 = F4(l8);
        return { stdout: `-rw-r--r-- 1 user user ${e7} ${s9} ${a7}
`, stderr: "", exitCode: 0 };
      }
      return { stdout: `${a7}
`, stderr: "", exitCode: 0 };
    }
    let c15 = await r8.fs.readdir(o9);
    if (m25 || (c15 = c15.filter((f11) => !f11.startsWith("."))), z10) {
      let f11 = [];
      for (let e7 of c15) {
        let l8 = o9 === "/" ? `/${e7}` : `${o9}/${e7}`;
        try {
          let s9 = await r8.fs.stat(l8);
          f11.push({ name: e7, size: s9.size ?? 0 });
        } catch {
          f11.push({ name: e7, size: 0 });
        }
      }
      f11.sort((e7, l8) => l8.size - e7.size), c15 = f11.map((e7) => e7.name);
    } else c15.sort();
    n23 && (c15 = [".", "..", ...c15]), w19 && c15.reverse();
    let u11 = "";
    if ((y18 || b25) && (u11 += `${a7}:
`), $18) {
      u11 += `total ${c15.length}
`;
      let f11 = c15.filter((t6) => t6 === "." || t6 === ".."), e7 = c15.filter((t6) => t6 !== "." && t6 !== "..");
      for (let t6 of f11) u11 += `drwxr-xr-x 1 user user     0 Jan  1 00:00 ${t6}
`;
      let l8 = [];
      for (let t6 = 0; t6 < e7.length; t6 += 100) {
        let d16 = e7.slice(t6, t6 + 100), h17 = await Promise.all(d16.map(async (p17) => {
          let D15 = o9 === "/" ? `/${p17}` : `${o9}/${p17}`;
          try {
            let P20 = await r8.fs.stat(D15), O17 = P20.isDirectory ? "drwxr-xr-x" : "-rw-r--r--", R13 = P20.isDirectory ? "/" : "", x23 = P20.size ?? 0, B12 = S17 ? A(x23).padStart(5) : String(x23).padStart(5), J15 = P20.mtime ?? /* @__PURE__ */ new Date(0), N15 = F4(J15);
            return { name: p17, line: `${O17} 1 user user ${B12} ${N15} ${p17}${R13}
` };
          } catch {
            return { name: p17, line: `-rw-r--r-- 1 user user     0 Jan  1 00:00 ${p17}
` };
          }
        }));
        l8.push(...h17);
      }
      let s9 = new Map(e7.map((t6, d16) => [t6, d16]));
      l8.sort((t6, d16) => (s9.get(t6.name) ?? 0) - (s9.get(d16.name) ?? 0));
      for (let { line: t6 } of l8) u11 += t6;
    } else u11 += c15.join(`
`) + (c15.length ? `
` : "");
    if (y18) {
      let f11 = c15.filter((s9) => s9 !== "." && s9 !== ".."), e7 = [];
      if (r8.fs.readdirWithFileTypes) e7 = (await r8.fs.readdirWithFileTypes(o9)).filter((t6) => t6.isDirectory && f11.includes(t6.name)).map((t6) => ({ name: t6.name, isDirectory: true }));
      else for (let s9 = 0; s9 < f11.length; s9 += 100) {
        let t6 = f11.slice(s9, s9 + 100), d16 = await Promise.all(t6.map(async (h17) => {
          let p17 = o9 === "/" ? `/${h17}` : `${o9}/${h17}`;
          try {
            let D15 = await r8.fs.stat(p17);
            return { name: h17, isDirectory: D15.isDirectory };
          } catch {
            return { name: h17, isDirectory: false };
          }
        }));
        e7.push(...d16.filter((h17) => h17.isDirectory));
      }
      e7.sort((s9, t6) => s9.name.localeCompare(t6.name)), w19 && e7.reverse();
      let l8 = [];
      for (let s9 = 0; s9 < e7.length; s9 += 100) {
        let t6 = e7.slice(s9, s9 + 100), d16 = await Promise.all(t6.map(async (h17) => {
          let p17 = a7 === "." ? `./${h17.name}` : `${a7}/${h17.name}`, D15 = await E2(p17, r8, n23, g18, $18, y18, false, w19, S17, z10, true);
          return { name: h17.name, result: D15 };
        }));
        l8.push(...d16);
      }
      l8.sort((s9, t6) => s9.name.localeCompare(t6.name)), w19 && l8.reverse();
      for (let { result: s9 } of l8) u11 += `
`, u11 += s9.stdout;
    }
    return { stdout: u11, stderr: "", exitCode: 0 };
  } catch {
    return { stdout: "", stderr: `ls: ${a7}: No such file or directory
`, exitCode: 2 };
  }
}
var G2, L4, U3, Y2;
var init_chunk_KY5VPZXG = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-KY5VPZXG.js"() {
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    init_esm3();
    G2 = { name: "ls", summary: "list directory contents", usage: "ls [OPTION]... [FILE]...", options: ["-a, --all            do not ignore entries starting with .", "-A, --almost-all     do not list . and ..", "-d, --directory      list directories themselves, not their contents", "-h, --human-readable with -l, print sizes like 1K 234M 2G etc.", "-l                   use a long listing format", "-r, --reverse        reverse order while sorting", "-R, --recursive      list subdirectories recursively", "-S                   sort by file size, largest first", "-t                   sort by time, newest first", "-1                   list one file per line", "    --help           display this help and exit"] };
    L4 = { showAll: { short: "a", long: "all", type: "boolean" }, showAlmostAll: { short: "A", long: "almost-all", type: "boolean" }, longFormat: { short: "l", type: "boolean" }, humanReadable: { short: "h", long: "human-readable", type: "boolean" }, recursive: { short: "R", long: "recursive", type: "boolean" }, reverse: { short: "r", long: "reverse", type: "boolean" }, sortBySize: { short: "S", type: "boolean" }, directoryOnly: { short: "d", long: "directory", type: "boolean" }, sortByTime: { short: "t", type: "boolean" }, onePerLine: { short: "1", type: "boolean" } };
    U3 = { name: "ls", async execute(a7, r8) {
      if (o2(a7)) return s(G2);
      let n23 = x5("ls", a7, L4);
      if (!n23.ok) return n23.error;
      let g18 = n23.result.flags.showAll, $18 = n23.result.flags.showAlmostAll, y18 = n23.result.flags.longFormat, b25 = n23.result.flags.humanReadable, w19 = n23.result.flags.recursive, S17 = n23.result.flags.reverse, z10 = n23.result.flags.sortBySize, C19 = n23.result.flags.directoryOnly, m25 = n23.result.flags.sortByTime;
      n23.result.flags.onePerLine;
      let o9 = n23.result.positional;
      o9.length === 0 && o9.push(".");
      let i10 = "", c15 = "", u11 = 0;
      for (let f11 = 0; f11 < o9.length; f11++) {
        let e7 = o9[f11];
        if (f11 > 0 && i10 && !i10.endsWith(`

`) && (i10 += `
`), C19) {
          let l8 = r8.fs.resolvePath(r8.cwd, e7);
          try {
            let s9 = await r8.fs.stat(l8);
            if (y18) {
              let t6 = s9.isDirectory ? "drwxr-xr-x" : "-rw-r--r--", d16 = s9.isDirectory ? "/" : "", h17 = s9.size ?? 0, p17 = b25 ? A(h17).padStart(5) : String(h17).padStart(5), D15 = s9.mtime ?? /* @__PURE__ */ new Date(0), P20 = F4(D15);
              i10 += `${t6} 1 user user ${p17} ${P20} ${e7}${d16}
`;
            } else i10 += `${e7}
`;
          } catch {
            c15 += `ls: cannot access '${e7}': No such file or directory
`, u11 = 2;
          }
          continue;
        }
        if (e7.includes("*") || e7.includes("?") || e7.includes("[")) {
          let l8 = await _3(e7, r8, g18, $18, y18, S17, b25, z10);
          i10 += l8.stdout, c15 += l8.stderr, l8.exitCode !== 0 && (u11 = l8.exitCode);
        } else {
          let l8 = await E2(e7, r8, g18, $18, y18, w19, o9.length > 1, S17, b25, z10);
          i10 += l8.stdout, c15 += l8.stderr, l8.exitCode !== 0 && (u11 = l8.exitCode);
        }
      }
      return { stdout: i10, stderr: c15, exitCode: u11 };
    } };
    Y2 = { name: "ls", flags: [{ flag: "-a", type: "boolean" }, { flag: "-A", type: "boolean" }, { flag: "-l", type: "boolean" }, { flag: "-h", type: "boolean" }, { flag: "-R", type: "boolean" }, { flag: "-r", type: "boolean" }, { flag: "-S", type: "boolean" }, { flag: "-d", type: "boolean" }, { flag: "-t", type: "boolean" }, { flag: "-1", type: "boolean" }], needsFiles: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/ls-OTONBH2E.js
var ls_OTONBH2E_exports = {};
__export(ls_OTONBH2E_exports, {
  flagsForFuzzing: () => Y2,
  lsCommand: () => U3
});
var init_ls_OTONBH2E = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/ls-OTONBH2E.js"() {
    init_chunk_KY5VPZXG();
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-XZ3MZS57.js
var g4, k3, v5;
var init_chunk_XZ3MZS57 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-XZ3MZS57.js"() {
    init_chunk_HWKDQ44K();
    init_chunk_44UOCSGV();
    g4 = { recursive: { short: "p", long: "parents", type: "boolean" }, verbose: { short: "v", long: "verbose", type: "boolean" } };
    k3 = { name: "mkdir", async execute(f11, o9) {
      let e7 = x5("mkdir", f11, g4);
      if (!e7.ok) return e7.error;
      let u11 = e7.result.flags.recursive, m25 = e7.result.flags.verbose, i10 = e7.result.positional;
      if (i10.length === 0) return { stdout: "", stderr: `mkdir: missing operand
`, exitCode: 1 };
      let a7 = "", t6 = "", c15 = 0;
      for (let r8 of i10) try {
        let n23 = o9.fs.resolvePath(o9.cwd, r8);
        await o9.fs.mkdir(n23, { recursive: u11 }), m25 && (a7 += `mkdir: created directory '${r8}'
`);
      } catch (n23) {
        let s9 = n17(n23);
        s9.includes("ENOENT") || s9.includes("no such file") ? t6 += `mkdir: cannot create directory '${r8}': No such file or directory
` : s9.includes("EEXIST") || s9.includes("already exists") ? t6 += `mkdir: cannot create directory '${r8}': File exists
` : t6 += `mkdir: cannot create directory '${r8}': ${s9}
`, c15 = 1;
      }
      return { stdout: a7, stderr: t6, exitCode: c15 };
    } };
    v5 = { name: "mkdir", flags: [{ flag: "-p", type: "boolean" }, { flag: "-v", type: "boolean" }], needsArgs: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/mkdir-QWGXDWUS.js
var mkdir_QWGXDWUS_exports = {};
__export(mkdir_QWGXDWUS_exports, {
  flagsForFuzzing: () => v5,
  mkdirCommand: () => k3
});
var init_mkdir_QWGXDWUS = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/mkdir-QWGXDWUS.js"() {
    init_chunk_XZ3MZS57();
    init_chunk_HWKDQ44K();
    init_chunk_44UOCSGV();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-OCS6LSEM.js
async function b5(t6, r8, e7, a7) {
  let o9 = "", s9 = "", n23 = t6.fs.resolvePath(t6.cwd, r8), i10 = await v6(t6, n23, r8, a7);
  if (o9 += i10.stdout, s9 += i10.stderr, i10.exitCode !== 0) return { stdout: o9, stderr: s9, exitCode: i10.exitCode };
  if (e7) {
    let u11 = n23, d16 = r8;
    for (; ; ) {
      let l8 = C2(u11), f11 = C2(d16);
      if (l8 === u11 || l8 === "/" || l8 === "." || f11 === "." || f11 === "") break;
      let m25 = await v6(t6, l8, f11, a7);
      if (o9 += m25.stdout, m25.exitCode !== 0) break;
      u11 = l8, d16 = f11;
    }
  }
  return { stdout: o9, stderr: s9, exitCode: 0 };
}
async function v6(t6, r8, e7, a7) {
  try {
    if (!await t6.fs.exists(r8)) return { stdout: "", stderr: `rmdir: failed to remove '${e7}': No such file or directory
`, exitCode: 1 };
    if (!(await t6.fs.stat(r8)).isDirectory) return { stdout: "", stderr: `rmdir: failed to remove '${e7}': Not a directory
`, exitCode: 1 };
    if ((await t6.fs.readdir(r8)).length > 0) return { stdout: "", stderr: `rmdir: failed to remove '${e7}': Directory not empty
`, exitCode: 1 };
    await t6.fs.rm(r8, { recursive: false, force: false });
    let n23 = "";
    return a7 && (n23 = `rmdir: removing directory, '${e7}'
`), { stdout: n23, stderr: "", exitCode: 0 };
  } catch (o9) {
    let s9 = n17(o9);
    return { stdout: "", stderr: `rmdir: failed to remove '${e7}': ${s9}
`, exitCode: 1 };
  }
}
function C2(t6) {
  let r8 = t6.replace(/\/+$/, ""), e7 = r8.lastIndexOf("/");
  return e7 === -1 ? "." : e7 === 0 ? "/" : r8.substring(0, e7);
}
var x6, y4, D2, $4;
var init_chunk_OCS6LSEM = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-OCS6LSEM.js"() {
    init_chunk_HWKDQ44K();
    init_chunk_44UOCSGV();
    x6 = `Usage: rmdir [-pv] DIRECTORY...
Remove empty directories.

Options:
  -p, --parents   Remove DIRECTORY and its ancestors
  -v, --verbose   Output a diagnostic for every directory processed`;
    y4 = { parents: { short: "p", long: "parents", type: "boolean" }, verbose: { short: "v", long: "verbose", type: "boolean" }, help: { long: "help", type: "boolean" } };
    D2 = { name: "rmdir", async execute(t6, r8) {
      let e7 = x5("rmdir", t6, y4);
      if (!e7.ok) return e7.error;
      if (e7.result.flags.help) return { stdout: `${x6}
`, stderr: "", exitCode: 0 };
      let a7 = e7.result.flags.parents, o9 = e7.result.flags.verbose, s9 = e7.result.positional;
      if (s9.length === 0) return { stdout: "", stderr: `rmdir: missing operand
`, exitCode: 1 };
      let c15 = "", n23 = "", i10 = 0;
      for (let u11 of s9) {
        let d16 = await b5(r8, u11, a7, o9);
        c15 += d16.stdout, n23 += d16.stderr, d16.exitCode !== 0 && (i10 = d16.exitCode);
      }
      return { stdout: c15, stderr: n23, exitCode: i10 };
    } };
    $4 = { name: "rmdir", flags: [{ flag: "-p", type: "boolean" }, { flag: "-v", type: "boolean" }], needsArgs: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/rmdir-XTQXT7RK.js
var rmdir_XTQXT7RK_exports = {};
__export(rmdir_XTQXT7RK_exports, {
  flagsForFuzzing: () => $4,
  rmdirCommand: () => D2
});
var init_rmdir_XTQXT7RK = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/rmdir-XTQXT7RK.js"() {
    init_chunk_OCS6LSEM();
    init_chunk_HWKDQ44K();
    init_chunk_44UOCSGV();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-OCLXQMOG.js
function h4(s9) {
  let a7 = s9.replace(/\//g, "-"), r8 = new Date(a7);
  if (!Number.isNaN(r8.getTime())) return r8;
  let i10 = a7.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (i10) {
    let [, o9, l8, f11] = i10;
    if (r8 = new Date(Number.parseInt(o9, 10), Number.parseInt(l8, 10) - 1, Number.parseInt(f11, 10)), !Number.isNaN(r8.getTime())) return r8;
  }
  let u11 = a7.match(/^(\d{4})-(\d{2})-(\d{2})\s+(\d{2}):(\d{2}):(\d{2})$/);
  if (u11) {
    let [, o9, l8, f11, t6, e7, d16] = u11;
    if (r8 = new Date(Number.parseInt(o9, 10), Number.parseInt(l8, 10) - 1, Number.parseInt(f11, 10), Number.parseInt(t6, 10), Number.parseInt(e7, 10), Number.parseInt(d16, 10)), !Number.isNaN(r8.getTime())) return r8;
  }
  return null;
}
var N4, b6;
var init_chunk_OCLXQMOG = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-OCLXQMOG.js"() {
    init_chunk_44UOCSGV();
    init_chunk_74CEPOFO();
    N4 = { name: "touch", async execute(s9, a7) {
      let r8 = [], i10 = null, u11 = false;
      for (let t6 = 0; t6 < s9.length; t6++) {
        let e7 = s9[t6];
        if (e7 === "--") {
          r8.push(...s9.slice(t6 + 1));
          break;
        } else if (e7 === "-d" || e7 === "--date") {
          if (t6 + 1 >= s9.length) return { stdout: "", stderr: `touch: option requires an argument -- 'd'
`, exitCode: 1 };
          i10 = s9[++t6];
        } else if (e7.startsWith("--date=")) i10 = e7.slice(7);
        else if (e7 === "-c" || e7 === "--no-create") u11 = true;
        else if (e7 === "-a" || e7 === "-m" || e7 === "-r" || e7 === "-t") (e7 === "-r" || e7 === "-t") && t6++;
        else {
          if (e7.startsWith("--")) return r3("touch", e7);
          if (e7.startsWith("-") && e7.length > 1) {
            let d16 = false;
            for (let n23 of e7.slice(1)) if (n23 === "c") u11 = true;
            else if (!(n23 === "a" || n23 === "m")) if (n23 === "d") {
              if (t6 + 1 >= s9.length) return { stdout: "", stderr: `touch: option requires an argument -- 'd'
`, exitCode: 1 };
              i10 = s9[++t6], d16 = true;
              break;
            } else if (n23 === "r" || n23 === "t") {
              t6++, d16 = true;
              break;
            } else return r3("touch", `-${n23}`);
            if (d16) continue;
          } else r8.push(e7);
        }
      }
      if (r8.length === 0) return { stdout: "", stderr: `touch: missing file operand
`, exitCode: 1 };
      let o9 = null;
      if (i10 !== null && (o9 = h4(i10), o9 === null)) return { stdout: "", stderr: `touch: invalid date format '${i10}'
`, exitCode: 1 };
      let l8 = "", f11 = 0;
      for (let t6 of r8) try {
        let e7 = a7.fs.resolvePath(a7.cwd, t6);
        if (!await a7.fs.exists(e7)) {
          if (u11) continue;
          await a7.fs.writeFile(e7, "");
        }
        let n23 = o9 ?? /* @__PURE__ */ new Date();
        await a7.fs.utimes(e7, n23, n23);
      } catch (e7) {
        l8 += `touch: cannot touch '${t6}': ${n17(e7)}
`, f11 = 1;
      }
      return { stdout: "", stderr: l8, exitCode: f11 };
    } };
    b6 = { name: "touch", flags: [{ flag: "-c", type: "boolean" }, { flag: "-a", type: "boolean" }, { flag: "-m", type: "boolean" }, { flag: "-d", type: "value", valueHint: "string" }], needsArgs: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/touch-DX2IJOQ4.js
var touch_DX2IJOQ4_exports = {};
__export(touch_DX2IJOQ4_exports, {
  flagsForFuzzing: () => b6,
  touchCommand: () => N4
});
var init_touch_DX2IJOQ4 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/touch-DX2IJOQ4.js"() {
    init_chunk_OCLXQMOG();
    init_chunk_44UOCSGV();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-27LMNKBP.js
var d5, b7, h5;
var init_chunk_27LMNKBP = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-27LMNKBP.js"() {
    init_chunk_HWKDQ44K();
    init_chunk_44UOCSGV();
    d5 = { recursive: { short: "r", long: "recursive", type: "boolean" }, recursiveUpper: { short: "R", type: "boolean" }, force: { short: "f", long: "force", type: "boolean" }, verbose: { short: "v", long: "verbose", type: "boolean" } };
    b7 = { name: "rm", async execute(p17, s9) {
      let e7 = x5("rm", p17, d5);
      if (!e7.ok) return e7.error;
      let c15 = e7.result.flags.recursive || e7.result.flags.recursiveUpper, a7 = e7.result.flags.force, g18 = e7.result.flags.verbose, i10 = e7.result.positional;
      if (i10.length === 0) return a7 ? { stdout: "", stderr: "", exitCode: 0 } : { stdout: "", stderr: `rm: missing operand
`, exitCode: 1 };
      let f11 = "", t6 = "", l8 = 0;
      for (let r8 of i10) try {
        let n23 = s9.fs.resolvePath(s9.cwd, r8);
        if ((await s9.fs.stat(n23)).isDirectory && !c15) {
          t6 += `rm: cannot remove '${r8}': Is a directory
`, l8 = 1;
          continue;
        }
        await s9.fs.rm(n23, { recursive: c15, force: a7 }), g18 && (f11 += `removed '${r8}'
`);
      } catch (n23) {
        if (!a7) {
          let o9 = n17(n23);
          o9.includes("ENOENT") || o9.includes("no such file") ? t6 += `rm: cannot remove '${r8}': No such file or directory
` : o9.includes("ENOTEMPTY") || o9.includes("not empty") ? t6 += `rm: cannot remove '${r8}': Directory not empty
` : t6 += `rm: cannot remove '${r8}': ${o9}
`, l8 = 1;
        }
      }
      return { stdout: f11, stderr: t6, exitCode: l8 };
    } };
    h5 = { name: "rm", flags: [{ flag: "-r", type: "boolean" }, { flag: "-R", type: "boolean" }, { flag: "-f", type: "boolean" }, { flag: "-v", type: "boolean" }], needsArgs: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/rm-KPTLPKPH.js
var rm_KPTLPKPH_exports = {};
__export(rm_KPTLPKPH_exports, {
  flagsForFuzzing: () => h5,
  rmCommand: () => b7
});
var init_rm_KPTLPKPH = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/rm-KPTLPKPH.js"() {
    init_chunk_27LMNKBP();
    init_chunk_HWKDQ44K();
    init_chunk_44UOCSGV();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-NUYSJFDK.js
var D3, E3, A2, F5;
var init_chunk_NUYSJFDK = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-NUYSJFDK.js"() {
    init_chunk_HWKDQ44K();
    init_chunk_44UOCSGV();
    init_chunk_74CEPOFO();
    D3 = { name: "cp", summary: "copy files and directories", usage: "cp [OPTION]... SOURCE... DEST", options: ["-r, -R, --recursive  copy directories recursively", "-n, --no-clobber     do not overwrite an existing file", "-p, --preserve       preserve file attributes", "-v, --verbose        explain what is being done", "    --help           display this help and exit"] };
    E3 = { recursive: { short: "r", long: "recursive", type: "boolean" }, recursiveUpper: { short: "R", type: "boolean" }, noClobber: { short: "n", long: "no-clobber", type: "boolean" }, preserve: { short: "p", long: "preserve", type: "boolean" }, verbose: { short: "v", long: "verbose", type: "boolean" } };
    A2 = { name: "cp", async execute(f11, e7) {
      if (o2(f11)) return s(D3);
      let t6 = x5("cp", f11, E3);
      if (!t6.ok) return t6.error;
      let u11 = t6.result.flags.recursive || t6.result.flags.recursiveUpper, w19 = t6.result.flags.noClobber, C19 = t6.result.flags.preserve, P20 = t6.result.flags.verbose, c15 = t6.result.positional;
      if (c15.length < 2) return { stdout: "", stderr: `cp: missing destination file operand
`, exitCode: 1 };
      let g18 = c15.pop() ?? "", d16 = c15, o9 = e7.fs.resolvePath(e7.cwd, g18), b25 = "", n23 = "", l8 = 0, p17 = false;
      try {
        p17 = (await e7.fs.stat(o9)).isDirectory;
      } catch {
      }
      if (d16.length > 1 && !p17) return { stdout: "", stderr: `cp: target '${g18}' is not a directory
`, exitCode: 1 };
      for (let r8 of d16) try {
        let a7 = e7.fs.resolvePath(e7.cwd, r8), s9 = await e7.fs.stat(a7), i10 = o9;
        if (p17) {
          let v21 = r8.split("/").pop() || r8;
          i10 = o9 === "/" ? `/${v21}` : `${o9}/${v21}`;
        }
        if (s9.isDirectory && !u11) {
          n23 += `cp: -r not specified; omitting directory '${r8}'
`, l8 = 1;
          continue;
        }
        if (w19) try {
          await e7.fs.stat(i10);
          continue;
        } catch {
        }
        await e7.fs.cp(a7, i10, { recursive: u11 }), P20 && (b25 += `'${r8}' -> '${i10}'
`);
      } catch (a7) {
        let s9 = n17(a7);
        s9.includes("ENOENT") || s9.includes("no such file") ? n23 += `cp: cannot stat '${r8}': No such file or directory
` : n23 += `cp: cannot copy '${r8}': ${s9}
`, l8 = 1;
      }
      return { stdout: b25, stderr: n23, exitCode: l8 };
    } };
    F5 = { name: "cp", flags: [{ flag: "-r", type: "boolean" }, { flag: "-R", type: "boolean" }, { flag: "-n", type: "boolean" }, { flag: "-p", type: "boolean" }, { flag: "-v", type: "boolean" }], needsArgs: true, minArgs: 2 };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/cp-XOYR4ABJ.js
var cp_XOYR4ABJ_exports = {};
__export(cp_XOYR4ABJ_exports, {
  cpCommand: () => A2,
  flagsForFuzzing: () => F5
});
var init_cp_XOYR4ABJ = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/cp-XOYR4ABJ.js"() {
    init_chunk_NUYSJFDK();
    init_chunk_HWKDQ44K();
    init_chunk_44UOCSGV();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-A4JSPFCI.js
var C3, P4, O3, x7;
var init_chunk_A4JSPFCI = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-A4JSPFCI.js"() {
    init_chunk_HWKDQ44K();
    init_chunk_44UOCSGV();
    init_chunk_74CEPOFO();
    C3 = { name: "mv", summary: "move (rename) files", usage: "mv [OPTION]... SOURCE... DEST", options: ["-f, --force       do not prompt before overwriting", "-n, --no-clobber  do not overwrite an existing file", "-v, --verbose     explain what is being done", "    --help        display this help and exit"] };
    P4 = { force: { short: "f", long: "force", type: "boolean" }, noClobber: { short: "n", long: "no-clobber", type: "boolean" }, verbose: { short: "v", long: "verbose", type: "boolean" } };
    O3 = { name: "mv", async execute(m25, t6) {
      if (o2(m25)) return s(C3);
      let s9 = x5("mv", m25, P4);
      if (!s9.ok) return s9.error;
      let p17 = s9.result.flags.force, d16 = s9.result.flags.noClobber, w19 = s9.result.flags.verbose, i10 = s9.result.positional;
      if (d16 && (p17 = false), i10.length < 2) return { stdout: "", stderr: `mv: missing destination file operand
`, exitCode: 1 };
      let r8 = i10.pop() ?? "", g18 = i10, n23 = t6.fs.resolvePath(t6.cwd, r8), v21 = "", f11 = "", b25 = 0, a7 = false;
      try {
        a7 = (await t6.fs.stat(n23)).isDirectory;
      } catch {
      }
      if (g18.length > 1 && !a7) return { stdout: "", stderr: `mv: target '${r8}' is not a directory
`, exitCode: 1 };
      for (let e7 of g18) try {
        let c15 = t6.fs.resolvePath(t6.cwd, e7), o9 = n23;
        if (a7) {
          let l8 = e7.split("/").pop() || e7;
          o9 = n23 === "/" ? `/${l8}` : `${n23}/${l8}`;
        }
        if (d16) try {
          await t6.fs.stat(o9);
          continue;
        } catch {
        }
        if (await t6.fs.mv(c15, o9), w19) {
          let l8 = a7 ? `${r8}/${e7.split("/").pop() || e7}` : r8;
          v21 += `renamed '${e7}' -> '${l8}'
`;
        }
      } catch (c15) {
        let o9 = n17(c15);
        o9.includes("ENOENT") || o9.includes("no such file") ? f11 += `mv: cannot stat '${e7}': No such file or directory
` : f11 += `mv: cannot move '${e7}': ${o9}
`, b25 = 1;
      }
      return { stdout: v21, stderr: f11, exitCode: b25 };
    } };
    x7 = { name: "mv", flags: [{ flag: "-f", type: "boolean" }, { flag: "-n", type: "boolean" }, { flag: "-v", type: "boolean" }], needsArgs: true, minArgs: 2 };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/mv-Z6MORUFL.js
var mv_Z6MORUFL_exports = {};
__export(mv_Z6MORUFL_exports, {
  flagsForFuzzing: () => x7,
  mvCommand: () => O3
});
var init_mv_Z6MORUFL = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/mv-Z6MORUFL.js"() {
    init_chunk_A4JSPFCI();
    init_chunk_HWKDQ44K();
    init_chunk_44UOCSGV();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-SL4FN3A5.js
var g5, p4, b8;
var init_chunk_SL4FN3A5 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-SL4FN3A5.js"() {
    init_chunk_74CEPOFO();
    g5 = { name: "ln", summary: "make links between files", usage: "ln [OPTIONS] TARGET LINK_NAME", options: ["-s      create a symbolic link instead of a hard link", "-f      remove existing destination files", "-n      treat LINK_NAME as a normal file if it is a symbolic link to a directory", "-v      print name of each linked file", "    --help display this help and exit"] };
    p4 = { name: "ln", async execute(n23, s9) {
      if (o2(n23)) return s(g5);
      let l8 = false, a7 = false, f11 = false, t6 = 0;
      for (; t6 < n23.length && n23[t6].startsWith("-"); ) {
        let e7 = n23[t6];
        if (e7 === "-s" || e7 === "--symbolic") l8 = true, t6++;
        else if (e7 === "-f" || e7 === "--force") a7 = true, t6++;
        else if (e7 === "-v" || e7 === "--verbose") f11 = true, t6++;
        else if (e7 === "-n" || e7 === "--no-dereference") t6++;
        else if (/^-[sfvn]+$/.test(e7)) e7.includes("s") && (l8 = true), e7.includes("f") && (a7 = true), e7.includes("v") && (f11 = true), t6++;
        else if (e7 === "--") {
          t6++;
          break;
        } else return { stdout: "", stderr: `ln: invalid option -- '${e7.slice(1)}'
`, exitCode: 1 };
      }
      let d16 = n23.slice(t6);
      if (d16.length < 2) return { stdout: "", stderr: `ln: missing file operand
`, exitCode: 1 };
      let i10 = d16[0], r8 = d16[1], o9 = s9.fs.resolvePath(s9.cwd, r8);
      if (await s9.fs.exists(o9)) if (a7) try {
        await s9.fs.rm(o9, { force: true });
      } catch {
        return { stdout: "", stderr: `ln: cannot remove '${r8}': Permission denied
`, exitCode: 1 };
      }
      else return { stdout: "", stderr: `ln: failed to create ${l8 ? "symbolic " : ""}link '${r8}': File exists
`, exitCode: 1 };
      try {
        if (l8) await s9.fs.symlink(i10, o9);
        else {
          let e7 = s9.fs.resolvePath(s9.cwd, i10);
          if (!await s9.fs.exists(e7)) return { stdout: "", stderr: `ln: failed to access '${i10}': No such file or directory
`, exitCode: 1 };
          await s9.fs.link(e7, o9);
        }
      } catch (e7) {
        let u11 = e7;
        return u11.message.includes("EPERM") ? { stdout: "", stderr: `ln: '${i10}': hard link not allowed for directory
`, exitCode: 1 } : { stdout: "", stderr: `ln: ${u11.message}
`, exitCode: 1 };
      }
      let c15 = "";
      return f11 && (c15 = `'${r8}' -> '${i10}'
`), { stdout: c15, stderr: "", exitCode: 0 };
    } };
    b8 = { name: "ln", flags: [{ flag: "-s", type: "boolean" }, { flag: "-f", type: "boolean" }, { flag: "-n", type: "boolean" }, { flag: "-v", type: "boolean" }], needsArgs: true, minArgs: 2 };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/ln-YAIFIHCT.js
var ln_YAIFIHCT_exports = {};
__export(ln_YAIFIHCT_exports, {
  flagsForFuzzing: () => b8,
  lnCommand: () => p4
});
var init_ln_YAIFIHCT = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/ln-YAIFIHCT.js"() {
    init_chunk_SL4FN3A5();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-GZ2N3SXD.js
async function $5(s9, a7, e7, c15, o9) {
  let n23 = "", l8 = await s9.fs.readdir(a7);
  for (let r8 of l8) {
    let i10 = a7 === "/" ? `/${r8}` : `${a7}/${r8}`, f11;
    if (e7 !== void 0) f11 = e7;
    else if (c15 !== void 0) {
      let u11 = await s9.fs.stat(i10);
      f11 = p5(c15, u11.mode);
    } else f11 = 420;
    await s9.fs.chmod(i10, f11), o9 && (n23 += `mode of '${i10}' changed to ${f11.toString(8).padStart(4, "0")}
`), (await s9.fs.stat(i10)).isDirectory && (n23 += await $5(s9, i10, e7, c15, o9));
  }
  return n23;
}
function p5(s9, a7 = 420) {
  if (/^[0-7]+$/.test(s9)) return parseInt(s9, 8);
  let e7 = a7 & 4095, c15 = s9.split(",");
  for (let o9 of c15) {
    let n23 = o9.match(/^([ugoa]*)([+\-=])([rwxXst]*)$/);
    if (!n23) throw new Error(`Invalid mode: ${s9}`);
    let l8 = n23[1] || "a", r8 = n23[2], i10 = n23[3];
    (l8 === "a" || l8 === "") && (l8 = "ugo");
    let f11 = 0;
    i10.includes("r") && (f11 |= 4), i10.includes("w") && (f11 |= 2), (i10.includes("x") || i10.includes("X")) && (f11 |= 1);
    let d16 = 0;
    i10.includes("s") && (l8.includes("u") && (d16 |= 2048), l8.includes("g") && (d16 |= 1024)), i10.includes("t") && (d16 |= 512);
    for (let u11 of l8) {
      let t6 = 0;
      u11 === "u" ? t6 = 6 : u11 === "g" ? t6 = 3 : u11 === "o" && (t6 = 0);
      let h17 = f11 << t6;
      r8 === "+" ? e7 |= h17 : r8 === "-" ? e7 &= ~h17 : r8 === "=" && (e7 &= ~(7 << t6), e7 |= h17);
    }
    r8 === "+" ? e7 |= d16 : r8 === "-" ? e7 &= ~d16 : r8 === "=" && (i10.includes("s") && (l8.includes("u") && (e7 &= -2049, e7 |= d16 & 2048), l8.includes("g") && (e7 &= -1025, e7 |= d16 & 1024)), i10.includes("t") && (e7 &= -513, e7 |= d16 & 512));
  }
  return e7;
}
var C4, R3, b9;
var init_chunk_GZ2N3SXD = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-GZ2N3SXD.js"() {
    init_chunk_74CEPOFO();
    C4 = { name: "chmod", summary: "change file mode bits", usage: "chmod [OPTIONS] MODE FILE...", options: ["-R      change files recursively", "-v      output a diagnostic for every file processed", "    --help display this help and exit"] };
    R3 = { name: "chmod", async execute(s9, a7) {
      if (o2(s9)) return s(C4);
      if (s9.length < 2) return { stdout: "", stderr: `chmod: missing operand
`, exitCode: 1 };
      let e7 = false, c15 = false, o9 = 0;
      for (; o9 < s9.length && s9[o9].startsWith("-"); ) {
        let t6 = s9[o9];
        if (t6 === "-R" || t6 === "--recursive") e7 = true, o9++;
        else if (t6 === "-v" || t6 === "--verbose") c15 = true, o9++;
        else if (t6 === "--") {
          o9++;
          break;
        } else {
          if (/^[+-]?[rwxugo]+/.test(t6) || /^\d+$/.test(t6)) break;
          if (/^-[Rv]+$/.test(t6)) {
            t6.includes("R") && (e7 = true), t6.includes("v") && (c15 = true), o9++;
            continue;
          }
          return { stdout: "", stderr: `chmod: invalid option -- '${t6.slice(1)}'
`, exitCode: 1 };
        }
      }
      if (s9.length - o9 < 2) return { stdout: "", stderr: `chmod: missing operand
`, exitCode: 1 };
      let n23 = s9[o9], l8 = s9.slice(o9 + 1), r8 = /^[0-7]+$/.test(n23), i10;
      if (r8) i10 = parseInt(n23, 8);
      else try {
        p5(n23, 420);
      } catch {
        return { stdout: "", stderr: `chmod: invalid mode: '${n23}'
`, exitCode: 1 };
      }
      let f11 = "", d16 = "", u11 = false;
      for (let t6 of l8) {
        let h17 = a7.fs.resolvePath(a7.cwd, t6);
        try {
          let m25;
          if (r8 && i10 !== void 0) m25 = i10;
          else {
            let g18 = await a7.fs.stat(h17);
            m25 = p5(n23, g18.mode);
          }
          if (await a7.fs.chmod(h17, m25), c15 && (f11 += `mode of '${t6}' changed to ${m25.toString(8).padStart(4, "0")}
`), e7 && (await a7.fs.stat(h17)).isDirectory) {
            let y18 = await $5(a7, h17, r8 ? i10 : void 0, r8 ? void 0 : n23, c15);
            f11 += y18;
          }
        } catch {
          d16 += `chmod: cannot access '${t6}': No such file or directory
`, u11 = true;
        }
      }
      return { stdout: f11, stderr: d16, exitCode: u11 ? 1 : 0 };
    } };
    b9 = { name: "chmod", flags: [{ flag: "-R", type: "boolean" }, { flag: "-v", type: "boolean" }], needsArgs: true, minArgs: 2 };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chmod-MIKE3OIT.js
var chmod_MIKE3OIT_exports = {};
__export(chmod_MIKE3OIT_exports, {
  chmodCommand: () => R3,
  flagsForFuzzing: () => b9
});
var init_chmod_MIKE3OIT = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chmod-MIKE3OIT.js"() {
    init_chunk_GZ2N3SXD();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-A4HU7SVR.js
var o3, f5;
var init_chunk_A4HU7SVR = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-A4HU7SVR.js"() {
    o3 = { name: "pwd", async execute(l8, a7) {
      let t6 = false;
      for (let e7 of l8) if (e7 === "-P") t6 = true;
      else if (e7 === "-L") t6 = false;
      else {
        if (e7 === "--") break;
        e7.startsWith("-");
      }
      let s9 = a7.cwd;
      if (t6) try {
        s9 = await a7.fs.realpath(a7.cwd);
      } catch {
      }
      return { stdout: `${s9}
`, stderr: "", exitCode: 0 };
    } };
    f5 = { name: "pwd", flags: [{ flag: "-P", type: "boolean" }, { flag: "-L", type: "boolean" }] };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/pwd-D4OZ7N27.js
var pwd_D4OZ7N27_exports = {};
__export(pwd_D4OZ7N27_exports, {
  flagsForFuzzing: () => f5,
  pwdCommand: () => o3
});
var init_pwd_D4OZ7N27 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/pwd-D4OZ7N27.js"() {
    init_chunk_A4HU7SVR();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-IKZ5LEGB.js
var k4, g6, y5;
var init_chunk_IKZ5LEGB = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-IKZ5LEGB.js"() {
    init_chunk_74CEPOFO();
    k4 = { name: "readlink", summary: "print resolved symbolic links or canonical file names", usage: "readlink [OPTIONS] FILE...", options: ["-f      canonicalize by following every symlink in every component of the given name recursively", "    --help display this help and exit"] };
    g6 = { name: "readlink", async execute(i10, a7) {
      if (o2(i10)) return s(k4);
      let r8 = false, n23 = 0;
      for (; n23 < i10.length && i10[n23].startsWith("-"); ) {
        let t6 = i10[n23];
        if (t6 === "-f" || t6 === "--canonicalize") r8 = true, n23++;
        else if (t6 === "--") {
          n23++;
          break;
        } else return { stdout: "", stderr: `readlink: invalid option -- '${t6.slice(1)}'
`, exitCode: 1 };
      }
      let d16 = i10.slice(n23);
      if (d16.length === 0) return { stdout: "", stderr: `readlink: missing operand
`, exitCode: 1 };
      let l8 = "", f11 = false;
      for (let t6 of d16) {
        let s9 = a7.fs.resolvePath(a7.cwd, t6);
        try {
          if (r8) {
            let e7 = s9, c15 = /* @__PURE__ */ new Set();
            for (; !c15.has(e7); ) {
              c15.add(e7);
              try {
                let o9 = await a7.fs.readlink(e7);
                if (o9.startsWith("/")) e7 = o9;
                else {
                  let p17 = e7.substring(0, e7.lastIndexOf("/")) || "/";
                  e7 = a7.fs.resolvePath(p17, o9);
                }
              } catch {
                break;
              }
            }
            l8 += `${e7}
`;
          } else {
            let e7 = await a7.fs.readlink(s9);
            l8 += `${e7}
`;
          }
        } catch {
          r8 ? l8 += `${s9}
` : f11 = true;
        }
      }
      return { stdout: l8, stderr: "", exitCode: f11 ? 1 : 0 };
    } };
    y5 = { name: "readlink", flags: [{ flag: "-f", type: "boolean" }, { flag: "-e", type: "boolean" }], needsArgs: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/readlink-IEQO24KU.js
var readlink_IEQO24KU_exports = {};
__export(readlink_IEQO24KU_exports, {
  flagsForFuzzing: () => y5,
  readlinkCommand: () => g6
});
var init_readlink_IEQO24KU = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/readlink-IEQO24KU.js"() {
    init_chunk_IKZ5LEGB();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-HDQ56CKY.js
function I3(t6, r8) {
  let i10 = 10, s9 = null, o9 = false, l8 = false, n23 = false, u11 = [];
  for (let f11 = 0; f11 < t6.length; f11++) {
    let e7 = t6[f11];
    if (e7 === "-n" && f11 + 1 < t6.length) {
      let a7 = t6[++f11];
      r8 === "tail" && a7.startsWith("+") ? (n23 = true, i10 = parseInt(a7.slice(1), 10)) : i10 = parseInt(a7, 10);
    } else if (r8 === "tail" && e7.startsWith("-n+")) n23 = true, i10 = parseInt(e7.slice(3), 10);
    else if (e7.startsWith("-n")) i10 = parseInt(e7.slice(2), 10);
    else if (e7 === "-c" && f11 + 1 < t6.length) s9 = parseInt(t6[++f11], 10);
    else if (e7.startsWith("-c")) s9 = parseInt(e7.slice(2), 10);
    else if (e7.startsWith("--bytes=")) s9 = parseInt(e7.slice(8), 10);
    else if (e7.startsWith("--lines=")) i10 = parseInt(e7.slice(8), 10);
    else if (e7 === "-q" || e7 === "--quiet" || e7 === "--silent") o9 = true;
    else if (e7 === "-v" || e7 === "--verbose") l8 = true;
    else if (e7.match(/^-\d+$/)) i10 = parseInt(e7.slice(1), 10);
    else {
      if (e7.startsWith("--")) return { ok: false, error: r3(r8, e7) };
      if (e7.startsWith("-") && e7 !== "-") return { ok: false, error: r3(r8, e7) };
      u11.push(e7);
    }
  }
  return s9 !== null && (Number.isNaN(s9) || s9 < 0) ? { ok: false, error: { stdout: "", stderr: `${r8}: invalid number of bytes
`, exitCode: 1 } } : Number.isNaN(i10) || i10 < 0 ? { ok: false, error: { stdout: "", stderr: `${r8}: invalid number of lines
`, exitCode: 1 } } : { ok: true, options: { lines: i10, bytes: s9, quiet: o9, verbose: l8, files: u11, fromLine: n23 } };
}
async function W3(t6, r8, i10, s9) {
  let { quiet: o9, verbose: l8, files: n23 } = r8;
  if (n23.length === 0) return { stdout: s9(t6.stdin), stderr: "", exitCode: 0 };
  let u11 = "", f11 = "", e7 = 0, a7 = l8 || !o9 && n23.length > 1, h17 = 0;
  for (let d16 = 0; d16 < n23.length; d16++) {
    let p17 = n23[d16];
    try {
      let b25 = t6.fs.resolvePath(t6.cwd, p17), x23 = await t6.fs.readFile(b25);
      a7 && (h17 > 0 && (u11 += `
`), u11 += `==> ${p17} <==
`), u11 += s9(x23), h17++;
    } catch {
      f11 += `${i10}: ${p17}: No such file or directory
`, e7 = 1;
    }
  }
  return { stdout: u11, stderr: f11, exitCode: e7 };
}
function $6(t6, r8, i10) {
  if (i10 !== null) return t6.slice(0, i10);
  if (r8 === 0) return "";
  let s9 = 0, o9 = 0, l8 = t6.length;
  for (; s9 < l8 && o9 < r8; ) {
    let n23 = t6.indexOf(`
`, s9);
    if (n23 === -1) return `${t6}
`;
    o9++, s9 = n23 + 1;
  }
  return s9 > 0 ? t6.slice(0, s9) : "";
}
function g7(t6, r8, i10, s9) {
  if (i10 !== null) return t6.slice(-i10);
  let o9 = t6.length;
  if (o9 === 0) return "";
  if (s9) {
    let f11 = 0, e7 = 1;
    for (; f11 < o9 && e7 < r8; ) {
      let h17 = t6.indexOf(`
`, f11);
      if (h17 === -1) break;
      e7++, f11 = h17 + 1;
    }
    let a7 = t6.slice(f11);
    return a7.endsWith(`
`) ? a7 : `${a7}
`;
  }
  if (r8 === 0) return "";
  let l8 = o9 - 1;
  t6[l8] === `
` && l8--;
  let n23 = 0;
  for (; l8 >= 0 && n23 < r8; ) {
    if (t6[l8] === `
` && (n23++, n23 === r8)) {
      l8++;
      break;
    }
    l8--;
  }
  l8 < 0 && (l8 = 0);
  let u11 = t6.slice(l8);
  return t6[o9 - 1] === `
` ? u11 : `${u11}
`;
}
var init_chunk_HDQ56CKY = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-HDQ56CKY.js"() {
    init_chunk_74CEPOFO();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-64BAICW3.js
var f6, m5, g8;
var init_chunk_64BAICW3 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-64BAICW3.js"() {
    init_chunk_HDQ56CKY();
    init_chunk_74CEPOFO();
    f6 = { name: "head", summary: "output the first part of files", usage: "head [OPTION]... [FILE]...", options: ["-c, --bytes=NUM    print the first NUM bytes", "-n, --lines=NUM    print the first NUM lines (default 10)", "-q, --quiet        never print headers giving file names", "-v, --verbose      always print headers giving file names", "    --help         display this help and exit"] };
    m5 = { name: "head", async execute(t6, l8) {
      if (o2(t6)) return s(f6);
      let e7 = I3(t6, "head");
      if (!e7.ok) return e7.error;
      let { lines: o9, bytes: p17 } = e7.options;
      return W3(l8, e7.options, "head", (d16) => $6(d16, o9, p17));
    } };
    g8 = { name: "head", flags: [{ flag: "-n", type: "value", valueHint: "number" }, { flag: "-c", type: "value", valueHint: "number" }, { flag: "-q", type: "boolean" }, { flag: "-v", type: "boolean" }], stdinType: "text", needsFiles: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/head-HT2B6D2J.js
var head_HT2B6D2J_exports = {};
__export(head_HT2B6D2J_exports, {
  flagsForFuzzing: () => g8,
  headCommand: () => m5
});
var init_head_HT2B6D2J = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/head-HT2B6D2J.js"() {
    init_chunk_64BAICW3();
    init_chunk_HDQ56CKY();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-DCAAORBQ.js
var m6, d6, c5;
var init_chunk_DCAAORBQ = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-DCAAORBQ.js"() {
    init_chunk_HDQ56CKY();
    init_chunk_74CEPOFO();
    m6 = { name: "tail", summary: "output the last part of files", usage: "tail [OPTION]... [FILE]...", options: ["-c, --bytes=NUM    print the last NUM bytes", "-n, --lines=NUM    print the last NUM lines (default 10)", "-n +NUM            print starting from line NUM", "-q, --quiet        never print headers giving file names", "-v, --verbose      always print headers giving file names", "    --help         display this help and exit"] };
    d6 = { name: "tail", async execute(t6, r8) {
      if (o2(t6)) return s(m6);
      let e7 = I3(t6, "tail");
      if (!e7.ok) return e7.error;
      let { lines: o9, bytes: p17, fromLine: f11 } = e7.options;
      return W3(r8, e7.options, "tail", (u11) => g7(u11, o9, p17, f11 ?? false));
    } };
    c5 = { name: "tail", flags: [{ flag: "-n", type: "value", valueHint: "number" }, { flag: "-c", type: "value", valueHint: "number" }, { flag: "-q", type: "boolean" }, { flag: "-v", type: "boolean" }], stdinType: "text", needsFiles: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/tail-S5ULNTJU.js
var tail_S5ULNTJU_exports = {};
__export(tail_S5ULNTJU_exports, {
  flagsForFuzzing: () => c5,
  tailCommand: () => d6
});
var init_tail_S5ULNTJU = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/tail-S5ULNTJU.js"() {
    init_chunk_DCAAORBQ();
    init_chunk_HDQ56CKY();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-GXVXFKBA.js
function C5(a7) {
  let c15 = a7.length, n23 = 0, o9 = 0, e7 = false;
  for (let s9 = 0; s9 < c15; s9++) {
    let t6 = a7[s9];
    t6 === `
` ? (n23++, e7 && (o9++, e7 = false)) : t6 === " " || t6 === "	" || t6 === "\r" ? e7 && (o9++, e7 = false) : e7 = true;
  }
  return e7 && o9++, { lines: n23, words: o9, chars: c15 };
}
function w3(a7, c15, n23, o9, e7, s9) {
  let t6 = [];
  c15 && t6.push(String(a7.lines).padStart(s9)), n23 && t6.push(String(a7.words).padStart(s9)), o9 && t6.push(String(a7.chars).padStart(s9));
  let i10 = t6.join(" ");
  return e7 && (i10 += ` ${e7}`), i10;
}
var $7, H3, E4, I4;
var init_chunk_GXVXFKBA = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-GXVXFKBA.js"() {
    init_chunk_7L36YK2X();
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    $7 = { name: "wc", summary: "print newline, word, and byte counts for each file", usage: "wc [OPTION]... [FILE]...", options: ["-c, --bytes      print the byte counts", "-m, --chars      print the character counts", "-l, --lines      print the newline counts", "-w, --words      print the word counts", "    --help       display this help and exit"] };
    H3 = { lines: { short: "l", long: "lines", type: "boolean" }, words: { short: "w", long: "words", type: "boolean" }, bytes: { short: "c", long: "bytes", type: "boolean" }, chars: { short: "m", long: "chars", type: "boolean" } };
    E4 = { name: "wc", async execute(a7, c15) {
      if (o2(a7)) return s($7);
      let n23 = x5("wc", a7, H3);
      if (!n23.ok) return n23.error;
      let { lines: o9, words: e7 } = n23.result.flags, s9 = n23.result.flags.bytes || n23.result.flags.chars, t6 = n23.result.positional;
      !o9 && !e7 && !s9 && (o9 = e7 = s9 = true);
      let i10 = await y3(c15, t6, { cmdName: "wc", stopOnError: false });
      if (t6.length === 0) {
        let r8 = C5(i10.files[0].content);
        return { stdout: `${w3(r8, o9, e7, s9, "", 0)}
`, stderr: "", exitCode: 0 };
      }
      let h17 = [], p17 = 0, d16 = 0, u11 = 0;
      for (let { filename: r8, content: m25 } of i10.files) {
        let f11 = C5(m25);
        p17 += f11.lines, d16 += f11.words, u11 += f11.chars, h17.push({ filename: r8, stats: f11 });
      }
      let F21 = t6.length > 1 ? p17 : Math.max(...h17.map((r8) => r8.stats.lines)), M15 = t6.length > 1 ? d16 : Math.max(...h17.map((r8) => r8.stats.words)), L18 = t6.length > 1 ? u11 : Math.max(...h17.map((r8) => r8.stats.chars)), l8 = t6.length > 1 ? 3 : 0;
      o9 && (l8 = Math.max(l8, String(F21).length)), e7 && (l8 = Math.max(l8, String(M15).length)), s9 && (l8 = Math.max(l8, String(L18).length));
      let g18 = "";
      for (let { filename: r8, stats: m25 } of h17) g18 += `${w3(m25, o9, e7, s9, r8, l8)}
`;
      return t6.length > 1 && (g18 += `${w3({ lines: p17, words: d16, chars: u11 }, o9, e7, s9, "total", l8)}
`), { stdout: g18, stderr: i10.stderr, exitCode: i10.exitCode };
    } };
    I4 = { name: "wc", flags: [{ flag: "-l", type: "boolean" }, { flag: "-w", type: "boolean" }, { flag: "-c", type: "boolean" }, { flag: "-m", type: "boolean" }], stdinType: "text", needsFiles: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/wc-TQB3VNOX.js
var wc_TQB3VNOX_exports = {};
__export(wc_TQB3VNOX_exports, {
  flagsForFuzzing: () => I4,
  wcCommand: () => E4
});
var init_wc_TQB3VNOX = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/wc-TQB3VNOX.js"() {
    init_chunk_GXVXFKBA();
    init_chunk_7L36YK2X();
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-OFJTSXN6.js
function m7(e7, a7) {
  let s9 = a7 ? "d" : "-", l8 = [e7 & 256 ? "r" : "-", e7 & 128 ? "w" : "-", e7 & 64 ? "x" : "-", e7 & 32 ? "r" : "-", e7 & 16 ? "w" : "-", e7 & 8 ? "x" : "-", e7 & 4 ? "r" : "-", e7 & 2 ? "w" : "-", e7 & 1 ? "x" : "-"];
  return s9 + l8.join("");
}
var S3, $8, O4, w4;
var init_chunk_OFJTSXN6 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-OFJTSXN6.js"() {
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    S3 = { name: "stat", summary: "display file or file system status", usage: "stat [OPTION]... FILE...", options: ["-c FORMAT   use the specified FORMAT instead of the default", "    --help  display this help and exit"] };
    $8 = { format: { short: "c", type: "string" } };
    O4 = { name: "stat", async execute(e7, a7) {
      if (o2(e7)) return s(S3);
      let s9 = x5("stat", e7, $8);
      if (!s9.ok) return s9.error;
      let l8 = s9.result.flags.format ?? null, c15 = s9.result.positional;
      if (c15.length === 0) return { stdout: "", stderr: `stat: missing operand
`, exitCode: 1 };
      let o9 = "", p17 = "", f11 = false;
      for (let n23 of c15) {
        let h17 = a7.fs.resolvePath(a7.cwd, n23);
        try {
          let r8 = await a7.fs.stat(h17);
          if (l8) {
            let t6 = l8, i10 = r8.mode.toString(8), y18 = m7(r8.mode, r8.isDirectory);
            t6 = t6.replace(/%n/g, n23), t6 = t6.replace(/%N/g, `'${n23}'`), t6 = t6.replace(/%s/g, String(r8.size)), t6 = t6.replace(/%F/g, r8.isDirectory ? "directory" : "regular file"), t6 = t6.replace(/%a/g, i10), t6 = t6.replace(/%A/g, y18), t6 = t6.replace(/%u/g, "1000"), t6 = t6.replace(/%U/g, "user"), t6 = t6.replace(/%g/g, "1000"), t6 = t6.replace(/%G/g, "group"), o9 += `${t6}
`;
          } else {
            let t6 = r8.mode.toString(8).padStart(4, "0"), i10 = m7(r8.mode, r8.isDirectory);
            o9 += `  File: ${n23}
`, o9 += `  Size: ${r8.size}		Blocks: ${Math.ceil(r8.size / 512)}
`, o9 += `Access: (${t6}/${i10})
`, o9 += `Modify: ${r8.mtime.toISOString()}
`;
          }
        } catch {
          p17 += `stat: cannot stat '${n23}': No such file or directory
`, f11 = true;
        }
      }
      return { stdout: o9, stderr: p17, exitCode: f11 ? 1 : 0 };
    } };
    w4 = { name: "stat", flags: [{ flag: "-c", type: "value", valueHint: "format" }, { flag: "-L", type: "boolean" }], needsArgs: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/stat-74KBZFAX.js
var stat_74KBZFAX_exports = {};
__export(stat_74KBZFAX_exports, {
  flagsForFuzzing: () => w4,
  statCommand: () => O4
});
var init_stat_74KBZFAX = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/stat-74KBZFAX.js"() {
    init_chunk_OFJTSXN6();
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-IJXFPKNC.js
function h6(l8, c15, t6) {
  let s9 = typeof t6 == "boolean" ? { ignoreCase: t6 } : t6 ?? {}, e7 = c15;
  s9.stripQuotes && (e7.startsWith('"') && e7.endsWith('"') || e7.startsWith("'") && e7.endsWith("'")) && (e7 = e7.slice(1, -1));
  let i10 = s9.ignoreCase ? `i:${e7}` : e7, o9 = r5.get(i10);
  return o9 || (o9 = f7(e7, s9.ignoreCase), r5.set(i10, o9)), o9.test(l8);
}
function f7(l8, c15) {
  let t6 = "^";
  for (let s9 = 0; s9 < l8.length; s9++) {
    let e7 = l8[s9];
    if (e7 === "*") t6 += ".*";
    else if (e7 === "?") t6 += ".";
    else if (e7 === "[") {
      let i10 = s9 + 1;
      for (; i10 < l8.length && l8[i10] !== "]"; ) i10++;
      t6 += l8.slice(s9, i10 + 1), s9 = i10;
    } else e7 === "." || e7 === "+" || e7 === "^" || e7 === "$" || e7 === "{" || e7 === "}" || e7 === "(" || e7 === ")" || e7 === "|" || e7 === "\\" ? t6 += `\\${e7}` : t6 += e7;
  }
  return t6 += "$", b1(t6, c15 ? "i" : "");
}
var r5;
var init_chunk_IJXFPKNC = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-IJXFPKNC.js"() {
    init_chunk_YNYSPYQ5();
    r5 = /* @__PURE__ */ new Map();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-VLGZJRPG.js
function B3(n23, t6) {
  return n23.replace(/\$(&|\d+|<([^>]+)>)/g, (e7, i10, s9) => {
    if (i10 === "&") return t6[0];
    if (s9 !== void 0) return t6.groups?.[s9] ?? "";
    let h17 = parseInt(i10, 10);
    return t6[h17] ?? "";
  });
}
function D4(n23, t6, e7 = {}) {
  let { invertMatch: i10 = false, showLineNumbers: s9 = false, countOnly: h17 = false, countMatches: d16 = false, filename: a7 = "", onlyMatching: m25 = false, beforeContext: I18 = 0, afterContext: R13 = 0, maxCount: S17 = 0, contextSeparator: F21 = "--", showColumn: O17 = false, vimgrep: G9 = false, showByteOffset: P20 = false, replace: k17 = null, passthru: y18 = false, multiline: j12 = false, kResetGroup: A14 } = e7;
  if (j12) return Q4(n23, t6, { invertMatch: i10, showLineNumbers: s9, countOnly: h17, countMatches: d16, filename: a7, onlyMatching: m25, beforeContext: I18, afterContext: R13, maxCount: S17, contextSeparator: F21, showColumn: O17, showByteOffset: P20, replace: k17, kResetGroup: A14 });
  let x23 = n23.split(`
`), Z13 = x23.length, v21 = Z13 > 0 && x23[Z13 - 1] === "" ? Z13 - 1 : Z13;
  if (h17 || d16) {
    let f11 = 0, r8 = (d16 || m25) && !i10;
    for (let l8 = 0; l8 < v21; l8++) if (t6.lastIndex = 0, r8) for (let u11 = t6.exec(x23[l8]); u11 !== null; u11 = t6.exec(x23[l8])) f11++, u11[0].length === 0 && t6.lastIndex++;
    else t6.test(x23[l8]) !== i10 && f11++;
    return { output: `${a7 ? `${a7}:${f11}` : String(f11)}
`, matched: f11 > 0, matchCount: f11 };
  }
  if (I18 === 0 && R13 === 0 && !y18) {
    let f11 = [], r8 = false, o9 = 0, l8 = 0;
    for (let u11 = 0; u11 < v21 && !(S17 > 0 && o9 >= S17); u11++) {
      let L18 = x23[u11];
      if (t6.lastIndex = 0, t6.test(L18) !== i10) if (r8 = true, o9++, m25) {
        t6.lastIndex = 0;
        for (let $18 = t6.exec(L18); $18 !== null; $18 = t6.exec(L18)) {
          let b25 = A14 !== void 0 ? $18[A14] ?? "" : $18[0], T10 = k17 !== null ? B3(k17, $18) : b25, z10 = a7 ? `${a7}:` : "";
          P20 && (z10 += `${l8 + $18.index}:`), s9 && (z10 += `${u11 + 1}:`), O17 && (z10 += `${$18.index + 1}:`), f11.push(z10 + T10), $18[0].length === 0 && t6.lastIndex++;
        }
      } else if (G9) {
        t6.lastIndex = 0;
        for (let $18 = t6.exec(L18); $18 !== null; $18 = t6.exec(L18)) {
          let b25 = a7 ? `${a7}:` : "";
          P20 && (b25 += `${l8 + $18.index}:`), s9 && (b25 += `${u11 + 1}:`), O17 && (b25 += `${$18.index + 1}:`), f11.push(b25 + L18), $18[0].length === 0 && t6.lastIndex++;
        }
      } else {
        t6.lastIndex = 0;
        let $18 = t6.exec(L18), b25 = $18 ? $18.index + 1 : 1, T10 = L18;
        k17 !== null && (t6.lastIndex = 0, T10 = t6.replace(L18, (...M15) => {
          if (M15[0].length === 0) return "";
          let U14 = M15, _15 = M15[M15.length - 1];
          return typeof _15 == "object" && _15 !== null ? (U14.groups = _15, U14.input = M15[M15.length - 2], U14.index = M15[M15.length - 3]) : (U14.input = M15[M15.length - 1], U14.index = M15[M15.length - 2]), B3(k17, U14);
        }));
        let z10 = a7 ? `${a7}:` : "";
        P20 && (z10 += `${l8 + ($18 ? $18.index : 0)}:`), s9 && (z10 += `${u11 + 1}:`), O17 && (z10 += `${b25}:`), f11.push(z10 + T10);
      }
      l8 += L18.length + 1;
    }
    return { output: f11.length > 0 ? `${f11.join(`
`)}
` : "", matched: r8, matchCount: o9 };
  }
  if (y18) {
    let f11 = [], r8 = false, o9 = 0;
    for (let l8 = 0; l8 < v21; l8++) {
      let u11 = x23[l8];
      t6.lastIndex = 0;
      let E13 = t6.test(u11) !== i10;
      E13 && (r8 = true, o9++);
      let $18 = E13 ? ":" : "-", b25 = a7 ? `${a7}${$18}` : "";
      s9 && (b25 += `${l8 + 1}${$18}`), f11.push(b25 + u11);
    }
    return { output: f11.length > 0 ? `${f11.join(`
`)}
` : "", matched: r8, matchCount: o9 };
  }
  let g18 = [], w19 = 0, p17 = /* @__PURE__ */ new Set(), C19 = -1, c15 = [];
  for (let f11 = 0; f11 < v21 && !(S17 > 0 && w19 >= S17); f11++) t6.lastIndex = 0, t6.test(x23[f11]) !== i10 && (c15.push(f11), w19++);
  for (let f11 of c15) {
    let r8 = Math.max(0, f11 - I18);
    C19 >= 0 && r8 > C19 + 1 && g18.push(F21);
    for (let l8 = r8; l8 < f11; l8++) if (!p17.has(l8)) {
      p17.add(l8), C19 = l8;
      let u11 = x23[l8];
      s9 && (u11 = `${l8 + 1}-${u11}`), a7 && (u11 = `${a7}-${u11}`), g18.push(u11);
    }
    if (!p17.has(f11)) {
      p17.add(f11), C19 = f11;
      let l8 = x23[f11];
      if (m25) {
        t6.lastIndex = 0;
        for (let u11 = t6.exec(l8); u11 !== null; u11 = t6.exec(l8)) {
          let L18 = A14 !== void 0 ? u11[A14] ?? "" : u11[0], E13 = k17 !== null ? k17 : L18, $18 = a7 ? `${a7}:` : "";
          s9 && ($18 += `${f11 + 1}:`), O17 && ($18 += `${u11.index + 1}:`), g18.push($18 + E13), u11[0].length === 0 && t6.lastIndex++;
        }
      } else {
        let u11 = l8;
        s9 && (u11 = `${f11 + 1}:${u11}`), a7 && (u11 = `${a7}:${u11}`), g18.push(u11);
      }
    }
    let o9 = Math.min(v21 - 1, f11 + R13);
    for (let l8 = f11 + 1; l8 <= o9; l8++) if (!p17.has(l8)) {
      p17.add(l8), C19 = l8;
      let u11 = x23[l8];
      s9 && (u11 = `${l8 + 1}-${u11}`), a7 && (u11 = `${a7}-${u11}`), g18.push(u11);
    }
  }
  return { output: g18.length > 0 ? `${g18.join(`
`)}
` : "", matched: w19 > 0, matchCount: w19 };
}
function Q4(n23, t6, e7) {
  let { invertMatch: i10, showLineNumbers: s9, countOnly: h17, countMatches: d16, filename: a7, onlyMatching: m25, beforeContext: I18, afterContext: R13, maxCount: S17, contextSeparator: F21, showColumn: O17, showByteOffset: G9, replace: P20, kResetGroup: k17 } = e7, y18 = n23.split(`
`), j12 = y18.length, A14 = j12 > 0 && y18[j12 - 1] === "" ? j12 - 1 : j12, x23 = [0];
  for (let c15 = 0; c15 < n23.length; c15++) n23[c15] === `
` && x23.push(c15 + 1);
  let Z13 = (c15) => {
    let f11 = 0;
    for (let r8 = 0; r8 < x23.length && !(x23[r8] > c15); r8++) f11 = r8;
    return f11;
  }, v21 = (c15) => {
    let f11 = Z13(c15);
    return c15 - x23[f11] + 1;
  }, g18 = [];
  t6.lastIndex = 0;
  for (let c15 = t6.exec(n23); c15 !== null && !(S17 > 0 && g18.length >= S17); c15 = t6.exec(n23)) {
    let f11 = Z13(c15.index), r8 = Z13(c15.index + Math.max(0, c15[0].length - 1)), o9 = k17 !== void 0 ? c15[k17] ?? "" : c15[0];
    g18.push({ startLine: f11, endLine: r8, byteOffset: c15.index, column: v21(c15.index), matchText: o9 }), c15[0].length === 0 && t6.lastIndex++;
  }
  if (h17 || d16) {
    let c15;
    if (d16) c15 = i10 ? 0 : g18.length;
    else {
      let r8 = /* @__PURE__ */ new Set();
      for (let o9 of g18) for (let l8 = o9.startLine; l8 <= o9.endLine; l8++) r8.add(l8);
      c15 = i10 ? A14 - r8.size : r8.size;
    }
    return { output: `${a7 ? `${a7}:${c15}` : String(c15)}
`, matched: c15 > 0, matchCount: c15 };
  }
  if (i10) {
    let c15 = /* @__PURE__ */ new Set();
    for (let r8 of g18) for (let o9 = r8.startLine; o9 <= r8.endLine; o9++) c15.add(o9);
    let f11 = [];
    for (let r8 = 0; r8 < A14; r8++) if (!c15.has(r8)) {
      let o9 = y18[r8];
      s9 && (o9 = `${r8 + 1}:${o9}`), a7 && (o9 = `${a7}:${o9}`), f11.push(o9);
    }
    return { output: f11.length > 0 ? `${f11.join(`
`)}
` : "", matched: f11.length > 0, matchCount: f11.length };
  }
  if (g18.length === 0) return { output: "", matched: false, matchCount: 0 };
  let w19 = /* @__PURE__ */ new Set(), p17 = -1, C19 = [];
  for (let c15 of g18) {
    let f11 = Math.max(0, c15.startLine - I18), r8 = Math.min(A14 - 1, c15.endLine + R13);
    p17 >= 0 && f11 > p17 + 1 && C19.push(F21);
    for (let o9 = f11; o9 < c15.startLine; o9++) if (!w19.has(o9)) {
      w19.add(o9), p17 = o9;
      let l8 = y18[o9];
      s9 && (l8 = `${o9 + 1}-${l8}`), a7 && (l8 = `${a7}-${l8}`), C19.push(l8);
    }
    if (m25) {
      let o9 = P20 !== null ? P20 : c15.matchText, l8 = a7 ? `${a7}:` : "";
      G9 && (l8 += `${c15.byteOffset}:`), s9 && (l8 += `${c15.startLine + 1}:`), O17 && (l8 += `${c15.column}:`), C19.push(l8 + o9);
      for (let u11 = c15.startLine; u11 <= c15.endLine; u11++) w19.add(u11), p17 = u11;
    } else for (let o9 = c15.startLine; o9 <= c15.endLine && o9 < A14; o9++) if (!w19.has(o9)) {
      w19.add(o9), p17 = o9;
      let l8 = y18[o9];
      P20 !== null && o9 === c15.startLine && (t6.lastIndex = 0, l8 = t6.replace(l8, P20));
      let u11 = a7 ? `${a7}:` : "";
      G9 && o9 === c15.startLine && (u11 += `${c15.byteOffset}:`), s9 && (u11 += `${o9 + 1}:`), O17 && o9 === c15.startLine && (u11 += `${c15.column}:`), C19.push(u11 + l8);
    }
    for (let o9 = c15.endLine + 1; o9 <= r8; o9++) if (!w19.has(o9)) {
      w19.add(o9), p17 = o9;
      let l8 = y18[o9];
      s9 && (l8 = `${o9 + 1}-${l8}`), a7 && (l8 = `${a7}-${l8}`), C19.push(l8);
    }
  }
  return { output: C19.length > 0 ? `${C19.join(`
`)}
` : "", matched: true, matchCount: g18.length };
}
function K3(n23) {
  let t6 = "", e7 = 0;
  for (; e7 < n23.length; ) {
    if (n23.slice(e7, e7 + 7) === "[[:<:]]") {
      t6 += "\\b", e7 += 7;
      continue;
    }
    if (n23.slice(e7, e7 + 7) === "[[:>:]]") {
      t6 += "\\b", e7 += 7;
      continue;
    }
    if (n23[e7] === "[") {
      let i10 = "[";
      for (e7++, e7 < n23.length && (n23[e7] === "^" || n23[e7] === "!") && (i10 += "^", e7++), e7 < n23.length && n23[e7] === "]" && (i10 += "\\]", e7++); e7 < n23.length && n23[e7] !== "]"; ) {
        if (n23[e7] === "[" && e7 + 1 < n23.length && n23[e7 + 1] === ":") {
          let s9 = n23.indexOf(":]", e7 + 2);
          if (s9 !== -1) {
            let h17 = n23.slice(e7 + 2, s9), d16 = q5.get(h17);
            if (d16) {
              i10 += d16, e7 = s9 + 2;
              continue;
            }
          }
        }
        if (n23[e7] === "\\" && e7 + 1 < n23.length) {
          i10 += n23[e7] + n23[e7 + 1], e7 += 2;
          continue;
        }
        i10 += n23[e7], e7++;
      }
      e7 < n23.length && n23[e7] === "]" && (i10 += "]", e7++), t6 += i10;
      continue;
    }
    if (n23[e7] === "\\" && e7 + 1 < n23.length) {
      t6 += n23[e7] + n23[e7 + 1], e7 += 2;
      continue;
    }
    t6 += n23[e7], e7++;
  }
  return t6;
}
function W4(n23, t6) {
  let e7, i10;
  switch (t6.mode) {
    case "fixed":
      e7 = n23.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      break;
    case "extended":
    case "perl": {
      if (e7 = K3(n23), e7 = e7.replace(/\(\?P<([^>]+)>/g, "(?<$1>"), t6.mode === "perl") {
        e7 = X4(e7), e7 = H4(e7), e7 = J3(e7);
        let d16 = ne3(e7);
        e7 = d16.pattern, i10 = d16.kResetGroup;
      }
      break;
    }
    default:
      e7 = K3(n23), e7 = se2(e7);
      break;
  }
  t6.wholeWord && (e7 = `\\b(?:${e7})\\b`), t6.lineRegexp && (e7 = `^${e7}$`);
  let s9 = /\\u\{[0-9A-Fa-f]+\}/.test(e7), h17 = "g" + (t6.ignoreCase ? "i" : "") + (t6.multiline ? "m" : "") + (t6.multilineDotall ? "s" : "") + (s9 ? "u" : "");
  return { regex: b1(e7, h17), kResetGroup: i10 };
}
function X4(n23) {
  let t6 = "", e7 = 0;
  for (; e7 < n23.length; ) if (n23[e7] === "\\" && e7 + 1 < n23.length && n23[e7 + 1] === "Q") {
    e7 += 2;
    let i10 = "";
    for (; e7 < n23.length; ) {
      if (n23[e7] === "\\" && e7 + 1 < n23.length && n23[e7 + 1] === "E") {
        e7 += 2;
        break;
      }
      i10 += n23[e7], e7++;
    }
    t6 += i10.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  } else t6 += n23[e7], e7++;
  return t6;
}
function H4(n23) {
  return n23.replace(/\\x\{([0-9A-Fa-f]+)\}/g, "\\u{$1}");
}
function J3(n23) {
  let t6 = "", e7 = 0;
  for (; e7 < n23.length; ) {
    if (n23[e7] === "(" && e7 + 1 < n23.length && n23[e7 + 1] === "?") {
      let i10 = n23.slice(e7).match(/^\(\?([imsx]*)(-[imsx]*)?(:|$|\))/);
      if (i10) {
        let s9 = i10[1] || "", h17 = i10[2] || "", d16 = i10[3];
        if (d16 === ":") {
          let a7 = e7 + i10[0].length - 1, m25 = V4(n23, e7);
          if (m25 !== -1) {
            let I18 = n23.slice(a7 + 1, m25), R13 = Y3(I18, s9, h17);
            t6 += `(?:${R13})`, e7 = m25 + 1;
            continue;
          }
        } else if (d16 === ")" || d16 === "") {
          e7 += i10[0].length;
          continue;
        }
      }
    }
    t6 += n23[e7], e7++;
  }
  return t6;
}
function V4(n23, t6) {
  let e7 = 0, i10 = t6;
  for (; i10 < n23.length; ) {
    if (n23[i10] === "\\") {
      i10 += 2;
      continue;
    }
    if (n23[i10] === "[") {
      for (i10++; i10 < n23.length && n23[i10] !== "]"; ) n23[i10] === "\\" && i10++, i10++;
      i10++;
      continue;
    }
    if (n23[i10] === "(") e7++;
    else if (n23[i10] === ")" && (e7--, e7 === 0)) return i10;
    i10++;
  }
  return -1;
}
function Y3(n23, t6, e7) {
  let i10 = n23;
  return t6.includes("i") && (i10 = ee2(i10)), i10;
}
function ee2(n23) {
  let t6 = "", e7 = 0;
  for (; e7 < n23.length; ) {
    let i10 = n23[e7];
    if (i10 === "\\") {
      e7 + 1 < n23.length ? (t6 += i10 + n23[e7 + 1], e7 += 2) : (t6 += i10, e7++);
      continue;
    }
    if (i10 === "[") {
      t6 += i10, e7++, e7 < n23.length && n23[e7] === "^" && (t6 += n23[e7], e7++);
      let s9 = [];
      for (; e7 < n23.length && n23[e7] !== "]"; ) if (n23[e7] === "\\") s9.push(n23[e7]), e7++, e7 < n23.length && (s9.push(n23[e7]), e7++);
      else if (n23[e7] === "-" && s9.length > 0 && e7 + 1 < n23.length && n23[e7 + 1] !== "]") {
        let h17 = s9[s9.length - 1], d16 = n23[e7 + 1];
        s9.push("-"), s9.push(d16), /[a-z]/.test(h17) && /[a-z]/.test(d16) ? (s9.push(h17.toUpperCase()), s9.push("-"), s9.push(d16.toUpperCase())) : /[A-Z]/.test(h17) && /[A-Z]/.test(d16) && (s9.push(h17.toLowerCase()), s9.push("-"), s9.push(d16.toLowerCase())), e7 += 2;
      } else {
        let h17 = n23[e7];
        if (s9.push(h17), /[a-zA-Z]/.test(h17)) {
          let d16 = h17 === h17.toLowerCase() ? h17.toUpperCase() : h17.toLowerCase();
          s9.includes(d16) || s9.push(d16);
        }
        e7++;
      }
      t6 += s9.join(""), e7 < n23.length && (t6 += n23[e7], e7++);
      continue;
    }
    if (/[a-zA-Z]/.test(i10)) {
      let s9 = i10.toLowerCase(), h17 = i10.toUpperCase();
      t6 += `[${h17}${s9}]`;
    } else t6 += i10;
    e7++;
  }
  return t6;
}
function ne3(n23) {
  let t6 = te3(n23);
  if (t6 === -1) return { pattern: n23 };
  let e7 = n23.slice(0, t6), i10 = n23.slice(t6 + 2), s9 = ie(e7);
  return { pattern: `(?:${e7})(${i10})`, kResetGroup: s9 + 1 };
}
function te3(n23) {
  let t6 = 0;
  for (; t6 < n23.length - 1; ) if (n23[t6] === "\\") {
    if (n23[t6 + 1] === "K") {
      let e7 = 0, i10 = t6 - 1;
      for (; i10 >= 0 && n23[i10] === "\\"; ) e7++, i10--;
      if (e7 % 2 === 0) return t6;
    }
    t6 += 2;
  } else t6++;
  return -1;
}
function ie(n23) {
  let t6 = 0, e7 = 0;
  for (; e7 < n23.length; ) {
    if (n23[e7] === "\\") {
      e7 += 2;
      continue;
    }
    if (n23[e7] === "[") {
      for (e7++; e7 < n23.length && n23[e7] !== "]"; ) n23[e7] === "\\" && e7++, e7++;
      e7++;
      continue;
    }
    if (n23[e7] === "(") if (e7 + 1 < n23.length && n23[e7 + 1] === "?") {
      if (e7 + 2 < n23.length) {
        let i10 = n23[e7 + 2];
        if (i10 === ":" || i10 === "=" || i10 === "!") {
          e7++;
          continue;
        }
        if (i10 === "<" && e7 + 3 < n23.length) {
          let s9 = n23[e7 + 3];
          if (s9 === "=" || s9 === "!") {
            e7++;
            continue;
          }
          t6++, e7++;
          continue;
        }
      }
    } else t6++;
    e7++;
  }
  return t6;
}
function le2(n23) {
  let t6 = n23.replace(/\$\{0\}|\$0(?![0-9])/g, "$$&");
  return t6 = t6.replace(/\$\{([^0-9}][^}]*)\}/g, "$$<$1>"), t6 = t6.replace(/\$([a-zA-Z_][a-zA-Z0-9_]*)(?![>0-9])/g, "$$<$1>"), t6;
}
function se2(n23) {
  let t6 = "", e7 = 0, i10 = true, s9 = 0;
  for (; e7 < n23.length; ) {
    let h17 = n23[e7];
    if (h17 === "[") {
      for (t6 += h17, e7++, e7 < n23.length && (n23[e7] === "^" || n23[e7] === "!") && (t6 += n23[e7], e7++), e7 < n23.length && n23[e7] === "]" && (t6 += n23[e7], e7++); e7 < n23.length && n23[e7] !== "]"; ) n23[e7] === "\\" && e7 + 1 < n23.length ? (t6 += n23[e7] + n23[e7 + 1], e7 += 2) : (t6 += n23[e7], e7++);
      e7 < n23.length && n23[e7] === "]" && (t6 += n23[e7], e7++), i10 = false;
      continue;
    }
    if (h17 === "\\" && e7 + 1 < n23.length) {
      let d16 = n23[e7 + 1];
      if (d16 === "|") {
        t6 += "|", e7 += 2, i10 = true;
        continue;
      }
      if (d16 === "(") {
        t6 += "(", e7 += 2, s9++, i10 = true;
        continue;
      }
      if (d16 === ")") {
        t6 += ")", e7 += 2, s9 = Math.max(0, s9 - 1), i10 = false;
        continue;
      }
      if (d16 === "{") {
        let m25 = n23.slice(e7).match(/^\\{(\d+)(,(\d*)?)?\\}/);
        if (m25) {
          let I18 = m25[1], R13 = m25[2] !== void 0, S17 = m25[3] || "";
          R13 ? t6 += `{${I18},${S17}}` : t6 += `{${I18}}`, e7 += m25[0].length, i10 = false;
          continue;
        }
        t6 += "\\{", e7 += 2, i10 = false;
        continue;
      }
      if (d16 === "}") {
        t6 += "\\}", e7 += 2, i10 = false;
        continue;
      }
      t6 += h17 + d16, e7 += 2, i10 = false;
      continue;
    }
    if (h17 === "*" && i10) {
      t6 += "\\*", e7++;
      continue;
    }
    if (h17 === "^") {
      if (i10) {
        t6 += "^", e7++;
        continue;
      }
      t6 += "\\^", e7++;
      continue;
    }
    if (h17 === "$") {
      let d16 = e7 === n23.length - 1, a7 = e7 + 2 < n23.length && n23[e7 + 1] === "\\" && n23[e7 + 2] === ")";
      d16 || a7 ? t6 += "$" : t6 += "\\$", e7++, i10 = false;
      continue;
    }
    h17 === "+" || h17 === "?" || h17 === "|" || h17 === "(" || h17 === ")" || h17 === "{" || h17 === "}" ? t6 += `\\${h17}` : t6 += h17, e7++, i10 = false;
  }
  return t6;
}
var q5;
var init_chunk_VLGZJRPG = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-VLGZJRPG.js"() {
    init_chunk_YNYSPYQ5();
    q5 = /* @__PURE__ */ new Map([["alpha", "a-zA-Z"], ["digit", "0-9"], ["alnum", "a-zA-Z0-9"], ["lower", "a-z"], ["upper", "A-Z"], ["xdigit", "0-9A-Fa-f"], ["space", " \\t\\n\\r\\f\\v"], ["blank", " \\t"], ["punct", "!-/:-@\\[-`{-~"], ["graph", "!-~"], ["print", " -~"], ["cntrl", "\\x00-\\x1F\\x7F"], ["ascii", "\\x00-\\x7F"], ["word", "a-zA-Z0-9_"]]);
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-S6BBC45K.js
async function K4(t6, s9, o9, f11) {
  let c15 = o9.fs.resolvePath(o9.cwd, t6);
  try {
    if (!(await o9.fs.stat(c15)).isDirectory) {
      let l8 = t6.split("/").pop() || "";
      if (s9) {
        let n23 = s9.replace(/^\//, "");
        h6(l8, n23, { stripQuotes: true }) && f11.push(t6);
      }
      return;
    }
    let g18 = await o9.fs.readdir(c15);
    for (let l8 of g18) {
      let n23 = t6 === "." ? l8 : `${t6}/${l8}`, d16 = o9.fs.resolvePath(o9.cwd, n23);
      if ((await o9.fs.stat(d16)).isDirectory) await K4(n23, s9, o9, f11);
      else if (s9) {
        let u11 = s9.replace(/^\//, "");
        h6(l8, u11, { stripQuotes: true }) && f11.push(n23);
      }
    }
  } catch {
  }
}
async function se3(t6, s9) {
  let o9 = [], f11 = t6.lastIndexOf("/"), c15, h17;
  if (f11 === -1 ? (c15 = s9.cwd, h17 = t6) : (c15 = t6.slice(0, f11) || "/", h17 = t6.slice(f11 + 1)), t6.includes("**")) {
    let l8 = [], n23 = t6.split("**"), d16 = n23[0].replace(/\/$/, "") || ".", x23 = n23[1] || "";
    return await K4(d16, x23, s9, l8), l8.map((u11) => ({ path: u11 }));
  }
  let g18 = s9.fs.resolvePath(s9.cwd, c15);
  try {
    if (s9.fs.readdirWithFileTypes) {
      let l8 = await s9.fs.readdirWithFileTypes(g18);
      for (let n23 of l8) if (h6(n23.name, h17, { stripQuotes: true })) {
        let d16 = f11 === -1 ? n23.name : `${c15}/${n23.name}`;
        o9.push({ path: d16, isFile: n23.isFile });
      }
    } else {
      let l8 = await s9.fs.readdir(g18);
      for (let n23 of l8) if (h6(n23, h17, { stripQuotes: true })) {
        let d16 = f11 === -1 ? n23 : `${c15}/${n23}`;
        o9.push({ path: d16 });
      }
    }
  } catch {
  }
  return o9.sort((l8, n23) => l8.path.localeCompare(n23.path));
}
async function I5(t6, s9, o9 = [], f11 = [], c15 = [], h17) {
  let g18 = s9.fs.resolvePath(s9.cwd, t6), l8 = [];
  try {
    let n23, d16;
    if (h17 !== void 0) n23 = h17, d16 = !h17;
    else {
      let u11 = await s9.fs.stat(g18);
      n23 = u11.isFile, d16 = u11.isDirectory;
    }
    if (n23) {
      let u11 = t6.split("/").pop() || t6;
      return f11.length > 0 && f11.some((p17) => h6(u11, p17, { stripQuotes: true })) ? [] : o9.length > 0 && !o9.some((p17) => h6(u11, p17, { stripQuotes: true })) ? [] : [{ path: t6, isFile: true }];
    }
    if (!d16) return [];
    let x23 = t6.split("/").pop() || t6;
    if (c15.length > 0 && c15.some((u11) => h6(x23, u11, { stripQuotes: true }))) return [];
    if (s9.fs.readdirWithFileTypes) {
      let u11 = await s9.fs.readdirWithFileTypes(g18);
      for (let p17 of u11) {
        if (p17.name.startsWith(".")) continue;
        let b25 = t6 === "." ? p17.name : `${t6}/${p17.name}`, w19 = await I5(b25, s9, o9, f11, c15, p17.isFile);
        l8.push(...w19);
      }
    } else {
      let u11 = await s9.fs.readdir(g18);
      for (let p17 of u11) {
        if (p17.startsWith(".")) continue;
        let b25 = t6 === "." ? p17 : `${t6}/${p17}`, w19 = await I5(b25, s9, o9, f11, c15);
        l8.push(...w19);
      }
    }
  } catch {
  }
  return l8;
}
var te4, J4, oe2, ae3, fe2, ue2, ce2;
var init_chunk_S6BBC45K = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-S6BBC45K.js"() {
    init_chunk_IJXFPKNC();
    init_chunk_VLGZJRPG();
    init_chunk_74CEPOFO();
    te4 = { name: "grep", summary: "print lines that match patterns", usage: "grep [OPTION]... PATTERN [FILE]...", options: ["-E, --extended-regexp    PATTERN is an extended regular expression", "-P, --perl-regexp        PATTERN is a Perl regular expression", "-F, --fixed-strings      PATTERN is a set of newline-separated strings", "-i, --ignore-case        ignore case distinctions", "-v, --invert-match       select non-matching lines", "-w, --word-regexp        match only whole words", "-x, --line-regexp        match only whole lines", "-c, --count              print only a count of matching lines", "-l, --files-with-matches print only names of files with matches", "-L, --files-without-match print names of files with no matches", "-m NUM, --max-count=NUM  stop after NUM matches", "-n, --line-number        print line number with output lines", "-h, --no-filename        suppress the file name prefix on output", "-o, --only-matching      show only nonempty parts of lines that match", "-q, --quiet, --silent    suppress all normal output", "-r, -R, --recursive      search directories recursively", "-A NUM                   print NUM lines of trailing context", "-B NUM                   print NUM lines of leading context", "-C NUM                   print NUM lines of context", "-e PATTERN               use PATTERN for matching", "    --include=GLOB       search only files matching GLOB", "    --exclude=GLOB       skip files matching GLOB", "    --exclude-dir=DIR    skip directories matching DIR", "    --help               display this help and exit"] };
    J4 = { name: "grep", async execute(t6, s9) {
      if (o2(t6)) return s(te4);
      let o9 = false, f11 = false, c15 = false, h17 = false, g18 = false, l8 = false, n23 = false, d16 = false, x23 = false, u11 = false, p17 = false, b25 = false, w19 = false, z10 = false, E13 = false, $18 = 0, P20 = 0, T10 = 0, M15 = [], W15 = [], H16 = [], C19 = null, B12 = [];
      for (let r8 = 0; r8 < t6.length; r8++) {
        let i10 = t6[r8];
        if (i10.startsWith("-") && i10 !== "-") {
          if (i10 === "-e" && r8 + 1 < t6.length) {
            C19 = t6[++r8];
            continue;
          }
          if (i10.startsWith("--include=")) {
            M15.push(i10.slice(10));
            continue;
          }
          if (i10.startsWith("--exclude=")) {
            W15.push(i10.slice(10));
            continue;
          }
          if (i10.startsWith("--exclude-dir=")) {
            H16.push(i10.slice(14));
            continue;
          }
          if (i10.startsWith("--max-count=")) {
            $18 = parseInt(i10.slice(12), 10);
            continue;
          }
          let F21 = i10.match(/^-m(\d+)$/);
          if (F21) {
            $18 = parseInt(F21[1], 10);
            continue;
          }
          if (i10 === "-m" && r8 + 1 < t6.length) {
            $18 = parseInt(t6[++r8], 10);
            continue;
          }
          let a7 = i10.match(/^-([ABC])(\d+)$/);
          if (a7) {
            let e7 = parseInt(a7[2], 10);
            a7[1] === "A" ? T10 = e7 : a7[1] === "B" ? P20 = e7 : a7[1] === "C" && (P20 = e7, T10 = e7);
            continue;
          }
          if ((i10 === "-A" || i10 === "-B" || i10 === "-C") && r8 + 1 < t6.length) {
            let e7 = parseInt(t6[++r8], 10);
            i10 === "-A" ? T10 = e7 : i10 === "-B" ? P20 = e7 : (P20 = e7, T10 = e7);
            continue;
          }
          let m25 = i10.startsWith("--") ? [i10] : i10.slice(1).split("");
          for (let e7 of m25) if (e7 === "i" || e7 === "--ignore-case") o9 = true;
          else if (e7 === "n" || e7 === "--line-number") f11 = true;
          else if (e7 === "v" || e7 === "--invert-match") c15 = true;
          else if (e7 === "c" || e7 === "--count") h17 = true;
          else if (e7 === "l" || e7 === "--files-with-matches") g18 = true;
          else if (e7 === "L" || e7 === "--files-without-match") l8 = true;
          else if (e7 === "r" || e7 === "R" || e7 === "--recursive") n23 = true;
          else if (e7 === "w" || e7 === "--word-regexp") d16 = true;
          else if (e7 === "x" || e7 === "--line-regexp") x23 = true;
          else if (e7 === "E" || e7 === "--extended-regexp") u11 = true;
          else if (e7 === "P" || e7 === "--perl-regexp") p17 = true;
          else if (e7 === "F" || e7 === "--fixed-strings") b25 = true;
          else if (e7 === "o" || e7 === "--only-matching") w19 = true;
          else if (e7 === "h" || e7 === "--no-filename") z10 = true;
          else if (e7 === "q" || e7 === "--quiet" || e7 === "--silent") E13 = true;
          else {
            if (e7.startsWith("--")) return r3("grep", e7);
            if (e7.length === 1) return r3("grep", `-${e7}`);
          }
        } else C19 === null ? C19 = i10 : B12.push(i10);
      }
      if (C19 === null) return { stdout: "", stderr: `grep: missing pattern
`, exitCode: 2 };
      let V13 = b25 ? "fixed" : u11 ? "extended" : p17 ? "perl" : "basic", L18, O17;
      try {
        let r8 = W4(C19, { mode: V13, ignoreCase: o9, wholeWord: d16, lineRegexp: x23 });
        L18 = r8.regex, O17 = r8.kResetGroup;
      } catch {
        return { stdout: "", stderr: `grep: invalid regular expression: ${C19}
`, exitCode: 2 };
      }
      if (B12.length === 0 && s9.stdin !== void 0) {
        let r8 = D4(s9.stdin, L18, { invertMatch: c15, showLineNumbers: f11, countOnly: h17, filename: "", onlyMatching: w19, beforeContext: P20, afterContext: T10, maxCount: $18, kResetGroup: O17 });
        return E13 ? { stdout: "", stderr: "", exitCode: r8.matched ? 0 : 1 } : { stdout: r8.output, stderr: "", exitCode: r8.matched ? 0 : 1 };
      }
      if (B12.length === 0) return { stdout: "", stderr: `grep: no input files
`, exitCode: 2 };
      let R13 = "", G9 = "", S17 = false, D15 = false, v21 = [];
      for (let r8 of B12) if (r8.includes("*") || r8.includes("?") || r8.includes("[")) {
        let i10 = await se3(r8, s9);
        if (n23) for (let F21 of i10) {
          let a7 = await I5(F21.path, s9, M15, W15, H16, F21.isFile);
          v21.push(...a7);
        }
        else v21.push(...i10);
      } else if (n23) {
        let i10 = await I5(r8, s9, M15, W15, H16);
        v21.push(...i10);
      } else v21.push({ path: r8 });
      let X10 = (v21.length > 1 || n23) && !z10, k17 = 50;
      for (let r8 = 0; r8 < v21.length; r8 += k17) {
        let i10 = v21.slice(r8, r8 + k17), F21 = await Promise.all(i10.map(async (a7) => {
          let m25 = a7.path, e7 = m25.split("/").pop() || m25;
          if (W15.length > 0 && !n23 && W15.some((N15) => h6(e7, N15, { stripQuotes: true })) || M15.length > 0 && !n23 && !M15.some((N15) => h6(e7, N15, { stripQuotes: true }))) return null;
          try {
            let N15 = s9.fs.resolvePath(s9.cwd, m25), Q13 = false;
            if (a7.isFile === void 0 ? Q13 = (await s9.fs.stat(N15)).isDirectory : Q13 = !a7.isFile, Q13) return n23 ? null : { error: `grep: ${m25}: Is a directory
` };
            let Y11 = await s9.fs.readFile(N15), ee7 = D4(Y11, L18, { invertMatch: c15, showLineNumbers: f11, countOnly: h17, filename: X10 ? m25 : "", onlyMatching: w19, beforeContext: P20, afterContext: T10, maxCount: $18, kResetGroup: O17 });
            return { file: m25, result: ee7 };
          } catch {
            return { error: `grep: ${m25}: No such file or directory
` };
          }
        }));
        for (let a7 of F21) {
          if (a7 === null) continue;
          if ("error" in a7 && a7.error) {
            G9 += a7.error, a7.error.includes("Is a directory") || (D15 = true);
            continue;
          }
          if (!("file" in a7) || !a7.result) continue;
          let { file: m25, result: e7 } = a7;
          if (e7.matched) {
            if (S17 = true, E13) return { stdout: "", stderr: "", exitCode: 0 };
            g18 ? R13 += `${m25}
` : l8 || (R13 += e7.output);
          } else l8 ? R13 += `${m25}
` : h17 && !g18 && (R13 += e7.output);
        }
      }
      let A14;
      return D15 ? A14 = 2 : l8 ? A14 = R13.length > 0 ? 0 : 1 : A14 = S17 ? 0 : 1, E13 ? { stdout: "", stderr: "", exitCode: A14 } : { stdout: R13, stderr: G9, exitCode: A14 };
    } };
    oe2 = { name: "fgrep", async execute(t6, s9) {
      return J4.execute(["-F", ...t6], s9);
    } };
    ae3 = { name: "egrep", async execute(t6, s9) {
      return J4.execute(["-E", ...t6], s9);
    } };
    fe2 = { name: "grep", flags: [{ flag: "-E", type: "boolean" }, { flag: "-F", type: "boolean" }, { flag: "-P", type: "boolean" }, { flag: "-i", type: "boolean" }, { flag: "-v", type: "boolean" }, { flag: "-w", type: "boolean" }, { flag: "-x", type: "boolean" }, { flag: "-c", type: "boolean" }, { flag: "-l", type: "boolean" }, { flag: "-L", type: "boolean" }, { flag: "-n", type: "boolean" }, { flag: "-h", type: "boolean" }, { flag: "-o", type: "boolean" }, { flag: "-q", type: "boolean" }, { flag: "-r", type: "boolean" }, { flag: "-m", type: "value", valueHint: "number" }, { flag: "-A", type: "value", valueHint: "number" }, { flag: "-B", type: "value", valueHint: "number" }, { flag: "-C", type: "value", valueHint: "number" }, { flag: "-e", type: "value", valueHint: "pattern" }], stdinType: "text", needsArgs: true };
    ue2 = { name: "fgrep", flags: [], stdinType: "text", needsArgs: true };
    ce2 = { name: "egrep", flags: [], stdinType: "text", needsArgs: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/grep-BPEMMINR.js
var grep_BPEMMINR_exports = {};
__export(grep_BPEMMINR_exports, {
  egrepCommand: () => ae3,
  egrepFlagsForFuzzing: () => ce2,
  fgrepCommand: () => oe2,
  fgrepFlagsForFuzzing: () => ue2,
  flagsForFuzzing: () => fe2,
  grepCommand: () => J4
});
var init_grep_BPEMMINR = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/grep-BPEMMINR.js"() {
    init_chunk_S6BBC45K();
    init_chunk_IJXFPKNC();
    init_chunk_VLGZJRPG();
    init_chunk_YNYSPYQ5();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// stub-node:node:zlib
var gunzipSync, gzipSync, constants;
var init_node_zlib = __esm({
  "stub-node:node:zlib"() {
    gunzipSync = () => {
      throw new Error("node:zlib stubbed for browser");
    };
    gzipSync = () => {
      throw new Error("node:zlib stubbed for browser");
    };
    constants = {};
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-QOENL5UZ.js
function U4() {
  let e7 = [];
  for (let [t6, n23] of Object.entries(G3).sort()) {
    let s9 = [];
    for (let r8 of n23.extensions) s9.push(`*${r8}`);
    for (let r8 of n23.globs) s9.push(r8);
    e7.push(`${t6}: ${s9.join(", ")}`);
  }
  return `${e7.join(`
`)}
`;
}
function q6() {
  return { ignoreCase: false, caseSensitive: false, smartCase: true, fixedStrings: false, wordRegexp: false, lineRegexp: false, invertMatch: false, multiline: false, multilineDotall: false, patterns: [], patternFiles: [], count: false, countMatches: false, files: false, filesWithMatches: false, filesWithoutMatch: false, stats: false, onlyMatching: false, maxCount: 0, lineNumber: true, noFilename: false, withFilename: false, nullSeparator: false, byteOffset: false, column: false, vimgrep: false, replace: null, afterContext: 0, beforeContext: 0, contextSeparator: "--", quiet: false, heading: false, passthru: false, includeZero: false, sort: "path", json: false, globs: [], iglobs: [], globCaseInsensitive: false, types: [], typesNot: [], typeAdd: [], typeClear: [], hidden: false, noIgnore: false, noIgnoreDot: false, noIgnoreVcs: false, ignoreFiles: [], maxDepth: 1 / 0, maxFilesize: 0, followSymlinks: false, searchZip: false, searchBinary: false, preprocessor: null, preprocessorGlobs: [] };
}
function Q5(e7) {
  let t6 = e7.match(/^(\d+)([KMG])?$/i);
  if (!t6) return 0;
  let n23 = parseInt(t6[1], 10);
  switch ((t6[2] || "").toUpperCase()) {
    case "K":
      return n23 * 1024;
    case "M":
      return n23 * 1024 * 1024;
    case "G":
      return n23 * 1024 * 1024 * 1024;
    default:
      return n23;
  }
}
function ee3(e7) {
  return /^\d+[KMG]?$/i.test(e7) ? null : { stdout: "", stderr: `rg: invalid --max-filesize value: ${e7}
`, exitCode: 1 };
}
function H5(e7) {
  return null;
}
function ne4(e7) {
  e7.hidden ? e7.searchBinary = true : e7.noIgnore ? e7.hidden = true : e7.noIgnore = true;
}
function re2(e7, t6, n23) {
  let s9 = e7[t6];
  for (let r8 of V5) {
    if (s9.startsWith(`--${r8.long}=`)) {
      let l8 = s9.slice(`--${r8.long}=`.length), i10 = O5(n23, r8, l8);
      return i10 ? { newIndex: t6, error: i10 } : { newIndex: t6 };
    }
    if (r8.short && s9.startsWith(`-${r8.short}`) && s9.length > 2) {
      let l8 = s9.slice(2), i10 = O5(n23, r8, l8);
      return i10 ? { newIndex: t6, error: i10 } : { newIndex: t6 };
    }
    if (r8.short && s9 === `-${r8.short}` || s9 === `--${r8.long}`) {
      if (t6 + 1 >= e7.length) return null;
      let l8 = e7[t6 + 1], i10 = O5(n23, r8, l8);
      return i10 ? { newIndex: t6 + 1, error: i10 } : { newIndex: t6 + 1 };
    }
  }
  return null;
}
function ie2(e7) {
  return V5.find((t6) => t6.short === e7);
}
function O5(e7, t6, n23) {
  if (t6.validate) {
    let r8 = t6.validate(n23);
    if (r8) return r8;
  }
  let s9 = t6.parse ? t6.parse(n23) : n23;
  t6.multi ? e7[t6.target].push(s9) : e7[t6.target] = s9;
}
function le3(e7, t6) {
  let n23 = e7[t6];
  if (n23 === "--sort" && t6 + 1 < e7.length) {
    let s9 = e7[t6 + 1];
    if (s9 === "path" || s9 === "none") return { value: s9, newIndex: t6 + 1 };
  }
  if (n23.startsWith("--sort=")) {
    let s9 = n23.slice(7);
    if (s9 === "path" || s9 === "none") return { value: s9, newIndex: t6 };
  }
  return null;
}
function oe3(e7, t6) {
  let n23 = e7[t6], s9 = n23.match(/^-([ABC])(\d+)$/);
  return s9 ? { flag: s9[1], value: parseInt(s9[2], 10), newIndex: t6 } : (n23 === "-A" || n23 === "-B" || n23 === "-C") && t6 + 1 < e7.length ? { flag: n23[1], value: parseInt(e7[t6 + 1], 10), newIndex: t6 + 1 } : null;
}
function ae4(e7) {
  let t6 = e7.match(/^-m(\d+)$/);
  return t6 ? parseInt(t6[1], 10) : null;
}
function Z4(e7) {
  let t6 = q6(), n23 = null, s9 = [], r8 = -1, l8 = -1, i10 = -1, o9 = false;
  for (let c15 = 0; c15 < e7.length; c15++) {
    let a7 = e7[c15];
    if (a7.startsWith("-") && a7 !== "-") {
      let u11 = oe3(e7, c15);
      if (u11) {
        let { flag: f11, value: x23, newIndex: b25 } = u11;
        f11 === "A" ? r8 = Math.max(r8, x23) : f11 === "B" ? l8 = Math.max(l8, x23) : i10 = x23, c15 = b25;
        continue;
      }
      let d16 = ae4(a7);
      if (d16 !== null) {
        t6.maxCount = d16;
        continue;
      }
      let p17 = re2(e7, c15, t6);
      if (p17) {
        if (p17.error) return { success: false, error: p17.error };
        c15 = p17.newIndex;
        continue;
      }
      let g18 = le3(e7, c15);
      if (g18) {
        t6.sort = g18.value, c15 = g18.newIndex;
        continue;
      }
      let w19 = a7.startsWith("--") ? [a7] : a7.slice(1).split(""), m25 = false;
      for (let f11 of w19) {
        if (se4.has(f11)) {
          t6.lineNumber = true, o9 = true;
          continue;
        }
        if (f11 === "u" || f11 === "--unrestricted") {
          ne4(t6);
          continue;
        }
        if (f11 === "P" || f11 === "--pcre2") return { success: false, error: { stdout: "", stderr: `rg: PCRE2 is not supported. Use standard regex syntax instead.
`, exitCode: 1 } };
        if (f11.length === 1) {
          let b25 = ie2(f11);
          if (b25) {
            if (c15 + 1 >= e7.length) return { success: false, error: r3("rg", `-${f11}`) };
            let h17 = O5(t6, b25, e7[c15 + 1]);
            if (h17) return { success: false, error: h17 };
            c15++, m25 = true;
            continue;
          }
        }
        let x23 = te5.get(f11);
        if (x23) {
          x23(t6);
          continue;
        }
        if (f11.startsWith("--")) return { success: false, error: r3("rg", f11) };
        if (f11.length === 1) return { success: false, error: r3("rg", `-${f11}`) };
      }
    } else n23 === null && t6.patterns.length === 0 && t6.patternFiles.length === 0 ? n23 = a7 : s9.push(a7);
  }
  return (r8 >= 0 || i10 >= 0) && (t6.afterContext = Math.max(r8 >= 0 ? r8 : 0, i10 >= 0 ? i10 : 0)), (l8 >= 0 || i10 >= 0) && (t6.beforeContext = Math.max(l8 >= 0 ? l8 : 0, i10 >= 0 ? i10 : 0)), n23 !== null && t6.patterns.push(n23), (t6.column || t6.vimgrep) && (o9 = true), { success: true, options: t6, paths: s9, explicitLineNumbers: o9 };
}
async function L5(e7, t6, n23 = false, s9 = false, r8 = []) {
  let l8 = new k5(e7, t6, n23, s9);
  await l8.load(t6);
  for (let i10 of r8) try {
    let o9 = e7.resolvePath(t6, i10), c15 = await e7.readFile(o9);
    l8.addPatternsFromContent(c15, t6);
  } catch {
  }
  return l8;
}
function fe3(e7) {
  return e7.length >= 2 && e7[0] === 31 && e7[1] === 139;
}
function ue3(e7) {
  let t6 = false;
  for (let n23 = 0; n23 < e7.length; n23++) {
    let s9 = e7[n23];
    s9 === "[" && !t6 ? t6 = true : s9 === "]" && t6 && (t6 = false);
  }
  return t6 ? `rg: glob '${e7}' has an unclosed character class` : null;
}
async function J5(e7) {
  let { ctx: t6, options: n23, paths: s9, explicitLineNumbers: r8 } = e7;
  for (let f11 of n23.globs) {
    let x23 = f11.startsWith("!") ? f11.slice(1) : f11, b25 = ue3(x23);
    if (b25) return { stdout: "", stderr: `${b25}
`, exitCode: 1 };
  }
  if (n23.files) {
    let f11 = [...n23.patterns, ...s9];
    return pe2(t6, f11, n23);
  }
  let l8 = [...n23.patterns];
  for (let f11 of n23.patternFiles) try {
    let x23;
    if (f11 === "-") x23 = t6.stdin;
    else {
      let h17 = t6.fs.resolvePath(t6.cwd, f11);
      x23 = await t6.fs.readFile(h17);
    }
    let b25 = x23.split(`
`).filter((h17) => h17.length > 0);
    l8.push(...b25);
  } catch {
    return { stdout: "", stderr: `rg: ${f11}: No such file or directory
`, exitCode: 2 };
  }
  if (l8.length === 0) return n23.patternFiles.length > 0 ? { stdout: "", stderr: "", exitCode: 1 } : { stdout: "", stderr: `rg: no pattern given
`, exitCode: 2 };
  let i10 = s9.length === 0 ? ["."] : s9, o9 = he3(n23, l8), c15, a7;
  try {
    let f11 = ge2(l8, n23, o9);
    c15 = f11.regex, a7 = f11.kResetGroup;
  } catch {
    return { stdout: "", stderr: `rg: invalid regex: ${l8.join(", ")}
`, exitCode: 2 };
  }
  let u11 = null;
  n23.noIgnore || (u11 = await L5(t6.fs, t6.cwd, n23.noIgnoreDot, n23.noIgnoreVcs, n23.ignoreFiles));
  let d16 = new M3();
  for (let f11 of n23.typeClear) d16.clearType(f11);
  for (let f11 of n23.typeAdd) d16.addType(f11);
  let { files: p17, singleExplicitFile: g18 } = await Y4(t6, i10, n23, u11, d16);
  if (p17.length === 0) return { stdout: "", stderr: "", exitCode: 1 };
  let w19 = !n23.noFilename && (n23.withFilename || !g18 || p17.length > 1), m25 = n23.lineNumber;
  return r8 || (g18 && p17.length === 1 && (m25 = false), n23.onlyMatching && (m25 = false)), xe2(t6, p17, c15, n23, w19, m25, a7);
}
function he3(e7, t6) {
  return e7.caseSensitive ? false : e7.ignoreCase ? true : e7.smartCase ? !t6.some((n23) => /[A-Z]/.test(n23)) : false;
}
function ge2(e7, t6, n23) {
  let s9;
  return e7.length === 1 ? s9 = e7[0] : s9 = e7.map((r8) => t6.fixedStrings ? r8.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") : `(?:${r8})`).join("|"), W4(s9, { mode: t6.fixedStrings && e7.length === 1 ? "fixed" : "perl", ignoreCase: n23, wholeWord: t6.wordRegexp, lineRegexp: t6.lineRegexp, multiline: t6.multiline, multilineDotall: t6.multilineDotall });
}
async function Y4(e7, t6, n23, s9, r8) {
  let l8 = [], i10 = 0, o9 = 0;
  for (let a7 of t6) {
    let u11 = e7.fs.resolvePath(e7.cwd, a7);
    try {
      let d16 = await e7.fs.stat(u11);
      if (d16.isFile) {
        if (i10++, n23.maxFilesize > 0 && d16.size > n23.maxFilesize) continue;
        X5(a7, n23, s9, u11, r8) && l8.push(a7);
      } else d16.isDirectory && (o9++, await K5(e7, a7, u11, 0, n23, s9, r8, l8));
    } catch {
    }
  }
  return { files: n23.sort === "path" ? l8.sort() : l8, singleExplicitFile: i10 === 1 && o9 === 0 };
}
async function K5(e7, t6, n23, s9, r8, l8, i10, o9) {
  if (!(s9 >= r8.maxDepth)) {
    l8 && await l8.loadForDirectory(n23);
    try {
      let c15 = e7.fs.readdirWithFileTypes ? await e7.fs.readdirWithFileTypes(n23) : (await e7.fs.readdir(n23)).map((a7) => ({ name: a7, isFile: void 0 }));
      for (let a7 of c15) {
        let u11 = a7.name;
        if (!r8.noIgnore && k5.isCommonIgnored(u11)) continue;
        let d16 = u11.startsWith("."), p17 = t6 === "." ? u11 : t6 === "./" ? `./${u11}` : t6.endsWith("/") ? `${t6}${u11}` : `${t6}/${u11}`, g18 = e7.fs.resolvePath(n23, u11), w19, m25, f11 = false;
        if (a7.isFile !== void 0 && "isDirectory" in a7) {
          let h17 = a7;
          if (f11 = h17.isSymbolicLink === true, f11 && !r8.followSymlinks) continue;
          if (f11 && r8.followSymlinks) try {
            let y18 = await e7.fs.stat(g18);
            w19 = y18.isFile, m25 = y18.isDirectory;
          } catch {
            continue;
          }
          else w19 = h17.isFile, m25 = h17.isDirectory;
        } else try {
          let h17 = e7.fs.lstat ? await e7.fs.lstat(g18) : await e7.fs.stat(g18);
          if (f11 = h17.isSymbolicLink === true, f11 && !r8.followSymlinks) continue;
          let y18 = f11 && r8.followSymlinks ? await e7.fs.stat(g18) : h17;
          w19 = y18.isFile, m25 = y18.isDirectory;
        } catch {
          continue;
        }
        if (!l8?.matches(g18, m25) && !(d16 && !r8.hidden && !l8?.isWhitelisted(g18, m25))) {
          if (m25) await K5(e7, p17, g18, s9 + 1, r8, l8, i10, o9);
          else if (w19) {
            if (r8.maxFilesize > 0) try {
              if ((await e7.fs.stat(g18)).size > r8.maxFilesize) continue;
            } catch {
              continue;
            }
            X5(p17, r8, l8, g18, i10) && o9.push(p17);
          }
        }
      }
    } catch {
    }
  }
}
function X5(e7, t6, n23, s9, r8) {
  let l8 = e7.split("/").pop() || e7;
  if (n23?.matches(s9, false) || t6.types.length > 0 && !r8.matchesType(l8, t6.types) || t6.typesNot.length > 0 && r8.matchesType(l8, t6.typesNot)) return false;
  if (t6.globs.length > 0) {
    let i10 = t6.globCaseInsensitive, o9 = t6.globs.filter((a7) => !a7.startsWith("!")), c15 = t6.globs.filter((a7) => a7.startsWith("!")).map((a7) => a7.slice(1));
    if (o9.length > 0) {
      let a7 = false;
      for (let u11 of o9) if (v7(l8, u11, i10) || v7(e7, u11, i10)) {
        a7 = true;
        break;
      }
      if (!a7) return false;
    }
    for (let a7 of c15) if (a7.startsWith("/")) {
      let u11 = a7.slice(1);
      if (v7(e7, u11, i10)) return false;
    } else if (v7(l8, a7, i10) || v7(e7, a7, i10)) return false;
  }
  if (t6.iglobs.length > 0) {
    let i10 = t6.iglobs.filter((c15) => !c15.startsWith("!")), o9 = t6.iglobs.filter((c15) => c15.startsWith("!")).map((c15) => c15.slice(1));
    if (i10.length > 0) {
      let c15 = false;
      for (let a7 of i10) if (v7(l8, a7, true) || v7(e7, a7, true)) {
        c15 = true;
        break;
      }
      if (!c15) return false;
    }
    for (let c15 of o9) if (c15.startsWith("/")) {
      let a7 = c15.slice(1);
      if (v7(e7, a7, true)) return false;
    } else if (v7(l8, c15, true) || v7(e7, c15, true)) return false;
  }
  return true;
}
function v7(e7, t6, n23 = false) {
  let s9 = "^";
  for (let r8 = 0; r8 < t6.length; r8++) {
    let l8 = t6[r8];
    if (l8 === "*") t6[r8 + 1] === "*" ? (s9 += ".*", r8++) : s9 += "[^/]*";
    else if (l8 === "?") s9 += "[^/]";
    else if (l8 === "[") {
      let i10 = r8 + 1;
      for (i10 < t6.length && t6[i10] === "!" && i10++, i10 < t6.length && t6[i10] === "]" && i10++; i10 < t6.length && t6[i10] !== "]"; ) i10++;
      if (i10 < t6.length) {
        let o9 = t6.slice(r8, i10 + 1);
        o9.startsWith("[!") && (o9 = `[^${o9.slice(2)}`), s9 += o9, r8 = i10;
      } else s9 += "\\[";
    } else s9 += l8.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }
  return s9 += "$", b1(s9, n23 ? "i" : "").test(e7);
}
async function pe2(e7, t6, n23) {
  let s9 = null;
  n23.noIgnore || (s9 = await L5(e7.fs, e7.cwd, n23.noIgnoreDot, n23.noIgnoreVcs, n23.ignoreFiles));
  let r8 = new M3();
  for (let a7 of n23.typeClear) r8.clearType(a7);
  for (let a7 of n23.typeAdd) r8.addType(a7);
  let l8 = t6.length === 0 ? ["."] : t6, { files: i10 } = await Y4(e7, l8, n23, s9, r8);
  if (i10.length === 0) return { stdout: "", stderr: "", exitCode: 1 };
  if (n23.quiet) return { stdout: "", stderr: "", exitCode: 0 };
  let o9 = n23.nullSeparator ? "\0" : `
`;
  return { stdout: i10.map((a7) => a7 + o9).join(""), stderr: "", exitCode: 0 };
}
function me2(e7, t6) {
  if (t6.length === 0) return true;
  for (let n23 of t6) if (v7(e7, n23, false)) return true;
  return false;
}
async function de3(e7, t6, n23, s9) {
  try {
    if (s9.preprocessor && e7.exec) {
      let i10 = n23.split("/").pop() || n23;
      if (me2(i10, s9.preprocessorGlobs)) {
        let o9 = await e7.exec(`${s9.preprocessor} "${t6}"`, { cwd: e7.cwd });
        if (o9.exitCode === 0 && o9.stdout) {
          let c15 = o9.stdout.slice(0, 8192);
          return { content: o9.stdout, isBinary: c15.includes("\0") };
        }
      }
    }
    if (s9.searchZip && n23.endsWith(".gz")) {
      let i10 = await e7.fs.readFileBuffer(t6);
      if (fe3(i10)) try {
        let o9 = gunzipSync(i10), c15 = new TextDecoder().decode(o9), a7 = c15.slice(0, 8192);
        return { content: c15, isBinary: a7.includes("\0") };
      } catch {
        return null;
      }
    }
    let r8 = await e7.fs.readFile(t6), l8 = r8.slice(0, 8192);
    return { content: r8, isBinary: l8.includes("\0") };
  } catch {
    return null;
  }
}
async function xe2(e7, t6, n23, s9, r8, l8, i10) {
  let o9 = "", c15 = false, a7 = [], u11 = 0, d16 = 0, p17 = 0, g18 = 50;
  e: for (let f11 = 0; f11 < t6.length; f11 += g18) {
    let x23 = t6.slice(f11, f11 + g18), b25 = await Promise.all(x23.map(async (h17) => {
      let y18 = e7.fs.resolvePath(e7.cwd, h17), F21 = await de3(e7, y18, h17, s9);
      if (!F21) return null;
      let { content: C19, isBinary: N15 } = F21;
      if (p17 += C19.length, N15 && !s9.searchBinary) return null;
      let W15 = r8 && !s9.heading ? h17 : "", S17 = D4(C19, n23, { invertMatch: s9.invertMatch, showLineNumbers: l8, countOnly: s9.count, countMatches: s9.countMatches, filename: W15, onlyMatching: s9.onlyMatching, beforeContext: s9.beforeContext, afterContext: s9.afterContext, maxCount: s9.maxCount, contextSeparator: s9.contextSeparator, showColumn: s9.column, vimgrep: s9.vimgrep, showByteOffset: s9.byteOffset, replace: s9.replace !== null ? le2(s9.replace) : null, passthru: s9.passthru, multiline: s9.multiline, kResetGroup: i10 });
      return s9.json && S17.matched ? { file: h17, result: S17, content: C19, isBinary: false } : { file: h17, result: S17 };
    }));
    for (let h17 of b25) {
      if (!h17) continue;
      let { file: y18, result: F21 } = h17;
      if (F21.matched) {
        if (c15 = true, d16++, u11 += F21.matchCount, s9.quiet && !s9.json) break e;
        if (s9.json && !s9.quiet) {
          let C19 = h17.content || "";
          a7.push(JSON.stringify({ type: "begin", data: { path: { text: y18 } } }));
          let N15 = C19.split(`
`);
          n23.lastIndex = 0;
          let W15 = 0;
          for (let S17 = 0; S17 < N15.length; S17++) {
            let j12 = N15[S17];
            n23.lastIndex = 0;
            let P20 = [];
            for (let I18 = n23.exec(j12); I18 !== null; I18 = n23.exec(j12)) {
              let R13 = { match: { text: I18[0] }, start: I18.index, end: I18.index + I18[0].length };
              s9.replace !== null && (R13.replacement = { text: s9.replace }), P20.push(R13), I18[0].length === 0 && n23.lastIndex++;
            }
            if (P20.length > 0) {
              let I18 = { type: "match", data: { path: { text: y18 }, lines: { text: `${j12}
` }, line_number: S17 + 1, absolute_offset: W15, submatches: P20 } };
              a7.push(JSON.stringify(I18));
            }
            W15 += j12.length + 1;
          }
          a7.push(JSON.stringify({ type: "end", data: { path: { text: y18 }, binary_offset: null, stats: { elapsed: { secs: 0, nanos: 0, human: "0s" }, searches: 1, searches_with_match: 1, bytes_searched: C19.length, bytes_printed: 0, matched_lines: F21.matchCount, matches: F21.matchCount } } }));
        } else if (s9.filesWithMatches) {
          let C19 = s9.nullSeparator ? "\0" : `
`;
          o9 += `${y18}${C19}`;
        } else s9.filesWithoutMatch || (s9.heading && !s9.noFilename && (o9 += `${y18}
`), o9 += F21.output);
      } else if (s9.filesWithoutMatch) {
        let C19 = s9.nullSeparator ? "\0" : `
`;
        o9 += `${y18}${C19}`;
      } else s9.includeZero && (s9.count || s9.countMatches) && (o9 += F21.output);
    }
  }
  s9.json && (a7.push(JSON.stringify({ type: "summary", data: { elapsed_total: { secs: 0, nanos: 0, human: "0s" }, stats: { elapsed: { secs: 0, nanos: 0, human: "0s" }, searches: t6.length, searches_with_match: d16, bytes_searched: p17, bytes_printed: 0, matched_lines: u11, matches: u11 } } })), o9 = `${a7.join(`
`)}
`);
  let w19 = s9.quiet && !s9.json ? "" : o9;
  if (s9.stats && !s9.json) {
    let f11 = ["", `${u11} matches`, `${u11} matched lines`, `${d16} files contained matches`, `${t6.length} files searched`, `${p17} bytes searched`].join(`
`);
    w19 += `${f11}
`;
  }
  let m25;
  return s9.filesWithoutMatch ? m25 = o9.length > 0 ? 0 : 1 : m25 = c15 ? 0 : 1, { stdout: w19, stderr: "", exitCode: m25 };
}
var G3, M3, V5, te5, se4, T2, k5, ye2, Re2, Ae2;
var init_chunk_QOENL5UZ = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-QOENL5UZ.js"() {
    init_chunk_VLGZJRPG();
    init_chunk_YNYSPYQ5();
    init_chunk_74CEPOFO();
    init_node_zlib();
    G3 = { js: { extensions: [".js", ".mjs", ".cjs", ".jsx"], globs: [] }, ts: { extensions: [".ts", ".tsx", ".mts", ".cts"], globs: [] }, html: { extensions: [".html", ".htm", ".xhtml"], globs: [] }, css: { extensions: [".css", ".scss", ".sass", ".less"], globs: [] }, json: { extensions: [".json", ".jsonc", ".json5"], globs: [] }, xml: { extensions: [".xml", ".xsl", ".xslt"], globs: [] }, c: { extensions: [".c", ".h"], globs: [] }, cpp: { extensions: [".cpp", ".cc", ".cxx", ".hpp", ".hh", ".hxx", ".h"], globs: [] }, rust: { extensions: [".rs"], globs: [] }, go: { extensions: [".go"], globs: [] }, zig: { extensions: [".zig"], globs: [] }, java: { extensions: [".java"], globs: [] }, kotlin: { extensions: [".kt", ".kts"], globs: [] }, scala: { extensions: [".scala", ".sc"], globs: [] }, clojure: { extensions: [".clj", ".cljc", ".cljs", ".edn"], globs: [] }, py: { extensions: [".py", ".pyi", ".pyw"], globs: [] }, rb: { extensions: [".rb", ".rake", ".gemspec"], globs: ["Rakefile", "Gemfile"] }, php: { extensions: [".php", ".phtml", ".php3", ".php4", ".php5"], globs: [] }, perl: { extensions: [".pl", ".pm", ".pod", ".t"], globs: [] }, lua: { extensions: [".lua"], globs: [] }, sh: { extensions: [".sh", ".bash", ".zsh", ".fish"], globs: [".bashrc", ".zshrc", ".profile"] }, bat: { extensions: [".bat", ".cmd"], globs: [] }, ps: { extensions: [".ps1", ".psm1", ".psd1"], globs: [] }, yaml: { extensions: [".yaml", ".yml"], globs: [] }, toml: { extensions: [".toml"], globs: ["Cargo.toml", "pyproject.toml"] }, ini: { extensions: [".ini", ".cfg", ".conf"], globs: [] }, csv: { extensions: [".csv", ".tsv"], globs: [] }, md: { extensions: [".md", ".mdx", ".markdown", ".mdown", ".mkd"], globs: [] }, markdown: { extensions: [".md", ".mdx", ".markdown", ".mdown", ".mkd"], globs: [] }, rst: { extensions: [".rst"], globs: [] }, txt: { extensions: [".txt", ".text"], globs: [] }, tex: { extensions: [".tex", ".ltx", ".sty", ".cls"], globs: [] }, sql: { extensions: [".sql"], globs: [] }, graphql: { extensions: [".graphql", ".gql"], globs: [] }, proto: { extensions: [".proto"], globs: [] }, make: { extensions: [".mk", ".mak"], globs: ["Makefile", "GNUmakefile", "makefile"] }, docker: { extensions: [], globs: ["Dockerfile", "Dockerfile.*", "*.dockerfile"] }, tf: { extensions: [".tf", ".tfvars"], globs: [] } };
    M3 = class {
      types;
      constructor() {
        this.types = new Map(Object.entries(G3).map(([t6, n23]) => [t6, { extensions: [...n23.extensions], globs: [...n23.globs] }]));
      }
      addType(t6) {
        let n23 = t6.indexOf(":");
        if (n23 === -1) return;
        let s9 = t6.slice(0, n23), r8 = t6.slice(n23 + 1);
        if (r8.startsWith("include:")) {
          let l8 = r8.slice(8), i10 = this.types.get(l8);
          if (i10) {
            let o9 = this.types.get(s9) || { extensions: [], globs: [] };
            o9.extensions.push(...i10.extensions), o9.globs.push(...i10.globs), this.types.set(s9, o9);
          }
        } else {
          let l8 = this.types.get(s9) || { extensions: [], globs: [] };
          if (r8.startsWith("*.") && !r8.slice(2).includes("*")) {
            let i10 = r8.slice(1);
            l8.extensions.includes(i10) || l8.extensions.push(i10);
          } else l8.globs.includes(r8) || l8.globs.push(r8);
          this.types.set(s9, l8);
        }
      }
      clearType(t6) {
        let n23 = this.types.get(t6);
        n23 && (n23.extensions = [], n23.globs = []);
      }
      getType(t6) {
        return this.types.get(t6);
      }
      getAllTypes() {
        return this.types;
      }
      matchesType(t6, n23) {
        let s9 = t6.toLowerCase();
        for (let r8 of n23) {
          if (r8 === "all") {
            if (this.matchesAnyType(t6)) return true;
            continue;
          }
          let l8 = this.types.get(r8);
          if (l8) {
            for (let i10 of l8.extensions) if (s9.endsWith(i10)) return true;
            for (let i10 of l8.globs) if (i10.includes("*")) {
              let o9 = i10.replace(/\./g, "\\.").replace(/\*/g, ".*");
              if (b1(`^${o9}$`, "i").test(t6)) return true;
            } else if (s9 === i10.toLowerCase()) return true;
          }
        }
        return false;
      }
      matchesAnyType(t6) {
        let n23 = t6.toLowerCase();
        for (let s9 of this.types.values()) {
          for (let r8 of s9.extensions) if (n23.endsWith(r8)) return true;
          for (let r8 of s9.globs) if (r8.includes("*")) {
            let l8 = r8.replace(/\./g, "\\.").replace(/\*/g, ".*");
            if (b1(`^${l8}$`, "i").test(t6)) return true;
          } else if (n23 === r8.toLowerCase()) return true;
        }
        return false;
      }
    };
    V5 = [{ short: "g", long: "glob", target: "globs", multi: true }, { long: "iglob", target: "iglobs", multi: true }, { short: "t", long: "type", target: "types", multi: true, validate: H5 }, { short: "T", long: "type-not", target: "typesNot", multi: true, validate: H5 }, { long: "type-add", target: "typeAdd", multi: true }, { long: "type-clear", target: "typeClear", multi: true }, { short: "m", long: "max-count", target: "maxCount", parse: parseInt }, { short: "e", long: "regexp", target: "patterns", multi: true }, { short: "f", long: "file", target: "patternFiles", multi: true }, { short: "r", long: "replace", target: "replace" }, { short: "d", long: "max-depth", target: "maxDepth", parse: parseInt }, { long: "max-filesize", target: "maxFilesize", parse: Q5, validate: ee3 }, { long: "context-separator", target: "contextSeparator" }, { short: "j", long: "threads", target: "maxDepth", parse: () => 1 / 0 }, { long: "ignore-file", target: "ignoreFiles", multi: true }, { long: "pre", target: "preprocessor" }, { long: "pre-glob", target: "preprocessorGlobs", multi: true }];
    te5 = /* @__PURE__ */ new Map([["i", (e7) => {
      e7.ignoreCase = true, e7.caseSensitive = false, e7.smartCase = false;
    }], ["--ignore-case", (e7) => {
      e7.ignoreCase = true, e7.caseSensitive = false, e7.smartCase = false;
    }], ["s", (e7) => {
      e7.caseSensitive = true, e7.ignoreCase = false, e7.smartCase = false;
    }], ["--case-sensitive", (e7) => {
      e7.caseSensitive = true, e7.ignoreCase = false, e7.smartCase = false;
    }], ["S", (e7) => {
      e7.smartCase = true, e7.ignoreCase = false, e7.caseSensitive = false;
    }], ["--smart-case", (e7) => {
      e7.smartCase = true, e7.ignoreCase = false, e7.caseSensitive = false;
    }], ["F", (e7) => {
      e7.fixedStrings = true;
    }], ["--fixed-strings", (e7) => {
      e7.fixedStrings = true;
    }], ["w", (e7) => {
      e7.wordRegexp = true;
    }], ["--word-regexp", (e7) => {
      e7.wordRegexp = true;
    }], ["x", (e7) => {
      e7.lineRegexp = true;
    }], ["--line-regexp", (e7) => {
      e7.lineRegexp = true;
    }], ["v", (e7) => {
      e7.invertMatch = true;
    }], ["--invert-match", (e7) => {
      e7.invertMatch = true;
    }], ["U", (e7) => {
      e7.multiline = true;
    }], ["--multiline", (e7) => {
      e7.multiline = true;
    }], ["--multiline-dotall", (e7) => {
      e7.multilineDotall = true, e7.multiline = true;
    }], ["c", (e7) => {
      e7.count = true;
    }], ["--count", (e7) => {
      e7.count = true;
    }], ["--count-matches", (e7) => {
      e7.countMatches = true;
    }], ["l", (e7) => {
      e7.filesWithMatches = true;
    }], ["--files", (e7) => {
      e7.files = true;
    }], ["--files-with-matches", (e7) => {
      e7.filesWithMatches = true;
    }], ["--files-without-match", (e7) => {
      e7.filesWithoutMatch = true;
    }], ["--stats", (e7) => {
      e7.stats = true;
    }], ["o", (e7) => {
      e7.onlyMatching = true;
    }], ["--only-matching", (e7) => {
      e7.onlyMatching = true;
    }], ["q", (e7) => {
      e7.quiet = true;
    }], ["--quiet", (e7) => {
      e7.quiet = true;
    }], ["N", (e7) => {
      e7.lineNumber = false;
    }], ["--no-line-number", (e7) => {
      e7.lineNumber = false;
    }], ["H", (e7) => {
      e7.withFilename = true;
    }], ["--with-filename", (e7) => {
      e7.withFilename = true;
    }], ["I", (e7) => {
      e7.noFilename = true;
    }], ["--no-filename", (e7) => {
      e7.noFilename = true;
    }], ["0", (e7) => {
      e7.nullSeparator = true;
    }], ["--null", (e7) => {
      e7.nullSeparator = true;
    }], ["b", (e7) => {
      e7.byteOffset = true;
    }], ["--byte-offset", (e7) => {
      e7.byteOffset = true;
    }], ["--column", (e7) => {
      e7.column = true, e7.lineNumber = true;
    }], ["--no-column", (e7) => {
      e7.column = false;
    }], ["--vimgrep", (e7) => {
      e7.vimgrep = true, e7.column = true, e7.lineNumber = true;
    }], ["--json", (e7) => {
      e7.json = true;
    }], ["--hidden", (e7) => {
      e7.hidden = true;
    }], ["--no-ignore", (e7) => {
      e7.noIgnore = true;
    }], ["--no-ignore-dot", (e7) => {
      e7.noIgnoreDot = true;
    }], ["--no-ignore-vcs", (e7) => {
      e7.noIgnoreVcs = true;
    }], ["L", (e7) => {
      e7.followSymlinks = true;
    }], ["--follow", (e7) => {
      e7.followSymlinks = true;
    }], ["z", (e7) => {
      e7.searchZip = true;
    }], ["--search-zip", (e7) => {
      e7.searchZip = true;
    }], ["a", (e7) => {
      e7.searchBinary = true;
    }], ["--text", (e7) => {
      e7.searchBinary = true;
    }], ["--heading", (e7) => {
      e7.heading = true;
    }], ["--passthru", (e7) => {
      e7.passthru = true;
    }], ["--include-zero", (e7) => {
      e7.includeZero = true;
    }], ["--glob-case-insensitive", (e7) => {
      e7.globCaseInsensitive = true;
    }]]);
    se4 = /* @__PURE__ */ new Set(["n", "--line-number"]);
    T2 = class {
      patterns = [];
      basePath;
      constructor(t6 = "/") {
        this.basePath = t6;
      }
      parse(t6) {
        let n23 = t6.split(`
`);
        for (let s9 of n23) {
          let r8 = s9.replace(/\s+$/, "");
          if (!r8 || r8.startsWith("#")) continue;
          let l8 = false;
          r8.startsWith("!") && (l8 = true, r8 = r8.slice(1));
          let i10 = false;
          r8.endsWith("/") && (i10 = true, r8 = r8.slice(0, -1));
          let o9 = false;
          r8.startsWith("/") ? (o9 = true, r8 = r8.slice(1)) : r8.includes("/") && !r8.startsWith("**/") && (o9 = true);
          let c15 = this.patternToRegex(r8, o9);
          this.patterns.push({ pattern: s9, regex: c15, negated: l8, directoryOnly: i10, rooted: o9 });
        }
      }
      patternToRegex(t6, n23) {
        let s9 = "";
        n23 ? s9 = "^" : s9 = "(?:^|/)";
        let r8 = 0;
        for (; r8 < t6.length; ) {
          let l8 = t6[r8];
          if (l8 === "*") t6[r8 + 1] === "*" ? t6[r8 + 2] === "/" ? (s9 += "(?:.*/)?", r8 += 3) : (r8 + 2 >= t6.length, s9 += ".*", r8 += 2) : (s9 += "[^/]*", r8++);
          else if (l8 === "?") s9 += "[^/]", r8++;
          else if (l8 === "[") {
            let i10 = r8 + 1;
            for (i10 < t6.length && t6[i10] === "!" && i10++, i10 < t6.length && t6[i10] === "]" && i10++; i10 < t6.length && t6[i10] !== "]"; ) i10++;
            if (i10 < t6.length) {
              let o9 = t6.slice(r8, i10 + 1);
              o9.startsWith("[!") && (o9 = `[^${o9.slice(2)}`), s9 += o9, r8 = i10 + 1;
            } else s9 += "\\[", r8++;
          } else l8 === "/" ? (s9 += "/", r8++) : (s9 += l8.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), r8++);
        }
        return s9 += "(?:/.*)?$", b1(s9);
      }
      matches(t6, n23) {
        let s9 = t6.replace(/^\.\//, "");
        s9 = s9.replace(/^\//, "");
        let r8 = false;
        for (let l8 of this.patterns) l8.directoryOnly && !n23 || l8.regex.test(s9) && (r8 = !l8.negated);
        return r8;
      }
      isWhitelisted(t6, n23) {
        let s9 = t6.replace(/^\.\//, "");
        s9 = s9.replace(/^\//, "");
        for (let r8 of this.patterns) if (!(r8.directoryOnly && !n23) && r8.negated && r8.regex.test(s9)) return true;
        return false;
      }
      getBasePath() {
        return this.basePath;
      }
    };
    k5 = class {
      parsers = [];
      fs;
      skipDotIgnore;
      skipVcsIgnore;
      loadedDirs = /* @__PURE__ */ new Set();
      constructor(t6, n23, s9 = false, r8 = false) {
        this.fs = t6, this.skipDotIgnore = s9, this.skipVcsIgnore = r8;
      }
      async load(t6) {
        let n23 = [], s9 = t6;
        for (; ; ) {
          n23.unshift(s9);
          let l8 = this.fs.resolvePath(s9, "..");
          if (l8 === s9) break;
          s9 = l8;
        }
        let r8 = [];
        this.skipVcsIgnore || r8.push(".gitignore"), this.skipDotIgnore || r8.push(".rgignore", ".ignore");
        for (let l8 of n23) {
          this.loadedDirs.add(l8);
          for (let i10 of r8) {
            let o9 = this.fs.resolvePath(l8, i10);
            try {
              let c15 = await this.fs.readFile(o9), a7 = new T2(l8);
              a7.parse(c15), this.parsers.push(a7);
            } catch {
            }
          }
        }
      }
      async loadForDirectory(t6) {
        if (this.loadedDirs.has(t6)) return;
        this.loadedDirs.add(t6);
        let n23 = [];
        this.skipVcsIgnore || n23.push(".gitignore"), this.skipDotIgnore || n23.push(".rgignore", ".ignore");
        for (let s9 of n23) {
          let r8 = this.fs.resolvePath(t6, s9);
          try {
            let l8 = await this.fs.readFile(r8), i10 = new T2(t6);
            i10.parse(l8), this.parsers.push(i10);
          } catch {
          }
        }
      }
      addPatternsFromContent(t6, n23) {
        let s9 = new T2(n23);
        s9.parse(t6), this.parsers.push(s9);
      }
      matches(t6, n23) {
        for (let s9 of this.parsers) {
          let r8 = s9.getBasePath();
          if (!t6.startsWith(r8)) continue;
          let l8 = t6.slice(r8.length).replace(/^\//, "");
          if (s9.matches(l8, n23)) return true;
        }
        return false;
      }
      isWhitelisted(t6, n23) {
        for (let s9 of this.parsers) {
          let r8 = s9.getBasePath();
          if (!t6.startsWith(r8)) continue;
          let l8 = t6.slice(r8.length).replace(/^\//, "");
          if (s9.isWhitelisted(l8, n23)) return true;
        }
        return false;
      }
      static isCommonIgnored(t6) {
        return (/* @__PURE__ */ new Set(["node_modules", ".git", ".svn", ".hg", "__pycache__", ".pytest_cache", ".mypy_cache", "venv", ".venv", ".next", ".nuxt", ".cargo"])).has(t6);
      }
    };
    ye2 = { name: "rg", summary: "recursively search for a pattern", usage: "rg [OPTIONS] PATTERN [PATH ...]", description: `rg (ripgrep) recursively searches directories for a regex pattern.
Unlike grep, rg is recursive by default and respects .gitignore files.

EXAMPLES:
  rg foo                    Search for 'foo' in current directory
  rg foo src/               Search in src/ directory
  rg -i foo                 Case-insensitive search
  rg -w foo                 Match whole words only
  rg -t js foo              Search only JavaScript files
  rg -g '*.ts' foo          Search files matching glob
  rg --hidden foo           Include hidden files
  rg -l foo                 List files with matches only`, options: ["-e, --regexp PATTERN    search for PATTERN (can be used multiple times)", "-f, --file FILE         read patterns from FILE, one per line", "-i, --ignore-case       case-insensitive search", "-s, --case-sensitive    case-sensitive search (overrides smart-case)", "-S, --smart-case        smart case (default: case-insensitive unless pattern has uppercase)", "-F, --fixed-strings     treat pattern as literal string", "-w, --word-regexp       match whole words only", "-x, --line-regexp       match whole lines only", "-v, --invert-match      select non-matching lines", "-r, --replace TEXT      replace matches with TEXT", "-c, --count             print count of matching lines per file", "    --count-matches     print count of individual matches per file", "-l, --files-with-matches print only file names with matches", "    --files-without-match print file names without matches", "    --files             list files that would be searched", "-o, --only-matching     print only matching parts", "-m, --max-count NUM     stop after NUM matches per file", "-q, --quiet             suppress output, exit 0 on match", "    --stats             print search statistics", "-n, --line-number       print line numbers (default: on)", "-N, --no-line-number    do not print line numbers", "-I, --no-filename       suppress the prefixing of file names", "-0, --null              use NUL as filename separator", "-b, --byte-offset       show byte offset of each match", "    --column            show column number of first match", "    --vimgrep           show results in vimgrep format", "    --json              show results in JSON Lines format", "-A NUM                  print NUM lines after each match", "-B NUM                  print NUM lines before each match", "-C NUM                  print NUM lines before and after each match", "    --context-separator SEP  separator for context groups (default: --)", "-U, --multiline         match patterns across lines", "-z, --search-zip        search in compressed files (gzip only)", "-g, --glob GLOB         include files matching GLOB", "-t, --type TYPE         only search files of TYPE (e.g., js, py, ts)", "-T, --type-not TYPE     exclude files of TYPE", "-L, --follow            follow symbolic links", "-u, --unrestricted      reduce filtering (-u: no ignore, -uu: +hidden, -uuu: +binary)", "-a, --text              search binary files as text", "    --hidden            search hidden files and directories", "    --no-ignore         don't respect .gitignore/.ignore files", "-d, --max-depth NUM     maximum search depth", "    --sort TYPE         sort files (path, none)", "    --heading           show file path above matches", "    --passthru          print all lines (non-matches use - separator)", "    --include-zero      include files with 0 matches in count output", "    --type-list         list all available file types", "    --help              display this help and exit"] };
    Re2 = { name: "rg", async execute(e7, t6) {
      if (o2(e7)) return s(ye2);
      if (e7.includes("--type-list")) return { stdout: U4(), stderr: "", exitCode: 0 };
      let n23 = Z4(e7);
      return n23.success ? J5({ ctx: t6, options: n23.options, paths: n23.paths, explicitLineNumbers: n23.explicitLineNumbers }) : n23.error;
    } };
    Ae2 = { name: "rg", flags: [{ flag: "-i", type: "boolean" }, { flag: "-s", type: "boolean" }, { flag: "-S", type: "boolean" }, { flag: "-F", type: "boolean" }, { flag: "-w", type: "boolean" }, { flag: "-x", type: "boolean" }, { flag: "-v", type: "boolean" }, { flag: "-c", type: "boolean" }, { flag: "-l", type: "boolean" }, { flag: "-o", type: "boolean" }, { flag: "-n", type: "boolean" }, { flag: "-N", type: "boolean" }, { flag: "--hidden", type: "boolean" }, { flag: "--no-ignore", type: "boolean" }, { flag: "-m", type: "value", valueHint: "number" }, { flag: "-A", type: "value", valueHint: "number" }, { flag: "-B", type: "value", valueHint: "number" }, { flag: "-C", type: "value", valueHint: "number" }, { flag: "-g", type: "value", valueHint: "pattern" }, { flag: "-t", type: "value", valueHint: "string" }, { flag: "-T", type: "value", valueHint: "string" }], needsArgs: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/rg-ORQK4GVH.js
var rg_ORQK4GVH_exports = {};
__export(rg_ORQK4GVH_exports, {
  flagsForFuzzing: () => Ae2,
  rgCommand: () => Re2
});
var init_rg_ORQK4GVH = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/rg-ORQK4GVH.js"() {
    init_chunk_QOENL5UZ();
    init_chunk_VLGZJRPG();
    init_chunk_YNYSPYQ5();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-MZLOTDD7.js
function P5(i10) {
  let e7 = "", t6 = 0, n23 = false;
  for (; t6 < i10.length; ) {
    if (i10[t6] === "[" && !n23) {
      if (i10[t6 + 1] === "[" && i10[t6 + 2] === ":") {
        let s9 = i10.indexOf(":]]", t6 + 3);
        if (s9 !== -1) {
          let r8 = i10.slice(t6 + 3, s9), a7 = B4.get(r8);
          if (a7) {
            e7 += `[${a7}]`, t6 = s9 + 3;
            continue;
          }
        }
      }
      if (i10[t6 + 1] === "^" && i10[t6 + 2] === "[" && i10[t6 + 3] === ":") {
        let s9 = i10.indexOf(":]]", t6 + 4);
        if (s9 !== -1) {
          let r8 = i10.slice(t6 + 4, s9), a7 = B4.get(r8);
          if (a7) {
            e7 += `[^${a7}]`, t6 = s9 + 3;
            continue;
          }
        }
      }
      e7 += "[", t6++, n23 = true, t6 < i10.length && i10[t6] === "^" && (e7 += "^", t6++), t6 < i10.length && i10[t6] === "]" && (e7 += "\\]", t6++);
      continue;
    }
    if (n23) {
      if (i10[t6] === "]") {
        e7 += "]", t6++, n23 = false;
        continue;
      }
      if (i10[t6] === "[" && i10[t6 + 1] === ":") {
        let s9 = i10.indexOf(":]", t6 + 2);
        if (s9 !== -1) {
          let r8 = i10.slice(t6 + 2, s9), a7 = B4.get(r8);
          if (a7) {
            e7 += a7, t6 = s9 + 2;
            continue;
          }
        }
      }
      if (i10[t6] === "\\" && t6 + 1 < i10.length) {
        e7 += i10[t6] + i10[t6 + 1], t6 += 2;
        continue;
      }
      e7 += i10[t6], t6++;
      continue;
    }
    if (i10[t6] === "\\" && t6 + 1 < i10.length) {
      let s9 = i10[t6 + 1];
      if (s9 === "+" || s9 === "?" || s9 === "|") {
        e7 += s9, t6 += 2;
        continue;
      }
      if (s9 === "(" || s9 === ")") {
        e7 += s9, t6 += 2;
        continue;
      }
      if (s9 === "{" || s9 === "}") {
        e7 += s9, t6 += 2;
        continue;
      }
      if (s9 === "t") {
        e7 += "	", t6 += 2;
        continue;
      }
      if (s9 === "n") {
        e7 += `
`, t6 += 2;
        continue;
      }
      if (s9 === "r") {
        e7 += "\r", t6 += 2;
        continue;
      }
      e7 += i10[t6] + s9, t6 += 2;
      continue;
    }
    if (i10[t6] === "+" || i10[t6] === "?" || i10[t6] === "|" || i10[t6] === "(" || i10[t6] === ")") {
      e7 += `\\${i10[t6]}`, t6++;
      continue;
    }
    if (i10[t6] === "^" && !(e7 === "" || e7.endsWith("("))) {
      e7 += "\\^", t6++;
      continue;
    }
    if (i10[t6] === "$") {
      let s9 = t6 === i10.length - 1, r8 = t6 + 2 < i10.length && i10[t6 + 1] === "\\" && i10[t6 + 2] === ")";
      if (!s9 && !r8) {
        e7 += "\\$", t6++;
        continue;
      }
    }
    e7 += i10[t6], t6++;
  }
  return e7;
}
function D5(i10) {
  let e7 = "", t6 = false;
  for (let n23 = 0; n23 < i10.length; n23++) i10[n23] === "[" && !t6 ? (t6 = true, e7 += "[", n23++, n23 < i10.length && i10[n23] === "^" && (e7 += "^", n23++), n23 < i10.length && i10[n23] === "]" && (e7 += "]", n23++), n23--) : i10[n23] === "]" && t6 ? (t6 = false, e7 += "]") : !t6 && i10[n23] === "{" && i10[n23 + 1] === "," ? (e7 += "{0,", n23++) : e7 += i10[n23];
  return e7;
}
function Z5(i10) {
  let e7 = "";
  for (let t6 = 0; t6 < i10.length; t6++) {
    let n23 = i10[t6], s9 = n23.charCodeAt(0);
    n23 === "\\" ? e7 += "\\\\" : n23 === "	" ? e7 += "\\t" : n23 === `
` ? e7 += `$
` : n23 === "\r" ? e7 += "\\r" : n23 === "\x07" ? e7 += "\\a" : n23 === "\b" ? e7 += "\\b" : n23 === "\f" ? e7 += "\\f" : n23 === "\v" ? e7 += "\\v" : s9 < 32 || s9 >= 127 ? e7 += `\\${s9.toString(8).padStart(3, "0")}` : e7 += n23;
  }
  return `${e7}$`;
}
function K6(i10, e7, t6) {
  return { patternSpace: "", holdSpace: "", lineNumber: 0, totalLines: i10, deleted: false, printed: false, quit: false, quitSilent: false, exitCode: void 0, errorMessage: void 0, appendBuffer: [], substitutionMade: false, lineNumberOutput: [], nCommandOutput: [], restartCycle: false, inDRestartedCycle: false, currentFilename: e7, pendingFileReads: [], pendingFileWrites: [], pendingExecute: void 0, rangeStates: t6 || /* @__PURE__ */ new Map(), linesConsumedInCycle: 0 };
}
function ce3(i10) {
  return typeof i10 == "object" && "first" in i10 && "step" in i10;
}
function le4(i10) {
  return typeof i10 == "object" && "offset" in i10;
}
function O6(i10, e7, t6, n23, s9) {
  if (i10 === "$") return e7 === t6;
  if (typeof i10 == "number") return e7 === i10;
  if (ce3(i10)) {
    let { first: r8, step: a7 } = i10;
    return a7 === 0 ? e7 === r8 : (e7 - r8) % a7 === 0 && e7 >= r8;
  }
  if (typeof i10 == "object" && "pattern" in i10) try {
    let r8 = i10.pattern;
    r8 === "" && s9?.lastPattern ? r8 = s9.lastPattern : r8 !== "" && s9 && (s9.lastPattern = r8);
    let a7 = D5(P5(r8));
    return b1(a7).test(n23);
  } catch {
    return false;
  }
  return false;
}
function W5(i10) {
  let e7 = (t6) => t6 === void 0 ? "undefined" : t6 === "$" ? "$" : typeof t6 == "number" ? String(t6) : "pattern" in t6 ? `/${t6.pattern}/` : "first" in t6 ? `${t6.first}~${t6.step}` : "unknown";
  return `${e7(i10.start)},${e7(i10.end)}`;
}
function oe4(i10, e7, t6, n23, s9, r8) {
  if (!i10 || !i10.start && !i10.end) return true;
  let a7 = i10.start, c15 = i10.end;
  if (a7 !== void 0 && c15 === void 0) return O6(a7, e7, t6, n23, r8);
  if (a7 !== void 0 && c15 !== void 0) {
    let o9 = typeof a7 == "object" && "pattern" in a7, d16 = typeof c15 == "object" && "pattern" in c15, p17 = le4(c15);
    if (p17 && s9) {
      let m25 = W5(i10), f11 = s9.get(m25);
      if (f11 || (f11 = { active: false }, s9.set(m25, f11)), f11.active) {
        let u11 = f11.startLine || e7;
        return e7 >= u11 + c15.offset && (f11.active = false, s9.set(m25, f11)), true;
      } else return O6(a7, e7, t6, n23, r8) ? (f11.active = true, f11.startLine = e7, s9.set(m25, f11), c15.offset === 0 && (f11.active = false, s9.set(m25, f11)), true) : false;
    }
    if (!o9 && !d16 && !p17) {
      let m25 = typeof a7 == "number" ? a7 : a7 === "$" ? t6 : 1, f11 = typeof c15 == "number" ? c15 : t6;
      if (m25 <= f11) return e7 >= m25 && e7 <= f11;
      if (s9) {
        let u11 = W5(i10), h17 = s9.get(u11);
        return h17 || (h17 = { active: false }, s9.set(u11, h17)), !h17.completed && e7 >= m25 ? (h17.completed = true, s9.set(u11, h17), true) : false;
      }
      return false;
    }
    if (s9) {
      let m25 = W5(i10), f11 = s9.get(m25);
      if (f11 || (f11 = { active: false }, s9.set(m25, f11)), f11.active) return O6(c15, e7, t6, n23, r8) && (f11.active = false, typeof a7 == "number" && (f11.completed = true), s9.set(m25, f11)), true;
      {
        if (f11.completed) return false;
        let u11 = false;
        return typeof a7 == "number" ? u11 = e7 >= a7 : u11 = O6(a7, e7, t6, n23, r8), u11 ? (f11.active = true, f11.startLine = e7, s9.set(m25, f11), O6(c15, e7, t6, n23, r8) && (f11.active = false, typeof a7 == "number" && (f11.completed = true), s9.set(m25, f11)), true) : false;
      }
    }
    return O6(a7, e7, t6, n23, r8);
  }
  return true;
}
function I6(i10, e7, t6, n23, s9, r8) {
  let a7 = oe4(i10, e7, t6, n23, s9, r8);
  return i10?.negated ? !a7 : a7;
}
function ue4(i10, e7, t6, n23) {
  let s9 = "", r8 = 0, a7 = false;
  for (; r8 <= i10.length; ) {
    e7.lastIndex = r8;
    let c15 = e7.exec(i10);
    if (!c15) {
      s9 += i10.slice(r8);
      break;
    }
    if (c15.index !== r8) {
      s9 += i10.slice(r8, c15.index), r8 = c15.index, a7 = false;
      continue;
    }
    let o9 = c15[0], d16 = c15.slice(1);
    if (a7 && o9.length === 0) {
      if (r8 < i10.length) s9 += i10[r8], r8++;
      else break;
      a7 = false;
      continue;
    }
    if (s9 += n23(o9, d16), a7 = false, o9.length === 0) if (r8 < i10.length) s9 += i10[r8], r8++;
    else break;
    else r8 += o9.length, a7 = true;
  }
  return s9;
}
function q7(i10, e7, t6) {
  let n23 = "", s9 = 0;
  for (; s9 < i10.length; ) {
    if (i10[s9] === "\\" && s9 + 1 < i10.length) {
      let r8 = i10[s9 + 1];
      if (r8 === "&") {
        n23 += "&", s9 += 2;
        continue;
      }
      if (r8 === "n") {
        n23 += `
`, s9 += 2;
        continue;
      }
      if (r8 === "t") {
        n23 += "	", s9 += 2;
        continue;
      }
      if (r8 === "r") {
        n23 += "\r", s9 += 2;
        continue;
      }
      let a7 = parseInt(r8, 10);
      if (a7 === 0) {
        n23 += e7, s9 += 2;
        continue;
      }
      if (a7 >= 1 && a7 <= 9) {
        n23 += t6[a7 - 1] || "", s9 += 2;
        continue;
      }
      n23 += r8, s9 += 2;
      continue;
    }
    if (i10[s9] === "&") {
      n23 += e7, s9++;
      continue;
    }
    n23 += i10[s9], s9++;
  }
  return n23;
}
function he4(i10, e7) {
  let { lineNumber: t6, totalLines: n23, patternSpace: s9 } = e7;
  if (i10.type === "label") {
    e7.coverage?.hit(`sed:cmd:${i10.type}`);
    return;
  }
  if (I6(i10.address, t6, n23, s9, e7.rangeStates, e7)) switch (e7.coverage?.hit(`sed:cmd:${i10.type}`), i10.type) {
    case "substitute": {
      let r8 = i10, a7 = "";
      r8.global && (a7 += "g"), r8.ignoreCase && (a7 += "i");
      let c15 = r8.pattern;
      c15 === "" && e7.lastPattern ? c15 = e7.lastPattern : c15 !== "" && (e7.lastPattern = c15);
      let o9 = D5(r8.extendedRegex ? c15 : P5(c15));
      try {
        let d16 = b1(o9, a7), p17 = d16.test(e7.patternSpace);
        if (d16.lastIndex = 0, p17) {
          if (e7.substitutionMade = true, r8.nthOccurrence && r8.nthOccurrence > 0 && !r8.global) {
            let E13 = 0, m25 = r8.nthOccurrence, f11 = b1(o9, `g${r8.ignoreCase ? "i" : ""}`);
            e7.patternSpace = f11.replace(e7.patternSpace, (u11, ...h17) => {
              if (E13++, E13 === m25) {
                let b25 = h17.slice(0, -2);
                return q7(r8.replacement, u11, b25);
              }
              return u11;
            });
          } else if (r8.global) {
            let E13 = b1(o9, `g${r8.ignoreCase ? "i" : ""}`);
            e7.patternSpace = ue4(e7.patternSpace, E13, r8.replacement, (m25, f11) => q7(r8.replacement, m25, f11));
          } else e7.patternSpace = d16.replace(e7.patternSpace, (E13, ...m25) => {
            let f11 = m25.slice(0, -2);
            return q7(r8.replacement, E13, f11);
          });
          r8.printOnMatch && e7.lineNumberOutput.push(e7.patternSpace);
        }
      } catch {
      }
      break;
    }
    case "print":
      e7.lineNumberOutput.push(e7.patternSpace);
      break;
    case "printFirstLine": {
      let r8 = e7.patternSpace.indexOf(`
`);
      r8 !== -1 ? e7.lineNumberOutput.push(e7.patternSpace.slice(0, r8)) : e7.lineNumberOutput.push(e7.patternSpace);
      break;
    }
    case "delete":
      e7.deleted = true;
      break;
    case "deleteFirstLine": {
      let r8 = e7.patternSpace.indexOf(`
`);
      r8 !== -1 ? (e7.patternSpace = e7.patternSpace.slice(r8 + 1), e7.restartCycle = true, e7.inDRestartedCycle = true) : e7.deleted = true;
      break;
    }
    case "zap":
      e7.patternSpace = "";
      break;
    case "append":
      e7.appendBuffer.push(i10.text);
      break;
    case "insert":
      e7.appendBuffer.unshift(`__INSERT__${i10.text}`);
      break;
    case "change":
      e7.deleted = true, e7.changedText = i10.text;
      break;
    case "hold":
      e7.holdSpace = e7.patternSpace;
      break;
    case "holdAppend":
      e7.holdSpace ? e7.holdSpace += `
${e7.patternSpace}` : e7.holdSpace = e7.patternSpace;
      break;
    case "get":
      e7.patternSpace = e7.holdSpace;
      break;
    case "getAppend":
      e7.patternSpace += `
${e7.holdSpace}`;
      break;
    case "exchange": {
      let r8 = e7.patternSpace;
      e7.patternSpace = e7.holdSpace, e7.holdSpace = r8;
      break;
    }
    case "next":
      e7.printed = true;
      break;
    case "quit":
      e7.quit = true, i10.exitCode !== void 0 && (e7.exitCode = i10.exitCode);
      break;
    case "quitSilent":
      e7.quit = true, e7.quitSilent = true, i10.exitCode !== void 0 && (e7.exitCode = i10.exitCode);
      break;
    case "list": {
      let r8 = Z5(e7.patternSpace);
      e7.lineNumberOutput.push(r8);
      break;
    }
    case "printFilename":
      e7.currentFilename && e7.lineNumberOutput.push(e7.currentFilename);
      break;
    case "version": {
      let r8 = [4, 8, 0];
      if (i10.minVersion) {
        let a7 = i10.minVersion.split("."), c15 = [], o9 = false;
        for (let d16 of a7) {
          let p17 = parseInt(d16, 10);
          if (Number.isNaN(p17) || p17 < 0) {
            e7.quit = true, e7.exitCode = 1, e7.errorMessage = `sed: invalid version string: ${i10.minVersion}`, o9 = true;
            break;
          }
          c15.push(p17);
        }
        if (!o9) {
          for (; c15.length < 3; ) c15.push(0);
          for (let d16 = 0; d16 < 3; d16++) {
            if (c15[d16] > r8[d16]) {
              e7.quit = true, e7.exitCode = 1, e7.errorMessage = `sed: this is not GNU sed version ${i10.minVersion}`;
              break;
            }
            if (c15[d16] < r8[d16]) break;
          }
        }
      }
      break;
    }
    case "readFile":
      e7.pendingFileReads.push({ filename: i10.filename, wholeFile: true });
      break;
    case "readFileLine":
      e7.pendingFileReads.push({ filename: i10.filename, wholeFile: false });
      break;
    case "writeFile":
      e7.pendingFileWrites.push({ filename: i10.filename, content: `${e7.patternSpace}
` });
      break;
    case "writeFirstLine": {
      let r8 = e7.patternSpace.indexOf(`
`), a7 = r8 !== -1 ? e7.patternSpace.slice(0, r8) : e7.patternSpace;
      e7.pendingFileWrites.push({ filename: i10.filename, content: `${a7}
` });
      break;
    }
    case "execute":
      i10.command ? e7.pendingExecute = { command: i10.command, replacePattern: false } : e7.pendingExecute = { command: e7.patternSpace, replacePattern: true };
      break;
    case "transliterate":
      e7.patternSpace = de4(e7.patternSpace, i10);
      break;
    case "lineNumber":
      e7.lineNumberOutput.push(String(e7.lineNumber));
      break;
    case "branch":
      break;
    case "branchOnSubst":
      break;
    case "branchOnNoSubst":
      break;
    case "group":
      break;
  }
}
function de4(i10, e7) {
  let t6 = "";
  for (let n23 of i10) {
    let s9 = e7.source.indexOf(n23);
    s9 !== -1 ? t6 += e7.dest[s9] : t6 += n23;
  }
  return t6;
}
function U5(i10, e7, t6, n23) {
  let s9 = /* @__PURE__ */ new Map();
  for (let o9 = 0; o9 < i10.length; o9++) {
    let d16 = i10[o9];
    d16.type === "label" && s9.set(d16.name, o9);
  }
  let r8 = n23?.maxIterations ?? ae5, a7 = 0, c15 = 0;
  for (; c15 < i10.length; ) {
    if (a7++, a7 > r8) throw new b2(`sed: command execution exceeded maximum iterations (${r8})`, "iterations");
    if (e7.deleted || e7.quit || e7.quitSilent || e7.restartCycle) break;
    let o9 = i10[c15];
    if (o9.type === "next") {
      if (I6(o9.address, e7.lineNumber, e7.totalLines, e7.patternSpace, e7.rangeStates, e7)) if (e7.coverage?.hit("sed:cmd:next"), e7.nCommandOutput.push(e7.patternSpace), t6 && t6.currentLineIndex + e7.linesConsumedInCycle + 1 < t6.lines.length) {
        e7.linesConsumedInCycle++;
        let d16 = t6.lines[t6.currentLineIndex + e7.linesConsumedInCycle];
        e7.patternSpace = d16, e7.lineNumber = t6.currentLineIndex + e7.linesConsumedInCycle + 1, e7.substitutionMade = false;
      } else {
        e7.quit = true, e7.deleted = true;
        break;
      }
      c15++;
      continue;
    }
    if (o9.type === "nextAppend") {
      if (I6(o9.address, e7.lineNumber, e7.totalLines, e7.patternSpace, e7.rangeStates, e7)) if (e7.coverage?.hit("sed:cmd:nextAppend"), t6 && t6.currentLineIndex + e7.linesConsumedInCycle + 1 < t6.lines.length) {
        e7.linesConsumedInCycle++;
        let d16 = t6.lines[t6.currentLineIndex + e7.linesConsumedInCycle];
        e7.patternSpace += `
${d16}`, e7.lineNumber = t6.currentLineIndex + e7.linesConsumedInCycle + 1;
      } else {
        e7.quit = true;
        break;
      }
      c15++;
      continue;
    }
    if (o9.type === "branch") {
      let d16 = o9;
      if (I6(d16.address, e7.lineNumber, e7.totalLines, e7.patternSpace, e7.rangeStates, e7)) {
        if (e7.coverage?.hit("sed:cmd:branch"), d16.label) {
          let p17 = s9.get(d16.label);
          if (p17 !== void 0) {
            c15 = p17;
            continue;
          }
          e7.branchRequest = d16.label;
          break;
        }
        break;
      }
      c15++;
      continue;
    }
    if (o9.type === "branchOnSubst") {
      let d16 = o9;
      if (I6(d16.address, e7.lineNumber, e7.totalLines, e7.patternSpace, e7.rangeStates, e7) && (e7.coverage?.hit("sed:cmd:branchOnSubst"), e7.substitutionMade)) {
        if (e7.substitutionMade = false, d16.label) {
          let p17 = s9.get(d16.label);
          if (p17 !== void 0) {
            c15 = p17;
            continue;
          }
          e7.branchRequest = d16.label;
          break;
        }
        break;
      }
      c15++;
      continue;
    }
    if (o9.type === "branchOnNoSubst") {
      let d16 = o9;
      if (I6(d16.address, e7.lineNumber, e7.totalLines, e7.patternSpace, e7.rangeStates, e7) && (e7.coverage?.hit("sed:cmd:branchOnNoSubst"), !e7.substitutionMade)) {
        if (d16.label) {
          let p17 = s9.get(d16.label);
          if (p17 !== void 0) {
            c15 = p17;
            continue;
          }
          e7.branchRequest = d16.label;
          break;
        }
        break;
      }
      c15++;
      continue;
    }
    if (o9.type === "group") {
      let d16 = o9;
      if (I6(d16.address, e7.lineNumber, e7.totalLines, e7.patternSpace, e7.rangeStates, e7) && (e7.coverage?.hit("sed:cmd:group"), U5(d16.commands, e7, t6, n23), e7.branchRequest)) {
        let p17 = s9.get(e7.branchRequest);
        if (p17 !== void 0) {
          e7.branchRequest = void 0, c15 = p17;
          continue;
        }
        break;
      }
      c15++;
      continue;
    }
    he4(o9, e7), c15++;
  }
  return e7.linesConsumedInCycle;
}
function Q6(i10, e7 = false) {
  let t6 = false, n23 = false, s9 = [];
  for (let o9 = 0; o9 < i10.length; o9++) {
    let d16 = i10[o9];
    if (s9.length === 0 && o9 === 0) {
      let p17 = d16.match(/^#([nr]+)\s*(?:\n|$)/i);
      if (p17) {
        let E13 = p17[1].toLowerCase();
        E13.includes("n") && (t6 = true), E13.includes("r") && (n23 = true), d16 = d16.slice(p17[0].length);
      }
    }
    if (s9.length > 0 && s9[s9.length - 1].endsWith("\\")) {
      let p17 = s9[s9.length - 1];
      s9[s9.length - 1] = `${p17}
${d16}`;
    } else s9.push(d16);
  }
  let r8 = s9.join(`
`), c15 = new H6([r8], e7 || n23).parse();
  if (!c15.error && c15.commands.length > 0) {
    let o9 = fe4(c15.commands);
    if (o9) return { commands: [], error: o9, silentMode: t6, extendedRegexMode: n23 };
  }
  return { ...c15, silentMode: t6, extendedRegexMode: n23 };
}
function fe4(i10) {
  let e7 = /* @__PURE__ */ new Set();
  J6(i10, e7);
  let t6 = Y5(i10, e7);
  if (t6) return `undefined label '${t6}'`;
}
function J6(i10, e7) {
  for (let t6 of i10) t6.type === "label" ? e7.add(t6.name) : t6.type === "group" && J6(t6.commands, e7);
}
function Y5(i10, e7) {
  for (let t6 of i10) {
    if ((t6.type === "branch" || t6.type === "branchOnSubst" || t6.type === "branchOnNoSubst") && t6.label && !e7.has(t6.label)) return t6.label;
    if (t6.type === "group") {
      let n23 = Y5(t6.commands, e7);
      if (n23) return n23;
    }
  }
}
async function z4(i10, e7, t6, n23 = {}) {
  let { limits: s9, filename: r8, fs: a7, cwd: c15, coverage: o9 } = n23, d16 = i10.endsWith(`
`), p17 = i10.split(`
`);
  p17.length > 0 && p17[p17.length - 1] === "" && p17.pop();
  let E13 = p17.length, m25 = "", f11, u11 = false, h17 = s9?.maxStringLength ?? 0, b25 = (R13) => {
    if (m25 += R13, h17 > 0 && m25.length > h17) throw new b2(`sed: output size limit exceeded (${h17} bytes)`, "string_length");
  }, C19 = "", y18, ee7 = /* @__PURE__ */ new Map(), F21 = /* @__PURE__ */ new Map(), $18 = /* @__PURE__ */ new Map(), M15 = /* @__PURE__ */ new Map(), te10 = s9 ? { maxIterations: s9.maxSedIterations } : void 0;
  for (let R13 = 0; R13 < p17.length; R13++) {
    let g18 = { ...K6(E13, r8, ee7), patternSpace: p17[R13], holdSpace: C19, lastPattern: y18, lineNumber: R13 + 1, totalLines: E13, substitutionMade: false, coverage: o9 }, ne10 = { lines: p17, currentLineIndex: R13 }, V13 = 0, ie8 = 1e4;
    g18.linesConsumedInCycle = 0;
    do {
      if (V13++, V13 > ie8) break;
      if (g18.restartCycle = false, g18.pendingFileReads = [], g18.pendingFileWrites = [], U5(e7, g18, ne10, te10), a7 && c15) {
        for (let v21 of g18.pendingFileReads) {
          let k17 = a7.resolvePath(c15, v21.filename);
          try {
            if (v21.wholeFile) {
              let S17 = await a7.readFile(k17);
              g18.appendBuffer.push(S17.replace(/\n$/, ""));
            } else {
              if (!F21.has(k17)) {
                let re5 = await a7.readFile(k17);
                F21.set(k17, re5.split(`
`)), $18.set(k17, 0);
              }
              let S17 = F21.get(k17), A14 = $18.get(k17);
              S17 && A14 !== void 0 && A14 < S17.length && (g18.appendBuffer.push(S17[A14]), $18.set(k17, A14 + 1));
            }
          } catch {
          }
        }
        for (let v21 of g18.pendingFileWrites) {
          let k17 = a7.resolvePath(c15, v21.filename), S17 = M15.get(k17) || "";
          M15.set(k17, S17 + v21.content);
        }
      }
    } while (g18.restartCycle && !g18.deleted && !g18.quit && !g18.quitSilent);
    if (R13 += g18.linesConsumedInCycle, C19 = g18.holdSpace, y18 = g18.lastPattern, !t6) for (let v21 of g18.nCommandOutput) b25(`${v21}
`);
    let se9 = g18.lineNumberOutput.length > 0;
    for (let v21 of g18.lineNumberOutput) b25(`${v21}
`);
    let X10 = [], _15 = [];
    for (let v21 of g18.appendBuffer) v21.startsWith("__INSERT__") ? X10.push(v21.slice(10)) : _15.push(v21);
    for (let v21 of X10) b25(`${v21}
`);
    let L18 = false;
    !g18.deleted && !g18.quitSilent ? t6 ? g18.printed && (b25(`${g18.patternSpace}
`), L18 = true) : (b25(`${g18.patternSpace}
`), L18 = true) : g18.changedText !== void 0 && (b25(`${g18.changedText}
`), L18 = true);
    for (let v21 of _15) b25(`${v21}
`);
    if (u11 = (se9 || L18) && _15.length === 0, g18.quit || g18.quitSilent) {
      if (g18.exitCode !== void 0 && (f11 = g18.exitCode), g18.errorMessage) return { output: "", exitCode: f11 || 1, errorMessage: g18.errorMessage };
      break;
    }
  }
  if (a7 && c15) for (let [R13, g18] of M15) try {
    await a7.writeFile(R13, g18);
  } catch {
  }
  return !d16 && u11 && m25.endsWith(`
`) && (m25 = m25.slice(0, -1)), { output: m25, exitCode: f11 };
}
var B4, ae5, l3, w5, H6, pe3, Ne, Le2;
var init_chunk_MZLOTDD7 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-MZLOTDD7.js"() {
    init_chunk_YNYSPYQ5();
    init_chunk_PSW6BMXW();
    init_chunk_74CEPOFO();
    B4 = /* @__PURE__ */ new Map([["alnum", "a-zA-Z0-9"], ["alpha", "a-zA-Z"], ["ascii", "\\x00-\\x7F"], ["blank", " \\t"], ["cntrl", "\\x00-\\x1F\\x7F"], ["digit", "0-9"], ["graph", "!-~"], ["lower", "a-z"], ["print", " -~"], ["punct", "!-/:-@\\[-`{-~"], ["space", " \\t\\n\\r\\f\\v"], ["upper", "A-Z"], ["word", "a-zA-Z0-9_"], ["xdigit", "0-9A-Fa-f"]]);
    ae5 = 1e4;
    (function(i10) {
      i10.NUMBER = "NUMBER", i10.DOLLAR = "DOLLAR", i10.PATTERN = "PATTERN", i10.STEP = "STEP", i10.RELATIVE_OFFSET = "RELATIVE_OFFSET", i10.LBRACE = "LBRACE", i10.RBRACE = "RBRACE", i10.SEMICOLON = "SEMICOLON", i10.NEWLINE = "NEWLINE", i10.COMMA = "COMMA", i10.NEGATION = "NEGATION", i10.COMMAND = "COMMAND", i10.SUBSTITUTE = "SUBSTITUTE", i10.TRANSLITERATE = "TRANSLITERATE", i10.LABEL_DEF = "LABEL_DEF", i10.BRANCH = "BRANCH", i10.BRANCH_ON_SUBST = "BRANCH_ON_SUBST", i10.BRANCH_ON_NO_SUBST = "BRANCH_ON_NO_SUBST", i10.TEXT_CMD = "TEXT_CMD", i10.FILE_READ = "FILE_READ", i10.FILE_READ_LINE = "FILE_READ_LINE", i10.FILE_WRITE = "FILE_WRITE", i10.FILE_WRITE_LINE = "FILE_WRITE_LINE", i10.EXECUTE = "EXECUTE", i10.VERSION = "VERSION", i10.EOF = "EOF", i10.ERROR = "ERROR";
    })(l3 || (l3 = {}));
    w5 = class {
      input;
      pos = 0;
      line = 1;
      column = 1;
      constructor(e7) {
        this.input = e7;
      }
      tokenize() {
        let e7 = [];
        for (; this.pos < this.input.length; ) {
          let t6 = this.nextToken();
          t6 && e7.push(t6);
        }
        return e7.push(this.makeToken(l3.EOF, "")), e7;
      }
      makeToken(e7, t6, n23) {
        return { type: e7, value: t6, line: this.line, column: this.column, ...n23 };
      }
      peek(e7 = 0) {
        return this.input[this.pos + e7] || "";
      }
      advance() {
        let e7 = this.input[this.pos++] || "";
        return e7 === `
` ? (this.line++, this.column = 1) : this.column++, e7;
      }
      readEscapedString(e7) {
        let t6 = "";
        for (; this.pos < this.input.length && this.peek() !== e7; ) if (this.peek() === "\\") {
          this.advance();
          let n23 = this.advance();
          n23 === "n" ? t6 += `
` : n23 === "t" ? t6 += "	" : t6 += n23;
        } else {
          if (this.peek() === `
`) return null;
          t6 += this.advance();
        }
        return t6;
      }
      skipWhitespace() {
        for (; this.pos < this.input.length; ) {
          let e7 = this.peek();
          if (e7 === " " || e7 === "	" || e7 === "\r") this.advance();
          else if (e7 === "#") for (; this.pos < this.input.length && this.peek() !== `
`; ) this.advance();
          else break;
        }
      }
      nextToken() {
        if (this.skipWhitespace(), this.pos >= this.input.length) return null;
        let e7 = this.line, t6 = this.column, n23 = this.peek();
        return n23 === `
` ? (this.advance(), { type: l3.NEWLINE, value: `
`, line: e7, column: t6 }) : n23 === ";" ? (this.advance(), { type: l3.SEMICOLON, value: ";", line: e7, column: t6 }) : n23 === "{" ? (this.advance(), { type: l3.LBRACE, value: "{", line: e7, column: t6 }) : n23 === "}" ? (this.advance(), { type: l3.RBRACE, value: "}", line: e7, column: t6 }) : n23 === "," ? (this.advance(), { type: l3.COMMA, value: ",", line: e7, column: t6 }) : n23 === "!" ? (this.advance(), { type: l3.NEGATION, value: "!", line: e7, column: t6 }) : n23 === "$" ? (this.advance(), { type: l3.DOLLAR, value: "$", line: e7, column: t6 }) : this.isDigit(n23) ? this.readNumber() : n23 === "+" && this.isDigit(this.input[this.pos + 1] || "") ? this.readRelativeOffset() : n23 === "/" ? this.readPattern() : n23 === ":" ? this.readLabelDef() : this.readCommand();
      }
      readNumber() {
        let e7 = this.line, t6 = this.column, n23 = "";
        for (; this.isDigit(this.peek()); ) n23 += this.advance();
        if (this.peek() === "~") {
          this.advance();
          let s9 = "";
          for (; this.isDigit(this.peek()); ) s9 += this.advance();
          let r8 = parseInt(n23, 10), a7 = parseInt(s9, 10) || 0;
          return { type: l3.STEP, value: `${r8}~${a7}`, first: r8, step: a7, line: e7, column: t6 };
        }
        return { type: l3.NUMBER, value: parseInt(n23, 10), line: e7, column: t6 };
      }
      readRelativeOffset() {
        let e7 = this.line, t6 = this.column;
        this.advance();
        let n23 = "";
        for (; this.isDigit(this.peek()); ) n23 += this.advance();
        let s9 = parseInt(n23, 10) || 0;
        return { type: l3.RELATIVE_OFFSET, value: `+${s9}`, offset: s9, line: e7, column: t6 };
      }
      readPattern() {
        let e7 = this.line, t6 = this.column;
        this.advance();
        let n23 = "", s9 = false;
        for (; this.pos < this.input.length; ) {
          let r8 = this.peek();
          if (r8 === "/" && !s9) break;
          if (r8 === "\\") n23 += this.advance(), this.pos < this.input.length && this.peek() !== `
` && (n23 += this.advance());
          else {
            if (r8 === `
`) break;
            r8 === "[" && !s9 ? (s9 = true, n23 += this.advance(), this.peek() === "^" && (n23 += this.advance()), this.peek() === "]" && (n23 += this.advance())) : r8 === "]" && s9 ? (s9 = false, n23 += this.advance()) : n23 += this.advance();
          }
        }
        return this.peek() === "/" && this.advance(), { type: l3.PATTERN, value: n23, pattern: n23, line: e7, column: t6 };
      }
      readLabelDef() {
        let e7 = this.line, t6 = this.column;
        for (this.advance(); this.peek() === " " || this.peek() === "	"; ) this.advance();
        let n23 = "";
        for (; this.pos < this.input.length; ) {
          let s9 = this.peek();
          if (s9 === " " || s9 === "	" || s9 === `
` || s9 === ";" || s9 === "}" || s9 === "{") break;
          n23 += this.advance();
        }
        return { type: l3.LABEL_DEF, value: n23, label: n23, line: e7, column: t6 };
      }
      readCommand() {
        let e7 = this.line, t6 = this.column, n23 = this.advance();
        switch (n23) {
          case "s":
            return this.readSubstitute(e7, t6);
          case "y":
            return this.readTransliterate(e7, t6);
          case "a":
          case "i":
          case "c":
            return this.readTextCommand(n23, e7, t6);
          case "b":
            return this.readBranch(l3.BRANCH, "b", e7, t6);
          case "t":
            return this.readBranch(l3.BRANCH_ON_SUBST, "t", e7, t6);
          case "T":
            return this.readBranch(l3.BRANCH_ON_NO_SUBST, "T", e7, t6);
          case "r":
            return this.readFileCommand(l3.FILE_READ, "r", e7, t6);
          case "R":
            return this.readFileCommand(l3.FILE_READ_LINE, "R", e7, t6);
          case "w":
            return this.readFileCommand(l3.FILE_WRITE, "w", e7, t6);
          case "W":
            return this.readFileCommand(l3.FILE_WRITE_LINE, "W", e7, t6);
          case "e":
            return this.readExecute(e7, t6);
          case "p":
          case "P":
          case "d":
          case "D":
          case "h":
          case "H":
          case "g":
          case "G":
          case "x":
          case "n":
          case "N":
          case "q":
          case "Q":
          case "z":
          case "=":
          case "l":
          case "F":
            return { type: l3.COMMAND, value: n23, line: e7, column: t6 };
          case "v":
            return this.readVersion(e7, t6);
          default:
            return { type: l3.ERROR, value: n23, line: e7, column: t6 };
        }
      }
      readSubstitute(e7, t6) {
        let n23 = this.advance();
        if (!n23 || n23 === `
`) return { type: l3.ERROR, value: "s", line: e7, column: t6 };
        let s9 = "", r8 = false;
        for (; this.pos < this.input.length; ) {
          let o9 = this.peek();
          if (o9 === n23 && !r8) break;
          if (o9 === "\\") this.advance(), this.pos < this.input.length && this.peek() !== `
` ? this.peek() === n23 && !r8 ? s9 += this.advance() : (s9 += "\\", s9 += this.advance()) : s9 += "\\";
          else {
            if (o9 === `
`) break;
            o9 === "[" && !r8 ? (r8 = true, s9 += this.advance(), this.peek() === "^" && (s9 += this.advance()), this.peek() === "]" && (s9 += this.advance())) : o9 === "]" && r8 ? (r8 = false, s9 += this.advance()) : s9 += this.advance();
          }
        }
        if (this.peek() !== n23) return { type: l3.ERROR, value: "unterminated substitution pattern", line: e7, column: t6 };
        this.advance();
        let a7 = "";
        for (; this.pos < this.input.length && this.peek() !== n23; ) if (this.peek() === "\\") if (this.advance(), this.pos < this.input.length) {
          let o9 = this.peek();
          o9 === "\\" ? (this.advance(), this.pos < this.input.length && this.peek() === `
` ? (a7 += `
`, this.advance()) : a7 += "\\") : o9 === `
` ? (a7 += `
`, this.advance()) : a7 += `\\${this.advance()}`;
        } else a7 += "\\";
        else {
          if (this.peek() === `
`) break;
          a7 += this.advance();
        }
        this.peek() === n23 && this.advance();
        let c15 = "";
        for (; this.pos < this.input.length; ) {
          let o9 = this.peek();
          if (o9 === "g" || o9 === "i" || o9 === "p" || o9 === "I" || this.isDigit(o9)) c15 += this.advance();
          else break;
        }
        return { type: l3.SUBSTITUTE, value: `s${n23}${s9}${n23}${a7}${n23}${c15}`, pattern: s9, replacement: a7, flags: c15, line: e7, column: t6 };
      }
      readTransliterate(e7, t6) {
        let n23 = this.advance();
        if (!n23 || n23 === `
`) return { type: l3.ERROR, value: "y", line: e7, column: t6 };
        let s9 = this.readEscapedString(n23);
        if (s9 === null || this.peek() !== n23) return { type: l3.ERROR, value: "unterminated transliteration source", line: e7, column: t6 };
        this.advance();
        let r8 = this.readEscapedString(n23);
        if (r8 === null || this.peek() !== n23) return { type: l3.ERROR, value: "unterminated transliteration dest", line: e7, column: t6 };
        this.advance();
        let a7 = this.peek();
        for (; a7 === " " || a7 === "	"; ) this.advance(), a7 = this.peek();
        return a7 !== "" && a7 !== ";" && a7 !== `
` && a7 !== "}" ? { type: l3.ERROR, value: "extra text at the end of a transform command", line: e7, column: t6 } : { type: l3.TRANSLITERATE, value: `y${n23}${s9}${n23}${r8}${n23}`, source: s9, dest: r8, line: e7, column: t6 };
      }
      readTextCommand(e7, t6, n23) {
        let s9 = false;
        this.peek() === "\\" && this.pos + 1 < this.input.length && (this.input[this.pos + 1] === `
` || this.input[this.pos + 1] === " " || this.input[this.pos + 1] === "	") && (s9 = true, this.advance()), (this.peek() === " " || this.peek() === "	") && this.advance(), this.peek() === "\\" && this.pos + 1 < this.input.length && (this.input[this.pos + 1] === " " || this.input[this.pos + 1] === "	") && this.advance(), s9 && this.peek() === `
` && this.advance();
        let r8 = "";
        for (; this.pos < this.input.length; ) {
          let a7 = this.peek();
          if (a7 === `
`) {
            if (r8.endsWith("\\")) {
              r8 = `${r8.slice(0, -1)}
`, this.advance();
              continue;
            }
            break;
          }
          if (a7 === "\\" && this.pos + 1 < this.input.length) {
            let c15 = this.input[this.pos + 1];
            if (c15 === "n") {
              r8 += `
`, this.advance(), this.advance();
              continue;
            }
            if (c15 === "t") {
              r8 += "	", this.advance(), this.advance();
              continue;
            }
            if (c15 === "r") {
              r8 += "\r", this.advance(), this.advance();
              continue;
            }
          }
          r8 += this.advance();
        }
        return { type: l3.TEXT_CMD, value: e7, text: r8, line: t6, column: n23 };
      }
      readBranch(e7, t6, n23, s9) {
        for (; this.peek() === " " || this.peek() === "	"; ) this.advance();
        let r8 = "";
        for (; this.pos < this.input.length; ) {
          let a7 = this.peek();
          if (a7 === " " || a7 === "	" || a7 === `
` || a7 === ";" || a7 === "}" || a7 === "{") break;
          r8 += this.advance();
        }
        return { type: e7, value: t6, label: r8 || void 0, line: n23, column: s9 };
      }
      readVersion(e7, t6) {
        for (; this.peek() === " " || this.peek() === "	"; ) this.advance();
        let n23 = "";
        for (; this.pos < this.input.length; ) {
          let s9 = this.peek();
          if (s9 === " " || s9 === "	" || s9 === `
` || s9 === ";" || s9 === "}" || s9 === "{") break;
          n23 += this.advance();
        }
        return { type: l3.VERSION, value: "v", label: n23 || void 0, line: e7, column: t6 };
      }
      readFileCommand(e7, t6, n23, s9) {
        for (; this.peek() === " " || this.peek() === "	"; ) this.advance();
        let r8 = "";
        for (; this.pos < this.input.length; ) {
          let a7 = this.peek();
          if (a7 === `
` || a7 === ";") break;
          r8 += this.advance();
        }
        return { type: e7, value: t6, filename: r8.trim(), line: n23, column: s9 };
      }
      readExecute(e7, t6) {
        for (; this.peek() === " " || this.peek() === "	"; ) this.advance();
        let n23 = "";
        for (; this.pos < this.input.length; ) {
          let s9 = this.peek();
          if (s9 === `
` || s9 === ";") break;
          n23 += this.advance();
        }
        return { type: l3.EXECUTE, value: "e", command: n23.trim() || void 0, line: e7, column: t6 };
      }
      isDigit(e7) {
        return e7 >= "0" && e7 <= "9";
      }
    };
    H6 = class {
      scripts;
      tokens = [];
      pos = 0;
      extendedRegex = false;
      constructor(e7, t6 = false) {
        this.scripts = e7, this.extendedRegex = t6;
      }
      parse() {
        let e7 = [];
        for (let t6 of this.scripts) {
          let n23 = new w5(t6);
          for (this.tokens = n23.tokenize(), this.pos = 0; !this.isAtEnd(); ) {
            if (this.check(l3.NEWLINE) || this.check(l3.SEMICOLON)) {
              this.advance();
              continue;
            }
            let s9 = this.pos, r8 = this.parseCommand();
            if (r8.error) return { commands: [], error: r8.error };
            if (r8.command && e7.push(r8.command), this.pos === s9 && !this.isAtEnd()) return { commands: [], error: `unknown command: '${this.peek()?.value ?? this.peek()?.type}'` };
          }
        }
        return { commands: e7 };
      }
      parseCommand() {
        let e7 = this.parseAddressRange();
        if (e7?.error) return { command: null, error: e7.error };
        let t6 = e7?.address;
        for (this.check(l3.NEGATION) && (this.advance(), t6 && (t6.negated = true)); this.check(l3.NEWLINE) || this.check(l3.SEMICOLON); ) this.advance();
        if (this.isAtEnd()) return t6 && (t6.start !== void 0 || t6.end !== void 0) ? { command: null, error: "command expected" } : { command: null };
        let n23 = this.peek();
        switch (n23.type) {
          case l3.COMMAND:
            return this.parseSimpleCommand(n23, t6);
          case l3.SUBSTITUTE:
            return this.parseSubstituteFromToken(n23, t6);
          case l3.TRANSLITERATE:
            return this.parseTransliterateFromToken(n23, t6);
          case l3.LABEL_DEF:
            return this.advance(), { command: { type: "label", name: n23.label || "" } };
          case l3.BRANCH:
            return this.advance(), { command: { type: "branch", address: t6, label: n23.label } };
          case l3.BRANCH_ON_SUBST:
            return this.advance(), { command: { type: "branchOnSubst", address: t6, label: n23.label } };
          case l3.BRANCH_ON_NO_SUBST:
            return this.advance(), { command: { type: "branchOnNoSubst", address: t6, label: n23.label } };
          case l3.TEXT_CMD:
            return this.advance(), this.parseTextCommand(n23, t6);
          case l3.FILE_READ:
            return this.advance(), { command: { type: "readFile", address: t6, filename: n23.filename || "" } };
          case l3.FILE_READ_LINE:
            return this.advance(), { command: { type: "readFileLine", address: t6, filename: n23.filename || "" } };
          case l3.FILE_WRITE:
            return this.advance(), { command: { type: "writeFile", address: t6, filename: n23.filename || "" } };
          case l3.FILE_WRITE_LINE:
            return this.advance(), { command: { type: "writeFirstLine", address: t6, filename: n23.filename || "" } };
          case l3.EXECUTE:
            return this.advance(), { command: { type: "execute", address: t6, command: n23.command } };
          case l3.VERSION:
            return this.advance(), { command: { type: "version", address: t6, minVersion: n23.label } };
          case l3.LBRACE:
            return this.parseGroup(t6);
          case l3.RBRACE:
            return { command: null };
          case l3.ERROR:
            return { command: null, error: `invalid command: ${n23.value}` };
          default:
            return t6 && (t6.start !== void 0 || t6.end !== void 0) ? { command: null, error: "command expected" } : { command: null };
        }
      }
      parseSimpleCommand(e7, t6) {
        this.advance();
        let n23 = e7.value;
        switch (n23) {
          case "p":
            return { command: { type: "print", address: t6 } };
          case "P":
            return { command: { type: "printFirstLine", address: t6 } };
          case "d":
            return { command: { type: "delete", address: t6 } };
          case "D":
            return { command: { type: "deleteFirstLine", address: t6 } };
          case "h":
            return { command: { type: "hold", address: t6 } };
          case "H":
            return { command: { type: "holdAppend", address: t6 } };
          case "g":
            return { command: { type: "get", address: t6 } };
          case "G":
            return { command: { type: "getAppend", address: t6 } };
          case "x":
            return { command: { type: "exchange", address: t6 } };
          case "n":
            return { command: { type: "next", address: t6 } };
          case "N":
            return { command: { type: "nextAppend", address: t6 } };
          case "q":
            return { command: { type: "quit", address: t6 } };
          case "Q":
            return { command: { type: "quitSilent", address: t6 } };
          case "z":
            return { command: { type: "zap", address: t6 } };
          case "=":
            return { command: { type: "lineNumber", address: t6 } };
          case "l":
            return { command: { type: "list", address: t6 } };
          case "F":
            return { command: { type: "printFilename", address: t6 } };
          default:
            return { command: null, error: `unknown command: ${n23}` };
        }
      }
      parseSubstituteFromToken(e7, t6) {
        this.advance();
        let n23 = e7.flags || "", s9, r8 = n23.match(/(\d+)/);
        return r8 && (s9 = parseInt(r8[1], 10)), { command: { type: "substitute", address: t6, pattern: e7.pattern || "", replacement: e7.replacement || "", global: n23.includes("g"), ignoreCase: n23.includes("i") || n23.includes("I"), printOnMatch: n23.includes("p"), nthOccurrence: s9, extendedRegex: this.extendedRegex } };
      }
      parseTransliterateFromToken(e7, t6) {
        this.advance();
        let n23 = e7.source || "", s9 = e7.dest || "";
        return n23.length !== s9.length ? { command: null, error: "transliteration sets must have same length" } : { command: { type: "transliterate", address: t6, source: n23, dest: s9 } };
      }
      parseTextCommand(e7, t6) {
        let n23 = e7.value, s9 = e7.text || "";
        switch (n23) {
          case "a":
            return { command: { type: "append", address: t6, text: s9 } };
          case "i":
            return { command: { type: "insert", address: t6, text: s9 } };
          case "c":
            return { command: { type: "change", address: t6, text: s9 } };
          default:
            return { command: null, error: `unknown text command: ${n23}` };
        }
      }
      parseGroup(e7) {
        this.advance();
        let t6 = [];
        for (; !this.isAtEnd() && !this.check(l3.RBRACE); ) {
          if (this.check(l3.NEWLINE) || this.check(l3.SEMICOLON)) {
            this.advance();
            continue;
          }
          let n23 = this.pos, s9 = this.parseCommand();
          if (s9.error) return { command: null, error: s9.error };
          if (s9.command && t6.push(s9.command), this.pos === n23 && !this.isAtEnd()) return { command: null, error: `unknown command: '${this.peek()?.value ?? this.peek()?.type}'` };
        }
        return this.check(l3.RBRACE) ? (this.advance(), { command: { type: "group", address: e7, commands: t6 } }) : { command: null, error: "unmatched brace in grouped commands" };
      }
      parseAddressRange() {
        if (this.check(l3.COMMA)) return { error: "expected context address" };
        let e7 = this.parseAddress();
        if (e7 === void 0) return;
        let t6;
        if (this.check(l3.RELATIVE_OFFSET)) t6 = { offset: this.advance().offset || 0 };
        else if (this.check(l3.COMMA) && (this.advance(), t6 = this.parseAddress(), t6 === void 0)) return { error: "expected context address" };
        return { address: { start: e7, end: t6 } };
      }
      parseAddress() {
        let e7 = this.peek();
        switch (e7.type) {
          case l3.NUMBER:
            return this.advance(), e7.value;
          case l3.DOLLAR:
            return this.advance(), "$";
          case l3.PATTERN:
            return this.advance(), { pattern: e7.pattern || e7.value };
          case l3.STEP:
            return this.advance(), { first: e7.first || 0, step: e7.step || 0 };
          case l3.RELATIVE_OFFSET:
            return this.advance(), { offset: e7.offset || 0 };
          default:
            return;
        }
      }
      peek() {
        return this.tokens[this.pos] || { type: l3.EOF, value: "", line: 0, column: 0 };
      }
      advance() {
        return this.isAtEnd() || this.pos++, this.tokens[this.pos - 1];
      }
      check(e7) {
        return this.peek().type === e7;
      }
      isAtEnd() {
        return this.peek().type === l3.EOF;
      }
    };
    pe3 = { name: "sed", summary: "stream editor for filtering and transforming text", usage: "sed [OPTION]... {script} [input-file]...", options: ["-n, --quiet, --silent  suppress automatic printing of pattern space", "-e script              add the script to commands to be executed", "-f script-file         read script from file", "-i, --in-place         edit files in place", "-E, -r, --regexp-extended  use extended regular expressions", "    --help             display this help and exit"], description: `Commands:
  s/regexp/replacement/[flags]  substitute
  d                             delete pattern space
  p                             print pattern space
  a\\ text                       append text after line
  i\\ text                       insert text before line
  c\\ text                       change (replace) line with text
  h                             copy pattern space to hold space
  H                             append pattern space to hold space
  g                             copy hold space to pattern space
  G                             append hold space to pattern space
  x                             exchange pattern and hold spaces
  n                             read next line into pattern space
  N                             append next line to pattern space
  y/source/dest/                transliterate characters
  =                             print line number
  l                             list pattern space (escape special chars)
  b [label]                     branch to label
  t [label]                     branch on substitution
  T [label]                     branch if no substitution
  :label                        define label
  q                             quit
  Q                             quit without printing

Addresses:
  N                             line number
  $                             last line
  /regexp/                      lines matching regexp
  N,M                           range from line N to M
  first~step                    every step-th line starting at first` };
    Ne = { name: "sed", async execute(i10, e7) {
      if (o2(i10)) return s(pe3);
      let t6 = [], n23 = [], s9 = false, r8 = false, a7 = false, c15 = [];
      for (let u11 = 0; u11 < i10.length; u11++) {
        let h17 = i10[u11];
        if (h17 === "-n" || h17 === "--quiet" || h17 === "--silent") s9 = true;
        else if (h17 === "-i" || h17 === "--in-place") r8 = true;
        else if (h17.startsWith("-i")) r8 = true;
        else if (h17 === "-E" || h17 === "-r" || h17 === "--regexp-extended") a7 = true;
        else if (h17 === "-e") u11 + 1 < i10.length && t6.push(i10[++u11]);
        else if (h17 === "-f") u11 + 1 < i10.length && n23.push(i10[++u11]);
        else {
          if (h17.startsWith("--")) return r3("sed", h17);
          if (h17 === "-") c15.push(h17);
          else if (h17.startsWith("-") && h17.length > 1) {
            for (let b25 of h17.slice(1)) if (b25 !== "n" && b25 !== "e" && b25 !== "f" && b25 !== "i" && b25 !== "E" && b25 !== "r") return r3("sed", `-${b25}`);
            h17.includes("n") && (s9 = true), h17.includes("i") && (r8 = true), (h17.includes("E") || h17.includes("r")) && (a7 = true), h17.includes("e") && !h17.includes("n") && !h17.includes("i") && u11 + 1 < i10.length && t6.push(i10[++u11]), h17.includes("f") && !h17.includes("e") && u11 + 1 < i10.length && n23.push(i10[++u11]);
          } else !h17.startsWith("-") && t6.length === 0 && n23.length === 0 ? t6.push(h17) : h17.startsWith("-") || c15.push(h17);
        }
      }
      for (let u11 of n23) {
        let h17 = e7.fs.resolvePath(e7.cwd, u11);
        try {
          let b25 = await e7.fs.readFile(h17);
          for (let C19 of b25.split(`
`)) {
            let y18 = C19.trim();
            y18 && !y18.startsWith("#") && t6.push(y18);
          }
        } catch {
          return { stdout: "", stderr: `sed: couldn't open file ${u11}: No such file or directory
`, exitCode: 1 };
        }
      }
      if (t6.length === 0) return { stdout: "", stderr: `sed: no script specified
`, exitCode: 1 };
      let { commands: o9, error: d16, silentMode: p17 } = Q6(t6, a7);
      if (d16) return { stdout: "", stderr: `sed: ${d16}
`, exitCode: 1 };
      let E13 = !!(s9 || p17);
      if (r8) {
        if (c15.length === 0) return { stdout: "", stderr: `sed: -i requires at least one file argument
`, exitCode: 1 };
        for (let u11 of c15) {
          if (u11 === "-") continue;
          let h17 = e7.fs.resolvePath(e7.cwd, u11);
          try {
            let b25 = await e7.fs.readFile(h17), C19 = await z4(b25, o9, E13, { limits: e7.limits, filename: u11, fs: e7.fs, cwd: e7.cwd, coverage: e7.coverage });
            if (C19.errorMessage) return { stdout: "", stderr: `${C19.errorMessage}
`, exitCode: C19.exitCode ?? 1 };
            await e7.fs.writeFile(h17, C19.output);
          } catch (b25) {
            return b25 instanceof b2 ? { stdout: "", stderr: `sed: ${b25.message}
`, exitCode: b2.EXIT_CODE } : { stdout: "", stderr: `sed: ${u11}: No such file or directory
`, exitCode: 1 };
          }
        }
        return { stdout: "", stderr: "", exitCode: 0 };
      }
      let m25 = "";
      if (c15.length === 0) {
        m25 = e7.stdin;
        try {
          let u11 = await z4(m25, o9, E13, { limits: e7.limits, fs: e7.fs, cwd: e7.cwd, coverage: e7.coverage });
          return { stdout: u11.output, stderr: u11.errorMessage ? `${u11.errorMessage}
` : "", exitCode: u11.exitCode ?? 0 };
        } catch (u11) {
          if (u11 instanceof b2) return { stdout: "", stderr: `sed: ${u11.message}
`, exitCode: b2.EXIT_CODE };
          throw u11;
        }
      }
      let f11 = false;
      for (let u11 of c15) {
        let h17;
        if (u11 === "-") f11 ? h17 = "" : (h17 = e7.stdin, f11 = true);
        else {
          let b25 = e7.fs.resolvePath(e7.cwd, u11);
          try {
            h17 = await e7.fs.readFile(b25);
          } catch (C19) {
            return C19 instanceof b2 ? { stdout: "", stderr: `sed: ${C19.message}
`, exitCode: b2.EXIT_CODE } : { stdout: "", stderr: `sed: ${u11}: No such file or directory
`, exitCode: 1 };
          }
        }
        m25.length > 0 && h17.length > 0 && !m25.endsWith(`
`) && (m25 += `
`), m25 += h17;
      }
      try {
        let u11 = await z4(m25, o9, E13, { limits: e7.limits, filename: c15.length === 1 ? c15[0] : void 0, fs: e7.fs, cwd: e7.cwd, coverage: e7.coverage });
        return { stdout: u11.output, stderr: u11.errorMessage ? `${u11.errorMessage}
` : "", exitCode: u11.exitCode ?? 0 };
      } catch (u11) {
        if (u11 instanceof b2) return { stdout: "", stderr: `sed: ${u11.message}
`, exitCode: b2.EXIT_CODE };
        throw u11;
      }
    } };
    Le2 = { name: "sed", flags: [{ flag: "-n", type: "boolean" }, { flag: "-i", type: "boolean" }, { flag: "-E", type: "boolean" }, { flag: "-r", type: "boolean" }, { flag: "-e", type: "value", valueHint: "string" }], stdinType: "text", needsArgs: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/sed-7HX4RAZG.js
var sed_7HX4RAZG_exports = {};
__export(sed_7HX4RAZG_exports, {
  flagsForFuzzing: () => Le2,
  sedCommand: () => Ne
});
var init_sed_7HX4RAZG = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/sed-7HX4RAZG.js"() {
    init_chunk_MZLOTDD7();
    init_chunk_YNYSPYQ5();
    init_chunk_PSW6BMXW();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-3KWUDRIP.js
function Q7(e7 = {}) {
  let { fieldSep: t6 = Pe2, maxIterations: n23 = Le3, maxRecursionDepth: i10 = Me2, maxOutputSize: a7 = 0, fs: s9, cwd: o9, exec: c15, coverage: u11 } = e7;
  return { FS: " ", OFS: " ", ORS: `
`, OFMT: "%.6g", NR: 0, NF: 0, FNR: 0, FILENAME: "", RSTART: 0, RLENGTH: -1, SUBSEP: "", fields: [], line: "", vars: /* @__PURE__ */ Object.create(null), arrays: /* @__PURE__ */ Object.create(null), arrayAliases: /* @__PURE__ */ new Map(), ARGC: 0, ARGV: /* @__PURE__ */ Object.create(null), ENVIRON: /* @__PURE__ */ Object.create(null), functions: /* @__PURE__ */ new Map(), fieldSep: t6, maxIterations: n23, maxRecursionDepth: i10, maxOutputSize: a7, currentRecursionDepth: 0, exitCode: 0, shouldExit: false, shouldNext: false, shouldNextFile: false, loopBreak: false, loopContinue: false, hasReturn: false, inEndBlock: false, output: "", openedFiles: /* @__PURE__ */ new Set(), fs: s9, cwd: o9, exec: c15, coverage: u11 };
}
function le5(e7, t6, n23) {
  switch (n23) {
    case "+":
      return e7 + t6;
    case "-":
      return e7 - t6;
    case "*":
      return e7 * t6;
    case "/":
      return t6 !== 0 ? e7 / t6 : 0;
    case "%":
      return t6 !== 0 ? e7 % t6 : 0;
    case "^":
    case "**":
      return e7 ** t6;
    default:
      return 0;
  }
}
function C6(e7) {
  if (typeof e7 == "number") return e7;
  let t6 = parseFloat(e7);
  return Number.isNaN(t6) ? 0 : t6;
}
function I7(e7) {
  return typeof e7 == "string" ? e7 : (Number.isInteger(e7), String(e7));
}
async function U6(e7, t6) {
  if (e7.type === "regex") return e7.pattern;
  let n23 = I7(await t6.evalExpr(e7));
  return n23.startsWith("/") && n23.endsWith("/") && (n23 = n23.slice(1, -1)), n23;
}
async function ue5(e7, t6) {
  return e7 ? e7.type === "variable" ? e7.name : e7.type === "field" ? `$${Math.floor(C6(await t6.evalExpr(e7.index)))}` : "$0" : "$0";
}
function he5(e7, t6) {
  if (e7 === "$0") return t6.line;
  if (e7.startsWith("$")) {
    let n23 = parseInt(e7.slice(1), 10) - 1;
    return t6.fields[n23] || "";
  }
  return I7(t6.vars[e7] ?? "");
}
function pe4(e7, t6, n23) {
  if (e7 === "$0") n23.line = t6, n23.fields = n23.FS === " " ? t6.trim().split(/\s+/).filter(Boolean) : n23.fieldSep.split(t6), n23.NF = n23.fields.length;
  else if (e7.startsWith("$")) {
    let i10 = parseInt(e7.slice(1), 10) - 1;
    for (; n23.fields.length <= i10; ) n23.fields.push("");
    n23.fields[i10] = t6, n23.NF = n23.fields.length, n23.line = n23.fields.join(n23.OFS);
  } else n23.vars[e7] = t6;
}
async function Te2(e7, t6, n23) {
  return e7.length === 0 ? t6.line.length : I7(await n23.evalExpr(e7[0])).length;
}
async function Fe2(e7, t6, n23) {
  if (e7.length < 2) return "";
  let i10 = I7(await n23.evalExpr(e7[0])), a7 = Math.floor(C6(await n23.evalExpr(e7[1]))) - 1;
  if (e7.length >= 3) {
    let s9 = Math.floor(C6(await n23.evalExpr(e7[2])));
    return i10.substr(Math.max(0, a7), s9);
  }
  return i10.substr(Math.max(0, a7));
}
async function _e2(e7, t6, n23) {
  if (e7.length < 2) return 0;
  let i10 = I7(await n23.evalExpr(e7[0])), a7 = I7(await n23.evalExpr(e7[1])), s9 = i10.indexOf(a7);
  return s9 === -1 ? 0 : s9 + 1;
}
async function Ge2(e7, t6, n23) {
  if (e7.length < 2) return 0;
  let i10 = I7(await n23.evalExpr(e7[0])), a7 = e7[1];
  if (a7.type !== "variable") return 0;
  let s9 = a7.name, o9 = t6.FS;
  if (e7.length >= 3) {
    let u11 = e7[2];
    if (u11.type === "regex") o9 = b1(u11.pattern);
    else {
      let N15 = I7(await n23.evalExpr(u11));
      o9 = N15 === " " ? b1("\\s+") : N15;
    }
  } else t6.FS === " " && (o9 = b1("\\s+"));
  let c15 = typeof o9 == "string" ? i10.split(o9) : o9.split(i10);
  t6.arrays[s9] = /* @__PURE__ */ Object.create(null);
  for (let u11 = 0; u11 < c15.length; u11++) t6.arrays[s9][String(u11 + 1)] = c15[u11];
  return c15.length;
}
async function De2(e7, t6, n23) {
  if (e7.length < 2) return 0;
  let i10 = await U6(e7[0], n23), a7 = I7(await n23.evalExpr(e7[1])), s9 = await ue5(e7[2], n23), o9 = he5(s9, t6);
  try {
    let u11 = b1(i10).replace(o9, fe5(a7)), N15 = u11 !== o9 ? 1 : 0;
    return pe4(s9, u11, t6), N15;
  } catch {
    return 0;
  }
}
async function xe3(e7, t6, n23) {
  if (e7.length < 2) return 0;
  let i10 = await U6(e7[0], n23), a7 = I7(await n23.evalExpr(e7[1])), s9 = await ue5(e7[2], n23), o9 = he5(s9, t6);
  try {
    let c15 = b1(i10, "g"), u11 = c15.match(o9), N15 = u11 ? u11.length : 0, k17 = c15.replace(o9, fe5(a7));
    return pe4(s9, k17, t6), N15;
  } catch {
    return 0;
  }
}
function fe5(e7) {
  return (t6) => {
    let n23 = "", i10 = 0;
    for (; i10 < e7.length; ) if (e7[i10] === "\\" && i10 + 1 < e7.length) {
      let a7 = e7[i10 + 1];
      a7 === "&" ? (n23 += "&", i10 += 2) : a7 === "\\" ? (n23 += "\\", i10 += 2) : (n23 += e7[i10 + 1], i10 += 2);
    } else e7[i10] === "&" ? (n23 += t6, i10++) : (n23 += e7[i10], i10++);
    return n23;
  };
}
async function Ue2(e7, t6, n23) {
  if (e7.length < 2) return t6.RSTART = 0, t6.RLENGTH = -1, 0;
  let i10 = I7(await n23.evalExpr(e7[0])), a7 = await U6(e7[1], n23);
  try {
    let o9 = b1(a7).exec(i10);
    if (o9) return t6.RSTART = o9.index + 1, t6.RLENGTH = o9[0].length, t6.RSTART;
  } catch {
  }
  return t6.RSTART = 0, t6.RLENGTH = -1, 0;
}
async function Be(e7, t6, n23) {
  if (e7.length < 3) return "";
  let i10 = await U6(e7[0], n23), a7 = I7(await n23.evalExpr(e7[1])), s9 = I7(await n23.evalExpr(e7[2])), o9 = e7.length >= 4 ? I7(await n23.evalExpr(e7[3])) : t6.line;
  try {
    let c15 = s9.toLowerCase() === "g", u11 = c15 ? 0 : parseInt(s9, 10) || 1;
    if (c15) return b1(i10, "g").replace(o9, (k17, ...y18) => ce4(a7, k17, y18.slice(0, -2)));
    {
      let N15 = 0;
      return b1(i10, "g").replace(o9, (y18, ...w19) => (N15++, N15 === u11 ? ce4(a7, y18, w19.slice(0, -2)) : y18));
    }
  } catch {
    return o9;
  }
}
function ce4(e7, t6, n23) {
  let i10 = "", a7 = 0;
  for (; a7 < e7.length; ) if (e7[a7] === "\\" && a7 + 1 < e7.length) {
    let s9 = e7[a7 + 1];
    if (s9 === "&") i10 += "&", a7 += 2;
    else if (s9 === "0") i10 += t6, a7 += 2;
    else if (s9 >= "1" && s9 <= "9") {
      let o9 = parseInt(s9, 10) - 1;
      i10 += n23[o9] || "", a7 += 2;
    } else s9 === "n" ? (i10 += `
`, a7 += 2) : s9 === "t" ? (i10 += "	", a7 += 2) : (i10 += s9, a7 += 2);
  } else e7[a7] === "&" ? (i10 += t6, a7++) : (i10 += e7[a7], a7++);
  return i10;
}
async function He2(e7, t6, n23) {
  return e7.length === 0 ? "" : I7(await n23.evalExpr(e7[0])).toLowerCase();
}
async function $e2(e7, t6, n23) {
  return e7.length === 0 ? "" : I7(await n23.evalExpr(e7[0])).toUpperCase();
}
async function We2(e7, t6, n23) {
  if (e7.length === 0) return "";
  let i10 = I7(await n23.evalExpr(e7[0])), a7 = [];
  for (let s9 = 1; s9 < e7.length; s9++) a7.push(await n23.evalExpr(e7[s9]));
  return B5(i10, a7);
}
async function Ve2(e7, t6, n23) {
  return e7.length === 0 ? 0 : Math.floor(C6(await n23.evalExpr(e7[0])));
}
async function Ke2(e7, t6, n23) {
  return e7.length === 0 ? 0 : Math.sqrt(C6(await n23.evalExpr(e7[0])));
}
async function Xe2(e7, t6, n23) {
  return e7.length === 0 ? 0 : Math.sin(C6(await n23.evalExpr(e7[0])));
}
async function je2(e7, t6, n23) {
  return e7.length === 0 ? 0 : Math.cos(C6(await n23.evalExpr(e7[0])));
}
async function ze2(e7, t6, n23) {
  let i10 = e7.length > 0 ? C6(await n23.evalExpr(e7[0])) : 0, a7 = e7.length > 1 ? C6(await n23.evalExpr(e7[1])) : 0;
  return Math.atan2(i10, a7);
}
async function Qe2(e7, t6, n23) {
  return e7.length === 0 ? 0 : Math.log(C6(await n23.evalExpr(e7[0])));
}
async function qe(e7, t6, n23) {
  return e7.length === 0 ? 1 : Math.exp(C6(await n23.evalExpr(e7[0])));
}
function Je2(e7, t6, n23) {
  return t6.random ? t6.random() : Math.random();
}
async function Ze2(e7, t6, n23) {
  let i10 = e7.length > 0 ? C6(await n23.evalExpr(e7[0])) : Date.now();
  return t6.vars._srand_seed = i10, i10;
}
function Ye2(e7, t6) {
  return () => {
    throw new Error(`${e7}() is not supported - ${t6}`);
  };
}
function q8(e7) {
  return () => {
    throw new Error(`function '${e7}()' is not implemented`);
  };
}
function B5(e7, t6) {
  let n23 = 0, i10 = "", a7 = 0;
  for (; a7 < e7.length; ) if (e7[a7] === "%" && a7 + 1 < e7.length) {
    let s9 = a7 + 1, o9 = "", c15 = "", u11 = "", N15, k17 = s9;
    for (; s9 < e7.length && /\d/.test(e7[s9]); ) s9++;
    s9 > k17 && e7[s9] === "$" ? (N15 = parseInt(e7.substring(k17, s9), 10) - 1, s9++) : s9 = k17;
    let y18 = () => {
      if (s9 < e7.length) {
        if (s9 + 1 < e7.length && (e7[s9] === "h" && e7[s9 + 1] === "h" || e7[s9] === "l" && e7[s9 + 1] === "l")) {
          s9 += 2;
          return;
        }
        /[lzjh]/.test(e7[s9]) && s9++;
      }
    };
    for (; s9 < e7.length && /[-+ #0]/.test(e7[s9]); ) o9 += e7[s9++];
    if (e7[s9] === "*") {
      let l8 = t6[n23++], p17 = l8 !== void 0 ? Math.floor(Number(l8)) : 0;
      p17 < 0 ? (o9 += "-", c15 = String(Math.min(-p17, L6))) : c15 = String(Math.min(p17, L6)), s9++;
    } else for (; s9 < e7.length && /\d/.test(e7[s9]); ) c15 += e7[s9++];
    if (c15 && parseInt(c15, 10) > L6 && (c15 = String(L6)), e7[s9] === ".") {
      if (s9++, e7[s9] === "*") {
        let l8 = t6[n23++];
        u11 = String(Math.min(l8 !== void 0 ? Math.floor(Number(l8)) : 0, L6)), s9++;
      } else for (; s9 < e7.length && /\d/.test(e7[s9]); ) u11 += e7[s9++];
      u11 && parseInt(u11, 10) > L6 && (u11 = String(L6));
    }
    y18();
    let w19 = e7[s9], g18 = t6[N15 !== void 0 ? N15 : n23];
    switch (w19) {
      case "s": {
        let l8 = g18 !== void 0 ? String(g18) : "";
        if (u11 && (l8 = l8.substring(0, parseInt(u11, 10))), c15) {
          let p17 = parseInt(c15, 10);
          o9.includes("-") ? l8 = l8.padEnd(p17) : l8 = l8.padStart(p17);
        }
        i10 += l8, N15 === void 0 && n23++;
        break;
      }
      case "d":
      case "i": {
        let l8 = g18 !== void 0 ? Math.floor(Number(g18)) : 0;
        Number.isNaN(l8) && (l8 = 0);
        let p17 = l8 < 0, E13 = Math.abs(l8).toString();
        if (u11) {
          let b25 = parseInt(u11, 10);
          E13 = E13.padStart(b25, "0");
        }
        let d16 = "";
        p17 ? d16 = "-" : o9.includes("+") ? d16 = "+" : o9.includes(" ") && (d16 = " ");
        let R13 = d16 + E13;
        if (c15) {
          let b25 = parseInt(c15, 10);
          o9.includes("-") ? R13 = R13.padEnd(b25) : o9.includes("0") && !u11 ? R13 = d16 + E13.padStart(b25 - d16.length, "0") : R13 = R13.padStart(b25);
        }
        i10 += R13, N15 === void 0 && n23++;
        break;
      }
      case "f": {
        let l8 = g18 !== void 0 ? Number(g18) : 0;
        Number.isNaN(l8) && (l8 = 0);
        let p17 = u11 ? parseInt(u11, 10) : 6, E13 = l8.toFixed(p17);
        if (c15) {
          let d16 = parseInt(c15, 10);
          o9.includes("-") ? E13 = E13.padEnd(d16) : E13 = E13.padStart(d16);
        }
        i10 += E13, N15 === void 0 && n23++;
        break;
      }
      case "e":
      case "E": {
        let l8 = g18 !== void 0 ? Number(g18) : 0;
        Number.isNaN(l8) && (l8 = 0);
        let p17 = u11 ? parseInt(u11, 10) : 6, E13 = l8.toExponential(p17);
        if (w19 === "E" && (E13 = E13.toUpperCase()), c15) {
          let d16 = parseInt(c15, 10);
          o9.includes("-") ? E13 = E13.padEnd(d16) : E13 = E13.padStart(d16);
        }
        i10 += E13, N15 === void 0 && n23++;
        break;
      }
      case "g":
      case "G": {
        let l8 = g18 !== void 0 ? Number(g18) : 0;
        Number.isNaN(l8) && (l8 = 0);
        let p17 = u11 ? parseInt(u11, 10) : 6, E13 = l8 !== 0 ? Math.floor(Math.log10(Math.abs(l8))) : 0, d16;
        if (l8 === 0 ? d16 = "0" : E13 < -4 || E13 >= p17 ? (d16 = l8.toExponential(p17 - 1), w19 === "G" && (d16 = d16.toUpperCase())) : d16 = l8.toPrecision(p17), d16.includes(".") && (d16 = d16.replace(/\.?0+$/, "").replace(/\.?0+e/, "e")), d16.includes("e") && (d16 = d16.replace(/\.?0+e/, "e")), c15) {
          let R13 = parseInt(c15, 10);
          o9.includes("-") ? d16 = d16.padEnd(R13) : d16 = d16.padStart(R13);
        }
        i10 += d16, N15 === void 0 && n23++;
        break;
      }
      case "x":
      case "X": {
        let l8 = g18 !== void 0 ? Math.floor(Number(g18)) : 0;
        Number.isNaN(l8) && (l8 = 0);
        let p17 = Math.abs(l8).toString(16);
        if (w19 === "X" && (p17 = p17.toUpperCase()), u11) {
          let R13 = parseInt(u11, 10);
          p17 = p17.padStart(R13, "0");
        }
        let E13 = l8 < 0 ? "-" : "", d16 = E13 + p17;
        if (c15) {
          let R13 = parseInt(c15, 10);
          o9.includes("-") ? d16 = d16.padEnd(R13) : o9.includes("0") && !u11 ? d16 = E13 + p17.padStart(R13 - E13.length, "0") : d16 = d16.padStart(R13);
        }
        i10 += d16, N15 === void 0 && n23++;
        break;
      }
      case "o": {
        let l8 = g18 !== void 0 ? Math.floor(Number(g18)) : 0;
        Number.isNaN(l8) && (l8 = 0);
        let p17 = Math.abs(l8).toString(8);
        if (u11) {
          let R13 = parseInt(u11, 10);
          p17 = p17.padStart(R13, "0");
        }
        let E13 = l8 < 0 ? "-" : "", d16 = E13 + p17;
        if (c15) {
          let R13 = parseInt(c15, 10);
          o9.includes("-") ? d16 = d16.padEnd(R13) : o9.includes("0") && !u11 ? d16 = E13 + p17.padStart(R13 - E13.length, "0") : d16 = d16.padStart(R13);
        }
        i10 += d16, N15 === void 0 && n23++;
        break;
      }
      case "c": {
        typeof g18 == "number" ? i10 += String.fromCharCode(g18) : i10 += String(g18 ?? "").charAt(0) || "", N15 === void 0 && n23++;
        break;
      }
      case "%":
        i10 += "%";
        break;
      default:
        i10 += e7.substring(a7, s9 + 1);
    }
    a7 = s9 + 1;
  } else if (e7[a7] === "\\" && a7 + 1 < e7.length) {
    let s9 = e7[a7 + 1];
    switch (s9) {
      case "n":
        i10 += `
`;
        break;
      case "t":
        i10 += "	";
        break;
      case "r":
        i10 += "\r";
        break;
      case "\\":
        i10 += "\\";
        break;
      default:
        i10 += s9;
    }
    a7 += 2;
  } else i10 += e7[a7++];
  return i10;
}
function v8(e7) {
  return typeof e7 == "number" ? e7 !== 0 : !(e7 === "" || e7 === "0");
}
function m8(e7) {
  if (typeof e7 == "number") return e7;
  let t6 = parseFloat(e7);
  return Number.isNaN(t6) ? 0 : t6;
}
function S4(e7) {
  return typeof e7 == "string" ? e7 : (Number.isInteger(e7), String(e7));
}
function J7(e7) {
  if (typeof e7 == "number") return true;
  let t6 = String(e7).trim();
  return t6 === "" ? false : !Number.isNaN(Number(t6));
}
function G4(e7, t6) {
  try {
    return b1(e7).test(t6);
  } catch {
    return false;
  }
}
function Ee2(e7, t6) {
  return t6 === "" ? [] : e7.FS === " " ? t6.trim().split(/\s+/).filter(Boolean) : e7.fieldSep.split(t6);
}
function H7(e7, t6) {
  return t6 === 0 ? e7.line : t6 < 0 || t6 > e7.fields.length ? "" : e7.fields[t6 - 1] ?? "";
}
function Z6(e7, t6, n23) {
  if (t6 === 0) e7.line = S4(n23), e7.fields = Ee2(e7, e7.line), e7.NF = e7.fields.length;
  else if (t6 > 0) {
    for (; e7.fields.length < t6; ) e7.fields.push("");
    e7.fields[t6 - 1] = S4(n23), e7.NF = e7.fields.length, e7.line = e7.fields.join(e7.OFS);
  }
}
function T3(e7, t6) {
  e7.line = t6, e7.fields = Ee2(e7, t6), e7.NF = e7.fields.length;
}
function Ne2(e7, t6) {
  if (e7.FS = t6, t6 === " ") e7.fieldSep = new i1(/\s+/);
  else try {
    e7.fieldSep = b1(t6);
  } catch {
    e7.fieldSep = b1(t6.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"));
  }
}
function $9(e7, t6) {
  switch (t6) {
    case "FS":
      return e7.FS;
    case "OFS":
      return e7.OFS;
    case "ORS":
      return e7.ORS;
    case "OFMT":
      return e7.OFMT;
    case "NR":
      return e7.NR;
    case "NF":
      return e7.NF;
    case "FNR":
      return e7.FNR;
    case "FILENAME":
      return e7.FILENAME;
    case "RSTART":
      return e7.RSTART;
    case "RLENGTH":
      return e7.RLENGTH;
    case "SUBSEP":
      return e7.SUBSEP;
    case "ARGC":
      return e7.ARGC;
  }
  return e7.vars[t6] ?? "";
}
function F6(e7, t6, n23) {
  switch (t6) {
    case "FS":
      Ne2(e7, S4(n23));
      return;
    case "OFS":
      e7.OFS = S4(n23);
      return;
    case "ORS":
      e7.ORS = S4(n23);
      return;
    case "OFMT":
      e7.OFMT = S4(n23);
      return;
    case "NR":
      e7.NR = Math.floor(m8(n23));
      return;
    case "NF": {
      let i10 = Math.floor(m8(n23));
      if (i10 < e7.NF) e7.fields = e7.fields.slice(0, i10), e7.line = e7.fields.join(e7.OFS);
      else if (i10 > e7.NF) {
        for (; e7.fields.length < i10; ) e7.fields.push("");
        e7.line = e7.fields.join(e7.OFS);
      }
      e7.NF = i10;
      return;
    }
    case "FNR":
      e7.FNR = Math.floor(m8(n23));
      return;
    case "FILENAME":
      e7.FILENAME = S4(n23);
      return;
    case "RSTART":
      e7.RSTART = Math.floor(m8(n23));
      return;
    case "RLENGTH":
      e7.RLENGTH = Math.floor(m8(n23));
      return;
    case "SUBSEP":
      e7.SUBSEP = S4(n23);
      return;
  }
  e7.vars[t6] = n23;
}
function D6(e7, t6) {
  let n23 = t6, i10 = /* @__PURE__ */ new Set(), a7 = e7.arrayAliases.get(n23);
  for (; a7 !== void 0 && !i10.has(n23); ) i10.add(n23), n23 = a7, a7 = e7.arrayAliases.get(n23);
  return n23;
}
function W6(e7, t6, n23) {
  if (t6 === "ARGV") return e7.ARGV[n23] ?? "";
  if (t6 === "ENVIRON") return e7.ENVIRON[n23] ?? "";
  let i10 = D6(e7, t6);
  return e7.arrays[i10]?.[n23] ?? "";
}
function Y6(e7, t6, n23, i10) {
  let a7 = D6(e7, t6);
  e7.arrays[a7] || (e7.arrays[a7] = /* @__PURE__ */ Object.create(null)), e7.arrays[a7][n23] = i10;
}
function Se2(e7, t6, n23) {
  if (t6 === "ARGV") return e7.ARGV[n23] !== void 0;
  if (t6 === "ENVIRON") return e7.ENVIRON[n23] !== void 0;
  let i10 = D6(e7, t6);
  return e7.arrays[i10]?.[n23] !== void 0;
}
function ye3(e7, t6, n23) {
  let i10 = D6(e7, t6);
  e7.arrays[i10] && delete e7.arrays[i10][n23];
}
function Re3(e7, t6) {
  let n23 = D6(e7, t6);
  delete e7.arrays[n23];
}
function me3(e7) {
  ee4 = e7;
}
async function f8(e7, t6) {
  switch (e7.coverage?.hit(`awk:expr:${t6.type}`), t6.type) {
    case "number":
      return t6.value;
    case "string":
      return t6.value;
    case "regex":
      return G4(t6.pattern, e7.line) ? 1 : 0;
    case "field":
      return et2(e7, t6);
    case "variable":
      return $9(e7, t6.name);
    case "array_access":
      return tt2(e7, t6);
    case "binary":
      return nt2(e7, t6);
    case "unary":
      return st2(e7, t6);
    case "ternary":
      return v8(await f8(e7, t6.condition)) ? await f8(e7, t6.consequent) : await f8(e7, t6.alternate);
    case "call":
      return at2(e7, t6.name, t6.args);
    case "assignment":
      return lt2(e7, t6);
    case "pre_increment":
      return ct2(e7, t6.operand);
    case "pre_decrement":
      return ut2(e7, t6.operand);
    case "post_increment":
      return ht2(e7, t6.operand);
    case "post_decrement":
      return pt2(e7, t6.operand);
    case "in":
      return ft2(e7, t6.key, t6.array);
    case "getline":
      return dt2(e7, t6.variable, t6.file, t6.command);
    case "tuple":
      return St2(e7, t6.elements);
    default:
      return "";
  }
}
async function et2(e7, t6) {
  let n23 = Math.floor(m8(await f8(e7, t6.index)));
  return H7(e7, n23);
}
async function tt2(e7, t6) {
  let n23 = S4(await f8(e7, t6.key));
  return W6(e7, t6.array, n23);
}
async function nt2(e7, t6) {
  let n23 = t6.operator;
  if (n23 === "||") return v8(await f8(e7, t6.left)) || v8(await f8(e7, t6.right)) ? 1 : 0;
  if (n23 === "&&") return v8(await f8(e7, t6.left)) && v8(await f8(e7, t6.right)) ? 1 : 0;
  if (n23 === "~") {
    let c15 = await f8(e7, t6.left);
    t6.right.type === "regex" && e7.coverage?.hit("awk:expr:regex");
    let u11 = t6.right.type === "regex" ? t6.right.pattern : S4(await f8(e7, t6.right));
    try {
      return b1(u11).test(S4(c15)) ? 1 : 0;
    } catch {
      return 0;
    }
  }
  if (n23 === "!~") {
    let c15 = await f8(e7, t6.left);
    t6.right.type === "regex" && e7.coverage?.hit("awk:expr:regex");
    let u11 = t6.right.type === "regex" ? t6.right.pattern : S4(await f8(e7, t6.right));
    try {
      return b1(u11).test(S4(c15)) ? 0 : 1;
    } catch {
      return 1;
    }
  }
  let i10 = await f8(e7, t6.left), a7 = await f8(e7, t6.right);
  if (n23 === " ") {
    let c15 = S4(i10) + S4(a7);
    if (e7.maxOutputSize > 0 && c15.length > e7.maxOutputSize) throw new b2(`awk: string concatenation size limit exceeded (${e7.maxOutputSize} bytes)`, "string_length", e7.output);
    return c15;
  }
  if (rt2(n23)) return it2(i10, a7, n23);
  let s9 = m8(i10), o9 = m8(a7);
  return le5(s9, o9, n23);
}
function rt2(e7) {
  return ["<", "<=", ">", ">=", "==", "!="].includes(e7);
}
function it2(e7, t6, n23) {
  let i10 = J7(e7), a7 = J7(t6);
  if (i10 && a7) {
    let c15 = m8(e7), u11 = m8(t6);
    switch (n23) {
      case "<":
        return c15 < u11 ? 1 : 0;
      case "<=":
        return c15 <= u11 ? 1 : 0;
      case ">":
        return c15 > u11 ? 1 : 0;
      case ">=":
        return c15 >= u11 ? 1 : 0;
      case "==":
        return c15 === u11 ? 1 : 0;
      case "!=":
        return c15 !== u11 ? 1 : 0;
    }
  }
  let s9 = S4(e7), o9 = S4(t6);
  switch (n23) {
    case "<":
      return s9 < o9 ? 1 : 0;
    case "<=":
      return s9 <= o9 ? 1 : 0;
    case ">":
      return s9 > o9 ? 1 : 0;
    case ">=":
      return s9 >= o9 ? 1 : 0;
    case "==":
      return s9 === o9 ? 1 : 0;
    case "!=":
      return s9 !== o9 ? 1 : 0;
  }
  return 0;
}
async function st2(e7, t6) {
  let n23 = await f8(e7, t6.operand);
  switch (t6.operator) {
    case "!":
      return v8(n23) ? 0 : 1;
    case "-":
      return -m8(n23);
    case "+":
      return +m8(n23);
    default:
      return n23;
  }
}
async function at2(e7, t6, n23) {
  let i10 = de5.get(t6);
  if (i10) return i10(n23, e7, { evalExpr: (s9) => f8(e7, s9) });
  let a7 = e7.functions.get(t6);
  return a7 ? ot2(e7, a7, n23) : "";
}
async function ot2(e7, t6, n23) {
  if (e7.currentRecursionDepth++, e7.currentRecursionDepth > e7.maxRecursionDepth) throw e7.currentRecursionDepth--, new b2(`awk: recursion depth exceeded maximum (${e7.maxRecursionDepth})`, "recursion", e7.output);
  let i10 = /* @__PURE__ */ Object.create(null);
  for (let o9 of t6.params) i10[o9] = e7.vars[o9];
  let a7 = [];
  for (let o9 = 0; o9 < t6.params.length; o9++) {
    let c15 = t6.params[o9];
    if (o9 < n23.length) {
      let u11 = n23[o9];
      u11.type === "variable" && (e7.arrayAliases.set(c15, u11.name), a7.push(c15));
      let N15 = await f8(e7, u11);
      e7.vars[c15] = N15;
    } else e7.vars[c15] = "";
  }
  e7.hasReturn = false, e7.returnValue = void 0, ee4 && await ee4(e7, t6.body.statements);
  let s9 = e7.returnValue ?? "";
  for (let o9 of t6.params) i10[o9] !== void 0 ? e7.vars[o9] = i10[o9] : delete e7.vars[o9];
  for (let o9 of a7) e7.arrayAliases.delete(o9);
  return e7.hasReturn = false, e7.returnValue = void 0, e7.currentRecursionDepth--, s9;
}
async function lt2(e7, t6) {
  let n23 = await f8(e7, t6.value), i10 = t6.target, a7 = t6.operator, s9;
  if (a7 === "=") s9 = n23;
  else {
    let o9;
    if (i10.type === "field") {
      let N15 = Math.floor(m8(await f8(e7, i10.index)));
      o9 = H7(e7, N15);
    } else if (i10.type === "variable") o9 = $9(e7, i10.name);
    else {
      let N15 = S4(await f8(e7, i10.key));
      o9 = W6(e7, i10.array, N15);
    }
    let c15 = m8(o9), u11 = m8(n23);
    switch (a7) {
      case "+=":
        s9 = c15 + u11;
        break;
      case "-=":
        s9 = c15 - u11;
        break;
      case "*=":
        s9 = c15 * u11;
        break;
      case "/=":
        s9 = u11 !== 0 ? c15 / u11 : 0;
        break;
      case "%=":
        s9 = u11 !== 0 ? c15 % u11 : 0;
        break;
      case "^=":
        s9 = c15 ** u11;
        break;
      default:
        s9 = n23;
    }
  }
  if (i10.type === "field") {
    let o9 = Math.floor(m8(await f8(e7, i10.index)));
    Z6(e7, o9, s9);
  } else if (i10.type === "variable") F6(e7, i10.name, s9);
  else {
    let o9 = S4(await f8(e7, i10.key));
    Y6(e7, i10.array, o9, s9);
  }
  return s9;
}
async function V6(e7, t6, n23, i10) {
  let a7;
  if (t6.type === "field") {
    let s9 = Math.floor(m8(await f8(e7, t6.index)));
    a7 = m8(H7(e7, s9)), Z6(e7, s9, a7 + n23);
  } else if (t6.type === "variable") a7 = m8($9(e7, t6.name)), F6(e7, t6.name, a7 + n23);
  else {
    let s9 = S4(await f8(e7, t6.key));
    a7 = m8(W6(e7, t6.array, s9)), Y6(e7, t6.array, s9, a7 + n23);
  }
  return i10 ? a7 + n23 : a7;
}
async function ct2(e7, t6) {
  return V6(e7, t6, 1, true);
}
async function ut2(e7, t6) {
  return V6(e7, t6, -1, true);
}
async function ht2(e7, t6) {
  return V6(e7, t6, 1, false);
}
async function pt2(e7, t6) {
  return V6(e7, t6, -1, false);
}
async function ft2(e7, t6, n23) {
  let i10;
  if (t6.type === "tuple") {
    e7.coverage?.hit("awk:expr:tuple");
    let a7 = [];
    for (let s9 of t6.elements) a7.push(S4(await f8(e7, s9)));
    i10 = a7.join(e7.SUBSEP);
  } else i10 = S4(await f8(e7, t6));
  return Se2(e7, n23, i10) ? 1 : 0;
}
async function dt2(e7, t6, n23, i10) {
  if (i10) return Et2(e7, t6, i10);
  if (n23) return Nt2(e7, t6, n23);
  if (!e7.lines || e7.lineIndex === void 0) return -1;
  let a7 = e7.lineIndex + 1;
  if (a7 >= e7.lines.length) return 0;
  let s9 = e7.lines[a7];
  return t6 ? F6(e7, t6, s9) : T3(e7, s9), e7.NR++, e7.lineIndex = a7, 1;
}
async function Et2(e7, t6, n23) {
  if (!e7.exec) return -1;
  let i10 = S4(await f8(e7, n23)), a7 = `__cmd_${i10}`, s9 = `__cmdi_${i10}`, o9, c15;
  if (e7.vars[a7] === void 0) try {
    o9 = (await e7.exec(i10)).stdout.split(`
`), o9.length > 0 && o9[o9.length - 1] === "" && o9.pop(), e7.vars[a7] = JSON.stringify(o9), e7.vars[s9] = -1, c15 = -1;
  } catch {
    return -1;
  }
  else o9 = JSON.parse(e7.vars[a7]), c15 = e7.vars[s9];
  let u11 = c15 + 1;
  if (u11 >= o9.length) return 0;
  let N15 = o9[u11];
  return e7.vars[s9] = u11, t6 ? F6(e7, t6, N15) : T3(e7, N15), 1;
}
async function Nt2(e7, t6, n23) {
  if (!e7.fs || !e7.cwd) return -1;
  let i10 = S4(await f8(e7, n23));
  if (i10 === "/dev/null") return 0;
  let a7 = e7.fs.resolvePath(e7.cwd, i10), s9 = `__fc_${a7}`, o9 = `__fi_${a7}`, c15, u11;
  if (e7.vars[s9] === void 0) try {
    c15 = (await e7.fs.readFile(a7)).split(`
`), c15.length > 0 && c15[c15.length - 1] === "" && c15.pop(), e7.vars[s9] = JSON.stringify(c15), e7.vars[o9] = -1, u11 = -1;
  } catch {
    return -1;
  }
  else c15 = JSON.parse(e7.vars[s9]), u11 = e7.vars[o9];
  let N15 = u11 + 1;
  if (N15 >= c15.length) return 0;
  let k17 = c15[N15];
  return e7.vars[o9] = N15, t6 ? F6(e7, t6, k17) : T3(e7, k17), 1;
}
async function St2(e7, t6) {
  if (t6.length === 0) return "";
  for (let n23 = 0; n23 < t6.length - 1; n23++) await f8(e7, t6[n23]);
  return f8(e7, t6[t6.length - 1]);
}
function te6(e7) {
  if (e7.maxOutputSize > 0 && e7.output.length > e7.maxOutputSize) throw new b2(`awk: output size limit exceeded (${e7.maxOutputSize} bytes)`, "string_length", e7.output);
}
async function _4(e7, t6) {
  for (let n23 of t6) if (await M4(e7, n23), yt2(e7)) break;
}
function yt2(e7) {
  return e7.shouldExit || e7.shouldNext || e7.shouldNextFile || e7.loopBreak || e7.loopContinue || e7.hasReturn;
}
async function M4(e7, t6) {
  switch (e7.coverage?.hit(`awk:stmt:${t6.type}`), t6.type) {
    case "block":
      await _4(e7, t6.statements);
      break;
    case "expr_stmt":
      await f8(e7, t6.expression);
      break;
    case "print":
      await Rt(e7, t6.args, t6.output);
      break;
    case "printf":
      await mt2(e7, t6.format, t6.args, t6.output);
      break;
    case "if":
      await At2(e7, t6);
      break;
    case "while":
      await wt2(e7, t6);
      break;
    case "do_while":
      await gt2(e7, t6);
      break;
    case "for":
      await It2(e7, t6);
      break;
    case "for_in":
      await vt2(e7, t6);
      break;
    case "break":
      e7.loopBreak = true;
      break;
    case "continue":
      e7.loopContinue = true;
      break;
    case "next":
      e7.shouldNext = true;
      break;
    case "nextfile":
      e7.shouldNextFile = true;
      break;
    case "exit":
      e7.shouldExit = true, e7.exitCode = t6.code ? Math.floor(m8(await f8(e7, t6.code))) : 0;
      break;
    case "return":
      e7.hasReturn = true, e7.returnValue = t6.value ? await f8(e7, t6.value) : "";
      break;
    case "delete":
      await kt2(e7, t6.target);
      break;
  }
}
async function Rt(e7, t6, n23) {
  let i10 = [];
  for (let s9 of t6) {
    let o9 = await f8(e7, s9);
    typeof o9 == "number" ? Number.isInteger(o9) && Math.abs(o9) < Number.MAX_SAFE_INTEGER ? i10.push(String(o9)) : i10.push(B5(e7.OFMT, [o9])) : i10.push(S4(o9));
  }
  let a7 = i10.join(e7.OFS) + e7.ORS;
  n23 ? await Ae3(e7, n23.redirect, n23.file, a7) : (e7.output += a7, te6(e7));
}
async function mt2(e7, t6, n23, i10) {
  let a7 = S4(await f8(e7, t6)), s9 = [];
  for (let c15 of n23) s9.push(await f8(e7, c15));
  let o9 = B5(a7, s9);
  i10 ? await Ae3(e7, i10.redirect, i10.file, o9) : (e7.output += o9, te6(e7));
}
async function Ae3(e7, t6, n23, i10) {
  if (!e7.fs || !e7.cwd) {
    e7.output += i10, te6(e7);
    return;
  }
  let a7 = S4(await f8(e7, n23)), s9 = e7.fs.resolvePath(e7.cwd, a7);
  t6 === ">" ? e7.openedFiles.has(s9) ? await e7.fs.appendFile(s9, i10) : (await e7.fs.writeFile(s9, i10), e7.openedFiles.add(s9)) : (e7.openedFiles.has(s9) || e7.openedFiles.add(s9), await e7.fs.appendFile(s9, i10));
}
async function At2(e7, t6) {
  v8(await f8(e7, t6.condition)) ? await M4(e7, t6.consequent) : t6.alternate && await M4(e7, t6.alternate);
}
async function wt2(e7, t6) {
  let n23 = 0;
  for (; v8(await f8(e7, t6.condition)); ) {
    if (n23++, n23 > e7.maxIterations) throw new b2(`awk: while loop exceeded maximum iterations (${e7.maxIterations})`, "iterations", e7.output);
    if (e7.loopContinue = false, await M4(e7, t6.body), e7.loopBreak) {
      e7.loopBreak = false;
      break;
    }
    if (e7.shouldExit || e7.shouldNext || e7.hasReturn) break;
  }
}
async function gt2(e7, t6) {
  let n23 = 0;
  do {
    if (n23++, n23 > e7.maxIterations) throw new b2(`awk: do-while loop exceeded maximum iterations (${e7.maxIterations})`, "iterations", e7.output);
    if (e7.loopContinue = false, await M4(e7, t6.body), e7.loopBreak) {
      e7.loopBreak = false;
      break;
    }
    if (e7.shouldExit || e7.shouldNext || e7.hasReturn) break;
  } while (v8(await f8(e7, t6.condition)));
}
async function It2(e7, t6) {
  t6.init && await f8(e7, t6.init);
  let n23 = 0;
  for (; !t6.condition || v8(await f8(e7, t6.condition)); ) {
    if (n23++, n23 > e7.maxIterations) throw new b2(`awk: for loop exceeded maximum iterations (${e7.maxIterations})`, "iterations", e7.output);
    if (e7.loopContinue = false, await M4(e7, t6.body), e7.loopBreak) {
      e7.loopBreak = false;
      break;
    }
    if (e7.shouldExit || e7.shouldNext || e7.hasReturn) break;
    t6.update && await f8(e7, t6.update);
  }
}
async function vt2(e7, t6) {
  let n23 = e7.arrays[t6.array];
  if (n23) for (let i10 of Object.keys(n23)) {
    if (e7.vars[t6.variable] = i10, e7.loopContinue = false, await M4(e7, t6.body), e7.loopBreak) {
      e7.loopBreak = false;
      break;
    }
    if (e7.shouldExit || e7.shouldNext || e7.hasReturn) break;
  }
}
async function kt2(e7, t6) {
  if (t6.type === "array_access") {
    let n23 = S4(await f8(e7, t6.key));
    ye3(e7, t6.array, n23);
  } else t6.type === "variable" && Re3(e7, t6.name);
}
function Ot2(e7) {
  return e7.replace(/\[\[:space:\]\]/g, "[ \\t\\n\\r\\f\\v]").replace(/\[\[:blank:\]\]/g, "[ \\t]").replace(/\[\[:alpha:\]\]/g, "[a-zA-Z]").replace(/\[\[:digit:\]\]/g, "[0-9]").replace(/\[\[:alnum:\]\]/g, "[a-zA-Z0-9]").replace(/\[\[:upper:\]\]/g, "[A-Z]").replace(/\[\[:lower:\]\]/g, "[a-z]").replace(/\[\[:punct:\]\]/g, "[!\"#$%&'()*+,\\-./:;<=>?@\\[\\]\\\\^_`{|}~]").replace(/\[\[:xdigit:\]\]/g, "[0-9A-Fa-f]").replace(/\[\[:graph:\]\]/g, "[!-~]").replace(/\[\[:print:\]\]/g, "[ -~]").replace(/\[\[:cntrl:\]\]/g, "[\\x00-\\x1f\\x7f]");
}
function ke(e7) {
  e7.expect(h7.PRINT);
  let t6 = [];
  if (e7.check(h7.NEWLINE) || e7.check(h7.SEMICOLON) || e7.check(h7.RBRACE) || e7.check(h7.PIPE) || e7.check(h7.GT) || e7.check(h7.APPEND)) t6.push({ type: "field", index: { type: "number", value: 0 } });
  else for (t6.push(X6(e7)); e7.check(h7.COMMA); ) e7.advance(), t6.push(X6(e7));
  let n23;
  return e7.check(h7.GT) ? (e7.advance(), n23 = { redirect: ">", file: e7.parsePrimary() }) : e7.check(h7.APPEND) && (e7.advance(), n23 = { redirect: ">>", file: e7.parsePrimary() }), { type: "print", args: t6, output: n23 };
}
function X6(e7) {
  return bt2(e7) ? ne5(e7, true) : ne5(e7, false);
}
function ne5(e7, t6) {
  let n23 = t6 ? e7.parseTernary() : Lt2(e7);
  if (e7.match(h7.ASSIGN, h7.PLUS_ASSIGN, h7.MINUS_ASSIGN, h7.STAR_ASSIGN, h7.SLASH_ASSIGN, h7.PERCENT_ASSIGN, h7.CARET_ASSIGN)) {
    let i10 = e7.advance(), a7 = ne5(e7, t6);
    if (n23.type !== "variable" && n23.type !== "field" && n23.type !== "array_access") throw new Error("Invalid assignment target");
    return { type: "assignment", operator: (/* @__PURE__ */ new Map([["=", "="], ["+=", "+="], ["-=", "-="], ["*=", "*="], ["/=", "/="], ["%=", "%="], ["^=", "^="]])).get(i10.value) ?? "=", target: n23, value: a7 };
  }
  return n23;
}
function bt2(e7) {
  let t6 = 0, n23 = e7.pos;
  for (; n23 < e7.tokens.length; ) {
    let i10 = e7.tokens[n23];
    if (i10.type === h7.LPAREN && t6++, i10.type === h7.RPAREN && t6--, i10.type === h7.QUESTION && t6 === 0) return true;
    if (i10.type === h7.NEWLINE || i10.type === h7.SEMICOLON || i10.type === h7.RBRACE || i10.type === h7.COMMA || i10.type === h7.PIPE) return false;
    n23++;
  }
  return false;
}
function Lt2(e7) {
  let t6 = we(e7);
  for (; e7.check(h7.OR); ) {
    e7.advance();
    let n23 = we(e7);
    t6 = { type: "binary", operator: "||", left: t6, right: n23 };
  }
  return t6;
}
function we(e7) {
  let t6 = ge3(e7);
  for (; e7.check(h7.AND); ) {
    e7.advance();
    let n23 = ge3(e7);
    t6 = { type: "binary", operator: "&&", left: t6, right: n23 };
  }
  return t6;
}
function ge3(e7) {
  let t6 = Mt2(e7);
  if (e7.check(h7.IN)) {
    e7.advance();
    let n23 = String(e7.expect(h7.IDENT).value);
    return { type: "in", key: t6, array: n23 };
  }
  return t6;
}
function Mt2(e7) {
  let t6 = Ie2(e7);
  for (; Pt2(e7) && !Tt2(e7); ) {
    let n23 = Ie2(e7);
    t6 = { type: "binary", operator: " ", left: t6, right: n23 };
  }
  return t6;
}
function Ie2(e7) {
  let t6 = ve2(e7);
  for (; e7.match(h7.MATCH, h7.NOT_MATCH); ) {
    let n23 = e7.advance().type === h7.MATCH ? "~" : "!~", i10 = ve2(e7);
    t6 = { type: "binary", operator: n23, left: t6, right: i10 };
  }
  return t6;
}
function ve2(e7) {
  let t6 = e7.parseAddSub();
  for (; e7.match(h7.LT, h7.LE, h7.GE, h7.EQ, h7.NE); ) {
    let n23 = e7.advance(), i10 = e7.parseAddSub();
    t6 = { type: "binary", operator: (/* @__PURE__ */ new Map([["<", "<"], ["<=", "<="], [">=", ">="], ["==", "=="], ["!=", "!="]])).get(n23.value) ?? "==", left: t6, right: i10 };
  }
  return t6;
}
function Pt2(e7) {
  return e7.match(h7.NUMBER, h7.STRING, h7.IDENT, h7.DOLLAR, h7.LPAREN, h7.NOT, h7.MINUS, h7.PLUS, h7.INCREMENT, h7.DECREMENT);
}
function Tt2(e7) {
  return e7.match(h7.AND, h7.OR, h7.QUESTION, h7.ASSIGN, h7.PLUS_ASSIGN, h7.MINUS_ASSIGN, h7.STAR_ASSIGN, h7.SLASH_ASSIGN, h7.PERCENT_ASSIGN, h7.CARET_ASSIGN, h7.COMMA, h7.SEMICOLON, h7.NEWLINE, h7.RBRACE, h7.RPAREN, h7.RBRACKET, h7.COLON, h7.PIPE, h7.APPEND, h7.GT, h7.IN);
}
function Ce2(e7) {
  e7.expect(h7.PRINTF);
  let t6 = e7.check(h7.LPAREN);
  t6 && (e7.advance(), e7.skipNewlines());
  let n23 = t6 ? e7.parseExpression() : X6(e7), i10 = [];
  for (; e7.check(h7.COMMA); ) e7.advance(), t6 && e7.skipNewlines(), i10.push(t6 ? e7.parseExpression() : X6(e7));
  t6 && (e7.skipNewlines(), e7.expect(h7.RPAREN));
  let a7;
  return e7.check(h7.GT) ? (e7.advance(), a7 = { redirect: ">", file: e7.parsePrimary() }) : e7.check(h7.APPEND) && (e7.advance(), a7 = { redirect: ">>", file: e7.parsePrimary() }), { type: "printf", format: n23, args: i10, output: a7 };
}
function re3(e7) {
  return e7.replace(/\\t/g, "	").replace(/\\n/g, `
`).replace(/\\r/g, "\r").replace(/\\b/g, "\b").replace(/\\f/g, "\f").replace(/\\a/g, "\x07").replace(/\\v/g, "\v").replace(/\\\\/g, "\\");
}
function Oe2(e7) {
  if (e7 === " ") return b1("\\s+");
  if (/[[\](){}.*+?^$|\\]/.test(e7)) try {
    return b1(e7);
  } catch {
    return b1(be2(e7));
  }
  return b1(be2(e7));
}
function be2(e7) {
  return e7.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
var Le3, Me2, Pe2, L6, de5, ee4, x8, r6, Ct2, K7, h7, j3, Ft2, On2, bn2;
var init_chunk_3KWUDRIP = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-3KWUDRIP.js"() {
    init_chunk_OJDRYQWQ();
    init_chunk_YNYSPYQ5();
    init_chunk_PSW6BMXW();
    init_chunk_74CEPOFO();
    Le3 = 1e4;
    Me2 = 100;
    Pe2 = new i1(/\s+/);
    L6 = 1e4;
    de5 = /* @__PURE__ */ new Map([["length", Te2], ["substr", Fe2], ["index", _e2], ["split", Ge2], ["sub", De2], ["gsub", xe3], ["match", Ue2], ["gensub", Be], ["tolower", He2], ["toupper", $e2], ["sprintf", We2], ["int", Ve2], ["sqrt", Ke2], ["sin", Xe2], ["cos", je2], ["atan2", ze2], ["log", Qe2], ["exp", qe], ["rand", Je2], ["srand", Ze2], ["system", Ye2("system", "shell execution not allowed in sandboxed environment")], ["close", () => 0], ["fflush", () => 0], ["systime", q8("systime")], ["mktime", q8("mktime")], ["strftime", q8("strftime")]]);
    ee4 = null;
    me3(_4);
    x8 = class {
      ctx;
      program = null;
      rangeStates = [];
      constructor(t6) {
        this.ctx = t6;
      }
      execute(t6) {
        this.program = t6, this.ctx.output = "";
        for (let n23 of t6.functions) this.ctx.functions.set(n23.name, n23);
        this.rangeStates = t6.rules.map(() => false);
      }
      async executeBegin() {
        if (this.program) {
          for (let t6 of this.program.rules) if (t6.pattern?.type === "begin" && (await _4(this.ctx, t6.action.statements), this.ctx.shouldExit)) break;
        }
      }
      async executeLine(t6) {
        if (!(!this.program || this.ctx.shouldExit)) {
          T3(this.ctx, t6), this.ctx.NR++, this.ctx.FNR++, this.ctx.shouldNext = false;
          for (let n23 = 0; n23 < this.program.rules.length && !(this.ctx.shouldExit || this.ctx.shouldNext || this.ctx.shouldNextFile); n23++) {
            let i10 = this.program.rules[n23];
            i10.pattern?.type === "begin" || i10.pattern?.type === "end" || await this.matchesRule(i10, n23) && await _4(this.ctx, i10.action.statements);
          }
        }
      }
      async executeEnd() {
        if (this.program && !this.ctx.inEndBlock) {
          this.ctx.inEndBlock = true, this.ctx.shouldExit = false;
          for (let t6 of this.program.rules) if (t6.pattern?.type === "end" && (await _4(this.ctx, t6.action.statements), this.ctx.shouldExit)) break;
          this.ctx.inEndBlock = false;
        }
      }
      getOutput() {
        return this.ctx.output;
      }
      getExitCode() {
        return this.ctx.exitCode;
      }
      getContext() {
        return this.ctx;
      }
      async matchesRule(t6, n23) {
        let i10 = t6.pattern;
        if (!i10) return true;
        switch (i10.type) {
          case "begin":
          case "end":
            return false;
          case "regex_pattern":
            return G4(i10.pattern, this.ctx.line);
          case "expr_pattern":
            return v8(await f8(this.ctx, i10.expression));
          case "range": {
            let a7 = await this.matchPattern(i10.start), s9 = await this.matchPattern(i10.end);
            return this.rangeStates[n23] ? (s9 && (this.rangeStates[n23] = false), true) : a7 ? (this.rangeStates[n23] = true, s9 && (this.rangeStates[n23] = false), true) : false;
          }
          default:
            return false;
        }
      }
      async matchPattern(t6) {
        switch (t6.type) {
          case "regex_pattern":
            return G4(t6.pattern, this.ctx.line);
          case "expr_pattern":
            return v8(await f8(this.ctx, t6.expression));
          default:
            return false;
        }
      }
    };
    (function(e7) {
      e7.NUMBER = "NUMBER", e7.STRING = "STRING", e7.REGEX = "REGEX", e7.IDENT = "IDENT", e7.BEGIN = "BEGIN", e7.END = "END", e7.IF = "IF", e7.ELSE = "ELSE", e7.WHILE = "WHILE", e7.DO = "DO", e7.FOR = "FOR", e7.IN = "IN", e7.BREAK = "BREAK", e7.CONTINUE = "CONTINUE", e7.NEXT = "NEXT", e7.NEXTFILE = "NEXTFILE", e7.EXIT = "EXIT", e7.RETURN = "RETURN", e7.DELETE = "DELETE", e7.FUNCTION = "FUNCTION", e7.PRINT = "PRINT", e7.PRINTF = "PRINTF", e7.GETLINE = "GETLINE", e7.PLUS = "PLUS", e7.MINUS = "MINUS", e7.STAR = "STAR", e7.SLASH = "SLASH", e7.PERCENT = "PERCENT", e7.CARET = "CARET", e7.EQ = "EQ", e7.NE = "NE", e7.LT = "LT", e7.GT = "GT", e7.LE = "LE", e7.GE = "GE", e7.MATCH = "MATCH", e7.NOT_MATCH = "NOT_MATCH", e7.AND = "AND", e7.OR = "OR", e7.NOT = "NOT", e7.ASSIGN = "ASSIGN", e7.PLUS_ASSIGN = "PLUS_ASSIGN", e7.MINUS_ASSIGN = "MINUS_ASSIGN", e7.STAR_ASSIGN = "STAR_ASSIGN", e7.SLASH_ASSIGN = "SLASH_ASSIGN", e7.PERCENT_ASSIGN = "PERCENT_ASSIGN", e7.CARET_ASSIGN = "CARET_ASSIGN", e7.INCREMENT = "INCREMENT", e7.DECREMENT = "DECREMENT", e7.QUESTION = "QUESTION", e7.COLON = "COLON", e7.COMMA = "COMMA", e7.SEMICOLON = "SEMICOLON", e7.NEWLINE = "NEWLINE", e7.LPAREN = "LPAREN", e7.RPAREN = "RPAREN", e7.LBRACE = "LBRACE", e7.RBRACE = "RBRACE", e7.LBRACKET = "LBRACKET", e7.RBRACKET = "RBRACKET", e7.DOLLAR = "DOLLAR", e7.APPEND = "APPEND", e7.PIPE = "PIPE", e7.EOF = "EOF";
    })(r6 || (r6 = {}));
    Ct2 = /* @__PURE__ */ new Map([["BEGIN", r6.BEGIN], ["END", r6.END], ["if", r6.IF], ["else", r6.ELSE], ["while", r6.WHILE], ["do", r6.DO], ["for", r6.FOR], ["in", r6.IN], ["break", r6.BREAK], ["continue", r6.CONTINUE], ["next", r6.NEXT], ["nextfile", r6.NEXTFILE], ["exit", r6.EXIT], ["return", r6.RETURN], ["delete", r6.DELETE], ["function", r6.FUNCTION], ["print", r6.PRINT], ["printf", r6.PRINTF], ["getline", r6.GETLINE]]);
    K7 = class {
      input;
      pos = 0;
      line = 1;
      column = 1;
      lastTokenType = null;
      constructor(t6) {
        this.input = t6;
      }
      tokenize() {
        let t6 = [];
        for (; this.pos < this.input.length; ) {
          let n23 = this.nextToken();
          n23 && (t6.push(n23), this.lastTokenType = n23.type);
        }
        return t6.push(this.makeToken(r6.EOF, "")), t6;
      }
      makeToken(t6, n23) {
        return { type: t6, value: n23, line: this.line, column: this.column };
      }
      peek(t6 = 0) {
        return this.input[this.pos + t6] || "";
      }
      advance() {
        let t6 = this.input[this.pos++] || "";
        return t6 === `
` ? (this.line++, this.column = 1) : this.column++, t6;
      }
      skipWhitespace() {
        for (; this.pos < this.input.length; ) {
          let t6 = this.peek();
          if (t6 === " " || t6 === "	" || t6 === "\r") this.advance();
          else if (t6 === "\\") if (this.peek(1) === `
`) this.advance(), this.advance();
          else break;
          else if (t6 === "#") for (; this.pos < this.input.length && this.peek() !== `
`; ) this.advance();
          else break;
        }
      }
      nextToken() {
        if (this.skipWhitespace(), this.pos >= this.input.length) return null;
        let t6 = this.line, n23 = this.column, i10 = this.peek();
        return i10 === `
` ? (this.advance(), { type: r6.NEWLINE, value: `
`, line: t6, column: n23 }) : i10 === '"' ? this.readString() : i10 === "/" && this.canBeRegex() ? this.readRegex() : this.isDigit(i10) || i10 === "." && this.isDigit(this.peek(1)) ? this.readNumber() : this.isAlpha(i10) || i10 === "_" ? this.readIdentifier() : this.readOperator();
      }
      canBeRegex() {
        return (/* @__PURE__ */ new Set([null, r6.NEWLINE, r6.SEMICOLON, r6.LBRACE, r6.RBRACE, r6.LPAREN, r6.LBRACKET, r6.COMMA, r6.ASSIGN, r6.PLUS_ASSIGN, r6.MINUS_ASSIGN, r6.STAR_ASSIGN, r6.SLASH_ASSIGN, r6.PERCENT_ASSIGN, r6.CARET_ASSIGN, r6.AND, r6.OR, r6.NOT, r6.MATCH, r6.NOT_MATCH, r6.QUESTION, r6.COLON, r6.LT, r6.GT, r6.LE, r6.GE, r6.EQ, r6.NE, r6.PLUS, r6.MINUS, r6.STAR, r6.PERCENT, r6.CARET, r6.PRINT, r6.PRINTF, r6.IF, r6.WHILE, r6.DO, r6.FOR, r6.RETURN])).has(this.lastTokenType);
      }
      readString() {
        let t6 = this.line, n23 = this.column;
        this.advance();
        let i10 = "";
        for (; this.pos < this.input.length && this.peek() !== '"'; ) if (this.peek() === "\\") {
          this.advance();
          let a7 = this.advance();
          switch (a7) {
            case "n":
              i10 += `
`;
              break;
            case "t":
              i10 += "	";
              break;
            case "r":
              i10 += "\r";
              break;
            case "f":
              i10 += "\f";
              break;
            case "b":
              i10 += "\b";
              break;
            case "v":
              i10 += "\v";
              break;
            case "a":
              i10 += "\x07";
              break;
            case "\\":
              i10 += "\\";
              break;
            case '"':
              i10 += '"';
              break;
            case "/":
              i10 += "/";
              break;
            case "x": {
              let s9 = "";
              for (; s9.length < 2 && /[0-9a-fA-F]/.test(this.peek()); ) s9 += this.advance();
              s9.length > 0 ? i10 += String.fromCharCode(parseInt(s9, 16)) : i10 += "x";
              break;
            }
            default:
              if (/[0-7]/.test(a7)) {
                let s9 = a7;
                for (; s9.length < 3 && /[0-7]/.test(this.peek()); ) s9 += this.advance();
                i10 += String.fromCharCode(parseInt(s9, 8));
              } else i10 += a7;
          }
        } else i10 += this.advance();
        return this.peek() === '"' && this.advance(), { type: r6.STRING, value: i10, line: t6, column: n23 };
      }
      readRegex() {
        let t6 = this.line, n23 = this.column;
        this.advance();
        let i10 = "";
        for (; this.pos < this.input.length && this.peek() !== "/"; ) if (this.peek() === "\\") i10 += this.advance(), this.pos < this.input.length && (i10 += this.advance());
        else {
          if (this.peek() === `
`) break;
          i10 += this.advance();
        }
        return this.peek() === "/" && this.advance(), i10 = Ot2(i10), { type: r6.REGEX, value: i10, line: t6, column: n23 };
      }
      readNumber() {
        let t6 = this.line, n23 = this.column, i10 = "";
        for (; this.isDigit(this.peek()); ) i10 += this.advance();
        if (this.peek() === "." && this.isDigit(this.peek(1))) for (i10 += this.advance(); this.isDigit(this.peek()); ) i10 += this.advance();
        if (this.peek() === "e" || this.peek() === "E") for (i10 += this.advance(), (this.peek() === "+" || this.peek() === "-") && (i10 += this.advance()); this.isDigit(this.peek()); ) i10 += this.advance();
        return { type: r6.NUMBER, value: parseFloat(i10), line: t6, column: n23 };
      }
      readIdentifier() {
        let t6 = this.line, n23 = this.column, i10 = "";
        for (; this.isAlphaNumeric(this.peek()) || this.peek() === "_"; ) i10 += this.advance();
        let a7 = Ct2.get(i10);
        return a7 !== void 0 ? { type: a7, value: i10, line: t6, column: n23 } : { type: r6.IDENT, value: i10, line: t6, column: n23 };
      }
      readOperator() {
        let t6 = this.line, n23 = this.column, i10 = this.advance(), a7 = this.peek();
        switch (i10) {
          case "+":
            return a7 === "+" ? (this.advance(), { type: r6.INCREMENT, value: "++", line: t6, column: n23 }) : a7 === "=" ? (this.advance(), { type: r6.PLUS_ASSIGN, value: "+=", line: t6, column: n23 }) : { type: r6.PLUS, value: "+", line: t6, column: n23 };
          case "-":
            return a7 === "-" ? (this.advance(), { type: r6.DECREMENT, value: "--", line: t6, column: n23 }) : a7 === "=" ? (this.advance(), { type: r6.MINUS_ASSIGN, value: "-=", line: t6, column: n23 }) : { type: r6.MINUS, value: "-", line: t6, column: n23 };
          case "*":
            return a7 === "*" ? (this.advance(), { type: r6.CARET, value: "**", line: t6, column: n23 }) : a7 === "=" ? (this.advance(), { type: r6.STAR_ASSIGN, value: "*=", line: t6, column: n23 }) : { type: r6.STAR, value: "*", line: t6, column: n23 };
          case "/":
            return a7 === "=" ? (this.advance(), { type: r6.SLASH_ASSIGN, value: "/=", line: t6, column: n23 }) : { type: r6.SLASH, value: "/", line: t6, column: n23 };
          case "%":
            return a7 === "=" ? (this.advance(), { type: r6.PERCENT_ASSIGN, value: "%=", line: t6, column: n23 }) : { type: r6.PERCENT, value: "%", line: t6, column: n23 };
          case "^":
            return a7 === "=" ? (this.advance(), { type: r6.CARET_ASSIGN, value: "^=", line: t6, column: n23 }) : { type: r6.CARET, value: "^", line: t6, column: n23 };
          case "=":
            return a7 === "=" ? (this.advance(), { type: r6.EQ, value: "==", line: t6, column: n23 }) : { type: r6.ASSIGN, value: "=", line: t6, column: n23 };
          case "!":
            return a7 === "=" ? (this.advance(), { type: r6.NE, value: "!=", line: t6, column: n23 }) : a7 === "~" ? (this.advance(), { type: r6.NOT_MATCH, value: "!~", line: t6, column: n23 }) : { type: r6.NOT, value: "!", line: t6, column: n23 };
          case "<":
            return a7 === "=" ? (this.advance(), { type: r6.LE, value: "<=", line: t6, column: n23 }) : { type: r6.LT, value: "<", line: t6, column: n23 };
          case ">":
            return a7 === "=" ? (this.advance(), { type: r6.GE, value: ">=", line: t6, column: n23 }) : a7 === ">" ? (this.advance(), { type: r6.APPEND, value: ">>", line: t6, column: n23 }) : { type: r6.GT, value: ">", line: t6, column: n23 };
          case "&":
            return a7 === "&" ? (this.advance(), { type: r6.AND, value: "&&", line: t6, column: n23 }) : { type: r6.IDENT, value: "&", line: t6, column: n23 };
          case "|":
            return a7 === "|" ? (this.advance(), { type: r6.OR, value: "||", line: t6, column: n23 }) : { type: r6.PIPE, value: "|", line: t6, column: n23 };
          case "~":
            return { type: r6.MATCH, value: "~", line: t6, column: n23 };
          case "?":
            return { type: r6.QUESTION, value: "?", line: t6, column: n23 };
          case ":":
            return { type: r6.COLON, value: ":", line: t6, column: n23 };
          case ",":
            return { type: r6.COMMA, value: ",", line: t6, column: n23 };
          case ";":
            return { type: r6.SEMICOLON, value: ";", line: t6, column: n23 };
          case "(":
            return { type: r6.LPAREN, value: "(", line: t6, column: n23 };
          case ")":
            return { type: r6.RPAREN, value: ")", line: t6, column: n23 };
          case "{":
            return { type: r6.LBRACE, value: "{", line: t6, column: n23 };
          case "}":
            return { type: r6.RBRACE, value: "}", line: t6, column: n23 };
          case "[":
            return { type: r6.LBRACKET, value: "[", line: t6, column: n23 };
          case "]":
            return { type: r6.RBRACKET, value: "]", line: t6, column: n23 };
          case "$":
            return { type: r6.DOLLAR, value: "$", line: t6, column: n23 };
          default:
            return { type: r6.IDENT, value: i10, line: t6, column: n23 };
        }
      }
      isDigit(t6) {
        return t6 >= "0" && t6 <= "9";
      }
      isAlpha(t6) {
        return t6 >= "a" && t6 <= "z" || t6 >= "A" && t6 <= "Z";
      }
      isAlphaNumeric(t6) {
        return this.isDigit(t6) || this.isAlpha(t6);
      }
    };
    h7 = { LPAREN: "LPAREN", RPAREN: "RPAREN", QUESTION: "QUESTION", NEWLINE: "NEWLINE", SEMICOLON: "SEMICOLON", RBRACE: "RBRACE", COMMA: "COMMA", PIPE: "PIPE", GT: "GT", APPEND: "APPEND", AND: "AND", OR: "OR", ASSIGN: "ASSIGN", PLUS_ASSIGN: "PLUS_ASSIGN", MINUS_ASSIGN: "MINUS_ASSIGN", STAR_ASSIGN: "STAR_ASSIGN", SLASH_ASSIGN: "SLASH_ASSIGN", PERCENT_ASSIGN: "PERCENT_ASSIGN", CARET_ASSIGN: "CARET_ASSIGN", RBRACKET: "RBRACKET", COLON: "COLON", IN: "IN", PRINT: "PRINT", PRINTF: "PRINTF", IDENT: "IDENT", LT: "LT", LE: "LE", GE: "GE", EQ: "EQ", NE: "NE", MATCH: "MATCH", NOT_MATCH: "NOT_MATCH", NUMBER: "NUMBER", STRING: "STRING", DOLLAR: "DOLLAR", NOT: "NOT", MINUS: "MINUS", PLUS: "PLUS", INCREMENT: "INCREMENT", DECREMENT: "DECREMENT" };
    j3 = class {
      tokens = [];
      pos = 0;
      parse(t6) {
        let n23 = new K7(t6);
        return this.tokens = n23.tokenize(), this.pos = 0, this.parseProgram();
      }
      setPos(t6) {
        this.pos = t6;
      }
      current() {
        return this.tokens[this.pos] || { type: r6.EOF, value: "", line: 0, column: 0 };
      }
      advance() {
        let t6 = this.current();
        return this.pos < this.tokens.length && this.pos++, t6;
      }
      match(...t6) {
        return t6.includes(this.current().type);
      }
      check(t6) {
        return this.current().type === t6;
      }
      expect(t6, n23) {
        if (!this.check(t6)) {
          let i10 = this.current();
          throw new Error(n23 || `Expected ${t6}, got ${i10.type} at line ${i10.line}:${i10.column}`);
        }
        return this.advance();
      }
      skipNewlines() {
        for (; this.check(r6.NEWLINE); ) this.advance();
      }
      skipTerminators() {
        for (; this.check(r6.NEWLINE) || this.check(r6.SEMICOLON); ) this.advance();
      }
      parseProgram() {
        let t6 = [], n23 = [];
        for (this.skipNewlines(); !this.check(r6.EOF) && (this.skipNewlines(), !this.check(r6.EOF)); ) this.check(r6.FUNCTION) ? t6.push(this.parseFunction()) : n23.push(this.parseRule()), this.skipTerminators();
        return { functions: t6, rules: n23 };
      }
      parseFunction() {
        this.expect(r6.FUNCTION);
        let t6 = this.expect(r6.IDENT).value;
        this.expect(r6.LPAREN);
        let n23 = [];
        if (!this.check(r6.RPAREN)) for (n23.push(this.expect(r6.IDENT).value); this.check(r6.COMMA); ) this.advance(), n23.push(this.expect(r6.IDENT).value);
        this.expect(r6.RPAREN), this.skipNewlines();
        let i10 = this.parseBlock();
        return { name: t6, params: n23, body: i10 };
      }
      parseRule() {
        let t6;
        if (this.check(r6.BEGIN)) this.advance(), t6 = { type: "begin" };
        else if (this.check(r6.END)) this.advance(), t6 = { type: "end" };
        else if (this.check(r6.LBRACE)) t6 = void 0;
        else if (this.check(r6.REGEX)) {
          let i10 = this.advance();
          if (this.check(r6.AND) || this.check(r6.OR)) {
            let a7 = { type: "binary", operator: "~", left: { type: "field", index: { type: "number", value: 0 } }, right: { type: "regex", pattern: i10.value } };
            t6 = { type: "expr_pattern", expression: this.parseLogicalOrRest(a7) };
          } else {
            let a7 = { type: "regex_pattern", pattern: i10.value };
            if (this.check(r6.COMMA)) {
              this.advance();
              let s9;
              this.check(r6.REGEX) ? s9 = { type: "regex_pattern", pattern: this.advance().value } : s9 = { type: "expr_pattern", expression: this.parseExpression() }, t6 = { type: "range", start: a7, end: s9 };
            } else t6 = a7;
          }
        } else {
          let a7 = { type: "expr_pattern", expression: this.parseExpression() };
          if (this.check(r6.COMMA)) {
            this.advance();
            let s9;
            this.check(r6.REGEX) ? s9 = { type: "regex_pattern", pattern: this.advance().value } : s9 = { type: "expr_pattern", expression: this.parseExpression() }, t6 = { type: "range", start: a7, end: s9 };
          } else t6 = a7;
        }
        this.skipNewlines();
        let n23;
        return this.check(r6.LBRACE) ? n23 = this.parseBlock() : n23 = { type: "block", statements: [{ type: "print", args: [{ type: "field", index: { type: "number", value: 0 } }] }] }, { pattern: t6, action: n23 };
      }
      parseBlock() {
        this.expect(r6.LBRACE), this.skipNewlines();
        let t6 = [];
        for (; !this.check(r6.RBRACE) && !this.check(r6.EOF); ) t6.push(this.parseStatement()), this.skipTerminators();
        return this.expect(r6.RBRACE), { type: "block", statements: t6 };
      }
      parseStatement() {
        if (this.check(r6.SEMICOLON) || this.check(r6.NEWLINE)) return this.advance(), { type: "block", statements: [] };
        if (this.check(r6.LBRACE)) return this.parseBlock();
        if (this.check(r6.IF)) return this.parseIf();
        if (this.check(r6.WHILE)) return this.parseWhile();
        if (this.check(r6.DO)) return this.parseDoWhile();
        if (this.check(r6.FOR)) return this.parseFor();
        if (this.check(r6.BREAK)) return this.advance(), { type: "break" };
        if (this.check(r6.CONTINUE)) return this.advance(), { type: "continue" };
        if (this.check(r6.NEXT)) return this.advance(), { type: "next" };
        if (this.check(r6.NEXTFILE)) return this.advance(), { type: "nextfile" };
        if (this.check(r6.EXIT)) {
          this.advance();
          let n23;
          return !this.check(r6.NEWLINE) && !this.check(r6.SEMICOLON) && !this.check(r6.RBRACE) && !this.check(r6.EOF) && (n23 = this.parseExpression()), { type: "exit", code: n23 };
        }
        if (this.check(r6.RETURN)) {
          this.advance();
          let n23;
          return !this.check(r6.NEWLINE) && !this.check(r6.SEMICOLON) && !this.check(r6.RBRACE) && !this.check(r6.EOF) && (n23 = this.parseExpression()), { type: "return", value: n23 };
        }
        if (this.check(r6.DELETE)) {
          this.advance();
          let n23 = this.parsePrimary();
          if (n23.type !== "array_access" && n23.type !== "variable") throw new Error("delete requires array element or array");
          return { type: "delete", target: n23 };
        }
        return this.check(r6.PRINT) ? ke(this) : this.check(r6.PRINTF) ? Ce2(this) : { type: "expr_stmt", expression: this.parseExpression() };
      }
      parseIf() {
        this.expect(r6.IF), this.expect(r6.LPAREN);
        let t6 = this.parseExpression();
        this.expect(r6.RPAREN), this.skipNewlines();
        let n23 = this.parseStatement();
        this.skipTerminators();
        let i10;
        return this.check(r6.ELSE) && (this.advance(), this.skipNewlines(), i10 = this.parseStatement()), { type: "if", condition: t6, consequent: n23, alternate: i10 };
      }
      parseWhile() {
        this.expect(r6.WHILE), this.expect(r6.LPAREN);
        let t6 = this.parseExpression();
        this.expect(r6.RPAREN), this.skipNewlines();
        let n23 = this.parseStatement();
        return { type: "while", condition: t6, body: n23 };
      }
      parseDoWhile() {
        this.expect(r6.DO), this.skipNewlines();
        let t6 = this.parseStatement();
        this.skipNewlines(), this.expect(r6.WHILE), this.expect(r6.LPAREN);
        let n23 = this.parseExpression();
        return this.expect(r6.RPAREN), { type: "do_while", body: t6, condition: n23 };
      }
      parseFor() {
        if (this.expect(r6.FOR), this.expect(r6.LPAREN), this.check(r6.IDENT)) {
          let s9 = this.advance();
          if (this.check(r6.IN)) {
            this.advance();
            let o9 = this.expect(r6.IDENT).value;
            this.expect(r6.RPAREN), this.skipNewlines();
            let c15 = this.parseStatement();
            return { type: "for_in", variable: s9.value, array: o9, body: c15 };
          }
          this.pos--;
        }
        let t6;
        this.check(r6.SEMICOLON) || (t6 = this.parseExpression()), this.expect(r6.SEMICOLON);
        let n23;
        this.check(r6.SEMICOLON) || (n23 = this.parseExpression()), this.expect(r6.SEMICOLON);
        let i10;
        this.check(r6.RPAREN) || (i10 = this.parseExpression()), this.expect(r6.RPAREN), this.skipNewlines();
        let a7 = this.parseStatement();
        return { type: "for", init: t6, condition: n23, update: i10, body: a7 };
      }
      parseExpression() {
        return this.parseAssignment();
      }
      parseAssignment() {
        let t6 = this.parseTernary();
        if (this.match(r6.ASSIGN, r6.PLUS_ASSIGN, r6.MINUS_ASSIGN, r6.STAR_ASSIGN, r6.SLASH_ASSIGN, r6.PERCENT_ASSIGN, r6.CARET_ASSIGN)) {
          let n23 = this.advance(), i10 = this.parseAssignment();
          if (t6.type !== "variable" && t6.type !== "field" && t6.type !== "array_access") throw new Error("Invalid assignment target");
          return { type: "assignment", operator: { "=": "=", "+=": "+=", "-=": "-=", "*=": "*=", "/=": "/=", "%=": "%=", "^=": "^=" }[n23.value], target: t6, value: i10 };
        }
        return t6;
      }
      parseTernary() {
        let t6 = this.parsePipeGetline();
        if (this.check(r6.QUESTION)) {
          this.advance();
          let n23 = this.parseExpression();
          this.expect(r6.COLON);
          let i10 = this.parseExpression();
          t6 = { type: "ternary", condition: t6, consequent: n23, alternate: i10 };
        }
        return t6;
      }
      parsePipeGetline() {
        let t6 = this.parseOr();
        if (this.check(r6.PIPE)) {
          if (this.advance(), !this.check(r6.GETLINE)) throw new Error("Expected 'getline' after '|' in expression context");
          this.advance();
          let n23;
          return this.check(r6.IDENT) && (n23 = this.advance().value), { type: "getline", command: t6, variable: n23 };
        }
        return t6;
      }
      parseOr() {
        let t6 = this.parseAnd();
        for (; this.check(r6.OR); ) {
          this.advance();
          let n23 = this.parseAnd();
          t6 = { type: "binary", operator: "||", left: t6, right: n23 };
        }
        return t6;
      }
      parseLogicalOrRest(t6) {
        for (t6 = this.parseLogicalAndRest(t6); this.check(r6.OR); ) {
          this.advance();
          let n23 = this.parseAnd();
          t6 = { type: "binary", operator: "||", left: t6, right: n23 };
        }
        return t6;
      }
      parseLogicalAndRest(t6) {
        for (; this.check(r6.AND); ) {
          this.advance();
          let n23 = this.parseIn();
          t6 = { type: "binary", operator: "&&", left: t6, right: n23 };
        }
        return t6;
      }
      parseAnd() {
        let t6 = this.parseIn();
        for (; this.check(r6.AND); ) {
          this.advance();
          let n23 = this.parseIn();
          t6 = { type: "binary", operator: "&&", left: t6, right: n23 };
        }
        return t6;
      }
      parseIn() {
        let t6 = this.parseConcatenation();
        if (this.check(r6.IN)) {
          this.advance();
          let n23 = this.expect(r6.IDENT).value;
          return { type: "in", key: t6, array: n23 };
        }
        return t6;
      }
      parseConcatenation() {
        let t6 = this.parseMatch();
        for (; this.canStartExpression() && !this.isConcatTerminator(); ) {
          let n23 = this.parseMatch();
          t6 = { type: "binary", operator: " ", left: t6, right: n23 };
        }
        return t6;
      }
      parseMatch() {
        let t6 = this.parseComparison();
        for (; this.match(r6.MATCH, r6.NOT_MATCH); ) {
          let n23 = this.advance().type === r6.MATCH ? "~" : "!~", i10 = this.parseComparison();
          t6 = { type: "binary", operator: n23, left: t6, right: i10 };
        }
        return t6;
      }
      parseComparison() {
        let t6 = this.parseAddSub();
        for (; this.match(r6.LT, r6.LE, r6.GT, r6.GE, r6.EQ, r6.NE); ) {
          let n23 = this.advance(), i10 = this.parseAddSub();
          t6 = { type: "binary", operator: (/* @__PURE__ */ new Map([["<", "<"], ["<=", "<="], [">", ">"], [">=", ">="], ["==", "=="], ["!=", "!="]])).get(n23.value) ?? "==", left: t6, right: i10 };
        }
        return t6;
      }
      canStartExpression() {
        return this.match(r6.NUMBER, r6.STRING, r6.IDENT, r6.DOLLAR, r6.LPAREN, r6.NOT, r6.MINUS, r6.PLUS, r6.INCREMENT, r6.DECREMENT);
      }
      isConcatTerminator() {
        return this.match(r6.AND, r6.OR, r6.QUESTION, r6.ASSIGN, r6.PLUS_ASSIGN, r6.MINUS_ASSIGN, r6.STAR_ASSIGN, r6.SLASH_ASSIGN, r6.PERCENT_ASSIGN, r6.CARET_ASSIGN, r6.COMMA, r6.SEMICOLON, r6.NEWLINE, r6.RBRACE, r6.RPAREN, r6.RBRACKET, r6.COLON, r6.PIPE, r6.APPEND, r6.IN);
      }
      parseAddSub() {
        let t6 = this.parseMulDiv();
        for (; this.match(r6.PLUS, r6.MINUS); ) {
          let n23 = this.advance().value, i10 = this.parseMulDiv();
          t6 = { type: "binary", operator: n23, left: t6, right: i10 };
        }
        return t6;
      }
      parseMulDiv() {
        let t6 = this.parseUnary();
        for (; this.match(r6.STAR, r6.SLASH, r6.PERCENT); ) {
          let n23 = this.advance(), i10 = this.parseUnary();
          t6 = { type: "binary", operator: (/* @__PURE__ */ new Map([["*", "*"], ["/", "/"], ["%", "%"]])).get(n23.value) ?? "*", left: t6, right: i10 };
        }
        return t6;
      }
      parseUnary() {
        if (this.check(r6.INCREMENT)) {
          this.advance();
          let t6 = this.parseUnary();
          return t6.type !== "variable" && t6.type !== "field" && t6.type !== "array_access" ? { type: "unary", operator: "+", operand: { type: "unary", operator: "+", operand: t6 } } : { type: "pre_increment", operand: t6 };
        }
        if (this.check(r6.DECREMENT)) {
          this.advance();
          let t6 = this.parseUnary();
          return t6.type !== "variable" && t6.type !== "field" && t6.type !== "array_access" ? { type: "unary", operator: "-", operand: { type: "unary", operator: "-", operand: t6 } } : { type: "pre_decrement", operand: t6 };
        }
        if (this.match(r6.NOT, r6.MINUS, r6.PLUS)) {
          let t6 = this.advance().value, n23 = this.parseUnary();
          return { type: "unary", operator: t6, operand: n23 };
        }
        return this.parsePower();
      }
      parsePower() {
        let t6 = this.parsePostfix();
        if (this.check(r6.CARET)) {
          this.advance();
          let n23 = this.parsePower();
          t6 = { type: "binary", operator: "^", left: t6, right: n23 };
        }
        return t6;
      }
      parsePostfix() {
        let t6 = this.parsePrimary();
        if (this.check(r6.INCREMENT)) {
          if (this.advance(), t6.type !== "variable" && t6.type !== "field" && t6.type !== "array_access") throw new Error("Invalid increment operand");
          return { type: "post_increment", operand: t6 };
        }
        if (this.check(r6.DECREMENT)) {
          if (this.advance(), t6.type !== "variable" && t6.type !== "field" && t6.type !== "array_access") throw new Error("Invalid decrement operand");
          return { type: "post_decrement", operand: t6 };
        }
        return t6;
      }
      parseFieldIndex() {
        if (this.check(r6.INCREMENT)) {
          this.advance();
          let t6 = this.parseFieldIndex();
          return t6.type !== "variable" && t6.type !== "field" && t6.type !== "array_access" ? { type: "unary", operator: "+", operand: { type: "unary", operator: "+", operand: t6 } } : { type: "pre_increment", operand: t6 };
        }
        if (this.check(r6.DECREMENT)) {
          this.advance();
          let t6 = this.parseFieldIndex();
          return t6.type !== "variable" && t6.type !== "field" && t6.type !== "array_access" ? { type: "unary", operator: "-", operand: { type: "unary", operator: "-", operand: t6 } } : { type: "pre_decrement", operand: t6 };
        }
        if (this.match(r6.NOT, r6.MINUS, r6.PLUS)) {
          let t6 = this.advance().value, n23 = this.parseFieldIndex();
          return { type: "unary", operator: t6, operand: n23 };
        }
        return this.parseFieldIndexPower();
      }
      parseFieldIndexPower() {
        let t6 = this.parseFieldIndexPrimary();
        if (this.check(r6.CARET)) {
          this.advance();
          let n23 = this.parseFieldIndexPower();
          t6 = { type: "binary", operator: "^", left: t6, right: n23 };
        }
        return t6;
      }
      parseFieldIndexPrimary() {
        if (this.check(r6.NUMBER)) return { type: "number", value: this.advance().value };
        if (this.check(r6.STRING)) return { type: "string", value: this.advance().value };
        if (this.check(r6.DOLLAR)) return this.advance(), { type: "field", index: this.parseFieldIndex() };
        if (this.check(r6.LPAREN)) {
          this.advance();
          let t6 = this.parseExpression();
          return this.expect(r6.RPAREN), t6;
        }
        if (this.check(r6.IDENT)) {
          let t6 = this.advance().value;
          if (this.check(r6.LPAREN)) {
            this.advance();
            let n23 = [];
            if (!this.check(r6.RPAREN)) for (n23.push(this.parseExpression()); this.check(r6.COMMA); ) this.advance(), n23.push(this.parseExpression());
            return this.expect(r6.RPAREN), { type: "call", name: t6, args: n23 };
          }
          if (this.check(r6.LBRACKET)) {
            this.advance();
            let n23 = this.parseExpression();
            if (this.check(r6.COMMA)) {
              let i10 = [n23];
              for (; this.check(r6.COMMA); ) this.advance(), i10.push(this.parseExpression());
              this.expect(r6.RBRACKET);
              let a7 = i10.reduce((s9, o9) => ({ type: "binary", operator: " ", left: { type: "binary", operator: " ", left: s9, right: { type: "variable", name: "SUBSEP" } }, right: o9 }));
              return { type: "array_access", array: t6, key: a7 };
            }
            return this.expect(r6.RBRACKET), { type: "array_access", array: t6, key: n23 };
          }
          return { type: "variable", name: t6 };
        }
        throw new Error(`Unexpected token in field index: ${this.current().type} at line ${this.current().line}:${this.current().column}`);
      }
      parsePrimary() {
        if (this.check(r6.NUMBER)) return { type: "number", value: this.advance().value };
        if (this.check(r6.STRING)) return { type: "string", value: this.advance().value };
        if (this.check(r6.REGEX)) return { type: "regex", pattern: this.advance().value };
        if (this.check(r6.DOLLAR)) return this.advance(), { type: "field", index: this.parseFieldIndex() };
        if (this.check(r6.LPAREN)) {
          this.advance();
          let t6 = this.parseExpression();
          if (this.check(r6.COMMA)) {
            let n23 = [t6];
            for (; this.check(r6.COMMA); ) this.advance(), n23.push(this.parseExpression());
            return this.expect(r6.RPAREN), { type: "tuple", elements: n23 };
          }
          return this.expect(r6.RPAREN), t6;
        }
        if (this.check(r6.GETLINE)) {
          this.advance();
          let t6, n23;
          return this.check(r6.IDENT) && (t6 = this.advance().value), this.check(r6.LT) && (this.advance(), n23 = this.parsePrimary()), { type: "getline", variable: t6, file: n23 };
        }
        if (this.check(r6.IDENT)) {
          let t6 = this.advance().value;
          if (this.check(r6.LPAREN)) {
            this.advance();
            let n23 = [];
            if (this.skipNewlines(), !this.check(r6.RPAREN)) for (n23.push(this.parseExpression()); this.check(r6.COMMA); ) this.advance(), this.skipNewlines(), n23.push(this.parseExpression());
            return this.skipNewlines(), this.expect(r6.RPAREN), { type: "call", name: t6, args: n23 };
          }
          if (this.check(r6.LBRACKET)) {
            this.advance();
            let n23 = [this.parseExpression()];
            for (; this.check(r6.COMMA); ) this.advance(), n23.push(this.parseExpression());
            this.expect(r6.RBRACKET);
            let i10;
            if (n23.length === 1) i10 = n23[0];
            else {
              i10 = n23[0];
              for (let a7 = 1; a7 < n23.length; a7++) i10 = { type: "binary", operator: " ", left: { type: "binary", operator: " ", left: i10, right: { type: "variable", name: "SUBSEP" } }, right: n23[a7] };
            }
            return { type: "array_access", array: t6, key: i10 };
          }
          return { type: "variable", name: t6 };
        }
        throw new Error(`Unexpected token: ${this.current().type} at line ${this.current().line}:${this.current().column}`);
      }
    };
    Ft2 = { name: "awk", summary: "pattern scanning and text processing language", usage: "awk [OPTIONS] 'PROGRAM' [FILE...]", options: ["-F FS      use FS as field separator", "-v VAR=VAL assign VAL to variable VAR", "    --help display this help and exit"] };
    On2 = { name: "awk", async execute(e7, t6) {
      if (o2(e7)) return s(Ft2);
      let n23 = new i1(/\s+/), i10 = " ", a7 = /* @__PURE__ */ Object.create(null), s9 = 0;
      for (let l8 = 0; l8 < e7.length; l8++) {
        let p17 = e7[l8];
        if (p17 === "-F" && l8 + 1 < e7.length) i10 = re3(e7[++l8]), n23 = Oe2(i10), s9 = l8 + 1;
        else if (p17.startsWith("-F")) i10 = re3(p17.slice(2)), n23 = Oe2(i10), s9 = l8 + 1;
        else if (p17 === "-v" && l8 + 1 < e7.length) {
          let E13 = e7[++l8], d16 = E13.indexOf("=");
          if (d16 > 0) {
            let R13 = E13.slice(0, d16), b25 = re3(E13.slice(d16 + 1));
            a7[R13] = b25;
          }
          s9 = l8 + 1;
        } else {
          if (p17.startsWith("--")) return r3("awk", p17);
          if (p17.startsWith("-") && p17.length > 1) {
            let E13 = p17[1];
            if (E13 !== "F" && E13 !== "v") return r3("awk", `-${E13}`);
            s9 = l8 + 1;
          } else if (!p17.startsWith("-")) {
            s9 = l8;
            break;
          }
        }
      }
      if (s9 >= e7.length) return { stdout: "", stderr: `awk: missing program
`, exitCode: 1 };
      let o9 = e7[s9], c15 = e7.slice(s9 + 1), u11 = new j3(), N15;
      try {
        N15 = u11.parse(o9);
      } catch (l8) {
        return { stdout: "", stderr: `awk: ${l8 instanceof Error ? l8.message : String(l8)}
`, exitCode: 1 };
      }
      let k17 = { readFile: t6.fs.readFile.bind(t6.fs), writeFile: t6.fs.writeFile.bind(t6.fs), appendFile: async (l8, p17) => {
        try {
          let E13 = await t6.fs.readFile(l8);
          await t6.fs.writeFile(l8, E13 + p17);
        } catch {
          await t6.fs.writeFile(l8, p17);
        }
      }, resolvePath: t6.fs.resolvePath.bind(t6.fs) }, y18 = Q7({ fieldSep: n23, maxIterations: t6.limits?.maxAwkIterations, maxOutputSize: t6.limits?.maxStringLength, fs: k17, cwd: t6.cwd, exec: t6.exec ? (l8) => t6.exec(l8, { cwd: t6.cwd }) : void 0, coverage: t6.coverage });
      y18.FS = i10, y18.vars = Object.assign(/* @__PURE__ */ Object.create(null), a7), y18.ARGC = c15.length + 1, y18.ARGV = /* @__PURE__ */ Object.create(null), y18.ARGV[0] = "awk";
      for (let l8 = 0; l8 < c15.length; l8++) y18.ARGV[String(l8 + 1)] = c15[l8];
      y18.ENVIRON = r(t6.env);
      let w19 = new x8(y18);
      w19.execute(N15);
      let ie8 = N15.rules.some((l8) => l8.pattern?.type !== "begin" && l8.pattern?.type !== "end"), g18 = N15.rules.some((l8) => l8.pattern?.type === "end");
      try {
        if (await w19.executeBegin(), y18.shouldExit) return await w19.executeEnd(), { stdout: w19.getOutput(), stderr: "", exitCode: w19.getExitCode() };
        if (!ie8 && !g18) return { stdout: w19.getOutput(), stderr: "", exitCode: w19.getExitCode() };
        let l8 = [];
        if (c15.length > 0) for (let p17 of c15) try {
          let E13 = t6.fs.resolvePath(t6.cwd, p17), R13 = (await t6.fs.readFile(E13)).split(`
`);
          R13.length > 0 && R13[R13.length - 1] === "" && R13.pop(), l8.push({ filename: p17, lines: R13 });
        } catch {
          return { stdout: "", stderr: `awk: ${p17}: No such file or directory
`, exitCode: 1 };
        }
        else {
          let p17 = t6.stdin.split(`
`);
          p17.length > 0 && p17[p17.length - 1] === "" && p17.pop(), l8.push({ filename: "", lines: p17 });
        }
        for (let p17 of l8) {
          for (y18.FILENAME = p17.filename, y18.FNR = 0, y18.lines = p17.lines, y18.lineIndex = -1, y18.shouldNextFile = false; y18.lineIndex < p17.lines.length - 1 && (y18.lineIndex++, await w19.executeLine(p17.lines[y18.lineIndex]), !(y18.shouldExit || y18.shouldNextFile)); ) ;
          if (y18.shouldExit) break;
        }
        return await w19.executeEnd(), { stdout: w19.getOutput(), stderr: "", exitCode: w19.getExitCode() };
      } catch (l8) {
        let p17 = l8 instanceof Error ? l8.message : String(l8), E13 = l8 instanceof b2 ? b2.EXIT_CODE : 2;
        return { stdout: w19.getOutput(), stderr: `awk: ${p17}
`, exitCode: E13 };
      }
    } };
    bn2 = { name: "awk", flags: [{ flag: "-F", type: "value", valueHint: "delimiter" }, { flag: "-v", type: "value", valueHint: "string" }], stdinType: "text", needsArgs: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/awk2-BDPR2JPZ.js
var awk2_BDPR2JPZ_exports = {};
__export(awk2_BDPR2JPZ_exports, {
  awkCommand2: () => On2,
  flagsForFuzzing: () => bn2
});
var init_awk2_BDPR2JPZ = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/awk2-BDPR2JPZ.js"() {
    init_chunk_3KWUDRIP();
    init_chunk_OJDRYQWQ();
    init_chunk_YNYSPYQ5();
    init_chunk_PSW6BMXW();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-KAEMRWOH.js
function O7(u11) {
  let r8 = u11.trim(), e7 = r8.match(/^([+-]?\d*\.?\d+)\s*([kmgtpeKMGTPE])?[iI]?[bB]?$/);
  if (!e7) {
    let n23 = parseFloat(r8);
    return Number.isNaN(n23) ? 0 : n23;
  }
  let l8 = parseFloat(e7[1]), s9 = (e7[2] || "").toLowerCase(), i10 = A3.get(s9) ?? 1;
  return l8 * i10;
}
function x9(u11) {
  let r8 = u11.trim().toLowerCase().slice(0, 3);
  return P6.get(r8) ?? 0;
}
function D7(u11, r8) {
  let e7 = u11.split(/(\d+)/), l8 = r8.split(/(\d+)/), s9 = Math.max(e7.length, l8.length);
  for (let i10 = 0; i10 < s9; i10++) {
    let n23 = e7[i10] || "", d16 = l8[i10] || "", o9 = /^\d+$/.test(n23) ? parseInt(n23, 10) : null, c15 = /^\d+$/.test(d16) ? parseInt(d16, 10) : null;
    if (o9 !== null && c15 !== null) {
      if (o9 !== c15) return o9 - c15;
    } else if (n23 !== d16) return n23.localeCompare(d16);
  }
  return 0;
}
function M5(u11) {
  return u11.replace(/[^a-zA-Z0-9\s]/g, "");
}
function v9(u11, r8, e7) {
  let l8 = e7 !== null ? e7 : /\s+/, s9 = u11.split(l8), i10 = r8.startField - 1;
  if (i10 >= s9.length) return "";
  if (r8.endField === void 0) {
    let o9 = s9[i10] || "";
    return r8.startChar !== void 0 && (o9 = o9.slice(r8.startChar - 1)), r8.ignoreLeading && (o9 = o9.trimStart()), o9;
  }
  let n23 = Math.min(r8.endField - 1, s9.length - 1), d16 = "";
  for (let o9 = i10; o9 <= n23 && o9 < s9.length; o9++) {
    let c15 = s9[o9] || "";
    if (o9 === i10 && r8.startChar !== void 0 && (c15 = c15.slice(r8.startChar - 1)), o9 === n23 && r8.endChar !== void 0) {
      let t6 = o9 === i10 && r8.startChar !== void 0 ? r8.endChar - r8.startChar + 1 : r8.endChar;
      c15 = c15.slice(0, t6);
    }
    o9 > i10 && (d16 += e7 || " "), d16 += c15;
  }
  return r8.ignoreLeading && (d16 = d16.trimStart()), d16;
}
function L7(u11, r8, e7) {
  let l8 = u11, s9 = r8;
  if (e7.dictionaryOrder && (l8 = M5(l8), s9 = M5(s9)), e7.ignoreCase && (l8 = l8.toLowerCase(), s9 = s9.toLowerCase()), e7.monthSort) {
    let i10 = x9(l8), n23 = x9(s9);
    return i10 - n23;
  }
  if (e7.humanNumeric) {
    let i10 = O7(l8), n23 = O7(s9);
    return i10 - n23;
  }
  if (e7.versionSort) return D7(l8, s9);
  if (e7.numeric) {
    let i10 = parseFloat(l8) || 0, n23 = parseFloat(s9) || 0;
    return i10 - n23;
  }
  return l8.localeCompare(s9);
}
function I8(u11) {
  let { keys: r8, fieldDelimiter: e7, numeric: l8, ignoreCase: s9, reverse: i10, humanNumeric: n23, versionSort: d16, dictionaryOrder: o9, monthSort: c15, ignoreLeadingBlanks: t6, stable: a7 } = u11;
  return (f11, C19) => {
    let g18 = f11, b25 = C19;
    if (t6 && (g18 = g18.trimStart(), b25 = b25.trimStart()), r8.length === 0) {
      let h17 = L7(g18, b25, { numeric: l8, ignoreCase: s9, humanNumeric: n23, versionSort: d16, dictionaryOrder: o9, monthSort: c15 });
      if (h17 !== 0) return i10 ? -h17 : h17;
      if (!a7) {
        let p17 = f11.localeCompare(C19);
        return i10 ? -p17 : p17;
      }
      return 0;
    }
    for (let m25 of r8) {
      let h17 = v9(g18, m25, e7), p17 = v9(b25, m25, e7);
      m25.ignoreLeading && (h17 = h17.trimStart(), p17 = p17.trimStart());
      let B12 = { numeric: m25.numeric ?? l8, ignoreCase: m25.ignoreCase ?? s9, humanNumeric: m25.humanNumeric ?? n23, versionSort: m25.versionSort ?? d16, dictionaryOrder: m25.dictionaryOrder ?? o9, monthSort: m25.monthSort ?? c15 }, V13 = m25.reverse ?? i10, S17 = L7(h17, p17, B12);
      if (S17 !== 0) return V13 ? -S17 : S17;
    }
    if (!a7) {
      let m25 = f11.localeCompare(C19);
      return i10 ? -m25 : m25;
    }
    return 0;
  };
}
function E5(u11, r8) {
  if (r8.keys.length === 0) {
    if (r8.ignoreCase) {
      let s9 = /* @__PURE__ */ new Set();
      return u11.filter((i10) => {
        let n23 = i10.toLowerCase();
        return s9.has(n23) ? false : (s9.add(n23), true);
      });
    }
    return [...new Set(u11)];
  }
  let e7 = r8.keys[0], l8 = /* @__PURE__ */ new Set();
  return u11.filter((s9) => {
    let i10 = v9(s9, e7, r8.fieldDelimiter);
    return (e7.ignoreCase ?? r8.ignoreCase) && (i10 = i10.toLowerCase()), l8.has(i10) ? false : (l8.add(i10), true);
  });
}
function y6(u11) {
  let r8 = { startField: 1 }, e7 = "", l8 = u11, s9 = l8.match(/([bdfhMnrV]+)$/);
  s9 && (e7 = s9[1], l8 = l8.slice(0, -e7.length)), e7.includes("n") && (r8.numeric = true), e7.includes("r") && (r8.reverse = true), e7.includes("f") && (r8.ignoreCase = true), e7.includes("b") && (r8.ignoreLeading = true), e7.includes("h") && (r8.humanNumeric = true), e7.includes("V") && (r8.versionSort = true), e7.includes("d") && (r8.dictionaryOrder = true), e7.includes("M") && (r8.monthSort = true);
  let i10 = l8.split(",");
  if (i10.length === 0 || i10[0] === "") return null;
  let n23 = i10[0].split("."), d16 = parseInt(n23[0], 10);
  if (Number.isNaN(d16) || d16 < 1) return null;
  if (r8.startField = d16, n23.length > 1 && n23[1]) {
    let o9 = parseInt(n23[1], 10);
    !Number.isNaN(o9) && o9 >= 1 && (r8.startChar = o9);
  }
  if (i10.length > 1 && i10[1]) {
    let o9 = i10[1], c15 = o9.match(/([bdfhMnrV]+)$/);
    if (c15) {
      let a7 = c15[1];
      a7.includes("n") && (r8.numeric = true), a7.includes("r") && (r8.reverse = true), a7.includes("f") && (r8.ignoreCase = true), a7.includes("b") && (r8.ignoreLeading = true), a7.includes("h") && (r8.humanNumeric = true), a7.includes("V") && (r8.versionSort = true), a7.includes("d") && (r8.dictionaryOrder = true), a7.includes("M") && (r8.monthSort = true), o9 = o9.slice(0, -a7.length);
    }
    let t6 = o9.split(".");
    if (t6[0]) {
      let a7 = parseInt(t6[0], 10);
      if (!Number.isNaN(a7) && a7 >= 1 && (r8.endField = a7), t6.length > 1 && t6[1]) {
        let f11 = parseInt(t6[1], 10);
        !Number.isNaN(f11) && f11 >= 1 && (r8.endChar = f11);
      }
    }
  }
  return r8;
}
var A3, P6, q9, j4, U7;
var init_chunk_KAEMRWOH = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-KAEMRWOH.js"() {
    init_chunk_7L36YK2X();
    init_chunk_74CEPOFO();
    A3 = /* @__PURE__ */ new Map([["", 1], ["k", 1024], ["m", 1048576], ["g", 1073741824], ["t", 1099511627776], ["p", 1125899906842624], ["e", 1152921504606847e3]]);
    P6 = /* @__PURE__ */ new Map([["jan", 1], ["feb", 2], ["mar", 3], ["apr", 4], ["may", 5], ["jun", 6], ["jul", 7], ["aug", 8], ["sep", 9], ["oct", 10], ["nov", 11], ["dec", 12]]);
    q9 = { name: "sort", summary: "sort lines of text files", usage: "sort [OPTION]... [FILE]...", options: ["-b, --ignore-leading-blanks  ignore leading blanks", "-d, --dictionary-order  consider only blanks and alphanumeric characters", "-f, --ignore-case    fold lower case to upper case characters", "-h, --human-numeric-sort  compare human readable numbers (e.g., 2K 1G)", "-M, --month-sort     compare (unknown) < 'JAN' < ... < 'DEC'", "-n, --numeric-sort   compare according to string numerical value", "-r, --reverse        reverse the result of comparisons", "-V, --version-sort   natural sort of (version) numbers within text", "-c, --check          check for sorted input; do not sort", "-o, --output=FILE    write result to FILE instead of stdout", "-s, --stable         stabilize sort by disabling last-resort comparison", "-u, --unique         output only unique lines", "-k, --key=KEYDEF     sort via a key; KEYDEF gives location and type", "-t, --field-separator=SEP  use SEP as field separator", "    --help           display this help and exit"], description: `KEYDEF is F[.C][OPTS][,F[.C][OPTS]]
  F is a field number (1-indexed)
  C is a character position within the field (1-indexed)
  OPTS can be: b d f h M n r V (per-key modifiers)

Examples:
  -k1        sort by first field
  -k2,2      sort by second field only
  -k1.3      sort by first field starting at 3rd character
  -k1,2n     sort by fields 1-2 numerically
  -k2 -k1    sort by field 2, then by field 1` };
    j4 = { name: "sort", async execute(u11, r8) {
      if (o2(u11)) return s(q9);
      let e7 = { reverse: false, numeric: false, unique: false, ignoreCase: false, humanNumeric: false, versionSort: false, dictionaryOrder: false, monthSort: false, ignoreLeadingBlanks: false, stable: false, checkOnly: false, outputFile: null, keys: [], fieldDelimiter: null }, l8 = [];
      for (let c15 = 0; c15 < u11.length; c15++) {
        let t6 = u11[c15];
        if (t6 === "-r" || t6 === "--reverse") e7.reverse = true;
        else if (t6 === "-n" || t6 === "--numeric-sort") e7.numeric = true;
        else if (t6 === "-u" || t6 === "--unique") e7.unique = true;
        else if (t6 === "-f" || t6 === "--ignore-case") e7.ignoreCase = true;
        else if (t6 === "-h" || t6 === "--human-numeric-sort") e7.humanNumeric = true;
        else if (t6 === "-V" || t6 === "--version-sort") e7.versionSort = true;
        else if (t6 === "-d" || t6 === "--dictionary-order") e7.dictionaryOrder = true;
        else if (t6 === "-M" || t6 === "--month-sort") e7.monthSort = true;
        else if (t6 === "-b" || t6 === "--ignore-leading-blanks") e7.ignoreLeadingBlanks = true;
        else if (t6 === "-s" || t6 === "--stable") e7.stable = true;
        else if (t6 === "-c" || t6 === "--check") e7.checkOnly = true;
        else if (t6 === "-o" || t6 === "--output") e7.outputFile = u11[++c15] || null;
        else if (t6.startsWith("-o")) e7.outputFile = t6.slice(2) || null;
        else if (t6.startsWith("--output=")) e7.outputFile = t6.slice(9) || null;
        else if (t6 === "-t" || t6 === "--field-separator") e7.fieldDelimiter = u11[++c15] || null;
        else if (t6.startsWith("-t")) e7.fieldDelimiter = t6.slice(2) || null;
        else if (t6.startsWith("--field-separator=")) e7.fieldDelimiter = t6.slice(18) || null;
        else if (t6 === "-k" || t6 === "--key") {
          let a7 = u11[++c15];
          if (a7) {
            let f11 = y6(a7);
            f11 && e7.keys.push(f11);
          }
        } else if (t6.startsWith("-k")) {
          let a7 = y6(t6.slice(2));
          a7 && e7.keys.push(a7);
        } else if (t6.startsWith("--key=")) {
          let a7 = y6(t6.slice(6));
          a7 && e7.keys.push(a7);
        } else {
          if (t6.startsWith("--")) return r3("sort", t6);
          if (t6.startsWith("-") && !t6.startsWith("--")) {
            let a7 = false;
            for (let f11 of t6.slice(1)) if (f11 === "r") e7.reverse = true;
            else if (f11 === "n") e7.numeric = true;
            else if (f11 === "u") e7.unique = true;
            else if (f11 === "f") e7.ignoreCase = true;
            else if (f11 === "h") e7.humanNumeric = true;
            else if (f11 === "V") e7.versionSort = true;
            else if (f11 === "d") e7.dictionaryOrder = true;
            else if (f11 === "M") e7.monthSort = true;
            else if (f11 === "b") e7.ignoreLeadingBlanks = true;
            else if (f11 === "s") e7.stable = true;
            else if (f11 === "c") e7.checkOnly = true;
            else {
              a7 = true;
              break;
            }
            if (a7) return r3("sort", t6);
          } else l8.push(t6);
        }
      }
      let s9 = await b3(r8, l8, { cmdName: "sort" });
      if (!s9.ok) return s9.error;
      let n23 = s9.content.split(`
`);
      n23.length > 0 && n23[n23.length - 1] === "" && n23.pop();
      let d16 = I8(e7);
      if (e7.checkOnly) {
        let c15 = l8.length > 0 ? l8[0] : "-";
        for (let t6 = 1; t6 < n23.length; t6++) if (d16(n23[t6 - 1], n23[t6]) > 0) return { stdout: "", stderr: `sort: ${c15}:${t6 + 1}: disorder: ${n23[t6]}
`, exitCode: 1 };
        return { stdout: "", stderr: "", exitCode: 0 };
      }
      n23.sort(d16), e7.unique && (n23 = E5(n23, e7));
      let o9 = n23.length > 0 ? `${n23.join(`
`)}
` : "";
      if (e7.outputFile) {
        let c15 = r8.fs.resolvePath(r8.cwd, e7.outputFile);
        return await r8.fs.writeFile(c15, o9), { stdout: "", stderr: "", exitCode: 0 };
      }
      return { stdout: o9, stderr: "", exitCode: 0 };
    } };
    U7 = { name: "sort", flags: [{ flag: "-r", type: "boolean" }, { flag: "-n", type: "boolean" }, { flag: "-u", type: "boolean" }, { flag: "-f", type: "boolean" }, { flag: "-h", type: "boolean" }, { flag: "-V", type: "boolean" }, { flag: "-d", type: "boolean" }, { flag: "-M", type: "boolean" }, { flag: "-b", type: "boolean" }, { flag: "-s", type: "boolean" }, { flag: "-c", type: "boolean" }, { flag: "-k", type: "value", valueHint: "string" }, { flag: "-t", type: "value", valueHint: "delimiter" }, { flag: "-o", type: "value", valueHint: "path" }], stdinType: "text", needsFiles: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/sort-T7TNLWXL.js
var sort_T7TNLWXL_exports = {};
__export(sort_T7TNLWXL_exports, {
  flagsForFuzzing: () => U7,
  sortCommand: () => j4
});
var init_sort_T7TNLWXL = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/sort-T7TNLWXL.js"() {
    init_chunk_KAEMRWOH();
    init_chunk_7L36YK2X();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-7C6RBHP3.js
var O8, w6, N5, P7;
var init_chunk_7C6RBHP3 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-7C6RBHP3.js"() {
    init_chunk_7L36YK2X();
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    O8 = { name: "uniq", summary: "report or omit repeated lines", usage: "uniq [OPTION]... [INPUT [OUTPUT]]", options: ["-c, --count        prefix lines by the number of occurrences", "-d, --repeated     only print duplicate lines", "-i, --ignore-case  ignore case when comparing", "-u, --unique       only print unique lines", "    --help         display this help and exit"] };
    w6 = { count: { short: "c", long: "count", type: "boolean" }, duplicatesOnly: { short: "d", long: "repeated", type: "boolean" }, uniqueOnly: { short: "u", long: "unique", type: "boolean" }, ignoreCase: { short: "i", long: "ignore-case", type: "boolean" } };
    N5 = { name: "uniq", async execute(c15, m25) {
      if (o2(c15)) return s(O8);
      let o9 = x5("uniq", c15, w6);
      if (!o9.ok) return o9.error;
      let { count: y18, duplicatesOnly: h17, uniqueOnly: q17, ignoreCase: b25 } = o9.result.flags, C19 = o9.result.positional, s9 = await b3(m25, C19, { cmdName: "uniq" });
      if (!s9.ok) return s9.error;
      let n23 = s9.content.split(`
`);
      if (n23.length > 0 && n23[n23.length - 1] === "" && n23.pop(), n23.length === 0) return { stdout: "", stderr: "", exitCode: 0 };
      let t6 = [], r8 = n23[0], i10 = 1, x23 = (e7, l8) => b25 ? e7.toLowerCase() === l8.toLowerCase() : e7 === l8;
      for (let e7 = 1; e7 < n23.length; e7++) x23(n23[e7], r8) ? i10++ : (t6.push({ line: r8, count: i10 }), r8 = n23[e7], i10 = 1);
      t6.push({ line: r8, count: i10 });
      let u11 = t6;
      h17 ? u11 = t6.filter((e7) => e7.count > 1) : q17 && (u11 = t6.filter((e7) => e7.count === 1));
      let a7 = "";
      for (let { line: e7, count: l8 } of u11) y18 ? a7 += `${String(l8).padStart(4)} ${e7}
` : a7 += `${e7}
`;
      return { stdout: a7, stderr: "", exitCode: 0 };
    } };
    P7 = { name: "uniq", flags: [{ flag: "-c", type: "boolean" }, { flag: "-d", type: "boolean" }, { flag: "-u", type: "boolean" }, { flag: "-i", type: "boolean" }], stdinType: "text", needsFiles: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/uniq-ZXE4O5XB.js
var uniq_ZXE4O5XB_exports = {};
__export(uniq_ZXE4O5XB_exports, {
  flagsForFuzzing: () => P7,
  uniqCommand: () => N5
});
var init_uniq_ZXE4O5XB = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/uniq-ZXE4O5XB.js"() {
    init_chunk_7C6RBHP3();
    init_chunk_7L36YK2X();
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-Z7JVV2SM.js
var x10, C7, I9;
var init_chunk_Z7JVV2SM = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-Z7JVV2SM.js"() {
    init_chunk_74CEPOFO();
    x10 = { name: "comm", summary: "compare two sorted files line by line", usage: "comm [OPTION]... FILE1 FILE2", options: ["-1             suppress column 1 (lines unique to FILE1)", "-2             suppress column 2 (lines unique to FILE2)", "-3             suppress column 3 (lines that appear in both files)", "    --help     display this help and exit"] };
    C7 = { name: "comm", async execute(p17, a7) {
      if (o2(p17)) return s(x10);
      let r8 = false, l8 = false, f11 = false, i10 = [];
      for (let e7 of p17) if (e7 === "-1") r8 = true;
      else if (e7 === "-2") l8 = true;
      else if (e7 === "-3") f11 = true;
      else if (e7 === "-12" || e7 === "-21") r8 = true, l8 = true;
      else if (e7 === "-13" || e7 === "-31") r8 = true, f11 = true;
      else if (e7 === "-23" || e7 === "-32") l8 = true, f11 = true;
      else if (e7 === "-123" || e7 === "-132" || e7 === "-213" || e7 === "-231" || e7 === "-312" || e7 === "-321") r8 = true, l8 = true, f11 = true;
      else {
        if (e7.startsWith("-") && e7 !== "-") return r3("comm", e7);
        i10.push(e7);
      }
      if (i10.length !== 2) return { stdout: "", stderr: `comm: missing operand
Try 'comm --help' for more information.
`, exitCode: 1 };
      let c15 = async (e7) => {
        if (e7 === "-") return a7.stdin;
        try {
          let w19 = a7.fs.resolvePath(a7.cwd, e7);
          return await a7.fs.readFile(w19);
        } catch {
          return null;
        }
      }, m25 = await c15(i10[0]);
      if (m25 === null) return { stdout: "", stderr: `comm: ${i10[0]}: No such file or directory
`, exitCode: 1 };
      let h17 = await c15(i10[1]);
      if (h17 === null) return { stdout: "", stderr: `comm: ${i10[1]}: No such file or directory
`, exitCode: 1 };
      let t6 = m25.split(`
`), s9 = h17.split(`
`);
      t6.length > 0 && t6[t6.length - 1] === "" && t6.pop(), s9.length > 0 && s9[s9.length - 1] === "" && s9.pop();
      let n23 = 0, o9 = 0, u11 = "", d16 = r8 ? "" : "	", F21 = (r8 ? "" : "	") + (l8 ? "" : "	");
      for (; n23 < t6.length || o9 < s9.length; ) n23 >= t6.length ? (l8 || (u11 += `${d16}${s9[o9]}
`), o9++) : o9 >= s9.length ? (r8 || (u11 += `${t6[n23]}
`), n23++) : t6[n23] < s9[o9] ? (r8 || (u11 += `${t6[n23]}
`), n23++) : t6[n23] > s9[o9] ? (l8 || (u11 += `${d16}${s9[o9]}
`), o9++) : (f11 || (u11 += `${F21}${t6[n23]}
`), n23++, o9++);
      return { stdout: u11, stderr: "", exitCode: 0 };
    } };
    I9 = { name: "comm", flags: [{ flag: "-1", type: "boolean" }, { flag: "-2", type: "boolean" }, { flag: "-3", type: "boolean" }], needsArgs: true, minArgs: 2 };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/comm-5SLSESQG.js
var comm_5SLSESQG_exports = {};
__export(comm_5SLSESQG_exports, {
  commCommand: () => C7,
  flagsForFuzzing: () => I9
});
var init_comm_5SLSESQG = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/comm-5SLSESQG.js"() {
    init_chunk_Z7JVV2SM();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-6NY2AP72.js
function F7(t6) {
  let c15 = [], l8 = t6.split(",");
  for (let n23 of l8) if (n23.includes("-")) {
    let [s9, r8] = n23.split("-");
    c15.push({ start: s9 ? parseInt(s9, 10) : 1, end: r8 ? parseInt(r8, 10) : null });
  } else {
    let s9 = parseInt(n23, 10);
    c15.push({ start: s9, end: s9 });
  }
  return c15;
}
function L8(t6, c15) {
  let l8 = [];
  for (let n23 of c15) {
    let s9 = n23.start - 1, r8 = n23.end === null ? t6.length : n23.end;
    for (let o9 = s9; o9 < r8 && o9 < t6.length; o9++) o9 >= 0 && !l8.includes(t6[o9]) && l8.push(t6[o9]);
  }
  return l8;
}
var w7, C8, S5;
var init_chunk_6NY2AP72 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-6NY2AP72.js"() {
    init_chunk_7L36YK2X();
    init_chunk_74CEPOFO();
    w7 = { name: "cut", summary: "remove sections from each line of files", usage: "cut [OPTION]... [FILE]...", options: ["-c LIST              select only these characters", "-d DELIM             use DELIM instead of TAB for field delimiter", "-f LIST              select only these fields", "-s, --only-delimited  do not print lines without delimiters", "    --help           display this help and exit"] };
    C8 = { name: "cut", async execute(t6, c15) {
      if (o2(t6)) return s(w7);
      let l8 = "	", n23 = null, s9 = null, r8 = false, o9 = [];
      for (let i10 = 0; i10 < t6.length; i10++) {
        let e7 = t6[i10];
        if (e7 === "-d") l8 = t6[++i10] || "	";
        else if (e7.startsWith("-d")) l8 = e7.slice(2);
        else if (e7 === "-f") n23 = t6[++i10];
        else if (e7.startsWith("-f")) n23 = e7.slice(2);
        else if (e7 === "-c") s9 = t6[++i10];
        else if (e7.startsWith("-c")) s9 = e7.slice(2);
        else if (e7 === "-s" || e7 === "--only-delimited") r8 = true;
        else {
          if (e7.startsWith("--")) return r3("cut", e7);
          if (e7.startsWith("-")) {
            let f11 = false;
            for (let a7 of e7.slice(1)) if (a7 === "s") r8 = true;
            else if (!"dfc".includes(a7)) {
              f11 = true;
              break;
            }
            if (f11) return r3("cut", e7);
          } else o9.push(e7);
        }
      }
      if (!n23 && !s9) return { stdout: "", stderr: `cut: you must specify a list of bytes, characters, or fields
`, exitCode: 1 };
      let p17 = await b3(c15, o9, { cmdName: "cut" });
      if (!p17.ok) return p17.error;
      let u11 = p17.content.split(`
`);
      u11.length > 0 && u11[u11.length - 1] === "" && u11.pop();
      let g18 = F7(n23 || s9 || "1"), h17 = "";
      for (let i10 of u11) if (s9) {
        let e7 = i10.split(""), f11 = [];
        for (let a7 of g18) {
          let v21 = a7.start - 1, H16 = a7.end === null ? e7.length : a7.end;
          for (let d16 = v21; d16 < H16 && d16 < e7.length; d16++) d16 >= 0 && f11.push(e7[d16]);
        }
        h17 += `${f11.join("")}
`;
      } else {
        if (r8 && !i10.includes(l8)) continue;
        let e7 = i10.split(l8), f11 = L8(e7, g18);
        h17 += `${f11.join(l8)}
`;
      }
      return { stdout: h17, stderr: "", exitCode: 0 };
    } };
    S5 = { name: "cut", flags: [{ flag: "-d", type: "value", valueHint: "delimiter" }, { flag: "-f", type: "value", valueHint: "string" }, { flag: "-c", type: "value", valueHint: "string" }, { flag: "-s", type: "boolean" }], stdinType: "text", needsFiles: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/cut-LO6YYY5P.js
var cut_LO6YYY5P_exports = {};
__export(cut_LO6YYY5P_exports, {
  cutCommand: () => C8,
  flagsForFuzzing: () => S5
});
var init_cut_LO6YYY5P = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/cut-LO6YYY5P.js"() {
    init_chunk_6NY2AP72();
    init_chunk_7L36YK2X();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-JVPRLUMK.js
function y7(s9, i10) {
  if (s9.length === 0) return "";
  if (s9.length === 1) return s9[0];
  let n23 = s9[0];
  for (let l8 = 1; l8 < s9.length; l8++) {
    let d16 = (l8 - 1) % i10.length;
    n23 += i10[d16] + s9[l8];
  }
  return n23;
}
var I10, F8, P8, T4;
var init_chunk_JVPRLUMK = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-JVPRLUMK.js"() {
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    I10 = { name: "paste", summary: "merge lines of files", usage: "paste [OPTION]... [FILE]...", description: ["Write lines consisting of the sequentially corresponding lines from", "each FILE, separated by TABs, to standard output.", "", "With no FILE, or when FILE is -, read standard input."], options: ["-d, --delimiters=LIST   reuse characters from LIST instead of TABs", "-s, --serial            paste one file at a time instead of in parallel", "    --help              display this help and exit"], examples: ["paste file1 file2       Merge file1 and file2 side by side", "paste -d, file1 file2   Use comma as delimiter", "paste -s file1          Paste all lines of file1 on one line", "paste - - < file        Paste pairs of lines from file"] };
    F8 = { delimiter: { short: "d", long: "delimiters", type: "string", default: "	" }, serial: { short: "s", long: "serial", type: "boolean" } };
    P8 = { name: "paste", async execute(s9, i10) {
      if (o2(s9)) return s(I10);
      let n23 = x5("paste", s9, F8);
      if (!n23.ok) return n23.error;
      let l8 = n23.result.flags.delimiter, d16 = n23.result.flags.serial, p17 = n23.result.positional;
      if (p17.length === 0) return { stdout: "", stderr: `usage: paste [-s] [-d delimiters] file ...
`, exitCode: 1 };
      let a7 = i10.stdin ? i10.stdin.split(`
`) : [""];
      a7.length > 0 && a7[a7.length - 1] === "" && a7.pop();
      let x23 = p17.filter((e7) => e7 === "-").length, f11 = [], h17 = 0;
      for (let e7 of p17) if (e7 === "-") {
        let t6 = [];
        for (let o9 = h17; o9 < a7.length; o9 += x23) t6.push(a7[o9]);
        f11.push(t6), h17++;
      } else {
        let t6 = i10.fs.resolvePath(i10.cwd, e7);
        try {
          let r8 = (await i10.fs.readFile(t6)).split(`
`);
          r8.length > 0 && r8[r8.length - 1] === "" && r8.pop(), f11.push(r8);
        } catch {
          return { stdout: "", stderr: `paste: ${e7}: No such file or directory
`, exitCode: 1 };
        }
      }
      let u11 = "";
      if (d16) for (let e7 of f11) e7 && (u11 += `${y7(e7, l8)}
`);
      else {
        let e7 = Math.max(...f11.map((t6) => t6?.length ?? 0));
        for (let t6 = 0; t6 < e7; t6++) {
          let o9 = [];
          for (let r8 of f11) o9.push(r8?.[t6] ?? "");
          u11 += `${y7(o9, l8)}
`;
        }
      }
      return { stdout: u11, stderr: "", exitCode: 0 };
    } };
    T4 = { name: "paste", flags: [{ flag: "-d", type: "value", valueHint: "delimiter" }, { flag: "-s", type: "boolean" }], stdinType: "text", needsFiles: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/paste-7N6AFSDS.js
var paste_7N6AFSDS_exports = {};
__export(paste_7N6AFSDS_exports, {
  flagsForFuzzing: () => T4,
  pasteCommand: () => P8
});
var init_paste_7N6AFSDS = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/paste-7N6AFSDS.js"() {
    init_chunk_JVPRLUMK();
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-X6JMGGW2.js
function S6(r8) {
  let n23 = "", e7 = 0;
  for (; e7 < r8.length; ) {
    if (r8[e7] === "[" && r8[e7 + 1] === ":") {
      let l8 = false;
      for (let [i10, a7] of x11) if (r8.slice(e7).startsWith(i10)) {
        n23 += a7, e7 += i10.length, l8 = true;
        break;
      }
      if (l8) continue;
    }
    if (r8[e7] === "\\" && e7 + 1 < r8.length) {
      let l8 = r8[e7 + 1];
      l8 === "n" ? n23 += `
` : l8 === "t" ? n23 += "	" : l8 === "r" ? n23 += "\r" : n23 += l8, e7 += 2;
      continue;
    }
    if (e7 + 2 < r8.length && r8[e7 + 1] === "-") {
      let l8 = r8.charCodeAt(e7), i10 = r8.charCodeAt(e7 + 2);
      for (let a7 = l8; a7 <= i10; a7++) n23 += String.fromCharCode(a7);
      e7 += 3;
      continue;
    }
    n23 += r8[e7], e7++;
  }
  return n23;
}
var y8, x11, b10, A4, q10;
var init_chunk_X6JMGGW2 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-X6JMGGW2.js"() {
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    y8 = { name: "tr", summary: "translate or delete characters", usage: "tr [OPTION]... SET1 [SET2]", options: ["-c, -C, --complement   use the complement of SET1", "-d, --delete           delete characters in SET1", "-s, --squeeze-repeats  squeeze repeated characters", "    --help             display this help and exit"], description: `SET syntax:
  a-z         character range
  [:alnum:]   all letters and digits
  [:alpha:]   all letters
  [:digit:]   all digits
  [:lower:]   all lowercase letters
  [:upper:]   all uppercase letters
  [:space:]   all whitespace
  [:blank:]   horizontal whitespace
  [:punct:]   all punctuation
  [:print:]   all printable characters
  [:graph:]   all printable characters except space
  [:cntrl:]   all control characters
  [:xdigit:]  all hexadecimal digits
  \\n, \\t, \\r  escape sequences` };
    x11 = /* @__PURE__ */ new Map([["[:alnum:]", "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789"], ["[:alpha:]", "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz"], ["[:blank:]", " 	"], ["[:cntrl:]", Array.from({ length: 32 }, (r8, n23) => String.fromCharCode(n23)).join("").concat("\x7F")], ["[:digit:]", "0123456789"], ["[:graph:]", Array.from({ length: 94 }, (r8, n23) => String.fromCharCode(33 + n23)).join("")], ["[:lower:]", "abcdefghijklmnopqrstuvwxyz"], ["[:print:]", Array.from({ length: 95 }, (r8, n23) => String.fromCharCode(32 + n23)).join("")], ["[:punct:]", "!\"#$%&'()*+,-./:;<=>?@[\\]^_`{|}~"], ["[:space:]", ` 	
\r\f\v`], ["[:upper:]", "ABCDEFGHIJKLMNOPQRSTUVWXYZ"], ["[:xdigit:]", "0123456789ABCDEFabcdef"]]);
    b10 = { complement: { short: "c", long: "complement", type: "boolean" }, complementUpper: { short: "C", type: "boolean" }, delete: { short: "d", long: "delete", type: "boolean" }, squeeze: { short: "s", long: "squeeze-repeats", type: "boolean" } };
    A4 = { name: "tr", async execute(r8, n23) {
      if (o2(r8)) return s(y8);
      let e7 = x5("tr", r8, b10);
      if (!e7.ok) return e7.error;
      let l8 = e7.result.flags.complement || e7.result.flags.complementUpper, i10 = e7.result.flags.delete, a7 = e7.result.flags.squeeze, p17 = e7.result.positional;
      if (p17.length < 1) return { stdout: "", stderr: `tr: missing operand
`, exitCode: 1 };
      if (!i10 && !a7 && p17.length < 2) return { stdout: "", stderr: `tr: missing operand after SET1
`, exitCode: 1 };
      let d16 = S6(p17[0]), s9 = p17.length > 1 ? S6(p17[1]) : "", h17 = n23.stdin, g18 = (o9) => {
        let t6 = d16.includes(o9);
        return l8 ? !t6 : t6;
      }, c15 = "";
      if (i10) for (let o9 of h17) g18(o9) || (c15 += o9);
      else if (a7 && p17.length === 1) {
        let o9 = "";
        for (let t6 of h17) g18(t6) && t6 === o9 || (c15 += t6, o9 = t6);
      } else {
        if (l8) {
          let o9 = s9.length > 0 ? s9[s9.length - 1] : "";
          for (let t6 of h17) d16.includes(t6) ? c15 += t6 : c15 += o9;
        } else {
          let o9 = /* @__PURE__ */ new Map();
          for (let t6 = 0; t6 < d16.length; t6++) {
            let f11 = t6 < s9.length ? s9[t6] : s9[s9.length - 1];
            o9.set(d16[t6], f11);
          }
          for (let t6 of h17) c15 += o9.get(t6) ?? t6;
        }
        if (a7) {
          let o9 = "", t6 = "";
          for (let f11 of c15) s9.includes(f11) && f11 === t6 || (o9 += f11, t6 = f11);
          c15 = o9;
        }
      }
      return { stdout: c15, stderr: "", exitCode: 0 };
    } };
    q10 = { name: "tr", flags: [{ flag: "-c", type: "boolean" }, { flag: "-C", type: "boolean" }, { flag: "-d", type: "boolean" }, { flag: "-s", type: "boolean" }], stdinType: "text", needsArgs: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/tr-RYO2EDCA.js
var tr_RYO2EDCA_exports = {};
__export(tr_RYO2EDCA_exports, {
  flagsForFuzzing: () => q10,
  trCommand: () => A4
});
var init_tr_RYO2EDCA = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/tr-RYO2EDCA.js"() {
    init_chunk_X6JMGGW2();
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-QCDB2VPH.js
function d7(t6) {
  return Array.from(t6).reverse().join("");
}
var u3, v10, m9;
var init_chunk_QCDB2VPH = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-QCDB2VPH.js"() {
    init_chunk_74CEPOFO();
    u3 = { name: "rev", summary: "reverse lines characterwise", usage: "rev [file ...]", description: "Copies the specified files to standard output, reversing the order of characters in every line. If no files are specified, standard input is read.", examples: ["echo 'hello' | rev     # Output: olleh", "rev file.txt           # Reverse each line in file"] };
    v10 = { name: "rev", execute: async (t6, s9) => {
      if (o2(t6)) return s(u3);
      let o9 = [];
      for (let e7 of t6) if (e7 === "--") {
        let r8 = t6.indexOf(e7);
        o9.push(...t6.slice(r8 + 1));
        break;
      } else {
        if (e7.startsWith("-") && e7 !== "-") return r3("rev", e7);
        o9.push(e7);
      }
      let n23 = "", l8 = (e7) => {
        let r8 = e7.split(`
`), i10 = e7.endsWith(`
`) && r8[r8.length - 1] === "";
        return i10 && r8.pop(), r8.map(d7).join(`
`) + (i10 ? `
` : "");
      };
      if (o9.length === 0) {
        let e7 = s9.stdin ?? "";
        n23 = l8(e7);
      } else for (let e7 of o9) if (e7 === "-") {
        let r8 = s9.stdin ?? "";
        n23 += l8(r8);
      } else {
        let r8 = s9.fs.resolvePath(s9.cwd, e7), i10 = await s9.fs.readFile(r8);
        if (i10 === null) return { exitCode: 1, stdout: n23, stderr: `rev: ${e7}: No such file or directory
` };
        n23 += l8(i10);
      }
      return { exitCode: 0, stdout: n23, stderr: "" };
    } };
    m9 = { name: "rev", flags: [], stdinType: "text", needsFiles: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/rev-XOSYPP45.js
var rev_XOSYPP45_exports = {};
__export(rev_XOSYPP45_exports, {
  flagsForFuzzing: () => m9,
  rev: () => v10
});
var init_rev_XOSYPP45 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/rev-XOSYPP45.js"() {
    init_chunk_QCDB2VPH();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-F23WWYKW.js
function p6(r8, s9, i10) {
  let l8 = String(r8);
  switch (s9) {
    case "ln":
      return l8.padEnd(i10);
    case "rn":
      return l8.padStart(i10);
    case "rz":
      return l8.padStart(i10, "0");
    default:
      return s9;
  }
}
function N6(r8, s9) {
  switch (s9) {
    case "a":
      return true;
    case "t":
      return r8.trim().length > 0;
    case "n":
      return false;
    default:
      return s9;
  }
}
function b11(r8, s9, i10) {
  if (r8 === "") return { output: "", nextNumber: i10 };
  let l8 = r8.split(`
`), t6 = [], u11 = i10, a7 = r8.endsWith(`
`) && l8[l8.length - 1] === "";
  a7 && l8.pop();
  for (let n23 of l8) if (N6(n23, s9.bodyStyle)) {
    let e7 = p6(u11, s9.numberFormat, s9.width);
    t6.push(`${e7}${s9.separator}${n23}`), u11 += s9.increment;
  } else {
    let e7 = " ".repeat(s9.width);
    t6.push(`${e7}${s9.separator}${n23}`);
  }
  return { output: t6.join(`
`) + (a7 ? `
` : ""), nextNumber: u11 };
}
var h8, y9, x12;
var init_chunk_F23WWYKW = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-F23WWYKW.js"() {
    init_chunk_74CEPOFO();
    h8 = { name: "nl", summary: "number lines of files", usage: "nl [OPTION]... [FILE]...", description: "Write each FILE to standard output, with line numbers added. If no FILE is specified, standard input is read.", options: ["-b STYLE     Body numbering style: a (all), t (non-empty), n (none)", "-n FORMAT    Number format: ln (left), rn (right), rz (right zeros)", "-w WIDTH     Number width (default: 6)", "-s SEP       Separator after number (default: TAB)", "-v START     Starting line number (default: 1)", "-i INCR      Line number increment (default: 1)"], examples: ["nl file.txt              # Number non-empty lines", "nl -ba file.txt          # Number all lines", "nl -n rz -w 3 file.txt   # Right-justified with zeros", "nl -s ': ' file.txt      # Use ': ' as separator"] };
    y9 = { name: "nl", execute: async (r8, s9) => {
      if (o2(r8)) return s(h8);
      let i10 = { bodyStyle: "t", numberFormat: "rn", width: 6, separator: "	", startNumber: 1, increment: 1 }, l8 = [], t6 = 0;
      for (; t6 < r8.length; ) {
        let n23 = r8[t6];
        if (n23 === "-b" && t6 + 1 < r8.length) {
          let e7 = r8[t6 + 1];
          if (e7 !== "a" && e7 !== "t" && e7 !== "n") return { exitCode: 1, stdout: "", stderr: `nl: invalid body numbering style: '${e7}'
` };
          i10.bodyStyle = e7, t6 += 2;
        } else if (n23.startsWith("-b")) {
          let e7 = n23.slice(2);
          if (e7 !== "a" && e7 !== "t" && e7 !== "n") return { exitCode: 1, stdout: "", stderr: `nl: invalid body numbering style: '${e7}'
` };
          i10.bodyStyle = e7, t6++;
        } else if (n23 === "-n" && t6 + 1 < r8.length) {
          let e7 = r8[t6 + 1];
          if (e7 !== "ln" && e7 !== "rn" && e7 !== "rz") return { exitCode: 1, stdout: "", stderr: `nl: invalid line numbering format: '${e7}'
` };
          i10.numberFormat = e7, t6 += 2;
        } else if (n23.startsWith("-n")) {
          let e7 = n23.slice(2);
          if (e7 !== "ln" && e7 !== "rn" && e7 !== "rz") return { exitCode: 1, stdout: "", stderr: `nl: invalid line numbering format: '${e7}'
` };
          i10.numberFormat = e7, t6++;
        } else if (n23 === "-w" && t6 + 1 < r8.length) {
          let e7 = parseInt(r8[t6 + 1], 10);
          if (Number.isNaN(e7) || e7 < 1) return { exitCode: 1, stdout: "", stderr: `nl: invalid line number field width: '${r8[t6 + 1]}'
` };
          i10.width = e7, t6 += 2;
        } else if (n23.startsWith("-w")) {
          let e7 = parseInt(n23.slice(2), 10);
          if (Number.isNaN(e7) || e7 < 1) return { exitCode: 1, stdout: "", stderr: `nl: invalid line number field width: '${n23.slice(2)}'
` };
          i10.width = e7, t6++;
        } else if (n23 === "-s" && t6 + 1 < r8.length) i10.separator = r8[t6 + 1], t6 += 2;
        else if (n23.startsWith("-s")) i10.separator = n23.slice(2), t6++;
        else if (n23 === "-v" && t6 + 1 < r8.length) {
          let e7 = parseInt(r8[t6 + 1], 10);
          if (Number.isNaN(e7)) return { exitCode: 1, stdout: "", stderr: `nl: invalid starting line number: '${r8[t6 + 1]}'
` };
          i10.startNumber = e7, t6 += 2;
        } else if (n23.startsWith("-v")) {
          let e7 = parseInt(n23.slice(2), 10);
          if (Number.isNaN(e7)) return { exitCode: 1, stdout: "", stderr: `nl: invalid starting line number: '${n23.slice(2)}'
` };
          i10.startNumber = e7, t6++;
        } else if (n23 === "-i" && t6 + 1 < r8.length) {
          let e7 = parseInt(r8[t6 + 1], 10);
          if (Number.isNaN(e7)) return { exitCode: 1, stdout: "", stderr: `nl: invalid line number increment: '${r8[t6 + 1]}'
` };
          i10.increment = e7, t6 += 2;
        } else if (n23.startsWith("-i")) {
          let e7 = parseInt(n23.slice(2), 10);
          if (Number.isNaN(e7)) return { exitCode: 1, stdout: "", stderr: `nl: invalid line number increment: '${n23.slice(2)}'
` };
          i10.increment = e7, t6++;
        } else if (n23 === "--") {
          l8.push(...r8.slice(t6 + 1));
          break;
        } else {
          if (n23.startsWith("-") && n23 !== "-") return r3("nl", n23);
          l8.push(n23), t6++;
        }
      }
      let u11 = "", a7 = i10.startNumber;
      if (l8.length === 0) {
        let n23 = s9.stdin ?? "";
        u11 = b11(n23, i10, a7).output;
      } else for (let n23 of l8) {
        let e7 = s9.fs.resolvePath(s9.cwd, n23), o9 = await s9.fs.readFile(e7);
        if (o9 === null) return { exitCode: 1, stdout: u11, stderr: `nl: ${n23}: No such file or directory
` };
        let d16 = b11(o9, i10, a7);
        u11 += d16.output, a7 = d16.nextNumber;
      }
      return { exitCode: 0, stdout: u11, stderr: "" };
    } };
    x12 = { name: "nl", flags: [{ flag: "-b", type: "value", valueHint: "string" }, { flag: "-n", type: "value", valueHint: "string" }, { flag: "-w", type: "value", valueHint: "number" }, { flag: "-s", type: "value", valueHint: "string" }, { flag: "-v", type: "value", valueHint: "number" }, { flag: "-i", type: "value", valueHint: "number" }], stdinType: "text", needsFiles: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/nl-U5YJDM32.js
var nl_U5YJDM32_exports = {};
__export(nl_U5YJDM32_exports, {
  flagsForFuzzing: () => x12,
  nl: () => y9
});
var init_nl_U5YJDM32 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/nl-U5YJDM32.js"() {
    init_chunk_F23WWYKW();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-D4J545R4.js
function g9(s9, r8, n23) {
  return n23 ? new TextEncoder().encode(s9).length : s9 === "	" ? 8 - r8 % 8 : s9 === "\b" ? -1 : 1;
}
function y10(s9, r8) {
  if (s9.length === 0) return s9;
  let { width: n23, breakAtSpaces: u11, countBytes: i10 } = r8, l8 = [], e7 = "", t6 = 0, o9 = -1, f11 = 0;
  for (let c15 = 0; c15 < s9.length; c15++) {
    let a7 = s9[c15], d16 = g9(a7, t6, i10);
    t6 + d16 > n23 && e7.length > 0 ? u11 && o9 >= 0 ? (l8.push(e7.slice(0, o9 + 1)), e7 = e7.slice(o9 + 1) + a7, t6 = t6 - f11 - 1 + d16, o9 = -1, f11 = 0) : (l8.push(e7), e7 = a7, t6 = d16, o9 = -1, f11 = 0) : (e7 += a7, t6 += d16, (a7 === " " || a7 === "	") && (o9 = e7.length - 1, f11 = t6 - d16));
  }
  return e7.length > 0 && l8.push(e7), l8.join(`
`);
}
function b12(s9, r8) {
  if (s9 === "") return "";
  let n23 = s9.split(`
`), u11 = s9.endsWith(`
`) && n23[n23.length - 1] === "";
  return u11 && n23.pop(), n23.map((l8) => y10(l8, r8)).join(`
`) + (u11 ? `
` : "");
}
var m10, k6, x13;
var init_chunk_D4J545R4 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-D4J545R4.js"() {
    init_chunk_74CEPOFO();
    m10 = { name: "fold", summary: "wrap each input line to fit in specified width", usage: "fold [OPTION]... [FILE]...", description: "Wrap input lines in each FILE, writing to standard output. If no FILE is specified, standard input is read.", options: ["-w WIDTH    Use WIDTH columns instead of 80", "-s          Break at spaces", "-b          Count bytes rather than columns"], examples: ["fold -w 40 file.txt           # Wrap at 40 columns", "fold -sw 40 file.txt          # Word wrap at 40 columns", "echo 'long line' | fold -w 5  # Force wrap at 5"] };
    k6 = { name: "fold", execute: async (s9, r8) => {
      if (o2(s9)) return s(m10);
      let n23 = { width: 80, breakAtSpaces: false, countBytes: false }, u11 = [], i10 = 0;
      for (; i10 < s9.length; ) {
        let e7 = s9[i10];
        if (e7 === "-w" && i10 + 1 < s9.length) {
          let t6 = parseInt(s9[i10 + 1], 10);
          if (Number.isNaN(t6) || t6 < 1) return { exitCode: 1, stdout: "", stderr: `fold: invalid number of columns: '${s9[i10 + 1]}'
` };
          n23.width = t6, i10 += 2;
        } else if (e7.startsWith("-w") && e7.length > 2) {
          let t6 = parseInt(e7.slice(2), 10);
          if (Number.isNaN(t6) || t6 < 1) return { exitCode: 1, stdout: "", stderr: `fold: invalid number of columns: '${e7.slice(2)}'
` };
          n23.width = t6, i10++;
        } else if (e7 === "-s") n23.breakAtSpaces = true, i10++;
        else if (e7 === "-b") n23.countBytes = true, i10++;
        else if (e7 === "-bs" || e7 === "-sb") n23.breakAtSpaces = true, n23.countBytes = true, i10++;
        else if (e7.match(/^-[sb]+w\d+$/)) {
          e7.includes("s") && (n23.breakAtSpaces = true), e7.includes("b") && (n23.countBytes = true);
          let t6 = e7.replace(/^-[sb]+w/, ""), o9 = parseInt(t6, 10);
          if (Number.isNaN(o9) || o9 < 1) return { exitCode: 1, stdout: "", stderr: `fold: invalid number of columns: '${t6}'
` };
          n23.width = o9, i10++;
        } else if (e7.match(/^-[sb]+w$/) && i10 + 1 < s9.length) {
          e7.includes("s") && (n23.breakAtSpaces = true), e7.includes("b") && (n23.countBytes = true);
          let t6 = parseInt(s9[i10 + 1], 10);
          if (Number.isNaN(t6) || t6 < 1) return { exitCode: 1, stdout: "", stderr: `fold: invalid number of columns: '${s9[i10 + 1]}'
` };
          n23.width = t6, i10 += 2;
        } else if (e7 === "--") {
          u11.push(...s9.slice(i10 + 1));
          break;
        } else if (e7.startsWith("-") && e7 !== "-") {
          let t6 = e7.slice(1), o9 = false;
          for (let f11 of t6) if (f11 === "s") n23.breakAtSpaces = true;
          else if (f11 === "b") n23.countBytes = true;
          else {
            o9 = true;
            break;
          }
          if (o9) return r3("fold", e7);
          i10++;
        } else u11.push(e7), i10++;
      }
      let l8 = "";
      if (u11.length === 0) {
        let e7 = r8.stdin ?? "";
        l8 = b12(e7, n23);
      } else for (let e7 of u11) {
        let t6 = r8.fs.resolvePath(r8.cwd, e7), o9 = await r8.fs.readFile(t6);
        if (o9 === null) return { exitCode: 1, stdout: l8, stderr: `fold: ${e7}: No such file or directory
` };
        l8 += b12(o9, n23);
      }
      return { exitCode: 0, stdout: l8, stderr: "" };
    } };
    x13 = { name: "fold", flags: [{ flag: "-w", type: "value", valueHint: "number" }, { flag: "-s", type: "boolean" }, { flag: "-b", type: "boolean" }], stdinType: "text", needsFiles: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/fold-LDSORVYE.js
var fold_LDSORVYE_exports = {};
__export(fold_LDSORVYE_exports, {
  flagsForFuzzing: () => x13,
  fold: () => k6
});
var init_fold_LDSORVYE = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/fold-LDSORVYE.js"() {
    init_chunk_D4J545R4();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-VJFXDYWH.js
function p7(n23) {
  let i10 = n23.split(",").map((o9) => o9.trim()), t6 = [];
  for (let o9 of i10) {
    let e7 = parseInt(o9, 10);
    if (Number.isNaN(e7) || e7 < 1) return null;
    t6.push(e7);
  }
  for (let o9 = 1; o9 < t6.length; o9++) if (t6[o9] <= t6[o9 - 1]) return null;
  return t6;
}
function x14(n23, i10) {
  if (i10.length === 1) {
    let t6 = i10[0];
    return t6 - n23 % t6;
  }
  for (let t6 of i10) if (t6 > n23) return t6 - n23;
  if (i10.length >= 2) {
    let t6 = i10[i10.length - 1] - i10[i10.length - 2], o9 = i10[i10.length - 1], e7 = Math.floor((n23 - o9) / t6) + 1;
    return o9 + e7 * t6 - n23;
  }
  return 1;
}
function g10(n23, i10) {
  let { tabStops: t6, leadingOnly: o9 } = i10, e7 = "", l8 = 0, s9 = true;
  for (let a7 of n23) if (a7 === "	") if (o9 && !s9) e7 += a7, l8++;
  else {
    let r8 = x14(l8, t6);
    e7 += " ".repeat(r8), l8 += r8;
  }
  else a7 !== " " && a7 !== "	" && (s9 = false), e7 += a7, l8++;
  return e7;
}
function c6(n23, i10) {
  if (n23 === "") return "";
  let t6 = n23.split(`
`), o9 = n23.endsWith(`
`) && t6[t6.length - 1] === "";
  return o9 && t6.pop(), t6.map((l8) => g10(l8, i10)).join(`
`) + (o9 ? `
` : "");
}
var h9, m11, v11;
var init_chunk_VJFXDYWH = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-VJFXDYWH.js"() {
    init_chunk_74CEPOFO();
    h9 = { name: "expand", summary: "convert tabs to spaces", usage: "expand [OPTION]... [FILE]...", description: "Convert TABs in each FILE to spaces, writing to standard output. If no FILE is specified, standard input is read.", options: ["-t N        Use N spaces per tab (default: 8)", "-t LIST     Use comma-separated list of tab stops", "-i          Only convert leading tabs on each line"], examples: ["expand file.txt             # Convert all tabs to 8 spaces", "expand -t 4 file.txt        # Use 4-space tabs", "expand -t 4,8,12 file.txt   # Custom tab stops"] };
    m11 = { name: "expand", execute: async (n23, i10) => {
      if (o2(n23)) return s(h9);
      let t6 = { tabStops: [8], leadingOnly: false }, o9 = [], e7 = 0;
      for (; e7 < n23.length; ) {
        let s9 = n23[e7];
        if (s9 === "-t" && e7 + 1 < n23.length) {
          let a7 = p7(n23[e7 + 1]);
          if (!a7) return { exitCode: 1, stdout: "", stderr: `expand: invalid tab size: '${n23[e7 + 1]}'
` };
          t6.tabStops = a7, e7 += 2;
        } else if (s9.startsWith("-t") && s9.length > 2) {
          let a7 = p7(s9.slice(2));
          if (!a7) return { exitCode: 1, stdout: "", stderr: `expand: invalid tab size: '${s9.slice(2)}'
` };
          t6.tabStops = a7, e7++;
        } else if (s9 === "--tabs" && e7 + 1 < n23.length) {
          let a7 = p7(n23[e7 + 1]);
          if (!a7) return { exitCode: 1, stdout: "", stderr: `expand: invalid tab size: '${n23[e7 + 1]}'
` };
          t6.tabStops = a7, e7 += 2;
        } else if (s9.startsWith("--tabs=")) {
          let a7 = p7(s9.slice(7));
          if (!a7) return { exitCode: 1, stdout: "", stderr: `expand: invalid tab size: '${s9.slice(7)}'
` };
          t6.tabStops = a7, e7++;
        } else if (s9 === "-i" || s9 === "--initial") t6.leadingOnly = true, e7++;
        else if (s9 === "--") {
          o9.push(...n23.slice(e7 + 1));
          break;
        } else {
          if (s9.startsWith("-") && s9 !== "-") return r3("expand", s9);
          o9.push(s9), e7++;
        }
      }
      let l8 = "";
      if (o9.length === 0) {
        let s9 = i10.stdin ?? "";
        l8 = c6(s9, t6);
      } else for (let s9 of o9) {
        let a7 = i10.fs.resolvePath(i10.cwd, s9), r8 = await i10.fs.readFile(a7);
        if (r8 === null) return { exitCode: 1, stdout: l8, stderr: `expand: ${s9}: No such file or directory
` };
        l8 += c6(r8, t6);
      }
      return { exitCode: 0, stdout: l8, stderr: "" };
    } };
    v11 = { name: "expand", flags: [{ flag: "-t", type: "value", valueHint: "number" }, { flag: "-i", type: "boolean" }], stdinType: "text", needsFiles: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/expand-DTNXU4LQ.js
var expand_DTNXU4LQ_exports = {};
__export(expand_DTNXU4LQ_exports, {
  expand: () => m11,
  flagsForFuzzing: () => v11
});
var init_expand_DTNXU4LQ = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/expand-DTNXU4LQ.js"() {
    init_chunk_VJFXDYWH();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-PYSFUGCK.js
function f9(s9) {
  let i10 = s9.split(",").map((l8) => l8.trim()), e7 = [];
  for (let l8 of i10) {
    let n23 = parseInt(l8, 10);
    if (Number.isNaN(n23) || n23 < 1) return null;
    e7.push(n23);
  }
  for (let l8 = 1; l8 < e7.length; l8++) if (e7[l8] <= e7[l8 - 1]) return null;
  return e7;
}
function v12(s9, i10) {
  if (i10.length === 1) {
    let e7 = i10[0];
    return s9 + (e7 - s9 % e7);
  }
  for (let e7 of i10) if (e7 > s9) return e7;
  if (i10.length >= 2) {
    let e7 = i10[i10.length - 1] - i10[i10.length - 2], l8 = i10[i10.length - 1], n23 = Math.floor((s9 - l8) / e7) + 1;
    return l8 + n23 * e7;
  }
  return -1;
}
function L9(s9, i10) {
  let { tabStops: e7, allBlanks: l8 } = i10, n23 = "", o9 = 0, t6 = "", a7 = 0, u11 = true, d16 = () => {
    if (t6.length === 0) return;
    let r8 = a7 + t6.length;
    if (!l8 && !u11) {
      n23 += t6, t6 = "";
      return;
    }
    let p17 = a7, c15 = "";
    for (; p17 < r8; ) {
      let h17 = v12(p17, e7);
      if (h17 <= r8 && h17 > p17) c15 += "	", p17 = h17;
      else break;
    }
    let x23 = r8 - p17;
    x23 > 0 && (c15 += " ".repeat(x23)), n23 += c15, t6 = "";
  };
  for (let r8 of s9) r8 === " " ? (t6.length === 0 && (a7 = o9), t6 += r8, o9++) : r8 === "	" ? (d16(), n23 += r8, o9 = v12(o9, e7)) : (d16(), n23 += r8, o9++, u11 = false);
  return d16(), n23;
}
function C9(s9, i10) {
  if (s9 === "") return "";
  let e7 = s9.split(`
`), l8 = s9.endsWith(`
`) && e7[e7.length - 1] === "";
  return l8 && e7.pop(), e7.map((o9) => L9(o9, i10)).join(`
`) + (l8 ? `
` : "");
}
var k7, w8, F9;
var init_chunk_PYSFUGCK = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-PYSFUGCK.js"() {
    init_chunk_74CEPOFO();
    k7 = { name: "unexpand", summary: "convert spaces to tabs", usage: "unexpand [OPTION]... [FILE]...", description: "Convert blanks in each FILE to TABs, writing to standard output. If no FILE is specified, standard input is read.", options: ["-t N        Use N spaces per tab (default: 8)", "-t LIST     Use comma-separated list of tab stops", "-a          Convert all sequences of blanks (not just leading)"], examples: ["unexpand file.txt           # Convert leading spaces to tabs", "unexpand -a file.txt        # Convert all space sequences", "unexpand -t 4 file.txt      # Use 4-space tabs"] };
    w8 = { name: "unexpand", execute: async (s9, i10) => {
      if (o2(s9)) return s(k7);
      let e7 = { tabStops: [8], allBlanks: false }, l8 = [], n23 = 0;
      for (; n23 < s9.length; ) {
        let t6 = s9[n23];
        if (t6 === "-t" && n23 + 1 < s9.length) {
          let a7 = f9(s9[n23 + 1]);
          if (!a7) return { exitCode: 1, stdout: "", stderr: `unexpand: invalid tab size: '${s9[n23 + 1]}'
` };
          e7.tabStops = a7, n23 += 2;
        } else if (t6.startsWith("-t") && t6.length > 2) {
          let a7 = f9(t6.slice(2));
          if (!a7) return { exitCode: 1, stdout: "", stderr: `unexpand: invalid tab size: '${t6.slice(2)}'
` };
          e7.tabStops = a7, n23++;
        } else if (t6 === "--tabs" && n23 + 1 < s9.length) {
          let a7 = f9(s9[n23 + 1]);
          if (!a7) return { exitCode: 1, stdout: "", stderr: `unexpand: invalid tab size: '${s9[n23 + 1]}'
` };
          e7.tabStops = a7, n23 += 2;
        } else if (t6.startsWith("--tabs=")) {
          let a7 = f9(t6.slice(7));
          if (!a7) return { exitCode: 1, stdout: "", stderr: `unexpand: invalid tab size: '${t6.slice(7)}'
` };
          e7.tabStops = a7, n23++;
        } else if (t6 === "-a" || t6 === "--all") e7.allBlanks = true, n23++;
        else if (t6 === "--") {
          l8.push(...s9.slice(n23 + 1));
          break;
        } else {
          if (t6.startsWith("-") && t6 !== "-") return r3("unexpand", t6);
          l8.push(t6), n23++;
        }
      }
      let o9 = "";
      if (l8.length === 0) {
        let t6 = i10.stdin ?? "";
        o9 = C9(t6, e7);
      } else for (let t6 of l8) {
        let a7 = i10.fs.resolvePath(i10.cwd, t6), u11 = await i10.fs.readFile(a7);
        if (u11 === null) return { exitCode: 1, stdout: o9, stderr: `unexpand: ${t6}: No such file or directory
` };
        o9 += C9(u11, e7);
      }
      return { exitCode: 0, stdout: o9, stderr: "" };
    } };
    F9 = { name: "unexpand", flags: [{ flag: "-t", type: "value", valueHint: "number" }, { flag: "-a", type: "boolean" }], stdinType: "text", needsFiles: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/unexpand-RGTMIGZM.js
var unexpand_RGTMIGZM_exports = {};
__export(unexpand_RGTMIGZM_exports, {
  flagsForFuzzing: () => F9,
  unexpand: () => w8
});
var init_unexpand_RGTMIGZM = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/unexpand-RGTMIGZM.js"() {
    init_chunk_PYSFUGCK();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-VYOJP4TV.js
function p8(n23) {
  return n23 >= 32 && n23 <= 126 || n23 === 9;
}
function d8(n23, s9) {
  if (s9 === null) return "";
  switch (s9) {
    case "o":
      return `${n23.toString(8).padStart(7, " ")} `;
    case "x":
      return `${n23.toString(16).padStart(7, " ")} `;
    case "d":
      return `${n23.toString(10).padStart(7, " ")} `;
    default:
      return s9;
  }
}
function g11(n23, s9) {
  let o9 = [], r8 = "", i10 = 0, l8 = typeof n23 == "string" ? new TextEncoder().encode(n23) : n23;
  for (let e7 = 0; e7 < l8.length; e7++) {
    let t6 = l8[e7];
    if (p8(t6)) r8.length === 0 && (i10 = e7), r8 += String.fromCharCode(t6);
    else {
      if (r8.length >= s9.minLength) {
        let a7 = d8(i10, s9.offsetFormat);
        o9.push(`${a7}${r8}`);
      }
      r8 = "";
    }
  }
  if (r8.length >= s9.minLength) {
    let e7 = d8(i10, s9.offsetFormat);
    o9.push(`${e7}${r8}`);
  }
  return o9;
}
var m12, b13, N7;
var init_chunk_VYOJP4TV = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-VYOJP4TV.js"() {
    init_chunk_74CEPOFO();
    m12 = { name: "strings", summary: "print the sequences of printable characters in files", usage: "strings [OPTION]... [FILE]...", description: "For each FILE, print the printable character sequences that are at least MIN characters long. If no FILE is specified, standard input is read.", options: ["-n MIN       Print sequences of at least MIN characters (default: 4)", "-t FORMAT    Print offset before each string (o=octal, x=hex, d=decimal)", "-a           Scan the entire file (default behavior)", "-e ENCODING  Select character encoding (s=7-bit, S=8-bit)"], examples: ["strings file.bin          # Extract strings (min 4 chars)", "strings -n 8 file.bin     # Extract strings (min 8 chars)", "strings -t x file.bin     # Show hex offset", "echo 'hello' | strings    # Read from stdin"] };
    b13 = { name: "strings", execute: async (n23, s9) => {
      if (o2(n23)) return s(m12);
      let o9 = { minLength: 4, offsetFormat: null }, r8 = [], i10 = 0;
      for (; i10 < n23.length; ) {
        let e7 = n23[i10];
        if (e7 === "-n" && i10 + 1 < n23.length) {
          let t6 = Number.parseInt(n23[i10 + 1], 10);
          if (Number.isNaN(t6) || t6 < 1) return { exitCode: 1, stdout: "", stderr: `strings: invalid minimum string length: '${n23[i10 + 1]}'
` };
          o9.minLength = t6, i10 += 2;
        } else if (e7.match(/^-n\d+$/)) {
          let t6 = Number.parseInt(e7.slice(2), 10);
          if (Number.isNaN(t6) || t6 < 1) return { exitCode: 1, stdout: "", stderr: `strings: invalid minimum string length: '${e7.slice(2)}'
` };
          o9.minLength = t6, i10++;
        } else if (e7.match(/^-\d+$/)) {
          let t6 = Number.parseInt(e7.slice(1), 10);
          if (Number.isNaN(t6) || t6 < 1) return { exitCode: 1, stdout: "", stderr: `strings: invalid minimum string length: '${e7.slice(1)}'
` };
          o9.minLength = t6, i10++;
        } else if (e7 === "-t" && i10 + 1 < n23.length) {
          let t6 = n23[i10 + 1];
          if (t6 !== "o" && t6 !== "x" && t6 !== "d") return { exitCode: 1, stdout: "", stderr: `strings: invalid radix: '${t6}'
` };
          o9.offsetFormat = t6, i10 += 2;
        } else if (e7.startsWith("-t") && e7.length === 3) {
          let t6 = e7[2];
          if (t6 !== "o" && t6 !== "x" && t6 !== "d") return { exitCode: 1, stdout: "", stderr: `strings: invalid radix: '${t6}'
` };
          o9.offsetFormat = t6, i10++;
        } else if (e7 === "-a" || e7 === "--all" || e7 === "-") e7 === "-" && r8.push(e7), i10++;
        else if (e7 === "-e" && i10 + 1 < n23.length) {
          let t6 = n23[i10 + 1];
          if (t6 !== "s" && t6 !== "S") return { exitCode: 1, stdout: "", stderr: `strings: invalid encoding: '${t6}'
` };
          i10 += 2;
        } else if (e7.startsWith("-e") && e7.length === 3) {
          let t6 = e7[2];
          if (t6 !== "s" && t6 !== "S") return { exitCode: 1, stdout: "", stderr: `strings: invalid encoding: '${t6}'
` };
          i10++;
        } else if (e7 === "--") {
          r8.push(...n23.slice(i10 + 1));
          break;
        } else {
          if (e7.startsWith("-") && e7 !== "-") return r3("strings", e7);
          r8.push(e7), i10++;
        }
      }
      let l8 = "";
      if (r8.length === 0) {
        let e7 = s9.stdin ?? "", t6 = g11(e7, o9);
        l8 = t6.length > 0 ? `${t6.join(`
`)}
` : "";
      } else for (let e7 of r8) {
        let t6;
        if (e7 === "-") t6 = s9.stdin ?? "";
        else {
          let h17 = s9.fs.resolvePath(s9.cwd, e7);
          if (t6 = await s9.fs.readFile(h17), t6 === null) return { exitCode: 1, stdout: l8, stderr: `strings: ${e7}: No such file or directory
` };
        }
        let a7 = g11(t6, o9);
        a7.length > 0 && (l8 += `${a7.join(`
`)}
`);
      }
      return { exitCode: 0, stdout: l8, stderr: "" };
    } };
    N7 = { name: "strings", flags: [{ flag: "-n", type: "value", valueHint: "number" }, { flag: "-t", type: "value", valueHint: "string" }, { flag: "-a", type: "boolean" }, { flag: "-e", type: "value", valueHint: "string" }], stdinType: "text", needsFiles: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/strings-7PLOGTPD.js
var strings_7PLOGTPD_exports = {};
__export(strings_7PLOGTPD_exports, {
  flagsForFuzzing: () => N7,
  strings: () => b13
});
var init_strings_7PLOGTPD = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/strings-7PLOGTPD.js"() {
    init_chunk_VYOJP4TV();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-KTGH7NTP.js
function p9(s9) {
  let l8 = s9.match(/^(\d+)([KMGTPEZY]?)([B]?)$/i);
  if (!l8) return null;
  let e7 = Number.parseInt(l8[1], 10);
  if (Number.isNaN(e7) || e7 < 1) return null;
  let o9 = (l8[2] || "").toUpperCase(), u11 = (/* @__PURE__ */ new Map([["", 1], ["K", 1024], ["M", 1024 * 1024], ["G", 1024 * 1024 * 1024], ["T", 1024 * 1024 * 1024 * 1024], ["P", 1024 * 1024 * 1024 * 1024 * 1024]])).get(o9);
  return u11 === void 0 ? null : e7 * u11;
}
function k8(s9, l8, e7) {
  if (l8) return s9.toString().padStart(e7, "0");
  let o9 = "abcdefghijklmnopqrstuvwxyz", t6 = "", u11 = s9;
  for (let r8 = 0; r8 < e7; r8++) t6 = o9[u11 % 26] + t6, u11 = Math.floor(u11 / 26);
  return t6;
}
function y11(s9, l8) {
  let e7 = s9.split(`
`), o9 = s9.endsWith(`
`) && e7[e7.length - 1] === "";
  o9 && e7.pop();
  let t6 = [];
  for (let u11 = 0; u11 < e7.length; u11 += l8) {
    let r8 = e7.slice(u11, u11 + l8), c15 = u11 + l8 >= e7.length && !o9 ? r8.join(`
`) : `${r8.join(`
`)}
`;
    t6.push({ content: c15, hasContent: true });
  }
  return t6;
}
function g12(s9, l8) {
  let o9 = new TextEncoder().encode(s9), t6 = new TextDecoder(), u11 = [];
  for (let r8 = 0; r8 < o9.length; r8 += l8) {
    let f11 = o9.slice(r8, r8 + l8);
    u11.push({ content: t6.decode(f11), hasContent: f11.length > 0 });
  }
  return u11;
}
function C10(s9, l8) {
  let o9 = new TextEncoder().encode(s9), t6 = new TextDecoder(), u11 = [], r8 = Math.ceil(o9.length / l8);
  for (let f11 = 0; f11 < l8; f11++) {
    let c15 = f11 * r8, i10 = Math.min(c15 + r8, o9.length), n23 = o9.slice(c15, i10);
    u11.push({ content: t6.decode(n23), hasContent: n23.length > 0 });
  }
  return u11;
}
var N8, S7, I11;
var init_chunk_KTGH7NTP = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-KTGH7NTP.js"() {
    init_chunk_74CEPOFO();
    N8 = { name: "split", summary: "split a file into pieces", usage: "split [OPTION]... [FILE [PREFIX]]", description: "Output pieces of FILE to PREFIXaa, PREFIXab, ...; default size is 1000 lines, and default PREFIX is 'x'.", options: ["-l N         Put N lines per output file", "-b SIZE      Put SIZE bytes per output file (K, M, G suffixes)", "-n CHUNKS    Split into CHUNKS equal-sized files", "-d           Use numeric suffixes (00, 01, ...) instead of alphabetic", "-a LENGTH    Use suffixes of length LENGTH (default: 2)", "--additional-suffix=SUFFIX  Append SUFFIX to file names"], examples: ["split -l 100 file.txt        # Split into 100-line chunks", "split -b 1M file.bin         # Split into 1MB chunks", "split -n 5 file.txt          # Split into 5 equal parts", "split -d file.txt part_      # part_00, part_01, ...", "split -a 3 -d file.txt x     # x000, x001, ..."] };
    S7 = { name: "split", execute: async (s9, l8) => {
      if (o2(s9)) return s(N8);
      let e7 = { mode: "lines", lines: 1e3, bytes: 0, chunks: 0, useNumericSuffix: false, suffixLength: 2, additionalSuffix: "" }, o9 = [], t6 = 0;
      for (; t6 < s9.length; ) {
        let i10 = s9[t6];
        if (i10 === "-l" && t6 + 1 < s9.length) {
          let n23 = Number.parseInt(s9[t6 + 1], 10);
          if (Number.isNaN(n23) || n23 < 1) return { exitCode: 1, stdout: "", stderr: `split: invalid number of lines: '${s9[t6 + 1]}'
` };
          e7.mode = "lines", e7.lines = n23, t6 += 2;
        } else if (i10.match(/^-l\d+$/)) {
          let n23 = Number.parseInt(i10.slice(2), 10);
          if (Number.isNaN(n23) || n23 < 1) return { exitCode: 1, stdout: "", stderr: `split: invalid number of lines: '${i10.slice(2)}'
` };
          e7.mode = "lines", e7.lines = n23, t6++;
        } else if (i10 === "-b" && t6 + 1 < s9.length) {
          let n23 = p9(s9[t6 + 1]);
          if (n23 === null) return { exitCode: 1, stdout: "", stderr: `split: invalid number of bytes: '${s9[t6 + 1]}'
` };
          e7.mode = "bytes", e7.bytes = n23, t6 += 2;
        } else if (i10.match(/^-b.+$/)) {
          let n23 = p9(i10.slice(2));
          if (n23 === null) return { exitCode: 1, stdout: "", stderr: `split: invalid number of bytes: '${i10.slice(2)}'
` };
          e7.mode = "bytes", e7.bytes = n23, t6++;
        } else if (i10 === "-n" && t6 + 1 < s9.length) {
          let n23 = Number.parseInt(s9[t6 + 1], 10);
          if (Number.isNaN(n23) || n23 < 1) return { exitCode: 1, stdout: "", stderr: `split: invalid number of chunks: '${s9[t6 + 1]}'
` };
          e7.mode = "chunks", e7.chunks = n23, t6 += 2;
        } else if (i10.match(/^-n\d+$/)) {
          let n23 = Number.parseInt(i10.slice(2), 10);
          if (Number.isNaN(n23) || n23 < 1) return { exitCode: 1, stdout: "", stderr: `split: invalid number of chunks: '${i10.slice(2)}'
` };
          e7.mode = "chunks", e7.chunks = n23, t6++;
        } else if (i10 === "-a" && t6 + 1 < s9.length) {
          let n23 = Number.parseInt(s9[t6 + 1], 10);
          if (Number.isNaN(n23) || n23 < 1) return { exitCode: 1, stdout: "", stderr: `split: invalid suffix length: '${s9[t6 + 1]}'
` };
          e7.suffixLength = n23, t6 += 2;
        } else if (i10.match(/^-a\d+$/)) {
          let n23 = Number.parseInt(i10.slice(2), 10);
          if (Number.isNaN(n23) || n23 < 1) return { exitCode: 1, stdout: "", stderr: `split: invalid suffix length: '${i10.slice(2)}'
` };
          e7.suffixLength = n23, t6++;
        } else if (i10 === "-d" || i10 === "--numeric-suffixes") e7.useNumericSuffix = true, t6++;
        else if (i10.startsWith("--additional-suffix=")) e7.additionalSuffix = i10.slice(20), t6++;
        else if (i10 === "--additional-suffix" && t6 + 1 < s9.length) e7.additionalSuffix = s9[t6 + 1], t6 += 2;
        else if (i10 === "--") {
          o9.push(...s9.slice(t6 + 1));
          break;
        } else {
          if (i10.startsWith("-") && i10 !== "-") return r3("split", i10);
          o9.push(i10), t6++;
        }
      }
      let u11 = "-", r8 = "x";
      o9.length >= 1 && (u11 = o9[0]), o9.length >= 2 && (r8 = o9[1]);
      let f11;
      if (u11 === "-") f11 = l8.stdin ?? "";
      else {
        let i10 = l8.fs.resolvePath(l8.cwd, u11), n23 = await l8.fs.readFile(i10);
        if (n23 === null) return { exitCode: 1, stdout: "", stderr: `split: ${u11}: No such file or directory
` };
        f11 = n23;
      }
      if (f11 === "") return { exitCode: 0, stdout: "", stderr: "" };
      let c15;
      switch (e7.mode) {
        case "lines":
          c15 = y11(f11, e7.lines);
          break;
        case "bytes":
          c15 = g12(f11, e7.bytes);
          break;
        case "chunks":
          c15 = C10(f11, e7.chunks);
          break;
        default:
          return e7.mode;
      }
      for (let i10 = 0; i10 < c15.length; i10++) {
        let n23 = c15[i10];
        if (!n23.hasContent) continue;
        let m25 = k8(i10, e7.useNumericSuffix, e7.suffixLength), b25 = `${r8}${m25}${e7.additionalSuffix}`, x23 = l8.fs.resolvePath(l8.cwd, b25);
        await l8.fs.writeFile(x23, n23.content);
      }
      return { exitCode: 0, stdout: "", stderr: "" };
    } };
    I11 = { name: "split", flags: [{ flag: "-l", type: "value", valueHint: "number" }, { flag: "-b", type: "value", valueHint: "string" }, { flag: "-n", type: "value", valueHint: "number" }, { flag: "-d", type: "boolean" }, { flag: "-a", type: "value", valueHint: "number" }], needsFiles: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/split-EZOC5IIZ.js
var split_EZOC5IIZ_exports = {};
__export(split_EZOC5IIZ_exports, {
  flagsForFuzzing: () => I11,
  split: () => S7
});
var init_split_EZOC5IIZ = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/split-EZOC5IIZ.js"() {
    init_chunk_KTGH7NTP();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-LWEGUNWT.js
function C11(t6, e7, l8) {
  return e7 ? l8 ? t6.split(e7) : t6.split(e7).filter((n23) => n23.length > 0) : l8 ? t6.split(/[ \t]/) : t6.split(/[ \t]+/).filter((n23) => n23.length > 0);
}
function I12(t6) {
  let e7 = [];
  for (let l8 of t6) for (let n23 = 0; n23 < l8.length; n23++) {
    let o9 = l8[n23].length;
    (e7[n23] === void 0 || o9 > e7[n23]) && (e7[n23] = o9);
  }
  return e7;
}
function W7(t6, e7) {
  if (t6.length === 0) return "";
  let l8 = I12(t6), n23 = [];
  for (let o9 of t6) {
    let c15 = [];
    for (let s9 = 0; s9 < o9.length; s9++) s9 === o9.length - 1 ? c15.push(o9[s9]) : c15.push(o9[s9].padEnd(l8[s9]));
    n23.push(c15.join(e7));
  }
  return n23.join(`
`);
}
function j5(t6, e7, l8) {
  if (t6.length === 0) return "";
  let n23 = Math.max(...t6.map((a7) => a7.length)), o9 = l8.length, c15 = n23 + o9, s9 = Math.max(1, Math.floor((e7 + o9) / c15)), p17 = Math.ceil(t6.length / s9), d16 = [];
  for (let a7 = 0; a7 < p17; a7++) {
    let i10 = [];
    for (let r8 = 0; r8 < s9; r8++) {
      let m25 = r8 * p17 + a7;
      m25 < t6.length && (r8 === s9 - 1 || (r8 + 1) * p17 + a7 >= t6.length ? i10.push(t6[m25]) : i10.push(t6[m25].padEnd(n23)));
    }
    d16.push(i10.join(l8));
  }
  return d16.join(`
`);
}
var v13, H8, M6, P9;
var init_chunk_LWEGUNWT = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-LWEGUNWT.js"() {
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    v13 = { name: "column", summary: "columnate lists", usage: "column [OPTION]... [FILE]...", description: "Format input into multiple columns. By default, fills rows first. Use -t to create a table based on whitespace-delimited input.", options: ["-t           Create a table (determine columns from input)", "-s SEP       Input field delimiter (default: whitespace)", "-o SEP       Output field delimiter (default: two spaces)", "-c WIDTH     Output width for fill mode (default: 80)", "-n           Don't merge multiple adjacent delimiters"], examples: ["ls | column              # Fill columns with ls output", "cat data | column -t     # Format as table", "column -t -s ',' file    # Format CSV as table", "column -c 40 file        # Fill 40-char wide columns"] };
    H8 = { table: { short: "t", long: "table", type: "boolean" }, separator: { short: "s", type: "string" }, outputSep: { short: "o", type: "string" }, width: { short: "c", type: "number", default: 80 }, noMerge: { short: "n", type: "boolean" } };
    M6 = { name: "column", execute: async (t6, e7) => {
      if (o2(t6)) return s(v13);
      let l8 = x5("column", t6, H8);
      if (!l8.ok) return l8.error;
      let { table: n23, separator: o9, outputSep: c15, width: s9, noMerge: p17 } = l8.result.flags, d16 = l8.result.positional, a7 = c15 ?? "  ", i10;
      if (d16.length === 0) i10 = e7.stdin ?? "";
      else {
        let u11 = [];
        for (let f11 of d16) if (f11 === "-") u11.push(e7.stdin ?? "");
        else {
          let w19 = e7.fs.resolvePath(e7.cwd, f11), y18 = await e7.fs.readFile(w19);
          if (y18 === null) return { exitCode: 1, stdout: "", stderr: `column: ${f11}: No such file or directory
` };
          u11.push(y18);
        }
        i10 = u11.join("");
      }
      if (i10 === "" || i10.trim() === "") return { exitCode: 0, stdout: "", stderr: "" };
      let r8 = i10.split(`
`);
      i10.endsWith(`
`) && r8[r8.length - 1] === "" && r8.pop();
      let g18 = r8.filter((u11) => u11.trim().length > 0), h17;
      if (n23) {
        let u11 = g18.map((f11) => C11(f11, o9, p17));
        h17 = W7(u11, a7);
      } else {
        let u11 = [];
        for (let f11 of g18) {
          let w19 = C11(f11, o9, p17);
          u11.push(...w19);
        }
        h17 = j5(u11, s9, a7);
      }
      return h17.length > 0 && (h17 += `
`), { exitCode: 0, stdout: h17, stderr: "" };
    } };
    P9 = { name: "column", flags: [{ flag: "-t", type: "boolean" }, { flag: "-s", type: "value", valueHint: "delimiter" }, { flag: "-o", type: "value", valueHint: "string" }, { flag: "-c", type: "value", valueHint: "number" }, { flag: "-n", type: "boolean" }], stdinType: "text", needsFiles: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/column-WLPMMSTS.js
var column_WLPMMSTS_exports = {};
__export(column_WLPMMSTS_exports, {
  column: () => M6,
  flagsForFuzzing: () => P9
});
var init_column_WLPMMSTS = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/column-WLPMMSTS.js"() {
    init_chunk_LWEGUNWT();
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-A7ICOL4V.js
function N9(i10, s9) {
  return s9 ? i10.split(s9) : i10.split(/[ \t]+/).filter((n23) => n23.length > 0);
}
function F10(i10, s9, n23, f11) {
  let e7 = N9(i10, s9), r8 = e7[n23 - 1] ?? "";
  return f11 && (r8 = r8.toLowerCase()), { fields: e7, joinKey: r8, original: i10 };
}
function m13(i10, s9, n23) {
  let f11 = n23.separator ?? " ";
  if (n23.outputFormat) {
    let o9 = [];
    for (let { file: c15, field: p17 } of n23.outputFormat) {
      let a7 = c15 === 1 ? i10 : s9;
      a7 && p17 === 0 ? o9.push(a7.joinKey) : a7 && a7.fields[p17 - 1] !== void 0 ? o9.push(a7.fields[p17 - 1]) : o9.push(n23.emptyString);
    }
    return o9.join(f11);
  }
  let e7 = [], r8 = i10?.joinKey ?? s9?.joinKey ?? "";
  if (e7.push(r8), i10) for (let o9 = 0; o9 < i10.fields.length; o9++) o9 !== n23.field1 - 1 && e7.push(i10.fields[o9]);
  if (s9) for (let o9 = 0; o9 < s9.fields.length; o9++) o9 !== n23.field2 - 1 && e7.push(s9.fields[o9]);
  return e7.join(f11);
}
function I13(i10) {
  let s9 = i10.split(","), n23 = [];
  for (let f11 of s9) {
    let e7 = f11.trim().match(/^(\d+)\.(\d+)$/);
    if (!e7) return null;
    let r8 = Number.parseInt(e7[1], 10), o9 = Number.parseInt(e7[2], 10);
    if (r8 !== 1 && r8 !== 2) return null;
    n23.push({ file: r8, field: o9 });
  }
  return n23;
}
var v14, w9, U8;
var init_chunk_A7ICOL4V = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-A7ICOL4V.js"() {
    init_chunk_74CEPOFO();
    v14 = { name: "join", summary: "join lines of two files on a common field", usage: "join [OPTION]... FILE1 FILE2", description: "For each pair of input lines with identical join fields, write a line to standard output. The default join field is the first, delimited by blanks.", options: ["-1 FIELD     Join on this FIELD of file 1 (default: 1)", "-2 FIELD     Join on this FIELD of file 2 (default: 1)", "-t CHAR      Use CHAR as input and output field separator", "-a FILENUM   Also print unpairable lines from file FILENUM (1 or 2)", "-v FILENUM   Like -a but only output unpairable lines", "-e STRING    Replace missing fields with STRING", "-o FORMAT    Output format (comma-separated list of FILENUM.FIELD)", "-i           Ignore case when comparing fields"], examples: ["join file1 file2               # Join on first field", "join -1 2 -2 1 file1 file2     # Join file1 col 2 with file2 col 1", "join -t ',' file1.csv file2.csv  # Join CSV files", "join -a 1 file1 file2          # Left outer join"] };
    w9 = { name: "join", execute: async (i10, s9) => {
      if (o2(i10)) return s(v14);
      let n23 = { field1: 1, field2: 1, separator: null, printUnpairable: /* @__PURE__ */ new Set(), onlyUnpairable: /* @__PURE__ */ new Set(), emptyString: "", outputFormat: null, ignoreCase: false }, f11 = [], e7 = 0;
      for (; e7 < i10.length; ) {
        let t6 = i10[e7];
        if (t6 === "-1" && e7 + 1 < i10.length) {
          let l8 = Number.parseInt(i10[e7 + 1], 10);
          if (Number.isNaN(l8) || l8 < 1) return { exitCode: 1, stdout: "", stderr: `join: invalid field number: '${i10[e7 + 1]}'
` };
          n23.field1 = l8, e7 += 2;
        } else if (t6 === "-2" && e7 + 1 < i10.length) {
          let l8 = Number.parseInt(i10[e7 + 1], 10);
          if (Number.isNaN(l8) || l8 < 1) return { exitCode: 1, stdout: "", stderr: `join: invalid field number: '${i10[e7 + 1]}'
` };
          n23.field2 = l8, e7 += 2;
        } else if ((t6 === "-t" || t6 === "--field-separator") && e7 + 1 < i10.length) n23.separator = i10[e7 + 1], e7 += 2;
        else if (t6.startsWith("-t") && t6.length > 2) n23.separator = t6.slice(2), e7++;
        else if (t6 === "-a" && e7 + 1 < i10.length) {
          let l8 = Number.parseInt(i10[e7 + 1], 10);
          if (l8 !== 1 && l8 !== 2) return { exitCode: 1, stdout: "", stderr: `join: invalid file number: '${i10[e7 + 1]}'
` };
          n23.printUnpairable.add(l8), e7 += 2;
        } else if (t6.match(/^-a[12]$/)) n23.printUnpairable.add(Number.parseInt(t6[2], 10)), e7++;
        else if (t6 === "-v" && e7 + 1 < i10.length) {
          let l8 = Number.parseInt(i10[e7 + 1], 10);
          if (l8 !== 1 && l8 !== 2) return { exitCode: 1, stdout: "", stderr: `join: invalid file number: '${i10[e7 + 1]}'
` };
          n23.onlyUnpairable.add(l8), e7 += 2;
        } else if (t6.match(/^-v[12]$/)) n23.onlyUnpairable.add(Number.parseInt(t6[2], 10)), e7++;
        else if (t6 === "-e" && e7 + 1 < i10.length) n23.emptyString = i10[e7 + 1], e7 += 2;
        else if (t6 === "-o" && e7 + 1 < i10.length) {
          let l8 = I13(i10[e7 + 1]);
          if (!l8) return { exitCode: 1, stdout: "", stderr: `join: invalid field spec: '${i10[e7 + 1]}'
` };
          n23.outputFormat = l8, e7 += 2;
        } else if (t6 === "-i" || t6 === "--ignore-case") n23.ignoreCase = true, e7++;
        else if (t6 === "--") {
          f11.push(...i10.slice(e7 + 1));
          break;
        } else {
          if (t6.startsWith("-") && t6 !== "-") return r3("join", t6);
          f11.push(t6), e7++;
        }
      }
      if (f11.length !== 2) return { exitCode: 1, stdout: "", stderr: f11.length < 2 ? `join: missing file operand
` : `join: extra operand
` };
      let r8 = [];
      for (let t6 of f11) if (t6 === "-") r8.push(s9.stdin ?? "");
      else {
        let l8 = s9.fs.resolvePath(s9.cwd, t6), u11 = await s9.fs.readFile(l8);
        if (u11 === null) return { exitCode: 1, stdout: "", stderr: `join: ${t6}: No such file or directory
` };
        r8.push(u11);
      }
      let o9 = (t6, l8) => {
        let u11 = t6.split(`
`);
        return t6.endsWith(`
`) && u11[u11.length - 1] === "" && u11.pop(), u11.filter((h17) => h17.length > 0).map((h17) => F10(h17, n23.separator, l8, n23.ignoreCase));
      }, c15 = o9(r8[0], n23.field1), p17 = o9(r8[1], n23.field2), a7 = /* @__PURE__ */ new Map();
      for (let t6 of p17) {
        let l8 = a7.get(t6.joinKey);
        l8 ? l8.push(t6) : a7.set(t6.joinKey, [t6]);
      }
      let d16 = [], b25 = /* @__PURE__ */ new Set();
      for (let t6 of c15) {
        let l8 = a7.get(t6.joinKey);
        if (l8 && l8.length > 0) {
          if (b25.add(t6.joinKey), n23.onlyUnpairable.size === 0) for (let u11 of l8) d16.push(m13(t6, u11, n23));
        } else (n23.printUnpairable.has(1) || n23.onlyUnpairable.has(1)) && d16.push(m13(t6, null, n23));
      }
      if (n23.printUnpairable.has(2) || n23.onlyUnpairable.has(2)) for (let t6 of p17) b25.has(t6.joinKey) || d16.push(m13(null, t6, n23));
      return { exitCode: 0, stdout: d16.length > 0 ? `${d16.join(`
`)}
` : "", stderr: "" };
    } };
    U8 = { name: "join", flags: [{ flag: "-1", type: "value", valueHint: "number" }, { flag: "-2", type: "value", valueHint: "number" }, { flag: "-t", type: "value", valueHint: "delimiter" }, { flag: "-a", type: "value", valueHint: "number" }, { flag: "-v", type: "value", valueHint: "number" }, { flag: "-e", type: "value", valueHint: "string" }, { flag: "-o", type: "value", valueHint: "format" }, { flag: "-i", type: "boolean" }], needsArgs: true, minArgs: 2 };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/join-GG2LDHE5.js
var join_GG2LDHE5_exports = {};
__export(join_GG2LDHE5_exports, {
  flagsForFuzzing: () => U8,
  join: () => w9
});
var init_join_GG2LDHE5 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/join-GG2LDHE5.js"() {
    init_chunk_A7ICOL4V();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-55VFSPNA.js
var u4, m14, y12, w10;
var init_chunk_55VFSPNA = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-55VFSPNA.js"() {
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    u4 = { name: "tee", summary: "read from stdin and write to stdout and files", usage: "tee [OPTION]... [FILE]...", options: ["-a, --append     append to the given FILEs, do not overwrite", "    --help       display this help and exit"] };
    m14 = { append: { short: "a", long: "append", type: "boolean" } };
    y12 = { name: "tee", async execute(n23, e7) {
      if (o2(n23)) return s(u4);
      let t6 = x5("tee", n23, m14);
      if (!t6.ok) return t6.error;
      let { append: f11 } = t6.result.flags, c15 = t6.result.positional, o9 = e7.stdin, r8 = "", a7 = 0;
      for (let i10 of c15) try {
        let s9 = e7.fs.resolvePath(e7.cwd, i10);
        f11 ? await e7.fs.appendFile(s9, o9) : await e7.fs.writeFile(s9, o9);
      } catch {
        r8 += `tee: ${i10}: No such file or directory
`, a7 = 1;
      }
      return { stdout: o9, stderr: r8, exitCode: a7 };
    } };
    w10 = { name: "tee", flags: [{ flag: "-a", type: "boolean" }], stdinType: "text", needsArgs: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/tee-O7VXZDCO.js
var tee_O7VXZDCO_exports = {};
__export(tee_O7VXZDCO_exports, {
  flagsForFuzzing: () => w10,
  teeCommand: () => y12
});
var init_tee_O7VXZDCO = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/tee-O7VXZDCO.js"() {
    init_chunk_55VFSPNA();
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-YYB54I7F.js
function N10(e7, t6) {
  switch (e7.type) {
    case "name": {
      let n23 = e7.pattern, r8 = n23.match(/^\*(\.[a-zA-Z0-9]+)$/);
      if (r8) {
        let s9 = r8[1], o9 = t6.name;
        if (e7.ignoreCase) {
          if (!o9.toLowerCase().endsWith(s9.toLowerCase())) return { matches: false, pruned: false, printed: false };
        } else if (!o9.endsWith(s9)) return { matches: false, pruned: false, printed: false };
        return { matches: true, pruned: false, printed: false };
      }
      return { matches: h6(t6.name, n23, e7.ignoreCase), pruned: false, printed: false };
    }
    case "path": {
      let n23 = e7.pattern, r8 = t6.relativePath, s9 = n23.split("/");
      for (let i10 = 0; i10 < s9.length - 1; i10++) {
        let a7 = s9[i10];
        if (a7 && a7 !== "." && a7 !== ".." && !a7.includes("*") && !a7.includes("?") && !a7.includes("[")) {
          let c15 = `/${a7}/`;
          if (e7.ignoreCase) {
            if (!r8.toLowerCase().includes(c15.toLowerCase())) return { matches: false, pruned: false, printed: false };
          } else if (!r8.includes(c15)) return { matches: false, pruned: false, printed: false };
        }
      }
      let o9 = n23.match(/\*(\.[a-zA-Z0-9]+)$/);
      if (o9) {
        let i10 = o9[1];
        if (e7.ignoreCase) {
          if (!r8.toLowerCase().endsWith(i10.toLowerCase())) return { matches: false, pruned: false, printed: false };
        } else if (!r8.endsWith(i10)) return { matches: false, pruned: false, printed: false };
      }
      return { matches: h6(r8, n23, e7.ignoreCase), pruned: false, printed: false };
    }
    case "regex":
      try {
        let n23 = e7.ignoreCase ? "i" : "";
        return { matches: b1(e7.pattern, n23).test(t6.relativePath), pruned: false, printed: false };
      } catch {
        return { matches: false, pruned: false, printed: false };
      }
    case "type":
      return e7.fileType === "f" ? { matches: t6.isFile, pruned: false, printed: false } : e7.fileType === "d" ? { matches: t6.isDirectory, pruned: false, printed: false } : { matches: false, pruned: false, printed: false };
    case "empty":
      return { matches: t6.isEmpty, pruned: false, printed: false };
    case "mtime": {
      let r8 = (Date.now() - t6.mtime) / (1e3 * 60 * 60 * 24), s9;
      return e7.comparison === "more" ? s9 = r8 > e7.days : e7.comparison === "less" ? s9 = r8 < e7.days : s9 = Math.floor(r8) === e7.days, { matches: s9, pruned: false, printed: false };
    }
    case "newer": {
      let n23 = t6.newerRefTimes.get(e7.refPath);
      return n23 === void 0 ? { matches: false, pruned: false, printed: false } : { matches: t6.mtime > n23, pruned: false, printed: false };
    }
    case "size": {
      let n23 = e7.value;
      switch (e7.unit) {
        case "c":
          n23 = e7.value;
          break;
        case "k":
          n23 = e7.value * 1024;
          break;
        case "M":
          n23 = e7.value * 1024 * 1024;
          break;
        case "G":
          n23 = e7.value * 1024 * 1024 * 1024;
          break;
        case "b":
          n23 = e7.value * 512;
          break;
      }
      let r8;
      return e7.comparison === "more" ? r8 = t6.size > n23 : e7.comparison === "less" ? r8 = t6.size < n23 : e7.unit === "b" ? r8 = Math.ceil(t6.size / 512) === e7.value : r8 = t6.size === n23, { matches: r8, pruned: false, printed: false };
    }
    case "perm": {
      let n23 = t6.mode & 511, r8 = e7.mode & 511, s9;
      return e7.matchType === "exact" ? s9 = n23 === r8 : e7.matchType === "all" ? s9 = (n23 & r8) === r8 : s9 = (n23 & r8) !== 0, { matches: s9, pruned: false, printed: false };
    }
    case "prune":
      return { matches: true, pruned: true, printed: false };
    case "print":
      return { matches: true, pruned: false, printed: true };
    case "not": {
      let n23 = N10(e7.expr, t6);
      return { matches: !n23.matches, pruned: n23.pruned, printed: false };
    }
    case "and": {
      let n23 = N10(e7.left, t6);
      if (!n23.matches) return { matches: false, pruned: n23.pruned, printed: false };
      let r8 = N10(e7.right, t6);
      return { matches: r8.matches, pruned: n23.pruned || r8.pruned, printed: n23.printed || r8.printed };
    }
    case "or": {
      let n23 = N10(e7.left, t6);
      if (n23.matches) return n23;
      let r8 = N10(e7.right, t6);
      return { matches: r8.matches, pruned: n23.pruned || r8.pruned, printed: r8.printed };
    }
  }
}
function Y7(e7) {
  if (!e7) return false;
  switch (e7.type) {
    case "name":
    case "path":
    case "regex":
    case "type":
    case "prune":
    case "print":
      return false;
    case "empty":
    case "mtime":
    case "newer":
    case "size":
    case "perm":
      return true;
    case "not":
      return Y7(e7.expr);
    case "and":
    case "or":
      return Y7(e7.left) || Y7(e7.right);
  }
}
function _5(e7) {
  if (!e7) return false;
  switch (e7.type) {
    case "empty":
      return true;
    case "not":
      return _5(e7.expr);
    case "and":
    case "or":
      return _5(e7.left) || _5(e7.right);
    default:
      return false;
  }
}
function pe5(e7) {
  let t6 = { terminalDirName: null, requiredExtension: null };
  if (!e7) return t6;
  let n23 = be3(e7);
  if (ve3(e7) && n23.length === 1) {
    let o9 = n23[0].split("/").filter((i10) => i10.length > 0);
    if (o9.length >= 2) for (let i10 = o9.length - 2; i10 >= 0; i10--) {
      let a7 = o9[i10];
      if (!a7.includes("*") && !a7.includes("?") && !a7.includes("[") && a7 !== "." && a7 !== "..") {
        let c15 = o9[i10 + 1];
        if (c15 && (c15.includes("*") || c15.includes("?"))) {
          t6.terminalDirName = a7;
          let l8 = c15.match(/^\*(\.[a-zA-Z0-9]+)$/);
          l8 && (t6.requiredExtension = l8[1]);
        }
        break;
      }
    }
  }
  return t6;
}
function be3(e7) {
  let t6 = [], n23 = (r8) => {
    r8.type === "path" ? t6.push(r8.pattern) : r8.type === "not" ? n23(r8.expr) : (r8.type === "and" || r8.type === "or") && (n23(r8.left), n23(r8.right));
  };
  return n23(e7), t6;
}
function ve3(e7) {
  let t6 = (n23) => n23.type === "type" && n23.fileType === "f" ? true : n23.type === "not" ? t6(n23.expr) : n23.type === "and" || n23.type === "or" ? t6(n23.left) || t6(n23.right) : false;
  return t6(e7);
}
function fe6(e7) {
  let t6 = [], n23 = (r8) => {
    r8 && (r8.type === "newer" ? t6.push(r8.refPath) : r8.type === "not" ? n23(r8.expr) : (r8.type === "and" || r8.type === "or") && (n23(r8.left), n23(r8.right)));
  };
  return n23(e7), t6;
}
function V7(e7) {
  if (!e7) return true;
  switch (e7.type) {
    case "name":
    case "path":
    case "regex":
    case "type":
    case "prune":
    case "print":
      return true;
    case "empty":
    case "mtime":
    case "newer":
    case "size":
    case "perm":
      return false;
    case "not":
      return V7(e7.expr);
    case "and":
    case "or":
      return V7(e7.left) && V7(e7.right);
  }
}
function H9(e7, t6, n23, r8, s9) {
  switch (e7.type) {
    case "name": {
      let o9 = e7.pattern, i10 = o9.match(/^\*(\.[a-zA-Z0-9]+)$/);
      if (i10) {
        let a7 = i10[1];
        if (e7.ignoreCase) {
          if (!t6.toLowerCase().endsWith(a7.toLowerCase())) return { matches: false, pruned: false, printed: false };
        } else if (!t6.endsWith(a7)) return { matches: false, pruned: false, printed: false };
        return { matches: true, pruned: false, printed: false };
      }
      return { matches: h6(t6, o9, e7.ignoreCase), pruned: false, printed: false };
    }
    case "path": {
      let o9 = e7.pattern, i10 = o9.split("/");
      for (let c15 = 0; c15 < i10.length - 1; c15++) {
        let l8 = i10[c15];
        if (l8 && l8 !== "." && l8 !== ".." && !l8.includes("*") && !l8.includes("?") && !l8.includes("[")) {
          let d16 = `/${l8}/`;
          if (e7.ignoreCase) {
            if (!n23.toLowerCase().includes(d16.toLowerCase())) return { matches: false, pruned: false, printed: false };
          } else if (!n23.includes(d16)) return { matches: false, pruned: false, printed: false };
        }
      }
      let a7 = o9.match(/\*(\.[a-zA-Z0-9]+)$/);
      if (a7) {
        let c15 = a7[1];
        if (e7.ignoreCase) {
          if (!n23.toLowerCase().endsWith(c15.toLowerCase())) return { matches: false, pruned: false, printed: false };
        } else if (!n23.endsWith(c15)) return { matches: false, pruned: false, printed: false };
      }
      return { matches: h6(n23, o9, e7.ignoreCase), pruned: false, printed: false };
    }
    case "regex":
      try {
        let o9 = e7.ignoreCase ? "i" : "";
        return { matches: b1(e7.pattern, o9).test(n23), pruned: false, printed: false };
      } catch {
        return { matches: false, pruned: false, printed: false };
      }
    case "type":
      return e7.fileType === "f" ? { matches: r8, pruned: false, printed: false } : e7.fileType === "d" ? { matches: s9, pruned: false, printed: false } : { matches: false, pruned: false, printed: false };
    case "prune":
      return { matches: true, pruned: true, printed: false };
    case "print":
      return { matches: true, pruned: false, printed: true };
    case "not": {
      let o9 = H9(e7.expr, t6, n23, r8, s9);
      return { matches: !o9.matches, pruned: o9.pruned, printed: false };
    }
    case "and": {
      let o9 = H9(e7.left, t6, n23, r8, s9);
      if (!o9.matches) return { matches: false, pruned: o9.pruned, printed: false };
      let i10 = H9(e7.right, t6, n23, r8, s9);
      return { matches: i10.matches, pruned: o9.pruned || i10.pruned, printed: o9.printed || i10.printed };
    }
    case "or": {
      let o9 = H9(e7.left, t6, n23, r8, s9);
      if (o9.matches) return o9;
      let i10 = H9(e7.right, t6, n23, r8, s9);
      return { matches: i10.matches, pruned: o9.pruned || i10.pruned, printed: i10.printed };
    }
    default:
      return { matches: false, pruned: false, printed: false };
  }
}
function J8(e7) {
  if (!e7) return false;
  switch (e7.type) {
    case "prune":
      return true;
    case "not":
      return J8(e7.expr);
    case "and":
    case "or":
      return J8(e7.left) || J8(e7.right);
    default:
      return false;
  }
}
function z5(e7) {
  switch (e7.type) {
    case "name":
    case "path":
    case "regex":
    case "type":
    case "prune":
    case "print":
      return true;
    case "empty":
    case "mtime":
    case "newer":
    case "size":
    case "perm":
      return false;
    case "not":
      return z5(e7.expr);
    case "and":
    case "or":
      return z5(e7.left) && z5(e7.right);
  }
}
function ue6(e7, t6) {
  if (!e7 || !t6.isDirectory) return { shouldPrune: false };
  if (!z5(e7)) return ne6(e7, t6);
  let n23 = { name: t6.name, relativePath: t6.relativePath, isFile: t6.isFile, isDirectory: t6.isDirectory, isEmpty: false, mtime: 0, size: 0, mode: 0, newerRefTimes: /* @__PURE__ */ new Map() };
  return { shouldPrune: N10(e7, n23).pruned };
}
function ne6(e7, t6) {
  switch (e7.type) {
    case "or": {
      if (z5(e7.left)) {
        let n23 = { name: t6.name, relativePath: t6.relativePath, isFile: t6.isFile, isDirectory: t6.isDirectory, isEmpty: false, mtime: 0, size: 0, mode: 0, newerRefTimes: /* @__PURE__ */ new Map() };
        if (N10(e7.left, n23).pruned) return { shouldPrune: true };
      }
      return ne6(e7.right, t6);
    }
    case "and": {
      if (z5(e7.left) && z5(e7.right)) {
        let n23 = { name: t6.name, relativePath: t6.relativePath, isFile: t6.isFile, isDirectory: t6.isDirectory, isEmpty: false, mtime: 0, size: 0, mode: 0, newerRefTimes: /* @__PURE__ */ new Map() };
        return { shouldPrune: N10(e7, n23).pruned };
      }
      if (z5(e7.left)) {
        let n23 = { name: t6.name, relativePath: t6.relativePath, isFile: t6.isFile, isDirectory: t6.isDirectory, isEmpty: false, mtime: 0, size: 0, mode: 0, newerRefTimes: /* @__PURE__ */ new Map() };
        return N10(e7.left, n23).matches ? ne6(e7.right, t6) : { shouldPrune: false };
      }
      return { shouldPrune: false };
    }
    case "not":
      return { shouldPrune: false };
    default:
      return { shouldPrune: false };
  }
}
function he6(e7, t6) {
  let n23 = [], r8 = [], s9 = t6;
  for (; s9 < e7.length; ) {
    let i10 = e7[s9];
    if (i10 === "(" || i10 === "\\(") {
      n23.push({ type: "lparen" }), s9++;
      continue;
    }
    if (i10 === ")" || i10 === "\\)") {
      n23.push({ type: "rparen" }), s9++;
      continue;
    }
    if (i10 === "-name" && s9 + 1 < e7.length) n23.push({ type: "expr", expr: { type: "name", pattern: e7[++s9] } });
    else if (i10 === "-iname" && s9 + 1 < e7.length) n23.push({ type: "expr", expr: { type: "name", pattern: e7[++s9], ignoreCase: true } });
    else if (i10 === "-path" && s9 + 1 < e7.length) n23.push({ type: "expr", expr: { type: "path", pattern: e7[++s9] } });
    else if (i10 === "-ipath" && s9 + 1 < e7.length) n23.push({ type: "expr", expr: { type: "path", pattern: e7[++s9], ignoreCase: true } });
    else if (i10 === "-regex" && s9 + 1 < e7.length) n23.push({ type: "expr", expr: { type: "regex", pattern: e7[++s9] } });
    else if (i10 === "-iregex" && s9 + 1 < e7.length) n23.push({ type: "expr", expr: { type: "regex", pattern: e7[++s9], ignoreCase: true } });
    else if (i10 === "-type" && s9 + 1 < e7.length) {
      let a7 = e7[++s9];
      if (a7 === "f" || a7 === "d") n23.push({ type: "expr", expr: { type: "type", fileType: a7 } });
      else return { expr: null, pathIndex: s9, error: `find: Unknown argument to -type: ${a7}
`, actions: [] };
    } else if (i10 === "-empty") n23.push({ type: "expr", expr: { type: "empty" } });
    else if (i10 === "-mtime" && s9 + 1 < e7.length) {
      let a7 = e7[++s9], c15 = "exact", l8 = a7;
      a7.startsWith("+") ? (c15 = "more", l8 = a7.slice(1)) : a7.startsWith("-") && (c15 = "less", l8 = a7.slice(1));
      let d16 = parseInt(l8, 10);
      Number.isNaN(d16) || n23.push({ type: "expr", expr: { type: "mtime", days: d16, comparison: c15 } });
    } else if (i10 === "-newer" && s9 + 1 < e7.length) {
      let a7 = e7[++s9];
      n23.push({ type: "expr", expr: { type: "newer", refPath: a7 } });
    } else if (i10 === "-size" && s9 + 1 < e7.length) {
      let a7 = e7[++s9], c15 = "exact", l8 = a7;
      a7.startsWith("+") ? (c15 = "more", l8 = a7.slice(1)) : a7.startsWith("-") && (c15 = "less", l8 = a7.slice(1));
      let d16 = l8.match(/^(\d+)([ckMGb])?$/);
      if (d16) {
        let B12 = parseInt(d16[1], 10), I18 = d16[2] || "b";
        n23.push({ type: "expr", expr: { type: "size", value: B12, unit: I18, comparison: c15 } });
      }
    } else if (i10 === "-perm" && s9 + 1 < e7.length) {
      let a7 = e7[++s9], c15 = "exact", l8 = a7;
      a7.startsWith("-") ? (c15 = "all", l8 = a7.slice(1)) : a7.startsWith("/") && (c15 = "any", l8 = a7.slice(1));
      let d16 = parseInt(l8, 8);
      Number.isNaN(d16) || n23.push({ type: "expr", expr: { type: "perm", mode: d16, matchType: c15 } });
    } else if (i10 === "-prune") n23.push({ type: "expr", expr: { type: "prune" } });
    else if (i10 === "-not" || i10 === "!") n23.push({ type: "not" });
    else if (i10 === "-o" || i10 === "-or") n23.push({ type: "op", op: "or" });
    else if (i10 === "-a" || i10 === "-and") n23.push({ type: "op", op: "and" });
    else if (i10 === "-maxdepth" || i10 === "-mindepth") s9++;
    else if (i10 !== "-depth") if (i10 === "-exec") {
      let a7 = [];
      for (s9++; s9 < e7.length && e7[s9] !== ";" && e7[s9] !== "+"; ) a7.push(e7[s9]), s9++;
      if (s9 >= e7.length) return { expr: null, pathIndex: s9, error: "find: missing argument to `-exec'\n", actions: [] };
      let c15 = e7[s9] === "+";
      r8.push({ type: "exec", command: a7, batchMode: c15 });
    } else if (i10 === "-print") n23.push({ type: "expr", expr: { type: "print" } }), r8.push({ type: "print" });
    else if (i10 === "-print0") r8.push({ type: "print0" });
    else if (i10 === "-printf" && s9 + 1 < e7.length) {
      let a7 = e7[++s9];
      r8.push({ type: "printf", format: a7 });
    } else if (i10 === "-delete") r8.push({ type: "delete" });
    else {
      if (i10.startsWith("-")) return { expr: null, pathIndex: s9, error: `find: unknown predicate '${i10}'
`, actions: [] };
      if (n23.length === 0) {
        s9++;
        continue;
      }
      break;
    }
    s9++;
  }
  if (n23.length === 0) return { expr: null, pathIndex: s9, actions: r8 };
  let o9 = Ee3(n23);
  return o9.error ? { expr: null, pathIndex: s9, error: o9.error, actions: r8 } : { expr: o9.expr, pathIndex: s9, actions: r8 };
}
function Ee3(e7) {
  let t6 = 0;
  function n23() {
    let a7 = r8();
    if (!a7) return null;
    for (; t6 < e7.length; ) {
      let c15 = e7[t6];
      if (c15.type === "op" && c15.op === "or") {
        t6++;
        let l8 = r8();
        if (!l8) return a7;
        a7 = { type: "or", left: a7, right: l8 };
      } else break;
    }
    return a7;
  }
  function r8() {
    let a7 = s9();
    if (!a7) return null;
    for (; t6 < e7.length; ) {
      let c15 = e7[t6];
      if (c15.type === "op" && c15.op === "and") {
        t6++;
        let l8 = s9();
        if (!l8) return a7;
        a7 = { type: "and", left: a7, right: l8 };
      } else if (c15.type === "expr" || c15.type === "not" || c15.type === "lparen") {
        let l8 = s9();
        if (!l8) return a7;
        a7 = { type: "and", left: a7, right: l8 };
      } else break;
    }
    return a7;
  }
  function s9() {
    if (t6 < e7.length && e7[t6].type === "not") {
      t6++;
      let a7 = s9();
      return a7 ? { type: "not", expr: a7 } : null;
    }
    return o9();
  }
  function o9() {
    if (t6 >= e7.length) return null;
    let a7 = e7[t6];
    if (a7.type === "lparen") {
      t6++;
      let c15 = n23();
      return t6 < e7.length && e7[t6].type === "rparen" && t6++, c15;
    }
    return a7.type === "expr" ? (t6++, a7.expr) : (a7.type === "rparen", null);
  }
  return { expr: n23() };
}
function Me3() {
  return { readdirCalls: 0, readdirTime: 0, statCalls: 0, statTime: 0, evalCalls: 0, evalTime: 0, nodeCount: 0, batchCount: 0, batchTime: 0, earlyPrunes: 0 };
}
function xe4(e7, t6, n23) {
  e7({ category: "find", name: "summary", durationMs: n23, details: { readdirCalls: t6.readdirCalls, readdirTimeMs: t6.readdirTime, statCalls: t6.statCalls, statTimeMs: t6.statTime, evalCalls: t6.evalCalls, evalTimeMs: t6.evalTime, nodeCount: t6.nodeCount, batchCount: t6.batchCount, batchTimeMs: t6.batchTime, earlyPrunes: t6.earlyPrunes, otherTimeMs: n23 - t6.readdirTime - t6.statTime - t6.evalTime - t6.batchTime } });
}
function $e3(e7, t6) {
  let n23 = r4(e7), r8 = "", s9 = 0;
  for (; s9 < n23.length; ) if (n23[s9] === "%" && s9 + 1 < n23.length) {
    if (s9++, n23[s9] === "%") {
      r8 += "%", s9++;
      continue;
    }
    let [o9, i10, a7] = h3(n23, s9);
    if (s9 += a7, s9 >= n23.length) {
      r8 += "%";
      break;
    }
    let c15 = n23[s9], l8;
    switch (c15) {
      case "f":
        l8 = t6.name, s9++;
        break;
      case "h": {
        let d16 = t6.path.lastIndexOf("/");
        l8 = d16 > 0 ? t6.path.slice(0, d16) : ".", s9++;
        break;
      }
      case "p":
        l8 = t6.path, s9++;
        break;
      case "P": {
        let d16 = t6.startingPoint;
        t6.path === d16 ? l8 = "" : t6.path.startsWith(`${d16}/`) ? l8 = t6.path.slice(d16.length + 1) : d16 === "." && t6.path.startsWith("./") ? l8 = t6.path.slice(2) : l8 = t6.path, s9++;
        break;
      }
      case "s":
        l8 = String(t6.size), s9++;
        break;
      case "d":
        l8 = String(t6.depth), s9++;
        break;
      case "m":
        l8 = (t6.mode & 511).toString(8), s9++;
        break;
      case "M":
        l8 = Re4(t6.mode, t6.isDirectory), s9++;
        break;
      case "t": {
        let d16 = new Date(t6.mtime);
        l8 = ke2(d16), s9++;
        break;
      }
      case "T": {
        if (s9 + 1 < n23.length) {
          let d16 = n23[s9 + 1], B12 = new Date(t6.mtime);
          l8 = Ne3(B12, d16), s9 += 2;
        } else l8 = "%T", s9++;
        break;
      }
      default:
        r8 += `%${o9 !== 0 || i10 !== -1 ? `${o9}.${i10}` : ""}${c15}`, s9++;
        continue;
    }
    r8 += i3(l8, o9, i10);
  } else r8 += n23[s9], s9++;
  return r8;
}
function Re4(e7, t6) {
  let n23 = e7 & 511, r8 = t6 ? "d" : "-";
  return r8 += n23 & 256 ? "r" : "-", r8 += n23 & 128 ? "w" : "-", r8 += n23 & 64 ? "x" : "-", r8 += n23 & 32 ? "r" : "-", r8 += n23 & 16 ? "w" : "-", r8 += n23 & 8 ? "x" : "-", r8 += n23 & 4 ? "r" : "-", r8 += n23 & 2 ? "w" : "-", r8 += n23 & 1 ? "x" : "-", r8;
}
function ke2(e7) {
  let t6 = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], n23 = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], r8 = t6[e7.getDay()], s9 = n23[e7.getMonth()], o9 = String(e7.getDate()).padStart(2, " "), i10 = String(e7.getHours()).padStart(2, "0"), a7 = String(e7.getMinutes()).padStart(2, "0"), c15 = String(e7.getSeconds()).padStart(2, "0"), l8 = e7.getFullYear();
  return `${r8} ${s9} ${o9} ${i10}:${a7}:${c15} ${l8}`;
}
function Ne3(e7, t6) {
  switch (t6) {
    case "@":
      return String(e7.getTime() / 1e3);
    case "Y":
      return String(e7.getFullYear());
    case "m":
      return String(e7.getMonth() + 1).padStart(2, "0");
    case "d":
      return String(e7.getDate()).padStart(2, "0");
    case "H":
      return String(e7.getHours()).padStart(2, "0");
    case "M":
      return String(e7.getMinutes()).padStart(2, "0");
    case "S":
      return String(e7.getSeconds()).padStart(2, "0");
    case "T":
      return `${String(e7.getHours()).padStart(2, "0")}:${String(e7.getMinutes()).padStart(2, "0")}:${String(e7.getSeconds()).padStart(2, "0")}`;
    case "F":
      return `${e7.getFullYear()}-${String(e7.getMonth() + 1).padStart(2, "0")}-${String(e7.getDate()).padStart(2, "0")}`;
    default:
      return `%T${t6}`;
  }
}
var de6, Fe3, Ie3, je3, Ze3;
var init_chunk_YYB54I7F = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-YYB54I7F.js"() {
    init_chunk_IJXFPKNC();
    init_chunk_YNYSPYQ5();
    init_chunk_EEXR5ZDP();
    init_chunk_74CEPOFO();
    de6 = 500;
    Fe3 = { name: "find", summary: "search for files in a directory hierarchy", usage: "find [path...] [expression]", options: ["-name PATTERN    file name matches shell pattern PATTERN", "-iname PATTERN   like -name but case insensitive", "-path PATTERN    file path matches shell pattern PATTERN", "-ipath PATTERN   like -path but case insensitive", "-regex PATTERN   file path matches regular expression PATTERN", "-iregex PATTERN  like -regex but case insensitive", "-type TYPE       file is of type: f (regular file), d (directory)", "-empty           file is empty or directory is empty", "-mtime N         file's data was modified N*24 hours ago", "-newer FILE      file was modified more recently than FILE", "-size N[ckMGb]   file uses N units of space (c=bytes, k=KB, M=MB, G=GB, b=512B blocks)", "-perm MODE       file's permission bits are exactly MODE (octal)", "-perm -MODE      all permission bits MODE are set", "-perm /MODE      any permission bits MODE are set", "-maxdepth LEVELS descend at most LEVELS directories", "-mindepth LEVELS do not apply tests at levels less than LEVELS", "-depth           process directory contents before directory itself", "-prune           do not descend into this directory", "-not, !          negate the following expression", "-a, -and         logical AND (default)", "-o, -or          logical OR", "-exec CMD {} ;   execute CMD on each file ({} is replaced by filename)", "-exec CMD {} +   execute CMD with multiple files at once", "-print           print the full file name (default action)", "-print0          print the full file name followed by a null character", "-printf FORMAT   print FORMAT with directives: %f %h %p %P %s %d %m %M %t", "-delete          delete found files/directories", "    --help       display this help and exit"] };
    Ie3 = /* @__PURE__ */ new Set(["-name", "-iname", "-path", "-ipath", "-regex", "-iregex", "-type", "-maxdepth", "-mindepth", "-mtime", "-newer", "-size", "-perm"]);
    je3 = { name: "find", async execute(e7, t6) {
      if (o2(e7)) return s(Fe3);
      let n23 = [], r8 = null, s9 = null, o9 = false, i10 = false;
      for (let p17 = 0; p17 < e7.length; p17++) {
        let f11 = e7[p17];
        if (f11 === "-maxdepth" && p17 + 1 < e7.length) i10 = true, r8 = parseInt(e7[++p17], 10);
        else if (f11 === "-mindepth" && p17 + 1 < e7.length) i10 = true, s9 = parseInt(e7[++p17], 10);
        else if (f11 === "-depth") i10 = true, o9 = true;
        else if (f11 === "-exec") for (i10 = true, p17++; p17 < e7.length && e7[p17] !== ";" && e7[p17] !== "+"; ) p17++;
        else !f11.startsWith("-") && f11 !== ";" && f11 !== "+" && f11 !== "(" && f11 !== ")" && f11 !== "\\(" && f11 !== "\\)" && f11 !== "!" ? i10 || n23.push(f11) : Ie3.has(f11) ? (i10 = true, p17++) : (f11.startsWith("-") || f11 === "(" || f11 === "\\(" || f11 === "!") && (i10 = true);
      }
      n23.length === 0 && n23.push(".");
      let { expr: a7, error: c15, actions: l8 } = he6(e7, 0);
      if (c15) return { stdout: "", stderr: c15, exitCode: 1 };
      let d16 = l8.some((p17) => p17.type === "print"), B12 = l8.length === 0, I18 = [], me6 = l8.some((p17) => p17.type === "printf"), se9 = [], q17 = "", G9 = 0, ye7 = fe6(a7), U14 = /* @__PURE__ */ new Map();
      for (let p17 of ye7) {
        let f11 = t6.fs.resolvePath(t6.cwd, p17);
        try {
          let h17 = await t6.fs.stat(f11);
          U14.set(p17, h17.mtime?.getTime() ?? Date.now());
        } catch {
        }
      }
      let ge8 = l8.some((p17) => {
        if (p17.type !== "printf") return false;
        let f11 = p17.format.replace(/%%/g, "");
        return /%[-+]?[0-9]*\.?[0-9]*(s|m|M|t|T)/.test(f11);
      }), we6 = Y7(a7) || ge8, De7 = _5(a7), K9 = pe5(a7), re5 = J8(a7), Te6 = V7(a7), Ce6 = typeof t6.fs.readdirWithFileTypes == "function";
      for (let p17 of n23) {
        let W15 = function(u11) {
          let R13 = s9 === null || u11.depth >= s9, P20 = false;
          if (R13 && a7 !== null) {
            let S17 = Date.now(), y18;
            if (Te6) y18 = H9(a7, u11.name, u11.relativePath, u11.isFile, u11.isDirectory);
            else {
              let m25 = { name: u11.name, relativePath: u11.relativePath, isFile: u11.isFile, isDirectory: u11.isDirectory, isEmpty: u11.isEmpty, mtime: u11.stat?.mtime?.getTime() ?? Date.now(), size: u11.stat?.size ?? 0, mode: u11.stat?.mode ?? 420, newerRefTimes: U14 };
              y18 = N10(a7, m25);
            }
            R13 = y18.matches, P20 = d16 ? y18.printed : R13, h17.evalCalls++, h17.evalTime += Date.now() - S17;
          } else R13 && (P20 = true);
          return P20 ? { print: true, printfData: me6 ? { path: u11.relativePath, name: u11.name, size: u11.stat?.size ?? 0, mtime: u11.stat?.mtime?.getTime() ?? Date.now(), mode: u11.stat?.mode ?? 420, isDirectory: u11.isDirectory, depth: u11.depth, startingPoint: p17 } : null } : { print: false, printfData: null };
        };
        var We7 = W15;
        p17.length > 1 && p17.endsWith("/") && (p17 = p17.slice(0, -1));
        let f11 = t6.fs.resolvePath(t6.cwd, p17);
        try {
          await t6.fs.stat(f11);
        } catch {
          q17 += `find: ${p17}: No such file or directory
`, G9 = 1;
          continue;
        }
        let h17 = Me3(), $18 = Date.now();
        async function b25(u11) {
          let { path: v21, depth: R13, typeInfo: P20 } = u11;
          if (h17.nodeCount++, r8 !== null && R13 > r8) return null;
          let E13, S17, y18;
          if (P20 && !we6) E13 = P20.isFile, S17 = P20.isDirectory;
          else {
            try {
              let L18 = Date.now();
              y18 = await t6.fs.stat(v21), h17.statCalls++, h17.statTime += Date.now() - L18;
            } catch {
              return null;
            }
            if (!y18) return null;
            E13 = y18.isFile, S17 = y18.isDirectory;
          }
          let m25;
          v21 === f11 ? m25 = p17.split("/").pop() || p17 : m25 = v21.split("/").pop() || "";
          let g18 = v21 === f11 ? p17 : p17 === "." ? `./${v21.slice(f11 === "/" ? f11.length : f11.length + 1)}` : p17 + v21.slice(f11.length), T10 = [], C19 = null, w19 = null, D15 = false;
          S17 && re5 && !o9 && (D15 = ue6(a7, { name: m25, relativePath: g18, isFile: E13, isDirectory: S17 }).shouldPrune, D15 && h17.earlyPrunes++);
          let x23 = r8 !== null && R13 >= r8, F21 = K9.terminalDirName !== null && m25 === K9.terminalDirName, j12 = !x23 && !F21 && !D15;
          if (S17 && ((j12 || De7 || F21) && !D15)) {
            let L18 = Date.now();
            if (Ce6 && t6.fs.readdirWithFileTypes) {
              if (C19 = await t6.fs.readdirWithFileTypes(v21), w19 = C19.map((M15) => M15.name), h17.readdirCalls++, h17.readdirTime += Date.now() - L18, j12) T10 = C19.map((M15, k17) => ({ path: v21 === "/" ? `/${M15.name}` : `${v21}/${M15.name}`, depth: R13 + 1, typeInfo: { isFile: M15.isFile, isDirectory: M15.isDirectory }, resultIndex: k17 }));
              else if (F21) {
                let M15 = K9.requiredExtension;
                T10 = C19.filter((k17) => k17.isFile && (!M15 || k17.name.endsWith(M15))).map((k17, Se6) => ({ path: v21 === "/" ? `/${k17.name}` : `${v21}/${k17.name}`, depth: R13 + 1, typeInfo: { isFile: k17.isFile, isDirectory: k17.isDirectory }, resultIndex: Se6 }));
              }
            } else w19 = await t6.fs.readdir(v21), h17.readdirCalls++, h17.readdirTime += Date.now() - L18, j12 && (T10 = w19.map((M15, k17) => ({ path: v21 === "/" ? `/${M15}` : `${v21}/${M15}`, depth: R13 + 1, resultIndex: k17 })));
          }
          let Q13 = E13 ? (y18?.size ?? 0) === 0 : w19 !== null && w19.length === 0, O17 = D15;
          if (!o9 && a7 !== null && !D15 && re5) {
            let L18 = Date.now(), M15 = { name: m25, relativePath: g18, isFile: E13, isDirectory: S17, isEmpty: Q13, mtime: y18?.mtime?.getTime() ?? Date.now(), size: y18?.size ?? 0, mode: y18?.mode ?? 420, newerRefTimes: U14 };
            O17 = N10(a7, M15).pruned, h17.evalCalls++, h17.evalTime += Date.now() - L18;
          }
          return { relativePath: g18, name: m25, isFile: E13, isDirectory: S17, isEmpty: Q13, stat: y18, depth: R13, children: O17 ? [] : T10, pruned: O17 };
        }
        async function Pe6() {
          let u11 = { paths: [], printfData: [] };
          if (o9) {
            let y18 = function(m25) {
              let g18 = { paths: [], printfData: [] }, T10 = P20[m25];
              if (!T10) return g18;
              for (let D15 of T10.childIndices) {
                let x23 = y18(D15);
                g18.paths.push(...x23.paths), g18.printfData.push(...x23.printfData);
              }
              let { print: C19, printfData: w19 } = W15(T10.node);
              return C19 && (g18.paths.push(T10.node.relativePath), w19 && g18.printfData.push(w19)), g18;
            };
            var v21 = y18;
            let P20 = [], E13 = [{ item: { path: f11, depth: 0, resultIndex: 0 }, parentIndex: -1, childOrderInParent: 0 }], S17 = /* @__PURE__ */ new Map();
            for (; E13.length > 0; ) {
              let m25 = Date.now(), g18 = E13.splice(0, de6), T10 = await Promise.all(g18.map((C19) => b25(C19.item)));
              h17.batchCount++, h17.batchTime += Date.now() - m25;
              for (let C19 = 0; C19 < g18.length; C19++) {
                let w19 = T10[C19], D15 = g18[C19];
                if (!w19) continue;
                let x23 = P20.length;
                if (D15.parentIndex >= 0) {
                  let F21 = S17.get(D15.parentIndex) || [];
                  F21.push(x23), S17.set(D15.parentIndex, F21);
                }
                P20.push({ node: w19, parentIndex: D15.parentIndex, childIndices: [] });
                for (let F21 = 0; F21 < w19.children.length; F21++) E13.push({ item: w19.children[F21], parentIndex: x23, childOrderInParent: F21 });
              }
            }
            for (let [m25, g18] of S17) m25 >= 0 && m25 < P20.length && (P20[m25].childIndices = g18);
            if (P20.length > 0) {
              let m25 = y18(0);
              u11.paths.push(...m25.paths), u11.printfData.push(...m25.printfData);
            }
          } else {
            let m25 = function(g18) {
              let T10 = P20.get(g18);
              T10 && (u11.paths.push(T10.path), T10.printfData && u11.printfData.push(T10.printfData));
              let C19 = y18.get(g18);
              if (C19) for (let w19 of C19) m25(w19);
            };
            var R13 = m25;
            let P20 = /* @__PURE__ */ new Map(), E13 = 0, S17 = [{ item: { path: f11, depth: 0, resultIndex: 0 }, orderIndex: E13++ }], y18 = /* @__PURE__ */ new Map();
            for (; S17.length > 0; ) {
              let g18 = Date.now(), T10 = S17.splice(0, de6), C19 = await Promise.all(T10.map(async ({ item: w19, orderIndex: D15 }) => {
                let x23 = await b25(w19);
                return x23 ? { node: x23, orderIndex: D15 } : null;
              }));
              h17.batchCount++, h17.batchTime += Date.now() - g18;
              for (let w19 of C19) {
                if (!w19) continue;
                let { node: D15, orderIndex: x23 } = w19, { print: F21, printfData: j12 } = W15(D15);
                if (F21 && P20.set(x23, { path: D15.relativePath, printfData: j12 }), D15.children.length > 0) {
                  let ee7 = [];
                  for (let Q13 of D15.children) {
                    let O17 = E13++;
                    ee7.push(O17), S17.push({ item: Q13, orderIndex: O17 });
                  }
                  y18.set(x23, ee7);
                }
              }
            }
            m25(0);
          }
          return u11;
        }
        let X10 = await Pe6();
        if (I18.push(...X10.paths), se9.push(...X10.printfData), t6.trace) {
          let u11 = Date.now() - $18;
          xe4(t6.trace, h17, u11), t6.trace({ category: "find", name: "searchPath", durationMs: u11, details: { path: p17, resultsFound: X10.paths.length } });
        }
      }
      let A14 = "";
      if (l8.length > 0) for (let p17 of l8) switch (p17.type) {
        case "print":
          A14 += I18.length > 0 ? `${I18.join(`
`)}
` : "";
          break;
        case "print0":
          A14 += I18.length > 0 ? `${I18.join("\0")}\0` : "";
          break;
        case "delete": {
          let f11 = [...I18].sort((h17, $18) => $18.length - h17.length);
          for (let h17 of f11) {
            let $18 = t6.fs.resolvePath(t6.cwd, h17);
            try {
              await t6.fs.rm($18, { recursive: false });
            } catch (b25) {
              let W15 = b25 instanceof Error ? b25.message : String(b25);
              q17 += `find: cannot delete '${h17}': ${W15}
`, G9 = 1;
            }
          }
          break;
        }
        case "printf":
          for (let f11 of se9) A14 += $e3(p17.format, f11);
          break;
        case "exec":
          if (!t6.exec) return { stdout: "", stderr: `find: -exec not supported in this context
`, exitCode: 1 };
          if (p17.batchMode) {
            let f11 = [];
            for (let b25 of p17.command) b25 === "{}" ? f11.push(...I18) : f11.push(b25);
            let h17 = f11.map((b25) => `"${b25}"`).join(" "), $18 = await t6.exec(h17, { cwd: t6.cwd });
            A14 += $18.stdout, q17 += $18.stderr, $18.exitCode !== 0 && (G9 = $18.exitCode);
          } else for (let f11 of I18) {
            let $18 = p17.command.map((W15) => W15 === "{}" ? f11 : W15).map((W15) => `"${W15}"`).join(" "), b25 = await t6.exec($18, { cwd: t6.cwd });
            A14 += b25.stdout, q17 += b25.stderr, b25.exitCode !== 0 && (G9 = b25.exitCode);
          }
          break;
      }
      else B12 && (A14 = I18.length > 0 ? `${I18.join(`
`)}
` : "");
      return { stdout: A14, stderr: q17, exitCode: G9 };
    } };
    Ze3 = { name: "find", flags: [{ flag: "-name", type: "value", valueHint: "pattern" }, { flag: "-iname", type: "value", valueHint: "pattern" }, { flag: "-type", type: "value", valueHint: "string" }, { flag: "-maxdepth", type: "value", valueHint: "number" }, { flag: "-mindepth", type: "value", valueHint: "number" }, { flag: "-empty", type: "boolean" }, { flag: "-print", type: "boolean" }, { flag: "-print0", type: "boolean" }], needsFiles: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/find-74OP3M7S.js
var find_74OP3M7S_exports = {};
__export(find_74OP3M7S_exports, {
  findCommand: () => je3,
  flagsForFuzzing: () => Ze3
});
var init_find_74OP3M7S = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/find-74OP3M7S.js"() {
    init_chunk_YYB54I7F();
    init_chunk_IJXFPKNC();
    init_chunk_YNYSPYQ5();
    init_chunk_EEXR5ZDP();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-ALLTKNUZ.js
var p10, c7, h10;
var init_chunk_ALLTKNUZ = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-ALLTKNUZ.js"() {
    init_chunk_74CEPOFO();
    p10 = { name: "basename", summary: "strip directory and suffix from filenames", usage: `basename NAME [SUFFIX]
basename OPTION... NAME...`, options: ["-a, --multiple   support multiple arguments", "-s, --suffix=SUFFIX  remove a trailing SUFFIX", "    --help       display this help and exit"] };
    c7 = { name: "basename", async execute(n23, u11) {
      if (o2(n23)) return s(p10);
      let l8 = false, s9 = "", a7 = [];
      for (let t6 = 0; t6 < n23.length; t6++) {
        let e7 = n23[t6];
        e7 === "-a" || e7 === "--multiple" ? l8 = true : e7 === "-s" && t6 + 1 < n23.length ? (s9 = n23[++t6], l8 = true) : e7.startsWith("--suffix=") ? (s9 = e7.slice(9), l8 = true) : e7.startsWith("-") || a7.push(e7);
      }
      if (a7.length === 0) return { stdout: "", stderr: `basename: missing operand
`, exitCode: 1 };
      !l8 && a7.length >= 2 && (s9 = a7.pop() ?? "");
      let o9 = [];
      for (let t6 of a7) {
        let e7 = t6.replace(/\/+$/, ""), i10 = e7.split("/").pop() || e7;
        s9 && i10.endsWith(s9) && (i10 = i10.slice(0, -s9.length)), o9.push(i10);
      }
      return { stdout: `${o9.join(`
`)}
`, stderr: "", exitCode: 0 };
    } };
    h10 = { name: "basename", flags: [{ flag: "-a", type: "boolean" }, { flag: "-s", type: "value", valueHint: "string" }], needsArgs: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/basename-AA2KJYZQ.js
var basename_AA2KJYZQ_exports = {};
__export(basename_AA2KJYZQ_exports, {
  basenameCommand: () => c7,
  flagsForFuzzing: () => h10
});
var init_basename_AA2KJYZQ = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/basename-AA2KJYZQ.js"() {
    init_chunk_ALLTKNUZ();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-4Q4SM6WR.js
var m15, p11, c8;
var init_chunk_4Q4SM6WR = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-4Q4SM6WR.js"() {
    init_chunk_74CEPOFO();
    m15 = { name: "dirname", summary: "strip last component from file name", usage: "dirname [OPTION] NAME...", options: ["    --help       display this help and exit"] };
    p11 = { name: "dirname", async execute(t6, l8) {
      if (o2(t6)) return s(m15);
      let r8 = t6.filter((n23) => !n23.startsWith("-"));
      if (r8.length === 0) return { stdout: "", stderr: `dirname: missing operand
`, exitCode: 1 };
      let e7 = [];
      for (let n23 of r8) {
        let a7 = n23.replace(/\/+$/, ""), s9 = a7.lastIndexOf("/");
        s9 === -1 ? e7.push(".") : s9 === 0 ? e7.push("/") : e7.push(a7.slice(0, s9));
      }
      return { stdout: `${e7.join(`
`)}
`, stderr: "", exitCode: 0 };
    } };
    c8 = { name: "dirname", flags: [], needsArgs: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/dirname-LEMTZZFS.js
var dirname_LEMTZZFS_exports = {};
__export(dirname_LEMTZZFS_exports, {
  dirnameCommand: () => p11,
  flagsForFuzzing: () => c8
});
var init_dirname_LEMTZZFS = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/dirname-LEMTZZFS.js"() {
    init_chunk_4Q4SM6WR();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-XVDPCNWR.js
async function T5(i10, o9, s9, f11, d16) {
  let e7 = { output: "", stderr: "", dirCount: 0, fileCount: 0 }, l8 = i10.fs.resolvePath(i10.cwd, o9);
  try {
    if (!(await i10.fs.stat(l8)).isDirectory) return e7.output = `${o9}
`, e7.fileCount = 1, e7;
  } catch {
    return e7.stderr = `tree: ${o9}: No such file or directory
`, e7;
  }
  if (e7.output = `${o9}
`, s9.maxDepth !== null && d16 >= s9.maxDepth) return e7;
  try {
    let a7 = [];
    if (i10.fs.readdirWithFileTypes) a7 = (await i10.fs.readdirWithFileTypes(l8)).map((r8) => ({ name: r8.name, isDirectory: r8.isDirectory }));
    else {
      let t6 = await i10.fs.readdir(l8);
      for (let r8 = 0; r8 < t6.length; r8 += 100) {
        let m25 = t6.slice(r8, r8 + 100), u11 = await Promise.all(m25.map(async (c15) => {
          let y18 = l8 === "/" ? `/${c15}` : `${l8}/${c15}`;
          try {
            let h17 = await i10.fs.stat(y18);
            return { name: c15, isDirectory: h17.isDirectory };
          } catch {
            return null;
          }
        }));
        a7.push(...u11.filter((c15) => c15 !== null));
      }
    }
    let n23 = a7.filter((t6) => !(!s9.showHidden && t6.name.startsWith(".") || s9.directoriesOnly && !t6.isDirectory));
    n23.sort((t6, r8) => t6.name.localeCompare(r8.name));
    for (let t6 = 0; t6 < n23.length; t6++) {
      let r8 = n23[t6], m25 = l8 === "/" ? `/${r8.name}` : `${l8}/${r8.name}`, u11 = t6 === n23.length - 1, c15 = u11 ? "`-- " : "|-- ", y18 = f11 + (u11 ? "    " : "|   ");
      if (r8.isDirectory) {
        e7.dirCount++;
        let h17 = s9.fullPath ? m25 : r8.name;
        if (e7.output += `${f11 + c15 + h17}
`, s9.maxDepth === null || d16 + 1 < s9.maxDepth) {
          let C19 = await w11(i10, m25, s9, y18, d16 + 1);
          e7.output += C19.output, e7.dirCount += C19.dirCount, e7.fileCount += C19.fileCount;
        }
      } else {
        e7.fileCount++;
        let h17 = s9.fullPath ? m25 : r8.name;
        e7.output += `${f11 + c15 + h17}
`;
      }
    }
  } catch {
    e7.stderr = `tree: ${o9}: Permission denied
`;
  }
  return e7;
}
async function w11(i10, o9, s9, f11, d16) {
  let e7 = { output: "", stderr: "", dirCount: 0, fileCount: 0 };
  if (s9.maxDepth !== null && d16 >= s9.maxDepth) return e7;
  try {
    let l8 = [];
    if (i10.fs.readdirWithFileTypes) l8 = (await i10.fs.readdirWithFileTypes(o9)).map((t6) => ({ name: t6.name, isDirectory: t6.isDirectory }));
    else {
      let n23 = await i10.fs.readdir(o9);
      for (let t6 = 0; t6 < n23.length; t6 += 100) {
        let r8 = n23.slice(t6, t6 + 100), m25 = await Promise.all(r8.map(async (u11) => {
          let c15 = o9 === "/" ? `/${u11}` : `${o9}/${u11}`;
          try {
            let y18 = await i10.fs.stat(c15);
            return { name: u11, isDirectory: y18.isDirectory };
          } catch {
            return null;
          }
        }));
        l8.push(...m25.filter((u11) => u11 !== null));
      }
    }
    let a7 = l8.filter((n23) => !(!s9.showHidden && n23.name.startsWith(".") || s9.directoriesOnly && !n23.isDirectory));
    a7.sort((n23, t6) => n23.name.localeCompare(t6.name));
    for (let n23 = 0; n23 < a7.length; n23++) {
      let t6 = a7[n23], r8 = o9 === "/" ? `/${t6.name}` : `${o9}/${t6.name}`, m25 = n23 === a7.length - 1, u11 = m25 ? "`-- " : "|-- ", c15 = f11 + (m25 ? "    " : "|   ");
      if (t6.isDirectory) {
        e7.dirCount++;
        let y18 = s9.fullPath ? r8 : t6.name;
        e7.output += `${f11 + u11 + y18}
`;
        let h17 = await w11(i10, r8, s9, c15, d16 + 1);
        e7.output += h17.output, e7.dirCount += h17.dirCount, e7.fileCount += h17.fileCount;
      } else {
        e7.fileCount++;
        let y18 = s9.fullPath ? r8 : t6.name;
        e7.output += `${f11 + u11 + y18}
`;
      }
    }
  } catch {
  }
  return e7;
}
var P10, b14, O9, L10;
var init_chunk_XVDPCNWR = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-XVDPCNWR.js"() {
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    P10 = { name: "tree", summary: "list contents of directories in a tree-like format", usage: "tree [OPTION]... [DIRECTORY]...", options: ["-a          include hidden files", "-d          list directories only", "-L LEVEL    limit depth of directory tree", "-f          print full path prefix for each file", "    --help  display this help and exit"] };
    b14 = { showHidden: { short: "a", type: "boolean" }, directoriesOnly: { short: "d", type: "boolean" }, fullPath: { short: "f", type: "boolean" }, maxDepth: { short: "L", type: "number" } };
    O9 = { name: "tree", async execute(i10, o9) {
      if (o2(i10)) return s(P10);
      let s9 = x5("tree", i10, b14);
      if (!s9.ok) return s9.error;
      let f11 = { showHidden: s9.result.flags.showHidden, directoriesOnly: s9.result.flags.directoriesOnly, maxDepth: s9.result.flags.maxDepth ?? null, fullPath: s9.result.flags.fullPath }, d16 = s9.result.positional;
      d16.length === 0 && d16.push(".");
      let e7 = "", l8 = "", a7 = 0, n23 = 0;
      for (let t6 of d16) {
        let r8 = await T5(o9, t6, f11, "", 0);
        e7 += r8.output, l8 += r8.stderr, a7 += r8.dirCount, n23 += r8.fileCount;
      }
      return e7 += `
${a7} director${a7 === 1 ? "y" : "ies"}`, f11.directoriesOnly || (e7 += `, ${n23} file${n23 === 1 ? "" : "s"}`), e7 += `
`, { stdout: e7, stderr: l8, exitCode: l8 ? 1 : 0 };
    } };
    L10 = { name: "tree", flags: [{ flag: "-a", type: "boolean" }, { flag: "-d", type: "boolean" }, { flag: "-f", type: "boolean" }, { flag: "-L", type: "value", valueHint: "number" }], needsFiles: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/tree-LYXBS7DC.js
var tree_LYXBS7DC_exports = {};
__export(tree_LYXBS7DC_exports, {
  flagsForFuzzing: () => L10,
  treeCommand: () => O9
});
var init_tree_LYXBS7DC = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/tree-LYXBS7DC.js"() {
    init_chunk_XVDPCNWR();
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-K3PAWJ7V.js
async function w12(a7, s9, n23, r8, c15) {
  let i10 = { output: "", totalSize: 0, stderr: "" };
  try {
    let m25 = await a7.fs.stat(s9);
    if (!m25.isDirectory) return i10.totalSize = m25.size, (r8.allFiles || c15 === 0) && (i10.output = D8(m25.size, r8.humanReadable) + "	" + n23 + `
`), i10;
    let p17 = 0, l8 = [];
    if (a7.fs.readdirWithFileTypes) {
      let t6 = await a7.fs.readdirWithFileTypes(s9), o9 = t6.filter((e7) => e7.isFile), f11 = t6.filter((e7) => e7.isDirectory);
      for (let e7 = 0; e7 < o9.length; e7 += 100) {
        let u11 = o9.slice(e7, e7 + 100), y18 = await Promise.all(u11.map(async (d16) => {
          let T10 = s9 === "/" ? `/${d16.name}` : `${s9}/${d16.name}`;
          try {
            let S17 = await a7.fs.stat(T10);
            return { name: d16.name, isDirectory: false, size: S17.size };
          } catch {
            return { name: d16.name, isDirectory: false, size: 0 };
          }
        }));
        l8.push(...y18);
      }
      l8.push(...f11.map((e7) => ({ name: e7.name, isDirectory: true })));
    } else {
      let t6 = await a7.fs.readdir(s9);
      for (let o9 = 0; o9 < t6.length; o9 += 100) {
        let f11 = t6.slice(o9, o9 + 100), e7 = await Promise.all(f11.map(async (u11) => {
          let y18 = s9 === "/" ? `/${u11}` : `${s9}/${u11}`;
          try {
            let d16 = await a7.fs.stat(y18);
            return { name: u11, isDirectory: d16.isDirectory, size: d16.isDirectory ? void 0 : d16.size };
          } catch {
            return { name: u11, isDirectory: false, size: 0 };
          }
        }));
        l8.push(...e7);
      }
    }
    l8.sort((t6, o9) => t6.name.localeCompare(o9.name));
    let z10 = l8.filter((t6) => !t6.isDirectory);
    for (let t6 of z10) {
      let o9 = t6.size ?? 0;
      if (p17 += o9, r8.allFiles && !r8.summarize) {
        let f11 = n23 === "." ? t6.name : `${n23}/${t6.name}`;
        i10.output += D8(o9, r8.humanReadable) + "	" + f11 + `
`;
      }
    }
    let h17 = l8.filter((t6) => t6.isDirectory);
    for (let t6 = 0; t6 < h17.length; t6 += 100) {
      let o9 = h17.slice(t6, t6 + 100), f11 = await Promise.all(o9.map(async (e7) => {
        let u11 = s9 === "/" ? `/${e7.name}` : `${s9}/${e7.name}`, y18 = n23 === "." ? e7.name : `${n23}/${e7.name}`;
        return { name: e7.name, result: await w12(a7, u11, y18, r8, c15 + 1) };
      }));
      f11.sort((e7, u11) => e7.name.localeCompare(u11.name));
      for (let { result: e7 } of f11) p17 += e7.totalSize, r8.summarize || (r8.maxDepth === null || c15 + 1 <= r8.maxDepth) && (i10.output += e7.output);
    }
    i10.totalSize = p17, (r8.summarize || r8.maxDepth === null || c15 <= r8.maxDepth) && (i10.output += `${D8(p17, r8.humanReadable)}	${n23}
`);
  } catch {
    i10.stderr = `du: cannot read directory '${n23}': Permission denied
`;
  }
  return i10;
}
function D8(a7, s9) {
  return s9 ? a7 < 1024 ? `${a7}` : a7 < 1024 * 1024 ? `${(a7 / 1024).toFixed(1)}K` : a7 < 1024 * 1024 * 1024 ? `${(a7 / (1024 * 1024)).toFixed(1)}M` : `${(a7 / (1024 * 1024 * 1024)).toFixed(1)}G` : String(Math.ceil(a7 / 1024) || 1);
}
var x15, R4, H10, v15;
var init_chunk_K3PAWJ7V = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-K3PAWJ7V.js"() {
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    x15 = { name: "du", summary: "estimate file space usage", usage: "du [OPTION]... [FILE]...", options: ["-a          write counts for all files, not just directories", "-h          print sizes in human readable format", "-s          display only a total for each argument", "-c          produce a grand total", "--max-depth=N  print total for directory only if N or fewer levels deep", "    --help  display this help and exit"] };
    R4 = { allFiles: { short: "a", type: "boolean" }, humanReadable: { short: "h", type: "boolean" }, summarize: { short: "s", type: "boolean" }, grandTotal: { short: "c", type: "boolean" }, maxDepth: { long: "max-depth", type: "number" } };
    H10 = { name: "du", async execute(a7, s9) {
      if (o2(a7)) return s(x15);
      let n23 = x5("du", a7, R4);
      if (!n23.ok) return n23.error;
      let r8 = { allFiles: n23.result.flags.allFiles, humanReadable: n23.result.flags.humanReadable, summarize: n23.result.flags.summarize, grandTotal: n23.result.flags.grandTotal, maxDepth: n23.result.flags.maxDepth ?? null }, c15 = n23.result.positional;
      c15.length === 0 && c15.push(".");
      let i10 = "", m25 = "", p17 = 0;
      for (let l8 of c15) {
        let z10 = s9.fs.resolvePath(s9.cwd, l8);
        try {
          await s9.fs.stat(z10);
          let h17 = await w12(s9, z10, l8, r8, 0);
          i10 += h17.output, p17 += h17.totalSize, m25 += h17.stderr;
        } catch {
          m25 += `du: cannot access '${l8}': No such file or directory
`;
        }
      }
      return r8.grandTotal && c15.length > 0 && (i10 += `${D8(p17, r8.humanReadable)}	total
`), { stdout: i10, stderr: m25, exitCode: m25 ? 1 : 0 };
    } };
    v15 = { name: "du", flags: [{ flag: "-a", type: "boolean" }, { flag: "-h", type: "boolean" }, { flag: "-s", type: "boolean" }, { flag: "-c", type: "boolean" }, { flag: "--max-depth", type: "value", valueHint: "number" }], needsFiles: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/du-DM4QX4XA.js
var du_DM4QX4XA_exports = {};
__export(du_DM4QX4XA_exports, {
  duCommand: () => H10,
  flagsForFuzzing: () => v15
});
var init_du_DM4QX4XA = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/du-DM4QX4XA.js"() {
    init_chunk_K3PAWJ7V();
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-OGDTSM2Q.js
var $10, C12, w13, E6, O10, j6;
var init_chunk_OGDTSM2Q = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-OGDTSM2Q.js"() {
    init_chunk_74CEPOFO();
    $10 = { name: "env", summary: "run a program in a modified environment", usage: "env [OPTION]... [NAME=VALUE]... [COMMAND [ARG]...]", options: ["-i, --ignore-environment  start with an empty environment", "-u NAME, --unset=NAME     remove NAME from the environment", "    --help                display this help and exit"] };
    C12 = { name: "env", async execute(o9, l8) {
      if (o2(o9)) return s($10);
      let c15 = false, i10 = [], a7 = /* @__PURE__ */ new Map(), t6 = -1;
      for (let n23 = 0; n23 < o9.length; n23++) {
        let e7 = o9[n23];
        if (e7 === "-i" || e7 === "--ignore-environment") c15 = true;
        else if (e7 === "-u" && n23 + 1 < o9.length) i10.push(o9[++n23]);
        else if (e7.startsWith("-u")) i10.push(e7.slice(2));
        else if (e7.startsWith("--unset=")) i10.push(e7.slice(8));
        else {
          if (e7.startsWith("--") && e7 !== "--") return r3("env", e7);
          if (e7.startsWith("-") && e7 !== "-") {
            for (let r8 of e7.slice(1)) if (r8 !== "i" && r8 !== "u") return r3("env", `-${r8}`);
            e7.includes("i") && (c15 = true);
          } else if (e7.includes("=") && t6 === -1) {
            let r8 = e7.indexOf("="), y18 = e7.slice(0, r8), A14 = e7.slice(r8 + 1);
            a7.set(y18, A14);
          } else {
            t6 = n23;
            break;
          }
        }
      }
      let s9;
      if (c15) s9 = new Map(a7);
      else {
        s9 = new Map(l8.env);
        for (let n23 of i10) s9.delete(n23);
        for (let [n23, e7] of a7) s9.set(n23, e7);
      }
      if (t6 === -1) {
        let n23 = [];
        for (let [e7, r8] of s9) n23.push(`${e7}=${r8}`);
        return { stdout: n23.join(`
`) + (n23.length > 0 ? `
` : ""), stderr: "", exitCode: 0 };
      }
      if (!l8.exec) return { stdout: "", stderr: `env: command execution not supported in this context
`, exitCode: 1 };
      let u11 = o9.slice(t6), h17 = u11[0], g18 = u11.slice(1).map((n23) => /[\s"'\\$`!*?[\]{}|&;<>()]/.test(n23) ? `'${n23.replace(/'/g, "'\\''")}'` : n23), d16 = ["command", h17, ...g18].join(" "), v21 = Object.entries(a7).map(([n23, e7]) => `${n23}="${e7}"`).join(" "), x23 = v21 ? `${v21} ${d16}` : d16;
      return l8.exec(x23, { cwd: l8.cwd });
    } };
    w13 = { name: "printenv", summary: "print all or part of environment", usage: "printenv [OPTION]... [VARIABLE]...", options: ["    --help       display this help and exit"] };
    E6 = { name: "printenv", async execute(o9, l8) {
      if (o2(o9)) return s(w13);
      let c15 = o9.filter((t6) => !t6.startsWith("-"));
      if (c15.length === 0) {
        let t6 = [];
        for (let [s9, u11] of l8.env) t6.push(`${s9}=${u11}`);
        return { stdout: t6.join(`
`) + (t6.length > 0 ? `
` : ""), stderr: "", exitCode: 0 };
      }
      let i10 = [], a7 = 0;
      for (let t6 of c15) {
        let s9 = l8.env.get(t6);
        s9 !== void 0 ? i10.push(s9) : a7 = 1;
      }
      return { stdout: i10.join(`
`) + (i10.length > 0 ? `
` : ""), stderr: "", exitCode: a7 };
    } };
    O10 = { name: "env", flags: [{ flag: "-i", type: "boolean" }, { flag: "-u", type: "value", valueHint: "string" }] };
    j6 = { name: "printenv", flags: [] };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/env-S547XMN7.js
var env_S547XMN7_exports = {};
__export(env_S547XMN7_exports, {
  envCommand: () => C12,
  flagsForFuzzing: () => O10,
  printenvCommand: () => E6,
  printenvFlagsForFuzzing: () => j6
});
var init_env_S547XMN7 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/env-S547XMN7.js"() {
    init_chunk_OGDTSM2Q();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-VOBGTVA6.js
var d9, o4, m16, c9, p12, h11;
var init_chunk_VOBGTVA6 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-VOBGTVA6.js"() {
    init_chunk_74CEPOFO();
    d9 = { name: "alias", summary: "define or display aliases", usage: "alias [name[=value] ...]", options: ["    --help display this help and exit"] };
    o4 = "BASH_ALIAS_";
    m16 = { name: "alias", async execute(e7, a7) {
      if (o2(e7)) return s(d9);
      if (e7.length === 0) {
        let s9 = "";
        for (let [i10, t6] of a7.env) if (i10.startsWith(o4)) {
          let n23 = i10.slice(o4.length);
          s9 += `alias ${n23}='${t6}'
`;
        }
        return { stdout: s9, stderr: "", exitCode: 0 };
      }
      let l8 = e7[0] === "--" ? e7.slice(1) : e7;
      for (let s9 of l8) {
        let i10 = s9.indexOf("=");
        if (i10 === -1) {
          let t6 = o4 + s9;
          return a7.env.get(t6) ? { stdout: `alias ${s9}='${a7.env.get(t6)}'
`, stderr: "", exitCode: 0 } : { stdout: "", stderr: `alias: ${s9}: not found
`, exitCode: 1 };
        } else {
          let t6 = s9.slice(0, i10), n23 = s9.slice(i10 + 1);
          (n23.startsWith("'") && n23.endsWith("'") || n23.startsWith('"') && n23.endsWith('"')) && (n23 = n23.slice(1, -1)), a7.env.set(o4 + t6, n23);
        }
      }
      return { stdout: "", stderr: "", exitCode: 0 };
    } };
    c9 = { name: "unalias", async execute(e7, a7) {
      if (o2(e7)) return s({ name: "unalias", summary: "remove alias definitions", usage: "unalias name [name ...]", options: ["-a      remove all aliases", "    --help display this help and exit"] });
      if (e7.length === 0) return { stdout: "", stderr: `unalias: usage: unalias [-a] name [name ...]
`, exitCode: 1 };
      if (e7[0] === "-a") {
        for (let t6 of a7.env.keys()) t6.startsWith(o4) && a7.env.delete(t6);
        return { stdout: "", stderr: "", exitCode: 0 };
      }
      let l8 = e7[0] === "--" ? e7.slice(1) : e7, s9 = false, i10 = "";
      for (let t6 of l8) {
        let n23 = o4 + t6;
        a7.env.get(n23) ? a7.env.delete(n23) : (i10 += `unalias: ${t6}: not found
`, s9 = true);
      }
      return { stdout: "", stderr: i10, exitCode: s9 ? 1 : 0 };
    } };
    p12 = { name: "alias", flags: [] };
    h11 = { name: "unalias", flags: [{ flag: "-a", type: "boolean" }] };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/alias-JE7RI5QX.js
var alias_JE7RI5QX_exports = {};
__export(alias_JE7RI5QX_exports, {
  aliasCommand: () => m16,
  flagsForFuzzing: () => p12,
  unaliasCommand: () => c9,
  unaliasFlagsForFuzzing: () => h11
});
var init_alias_JE7RI5QX = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/alias-JE7RI5QX.js"() {
    init_chunk_VOBGTVA6();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-NCNPKYJZ.js
var p13, h12, m17, u5;
var init_chunk_NCNPKYJZ = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-NCNPKYJZ.js"() {
    init_chunk_74CEPOFO();
    p13 = { name: "history", summary: "display command history", usage: "history [n]", options: ["-c      clear the history list", "    --help display this help and exit"] };
    h12 = "BASH_HISTORY";
    m17 = { name: "history", async execute(e7, s9) {
      if (o2(e7)) return s(p13);
      let a7 = s9.env.get(h12) || "[]", t6;
      try {
        t6 = JSON.parse(a7);
      } catch {
        t6 = [];
      }
      if (e7[0] === "-c") return s9.env.set(h12, "[]"), { stdout: "", stderr: "", exitCode: 0 };
      let n23 = t6.length;
      e7[0] && /^\d+$/.test(e7[0]) && (n23 = Math.min(parseInt(e7[0], 10), t6.length));
      let c15 = t6.length - n23, r8 = "";
      for (let o9 = c15; o9 < t6.length; o9++) {
        let y18 = (o9 + 1).toString().padStart(5, " ");
        r8 += `${y18}  ${t6[o9]}
`;
      }
      return { stdout: r8, stderr: "", exitCode: 0 };
    } };
    u5 = { name: "history", flags: [{ flag: "-c", type: "boolean" }] };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/history-J4QRNGRO.js
var history_J4QRNGRO_exports = {};
__export(history_J4QRNGRO_exports, {
  flagsForFuzzing: () => u5,
  historyCommand: () => m17
});
var init_history_J4QRNGRO = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/history-J4QRNGRO.js"() {
    init_chunk_NCNPKYJZ();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-SXR3EI72.js
var $11, N11, P11;
var init_chunk_SXR3EI72 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-SXR3EI72.js"() {
    init_chunk_74CEPOFO();
    $11 = { name: "xargs", summary: "build and execute command lines from standard input", usage: "xargs [OPTION]... [COMMAND [INITIAL-ARGS]]", options: ["-I REPLACE   replace occurrences of REPLACE with input", "-d DELIM     use DELIM as input delimiter (e.g., -d '\\n' for newline)", "-n NUM       use at most NUM arguments per command line", "-P NUM       run at most NUM processes at a time", "-0, --null   items are separated by null, not whitespace", "-t, --verbose  print commands before executing", "-r, --no-run-if-empty  do not run command if input is empty", "    --help   display this help and exit"] };
    N11 = { name: "xargs", async execute(l8, i10) {
      if (o2(l8)) return s($11);
      let m25 = null, g18 = null, c15 = null, o9 = null, h17 = false, x23 = false, y18 = false, s9 = 0;
      for (let e7 = 0; e7 < l8.length; e7++) {
        let t6 = l8[e7];
        if (t6 === "-I" && e7 + 1 < l8.length) m25 = l8[++e7], s9 = e7 + 1;
        else if (t6 === "-d" && e7 + 1 < l8.length) g18 = l8[++e7].replace(/\\n/g, `
`).replace(/\\t/g, "	").replace(/\\r/g, "\r").replace(/\\0/g, "\0").replace(/\\\\/g, "\\"), s9 = e7 + 1;
        else if (t6 === "-n" && e7 + 1 < l8.length) c15 = parseInt(l8[++e7], 10), s9 = e7 + 1;
        else if (t6 === "-P" && e7 + 1 < l8.length) o9 = parseInt(l8[++e7], 10), s9 = e7 + 1;
        else if (t6 === "-0" || t6 === "--null") h17 = true, s9 = e7 + 1;
        else if (t6 === "-t" || t6 === "--verbose") x23 = true, s9 = e7 + 1;
        else if (t6 === "-r" || t6 === "--no-run-if-empty") y18 = true, s9 = e7 + 1;
        else {
          if (t6.startsWith("--")) return r3("xargs", t6);
          if (t6.startsWith("-") && t6.length > 1) {
            for (let n23 of t6.slice(1)) if (!"0tr".includes(n23)) return r3("xargs", `-${n23}`);
            t6.includes("0") && (h17 = true), t6.includes("t") && (x23 = true), t6.includes("r") && (y18 = true), s9 = e7 + 1;
          } else if (!t6.startsWith("-")) {
            s9 = e7;
            break;
          }
        }
      }
      let a7 = l8.slice(s9);
      a7.length === 0 && a7.push("echo");
      let r8;
      if (h17 ? r8 = i10.stdin.split("\0").filter((e7) => e7.length > 0) : g18 !== null ? r8 = i10.stdin.replace(/\n$/, "").split(g18).filter((t6) => t6.length > 0) : r8 = i10.stdin.split(/\s+/).map((e7) => e7.trim()).filter((e7) => e7.length > 0), r8.length === 0) return y18 ? { stdout: "", stderr: "", exitCode: 0 } : { stdout: "", stderr: "", exitCode: 0 };
      let d16 = "", u11 = "", f11 = 0, v21 = (e7) => /[\s"'\\$`!*?[\]{}();&|<>#]/.test(e7) ? `"${e7.replace(/([\\"`$])/g, "\\$1")}"` : e7, C19 = async (e7) => {
        let t6 = e7.map(v21).join(" ");
        return x23 && (u11 += `${t6}
`), i10.exec ? i10.exec(t6, { cwd: i10.cwd }) : { stdout: `${t6}
`, stderr: "", exitCode: 0 };
      }, w19 = async (e7) => {
        if (o9 !== null && o9 > 1) for (let t6 = 0; t6 < e7.length; t6 += o9) {
          let n23 = e7.slice(t6, t6 + o9), M15 = await Promise.all(n23.map(C19));
          for (let p17 of M15) d16 += p17.stdout, u11 += p17.stderr, p17.exitCode !== 0 && (f11 = p17.exitCode);
        }
        else for (let t6 of e7) {
          let n23 = await C19(t6);
          d16 += n23.stdout, u11 += n23.stderr, n23.exitCode !== 0 && (f11 = n23.exitCode);
        }
      };
      if (m25 !== null) {
        let e7 = r8.map((t6) => a7.map((n23) => n23.replaceAll(m25, t6)));
        await w19(e7);
      } else if (c15 !== null) {
        let e7 = [];
        for (let t6 = 0; t6 < r8.length; t6 += c15) {
          let n23 = r8.slice(t6, t6 + c15);
          e7.push([...a7, ...n23]);
        }
        await w19(e7);
      } else {
        let e7 = [...a7, ...r8], t6 = await C19(e7);
        d16 += t6.stdout, u11 += t6.stderr, f11 = t6.exitCode;
      }
      return { stdout: d16, stderr: u11, exitCode: f11 };
    } };
    P11 = { name: "xargs", flags: [{ flag: "-I", type: "value", valueHint: "string" }, { flag: "-d", type: "value", valueHint: "delimiter" }, { flag: "-n", type: "value", valueHint: "number" }, { flag: "-0", type: "boolean" }, { flag: "-t", type: "boolean" }, { flag: "-r", type: "boolean" }], stdinType: "text" };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/xargs-OGI2NN6J.js
var xargs_OGI2NN6J_exports = {};
__export(xargs_OGI2NN6J_exports, {
  flagsForFuzzing: () => P11,
  xargsCommand: () => N11
});
var init_xargs_OGI2NN6J = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/xargs-OGI2NN6J.js"() {
    init_chunk_SXR3EI72();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-R6QSAL5T.js
var e3, t, s2, r7;
var init_chunk_R6QSAL5T = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-R6QSAL5T.js"() {
    e3 = { name: "true", async execute() {
      return { stdout: "", stderr: "", exitCode: 0 };
    } };
    t = { name: "false", async execute() {
      return { stdout: "", stderr: "", exitCode: 1 };
    } };
    s2 = { name: "true", flags: [] };
    r7 = { name: "false", flags: [] };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/true-WHJNXCHG.js
var true_WHJNXCHG_exports = {};
__export(true_WHJNXCHG_exports, {
  falseCommand: () => t,
  falseFlagsForFuzzing: () => r7,
  flagsForFuzzing: () => s2,
  trueCommand: () => e3
});
var init_true_WHJNXCHG = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/true-WHJNXCHG.js"() {
    init_chunk_R6QSAL5T();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-LL3S3NLB.js
var t2, s3, o5;
var init_chunk_LL3S3NLB = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-LL3S3NLB.js"() {
    init_chunk_74CEPOFO();
    t2 = { name: "clear", summary: "clear the terminal screen", usage: "clear [OPTIONS]", options: ["    --help display this help and exit"] };
    s3 = { name: "clear", async execute(r8, c15) {
      return o2(r8) ? s(t2) : { stdout: "\x1B[2J\x1B[H", stderr: "", exitCode: 0 };
    } };
    o5 = { name: "clear", flags: [] };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/clear-5CZ5X4YR.js
var clear_5CZ5X4YR_exports = {};
__export(clear_5CZ5X4YR_exports, {
  clearCommand: () => s3,
  flagsForFuzzing: () => o5
});
var init_clear_5CZ5X4YR = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/clear-5CZ5X4YR.js"() {
    init_chunk_LL3S3NLB();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-JP44OYZS.js
async function i4(t6, e7, n23, o9) {
  if (!o9.exec) return { stdout: "", stderr: `bash: internal error: exec function not available
`, exitCode: 1 };
  let r8 = c3(o9.exportedEnv || {}, { 0: e7, "#": String(n23.length), "@": n23.join(" "), "*": n23.join(" ") });
  n23.forEach((a7, m25) => {
    r8[String(m25 + 1)] = a7;
  });
  let s9 = t6;
  if (s9.startsWith("#!")) {
    let a7 = s9.indexOf(`
`);
    a7 !== -1 && (s9 = s9.slice(a7 + 1));
  }
  return await o9.exec(s9, { env: r8, cwd: o9.cwd, stdin: o9.stdin });
}
var d10, y13, C13, b15, P12;
var init_chunk_JP44OYZS = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-JP44OYZS.js"() {
    init_chunk_OJDRYQWQ();
    init_chunk_74CEPOFO();
    d10 = { name: "bash", summary: "execute shell commands or scripts", usage: "bash [OPTIONS] [SCRIPT_FILE] [ARGUMENTS...]", options: ["-c COMMAND  execute COMMAND string", "    --help  display this help and exit"], notes: ["Without -c, reads and executes commands from SCRIPT_FILE.", "Arguments are passed as $1, $2, etc. to the script.", '$0 is set to the script name (or "bash" with -c).'] };
    y13 = { name: "bash", async execute(t6, e7) {
      if (o2(t6)) return s(d10);
      if (t6[0] === "-c" && t6.length >= 2) {
        let r8 = t6[1], s9 = t6[2] || "bash", c15 = t6.slice(3);
        return i4(r8, s9, c15, e7);
      }
      if (t6.length === 0) return e7.stdin?.trim() ? i4(e7.stdin, "bash", [], e7) : { stdout: "", stderr: "", exitCode: 0 };
      let n23 = t6[0], o9 = t6.slice(1);
      try {
        let r8 = e7.fs.resolvePath(e7.cwd, n23), s9 = await e7.fs.readFile(r8);
        return i4(s9, n23, o9, e7);
      } catch {
        return { stdout: "", stderr: `bash: ${n23}: No such file or directory
`, exitCode: 127 };
      }
    } };
    C13 = { name: "sh", async execute(t6, e7) {
      if (o2(t6)) return s({ ...d10, name: "sh", summary: "execute shell commands or scripts (POSIX shell)" });
      if (t6[0] === "-c" && t6.length >= 2) {
        let r8 = t6[1], s9 = t6[2] || "sh", c15 = t6.slice(3);
        return i4(r8, s9, c15, e7);
      }
      if (t6.length === 0) return e7.stdin?.trim() ? i4(e7.stdin, "sh", [], e7) : { stdout: "", stderr: "", exitCode: 0 };
      let n23 = t6[0], o9 = t6.slice(1);
      try {
        let r8 = e7.fs.resolvePath(e7.cwd, n23), s9 = await e7.fs.readFile(r8);
        return i4(s9, n23, o9, e7);
      } catch {
        return { stdout: "", stderr: `sh: ${n23}: No such file or directory
`, exitCode: 127 };
      }
    } };
    b15 = { name: "bash", flags: [{ flag: "-c", type: "value", valueHint: "string" }], stdinType: "text" };
    P12 = { name: "sh", flags: [{ flag: "-c", type: "value", valueHint: "string" }], stdinType: "text" };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/bash-DYXMG247.js
var bash_DYXMG247_exports = {};
__export(bash_DYXMG247_exports, {
  bashCommand: () => y13,
  flagsForFuzzing: () => b15,
  shCommand: () => C13,
  shFlagsForFuzzing: () => P12
});
var init_bash_DYXMG247 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/bash-DYXMG247.js"() {
    init_chunk_JP44OYZS();
    init_chunk_OJDRYQWQ();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-7MKBHGLS.js
function o6(e7) {
  return !n20.has(e7);
}
function u6(e7, t6, r8) {
  o6(t6) && (e7[t6] = r8);
}
function c10(e7, t6) {
  return Object.hasOwn(e7, t6);
}
function s4(e7) {
  return Object.assign(/* @__PURE__ */ Object.create(null), e7);
}
function i5(...e7) {
  return Object.assign(/* @__PURE__ */ Object.create(null), ...e7);
}
var n20, f10;
var init_chunk_7MKBHGLS = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-7MKBHGLS.js"() {
    n20 = /* @__PURE__ */ new Set(["__proto__", "constructor", "prototype"]);
    f10 = /* @__PURE__ */ new Set([...n20, "__defineGetter__", "__defineSetter__", "__lookupGetter__", "__lookupSetter__", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"]);
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-FRDGR5VK.js
function W8(t6, r8, e7, n23, p17, i10, u11, c15, s9, f11) {
  switch (r8) {
    case "sort":
      return Array.isArray(t6) ? [[...t6].sort(u11)] : [null];
    case "sort_by":
      return !Array.isArray(t6) || e7.length === 0 ? [null] : [[...t6].sort((h17, y18) => {
        let a7 = p17(h17, e7[0], n23)[0], l8 = p17(y18, e7[0], n23)[0];
        return u11(a7, l8);
      })];
    case "bsearch": {
      if (!Array.isArray(t6)) {
        let h17 = t6 === null ? "null" : typeof t6 == "object" ? "object" : typeof t6;
        throw new Error(`${h17} (${JSON.stringify(t6)}) cannot be searched from`);
      }
      return e7.length === 0 ? [null] : p17(t6, e7[0], n23).map((h17) => {
        let y18 = 0, a7 = t6.length;
        for (; y18 < a7; ) {
          let l8 = y18 + a7 >>> 1;
          u11(t6[l8], h17) < 0 ? y18 = l8 + 1 : a7 = l8;
        }
        return y18 < t6.length && u11(t6[y18], h17) === 0 ? y18 : -y18 - 1;
      });
    }
    case "unique_by": {
      if (!Array.isArray(t6) || e7.length === 0) return [null];
      let o9 = /* @__PURE__ */ new Map();
      for (let y18 of t6) {
        let a7 = p17(y18, e7[0], n23)[0], l8 = JSON.stringify(a7);
        o9.has(l8) || o9.set(l8, { item: y18, key: a7 });
      }
      let h17 = [...o9.values()];
      return h17.sort((y18, a7) => u11(y18.key, a7.key)), [h17.map((y18) => y18.item)];
    }
    case "group_by": {
      if (!Array.isArray(t6) || e7.length === 0) return [null];
      let o9 = /* @__PURE__ */ new Map();
      for (let h17 of t6) {
        let y18 = JSON.stringify(p17(h17, e7[0], n23)[0]);
        o9.has(y18) || o9.set(y18, []), o9.get(y18)?.push(h17);
      }
      return [[...o9.values()]];
    }
    case "max":
      return Array.isArray(t6) && t6.length > 0 ? [t6.reduce((o9, h17) => u11(o9, h17) > 0 ? o9 : h17)] : [null];
    case "max_by":
      return !Array.isArray(t6) || t6.length === 0 || e7.length === 0 ? [null] : [t6.reduce((o9, h17) => {
        let y18 = p17(o9, e7[0], n23)[0], a7 = p17(h17, e7[0], n23)[0];
        return u11(y18, a7) > 0 ? o9 : h17;
      })];
    case "min":
      return Array.isArray(t6) && t6.length > 0 ? [t6.reduce((o9, h17) => u11(o9, h17) < 0 ? o9 : h17)] : [null];
    case "min_by":
      return !Array.isArray(t6) || t6.length === 0 || e7.length === 0 ? [null] : [t6.reduce((o9, h17) => {
        let y18 = p17(o9, e7[0], n23)[0], a7 = p17(h17, e7[0], n23)[0];
        return u11(y18, a7) < 0 ? o9 : h17;
      })];
    case "add": {
      let o9 = (h17) => {
        let y18 = h17.filter((a7) => a7 !== null);
        return y18.length === 0 ? null : y18.every((a7) => typeof a7 == "number") ? y18.reduce((a7, l8) => a7 + l8, 0) : y18.every((a7) => typeof a7 == "string") ? y18.join("") : y18.every((a7) => Array.isArray(a7)) ? y18.flat() : y18.every((a7) => a7 && typeof a7 == "object" && !Array.isArray(a7)) ? c3(...y18) : null;
      };
      if (e7.length >= 1) {
        let h17 = p17(t6, e7[0], n23);
        return [o9(h17)];
      }
      return Array.isArray(t6) ? [o9(t6)] : [null];
    }
    case "any": {
      if (e7.length >= 2) {
        try {
          let o9 = i10(t6, e7[0], n23);
          for (let h17 of o9) if (p17(h17, e7[1], n23).some(c15)) return [true];
        } catch (o9) {
          if (o9 instanceof f11) throw o9;
        }
        return [false];
      }
      return e7.length === 1 ? Array.isArray(t6) ? [t6.some((o9) => c15(p17(o9, e7[0], n23)[0]))] : [false] : Array.isArray(t6) ? [t6.some(c15)] : [false];
    }
    case "all": {
      if (e7.length >= 2) {
        try {
          let o9 = i10(t6, e7[0], n23);
          for (let h17 of o9) if (!p17(h17, e7[1], n23).some(c15)) return [false];
        } catch (o9) {
          if (o9 instanceof f11) throw o9;
        }
        return [true];
      }
      return e7.length === 1 ? Array.isArray(t6) ? [t6.every((o9) => c15(p17(o9, e7[0], n23)[0]))] : [true] : Array.isArray(t6) ? [t6.every(c15)] : [true];
    }
    case "select":
      return e7.length === 0 ? [t6] : p17(t6, e7[0], n23).some(c15) ? [t6] : [];
    case "map":
      return e7.length === 0 || !Array.isArray(t6) ? [null] : [t6.flatMap((h17) => p17(h17, e7[0], n23))];
    case "map_values": {
      if (e7.length === 0) return [null];
      if (Array.isArray(t6)) return [t6.flatMap((o9) => p17(o9, e7[0], n23))];
      if (t6 && typeof t6 == "object") {
        let o9 = /* @__PURE__ */ Object.create(null);
        for (let [h17, y18] of Object.entries(t6)) {
          if (!o6(h17)) continue;
          let a7 = p17(y18, e7[0], n23);
          a7.length > 0 && u6(o9, h17, a7[0]);
        }
        return [o9];
      }
      return [null];
    }
    case "has": {
      if (e7.length === 0) return [false];
      let h17 = p17(t6, e7[0], n23)[0];
      return Array.isArray(t6) && typeof h17 == "number" ? [h17 >= 0 && h17 < t6.length] : t6 && typeof t6 == "object" && typeof h17 == "string" ? [c10(t6, h17)] : [false];
    }
    case "in": {
      if (e7.length === 0) return [false];
      let h17 = p17(t6, e7[0], n23)[0];
      return Array.isArray(h17) && typeof t6 == "number" ? [t6 >= 0 && t6 < h17.length] : h17 && typeof h17 == "object" && typeof t6 == "string" ? [c10(h17, t6)] : [false];
    }
    case "contains": {
      if (e7.length === 0) return [false];
      let o9 = p17(t6, e7[0], n23);
      return [s9(t6, o9[0])];
    }
    case "inside": {
      if (e7.length === 0) return [false];
      let o9 = p17(t6, e7[0], n23);
      return [s9(o9[0], t6)];
    }
    default:
      return null;
  }
}
function Q8(t6, r8, e7, n23, p17, i10, u11, c15) {
  switch (r8) {
    case "first":
      if (e7.length > 0) try {
        let s9 = i10(t6, e7[0], n23);
        return s9.length > 0 ? [s9[0]] : [];
      } catch (s9) {
        if (s9 instanceof c15) throw s9;
        return [];
      }
      return Array.isArray(t6) && t6.length > 0 ? [t6[0]] : [null];
    case "last":
      if (e7.length > 0) {
        let s9 = p17(t6, e7[0], n23);
        return s9.length > 0 ? [s9[s9.length - 1]] : [];
      }
      return Array.isArray(t6) && t6.length > 0 ? [t6[t6.length - 1]] : [null];
    case "nth": {
      if (e7.length < 1) return [null];
      let s9 = p17(t6, e7[0], n23);
      if (e7.length > 1) {
        for (let o9 of s9) if (o9 < 0) throw new Error("nth doesn't support negative indices");
        let f11;
        try {
          f11 = i10(t6, e7[1], n23);
        } catch (o9) {
          if (o9 instanceof c15) throw o9;
          f11 = [];
        }
        return s9.flatMap((o9) => {
          let h17 = o9;
          return h17 < f11.length ? [f11[h17]] : [];
        });
      }
      return Array.isArray(t6) ? s9.flatMap((f11) => {
        let o9 = f11;
        if (o9 < 0) throw new Error("nth doesn't support negative indices");
        return o9 < t6.length ? [t6[o9]] : [null];
      }) : [null];
    }
    case "range": {
      if (e7.length === 0) return [];
      let s9 = p17(t6, e7[0], n23);
      if (e7.length === 1) {
        let y18 = [];
        for (let a7 of s9) {
          let l8 = a7;
          for (let m25 = 0; m25 < l8; m25++) y18.push(m25);
        }
        return y18;
      }
      let f11 = p17(t6, e7[1], n23);
      if (e7.length === 2) {
        let y18 = [];
        for (let a7 of s9) for (let l8 of f11) {
          let m25 = a7, A14 = l8;
          for (let E13 = m25; E13 < A14; E13++) y18.push(E13);
        }
        return y18;
      }
      let o9 = p17(t6, e7[2], n23), h17 = [];
      for (let y18 of s9) for (let a7 of f11) for (let l8 of o9) {
        let m25 = y18, A14 = a7, E13 = l8;
        if (E13 !== 0) if (E13 > 0) for (let w19 = m25; w19 < A14; w19 += E13) h17.push(w19);
        else for (let w19 = m25; w19 > A14; w19 += E13) h17.push(w19);
      }
      return h17;
    }
    case "limit":
      return e7.length < 2 ? [] : p17(t6, e7[0], n23).flatMap((f11) => {
        let o9 = f11;
        if (o9 < 0) throw new Error("limit doesn't support negative count");
        if (o9 === 0) return [];
        let h17;
        try {
          h17 = i10(t6, e7[1], n23);
        } catch (y18) {
          if (y18 instanceof c15) throw y18;
          h17 = [];
        }
        return h17.slice(0, o9);
      });
    case "isempty": {
      if (e7.length < 1) return [true];
      try {
        return [i10(t6, e7[0], n23).length === 0];
      } catch (s9) {
        if (s9 instanceof c15) throw s9;
        return [true];
      }
    }
    case "isvalid": {
      if (e7.length < 1) return [true];
      try {
        return [p17(t6, e7[0], n23).length > 0];
      } catch (s9) {
        if (s9 instanceof c15) throw s9;
        return [false];
      }
    }
    case "skip":
      return e7.length < 2 ? [] : p17(t6, e7[0], n23).flatMap((f11) => {
        let o9 = f11;
        if (o9 < 0) throw new Error("skip doesn't support negative count");
        return p17(t6, e7[1], n23).slice(o9);
      });
    case "until": {
      if (e7.length < 2) return [t6];
      let s9 = t6, f11 = n23.limits.maxIterations;
      for (let o9 = 0; o9 < f11; o9++) {
        if (p17(s9, e7[0], n23).some(u11)) return [s9];
        let y18 = p17(s9, e7[1], n23);
        if (y18.length === 0) return [s9];
        s9 = y18[0];
      }
      throw new c15(`jq until: too many iterations (${f11}), increase executionLimits.maxJqIterations`, "iterations");
    }
    case "while": {
      if (e7.length < 2) return [t6];
      let s9 = [], f11 = t6, o9 = n23.limits.maxIterations;
      for (let h17 = 0; h17 < o9 && p17(f11, e7[0], n23).some(u11); h17++) {
        s9.push(f11);
        let a7 = p17(f11, e7[1], n23);
        if (a7.length === 0) break;
        f11 = a7[0];
      }
      if (s9.length >= o9) throw new c15(`jq while: too many iterations (${o9}), increase executionLimits.maxJqIterations`, "iterations");
      return s9;
    }
    case "repeat": {
      if (e7.length === 0) return [t6];
      let s9 = [], f11 = t6, o9 = n23.limits.maxIterations;
      for (let h17 = 0; h17 < o9; h17++) {
        s9.push(f11);
        let y18 = p17(f11, e7[0], n23);
        if (y18.length === 0) break;
        f11 = y18[0];
      }
      if (s9.length >= o9) throw new c15(`jq repeat: too many iterations (${o9}), increase executionLimits.maxJqIterations`, "iterations");
      return s9;
    }
    default:
      return null;
  }
}
function Z7(t6, r8, e7, n23, p17) {
  switch (r8) {
    case "now":
      return [Date.now() / 1e3];
    case "gmtime": {
      if (typeof t6 != "number") return [null];
      let i10 = new Date(t6 * 1e3), u11 = i10.getUTCFullYear(), c15 = i10.getUTCMonth(), s9 = i10.getUTCDate(), f11 = i10.getUTCHours(), o9 = i10.getUTCMinutes(), h17 = i10.getUTCSeconds(), y18 = i10.getUTCDay(), a7 = Date.UTC(u11, 0, 1), l8 = Math.floor((i10.getTime() - a7) / (1440 * 60 * 1e3));
      return [[u11, c15, s9, f11, o9, h17, y18, l8]];
    }
    case "mktime": {
      if (!Array.isArray(t6)) throw new Error("mktime requires parsed datetime inputs");
      let [i10, u11, c15, s9 = 0, f11 = 0, o9 = 0] = t6;
      if (typeof i10 != "number" || typeof u11 != "number") throw new Error("mktime requires parsed datetime inputs");
      let h17 = Date.UTC(i10, u11, c15 ?? 1, s9 ?? 0, f11 ?? 0, o9 ?? 0);
      return [Math.floor(h17 / 1e3)];
    }
    case "strftime": {
      if (e7.length === 0) return [null];
      let u11 = p17(t6, e7[0], n23)[0];
      if (typeof u11 != "string") throw new Error("strftime/1 requires a string format");
      let c15;
      if (typeof t6 == "number") c15 = new Date(t6 * 1e3);
      else if (Array.isArray(t6)) {
        let [y18, a7, l8, m25 = 0, A14 = 0, E13 = 0] = t6;
        if (typeof y18 != "number" || typeof a7 != "number") throw new Error("strftime/1 requires parsed datetime inputs");
        c15 = new Date(Date.UTC(y18, a7, l8 ?? 1, m25 ?? 0, A14 ?? 0, E13 ?? 0));
      } else throw new Error("strftime/1 requires parsed datetime inputs");
      let s9 = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], f11 = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], o9 = (y18, a7 = 2) => String(y18).padStart(a7, "0");
      return [u11.replace(/%Y/g, String(c15.getUTCFullYear())).replace(/%m/g, o9(c15.getUTCMonth() + 1)).replace(/%d/g, o9(c15.getUTCDate())).replace(/%H/g, o9(c15.getUTCHours())).replace(/%M/g, o9(c15.getUTCMinutes())).replace(/%S/g, o9(c15.getUTCSeconds())).replace(/%A/g, s9[c15.getUTCDay()]).replace(/%B/g, f11[c15.getUTCMonth()]).replace(/%Z/g, "UTC").replace(/%%/g, "%")];
    }
    case "strptime": {
      if (e7.length === 0) return [null];
      if (typeof t6 != "string") throw new Error("strptime/1 requires a string input");
      let u11 = p17(t6, e7[0], n23)[0];
      if (typeof u11 != "string") throw new Error("strptime/1 requires a string format");
      if (u11 === "%Y-%m-%dT%H:%M:%SZ") {
        let s9 = t6.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})Z$/);
        if (s9) {
          let [, f11, o9, h17, y18, a7, l8] = s9.map(Number), m25 = new Date(Date.UTC(f11, o9 - 1, h17, y18, a7, l8)), A14 = m25.getUTCDay(), E13 = Date.UTC(f11, 0, 1), w19 = Math.floor((m25.getTime() - E13) / (1440 * 60 * 1e3));
          return [[f11, o9 - 1, h17, y18, a7, l8, A14, w19]];
        }
      }
      let c15 = new Date(t6);
      if (!Number.isNaN(c15.getTime())) {
        let s9 = c15.getUTCFullYear(), f11 = c15.getUTCMonth(), o9 = c15.getUTCDate(), h17 = c15.getUTCHours(), y18 = c15.getUTCMinutes(), a7 = c15.getUTCSeconds(), l8 = c15.getUTCDay(), m25 = Date.UTC(s9, 0, 1), A14 = Math.floor((c15.getTime() - m25) / (1440 * 60 * 1e3));
        return [[s9, f11, o9, h17, y18, a7, l8, A14]];
      }
      throw new Error(`Cannot parse date: ${t6}`);
    }
    case "fromdate": {
      if (typeof t6 != "string") throw new Error("fromdate requires a string input");
      let i10 = new Date(t6);
      if (Number.isNaN(i10.getTime())) throw new Error(`date "${t6}" does not match format "%Y-%m-%dT%H:%M:%SZ"`);
      return [Math.floor(i10.getTime() / 1e3)];
    }
    case "todate": {
      if (typeof t6 != "number") throw new Error("todate requires a number input");
      return [new Date(t6 * 1e3).toISOString().replace(/\.\d{3}Z$/, "Z")];
    }
    default:
      return null;
  }
}
function N12(t6) {
  return t6 !== false && t6 !== null;
}
function R5(t6, r8) {
  return JSON.stringify(t6) === JSON.stringify(r8);
}
function D9(t6, r8) {
  return typeof t6 == "number" && typeof r8 == "number" ? t6 - r8 : typeof t6 == "string" && typeof r8 == "string" ? t6.localeCompare(r8) : 0;
}
function z6(t6, r8) {
  let e7 = s4(t6);
  for (let n23 of Object.keys(r8)) o6(n23) && (c10(e7, n23) && e7[n23] && typeof e7[n23] == "object" && !Array.isArray(e7[n23]) && r8[n23] && typeof r8[n23] == "object" && !Array.isArray(r8[n23]) ? u6(e7, n23, z6(e7[n23], r8[n23])) : u6(e7, n23, r8[n23]));
  return e7;
}
function M7(t6, r8 = 3e3) {
  let e7 = 0, n23 = t6;
  for (; e7 < r8; ) if (Array.isArray(n23)) {
    if (n23.length === 0) return e7 + 1;
    n23 = n23[0], e7++;
  } else if (n23 !== null && typeof n23 == "object") {
    let p17 = Object.keys(n23);
    if (p17.length === 0) return e7 + 1;
    n23 = n23[p17[0]], e7++;
  } else return e7;
  return e7;
}
function L11(t6, r8) {
  let e7 = (i10) => i10 === null ? 0 : typeof i10 == "boolean" ? 1 : typeof i10 == "number" ? 2 : typeof i10 == "string" ? 3 : Array.isArray(i10) ? 4 : typeof i10 == "object" ? 5 : 6, n23 = e7(t6), p17 = e7(r8);
  if (n23 !== p17) return n23 - p17;
  if (typeof t6 == "number" && typeof r8 == "number") return t6 - r8;
  if (typeof t6 == "string" && typeof r8 == "string") return t6.localeCompare(r8);
  if (typeof t6 == "boolean" && typeof r8 == "boolean") return (t6 ? 1 : 0) - (r8 ? 1 : 0);
  if (Array.isArray(t6) && Array.isArray(r8)) {
    for (let i10 = 0; i10 < Math.min(t6.length, r8.length); i10++) {
      let u11 = L11(t6[i10], r8[i10]);
      if (u11 !== 0) return u11;
    }
    return t6.length - r8.length;
  }
  if (t6 && r8 && typeof t6 == "object" && typeof r8 == "object") {
    let i10 = t6, u11 = r8, c15 = Object.keys(i10).sort(), s9 = Object.keys(u11).sort();
    for (let f11 = 0; f11 < Math.min(c15.length, s9.length); f11++) {
      let o9 = c15[f11].localeCompare(s9[f11]);
      if (o9 !== 0) return o9;
    }
    if (c15.length !== s9.length) return c15.length - s9.length;
    for (let f11 of c15) {
      let o9 = L11(i10[f11], u11[f11]);
      if (o9 !== 0) return o9;
    }
  }
  return 0;
}
function _6(t6, r8) {
  if (R5(t6, r8)) return true;
  if (typeof t6 == "string" && typeof r8 == "string") return t6.includes(r8);
  if (Array.isArray(t6) && Array.isArray(r8)) return r8.every((e7) => t6.some((n23) => _6(n23, e7)));
  if (t6 && r8 && typeof t6 == "object" && typeof r8 == "object" && !Array.isArray(t6) && !Array.isArray(r8)) {
    let e7 = t6, n23 = r8;
    return Object.keys(n23).every((p17) => c10(e7, p17) && _6(e7[p17], n23[p17]));
  }
  return false;
}
function v16(t6, r8, e7) {
  switch (r8) {
    case "@base64":
      return typeof t6 == "string" ? typeof Buffer < "u" ? [Buffer.from(t6, "utf-8").toString("base64")] : [btoa(t6)] : [null];
    case "@base64d":
      return typeof t6 == "string" ? typeof Buffer < "u" ? [Buffer.from(t6, "base64").toString("utf-8")] : [atob(t6)] : [null];
    case "@uri":
      return typeof t6 == "string" ? [encodeURIComponent(t6).replace(/!/g, "%21").replace(/'/g, "%27").replace(/\(/g, "%28").replace(/\)/g, "%29").replace(/\*/g, "%2A")] : [null];
    case "@urid":
      return typeof t6 == "string" ? [decodeURIComponent(t6)] : [null];
    case "@csv":
      return Array.isArray(t6) ? [t6.map((p17) => {
        if (p17 === null) return "";
        if (typeof p17 == "boolean") return p17 ? "true" : "false";
        if (typeof p17 == "number") return String(p17);
        let i10 = String(p17);
        return i10.includes(",") || i10.includes('"') || i10.includes(`
`) || i10.includes("\r") ? `"${i10.replace(/"/g, '""')}"` : i10;
      }).join(",")] : [null];
    case "@tsv":
      return Array.isArray(t6) ? [t6.map((n23) => String(n23 ?? "").replace(/\t/g, "\\t").replace(/\n/g, "\\n")).join("	")] : [null];
    case "@json": {
      let n23 = e7 ?? Et3;
      return M7(t6, n23 + 1) > n23 ? [null] : [JSON.stringify(t6)];
    }
    case "@html":
      return typeof t6 == "string" ? [t6.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/'/g, "&apos;").replace(/"/g, "&quot;")] : [null];
    case "@sh":
      return typeof t6 == "string" ? [`'${t6.replace(/'/g, "'\\''")}'`] : [null];
    case "@text":
      return typeof t6 == "string" ? [t6] : t6 == null ? [""] : [String(t6)];
    default:
      return null;
  }
}
function tt3(t6, r8, e7, n23, p17, i10) {
  switch (r8) {
    case "index":
      return e7.length === 0 ? [null] : p17(t6, e7[0], n23).map((c15) => {
        if (typeof t6 == "string" && typeof c15 == "string") {
          if (c15 === "" && t6 === "") return null;
          let s9 = t6.indexOf(c15);
          return s9 >= 0 ? s9 : null;
        }
        if (Array.isArray(t6)) {
          if (Array.isArray(c15)) {
            for (let f11 = 0; f11 <= t6.length - c15.length; f11++) {
              let o9 = true;
              for (let h17 = 0; h17 < c15.length; h17++) if (!i10(t6[f11 + h17], c15[h17])) {
                o9 = false;
                break;
              }
              if (o9) return f11;
            }
            return null;
          }
          let s9 = t6.findIndex((f11) => i10(f11, c15));
          return s9 >= 0 ? s9 : null;
        }
        return null;
      });
    case "rindex":
      return e7.length === 0 ? [null] : p17(t6, e7[0], n23).map((c15) => {
        if (typeof t6 == "string" && typeof c15 == "string") {
          let s9 = t6.lastIndexOf(c15);
          return s9 >= 0 ? s9 : null;
        }
        if (Array.isArray(t6)) {
          if (Array.isArray(c15)) {
            for (let s9 = t6.length - c15.length; s9 >= 0; s9--) {
              let f11 = true;
              for (let o9 = 0; o9 < c15.length; o9++) if (!i10(t6[s9 + o9], c15[o9])) {
                f11 = false;
                break;
              }
              if (f11) return s9;
            }
            return null;
          }
          for (let s9 = t6.length - 1; s9 >= 0; s9--) if (i10(t6[s9], c15)) return s9;
          return null;
        }
        return null;
      });
    case "indices":
      return e7.length === 0 ? [[]] : p17(t6, e7[0], n23).map((c15) => {
        let s9 = [];
        if (typeof t6 == "string" && typeof c15 == "string") {
          let f11 = t6.indexOf(c15);
          for (; f11 !== -1; ) s9.push(f11), f11 = t6.indexOf(c15, f11 + 1);
        } else if (Array.isArray(t6)) if (Array.isArray(c15)) {
          let f11 = c15.length;
          if (f11 === 0) for (let o9 = 0; o9 <= t6.length; o9++) s9.push(o9);
          else for (let o9 = 0; o9 <= t6.length - f11; o9++) {
            let h17 = true;
            for (let y18 = 0; y18 < f11; y18++) if (!i10(t6[o9 + y18], c15[y18])) {
              h17 = false;
              break;
            }
            h17 && s9.push(o9);
          }
        } else for (let f11 = 0; f11 < t6.length; f11++) i10(t6[f11], c15) && s9.push(f11);
        return s9;
      });
    default:
      return null;
  }
}
function et3(t6, r8, e7, n23, p17) {
  switch (r8) {
    case "fabs":
    case "abs":
      return typeof t6 == "number" ? [Math.abs(t6)] : typeof t6 == "string" ? [t6] : [null];
    case "exp10":
      return typeof t6 == "number" ? [10 ** t6] : [null];
    case "exp2":
      return typeof t6 == "number" ? [2 ** t6] : [null];
    case "pow": {
      if (e7.length < 2) return [null];
      let i10 = p17(t6, e7[0], n23), u11 = p17(t6, e7[1], n23), c15 = i10[0], s9 = u11[0];
      return typeof c15 != "number" || typeof s9 != "number" ? [null] : [c15 ** s9];
    }
    case "atan2": {
      if (e7.length < 2) return [null];
      let i10 = p17(t6, e7[0], n23), u11 = p17(t6, e7[1], n23), c15 = i10[0], s9 = u11[0];
      return typeof c15 != "number" || typeof s9 != "number" ? [null] : [Math.atan2(c15, s9)];
    }
    case "hypot": {
      if (typeof t6 != "number" || e7.length === 0) return [null];
      let i10 = p17(t6, e7[0], n23)[0];
      return [Math.hypot(t6, i10)];
    }
    case "fma": {
      if (typeof t6 != "number" || e7.length < 2) return [null];
      let i10 = p17(t6, e7[0], n23)[0], u11 = p17(t6, e7[1], n23)[0];
      return [t6 * i10 + u11];
    }
    case "copysign": {
      if (typeof t6 != "number" || e7.length === 0) return [null];
      let i10 = p17(t6, e7[0], n23)[0];
      return [Math.sign(i10) * Math.abs(t6)];
    }
    case "drem":
    case "remainder": {
      if (typeof t6 != "number" || e7.length === 0) return [null];
      let i10 = p17(t6, e7[0], n23)[0];
      return [t6 - Math.round(t6 / i10) * i10];
    }
    case "fdim": {
      if (typeof t6 != "number" || e7.length === 0) return [null];
      let i10 = p17(t6, e7[0], n23)[0];
      return [Math.max(0, t6 - i10)];
    }
    case "fmax": {
      if (typeof t6 != "number" || e7.length === 0) return [null];
      let i10 = p17(t6, e7[0], n23)[0];
      return [Math.max(t6, i10)];
    }
    case "fmin": {
      if (typeof t6 != "number" || e7.length === 0) return [null];
      let i10 = p17(t6, e7[0], n23)[0];
      return [Math.min(t6, i10)];
    }
    case "ldexp": {
      if (typeof t6 != "number" || e7.length === 0) return [null];
      let i10 = p17(t6, e7[0], n23)[0];
      return [t6 * 2 ** i10];
    }
    case "scalbn":
    case "scalbln": {
      if (typeof t6 != "number" || e7.length === 0) return [null];
      let i10 = p17(t6, e7[0], n23)[0];
      return [t6 * 2 ** i10];
    }
    case "nearbyint":
      return typeof t6 == "number" ? [Math.round(t6)] : [null];
    case "logb":
      return typeof t6 == "number" ? [Math.floor(Math.log2(Math.abs(t6)))] : [null];
    case "significand":
      if (typeof t6 == "number") {
        let i10 = Math.floor(Math.log2(Math.abs(t6)));
        return [t6 / 2 ** i10];
      }
      return [null];
    case "frexp":
      if (typeof t6 == "number") {
        if (t6 === 0) return [[0, 0]];
        let i10 = Math.floor(Math.log2(Math.abs(t6))) + 1;
        return [[t6 / 2 ** i10, i10]];
      }
      return [null];
    case "modf":
      if (typeof t6 == "number") {
        let i10 = Math.trunc(t6);
        return [[t6 - i10, i10]];
      }
      return [null];
    default:
      return null;
  }
}
function rt3(t6, r8, e7, n23, p17, i10, u11, c15) {
  switch (r8) {
    case "recurse": {
      if (e7.length === 0) {
        let a7 = [], l8 = (m25) => {
          if (a7.push(m25), Array.isArray(m25)) for (let A14 of m25) l8(A14);
          else if (m25 && typeof m25 == "object") for (let A14 of Object.keys(m25)) l8(m25[A14]);
        };
        return l8(t6), a7;
      }
      let s9 = [], f11 = e7.length >= 2 ? e7[1] : null, o9 = 1e4, h17 = 0, y18 = (a7) => {
        if (h17++ > o9 || f11 && !p17(a7, f11, n23).some(i10)) return;
        s9.push(a7);
        let l8 = p17(a7, e7[0], n23);
        for (let m25 of l8) m25 != null && y18(m25);
      };
      return y18(t6), s9;
    }
    case "recurse_down":
      return c15(t6, "recurse", e7, n23);
    case "walk": {
      if (e7.length === 0) return [t6];
      let s9 = /* @__PURE__ */ new WeakSet(), f11 = (o9) => {
        if (o9 && typeof o9 == "object") {
          if (s9.has(o9)) return o9;
          s9.add(o9);
        }
        let h17;
        if (Array.isArray(o9)) h17 = o9.map(f11);
        else if (o9 && typeof o9 == "object") {
          let a7 = /* @__PURE__ */ Object.create(null);
          for (let [l8, m25] of Object.entries(o9)) o6(l8) && u6(a7, l8, f11(m25));
          h17 = a7;
        } else h17 = o9;
        return p17(h17, e7[0], n23)[0];
      };
      return [f11(t6)];
    }
    case "transpose": {
      if (!Array.isArray(t6)) return [null];
      if (t6.length === 0) return [[]];
      let s9 = Math.max(...t6.map((o9) => Array.isArray(o9) ? o9.length : 0)), f11 = [];
      for (let o9 = 0; o9 < s9; o9++) f11.push(t6.map((h17) => Array.isArray(h17) ? h17[o9] : null));
      return [f11];
    }
    case "combinations": {
      if (e7.length > 0) {
        let h17 = p17(t6, e7[0], n23)[0];
        if (!Array.isArray(t6) || h17 < 0) return [];
        if (h17 === 0) return [[]];
        let y18 = [], a7 = (l8, m25) => {
          if (m25 === h17) {
            y18.push([...l8]);
            return;
          }
          for (let A14 of t6) l8.push(A14), a7(l8, m25 + 1), l8.pop();
        };
        return a7([], 0), y18;
      }
      if (!Array.isArray(t6)) return [];
      if (t6.length === 0) return [[]];
      for (let o9 of t6) if (!Array.isArray(o9)) return [];
      let s9 = [], f11 = (o9, h17) => {
        if (o9 === t6.length) {
          s9.push([...h17]);
          return;
        }
        let y18 = t6[o9];
        for (let a7 of y18) h17.push(a7), f11(o9 + 1, h17), h17.pop();
      };
      return f11(0, []), s9;
    }
    case "parent": {
      if (n23.root === void 0 || n23.currentPath === void 0) return [];
      let s9 = n23.currentPath;
      if (s9.length === 0) return [];
      let f11 = e7.length > 0 ? p17(t6, e7[0], n23)[0] : 1;
      if (f11 >= 0) {
        if (f11 > s9.length) return [];
        let o9 = s9.slice(0, s9.length - f11);
        return [u11(n23.root, o9)];
      } else {
        let o9 = -f11 - 1;
        if (o9 >= s9.length) return [t6];
        let h17 = s9.slice(0, o9);
        return [u11(n23.root, h17)];
      }
    }
    case "parents": {
      if (n23.root === void 0 || n23.currentPath === void 0) return [[]];
      let s9 = n23.currentPath, f11 = [];
      for (let o9 = s9.length - 1; o9 >= 0; o9--) f11.push(u11(n23.root, s9.slice(0, o9)));
      return [f11];
    }
    case "root":
      return n23.root !== void 0 ? [n23.root] : [];
    default:
      return null;
  }
}
function nt3(t6, r8, e7, n23, p17) {
  switch (r8) {
    case "keys":
      return Array.isArray(t6) ? [t6.map((i10, u11) => u11)] : t6 && typeof t6 == "object" ? [Object.keys(t6).sort()] : [null];
    case "keys_unsorted":
      return Array.isArray(t6) ? [t6.map((i10, u11) => u11)] : t6 && typeof t6 == "object" ? [Object.keys(t6)] : [null];
    case "length":
      return typeof t6 == "string" ? [t6.length] : Array.isArray(t6) ? [t6.length] : t6 && typeof t6 == "object" ? [Object.keys(t6).length] : t6 === null ? [0] : typeof t6 == "number" ? [Math.abs(t6)] : [null];
    case "utf8bytelength": {
      if (typeof t6 == "string") return [new TextEncoder().encode(t6).length];
      let i10 = t6 === null ? "null" : Array.isArray(t6) ? "array" : typeof t6, u11 = i10 === "array" || i10 === "object" ? JSON.stringify(t6) : String(t6);
      throw new Error(`${i10} (${u11}) only strings have UTF-8 byte length`);
    }
    case "to_entries":
      return t6 && typeof t6 == "object" && !Array.isArray(t6) ? [Object.entries(t6).map(([i10, u11]) => ({ key: i10, value: u11 }))] : [null];
    case "from_entries":
      if (Array.isArray(t6)) {
        let i10 = /* @__PURE__ */ Object.create(null);
        for (let u11 of t6) if (u11 && typeof u11 == "object") {
          let c15 = u11, s9 = c15.key ?? c15.Key ?? c15.name ?? c15.Name ?? c15.k, f11 = c15.value ?? c15.Value ?? c15.v;
          if (s9 !== void 0) {
            let o9 = String(s9);
            o6(o9) && u6(i10, o9, f11);
          }
        }
        return [i10];
      }
      return [null];
    case "with_entries": {
      if (e7.length === 0) return [t6];
      if (t6 && typeof t6 == "object" && !Array.isArray(t6)) {
        let u11 = Object.entries(t6).map(([s9, f11]) => ({ key: s9, value: f11 })).flatMap((s9) => p17(s9, e7[0], n23)), c15 = /* @__PURE__ */ Object.create(null);
        for (let s9 of u11) if (s9 && typeof s9 == "object") {
          let f11 = s9, o9 = f11.key ?? f11.name ?? f11.k, h17 = f11.value ?? f11.v;
          if (o9 !== void 0) {
            let y18 = String(o9);
            o6(y18) && u6(c15, y18, h17);
          }
        }
        return [c15];
      }
      return [null];
    }
    case "reverse":
      return Array.isArray(t6) ? [[...t6].reverse()] : typeof t6 == "string" ? [t6.split("").reverse().join("")] : [null];
    case "flatten":
      return Array.isArray(t6) ? (e7.length > 0 ? p17(t6, e7[0], n23) : [Number.POSITIVE_INFINITY]).map((u11) => {
        let c15 = u11;
        if (c15 < 0) throw new Error("flatten depth must not be negative");
        return t6.flat(c15);
      }) : [null];
    case "unique":
      if (Array.isArray(t6)) {
        let i10 = /* @__PURE__ */ new Set(), u11 = [];
        for (let c15 of t6) {
          let s9 = JSON.stringify(c15);
          i10.has(s9) || (i10.add(s9), u11.push(c15));
        }
        return [u11];
      }
      return [null];
    case "tojson":
    case "tojsonstream": {
      let i10 = n23.limits.maxDepth ?? wt3;
      return M7(t6, i10 + 1) > i10 ? [null] : [JSON.stringify(t6)];
    }
    case "fromjson": {
      if (typeof t6 == "string") {
        let i10 = t6.trim().toLowerCase();
        if (i10 === "nan") return [Number.NaN];
        if (i10 === "inf" || i10 === "infinity") return [Number.POSITIVE_INFINITY];
        if (i10 === "-inf" || i10 === "-infinity") return [Number.NEGATIVE_INFINITY];
        try {
          return [JSON.parse(t6)];
        } catch {
          throw new Error(`Invalid JSON: ${t6}`);
        }
      }
      return [t6];
    }
    case "tostring":
      return typeof t6 == "string" ? [t6] : [JSON.stringify(t6)];
    case "tonumber":
      if (typeof t6 == "number") return [t6];
      if (typeof t6 == "string") {
        let i10 = Number(t6);
        if (Number.isNaN(i10)) throw new Error(`${JSON.stringify(t6)} cannot be parsed as a number`);
        return [i10];
      }
      throw new Error(`${typeof t6} cannot be parsed as a number`);
    case "toboolean": {
      if (typeof t6 == "boolean") return [t6];
      if (typeof t6 == "string") {
        if (t6 === "true") return [true];
        if (t6 === "false") return [false];
        throw new Error(`string (${JSON.stringify(t6)}) cannot be parsed as a boolean`);
      }
      let i10 = t6 === null ? "null" : Array.isArray(t6) ? "array" : typeof t6, u11 = i10 === "array" || i10 === "object" ? JSON.stringify(t6) : String(t6);
      throw new Error(`${i10} (${u11}) cannot be parsed as a boolean`);
    }
    case "tostream": {
      let i10 = [], u11 = (c15, s9) => {
        if (c15 === null || typeof c15 != "object") i10.push([s9, c15]);
        else if (Array.isArray(c15)) if (c15.length === 0) i10.push([s9, []]);
        else for (let f11 = 0; f11 < c15.length; f11++) u11(c15[f11], [...s9, f11]);
        else {
          let f11 = Object.keys(c15);
          if (f11.length === 0) i10.push([s9, /* @__PURE__ */ Object.create(null)]);
          else for (let o9 of f11) u11(c15[o9], [...s9, o9]);
        }
      };
      return u11(t6, []), i10.push([[]]), i10;
    }
    case "fromstream": {
      if (e7.length === 0) return [t6];
      let i10 = p17(t6, e7[0], n23), u11 = null;
      for (let c15 of i10) {
        if (!Array.isArray(c15) || c15.length === 1 && Array.isArray(c15[0]) && c15[0].length === 0 || c15.length !== 2) continue;
        let [s9, f11] = c15;
        if (!Array.isArray(s9)) continue;
        if (s9.length === 0) {
          u11 = f11;
          continue;
        }
        u11 === null && (u11 = typeof s9[0] == "number" ? [] : {});
        let o9 = u11;
        for (let y18 = 0; y18 < s9.length - 1; y18++) {
          let a7 = s9[y18], l8 = s9[y18 + 1];
          if (Array.isArray(o9) && typeof a7 == "number") {
            for (; o9.length <= a7; ) o9.push(null);
            o9[a7] === null && (o9[a7] = typeof l8 == "number" ? [] : {}), o9 = o9[a7];
          } else if (o9 && typeof o9 == "object" && !Array.isArray(o9)) {
            let m25 = String(a7);
            if (!o6(m25)) continue;
            let A14 = o9;
            (A14[m25] === null || A14[m25] === void 0) && u6(A14, m25, typeof l8 == "number" ? [] : {}), o9 = A14[m25];
          }
        }
        let h17 = s9[s9.length - 1];
        if (Array.isArray(o9) && typeof h17 == "number") {
          for (; o9.length <= h17; ) o9.push(null);
          o9[h17] = f11;
        } else if (o9 && typeof o9 == "object" && !Array.isArray(o9)) {
          let y18 = String(h17);
          o6(y18) && u6(o9, y18, f11);
        }
      }
      return [u11];
    }
    case "truncate_stream": {
      let i10 = typeof t6 == "number" ? Math.floor(t6) : 0;
      if (e7.length === 0) return [];
      let u11 = [], c15 = p17(t6, e7[0], n23);
      for (let s9 of c15) if (Array.isArray(s9)) {
        if (s9.length === 1 && Array.isArray(s9[0])) {
          let f11 = s9[0];
          f11.length > i10 && u11.push([f11.slice(i10)]);
          continue;
        }
        if (s9.length === 2 && Array.isArray(s9[0])) {
          let f11 = s9[0], o9 = s9[1];
          f11.length > i10 && u11.push([f11.slice(i10), o9]);
        }
      }
      return u11;
    }
    default:
      return null;
  }
}
function st3(t6, r8, e7, n23, p17, i10, u11, c15, s9, f11) {
  switch (r8) {
    case "getpath": {
      if (e7.length === 0) return [null];
      let o9 = p17(t6, e7[0], n23), h17 = [];
      for (let y18 of o9) {
        let a7 = y18, l8 = t6;
        for (let m25 of a7) {
          if (l8 == null) {
            l8 = null;
            break;
          }
          if (Array.isArray(l8) && typeof m25 == "number") l8 = l8[m25];
          else if (typeof l8 == "object" && typeof m25 == "string") {
            let A14 = l8;
            if (!Object.hasOwn(A14, m25)) {
              l8 = null;
              break;
            }
            l8 = A14[m25];
          } else {
            l8 = null;
            break;
          }
        }
        h17.push(l8);
      }
      return h17;
    }
    case "setpath": {
      if (e7.length < 2) return [null];
      let h17 = p17(t6, e7[0], n23)[0], a7 = p17(t6, e7[1], n23)[0];
      return [u11(t6, h17, a7)];
    }
    case "delpaths": {
      if (e7.length === 0) return [t6];
      let h17 = p17(t6, e7[0], n23)[0], y18 = t6;
      for (let a7 of h17.sort((l8, m25) => m25.length - l8.length)) y18 = c15(y18, a7);
      return [y18];
    }
    case "path": {
      if (e7.length === 0) return [[]];
      let o9 = [];
      return f11(t6, e7[0], n23, [], o9), o9;
    }
    case "del":
      return e7.length === 0 ? [t6] : [s9(t6, e7[0], n23)];
    case "pick": {
      if (e7.length === 0) return [null];
      let o9 = [];
      for (let y18 of e7) f11(t6, y18, n23, [], o9);
      let h17 = null;
      for (let y18 of o9) {
        for (let l8 of y18) if (typeof l8 == "number" && l8 < 0) throw new Error("Out of bounds negative array index");
        let a7 = t6;
        for (let l8 of y18) {
          if (a7 == null) break;
          if (Array.isArray(a7) && typeof l8 == "number") a7 = a7[l8];
          else if (typeof a7 == "object" && typeof l8 == "string") {
            let m25 = a7;
            if (!Object.hasOwn(m25, l8)) {
              a7 = null;
              break;
            }
            a7 = m25[l8];
          } else {
            a7 = null;
            break;
          }
        }
        h17 = u11(h17, y18, a7);
      }
      return [h17];
    }
    case "paths": {
      let o9 = [], h17 = (y18, a7) => {
        if (y18 && typeof y18 == "object") if (Array.isArray(y18)) for (let l8 = 0; l8 < y18.length; l8++) o9.push([...a7, l8]), h17(y18[l8], [...a7, l8]);
        else for (let l8 of Object.keys(y18)) o9.push([...a7, l8]), h17(y18[l8], [...a7, l8]);
      };
      return h17(t6, []), e7.length > 0 ? o9.filter((y18) => {
        let a7 = t6;
        for (let m25 of y18) if (Array.isArray(a7) && typeof m25 == "number") a7 = a7[m25];
        else if (a7 && typeof a7 == "object" && typeof m25 == "string") {
          let A14 = a7;
          if (!Object.hasOwn(A14, m25)) return false;
          a7 = A14[m25];
        } else return false;
        return p17(a7, e7[0], n23).some(i10);
      }) : o9;
    }
    case "leaf_paths": {
      let o9 = [], h17 = (y18, a7) => {
        if (y18 === null || typeof y18 != "object") o9.push(a7);
        else if (Array.isArray(y18)) for (let l8 = 0; l8 < y18.length; l8++) h17(y18[l8], [...a7, l8]);
        else for (let l8 of Object.keys(y18)) h17(y18[l8], [...a7, l8]);
      };
      return h17(t6, []), o9;
    }
    default:
      return null;
  }
}
function it3(t6, r8, e7, n23, p17, i10) {
  switch (r8) {
    case "IN": {
      if (e7.length === 0) return [false];
      if (e7.length === 1) {
        let f11 = p17(t6, e7[0], n23);
        for (let o9 of f11) if (i10(t6, o9)) return [true];
        return [false];
      }
      let u11 = p17(t6, e7[0], n23), c15 = p17(t6, e7[1], n23), s9 = new Set(c15.map((f11) => JSON.stringify(f11)));
      for (let f11 of u11) if (s9.has(JSON.stringify(f11))) return [true];
      return [false];
    }
    case "INDEX": {
      if (e7.length === 0) return [{}];
      if (e7.length === 1) {
        let s9 = p17(t6, e7[0], n23), f11 = /* @__PURE__ */ Object.create(null);
        for (let o9 of s9) {
          let h17 = String(o9);
          o6(h17) && u6(f11, h17, o9);
        }
        return [f11];
      }
      if (e7.length === 2) {
        let s9 = p17(t6, e7[0], n23), f11 = /* @__PURE__ */ Object.create(null);
        for (let o9 of s9) {
          let h17 = p17(o9, e7[1], n23);
          if (h17.length > 0) {
            let y18 = String(h17[0]);
            o6(y18) && u6(f11, y18, o9);
          }
        }
        return [f11];
      }
      let u11 = p17(t6, e7[0], n23), c15 = /* @__PURE__ */ Object.create(null);
      for (let s9 of u11) {
        let f11 = p17(s9, e7[1], n23), o9 = p17(s9, e7[2], n23);
        if (f11.length > 0 && o9.length > 0) {
          let h17 = String(f11[0]);
          o6(h17) && u6(c15, h17, o9[0]);
        }
      }
      return [c15];
    }
    case "JOIN": {
      if (e7.length < 2) return [null];
      let u11 = p17(t6, e7[0], n23)[0];
      if (!u11 || typeof u11 != "object" || Array.isArray(u11)) return [null];
      let c15 = u11;
      if (!Array.isArray(t6)) return [null];
      let s9 = [];
      for (let f11 of t6) {
        let o9 = p17(f11, e7[1], n23), h17 = o9.length > 0 ? String(o9[0]) : "", y18 = c10(c15, h17) ? c15[h17] : null;
        s9.push([f11, y18]);
      }
      return [s9];
    }
    default:
      return null;
  }
}
function ot3(t6, r8, e7, n23, p17) {
  switch (r8) {
    case "join": {
      if (!Array.isArray(t6)) return [null];
      let i10 = e7.length > 0 ? p17(t6, e7[0], n23) : [""];
      for (let u11 of t6) if (Array.isArray(u11) || u11 !== null && typeof u11 == "object") throw new Error("cannot join: contains arrays or objects");
      return i10.map((u11) => t6.map((c15) => c15 === null ? "" : typeof c15 == "string" ? c15 : String(c15)).join(String(u11)));
    }
    case "split": {
      if (typeof t6 != "string" || e7.length === 0) return [null];
      let i10 = p17(t6, e7[0], n23), u11 = String(i10[0]);
      return [t6.split(u11)];
    }
    case "splits": {
      if (typeof t6 != "string" || e7.length === 0) return [];
      let i10 = p17(t6, e7[0], n23), u11 = String(i10[0]);
      try {
        let c15 = e7.length > 1 ? String(p17(t6, e7[1], n23)[0]) : "g";
        return b1(u11, c15.includes("g") ? c15 : `${c15}g`).split(t6);
      } catch {
        return [];
      }
    }
    case "scan": {
      if (typeof t6 != "string" || e7.length === 0) return [];
      let i10 = p17(t6, e7[0], n23), u11 = String(i10[0]);
      try {
        let c15 = e7.length > 1 ? String(p17(t6, e7[1], n23)[0]) : "";
        return [...b1(u11, c15.includes("g") ? c15 : `${c15}g`).matchAll(t6)].map((o9) => o9.length > 1 ? o9.slice(1) : o9[0]);
      } catch {
        return [];
      }
    }
    case "test": {
      if (typeof t6 != "string" || e7.length === 0) return [false];
      let i10 = p17(t6, e7[0], n23), u11 = String(i10[0]);
      try {
        let c15 = e7.length > 1 ? String(p17(t6, e7[1], n23)[0]) : "";
        return [b1(u11, c15).test(t6)];
      } catch {
        return [false];
      }
    }
    case "match": {
      if (typeof t6 != "string" || e7.length === 0) return [null];
      let i10 = p17(t6, e7[0], n23), u11 = String(i10[0]);
      try {
        let c15 = e7.length > 1 ? String(p17(t6, e7[1], n23)[0]) : "", f11 = b1(u11, `${c15}d`).exec(t6);
        if (!f11) return [];
        let o9 = f11.indices;
        return [{ offset: f11.index, length: f11[0].length, string: f11[0], captures: f11.slice(1).map((h17, y18) => ({ offset: o9?.[y18 + 1]?.[0] ?? null, length: h17?.length ?? 0, string: h17 ?? "", name: null })) }];
      } catch {
        return [null];
      }
    }
    case "capture": {
      if (typeof t6 != "string" || e7.length === 0) return [null];
      let i10 = p17(t6, e7[0], n23), u11 = String(i10[0]);
      try {
        let c15 = e7.length > 1 ? String(p17(t6, e7[1], n23)[0]) : "", f11 = b1(u11, c15).match(t6);
        return !f11 || !f11.groups ? [{}] : [f11.groups];
      } catch {
        return [null];
      }
    }
    case "sub": {
      if (typeof t6 != "string" || e7.length < 2) return [null];
      let i10 = p17(t6, e7[0], n23), u11 = p17(t6, e7[1], n23), c15 = String(i10[0]), s9 = String(u11[0]);
      try {
        let f11 = e7.length > 2 ? String(p17(t6, e7[2], n23)[0]) : "";
        return [b1(c15, f11).replace(t6, s9)];
      } catch {
        return [t6];
      }
    }
    case "gsub": {
      if (typeof t6 != "string" || e7.length < 2) return [null];
      let i10 = p17(t6, e7[0], n23), u11 = p17(t6, e7[1], n23), c15 = String(i10[0]), s9 = String(u11[0]);
      try {
        let f11 = e7.length > 2 ? String(p17(t6, e7[2], n23)[0]) : "g", o9 = f11.includes("g") ? f11 : `${f11}g`;
        return [b1(c15, o9).replace(t6, s9)];
      } catch {
        return [t6];
      }
    }
    case "ascii_downcase":
      return typeof t6 == "string" ? [t6.replace(/[A-Z]/g, (i10) => String.fromCharCode(i10.charCodeAt(0) + 32))] : [null];
    case "ascii_upcase":
      return typeof t6 == "string" ? [t6.replace(/[a-z]/g, (i10) => String.fromCharCode(i10.charCodeAt(0) - 32))] : [null];
    case "ltrimstr": {
      if (typeof t6 != "string" || e7.length === 0) return [t6];
      let i10 = p17(t6, e7[0], n23), u11 = String(i10[0]);
      return [t6.startsWith(u11) ? t6.slice(u11.length) : t6];
    }
    case "rtrimstr": {
      if (typeof t6 != "string" || e7.length === 0) return [t6];
      let i10 = p17(t6, e7[0], n23), u11 = String(i10[0]);
      return u11 === "" ? [t6] : [t6.endsWith(u11) ? t6.slice(0, -u11.length) : t6];
    }
    case "trimstr": {
      if (typeof t6 != "string" || e7.length === 0) return [t6];
      let i10 = p17(t6, e7[0], n23), u11 = String(i10[0]);
      if (u11 === "") return [t6];
      let c15 = t6;
      return c15.startsWith(u11) && (c15 = c15.slice(u11.length)), c15.endsWith(u11) && (c15 = c15.slice(0, -u11.length)), [c15];
    }
    case "trim":
      if (typeof t6 == "string") return [t6.trim()];
      throw new Error("trim input must be a string");
    case "ltrim":
      if (typeof t6 == "string") return [t6.trimStart()];
      throw new Error("trim input must be a string");
    case "rtrim":
      if (typeof t6 == "string") return [t6.trimEnd()];
      throw new Error("trim input must be a string");
    case "startswith": {
      if (typeof t6 != "string" || e7.length === 0) return [false];
      let i10 = p17(t6, e7[0], n23);
      return [t6.startsWith(String(i10[0]))];
    }
    case "endswith": {
      if (typeof t6 != "string" || e7.length === 0) return [false];
      let i10 = p17(t6, e7[0], n23);
      return [t6.endsWith(String(i10[0]))];
    }
    case "ascii":
      return typeof t6 == "string" && t6.length > 0 ? [t6.charCodeAt(0)] : [null];
    case "explode":
      return typeof t6 == "string" ? [Array.from(t6).map((i10) => i10.codePointAt(0))] : [null];
    case "implode":
      if (!Array.isArray(t6)) throw new Error("implode input must be an array");
      return [t6.map((c15) => {
        if (typeof c15 == "string") throw new Error(`string (${JSON.stringify(c15)}) can't be imploded, unicode codepoint needs to be numeric`);
        if (typeof c15 != "number" || Number.isNaN(c15)) throw new Error("number (null) can't be imploded, unicode codepoint needs to be numeric");
        let s9 = Math.trunc(c15);
        return s9 < 0 || s9 > 1114111 || s9 >= 55296 && s9 <= 57343 ? String.fromCodePoint(65533) : String.fromCodePoint(s9);
      }).join("")];
    default:
      return null;
  }
}
function ft3(t6, r8) {
  switch (r8) {
    case "type":
      return t6 === null ? ["null"] : Array.isArray(t6) ? ["array"] : typeof t6 == "boolean" ? ["boolean"] : typeof t6 == "number" ? ["number"] : typeof t6 == "string" ? ["string"] : typeof t6 == "object" ? ["object"] : ["null"];
    case "infinite":
      return [Number.POSITIVE_INFINITY];
    case "nan":
      return [Number.NaN];
    case "isinfinite":
      return [typeof t6 == "number" && !Number.isFinite(t6)];
    case "isnan":
      return [typeof t6 == "number" && Number.isNaN(t6)];
    case "isnormal":
      return [typeof t6 == "number" && Number.isFinite(t6) && t6 !== 0];
    case "isfinite":
      return [typeof t6 == "number" && Number.isFinite(t6)];
    case "numbers":
      return typeof t6 == "number" ? [t6] : [];
    case "strings":
      return typeof t6 == "string" ? [t6] : [];
    case "booleans":
      return typeof t6 == "boolean" ? [t6] : [];
    case "nulls":
      return t6 === null ? [t6] : [];
    case "arrays":
      return Array.isArray(t6) ? [t6] : [];
    case "objects":
      return t6 && typeof t6 == "object" && !Array.isArray(t6) ? [t6] : [];
    case "iterables":
      return Array.isArray(t6) || t6 && typeof t6 == "object" && !Array.isArray(t6) ? [t6] : [];
    case "scalars":
      return !Array.isArray(t6) && !(t6 && typeof t6 == "object") ? [t6] : [];
    case "values":
      return t6 === null ? [] : [t6];
    case "not":
      return t6 === false || t6 === null ? [true] : [false];
    case "null":
      return [null];
    case "true":
      return [true];
    case "false":
      return [false];
    case "empty":
      return [];
    default:
      return null;
  }
}
function $12(t6, r8, e7) {
  if (r8.length === 0) return e7;
  let [n23, ...p17] = r8;
  if (typeof n23 == "number") {
    if (t6 && typeof t6 == "object" && !Array.isArray(t6)) throw new Error("Cannot index object with number");
    if (n23 > 536870911) throw new Error("Array index too large");
    if (n23 < 0) throw new Error("Out of bounds negative array index");
    let s9 = Array.isArray(t6) ? [...t6] : [];
    for (; s9.length <= n23; ) s9.push(null);
    return s9[n23] = $12(s9[n23], p17, e7), s9;
  }
  if (Array.isArray(t6)) throw new Error("Cannot index array with string");
  if (!o6(n23)) return t6 ?? /* @__PURE__ */ Object.create(null);
  let i10 = t6 && typeof t6 == "object" && !Array.isArray(t6) ? s4(t6) : /* @__PURE__ */ Object.create(null), u11 = Object.hasOwn(i10, n23) ? i10[n23] : void 0;
  return u6(i10, n23, $12(u11, p17, e7)), i10;
}
function F11(t6, r8) {
  if (r8.length === 0) return null;
  if (r8.length === 1) {
    let p17 = r8[0];
    if (Array.isArray(t6) && typeof p17 == "number") {
      let i10 = [...t6];
      return i10.splice(p17, 1), i10;
    }
    if (t6 && typeof t6 == "object" && !Array.isArray(t6)) {
      let i10 = String(p17);
      if (!o6(i10)) return t6;
      let u11 = s4(t6);
      return delete u11[i10], u11;
    }
    return t6;
  }
  let [e7, ...n23] = r8;
  if (Array.isArray(t6) && typeof e7 == "number") {
    let p17 = [...t6];
    return p17[e7] = F11(p17[e7], n23), p17;
  }
  if (t6 && typeof t6 == "object" && !Array.isArray(t6)) {
    let p17 = String(e7);
    if (!o6(p17)) return t6;
    let i10 = s4(t6);
    return Object.hasOwn(i10, p17) && u6(i10, p17, F11(i10[p17], n23)), i10;
  }
  return t6;
}
function Ot3(t6) {
  return { vars: /* @__PURE__ */ new Map(), limits: { maxIterations: t6?.limits?.maxIterations ?? kt3, maxDepth: t6?.limits?.maxDepth ?? lt3 }, env: t6?.env, coverage: t6?.coverage };
}
function J9(t6, r8, e7) {
  let n23 = new Map(t6.vars);
  return n23.set(r8, e7), { vars: n23, limits: t6.limits, env: t6.env, root: t6.root, currentPath: t6.currentPath, funcs: t6.funcs, labels: t6.labels, coverage: t6.coverage };
}
function B6(t6, r8, e7) {
  switch (r8.type) {
    case "var":
      return J9(t6, r8.name, e7);
    case "array": {
      if (!Array.isArray(e7)) return null;
      let n23 = t6;
      for (let p17 = 0; p17 < r8.elements.length; p17++) {
        let i10 = r8.elements[p17], u11 = p17 < e7.length ? e7[p17] : null, c15 = B6(n23, i10, u11);
        if (c15 === null) return null;
        n23 = c15;
      }
      return n23;
    }
    case "object": {
      if (e7 === null || typeof e7 != "object" || Array.isArray(e7)) return null;
      let n23 = e7, p17 = t6;
      for (let i10 of r8.fields) {
        let u11;
        if (typeof i10.key == "string") u11 = i10.key;
        else {
          let f11 = d11(e7, i10.key, t6);
          if (f11.length === 0) return null;
          u11 = String(f11[0]);
        }
        let c15 = c10(n23, u11) ? n23[u11] : null;
        i10.keyVar && (p17 = J9(p17, i10.keyVar, c15));
        let s9 = B6(p17, i10.pattern, c15);
        if (s9 === null) return null;
        p17 = s9;
      }
      return p17;
    }
  }
}
function St3(t6, r8) {
  let e7 = t6;
  for (let n23 of r8) if (e7 && typeof e7 == "object") if (Array.isArray(e7)) if (typeof n23 == "number") e7 = e7[n23];
  else return;
  else {
    let p17 = e7;
    if (typeof n23 == "string" && Object.hasOwn(p17, n23)) e7 = p17[n23];
    else return;
  }
  else return;
  return e7;
}
function T6(t6) {
  if (t6.type === "Identity") return [];
  if (t6.type === "Field") {
    let r8 = t6.base ? T6(t6.base) : [];
    return r8 === null ? null : [...r8, t6.name];
  }
  if (t6.type === "Index" && t6.index.type === "Literal") {
    let r8 = t6.base ? T6(t6.base) : [];
    if (r8 === null) return null;
    let e7 = t6.index.value;
    return typeof e7 == "number" || typeof e7 == "string" ? [...r8, e7] : null;
  }
  if (t6.type === "Pipe") {
    let r8 = T6(t6.left);
    return r8 === null ? null : ct3(r8, t6.right);
  }
  if (t6.type === "Call") {
    if (t6.name === "parent" || t6.name === "root") return null;
    if (t6.name === "first" && t6.args.length === 0) return [0];
    if (t6.name === "last" && t6.args.length === 0) return [-1];
  }
  return null;
}
function ct3(t6, r8) {
  if (r8.type === "Call") {
    if (r8.name === "parent") {
      let e7 = 1;
      if (r8.args.length > 0 && r8.args[0].type === "Literal") {
        let n23 = r8.args[0].value;
        typeof n23 == "number" && (e7 = n23);
      }
      if (e7 >= 0) return t6.slice(0, Math.max(0, t6.length - e7));
      {
        let n23 = -e7 - 1;
        return t6.slice(0, Math.min(n23, t6.length));
      }
    }
    if (r8.name === "root") return [];
  }
  if (r8.type === "Field") {
    let e7 = T6(r8);
    if (e7 !== null) return [...t6, ...e7];
  }
  if (r8.type === "Index" && r8.index.type === "Literal") {
    let e7 = T6(r8);
    if (e7 !== null) return [...t6, ...e7];
  }
  if (r8.type === "Pipe") {
    let e7 = ct3(t6, r8.left);
    return e7 === null ? null : ct3(e7, r8.right);
  }
  return r8.type === "Identity" ? t6 : null;
}
function yt3(t6, r8, e7) {
  if (r8.type === "Comma") {
    let n23 = [];
    try {
      n23.push(...d11(t6, r8.left, e7));
    } catch (p17) {
      if (p17 instanceof b2) throw p17;
      if (n23.length > 0) return n23;
      throw new Error("evaluation failed");
    }
    try {
      n23.push(...d11(t6, r8.right, e7));
    } catch (p17) {
      if (p17 instanceof b2) throw p17;
      return n23;
    }
    return n23;
  }
  return d11(t6, r8, e7);
}
function d11(t6, r8, e7) {
  let n23 = e7 && "vars" in e7 ? e7 : Ot3(e7);
  switch (n23.root === void 0 && (n23 = { ...n23, root: t6, currentPath: [] }), n23.coverage?.hit(`jq:node:${r8.type}`), r8.type) {
    case "Identity":
      return [t6];
    case "Field":
      return (r8.base ? d11(t6, r8.base, n23) : [t6]).flatMap((i10) => {
        if (i10 && typeof i10 == "object" && !Array.isArray(i10)) {
          let c15 = i10;
          if (!Object.hasOwn(c15, r8.name)) return [null];
          let s9 = c15[r8.name];
          return [s9 === void 0 ? null : s9];
        }
        if (i10 === null) return [null];
        let u11 = Array.isArray(i10) ? "array" : typeof i10;
        throw new Error(`Cannot index ${u11} with string "${r8.name}"`);
      });
    case "Index":
      return (r8.base ? d11(t6, r8.base, n23) : [t6]).flatMap((i10) => d11(i10, r8.index, n23).flatMap((c15) => {
        if (typeof c15 == "number" && Array.isArray(i10)) {
          if (Number.isNaN(c15)) return [null];
          let s9 = Math.trunc(c15), f11 = s9 < 0 ? i10.length + s9 : s9;
          return f11 >= 0 && f11 < i10.length ? [i10[f11]] : [null];
        }
        if (typeof c15 == "string" && i10 && typeof i10 == "object" && !Array.isArray(i10)) {
          let s9 = i10;
          return Object.hasOwn(s9, c15) ? [s9[c15]] : [null];
        }
        return [null];
      }));
    case "Slice":
      return (r8.base ? d11(t6, r8.base, n23) : [t6]).flatMap((i10) => {
        if (i10 === null) return [null];
        if (!Array.isArray(i10) && typeof i10 != "string") throw new Error(`Cannot slice ${typeof i10} (${JSON.stringify(i10)})`);
        let u11 = i10.length, c15 = r8.start ? d11(t6, r8.start, n23) : [0], s9 = r8.end ? d11(t6, r8.end, n23) : [u11];
        return c15.flatMap((f11) => s9.map((o9) => {
          let h17 = f11, y18 = o9, a7 = Number.isNaN(h17) ? 0 : Number.isInteger(h17) ? h17 : Math.floor(h17), l8 = Number.isNaN(y18) ? u11 : Number.isInteger(y18) ? y18 : Math.ceil(y18), m25 = at3(a7, u11), A14 = at3(l8, u11);
          return Array.isArray(i10), i10.slice(m25, A14);
        }));
      });
    case "Iterate":
      return (r8.base ? d11(t6, r8.base, n23) : [t6]).flatMap((i10) => Array.isArray(i10) ? i10 : i10 && typeof i10 == "object" ? Object.values(i10) : []);
    case "Pipe": {
      let p17 = d11(t6, r8.left, n23), i10 = T6(r8.left), u11 = [];
      for (let c15 of p17) try {
        if (i10 !== null) {
          let s9 = { ...n23, currentPath: [...n23.currentPath ?? [], ...i10] };
          u11.push(...d11(c15, r8.right, s9));
        } else u11.push(...d11(c15, r8.right, n23));
      } catch (s9) {
        throw s9 instanceof I14 ? s9.withPrependedResults(u11) : s9;
      }
      return u11;
    }
    case "Comma": {
      let p17 = d11(t6, r8.left, n23), i10 = d11(t6, r8.right, n23);
      return [...p17, ...i10];
    }
    case "Literal":
      return [r8.value];
    case "Array":
      return r8.elements ? [d11(t6, r8.elements, n23)] : [[]];
    case "Object": {
      let p17 = [/* @__PURE__ */ Object.create(null)];
      for (let i10 of r8.entries) {
        let u11 = typeof i10.key == "string" ? [i10.key] : d11(t6, i10.key, n23), c15 = d11(t6, i10.value, n23), s9 = [];
        for (let f11 of p17) for (let o9 of u11) {
          if (typeof o9 != "string") {
            let h17 = o9 === null ? "null" : Array.isArray(o9) ? "array" : typeof o9;
            throw new Error(`Cannot use ${h17} (${JSON.stringify(o9)}) as object key`);
          }
          if (!o6(o9)) {
            for (let h17 of c15) s9.push(s4(f11));
            continue;
          }
          for (let h17 of c15) {
            let y18 = s4(f11);
            u6(y18, o9, h17), s9.push(y18);
          }
        }
        p17.length = 0, p17.push(...s9);
      }
      return p17;
    }
    case "Paren":
      return d11(t6, r8.expr, n23);
    case "BinaryOp":
      return jt2(t6, r8.op, r8.left, r8.right, n23);
    case "UnaryOp":
      return d11(t6, r8.operand, n23).map((i10) => {
        if (r8.op === "-") {
          if (typeof i10 == "number") return -i10;
          if (typeof i10 == "string") {
            let u11 = (c15) => c15.length > 5 ? `"${c15.slice(0, 3)}...` : JSON.stringify(c15);
            throw new Error(`string (${u11(i10)}) cannot be negated`);
          }
          return null;
        }
        return r8.op === "not" ? !N12(i10) : null;
      });
    case "Cond":
      return d11(t6, r8.cond, n23).flatMap((i10) => {
        if (N12(i10)) return d11(t6, r8.then, n23);
        for (let u11 of r8.elifs) if (d11(t6, u11.cond, n23).some(N12)) return d11(t6, u11.then, n23);
        return r8.else ? d11(t6, r8.else, n23) : [t6];
      });
    case "Try":
      try {
        return d11(t6, r8.body, n23);
      } catch (p17) {
        if (r8.catch) {
          let i10 = p17 instanceof V8 ? p17.value : p17 instanceof Error ? p17.message : String(p17);
          return d11(i10, r8.catch, n23);
        }
        return [];
      }
    case "Call":
      return mt3(t6, r8.name, r8.args, n23);
    case "VarBind":
      return d11(t6, r8.value, n23).flatMap((i10) => {
        let u11 = null, c15 = [];
        r8.pattern ? c15.push(r8.pattern) : r8.name && c15.push({ type: "var", name: r8.name }), r8.alternatives && c15.push(...r8.alternatives);
        for (let s9 of c15) if (u11 = B6(n23, s9, i10), u11 !== null) break;
        return u11 === null ? [] : d11(t6, r8.body, u11);
      });
    case "VarRef": {
      if (r8.name === "$ENV") return [n23.env ? r(n23.env) : /* @__PURE__ */ Object.create(null)];
      let p17 = n23.vars.get(r8.name);
      return p17 !== void 0 ? [p17] : [null];
    }
    case "Recurse": {
      let p17 = [], i10 = /* @__PURE__ */ new WeakSet(), u11 = (c15) => {
        if (c15 && typeof c15 == "object") {
          if (i10.has(c15)) return;
          i10.add(c15);
        }
        if (p17.push(c15), Array.isArray(c15)) for (let s9 of c15) u11(s9);
        else if (c15 && typeof c15 == "object") for (let s9 of Object.keys(c15)) u11(c15[s9]);
      };
      return u11(t6), p17;
    }
    case "Optional":
      try {
        return d11(t6, r8.expr, n23);
      } catch {
        return [];
      }
    case "StringInterp":
      return [r8.parts.map((i10) => typeof i10 == "string" ? i10 : d11(t6, i10, n23).map((c15) => typeof c15 == "string" ? c15 : JSON.stringify(c15)).join("")).join("")];
    case "UpdateOp":
      return [Tt3(t6, r8.path, r8.op, r8.value, n23)];
    case "Reduce": {
      let p17 = d11(t6, r8.expr, n23), i10 = d11(t6, r8.init, n23)[0], u11 = n23.limits.maxDepth ?? lt3;
      for (let c15 of p17) {
        let s9;
        if (r8.pattern) {
          if (s9 = B6(n23, r8.pattern, c15), s9 === null) continue;
        } else s9 = J9(n23, r8.varName, c15);
        if (i10 = d11(i10, r8.update, s9)[0], M7(i10, u11 + 1) > u11) return [null];
      }
      return [i10];
    }
    case "Foreach": {
      let p17 = d11(t6, r8.expr, n23), i10 = d11(t6, r8.init, n23)[0], u11 = [];
      for (let c15 of p17) try {
        let s9;
        if (r8.pattern) {
          if (s9 = B6(n23, r8.pattern, c15), s9 === null) continue;
        } else s9 = J9(n23, r8.varName, c15);
        if (i10 = d11(i10, r8.update, s9)[0], r8.extract) {
          let f11 = d11(i10, r8.extract, s9);
          u11.push(...f11);
        } else u11.push(i10);
      } catch (s9) {
        throw s9 instanceof I14 ? s9.withPrependedResults(u11) : s9;
      }
      return u11;
    }
    case "Label":
      try {
        return d11(t6, r8.body, { ...n23, labels: /* @__PURE__ */ new Set([...n23.labels ?? [], r8.name]) });
      } catch (p17) {
        if (p17 instanceof I14 && p17.label === r8.name) return p17.partialResults;
        throw p17;
      }
    case "Break":
      throw new I14(r8.name);
    case "Def": {
      let p17 = new Map(n23.funcs ?? []), i10 = `${r8.name}/${r8.params.length}`;
      p17.set(i10, { params: r8.params, body: r8.funcBody, closure: new Map(n23.funcs ?? []) });
      let u11 = { ...n23, funcs: p17 };
      return d11(t6, r8.body, u11);
    }
    default: {
      let p17 = r8;
      throw new Error(`Unknown AST node type: ${p17.type}`);
    }
  }
}
function at3(t6, r8) {
  return t6 < 0 ? Math.max(0, r8 + t6) : Math.min(t6, r8);
}
function Tt3(t6, r8, e7, n23, p17) {
  function i10(s9, f11) {
    switch (e7) {
      case "=":
        return f11;
      case "|=":
        return d11(s9, n23, p17)[0] ?? null;
      case "+=":
        return typeof s9 == "number" && typeof f11 == "number" || typeof s9 == "string" && typeof f11 == "string" ? s9 + f11 : Array.isArray(s9) && Array.isArray(f11) ? [...s9, ...f11] : s9 && f11 && typeof s9 == "object" && typeof f11 == "object" ? i5(s9, f11) : f11;
      case "-=":
        return typeof s9 == "number" && typeof f11 == "number" ? s9 - f11 : s9;
      case "*=":
        return typeof s9 == "number" && typeof f11 == "number" ? s9 * f11 : s9;
      case "/=":
        return typeof s9 == "number" && typeof f11 == "number" ? s9 / f11 : s9;
      case "%=":
        return typeof s9 == "number" && typeof f11 == "number" ? s9 % f11 : s9;
      case "//=":
        return s9 === null || s9 === false ? f11 : s9;
      default:
        return f11;
    }
  }
  function u11(s9, f11, o9) {
    switch (f11.type) {
      case "Identity":
        return o9(s9);
      case "Field": {
        if (!o6(f11.name)) return s9;
        if (f11.base) return u11(s9, f11.base, (h17) => {
          if (h17 && typeof h17 == "object" && !Array.isArray(h17)) {
            let y18 = s4(h17), a7 = Object.hasOwn(y18, f11.name) ? y18[f11.name] : void 0;
            return u6(y18, f11.name, o9(a7)), y18;
          }
          return h17;
        });
        if (s9 && typeof s9 == "object" && !Array.isArray(s9)) {
          let h17 = s4(s9), y18 = Object.hasOwn(h17, f11.name) ? h17[f11.name] : void 0;
          return u6(h17, f11.name, o9(y18)), h17;
        }
        return s9;
      }
      case "Index": {
        let y18 = d11(t6, f11.index, p17)[0];
        if (typeof y18 == "number" && Number.isNaN(y18)) throw new Error("Cannot set array element at NaN index");
        if (typeof y18 == "number" && !Number.isInteger(y18) && (y18 = Math.trunc(y18)), f11.base) return u11(s9, f11.base, (a7) => {
          if (typeof y18 == "number" && Array.isArray(a7)) {
            let l8 = [...a7], m25 = y18 < 0 ? l8.length + y18 : y18;
            if (m25 >= 0) {
              for (; l8.length <= m25; ) l8.push(null);
              l8[m25] = o9(l8[m25]);
            }
            return l8;
          }
          if (typeof y18 == "string" && a7 && typeof a7 == "object" && !Array.isArray(a7)) {
            if (!o6(y18)) return a7;
            let l8 = s4(a7), m25 = Object.hasOwn(l8, y18) ? l8[y18] : void 0;
            return u6(l8, y18, o9(m25)), l8;
          }
          return a7;
        });
        if (typeof y18 == "number") {
          if (y18 > 536870911) throw new Error("Array index too large");
          if (y18 < 0 && (!s9 || !Array.isArray(s9))) throw new Error("Out of bounds negative array index");
          if (Array.isArray(s9)) {
            let l8 = [...s9], m25 = y18 < 0 ? l8.length + y18 : y18;
            if (m25 >= 0) {
              for (; l8.length <= m25; ) l8.push(null);
              l8[m25] = o9(l8[m25]);
            }
            return l8;
          }
          if (s9 == null) {
            let l8 = [];
            for (; l8.length <= y18; ) l8.push(null);
            return l8[y18] = o9(null), l8;
          }
          return s9;
        }
        if (typeof y18 == "string" && s9 && typeof s9 == "object" && !Array.isArray(s9)) {
          if (!o6(y18)) return s9;
          let a7 = s4(s9), l8 = Object.hasOwn(a7, y18) ? a7[y18] : void 0;
          return u6(a7, y18, o9(l8)), a7;
        }
        return s9;
      }
      case "Iterate": {
        let h17 = (y18) => {
          if (Array.isArray(y18)) return y18.map((a7) => o9(a7));
          if (y18 && typeof y18 == "object") {
            let a7 = /* @__PURE__ */ Object.create(null);
            for (let [l8, m25] of Object.entries(y18)) o6(l8) && u6(a7, l8, o9(m25));
            return a7;
          }
          return y18;
        };
        return f11.base ? u11(s9, f11.base, h17) : h17(s9);
      }
      case "Pipe": {
        let h17 = u11(s9, f11.left, (y18) => y18);
        return u11(h17, f11.right, o9);
      }
      default:
        return o9(s9);
    }
  }
  return u11(t6, r8, (s9) => {
    if (e7 === "|=") return i10(s9, s9);
    let f11 = d11(t6, n23, p17);
    return i10(s9, f11[0] ?? null);
  });
}
function Ct3(t6, r8, e7) {
  function n23(i10, u11, c15) {
    switch (u11.type) {
      case "Identity":
        return c15;
      case "Field": {
        if (!o6(u11.name)) return i10;
        if (u11.base) {
          let s9 = d11(i10, u11.base, e7)[0], f11 = n23(s9, { type: "Field", name: u11.name }, c15);
          return n23(i10, u11.base, f11);
        }
        if (i10 && typeof i10 == "object" && !Array.isArray(i10)) {
          let s9 = s4(i10);
          return u6(s9, u11.name, c15), s9;
        }
        return i10;
      }
      case "Index": {
        if (u11.base) {
          let o9 = d11(i10, u11.base, e7)[0], h17 = n23(o9, { type: "Index", index: u11.index }, c15);
          return n23(i10, u11.base, h17);
        }
        let f11 = d11(t6, u11.index, e7)[0];
        if (typeof f11 == "number" && Array.isArray(i10)) {
          let o9 = [...i10], h17 = f11 < 0 ? o9.length + f11 : f11;
          return h17 >= 0 && h17 < o9.length && (o9[h17] = c15), o9;
        }
        if (typeof f11 == "string" && i10 && typeof i10 == "object" && !Array.isArray(i10)) {
          if (!o6(f11)) return i10;
          let o9 = s4(i10);
          return u6(o9, f11, c15), o9;
        }
        return i10;
      }
      default:
        return i10;
    }
  }
  function p17(i10, u11) {
    switch (u11.type) {
      case "Identity":
        return null;
      case "Field": {
        if (!o6(u11.name)) return i10;
        if (u11.base) {
          let s9 = d11(i10, u11.base, e7)[0];
          if (s9 == null) return i10;
          let f11 = p17(s9, { type: "Field", name: u11.name });
          return n23(i10, u11.base, f11);
        }
        if (i10 && typeof i10 == "object" && !Array.isArray(i10)) {
          if (!o6(u11.name)) return i10;
          let s9 = s4(i10);
          return delete s9[u11.name], s9;
        }
        return i10;
      }
      case "Index": {
        if (u11.base) {
          let o9 = d11(i10, u11.base, e7)[0];
          if (o9 == null) return i10;
          let h17 = p17(o9, { type: "Index", index: u11.index });
          return n23(i10, u11.base, h17);
        }
        let f11 = d11(t6, u11.index, e7)[0];
        if (typeof f11 == "number" && Array.isArray(i10)) {
          let o9 = [...i10], h17 = f11 < 0 ? o9.length + f11 : f11;
          return h17 >= 0 && h17 < o9.length && o9.splice(h17, 1), o9;
        }
        if (typeof f11 == "string" && i10 && typeof i10 == "object" && !Array.isArray(i10)) {
          if (!o6(f11)) return i10;
          let o9 = s4(i10);
          return delete o9[f11], o9;
        }
        return i10;
      }
      case "Iterate":
        return Array.isArray(i10) ? [] : i10 && typeof i10 == "object" ? /* @__PURE__ */ Object.create(null) : i10;
      case "Pipe": {
        let o9 = function(a7, l8, m25) {
          switch (l8.type) {
            case "Identity":
              return m25;
            case "Field": {
              if (!o6(l8.name)) return a7;
              if (a7 && typeof a7 == "object" && !Array.isArray(a7)) {
                let A14 = s4(a7);
                return u6(A14, l8.name, m25), A14;
              }
              return a7;
            }
            case "Index": {
              let E13 = d11(t6, l8.index, e7)[0];
              if (typeof E13 == "number" && Array.isArray(a7)) {
                let w19 = [...a7], x23 = E13 < 0 ? w19.length + E13 : E13;
                return x23 >= 0 && x23 < w19.length && (w19[x23] = m25), w19;
              }
              if (typeof E13 == "string" && a7 && typeof a7 == "object" && !Array.isArray(a7)) {
                if (!o6(E13)) return a7;
                let w19 = s4(a7);
                return u6(w19, E13, m25), w19;
              }
              return a7;
            }
            case "Pipe": {
              let A14 = d11(a7, l8.left, e7)[0], E13 = o9(A14, l8.right, m25);
              return o9(a7, l8.left, E13);
            }
            default:
              return a7;
          }
        };
        var c15 = o9;
        let s9 = u11.left, f11 = u11.right, h17 = d11(i10, s9, e7)[0];
        if (h17 == null) return i10;
        let y18 = p17(h17, f11);
        return o9(i10, s9, y18);
      }
      default:
        return i10;
    }
  }
  return p17(t6, r8);
}
function jt2(t6, r8, e7, n23, p17) {
  if (r8 === "and") return d11(t6, e7, p17).flatMap((s9) => N12(s9) ? d11(t6, n23, p17).map((o9) => N12(o9)) : [false]);
  if (r8 === "or") return d11(t6, e7, p17).flatMap((s9) => N12(s9) ? [true] : d11(t6, n23, p17).map((o9) => N12(o9)));
  if (r8 === "//") {
    let s9 = d11(t6, e7, p17).filter((f11) => f11 != null && f11 !== false);
    return s9.length > 0 ? s9 : d11(t6, n23, p17);
  }
  let i10 = d11(t6, e7, p17), u11 = d11(t6, n23, p17);
  return i10.flatMap((c15) => u11.map((s9) => {
    switch (r8) {
      case "+":
        return c15 === null ? s9 : s9 === null ? c15 : typeof c15 == "number" && typeof s9 == "number" || typeof c15 == "string" && typeof s9 == "string" ? c15 + s9 : Array.isArray(c15) && Array.isArray(s9) ? [...c15, ...s9] : c15 && s9 && typeof c15 == "object" && typeof s9 == "object" && !Array.isArray(c15) && !Array.isArray(s9) ? i5(c15, s9) : null;
      case "-":
        if (typeof c15 == "number" && typeof s9 == "number") return c15 - s9;
        if (Array.isArray(c15) && Array.isArray(s9)) {
          let f11 = new Set(s9.map((o9) => JSON.stringify(o9)));
          return c15.filter((o9) => !f11.has(JSON.stringify(o9)));
        }
        if (typeof c15 == "string" && typeof s9 == "string") {
          let f11 = (o9) => o9.length > 10 ? `"${o9.slice(0, 10)}...` : JSON.stringify(o9);
          throw new Error(`string (${f11(c15)}) and string (${f11(s9)}) cannot be subtracted`);
        }
        return null;
      case "*":
        return typeof c15 == "number" && typeof s9 == "number" ? c15 * s9 : typeof c15 == "string" && typeof s9 == "number" ? c15.repeat(s9) : c15 && s9 && typeof c15 == "object" && typeof s9 == "object" && !Array.isArray(c15) && !Array.isArray(s9) ? z6(c15, s9) : null;
      case "/":
        if (typeof c15 == "number" && typeof s9 == "number") {
          if (s9 === 0) throw new Error(`number (${c15}) and number (${s9}) cannot be divided because the divisor is zero`);
          return c15 / s9;
        }
        return typeof c15 == "string" && typeof s9 == "string" ? c15.split(s9) : null;
      case "%":
        if (typeof c15 == "number" && typeof s9 == "number") {
          if (s9 === 0) throw new Error(`number (${c15}) and number (${s9}) cannot be divided (remainder) because the divisor is zero`);
          return !Number.isFinite(c15) && !Number.isNaN(c15) ? !Number.isFinite(s9) && !Number.isNaN(s9) && c15 < 0 && s9 > 0 ? -1 : 0 : c15 % s9;
        }
        return null;
      case "==":
        return R5(c15, s9);
      case "!=":
        return !R5(c15, s9);
      case "<":
        return D9(c15, s9) < 0;
      case "<=":
        return D9(c15, s9) <= 0;
      case ">":
        return D9(c15, s9) > 0;
      case ">=":
        return D9(c15, s9) >= 0;
      default:
        return null;
    }
  }));
}
function mt3(t6, r8, e7, n23) {
  let p17 = Nt3.get(r8);
  if (p17) return typeof t6 == "number" ? [p17(t6)] : [null];
  let i10 = et3(t6, r8, e7, n23, d11);
  if (i10 !== null) return i10;
  let u11 = ot3(t6, r8, e7, n23, d11);
  if (u11 !== null) return u11;
  let c15 = Z7(t6, r8, e7, n23, d11);
  if (c15 !== null) return c15;
  let s9 = v16(t6, r8, n23.limits.maxDepth);
  if (s9 !== null) return s9;
  let f11 = ft3(t6, r8);
  if (f11 !== null) return f11;
  let o9 = nt3(t6, r8, e7, n23, d11);
  if (o9 !== null) return o9;
  let h17 = W8(t6, r8, e7, n23, d11, yt3, L11, N12, _6, b2);
  if (h17 !== null) return h17;
  let y18 = st3(t6, r8, e7, n23, d11, N12, $12, F11, Ct3, K8);
  if (y18 !== null) return y18;
  let a7 = tt3(t6, r8, e7, n23, d11, R5);
  if (a7 !== null) return a7;
  let l8 = Q8(t6, r8, e7, n23, d11, yt3, N12, b2);
  if (l8 !== null) return l8;
  let m25 = rt3(t6, r8, e7, n23, d11, N12, St3, mt3);
  if (m25 !== null) return m25;
  let A14 = it3(t6, r8, e7, n23, d11, R5);
  if (A14 !== null) return A14;
  switch (r8) {
    case "builtins":
      return [["add/0", "all/0", "all/1", "all/2", "any/0", "any/1", "any/2", "arrays/0", "ascii/0", "ascii_downcase/0", "ascii_upcase/0", "booleans/0", "bsearch/1", "builtins/0", "combinations/0", "combinations/1", "contains/1", "debug/0", "del/1", "delpaths/1", "empty/0", "env/0", "error/0", "error/1", "explode/0", "first/0", "first/1", "flatten/0", "flatten/1", "floor/0", "from_entries/0", "fromdate/0", "fromjson/0", "getpath/1", "gmtime/0", "group_by/1", "gsub/2", "gsub/3", "has/1", "implode/0", "IN/1", "IN/2", "INDEX/1", "INDEX/2", "index/1", "indices/1", "infinite/0", "inside/1", "isempty/1", "isnan/0", "isnormal/0", "isvalid/1", "iterables/0", "join/1", "keys/0", "keys_unsorted/0", "last/0", "last/1", "length/0", "limit/2", "ltrimstr/1", "map/1", "map_values/1", "match/1", "match/2", "max/0", "max_by/1", "min/0", "min_by/1", "mktime/0", "modulemeta/1", "nan/0", "not/0", "nth/1", "nth/2", "null/0", "nulls/0", "numbers/0", "objects/0", "path/1", "paths/0", "paths/1", "pick/1", "range/1", "range/2", "range/3", "recurse/0", "recurse/1", "recurse_down/0", "repeat/1", "reverse/0", "rindex/1", "rtrimstr/1", "scalars/0", "scan/1", "scan/2", "select/1", "setpath/2", "skip/2", "sort/0", "sort_by/1", "split/1", "splits/1", "splits/2", "sqrt/0", "startswith/1", "strftime/1", "strings/0", "strptime/1", "sub/2", "sub/3", "test/1", "test/2", "to_entries/0", "toboolean/0", "todate/0", "tojson/0", "tostream/0", "fromstream/1", "truncate_stream/1", "tonumber/0", "tostring/0", "transpose/0", "trim/0", "ltrim/0", "rtrim/0", "type/0", "unique/0", "unique_by/1", "until/2", "utf8bytelength/0", "values/0", "walk/1", "while/2", "with_entries/1"]];
    case "error": {
      let E13 = e7.length > 0 ? d11(t6, e7[0], n23)[0] : t6;
      throw new V8(E13);
    }
    case "env":
      return [n23.env ? r(n23.env) : /* @__PURE__ */ Object.create(null)];
    case "debug":
      return [t6];
    case "input_line_number":
      return [1];
    default: {
      let E13 = `${r8}/${e7.length}`, w19 = n23.funcs?.get(E13);
      if (w19) {
        let x23 = w19.closure ?? n23.funcs ?? /* @__PURE__ */ new Map(), Y11 = new Map(x23);
        Y11.set(E13, w19);
        for (let U14 = 0; U14 < w19.params.length; U14++) {
          let gt4 = w19.params[U14], ut7 = e7[U14];
          if (ut7) {
            let C19 = d11(t6, ut7, n23), j12;
            if (C19.length === 0) j12 = { type: "Call", name: "empty", args: [] };
            else if (C19.length === 1) j12 = { type: "Literal", value: C19[0] };
            else {
              j12 = { type: "Literal", value: C19[C19.length - 1] };
              for (let q17 = C19.length - 2; q17 >= 0; q17--) j12 = { type: "Comma", left: { type: "Literal", value: C19[q17] }, right: j12 };
            }
            Y11.set(`${gt4}/0`, { params: [], body: j12 });
          }
        }
        let bt4 = { ...n23, funcs: Y11 };
        return d11(t6, w19.body, bt4);
      }
      throw new Error(`Unknown function: ${r8}`);
    }
  }
}
function K8(t6, r8, e7, n23, p17) {
  if (r8.type === "Comma") {
    let c15 = r8;
    K8(t6, c15.left, e7, n23, p17), K8(t6, c15.right, e7, n23, p17);
    return;
  }
  let i10 = T6(r8);
  if (i10 !== null) {
    p17.push([...n23, ...i10]);
    return;
  }
  if (r8.type === "Iterate") {
    if (Array.isArray(t6)) for (let c15 = 0; c15 < t6.length; c15++) p17.push([...n23, c15]);
    else if (t6 && typeof t6 == "object") for (let c15 of Object.keys(t6)) p17.push([...n23, c15]);
    return;
  }
  if (r8.type === "Recurse") {
    let c15 = (s9, f11) => {
      if (p17.push([...n23, ...f11]), s9 && typeof s9 == "object") if (Array.isArray(s9)) for (let o9 = 0; o9 < s9.length; o9++) c15(s9[o9], [...f11, o9]);
      else for (let o9 of Object.keys(s9)) c15(s9[o9], [...f11, o9]);
    };
    c15(t6, []);
    return;
  }
  if (r8.type === "Pipe") {
    let c15 = T6(r8.left);
    if (c15 !== null) {
      let s9 = d11(t6, r8.left, e7);
      for (let f11 of s9) K8(f11, r8.right, e7, [...n23, ...c15], p17);
      return;
    }
  }
  d11(t6, r8, e7).length > 0 && p17.push(n23);
}
function At3(t6) {
  let r8 = [], e7 = 0, n23 = (f11 = 0) => t6[e7 + f11], p17 = () => t6[e7++], i10 = () => e7 >= t6.length, u11 = (f11) => f11 >= "0" && f11 <= "9", c15 = (f11) => f11 >= "a" && f11 <= "z" || f11 >= "A" && f11 <= "Z" || f11 === "_", s9 = (f11) => c15(f11) || u11(f11);
  for (; !i10(); ) {
    let f11 = e7, o9 = p17();
    if (!(o9 === " " || o9 === "	" || o9 === `
` || o9 === "\r")) {
      if (o9 === "#") {
        for (; !i10() && n23() !== `
`; ) p17();
        continue;
      }
      if (o9 === "." && n23() === ".") {
        p17(), r8.push({ type: "DOTDOT", pos: f11 });
        continue;
      }
      if (o9 === "=" && n23() === "=") {
        p17(), r8.push({ type: "EQ", pos: f11 });
        continue;
      }
      if (o9 === "!" && n23() === "=") {
        p17(), r8.push({ type: "NE", pos: f11 });
        continue;
      }
      if (o9 === "<" && n23() === "=") {
        p17(), r8.push({ type: "LE", pos: f11 });
        continue;
      }
      if (o9 === ">" && n23() === "=") {
        p17(), r8.push({ type: "GE", pos: f11 });
        continue;
      }
      if (o9 === "/" && n23() === "/") {
        p17(), n23() === "=" ? (p17(), r8.push({ type: "UPDATE_ALT", pos: f11 })) : r8.push({ type: "ALT", pos: f11 });
        continue;
      }
      if (o9 === "+" && n23() === "=") {
        p17(), r8.push({ type: "UPDATE_ADD", pos: f11 });
        continue;
      }
      if (o9 === "-" && n23() === "=") {
        p17(), r8.push({ type: "UPDATE_SUB", pos: f11 });
        continue;
      }
      if (o9 === "*" && n23() === "=") {
        p17(), r8.push({ type: "UPDATE_MUL", pos: f11 });
        continue;
      }
      if (o9 === "/" && n23() === "=") {
        p17(), r8.push({ type: "UPDATE_DIV", pos: f11 });
        continue;
      }
      if (o9 === "%" && n23() === "=") {
        p17(), r8.push({ type: "UPDATE_MOD", pos: f11 });
        continue;
      }
      if (o9 === "=" && n23() !== "=") {
        r8.push({ type: "ASSIGN", pos: f11 });
        continue;
      }
      if (o9 === ".") {
        r8.push({ type: "DOT", pos: f11 });
        continue;
      }
      if (o9 === "|") {
        n23() === "=" ? (p17(), r8.push({ type: "UPDATE_PIPE", pos: f11 })) : r8.push({ type: "PIPE", pos: f11 });
        continue;
      }
      if (o9 === ",") {
        r8.push({ type: "COMMA", pos: f11 });
        continue;
      }
      if (o9 === ":") {
        r8.push({ type: "COLON", pos: f11 });
        continue;
      }
      if (o9 === ";") {
        r8.push({ type: "SEMICOLON", pos: f11 });
        continue;
      }
      if (o9 === "(") {
        r8.push({ type: "LPAREN", pos: f11 });
        continue;
      }
      if (o9 === ")") {
        r8.push({ type: "RPAREN", pos: f11 });
        continue;
      }
      if (o9 === "[") {
        r8.push({ type: "LBRACKET", pos: f11 });
        continue;
      }
      if (o9 === "]") {
        r8.push({ type: "RBRACKET", pos: f11 });
        continue;
      }
      if (o9 === "{") {
        r8.push({ type: "LBRACE", pos: f11 });
        continue;
      }
      if (o9 === "}") {
        r8.push({ type: "RBRACE", pos: f11 });
        continue;
      }
      if (o9 === "?") {
        r8.push({ type: "QUESTION", pos: f11 });
        continue;
      }
      if (o9 === "+") {
        r8.push({ type: "PLUS", pos: f11 });
        continue;
      }
      if (o9 === "-") {
        r8.push({ type: "MINUS", pos: f11 });
        continue;
      }
      if (o9 === "*") {
        r8.push({ type: "STAR", pos: f11 });
        continue;
      }
      if (o9 === "/") {
        r8.push({ type: "SLASH", pos: f11 });
        continue;
      }
      if (o9 === "%") {
        r8.push({ type: "PERCENT", pos: f11 });
        continue;
      }
      if (o9 === "<") {
        r8.push({ type: "LT", pos: f11 });
        continue;
      }
      if (o9 === ">") {
        r8.push({ type: "GT", pos: f11 });
        continue;
      }
      if (u11(o9)) {
        let h17 = o9;
        for (; !i10() && (u11(n23()) || n23() === "." || n23() === "e" || n23() === "E"); ) (n23() === "e" || n23() === "E") && (t6[e7 + 1] === "+" || t6[e7 + 1] === "-") && (h17 += p17()), h17 += p17();
        r8.push({ type: "NUMBER", value: Number(h17), pos: f11 });
        continue;
      }
      if (o9 === '"') {
        let h17 = "";
        for (; !i10() && n23() !== '"'; ) if (n23() === "\\") {
          if (p17(), i10()) break;
          let y18 = p17();
          switch (y18) {
            case "n":
              h17 += `
`;
              break;
            case "r":
              h17 += "\r";
              break;
            case "t":
              h17 += "	";
              break;
            case "\\":
              h17 += "\\";
              break;
            case '"':
              h17 += '"';
              break;
            case "(":
              h17 += "\\(";
              break;
            default:
              h17 += y18;
          }
        } else h17 += p17();
        i10() || p17(), r8.push({ type: "STRING", value: h17, pos: f11 });
        continue;
      }
      if (c15(o9) || o9 === "$" || o9 === "@") {
        let h17 = o9;
        for (; !i10() && s9(n23()); ) h17 += p17();
        let y18 = dt3.get(h17);
        y18 ? r8.push({ type: y18, value: h17, pos: f11 }) : r8.push({ type: "IDENT", value: h17, pos: f11 });
        continue;
      }
      throw new Error(`Unexpected character '${o9}' at position ${f11}`);
    }
  }
  return r8.push({ type: "EOF", pos: e7 }), r8;
}
function ge4(t6) {
  let r8 = At3(t6);
  return new pt3(r8).parse();
}
var Et3, wt3, I14, V8, kt3, lt3, Nt3, dt3, H11, pt3;
var init_chunk_FRDGR5VK = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-FRDGR5VK.js"() {
    init_chunk_7MKBHGLS();
    init_chunk_OJDRYQWQ();
    init_chunk_YNYSPYQ5();
    init_chunk_PSW6BMXW();
    Et3 = 2e3;
    wt3 = 2e3;
    I14 = class t3 extends Error {
      label;
      partialResults;
      constructor(r8, e7 = []) {
        super(`break ${r8}`), this.label = r8, this.partialResults = e7, this.name = "BreakError";
      }
      withPrependedResults(r8) {
        return new t3(this.label, [...r8, ...this.partialResults]);
      }
    };
    V8 = class extends Error {
      value;
      constructor(r8) {
        super(typeof r8 == "string" ? r8 : JSON.stringify(r8)), this.value = r8, this.name = "JqError";
      }
    };
    kt3 = 1e4;
    lt3 = 2e3;
    Nt3 = /* @__PURE__ */ new Map([["floor", Math.floor], ["ceil", Math.ceil], ["round", Math.round], ["sqrt", Math.sqrt], ["log", Math.log], ["log10", Math.log10], ["log2", Math.log2], ["exp", Math.exp], ["sin", Math.sin], ["cos", Math.cos], ["tan", Math.tan], ["asin", Math.asin], ["acos", Math.acos], ["atan", Math.atan], ["sinh", Math.sinh], ["cosh", Math.cosh], ["tanh", Math.tanh], ["asinh", Math.asinh], ["acosh", Math.acosh], ["atanh", Math.atanh], ["cbrt", Math.cbrt], ["expm1", Math.expm1], ["log1p", Math.log1p], ["trunc", Math.trunc]]);
    dt3 = /* @__PURE__ */ new Map([["and", "AND"], ["or", "OR"], ["not", "NOT"], ["if", "IF"], ["then", "THEN"], ["elif", "ELIF"], ["else", "ELSE"], ["end", "END"], ["as", "AS"], ["try", "TRY"], ["catch", "CATCH"], ["true", "TRUE"], ["false", "FALSE"], ["null", "NULL"], ["reduce", "REDUCE"], ["foreach", "FOREACH"], ["label", "LABEL"], ["break", "BREAK"], ["def", "DEF"]]);
    H11 = new Set(dt3.values());
    pt3 = class t4 {
      tokens;
      pos = 0;
      constructor(r8) {
        this.tokens = r8;
      }
      peek(r8 = 0) {
        return this.tokens[this.pos + r8] ?? { type: "EOF", pos: -1 };
      }
      advance() {
        return this.tokens[this.pos++];
      }
      check(r8) {
        return this.peek().type === r8;
      }
      match(...r8) {
        for (let e7 of r8) if (this.check(e7)) return this.advance();
        return null;
      }
      expect(r8, e7) {
        if (!this.check(r8)) throw new Error(`${e7} at position ${this.peek().pos}, got ${this.peek().type}`);
        return this.advance();
      }
      isFieldNameAfterDot(r8 = 0) {
        let e7 = this.peek(r8), n23 = this.peek(r8 + 1);
        return n23.type === "STRING" ? true : n23.type === "IDENT" || H11.has(n23.type) ? n23.pos === e7.pos + 1 : false;
      }
      isIdentLike() {
        let r8 = this.peek().type;
        return r8 === "IDENT" || H11.has(r8);
      }
      consumeFieldNameAfterDot(r8) {
        let e7 = this.peek();
        return e7.type === "STRING" ? this.advance().value : (e7.type === "IDENT" || H11.has(e7.type)) && e7.pos === r8.pos + 1 ? this.advance().value : null;
      }
      parse() {
        let r8 = this.parseExpr();
        if (!this.check("EOF")) throw new Error(`Unexpected token ${this.peek().type} at position ${this.peek().pos}`);
        return r8;
      }
      parseExpr() {
        return this.parsePipe();
      }
      parsePattern() {
        if (this.match("LBRACKET")) {
          let n23 = [];
          if (!this.check("RBRACKET")) for (n23.push(this.parsePattern()); this.match("COMMA") && !this.check("RBRACKET"); ) n23.push(this.parsePattern());
          return this.expect("RBRACKET", "Expected ']' after array pattern"), { type: "array", elements: n23 };
        }
        if (this.match("LBRACE")) {
          let n23 = [];
          if (!this.check("RBRACE")) for (n23.push(this.parsePatternField()); this.match("COMMA") && !this.check("RBRACE"); ) n23.push(this.parsePatternField());
          return this.expect("RBRACE", "Expected '}' after object pattern"), { type: "object", fields: n23 };
        }
        let r8 = this.expect("IDENT", "Expected variable name in pattern"), e7 = r8.value;
        if (!e7.startsWith("$")) throw new Error(`Variable name must start with $ at position ${r8.pos}`);
        return { type: "var", name: e7 };
      }
      parsePatternField() {
        if (this.match("LPAREN")) {
          let e7 = this.parseExpr();
          this.expect("RPAREN", "Expected ')' after computed key"), this.expect("COLON", "Expected ':' after computed key");
          let n23 = this.parsePattern();
          return { key: e7, pattern: n23 };
        }
        let r8 = this.peek();
        if (r8.type === "IDENT" || H11.has(r8.type)) {
          let e7 = r8.value;
          if (e7.startsWith("$")) {
            if (this.advance(), this.match("COLON")) {
              let n23 = this.parsePattern();
              return { key: e7.slice(1), pattern: n23, keyVar: e7 };
            }
            return { key: e7.slice(1), pattern: { type: "var", name: e7 } };
          }
          if (this.advance(), this.match("COLON")) {
            let n23 = this.parsePattern();
            return { key: e7, pattern: n23 };
          }
          return { key: e7, pattern: { type: "var", name: `$${e7}` } };
        }
        throw new Error(`Expected field name in object pattern at position ${r8.pos}`);
      }
      parsePipe() {
        let r8 = this.parseComma();
        for (; this.match("PIPE"); ) {
          let e7 = this.parseComma();
          r8 = { type: "Pipe", left: r8, right: e7 };
        }
        return r8;
      }
      parseComma() {
        let r8 = this.parseVarBind();
        for (; this.match("COMMA"); ) {
          let e7 = this.parseVarBind();
          r8 = { type: "Comma", left: r8, right: e7 };
        }
        return r8;
      }
      parseVarBind() {
        let r8 = this.parseUpdate();
        if (this.match("AS")) {
          let e7 = this.parsePattern(), n23 = [];
          for (; this.check("QUESTION") && this.peekAhead(1)?.type === "ALT"; ) this.advance(), this.advance(), n23.push(this.parsePattern());
          this.expect("PIPE", "Expected '|' after variable binding");
          let p17 = this.parseExpr();
          return e7.type === "var" && n23.length === 0 ? { type: "VarBind", name: e7.name, value: r8, body: p17 } : { type: "VarBind", name: e7.type === "var" ? e7.name : "", value: r8, body: p17, pattern: e7.type !== "var" ? e7 : void 0, alternatives: n23.length > 0 ? n23 : void 0 };
        }
        return r8;
      }
      peekAhead(r8) {
        let e7 = this.pos + r8;
        return e7 < this.tokens.length ? this.tokens[e7] : void 0;
      }
      parseUpdate() {
        let r8 = this.parseAlt(), e7 = /* @__PURE__ */ new Map([["ASSIGN", "="], ["UPDATE_ADD", "+="], ["UPDATE_SUB", "-="], ["UPDATE_MUL", "*="], ["UPDATE_DIV", "/="], ["UPDATE_MOD", "%="], ["UPDATE_ALT", "//="], ["UPDATE_PIPE", "|="]]), n23 = this.match("ASSIGN", "UPDATE_ADD", "UPDATE_SUB", "UPDATE_MUL", "UPDATE_DIV", "UPDATE_MOD", "UPDATE_ALT", "UPDATE_PIPE");
        if (n23) {
          let p17 = this.parseVarBind(), i10 = e7.get(n23.type);
          if (i10) return { type: "UpdateOp", op: i10, path: r8, value: p17 };
        }
        return r8;
      }
      parseAlt() {
        let r8 = this.parseOr();
        for (; this.match("ALT"); ) {
          let e7 = this.parseOr();
          r8 = { type: "BinaryOp", op: "//", left: r8, right: e7 };
        }
        return r8;
      }
      parseOr() {
        let r8 = this.parseAnd();
        for (; this.match("OR"); ) {
          let e7 = this.parseAnd();
          r8 = { type: "BinaryOp", op: "or", left: r8, right: e7 };
        }
        return r8;
      }
      parseAnd() {
        let r8 = this.parseNot();
        for (; this.match("AND"); ) {
          let e7 = this.parseNot();
          r8 = { type: "BinaryOp", op: "and", left: r8, right: e7 };
        }
        return r8;
      }
      parseNot() {
        return this.parseComparison();
      }
      parseComparison() {
        let r8 = this.parseAddSub(), e7 = /* @__PURE__ */ new Map([["EQ", "=="], ["NE", "!="], ["LT", "<"], ["LE", "<="], ["GT", ">"], ["GE", ">="]]), n23 = this.match("EQ", "NE", "LT", "LE", "GT", "GE");
        if (n23) {
          let p17 = e7.get(n23.type);
          if (p17) {
            let i10 = this.parseAddSub();
            r8 = { type: "BinaryOp", op: p17, left: r8, right: i10 };
          }
        }
        return r8;
      }
      parseAddSub() {
        let r8 = this.parseMulDiv();
        for (; ; ) if (this.match("PLUS")) {
          let e7 = this.parseMulDiv();
          r8 = { type: "BinaryOp", op: "+", left: r8, right: e7 };
        } else if (this.match("MINUS")) {
          let e7 = this.parseMulDiv();
          r8 = { type: "BinaryOp", op: "-", left: r8, right: e7 };
        } else break;
        return r8;
      }
      parseMulDiv() {
        let r8 = this.parseUnary();
        for (; ; ) if (this.match("STAR")) {
          let e7 = this.parseUnary();
          r8 = { type: "BinaryOp", op: "*", left: r8, right: e7 };
        } else if (this.match("SLASH")) {
          let e7 = this.parseUnary();
          r8 = { type: "BinaryOp", op: "/", left: r8, right: e7 };
        } else if (this.match("PERCENT")) {
          let e7 = this.parseUnary();
          r8 = { type: "BinaryOp", op: "%", left: r8, right: e7 };
        } else break;
        return r8;
      }
      parseUnary() {
        return this.match("MINUS") ? { type: "UnaryOp", op: "-", operand: this.parseUnary() } : this.parsePostfix();
      }
      parsePostfix() {
        let r8 = this.parsePrimary();
        for (; ; ) if (this.match("QUESTION")) r8 = { type: "Optional", expr: r8 };
        else if (this.check("DOT") && this.isFieldNameAfterDot()) this.advance(), r8 = { type: "Field", name: this.advance().value, base: r8 };
        else if (this.check("LBRACKET")) if (this.advance(), this.match("RBRACKET")) r8 = { type: "Iterate", base: r8 };
        else if (this.check("COLON")) {
          this.advance();
          let e7 = this.check("RBRACKET") ? void 0 : this.parseExpr();
          this.expect("RBRACKET", "Expected ']'"), r8 = { type: "Slice", end: e7, base: r8 };
        } else {
          let e7 = this.parseExpr();
          if (this.match("COLON")) {
            let n23 = this.check("RBRACKET") ? void 0 : this.parseExpr();
            this.expect("RBRACKET", "Expected ']'"), r8 = { type: "Slice", start: e7, end: n23, base: r8 };
          } else this.expect("RBRACKET", "Expected ']'"), r8 = { type: "Index", index: e7, base: r8 };
        }
        else break;
        return r8;
      }
      parsePrimary() {
        if (this.match("DOTDOT")) return { type: "Recurse" };
        if (this.check("DOT")) {
          let r8 = this.advance();
          if (this.check("LBRACKET")) {
            if (this.advance(), this.match("RBRACKET")) return { type: "Iterate" };
            if (this.check("COLON")) {
              this.advance();
              let p17 = this.check("RBRACKET") ? void 0 : this.parseExpr();
              return this.expect("RBRACKET", "Expected ']'"), { type: "Slice", end: p17 };
            }
            let n23 = this.parseExpr();
            if (this.match("COLON")) {
              let p17 = this.check("RBRACKET") ? void 0 : this.parseExpr();
              return this.expect("RBRACKET", "Expected ']'"), { type: "Slice", start: n23, end: p17 };
            }
            return this.expect("RBRACKET", "Expected ']'"), { type: "Index", index: n23 };
          }
          let e7 = this.consumeFieldNameAfterDot(r8);
          return e7 !== null ? { type: "Field", name: e7 } : { type: "Identity" };
        }
        if (this.match("TRUE")) return { type: "Literal", value: true };
        if (this.match("FALSE")) return { type: "Literal", value: false };
        if (this.match("NULL")) return { type: "Literal", value: null };
        if (this.check("NUMBER")) return { type: "Literal", value: this.advance().value };
        if (this.check("STRING")) {
          let e7 = this.advance().value;
          return e7.includes("\\(") ? this.parseStringInterpolation(e7) : { type: "Literal", value: e7 };
        }
        if (this.match("LBRACKET")) {
          if (this.match("RBRACKET")) return { type: "Array" };
          let r8 = this.parseExpr();
          return this.expect("RBRACKET", "Expected ']'"), { type: "Array", elements: r8 };
        }
        if (this.match("LBRACE")) return this.parseObjectConstruction();
        if (this.match("LPAREN")) {
          let r8 = this.parseExpr();
          return this.expect("RPAREN", "Expected ')'"), { type: "Paren", expr: r8 };
        }
        if (this.match("IF")) return this.parseIf();
        if (this.match("TRY")) {
          let r8 = this.parsePostfix(), e7;
          return this.match("CATCH") && (e7 = this.parsePostfix()), { type: "Try", body: r8, catch: e7 };
        }
        if (this.match("REDUCE")) {
          let r8 = this.parseAddSub();
          this.expect("AS", "Expected 'as' after reduce expression");
          let e7 = this.parsePattern();
          this.expect("LPAREN", "Expected '(' after variable");
          let n23 = this.parseExpr();
          this.expect("SEMICOLON", "Expected ';' after init expression");
          let p17 = this.parseExpr();
          this.expect("RPAREN", "Expected ')' after update expression");
          let i10 = e7.type === "var" ? e7.name : "";
          return { type: "Reduce", expr: r8, varName: i10, init: n23, update: p17, pattern: e7.type !== "var" ? e7 : void 0 };
        }
        if (this.match("FOREACH")) {
          let r8 = this.parseAddSub();
          this.expect("AS", "Expected 'as' after foreach expression");
          let e7 = this.parsePattern();
          this.expect("LPAREN", "Expected '(' after variable");
          let n23 = this.parseExpr();
          this.expect("SEMICOLON", "Expected ';' after init expression");
          let p17 = this.parseExpr(), i10;
          this.match("SEMICOLON") && (i10 = this.parseExpr()), this.expect("RPAREN", "Expected ')' after expressions");
          let u11 = e7.type === "var" ? e7.name : "";
          return { type: "Foreach", expr: r8, varName: u11, init: n23, update: p17, extract: i10, pattern: e7.type !== "var" ? e7 : void 0 };
        }
        if (this.match("LABEL")) {
          let r8 = this.expect("IDENT", "Expected label name (e.g., $out)"), e7 = r8.value;
          if (!e7.startsWith("$")) throw new Error(`Label name must start with $ at position ${r8.pos}`);
          this.expect("PIPE", "Expected '|' after label name");
          let n23 = this.parseExpr();
          return { type: "Label", name: e7, body: n23 };
        }
        if (this.match("BREAK")) {
          let r8 = this.expect("IDENT", "Expected label name to break to"), e7 = r8.value;
          if (!e7.startsWith("$")) throw new Error(`Break label must start with $ at position ${r8.pos}`);
          return { type: "Break", name: e7 };
        }
        if (this.match("DEF")) {
          let e7 = this.expect("IDENT", "Expected function name after def").value, n23 = [];
          if (this.match("LPAREN")) {
            if (!this.check("RPAREN")) {
              let u11 = this.expect("IDENT", "Expected parameter name");
              for (n23.push(u11.value); this.match("SEMICOLON"); ) {
                let c15 = this.expect("IDENT", "Expected parameter name");
                n23.push(c15.value);
              }
            }
            this.expect("RPAREN", "Expected ')' after parameters");
          }
          this.expect("COLON", "Expected ':' after function name");
          let p17 = this.parseExpr();
          this.expect("SEMICOLON", "Expected ';' after function body");
          let i10 = this.parseExpr();
          return { type: "Def", name: e7, params: n23, funcBody: p17, body: i10 };
        }
        if (this.match("NOT")) return { type: "Call", name: "not", args: [] };
        if (this.check("IDENT")) {
          let e7 = this.advance().value;
          if (e7.startsWith("$")) return { type: "VarRef", name: e7 };
          if (this.match("LPAREN")) {
            let n23 = [];
            if (!this.check("RPAREN")) for (n23.push(this.parseExpr()); this.match("SEMICOLON"); ) n23.push(this.parseExpr());
            return this.expect("RPAREN", "Expected ')'"), { type: "Call", name: e7, args: n23 };
          }
          return { type: "Call", name: e7, args: [] };
        }
        throw new Error(`Unexpected token ${this.peek().type} at position ${this.peek().pos}`);
      }
      parseObjectConstruction() {
        let r8 = [];
        if (!this.check("RBRACE")) do {
          let e7, n23;
          if (this.match("LPAREN")) e7 = this.parseExpr(), this.expect("RPAREN", "Expected ')'"), this.expect("COLON", "Expected ':'"), n23 = this.parseObjectValue();
          else if (this.isIdentLike()) {
            let p17 = this.advance().value;
            this.match("COLON") ? (e7 = p17, n23 = this.parseObjectValue()) : (e7 = p17, n23 = { type: "Field", name: p17 });
          } else if (this.check("STRING")) e7 = this.advance().value, this.expect("COLON", "Expected ':'"), n23 = this.parseObjectValue();
          else throw new Error(`Expected object key at position ${this.peek().pos}`);
          r8.push({ key: e7, value: n23 });
        } while (this.match("COMMA"));
        return this.expect("RBRACE", "Expected '}'"), { type: "Object", entries: r8 };
      }
      parseObjectValue() {
        let r8 = this.parseVarBind();
        for (; this.match("PIPE"); ) {
          let e7 = this.parseVarBind();
          r8 = { type: "Pipe", left: r8, right: e7 };
        }
        return r8;
      }
      parseIf() {
        let r8 = this.parseExpr();
        this.expect("THEN", "Expected 'then'");
        let e7 = this.parseExpr(), n23 = [];
        for (; this.match("ELIF"); ) {
          let i10 = this.parseExpr();
          this.expect("THEN", "Expected 'then' after elif");
          let u11 = this.parseExpr();
          n23.push({ cond: i10, then: u11 });
        }
        let p17;
        return this.match("ELSE") && (p17 = this.parseExpr()), this.expect("END", "Expected 'end'"), { type: "Cond", cond: r8, then: e7, elifs: n23, else: p17 };
      }
      parseStringInterpolation(r8) {
        let e7 = [], n23 = "", p17 = 0;
        for (; p17 < r8.length; ) if (r8[p17] === "\\" && r8[p17 + 1] === "(") {
          n23 && (e7.push(n23), n23 = ""), p17 += 2;
          let i10 = 1, u11 = "";
          for (; p17 < r8.length && i10 > 0; ) r8[p17] === "(" ? i10++ : r8[p17] === ")" && i10--, i10 > 0 && (u11 += r8[p17]), p17++;
          let c15 = At3(u11), s9 = new t4(c15);
          e7.push(s9.parse());
        } else n23 += r8[p17], p17++;
        return n23 && e7.push(n23), { type: "StringInterp", parts: e7 };
      }
    };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-2OCD45J4.js
function I15(s9) {
  let r8 = [], t6 = 0, i10 = s9.length;
  for (; t6 < i10; ) {
    for (; t6 < i10 && /\s/.test(s9[t6]); ) t6++;
    if (t6 >= i10) break;
    let u11 = t6, n23 = s9[t6];
    if (n23 === "{" || n23 === "[") {
      let o9 = n23, l8 = n23 === "{" ? "}" : "]", c15 = 1, p17 = false, d16 = false;
      for (t6++; t6 < i10 && c15 > 0; ) {
        let h17 = s9[t6];
        d16 ? d16 = false : h17 === "\\" ? d16 = true : h17 === '"' ? p17 = !p17 : p17 || (h17 === o9 ? c15++ : h17 === l8 && c15--), t6++;
      }
      if (c15 !== 0) throw new Error(`Unexpected end of JSON input at position ${t6} (unclosed ${o9})`);
      r8.push(JSON.parse(s9.slice(u11, t6)));
    } else if (n23 === '"') {
      let o9 = false;
      for (t6++; t6 < i10; ) {
        let l8 = s9[t6];
        if (o9) o9 = false;
        else if (l8 === "\\") o9 = true;
        else if (l8 === '"') {
          t6++;
          break;
        }
        t6++;
      }
      r8.push(JSON.parse(s9.slice(u11, t6)));
    } else if (n23 === "-" || n23 >= "0" && n23 <= "9") {
      for (; t6 < i10 && /[\d.eE+-]/.test(s9[t6]); ) t6++;
      r8.push(JSON.parse(s9.slice(u11, t6)));
    } else if (s9.slice(t6, t6 + 4) === "true") r8.push(true), t6 += 4;
    else if (s9.slice(t6, t6 + 5) === "false") r8.push(false), t6 += 5;
    else if (s9.slice(t6, t6 + 4) === "null") r8.push(null), t6 += 4;
    else {
      let o9 = s9.slice(t6, t6 + 10);
      throw new Error(`Invalid JSON at position ${u11}: unexpected '${o9.split(/\s/)[0]}'`);
    }
  }
  return r8;
}
function j7(s9, r8, t6, i10, u11, n23 = 0) {
  if (s9 === null || s9 === void 0) return "null";
  if (typeof s9 == "boolean") return String(s9);
  if (typeof s9 == "number") return Number.isFinite(s9) ? String(s9) : "null";
  if (typeof s9 == "string") return t6 ? s9 : JSON.stringify(s9);
  let o9 = u11 ? "	" : "  ";
  if (Array.isArray(s9)) return s9.length === 0 ? "[]" : r8 ? `[${s9.map((c15) => j7(c15, true, false, i10, u11)).join(",")}]` : `[
${s9.map((c15) => o9.repeat(n23 + 1) + j7(c15, false, false, i10, u11, n23 + 1)).join(`,
`)}
${o9.repeat(n23)}]`;
  if (typeof s9 == "object") {
    let l8 = Object.keys(s9);
    return i10 && (l8 = l8.sort()), l8.length === 0 ? "{}" : r8 ? `{${l8.map((p17) => `${JSON.stringify(p17)}:${j7(s9[p17], true, false, i10, u11)}`).join(",")}}` : `{
${l8.map((p17) => {
      let d16 = j7(s9[p17], false, false, i10, u11, n23 + 1);
      return `${o9.repeat(n23 + 1)}${JSON.stringify(p17)}: ${d16}`;
    }).join(`,
`)}
${o9.repeat(n23)}}`;
  }
  return String(s9);
}
var A5, P13, U9;
var init_chunk_2OCD45J4 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-2OCD45J4.js"() {
    init_chunk_FRDGR5VK();
    init_chunk_7L36YK2X();
    init_chunk_PSW6BMXW();
    init_chunk_74CEPOFO();
    A5 = { name: "jq", summary: "command-line JSON processor", usage: "jq [OPTIONS] FILTER [FILE]", options: ["-r, --raw-output  output strings without quotes", "-c, --compact     compact output (no pretty printing)", "-e, --exit-status set exit status based on output", "-s, --slurp       read entire input into array", "-n, --null-input  don't read any input", "-j, --join-output don't print newlines after each output", "-a, --ascii       force ASCII output", "-S, --sort-keys   sort object keys", "-C, --color       colorize output (ignored)", "-M, --monochrome  monochrome output (ignored)", "    --tab         use tabs for indentation", "    --help        display this help and exit"] };
    P13 = { name: "jq", async execute(s9, r8) {
      if (o2(s9)) return s(A5);
      let t6 = false, i10 = false, u11 = false, n23 = false, o9 = false, l8 = false, c15 = false, p17 = false, d16 = ".", h17 = false, g18 = [];
      for (let a7 = 0; a7 < s9.length; a7++) {
        let e7 = s9[a7];
        if (e7 === "-r" || e7 === "--raw-output") t6 = true;
        else if (e7 === "-c" || e7 === "--compact-output") i10 = true;
        else if (e7 === "-e" || e7 === "--exit-status") u11 = true;
        else if (e7 === "-s" || e7 === "--slurp") n23 = true;
        else if (e7 === "-n" || e7 === "--null-input") o9 = true;
        else if (e7 === "-j" || e7 === "--join-output") l8 = true;
        else if (!(e7 === "-a" || e7 === "--ascii")) {
          if (e7 === "-S" || e7 === "--sort-keys") c15 = true;
          else if (!(e7 === "-C" || e7 === "--color")) {
            if (!(e7 === "-M" || e7 === "--monochrome")) if (e7 === "--tab") p17 = true;
            else if (e7 === "-") g18.push("-");
            else {
              if (e7.startsWith("--")) return r3("jq", e7);
              if (e7.startsWith("-")) {
                for (let f11 of e7.slice(1)) if (f11 === "r") t6 = true;
                else if (f11 === "c") i10 = true;
                else if (f11 === "e") u11 = true;
                else if (f11 === "s") n23 = true;
                else if (f11 === "n") o9 = true;
                else if (f11 === "j") l8 = true;
                else if (f11 !== "a") {
                  if (f11 === "S") c15 = true;
                  else if (f11 !== "C") {
                    if (f11 !== "M") return r3("jq", `-${f11}`);
                  }
                }
              } else h17 ? g18.push(e7) : (d16 = e7, h17 = true);
            }
          }
        }
      }
      let y18 = [];
      if (!o9) if (g18.length === 0 || g18.length === 1 && g18[0] === "-") y18.push({ source: "stdin", content: r8.stdin });
      else {
        let a7 = await y3(r8, g18, { cmdName: "jq", stopOnError: true });
        if (a7.exitCode !== 0) return { stdout: "", stderr: a7.stderr, exitCode: 2 };
        y18 = a7.files.map((e7) => ({ source: e7.filename || "stdin", content: e7.content }));
      }
      try {
        let a7 = ge4(d16), e7 = [], f11 = { limits: r8.limits ? { maxIterations: r8.limits.maxJqIterations } : void 0, env: r8.env, coverage: r8.coverage };
        if (o9) e7 = d11(null, a7, f11);
        else if (n23) {
          let m25 = [];
          for (let { content: w19 } of y18) {
            let b25 = w19.trim();
            b25 && m25.push(...I15(b25));
          }
          e7 = d11(m25, a7, f11);
        } else for (let { content: m25 } of y18) {
          let w19 = m25.trim();
          if (!w19) continue;
          let b25 = I15(w19);
          for (let z10 of b25) e7.push(...d11(z10, a7, f11));
        }
        let k17 = e7.map((m25) => j7(m25, i10, t6, c15, p17)), F21 = l8 ? "" : `
`, S17 = k17.join(F21), $18 = r8.limits?.maxStringLength;
        if ($18 !== void 0 && $18 > 0 && S17.length > $18) throw new b2(`jq: output size limit exceeded (${$18} bytes)`, "string_length");
        let L18 = u11 && (e7.length === 0 || e7.every((m25) => m25 == null || m25 === false)) ? 1 : 0;
        return { stdout: S17 ? l8 ? S17 : `${S17}
` : "", stderr: "", exitCode: L18 };
      } catch (a7) {
        if (a7 instanceof b2) return { stdout: "", stderr: `jq: ${a7.message}
`, exitCode: b2.EXIT_CODE };
        let e7 = a7.message;
        return e7.includes("Unknown function") ? { stdout: "", stderr: `jq: error: ${e7}
`, exitCode: 3 } : { stdout: "", stderr: `jq: parse error: ${e7}
`, exitCode: 5 };
      }
    } };
    U9 = { name: "jq", flags: [{ flag: "-r", type: "boolean" }, { flag: "-c", type: "boolean" }, { flag: "-e", type: "boolean" }, { flag: "-s", type: "boolean" }, { flag: "-n", type: "boolean" }, { flag: "-j", type: "boolean" }, { flag: "-S", type: "boolean" }, { flag: "--tab", type: "boolean" }], stdinType: "json", needsArgs: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/jq-OJYNICKX.js
var jq_OJYNICKX_exports = {};
__export(jq_OJYNICKX_exports, {
  flagsForFuzzing: () => U9,
  jqCommand: () => P13
});
var init_jq_OJYNICKX = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/jq-OJYNICKX.js"() {
    init_chunk_2OCD45J4();
    init_chunk_FRDGR5VK();
    init_chunk_7MKBHGLS();
    init_chunk_OJDRYQWQ();
    init_chunk_YNYSPYQ5();
    init_chunk_7L36YK2X();
    init_chunk_PSW6BMXW();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-IBFD7QQD.js
async function p14(r8, o9, n23) {
  if (o9.length === 0 || o9.length === 1 && o9[0] === "-") return { ok: true, data: Uint8Array.from(r8.stdin, (e7) => e7.charCodeAt(0)) };
  let d16 = [];
  for (let e7 of o9) {
    if (e7 === "-") {
      d16.push(Uint8Array.from(r8.stdin, (t6) => t6.charCodeAt(0)));
      continue;
    }
    try {
      let t6 = r8.fs.resolvePath(r8.cwd, e7), s9 = await r8.fs.readFileBuffer(t6);
      d16.push(s9);
    } catch {
      return { ok: false, error: { stdout: "", stderr: `${n23}: ${e7}: No such file or directory
`, exitCode: 1 } };
    }
  }
  let f11 = d16.reduce((e7, t6) => e7 + t6.length, 0), u11 = new Uint8Array(f11), a7 = 0;
  for (let e7 of d16) u11.set(e7, a7), a7 += e7.length;
  return { ok: true, data: u11 };
}
var b16, m18, A6, F12;
var init_chunk_IBFD7QQD = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-IBFD7QQD.js"() {
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    b16 = { name: "base64", summary: "base64 encode/decode data and print to standard output", usage: "base64 [OPTION]... [FILE]", options: ["-d, --decode    decode data", "-w, --wrap=COLS wrap encoded lines after COLS character (default 76, 0 to disable)", "    --help      display this help and exit"] };
    m18 = { decode: { short: "d", long: "decode", type: "boolean" }, wrap: { short: "w", long: "wrap", type: "number", default: 76 } };
    A6 = { name: "base64", async execute(r8, o9) {
      if (o2(r8)) return s(b16);
      let n23 = x5("base64", r8, m18);
      if (!n23.ok) return n23.error;
      let d16 = n23.result.flags.decode, f11 = n23.result.flags.wrap, u11 = n23.result.positional;
      try {
        if (d16) {
          let t6 = await p14(o9, u11, "base64");
          if (!t6.ok) return t6.error;
          if (typeof Buffer < "u") {
            let g18 = Buffer.from(t6.data).toString("utf8").replace(/\s/g, "");
            return { stdout: Buffer.from(g18, "base64").toString("latin1"), stderr: "", exitCode: 0 };
          }
          let h17 = String.fromCharCode(...t6.data).replace(/\s/g, "");
          return { stdout: atob(h17), stderr: "", exitCode: 0 };
        }
        let a7 = await p14(o9, u11, "base64");
        if (!a7.ok) return a7.error;
        let e7;
        if (typeof Buffer < "u" ? e7 = Buffer.from(a7.data).toString("base64") : e7 = btoa(String.fromCharCode(...a7.data)), f11 > 0) {
          let t6 = [];
          for (let s9 = 0; s9 < e7.length; s9 += f11) t6.push(e7.slice(s9, s9 + f11));
          e7 = t6.join(`
`) + (e7.length > 0 ? `
` : "");
        }
        return { stdout: e7, stderr: "", exitCode: 0 };
      } catch {
        return { stdout: "", stderr: `base64: invalid input
`, exitCode: 1 };
      }
    } };
    F12 = { name: "base64", flags: [{ flag: "-d", type: "boolean" }, { flag: "-w", type: "value", valueHint: "number" }], stdinType: "text", needsFiles: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/base64-A3SGWC34.js
var base64_A3SGWC34_exports = {};
__export(base64_A3SGWC34_exports, {
  base64Command: () => A6,
  flagsForFuzzing: () => F12
});
var init_base64_A3SGWC34 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/base64-A3SGWC34.js"() {
    init_chunk_IBFD7QQD();
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/node_modules/diff/libesm/diff/base.js
var Diff;
var init_base = __esm({
  "../../node_modules/just-bash/node_modules/diff/libesm/diff/base.js"() {
    Diff = class {
      diff(oldStr, newStr, options = {}) {
        let callback;
        if (typeof options === "function") {
          callback = options;
          options = {};
        } else if ("callback" in options) {
          callback = options.callback;
        }
        const oldString = this.castInput(oldStr, options);
        const newString = this.castInput(newStr, options);
        const oldTokens = this.removeEmpty(this.tokenize(oldString, options));
        const newTokens = this.removeEmpty(this.tokenize(newString, options));
        return this.diffWithOptionsObj(oldTokens, newTokens, options, callback);
      }
      diffWithOptionsObj(oldTokens, newTokens, options, callback) {
        var _a3;
        const done = (value) => {
          value = this.postProcess(value, options);
          if (callback) {
            setTimeout(function() {
              callback(value);
            }, 0);
            return void 0;
          } else {
            return value;
          }
        };
        const newLen = newTokens.length, oldLen = oldTokens.length;
        let editLength = 1;
        let maxEditLength = newLen + oldLen;
        if (options.maxEditLength != null) {
          maxEditLength = Math.min(maxEditLength, options.maxEditLength);
        }
        const maxExecutionTime = (_a3 = options.timeout) !== null && _a3 !== void 0 ? _a3 : Infinity;
        const abortAfterTimestamp = Date.now() + maxExecutionTime;
        const bestPath = [{ oldPos: -1, lastComponent: void 0 }];
        let newPos = this.extractCommon(bestPath[0], newTokens, oldTokens, 0, options);
        if (bestPath[0].oldPos + 1 >= oldLen && newPos + 1 >= newLen) {
          return done(this.buildValues(bestPath[0].lastComponent, newTokens, oldTokens));
        }
        let minDiagonalToConsider = -Infinity, maxDiagonalToConsider = Infinity;
        const execEditLength = () => {
          for (let diagonalPath = Math.max(minDiagonalToConsider, -editLength); diagonalPath <= Math.min(maxDiagonalToConsider, editLength); diagonalPath += 2) {
            let basePath;
            const removePath = bestPath[diagonalPath - 1], addPath = bestPath[diagonalPath + 1];
            if (removePath) {
              bestPath[diagonalPath - 1] = void 0;
            }
            let canAdd = false;
            if (addPath) {
              const addPathNewPos = addPath.oldPos - diagonalPath;
              canAdd = addPath && 0 <= addPathNewPos && addPathNewPos < newLen;
            }
            const canRemove = removePath && removePath.oldPos + 1 < oldLen;
            if (!canAdd && !canRemove) {
              bestPath[diagonalPath] = void 0;
              continue;
            }
            if (!canRemove || canAdd && removePath.oldPos < addPath.oldPos) {
              basePath = this.addToPath(addPath, true, false, 0, options);
            } else {
              basePath = this.addToPath(removePath, false, true, 1, options);
            }
            newPos = this.extractCommon(basePath, newTokens, oldTokens, diagonalPath, options);
            if (basePath.oldPos + 1 >= oldLen && newPos + 1 >= newLen) {
              return done(this.buildValues(basePath.lastComponent, newTokens, oldTokens)) || true;
            } else {
              bestPath[diagonalPath] = basePath;
              if (basePath.oldPos + 1 >= oldLen) {
                maxDiagonalToConsider = Math.min(maxDiagonalToConsider, diagonalPath - 1);
              }
              if (newPos + 1 >= newLen) {
                minDiagonalToConsider = Math.max(minDiagonalToConsider, diagonalPath + 1);
              }
            }
          }
          editLength++;
        };
        if (callback) {
          (function exec() {
            setTimeout(function() {
              if (editLength > maxEditLength || Date.now() > abortAfterTimestamp) {
                return callback(void 0);
              }
              if (!execEditLength()) {
                exec();
              }
            }, 0);
          })();
        } else {
          while (editLength <= maxEditLength && Date.now() <= abortAfterTimestamp) {
            const ret = execEditLength();
            if (ret) {
              return ret;
            }
          }
        }
      }
      addToPath(path2, added, removed, oldPosInc, options) {
        const last = path2.lastComponent;
        if (last && !options.oneChangePerToken && last.added === added && last.removed === removed) {
          return {
            oldPos: path2.oldPos + oldPosInc,
            lastComponent: { count: last.count + 1, added, removed, previousComponent: last.previousComponent }
          };
        } else {
          return {
            oldPos: path2.oldPos + oldPosInc,
            lastComponent: { count: 1, added, removed, previousComponent: last }
          };
        }
      }
      extractCommon(basePath, newTokens, oldTokens, diagonalPath, options) {
        const newLen = newTokens.length, oldLen = oldTokens.length;
        let oldPos = basePath.oldPos, newPos = oldPos - diagonalPath, commonCount = 0;
        while (newPos + 1 < newLen && oldPos + 1 < oldLen && this.equals(oldTokens[oldPos + 1], newTokens[newPos + 1], options)) {
          newPos++;
          oldPos++;
          commonCount++;
          if (options.oneChangePerToken) {
            basePath.lastComponent = { count: 1, previousComponent: basePath.lastComponent, added: false, removed: false };
          }
        }
        if (commonCount && !options.oneChangePerToken) {
          basePath.lastComponent = { count: commonCount, previousComponent: basePath.lastComponent, added: false, removed: false };
        }
        basePath.oldPos = oldPos;
        return newPos;
      }
      equals(left, right, options) {
        if (options.comparator) {
          return options.comparator(left, right);
        } else {
          return left === right || !!options.ignoreCase && left.toLowerCase() === right.toLowerCase();
        }
      }
      removeEmpty(array) {
        const ret = [];
        for (let i10 = 0; i10 < array.length; i10++) {
          if (array[i10]) {
            ret.push(array[i10]);
          }
        }
        return ret;
      }
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      castInput(value, options) {
        return value;
      }
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      tokenize(value, options) {
        return Array.from(value);
      }
      join(chars) {
        return chars.join("");
      }
      postProcess(changeObjects, options) {
        return changeObjects;
      }
      get useLongestToken() {
        return false;
      }
      buildValues(lastComponent, newTokens, oldTokens) {
        const components = [];
        let nextComponent;
        while (lastComponent) {
          components.push(lastComponent);
          nextComponent = lastComponent.previousComponent;
          delete lastComponent.previousComponent;
          lastComponent = nextComponent;
        }
        components.reverse();
        const componentLen = components.length;
        let componentPos = 0, newPos = 0, oldPos = 0;
        for (; componentPos < componentLen; componentPos++) {
          const component = components[componentPos];
          if (!component.removed) {
            if (!component.added && this.useLongestToken) {
              let value = newTokens.slice(newPos, newPos + component.count);
              value = value.map(function(value2, i10) {
                const oldValue = oldTokens[oldPos + i10];
                return oldValue.length > value2.length ? oldValue : value2;
              });
              component.value = this.join(value);
            } else {
              component.value = this.join(newTokens.slice(newPos, newPos + component.count));
            }
            newPos += component.count;
            if (!component.added) {
              oldPos += component.count;
            }
          } else {
            component.value = this.join(oldTokens.slice(oldPos, oldPos + component.count));
            oldPos += component.count;
          }
        }
        return components;
      }
    };
  }
});

// ../../node_modules/just-bash/node_modules/diff/libesm/diff/line.js
function diffLines(oldStr, newStr, options) {
  return lineDiff.diff(oldStr, newStr, options);
}
function tokenize(value, options) {
  if (options.stripTrailingCr) {
    value = value.replace(/\r\n/g, "\n");
  }
  const retLines = [], linesAndNewlines = value.split(/(\n|\r\n)/);
  if (!linesAndNewlines[linesAndNewlines.length - 1]) {
    linesAndNewlines.pop();
  }
  for (let i10 = 0; i10 < linesAndNewlines.length; i10++) {
    const line = linesAndNewlines[i10];
    if (i10 % 2 && !options.newlineIsToken) {
      retLines[retLines.length - 1] += line;
    } else {
      retLines.push(line);
    }
  }
  return retLines;
}
var LineDiff, lineDiff;
var init_line = __esm({
  "../../node_modules/just-bash/node_modules/diff/libesm/diff/line.js"() {
    init_base();
    LineDiff = class extends Diff {
      constructor() {
        super(...arguments);
        this.tokenize = tokenize;
      }
      equals(left, right, options) {
        if (options.ignoreWhitespace) {
          if (!options.newlineIsToken || !left.includes("\n")) {
            left = left.trim();
          }
          if (!options.newlineIsToken || !right.includes("\n")) {
            right = right.trim();
          }
        } else if (options.ignoreNewlineAtEof && !options.newlineIsToken) {
          if (left.endsWith("\n")) {
            left = left.slice(0, -1);
          }
          if (right.endsWith("\n")) {
            right = right.slice(0, -1);
          }
        }
        return super.equals(left, right, options);
      }
    };
    lineDiff = new LineDiff();
  }
});

// ../../node_modules/just-bash/node_modules/diff/libesm/patch/create.js
function structuredPatch(oldFileName, newFileName, oldStr, newStr, oldHeader, newHeader, options) {
  let optionsObj;
  if (!options) {
    optionsObj = {};
  } else if (typeof options === "function") {
    optionsObj = { callback: options };
  } else {
    optionsObj = options;
  }
  if (typeof optionsObj.context === "undefined") {
    optionsObj.context = 4;
  }
  const context = optionsObj.context;
  if (optionsObj.newlineIsToken) {
    throw new Error("newlineIsToken may not be used with patch-generation functions, only with diffing functions");
  }
  if (!optionsObj.callback) {
    return diffLinesResultToPatch(diffLines(oldStr, newStr, optionsObj));
  } else {
    const { callback } = optionsObj;
    diffLines(oldStr, newStr, Object.assign(Object.assign({}, optionsObj), { callback: (diff) => {
      const patch = diffLinesResultToPatch(diff);
      callback(patch);
    } }));
  }
  function diffLinesResultToPatch(diff) {
    if (!diff) {
      return;
    }
    diff.push({ value: "", lines: [] });
    function contextLines(lines) {
      return lines.map(function(entry) {
        return " " + entry;
      });
    }
    const hunks = [];
    let oldRangeStart = 0, newRangeStart = 0, curRange = [], oldLine = 1, newLine = 1;
    for (let i10 = 0; i10 < diff.length; i10++) {
      const current = diff[i10], lines = current.lines || splitLines(current.value);
      current.lines = lines;
      if (current.added || current.removed) {
        if (!oldRangeStart) {
          const prev = diff[i10 - 1];
          oldRangeStart = oldLine;
          newRangeStart = newLine;
          if (prev) {
            curRange = context > 0 ? contextLines(prev.lines.slice(-context)) : [];
            oldRangeStart -= curRange.length;
            newRangeStart -= curRange.length;
          }
        }
        for (const line of lines) {
          curRange.push((current.added ? "+" : "-") + line);
        }
        if (current.added) {
          newLine += lines.length;
        } else {
          oldLine += lines.length;
        }
      } else {
        if (oldRangeStart) {
          if (lines.length <= context * 2 && i10 < diff.length - 2) {
            for (const line of contextLines(lines)) {
              curRange.push(line);
            }
          } else {
            const contextSize = Math.min(lines.length, context);
            for (const line of contextLines(lines.slice(0, contextSize))) {
              curRange.push(line);
            }
            const hunk = {
              oldStart: oldRangeStart,
              oldLines: oldLine - oldRangeStart + contextSize,
              newStart: newRangeStart,
              newLines: newLine - newRangeStart + contextSize,
              lines: curRange
            };
            hunks.push(hunk);
            oldRangeStart = 0;
            newRangeStart = 0;
            curRange = [];
          }
        }
        oldLine += lines.length;
        newLine += lines.length;
      }
    }
    for (const hunk of hunks) {
      for (let i10 = 0; i10 < hunk.lines.length; i10++) {
        if (hunk.lines[i10].endsWith("\n")) {
          hunk.lines[i10] = hunk.lines[i10].slice(0, -1);
        } else {
          hunk.lines.splice(i10 + 1, 0, "\\ No newline at end of file");
          i10++;
        }
      }
    }
    return {
      oldFileName,
      newFileName,
      oldHeader,
      newHeader,
      hunks
    };
  }
}
function formatPatch(patch, headerOptions) {
  if (!headerOptions) {
    headerOptions = INCLUDE_HEADERS;
  }
  if (Array.isArray(patch)) {
    if (patch.length > 1 && !headerOptions.includeFileHeaders) {
      throw new Error("Cannot omit file headers on a multi-file patch. (The result would be unparseable; how would a tool trying to apply the patch know which changes are to which file?)");
    }
    return patch.map((p17) => formatPatch(p17, headerOptions)).join("\n");
  }
  const ret = [];
  if (headerOptions.includeIndex && patch.oldFileName == patch.newFileName) {
    ret.push("Index: " + patch.oldFileName);
  }
  if (headerOptions.includeUnderline) {
    ret.push("===================================================================");
  }
  if (headerOptions.includeFileHeaders) {
    ret.push("--- " + patch.oldFileName + (typeof patch.oldHeader === "undefined" ? "" : "	" + patch.oldHeader));
    ret.push("+++ " + patch.newFileName + (typeof patch.newHeader === "undefined" ? "" : "	" + patch.newHeader));
  }
  for (let i10 = 0; i10 < patch.hunks.length; i10++) {
    const hunk = patch.hunks[i10];
    if (hunk.oldLines === 0) {
      hunk.oldStart -= 1;
    }
    if (hunk.newLines === 0) {
      hunk.newStart -= 1;
    }
    ret.push("@@ -" + hunk.oldStart + "," + hunk.oldLines + " +" + hunk.newStart + "," + hunk.newLines + " @@");
    for (const line of hunk.lines) {
      ret.push(line);
    }
  }
  return ret.join("\n") + "\n";
}
function createTwoFilesPatch(oldFileName, newFileName, oldStr, newStr, oldHeader, newHeader, options) {
  if (typeof options === "function") {
    options = { callback: options };
  }
  if (!(options === null || options === void 0 ? void 0 : options.callback)) {
    const patchObj = structuredPatch(oldFileName, newFileName, oldStr, newStr, oldHeader, newHeader, options);
    if (!patchObj) {
      return;
    }
    return formatPatch(patchObj, options === null || options === void 0 ? void 0 : options.headerOptions);
  } else {
    const { callback } = options;
    structuredPatch(oldFileName, newFileName, oldStr, newStr, oldHeader, newHeader, Object.assign(Object.assign({}, options), { callback: (patchObj) => {
      if (!patchObj) {
        callback(void 0);
      } else {
        callback(formatPatch(patchObj, options.headerOptions));
      }
    } }));
  }
}
function splitLines(text) {
  const hasTrailingNl = text.endsWith("\n");
  const result = text.split("\n").map((line) => line + "\n");
  if (hasTrailingNl) {
    result.pop();
  } else {
    result.push(result.pop().slice(0, -1));
  }
  return result;
}
var INCLUDE_HEADERS;
var init_create = __esm({
  "../../node_modules/just-bash/node_modules/diff/libesm/patch/create.js"() {
    init_line();
    INCLUDE_HEADERS = {
      includeIndex: true,
      includeUnderline: true,
      includeFileHeaders: true
    };
  }
});

// ../../node_modules/just-bash/node_modules/diff/libesm/index.js
var init_libesm = __esm({
  "../../node_modules/just-bash/node_modules/diff/libesm/index.js"() {
    init_create();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-TLSUDHID.js
var y14, b17, $13, x16;
var init_chunk_TLSUDHID = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-TLSUDHID.js"() {
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    init_libesm();
    y14 = { name: "diff", summary: "compare files line by line", usage: "diff [OPTION]... FILE1 FILE2", options: ["-u, --unified     output unified diff format (default)", "-q, --brief       report only whether files differ", "-s, --report-identical-files  report when files are the same", "-i, --ignore-case  ignore case differences", "    --help        display this help and exit"] };
    b17 = { unified: { short: "u", long: "unified", type: "boolean" }, brief: { short: "q", long: "brief", type: "boolean" }, reportSame: { short: "s", long: "report-identical-files", type: "boolean" }, ignoreCase: { short: "i", long: "ignore-case", type: "boolean" } };
    $13 = { name: "diff", async execute(a7, e7) {
      if (o2(a7)) return s(y14);
      let t6 = x5("diff", a7, b17);
      if (!t6.ok) return t6.error;
      let g18 = t6.result.flags.brief, h17 = t6.result.flags.reportSame, m25 = t6.result.flags.ignoreCase, d16 = t6.result.positional;
      if (t6.result.flags.unified, d16.length < 2) return { stdout: "", stderr: `diff: missing operand
`, exitCode: 2 };
      let i10, s9, [r8, o9] = d16;
      try {
        i10 = r8 === "-" ? e7.stdin : await e7.fs.readFile(e7.fs.resolvePath(e7.cwd, r8));
      } catch {
        return { stdout: "", stderr: `diff: ${r8}: No such file or directory
`, exitCode: 2 };
      }
      try {
        s9 = o9 === "-" ? e7.stdin : await e7.fs.readFile(e7.fs.resolvePath(e7.cwd, o9));
      } catch {
        return { stdout: "", stderr: `diff: ${o9}: No such file or directory
`, exitCode: 2 };
      }
      let f11 = i10, n23 = s9;
      return m25 && (f11 = f11.toLowerCase(), n23 = n23.toLowerCase()), f11 === n23 ? h17 ? { stdout: `Files ${r8} and ${o9} are identical
`, stderr: "", exitCode: 0 } : { stdout: "", stderr: "", exitCode: 0 } : g18 ? { stdout: `Files ${r8} and ${o9} differ
`, stderr: "", exitCode: 1 } : { stdout: createTwoFilesPatch(r8, o9, i10, s9, "", "", { context: 3 }), stderr: "", exitCode: 1 };
    } };
    x16 = { name: "diff", flags: [{ flag: "-u", type: "boolean" }, { flag: "-q", type: "boolean" }, { flag: "-s", type: "boolean" }, { flag: "-i", type: "boolean" }], needsArgs: true, minArgs: 2 };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/diff-HJF2MPDN.js
var diff_HJF2MPDN_exports = {};
__export(diff_HJF2MPDN_exports, {
  diffCommand: () => $13,
  flagsForFuzzing: () => x16
});
var init_diff_HJF2MPDN = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/diff-HJF2MPDN.js"() {
    init_chunk_TLSUDHID();
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-D7MEQ3VN.js
function s5(a7, i10 = 2) {
  return String(a7).padStart(i10, "0");
}
function b18(a7, i10, n23) {
  let t6 = { Y: a7.getUTCFullYear(), m: a7.getUTCMonth(), D: a7.getUTCDate(), H: a7.getUTCHours(), M: a7.getUTCMinutes(), S: a7.getUTCSeconds(), w: a7.getUTCDay() }, e7 = "", l8 = 0;
  for (; l8 < i10.length; ) {
    if (i10[l8] === "%" && l8 + 1 < i10.length) {
      let o9 = i10[++l8];
      switch (o9) {
        case "%":
          e7 += "%";
          break;
        case "a":
          e7 += T7[t6.w];
          break;
        case "b":
        case "h":
          e7 += S8[t6.m];
          break;
        case "d":
          e7 += s5(t6.D);
          break;
        case "e":
          e7 += String(t6.D).padStart(2, " ");
          break;
        case "F":
          e7 += `${t6.Y}-${s5(t6.m + 1)}-${s5(t6.D)}`;
          break;
        case "H":
          e7 += s5(t6.H);
          break;
        case "I":
          e7 += s5(t6.H % 12 || 12);
          break;
        case "m":
          e7 += s5(t6.m + 1);
          break;
        case "M":
          e7 += s5(t6.M);
          break;
        case "n":
          e7 += `
`;
          break;
        case "p":
          e7 += t6.H < 12 ? "AM" : "PM";
          break;
        case "P":
          e7 += t6.H < 12 ? "am" : "pm";
          break;
        case "R":
          e7 += `${s5(t6.H)}:${s5(t6.M)}`;
          break;
        case "s":
          e7 += Math.floor(a7.getTime() / 1e3);
          break;
        case "S":
          e7 += s5(t6.S);
          break;
        case "t":
          e7 += "	";
          break;
        case "T":
          e7 += `${s5(t6.H)}:${s5(t6.M)}:${s5(t6.S)}`;
          break;
        case "u":
          e7 += t6.w || 7;
          break;
        case "w":
          e7 += t6.w;
          break;
        case "y":
          e7 += s5(t6.Y % 100);
          break;
        case "Y":
          e7 += t6.Y;
          break;
        case "z":
          e7 += "+0000";
          break;
        case "Z":
          e7 += "UTC";
          break;
        default:
          e7 += `%${o9}`;
      }
    } else e7 += i10[l8];
    l8++;
  }
  return e7;
}
function h13(a7) {
  let i10 = new Date(a7);
  if (!Number.isNaN(i10.getTime())) return i10;
  if (/^\d+$/.test(a7)) return new Date(Number.parseInt(a7, 10) * 1e3);
  let n23 = a7.toLowerCase();
  return n23 === "now" || n23 === "today" ? /* @__PURE__ */ new Date() : n23 === "yesterday" ? new Date(Date.now() - 864e5) : n23 === "tomorrow" ? new Date(Date.now() + 864e5) : null;
}
var g13, T7, S8, M8, D10;
var init_chunk_D7MEQ3VN = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-D7MEQ3VN.js"() {
    init_chunk_74CEPOFO();
    g13 = { name: "date", summary: "display the current time in the given FORMAT", usage: "date [OPTION]... [+FORMAT]", options: ["-d, --date=STRING   display time described by STRING", "-u, --utc           print Coordinated Universal Time (UTC)", "-I, --iso-8601      output date/time in ISO 8601 format", "-R, --rfc-email     output RFC 5322 date format", "    --help          display this help and exit"] };
    T7 = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    S8 = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    M8 = { name: "date", async execute(a7, i10) {
      if (o2(a7)) return s(g13);
      let n23 = false, t6 = null, e7 = null, l8 = false, o9 = false;
      for (let f11 = 0; f11 < a7.length; f11++) {
        let r8 = a7[f11];
        if (r8 === "-u" || r8 === "--utc") n23 = true;
        else if (r8 === "-d" || r8 === "--date") t6 = a7[++f11] ?? "";
        else if (r8.startsWith("--date=")) t6 = r8.slice(7);
        else if (r8 === "-I" || r8 === "--iso-8601") l8 = true;
        else if (r8 === "-R" || r8 === "--rfc-email") o9 = true;
        else if (r8.startsWith("+")) e7 = r8.slice(1);
        else {
          if (r8.startsWith("--")) return r3("date", r8);
          if (r8.startsWith("-")) for (let d16 of r8.slice(1)) if (d16 === "u") n23 = true;
          else if (d16 === "I") l8 = true;
          else if (d16 === "R") o9 = true;
          else return r3("date", `-${d16}`);
        }
      }
      let u11 = t6 !== null ? h13(t6) : /* @__PURE__ */ new Date();
      if (!u11) return { stdout: "", stderr: `date: invalid date '${t6}'
`, exitCode: 1 };
      let c15;
      return e7 ? c15 = b18(u11, e7, n23) : l8 ? c15 = b18(u11, "%Y-%m-%dT%H:%M:%S%z", n23) : o9 ? c15 = b18(u11, "%a, %d %b %Y %H:%M:%S %z", n23) : c15 = b18(u11, "%a %b %e %H:%M:%S %Z %Y", n23), { stdout: `${c15}
`, stderr: "", exitCode: 0 };
    } };
    D10 = { name: "date", flags: [{ flag: "-d", type: "value", valueHint: "string" }, { flag: "-u", type: "boolean" }, { flag: "-I", type: "boolean" }, { flag: "-R", type: "boolean" }] };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/date-DD7FVA2V.js
var date_DD7FVA2V_exports = {};
__export(date_DD7FVA2V_exports, {
  dateCommand: () => M8,
  flagsForFuzzing: () => D10
});
var init_date_DD7FVA2V = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/date-DD7FVA2V.js"() {
    init_chunk_D7MEQ3VN();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-WMLBQOWO.js
function i6(t6) {
  let s9 = t6.match(/^(\d+\.?\d*)(s|m|h|d)?$/);
  if (!s9) return null;
  let e7 = parseFloat(s9[1]);
  switch (s9[2] || "s") {
    case "s":
      return e7 * 1e3;
    case "m":
      return e7 * 60 * 1e3;
    case "h":
      return e7 * 60 * 60 * 1e3;
    case "d":
      return e7 * 24 * 60 * 60 * 1e3;
    default:
      return null;
  }
}
var l4, d12, m19;
var init_chunk_WMLBQOWO = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-WMLBQOWO.js"() {
    init_chunk_74CEPOFO();
    l4 = { name: "sleep", summary: "delay for a specified amount of time", usage: "sleep NUMBER[SUFFIX]", description: `Pause for NUMBER seconds. SUFFIX may be:
  s - seconds (default)
  m - minutes
  h - hours
  d - days

NUMBER may be a decimal number.`, options: ["    --help display this help and exit"] };
    d12 = { name: "sleep", async execute(t6, s9) {
      if (o2(t6)) return s(l4);
      if (t6.length === 0) return { stdout: "", stderr: `sleep: missing operand
`, exitCode: 1 };
      let e7 = 0;
      for (let n23 of t6) {
        let r8 = i6(n23);
        if (r8 === null) return { stdout: "", stderr: `sleep: invalid time interval '${n23}'
`, exitCode: 1 };
        e7 += r8;
      }
      return s9.sleep ? await s9.sleep(e7) : await new Promise((n23) => setTimeout(n23, e7)), { stdout: "", stderr: "", exitCode: 0 };
    } };
    m19 = { name: "sleep", flags: [], needsArgs: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/sleep-JHK4I472.js
var sleep_JHK4I472_exports = {};
__export(sleep_JHK4I472_exports, {
  flagsForFuzzing: () => m19,
  sleepCommand: () => d12
});
var init_sleep_JHK4I472 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/sleep-JHK4I472.js"() {
    init_chunk_WMLBQOWO();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-XNL7YAHW.js
function A7(r8) {
  let i10 = r8.match(/^(\d+\.?\d*)(s|m|h|d)?$/);
  if (!i10) return null;
  let n23 = parseFloat(i10[1]);
  switch (i10[2] || "s") {
    case "s":
      return n23 * 1e3;
    case "m":
      return n23 * 60 * 1e3;
    case "h":
      return n23 * 60 * 60 * 1e3;
    case "d":
      return n23 * 24 * 60 * 60 * 1e3;
    default:
      return null;
  }
}
var x17, v17, k9;
var init_chunk_XNL7YAHW = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-XNL7YAHW.js"() {
    init_chunk_74CEPOFO();
    x17 = { name: "timeout", summary: "run a command with a time limit", usage: "timeout [OPTION] DURATION COMMAND [ARG]...", description: `Start COMMAND, and kill it if still running after DURATION.

DURATION is a number with optional suffix:
  s - seconds (default)
  m - minutes
  h - hours
  d - days`, options: ["-k, --kill-after=DURATION  send KILL signal after DURATION if still running", "-s, --signal=SIGNAL        specify signal to send (default: TERM)", "    --preserve-status      exit with same status as COMMAND, even on timeout", "    --foreground           run command in foreground", "    --help                 display this help and exit"] };
    v17 = { name: "timeout", async execute(r8, i10) {
      if (o2(r8)) return s(x17);
      let n23 = false, s9 = 0;
      for (let e7 = 0; e7 < r8.length; e7++) {
        let t6 = r8[e7];
        if (t6 === "--preserve-status") n23 = true, s9 = e7 + 1;
        else if (t6 === "--foreground") s9 = e7 + 1;
        else if (t6 === "-k" || t6 === "--kill-after") e7++, s9 = e7 + 1;
        else if (t6.startsWith("--kill-after=")) s9 = e7 + 1;
        else if (t6 === "-s" || t6 === "--signal") e7++, s9 = e7 + 1;
        else if (t6.startsWith("--signal=")) s9 = e7 + 1;
        else {
          if (t6.startsWith("--") && t6 !== "--") return r3("timeout", t6);
          if (t6.startsWith("-") && t6.length > 1 && t6 !== "--") if (t6.startsWith("-k")) s9 = e7 + 1;
          else if (t6.startsWith("-s")) s9 = e7 + 1;
          else return r3("timeout", t6);
          else {
            s9 = e7;
            break;
          }
        }
      }
      let o9 = r8.slice(s9);
      if (o9.length === 0) return { stdout: "", stderr: `timeout: missing operand
`, exitCode: 1 };
      let u11 = o9[0], l8 = A7(u11);
      if (l8 === null) return { stdout: "", stderr: `timeout: invalid time interval '${u11}'
`, exitCode: 1 };
      let m25 = o9.slice(1);
      if (m25.length === 0) return { stdout: "", stderr: `timeout: missing operand
`, exitCode: 1 };
      if (!i10.exec) return { stdout: "", stderr: `timeout: exec not available
`, exitCode: 1 };
      let g18 = m25.map((e7) => e7.includes(" ") || e7.includes("	") ? `'${e7.replace(/'/g, "'\\''")}'` : e7).join(" "), p17 = new Promise((e7) => {
        setTimeout(() => e7({ timedOut: true }), l8);
      }), h17 = i10.exec(g18, { cwd: i10.cwd }).then((e7) => ({ timedOut: false, result: e7 })), d16 = await Promise.race([p17, h17]);
      return d16.timedOut ? { stdout: "", stderr: "", exitCode: 124 } : d16.result;
    } };
    k9 = { name: "timeout", flags: [{ flag: "-k", type: "value", valueHint: "string" }, { flag: "-s", type: "value", valueHint: "string" }, { flag: "--preserve-status", type: "boolean" }, { flag: "--foreground", type: "boolean" }], needsArgs: true, minArgs: 2 };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/timeout-5UJUQXOE.js
var timeout_5UJUQXOE_exports = {};
__export(timeout_5UJUQXOE_exports, {
  flagsForFuzzing: () => k9,
  timeoutCommand: () => v17
});
var init_timeout_5UJUQXOE = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/timeout-5UJUQXOE.js"() {
    init_chunk_XNL7YAHW();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-CSBFBYLD.js
function w14(i10) {
  let r8 = Math.floor(i10 / 3600), a7 = Math.floor(i10 % 3600 / 60), o9 = i10 % 60;
  return r8 > 0 ? `${r8}:${a7.toString().padStart(2, "0")}:${o9.toFixed(2).padStart(5, "0")}` : `${a7}:${o9.toFixed(2).padStart(5, "0")}`;
}
var C14, F13;
var init_chunk_CSBFBYLD = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-CSBFBYLD.js"() {
    init_chunk_OJDRYQWQ();
    C14 = { name: "time", async execute(i10, r8) {
      let a7 = "%e %M", o9 = null, d16 = false, m25 = false, t6 = 0;
      for (; t6 < i10.length; ) {
        let e7 = i10[t6];
        if (e7 === "-f" || e7 === "--format") {
          if (t6++, t6 >= i10.length) return { stdout: "", stderr: `time: missing argument to '-f'
`, exitCode: 1 };
          a7 = i10[t6], t6++;
        } else if (e7 === "-o" || e7 === "--output") {
          if (t6++, t6 >= i10.length) return { stdout: "", stderr: `time: missing argument to '-o'
`, exitCode: 1 };
          o9 = i10[t6], t6++;
        } else if (e7 === "-a" || e7 === "--append") d16 = true, t6++;
        else if (e7 === "-v" || e7 === "--verbose") a7 = `Command being timed: %C
Elapsed (wall clock) time: %e seconds
Maximum resident set size (kbytes): %M`, t6++;
        else if (e7 === "-p" || e7 === "--portability") m25 = true, t6++;
        else if (e7 === "--") {
          t6++;
          break;
        } else if (e7.startsWith("-")) t6++;
        else break;
      }
      let f11 = i10.slice(t6);
      if (f11.length === 0) return { stdout: "", stderr: "", exitCode: 0 };
      let p17 = performance.now(), u11 = f11.join(" "), s9;
      try {
        if (!r8.exec) return { stdout: "", stderr: `time: exec not available
`, exitCode: 1 };
        s9 = await r8.exec(u11, { env: r(r8.env), cwd: r8.cwd });
      } catch (e7) {
        s9 = { stdout: "", stderr: `time: ${e7.message}
`, exitCode: 127 };
      }
      let l8 = (performance.now() - p17) / 1e3, n23;
      if (m25 ? n23 = `real ${l8.toFixed(2)}
user 0.00
sys 0.00
` : (n23 = a7.replace(/%e/g, l8.toFixed(2)).replace(/%E/g, w14(l8)).replace(/%M/g, "0").replace(/%S/g, "0.00").replace(/%U/g, "0.00").replace(/%P/g, "0%").replace(/%C/g, u11), n23.endsWith(`
`) || (n23 += `
`)), o9) try {
        let e7 = r8.fs.resolvePath(r8.cwd, o9);
        if (d16 && await r8.fs.exists(e7)) {
          let g18 = await r8.fs.readFile(e7);
          await r8.fs.writeFile(e7, g18 + n23);
        } else await r8.fs.writeFile(e7, n23);
      } catch (e7) {
        return { stdout: s9.stdout, stderr: s9.stderr + `time: cannot write to '${o9}': ${e7.message}
`, exitCode: s9.exitCode };
      }
      else s9 = { ...s9, stderr: s9.stderr + n23 };
      return s9;
    } };
    F13 = { name: "time", flags: [{ flag: "-p", type: "boolean" }], needsArgs: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/time-BPT76IHZ.js
var time_BPT76IHZ_exports = {};
__export(time_BPT76IHZ_exports, {
  flagsForFuzzing: () => F13,
  timeCommand: () => C14
});
var init_time_BPT76IHZ = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/time-BPT76IHZ.js"() {
    init_chunk_CSBFBYLD();
    init_chunk_OJDRYQWQ();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-A7A2DBEE.js
var F14, b19;
var init_chunk_A7A2DBEE = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-A7A2DBEE.js"() {
    F14 = { name: "seq", async execute(r8) {
      let d16 = `
`, f11 = false, s9 = [], t6 = 0;
      for (; t6 < r8.length; ) {
        let e7 = r8[t6];
        if (e7 === "-s" && t6 + 1 < r8.length) {
          d16 = r8[t6 + 1], t6 += 2;
          continue;
        }
        if (e7 === "-w") {
          f11 = true, t6++;
          continue;
        }
        if (e7 === "--") {
          t6++;
          break;
        }
        if (e7.startsWith("-") && e7 !== "-") {
          if (e7.startsWith("-s") && e7.length > 2) {
            d16 = e7.slice(2), t6++;
            continue;
          }
          if ((e7 === "-ws" || e7 === "-sw") && (f11 = true, t6 + 1 < r8.length)) {
            d16 = r8[t6 + 1], t6 += 2;
            continue;
          }
        }
        s9.push(e7), t6++;
      }
      for (; t6 < r8.length; ) s9.push(r8[t6]), t6++;
      if (s9.length === 0) return { stdout: "", stderr: `seq: missing operand
`, exitCode: 1 };
      let l8 = 1, o9 = 1, a7;
      if (s9.length === 1 ? a7 = parseFloat(s9[0]) : s9.length === 2 ? (l8 = parseFloat(s9[0]), a7 = parseFloat(s9[1])) : (l8 = parseFloat(s9[0]), o9 = parseFloat(s9[1]), a7 = parseFloat(s9[2])), Number.isNaN(l8) || Number.isNaN(o9) || Number.isNaN(a7)) return { stdout: "", stderr: `seq: invalid floating point argument: '${s9.find((n23) => Number.isNaN(parseFloat(n23)))}'
`, exitCode: 1 };
      if (o9 === 0) return { stdout: "", stderr: `seq: invalid Zero increment value: '0'
`, exitCode: 1 };
      let i10 = [], h17 = (e7) => {
        let n23 = String(e7), u11 = n23.indexOf(".");
        return u11 === -1 ? 0 : n23.length - u11 - 1;
      }, c15 = Math.max(h17(l8), h17(o9), h17(a7)), p17 = 1e5, g18 = 0;
      if (o9 > 0) for (let e7 = l8; e7 <= a7 + 1e-10 && !(g18++ > p17); e7 += o9) i10.push(c15 > 0 ? e7.toFixed(c15) : String(Math.round(e7)));
      else for (let e7 = l8; e7 >= a7 - 1e-10 && !(g18++ > p17); e7 += o9) i10.push(c15 > 0 ? e7.toFixed(c15) : String(Math.round(e7)));
      if (f11 && i10.length > 0) {
        let e7 = Math.max(...i10.map((n23) => n23.replace("-", "").length));
        for (let n23 = 0; n23 < i10.length; n23++) {
          let u11 = i10[n23].startsWith("-"), x23 = (u11 ? i10[n23].slice(1) : i10[n23]).padStart(e7, "0");
          i10[n23] = u11 ? `-${x23}` : x23;
        }
      }
      let m25 = i10.join(d16);
      return { stdout: m25 ? `${m25}
` : "", stderr: "", exitCode: 0 };
    } };
    b19 = { name: "seq", flags: [{ flag: "-s", type: "value", valueHint: "string" }, { flag: "-w", type: "boolean" }], needsArgs: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/seq-RN5ZUASB.js
var seq_RN5ZUASB_exports = {};
__export(seq_RN5ZUASB_exports, {
  flagsForFuzzing: () => b19,
  seqCommand: () => F14
});
var init_seq_RN5ZUASB = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/seq-RN5ZUASB.js"() {
    init_chunk_A7A2DBEE();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-U7QI5ZS5.js
function d13(s9) {
  if (s9.length === 1) return s9[0];
  let r8 = 0;
  function l8() {
    let e7 = h17();
    for (; r8 < s9.length && s9[r8] === "|"; ) {
      r8++;
      let t6 = h17();
      if (e7 !== "0" && e7 !== "") return e7;
      e7 = t6;
    }
    return e7;
  }
  function h17() {
    let e7 = m25();
    for (; r8 < s9.length && s9[r8] === "&"; ) {
      r8++;
      let t6 = m25();
      (e7 === "0" || e7 === "" || t6 === "0" || t6 === "") && (e7 = "0");
    }
    return e7;
  }
  function m25() {
    let e7 = p17();
    for (; r8 < s9.length; ) {
      let t6 = s9[r8];
      if (["=", "!=", "<", ">", "<=", ">="].includes(t6)) {
        r8++;
        let o9 = p17(), n23 = parseInt(e7, 10), i10 = parseInt(o9, 10), f11 = !Number.isNaN(n23) && !Number.isNaN(i10), c15;
        t6 === "=" ? c15 = f11 ? n23 === i10 : e7 === o9 : t6 === "!=" ? c15 = f11 ? n23 !== i10 : e7 !== o9 : t6 === "<" ? c15 = f11 ? n23 < i10 : e7 < o9 : t6 === ">" ? c15 = f11 ? n23 > i10 : e7 > o9 : t6 === "<=" ? c15 = f11 ? n23 <= i10 : e7 <= o9 : c15 = f11 ? n23 >= i10 : e7 >= o9, e7 = c15 ? "1" : "0";
      } else break;
    }
    return e7;
  }
  function p17() {
    let e7 = g18();
    for (; r8 < s9.length; ) {
      let t6 = s9[r8];
      if (t6 === "+" || t6 === "-") {
        r8++;
        let o9 = g18(), n23 = parseInt(e7, 10), i10 = parseInt(o9, 10);
        if (Number.isNaN(n23) || Number.isNaN(i10)) throw new Error("non-integer argument");
        e7 = String(t6 === "+" ? n23 + i10 : n23 - i10);
      } else break;
    }
    return e7;
  }
  function g18() {
    let e7 = N15();
    for (; r8 < s9.length; ) {
      let t6 = s9[r8];
      if (t6 === "*" || t6 === "/" || t6 === "%") {
        r8++;
        let o9 = N15(), n23 = parseInt(e7, 10), i10 = parseInt(o9, 10);
        if (Number.isNaN(n23) || Number.isNaN(i10)) throw new Error("non-integer argument");
        if ((t6 === "/" || t6 === "%") && i10 === 0) throw new Error("division by zero");
        t6 === "*" ? e7 = String(n23 * i10) : t6 === "/" ? e7 = String(Math.trunc(n23 / i10)) : e7 = String(n23 % i10);
      } else break;
    }
    return e7;
  }
  function N15() {
    let e7 = u11();
    for (; r8 < s9.length && s9[r8] === ":"; ) {
      r8++;
      let t6 = u11(), n23 = b1(`^${t6}`).match(e7);
      n23 ? e7 = n23[1] !== void 0 ? n23[1] : String(n23[0].length) : e7 = "0";
    }
    return e7;
  }
  function u11() {
    if (r8 >= s9.length) throw new Error("syntax error");
    let e7 = s9[r8];
    if (e7 === "match") {
      r8++;
      let t6 = u11(), o9 = u11(), i10 = b1(o9).match(t6);
      return i10 ? i10[1] !== void 0 ? i10[1] : String(i10[0].length) : "0";
    }
    if (e7 === "substr") {
      r8++;
      let t6 = u11(), o9 = parseInt(u11(), 10), n23 = parseInt(u11(), 10);
      if (Number.isNaN(o9) || Number.isNaN(n23)) throw new Error("non-integer argument");
      return t6.substring(o9 - 1, o9 - 1 + n23);
    }
    if (e7 === "index") {
      r8++;
      let t6 = u11(), o9 = u11();
      for (let n23 = 0; n23 < t6.length; n23++) if (o9.includes(t6[n23])) return String(n23 + 1);
      return "0";
    }
    if (e7 === "length") {
      r8++;
      let t6 = u11();
      return String(t6.length);
    }
    if (e7 === "(") {
      r8++;
      let t6 = l8();
      if (r8 >= s9.length || s9[r8] !== ")") throw new Error("syntax error");
      return r8++, t6;
    }
    return r8++, e7;
  }
  return l8();
}
var w15, b20;
var init_chunk_U7QI5ZS5 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-U7QI5ZS5.js"() {
    init_chunk_YNYSPYQ5();
    w15 = { name: "expr", async execute(s9, r8) {
      if (s9.length === 0) return { stdout: "", stderr: `expr: missing operand
`, exitCode: 2 };
      try {
        let l8 = d13(s9), h17 = l8 === "0" || l8 === "" ? 1 : 0;
        return { stdout: `${l8}
`, stderr: "", exitCode: h17 };
      } catch (l8) {
        return { stdout: "", stderr: `expr: ${l8.message}
`, exitCode: 2 };
      }
    } };
    b20 = { name: "expr", flags: [], needsArgs: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/expr-3572LAOT.js
var expr_3572LAOT_exports = {};
__export(expr_3572LAOT_exports, {
  exprCommand: () => w15,
  flagsForFuzzing: () => b20
});
var init_expr_3572LAOT = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/expr-3572LAOT.js"() {
    init_chunk_U7QI5ZS5();
    init_chunk_YNYSPYQ5();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-EIZGF4BS.js
function L12(n23) {
  function h17(r8, u11) {
    return r8 << u11 | r8 >>> 32 - u11;
  }
  let g18 = new Uint32Array([3614090360, 3905402710, 606105819, 3250441966, 4118548399, 1200080426, 2821735955, 4249261313, 1770035416, 2336552879, 4294925233, 2304563134, 1804603682, 4254626195, 2792965006, 1236535329, 4129170786, 3225465664, 643717713, 3921069994, 3593408605, 38016083, 3634488961, 3889429448, 568446438, 3275163606, 4107603335, 1163531501, 2850285829, 4243563512, 1735328473, 2368359562, 4294588738, 2272392833, 1839030562, 4259657740, 2763975236, 1272893353, 4139469664, 3200236656, 681279174, 3936430074, 3572445317, 76029189, 3654602809, 3873151461, 530742520, 3299628645, 4096336452, 1126891415, 2878612391, 4237533241, 1700485571, 2399980690, 4293915773, 2240044497, 1873313359, 4264355552, 2734768916, 1309151649, 4149444226, 3174756917, 718787259, 3951481745]), A14 = [7, 12, 17, 22, 7, 12, 17, 22, 7, 12, 17, 22, 7, 12, 17, 22, 5, 9, 14, 20, 5, 9, 14, 20, 5, 9, 14, 20, 5, 9, 14, 20, 4, 11, 16, 23, 4, 11, 16, 23, 4, 11, 16, 23, 4, 11, 16, 23, 6, 10, 15, 21, 6, 10, 15, 21, 6, 10, 15, 21, 6, 10, 15, 21], b25 = n23.length * 8, o9 = (n23.length % 64 < 56 ? 56 : 120) - n23.length % 64, s9 = new Uint8Array(n23.length + o9 + 8);
  s9.set(n23), s9[n23.length] = 128;
  let d16 = new DataView(s9.buffer);
  d16.setUint32(s9.length - 8, b25 >>> 0, true), d16.setUint32(s9.length - 4, Math.floor(b25 / 4294967296), true);
  let w19 = 1732584193, l8 = 4023233417, p17 = 2562383102, e7 = 271733878;
  for (let r8 = 0; r8 < s9.length; r8 += 64) {
    let u11 = new Uint32Array(16);
    for (let t6 = 0; t6 < 16; t6++) u11[t6] = d16.getUint32(r8 + t6 * 4, true);
    let U14 = w19, a7 = l8, x23 = p17, c15 = e7;
    for (let t6 = 0; t6 < 64; t6++) {
      let i10, $18;
      t6 < 16 ? (i10 = a7 & x23 | ~a7 & c15, $18 = t6) : t6 < 32 ? (i10 = c15 & a7 | ~c15 & x23, $18 = (5 * t6 + 1) % 16) : t6 < 48 ? (i10 = a7 ^ x23 ^ c15, $18 = (3 * t6 + 5) % 16) : (i10 = x23 ^ (a7 | ~c15), $18 = 7 * t6 % 16), i10 = i10 + U14 + g18[t6] + u11[$18] >>> 0, U14 = c15, c15 = x23, x23 = a7, a7 = a7 + h17(i10, A14[t6]) >>> 0;
    }
    w19 = w19 + U14 >>> 0, l8 = l8 + a7 >>> 0, p17 = p17 + x23 >>> 0, e7 = e7 + c15 >>> 0;
  }
  let f11 = new Uint8Array(16);
  return new DataView(f11.buffer).setUint32(0, w19, true), new DataView(f11.buffer).setUint32(4, l8, true), new DataView(f11.buffer).setUint32(8, p17, true), new DataView(f11.buffer).setUint32(12, e7, true), Array.from(f11).map((r8) => r8.toString(16).padStart(2, "0")).join("");
}
async function C15(n23, h17) {
  if (n23 === "md5") return L12(h17);
  let g18 = F15.get(n23);
  if (!g18) throw new Error(`Unknown algorithm: ${n23}`);
  let A14 = await globalThis.crypto.subtle.digest(g18, new Uint8Array(h17).buffer);
  return Array.from(new Uint8Array(A14)).map((b25) => b25.toString(16).padStart(2, "0")).join("");
}
function S9(n23, h17, g18) {
  let A14 = { name: n23, summary: g18, usage: `${n23} [OPTION]... [FILE]...`, options: ["-c, --check    read checksums from FILEs and check them", "    --help     display this help and exit"] };
  return { name: n23, async execute(b25, o9) {
    if (o2(b25)) return s(A14);
    let s9 = false, d16 = [];
    for (let e7 of b25) if (e7 === "-c" || e7 === "--check") s9 = true;
    else if (!(e7 === "-b" || e7 === "-t" || e7 === "--binary" || e7 === "--text")) {
      if (e7.startsWith("-") && e7 !== "-") return r3(n23, e7);
      d16.push(e7);
    }
    d16.length === 0 && d16.push("-");
    let w19 = async (e7) => {
      if (e7 === "-") return Uint8Array.from(o9.stdin, (f11) => f11.charCodeAt(0));
      try {
        return await o9.fs.readFileBuffer(o9.fs.resolvePath(o9.cwd, e7));
      } catch {
        return null;
      }
    };
    if (s9) {
      let e7 = 0, f11 = "";
      for (let r8 of d16) {
        let u11 = r8 === "-" ? o9.stdin : await o9.fs.readFile(o9.fs.resolvePath(o9.cwd, r8)).catch(() => null);
        if (u11 === null) return { stdout: "", stderr: `${n23}: ${r8}: No such file or directory
`, exitCode: 1 };
        for (let U14 of u11.split(`
`)) {
          let a7 = U14.match(/^([a-fA-F0-9]+)\s+[* ]?(.+)$/);
          if (!a7) continue;
          let [, x23, c15] = a7, t6 = await w19(c15);
          if (t6 === null) {
            f11 += `${c15}: FAILED open or read
`, e7++;
            continue;
          }
          let i10 = await C15(h17, t6) === x23.toLowerCase();
          f11 += `${c15}: ${i10 ? "OK" : "FAILED"}
`, i10 || e7++;
        }
      }
      return e7 > 0 && (f11 += `${n23}: WARNING: ${e7} computed checksum${e7 > 1 ? "s" : ""} did NOT match
`), { stdout: f11, stderr: "", exitCode: e7 > 0 ? 1 : 0 };
    }
    let l8 = "", p17 = 0;
    for (let e7 of d16) {
      let f11 = await w19(e7);
      if (f11 === null) {
        l8 += `${n23}: ${e7}: No such file or directory
`, p17 = 1;
        continue;
      }
      l8 += `${await C15(h17, f11)}  ${e7}
`;
    }
    return { stdout: l8, stderr: "", exitCode: p17 };
  } };
}
var F15;
var init_chunk_EIZGF4BS = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-EIZGF4BS.js"() {
    init_chunk_74CEPOFO();
    F15 = /* @__PURE__ */ new Map([["sha1", "SHA-1"], ["sha256", "SHA-256"]]);
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-APT7OOP2.js
var s6, o7;
var init_chunk_APT7OOP2 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-APT7OOP2.js"() {
    init_chunk_EIZGF4BS();
    s6 = S9("md5sum", "md5", "compute MD5 message digest");
    o7 = { name: "md5sum", flags: [{ flag: "-c", type: "boolean" }], needsFiles: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/md5sum-INMIK4DX.js
var md5sum_INMIK4DX_exports = {};
__export(md5sum_INMIK4DX_exports, {
  flagsForFuzzing: () => o7,
  md5sumCommand: () => s6
});
var init_md5sum_INMIK4DX = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/md5sum-INMIK4DX.js"() {
    init_chunk_APT7OOP2();
    init_chunk_EIZGF4BS();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-XKQRETAK.js
var a4, m20;
var init_chunk_XKQRETAK = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-XKQRETAK.js"() {
    init_chunk_EIZGF4BS();
    a4 = S9("sha1sum", "sha1", "compute SHA1 message digest");
    m20 = { name: "sha1sum", flags: [{ flag: "-c", type: "boolean" }], needsFiles: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/sha1sum-VJPNLNU6.js
var sha1sum_VJPNLNU6_exports = {};
__export(sha1sum_VJPNLNU6_exports, {
  flagsForFuzzing: () => m20,
  sha1sumCommand: () => a4
});
var init_sha1sum_VJPNLNU6 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/sha1sum-VJPNLNU6.js"() {
    init_chunk_XKQRETAK();
    init_chunk_EIZGF4BS();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-5V6VZH6T.js
var a5, m21;
var init_chunk_5V6VZH6T = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-5V6VZH6T.js"() {
    init_chunk_EIZGF4BS();
    a5 = S9("sha256sum", "sha256", "compute SHA256 message digest");
    m21 = { name: "sha256sum", flags: [{ flag: "-c", type: "boolean" }], needsFiles: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/sha256sum-PI32XWXY.js
var sha256sum_PI32XWXY_exports = {};
__export(sha256sum_PI32XWXY_exports, {
  flagsForFuzzing: () => m21,
  sha256sumCommand: () => a5
});
var init_sha256sum_PI32XWXY = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/sha256sum-PI32XWXY.js"() {
    init_chunk_5V6VZH6T();
    init_chunk_EIZGF4BS();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// stub-node:node:fs/promises
var open;
var init_promises = __esm({
  "stub-node:node:fs/promises"() {
    open = () => {
      throw new Error("node:fs/promises stubbed for browser");
    };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-CR5AFCPT.js
function oe5(i10) {
  try {
    let e7 = i10.getReader({ mode: "byob" });
    return e7 instanceof ReadableStreamDefaultReader ? new L13(e7) : new _7(e7);
  } catch (e7) {
    if (e7 instanceof TypeError) return new L13(i10.getReader());
    throw e7;
  }
}
function se5(i10, e7) {
  let t6 = oe5(i10), r8 = e7 ?? {}, n23 = r8.onClose;
  return r8.onClose = async () => {
    if (await t6.close(), n23) return n23();
  }, new X7(t6, r8);
}
function ve4(i10, e7) {
  return new Z8(i10, e7);
}
function Se3(i10, e7) {
  return new Q9(i10, e7);
}
function Ee4(i10, e7 = "utf-8") {
  switch (e7.toLowerCase()) {
    case "utf-8":
    case "utf8":
      return typeof globalThis.TextDecoder < "u" ? new globalThis.TextDecoder("utf-8").decode(i10) : lt4(i10);
    case "utf-16le":
      return ut3(i10);
    case "ascii":
      return xt2(i10);
    case "latin1":
    case "iso-8859-1":
      return dt4(i10);
    case "windows-1252":
      return ht3(i10);
    default:
      throw new RangeError(`Encoding '${e7}' not supported`);
  }
}
function lt4(i10) {
  let e7 = "", t6 = 0;
  for (; t6 < i10.length; ) {
    let r8 = i10[t6++];
    if (r8 < 128) e7 += String.fromCharCode(r8);
    else if (r8 < 224) {
      let n23 = i10[t6++] & 63;
      e7 += String.fromCharCode((r8 & 31) << 6 | n23);
    } else if (r8 < 240) {
      let n23 = i10[t6++] & 63, o9 = i10[t6++] & 63;
      e7 += String.fromCharCode((r8 & 15) << 12 | n23 << 6 | o9);
    } else {
      let n23 = i10[t6++] & 63, o9 = i10[t6++] & 63, s9 = i10[t6++] & 63, c15 = (r8 & 7) << 18 | n23 << 12 | o9 << 6 | s9;
      c15 -= 65536, e7 += String.fromCharCode(55296 + (c15 >> 10 & 1023), 56320 + (c15 & 1023));
    }
  }
  return e7;
}
function ut3(i10) {
  let e7 = "";
  for (let t6 = 0; t6 < i10.length; t6 += 2) e7 += String.fromCharCode(i10[t6] | i10[t6 + 1] << 8);
  return e7;
}
function xt2(i10) {
  return String.fromCharCode(...i10.map((e7) => e7 & 127));
}
function dt4(i10) {
  return String.fromCharCode(...i10);
}
function ht3(i10) {
  let e7 = "";
  for (let t6 of i10) t6 >= 128 && t6 <= 159 && ce5[t6] ? e7 += ce5[t6] : e7 += String.fromCharCode(t6);
  return e7;
}
function y15(i10) {
  return new DataView(i10.buffer, i10.byteOffset);
}
function Xe3(i10) {
  let e7 = new Uint8Array(h14.len);
  return h14.put(e7, 0, i10), e7;
}
function _t2(i10, e7) {
  let t6 = i10.length, r8 = e7.length;
  if (r8 > t6) return -1;
  for (let n23 = 0; n23 <= t6 - r8; n23++) {
    let o9 = true;
    for (let s9 = 0; s9 < r8; s9++) if (i10[n23 + s9] !== e7[s9]) {
      o9 = false;
      break;
    }
    if (o9) return n23;
  }
  return -1;
}
function $t2(i10) {
  let e7 = i10.reduce((n23, o9) => n23 + o9.length, 0), t6 = new Uint8Array(e7), r8 = 0;
  for (let n23 of i10) t6.set(n23, r8), r8 += n23.length;
  return t6;
}
function de7(i10) {
  let { byteLength: e7 } = i10;
  if (e7 === 6) return i10.getUint16(0) * 2 ** 32 + i10.getUint32(2);
  if (e7 === 5) return i10.getUint8(0) * 2 ** 32 + i10.getUint32(1);
  if (e7 === 4) return i10.getUint32(0);
  if (e7 === 3) return i10.getUint8(0) * 2 ** 16 + i10.getUint16(1);
  if (e7 === 2) return i10.getUint16(0);
  if (e7 === 1) return i10.getUint8(0);
}
function Ze4(i10, e7) {
  if (e7 === "utf-16le") {
    let t6 = [];
    for (let r8 = 0; r8 < i10.length; r8++) {
      let n23 = i10.charCodeAt(r8);
      t6.push(n23 & 255, n23 >> 8 & 255);
    }
    return t6;
  }
  if (e7 === "utf-16be") {
    let t6 = [];
    for (let r8 = 0; r8 < i10.length; r8++) {
      let n23 = i10.charCodeAt(r8);
      t6.push(n23 >> 8 & 255, n23 & 255);
    }
    return t6;
  }
  return [...i10].map((t6) => t6.charCodeAt(0));
}
function Qe3(i10, e7 = 0) {
  let t6 = Number.parseInt(new b21(6).get(i10, 148).replace(/\0.*$/, "").trim(), 8);
  if (Number.isNaN(t6)) return false;
  let r8 = 256;
  for (let n23 = e7; n23 < e7 + 148; n23++) r8 += i10[n23];
  for (let n23 = e7 + 156; n23 < e7 + 512; n23++) r8 += i10[n23];
  return t6 === r8;
}
async function ke3(i10, e7) {
  return new we2(e7).fromBuffer(i10);
}
function ge5(i10) {
  switch (i10 = i10.toLowerCase(), i10) {
    case "application/epub+zip":
      return { ext: "epub", mime: i10 };
    case "application/vnd.oasis.opendocument.text":
      return { ext: "odt", mime: i10 };
    case "application/vnd.oasis.opendocument.text-template":
      return { ext: "ott", mime: i10 };
    case "application/vnd.oasis.opendocument.spreadsheet":
      return { ext: "ods", mime: i10 };
    case "application/vnd.oasis.opendocument.spreadsheet-template":
      return { ext: "ots", mime: i10 };
    case "application/vnd.oasis.opendocument.presentation":
      return { ext: "odp", mime: i10 };
    case "application/vnd.oasis.opendocument.presentation-template":
      return { ext: "otp", mime: i10 };
    case "application/vnd.oasis.opendocument.graphics":
      return { ext: "odg", mime: i10 };
    case "application/vnd.oasis.opendocument.graphics-template":
      return { ext: "otg", mime: i10 };
    case "application/vnd.openxmlformats-officedocument.presentationml.slideshow":
      return { ext: "ppsx", mime: i10 };
    case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
      return { ext: "xlsx", mime: i10 };
    case "application/vnd.ms-excel.sheet.macroenabled":
      return { ext: "xlsm", mime: "application/vnd.ms-excel.sheet.macroenabled.12" };
    case "application/vnd.openxmlformats-officedocument.spreadsheetml.template":
      return { ext: "xltx", mime: i10 };
    case "application/vnd.ms-excel.template.macroenabled":
      return { ext: "xltm", mime: "application/vnd.ms-excel.template.macroenabled.12" };
    case "application/vnd.ms-powerpoint.slideshow.macroenabled":
      return { ext: "ppsm", mime: "application/vnd.ms-powerpoint.slideshow.macroenabled.12" };
    case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
      return { ext: "docx", mime: i10 };
    case "application/vnd.ms-word.document.macroenabled":
      return { ext: "docm", mime: "application/vnd.ms-word.document.macroenabled.12" };
    case "application/vnd.openxmlformats-officedocument.wordprocessingml.template":
      return { ext: "dotx", mime: i10 };
    case "application/vnd.ms-word.template.macroenabledtemplate":
      return { ext: "dotm", mime: "application/vnd.ms-word.template.macroenabled.12" };
    case "application/vnd.openxmlformats-officedocument.presentationml.template":
      return { ext: "potx", mime: i10 };
    case "application/vnd.ms-powerpoint.template.macroenabled":
      return { ext: "potm", mime: "application/vnd.ms-powerpoint.template.macroenabled.12" };
    case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
      return { ext: "pptx", mime: i10 };
    case "application/vnd.ms-powerpoint.presentation.macroenabled":
      return { ext: "pptm", mime: "application/vnd.ms-powerpoint.presentation.macroenabled.12" };
    case "application/vnd.ms-visio.drawing":
      return { ext: "vsdx", mime: "application/vnd.visio" };
    case "application/vnd.ms-package.3dmanufacturing-3dmodel+xml":
      return { ext: "3mf", mime: "model/3mf" };
    default:
  }
}
function A8(i10, e7, t6) {
  t6 = { offset: 0, ...t6 };
  for (let [r8, n23] of e7.entries()) if (t6.mask) {
    if (n23 !== (t6.mask[r8] & i10[r8 + t6.offset])) return false;
  } else if (n23 !== i10[r8 + t6.offset]) return false;
  return true;
}
function Jt2(i10, e7) {
  let t6 = Gt2.get(i10);
  if (t6) return t6;
  let [r8, n23] = e7.split("/"), o9 = n23?.split("+")[0]?.replace(/-/g, " ") || i10;
  switch (r8) {
    case "image":
      return `${o9.toUpperCase()} image data`;
    case "audio":
      return `${o9.toUpperCase()} audio`;
    case "video":
      return `${o9.toUpperCase()} video`;
    case "font":
      return `${o9} font`;
    case "model":
      return `${o9} 3D model`;
    case "application":
      return n23?.includes("zip") || n23?.includes("compressed") ? `${o9} archive data` : n23?.includes("executable") ? `${o9} executable` : `${i10.toUpperCase()} data`;
    default:
      return `${i10.toUpperCase()} data`;
  }
}
function Xt2(i10) {
  let e7 = i10.split("/").pop() || i10;
  if (e7.startsWith(".") && !e7.includes(".", 1)) return e7;
  let t6 = e7.lastIndexOf(".");
  return t6 === -1 || t6 === 0 ? "" : e7.slice(t6).toLowerCase();
}
function Zt2(i10, e7) {
  if (i10.startsWith("#!")) {
    let m25 = i10.split(`
`)[0];
    return m25.includes("python") ? { description: "Python script, ASCII text executable", mime: "text/x-python" } : m25.includes("node") || m25.includes("bun") || m25.includes("deno") ? { description: "JavaScript script, ASCII text executable", mime: "text/javascript" } : m25.includes("bash") ? { description: "Bourne-Again shell script, ASCII text executable", mime: "text/x-shellscript" } : m25.includes("sh") ? { description: "POSIX shell script, ASCII text executable", mime: "text/x-shellscript" } : m25.includes("ruby") ? { description: "Ruby script, ASCII text executable", mime: "text/x-ruby" } : m25.includes("perl") ? { description: "Perl script, ASCII text executable", mime: "text/x-perl" } : { description: "script, ASCII text executable", mime: "text/plain" };
  }
  let t6 = i10.trimStart();
  if (t6.startsWith("<?xml")) return { description: "XML document", mime: "application/xml" };
  if (t6.startsWith("<!DOCTYPE html") || t6.toLowerCase().startsWith("<html")) return { description: "HTML document", mime: "text/html" };
  let r8 = i10.includes(`\r
`), n23 = i10.includes("\r") && !r8, o9 = "";
  r8 ? o9 = ", with CRLF line terminators" : n23 && (o9 = ", with CR line terminators");
  let s9 = Xt2(e7), c15 = s9 ? qt2.get(s9) : void 0;
  if (c15) return c15.mime.startsWith("text/") && o9 ? { description: `${c15.description}${o9}`, mime: c15.mime } : c15;
  let p17 = false;
  for (let m25 = 0; m25 < Math.min(i10.length, 8192); m25++) if (i10.charCodeAt(m25) > 127) {
    p17 = true;
    break;
  }
  return p17 ? { description: `UTF-8 Unicode text${o9}`, mime: "text/plain; charset=utf-8" } : { description: `ASCII text${o9}`, mime: "text/plain" };
}
async function Qt2(i10, e7) {
  if (e7.length === 0) return { description: "empty", mime: "inode/x-empty" };
  let t6 = await ke3(e7);
  if (t6) return { description: Jt2(t6.ext, t6.mime), mime: t6.mime };
  let r8 = new TextDecoder("utf-8", { fatal: false }).decode(e7);
  return Zt2(r8, i10);
}
var Te3, ze3, fe7, Le4, je4, _e3, He3, We3, nt4, x18, D11, M9, J10, _7, L13, S10, st4, X7, Z8, Q9, $14, ft4, Ae4, ce5, mt4, Be2, d14, R6, h14, Ie4, Oe3, De3, b21, Je3, U10, ue7, Ve3, qe2, Ge3, E7, xe5, Nt4, ie3, H12, W9, ur2, xr2, dr2, Ye3, Ke3, et4, he7, we2, Ht2, Wt2, Vt, qt2, Gt2, Dr2, Mr2;
var init_chunk_CR5AFCPT = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-CR5AFCPT.js"() {
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
    init_promises();
    Te3 = o((ae8) => {
      ae8.read = function(i10, e7, t6, r8, n23) {
        var o9, s9, c15 = n23 * 8 - r8 - 1, p17 = (1 << c15) - 1, m25 = p17 >> 1, a7 = -7, f11 = t6 ? n23 - 1 : 0, l8 = t6 ? -1 : 1, u11 = i10[e7 + f11];
        for (f11 += l8, o9 = u11 & (1 << -a7) - 1, u11 >>= -a7, a7 += c15; a7 > 0; o9 = o9 * 256 + i10[e7 + f11], f11 += l8, a7 -= 8) ;
        for (s9 = o9 & (1 << -a7) - 1, o9 >>= -a7, a7 += r8; a7 > 0; s9 = s9 * 256 + i10[e7 + f11], f11 += l8, a7 -= 8) ;
        if (o9 === 0) o9 = 1 - m25;
        else {
          if (o9 === p17) return s9 ? NaN : (u11 ? -1 : 1) * (1 / 0);
          s9 = s9 + Math.pow(2, r8), o9 = o9 - m25;
        }
        return (u11 ? -1 : 1) * s9 * Math.pow(2, o9 - r8);
      };
      ae8.write = function(i10, e7, t6, r8, n23, o9) {
        var s9, c15, p17, m25 = o9 * 8 - n23 - 1, a7 = (1 << m25) - 1, f11 = a7 >> 1, l8 = n23 === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, u11 = r8 ? 0 : o9 - 1, T10 = r8 ? 1 : -1, k17 = e7 < 0 || e7 === 0 && 1 / e7 < 0 ? 1 : 0;
        for (e7 = Math.abs(e7), isNaN(e7) || e7 === 1 / 0 ? (c15 = isNaN(e7) ? 1 : 0, s9 = a7) : (s9 = Math.floor(Math.log(e7) / Math.LN2), e7 * (p17 = Math.pow(2, -s9)) < 1 && (s9--, p17 *= 2), s9 + f11 >= 1 ? e7 += l8 / p17 : e7 += l8 * Math.pow(2, 1 - f11), e7 * p17 >= 2 && (s9++, p17 /= 2), s9 + f11 >= a7 ? (c15 = 0, s9 = a7) : s9 + f11 >= 1 ? (c15 = (e7 * p17 - 1) * Math.pow(2, n23), s9 = s9 + f11) : (c15 = e7 * Math.pow(2, f11 - 1) * Math.pow(2, n23), s9 = 0)); n23 >= 8; i10[t6 + u11] = c15 & 255, u11 += T10, c15 /= 256, n23 -= 8) ;
        for (s9 = s9 << n23 | c15, m25 += n23; m25 > 0; i10[t6 + u11] = s9 & 255, u11 += T10, s9 /= 256, m25 -= 8) ;
        i10[t6 + u11 - T10] |= k17 * 128;
      };
    });
    ze3 = o((Ki2, Me7) => {
      var j12 = 1e3, P20 = j12 * 60, N15 = P20 * 60, z10 = N15 * 24, wt6 = z10 * 7, kt4 = z10 * 365.25;
      Me7.exports = function(i10, e7) {
        e7 = e7 || {};
        var t6 = typeof i10;
        if (t6 === "string" && i10.length > 0) return yt6(i10);
        if (t6 === "number" && isFinite(i10)) return e7.long ? Ct5(i10) : bt4(i10);
        throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(i10));
      };
      function yt6(i10) {
        if (i10 = String(i10), !(i10.length > 100)) {
          var e7 = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(i10);
          if (e7) {
            var t6 = parseFloat(e7[1]), r8 = (e7[2] || "ms").toLowerCase();
            switch (r8) {
              case "years":
              case "year":
              case "yrs":
              case "yr":
              case "y":
                return t6 * kt4;
              case "weeks":
              case "week":
              case "w":
                return t6 * wt6;
              case "days":
              case "day":
              case "d":
                return t6 * z10;
              case "hours":
              case "hour":
              case "hrs":
              case "hr":
              case "h":
                return t6 * N15;
              case "minutes":
              case "minute":
              case "mins":
              case "min":
              case "m":
                return t6 * P20;
              case "seconds":
              case "second":
              case "secs":
              case "sec":
              case "s":
                return t6 * j12;
              case "milliseconds":
              case "millisecond":
              case "msecs":
              case "msec":
              case "ms":
                return t6;
              default:
                return;
            }
          }
        }
      }
      function bt4(i10) {
        var e7 = Math.abs(i10);
        return e7 >= z10 ? Math.round(i10 / z10) + "d" : e7 >= N15 ? Math.round(i10 / N15) + "h" : e7 >= P20 ? Math.round(i10 / P20) + "m" : e7 >= j12 ? Math.round(i10 / j12) + "s" : i10 + "ms";
      }
      function Ct5(i10) {
        var e7 = Math.abs(i10);
        return e7 >= z10 ? Y11(i10, e7, z10, "day") : e7 >= N15 ? Y11(i10, e7, N15, "hour") : e7 >= P20 ? Y11(i10, e7, P20, "minute") : e7 >= j12 ? Y11(i10, e7, j12, "second") : i10 + " ms";
      }
      function Y11(i10, e7, t6, r8) {
        var n23 = e7 >= t6 * 1.5;
        return Math.round(i10 / t6) + " " + r8 + (n23 ? "s" : "");
      }
    });
    fe7 = o((er3, Ue5) => {
      function Ft4(i10) {
        t6.debug = t6, t6.default = t6, t6.coerce = p17, t6.disable = s9, t6.enable = n23, t6.enabled = c15, t6.humanize = ze3(), t6.destroy = m25, Object.keys(i10).forEach((a7) => {
          t6[a7] = i10[a7];
        }), t6.names = [], t6.skips = [], t6.formatters = {};
        function e7(a7) {
          let f11 = 0;
          for (let l8 = 0; l8 < a7.length; l8++) f11 = (f11 << 5) - f11 + a7.charCodeAt(l8), f11 |= 0;
          return t6.colors[Math.abs(f11) % t6.colors.length];
        }
        t6.selectColor = e7;
        function t6(a7) {
          let f11, l8 = null, u11, T10;
          function k17(...F21) {
            if (!k17.enabled) return;
            let O17 = k17, V13 = Number(/* @__PURE__ */ new Date()), tt8 = V13 - (f11 || V13);
            O17.diff = tt8, O17.prev = f11, O17.curr = V13, f11 = V13, F21[0] = t6.coerce(F21[0]), typeof F21[0] != "string" && F21.unshift("%O");
            let q17 = 0;
            F21[0] = F21[0].replace(/%([a-zA-Z%])/g, (re5, it7) => {
              if (re5 === "%%") return "%";
              q17++;
              let ye7 = t6.formatters[it7];
              if (typeof ye7 == "function") {
                let rt7 = F21[q17];
                re5 = ye7.call(O17, rt7), F21.splice(q17, 1), q17--;
              }
              return re5;
            }), t6.formatArgs.call(O17, F21), (O17.log || t6.log).apply(O17, F21);
          }
          return k17.namespace = a7, k17.useColors = t6.useColors(), k17.color = t6.selectColor(a7), k17.extend = r8, k17.destroy = t6.destroy, Object.defineProperty(k17, "enabled", { enumerable: true, configurable: false, get: () => l8 !== null ? l8 : (u11 !== t6.namespaces && (u11 = t6.namespaces, T10 = t6.enabled(a7)), T10), set: (F21) => {
            l8 = F21;
          } }), typeof t6.init == "function" && t6.init(k17), k17;
        }
        function r8(a7, f11) {
          let l8 = t6(this.namespace + (typeof f11 > "u" ? ":" : f11) + a7);
          return l8.log = this.log, l8;
        }
        function n23(a7) {
          t6.save(a7), t6.namespaces = a7, t6.names = [], t6.skips = [];
          let f11 = (typeof a7 == "string" ? a7 : "").trim().replace(/\s+/g, ",").split(",").filter(Boolean);
          for (let l8 of f11) l8[0] === "-" ? t6.skips.push(l8.slice(1)) : t6.names.push(l8);
        }
        function o9(a7, f11) {
          let l8 = 0, u11 = 0, T10 = -1, k17 = 0;
          for (; l8 < a7.length; ) if (u11 < f11.length && (f11[u11] === a7[l8] || f11[u11] === "*")) f11[u11] === "*" ? (T10 = u11, k17 = l8, u11++) : (l8++, u11++);
          else if (T10 !== -1) u11 = T10 + 1, k17++, l8 = k17;
          else return false;
          for (; u11 < f11.length && f11[u11] === "*"; ) u11++;
          return u11 === f11.length;
        }
        function s9() {
          let a7 = [...t6.names, ...t6.skips.map((f11) => "-" + f11)].join(",");
          return t6.enable(""), a7;
        }
        function c15(a7) {
          for (let f11 of t6.skips) if (o9(a7, f11)) return false;
          for (let f11 of t6.names) if (o9(a7, f11)) return true;
          return false;
        }
        function p17(a7) {
          return a7 instanceof Error ? a7.stack || a7.message : a7;
        }
        function m25() {
          console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
        }
        return t6.enable(t6.load()), t6;
      }
      Ue5.exports = Ft4;
    });
    Le4 = o((C19, K9) => {
      C19.formatArgs = St6;
      C19.save = Tt6;
      C19.load = Et6;
      C19.useColors = vt5;
      C19.storage = At6();
      C19.destroy = /* @__PURE__ */ (() => {
        let i10 = false;
        return () => {
          i10 || (i10 = true, console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`."));
        };
      })();
      C19.colors = ["#0000CC", "#0000FF", "#0033CC", "#0033FF", "#0066CC", "#0066FF", "#0099CC", "#0099FF", "#00CC00", "#00CC33", "#00CC66", "#00CC99", "#00CCCC", "#00CCFF", "#3300CC", "#3300FF", "#3333CC", "#3333FF", "#3366CC", "#3366FF", "#3399CC", "#3399FF", "#33CC00", "#33CC33", "#33CC66", "#33CC99", "#33CCCC", "#33CCFF", "#6600CC", "#6600FF", "#6633CC", "#6633FF", "#66CC00", "#66CC33", "#9900CC", "#9900FF", "#9933CC", "#9933FF", "#99CC00", "#99CC33", "#CC0000", "#CC0033", "#CC0066", "#CC0099", "#CC00CC", "#CC00FF", "#CC3300", "#CC3333", "#CC3366", "#CC3399", "#CC33CC", "#CC33FF", "#CC6600", "#CC6633", "#CC9900", "#CC9933", "#CCCC00", "#CCCC33", "#FF0000", "#FF0033", "#FF0066", "#FF0099", "#FF00CC", "#FF00FF", "#FF3300", "#FF3333", "#FF3366", "#FF3399", "#FF33CC", "#FF33FF", "#FF6600", "#FF6633", "#FF9900", "#FF9933", "#FFCC00", "#FFCC33"];
      function vt5() {
        if (typeof window < "u" && window.process && (window.process.type === "renderer" || window.process.__nwjs)) return true;
        if (typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) return false;
        let i10;
        return typeof document < "u" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || typeof window < "u" && window.console && (window.console.firebug || window.console.exception && window.console.table) || typeof navigator < "u" && navigator.userAgent && (i10 = navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/)) && parseInt(i10[1], 10) >= 31 || typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
      }
      function St6(i10) {
        if (i10[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + i10[0] + (this.useColors ? "%c " : " ") + "+" + K9.exports.humanize(this.diff), !this.useColors) return;
        let e7 = "color: " + this.color;
        i10.splice(1, 0, e7, "color: inherit");
        let t6 = 0, r8 = 0;
        i10[0].replace(/%[a-zA-Z%]/g, (n23) => {
          n23 !== "%%" && (t6++, n23 === "%c" && (r8 = t6));
        }), i10.splice(r8, 0, e7);
      }
      C19.log = console.debug || console.log || (() => {
      });
      function Tt6(i10) {
        try {
          i10 ? C19.storage.setItem("debug", i10) : C19.storage.removeItem("debug");
        } catch {
        }
      }
      function Et6() {
        let i10;
        try {
          i10 = C19.storage.getItem("debug") || C19.storage.getItem("DEBUG");
        } catch {
        }
        return !i10 && typeof process < "u" && "env" in process && (i10 = process.env.DEBUG), i10;
      }
      function At6() {
        try {
          return localStorage;
        } catch {
        }
      }
      K9.exports = fe7()(C19);
      var { formatters: Bt3 } = K9.exports;
      Bt3.j = function(i10) {
        try {
          return JSON.stringify(i10);
        } catch (e7) {
          return "[UnexpectedJSONParseError]: " + e7.message;
        }
      };
    });
    je4 = o((tr3, Re8) => {
      "use strict";
      Re8.exports = (i10, e7 = process.argv) => {
        let t6 = i10.startsWith("-") ? "" : i10.length === 1 ? "-" : "--", r8 = e7.indexOf(t6 + i10), n23 = e7.indexOf("--");
        return r8 !== -1 && (n23 === -1 || r8 < n23);
      };
    });
    _e3 = o((ir3, Ne6) => {
      "use strict";
      var It3 = m4("os"), Pe6 = m4("tty"), v21 = je4(), { env: g18 } = process, I18;
      v21("no-color") || v21("no-colors") || v21("color=false") || v21("color=never") ? I18 = 0 : (v21("color") || v21("colors") || v21("color=true") || v21("color=always")) && (I18 = 1);
      "FORCE_COLOR" in g18 && (g18.FORCE_COLOR === "true" ? I18 = 1 : g18.FORCE_COLOR === "false" ? I18 = 0 : I18 = g18.FORCE_COLOR.length === 0 ? 1 : Math.min(parseInt(g18.FORCE_COLOR, 10), 3));
      function pe8(i10) {
        return i10 === 0 ? false : { level: i10, hasBasic: true, has256: i10 >= 2, has16m: i10 >= 3 };
      }
      function me6(i10, e7) {
        if (I18 === 0) return 0;
        if (v21("color=16m") || v21("color=full") || v21("color=truecolor")) return 3;
        if (v21("color=256")) return 2;
        if (i10 && !e7 && I18 === void 0) return 0;
        let t6 = I18 || 0;
        if (g18.TERM === "dumb") return t6;
        if (process.platform === "win32") {
          let r8 = It3.release().split(".");
          return Number(r8[0]) >= 10 && Number(r8[2]) >= 10586 ? Number(r8[2]) >= 14931 ? 3 : 2 : 1;
        }
        if ("CI" in g18) return ["TRAVIS", "CIRCLECI", "APPVEYOR", "GITLAB_CI", "GITHUB_ACTIONS", "BUILDKITE"].some((r8) => r8 in g18) || g18.CI_NAME === "codeship" ? 1 : t6;
        if ("TEAMCITY_VERSION" in g18) return /^(9\.(0*[1-9]\d*)\.|\d{2,}\.)/.test(g18.TEAMCITY_VERSION) ? 1 : 0;
        if (g18.COLORTERM === "truecolor") return 3;
        if ("TERM_PROGRAM" in g18) {
          let r8 = parseInt((g18.TERM_PROGRAM_VERSION || "").split(".")[0], 10);
          switch (g18.TERM_PROGRAM) {
            case "iTerm.app":
              return r8 >= 3 ? 3 : 2;
            case "Apple_Terminal":
              return 2;
          }
        }
        return /-256(color)?$/i.test(g18.TERM) ? 2 : /^screen|^xterm|^vt100|^vt220|^rxvt|color|ansi|cygwin|linux/i.test(g18.TERM) || "COLORTERM" in g18 ? 1 : t6;
      }
      function Ot5(i10) {
        let e7 = me6(i10, i10 && i10.isTTY);
        return pe8(e7);
      }
      Ne6.exports = { supportsColor: Ot5, stdout: pe8(me6(true, Pe6.isatty(1))), stderr: pe8(me6(true, Pe6.isatty(2))) };
    });
    He3 = o((w19, te10) => {
      var Dt2 = m4("tty"), ee7 = m4("util");
      w19.init = Pt5;
      w19.log = Lt5;
      w19.formatArgs = zt4;
      w19.save = Rt2;
      w19.load = jt4;
      w19.useColors = Mt4;
      w19.destroy = ee7.deprecate(() => {
      }, "Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
      w19.colors = [6, 2, 3, 4, 5, 1];
      try {
        let i10 = _e3();
        i10 && (i10.stderr || i10).level >= 2 && (w19.colors = [20, 21, 26, 27, 32, 33, 38, 39, 40, 41, 42, 43, 44, 45, 56, 57, 62, 63, 68, 69, 74, 75, 76, 77, 78, 79, 80, 81, 92, 93, 98, 99, 112, 113, 128, 129, 134, 135, 148, 149, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 178, 179, 184, 185, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 214, 215, 220, 221]);
      } catch {
      }
      w19.inspectOpts = Object.keys(process.env).filter((i10) => /^debug_/i.test(i10)).reduce((i10, e7) => {
        let t6 = e7.substring(6).toLowerCase().replace(/_([a-z])/g, (n23, o9) => o9.toUpperCase()), r8 = process.env[e7];
        return /^(yes|on|true|enabled)$/i.test(r8) ? r8 = true : /^(no|off|false|disabled)$/i.test(r8) ? r8 = false : r8 === "null" ? r8 = null : r8 = Number(r8), i10[t6] = r8, i10;
      }, {});
      function Mt4() {
        return "colors" in w19.inspectOpts ? !!w19.inspectOpts.colors : Dt2.isatty(process.stderr.fd);
      }
      function zt4(i10) {
        let { namespace: e7, useColors: t6 } = this;
        if (t6) {
          let r8 = this.color, n23 = "\x1B[3" + (r8 < 8 ? r8 : "8;5;" + r8), o9 = `  ${n23};1m${e7} \x1B[0m`;
          i10[0] = o9 + i10[0].split(`
`).join(`
` + o9), i10.push(n23 + "m+" + te10.exports.humanize(this.diff) + "\x1B[0m");
        } else i10[0] = Ut4() + e7 + " " + i10[0];
      }
      function Ut4() {
        return w19.inspectOpts.hideDate ? "" : (/* @__PURE__ */ new Date()).toISOString() + " ";
      }
      function Lt5(...i10) {
        return process.stderr.write(ee7.formatWithOptions(w19.inspectOpts, ...i10) + `
`);
      }
      function Rt2(i10) {
        i10 ? process.env.DEBUG = i10 : delete process.env.DEBUG;
      }
      function jt4() {
        return process.env.DEBUG;
      }
      function Pt5(i10) {
        i10.inspectOpts = {};
        let e7 = Object.keys(w19.inspectOpts);
        for (let t6 = 0; t6 < e7.length; t6++) i10.inspectOpts[e7[t6]] = w19.inspectOpts[e7[t6]];
      }
      te10.exports = fe7()(w19);
      var { formatters: $e7 } = te10.exports;
      $e7.o = function(i10) {
        return this.inspectOpts.colors = this.useColors, ee7.inspect(i10, this.inspectOpts).split(`
`).map((e7) => e7.trim()).join(" ");
      };
      $e7.O = function(i10) {
        return this.inspectOpts.colors = this.useColors, ee7.inspect(i10, this.inspectOpts);
      };
    });
    We3 = o((rr3, le9) => {
      typeof process > "u" || process.type === "renderer" || process.browser === true || process.__nwjs ? le9.exports = Le4() : le9.exports = He3();
    });
    nt4 = "End-Of-Stream";
    x18 = class extends Error {
      constructor() {
        super(nt4), this.name = "EndOfStreamError";
      }
    };
    D11 = class extends Error {
      constructor(e7 = "The operation was aborted") {
        super(e7), this.name = "AbortError";
      }
    };
    M9 = class {
      constructor() {
        this.endOfStream = false, this.interrupted = false, this.peekQueue = [];
      }
      async peek(e7, t6 = false) {
        let r8 = await this.read(e7, t6);
        return this.peekQueue.push(e7.subarray(0, r8)), r8;
      }
      async read(e7, t6 = false) {
        if (e7.length === 0) return 0;
        let r8 = this.readFromPeekBuffer(e7);
        if (this.endOfStream || (r8 += await this.readRemainderFromStream(e7.subarray(r8), t6)), r8 === 0 && !t6) throw new x18();
        return r8;
      }
      readFromPeekBuffer(e7) {
        let t6 = e7.length, r8 = 0;
        for (; this.peekQueue.length > 0 && t6 > 0; ) {
          let n23 = this.peekQueue.pop();
          if (!n23) throw new Error("peekData should be defined");
          let o9 = Math.min(n23.length, t6);
          e7.set(n23.subarray(0, o9), r8), r8 += o9, t6 -= o9, o9 < n23.length && this.peekQueue.push(n23.subarray(o9));
        }
        return r8;
      }
      async readRemainderFromStream(e7, t6) {
        let r8 = 0;
        for (; r8 < e7.length && !this.endOfStream; ) {
          if (this.interrupted) throw new D11();
          let n23 = await this.readFromStream(e7.subarray(r8), t6);
          if (n23 === 0) break;
          r8 += n23;
        }
        if (!t6 && r8 < e7.length) throw new x18();
        return r8;
      }
    };
    J10 = class extends M9 {
      constructor(e7) {
        super(), this.reader = e7;
      }
      async abort() {
        return this.close();
      }
      async close() {
        this.reader.releaseLock();
      }
    };
    _7 = class extends J10 {
      async readFromStream(e7, t6) {
        if (e7.length === 0) return 0;
        let r8 = await this.reader.read(new Uint8Array(e7.length), { min: t6 ? void 0 : e7.length });
        return r8.done && (this.endOfStream = r8.done), r8.value ? (e7.set(r8.value), r8.value.length) : 0;
      }
    };
    L13 = class extends M9 {
      constructor(e7) {
        super(), this.reader = e7, this.buffer = null;
      }
      writeChunk(e7, t6) {
        let r8 = Math.min(t6.length, e7.length);
        return e7.set(t6.subarray(0, r8)), r8 < t6.length ? this.buffer = t6.subarray(r8) : this.buffer = null, r8;
      }
      async readFromStream(e7, t6) {
        if (e7.length === 0) return 0;
        let r8 = 0;
        for (this.buffer && (r8 += this.writeChunk(e7, this.buffer)); r8 < e7.length && !this.endOfStream; ) {
          let n23 = await this.reader.read();
          if (n23.done) {
            this.endOfStream = true;
            break;
          }
          n23.value && (r8 += this.writeChunk(e7.subarray(r8), n23.value));
        }
        if (!t6 && r8 === 0 && this.endOfStream) throw new x18();
        return r8;
      }
      abort() {
        return this.interrupted = true, this.reader.cancel();
      }
      async close() {
        await this.abort(), this.reader.releaseLock();
      }
    };
    S10 = class {
      constructor(e7) {
        this.numBuffer = new Uint8Array(8), this.position = 0, this.onClose = e7?.onClose, e7?.abortSignal && e7.abortSignal.addEventListener("abort", () => {
          this.abort();
        });
      }
      async readToken(e7, t6 = this.position) {
        let r8 = new Uint8Array(e7.len);
        if (await this.readBuffer(r8, { position: t6 }) < e7.len) throw new x18();
        return e7.get(r8, 0);
      }
      async peekToken(e7, t6 = this.position) {
        let r8 = new Uint8Array(e7.len);
        if (await this.peekBuffer(r8, { position: t6 }) < e7.len) throw new x18();
        return e7.get(r8, 0);
      }
      async readNumber(e7) {
        if (await this.readBuffer(this.numBuffer, { length: e7.len }) < e7.len) throw new x18();
        return e7.get(this.numBuffer, 0);
      }
      async peekNumber(e7) {
        if (await this.peekBuffer(this.numBuffer, { length: e7.len }) < e7.len) throw new x18();
        return e7.get(this.numBuffer, 0);
      }
      async ignore(e7) {
        if (this.fileInfo.size !== void 0) {
          let t6 = this.fileInfo.size - this.position;
          if (e7 > t6) return this.position += t6, t6;
        }
        return this.position += e7, e7;
      }
      async close() {
        await this.abort(), await this.onClose?.();
      }
      normalizeOptions(e7, t6) {
        if (!this.supportsRandomAccess() && t6 && t6.position !== void 0 && t6.position < this.position) throw new Error("`options.position` must be equal or greater than `tokenizer.position`");
        return { mayBeLess: false, offset: 0, length: e7.length, position: this.position, ...t6 };
      }
      abort() {
        return Promise.resolve();
      }
    };
    st4 = 256e3;
    X7 = class extends S10 {
      constructor(e7, t6) {
        super(t6), this.streamReader = e7, this.fileInfo = t6?.fileInfo ?? {};
      }
      async readBuffer(e7, t6) {
        let r8 = this.normalizeOptions(e7, t6), n23 = r8.position - this.position;
        if (n23 > 0) return await this.ignore(n23), this.readBuffer(e7, t6);
        if (n23 < 0) throw new Error("`options.position` must be equal or greater than `tokenizer.position`");
        if (r8.length === 0) return 0;
        let o9 = await this.streamReader.read(e7.subarray(0, r8.length), r8.mayBeLess);
        if (this.position += o9, (!t6 || !t6.mayBeLess) && o9 < r8.length) throw new x18();
        return o9;
      }
      async peekBuffer(e7, t6) {
        let r8 = this.normalizeOptions(e7, t6), n23 = 0;
        if (r8.position) {
          let o9 = r8.position - this.position;
          if (o9 > 0) {
            let s9 = new Uint8Array(r8.length + o9);
            return n23 = await this.peekBuffer(s9, { mayBeLess: r8.mayBeLess }), e7.set(s9.subarray(o9)), n23 - o9;
          }
          if (o9 < 0) throw new Error("Cannot peek from a negative offset in a stream");
        }
        if (r8.length > 0) {
          try {
            n23 = await this.streamReader.peek(e7.subarray(0, r8.length), r8.mayBeLess);
          } catch (o9) {
            if (t6?.mayBeLess && o9 instanceof x18) return 0;
            throw o9;
          }
          if (!r8.mayBeLess && n23 < r8.length) throw new x18();
        }
        return n23;
      }
      async ignore(e7) {
        let t6 = Math.min(st4, e7), r8 = new Uint8Array(t6), n23 = 0;
        for (; n23 < e7; ) {
          let o9 = e7 - n23, s9 = await this.readBuffer(r8, { length: Math.min(t6, o9) });
          if (s9 < 0) return s9;
          n23 += s9;
        }
        return n23;
      }
      abort() {
        return this.streamReader.abort();
      }
      async close() {
        return this.streamReader.close();
      }
      supportsRandomAccess() {
        return false;
      }
    };
    Z8 = class extends S10 {
      constructor(e7, t6) {
        super(t6), this.uint8Array = e7, this.fileInfo = { ...t6?.fileInfo ?? {}, size: e7.length };
      }
      async readBuffer(e7, t6) {
        t6?.position && (this.position = t6.position);
        let r8 = await this.peekBuffer(e7, t6);
        return this.position += r8, r8;
      }
      async peekBuffer(e7, t6) {
        let r8 = this.normalizeOptions(e7, t6), n23 = Math.min(this.uint8Array.length - r8.position, r8.length);
        if (!r8.mayBeLess && n23 < r8.length) throw new x18();
        return e7.set(this.uint8Array.subarray(r8.position, r8.position + n23)), n23;
      }
      close() {
        return super.close();
      }
      supportsRandomAccess() {
        return true;
      }
      setPosition(e7) {
        this.position = e7;
      }
    };
    Q9 = class extends S10 {
      constructor(e7, t6) {
        super(t6), this.blob = e7, this.fileInfo = { ...t6?.fileInfo ?? {}, size: e7.size, mimeType: e7.type };
      }
      async readBuffer(e7, t6) {
        t6?.position && (this.position = t6.position);
        let r8 = await this.peekBuffer(e7, t6);
        return this.position += r8, r8;
      }
      async peekBuffer(e7, t6) {
        let r8 = this.normalizeOptions(e7, t6), n23 = Math.min(this.blob.size - r8.position, r8.length);
        if (!r8.mayBeLess && n23 < r8.length) throw new x18();
        let o9 = await this.blob.slice(r8.position, r8.position + n23).arrayBuffer();
        return e7.set(new Uint8Array(o9)), n23;
      }
      close() {
        return super.close();
      }
      supportsRandomAccess() {
        return true;
      }
      setPosition(e7) {
        this.position = e7;
      }
    };
    $14 = class i7 extends S10 {
      static async fromFile(e7) {
        let t6 = await open(e7, "r"), r8 = await t6.stat();
        return new i7(t6, { fileInfo: { path: e7, size: r8.size } });
      }
      constructor(e7, t6) {
        super(t6), this.fileHandle = e7, this.fileInfo = t6.fileInfo;
      }
      async readBuffer(e7, t6) {
        let r8 = this.normalizeOptions(e7, t6);
        if (this.position = r8.position, r8.length === 0) return 0;
        let n23 = await this.fileHandle.read(e7, 0, r8.length, r8.position);
        if (this.position += n23.bytesRead, n23.bytesRead < r8.length && (!t6 || !t6.mayBeLess)) throw new x18();
        return n23.bytesRead;
      }
      async peekBuffer(e7, t6) {
        let r8 = this.normalizeOptions(e7, t6), n23 = await this.fileHandle.read(e7, 0, r8.length, r8.position);
        if (!r8.mayBeLess && n23.bytesRead < r8.length) throw new x18();
        return n23.bytesRead;
      }
      async close() {
        return await this.fileHandle.close(), super.close();
      }
      setPosition(e7) {
        this.position = e7;
      }
      supportsRandomAccess() {
        return true;
      }
    };
    ft4 = $14.fromFile;
    Ae4 = q3(Te3(), 1);
    ce5 = { 128: "\u20AC", 130: "\u201A", 131: "\u0192", 132: "\u201E", 133: "\u2026", 134: "\u2020", 135: "\u2021", 136: "\u02C6", 137: "\u2030", 138: "\u0160", 139: "\u2039", 140: "\u0152", 142: "\u017D", 145: "\u2018", 146: "\u2019", 147: "\u201C", 148: "\u201D", 149: "\u2022", 150: "\u2013", 151: "\u2014", 152: "\u02DC", 153: "\u2122", 154: "\u0161", 155: "\u203A", 156: "\u0153", 158: "\u017E", 159: "\u0178" };
    mt4 = {};
    for (let [i10, e7] of Object.entries(ce5)) mt4[e7] = Number.parseInt(i10);
    Be2 = { len: 1, get(i10, e7) {
      return y15(i10).getUint8(e7);
    }, put(i10, e7, t6) {
      return y15(i10).setUint8(e7, t6), e7 + 1;
    } };
    d14 = { len: 2, get(i10, e7) {
      return y15(i10).getUint16(e7, true);
    }, put(i10, e7, t6) {
      return y15(i10).setUint16(e7, t6, true), e7 + 2;
    } };
    R6 = { len: 2, get(i10, e7) {
      return y15(i10).getUint16(e7);
    }, put(i10, e7, t6) {
      return y15(i10).setUint16(e7, t6), e7 + 2;
    } };
    h14 = { len: 4, get(i10, e7) {
      return y15(i10).getUint32(e7, true);
    }, put(i10, e7, t6) {
      return y15(i10).setUint32(e7, t6, true), e7 + 4;
    } };
    Ie4 = { len: 4, get(i10, e7) {
      return y15(i10).getUint32(e7);
    }, put(i10, e7, t6) {
      return y15(i10).setUint32(e7, t6), e7 + 4;
    } };
    Oe3 = { len: 4, get(i10, e7) {
      return y15(i10).getInt32(e7);
    }, put(i10, e7, t6) {
      return y15(i10).setInt32(e7, t6), e7 + 4;
    } };
    De3 = { len: 8, get(i10, e7) {
      return y15(i10).getBigUint64(e7, true);
    }, put(i10, e7, t6) {
      return y15(i10).setBigUint64(e7, t6, true), e7 + 8;
    } };
    b21 = class {
      constructor(e7, t6) {
        this.len = e7, this.encoding = t6;
      }
      get(e7, t6 = 0) {
        let r8 = e7.subarray(t6, t6 + this.len);
        return Ee4(r8, this.encoding);
      }
    };
    Je3 = q3(We3(), 1);
    U10 = { LocalFileHeader: 67324752, DataDescriptor: 134695760, CentralFileHeader: 33639248, EndOfCentralDirectory: 101010256 };
    ue7 = { get(i10) {
      return { signature: h14.get(i10, 0), compressedSize: h14.get(i10, 8), uncompressedSize: h14.get(i10, 12) };
    }, len: 16 };
    Ve3 = { get(i10) {
      let e7 = d14.get(i10, 6);
      return { signature: h14.get(i10, 0), minVersion: d14.get(i10, 4), dataDescriptor: !!(e7 & 8), compressedMethod: d14.get(i10, 8), compressedSize: h14.get(i10, 18), uncompressedSize: h14.get(i10, 22), filenameLength: d14.get(i10, 26), extraFieldLength: d14.get(i10, 28), filename: null };
    }, len: 30 };
    qe2 = { get(i10) {
      return { signature: h14.get(i10, 0), nrOfThisDisk: d14.get(i10, 4), nrOfThisDiskWithTheStart: d14.get(i10, 6), nrOfEntriesOnThisDisk: d14.get(i10, 8), nrOfEntriesOfSize: d14.get(i10, 10), sizeOfCd: h14.get(i10, 12), offsetOfStartOfCd: h14.get(i10, 16), zipFileCommentLength: d14.get(i10, 20) };
    }, len: 22 };
    Ge3 = { get(i10) {
      let e7 = d14.get(i10, 8);
      return { signature: h14.get(i10, 0), minVersion: d14.get(i10, 6), dataDescriptor: !!(e7 & 8), compressedMethod: d14.get(i10, 10), compressedSize: h14.get(i10, 20), uncompressedSize: h14.get(i10, 24), filenameLength: d14.get(i10, 28), extraFieldLength: d14.get(i10, 30), fileCommentLength: d14.get(i10, 32), relativeOffsetOfLocalHeader: h14.get(i10, 42), filename: null };
    }, len: 46 };
    E7 = (0, Je3.default)("tokenizer:inflate");
    xe5 = 256 * 1024;
    Nt4 = Xe3(U10.DataDescriptor);
    ie3 = Xe3(U10.EndOfCentralDirectory);
    H12 = class i8 {
      constructor(e7) {
        this.tokenizer = e7, this.syncBuffer = new Uint8Array(xe5);
      }
      async isZip() {
        return await this.peekSignature() === U10.LocalFileHeader;
      }
      peekSignature() {
        return this.tokenizer.peekToken(h14);
      }
      async findEndOfCentralDirectoryLocator() {
        let e7 = this.tokenizer, t6 = Math.min(16 * 1024, e7.fileInfo.size), r8 = this.syncBuffer.subarray(0, t6);
        await this.tokenizer.readBuffer(r8, { position: e7.fileInfo.size - t6 });
        for (let n23 = r8.length - 4; n23 >= 0; n23--) if (r8[n23] === ie3[0] && r8[n23 + 1] === ie3[1] && r8[n23 + 2] === ie3[2] && r8[n23 + 3] === ie3[3]) return e7.fileInfo.size - t6 + n23;
        return -1;
      }
      async readCentralDirectory() {
        if (!this.tokenizer.supportsRandomAccess()) {
          E7("Cannot reading central-directory without random-read support");
          return;
        }
        E7("Reading central-directory...");
        let e7 = this.tokenizer.position, t6 = await this.findEndOfCentralDirectoryLocator();
        if (t6 > 0) {
          E7("Central-directory 32-bit signature found");
          let r8 = await this.tokenizer.readToken(qe2, t6), n23 = [];
          this.tokenizer.setPosition(r8.offsetOfStartOfCd);
          for (let o9 = 0; o9 < r8.nrOfEntriesOfSize; ++o9) {
            let s9 = await this.tokenizer.readToken(Ge3);
            if (s9.signature !== U10.CentralFileHeader) throw new Error("Expected Central-File-Header signature");
            s9.filename = await this.tokenizer.readToken(new b21(s9.filenameLength, "utf-8")), await this.tokenizer.ignore(s9.extraFieldLength), await this.tokenizer.ignore(s9.fileCommentLength), n23.push(s9), E7(`Add central-directory file-entry: n=${o9 + 1}/${n23.length}: filename=${n23[o9].filename}`);
          }
          return this.tokenizer.setPosition(e7), n23;
        }
        this.tokenizer.setPosition(e7);
      }
      async unzip(e7) {
        let t6 = await this.readCentralDirectory();
        if (t6) return this.iterateOverCentralDirectory(t6, e7);
        let r8 = false;
        do {
          let n23 = await this.readLocalFileHeader();
          if (!n23) break;
          let o9 = e7(n23);
          r8 = !!o9.stop;
          let s9;
          if (await this.tokenizer.ignore(n23.extraFieldLength), n23.dataDescriptor && n23.compressedSize === 0) {
            let c15 = [], p17 = xe5;
            E7("Compressed-file-size unknown, scanning for next data-descriptor-signature....");
            let m25 = -1;
            for (; m25 < 0 && p17 === xe5; ) {
              p17 = await this.tokenizer.peekBuffer(this.syncBuffer, { mayBeLess: true }), m25 = _t2(this.syncBuffer.subarray(0, p17), Nt4);
              let a7 = m25 >= 0 ? m25 : p17;
              if (o9.handler) {
                let f11 = new Uint8Array(a7);
                await this.tokenizer.readBuffer(f11), c15.push(f11);
              } else await this.tokenizer.ignore(a7);
            }
            E7(`Found data-descriptor-signature at pos=${this.tokenizer.position}`), o9.handler && await this.inflate(n23, $t2(c15), o9.handler);
          } else o9.handler ? (E7(`Reading compressed-file-data: ${n23.compressedSize} bytes`), s9 = new Uint8Array(n23.compressedSize), await this.tokenizer.readBuffer(s9), await this.inflate(n23, s9, o9.handler)) : (E7(`Ignoring compressed-file-data: ${n23.compressedSize} bytes`), await this.tokenizer.ignore(n23.compressedSize));
          if (E7(`Reading data-descriptor at pos=${this.tokenizer.position}`), n23.dataDescriptor && (await this.tokenizer.readToken(ue7)).signature !== 134695760) throw new Error(`Expected data-descriptor-signature at position ${this.tokenizer.position - ue7.len}`);
        } while (!r8);
      }
      async iterateOverCentralDirectory(e7, t6) {
        for (let r8 of e7) {
          let n23 = t6(r8);
          if (n23.handler) {
            this.tokenizer.setPosition(r8.relativeOffsetOfLocalHeader);
            let o9 = await this.readLocalFileHeader();
            if (o9) {
              await this.tokenizer.ignore(o9.extraFieldLength);
              let s9 = new Uint8Array(r8.compressedSize);
              await this.tokenizer.readBuffer(s9), await this.inflate(o9, s9, n23.handler);
            }
          }
          if (n23.stop) break;
        }
      }
      async inflate(e7, t6, r8) {
        if (e7.compressedMethod === 0) return r8(t6);
        if (e7.compressedMethod !== 8) throw new Error(`Unsupported ZIP compression method: ${e7.compressedMethod}`);
        E7(`Decompress filename=${e7.filename}, compressed-size=${t6.length}`);
        let n23 = await i8.decompressDeflateRaw(t6);
        return r8(n23);
      }
      static async decompressDeflateRaw(e7) {
        let t6 = new ReadableStream({ start(o9) {
          o9.enqueue(e7), o9.close();
        } }), r8 = new DecompressionStream("deflate-raw"), n23 = t6.pipeThrough(r8);
        try {
          let s9 = await new Response(n23).arrayBuffer();
          return new Uint8Array(s9);
        } catch (o9) {
          let s9 = o9 instanceof Error ? `Failed to deflate ZIP entry: ${o9.message}` : "Unknown decompression error in ZIP entry";
          throw new TypeError(s9);
        }
      }
      async readLocalFileHeader() {
        let e7 = await this.tokenizer.peekToken(h14);
        if (e7 === U10.LocalFileHeader) {
          let t6 = await this.tokenizer.readToken(Ve3);
          return t6.filename = await this.tokenizer.readToken(new b21(t6.filenameLength, "utf-8")), t6;
        }
        if (e7 === U10.CentralFileHeader) return false;
        throw e7 === 3759263696 ? new Error("Encrypted ZIP") : new Error("Unexpected signature");
      }
    };
    W9 = class {
      constructor(e7) {
        this.tokenizer = e7;
      }
      inflate() {
        let e7 = this.tokenizer;
        return new ReadableStream({ async pull(t6) {
          let r8 = new Uint8Array(1024), n23 = await e7.readBuffer(r8, { mayBeLess: true });
          if (n23 === 0) {
            t6.close();
            return;
          }
          t6.enqueue(r8.subarray(0, n23));
        } }).pipeThrough(new DecompressionStream("gzip"));
      }
    };
    ur2 = { utf8: new globalThis.TextDecoder("utf8") };
    xr2 = new globalThis.TextEncoder();
    dr2 = Array.from({ length: 256 }, (i10, e7) => e7.toString(16).padStart(2, "0"));
    Ye3 = { get: (i10, e7) => i10[e7 + 3] & 127 | i10[e7 + 2] << 7 | i10[e7 + 1] << 14 | i10[e7] << 21, len: 4 };
    Ke3 = ["jpg", "png", "apng", "gif", "webp", "flif", "xcf", "cr2", "cr3", "orf", "arw", "dng", "nef", "rw2", "raf", "tif", "bmp", "icns", "jxr", "psd", "indd", "zip", "tar", "rar", "gz", "bz2", "7z", "dmg", "mp4", "mid", "mkv", "webm", "mov", "avi", "mpg", "mp2", "mp3", "m4a", "oga", "ogg", "ogv", "opus", "flac", "wav", "spx", "amr", "pdf", "epub", "elf", "macho", "exe", "swf", "rtf", "wasm", "woff", "woff2", "eot", "ttf", "otf", "ttc", "ico", "flv", "ps", "xz", "sqlite", "nes", "crx", "xpi", "cab", "deb", "ar", "rpm", "Z", "lz", "cfb", "mxf", "mts", "blend", "bpg", "docx", "pptx", "xlsx", "3gp", "3g2", "j2c", "jp2", "jpm", "jpx", "mj2", "aif", "qcp", "odt", "ods", "odp", "xml", "mobi", "heic", "cur", "ktx", "ape", "wv", "dcm", "ics", "glb", "pcap", "dsf", "lnk", "alias", "voc", "ac3", "m4v", "m4p", "m4b", "f4v", "f4p", "f4b", "f4a", "mie", "asf", "ogm", "ogx", "mpc", "arrow", "shp", "aac", "mp1", "it", "s3m", "xm", "skp", "avif", "eps", "lzh", "pgp", "asar", "stl", "chm", "3mf", "zst", "jxl", "vcf", "jls", "pst", "dwg", "parquet", "class", "arj", "cpio", "ace", "avro", "icc", "fbx", "vsdx", "vtt", "apk", "drc", "lz4", "potx", "xltx", "dotx", "xltm", "ott", "ots", "otp", "odg", "otg", "xlsm", "docm", "dotm", "potm", "pptm", "jar", "jmp", "rm", "sav", "ppsm", "ppsx", "tar.gz", "reg", "dat"];
    et4 = ["image/jpeg", "image/png", "image/gif", "image/webp", "image/flif", "image/x-xcf", "image/x-canon-cr2", "image/x-canon-cr3", "image/tiff", "image/bmp", "image/vnd.ms-photo", "image/vnd.adobe.photoshop", "application/x-indesign", "application/epub+zip", "application/x-xpinstall", "application/vnd.ms-powerpoint.slideshow.macroenabled.12", "application/vnd.oasis.opendocument.text", "application/vnd.oasis.opendocument.spreadsheet", "application/vnd.oasis.opendocument.presentation", "application/vnd.openxmlformats-officedocument.wordprocessingml.document", "application/vnd.openxmlformats-officedocument.presentationml.presentation", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.openxmlformats-officedocument.presentationml.slideshow", "application/zip", "application/x-tar", "application/x-rar-compressed", "application/gzip", "application/x-bzip2", "application/x-7z-compressed", "application/x-apple-diskimage", "application/vnd.apache.arrow.file", "video/mp4", "audio/midi", "video/matroska", "video/webm", "video/quicktime", "video/vnd.avi", "audio/wav", "audio/qcelp", "audio/x-ms-asf", "video/x-ms-asf", "application/vnd.ms-asf", "video/mpeg", "video/3gpp", "audio/mpeg", "audio/mp4", "video/ogg", "audio/ogg", "audio/ogg; codecs=opus", "application/ogg", "audio/flac", "audio/ape", "audio/wavpack", "audio/amr", "application/pdf", "application/x-elf", "application/x-mach-binary", "application/x-msdownload", "application/x-shockwave-flash", "application/rtf", "application/wasm", "font/woff", "font/woff2", "application/vnd.ms-fontobject", "font/ttf", "font/otf", "font/collection", "image/x-icon", "video/x-flv", "application/postscript", "application/eps", "application/x-xz", "application/x-sqlite3", "application/x-nintendo-nes-rom", "application/x-google-chrome-extension", "application/vnd.ms-cab-compressed", "application/x-deb", "application/x-unix-archive", "application/x-rpm", "application/x-compress", "application/x-lzip", "application/x-cfb", "application/x-mie", "application/mxf", "video/mp2t", "application/x-blender", "image/bpg", "image/j2c", "image/jp2", "image/jpx", "image/jpm", "image/mj2", "audio/aiff", "application/xml", "application/x-mobipocket-ebook", "image/heif", "image/heif-sequence", "image/heic", "image/heic-sequence", "image/icns", "image/ktx", "application/dicom", "audio/x-musepack", "text/calendar", "text/vcard", "text/vtt", "model/gltf-binary", "application/vnd.tcpdump.pcap", "audio/x-dsf", "application/x.ms.shortcut", "application/x.apple.alias", "audio/x-voc", "audio/vnd.dolby.dd-raw", "audio/x-m4a", "image/apng", "image/x-olympus-orf", "image/x-sony-arw", "image/x-adobe-dng", "image/x-nikon-nef", "image/x-panasonic-rw2", "image/x-fujifilm-raf", "video/x-m4v", "video/3gpp2", "application/x-esri-shape", "audio/aac", "audio/x-it", "audio/x-s3m", "audio/x-xm", "video/MP1S", "video/MP2P", "application/vnd.sketchup.skp", "image/avif", "application/x-lzh-compressed", "application/pgp-encrypted", "application/x-asar", "model/stl", "application/vnd.ms-htmlhelp", "model/3mf", "image/jxl", "application/zstd", "image/jls", "application/vnd.ms-outlook", "image/vnd.dwg", "application/vnd.apache.parquet", "application/java-vm", "application/x-arj", "application/x-cpio", "application/x-ace-compressed", "application/avro", "application/vnd.iccprofile", "application/x.autodesk.fbx", "application/vnd.visio", "application/vnd.android.package-archive", "application/vnd.google.draco", "application/x-lz4", "application/vnd.openxmlformats-officedocument.presentationml.template", "application/vnd.openxmlformats-officedocument.spreadsheetml.template", "application/vnd.openxmlformats-officedocument.wordprocessingml.template", "application/vnd.ms-excel.template.macroenabled.12", "application/vnd.oasis.opendocument.text-template", "application/vnd.oasis.opendocument.spreadsheet-template", "application/vnd.oasis.opendocument.presentation-template", "application/vnd.oasis.opendocument.graphics", "application/vnd.oasis.opendocument.graphics-template", "application/vnd.ms-excel.sheet.macroenabled.12", "application/vnd.ms-word.document.macroenabled.12", "application/vnd.ms-word.template.macroenabled.12", "application/vnd.ms-powerpoint.template.macroenabled.12", "application/vnd.ms-powerpoint.presentation.macroenabled.12", "application/java-archive", "application/vnd.rn-realmedia", "application/x-spss-sav", "application/x-ms-regedit", "application/x-ft-windows-registry-hive", "application/x-jmp-data"];
    he7 = 4100;
    we2 = class {
      constructor(e7) {
        this.options = { mpegOffsetTolerance: 0, ...e7 }, this.detectors = [...e7?.customDetectors ?? [], { id: "core", detect: this.detectConfident }, { id: "core.imprecise", detect: this.detectImprecise }], this.tokenizerOptions = { abortSignal: e7?.signal };
      }
      async fromTokenizer(e7) {
        let t6 = e7.position;
        for (let r8 of this.detectors) {
          let n23 = await r8.detect(e7);
          if (n23) return n23;
          if (t6 !== e7.position) return;
        }
      }
      async fromBuffer(e7) {
        if (!(e7 instanceof Uint8Array || e7 instanceof ArrayBuffer)) throw new TypeError(`Expected the \`input\` argument to be of type \`Uint8Array\` or \`ArrayBuffer\`, got \`${typeof e7}\``);
        let t6 = e7 instanceof Uint8Array ? e7 : new Uint8Array(e7);
        if (t6?.length > 1) return this.fromTokenizer(ve4(t6, this.tokenizerOptions));
      }
      async fromBlob(e7) {
        let t6 = Se3(e7, this.tokenizerOptions);
        try {
          return await this.fromTokenizer(t6);
        } finally {
          await t6.close();
        }
      }
      async fromStream(e7) {
        let t6 = se5(e7, this.tokenizerOptions);
        try {
          return await this.fromTokenizer(t6);
        } finally {
          await t6.close();
        }
      }
      async toDetectionStream(e7, t6) {
        let { sampleSize: r8 = he7 } = t6, n23, o9, s9 = e7.getReader({ mode: "byob" });
        try {
          let { value: m25, done: a7 } = await s9.read(new Uint8Array(r8));
          if (o9 = m25, !a7 && m25) try {
            n23 = await this.fromBuffer(m25.subarray(0, r8));
          } catch (f11) {
            if (!(f11 instanceof x18)) throw f11;
            n23 = void 0;
          }
          o9 = m25;
        } finally {
          s9.releaseLock();
        }
        let c15 = new TransformStream({ async start(m25) {
          m25.enqueue(o9);
        }, transform(m25, a7) {
          a7.enqueue(m25);
        } }), p17 = e7.pipeThrough(c15);
        return p17.fileType = n23, p17;
      }
      check(e7, t6) {
        return A8(this.buffer, e7, t6);
      }
      checkString(e7, t6) {
        return this.check(Ze4(e7, t6?.encoding), t6);
      }
      detectConfident = async (e7) => {
        if (this.buffer = new Uint8Array(he7), e7.fileInfo.size === void 0 && (e7.fileInfo.size = Number.MAX_SAFE_INTEGER), this.tokenizer = e7, await e7.peekBuffer(this.buffer, { length: 32, mayBeLess: true }), this.check([66, 77])) return { ext: "bmp", mime: "image/bmp" };
        if (this.check([11, 119])) return { ext: "ac3", mime: "audio/vnd.dolby.dd-raw" };
        if (this.check([120, 1])) return { ext: "dmg", mime: "application/x-apple-diskimage" };
        if (this.check([77, 90])) return { ext: "exe", mime: "application/x-msdownload" };
        if (this.check([37, 33])) return await e7.peekBuffer(this.buffer, { length: 24, mayBeLess: true }), this.checkString("PS-Adobe-", { offset: 2 }) && this.checkString(" EPSF-", { offset: 14 }) ? { ext: "eps", mime: "application/eps" } : { ext: "ps", mime: "application/postscript" };
        if (this.check([31, 160]) || this.check([31, 157])) return { ext: "Z", mime: "application/x-compress" };
        if (this.check([199, 113])) return { ext: "cpio", mime: "application/x-cpio" };
        if (this.check([96, 234])) return { ext: "arj", mime: "application/x-arj" };
        if (this.check([239, 187, 191])) return this.tokenizer.ignore(3), this.detectConfident(e7);
        if (this.check([71, 73, 70])) return { ext: "gif", mime: "image/gif" };
        if (this.check([73, 73, 188])) return { ext: "jxr", mime: "image/vnd.ms-photo" };
        if (this.check([31, 139, 8])) {
          let r8 = new W9(e7).inflate(), n23 = true;
          try {
            let o9;
            try {
              o9 = await this.fromStream(r8);
            } catch {
              n23 = false;
            }
            if (o9 && o9.ext === "tar") return { ext: "tar.gz", mime: "application/gzip" };
          } finally {
            n23 && await r8.cancel();
          }
          return { ext: "gz", mime: "application/gzip" };
        }
        if (this.check([66, 90, 104])) return { ext: "bz2", mime: "application/x-bzip2" };
        if (this.checkString("ID3")) {
          await e7.ignore(6);
          let t6 = await e7.readToken(Ye3);
          return e7.position + t6 > e7.fileInfo.size ? { ext: "mp3", mime: "audio/mpeg" } : (await e7.ignore(t6), this.fromTokenizer(e7));
        }
        if (this.checkString("MP+")) return { ext: "mpc", mime: "audio/x-musepack" };
        if ((this.buffer[0] === 67 || this.buffer[0] === 70) && this.check([87, 83], { offset: 1 })) return { ext: "swf", mime: "application/x-shockwave-flash" };
        if (this.check([255, 216, 255])) return this.check([247], { offset: 3 }) ? { ext: "jls", mime: "image/jls" } : { ext: "jpg", mime: "image/jpeg" };
        if (this.check([79, 98, 106, 1])) return { ext: "avro", mime: "application/avro" };
        if (this.checkString("FLIF")) return { ext: "flif", mime: "image/flif" };
        if (this.checkString("8BPS")) return { ext: "psd", mime: "image/vnd.adobe.photoshop" };
        if (this.checkString("MPCK")) return { ext: "mpc", mime: "audio/x-musepack" };
        if (this.checkString("FORM")) return { ext: "aif", mime: "audio/aiff" };
        if (this.checkString("icns", { offset: 0 })) return { ext: "icns", mime: "image/icns" };
        if (this.check([80, 75, 3, 4])) {
          let t6;
          return await new H12(e7).unzip((r8) => {
            switch (r8.filename) {
              case "META-INF/mozilla.rsa":
                return t6 = { ext: "xpi", mime: "application/x-xpinstall" }, { stop: true };
              case "META-INF/MANIFEST.MF":
                return t6 = { ext: "jar", mime: "application/java-archive" }, { stop: true };
              case "mimetype":
                return { async handler(n23) {
                  let o9 = new TextDecoder("utf-8").decode(n23).trim();
                  t6 = ge5(o9);
                }, stop: true };
              case "[Content_Types].xml":
                return { async handler(n23) {
                  let o9 = new TextDecoder("utf-8").decode(n23), s9 = o9.indexOf('.main+xml"');
                  if (s9 === -1) {
                    let c15 = "application/vnd.ms-package.3dmanufacturing-3dmodel+xml";
                    o9.includes(`ContentType="${c15}"`) && (t6 = ge5(c15));
                  } else {
                    o9 = o9.slice(0, Math.max(0, s9));
                    let c15 = o9.lastIndexOf('"'), p17 = o9.slice(Math.max(0, c15 + 1));
                    t6 = ge5(p17);
                  }
                }, stop: true };
              default:
                return /classes\d*\.dex/.test(r8.filename) ? (t6 = { ext: "apk", mime: "application/vnd.android.package-archive" }, { stop: true }) : {};
            }
          }).catch((r8) => {
            if (!(r8 instanceof x18)) throw r8;
          }), t6 ?? { ext: "zip", mime: "application/zip" };
        }
        if (this.checkString("OggS")) {
          await e7.ignore(28);
          let t6 = new Uint8Array(8);
          return await e7.readBuffer(t6), A8(t6, [79, 112, 117, 115, 72, 101, 97, 100]) ? { ext: "opus", mime: "audio/ogg; codecs=opus" } : A8(t6, [128, 116, 104, 101, 111, 114, 97]) ? { ext: "ogv", mime: "video/ogg" } : A8(t6, [1, 118, 105, 100, 101, 111, 0]) ? { ext: "ogm", mime: "video/ogg" } : A8(t6, [127, 70, 76, 65, 67]) ? { ext: "oga", mime: "audio/ogg" } : A8(t6, [83, 112, 101, 101, 120, 32, 32]) ? { ext: "spx", mime: "audio/ogg" } : A8(t6, [1, 118, 111, 114, 98, 105, 115]) ? { ext: "ogg", mime: "audio/ogg" } : { ext: "ogx", mime: "application/ogg" };
        }
        if (this.check([80, 75]) && (this.buffer[2] === 3 || this.buffer[2] === 5 || this.buffer[2] === 7) && (this.buffer[3] === 4 || this.buffer[3] === 6 || this.buffer[3] === 8)) return { ext: "zip", mime: "application/zip" };
        if (this.checkString("MThd")) return { ext: "mid", mime: "audio/midi" };
        if (this.checkString("wOFF") && (this.check([0, 1, 0, 0], { offset: 4 }) || this.checkString("OTTO", { offset: 4 }))) return { ext: "woff", mime: "font/woff" };
        if (this.checkString("wOF2") && (this.check([0, 1, 0, 0], { offset: 4 }) || this.checkString("OTTO", { offset: 4 }))) return { ext: "woff2", mime: "font/woff2" };
        if (this.check([212, 195, 178, 161]) || this.check([161, 178, 195, 212])) return { ext: "pcap", mime: "application/vnd.tcpdump.pcap" };
        if (this.checkString("DSD ")) return { ext: "dsf", mime: "audio/x-dsf" };
        if (this.checkString("LZIP")) return { ext: "lz", mime: "application/x-lzip" };
        if (this.checkString("fLaC")) return { ext: "flac", mime: "audio/flac" };
        if (this.check([66, 80, 71, 251])) return { ext: "bpg", mime: "image/bpg" };
        if (this.checkString("wvpk")) return { ext: "wv", mime: "audio/wavpack" };
        if (this.checkString("%PDF")) return { ext: "pdf", mime: "application/pdf" };
        if (this.check([0, 97, 115, 109])) return { ext: "wasm", mime: "application/wasm" };
        if (this.check([73, 73])) {
          let t6 = await this.readTiffHeader(false);
          if (t6) return t6;
        }
        if (this.check([77, 77])) {
          let t6 = await this.readTiffHeader(true);
          if (t6) return t6;
        }
        if (this.checkString("MAC ")) return { ext: "ape", mime: "audio/ape" };
        if (this.check([26, 69, 223, 163])) {
          async function t6() {
            let c15 = await e7.peekNumber(Be2), p17 = 128, m25 = 0;
            for (; (c15 & p17) === 0 && p17 !== 0; ) ++m25, p17 >>= 1;
            let a7 = new Uint8Array(m25 + 1);
            return await e7.readBuffer(a7), a7;
          }
          async function r8() {
            let c15 = await t6(), p17 = await t6();
            p17[0] ^= 128 >> p17.length - 1;
            let m25 = Math.min(6, p17.length), a7 = new DataView(c15.buffer), f11 = new DataView(p17.buffer, p17.length - m25, m25);
            return { id: de7(a7), len: de7(f11) };
          }
          async function n23(c15) {
            for (; c15 > 0; ) {
              let p17 = await r8();
              if (p17.id === 17026) return (await e7.readToken(new b21(p17.len))).replaceAll(/\00.*$/g, "");
              await e7.ignore(p17.len), --c15;
            }
          }
          let o9 = await r8();
          switch (await n23(o9.len)) {
            case "webm":
              return { ext: "webm", mime: "video/webm" };
            case "matroska":
              return { ext: "mkv", mime: "video/matroska" };
            default:
              return;
          }
        }
        if (this.checkString("SQLi")) return { ext: "sqlite", mime: "application/x-sqlite3" };
        if (this.check([78, 69, 83, 26])) return { ext: "nes", mime: "application/x-nintendo-nes-rom" };
        if (this.checkString("Cr24")) return { ext: "crx", mime: "application/x-google-chrome-extension" };
        if (this.checkString("MSCF") || this.checkString("ISc(")) return { ext: "cab", mime: "application/vnd.ms-cab-compressed" };
        if (this.check([237, 171, 238, 219])) return { ext: "rpm", mime: "application/x-rpm" };
        if (this.check([197, 208, 211, 198])) return { ext: "eps", mime: "application/eps" };
        if (this.check([40, 181, 47, 253])) return { ext: "zst", mime: "application/zstd" };
        if (this.check([127, 69, 76, 70])) return { ext: "elf", mime: "application/x-elf" };
        if (this.check([33, 66, 68, 78])) return { ext: "pst", mime: "application/vnd.ms-outlook" };
        if (this.checkString("PAR1") || this.checkString("PARE")) return { ext: "parquet", mime: "application/vnd.apache.parquet" };
        if (this.checkString("ttcf")) return { ext: "ttc", mime: "font/collection" };
        if (this.check([207, 250, 237, 254])) return { ext: "macho", mime: "application/x-mach-binary" };
        if (this.check([4, 34, 77, 24])) return { ext: "lz4", mime: "application/x-lz4" };
        if (this.checkString("regf")) return { ext: "dat", mime: "application/x-ft-windows-registry-hive" };
        if (this.checkString("$FL2") || this.checkString("$FL3")) return { ext: "sav", mime: "application/x-spss-sav" };
        if (this.check([79, 84, 84, 79, 0])) return { ext: "otf", mime: "font/otf" };
        if (this.checkString("#!AMR")) return { ext: "amr", mime: "audio/amr" };
        if (this.checkString("{\\rtf")) return { ext: "rtf", mime: "application/rtf" };
        if (this.check([70, 76, 86, 1])) return { ext: "flv", mime: "video/x-flv" };
        if (this.checkString("IMPM")) return { ext: "it", mime: "audio/x-it" };
        if (this.checkString("-lh0-", { offset: 2 }) || this.checkString("-lh1-", { offset: 2 }) || this.checkString("-lh2-", { offset: 2 }) || this.checkString("-lh3-", { offset: 2 }) || this.checkString("-lh4-", { offset: 2 }) || this.checkString("-lh5-", { offset: 2 }) || this.checkString("-lh6-", { offset: 2 }) || this.checkString("-lh7-", { offset: 2 }) || this.checkString("-lzs-", { offset: 2 }) || this.checkString("-lz4-", { offset: 2 }) || this.checkString("-lz5-", { offset: 2 }) || this.checkString("-lhd-", { offset: 2 })) return { ext: "lzh", mime: "application/x-lzh-compressed" };
        if (this.check([0, 0, 1, 186])) {
          if (this.check([33], { offset: 4, mask: [241] })) return { ext: "mpg", mime: "video/MP1S" };
          if (this.check([68], { offset: 4, mask: [196] })) return { ext: "mpg", mime: "video/MP2P" };
        }
        if (this.checkString("ITSF")) return { ext: "chm", mime: "application/vnd.ms-htmlhelp" };
        if (this.check([202, 254, 186, 190])) return { ext: "class", mime: "application/java-vm" };
        if (this.checkString(".RMF")) return { ext: "rm", mime: "application/vnd.rn-realmedia" };
        if (this.checkString("DRACO")) return { ext: "drc", mime: "application/vnd.google.draco" };
        if (this.check([253, 55, 122, 88, 90, 0])) return { ext: "xz", mime: "application/x-xz" };
        if (this.checkString("<?xml ")) return { ext: "xml", mime: "application/xml" };
        if (this.check([55, 122, 188, 175, 39, 28])) return { ext: "7z", mime: "application/x-7z-compressed" };
        if (this.check([82, 97, 114, 33, 26, 7]) && (this.buffer[6] === 0 || this.buffer[6] === 1)) return { ext: "rar", mime: "application/x-rar-compressed" };
        if (this.checkString("solid ")) return { ext: "stl", mime: "model/stl" };
        if (this.checkString("AC")) {
          let t6 = new b21(4, "latin1").get(this.buffer, 2);
          if (t6.match("^d*") && t6 >= 1e3 && t6 <= 1050) return { ext: "dwg", mime: "image/vnd.dwg" };
        }
        if (this.checkString("070707")) return { ext: "cpio", mime: "application/x-cpio" };
        if (this.checkString("BLENDER")) return { ext: "blend", mime: "application/x-blender" };
        if (this.checkString("!<arch>")) return await e7.ignore(8), await e7.readToken(new b21(13, "ascii")) === "debian-binary" ? { ext: "deb", mime: "application/x-deb" } : { ext: "ar", mime: "application/x-unix-archive" };
        if (this.checkString("WEBVTT") && [`
`, "\r", "	", " ", "\0"].some((t6) => this.checkString(t6, { offset: 6 }))) return { ext: "vtt", mime: "text/vtt" };
        if (this.check([137, 80, 78, 71, 13, 10, 26, 10])) {
          await e7.ignore(8);
          async function t6() {
            return { length: await e7.readToken(Oe3), type: await e7.readToken(new b21(4, "latin1")) };
          }
          do {
            let r8 = await t6();
            if (r8.length < 0) return;
            switch (r8.type) {
              case "IDAT":
                return { ext: "png", mime: "image/png" };
              case "acTL":
                return { ext: "apng", mime: "image/apng" };
              default:
                await e7.ignore(r8.length + 4);
            }
          } while (e7.position + 8 < e7.fileInfo.size);
          return { ext: "png", mime: "image/png" };
        }
        if (this.check([65, 82, 82, 79, 87, 49, 0, 0])) return { ext: "arrow", mime: "application/vnd.apache.arrow.file" };
        if (this.check([103, 108, 84, 70, 2, 0, 0, 0])) return { ext: "glb", mime: "model/gltf-binary" };
        if (this.check([102, 114, 101, 101], { offset: 4 }) || this.check([109, 100, 97, 116], { offset: 4 }) || this.check([109, 111, 111, 118], { offset: 4 }) || this.check([119, 105, 100, 101], { offset: 4 })) return { ext: "mov", mime: "video/quicktime" };
        if (this.check([73, 73, 82, 79, 8, 0, 0, 0, 24])) return { ext: "orf", mime: "image/x-olympus-orf" };
        if (this.checkString("gimp xcf ")) return { ext: "xcf", mime: "image/x-xcf" };
        if (this.checkString("ftyp", { offset: 4 }) && (this.buffer[8] & 96) !== 0) {
          let t6 = new b21(4, "latin1").get(this.buffer, 8).replace("\0", " ").trim();
          switch (t6) {
            case "avif":
            case "avis":
              return { ext: "avif", mime: "image/avif" };
            case "mif1":
              return { ext: "heic", mime: "image/heif" };
            case "msf1":
              return { ext: "heic", mime: "image/heif-sequence" };
            case "heic":
            case "heix":
              return { ext: "heic", mime: "image/heic" };
            case "hevc":
            case "hevx":
              return { ext: "heic", mime: "image/heic-sequence" };
            case "qt":
              return { ext: "mov", mime: "video/quicktime" };
            case "M4V":
            case "M4VH":
            case "M4VP":
              return { ext: "m4v", mime: "video/x-m4v" };
            case "M4P":
              return { ext: "m4p", mime: "video/mp4" };
            case "M4B":
              return { ext: "m4b", mime: "audio/mp4" };
            case "M4A":
              return { ext: "m4a", mime: "audio/x-m4a" };
            case "F4V":
              return { ext: "f4v", mime: "video/mp4" };
            case "F4P":
              return { ext: "f4p", mime: "video/mp4" };
            case "F4A":
              return { ext: "f4a", mime: "audio/mp4" };
            case "F4B":
              return { ext: "f4b", mime: "audio/mp4" };
            case "crx":
              return { ext: "cr3", mime: "image/x-canon-cr3" };
            default:
              return t6.startsWith("3g") ? t6.startsWith("3g2") ? { ext: "3g2", mime: "video/3gpp2" } : { ext: "3gp", mime: "video/3gpp" } : { ext: "mp4", mime: "video/mp4" };
          }
        }
        if (this.checkString(`REGEDIT4\r
`)) return { ext: "reg", mime: "application/x-ms-regedit" };
        if (this.check([82, 73, 70, 70])) {
          if (this.checkString("WEBP", { offset: 8 })) return { ext: "webp", mime: "image/webp" };
          if (this.check([65, 86, 73], { offset: 8 })) return { ext: "avi", mime: "video/vnd.avi" };
          if (this.check([87, 65, 86, 69], { offset: 8 })) return { ext: "wav", mime: "audio/wav" };
          if (this.check([81, 76, 67, 77], { offset: 8 })) return { ext: "qcp", mime: "audio/qcelp" };
        }
        if (this.check([73, 73, 85, 0, 24, 0, 0, 0, 136, 231, 116, 216])) return { ext: "rw2", mime: "image/x-panasonic-rw2" };
        if (this.check([48, 38, 178, 117, 142, 102, 207, 17, 166, 217])) {
          async function t6() {
            let r8 = new Uint8Array(16);
            return await e7.readBuffer(r8), { id: r8, size: Number(await e7.readToken(De3)) };
          }
          for (await e7.ignore(30); e7.position + 24 < e7.fileInfo.size; ) {
            let r8 = await t6(), n23 = r8.size - 24;
            if (A8(r8.id, [145, 7, 220, 183, 183, 169, 207, 17, 142, 230, 0, 192, 12, 32, 83, 101])) {
              let o9 = new Uint8Array(16);
              if (n23 -= await e7.readBuffer(o9), A8(o9, [64, 158, 105, 248, 77, 91, 207, 17, 168, 253, 0, 128, 95, 92, 68, 43])) return { ext: "asf", mime: "audio/x-ms-asf" };
              if (A8(o9, [192, 239, 25, 188, 77, 91, 207, 17, 168, 253, 0, 128, 95, 92, 68, 43])) return { ext: "asf", mime: "video/x-ms-asf" };
              break;
            }
            await e7.ignore(n23);
          }
          return { ext: "asf", mime: "application/vnd.ms-asf" };
        }
        if (this.check([171, 75, 84, 88, 32, 49, 49, 187, 13, 10, 26, 10])) return { ext: "ktx", mime: "image/ktx" };
        if ((this.check([126, 16, 4]) || this.check([126, 24, 4])) && this.check([48, 77, 73, 69], { offset: 4 })) return { ext: "mie", mime: "application/x-mie" };
        if (this.check([39, 10, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], { offset: 2 })) return { ext: "shp", mime: "application/x-esri-shape" };
        if (this.check([255, 79, 255, 81])) return { ext: "j2c", mime: "image/j2c" };
        if (this.check([0, 0, 0, 12, 106, 80, 32, 32, 13, 10, 135, 10])) switch (await e7.ignore(20), await e7.readToken(new b21(4, "ascii"))) {
          case "jp2 ":
            return { ext: "jp2", mime: "image/jp2" };
          case "jpx ":
            return { ext: "jpx", mime: "image/jpx" };
          case "jpm ":
            return { ext: "jpm", mime: "image/jpm" };
          case "mjp2":
            return { ext: "mj2", mime: "image/mj2" };
          default:
            return;
        }
        if (this.check([255, 10]) || this.check([0, 0, 0, 12, 74, 88, 76, 32, 13, 10, 135, 10])) return { ext: "jxl", mime: "image/jxl" };
        if (this.check([254, 255])) return this.checkString("<?xml ", { offset: 2, encoding: "utf-16be" }) ? { ext: "xml", mime: "application/xml" } : void 0;
        if (this.check([208, 207, 17, 224, 161, 177, 26, 225])) return { ext: "cfb", mime: "application/x-cfb" };
        if (await e7.peekBuffer(this.buffer, { length: Math.min(256, e7.fileInfo.size), mayBeLess: true }), this.check([97, 99, 115, 112], { offset: 36 })) return { ext: "icc", mime: "application/vnd.iccprofile" };
        if (this.checkString("**ACE", { offset: 7 }) && this.checkString("**", { offset: 12 })) return { ext: "ace", mime: "application/x-ace-compressed" };
        if (this.checkString("BEGIN:")) {
          if (this.checkString("VCARD", { offset: 6 })) return { ext: "vcf", mime: "text/vcard" };
          if (this.checkString("VCALENDAR", { offset: 6 })) return { ext: "ics", mime: "text/calendar" };
        }
        if (this.checkString("FUJIFILMCCD-RAW")) return { ext: "raf", mime: "image/x-fujifilm-raf" };
        if (this.checkString("Extended Module:")) return { ext: "xm", mime: "audio/x-xm" };
        if (this.checkString("Creative Voice File")) return { ext: "voc", mime: "audio/x-voc" };
        if (this.check([4, 0, 0, 0]) && this.buffer.length >= 16) {
          let t6 = new DataView(this.buffer.buffer).getUint32(12, true);
          if (t6 > 12 && this.buffer.length >= t6 + 16) try {
            let r8 = new TextDecoder().decode(this.buffer.subarray(16, t6 + 16));
            if (JSON.parse(r8).files) return { ext: "asar", mime: "application/x-asar" };
          } catch {
          }
        }
        if (this.check([6, 14, 43, 52, 2, 5, 1, 1, 13, 1, 2, 1, 1, 2])) return { ext: "mxf", mime: "application/mxf" };
        if (this.checkString("SCRM", { offset: 44 })) return { ext: "s3m", mime: "audio/x-s3m" };
        if (this.check([71]) && this.check([71], { offset: 188 })) return { ext: "mts", mime: "video/mp2t" };
        if (this.check([71], { offset: 4 }) && this.check([71], { offset: 196 })) return { ext: "mts", mime: "video/mp2t" };
        if (this.check([66, 79, 79, 75, 77, 79, 66, 73], { offset: 60 })) return { ext: "mobi", mime: "application/x-mobipocket-ebook" };
        if (this.check([68, 73, 67, 77], { offset: 128 })) return { ext: "dcm", mime: "application/dicom" };
        if (this.check([76, 0, 0, 0, 1, 20, 2, 0, 0, 0, 0, 0, 192, 0, 0, 0, 0, 0, 0, 70])) return { ext: "lnk", mime: "application/x.ms.shortcut" };
        if (this.check([98, 111, 111, 107, 0, 0, 0, 0, 109, 97, 114, 107, 0, 0, 0, 0])) return { ext: "alias", mime: "application/x.apple.alias" };
        if (this.checkString("Kaydara FBX Binary  \0")) return { ext: "fbx", mime: "application/x.autodesk.fbx" };
        if (this.check([76, 80], { offset: 34 }) && (this.check([0, 0, 1], { offset: 8 }) || this.check([1, 0, 2], { offset: 8 }) || this.check([2, 0, 2], { offset: 8 }))) return { ext: "eot", mime: "application/vnd.ms-fontobject" };
        if (this.check([6, 6, 237, 245, 216, 29, 70, 229, 189, 49, 239, 231, 254, 116, 183, 29])) return { ext: "indd", mime: "application/x-indesign" };
        if (this.check([255, 255, 0, 0, 7, 0, 0, 0, 4, 0, 0, 0, 1, 0, 1, 0]) || this.check([0, 0, 255, 255, 0, 0, 0, 7, 0, 0, 0, 4, 0, 1, 0, 1])) return { ext: "jmp", mime: "application/x-jmp-data" };
        if (await e7.peekBuffer(this.buffer, { length: Math.min(512, e7.fileInfo.size), mayBeLess: true }), this.checkString("ustar", { offset: 257 }) && (this.checkString("\0", { offset: 262 }) || this.checkString(" ", { offset: 262 })) || this.check([0, 0, 0, 0, 0, 0], { offset: 257 }) && Qe3(this.buffer)) return { ext: "tar", mime: "application/x-tar" };
        if (this.check([255, 254])) {
          let t6 = "utf-16le";
          return this.checkString("<?xml ", { offset: 2, encoding: t6 }) ? { ext: "xml", mime: "application/xml" } : this.check([255, 14], { offset: 2 }) && this.checkString("SketchUp Model", { offset: 4, encoding: t6 }) ? { ext: "skp", mime: "application/vnd.sketchup.skp" } : this.checkString(`Windows Registry Editor Version 5.00\r
`, { offset: 2, encoding: t6 }) ? { ext: "reg", mime: "application/x-ms-regedit" } : void 0;
        }
        if (this.checkString("-----BEGIN PGP MESSAGE-----")) return { ext: "pgp", mime: "application/pgp-encrypted" };
      };
      detectImprecise = async (e7) => {
        if (this.buffer = new Uint8Array(he7), await e7.peekBuffer(this.buffer, { length: Math.min(8, e7.fileInfo.size), mayBeLess: true }), this.check([0, 0, 1, 186]) || this.check([0, 0, 1, 179])) return { ext: "mpg", mime: "video/mpeg" };
        if (this.check([0, 1, 0, 0, 0])) return { ext: "ttf", mime: "font/ttf" };
        if (this.check([0, 0, 1, 0])) return { ext: "ico", mime: "image/x-icon" };
        if (this.check([0, 0, 2, 0])) return { ext: "cur", mime: "image/x-icon" };
        if (await e7.peekBuffer(this.buffer, { length: Math.min(2 + this.options.mpegOffsetTolerance, e7.fileInfo.size), mayBeLess: true }), this.buffer.length >= 2 + this.options.mpegOffsetTolerance) for (let t6 = 0; t6 <= this.options.mpegOffsetTolerance; ++t6) {
          let r8 = this.scanMpeg(t6);
          if (r8) return r8;
        }
      };
      async readTiffTag(e7) {
        let t6 = await this.tokenizer.readToken(e7 ? R6 : d14);
        switch (this.tokenizer.ignore(10), t6) {
          case 50341:
            return { ext: "arw", mime: "image/x-sony-arw" };
          case 50706:
            return { ext: "dng", mime: "image/x-adobe-dng" };
          default:
        }
      }
      async readTiffIFD(e7) {
        let t6 = await this.tokenizer.readToken(e7 ? R6 : d14);
        for (let r8 = 0; r8 < t6; ++r8) {
          let n23 = await this.readTiffTag(e7);
          if (n23) return n23;
        }
      }
      async readTiffHeader(e7) {
        let t6 = (e7 ? R6 : d14).get(this.buffer, 2), r8 = (e7 ? Ie4 : h14).get(this.buffer, 4);
        if (t6 === 42) {
          if (r8 >= 6) {
            if (this.checkString("CR", { offset: 8 })) return { ext: "cr2", mime: "image/x-canon-cr2" };
            if (r8 >= 8) {
              let o9 = (e7 ? R6 : d14).get(this.buffer, 8), s9 = (e7 ? R6 : d14).get(this.buffer, 10);
              if (o9 === 28 && s9 === 254 || o9 === 31 && s9 === 11) return { ext: "nef", mime: "image/x-nikon-nef" };
            }
          }
          return await this.tokenizer.ignore(r8), await this.readTiffIFD(e7) ?? { ext: "tif", mime: "image/tiff" };
        }
        if (t6 === 43) return { ext: "tif", mime: "image/tiff" };
      }
      scanMpeg(e7) {
        if (this.check([255, 224], { offset: e7, mask: [255, 224] })) {
          if (this.check([16], { offset: e7 + 1, mask: [22] })) return this.check([8], { offset: e7 + 1, mask: [8] }) ? { ext: "aac", mime: "audio/aac" } : { ext: "aac", mime: "audio/aac" };
          if (this.check([2], { offset: e7 + 1, mask: [6] })) return { ext: "mp3", mime: "audio/mpeg" };
          if (this.check([4], { offset: e7 + 1, mask: [6] })) return { ext: "mp2", mime: "audio/mpeg" };
          if (this.check([6], { offset: e7 + 1, mask: [6] })) return { ext: "mp1", mime: "audio/mpeg" };
        }
      }
    };
    Ht2 = new Set(Ke3);
    Wt2 = new Set(et4);
    Vt = { name: "file", summary: "determine file type", usage: "file [OPTION]... FILE...", options: ["-b, --brief          do not prepend filenames to output", "-i, --mime           output MIME type strings", "-L, --dereference    follow symlinks", "    --help           display this help and exit"] };
    qt2 = /* @__PURE__ */ new Map([[".js", { description: "JavaScript source", mime: "text/javascript" }], [".mjs", { description: "JavaScript module", mime: "text/javascript" }], [".cjs", { description: "CommonJS module", mime: "text/javascript" }], [".ts", { description: "TypeScript source", mime: "text/typescript" }], [".tsx", { description: "TypeScript JSX source", mime: "text/typescript" }], [".jsx", { description: "JavaScript JSX source", mime: "text/javascript" }], [".py", { description: "Python script", mime: "text/x-python" }], [".rb", { description: "Ruby script", mime: "text/x-ruby" }], [".go", { description: "Go source", mime: "text/x-go" }], [".rs", { description: "Rust source", mime: "text/x-rust" }], [".c", { description: "C source", mime: "text/x-c" }], [".h", { description: "C header", mime: "text/x-c" }], [".cpp", { description: "C++ source", mime: "text/x-c++" }], [".hpp", { description: "C++ header", mime: "text/x-c++" }], [".java", { description: "Java source", mime: "text/x-java" }], [".sh", { description: "Bourne-Again shell script", mime: "text/x-shellscript" }], [".bash", { description: "Bourne-Again shell script", mime: "text/x-shellscript" }], [".zsh", { description: "Zsh shell script", mime: "text/x-shellscript" }], [".json", { description: "JSON data", mime: "application/json" }], [".yaml", { description: "YAML data", mime: "text/yaml" }], [".yml", { description: "YAML data", mime: "text/yaml" }], [".xml", { description: "XML document", mime: "application/xml" }], [".csv", { description: "CSV text", mime: "text/csv" }], [".toml", { description: "TOML data", mime: "text/toml" }], [".html", { description: "HTML document", mime: "text/html" }], [".htm", { description: "HTML document", mime: "text/html" }], [".css", { description: "CSS stylesheet", mime: "text/css" }], [".svg", { description: "SVG image", mime: "image/svg+xml" }], [".md", { description: "Markdown document", mime: "text/markdown" }], [".markdown", { description: "Markdown document", mime: "text/markdown" }], [".txt", { description: "ASCII text", mime: "text/plain" }], [".rst", { description: "reStructuredText", mime: "text/x-rst" }], [".env", { description: "ASCII text", mime: "text/plain" }], [".gitignore", { description: "ASCII text", mime: "text/plain" }], [".dockerignore", { description: "ASCII text", mime: "text/plain" }]]);
    Gt2 = /* @__PURE__ */ new Map([["jpg", "JPEG image data"], ["jpeg", "JPEG image data"], ["png", "PNG image data"], ["gif", "GIF image data"], ["webp", "WebP image data"], ["bmp", "PC bitmap"], ["ico", "MS Windows icon resource"], ["tif", "TIFF image data"], ["tiff", "TIFF image data"], ["psd", "Adobe Photoshop Document"], ["avif", "AVIF image"], ["heic", "HEIC image"], ["heif", "HEIF image"], ["jxl", "JPEG XL image"], ["icns", "Mac OS X icon"], ["svg", "SVG Scalable Vector Graphics image"], ["pdf", "PDF document"], ["epub", "EPUB document"], ["mobi", "Mobipocket E-book"], ["djvu", "DjVu document"], ["zip", "Zip archive data"], ["gz", "gzip compressed data"], ["gzip", "gzip compressed data"], ["bz2", "bzip2 compressed data"], ["xz", "XZ compressed data"], ["tar", "POSIX tar archive"], ["rar", "RAR archive data"], ["7z", "7-zip archive data"], ["lz", "lzip compressed data"], ["lzma", "LZMA compressed data"], ["zst", "Zstandard compressed data"], ["cab", "Microsoft Cabinet archive"], ["ar", "Unix ar archive"], ["rpm", "RPM package"], ["deb", "Debian binary package"], ["apk", "Android Package"], ["dmg", "Apple disk image"], ["iso", "ISO 9660 CD-ROM filesystem data"], ["vhd", "Microsoft Virtual Hard Disk"], ["vhdx", "Microsoft Virtual Hard Disk (new format)"], ["qcow2", "QEMU QCOW Image"], ["mp3", "Audio file with ID3"], ["m4a", "MPEG-4 audio"], ["aac", "AAC audio"], ["wav", "RIFF (little-endian) data, WAVE audio"], ["flac", "FLAC audio bitstream data"], ["ogg", "Ogg data"], ["oga", "Ogg audio"], ["opus", "Ogg Opus audio"], ["aiff", "AIFF audio"], ["wma", "Windows Media Audio"], ["amr", "AMR audio"], ["mid", "MIDI audio"], ["midi", "MIDI audio"], ["ape", "Monkey's Audio"], ["mp4", "ISO Media, MPEG-4"], ["m4v", "MPEG-4 video"], ["webm", "WebM"], ["avi", "RIFF (little-endian) data, AVI"], ["mov", "ISO Media, Apple QuickTime movie"], ["mkv", "Matroska data"], ["wmv", "Windows Media Video"], ["flv", "Flash Video"], ["3gp", "3GPP multimedia"], ["3g2", "3GPP2 multimedia"], ["ogv", "Ogg video"], ["mts", "MPEG transport stream"], ["m2ts", "MPEG transport stream"], ["ts", "MPEG transport stream"], ["mpg", "MPEG video"], ["mpeg", "MPEG video"], ["exe", "PE32 executable"], ["dll", "PE32 DLL"], ["elf", "ELF executable"], ["mach", "Mach-O executable"], ["wasm", "WebAssembly (wasm) binary module"], ["dex", "Android Dalvik executable"], ["class", "Java class file"], ["swf", "Adobe Flash"], ["doc", "Microsoft Word Document"], ["docx", "Microsoft Word 2007+ Document"], ["xls", "Microsoft Excel Spreadsheet"], ["xlsx", "Microsoft Excel 2007+ Spreadsheet"], ["ppt", "Microsoft PowerPoint Presentation"], ["pptx", "Microsoft PowerPoint 2007+ Presentation"], ["odt", "OpenDocument Text"], ["ods", "OpenDocument Spreadsheet"], ["odp", "OpenDocument Presentation"], ["ttf", "TrueType Font"], ["otf", "OpenType Font"], ["woff", "Web Open Font Format"], ["woff2", "Web Open Font Format 2"], ["eot", "Embedded OpenType font"], ["stl", "Stereolithography CAD"], ["obj", "Wavefront 3D Object"], ["gltf", "GL Transmission Format"], ["glb", "GL Transmission Format (binary)"], ["sqlite", "SQLite 3.x database"], ["mdb", "Microsoft Access Database"], ["xml", "XML document"], ["json", "JSON data"], ["macho", "Mach-O binary"], ["ics", "iCalendar data"], ["vcf", "vCard data"], ["msi", "Microsoft Installer"], ["ps", "PostScript"], ["ai", "Adobe Illustrator"], ["indd", "Adobe InDesign"], ["sketch", "Sketch design file"], ["fig", "Figma design file"], ["xd", "Adobe XD"], ["blend", "Blender"], ["fbx", "Autodesk FBX"], ["lnk", "MS Windows shortcut"], ["alias", "Mac OS alias"], ["torrent", "BitTorrent file"], ["pcap", "pcap capture file"], ["arrow", "Apache Arrow"], ["parquet", "Apache Parquet"]]);
    Dr2 = { name: "file", async execute(i10, e7) {
      if (o2(i10)) return s(Vt);
      let t6 = false, r8 = false, n23 = [];
      for (let c15 of i10) if (c15.startsWith("--")) {
        if (c15 === "--brief") t6 = true;
        else if (c15 === "--mime" || c15 === "--mime-type") r8 = true;
        else if (c15 !== "--dereference") return r3("file", c15);
      } else if (c15.startsWith("-") && c15 !== "-") {
        for (let p17 of c15.slice(1)) if (p17 === "b") t6 = true;
        else if (p17 === "i") r8 = true;
        else if (p17 !== "L") return r3("file", `-${p17}`);
      } else n23.push(c15);
      if (n23.length === 0) return { stdout: "", stderr: `Usage: file [-bLi] FILE...
`, exitCode: 1 };
      let o9 = "", s9 = 0;
      for (let c15 of n23) try {
        let p17 = e7.fs.resolvePath(e7.cwd, c15);
        if ((await e7.fs.stat(p17)).isDirectory) {
          let u11 = r8 ? "inode/directory" : "directory";
          o9 += t6 ? `${u11}
` : `${c15}: ${u11}
`;
          continue;
        }
        let a7 = await e7.fs.readFileBuffer(p17), f11 = await Qt2(c15, a7), l8 = r8 ? f11.mime : f11.description;
        o9 += t6 ? `${l8}
` : `${c15}: ${l8}
`;
      } catch {
        o9 += t6 ? `cannot open
` : `${c15}: cannot open (No such file or directory)
`, s9 = 1;
      }
      return { stdout: o9, stderr: "", exitCode: s9 };
    } };
    Mr2 = { name: "file", flags: [{ flag: "-b", type: "boolean" }, { flag: "-i", type: "boolean" }, { flag: "-L", type: "boolean" }], needsArgs: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/file-ZIGAJ4YS.js
var file_ZIGAJ4YS_exports = {};
__export(file_ZIGAJ4YS_exports, {
  fileCommand: () => Dr2,
  flagsForFuzzing: () => Mr2
});
var init_file_ZIGAJ4YS = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/file-ZIGAJ4YS.js"() {
    init_chunk_CR5AFCPT();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/turndown/lib/turndown.browser.es.js
function extend(destination) {
  for (var i10 = 1; i10 < arguments.length; i10++) {
    var source = arguments[i10];
    for (var key in source) {
      if (source.hasOwnProperty(key)) destination[key] = source[key];
    }
  }
  return destination;
}
function repeat(character, count) {
  return Array(count + 1).join(character);
}
function trimLeadingNewlines(string) {
  return string.replace(/^\n*/, "");
}
function trimTrailingNewlines(string) {
  var indexEnd = string.length;
  while (indexEnd > 0 && string[indexEnd - 1] === "\n") indexEnd--;
  return string.substring(0, indexEnd);
}
function trimNewlines(string) {
  return trimTrailingNewlines(trimLeadingNewlines(string));
}
function isBlock(node) {
  return is2(node, blockElements);
}
function isVoid(node) {
  return is2(node, voidElements);
}
function hasVoid(node) {
  return has(node, voidElements);
}
function isMeaningfulWhenBlank(node) {
  return is2(node, meaningfulWhenBlankElements);
}
function hasMeaningfulWhenBlank(node) {
  return has(node, meaningfulWhenBlankElements);
}
function is2(node, tagNames) {
  return tagNames.indexOf(node.nodeName) >= 0;
}
function has(node, tagNames) {
  return node.getElementsByTagName && tagNames.some(function(tagName) {
    return node.getElementsByTagName(tagName).length;
  });
}
function cleanAttribute(attribute) {
  return attribute ? attribute.replace(/(\n+\s*)+/g, "\n") : "";
}
function Rules(options) {
  this.options = options;
  this._keep = [];
  this._remove = [];
  this.blankRule = {
    replacement: options.blankReplacement
  };
  this.keepReplacement = options.keepReplacement;
  this.defaultRule = {
    replacement: options.defaultReplacement
  };
  this.array = [];
  for (var key in options.rules) this.array.push(options.rules[key]);
}
function findRule(rules2, node, options) {
  for (var i10 = 0; i10 < rules2.length; i10++) {
    var rule = rules2[i10];
    if (filterValue(rule, node, options)) return rule;
  }
  return void 0;
}
function filterValue(rule, node, options) {
  var filter2 = rule.filter;
  if (typeof filter2 === "string") {
    if (filter2 === node.nodeName.toLowerCase()) return true;
  } else if (Array.isArray(filter2)) {
    if (filter2.indexOf(node.nodeName.toLowerCase()) > -1) return true;
  } else if (typeof filter2 === "function") {
    if (filter2.call(rule, node, options)) return true;
  } else {
    throw new TypeError("`filter` needs to be a string, array, or function");
  }
}
function collapseWhitespace(options) {
  var element = options.element;
  var isBlock2 = options.isBlock;
  var isVoid2 = options.isVoid;
  var isPre = options.isPre || function(node2) {
    return node2.nodeName === "PRE";
  };
  if (!element.firstChild || isPre(element)) return;
  var prevText = null;
  var keepLeadingWs = false;
  var prev = null;
  var node = next(prev, element, isPre);
  while (node !== element) {
    if (node.nodeType === 3 || node.nodeType === 4) {
      var text = node.data.replace(/[ \r\n\t]+/g, " ");
      if ((!prevText || / $/.test(prevText.data)) && !keepLeadingWs && text[0] === " ") {
        text = text.substr(1);
      }
      if (!text) {
        node = remove(node);
        continue;
      }
      node.data = text;
      prevText = node;
    } else if (node.nodeType === 1) {
      if (isBlock2(node) || node.nodeName === "BR") {
        if (prevText) {
          prevText.data = prevText.data.replace(/ $/, "");
        }
        prevText = null;
        keepLeadingWs = false;
      } else if (isVoid2(node) || isPre(node)) {
        prevText = null;
        keepLeadingWs = true;
      } else if (prevText) {
        keepLeadingWs = false;
      }
    } else {
      node = remove(node);
      continue;
    }
    var nextNode = next(prev, node, isPre);
    prev = node;
    node = nextNode;
  }
  if (prevText) {
    prevText.data = prevText.data.replace(/ $/, "");
    if (!prevText.data) {
      remove(prevText);
    }
  }
}
function remove(node) {
  var next2 = node.nextSibling || node.parentNode;
  node.parentNode.removeChild(node);
  return next2;
}
function next(prev, current, isPre) {
  if (prev && prev.parentNode === current || isPre(current)) {
    return current.nextSibling || current.parentNode;
  }
  return current.firstChild || current.nextSibling || current.parentNode;
}
function canParseHTMLNatively() {
  var Parser = root.DOMParser;
  var canParse = false;
  try {
    if (new Parser().parseFromString("", "text/html")) {
      canParse = true;
    }
  } catch (e7) {
  }
  return canParse;
}
function createHTMLParser() {
  var Parser = function() {
  };
  {
    if (shouldUseActiveX()) {
      Parser.prototype.parseFromString = function(string) {
        var doc = new window.ActiveXObject("htmlfile");
        doc.designMode = "on";
        doc.open();
        doc.write(string);
        doc.close();
        return doc;
      };
    } else {
      Parser.prototype.parseFromString = function(string) {
        var doc = document.implementation.createHTMLDocument("");
        doc.open();
        doc.write(string);
        doc.close();
        return doc;
      };
    }
  }
  return Parser;
}
function shouldUseActiveX() {
  var useActiveX = false;
  try {
    document.implementation.createHTMLDocument("").open();
  } catch (e7) {
    if (root.ActiveXObject) useActiveX = true;
  }
  return useActiveX;
}
function RootNode(input, options) {
  var root2;
  if (typeof input === "string") {
    var doc = htmlParser().parseFromString(
      // DOM parsers arrange elements in the <head> and <body>.
      // Wrapping in a custom element ensures elements are reliably arranged in
      // a single element.
      '<x-turndown id="turndown-root">' + input + "</x-turndown>",
      "text/html"
    );
    root2 = doc.getElementById("turndown-root");
  } else {
    root2 = input.cloneNode(true);
  }
  collapseWhitespace({
    element: root2,
    isBlock,
    isVoid,
    isPre: options.preformattedCode ? isPreOrCode : null
  });
  return root2;
}
function htmlParser() {
  _htmlParser = _htmlParser || new HTMLParser();
  return _htmlParser;
}
function isPreOrCode(node) {
  return node.nodeName === "PRE" || node.nodeName === "CODE";
}
function Node(node, options) {
  node.isBlock = isBlock(node);
  node.isCode = node.nodeName === "CODE" || node.parentNode.isCode;
  node.isBlank = isBlank(node);
  node.flankingWhitespace = flankingWhitespace(node, options);
  return node;
}
function isBlank(node) {
  return !isVoid(node) && !isMeaningfulWhenBlank(node) && /^\s*$/i.test(node.textContent) && !hasVoid(node) && !hasMeaningfulWhenBlank(node);
}
function flankingWhitespace(node, options) {
  if (node.isBlock || options.preformattedCode && node.isCode) {
    return { leading: "", trailing: "" };
  }
  var edges = edgeWhitespace(node.textContent);
  if (edges.leadingAscii && isFlankedByWhitespace("left", node, options)) {
    edges.leading = edges.leadingNonAscii;
  }
  if (edges.trailingAscii && isFlankedByWhitespace("right", node, options)) {
    edges.trailing = edges.trailingNonAscii;
  }
  return { leading: edges.leading, trailing: edges.trailing };
}
function edgeWhitespace(string) {
  var m25 = string.match(/^(([ \t\r\n]*)(\s*))(?:(?=\S)[\s\S]*\S)?((\s*?)([ \t\r\n]*))$/);
  return {
    leading: m25[1],
    // whole string for whitespace-only strings
    leadingAscii: m25[2],
    leadingNonAscii: m25[3],
    trailing: m25[4],
    // empty for whitespace-only strings
    trailingNonAscii: m25[5],
    trailingAscii: m25[6]
  };
}
function isFlankedByWhitespace(side, node, options) {
  var sibling;
  var regExp;
  var isFlanked;
  if (side === "left") {
    sibling = node.previousSibling;
    regExp = / $/;
  } else {
    sibling = node.nextSibling;
    regExp = /^ /;
  }
  if (sibling) {
    if (sibling.nodeType === 3) {
      isFlanked = regExp.test(sibling.nodeValue);
    } else if (options.preformattedCode && sibling.nodeName === "CODE") {
      isFlanked = false;
    } else if (sibling.nodeType === 1 && !isBlock(sibling)) {
      isFlanked = regExp.test(sibling.textContent);
    }
  }
  return isFlanked;
}
function TurndownService(options) {
  if (!(this instanceof TurndownService)) return new TurndownService(options);
  var defaults2 = {
    rules,
    headingStyle: "setext",
    hr: "* * *",
    bulletListMarker: "*",
    codeBlockStyle: "indented",
    fence: "```",
    emDelimiter: "_",
    strongDelimiter: "**",
    linkStyle: "inlined",
    linkReferenceStyle: "full",
    br: "  ",
    preformattedCode: false,
    blankReplacement: function(content, node) {
      return node.isBlock ? "\n\n" : "";
    },
    keepReplacement: function(content, node) {
      return node.isBlock ? "\n\n" + node.outerHTML + "\n\n" : node.outerHTML;
    },
    defaultReplacement: function(content, node) {
      return node.isBlock ? "\n\n" + content + "\n\n" : content;
    }
  };
  this.options = extend({}, defaults2, options);
  this.rules = new Rules(this.options);
}
function process2(parentNode) {
  var self2 = this;
  return reduce.call(parentNode.childNodes, function(output, node) {
    node = new Node(node, self2.options);
    var replacement = "";
    if (node.nodeType === 3) {
      replacement = node.isCode ? node.nodeValue : self2.escape(node.nodeValue);
    } else if (node.nodeType === 1) {
      replacement = replacementForNode.call(self2, node);
    }
    return join2(output, replacement);
  }, "");
}
function postProcess(output) {
  var self2 = this;
  this.rules.forEach(function(rule) {
    if (typeof rule.append === "function") {
      output = join2(output, rule.append(self2.options));
    }
  });
  return output.replace(/^[\t\r\n]+/, "").replace(/[\t\r\n\s]+$/, "");
}
function replacementForNode(node) {
  var rule = this.rules.forNode(node);
  var content = process2.call(this, node);
  var whitespace = node.flankingWhitespace;
  if (whitespace.leading || whitespace.trailing) content = content.trim();
  return whitespace.leading + rule.replacement(content, node, this.options) + whitespace.trailing;
}
function join2(output, replacement) {
  var s12 = trimTrailingNewlines(output);
  var s22 = trimLeadingNewlines(replacement);
  var nls = Math.max(output.length - s12.length, replacement.length - s22.length);
  var separator = "\n\n".substring(0, nls);
  return s12 + separator + s22;
}
function canConvert(input) {
  return input != null && (typeof input === "string" || input.nodeType && (input.nodeType === 1 || input.nodeType === 9 || input.nodeType === 11));
}
var blockElements, voidElements, meaningfulWhenBlankElements, rules, root, HTMLParser, _htmlParser, reduce, escapes, turndown_browser_es_default;
var init_turndown_browser_es = __esm({
  "../../node_modules/turndown/lib/turndown.browser.es.js"() {
    blockElements = [
      "ADDRESS",
      "ARTICLE",
      "ASIDE",
      "AUDIO",
      "BLOCKQUOTE",
      "BODY",
      "CANVAS",
      "CENTER",
      "DD",
      "DIR",
      "DIV",
      "DL",
      "DT",
      "FIELDSET",
      "FIGCAPTION",
      "FIGURE",
      "FOOTER",
      "FORM",
      "FRAMESET",
      "H1",
      "H2",
      "H3",
      "H4",
      "H5",
      "H6",
      "HEADER",
      "HGROUP",
      "HR",
      "HTML",
      "ISINDEX",
      "LI",
      "MAIN",
      "MENU",
      "NAV",
      "NOFRAMES",
      "NOSCRIPT",
      "OL",
      "OUTPUT",
      "P",
      "PRE",
      "SECTION",
      "TABLE",
      "TBODY",
      "TD",
      "TFOOT",
      "TH",
      "THEAD",
      "TR",
      "UL"
    ];
    voidElements = [
      "AREA",
      "BASE",
      "BR",
      "COL",
      "COMMAND",
      "EMBED",
      "HR",
      "IMG",
      "INPUT",
      "KEYGEN",
      "LINK",
      "META",
      "PARAM",
      "SOURCE",
      "TRACK",
      "WBR"
    ];
    meaningfulWhenBlankElements = [
      "A",
      "TABLE",
      "THEAD",
      "TBODY",
      "TFOOT",
      "TH",
      "TD",
      "IFRAME",
      "SCRIPT",
      "AUDIO",
      "VIDEO"
    ];
    rules = {};
    rules.paragraph = {
      filter: "p",
      replacement: function(content) {
        return "\n\n" + content + "\n\n";
      }
    };
    rules.lineBreak = {
      filter: "br",
      replacement: function(content, node, options) {
        return options.br + "\n";
      }
    };
    rules.heading = {
      filter: ["h1", "h2", "h3", "h4", "h5", "h6"],
      replacement: function(content, node, options) {
        var hLevel = Number(node.nodeName.charAt(1));
        if (options.headingStyle === "setext" && hLevel < 3) {
          var underline = repeat(hLevel === 1 ? "=" : "-", content.length);
          return "\n\n" + content + "\n" + underline + "\n\n";
        } else {
          return "\n\n" + repeat("#", hLevel) + " " + content + "\n\n";
        }
      }
    };
    rules.blockquote = {
      filter: "blockquote",
      replacement: function(content) {
        content = trimNewlines(content).replace(/^/gm, "> ");
        return "\n\n" + content + "\n\n";
      }
    };
    rules.list = {
      filter: ["ul", "ol"],
      replacement: function(content, node) {
        var parent = node.parentNode;
        if (parent.nodeName === "LI" && parent.lastElementChild === node) {
          return "\n" + content;
        } else {
          return "\n\n" + content + "\n\n";
        }
      }
    };
    rules.listItem = {
      filter: "li",
      replacement: function(content, node, options) {
        var prefix = options.bulletListMarker + "   ";
        var parent = node.parentNode;
        if (parent.nodeName === "OL") {
          var start = parent.getAttribute("start");
          var index = Array.prototype.indexOf.call(parent.children, node);
          prefix = (start ? Number(start) + index : index + 1) + ".  ";
        }
        var isParagraph = /\n$/.test(content);
        content = trimNewlines(content) + (isParagraph ? "\n" : "");
        content = content.replace(/\n/gm, "\n" + " ".repeat(prefix.length));
        return prefix + content + (node.nextSibling ? "\n" : "");
      }
    };
    rules.indentedCodeBlock = {
      filter: function(node, options) {
        return options.codeBlockStyle === "indented" && node.nodeName === "PRE" && node.firstChild && node.firstChild.nodeName === "CODE";
      },
      replacement: function(content, node, options) {
        return "\n\n    " + node.firstChild.textContent.replace(/\n/g, "\n    ") + "\n\n";
      }
    };
    rules.fencedCodeBlock = {
      filter: function(node, options) {
        return options.codeBlockStyle === "fenced" && node.nodeName === "PRE" && node.firstChild && node.firstChild.nodeName === "CODE";
      },
      replacement: function(content, node, options) {
        var className = node.firstChild.getAttribute("class") || "";
        var language = (className.match(/language-(\S+)/) || [null, ""])[1];
        var code = node.firstChild.textContent;
        var fenceChar = options.fence.charAt(0);
        var fenceSize = 3;
        var fenceInCodeRegex = new RegExp("^" + fenceChar + "{3,}", "gm");
        var match2;
        while (match2 = fenceInCodeRegex.exec(code)) {
          if (match2[0].length >= fenceSize) {
            fenceSize = match2[0].length + 1;
          }
        }
        var fence = repeat(fenceChar, fenceSize);
        return "\n\n" + fence + language + "\n" + code.replace(/\n$/, "") + "\n" + fence + "\n\n";
      }
    };
    rules.horizontalRule = {
      filter: "hr",
      replacement: function(content, node, options) {
        return "\n\n" + options.hr + "\n\n";
      }
    };
    rules.inlineLink = {
      filter: function(node, options) {
        return options.linkStyle === "inlined" && node.nodeName === "A" && node.getAttribute("href");
      },
      replacement: function(content, node) {
        var href = node.getAttribute("href");
        if (href) href = href.replace(/([()])/g, "\\$1");
        var title = cleanAttribute(node.getAttribute("title"));
        if (title) title = ' "' + title.replace(/"/g, '\\"') + '"';
        return "[" + content + "](" + href + title + ")";
      }
    };
    rules.referenceLink = {
      filter: function(node, options) {
        return options.linkStyle === "referenced" && node.nodeName === "A" && node.getAttribute("href");
      },
      replacement: function(content, node, options) {
        var href = node.getAttribute("href");
        var title = cleanAttribute(node.getAttribute("title"));
        if (title) title = ' "' + title + '"';
        var replacement;
        var reference;
        switch (options.linkReferenceStyle) {
          case "collapsed":
            replacement = "[" + content + "][]";
            reference = "[" + content + "]: " + href + title;
            break;
          case "shortcut":
            replacement = "[" + content + "]";
            reference = "[" + content + "]: " + href + title;
            break;
          default:
            var id = this.references.length + 1;
            replacement = "[" + content + "][" + id + "]";
            reference = "[" + id + "]: " + href + title;
        }
        this.references.push(reference);
        return replacement;
      },
      references: [],
      append: function(options) {
        var references = "";
        if (this.references.length) {
          references = "\n\n" + this.references.join("\n") + "\n\n";
          this.references = [];
        }
        return references;
      }
    };
    rules.emphasis = {
      filter: ["em", "i"],
      replacement: function(content, node, options) {
        if (!content.trim()) return "";
        return options.emDelimiter + content + options.emDelimiter;
      }
    };
    rules.strong = {
      filter: ["strong", "b"],
      replacement: function(content, node, options) {
        if (!content.trim()) return "";
        return options.strongDelimiter + content + options.strongDelimiter;
      }
    };
    rules.code = {
      filter: function(node) {
        var hasSiblings = node.previousSibling || node.nextSibling;
        var isCodeBlock = node.parentNode.nodeName === "PRE" && !hasSiblings;
        return node.nodeName === "CODE" && !isCodeBlock;
      },
      replacement: function(content) {
        if (!content) return "";
        content = content.replace(/\r?\n|\r/g, " ");
        var extraSpace = /^`|^ .*?[^ ].* $|`$/.test(content) ? " " : "";
        var delimiter = "`";
        var matches = content.match(/`+/gm) || [];
        while (matches.indexOf(delimiter) !== -1) delimiter = delimiter + "`";
        return delimiter + extraSpace + content + extraSpace + delimiter;
      }
    };
    rules.image = {
      filter: "img",
      replacement: function(content, node) {
        var alt = cleanAttribute(node.getAttribute("alt"));
        var src = node.getAttribute("src") || "";
        var title = cleanAttribute(node.getAttribute("title"));
        var titlePart = title ? ' "' + title + '"' : "";
        return src ? "![" + alt + "](" + src + titlePart + ")" : "";
      }
    };
    Rules.prototype = {
      add: function(key, rule) {
        this.array.unshift(rule);
      },
      keep: function(filter2) {
        this._keep.unshift({
          filter: filter2,
          replacement: this.keepReplacement
        });
      },
      remove: function(filter2) {
        this._remove.unshift({
          filter: filter2,
          replacement: function() {
            return "";
          }
        });
      },
      forNode: function(node) {
        if (node.isBlank) return this.blankRule;
        var rule;
        if (rule = findRule(this.array, node, this.options)) return rule;
        if (rule = findRule(this._keep, node, this.options)) return rule;
        if (rule = findRule(this._remove, node, this.options)) return rule;
        return this.defaultRule;
      },
      forEach: function(fn4) {
        for (var i10 = 0; i10 < this.array.length; i10++) fn4(this.array[i10], i10);
      }
    };
    root = typeof window !== "undefined" ? window : {};
    HTMLParser = canParseHTMLNatively() ? root.DOMParser : createHTMLParser();
    reduce = Array.prototype.reduce;
    escapes = [
      [/\\/g, "\\\\"],
      [/\*/g, "\\*"],
      [/^-/g, "\\-"],
      [/^\+ /g, "\\+ "],
      [/^(=+)/g, "\\$1"],
      [/^(#{1,6}) /g, "\\$1 "],
      [/`/g, "\\`"],
      [/^~~~/g, "\\~~~"],
      [/\[/g, "\\["],
      [/\]/g, "\\]"],
      [/^>/g, "\\>"],
      [/_/g, "\\_"],
      [/^(\d+)\. /g, "$1\\. "]
    ];
    TurndownService.prototype = {
      /**
       * The entry point for converting a string or DOM node to Markdown
       * @public
       * @param {String|HTMLElement} input The string or DOM node to convert
       * @returns A Markdown representation of the input
       * @type String
       */
      turndown: function(input) {
        if (!canConvert(input)) {
          throw new TypeError(
            input + " is not a string, or an element/document/fragment node."
          );
        }
        if (input === "") return "";
        var output = process2.call(this, new RootNode(input, this.options));
        return postProcess.call(this, output);
      },
      /**
       * Add one or more plugins
       * @public
       * @param {Function|Array} plugin The plugin or array of plugins to add
       * @returns The Turndown instance for chaining
       * @type Object
       */
      use: function(plugin) {
        if (Array.isArray(plugin)) {
          for (var i10 = 0; i10 < plugin.length; i10++) this.use(plugin[i10]);
        } else if (typeof plugin === "function") {
          plugin(this);
        } else {
          throw new TypeError("plugin must be a Function or an Array of Functions");
        }
        return this;
      },
      /**
       * Adds a rule
       * @public
       * @param {String} key The unique key of the rule
       * @param {Object} rule The rule
       * @returns The Turndown instance for chaining
       * @type Object
       */
      addRule: function(key, rule) {
        this.rules.add(key, rule);
        return this;
      },
      /**
       * Keep a node (as HTML) that matches the filter
       * @public
       * @param {String|Array|Function} filter The unique key of the rule
       * @returns The Turndown instance for chaining
       * @type Object
       */
      keep: function(filter2) {
        this.rules.keep(filter2);
        return this;
      },
      /**
       * Remove a node that matches the filter
       * @public
       * @param {String|Array|Function} filter The unique key of the rule
       * @returns The Turndown instance for chaining
       * @type Object
       */
      remove: function(filter2) {
        this.rules.remove(filter2);
        return this;
      },
      /**
       * Escapes Markdown syntax
       * @public
       * @param {String} string The string to escape
       * @returns A string with Markdown syntax escaped
       * @type String
       */
      escape: function(string) {
        return escapes.reduce(function(accumulator, escape2) {
          return accumulator.replace(escape2[0], escape2[1]);
        }, string);
      }
    };
    turndown_browser_es_default = TurndownService;
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-MDLLFABN.js
var p15, g14, x19;
var init_chunk_MDLLFABN = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-MDLLFABN.js"() {
    init_chunk_74CEPOFO();
    init_turndown_browser_es();
    p15 = { name: "html-to-markdown", summary: "convert HTML to Markdown (BashEnv extension)", usage: "html-to-markdown [OPTION]... [FILE]", description: ["Convert HTML content to Markdown format using the turndown library.", "This is a non-standard BashEnv extension command, not available in regular bash.", "", "Read HTML from FILE or standard input and output Markdown to standard output.", "Commonly used with curl to convert web pages:", "  curl -s https://example.com | html-to-markdown", "", "Supported HTML elements:", "  - Headings (h1-h6) \u2192 # Markdown headings", "  - Paragraphs (p) \u2192 Plain text with blank lines", "  - Links (a) \u2192 [text](url)", "  - Images (img) \u2192 ![alt](src)", "  - Bold/Strong \u2192 **text**", "  - Italic/Em \u2192 _text_", "  - Code (code, pre) \u2192 `inline` or fenced blocks", "  - Lists (ul, ol, li) \u2192 - or 1. items", "  - Blockquotes \u2192 > quoted text", "  - Horizontal rules (hr) \u2192 ---"], options: ["-b, --bullet=CHAR     bullet character for unordered lists (-, +, or *)", "-c, --code=FENCE      fence style for code blocks (``` or ~~~)", "-r, --hr=STRING       string for horizontal rules (default: ---)", "    --heading-style=STYLE", "                      heading style: 'atx' for # headings (default),", "                      'setext' for underlined headings (h1/h2 only)", "    --help            display this help and exit"], examples: ["echo '<h1>Hello</h1><p>World</p>' | html-to-markdown", "html-to-markdown page.html", "curl -s https://example.com | html-to-markdown > page.md"] };
    g14 = { name: "html-to-markdown", async execute(r8, n23) {
      if (o2(r8)) return s(p15);
      let s9 = "-", a7 = "```", i10 = "---", m25 = "atx", o9 = [];
      for (let e7 = 0; e7 < r8.length; e7++) {
        let t6 = r8[e7];
        if (t6 === "-b" || t6 === "--bullet") s9 = r8[++e7] ?? "-";
        else if (t6.startsWith("--bullet=")) s9 = t6.slice(9);
        else if (t6 === "-c" || t6 === "--code") a7 = r8[++e7] ?? "```";
        else if (t6.startsWith("--code=")) a7 = t6.slice(7);
        else if (t6 === "-r" || t6 === "--hr") i10 = r8[++e7] ?? "---";
        else if (t6.startsWith("--hr=")) i10 = t6.slice(5);
        else if (t6.startsWith("--heading-style=")) {
          let d16 = t6.slice(16);
          (d16 === "setext" || d16 === "atx") && (m25 = d16);
        } else if (t6 === "-") o9.push("-");
        else {
          if (t6.startsWith("--")) return r3("html-to-markdown", t6);
          if (t6.startsWith("-")) return r3("html-to-markdown", t6);
          o9.push(t6);
        }
      }
      let l8;
      if (o9.length === 0 || o9.length === 1 && o9[0] === "-") l8 = n23.stdin;
      else try {
        let e7 = n23.fs.resolvePath(n23.cwd, o9[0]);
        l8 = await n23.fs.readFile(e7);
      } catch {
        return { stdout: "", stderr: `html-to-markdown: ${o9[0]}: No such file or directory
`, exitCode: 1 };
      }
      if (!l8.trim()) return { stdout: "", stderr: "", exitCode: 0 };
      try {
        let e7 = new turndown_browser_es_default({ bulletListMarker: s9, codeBlockStyle: "fenced", fence: a7, hr: i10, headingStyle: m25 });
        return e7.remove(["script", "style", "footer"]), { stdout: `${e7.turndown(l8).trim()}
`, stderr: "", exitCode: 0 };
      } catch (e7) {
        return { stdout: "", stderr: `html-to-markdown: conversion error: ${e7.message}
`, exitCode: 1 };
      }
    } };
    x19 = { name: "html-to-markdown", flags: [], stdinType: "text" };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/html-to-markdown-TFCECAGV.js
var html_to_markdown_TFCECAGV_exports = {};
__export(html_to_markdown_TFCECAGV_exports, {
  flagsForFuzzing: () => x19,
  htmlToMarkdownCommand: () => g14
});
var init_html_to_markdown_TFCECAGV = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/html-to-markdown-TFCECAGV.js"() {
    init_chunk_MDLLFABN();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-ZKLK6C7H.js
function l5(n23) {
  let e7 = [], t6 = new Set(n23);
  e7.push(`Available commands:
`);
  let s9 = [];
  for (let [a7, r8] of c11) {
    let o9 = r8.filter((i10) => t6.has(i10));
    if (o9.length > 0) {
      e7.push(`  ${a7}:`), e7.push(`    ${o9.join(", ")}
`);
      for (let i10 of o9) t6.delete(i10);
    }
  }
  for (let a7 of t6) s9.push(a7);
  return s9.length > 0 && (e7.push("  Other:"), e7.push(`    ${s9.sort().join(", ")}
`)), e7.push("Use '<command> --help' for details on a specific command."), `${e7.join(`
`)}
`;
}
var c11, d15, m22;
var init_chunk_ZKLK6C7H = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-ZKLK6C7H.js"() {
    c11 = /* @__PURE__ */ new Map([["File operations", ["ls", "cat", "head", "tail", "wc", "touch", "mkdir", "rm", "cp", "mv", "ln", "chmod", "stat", "readlink"]], ["Text processing", ["grep", "sed", "awk", "sort", "uniq", "cut", "tr", "tee", "diff"]], ["Search", ["find"]], ["Navigation & paths", ["pwd", "basename", "dirname", "tree", "du"]], ["Environment & shell", ["echo", "printf", "env", "printenv", "export", "alias", "unalias", "history", "clear", "true", "false", "bash", "sh"]], ["Data processing", ["xargs", "jq", "base64", "date"]], ["Network", ["curl", "html-to-markdown"]]]);
    d15 = { name: "help", async execute(n23, e7) {
      if (n23.includes("--help") || n23.includes("-h")) return { stdout: `help - display available commands

Usage: help [command]

Options:
  -h, --help    Show this help message

If a command name is provided, shows help for that command.
Otherwise, lists all available commands.
`, stderr: "", exitCode: 0 };
      if (n23.length > 0 && e7.exec) {
        let s9 = n23[0];
        return e7.exec(`${s9} --help`, { cwd: e7.cwd });
      }
      let t6 = e7.getRegisteredCommands?.() ?? [];
      return { stdout: l5(t6), stderr: "", exitCode: 0 };
    } };
    m22 = { name: "help", flags: [] };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/help-T2NGLTSG.js
var help_T2NGLTSG_exports = {};
__export(help_T2NGLTSG_exports, {
  flagsForFuzzing: () => m22,
  helpCommand: () => d15
});
var init_help_T2NGLTSG = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/help-T2NGLTSG.js"() {
    init_chunk_ZKLK6C7H();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-UYGR3CFC.js
var g15, w16, A9, F16;
var init_chunk_UYGR3CFC = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-UYGR3CFC.js"() {
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    g15 = { name: "which", summary: "locate a command", usage: "which [-as] program ...", options: ["-a         List all instances of executables found", "-s         No output, just return 0 if found, 1 if not", "--help     display this help and exit"] };
    w16 = { showAll: { short: "a", type: "boolean" }, silent: { short: "s", type: "boolean" } };
    A9 = { name: "which", async execute(e7, s9) {
      if (o2(e7)) return s(g15);
      let t6 = x5("which", e7, w16);
      if (!t6.ok) return t6.error;
      let c15 = t6.result.flags.showAll, p17 = t6.result.flags.silent, o9 = t6.result.positional;
      if (o9.length === 0) return { stdout: "", stderr: "", exitCode: 1 };
      let d16 = (s9.env.get("PATH") || "/usr/bin:/bin").split(":"), n23 = "", a7 = true;
      for (let m25 of o9) {
        let l8 = false;
        for (let r8 of d16) {
          if (!r8) continue;
          let i10 = `${r8}/${m25}`;
          if (await s9.fs.exists(i10) && (l8 = true, p17 || (n23 += `${i10}
`), !c15)) break;
        }
        l8 || (a7 = false);
      }
      return { stdout: n23, stderr: "", exitCode: a7 ? 0 : 1 };
    } };
    F16 = { name: "which", flags: [{ flag: "-a", type: "boolean" }, { flag: "-s", type: "boolean" }], needsArgs: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/which-NCIYTMAT.js
var which_NCIYTMAT_exports = {};
__export(which_NCIYTMAT_exports, {
  flagsForFuzzing: () => F16,
  whichCommand: () => A9
});
var init_which_NCIYTMAT = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/which-NCIYTMAT.js"() {
    init_chunk_UYGR3CFC();
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-NQOQ2Q77.js
async function c12(t6, s9) {
  if (t6.length > 0 && t6[0] !== "-") {
    let i10 = t6[0].startsWith("/") ? t6[0] : `${s9.cwd}/${t6[0]}`;
    try {
      let n23 = (await s9.fs.readFile(i10)).split(`
`);
      n23[n23.length - 1] === "" && n23.pop();
      let r8 = n23.reverse();
      return { stdout: r8.length > 0 ? `${r8.join(`
`)}
` : "", stderr: "", exitCode: 0 };
    } catch {
      return { stdout: "", stderr: `tac: ${t6[0]}: No such file or directory
`, exitCode: 1 };
    }
  }
  let e7 = s9.stdin.split(`
`);
  e7[e7.length - 1] === "" && e7.pop();
  let o9 = e7.reverse();
  return { stdout: o9.length > 0 ? `${o9.join(`
`)}
` : "", stderr: "", exitCode: 0 };
}
var l6, u7;
var init_chunk_NQOQ2Q77 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-NQOQ2Q77.js"() {
    l6 = { name: "tac", execute: c12 };
    u7 = { name: "tac", flags: [], stdinType: "text", needsFiles: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/tac-T7YAU2Y6.js
var tac_T7YAU2Y6_exports = {};
__export(tac_T7YAU2Y6_exports, {
  flagsForFuzzing: () => u7,
  tac: () => l6
});
var init_tac_T7YAU2Y6 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/tac-T7YAU2Y6.js"() {
    init_chunk_NQOQ2Q77();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-4HHKTUW3.js
async function t5(e7, n23) {
  return { stdout: `localhost
`, stderr: "", exitCode: 0 };
}
var o8, s7;
var init_chunk_4HHKTUW3 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-4HHKTUW3.js"() {
    o8 = { name: "hostname", execute: t5 };
    s7 = { name: "hostname", flags: [] };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/hostname-BK6HG2DE.js
var hostname_BK6HG2DE_exports = {};
__export(hostname_BK6HG2DE_exports, {
  flagsForFuzzing: () => s7,
  hostname: () => o8
});
var init_hostname_BK6HG2DE = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/hostname-BK6HG2DE.js"() {
    init_chunk_4HHKTUW3();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-HJQJAYMS.js
async function e4(t6, o9) {
  return { stdout: `user
`, stderr: "", exitCode: 0 };
}
var a6, n21;
var init_chunk_HJQJAYMS = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-HJQJAYMS.js"() {
    a6 = { name: "whoami", execute: e4 };
    n21 = { name: "whoami", flags: [] };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/whoami-DGKU3D2X.js
var whoami_DGKU3D2X_exports = {};
__export(whoami_DGKU3D2X_exports, {
  flagsForFuzzing: () => n21,
  whoami: () => a6
});
var init_whoami_DGKU3D2X = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/whoami-DGKU3D2X.js"() {
    init_chunk_HJQJAYMS();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-PP6PSHAB.js
async function x20(a7, u11) {
  let o9 = "octal", n23 = [], i10 = [];
  for (let t6 = 0; t6 < a7.length; t6++) {
    let e7 = a7[t6];
    if (e7 === "-c") n23.push("char");
    else if (e7 === "-An" || e7 === "-A" && a7[t6 + 1] === "n") o9 = "none", e7 === "-A" && t6++;
    else if (e7 === "-t" && a7[t6 + 1]) {
      let r8 = a7[++t6];
      r8 === "x1" ? n23.push("hex") : r8 === "c" ? n23.push("char") : r8.startsWith("o") && n23.push("octal");
    } else (!e7.startsWith("-") || e7 === "-") && i10.push(e7);
  }
  n23.length === 0 && n23.push("octal");
  let c15 = u11.stdin;
  if (i10.length > 0 && i10[0] !== "-") {
    let t6 = i10[0].startsWith("/") ? i10[0] : `${u11.cwd}/${i10[0]}`;
    try {
      c15 = await u11.fs.readFile(t6);
    } catch {
      return { stdout: "", stderr: `od: ${i10[0]}: No such file or directory
`, exitCode: 1 };
    }
  }
  let d16 = n23.includes("char");
  function m25(t6) {
    return t6 === 0 ? "  \\0" : t6 === 7 ? "  \\a" : t6 === 8 ? "  \\b" : t6 === 9 ? "  \\t" : t6 === 10 ? "  \\n" : t6 === 11 ? "  \\v" : t6 === 12 ? "  \\f" : t6 === 13 ? "  \\r" : t6 >= 32 && t6 < 127 ? `   ${String.fromCharCode(t6)}` : ` ${t6.toString(8).padStart(3, "0")}`;
  }
  function y18(t6) {
    return d16 ? `  ${t6.toString(16).padStart(2, "0")}` : ` ${t6.toString(16).padStart(2, "0")}`;
  }
  function S17(t6) {
    return ` ${t6.toString(8).padStart(3, "0")}`;
  }
  let s9 = [];
  for (let t6 of c15) s9.push(t6.charCodeAt(0));
  let p17 = 16, f11 = [];
  for (let t6 = 0; t6 < s9.length; t6 += p17) {
    let e7 = s9.slice(t6, t6 + p17);
    for (let r8 = 0; r8 < n23.length; r8++) {
      let g18 = n23[r8], l8;
      g18 === "char" ? l8 = e7.map(m25) : g18 === "hex" ? l8 = e7.map(y18) : l8 = e7.map(S17);
      let h17 = "";
      r8 === 0 && o9 !== "none" ? h17 = `${t6.toString(8).padStart(7, "0")} ` : (r8 > 0 || o9 === "none") && (h17 = o9 === "none" ? "" : "        "), f11.push(h17 + l8.join(""));
    }
  }
  return o9 !== "none" && s9.length > 0 && f11.push(s9.length.toString(8).padStart(7, "0")), { stdout: f11.length > 0 ? `${f11.join(`
`)}
` : "", stderr: "", exitCode: 0 };
}
var $15, v18;
var init_chunk_PP6PSHAB = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-PP6PSHAB.js"() {
    $15 = { name: "od", execute: x20 };
    v18 = { name: "od", flags: [{ flag: "-c", type: "boolean" }, { flag: "-A", type: "value", valueHint: "string" }, { flag: "-t", type: "value", valueHint: "string" }, { flag: "-N", type: "value", valueHint: "number" }], stdinType: "text", needsFiles: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/od-VJEF2UR5.js
var od_VJEF2UR5_exports = {};
__export(od_VJEF2UR5_exports, {
  flagsForFuzzing: () => v18,
  od: () => $15
});
var init_od_VJEF2UR5 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/od-VJEF2UR5.js"() {
    init_chunk_PP6PSHAB();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-DZ33S2U7.js
function F17(e7) {
  return e7.best ? constants.Z_BEST_COMPRESSION : e7.level8 ? 8 : e7.level7 ? 7 : e7.level6 ? 6 : e7.level5 ? 5 : e7.level4 ? 4 : e7.level3 ? 3 : e7.level2 ? 2 : e7.fast ? constants.Z_BEST_SPEED : constants.Z_DEFAULT_COMPRESSION;
}
function S11(e7) {
  if (e7.length < 10) return { originalName: null, mtime: null, headerSize: 0 };
  if (e7[0] !== 31 || e7[1] !== 139) return { originalName: null, mtime: null, headerSize: 0 };
  let t6 = e7[3], o9 = e7[4] | e7[5] << 8 | e7[6] << 16 | e7[7] << 24, r8 = 10;
  if (t6 & 4) {
    if (r8 + 2 > e7.length) return { originalName: null, mtime: null, headerSize: 0 };
    let n23 = e7[r8] | e7[r8 + 1] << 8;
    r8 += 2 + n23;
  }
  let s9 = null;
  if (t6 & 8) {
    let n23 = r8;
    for (; r8 < e7.length && e7[r8] !== 0; ) r8++;
    r8 < e7.length && (s9 = new TextDecoder().decode(e7.slice(n23, r8)), r8++);
  }
  if (t6 & 16) {
    for (; r8 < e7.length && e7[r8] !== 0; ) r8++;
    r8++;
  }
  return t6 & 2 && (r8 += 2), { originalName: s9, mtime: o9 > 0 ? new Date(o9 * 1e3) : null, headerSize: r8 };
}
function D12(e7) {
  if (e7.length < 4) return 0;
  let t6 = e7.length;
  return e7[t6 - 4] | e7[t6 - 3] << 8 | e7[t6 - 2] << 16 | e7[t6 - 1] << 24;
}
function m23(e7) {
  return e7.length >= 2 && e7[0] === 31 && e7[1] === 139;
}
async function E8(e7, t6, o9, r8, s9, n23) {
  let l8 = o9.suffix, f11, p17, a7;
  if (t6 === "-" || t6 === "") if (a7 = Uint8Array.from(e7.stdin, (u11) => u11.charCodeAt(0)), s9) {
    if (!m23(a7)) return o9.quiet ? { stdout: "", stderr: "", exitCode: 1 } : { stdout: "", stderr: `${r8}: stdin: not in gzip format
`, exitCode: 1 };
    try {
      let u11 = gunzipSync(a7);
      return { stdout: String.fromCharCode(...u11), stderr: "", exitCode: 0 };
    } catch (u11) {
      let i10 = u11 instanceof Error ? u11.message : "unknown error";
      return { stdout: "", stderr: `${r8}: stdin: ${i10}
`, exitCode: 1 };
    }
  } else {
    let u11 = F17(o9), i10 = gzipSync(a7, { level: u11 });
    return { stdout: String.fromCharCode(...i10), stderr: "", exitCode: 0 };
  }
  f11 = e7.fs.resolvePath(e7.cwd, t6);
  try {
    if ((await e7.fs.stat(f11)).isDirectory) return o9.recursive ? await k10(e7, f11, o9, r8, s9, n23) : o9.quiet ? { stdout: "", stderr: "", exitCode: 1 } : { stdout: "", stderr: `${r8}: ${t6}: is a directory -- ignored
`, exitCode: 1 };
  } catch {
    return { stdout: "", stderr: `${r8}: ${t6}: No such file or directory
`, exitCode: 1 };
  }
  try {
    a7 = await e7.fs.readFileBuffer(f11);
  } catch {
    return { stdout: "", stderr: `${r8}: ${t6}: No such file or directory
`, exitCode: 1 };
  }
  if (s9) {
    if (!t6.endsWith(l8)) return o9.quiet ? { stdout: "", stderr: "", exitCode: 1 } : { stdout: "", stderr: `${r8}: ${t6}: unknown suffix -- ignored
`, exitCode: 1 };
    if (!m23(a7)) return o9.quiet ? { stdout: "", stderr: "", exitCode: 1 } : { stdout: "", stderr: `${r8}: ${t6}: not in gzip format
`, exitCode: 1 };
    let u11;
    try {
      u11 = gunzipSync(a7);
    } catch (i10) {
      let c15 = i10 instanceof Error ? i10.message : "unknown error";
      return { stdout: "", stderr: `${r8}: ${t6}: ${c15}
`, exitCode: 1 };
    }
    if (n23) return { stdout: String.fromCharCode(...u11), stderr: "", exitCode: 0 };
    if (o9.name) {
      let i10 = S11(a7);
      i10.originalName ? p17 = e7.fs.resolvePath(e7.cwd, i10.originalName) : p17 = f11.slice(0, -l8.length);
    } else p17 = f11.slice(0, -l8.length);
    if (!o9.force) try {
      return await e7.fs.stat(p17), { stdout: "", stderr: `${r8}: ${p17} already exists; not overwritten
`, exitCode: 1 };
    } catch {
    }
    if (await e7.fs.writeFile(p17, u11), !o9.keep && !n23 && await e7.fs.rm(f11), o9.verbose) {
      let i10 = a7.length > 0 ? ((1 - a7.length / u11.length) * 100).toFixed(1) : "0.0";
      return { stdout: "", stderr: `${t6}:	${i10}% -- replaced with ${p17.split("/").pop()}
`, exitCode: 0 };
    }
    return { stdout: "", stderr: "", exitCode: 0 };
  } else {
    if (t6.endsWith(l8)) return o9.quiet ? { stdout: "", stderr: "", exitCode: 1 } : { stdout: "", stderr: `${r8}: ${t6} already has ${l8} suffix -- unchanged
`, exitCode: 1 };
    let u11 = F17(o9), i10;
    try {
      i10 = gzipSync(a7, { level: u11 });
    } catch (c15) {
      let d16 = c15 instanceof Error ? c15.message : "unknown error";
      return { stdout: "", stderr: `${r8}: ${t6}: ${d16}
`, exitCode: 1 };
    }
    if (n23) return { stdout: String.fromCharCode(...i10), stderr: "", exitCode: 0 };
    if (p17 = f11 + l8, !o9.force) try {
      return await e7.fs.stat(p17), { stdout: "", stderr: `${r8}: ${p17} already exists; not overwritten
`, exitCode: 1 };
    } catch {
    }
    if (await e7.fs.writeFile(p17, i10), !o9.keep && !n23 && await e7.fs.rm(f11), o9.verbose) {
      let c15 = a7.length > 0 ? ((1 - i10.length / a7.length) * 100).toFixed(1) : "0.0";
      return { stdout: "", stderr: `${t6}:	${c15}% -- replaced with ${p17.split("/").pop()}
`, exitCode: 0 };
    }
    return { stdout: "", stderr: "", exitCode: 0 };
  }
}
async function k10(e7, t6, o9, r8, s9, n23) {
  let l8 = await e7.fs.readdir(t6), f11 = "", p17 = "", a7 = 0;
  for (let u11 of l8) {
    let i10 = e7.fs.resolvePath(t6, u11), c15 = await e7.fs.stat(i10);
    if (c15.isDirectory) {
      let d16 = await k10(e7, i10, o9, r8, s9, n23);
      f11 += d16.stdout, p17 += d16.stderr, d16.exitCode !== 0 && (a7 = d16.exitCode);
    } else if (c15.isFile) {
      let d16 = o9.suffix;
      if (s9 && !u11.endsWith(d16) || !s9 && u11.endsWith(d16)) continue;
      let y18 = i10.startsWith(`${e7.cwd}/`) ? i10.slice(e7.cwd.length + 1) : i10, h17 = await E8(e7, y18, o9, r8, s9, n23);
      f11 += h17.stdout, p17 += h17.stderr, h17.exitCode !== 0 && (a7 = h17.exitCode);
    }
  }
  return { stdout: f11, stderr: p17, exitCode: a7 };
}
async function O11(e7, t6, o9, r8) {
  let s9;
  if (t6 === "-" || t6 === "") s9 = Uint8Array.from(e7.stdin, (i10) => i10.charCodeAt(0));
  else {
    let i10 = e7.fs.resolvePath(e7.cwd, t6);
    try {
      s9 = await e7.fs.readFileBuffer(i10);
    } catch {
      return { stdout: "", stderr: `${r8}: ${t6}: No such file or directory
`, exitCode: 1 };
    }
  }
  if (!m23(s9)) return o9.quiet ? { stdout: "", stderr: "", exitCode: 1 } : { stdout: "", stderr: `${r8}: ${t6}: not in gzip format
`, exitCode: 1 };
  let n23 = s9.length, l8 = D12(s9), f11 = l8 > 0 ? ((1 - n23 / l8) * 100).toFixed(1) : "0.0", a7 = S11(s9).originalName || (t6 === "-" ? "" : t6.replace(/\.gz$/, ""));
  return { stdout: `${n23.toString().padStart(10)} ${l8.toString().padStart(10)} ${f11.padStart(5)}% ${a7}
`, stderr: "", exitCode: 0 };
}
async function U11(e7, t6, o9, r8) {
  let s9;
  if (t6 === "-" || t6 === "") s9 = Uint8Array.from(e7.stdin, (n23) => n23.charCodeAt(0));
  else {
    let n23 = e7.fs.resolvePath(e7.cwd, t6);
    try {
      s9 = await e7.fs.readFileBuffer(n23);
    } catch {
      return { stdout: "", stderr: `${r8}: ${t6}: No such file or directory
`, exitCode: 1 };
    }
  }
  if (!m23(s9)) return o9.quiet ? { stdout: "", stderr: "", exitCode: 1 } : { stdout: "", stderr: `${r8}: ${t6}: not in gzip format
`, exitCode: 1 };
  try {
    return gunzipSync(s9), o9.verbose ? { stdout: "", stderr: `${t6}:	OK
`, exitCode: 0 } : { stdout: "", stderr: "", exitCode: 0 };
  } catch (n23) {
    let l8 = n23 instanceof Error ? n23.message : "invalid";
    return { stdout: "", stderr: `${r8}: ${t6}: ${l8}
`, exitCode: 1 };
  }
}
async function x21(e7, t6, o9) {
  let r8 = o9 === "zcat" ? P14 : o9 === "gunzip" ? I16 : q11;
  if (o2(e7)) return s(r8);
  let s9 = x5(o9, e7, L14);
  if (!s9.ok) return s9.error.stderr.includes("unrecognized option"), s9.error;
  let n23 = s9.result.flags, l8 = s9.result.positional, f11 = o9 === "gunzip" || o9 === "zcat" || n23.decompress || n23.uncompress, p17 = o9 === "zcat" || n23.stdout || n23.toStdout;
  if (n23.list) {
    l8.length === 0 && (l8 = ["-"]);
    let c15 = `  compressed uncompressed  ratio uncompressed_name
`, d16 = "", y18 = 0;
    for (let h17 of l8) {
      let g18 = await O11(t6, h17, n23, o9);
      c15 += g18.stdout, d16 += g18.stderr, g18.exitCode !== 0 && (y18 = g18.exitCode);
    }
    return { stdout: c15, stderr: d16, exitCode: y18 };
  }
  if (n23.test) {
    l8.length === 0 && (l8 = ["-"]);
    let c15 = "", d16 = "", y18 = 0;
    for (let h17 of l8) {
      let g18 = await U11(t6, h17, n23, o9);
      c15 += g18.stdout, d16 += g18.stderr, g18.exitCode !== 0 && (y18 = g18.exitCode);
    }
    return { stdout: c15, stderr: d16, exitCode: y18 };
  }
  l8.length === 0 && (l8 = ["-"]);
  let a7 = "", u11 = "", i10 = 0;
  for (let c15 of l8) {
    let d16 = await E8(t6, c15, n23, o9, f11, p17);
    a7 += d16.stdout, u11 += d16.stderr, d16.exitCode !== 0 && (i10 = d16.exitCode);
  }
  return { stdout: a7, stderr: u11, exitCode: i10 };
}
var q11, I16, P14, L14, _8, H13, B7, G5, Z9, M10;
var init_chunk_DZ33S2U7 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-DZ33S2U7.js"() {
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    init_node_zlib();
    q11 = { name: "gzip", summary: "compress or expand files", usage: "gzip [OPTION]... [FILE]...", description: `Compress FILEs (by default, in-place).

When no FILE is given, or when FILE is -, read from standard input.

With -d, decompress instead.`, options: ["-c, --stdout      write to standard output, keep original files", "-d, --decompress  decompress", "-f, --force       force overwrite of output file", "-k, --keep        keep (don't delete) input files", "-l, --list        list compressed file contents", "-n, --no-name     do not save or restore the original name and timestamp", "-N, --name        save or restore the original file name and timestamp", "-q, --quiet       suppress all warnings", "-r, --recursive   operate recursively on directories", "-S, --suffix=SUF  use suffix SUF on compressed files (default: .gz)", "-t, --test        test compressed file integrity", "-v, --verbose     verbose mode", "-1, --fast        compress faster", "-9, --best        compress better", "    --help        display this help and exit"] };
    I16 = { name: "gunzip", summary: "decompress files", usage: "gunzip [OPTION]... [FILE]...", description: `Decompress FILEs (by default, in-place).

When no FILE is given, or when FILE is -, read from standard input.`, options: ["-c, --stdout      write to standard output, keep original files", "-f, --force       force overwrite of output file", "-k, --keep        keep (don't delete) input files", "-l, --list        list compressed file contents", "-n, --no-name     do not restore the original name and timestamp", "-N, --name        restore the original file name and timestamp", "-q, --quiet       suppress all warnings", "-r, --recursive   operate recursively on directories", "-S, --suffix=SUF  use suffix SUF on compressed files (default: .gz)", "-t, --test        test compressed file integrity", "-v, --verbose     verbose mode", "    --help        display this help and exit"] };
    P14 = { name: "zcat", summary: "decompress files to stdout", usage: "zcat [OPTION]... [FILE]...", description: `Decompress FILEs to standard output.

When no FILE is given, or when FILE is -, read from standard input.`, options: ["-f, --force       force; read compressed data even from a terminal", "-l, --list        list compressed file contents", "-q, --quiet       suppress all warnings", "-S, --suffix=SUF  use suffix SUF on compressed files (default: .gz)", "-t, --test        test compressed file integrity", "-v, --verbose     verbose mode", "    --help        display this help and exit"] };
    L14 = { stdout: { short: "c", long: "stdout", type: "boolean" }, toStdout: { long: "to-stdout", type: "boolean" }, decompress: { short: "d", long: "decompress", type: "boolean" }, uncompress: { long: "uncompress", type: "boolean" }, force: { short: "f", long: "force", type: "boolean" }, keep: { short: "k", long: "keep", type: "boolean" }, list: { short: "l", long: "list", type: "boolean" }, noName: { short: "n", long: "no-name", type: "boolean" }, name: { short: "N", long: "name", type: "boolean" }, quiet: { short: "q", long: "quiet", type: "boolean" }, recursive: { short: "r", long: "recursive", type: "boolean" }, suffix: { short: "S", long: "suffix", type: "string", default: ".gz" }, test: { short: "t", long: "test", type: "boolean" }, verbose: { short: "v", long: "verbose", type: "boolean" }, fast: { short: "1", long: "fast", type: "boolean" }, level2: { short: "2", type: "boolean" }, level3: { short: "3", type: "boolean" }, level4: { short: "4", type: "boolean" }, level5: { short: "5", type: "boolean" }, level6: { short: "6", type: "boolean" }, level7: { short: "7", type: "boolean" }, level8: { short: "8", type: "boolean" }, best: { short: "9", long: "best", type: "boolean" } };
    _8 = { name: "gzip", async execute(e7, t6) {
      return x21(e7, t6, "gzip");
    } };
    H13 = { name: "gunzip", async execute(e7, t6) {
      return x21(e7, t6, "gunzip");
    } };
    B7 = { name: "zcat", async execute(e7, t6) {
      return x21(e7, t6, "zcat");
    } };
    G5 = { name: "gzip", flags: [{ flag: "-c", type: "boolean" }, { flag: "-d", type: "boolean" }, { flag: "-f", type: "boolean" }, { flag: "-k", type: "boolean" }, { flag: "-l", type: "boolean" }, { flag: "-n", type: "boolean" }, { flag: "-q", type: "boolean" }, { flag: "-r", type: "boolean" }, { flag: "-t", type: "boolean" }, { flag: "-v", type: "boolean" }, { flag: "-1", type: "boolean" }, { flag: "-9", type: "boolean" }], stdinType: "binary", needsFiles: true };
    Z9 = { name: "gunzip", flags: [{ flag: "-c", type: "boolean" }, { flag: "-f", type: "boolean" }, { flag: "-k", type: "boolean" }, { flag: "-q", type: "boolean" }, { flag: "-v", type: "boolean" }], stdinType: "binary", needsFiles: true };
    M10 = { name: "zcat", flags: [{ flag: "-f", type: "boolean" }, { flag: "-q", type: "boolean" }, { flag: "-v", type: "boolean" }], stdinType: "binary", needsFiles: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/gzip-UTSGNF5Z.js
var gzip_UTSGNF5Z_exports = {};
__export(gzip_UTSGNF5Z_exports, {
  flagsForFuzzing: () => G5,
  gunzipCommand: () => H13,
  gunzipFlagsForFuzzing: () => Z9,
  gzipCommand: () => _8,
  zcatCommand: () => B7,
  zcatFlagsForFuzzing: () => M10
});
var init_gzip_UTSGNF5Z = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/gzip-UTSGNF5Z.js"() {
    init_chunk_DZ33S2U7();
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// stub-compressjs:compressjs
var err, compressjs_default;
var init_compressjs = __esm({
  "stub-compressjs:compressjs"() {
    err = () => {
      throw new Error("bzip2 support removed - compressjs (GPL) stripped");
    };
    compressjs_default = { Bzip2: { decompressFile: err, compressFile: err } };
  }
});

// stub-native:node-liblzma
var node_liblzma_exports = {};
__export(node_liblzma_exports, {
  compress: () => compress,
  decompress: () => decompress,
  default: () => node_liblzma_default
});
var node_liblzma_default, compress, decompress;
var init_node_liblzma = __esm({
  "stub-native:node-liblzma"() {
    node_liblzma_default = {};
    compress = () => {
      throw new Error("node-liblzma stubbed for browser");
    };
    decompress = () => {
      throw new Error("node-liblzma stubbed for browser");
    };
  }
});

// stub-native:@mongodb-js/zstd
var zstd_exports = {};
__export(zstd_exports, {
  compress: () => compress2,
  decompress: () => decompress2,
  default: () => zstd_default
});
var zstd_default, compress2, decompress2;
var init_zstd = __esm({
  "stub-native:@mongodb-js/zstd"() {
    zstd_default = {};
    compress2 = () => {
      throw new Error("@mongodb-js/zstd stubbed for browser");
    };
    decompress2 = () => {
      throw new Error("@mongodb-js/zstd stubbed for browser");
    };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-VZWXH2PZ.js
function T8(e7, t6, i10, r8) {
  r8 && U12.encodeInto(r8, e7.subarray(t6, t6 + i10));
}
function F18(e7, t6, i10, r8) {
  if (r8 === void 0) return;
  let n23 = r8.toString(8).padStart(i10 - 1, "0");
  U12.encodeInto(n23, e7.subarray(t6, t6 + i10 - 1));
}
function A10(e7, t6, i10) {
  let r8 = e7.indexOf(0, t6), n23 = r8 === -1 || r8 > t6 + i10 ? t6 + i10 : r8;
  return le6.decode(e7.subarray(t6, n23));
}
function W10(e7, t6, i10) {
  let r8 = 0, n23 = t6 + i10;
  for (let s9 = t6; s9 < n23; s9++) {
    let o9 = e7[s9];
    if (o9 === 0) break;
    o9 !== 32 && (r8 = r8 * 8 + (o9 - 48));
  }
  return r8;
}
function k11(e7, t6, i10) {
  if (e7[t6] & 128) {
    let r8 = 0;
    r8 = e7[t6] & 127;
    for (let n23 = 1; n23 < i10; n23++) r8 = r8 * 256 + e7[t6 + n23];
    if (!Number.isSafeInteger(r8)) throw new Error("TAR number too large");
    return r8;
  }
  return W10(e7, t6, i10);
}
async function ue8(e7) {
  if (e7 == null) return b22;
  if (e7 instanceof Uint8Array) return e7;
  if (typeof e7 == "string") return U12.encode(e7);
  if (e7 instanceof ArrayBuffer) return new Uint8Array(e7);
  if (e7 instanceof Blob) return new Uint8Array(await e7.arrayBuffer());
  throw new TypeError("Unsupported content type for entry body.");
}
function fe8(e7, t6) {
  let { strip: i10, filter: r8, map: n23 } = t6;
  if (!i10 && !r8 && !n23) return e7;
  let s9 = { ...e7 };
  if (i10 && i10 > 0) {
    let a7 = s9.name.split("/").filter(Boolean);
    if (i10 >= a7.length) return null;
    let c15 = a7.slice(i10).join("/");
    if (s9.name = s9.type === M11 && !c15.endsWith("/") ? `${c15}/` : c15, s9.linkname?.startsWith("/")) {
      let l8 = s9.linkname.split("/").filter(Boolean);
      s9.linkname = i10 >= l8.length ? "/" : `/${l8.slice(i10).join("/")}`;
    }
  }
  if (r8?.(s9) === false) return null;
  let o9 = n23 ? n23(s9) : s9;
  return o9 && (!o9.name || !o9.name.trim() || o9.name === "." || o9.name === "/") ? null : o9;
}
function Be3(e7) {
  let t6 = W10(e7, 148, 8), i10 = 0;
  for (let r8 = 0; r8 < e7.length; r8++) r8 >= 148 && r8 < 156 ? i10 += G6 : i10 += e7[r8];
  return t6 === i10;
}
function De4(e7) {
  e7.fill(G6, 148, 156);
  let t6 = 0;
  for (let i10 of e7) t6 += i10;
  for (let i10 = 153; i10 >= 148; i10--) e7[i10] = (t6 & 7) + Ze5, t6 >>= 3;
  e7[154] = 0, e7[155] = G6;
}
function Ne4(e7) {
  let t6 = {};
  e7.name.length > 100 && de8(e7.name) === null && (t6.path = e7.name), e7.linkname && e7.linkname.length > 100 && (t6.linkpath = e7.linkname), e7.uname && e7.uname.length > 32 && (t6.uname = e7.uname), e7.gname && e7.gname.length > 32 && (t6.gname = e7.gname), e7.uid != null && e7.uid > 2097151 && (t6.uid = String(e7.uid)), e7.gid != null && e7.gid > 2097151 && (t6.gid = String(e7.gid)), e7.size != null && e7.size > 8589934591 && (t6.size = String(e7.size)), e7.pax && Object.assign(t6, e7.pax);
  let i10 = Object.entries(t6);
  if (i10.length === 0) return null;
  let r8 = U12.encode(i10.map(([n23, s9]) => {
    let o9 = `${n23}=${s9}
`, a7 = U12.encode(o9).length + 1, c15 = a7 + String(a7).length;
    return c15 = a7 + String(c15).length, `${c15} ${o9}`;
  }).join(""));
  return { paxHeader: me4({ name: le6.decode(U12.encode(`PaxHeader/${e7.name}`).slice(0, 100)), size: r8.length, type: "pax-header", mode: 420, mtime: e7.mtime, uname: e7.uname, gname: e7.gname, uid: e7.uid, gid: e7.gid }), paxBody: r8 };
}
function de8(e7) {
  if (e7.length <= 100) return null;
  let t6 = e7.length - 100 - 1, i10 = e7.lastIndexOf("/", 155);
  return i10 > 0 && i10 >= t6 ? { prefix: e7.slice(0, i10), name: e7.slice(i10 + 1) } : null;
}
function me4(e7) {
  let t6 = new Uint8Array(512), i10 = z7(e7) ? 0 : e7.size ?? 0, r8 = e7.name, n23 = "";
  if (!e7.pax?.path) {
    let s9 = de8(r8);
    s9 && (r8 = s9.name, n23 = s9.prefix);
  }
  return T8(t6, 0, 100, r8), F18(t6, 100, 8, e7.mode ?? (e7.type === M11 ? 493 : 420)), F18(t6, 108, 8, e7.uid ?? 0), F18(t6, 116, 8, e7.gid ?? 0), F18(t6, 124, 12, i10), F18(t6, 136, 12, Math.floor((e7.mtime?.getTime() ?? Date.now()) / 1e3)), T8(t6, 156, 1, be4[e7.type ?? H14]), T8(t6, 157, 100, e7.linkname), T8(t6, 257, 6, "ustar\0"), T8(t6, 263, 2, "00"), T8(t6, 265, 32, e7.uname), T8(t6, 297, 32, e7.gname), T8(t6, 345, 155, n23), De4(t6), t6;
}
function Le5(e7, t6) {
  if (t6 && !Be3(e7)) throw new Error("Invalid tar header checksum.");
  let i10 = A10(e7, 156, 1), r8 = { name: A10(e7, 0, 100), mode: W10(e7, 100, 8), uid: k11(e7, 108, 8), gid: k11(e7, 116, 8), size: k11(e7, 124, 12), mtime: new Date(k11(e7, 136, 12) * 1e3), type: Me4[i10] || H14, linkname: A10(e7, 157, 100) }, n23 = A10(e7, 257, 6);
  return n23.trim() === "ustar" && (r8.uname = A10(e7, 265, 32), r8.gname = A10(e7, 297, 32)), n23 === "ustar" && (r8.prefix = A10(e7, 345, 155)), r8;
}
function Pe3(e7) {
  let t6 = new TextDecoder("utf-8"), i10 = {}, r8 = {}, n23 = 0;
  for (; n23 < e7.length; ) {
    let s9 = e7.indexOf(32, n23);
    if (s9 === -1) break;
    let o9 = parseInt(t6.decode(e7.subarray(n23, s9)), 10);
    if (Number.isNaN(o9) || o9 === 0) break;
    let a7 = n23 + o9, [c15, l8] = t6.decode(e7.subarray(s9 + 1, a7 - 1)).split("=", 2);
    if (c15 && l8 !== void 0) {
      r8[c15] = l8;
      let d16 = Ke4[c15];
      if (d16) {
        let [u11, g18] = d16, p17 = g18(l8);
        (typeof p17 == "string" || !Number.isNaN(p17)) && (i10[u11] = p17);
      }
    }
    n23 = a7;
  }
  return Object.keys(r8).length > 0 && (i10.pax = r8), i10;
}
function se6(e7, t6) {
  t6.name !== void 0 && (e7.name = t6.name), t6.linkname !== void 0 && (e7.linkname = t6.linkname), t6.size !== void 0 && (e7.size = t6.size), t6.mtime !== void 0 && (e7.mtime = new Date(t6.mtime * 1e3)), t6.uid !== void 0 && (e7.uid = t6.uid), t6.gid !== void 0 && (e7.gid = t6.gid), t6.uname !== void 0 && (e7.uname = t6.uname), t6.gname !== void 0 && (e7.gname = t6.gname), t6.pax && (e7.pax = Object.assign({}, e7.pax ?? {}, t6.pax));
}
function Ge4(e7) {
  switch (e7) {
    case "pax-global-header":
    case "pax-header":
      return Pe3;
    case "gnu-long-name":
      return (t6) => ({ name: A10(t6, 0, t6.length) });
    case "gnu-long-link-name":
      return (t6) => ({ linkname: A10(t6, 0, t6.length) });
    default:
      return;
  }
}
function He4(e7) {
  let t6 = me4(e7), i10 = Ne4(e7);
  if (!i10) return [t6];
  let r8 = -i10.paxBody.length & 511, n23 = r8 > 0 ? [$e4.subarray(0, r8)] : [];
  return [i10.paxHeader, i10.paxBody, ...n23, t6];
}
function pe6(e7, t6, i10) {
  let r8 = null, n23 = 0, s9 = false;
  return { add(o9) {
    if (s9) {
      let a7 = new Error("No new tar entries after finalize.");
      throw t6(a7), a7;
    }
    if (r8 !== null) {
      let a7 = new Error("Previous entry must be completed before adding a new one");
      throw t6(a7), a7;
    }
    try {
      let a7 = z7(o9) ? 0 : o9.size ?? 0, c15 = He4({ ...o9, size: a7 });
      for (let l8 of c15) e7(l8);
      r8 = { ...o9, size: a7 }, n23 = 0;
    } catch (a7) {
      t6(a7);
    }
  }, write(o9) {
    if (!r8) {
      let c15 = new Error("No active tar entry.");
      throw t6(c15), c15;
    }
    if (s9) {
      let c15 = new Error("Cannot write data after finalize.");
      throw t6(c15), c15;
    }
    let a7 = n23 + o9.length;
    if (a7 > r8.size) {
      let c15 = new Error(`"${r8.name}" exceeds given size of ${r8.size} bytes.`);
      throw t6(c15), c15;
    }
    try {
      n23 = a7, e7(o9);
    } catch (c15) {
      t6(c15);
    }
  }, endEntry() {
    if (!r8) {
      let o9 = new Error("No active entry to end.");
      throw t6(o9), o9;
    }
    if (s9) {
      let o9 = new Error("Cannot end entry after finalize.");
      throw t6(o9), o9;
    }
    try {
      if (n23 !== r8.size) {
        let a7 = new Error(`Size mismatch for "${r8.name}".`);
        throw t6(a7), a7;
      }
      let o9 = -r8.size & 511;
      o9 > 0 && e7(new Uint8Array(o9)), r8 = null, n23 = 0;
    } catch (o9) {
      throw t6(o9), o9;
    }
  }, finalize() {
    if (s9) {
      let o9 = new Error("Archive has already been finalized");
      throw t6(o9), o9;
    }
    if (r8 !== null) {
      let o9 = new Error("Cannot finalize while an entry is still active");
      throw t6(o9), o9;
    }
    try {
      e7(We4), s9 = true, i10 && i10();
    } catch (o9) {
      t6(o9);
    }
  } };
}
function Xe4() {
  let e7 = new Array(R7), t6 = e7.length - 1, i10 = 0, r8 = 0, n23 = 0, s9 = (a7) => {
    let c15 = e7[i10];
    a7 === c15.length ? (e7[i10] = b22, i10 = i10 + 1 & t6) : e7[i10] = c15.subarray(a7), n23 -= a7, n23 === 0 && e7.length > R7 && (e7 = new Array(R7), t6 = R7 - 1, i10 = 0, r8 = 0);
  };
  function o9(a7, c15) {
    if (c15) {
      let p17 = 0, f11 = Math.min(a7, n23);
      for (; f11 > 0; ) {
        let h17 = e7[i10], m25 = Math.min(f11, h17.length), S17 = m25 === h17.length ? h17 : h17.subarray(0, m25);
        if (s9(m25), f11 -= m25, p17 += m25, !c15(S17)) break;
      }
      return p17;
    }
    if (n23 < a7) return null;
    if (a7 === 0) return b22;
    let l8 = e7[i10];
    if (l8.length >= a7) {
      let p17 = l8.length === a7 ? l8 : l8.subarray(0, a7);
      return s9(a7), p17;
    }
    let d16 = new Uint8Array(a7), u11 = 0, g18 = a7;
    for (; g18 > 0; ) {
      let p17 = e7[i10], f11 = Math.min(g18, p17.length);
      d16.set(f11 === p17.length ? p17 : p17.subarray(0, f11), u11), u11 += f11, g18 -= f11, s9(f11);
    }
    return d16;
  }
  return { push: (a7) => {
    if (a7.length === 0) return;
    let c15 = r8 + 1 & t6;
    if (c15 === i10) {
      let l8 = e7.length, d16 = l8 * 2, u11 = new Array(d16), g18 = r8 - i10 + l8 & l8 - 1;
      if (i10 < r8) for (let p17 = 0; p17 < g18; p17++) u11[p17] = e7[i10 + p17];
      else if (g18 > 0) {
        let p17 = l8 - i10;
        for (let f11 = 0; f11 < p17; f11++) u11[f11] = e7[i10 + f11];
        for (let f11 = 0; f11 < r8; f11++) u11[p17 + f11] = e7[f11];
      }
      e7 = u11, t6 = d16 - 1, i10 = 0, r8 = g18, c15 = r8 + 1 & t6;
    }
    e7[r8] = a7, r8 = c15, n23 += a7.length;
  }, available: () => n23, peek: (a7) => {
    if (n23 < a7) return null;
    if (a7 === 0) return b22;
    let c15 = e7[i10];
    if (c15.length >= a7) return c15.length === a7 ? c15 : c15.subarray(0, a7);
    let l8 = new Uint8Array(a7), d16 = 0, u11 = i10;
    for (; d16 < a7; ) {
      let g18 = e7[u11], p17 = Math.min(a7 - d16, g18.length);
      p17 === g18.length ? l8.set(g18, d16) : l8.set(g18.subarray(0, p17), d16), d16 += p17, u11 = u11 + 1 & t6;
    }
    return l8;
  }, discard: (a7) => {
    if (a7 > n23) throw new Error("Too many bytes consumed");
    if (a7 === 0) return;
    let c15 = a7;
    for (; c15 > 0; ) {
      let l8 = e7[i10], d16 = Math.min(c15, l8.length);
      s9(d16), c15 -= d16;
    }
  }, pull: o9 };
}
function he8(e7 = {}) {
  let t6 = e7.strict ?? false, { available: i10, peek: r8, push: n23, discard: s9, pull: o9 } = Xe4(), a7 = P15, c15 = false, l8 = false, d16 = false, u11 = null, g18 = {}, p17 = {}, f11 = { isEntryActive: () => a7 === v19, isBodyComplete: () => !u11 || u11.remaining === 0, write(h17) {
    if (c15) throw new Error("Archive already ended.");
    n23(h17);
  }, end() {
    c15 = true;
  }, readHeader() {
    if (a7 !== P15) throw new Error("Cannot read header while an entry is active");
    if (!l8) for (; !l8; ) {
      if (i10() < 512) {
        if (c15) {
          if (i10() > 0 && t6) throw O12;
          l8 = true;
          return;
        }
        return null;
      }
      let h17 = r8(512);
      if (ae6(h17)) {
        if (i10() < 512 * 2) {
          if (c15) {
            if (t6) throw O12;
            l8 = true;
            return;
          }
          return null;
        }
        if (ae6(r8(512 * 2).subarray(512))) {
          s9(512 * 2), l8 = true, d16 = true;
          return;
        }
        if (t6) throw new Error("Invalid tar header.");
        s9(512);
        continue;
      }
      let m25;
      try {
        m25 = Le5(h17, t6);
      } catch (w19) {
        if (t6) throw w19;
        s9(512);
        continue;
      }
      let S17 = Ge4(m25.type);
      if (S17) {
        let w19 = m25.size + 511 & -512;
        if (i10() < 512 + w19) {
          if (c15 && t6) throw O12;
          return null;
        }
        s9(512);
        let I18 = S17(o9(w19).subarray(0, m25.size)), Oe6 = m25.type === "pax-global-header" ? g18 : p17;
        for (let re5 in I18) Oe6[re5] = I18[re5];
        continue;
      }
      s9(512);
      let E13 = m25;
      return m25.prefix && (E13.name = `${m25.prefix}/${E13.name}`), se6(E13, g18), se6(E13, p17), p17 = {}, u11 = { header: E13, remaining: E13.size, padding: -E13.size & 511 }, a7 = v19, E13;
    }
  }, streamBody(h17) {
    if (a7 !== v19 || !u11 || u11.remaining === 0) return 0;
    let m25 = Math.min(u11.remaining, i10());
    if (m25 === 0) return 0;
    let S17 = o9(m25, h17);
    return u11.remaining -= S17, S17;
  }, skipPadding() {
    if (a7 !== v19 || !u11) return true;
    if (u11.remaining > 0) throw new Error("Body not fully consumed");
    return i10() < u11.padding ? false : (s9(u11.padding), u11 = null, a7 = P15, true);
  }, skipEntry() {
    if (a7 !== v19 || !u11) return true;
    let h17 = Math.min(u11.remaining, i10());
    return h17 > 0 && (s9(h17), u11.remaining -= h17), u11.remaining > 0 ? false : f11.skipPadding();
  }, validateEOF() {
    if (t6) {
      if (!d16) throw O12;
      if (i10() > 0 && o9(i10()).some((h17) => h17 !== 0)) throw new Error("Invalid EOF.");
    }
  } };
  return f11;
}
function ae6(e7) {
  if (e7.byteOffset % 8 === 0) {
    let t6 = new BigUint64Array(e7.buffer, e7.byteOffset, e7.length / 8);
    for (let i10 = 0; i10 < t6.length; i10++) if (t6[i10] !== 0n) return false;
    return true;
  }
  for (let t6 = 0; t6 < e7.length; t6++) if (e7[t6] !== 0) return false;
  return true;
}
function Se4() {
  return new CompressionStream("gzip");
}
function Ee5() {
  return new DecompressionStream("gzip");
}
function je5() {
  let e7, t6;
  return { readable: new ReadableStream({ start(i10) {
    e7 = i10, t6 = pe6(i10.enqueue.bind(i10), i10.error.bind(i10), i10.close.bind(i10));
  } }), controller: { add(i10) {
    let r8 = z7(i10), n23 = { ...i10 };
    return r8 && (n23.size = 0), t6.add(n23), r8 && t6.endEntry(), new WritableStream({ write(s9) {
      t6.write(s9);
    }, close() {
      r8 || t6.endEntry();
    }, abort(s9) {
      e7.error(s9);
    } });
  }, finalize() {
    t6.finalize();
  }, error(i10) {
    e7.error(i10);
  } } };
}
async function we3(e7) {
  let t6 = [], i10 = e7.getReader(), r8 = 0;
  try {
    for (; ; ) {
      let { done: o9, value: a7 } = await i10.read();
      if (o9) break;
      t6.push(a7), r8 += a7.length;
    }
    let n23 = new Uint8Array(r8), s9 = 0;
    for (let o9 of t6) n23.set(o9, s9), s9 += o9.length;
    return n23;
  } finally {
    i10.releaseLock();
  }
}
function qe3(e7 = {}) {
  let t6 = he8(e7), i10 = null, r8 = false, n23 = (s9) => {
    if (!r8) {
      r8 = true;
      try {
        for (; ; ) if (t6.isEntryActive()) {
          if (i10) {
            if (t6.streamBody((o9) => (i10.enqueue(o9), true)) === 0 && !t6.isBodyComplete()) break;
          } else if (!t6.skipEntry()) break;
          if (t6.isBodyComplete()) {
            try {
              i10?.close();
            } catch {
            }
            if (i10 = null, !t6.skipPadding()) break;
          }
        } else {
          let o9 = t6.readHeader();
          if (o9 == null) break;
          s9.enqueue({ header: o9, body: new ReadableStream({ start(a7) {
            o9.size === 0 ? a7.close() : i10 = a7;
          }, pull: () => n23(s9), cancel() {
            i10 = null, n23(s9);
          } }) });
        }
      } catch (o9) {
        try {
          i10?.error(o9);
        } catch {
        }
        throw i10 = null, o9;
      } finally {
        r8 = false;
      }
    }
  };
  return new TransformStream({ transform(s9, o9) {
    try {
      t6.write(s9), n23(o9);
    } catch (a7) {
      try {
        i10?.error(a7);
      } catch {
      }
      throw a7;
    }
  }, flush(s9) {
    try {
      if (t6.end(), n23(s9), t6.validateEOF(), t6.isEntryActive() && !t6.isBodyComplete()) try {
        i10?.close();
      } catch {
      }
    } catch (o9) {
      try {
        i10?.error(o9);
      } catch {
      }
      throw o9;
    }
  } }, void 0, { highWaterMark: 1 });
}
async function ye4(e7) {
  let { readable: t6, controller: i10 } = je5();
  return await (async () => {
    for (let r8 of e7) {
      let n23 = i10.add(r8.header), s9 = "body" in r8 ? r8.body : r8.data;
      if (!s9) {
        await n23.close();
        continue;
      }
      if (s9 instanceof ReadableStream) await s9.pipeTo(n23);
      else if (s9 instanceof Blob) await s9.stream().pipeTo(n23);
      else try {
        let o9 = await ue8(s9);
        if (o9.length > 0) {
          let a7 = n23.getWriter();
          await a7.write(o9), await a7.close();
        } else await n23.close();
      } catch {
        throw new TypeError(`Unsupported content type for entry "${r8.header.name}".`);
      }
    }
  })().then(() => i10.finalize()).catch((r8) => i10.error(r8)), new Uint8Array(await we3(t6));
}
async function Ae5(e7, t6 = {}) {
  let i10 = e7 instanceof ReadableStream ? e7 : new ReadableStream({ start(s9) {
    s9.enqueue(e7 instanceof Uint8Array ? e7 : new Uint8Array(e7)), s9.close();
  } }), r8 = [], n23 = i10.pipeThrough(qe3(t6));
  for await (let s9 of n23) {
    let o9;
    try {
      o9 = fe8(s9.header, t6);
    } catch (a7) {
      throw await s9.body.cancel(), a7;
    }
    if (o9 === null) {
      await ge6(s9.body);
      continue;
    }
    z7(o9) ? (await ge6(s9.body), r8.push({ header: o9 })) : r8.push({ header: o9, data: await we3(s9.body) });
  }
  return r8;
}
async function Ce3() {
  if ($16) return $16;
  if (Z10) throw Z10;
  try {
    return $16 = await Promise.resolve().then(() => (init_node_liblzma(), node_liblzma_exports)), $16;
  } catch {
    throw Z10 = new Error("xz compression requires node-liblzma which failed to load. Install liblzma-dev (apt) or xz (brew) and reinstall dependencies."), Z10;
  }
}
async function xe6() {
  if (B8) return B8;
  if (D13) throw D13;
  try {
    return B8 = await Promise.resolve().then(() => (init_zstd(), zstd_exports)), B8;
  } catch {
    throw D13 = new Error("zstd compression requires @mongodb-js/zstd which is not installed. Install it with: npm install @mongodb-js/zstd"), D13;
  }
}
function Ye4(e7) {
  let t6 = "file";
  e7.isDirectory ? t6 = "directory" : e7.isSymlink && (t6 = "symlink");
  let i10 = e7.name;
  e7.isDirectory && !i10.endsWith("/") && (i10 += "/");
  let r8;
  e7.content !== void 0 && (typeof e7.content == "string" ? r8 = new TextEncoder().encode(e7.content) : r8 = e7.content);
  let n23 = e7.isDirectory || e7.isSymlink ? 0 : r8?.length ?? 0;
  return { header: { name: i10, mode: e7.mode ?? (e7.isDirectory ? 493 : 420), uid: e7.uid ?? 0, gid: e7.gid ?? 0, size: n23, mtime: e7.mtime ?? /* @__PURE__ */ new Date(), type: t6, linkname: e7.linkTarget ?? "", uname: "user", gname: "user" }, body: r8 };
}
async function C16(e7) {
  let t6 = e7.map(Ye4);
  return ye4(t6);
}
async function Ue3(e7) {
  let t6 = await C16(e7), n23 = new ReadableStream({ start(l8) {
    l8.enqueue(t6), l8.close();
  } }).pipeThrough(Se4()).getReader(), s9 = [];
  for (; ; ) {
    let { done: l8, value: d16 } = await n23.read();
    if (l8) break;
    s9.push(d16);
  }
  let o9 = s9.reduce((l8, d16) => l8 + d16.length, 0), a7 = new Uint8Array(o9), c15 = 0;
  for (let l8 of s9) a7.set(l8, c15), c15 += l8.length;
  return a7;
}
async function _9(e7) {
  if (e7.length > y16) return { entries: [], error: `Archive too large (max ${y16} bytes)` };
  try {
    let t6 = await Ae5(e7), i10 = [];
    for (let r8 of t6) {
      if (i10.length >= _e4) return { entries: i10, error: `Too many entries (max ${_e4})` };
      let n23 = "file";
      switch (r8.header.type) {
        case "directory":
          n23 = "directory";
          break;
        case "symlink":
          n23 = "symlink";
          break;
        case "link":
          n23 = "hardlink";
          break;
        case "file":
          n23 = "file";
          break;
        default:
          n23 = "other";
      }
      i10.push({ name: r8.header.name, mode: r8.header.mode ?? 420, uid: r8.header.uid ?? 0, gid: r8.header.gid ?? 0, size: r8.header.size, mtime: r8.header.mtime ?? /* @__PURE__ */ new Date(), type: n23, linkTarget: r8.header.linkname || void 0, content: r8.data ?? new Uint8Array(0) });
    }
    return { entries: i10 };
  } catch (t6) {
    let i10 = t6 instanceof Error ? t6.message : "Unknown error";
    return { entries: [], error: i10 };
  }
}
async function X8(e7) {
  if (e7.length > y16) return { entries: [], error: `Archive too large (max ${y16} bytes)` };
  try {
    let r8 = new ReadableStream({ start(c15) {
      c15.enqueue(e7), c15.close();
    } }).pipeThrough(Ee5()).getReader(), n23 = [];
    for (; ; ) {
      let { done: c15, value: l8 } = await r8.read();
      if (c15) break;
      n23.push(l8);
    }
    let s9 = n23.reduce((c15, l8) => c15 + l8.length, 0), o9 = new Uint8Array(s9), a7 = 0;
    for (let c15 of n23) o9.set(c15, a7), a7 += c15.length;
    return _9(o9);
  } catch (t6) {
    let i10 = t6 instanceof Error ? t6.message : "Unknown error";
    return { entries: [], error: `Decompression failed: ${i10}` };
  }
}
function j8(e7) {
  return e7.length >= 2 && e7[0] === 31 && e7[1] === 139;
}
function q12(e7) {
  return e7.length >= 3 && e7[0] === 66 && e7[1] === 90 && e7[2] === 104;
}
function Y8(e7) {
  return e7.length >= 6 && e7[0] === 253 && e7[1] === 55 && e7[2] === 122 && e7[3] === 88 && e7[4] === 90 && e7[5] === 0;
}
async function Ve4(e7) {
  let i10 = compressjs_default.Bzip2.decompressFile(Array.from(e7));
  return new Uint8Array(i10);
}
async function Je4(e7) {
  let t6 = compressjs_default.Bzip2, i10 = [];
  return t6.compressFile(Array.from(e7), i10, 9), new Uint8Array(i10);
}
async function Qe4(e7) {
  let i10 = (await Ce3()).unxzSync(Buffer.from(e7));
  return new Uint8Array(i10);
}
async function et5(e7) {
  let i10 = (await Ce3()).xzSync(Buffer.from(e7));
  return new Uint8Array(i10);
}
async function Ie5(e7) {
  let t6 = await C16(e7);
  return Je4(t6);
}
async function Fe4(e7) {
  let t6 = await C16(e7);
  return et5(t6);
}
async function V9(e7) {
  if (e7.length > y16) return { entries: [], error: `Archive too large (max ${y16} bytes)` };
  try {
    let t6 = await Ve4(e7);
    return _9(t6);
  } catch (t6) {
    let i10 = t6 instanceof Error ? t6.message : "Unknown error";
    return { entries: [], error: i10 };
  }
}
async function J11(e7) {
  if (e7.length > y16) return { entries: [], error: `Archive too large (max ${y16} bytes)` };
  try {
    let t6 = await Qe4(e7);
    return _9(t6);
  } catch (t6) {
    let i10 = t6 instanceof Error ? t6.message : "Unknown error";
    return { entries: [], error: i10 };
  }
}
function Q10(e7) {
  return e7.length >= 4 && e7[0] === 40 && e7[1] === 181 && e7[2] === 47 && e7[3] === 253;
}
async function tt4(e7) {
  let i10 = await (await xe6()).compress(Buffer.from(e7), 3);
  return new Uint8Array(i10);
}
async function rt4(e7) {
  let i10 = await (await xe6()).decompress(Buffer.from(e7));
  return new Uint8Array(i10);
}
async function ve5(e7) {
  let t6 = await C16(e7);
  return tt4(t6);
}
async function ee5(e7) {
  if (e7.length > y16) return { entries: [], error: `Archive too large (max ${y16} bytes)` };
  try {
    let t6 = await rt4(e7);
    return _9(t6);
  } catch (t6) {
    let i10 = t6 instanceof Error ? t6.message : "Unknown error";
    return { entries: [], error: i10 };
  }
}
function ze4(e7) {
  let t6 = { create: false, append: false, update: false, extract: false, list: false, file: "", autoCompress: false, gzip: false, bzip2: false, xz: false, zstd: false, verbose: false, toStdout: false, keepOldFiles: false, touch: false, directory: "", preserve: false, strip: 0, exclude: [], filesFrom: "", excludeFrom: "", wildcards: false }, i10 = [], r8 = 0;
  for (; r8 < e7.length; ) {
    let n23 = e7[r8];
    if (n23.startsWith("-") && !n23.startsWith("--") && n23.length > 2) {
      if (/^-\d+$/.test(n23)) {
        i10.push(n23), r8++;
        continue;
      }
      for (let s9 = 1; s9 < n23.length; s9++) {
        let o9 = n23[s9];
        switch (o9) {
          case "c":
            t6.create = true;
            break;
          case "r":
            t6.append = true;
            break;
          case "u":
            t6.update = true;
            break;
          case "x":
            t6.extract = true;
            break;
          case "t":
            t6.list = true;
            break;
          case "a":
            t6.autoCompress = true;
            break;
          case "z":
            t6.gzip = true;
            break;
          case "j":
            t6.bzip2 = true;
            break;
          case "J":
            t6.xz = true;
            break;
          case "v":
            t6.verbose = true;
            break;
          case "O":
            t6.toStdout = true;
            break;
          case "k":
            t6.keepOldFiles = true;
            break;
          case "m":
            t6.touch = true;
            break;
          case "p":
            t6.preserve = true;
            break;
          case "f":
            if (s9 < n23.length - 1) t6.file = n23.substring(s9 + 1), s9 = n23.length;
            else {
              if (r8++, r8 >= e7.length) return { ok: false, error: { stdout: "", stderr: `tar: option requires an argument -- 'f'
`, exitCode: 2 } };
              t6.file = e7[r8];
            }
            break;
          case "C":
            if (s9 < n23.length - 1) t6.directory = n23.substring(s9 + 1), s9 = n23.length;
            else {
              if (r8++, r8 >= e7.length) return { ok: false, error: { stdout: "", stderr: `tar: option requires an argument -- 'C'
`, exitCode: 2 } };
              t6.directory = e7[r8];
            }
            break;
          case "T":
            if (s9 < n23.length - 1) t6.filesFrom = n23.substring(s9 + 1), s9 = n23.length;
            else {
              if (r8++, r8 >= e7.length) return { ok: false, error: { stdout: "", stderr: `tar: option requires an argument -- 'T'
`, exitCode: 2 } };
              t6.filesFrom = e7[r8];
            }
            break;
          case "X":
            if (s9 < n23.length - 1) t6.excludeFrom = n23.substring(s9 + 1), s9 = n23.length;
            else {
              if (r8++, r8 >= e7.length) return { ok: false, error: { stdout: "", stderr: `tar: option requires an argument -- 'X'
`, exitCode: 2 } };
              t6.excludeFrom = e7[r8];
            }
            break;
          default:
            return { ok: false, error: r3("tar", `-${o9}`) };
        }
      }
      r8++;
      continue;
    }
    if (n23 === "-c" || n23 === "--create") t6.create = true;
    else if (n23 === "-r" || n23 === "--append") t6.append = true;
    else if (n23 === "-u" || n23 === "--update") t6.update = true;
    else if (n23 === "-x" || n23 === "--extract" || n23 === "--get") t6.extract = true;
    else if (n23 === "-t" || n23 === "--list") t6.list = true;
    else if (n23 === "-a" || n23 === "--auto-compress") t6.autoCompress = true;
    else if (n23 === "-z" || n23 === "--gzip" || n23 === "--gunzip") t6.gzip = true;
    else if (n23 === "-j" || n23 === "--bzip2") t6.bzip2 = true;
    else if (n23 === "-J" || n23 === "--xz") t6.xz = true;
    else if (n23 === "--zstd") t6.zstd = true;
    else if (n23 === "-v" || n23 === "--verbose") t6.verbose = true;
    else if (n23 === "-O" || n23 === "--to-stdout") t6.toStdout = true;
    else if (n23 === "-k" || n23 === "--keep-old-files") t6.keepOldFiles = true;
    else if (n23 === "-m" || n23 === "--touch") t6.touch = true;
    else if (n23 === "--wildcards") t6.wildcards = true;
    else if (n23 === "-p" || n23 === "--preserve" || n23 === "--preserve-permissions") t6.preserve = true;
    else if (n23 === "-f" || n23 === "--file") {
      if (r8++, r8 >= e7.length) return { ok: false, error: { stdout: "", stderr: `tar: option requires an argument -- 'f'
`, exitCode: 2 } };
      t6.file = e7[r8];
    } else if (n23.startsWith("--file=")) t6.file = n23.substring(7);
    else if (n23 === "-C" || n23 === "--directory") {
      if (r8++, r8 >= e7.length) return { ok: false, error: { stdout: "", stderr: `tar: option requires an argument -- 'C'
`, exitCode: 2 } };
      t6.directory = e7[r8];
    } else if (n23.startsWith("--directory=")) t6.directory = n23.substring(12);
    else if (n23.startsWith("--strip-components=") || n23.startsWith("--strip=")) {
      let s9 = n23.includes("--strip-components=") ? n23.substring(19) : n23.substring(8), o9 = parseInt(s9, 10);
      if (Number.isNaN(o9) || o9 < 0) return { ok: false, error: { stdout: "", stderr: `tar: invalid number for --strip: '${s9}'
`, exitCode: 2 } };
      t6.strip = o9;
    } else if (n23.startsWith("--exclude=")) t6.exclude.push(n23.substring(10));
    else if (n23 === "--exclude") {
      if (r8++, r8 >= e7.length) return { ok: false, error: { stdout: "", stderr: `tar: option '--exclude' requires an argument
`, exitCode: 2 } };
      t6.exclude.push(e7[r8]);
    } else if (n23 === "-T" || n23 === "--files-from") {
      if (r8++, r8 >= e7.length) return { ok: false, error: { stdout: "", stderr: `tar: option requires an argument -- 'T'
`, exitCode: 2 } };
      t6.filesFrom = e7[r8];
    } else if (n23.startsWith("--files-from=")) t6.filesFrom = n23.substring(13);
    else if (n23 === "-X" || n23 === "--exclude-from") {
      if (r8++, r8 >= e7.length) return { ok: false, error: { stdout: "", stderr: `tar: option requires an argument -- 'X'
`, exitCode: 2 } };
      t6.excludeFrom = e7[r8];
    } else if (n23.startsWith("--exclude-from=")) t6.excludeFrom = n23.substring(15);
    else if (n23 === "--") {
      i10.push(...e7.slice(r8 + 1));
      break;
    } else {
      if (n23.startsWith("-")) return { ok: false, error: r3("tar", n23) };
      i10.push(n23);
    }
    r8++;
  }
  return { ok: true, options: t6, files: i10 };
}
function te7(e7, t6) {
  let i10 = e7.includes("/") ? e7.substring(e7.lastIndexOf("/") + 1) : e7;
  for (let r8 of t6) {
    let n23 = r8.replace(/[.+^${}()|[\]\\]/g, "\\$&").replace(/\*\*/g, "<<<GLOBSTAR>>>").replace(/\*/g, "[^/]*").replace(/<<<GLOBSTAR>>>/g, ".*").replace(/\?/g, ".");
    if (b1(`^${n23}$`).test(e7) || b1(`^${n23}/`).test(e7) || !r8.includes("/") && b1(`^${n23}$`).test(i10)) return true;
  }
  return false;
}
function N13(e7, t6) {
  let i10 = t6.replace(/[.+^${}()|[\]\\]/g, "\\$&").replace(/\*\*/g, "<<<GLOBSTAR>>>").replace(/\*/g, "[^/]*").replace(/<<<GLOBSTAR>>>/g, ".*").replace(/\?/g, "."), r8 = e7.includes("/") ? e7.substring(e7.lastIndexOf("/") + 1) : e7;
  return b1(`^${i10}$`).test(e7) || b1(`^${i10}$`).test(r8);
}
function Re5(e7, t6) {
  if (t6 <= 0) return e7;
  let i10 = e7.split("/").filter((r8) => r8 !== "");
  return i10.length <= t6 ? "" : i10.slice(t6).join("/");
}
function it4(e7, t6) {
  let i10 = t6 ? "d" : "-", r8 = [e7 & 256 ? "r" : "-", e7 & 128 ? "w" : "-", e7 & 64 ? "x" : "-", e7 & 32 ? "r" : "-", e7 & 16 ? "w" : "-", e7 & 8 ? "x" : "-", e7 & 4 ? "r" : "-", e7 & 2 ? "w" : "-", e7 & 1 ? "x" : "-"].join("");
  return i10 + r8;
}
function st5(e7) {
  let i10 = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"][e7.getMonth()], r8 = e7.getDate().toString().padStart(2, " "), n23 = e7.getHours().toString().padStart(2, "0"), s9 = e7.getMinutes().toString().padStart(2, "0");
  return `${i10} ${r8} ${n23}:${s9}`;
}
async function L15(e7, t6, i10, r8) {
  let n23 = [], s9 = [], o9 = e7.fs.resolvePath(t6, i10);
  try {
    let a7 = await e7.fs.stat(o9);
    if (te7(i10, r8)) return { entries: n23, errors: s9 };
    if (a7.isDirectory) {
      n23.push({ name: i10, isDirectory: true, mode: a7.mode, mtime: a7.mtime });
      let c15 = await e7.fs.readdir(o9);
      for (let l8 = 0; l8 < c15.length; l8 += ke4) {
        let d16 = c15.slice(l8, l8 + ke4), u11 = await Promise.all(d16.map((g18) => L15(e7, t6, i10 ? `${i10}/${g18}` : g18, r8)));
        for (let g18 of u11) n23.push(...g18.entries), s9.push(...g18.errors);
      }
    } else if (a7.isFile) {
      let c15 = await e7.fs.readFileBuffer(o9);
      n23.push({ name: i10, content: c15, mode: a7.mode, mtime: a7.mtime });
    } else if (a7.isSymbolicLink) {
      let c15 = await e7.fs.readlink(o9);
      n23.push({ name: i10, isSymlink: true, linkTarget: c15, mode: a7.mode, mtime: a7.mtime });
    }
  } catch (a7) {
    let c15 = a7 instanceof Error ? a7.message : "unknown error";
    s9.push(`tar: ${i10}: ${c15}`);
  }
  return { entries: n23, errors: s9 };
}
async function at4(e7, t6, i10) {
  if (i10.length === 0) return { stdout: "", stderr: `tar: Cowardly refusing to create an empty archive
`, exitCode: 2 };
  let r8 = t6.directory ? e7.fs.resolvePath(e7.cwd, t6.directory) : e7.cwd, n23 = [], s9 = [], o9 = "";
  for (let d16 of i10) {
    let { entries: u11, errors: g18 } = await L15(e7, r8, d16, t6.exclude);
    if (n23.push(...u11), s9.push(...g18), t6.verbose) for (let p17 of u11) o9 += `${p17.name}${p17.isDirectory ? "/" : ""}
`;
  }
  if (n23.length === 0 && s9.length > 0) return { stdout: "", stderr: `${s9.join(`
`)}
`, exitCode: 2 };
  let a7;
  try {
    t6.gzip ? a7 = await Ue3(n23) : t6.bzip2 ? a7 = await Ie5(n23) : t6.xz ? a7 = await Fe4(n23) : t6.zstd ? a7 = await ve5(n23) : a7 = await C16(n23);
  } catch (d16) {
    return { stdout: "", stderr: `tar: error creating archive: ${d16 instanceof Error ? d16.message : "unknown error"}
`, exitCode: 2 };
  }
  let c15 = "";
  if (t6.file && t6.file !== "-") {
    let d16 = e7.fs.resolvePath(e7.cwd, t6.file);
    try {
      await e7.fs.writeFile(d16, a7);
    } catch (u11) {
      let g18 = u11 instanceof Error ? u11.message : "unknown error";
      return { stdout: "", stderr: `tar: ${t6.file}: ${g18}
`, exitCode: 2 };
    }
  } else c15 = String.fromCharCode(...a7);
  let l8 = o9;
  return s9.length > 0 && (l8 += `${s9.join(`
`)}
`), { stdout: c15, stderr: l8, exitCode: s9.length > 0 ? 2 : 0 };
}
async function ot4(e7, t6, i10) {
  if (!t6.file || t6.file === "-") return { stdout: "", stderr: `tar: Cannot append to stdin/stdout
`, exitCode: 2 };
  if (i10.length === 0) return { stdout: "", stderr: `tar: Cowardly refusing to append nothing to archive
`, exitCode: 2 };
  let r8 = e7.fs.resolvePath(e7.cwd, t6.file), n23;
  try {
    n23 = await e7.fs.readFileBuffer(r8);
  } catch {
    return { stdout: "", stderr: `tar: ${t6.file}: Cannot open: No such file or directory
`, exitCode: 2 };
  }
  let s9 = await _9(n23);
  if (s9.error) return { stdout: "", stderr: `tar: ${s9.error}
`, exitCode: 2 };
  let o9 = s9.entries.map((f11) => ({ name: f11.name, content: f11.content, mode: f11.mode, mtime: f11.mtime, isDirectory: f11.type === "directory", isSymlink: f11.type === "symlink", linkTarget: f11.linkTarget, uid: f11.uid, gid: f11.gid })), a7 = t6.directory ? e7.fs.resolvePath(e7.cwd, t6.directory) : e7.cwd, c15 = [], l8 = [], d16 = "";
  for (let f11 of i10) {
    let { entries: h17, errors: m25 } = await L15(e7, a7, f11, t6.exclude);
    if (c15.push(...h17), l8.push(...m25), t6.verbose) for (let S17 of h17) d16 += `${S17.name}${S17.isDirectory ? "/" : ""}
`;
  }
  let u11 = [...o9, ...c15], g18;
  try {
    g18 = await C16(u11);
  } catch (f11) {
    return { stdout: "", stderr: `tar: error creating archive: ${f11 instanceof Error ? f11.message : "unknown error"}
`, exitCode: 2 };
  }
  try {
    await e7.fs.writeFile(r8, g18);
  } catch (f11) {
    let h17 = f11 instanceof Error ? f11.message : "unknown error";
    return { stdout: "", stderr: `tar: ${t6.file}: ${h17}
`, exitCode: 2 };
  }
  let p17 = d16;
  return l8.length > 0 && (p17 += `${l8.join(`
`)}
`), { stdout: "", stderr: p17, exitCode: l8.length > 0 ? 2 : 0 };
}
async function ct4(e7, t6, i10) {
  if (!t6.file || t6.file === "-") return { stdout: "", stderr: `tar: Cannot update stdin/stdout
`, exitCode: 2 };
  if (i10.length === 0) return { stdout: "", stderr: `tar: Cowardly refusing to update with nothing
`, exitCode: 2 };
  let r8 = e7.fs.resolvePath(e7.cwd, t6.file), n23;
  try {
    n23 = await e7.fs.readFileBuffer(r8);
  } catch {
    return { stdout: "", stderr: `tar: ${t6.file}: Cannot open: No such file or directory
`, exitCode: 2 };
  }
  let s9 = await _9(n23);
  if (s9.error) return { stdout: "", stderr: `tar: ${s9.error}
`, exitCode: 2 };
  let o9 = /* @__PURE__ */ new Map();
  for (let m25 of s9.entries) o9.set(m25.name, m25.mtime);
  let a7 = t6.directory ? e7.fs.resolvePath(e7.cwd, t6.directory) : e7.cwd, c15 = [], l8 = [], d16 = "";
  for (let m25 of i10) {
    let { entries: S17, errors: E13 } = await L15(e7, a7, m25, t6.exclude);
    l8.push(...E13);
    for (let w19 of S17) {
      let I18 = o9.get(w19.name);
      (!I18 || w19.mtime && w19.mtime.getTime() > I18.getTime()) && (c15.push(w19), t6.verbose && (d16 += `${w19.name}${w19.isDirectory ? "/" : ""}
`));
    }
  }
  if (c15.length === 0) {
    let m25 = "";
    return l8.length > 0 && (m25 = `${l8.join(`
`)}
`), { stdout: "", stderr: m25, exitCode: l8.length > 0 ? 2 : 0 };
  }
  let u11 = new Set(c15.map((m25) => m25.name)), p17 = [...s9.entries.filter((m25) => !u11.has(m25.name)).map((m25) => ({ name: m25.name, content: m25.content, mode: m25.mode, mtime: m25.mtime, isDirectory: m25.type === "directory", isSymlink: m25.type === "symlink", linkTarget: m25.linkTarget, uid: m25.uid, gid: m25.gid })), ...c15], f11;
  try {
    f11 = await C16(p17);
  } catch (m25) {
    return { stdout: "", stderr: `tar: error creating archive: ${m25 instanceof Error ? m25.message : "unknown error"}
`, exitCode: 2 };
  }
  try {
    await e7.fs.writeFile(r8, f11);
  } catch (m25) {
    let S17 = m25 instanceof Error ? m25.message : "unknown error";
    return { stdout: "", stderr: `tar: ${t6.file}: ${S17}
`, exitCode: 2 };
  }
  let h17 = d16;
  return l8.length > 0 && (h17 += `${l8.join(`
`)}
`), { stdout: "", stderr: h17, exitCode: l8.length > 0 ? 2 : 0 };
}
async function lt5(e7, t6, i10) {
  let r8;
  if (t6.file && t6.file !== "-") {
    let f11 = e7.fs.resolvePath(e7.cwd, t6.file);
    try {
      r8 = await e7.fs.readFileBuffer(f11);
    } catch {
      return { stdout: "", stderr: `tar: ${t6.file}: Cannot open: No such file or directory
`, exitCode: 2 };
    }
  } else r8 = Uint8Array.from(e7.stdin, (f11) => f11.charCodeAt(0));
  let n23, s9 = t6.gzip || j8(r8), o9 = t6.bzip2 || q12(r8), a7 = t6.xz || Y8(r8), c15 = t6.zstd || Q10(r8);
  if (s9 ? n23 = await X8(r8) : o9 ? n23 = await V9(r8) : a7 ? n23 = await J11(r8) : c15 ? n23 = await ee5(r8) : n23 = await _9(r8), n23.error) return { stdout: "", stderr: `tar: ${n23.error}
`, exitCode: 2 };
  let l8 = t6.directory ? e7.fs.resolvePath(e7.cwd, t6.directory) : e7.cwd, d16 = "", u11 = "", g18 = [];
  if (t6.directory && !t6.toStdout) try {
    await e7.fs.mkdir(l8, { recursive: true });
  } catch {
  }
  for (let f11 of n23.entries) {
    let h17 = Re5(f11.name, t6.strip);
    if (!h17) continue;
    let m25 = h17.endsWith("/") ? h17.slice(0, -1) : h17;
    if (i10.length > 0) {
      let E13;
      if (t6.wildcards ? E13 = i10.some((w19) => N13(h17, w19) || N13(m25, w19) || h17.startsWith(`${w19}/`)) : E13 = i10.some((w19) => h17 === w19 || h17.startsWith(`${w19}/`) || m25 === w19), !E13) continue;
    }
    if (te7(h17, t6.exclude)) continue;
    let S17 = e7.fs.resolvePath(l8, h17);
    try {
      if (f11.type === "directory") {
        if (t6.toStdout) continue;
        await e7.fs.mkdir(S17, { recursive: true }), t6.verbose && (d16 += `${h17}
`);
      } else if (f11.type === "file") {
        if (t6.toStdout) {
          u11 += new TextDecoder().decode(f11.content), t6.verbose && (d16 += `${h17}
`);
          continue;
        }
        if (t6.keepOldFiles) try {
          await e7.fs.stat(S17), t6.verbose && (d16 += `${h17}: not overwritten, file exists
`);
          continue;
        } catch {
        }
        let E13 = S17.substring(0, S17.lastIndexOf("/"));
        if (E13) try {
          await e7.fs.mkdir(E13, { recursive: true });
        } catch {
        }
        if (await e7.fs.writeFile(S17, f11.content), t6.preserve && f11.mode) try {
          await e7.fs.chmod(S17, f11.mode);
        } catch {
        }
        t6.verbose && (d16 += `${h17}
`);
      } else if (f11.type === "symlink" && f11.linkTarget) {
        if (t6.toStdout) continue;
        if (t6.keepOldFiles) try {
          await e7.fs.stat(S17), t6.verbose && (d16 += `${h17}: not overwritten, file exists
`);
          continue;
        } catch {
        }
        let E13 = S17.substring(0, S17.lastIndexOf("/"));
        if (E13) try {
          await e7.fs.mkdir(E13, { recursive: true });
        } catch {
        }
        try {
          await e7.fs.symlink(f11.linkTarget, S17);
        } catch {
        }
        t6.verbose && (d16 += `${h17}
`);
      }
    } catch (E13) {
      let w19 = E13 instanceof Error ? E13.message : "unknown error";
      g18.push(`tar: ${h17}: ${w19}`);
    }
  }
  let p17 = d16;
  return g18.length > 0 && (p17 += `${g18.join(`
`)}
`), { stdout: u11, stderr: p17, exitCode: g18.length > 0 ? 2 : 0 };
}
async function ut4(e7, t6, i10) {
  let r8;
  if (t6.file && t6.file !== "-") {
    let d16 = e7.fs.resolvePath(e7.cwd, t6.file);
    try {
      r8 = await e7.fs.readFileBuffer(d16);
    } catch {
      return { stdout: "", stderr: `tar: ${t6.file}: Cannot open: No such file or directory
`, exitCode: 2 };
    }
  } else r8 = Uint8Array.from(e7.stdin, (d16) => d16.charCodeAt(0));
  let n23, s9 = t6.gzip || j8(r8), o9 = t6.bzip2 || q12(r8), a7 = t6.xz || Y8(r8), c15 = t6.zstd || Q10(r8);
  if (s9 ? n23 = await X8(r8) : o9 ? n23 = await V9(r8) : a7 ? n23 = await J11(r8) : c15 ? n23 = await ee5(r8) : n23 = await _9(r8), n23.error) return { stdout: "", stderr: `tar: ${n23.error}
`, exitCode: 2 };
  let l8 = "";
  for (let d16 of n23.entries) {
    let u11 = Re5(d16.name, t6.strip);
    if (!u11) continue;
    let g18 = u11.endsWith("/") ? u11.slice(0, -1) : u11;
    if (i10.length > 0) {
      let p17;
      if (t6.wildcards ? p17 = i10.some((f11) => N13(u11, f11) || N13(g18, f11) || u11.startsWith(`${f11}/`)) : p17 = i10.some((f11) => u11 === f11 || u11.startsWith(`${f11}/`) || g18 === f11), !p17) continue;
    }
    if (!te7(u11, t6.exclude)) if (t6.verbose) {
      let p17 = d16.type === "directory", f11 = it4(d16.mode, p17), h17 = `${d16.uid}/${d16.gid}`, m25 = d16.size.toString().padStart(8, " "), S17 = st5(d16.mtime), E13 = `${f11} ${h17.padEnd(10)} ${m25} ${S17} ${u11}`;
      d16.type === "symlink" && d16.linkTarget && (E13 += ` -> ${d16.linkTarget}`), l8 += `${E13}
`;
    } else l8 += `${u11}
`;
  }
  return { stdout: l8, stderr: "", exitCode: 0 };
}
var H14, oe6, ce6, M11, be4, Me4, $e4, b22, U12, le6, z7, G6, Ze5, Ke4, We4, R7, P15, v19, O12, ge6, $16, Z10, B8, D13, y16, _e4, ke4, nt5, Tt4, Ct4;
var init_chunk_VZWXH2PZ = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-VZWXH2PZ.js"() {
    init_chunk_YNYSPYQ5();
    init_chunk_74CEPOFO();
    init_compressjs();
    H14 = "file";
    oe6 = "link";
    ce6 = "symlink";
    M11 = "directory";
    be4 = { file: "0", link: "1", symlink: "2", "character-device": "3", "block-device": "4", directory: "5", fifo: "6", "pax-header": "x", "pax-global-header": "g", "gnu-long-name": "L", "gnu-long-link-name": "K" };
    Me4 = { 0: H14, 1: oe6, 2: ce6, 3: "character-device", 4: "block-device", 5: M11, 6: "fifo", x: "pax-header", g: "pax-global-header", L: "gnu-long-name", K: "gnu-long-link-name" };
    $e4 = new Uint8Array(512);
    b22 = new Uint8Array(0);
    U12 = new TextEncoder();
    le6 = new TextDecoder();
    z7 = (e7) => e7.type === M11 || e7.type === ce6 || e7.type === oe6;
    G6 = 32;
    Ze5 = 48;
    Ke4 = { path: ["name", (e7) => e7], linkpath: ["linkname", (e7) => e7], size: ["size", (e7) => parseInt(e7, 10)], mtime: ["mtime", parseFloat], uid: ["uid", (e7) => parseInt(e7, 10)], gid: ["gid", (e7) => parseInt(e7, 10)], uname: ["uname", (e7) => e7], gname: ["gname", (e7) => e7] };
    We4 = new Uint8Array(512 * 2);
    R7 = 256;
    P15 = 0;
    v19 = 1;
    O12 = new Error("Tar archive is truncated.");
    ge6 = (e7) => e7.pipeTo(new WritableStream());
    $16 = null;
    Z10 = null;
    B8 = null;
    D13 = null;
    y16 = 100 * 1024 * 1024;
    _e4 = 1e4;
    ke4 = 100;
    nt5 = { name: "tar", summary: "manipulate tape archives", usage: "tar [options] [file...]", description: ["Create, extract, or list contents of tar archives.", "", "One of -c, -r, -u, -x, or -t is required to specify the operation."], options: ["-c, --create           create a new archive", "-r, --append           append files to the end of an archive", "-u, --update           only append files newer than copy in archive", "-x, --extract          extract files from an archive", "-t, --list             list contents of an archive", "-f, --file=ARCHIVE     use archive file ARCHIVE", "-a, --auto-compress    use archive suffix to determine compression", "-z, --gzip             filter archive through gzip", "-j, --bzip2            filter archive through bzip2", "-J, --xz               filter archive through xz", "--zstd                 filter archive through zstd", "-v, --verbose          verbosely list files processed", "-O, --to-stdout        extract files to standard output", "-k, --keep-old-files   don't replace existing files when extracting", "-m, --touch            don't extract file modified time", "-C, --directory=DIR    change to directory DIR before performing operations", "-p, --preserve         preserve permissions", "-T, --files-from=FILE  read files to extract/create from FILE", "-X, --exclude-from=FILE read exclude patterns from FILE", "--strip=N              strip N leading path components on extraction", "--exclude=PATTERN      exclude files matching PATTERN", "--wildcards            use wildcards for pattern matching", "    --help             display this help and exit"], examples: ["tar -cvf archive.tar file1 file2     Create archive from files", "tar -czvf archive.tar.gz dir/        Create gzip-compressed archive", "tar -cjvf archive.tar.bz2 dir/       Create bzip2-compressed archive", "tar -rf archive.tar newfile.txt      Append file to archive", "tar -uf archive.tar dir/             Update archive with newer files", "tar -xvf archive.tar                 Extract archive", "tar -xvf archive.tar -C /tmp         Extract to /tmp", "tar -tvf archive.tar                 List archive contents", "tar -xzf archive.tar.gz              Extract gzip archive", "tar -xf archive.tar file1.txt        Extract specific file", "tar -xOf archive.tar file.txt        Extract file to stdout", "tar -xf archive.tar --wildcards '*.txt'  Extract matching files"] };
    Tt4 = { name: "tar", async execute(e7, t6) {
      if (o2(e7)) return s(nt5);
      let i10 = ze4(e7);
      if (!i10.ok) return i10.error;
      let { options: r8, files: n23 } = i10, s9 = [r8.create, r8.append, r8.update, r8.extract, r8.list].filter(Boolean).length;
      if (s9 === 0) return { stdout: "", stderr: `tar: You must specify one of -c, -r, -u, -x, or -t
`, exitCode: 2 };
      if (s9 > 1) return { stdout: "", stderr: `tar: You may not specify more than one of -c, -r, -u, -x, or -t
`, exitCode: 2 };
      if (r8.autoCompress && r8.file && r8.create) {
        let c15 = r8.file.toLowerCase();
        c15.endsWith(".tar.gz") || c15.endsWith(".tgz") ? r8.gzip = true : c15.endsWith(".tar.bz2") || c15.endsWith(".tbz2") ? r8.bzip2 = true : c15.endsWith(".tar.xz") || c15.endsWith(".txz") ? r8.xz = true : (c15.endsWith(".tar.zst") || c15.endsWith(".tzst")) && (r8.zstd = true);
      }
      let o9 = [r8.gzip, r8.bzip2, r8.xz, r8.zstd].filter(Boolean).length;
      if (o9 > 1) return { stdout: "", stderr: `tar: You may not specify more than one compression option
`, exitCode: 2 };
      if ((r8.append || r8.update) && o9 > 0) return { stdout: "", stderr: `tar: Cannot append/update compressed archives - decompress first
`, exitCode: 2 };
      let a7 = n23;
      if (r8.filesFrom) {
        let c15 = t6.fs.resolvePath(t6.cwd, r8.filesFrom);
        try {
          let d16 = (await t6.fs.readFile(c15)).split(`
`).map((u11) => u11.trim()).filter((u11) => u11.length > 0 && !u11.startsWith("#"));
          a7 = [...n23, ...d16];
        } catch {
          return { stdout: "", stderr: `tar: ${r8.filesFrom}: Cannot open: No such file or directory
`, exitCode: 2 };
        }
      }
      if (r8.excludeFrom) {
        let c15 = t6.fs.resolvePath(t6.cwd, r8.excludeFrom);
        try {
          let d16 = (await t6.fs.readFile(c15)).split(`
`).map((u11) => u11.trim()).filter((u11) => u11.length > 0 && !u11.startsWith("#"));
          r8.exclude.push(...d16);
        } catch {
          return { stdout: "", stderr: `tar: ${r8.excludeFrom}: Cannot open: No such file or directory
`, exitCode: 2 };
        }
      }
      return r8.create ? at4(t6, r8, a7) : r8.append ? ot4(t6, r8, a7) : r8.update ? ct4(t6, r8, a7) : r8.extract ? lt5(t6, r8, a7) : ut4(t6, r8, a7);
    } };
    Ct4 = { name: "tar", flags: [{ flag: "-c", type: "boolean" }, { flag: "-x", type: "boolean" }, { flag: "-t", type: "boolean" }, { flag: "-f", type: "value", valueHint: "path" }, { flag: "-z", type: "boolean" }, { flag: "-j", type: "boolean" }, { flag: "-v", type: "boolean" }, { flag: "-C", type: "value", valueHint: "path" }, { flag: "--strip-components", type: "value", valueHint: "number" }, { flag: "--exclude", type: "value", valueHint: "pattern" }], needsArgs: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/tar-K7K7BL55.js
var tar_K7K7BL55_exports = {};
__export(tar_K7K7BL55_exports, {
  flagsForFuzzing: () => Ct4,
  tarCommand: () => Tt4
});
var init_tar_K7K7BL55 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/tar-K7K7BL55.js"() {
    init_chunk_VZWXH2PZ();
    init_chunk_YNYSPYQ5();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-SYMJJMQ4.js
var xe7;
var init_chunk_SYMJJMQ4 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-SYMJJMQ4.js"() {
    init_chunk_DXB73IDG();
    xe7 = o((de10, pe8) => {
      (function(oe9, R13) {
        typeof define == "function" && define.amd ? define([], R13) : typeof pe8 == "object" && typeof de10 < "u" ? pe8.exports = R13() : oe9.Papa = R13();
      })(de10, function oe9() {
        "use strict";
        var R13 = /* @__PURE__ */ function() {
          return typeof self < "u" ? self : typeof window < "u" ? window : typeof R13 < "u" ? R13 : {};
        }();
        function _e7() {
          var e7 = R13.URL || R13.webkitURL || null, t6 = oe9.toString();
          return l8.BLOB_URL || (l8.BLOB_URL = e7.createObjectURL(new Blob(["var global = (function() { if (typeof self !== 'undefined') { return self; } if (typeof window !== 'undefined') { return window; } if (typeof global !== 'undefined') { return global; } return {}; })(); global.IS_PAPA_WORKER=true; ", "(", t6, ")();"], { type: "text/javascript" })));
        }
        var Y11 = !R13.document && !!R13.postMessage, ue11 = R13.IS_PAPA_WORKER || false, ae8 = {}, ge8 = 0, l8 = {};
        if (l8.parse = Ce6, l8.unparse = Re8, l8.RECORD_SEP = "", l8.UNIT_SEP = "", l8.BYTE_ORDER_MARK = "\uFEFF", l8.BAD_DELIMITERS = ["\r", `
`, '"', l8.BYTE_ORDER_MARK], l8.WORKERS_SUPPORTED = !Y11 && !!R13.Worker, l8.NODE_STREAM_INPUT = 1, l8.LocalChunkSize = 1024 * 1024 * 10, l8.RemoteChunkSize = 1024 * 1024 * 5, l8.DefaultDelimiter = ",", l8.Parser = fe10, l8.ParserHandle = ce10, l8.NetworkStreamer = G9, l8.FileStreamer = ee7, l8.StringStreamer = Z13, l8.ReadableStreamStreamer = te10, typeof PAPA_BROWSER_CONTEXT > "u" && (l8.DuplexStreamStreamer = re5), R13.jQuery) {
          var V13 = R13.jQuery;
          V13.fn.parse = function(e7) {
            var t6 = e7.config || {}, r8 = [];
            return this.each(function(h17) {
              var i10 = V13(this).prop("tagName").toUpperCase() === "INPUT" && V13(this).attr("type").toLowerCase() === "file" && R13.FileReader;
              if (!i10 || !this.files || this.files.length === 0) return true;
              for (var y18 = 0; y18 < this.files.length; y18++) r8.push({ file: this.files[y18], inputElem: this, instanceConfig: V13.extend({}, t6) });
            }), s9(), this;
            function s9() {
              if (r8.length === 0) {
                g18(e7.complete) && e7.complete();
                return;
              }
              var h17 = r8[0];
              if (g18(e7.before)) {
                var i10 = e7.before(h17.file, h17.inputElem);
                if (typeof i10 == "object") if (i10.action === "abort") {
                  n23("AbortError", h17.file, h17.inputElem, i10.reason);
                  return;
                } else if (i10.action === "skip") {
                  p17();
                  return;
                } else typeof i10.config == "object" && (h17.instanceConfig = V13.extend(h17.instanceConfig, i10.config));
                else if (i10 === "skip") {
                  p17();
                  return;
                }
              }
              var y18 = h17.instanceConfig.complete;
              h17.instanceConfig.complete = function(E13) {
                g18(y18) && y18(E13, h17.file, h17.inputElem), p17();
              }, l8.parse(h17.file, h17.instanceConfig);
            }
            function n23(h17, i10, y18, E13) {
              g18(e7.error) && e7.error({ name: h17 }, i10, y18, E13);
            }
            function p17() {
              r8.splice(0, 1), s9();
            }
          };
        }
        ue11 && (R13.onmessage = Se6);
        function Ce6(e7, t6) {
          t6 = t6 || {};
          var r8 = t6.dynamicTyping || false;
          if (g18(r8) && (t6.dynamicTypingFunction = r8, r8 = {}), t6.dynamicTyping = r8, t6.transform = g18(t6.transform) ? t6.transform : false, t6.worker && l8.WORKERS_SUPPORTED) {
            var s9 = Ee7();
            s9.userStep = t6.step, s9.userChunk = t6.chunk, s9.userComplete = t6.complete, s9.userError = t6.error, t6.step = g18(t6.step), t6.chunk = g18(t6.chunk), t6.complete = g18(t6.complete), t6.error = g18(t6.error), delete t6.worker, s9.postMessage({ input: e7, config: t6, workerId: s9.id });
            return;
          }
          var n23 = null;
          if (e7 === l8.NODE_STREAM_INPUT && typeof PAPA_BROWSER_CONTEXT > "u") return n23 = new re5(t6), n23.getStream();
          return typeof e7 == "string" ? (e7 = p17(e7), t6.download ? n23 = new G9(t6) : n23 = new Z13(t6)) : e7.readable === true && g18(e7.read) && g18(e7.on) ? n23 = new te10(t6) : (R13.File && e7 instanceof File || e7 instanceof Object) && (n23 = new ee7(t6)), n23.stream(e7);
          function p17(h17) {
            return h17.charCodeAt(0) === 65279 ? h17.slice(1) : h17;
          }
        }
        function Re8(e7, t6) {
          var r8 = false, s9 = true, n23 = ",", p17 = `\r
`, h17 = '"', i10 = h17 + h17, y18 = false, E13 = null, O17 = false;
          L18();
          var d16 = new RegExp(se9(h17), "g");
          if (typeof e7 == "string" && (e7 = JSON.parse(e7)), Array.isArray(e7)) {
            if (!e7.length || Array.isArray(e7[0])) return u11(null, e7, y18);
            if (typeof e7[0] == "object") return u11(E13 || Object.keys(e7[0]), e7, y18);
          } else if (typeof e7 == "object") return typeof e7.data == "string" && (e7.data = JSON.parse(e7.data)), Array.isArray(e7.data) && (e7.fields || (e7.fields = e7.meta && e7.meta.fields || E13), e7.fields || (e7.fields = Array.isArray(e7.data[0]) ? e7.fields : typeof e7.data[0] == "object" ? Object.keys(e7.data[0]) : []), !Array.isArray(e7.data[0]) && typeof e7.data[0] != "object" && (e7.data = [e7.data])), u11(e7.fields || [], e7.data || [], y18);
          throw new Error("Unable to serialize unrecognized input");
          function L18() {
            if (typeof t6 == "object") {
              if (typeof t6.delimiter == "string" && !l8.BAD_DELIMITERS.filter(function(v21) {
                return t6.delimiter.indexOf(v21) !== -1;
              }).length && (n23 = t6.delimiter), (typeof t6.quotes == "boolean" || typeof t6.quotes == "function" || Array.isArray(t6.quotes)) && (r8 = t6.quotes), (typeof t6.skipEmptyLines == "boolean" || typeof t6.skipEmptyLines == "string") && (y18 = t6.skipEmptyLines), typeof t6.newline == "string" && (p17 = t6.newline), typeof t6.quoteChar == "string" && (h17 = t6.quoteChar), typeof t6.header == "boolean" && (s9 = t6.header), Array.isArray(t6.columns)) {
                if (t6.columns.length === 0) throw new Error("Option columns is empty");
                E13 = t6.columns;
              }
              t6.escapeChar !== void 0 && (i10 = t6.escapeChar + h17), t6.escapeFormulae instanceof RegExp ? O17 = t6.escapeFormulae : typeof t6.escapeFormulae == "boolean" && t6.escapeFormulae && (O17 = /^[=+\-@\t\r].*$/);
            }
          }
          function u11(v21, k17, S17) {
            var w19 = "";
            typeof v21 == "string" && (v21 = JSON.parse(v21)), typeof k17 == "string" && (k17 = JSON.parse(k17));
            var M15 = Array.isArray(v21) && v21.length > 0, T10 = !Array.isArray(k17[0]);
            if (M15 && s9) {
              for (var q17 = 0; q17 < v21.length; q17++) q17 > 0 && (w19 += n23), w19 += c15(v21[q17], q17);
              k17.length > 0 && (w19 += p17);
            }
            for (var _15 = 0; _15 < k17.length; _15++) {
              var j12 = M15 ? v21.length : k17[_15].length, W15 = false, o9 = M15 ? Object.keys(k17[_15]).length === 0 : k17[_15].length === 0;
              if (S17 && !M15 && (W15 = S17 === "greedy" ? k17[_15].join("").trim() === "" : k17[_15].length === 1 && k17[_15][0].length === 0), S17 === "greedy" && M15) {
                for (var f11 = [], m25 = 0; m25 < j12; m25++) {
                  var b25 = T10 ? v21[m25] : m25;
                  f11.push(k17[_15][b25]);
                }
                W15 = f11.join("").trim() === "";
              }
              if (!W15) {
                for (var a7 = 0; a7 < j12; a7++) {
                  a7 > 0 && !o9 && (w19 += n23);
                  var C19 = M15 && T10 ? v21[a7] : a7;
                  w19 += c15(k17[_15][C19], a7);
                }
                _15 < k17.length - 1 && (!S17 || j12 > 0 && !o9) && (w19 += p17);
              }
            }
            return w19;
          }
          function c15(v21, k17) {
            if (typeof v21 > "u" || v21 === null) return "";
            if (v21.constructor === Date) return JSON.stringify(v21).slice(1, 25);
            var S17 = false;
            O17 && typeof v21 == "string" && O17.test(v21) && (v21 = "'" + v21, S17 = true);
            var w19 = v21.toString().replace(d16, i10);
            return S17 = S17 || r8 === true || typeof r8 == "function" && r8(v21, k17) || Array.isArray(r8) && r8[k17] || Q13(w19, l8.BAD_DELIMITERS) || w19.indexOf(n23) > -1 || w19.charAt(0) === " " || w19.charAt(w19.length - 1) === " ", S17 ? h17 + w19 + h17 : w19;
          }
          function Q13(v21, k17) {
            for (var S17 = 0; S17 < k17.length; S17++) if (v21.indexOf(k17[S17]) > -1) return true;
            return false;
          }
        }
        function z10(e7) {
          this._handle = null, this._finished = false, this._completed = false, this._halted = false, this._input = null, this._baseIndex = 0, this._partialLine = "", this._rowCount = 0, this._start = 0, this._nextChunk = null, this.isFirstChunk = true, this._completeResults = { data: [], errors: [], meta: {} }, t6.call(this, e7), this.parseChunk = function(r8, s9) {
            let n23 = parseInt(this._config.skipFirstNLines) || 0;
            if (this.isFirstChunk && n23 > 0) {
              let O17 = this._config.newline;
              if (!O17) {
                let L18 = this._config.quoteChar || '"';
                O17 = this._handle.guessLineEndings(r8, L18);
              }
              r8 = [...r8.split(O17).slice(n23)].join(O17);
            }
            if (this.isFirstChunk && g18(this._config.beforeFirstChunk)) {
              var p17 = this._config.beforeFirstChunk(r8);
              p17 !== void 0 && (r8 = p17);
            }
            this.isFirstChunk = false, this._halted = false;
            var h17 = this._partialLine + r8;
            this._partialLine = "";
            var i10 = this._handle.parse(h17, this._baseIndex, !this._finished);
            if (this._handle.paused() || this._handle.aborted()) {
              this._halted = true;
              return;
            }
            var y18 = i10.meta.cursor;
            this._finished || (this._partialLine = h17.substring(y18 - this._baseIndex), this._baseIndex = y18), i10 && i10.data && (this._rowCount += i10.data.length);
            var E13 = this._finished || this._config.preview && this._rowCount >= this._config.preview;
            if (ue11) R13.postMessage({ results: i10, workerId: l8.WORKER_ID, finished: E13 });
            else if (g18(this._config.chunk) && !s9) {
              if (this._config.chunk(i10, this._handle), this._handle.paused() || this._handle.aborted()) {
                this._halted = true;
                return;
              }
              i10 = void 0, this._completeResults = void 0;
            }
            return !this._config.step && !this._config.chunk && (this._completeResults.data = this._completeResults.data.concat(i10.data), this._completeResults.errors = this._completeResults.errors.concat(i10.errors), this._completeResults.meta = i10.meta), !this._completed && E13 && g18(this._config.complete) && (!i10 || !i10.meta.aborted) && (this._config.complete(this._completeResults, this._input), this._completed = true), !E13 && (!i10 || !i10.meta.paused) && this._nextChunk(), i10;
          }, this._sendError = function(r8) {
            g18(this._config.error) ? this._config.error(r8) : ue11 && this._config.error && R13.postMessage({ workerId: l8.WORKER_ID, error: r8, finished: false });
          };
          function t6(r8) {
            var s9 = he10(r8);
            s9.chunkSize = parseInt(s9.chunkSize), !r8.step && !r8.chunk && (s9.chunkSize = null), this._handle = new ce10(s9), this._handle.streamer = this, this._config = s9;
          }
        }
        function G9(e7) {
          e7 = e7 || {}, e7.chunkSize || (e7.chunkSize = l8.RemoteChunkSize), z10.call(this, e7);
          var t6;
          Y11 ? this._nextChunk = function() {
            this._readChunk(), this._chunkLoaded();
          } : this._nextChunk = function() {
            this._readChunk();
          }, this.stream = function(s9) {
            this._input = s9, this._nextChunk();
          }, this._readChunk = function() {
            if (this._finished) {
              this._chunkLoaded();
              return;
            }
            if (t6 = new XMLHttpRequest(), this._config.withCredentials && (t6.withCredentials = this._config.withCredentials), Y11 || (t6.onload = F21(this._chunkLoaded, this), t6.onerror = F21(this._chunkError, this)), t6.open(this._config.downloadRequestBody ? "POST" : "GET", this._input, !Y11), this._config.downloadRequestHeaders) {
              var s9 = this._config.downloadRequestHeaders;
              for (var n23 in s9) t6.setRequestHeader(n23, s9[n23]);
            }
            if (this._config.chunkSize) {
              var p17 = this._start + this._config.chunkSize - 1;
              t6.setRequestHeader("Range", "bytes=" + this._start + "-" + p17);
            }
            try {
              t6.send(this._config.downloadRequestBody);
            } catch (h17) {
              this._chunkError(h17.message);
            }
            Y11 && t6.status === 0 && this._chunkError();
          }, this._chunkLoaded = function() {
            if (t6.readyState === 4) {
              if (t6.status < 200 || t6.status >= 400) {
                this._chunkError();
                return;
              }
              this._start += this._config.chunkSize ? this._config.chunkSize : t6.responseText.length, this._finished = !this._config.chunkSize || this._start >= r8(t6), this.parseChunk(t6.responseText);
            }
          }, this._chunkError = function(s9) {
            var n23 = t6.statusText || s9;
            this._sendError(new Error(n23));
          };
          function r8(s9) {
            var n23 = s9.getResponseHeader("Content-Range");
            return n23 === null ? -1 : parseInt(n23.substring(n23.lastIndexOf("/") + 1));
          }
        }
        G9.prototype = Object.create(z10.prototype), G9.prototype.constructor = G9;
        function ee7(e7) {
          e7 = e7 || {}, e7.chunkSize || (e7.chunkSize = l8.LocalChunkSize), z10.call(this, e7);
          var t6, r8, s9 = typeof FileReader < "u";
          this.stream = function(n23) {
            this._input = n23, r8 = n23.slice || n23.webkitSlice || n23.mozSlice, s9 ? (t6 = new FileReader(), t6.onload = F21(this._chunkLoaded, this), t6.onerror = F21(this._chunkError, this)) : t6 = new FileReaderSync(), this._nextChunk();
          }, this._nextChunk = function() {
            !this._finished && (!this._config.preview || this._rowCount < this._config.preview) && this._readChunk();
          }, this._readChunk = function() {
            var n23 = this._input;
            if (this._config.chunkSize) {
              var p17 = Math.min(this._start + this._config.chunkSize, this._input.size);
              n23 = r8.call(n23, this._start, p17);
            }
            var h17 = t6.readAsText(n23, this._config.encoding);
            s9 || this._chunkLoaded({ target: { result: h17 } });
          }, this._chunkLoaded = function(n23) {
            this._start += this._config.chunkSize, this._finished = !this._config.chunkSize || this._start >= this._input.size, this.parseChunk(n23.target.result);
          }, this._chunkError = function() {
            this._sendError(t6.error);
          };
        }
        ee7.prototype = Object.create(z10.prototype), ee7.prototype.constructor = ee7;
        function Z13(e7) {
          e7 = e7 || {}, z10.call(this, e7);
          var t6;
          this.stream = function(r8) {
            return t6 = r8, this._nextChunk();
          }, this._nextChunk = function() {
            if (!this._finished) {
              var r8 = this._config.chunkSize, s9;
              return r8 ? (s9 = t6.substring(0, r8), t6 = t6.substring(r8)) : (s9 = t6, t6 = ""), this._finished = !t6, this.parseChunk(s9);
            }
          };
        }
        Z13.prototype = Object.create(Z13.prototype), Z13.prototype.constructor = Z13;
        function te10(e7) {
          e7 = e7 || {}, z10.call(this, e7);
          var t6 = [], r8 = true, s9 = false;
          this.pause = function() {
            z10.prototype.pause.apply(this, arguments), this._input.pause();
          }, this.resume = function() {
            z10.prototype.resume.apply(this, arguments), this._input.resume();
          }, this.stream = function(n23) {
            this._input = n23, this._input.on("data", this._streamData), this._input.on("end", this._streamEnd), this._input.on("error", this._streamError);
          }, this._checkIsFinished = function() {
            s9 && t6.length === 1 && (this._finished = true);
          }, this._nextChunk = function() {
            this._checkIsFinished(), t6.length ? this.parseChunk(t6.shift()) : r8 = true;
          }, this._streamData = F21(function(n23) {
            try {
              t6.push(typeof n23 == "string" ? n23 : n23.toString(this._config.encoding)), r8 && (r8 = false, this._checkIsFinished(), this.parseChunk(t6.shift()));
            } catch (p17) {
              this._streamError(p17);
            }
          }, this), this._streamError = F21(function(n23) {
            this._streamCleanUp(), this._sendError(n23);
          }, this), this._streamEnd = F21(function() {
            this._streamCleanUp(), s9 = true, this._streamData("");
          }, this), this._streamCleanUp = F21(function() {
            this._input.removeListener("data", this._streamData), this._input.removeListener("end", this._streamEnd), this._input.removeListener("error", this._streamError);
          }, this);
        }
        te10.prototype = Object.create(z10.prototype), te10.prototype.constructor = te10;
        function re5(e7) {
          var t6 = m4("stream").Duplex, r8 = he10(e7), s9 = true, n23 = false, p17 = [], h17 = null;
          this._onCsvData = function(i10) {
            var y18 = i10.data;
            !h17.push(y18) && !this._handle.paused() && this._handle.pause();
          }, this._onCsvComplete = function() {
            h17.push(null);
          }, r8.step = F21(this._onCsvData, this), r8.complete = F21(this._onCsvComplete, this), z10.call(this, r8), this._nextChunk = function() {
            n23 && p17.length === 1 && (this._finished = true), p17.length ? p17.shift()() : s9 = true;
          }, this._addToParseQueue = function(i10, y18) {
            p17.push(F21(function() {
              if (this.parseChunk(typeof i10 == "string" ? i10 : i10.toString(r8.encoding)), g18(y18)) return y18();
            }, this)), s9 && (s9 = false, this._nextChunk());
          }, this._onRead = function() {
            this._handle.paused() && this._handle.resume();
          }, this._onWrite = function(i10, y18, E13) {
            this._addToParseQueue(i10, E13);
          }, this._onWriteComplete = function() {
            n23 = true, this._addToParseQueue("");
          }, this.getStream = function() {
            return h17;
          }, h17 = new t6({ readableObjectMode: true, decodeStrings: false, read: F21(this._onRead, this), write: F21(this._onWrite, this) }), h17.once("finish", F21(this._onWriteComplete, this));
        }
        typeof PAPA_BROWSER_CONTEXT > "u" && (re5.prototype = Object.create(z10.prototype), re5.prototype.constructor = re5);
        function ce10(e7) {
          var t6 = Math.pow(2, 53), r8 = -t6, s9 = /^\s*-?(\d+\.?|\.\d+|\d+\.\d+)([eE][-+]?\d+)?\s*$/, n23 = /^((\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z)))$/, p17 = this, h17 = 0, i10 = 0, y18, E13, O17 = false, d16 = false, L18, u11 = [], c15 = { data: [], errors: [], meta: {} };
          if (g18(e7.step)) {
            var Q13 = e7.step;
            e7.step = function(o9) {
              if (c15 = o9, w19()) S17();
              else {
                if (S17(), c15.data.length === 0) return;
                h17 += o9.data.length, e7.preview && h17 > e7.preview ? E13.abort() : (c15.data = c15.data[0], Q13(c15, p17));
              }
            };
          }
          this.parse = function(o9, f11, m25) {
            var b25 = e7.quoteChar || '"';
            if (e7.newline || (e7.newline = this.guessLineEndings(o9, b25)), L18 = false, e7.delimiter) g18(e7.delimiter) && (e7.delimiter = e7.delimiter(o9), c15.meta.delimiter = e7.delimiter);
            else {
              var a7 = j12(o9, e7.newline, e7.skipEmptyLines, e7.comments, e7.delimitersToGuess);
              a7.successful ? e7.delimiter = a7.bestDelimiter : (L18 = true, e7.delimiter = l8.DefaultDelimiter), c15.meta.delimiter = e7.delimiter;
            }
            var C19 = he10(e7);
            return e7.preview && e7.header && C19.preview++, y18 = o9, E13 = new fe10(C19), c15 = E13.parse(y18, f11, m25), S17(), O17 ? { meta: { paused: true } } : c15 || { meta: { paused: false } };
          }, this.paused = function() {
            return O17;
          }, this.pause = function() {
            O17 = true, E13.abort(), y18 = g18(e7.chunk) ? "" : y18.substring(E13.getCharIndex());
          }, this.resume = function() {
            p17.streamer._halted ? (O17 = false, p17.streamer.parseChunk(y18, true)) : setTimeout(p17.resume, 3);
          }, this.aborted = function() {
            return d16;
          }, this.abort = function() {
            d16 = true, E13.abort(), c15.meta.aborted = true, g18(e7.complete) && e7.complete(c15), y18 = "";
          }, this.guessLineEndings = function(o9, f11) {
            o9 = o9.substring(0, 1024 * 1024);
            var m25 = new RegExp(se9(f11) + "([^]*?)" + se9(f11), "gm");
            o9 = o9.replace(m25, "");
            var b25 = o9.split("\r"), a7 = o9.split(`
`), C19 = a7.length > 1 && a7[0].length < b25[0].length;
            if (b25.length === 1 || C19) return `
`;
            for (var A14 = 0, x23 = 0; x23 < b25.length; x23++) b25[x23][0] === `
` && A14++;
            return A14 >= b25.length / 2 ? `\r
` : "\r";
          };
          function v21(o9) {
            return e7.skipEmptyLines === "greedy" ? o9.join("").trim() === "" : o9.length === 1 && o9[0].length === 0;
          }
          function k17(o9) {
            if (s9.test(o9)) {
              var f11 = parseFloat(o9);
              if (f11 > r8 && f11 < t6) return true;
            }
            return false;
          }
          function S17() {
            return c15 && L18 && (W15("Delimiter", "UndetectableDelimiter", "Unable to auto-detect delimiting character; defaulted to '" + l8.DefaultDelimiter + "'"), L18 = false), e7.skipEmptyLines && (c15.data = c15.data.filter(function(o9) {
              return !v21(o9);
            })), w19() && M15(), _15();
          }
          function w19() {
            return e7.header && u11.length === 0;
          }
          function M15() {
            if (!c15) return;
            function o9(m25, b25) {
              g18(e7.transformHeader) && (m25 = e7.transformHeader(m25, b25)), u11.push(m25);
            }
            if (Array.isArray(c15.data[0])) {
              for (var f11 = 0; w19() && f11 < c15.data.length; f11++) c15.data[f11].forEach(o9);
              c15.data.splice(0, 1);
            } else c15.data.forEach(o9);
          }
          function T10(o9) {
            return e7.dynamicTypingFunction && e7.dynamicTyping[o9] === void 0 && (e7.dynamicTyping[o9] = e7.dynamicTypingFunction(o9)), (e7.dynamicTyping[o9] || e7.dynamicTyping) === true;
          }
          function q17(o9, f11) {
            return T10(o9) ? f11 === "true" || f11 === "TRUE" ? true : f11 === "false" || f11 === "FALSE" ? false : k17(f11) ? parseFloat(f11) : n23.test(f11) ? new Date(f11) : f11 === "" ? null : f11 : f11;
          }
          function _15() {
            if (!c15 || !e7.header && !e7.dynamicTyping && !e7.transform) return c15;
            function o9(m25, b25) {
              var a7 = e7.header ? {} : [], C19;
              for (C19 = 0; C19 < m25.length; C19++) {
                var A14 = C19, x23 = m25[C19];
                e7.header && (A14 = C19 >= u11.length ? "__parsed_extra" : u11[C19]), e7.transform && (x23 = e7.transform(x23, A14)), x23 = q17(A14, x23), A14 === "__parsed_extra" ? (a7[A14] = a7[A14] || [], a7[A14].push(x23)) : a7[A14] = x23;
              }
              return e7.header && (C19 > u11.length ? W15("FieldMismatch", "TooManyFields", "Too many fields: expected " + u11.length + " fields but parsed " + C19, i10 + b25) : C19 < u11.length && W15("FieldMismatch", "TooFewFields", "Too few fields: expected " + u11.length + " fields but parsed " + C19, i10 + b25)), a7;
            }
            var f11 = 1;
            return !c15.data.length || Array.isArray(c15.data[0]) ? (c15.data = c15.data.map(o9), f11 = c15.data.length) : c15.data = o9(c15.data, 0), e7.header && c15.meta && (c15.meta.fields = u11), i10 += f11, c15;
          }
          function j12(o9, f11, m25, b25, a7) {
            var C19, A14, x23, J15;
            a7 = a7 || [",", "	", "|", ";", l8.RECORD_SEP, l8.UNIT_SEP];
            for (var N15 = 0; N15 < a7.length; N15++) {
              var ie8 = a7[N15], X10 = 0, K9 = 0, I18 = 0;
              x23 = void 0;
              for (var H16 = new fe10({ comments: b25, delimiter: ie8, newline: f11, preview: 10 }).parse(o9), D15 = 0; D15 < H16.data.length; D15++) {
                if (m25 && v21(H16.data[D15])) {
                  I18++;
                  continue;
                }
                var P20 = H16.data[D15].length;
                if (K9 += P20, typeof x23 > "u") {
                  x23 = P20;
                  continue;
                } else P20 > 0 && (X10 += Math.abs(P20 - x23), x23 = P20);
              }
              H16.data.length > 0 && (K9 /= H16.data.length - I18), (typeof A14 > "u" || X10 <= A14) && (typeof J15 > "u" || K9 > J15) && K9 > 1.99 && (A14 = X10, C19 = ie8, J15 = K9);
            }
            return e7.delimiter = C19, { successful: !!C19, bestDelimiter: C19 };
          }
          function W15(o9, f11, m25, b25) {
            var a7 = { type: o9, code: f11, message: m25 };
            b25 !== void 0 && (a7.row = b25), c15.errors.push(a7);
          }
        }
        function se9(e7) {
          return e7.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        }
        function fe10(e7) {
          e7 = e7 || {};
          var t6 = e7.delimiter, r8 = e7.newline, s9 = e7.comments, n23 = e7.step, p17 = e7.preview, h17 = e7.fastMode, i10, y18 = null, E13 = false;
          e7.quoteChar === void 0 || e7.quoteChar === null ? i10 = '"' : i10 = e7.quoteChar;
          var O17 = i10;
          if (e7.escapeChar !== void 0 && (O17 = e7.escapeChar), (typeof t6 != "string" || l8.BAD_DELIMITERS.indexOf(t6) > -1) && (t6 = ","), s9 === t6) throw new Error("Comment character same as delimiter");
          s9 === true ? s9 = "#" : (typeof s9 != "string" || l8.BAD_DELIMITERS.indexOf(s9) > -1) && (s9 = false), r8 !== `
` && r8 !== "\r" && r8 !== `\r
` && (r8 = `
`);
          var d16 = 0, L18 = false;
          this.parse = function(u11, c15, Q13) {
            if (typeof u11 != "string") throw new Error("Input must be a string");
            var v21 = u11.length, k17 = t6.length, S17 = r8.length, w19 = s9.length, M15 = g18(n23);
            d16 = 0;
            var T10 = [], q17 = [], _15 = [], j12 = 0;
            if (!u11) return I18();
            if (h17 || h17 !== false && u11.indexOf(i10) === -1) {
              for (var W15 = u11.split(r8), o9 = 0; o9 < W15.length; o9++) {
                if (_15 = W15[o9], d16 += _15.length, o9 !== W15.length - 1) d16 += r8.length;
                else if (Q13) return I18();
                if (!(s9 && _15.substring(0, w19) === s9)) {
                  if (M15) {
                    if (T10 = [], N15(_15.split(t6)), H16(), L18) return I18();
                  } else N15(_15.split(t6));
                  if (p17 && o9 >= p17) return T10 = T10.slice(0, p17), I18(true);
                }
              }
              return I18();
            }
            for (var f11 = u11.indexOf(t6, d16), m25 = u11.indexOf(r8, d16), b25 = new RegExp(se9(O17) + se9(i10), "g"), a7 = u11.indexOf(i10, d16); ; ) {
              if (u11[d16] === i10) {
                for (a7 = d16, d16++; ; ) {
                  if (a7 = u11.indexOf(i10, a7 + 1), a7 === -1) return Q13 || q17.push({ type: "Quotes", code: "MissingQuotes", message: "Quoted field unterminated", row: T10.length, index: d16 }), X10();
                  if (a7 === v21 - 1) {
                    var C19 = u11.substring(d16, a7).replace(b25, i10);
                    return X10(C19);
                  }
                  if (i10 === O17 && u11[a7 + 1] === O17) {
                    a7++;
                    continue;
                  }
                  if (!(i10 !== O17 && a7 !== 0 && u11[a7 - 1] === O17)) {
                    f11 !== -1 && f11 < a7 + 1 && (f11 = u11.indexOf(t6, a7 + 1)), m25 !== -1 && m25 < a7 + 1 && (m25 = u11.indexOf(r8, a7 + 1));
                    var A14 = m25 === -1 ? f11 : Math.min(f11, m25), x23 = ie8(A14);
                    if (u11.substr(a7 + 1 + x23, k17) === t6) {
                      _15.push(u11.substring(d16, a7).replace(b25, i10)), d16 = a7 + 1 + x23 + k17, u11[a7 + 1 + x23 + k17] !== i10 && (a7 = u11.indexOf(i10, d16)), f11 = u11.indexOf(t6, d16), m25 = u11.indexOf(r8, d16);
                      break;
                    }
                    var J15 = ie8(m25);
                    if (u11.substring(a7 + 1 + J15, a7 + 1 + J15 + S17) === r8) {
                      if (_15.push(u11.substring(d16, a7).replace(b25, i10)), K9(a7 + 1 + J15 + S17), f11 = u11.indexOf(t6, d16), a7 = u11.indexOf(i10, d16), M15 && (H16(), L18)) return I18();
                      if (p17 && T10.length >= p17) return I18(true);
                      break;
                    }
                    q17.push({ type: "Quotes", code: "InvalidQuotes", message: "Trailing quote on quoted field is malformed", row: T10.length, index: d16 }), a7++;
                  }
                }
                continue;
              }
              if (s9 && _15.length === 0 && u11.substring(d16, d16 + w19) === s9) {
                if (m25 === -1) return I18();
                d16 = m25 + S17, m25 = u11.indexOf(r8, d16), f11 = u11.indexOf(t6, d16);
                continue;
              }
              if (f11 !== -1 && (f11 < m25 || m25 === -1)) {
                _15.push(u11.substring(d16, f11)), d16 = f11 + k17, f11 = u11.indexOf(t6, d16);
                continue;
              }
              if (m25 !== -1) {
                if (_15.push(u11.substring(d16, m25)), K9(m25 + S17), M15 && (H16(), L18)) return I18();
                if (p17 && T10.length >= p17) return I18(true);
                continue;
              }
              break;
            }
            return X10();
            function N15(D15) {
              T10.push(D15), j12 = d16;
            }
            function ie8(D15) {
              var P20 = 0;
              if (D15 !== -1) {
                var B12 = u11.substring(a7 + 1, D15);
                B12 && B12.trim() === "" && (P20 = B12.length);
              }
              return P20;
            }
            function X10(D15) {
              return Q13 || (typeof D15 > "u" && (D15 = u11.substring(d16)), _15.push(D15), d16 = v21, N15(_15), M15 && H16()), I18();
            }
            function K9(D15) {
              d16 = D15, N15(_15), _15 = [], m25 = u11.indexOf(r8, d16);
            }
            function I18(D15) {
              if (e7.header && !c15 && T10.length && !E13) {
                let P20 = T10[0], B12 = /* @__PURE__ */ Object.create(null), le9 = new Set(P20), ve8 = false;
                for (let $18 = 0; $18 < P20.length; $18++) {
                  let U14 = P20[$18];
                  if (g18(e7.transformHeader) && (U14 = e7.transformHeader(U14, $18)), !B12[U14]) B12[U14] = 1, P20[$18] = U14;
                  else {
                    let ne10, ke6 = B12[U14];
                    do
                      ne10 = `${U14}_${ke6}`, ke6++;
                    while (le9.has(ne10));
                    le9.add(ne10), P20[$18] = ne10, B12[U14]++, ve8 = true, y18 === null && (y18 = {}), y18[ne10] = U14;
                  }
                  le9.add(U14);
                }
                ve8 && console.warn("Duplicate headers found and renamed."), E13 = true;
              }
              return { data: T10, errors: q17, meta: { delimiter: t6, linebreak: r8, aborted: L18, truncated: !!D15, cursor: j12 + (c15 || 0), renamedHeaders: y18 } };
            }
            function H16() {
              n23(I18()), T10 = [], q17 = [];
            }
          }, this.abort = function() {
            L18 = true;
          }, this.getCharIndex = function() {
            return d16;
          };
        }
        function Ee7() {
          if (!l8.WORKERS_SUPPORTED) return false;
          var e7 = _e7(), t6 = new R13.Worker(e7);
          return t6.onmessage = be8, t6.id = ge8++, ae8[t6.id] = t6, t6;
        }
        function be8(e7) {
          var t6 = e7.data, r8 = ae8[t6.workerId], s9 = false;
          if (t6.error) r8.userError(t6.error, t6.file);
          else if (t6.results && t6.results.data) {
            var n23 = function() {
              s9 = true, me6(t6.workerId, { data: [], errors: [], meta: { aborted: true } });
            }, p17 = { abort: n23, pause: ye7, resume: ye7 };
            if (g18(r8.userStep)) {
              for (var h17 = 0; h17 < t6.results.data.length && (r8.userStep({ data: t6.results.data[h17], errors: t6.results.errors, meta: t6.results.meta }, p17), !s9); h17++) ;
              delete t6.results;
            } else g18(r8.userChunk) && (r8.userChunk(t6.results, p17, t6.file), delete t6.results);
          }
          t6.finished && !s9 && me6(t6.workerId, t6.results);
        }
        function me6(e7, t6) {
          var r8 = ae8[e7];
          g18(r8.userComplete) && r8.userComplete(t6), r8.terminate(), delete ae8[e7];
        }
        function ye7() {
          throw new Error("Not implemented.");
        }
        function Se6(e7) {
          var t6 = e7.data;
          if (typeof l8.WORKER_ID > "u" && t6 && (l8.WORKER_ID = t6.workerId), typeof t6.input == "string") R13.postMessage({ workerId: l8.WORKER_ID, results: l8.parse(t6.input, t6.config), finished: true });
          else if (R13.File && t6.input instanceof File || t6.input instanceof Object) {
            var r8 = l8.parse(t6.input, t6.config);
            r8 && R13.postMessage({ workerId: l8.WORKER_ID, results: r8, finished: true });
          }
        }
        function he10(e7) {
          if (typeof e7 != "object" || e7 === null) return e7;
          var t6 = Array.isArray(e7) ? [] : {};
          for (var r8 in e7) t6[r8] = he10(e7[r8]);
          return t6;
        }
        function F21(e7, t6) {
          return function() {
            e7.apply(t6, arguments);
          };
        }
        function g18(e7) {
          return typeof e7 == "function";
        }
        return l8;
      });
    });
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-XMDVFEVC.js
function wt4(s9, e7) {
  let t6 = [], n23 = e7.exec(s9);
  for (; n23; ) {
    let i10 = [];
    i10.startIndex = e7.lastIndex - n23[0].length;
    let r8 = n23.length;
    for (let o9 = 0; o9 < r8; o9++) i10.push(n23[o9]);
    t6.push(i10), n23 = e7.exec(s9);
  }
  return t6;
}
function Ii(s9) {
  return typeof s9 < "u";
}
function Mi2(s9, e7) {
  e7 = Object.assign({}, Qa, e7);
  let t6 = [], n23 = false, i10 = false;
  s9[0] === "\uFEFF" && (s9 = s9.substr(1));
  for (let r8 = 0; r8 < s9.length; r8++) if (s9[r8] === "<" && s9[r8 + 1] === "?") {
    if (r8 += 2, r8 = Ci(s9, r8), r8.err) return r8;
  } else if (s9[r8] === "<") {
    let o9 = r8;
    if (r8++, s9[r8] === "!") {
      r8 = Li2(s9, r8);
      continue;
    } else {
      let a7 = false;
      s9[r8] === "/" && (a7 = true, r8++);
      let l8 = "";
      for (; r8 < s9.length && s9[r8] !== ">" && s9[r8] !== " " && s9[r8] !== "	" && s9[r8] !== `
` && s9[r8] !== "\r"; r8++) l8 += s9[r8];
      if (l8 = l8.trim(), l8[l8.length - 1] === "/" && (l8 = l8.substring(0, l8.length - 1), r8--), !nl(l8)) {
        let f11;
        return l8.trim().length === 0 ? f11 = "Invalid space after '<'." : f11 = "Tag '" + l8 + "' is an invalid name.", q13("InvalidTag", f11, _10(s9, r8));
      }
      let c15 = za(s9, r8);
      if (c15 === false) return q13("InvalidAttr", "Attributes for '" + l8 + "' have open quote.", _10(s9, r8));
      let u11 = c15.value;
      if (r8 = c15.index, u11[u11.length - 1] === "/") {
        let f11 = r8 - u11.length;
        u11 = u11.substring(0, u11.length - 1);
        let d16 = Pi(u11, e7);
        if (d16 === true) n23 = true;
        else return q13(d16.err.code, d16.err.msg, _10(s9, f11 + d16.err.line));
      } else if (a7) if (c15.tagClosed) {
        if (u11.trim().length > 0) return q13("InvalidTag", "Closing tag '" + l8 + "' can't have attributes or invalid starting.", _10(s9, o9));
        if (t6.length === 0) return q13("InvalidTag", "Closing tag '" + l8 + "' has not been opened.", _10(s9, o9));
        {
          let f11 = t6.pop();
          if (l8 !== f11.tagName) {
            let d16 = _10(s9, f11.tagStartPos);
            return q13("InvalidTag", "Expected closing tag '" + f11.tagName + "' (opened in line " + d16.line + ", col " + d16.col + ") instead of closing tag '" + l8 + "'.", _10(s9, o9));
          }
          t6.length == 0 && (i10 = true);
        }
      } else return q13("InvalidTag", "Closing tag '" + l8 + "' doesn't have proper closing.", _10(s9, r8));
      else {
        let f11 = Pi(u11, e7);
        if (f11 !== true) return q13(f11.err.code, f11.err.msg, _10(s9, r8 - u11.length + f11.err.line));
        if (i10 === true) return q13("InvalidXml", "Multiple possible root nodes found.", _10(s9, r8));
        e7.unpairedTags.indexOf(l8) !== -1 || t6.push({ tagName: l8, tagStartPos: o9 }), n23 = true;
      }
      for (r8++; r8 < s9.length; r8++) if (s9[r8] === "<") if (s9[r8 + 1] === "!") {
        r8++, r8 = Li2(s9, r8);
        continue;
      } else if (s9[r8 + 1] === "?") {
        if (r8 = Ci(s9, ++r8), r8.err) return r8;
      } else break;
      else if (s9[r8] === "&") {
        let f11 = tl(s9, r8);
        if (f11 == -1) return q13("InvalidChar", "char '&' is not expected.", _10(s9, r8));
        r8 = f11;
      } else if (i10 === true && !qi2(s9[r8])) return q13("InvalidXml", "Extra text at the end", _10(s9, r8));
      s9[r8] === "<" && r8--;
    }
  } else {
    if (qi2(s9[r8])) continue;
    return q13("InvalidChar", "char '" + s9[r8] + "' is not expected.", _10(s9, r8));
  }
  if (n23) {
    if (t6.length == 1) return q13("InvalidTag", "Unclosed tag '" + t6[0].tagName + "'.", _10(s9, t6[0].tagStartPos));
    if (t6.length > 0) return q13("InvalidXml", "Invalid '" + JSON.stringify(t6.map((r8) => r8.tagName), null, 4).replace(/\r?\n/g, "") + "' found.", { line: 1, col: 1 });
  } else return q13("InvalidXml", "Start tag expected.", 1);
  return true;
}
function qi2(s9) {
  return s9 === " " || s9 === "	" || s9 === `
` || s9 === "\r";
}
function Ci(s9, e7) {
  let t6 = e7;
  for (; e7 < s9.length; e7++) if (s9[e7] == "?" || s9[e7] == " ") {
    let n23 = s9.substr(t6, e7 - t6);
    if (e7 > 5 && n23 === "xml") return q13("InvalidXml", "XML declaration allowed only at the start of the document.", _10(s9, e7));
    if (s9[e7] == "?" && s9[e7 + 1] == ">") {
      e7++;
      break;
    } else continue;
  }
  return e7;
}
function Li2(s9, e7) {
  if (s9.length > e7 + 5 && s9[e7 + 1] === "-" && s9[e7 + 2] === "-") {
    for (e7 += 3; e7 < s9.length; e7++) if (s9[e7] === "-" && s9[e7 + 1] === "-" && s9[e7 + 2] === ">") {
      e7 += 2;
      break;
    }
  } else if (s9.length > e7 + 8 && s9[e7 + 1] === "D" && s9[e7 + 2] === "O" && s9[e7 + 3] === "C" && s9[e7 + 4] === "T" && s9[e7 + 5] === "Y" && s9[e7 + 6] === "P" && s9[e7 + 7] === "E") {
    let t6 = 1;
    for (e7 += 8; e7 < s9.length; e7++) if (s9[e7] === "<") t6++;
    else if (s9[e7] === ">" && (t6--, t6 === 0)) break;
  } else if (s9.length > e7 + 9 && s9[e7 + 1] === "[" && s9[e7 + 2] === "C" && s9[e7 + 3] === "D" && s9[e7 + 4] === "A" && s9[e7 + 5] === "T" && s9[e7 + 6] === "A" && s9[e7 + 7] === "[") {
    for (e7 += 8; e7 < s9.length; e7++) if (s9[e7] === "]" && s9[e7 + 1] === "]" && s9[e7 + 2] === ">") {
      e7 += 2;
      break;
    }
  }
  return e7;
}
function za(s9, e7) {
  let t6 = "", n23 = "", i10 = false;
  for (; e7 < s9.length; e7++) {
    if (s9[e7] === Ha || s9[e7] === Da) n23 === "" ? n23 = s9[e7] : n23 !== s9[e7] || (n23 = "");
    else if (s9[e7] === ">" && n23 === "") {
      i10 = true;
      break;
    }
    t6 += s9[e7];
  }
  return n23 !== "" ? false : { value: t6, index: e7, tagClosed: i10 };
}
function Pi(s9, e7) {
  let t6 = wt4(s9, Za), n23 = {};
  for (let i10 = 0; i10 < t6.length; i10++) {
    if (t6[i10][1].length === 0) return q13("InvalidAttr", "Attribute '" + t6[i10][2] + "' has no space in starting.", Pe4(t6[i10]));
    if (t6[i10][3] !== void 0 && t6[i10][4] === void 0) return q13("InvalidAttr", "Attribute '" + t6[i10][2] + "' is without value.", Pe4(t6[i10]));
    if (t6[i10][3] === void 0 && !e7.allowBooleanAttributes) return q13("InvalidAttr", "boolean attribute '" + t6[i10][2] + "' is not allowed.", Pe4(t6[i10]));
    let r8 = t6[i10][2];
    if (!sl(r8)) return q13("InvalidAttr", "Attribute '" + r8 + "' is an invalid name.", Pe4(t6[i10]));
    if (!n23.hasOwnProperty(r8)) n23[r8] = 1;
    else return q13("InvalidAttr", "Attribute '" + r8 + "' is repeated.", Pe4(t6[i10]));
  }
  return true;
}
function el(s9, e7) {
  let t6 = /\d/;
  for (s9[e7] === "x" && (e7++, t6 = /[\da-fA-F]/); e7 < s9.length; e7++) {
    if (s9[e7] === ";") return e7;
    if (!s9[e7].match(t6)) break;
  }
  return -1;
}
function tl(s9, e7) {
  if (e7++, s9[e7] === ";") return -1;
  if (s9[e7] === "#") return e7++, el(s9, e7);
  let t6 = 0;
  for (; e7 < s9.length; e7++, t6++) if (!(s9[e7].match(/\w/) && t6 < 20)) {
    if (s9[e7] === ";") break;
    return -1;
  }
  return e7;
}
function q13(s9, e7, t6) {
  return { err: { code: s9, msg: e7, line: t6.line || t6, col: t6.col } };
}
function sl(s9) {
  return ye5(s9);
}
function nl(s9) {
  return ye5(s9);
}
function _10(s9, e7) {
  let t6 = s9.substring(0, e7).split(/\r?\n/);
  return { line: t6.length, col: t6[t6.length - 1].length + 1 };
}
function Pe4(s9) {
  return s9.startIndex + s9[1].length;
}
function le7(s9, e7, t6) {
  for (let n23 = 0; n23 < e7.length; n23++) if (e7[n23] !== s9[t6 + n23 + 1]) return false;
  return true;
}
function Me5(s9) {
  if (ye5(s9)) return s9;
  throw new Error(`Invalid entity name ${s9}`);
}
function Os2(s9, e7 = {}) {
  if (e7 = Object.assign({}, al, e7), !s9 || typeof s9 != "string") return s9;
  let t6 = s9.trim();
  if (e7.skipLike !== void 0 && e7.skipLike.test(t6)) return s9;
  if (s9 === "0") return 0;
  if (e7.hex && rl.test(t6)) return ul(t6, 16);
  if (t6.includes("e") || t6.includes("E")) return cl(s9, t6, e7);
  {
    let n23 = ol.exec(t6);
    if (n23) {
      let i10 = n23[1] || "", r8 = n23[2], o9 = fl(n23[3]), a7 = i10 ? s9[r8.length + 1] === "." : s9[r8.length] === ".";
      if (!e7.leadingZeros && (r8.length > 1 || r8.length === 1 && !a7)) return s9;
      {
        let l8 = Number(t6), c15 = String(l8);
        if (l8 === 0) return l8;
        if (c15.search(/[eE]/) !== -1) return e7.eNotation ? l8 : s9;
        if (t6.indexOf(".") !== -1) return c15 === "0" || c15 === o9 || c15 === `${i10}${o9}` ? l8 : s9;
        let u11 = r8 ? o9 : t6;
        return r8 ? u11 === c15 || i10 + u11 === c15 ? l8 : s9 : u11 === c15 || u11 === i10 + c15 ? l8 : s9;
      }
    } else return s9;
  }
}
function cl(s9, e7, t6) {
  if (!t6.eNotation) return s9;
  let n23 = e7.match(ll);
  if (n23) {
    let i10 = n23[1] || "", r8 = n23[3].indexOf("e") === -1 ? "E" : "e", o9 = n23[2], a7 = i10 ? s9[o9.length + 1] === r8 : s9[o9.length] === r8;
    return o9.length > 1 && a7 ? s9 : o9.length === 1 && (n23[3].startsWith(`.${r8}`) || n23[3][0] === r8) ? Number(e7) : t6.leadingZeros && !a7 ? (e7 = (n23[1] || "") + n23[3], Number(e7)) : s9;
  } else return s9;
}
function fl(s9) {
  return s9 && s9.indexOf(".") !== -1 && (s9 = s9.replace(/0+$/, ""), s9 === "." ? s9 = "0" : s9[0] === "." ? s9 = "0" + s9 : s9[s9.length - 1] === "." && (s9 = s9.substring(0, s9.length - 1))), s9;
}
function ul(s9, e7) {
  if (parseInt) return parseInt(s9, e7);
  if (Number.parseInt) return Number.parseInt(s9, e7);
  if (window && window.parseInt) return window.parseInt(s9, e7);
  throw new Error("parseInt, Number.parseInt, window.parseInt are not supported");
}
function _e5(s9) {
  return typeof s9 == "function" ? s9 : Array.isArray(s9) ? (e7) => {
    for (let t6 of s9) if (typeof t6 == "string" && e7 === t6 || t6 instanceof RegExp && t6.test(e7)) return true;
  } : () => false;
}
function dl(s9) {
  let e7 = Object.keys(s9);
  for (let t6 = 0; t6 < e7.length; t6++) {
    let n23 = e7[t6];
    this.lastEntities[n23] = { regex: new RegExp("&" + n23 + ";", "g"), val: s9[n23] };
  }
}
function hl(s9, e7, t6, n23, i10, r8, o9) {
  if (s9 !== void 0 && (this.options.trimValues && !n23 && (s9 = s9.trim()), s9.length > 0)) {
    o9 || (s9 = this.replaceEntitiesValue(s9));
    let a7 = this.options.tagValueProcessor(e7, s9, t6, i10, r8);
    return a7 == null ? s9 : typeof a7 != typeof s9 || a7 !== s9 ? a7 : this.options.trimValues ? Is2(s9, this.options.parseTagValue, this.options.numberParseOptions) : s9.trim() === s9 ? Is2(s9, this.options.parseTagValue, this.options.numberParseOptions) : s9;
  }
}
function pl(s9) {
  if (this.options.removeNSPrefix) {
    let e7 = s9.split(":"), t6 = s9.charAt(0) === "/" ? "/" : "";
    if (e7[0] === "xmlns") return "";
    e7.length === 2 && (s9 = t6 + e7[1]);
  }
  return s9;
}
function gl(s9, e7) {
  if (this.options.ignoreAttributes !== true && typeof s9 == "string") {
    let t6 = wt4(s9, ml), n23 = t6.length, i10 = {};
    for (let r8 = 0; r8 < n23; r8++) {
      let o9 = this.resolveNameSpace(t6[r8][1]);
      if (this.ignoreAttributesFn(o9, e7)) continue;
      let a7 = t6[r8][4], l8 = this.options.attributeNamePrefix + o9;
      if (o9.length) if (this.options.transformAttributeName && (l8 = this.options.transformAttributeName(l8)), l8 === "__proto__" && (l8 = "#__proto__"), a7 !== void 0) {
        this.options.trimValues && (a7 = a7.trim()), a7 = this.replaceEntitiesValue(a7);
        let c15 = this.options.attributeValueProcessor(o9, a7, e7);
        c15 == null ? i10[l8] = a7 : typeof c15 != typeof a7 || c15 !== a7 ? i10[l8] = c15 : i10[l8] = Is2(a7, this.options.parseAttributeValue, this.options.numberParseOptions);
      } else this.options.allowBooleanAttributes && (i10[l8] = true);
    }
    if (!Object.keys(i10).length) return;
    if (this.options.attributesGroupName) {
      let r8 = {};
      return r8[this.options.attributesGroupName] = i10, r8;
    }
    return i10;
  }
}
function bl2(s9, e7, t6, n23) {
  this.options.captureMetaData || (n23 = void 0);
  let i10 = this.options.updateTag(e7.tagname, t6, e7[":@"]);
  i10 === false || (typeof i10 == "string" && (e7.tagname = i10), s9.addChild(e7, n23));
}
function Sl2(s9, e7, t6, n23) {
  return s9 && (n23 === void 0 && (n23 = e7.child.length === 0), s9 = this.parseTextData(s9, e7.tagname, t6, false, e7[":@"] ? Object.keys(e7[":@"]).length !== 0 : false, n23), s9 !== void 0 && s9 !== "" && e7.add(this.options.textNodeName, s9), s9 = ""), s9;
}
function Nl(s9, e7, t6, n23) {
  return !!(e7 && e7.has(n23) || s9 && s9.has(t6));
}
function El2(s9, e7, t6 = ">") {
  let n23, i10 = "";
  for (let r8 = e7; r8 < s9.length; r8++) {
    let o9 = s9[r8];
    if (n23) o9 === n23 && (n23 = "");
    else if (o9 === '"' || o9 === "'") n23 = o9;
    else if (o9 === t6[0]) if (t6[1]) {
      if (s9[r8 + 1] === t6[1]) return { data: i10, index: r8 };
    } else return { data: i10, index: r8 };
    else o9 === "	" && (o9 = " ");
    i10 += o9;
  }
}
function ce7(s9, e7, t6, n23) {
  let i10 = s9.indexOf(e7, t6);
  if (i10 === -1) throw new Error(n23);
  return i10 + e7.length - 1;
}
function ks2(s9, e7, t6, n23 = ">") {
  let i10 = El2(s9, e7 + 1, n23);
  if (!i10) return;
  let r8 = i10.data, o9 = i10.index, a7 = r8.search(/\s/), l8 = r8, c15 = true;
  a7 !== -1 && (l8 = r8.substring(0, a7), r8 = r8.substring(a7 + 1).trimStart());
  let u11 = l8;
  if (t6) {
    let f11 = l8.indexOf(":");
    f11 !== -1 && (l8 = l8.substr(f11 + 1), c15 = l8 !== i10.data.substr(f11 + 1));
  }
  return { tagName: l8, tagExp: r8, closeIndex: o9, attrExpPresent: c15, rawTagName: u11 };
}
function vl(s9, e7, t6) {
  let n23 = t6, i10 = 1;
  for (; t6 < s9.length; t6++) if (s9[t6] === "<") if (s9[t6 + 1] === "/") {
    let r8 = ce7(s9, ">", t6, `${e7} is not closed`);
    if (s9.substring(t6 + 2, r8).trim() === e7 && (i10--, i10 === 0)) return { tagContent: s9.substring(n23, t6), i: r8 };
    t6 = r8;
  } else if (s9[t6 + 1] === "?") t6 = ce7(s9, "?>", t6 + 1, "StopNode is not closed.");
  else if (s9.substr(t6 + 1, 3) === "!--") t6 = ce7(s9, "-->", t6 + 3, "StopNode is not closed.");
  else if (s9.substr(t6 + 1, 2) === "![") t6 = ce7(s9, "]]>", t6, "StopNode is not closed.") - 2;
  else {
    let r8 = ks2(s9, t6, ">");
    r8 && ((r8 && r8.tagName) === e7 && r8.tagExp[r8.tagExp.length - 1] !== "/" && i10++, t6 = r8.closeIndex);
  }
}
function Is2(s9, e7, t6) {
  if (e7 && typeof s9 == "string") {
    let n23 = s9.trim();
    return n23 === "true" ? true : n23 === "false" ? false : Os2(s9, t6);
  } else return Ii(s9) ? s9 : "";
}
function Cs2(s9, e7) {
  return _i2(s9, e7);
}
function _i2(s9, e7, t6) {
  let n23, i10 = {};
  for (let r8 = 0; r8 < s9.length; r8++) {
    let o9 = s9[r8], a7 = Al2(o9), l8 = "";
    if (t6 === void 0 ? l8 = a7 : l8 = t6 + "." + a7, a7 === e7.textNodeName) n23 === void 0 ? n23 = o9[a7] : n23 += "" + o9[a7];
    else {
      if (a7 === void 0) continue;
      if (o9[a7]) {
        let c15 = _i2(o9[a7], e7, l8), u11 = Ol(c15, e7);
        o9[qs2] !== void 0 && (c15[qs2] = o9[qs2]), o9[":@"] ? Tl(c15, o9[":@"], l8, e7) : Object.keys(c15).length === 1 && c15[e7.textNodeName] !== void 0 && !e7.alwaysCreateTextNode ? c15 = c15[e7.textNodeName] : Object.keys(c15).length === 0 && (e7.alwaysCreateTextNode ? c15[e7.textNodeName] = "" : c15 = ""), i10[a7] !== void 0 && i10.hasOwnProperty(a7) ? (Array.isArray(i10[a7]) || (i10[a7] = [i10[a7]]), i10[a7].push(c15)) : e7.isArray(a7, l8, u11) ? i10[a7] = [c15] : i10[a7] = c15;
      }
    }
  }
  return typeof n23 == "string" ? n23.length > 0 && (i10[e7.textNodeName] = n23) : n23 !== void 0 && (i10[e7.textNodeName] = n23), i10;
}
function Al2(s9) {
  let e7 = Object.keys(s9);
  for (let t6 = 0; t6 < e7.length; t6++) {
    let n23 = e7[t6];
    if (n23 !== ":@") return n23;
  }
}
function Tl(s9, e7, t6, n23) {
  if (e7) {
    let i10 = Object.keys(e7), r8 = i10.length;
    for (let o9 = 0; o9 < r8; o9++) {
      let a7 = i10[o9];
      n23.isArray(a7, t6 + "." + a7, true, true) ? s9[a7] = [e7[a7]] : s9[a7] = e7[a7];
    }
  }
}
function Ol(s9, e7) {
  let { textNodeName: t6 } = e7, n23 = Object.keys(s9).length;
  return !!(n23 === 0 || n23 === 1 && (s9[t6] || typeof s9[t6] == "boolean" || s9[t6] === 0));
}
function Ls2(s9, e7) {
  let t6 = "";
  return e7.format && e7.indentBy.length > 0 && (t6 = `
`), Bi2(s9, e7, "", t6);
}
function Bi2(s9, e7, t6, n23) {
  let i10 = "", r8 = false;
  for (let o9 = 0; o9 < s9.length; o9++) {
    let a7 = s9[o9], l8 = kl(a7);
    if (l8 === void 0) continue;
    let c15 = "";
    if (t6.length === 0 ? c15 = l8 : c15 = `${t6}.${l8}`, l8 === e7.textNodeName) {
      let g18 = a7[l8];
      Il(c15, e7) || (g18 = e7.tagValueProcessor(l8, g18), g18 = Fi(g18, e7)), r8 && (i10 += n23), i10 += g18, r8 = false;
      continue;
    } else if (l8 === e7.cdataPropName) {
      r8 && (i10 += n23), i10 += `<![CDATA[${a7[l8][0][e7.textNodeName]}]]>`, r8 = false;
      continue;
    } else if (l8 === e7.commentPropName) {
      i10 += n23 + `<!--${a7[l8][0][e7.textNodeName]}-->`, r8 = true;
      continue;
    } else if (l8[0] === "?") {
      let g18 = xi(a7[":@"], e7), h17 = l8 === "?xml" ? "" : n23, m25 = a7[l8][0][e7.textNodeName];
      m25 = m25.length !== 0 ? " " + m25 : "", i10 += h17 + `<${l8}${m25}${g18}?>`, r8 = true;
      continue;
    }
    let u11 = n23;
    u11 !== "" && (u11 += e7.indentBy);
    let f11 = xi(a7[":@"], e7), d16 = n23 + `<${l8}${f11}`, p17 = Bi2(a7[l8], e7, c15, u11);
    e7.unpairedTags.indexOf(l8) !== -1 ? e7.suppressUnpairedNode ? i10 += d16 + ">" : i10 += d16 + "/>" : (!p17 || p17.length === 0) && e7.suppressEmptyNode ? i10 += d16 + "/>" : p17 && p17.endsWith(">") ? i10 += d16 + `>${p17}${n23}</${l8}>` : (i10 += d16 + ">", p17 && n23 !== "" && (p17.includes("/>") || p17.includes("</")) ? i10 += n23 + e7.indentBy + p17 + n23 : i10 += p17, i10 += `</${l8}>`), r8 = true;
  }
  return i10;
}
function kl(s9) {
  let e7 = Object.keys(s9);
  for (let t6 = 0; t6 < e7.length; t6++) {
    let n23 = e7[t6];
    if (s9.hasOwnProperty(n23) && n23 !== ":@") return n23;
  }
}
function xi(s9, e7) {
  let t6 = "";
  if (s9 && !e7.ignoreAttributes) for (let n23 in s9) {
    if (!s9.hasOwnProperty(n23)) continue;
    let i10 = e7.attributeValueProcessor(n23, s9[n23]);
    i10 = Fi(i10, e7), i10 === true && e7.suppressBooleanAttributes ? t6 += ` ${n23.substr(e7.attributeNamePrefix.length)}` : t6 += ` ${n23.substr(e7.attributeNamePrefix.length)}="${i10}"`;
  }
  return t6;
}
function Il(s9, e7) {
  s9 = s9.substr(0, s9.length - e7.textNodeName.length - 1);
  let t6 = s9.substr(s9.lastIndexOf(".") + 1);
  for (let n23 in e7.stopNodes) if (e7.stopNodes[n23] === s9 || e7.stopNodes[n23] === "*." + t6) return true;
  return false;
}
function Fi(s9, e7) {
  if (s9 && s9.length > 0 && e7.processEntities) for (let t6 = 0; t6 < e7.entities.length; t6++) {
    let n23 = e7.entities[t6];
    s9 = s9.replace(n23.regex, n23.val);
  }
  return s9;
}
function R8(s9) {
  this.options = Object.assign({}, ql, s9), this.options.ignoreAttributes === true || this.options.attributesGroupName ? this.isAttribute = function() {
    return false;
  } : (this.ignoreAttributesFn = _e5(this.options.ignoreAttributes), this.attrPrefixLen = this.options.attributeNamePrefix.length, this.isAttribute = Pl), this.processTextOrObjNode = Cl, this.options.format ? (this.indentate = Ll, this.tagEndChar = `>
`, this.newLine = `
`) : (this.indentate = function() {
    return "";
  }, this.tagEndChar = ">", this.newLine = "");
}
function Cl(s9, e7, t6, n23) {
  let i10 = this.j2x(s9, t6 + 1, n23.concat(e7));
  return s9[this.options.textNodeName] !== void 0 && Object.keys(s9).length === 1 ? this.buildTextValNode(s9[this.options.textNodeName], e7, i10.attrStr, t6) : this.buildObjectNode(i10.val, e7, i10.attrStr, t6);
}
function Ll(s9) {
  return this.options.indentBy.repeat(s9);
}
function Pl(s9) {
  return s9.startsWith(this.options.attributeNamePrefix) && s9 !== this.options.textNodeName ? s9.substr(this.attrPrefixLen) : false;
}
function Ml(s9, e7) {
  let t6 = s9.slice(0, e7).split(/\r\n|\n|\r/g);
  return [t6.length, t6.pop().length + 1];
}
function $l(s9, e7, t6) {
  let n23 = s9.split(/\r\n|\n|\r/g), i10 = "", r8 = (Math.log10(e7 + 1) | 0) + 1;
  for (let o9 = e7 - 1; o9 <= e7 + 1; o9++) {
    let a7 = n23[o9 - 1];
    a7 && (i10 += o9.toString().padEnd(r8, " "), i10 += ":  ", i10 += a7, i10 += `
`, o9 === e7 && (i10 += " ".repeat(r8 + t6 + 2), i10 += `^
`));
  }
  return i10;
}
function _l(s9, e7) {
  let t6 = 0;
  for (; s9[e7 - ++t6] === "\\"; ) ;
  return --t6 && t6 % 2;
}
function Et4(s9, e7 = 0, t6 = s9.length) {
  let n23 = s9.indexOf(`
`, e7);
  return s9[n23 - 1] === "\r" && n23--, n23 <= t6 ? n23 : -1;
}
function we4(s9, e7) {
  for (let t6 = e7; t6 < s9.length; t6++) {
    let n23 = s9[t6];
    if (n23 === `
`) return t6;
    if (n23 === "\r" && s9[t6 + 1] === `
`) return t6 + 1;
    if (n23 < " " && n23 !== "	" || n23 === "\x7F") throw new T9("control characters are not allowed in comments", { toml: s9, ptr: e7 });
  }
  return s9.length;
}
function B9(s9, e7, t6, n23) {
  let i10;
  for (; (i10 = s9[e7]) === " " || i10 === "	" || !t6 && (i10 === `
` || i10 === "\r" && s9[e7 + 1] === `
`); ) e7++;
  return n23 || i10 !== "#" ? e7 : B9(s9, we4(s9, e7), t6);
}
function Ui(s9, e7, t6, n23, i10 = false) {
  if (!n23) return e7 = Et4(s9, e7), e7 < 0 ? s9.length : e7;
  for (let r8 = e7; r8 < s9.length; r8++) {
    let o9 = s9[r8];
    if (o9 === "#") r8 = Et4(s9, r8);
    else {
      if (o9 === t6) return r8 + 1;
      if (o9 === n23 || i10 && (o9 === `
` || o9 === "\r" && s9[r8 + 1] === `
`)) return r8;
    }
  }
  throw new T9("cannot find end of structure", { toml: s9, ptr: e7 });
}
function vt3(s9, e7) {
  let t6 = s9[e7], n23 = t6 === s9[e7 + 1] && s9[e7 + 1] === s9[e7 + 2] ? s9.slice(e7, e7 + 3) : t6;
  e7 += n23.length - 1;
  do
    e7 = s9.indexOf(n23, ++e7);
  while (e7 > -1 && t6 !== "'" && _l(s9, e7));
  return e7 > -1 && (e7 += n23.length, n23.length > 1 && (s9[e7] === t6 && e7++, s9[e7] === t6 && e7++)), e7;
}
function At4(s9, e7 = 0, t6 = s9.length) {
  let n23 = s9[e7] === "'", i10 = s9[e7++] === s9[e7] && s9[e7] === s9[e7 + 1];
  i10 && (t6 -= 2, s9[e7 += 2] === "\r" && e7++, s9[e7] === `
` && e7++);
  let r8 = 0, o9, a7 = "", l8 = e7;
  for (; e7 < t6 - 1; ) {
    let c15 = s9[e7++];
    if (c15 === `
` || c15 === "\r" && s9[e7] === `
`) {
      if (!i10) throw new T9("newlines are not allowed in strings", { toml: s9, ptr: e7 - 1 });
    } else if (c15 < " " && c15 !== "	" || c15 === "\x7F") throw new T9("control characters are not allowed in strings", { toml: s9, ptr: e7 - 1 });
    if (o9) {
      if (o9 = false, c15 === "x" || c15 === "u" || c15 === "U") {
        let u11 = s9.slice(e7, e7 += c15 === "x" ? 2 : c15 === "u" ? 4 : 8);
        if (!Vl.test(u11)) throw new T9("invalid unicode escape", { toml: s9, ptr: r8 });
        try {
          a7 += String.fromCodePoint(parseInt(u11, 16));
        } catch {
          throw new T9("invalid unicode escape", { toml: s9, ptr: r8 });
        }
      } else if (i10 && (c15 === `
` || c15 === " " || c15 === "	" || c15 === "\r")) {
        if (e7 = B9(s9, e7 - 1, true), s9[e7] !== `
` && s9[e7] !== "\r") throw new T9("invalid escape: only line-ending whitespace may be escaped", { toml: s9, ptr: r8 });
        e7 = B9(s9, e7);
      } else if (c15 in Ji) a7 += Ji[c15];
      else throw new T9("unrecognized escape sequence", { toml: s9, ptr: r8 });
      l8 = e7;
    } else !n23 && c15 === "\\" && (r8 = e7 - 1, o9 = true, a7 += s9.slice(l8, r8));
  }
  return a7 + s9.slice(l8, t6 - 1);
}
function Wi(s9, e7, t6, n23) {
  if (s9 === "true") return true;
  if (s9 === "false") return false;
  if (s9 === "-inf") return -1 / 0;
  if (s9 === "inf" || s9 === "+inf") return 1 / 0;
  if (s9 === "nan" || s9 === "+nan" || s9 === "-nan") return NaN;
  if (s9 === "-0") return n23 ? 0n : 0;
  let i10 = Bl.test(s9);
  if (i10 || Fl.test(s9)) {
    if (jl.test(s9)) throw new T9("leading zeroes are not allowed", { toml: e7, ptr: t6 });
    s9 = s9.replace(/_/g, "");
    let o9 = +s9;
    if (isNaN(o9)) throw new T9("invalid number", { toml: e7, ptr: t6 });
    if (i10) {
      if ((i10 = !Number.isSafeInteger(o9)) && !n23) throw new T9("integer value cannot be represented losslessly", { toml: e7, ptr: t6 });
      (i10 || n23 === true) && (o9 = BigInt(s9));
    }
    return o9;
  }
  let r8 = new Be4(s9);
  if (!r8.isValid()) throw new T9("invalid value", { toml: e7, ptr: t6 });
  return r8;
}
function Kl(s9, e7, t6) {
  let n23 = s9.slice(e7, t6), i10 = n23.indexOf("#");
  return i10 > -1 && (we4(s9, i10), n23 = n23.slice(0, i10)), [n23.trimEnd(), i10];
}
function Fe5(s9, e7, t6, n23, i10) {
  if (n23 === 0) throw new T9("document contains excessively nested structures. aborting.", { toml: s9, ptr: e7 });
  let r8 = s9[e7];
  if (r8 === "[" || r8 === "{") {
    let [l8, c15] = r8 === "[" ? Xi(s9, e7, n23, i10) : Gi(s9, e7, n23, i10);
    if (t6) {
      if (c15 = B9(s9, c15), s9[c15] === ",") c15++;
      else if (s9[c15] !== t6) throw new T9("expected comma or end of structure", { toml: s9, ptr: c15 });
    }
    return [l8, c15];
  }
  let o9;
  if (r8 === '"' || r8 === "'") {
    o9 = vt3(s9, e7);
    let l8 = At4(s9, e7, o9);
    if (t6) {
      if (o9 = B9(s9, o9), s9[o9] && s9[o9] !== "," && s9[o9] !== t6 && s9[o9] !== `
` && s9[o9] !== "\r") throw new T9("unexpected character encountered", { toml: s9, ptr: o9 });
      o9 += +(s9[o9] === ",");
    }
    return [l8, o9];
  }
  o9 = Ui(s9, e7, ",", t6);
  let a7 = Kl(s9, e7, o9 - +(s9[o9 - 1] === ","));
  if (!a7[0]) throw new T9("incomplete key-value declaration: no value specified", { toml: s9, ptr: e7 });
  return t6 && a7[1] > -1 && (o9 = B9(s9, e7 + a7[1]), o9 += +(s9[o9] === ",")), [Wi(a7[0], s9, e7, i10), o9];
}
function Tt5(s9, e7, t6 = "=") {
  let n23 = e7 - 1, i10 = [], r8 = s9.indexOf(t6, e7);
  if (r8 < 0) throw new T9("incomplete key-value: cannot find end of key", { toml: s9, ptr: e7 });
  do {
    let o9 = s9[e7 = ++n23];
    if (o9 !== " " && o9 !== "	") if (o9 === '"' || o9 === "'") {
      if (o9 === s9[e7 + 1] && o9 === s9[e7 + 2]) throw new T9("multiline strings are not allowed in keys", { toml: s9, ptr: e7 });
      let a7 = vt3(s9, e7);
      if (a7 < 0) throw new T9("unfinished string encountered", { toml: s9, ptr: e7 });
      n23 = s9.indexOf(".", a7);
      let l8 = s9.slice(a7, n23 < 0 || n23 > r8 ? r8 : n23), c15 = Et4(l8);
      if (c15 > -1) throw new T9("newlines are not allowed in keys", { toml: s9, ptr: e7 + n23 + c15 });
      if (l8.trimStart()) throw new T9("found extra tokens after the string part", { toml: s9, ptr: a7 });
      if (r8 < a7 && (r8 = s9.indexOf(t6, a7), r8 < 0)) throw new T9("incomplete key-value: cannot find end of key", { toml: s9, ptr: e7 });
      i10.push(At4(s9, e7, a7));
    } else {
      n23 = s9.indexOf(".", e7);
      let a7 = s9.slice(e7, n23 < 0 || n23 > r8 ? r8 : n23);
      if (!Rl.test(a7)) throw new T9("only letter, numbers, dashes and underscores are allowed in keys", { toml: s9, ptr: e7 });
      i10.push(a7.trimEnd());
    }
  } while (n23 + 1 && n23 < r8);
  return [i10, B9(s9, r8 + 1, true, true)];
}
function Gi(s9, e7, t6, n23) {
  let i10 = {}, r8 = /* @__PURE__ */ new Set(), o9;
  for (e7++; (o9 = s9[e7++]) !== "}" && o9; ) {
    if (o9 === ",") throw new T9("expected value, found comma", { toml: s9, ptr: e7 - 1 });
    if (o9 === "#") e7 = we4(s9, e7);
    else if (o9 !== " " && o9 !== "	" && o9 !== `
` && o9 !== "\r") {
      let a7, l8 = i10, c15 = false, [u11, f11] = Tt5(s9, e7 - 1);
      for (let g18 = 0; g18 < u11.length; g18++) {
        if (g18 && (l8 = c15 ? l8[a7] : l8[a7] = {}), a7 = u11[g18], (c15 = Object.hasOwn(l8, a7)) && (typeof l8[a7] != "object" || r8.has(l8[a7]))) throw new T9("trying to redefine an already defined value", { toml: s9, ptr: e7 });
        !c15 && a7 === "__proto__" && Object.defineProperty(l8, a7, { enumerable: true, configurable: true, writable: true });
      }
      if (c15) throw new T9("trying to redefine an already defined value", { toml: s9, ptr: e7 });
      let [d16, p17] = Fe5(s9, f11, "}", t6 - 1, n23);
      r8.add(d16), l8[a7] = d16, e7 = p17;
    }
  }
  if (!o9) throw new T9("unfinished table encountered", { toml: s9, ptr: e7 });
  return [i10, e7];
}
function Xi(s9, e7, t6, n23) {
  let i10 = [], r8;
  for (e7++; (r8 = s9[e7++]) !== "]" && r8; ) {
    if (r8 === ",") throw new T9("expected value, found comma", { toml: s9, ptr: e7 - 1 });
    if (r8 === "#") e7 = we4(s9, e7);
    else if (r8 !== " " && r8 !== "	" && r8 !== `
` && r8 !== "\r") {
      let o9 = Fe5(s9, e7 - 1, "]", t6 - 1, n23);
      i10.push(o9[0]), e7 = o9[1];
    }
  }
  if (!r8) throw new T9("unfinished array encountered", { toml: s9, ptr: e7 });
  return [i10, e7];
}
function Qi(s9, e7, t6, n23) {
  let i10 = e7, r8 = t6, o9, a7 = false, l8;
  for (let c15 = 0; c15 < s9.length; c15++) {
    if (c15) {
      if (i10 = a7 ? i10[o9] : i10[o9] = {}, r8 = (l8 = r8[o9]).c, n23 === 0 && (l8.t === 1 || l8.t === 2)) return null;
      if (l8.t === 2) {
        let u11 = i10.length - 1;
        i10 = i10[u11], r8 = r8[u11].c;
      }
    }
    if (o9 = s9[c15], (a7 = Object.hasOwn(i10, o9)) && r8[o9]?.t === 0 && r8[o9]?.d) return null;
    a7 || (o9 === "__proto__" && (Object.defineProperty(i10, o9, { enumerable: true, configurable: true, writable: true }), Object.defineProperty(r8, o9, { enumerable: true, configurable: true, writable: true })), r8[o9] = { t: c15 < s9.length - 1 && n23 === 2 ? 3 : n23, d: false, i: 0, c: {} });
  }
  if (l8 = r8[o9], l8.t !== n23 && !(n23 === 1 && l8.t === 3) || (n23 === 2 && (l8.d || (l8.d = true, i10[o9] = []), i10[o9].push(i10 = {}), l8.c[l8.i++] = l8 = { t: 1, d: false, i: 0, c: {} }), l8.d)) return null;
  if (l8.d = true, n23 === 1) i10 = a7 ? i10[o9] : i10[o9] = {};
  else if (n23 === 0 && a7) return null;
  return [o9, i10, l8.c];
}
function Ot4(s9, { maxDepth: e7 = 1e3, integersAsBigInt: t6 } = {}) {
  let n23 = {}, i10 = {}, r8 = n23, o9 = i10;
  for (let a7 = B9(s9, 0); a7 < s9.length; ) {
    if (s9[a7] === "[") {
      let l8 = s9[++a7] === "[", c15 = Tt5(s9, a7 += +l8, "]");
      if (l8) {
        if (s9[c15[1] - 1] !== "]") throw new T9("expected end of table declaration", { toml: s9, ptr: c15[1] - 1 });
        c15[1]++;
      }
      let u11 = Qi(c15[0], n23, i10, l8 ? 2 : 1);
      if (!u11) throw new T9("trying to redefine an already defined table or value", { toml: s9, ptr: a7 });
      o9 = u11[2], r8 = u11[1], a7 = c15[1];
    } else {
      let l8 = Tt5(s9, a7), c15 = Qi(l8[0], r8, o9, 0);
      if (!c15) throw new T9("trying to redefine an already defined table or value", { toml: s9, ptr: a7 });
      let u11 = Fe5(s9, l8[1], void 0, e7, t6);
      c15[1][c15[0]] = u11[0], a7 = u11[1];
    }
    if (a7 = B9(s9, a7, true), s9[a7] && s9[a7] !== `
` && s9[a7] !== "\r") throw new T9("each key-value declaration must be followed by an end-of-line", { toml: s9, ptr: a7 });
    a7 = B9(s9, a7);
  }
  return n23;
}
function je6(s9) {
  let e7 = typeof s9;
  if (e7 === "object") {
    if (Array.isArray(s9)) return "array";
    if (s9 instanceof Date) return "date";
  }
  return e7;
}
function Yl(s9) {
  for (let e7 = 0; e7 < s9.length; e7++) if (je6(s9[e7]) !== "object") return false;
  return s9.length != 0;
}
function $s2(s9) {
  return JSON.stringify(s9).replace(/\x7f/g, "\\u007f");
}
function _s2(s9, e7, t6, n23) {
  if (t6 === 0) throw new Error("Could not stringify the object: maximum object depth exceeded");
  if (e7 === "number") return isNaN(s9) ? "nan" : s9 === 1 / 0 ? "inf" : s9 === -1 / 0 ? "-inf" : n23 && Number.isInteger(s9) ? s9.toFixed(1) : s9.toString();
  if (e7 === "bigint" || e7 === "boolean") return s9.toString();
  if (e7 === "string") return $s2(s9);
  if (e7 === "date") {
    if (isNaN(s9.getTime())) throw new TypeError("cannot serialize invalid date");
    return s9.toISOString();
  }
  if (e7 === "object") return Ul(s9, t6, n23);
  if (e7 === "array") return Jl(s9, t6, n23);
}
function Ul(s9, e7, t6) {
  let n23 = Object.keys(s9);
  if (n23.length === 0) return "{}";
  let i10 = "{ ";
  for (let r8 = 0; r8 < n23.length; r8++) {
    let o9 = n23[r8];
    r8 && (i10 += ", "), i10 += Hi.test(o9) ? o9 : $s2(o9), i10 += " = ", i10 += _s2(s9[o9], je6(s9[o9]), e7 - 1, t6);
  }
  return i10 + " }";
}
function Jl(s9, e7, t6) {
  if (s9.length === 0) return "[]";
  let n23 = "[ ";
  for (let i10 = 0; i10 < s9.length; i10++) {
    if (i10 && (n23 += ", "), s9[i10] === null || s9[i10] === void 0) throw new TypeError("arrays cannot contain null or undefined values");
    n23 += _s2(s9[i10], je6(s9[i10]), e7 - 1, t6);
  }
  return n23 + " ]";
}
function Wl(s9, e7, t6, n23) {
  if (t6 === 0) throw new Error("Could not stringify the object: maximum object depth exceeded");
  let i10 = "";
  for (let r8 = 0; r8 < s9.length; r8++) i10 += `${i10 && `
`}[[${e7}]]
`, i10 += xs2(0, s9[r8], e7, t6, n23);
  return i10;
}
function xs2(s9, e7, t6, n23, i10) {
  if (n23 === 0) throw new Error("Could not stringify the object: maximum object depth exceeded");
  let r8 = "", o9 = "", a7 = Object.keys(e7);
  for (let l8 = 0; l8 < a7.length; l8++) {
    let c15 = a7[l8];
    if (e7[c15] !== null && e7[c15] !== void 0) {
      let u11 = je6(e7[c15]);
      if (u11 === "symbol" || u11 === "function") throw new TypeError(`cannot serialize values of type '${u11}'`);
      let f11 = Hi.test(c15) ? c15 : $s2(c15);
      if (u11 === "array" && Yl(e7[c15])) o9 += (o9 && `
`) + Wl(e7[c15], t6 ? `${t6}.${f11}` : f11, n23 - 1, i10);
      else if (u11 === "object") {
        let d16 = t6 ? `${t6}.${f11}` : f11;
        o9 += (o9 && `
`) + xs2(d16, e7[c15], d16, n23 - 1, i10);
      } else r8 += f11, r8 += " = ", r8 += _s2(e7[c15], u11, n23, i10), r8 += `
`;
    }
  }
  return s9 && (r8 || !o9) && (r8 = r8 ? `[${s9}]
${r8}` : `[${s9}]`), r8 && o9 ? `${r8}
${o9}` : r8 || o9;
}
function Bs(s9, { maxDepth: e7 = 1e3, numbersAsFloat: t6 = false } = {}) {
  if (je6(s9) !== "object") throw new TypeError("stringify can only be called with an object");
  let n23 = xs2(0, s9, "", e7, t6);
  return n23[n23.length - 1] !== `
` ? n23 + `
` : n23;
}
function Si(s9) {
  return typeof s9 == "string" && Eh.includes(s9);
}
function Ni(s9) {
  return typeof s9 == "string" && vh.includes(s9);
}
function Ah(s9) {
  let e7 = s9.lastIndexOf("."), t6 = Math.max(s9.lastIndexOf("/"), s9.lastIndexOf("\\"));
  return e7 <= t6 + 1 ? "" : s9.slice(e7);
}
function Ka(s9) {
  switch (Ah(s9).toLowerCase()) {
    case ".yaml":
    case ".yml":
      return "yaml";
    case ".json":
      return "json";
    case ".xml":
      return "xml";
    case ".ini":
      return "ini";
    case ".csv":
    case ".tsv":
      return "csv";
    case ".toml":
      return "toml";
    default:
      return null;
  }
}
function Th(s9, e7, t6) {
  return wi.default.parse(s9, { delimiter: e7 || void 0, header: t6, dynamicTyping: true, skipEmptyLines: true }).data;
}
function Oh(s9, e7) {
  return Array.isArray(s9) || (s9 = [s9]), wi.default.unparse(s9, { delimiter: e7 || "," });
}
function Ei(s9, e7) {
  let t6 = s9.trim();
  if (!t6) return null;
  switch (e7.inputFormat) {
    case "yaml":
      return yt4.default.parse(t6);
    case "json":
      return JSON.parse(t6);
    case "xml":
      return new be5({ ignoreAttributes: false, attributeNamePrefix: e7.xmlAttributePrefix, textNodeName: e7.xmlContentName, parseAttributeValue: false, parseTagValue: false, trimValues: true, tagValueProcessor: (i10, r8) => r8 === "" ? null : r8 }).parse(t6);
    case "ini":
      return vs2.parse(t6);
    case "csv":
      return Th(t6, e7.csvDelimiter, e7.csvHeader);
    case "toml":
      return Ot4(t6);
    default: {
      let n23 = e7.inputFormat;
      throw new Error(`Invalid input format: ${n23}`);
    }
  }
}
function Ra(s9) {
  return yt4.default.parseAllDocuments(s9).map((t6) => t6.toJSON());
}
function Ya(s9) {
  let e7 = s9.trimStart();
  if (e7.startsWith("---")) {
    let t6 = e7.slice(3).match(/\n---(\n|$)/);
    if (t6 && t6.index !== void 0) {
      let n23 = e7.slice(3, t6.index + 3), i10 = e7.slice(t6.index + 3 + t6[0].length);
      return { frontMatter: yt4.default.parse(n23), content: i10 };
    }
  }
  if (e7.startsWith("+++")) {
    let t6 = e7.slice(3).match(/\n\+\+\+(\n|$)/);
    if (t6 && t6.index !== void 0) {
      let n23 = e7.slice(3, t6.index + 3), i10 = e7.slice(t6.index + 3 + t6[0].length);
      return { frontMatter: Ot4(n23), content: i10 };
    }
  }
  if (e7.startsWith("{{{")) {
    let t6 = e7.slice(3).match(/\n}}}(\n|$)/);
    if (t6 && t6.index !== void 0) {
      let n23 = e7.slice(3, t6.index + 3), i10 = e7.slice(t6.index + 3 + t6[0].length);
      return { frontMatter: JSON.parse(n23), content: i10 };
    }
  }
  return null;
}
function Ua(s9, e7) {
  if (s9 === void 0) return "";
  switch (e7.outputFormat) {
    case "yaml":
      return yt4.default.stringify(s9, { indent: e7.indent }).trimEnd();
    case "json":
      return e7.raw && typeof s9 == "string" ? s9 : e7.compact ? JSON.stringify(s9) : JSON.stringify(s9, null, e7.indent);
    case "xml":
      return new R8({ ignoreAttributes: false, attributeNamePrefix: e7.xmlAttributePrefix, textNodeName: e7.xmlContentName, format: e7.prettyPrint || !e7.compact, indentBy: " ".repeat(e7.indent) }).build(s9);
    case "ini":
      return !s9 || typeof s9 != "object" || Array.isArray(s9) ? "" : vs2.stringify(s9);
    case "csv":
      return Oh(s9, e7.csvDelimiter);
    case "toml":
      return !s9 || typeof s9 != "object" || Array.isArray(s9) ? "" : Bs(s9);
    default:
      throw new Error(`Unknown output format: ${e7.outputFormat}`);
  }
}
function Ih(s9) {
  let e7 = { ...Va, exitStatus: false, slurp: false, nullInput: false, joinOutput: false, inplace: false, frontMatter: false }, t6 = false, n23 = ".", i10 = false, r8 = [];
  for (let o9 = 0; o9 < s9.length; o9++) {
    let a7 = s9[o9];
    if (a7.startsWith("--input-format=")) {
      let l8 = a7.slice(15);
      if (!Si(l8)) return r3("yq", `--input-format=${l8}`);
      e7.inputFormat = l8, t6 = true;
    } else if (a7.startsWith("--output-format=")) {
      let l8 = a7.slice(16);
      if (!Ni(l8)) return r3("yq", `--output-format=${l8}`);
      e7.outputFormat = l8;
    } else if (a7.startsWith("--indent=")) e7.indent = Number.parseInt(a7.slice(9), 10);
    else if (a7.startsWith("--xml-attribute-prefix=")) e7.xmlAttributePrefix = a7.slice(23);
    else if (a7.startsWith("--xml-content-name=")) e7.xmlContentName = a7.slice(19);
    else if (a7.startsWith("--csv-delimiter=")) e7.csvDelimiter = a7.slice(16);
    else if (a7 === "--csv-header") e7.csvHeader = true;
    else if (a7 === "--no-csv-header") e7.csvHeader = false;
    else if (a7 === "-p" || a7 === "--input-format") {
      let l8 = s9[++o9];
      if (!Si(l8)) return r3("yq", `${a7} ${l8}`);
      e7.inputFormat = l8, t6 = true;
    } else if (a7 === "-o" || a7 === "--output-format") {
      let l8 = s9[++o9];
      if (!Ni(l8)) return r3("yq", `${a7} ${l8}`);
      e7.outputFormat = l8;
    } else if (a7 === "-I" || a7 === "--indent") e7.indent = Number.parseInt(s9[++o9], 10);
    else if (a7 === "-r" || a7 === "--raw-output") e7.raw = true;
    else if (a7 === "-c" || a7 === "--compact") e7.compact = true;
    else if (a7 === "-e" || a7 === "--exit-status") e7.exitStatus = true;
    else if (a7 === "-s" || a7 === "--slurp") e7.slurp = true;
    else if (a7 === "-n" || a7 === "--null-input") e7.nullInput = true;
    else if (a7 === "-j" || a7 === "--join-output") e7.joinOutput = true;
    else if (a7 === "-i" || a7 === "--inplace") e7.inplace = true;
    else if (a7 === "-f" || a7 === "--front-matter") e7.frontMatter = true;
    else if (a7 === "-P" || a7 === "--prettyPrint") e7.prettyPrint = true;
    else if (a7 === "-") r8.push("-");
    else {
      if (a7.startsWith("--")) return r3("yq", a7);
      if (a7.startsWith("-")) for (let l8 of a7.slice(1)) if (l8 === "r") e7.raw = true;
      else if (l8 === "c") e7.compact = true;
      else if (l8 === "e") e7.exitStatus = true;
      else if (l8 === "s") e7.slurp = true;
      else if (l8 === "n") e7.nullInput = true;
      else if (l8 === "j") e7.joinOutput = true;
      else if (l8 === "i") e7.inplace = true;
      else if (l8 === "f") e7.frontMatter = true;
      else if (l8 === "P") e7.prettyPrint = true;
      else return r3("yq", `-${l8}`);
      else i10 ? r8.push(a7) : (n23 = a7, i10 = true);
    }
  }
  return { options: e7, filter: n23, files: r8, inputFormatExplicit: t6 };
}
var Yi, O13, Ve5, Ks, Lt3, Rs2, D14, Pt3, Ue4, C17, Je5, _t3, We5, Sr2, Qe5, He5, Tr2, en2, Ut2, nn2, te8, on2, ne7, Ae6, ie4, Te4, et6, zt2, fn2, Oe4, dn2, pn2, Hr2, Zr2, bn3, rs2, En2, co, fo, ho, kn2, qn2, bo, Io, Bn2, Lo, at5, ft5, ut5, ms2, Jn2, Wn2, Yo, Jo, qe4, Ho, zo, Dn2, Zn2, ia, oa, ca, da2, ni, ba, Sa, Aa, ws2, hi2, mi, yi, Ba, ja, ki, Wa, Ga, Xa, ye5, Qa, Ha, Da, Za, il, $i2, St4, V10, $e5, x22, rl, ol, al, ll, xe8, ml, yl2, wl, qs2, be5, ql, vs2, wi, T9, xl, Be4, Bl, Fl, jl, Vl, Ji, Rl, Hi, yt4, Eh, vh, Va, kh, ig, rg;
var init_chunk_XMDVFEVC = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-XMDVFEVC.js"() {
    init_chunk_SYMJJMQ4();
    init_chunk_FRDGR5VK();
    init_chunk_PSW6BMXW();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
    Yi = o((rp, Ri2) => {
      var { hasOwnProperty: Ps3 } = Object.prototype, Ms3 = (s9, e7 = {}) => {
        typeof e7 == "string" && (e7 = { section: e7 }), e7.align = e7.align === true, e7.newline = e7.newline === true, e7.sort = e7.sort === true, e7.whitespace = e7.whitespace === true || e7.align === true, e7.platform = e7.platform || typeof process < "u" && process.platform, e7.bracketedArray = e7.bracketedArray !== false;
        let t6 = e7.platform === "win32" ? `\r
` : `
`, n23 = e7.whitespace ? " = " : "=", i10 = [], r8 = e7.sort ? Object.keys(s9).sort() : Object.keys(s9), o9 = 0;
        e7.align && (o9 = G9(r8.filter((c15) => s9[c15] === null || Array.isArray(s9[c15]) || typeof s9[c15] != "object").map((c15) => Array.isArray(s9[c15]) ? `${c15}[]` : c15).concat([""]).reduce((c15, u11) => G9(c15).length >= G9(u11).length ? c15 : u11)).length);
        let a7 = "", l8 = e7.bracketedArray ? "[]" : "";
        for (let c15 of r8) {
          let u11 = s9[c15];
          if (u11 && Array.isArray(u11)) for (let f11 of u11) a7 += G9(`${c15}${l8}`).padEnd(o9, " ") + n23 + G9(f11) + t6;
          else u11 && typeof u11 == "object" ? i10.push(c15) : a7 += G9(c15).padEnd(o9, " ") + n23 + G9(u11) + t6;
        }
        e7.section && a7.length && (a7 = "[" + G9(e7.section) + "]" + (e7.newline ? t6 + t6 : t6) + a7);
        for (let c15 of i10) {
          let u11 = Vi3(c15, ".").join("\\."), f11 = (e7.section ? e7.section + "." : "") + u11, d16 = Ms3(s9[c15], { ...e7, section: f11 });
          a7.length && d16.length && (a7 += t6), a7 += d16;
        }
        return a7;
      };
      function Vi3(s9, e7) {
        var t6 = 0, n23 = 0, i10 = 0, r8 = [];
        do
          if (i10 = s9.indexOf(e7, t6), i10 !== -1) {
            if (t6 = i10 + e7.length, i10 > 0 && s9[i10 - 1] === "\\") continue;
            r8.push(s9.slice(n23, i10)), n23 = i10 + e7.length;
          }
        while (i10 !== -1);
        return r8.push(s9.slice(n23)), r8;
      }
      var ji2 = (s9, e7 = {}) => {
        e7.bracketedArray = e7.bracketedArray !== false;
        let t6 = /* @__PURE__ */ Object.create(null), n23 = t6, i10 = null, r8 = /^\[([^\]]*)\]\s*$|^([^=]+)(=(.*))?$/i, o9 = s9.split(/[\r\n]+/g), a7 = {};
        for (let c15 of o9) {
          if (!c15 || c15.match(/^\s*[;#]/) || c15.match(/^\s*$/)) continue;
          let u11 = c15.match(r8);
          if (!u11) continue;
          if (u11[1] !== void 0) {
            if (i10 = Nt5(u11[1]), i10 === "__proto__") {
              n23 = /* @__PURE__ */ Object.create(null);
              continue;
            }
            n23 = t6[i10] = t6[i10] || /* @__PURE__ */ Object.create(null);
            continue;
          }
          let f11 = Nt5(u11[2]), d16;
          e7.bracketedArray ? d16 = f11.length > 2 && f11.slice(-2) === "[]" : (a7[f11] = (a7?.[f11] || 0) + 1, d16 = a7[f11] > 1);
          let p17 = d16 && f11.endsWith("[]") ? f11.slice(0, -2) : f11;
          if (p17 === "__proto__") continue;
          let g18 = u11[3] ? Nt5(u11[4]) : true, h17 = g18 === "true" || g18 === "false" || g18 === "null" ? JSON.parse(g18) : g18;
          d16 && (Ps3.call(n23, p17) ? Array.isArray(n23[p17]) || (n23[p17] = [n23[p17]]) : n23[p17] = []), Array.isArray(n23[p17]) ? n23[p17].push(h17) : n23[p17] = h17;
        }
        let l8 = [];
        for (let c15 of Object.keys(t6)) {
          if (!Ps3.call(t6, c15) || typeof t6[c15] != "object" || Array.isArray(t6[c15])) continue;
          let u11 = Vi3(c15, ".");
          n23 = t6;
          let f11 = u11.pop(), d16 = f11.replace(/\\\./g, ".");
          for (let p17 of u11) p17 !== "__proto__" && ((!Ps3.call(n23, p17) || typeof n23[p17] != "object") && (n23[p17] = /* @__PURE__ */ Object.create(null)), n23 = n23[p17]);
          n23 === t6 && d16 === f11 || (n23[d16] = t6[c15], l8.push(c15));
        }
        for (let c15 of l8) delete t6[c15];
        return t6;
      }, Ki2 = (s9) => s9.startsWith('"') && s9.endsWith('"') || s9.startsWith("'") && s9.endsWith("'"), G9 = (s9) => typeof s9 != "string" || s9.match(/[=\r\n]/) || s9.match(/^\[/) || s9.length > 1 && Ki2(s9) || s9 !== s9.trim() ? JSON.stringify(s9) : s9.split(";").join("\\;").split("#").join("\\#"), Nt5 = (s9) => {
        if (s9 = (s9 || "").trim(), Ki2(s9)) {
          s9.charAt(0) === "'" && (s9 = s9.slice(1, -1));
          try {
            s9 = JSON.parse(s9);
          } catch {
          }
        } else {
          let e7 = false, t6 = "";
          for (let n23 = 0, i10 = s9.length; n23 < i10; n23++) {
            let r8 = s9.charAt(n23);
            if (e7) "\\;#".indexOf(r8) !== -1 ? t6 += r8 : t6 += "\\" + r8, e7 = false;
            else {
              if (";#".indexOf(r8) !== -1) break;
              r8 === "\\" ? e7 = true : t6 += r8;
            }
          }
          return e7 && (t6 += "\\"), t6.trim();
        }
        return s9;
      };
      Ri2.exports = { parse: ji2, decode: ji2, stringify: Ms3, encode: Ms3, safe: G9, unsafe: Nt5 };
    });
    O13 = o(($18) => {
      "use strict";
      var Fs2 = Symbol.for("yaml.alias"), Di3 = Symbol.for("yaml.document"), kt4 = Symbol.for("yaml.map"), zi2 = Symbol.for("yaml.pair"), js2 = Symbol.for("yaml.scalar"), It3 = Symbol.for("yaml.seq"), X10 = Symbol.for("yaml.node.type"), Xl = (s9) => !!s9 && typeof s9 == "object" && s9[X10] === Fs2, Ql = (s9) => !!s9 && typeof s9 == "object" && s9[X10] === Di3, Hl = (s9) => !!s9 && typeof s9 == "object" && s9[X10] === kt4, Dl = (s9) => !!s9 && typeof s9 == "object" && s9[X10] === zi2, Zi2 = (s9) => !!s9 && typeof s9 == "object" && s9[X10] === js2, zl = (s9) => !!s9 && typeof s9 == "object" && s9[X10] === It3;
      function er3(s9) {
        if (s9 && typeof s9 == "object") switch (s9[X10]) {
          case kt4:
          case It3:
            return true;
        }
        return false;
      }
      function Zl(s9) {
        if (s9 && typeof s9 == "object") switch (s9[X10]) {
          case Fs2:
          case kt4:
          case js2:
          case It3:
            return true;
        }
        return false;
      }
      var ec = (s9) => (Zi2(s9) || er3(s9)) && !!s9.anchor;
      $18.ALIAS = Fs2;
      $18.DOC = Di3;
      $18.MAP = kt4;
      $18.NODE_TYPE = X10;
      $18.PAIR = zi2;
      $18.SCALAR = js2;
      $18.SEQ = It3;
      $18.hasAnchor = ec;
      $18.isAlias = Xl;
      $18.isCollection = er3;
      $18.isDocument = Ql;
      $18.isMap = Hl;
      $18.isNode = Zl;
      $18.isPair = Dl;
      $18.isScalar = Zi2;
      $18.isSeq = zl;
    });
    Ve5 = o((Vs3) => {
      "use strict";
      var M15 = O13(), F21 = Symbol("break visit"), tr3 = Symbol("skip children"), J15 = Symbol("remove node");
      function qt4(s9, e7) {
        let t6 = sr3(e7);
        M15.isDocument(s9) ? Se6(null, s9.contents, t6, Object.freeze([s9])) === J15 && (s9.contents = null) : Se6(null, s9, t6, Object.freeze([]));
      }
      qt4.BREAK = F21;
      qt4.SKIP = tr3;
      qt4.REMOVE = J15;
      function Se6(s9, e7, t6, n23) {
        let i10 = nr3(s9, e7, t6, n23);
        if (M15.isNode(i10) || M15.isPair(i10)) return ir3(s9, n23, i10), Se6(s9, i10, t6, n23);
        if (typeof i10 != "symbol") {
          if (M15.isCollection(e7)) {
            n23 = Object.freeze(n23.concat(e7));
            for (let r8 = 0; r8 < e7.items.length; ++r8) {
              let o9 = Se6(r8, e7.items[r8], t6, n23);
              if (typeof o9 == "number") r8 = o9 - 1;
              else {
                if (o9 === F21) return F21;
                o9 === J15 && (e7.items.splice(r8, 1), r8 -= 1);
              }
            }
          } else if (M15.isPair(e7)) {
            n23 = Object.freeze(n23.concat(e7));
            let r8 = Se6("key", e7.key, t6, n23);
            if (r8 === F21) return F21;
            r8 === J15 && (e7.key = null);
            let o9 = Se6("value", e7.value, t6, n23);
            if (o9 === F21) return F21;
            o9 === J15 && (e7.value = null);
          }
        }
        return i10;
      }
      async function Ct5(s9, e7) {
        let t6 = sr3(e7);
        M15.isDocument(s9) ? await Ne6(null, s9.contents, t6, Object.freeze([s9])) === J15 && (s9.contents = null) : await Ne6(null, s9, t6, Object.freeze([]));
      }
      Ct5.BREAK = F21;
      Ct5.SKIP = tr3;
      Ct5.REMOVE = J15;
      async function Ne6(s9, e7, t6, n23) {
        let i10 = await nr3(s9, e7, t6, n23);
        if (M15.isNode(i10) || M15.isPair(i10)) return ir3(s9, n23, i10), Ne6(s9, i10, t6, n23);
        if (typeof i10 != "symbol") {
          if (M15.isCollection(e7)) {
            n23 = Object.freeze(n23.concat(e7));
            for (let r8 = 0; r8 < e7.items.length; ++r8) {
              let o9 = await Ne6(r8, e7.items[r8], t6, n23);
              if (typeof o9 == "number") r8 = o9 - 1;
              else {
                if (o9 === F21) return F21;
                o9 === J15 && (e7.items.splice(r8, 1), r8 -= 1);
              }
            }
          } else if (M15.isPair(e7)) {
            n23 = Object.freeze(n23.concat(e7));
            let r8 = await Ne6("key", e7.key, t6, n23);
            if (r8 === F21) return F21;
            r8 === J15 && (e7.key = null);
            let o9 = await Ne6("value", e7.value, t6, n23);
            if (o9 === F21) return F21;
            o9 === J15 && (e7.value = null);
          }
        }
        return i10;
      }
      function sr3(s9) {
        return typeof s9 == "object" && (s9.Collection || s9.Node || s9.Value) ? Object.assign({ Alias: s9.Node, Map: s9.Node, Scalar: s9.Node, Seq: s9.Node }, s9.Value && { Map: s9.Value, Scalar: s9.Value, Seq: s9.Value }, s9.Collection && { Map: s9.Collection, Seq: s9.Collection }, s9) : s9;
      }
      function nr3(s9, e7, t6, n23) {
        if (typeof t6 == "function") return t6(s9, e7, n23);
        if (M15.isMap(e7)) return t6.Map?.(s9, e7, n23);
        if (M15.isSeq(e7)) return t6.Seq?.(s9, e7, n23);
        if (M15.isPair(e7)) return t6.Pair?.(s9, e7, n23);
        if (M15.isScalar(e7)) return t6.Scalar?.(s9, e7, n23);
        if (M15.isAlias(e7)) return t6.Alias?.(s9, e7, n23);
      }
      function ir3(s9, e7, t6) {
        let n23 = e7[e7.length - 1];
        if (M15.isCollection(n23)) n23.items[s9] = t6;
        else if (M15.isPair(n23)) s9 === "key" ? n23.key = t6 : n23.value = t6;
        else if (M15.isDocument(n23)) n23.contents = t6;
        else {
          let i10 = M15.isAlias(n23) ? "alias" : "scalar";
          throw new Error(`Cannot replace node with ${i10} parent`);
        }
      }
      Vs3.visit = qt4;
      Vs3.visitAsync = Ct5;
    });
    Ks = o((or3) => {
      "use strict";
      var rr3 = O13(), tc = Ve5(), sc = { "!": "%21", ",": "%2C", "[": "%5B", "]": "%5D", "{": "%7B", "}": "%7D" }, nc = (s9) => s9.replace(/[!,[\]{}]/g, (e7) => sc[e7]), Ke7 = class s9 {
        constructor(e7, t6) {
          this.docStart = null, this.docEnd = false, this.yaml = Object.assign({}, s9.defaultYaml, e7), this.tags = Object.assign({}, s9.defaultTags, t6);
        }
        clone() {
          let e7 = new s9(this.yaml, this.tags);
          return e7.docStart = this.docStart, e7;
        }
        atDocument() {
          let e7 = new s9(this.yaml, this.tags);
          switch (this.yaml.version) {
            case "1.1":
              this.atNextDocument = true;
              break;
            case "1.2":
              this.atNextDocument = false, this.yaml = { explicit: s9.defaultYaml.explicit, version: "1.2" }, this.tags = Object.assign({}, s9.defaultTags);
              break;
          }
          return e7;
        }
        add(e7, t6) {
          this.atNextDocument && (this.yaml = { explicit: s9.defaultYaml.explicit, version: "1.1" }, this.tags = Object.assign({}, s9.defaultTags), this.atNextDocument = false);
          let n23 = e7.trim().split(/[ \t]+/), i10 = n23.shift();
          switch (i10) {
            case "%TAG": {
              if (n23.length !== 2 && (t6(0, "%TAG directive should contain exactly two parts"), n23.length < 2)) return false;
              let [r8, o9] = n23;
              return this.tags[r8] = o9, true;
            }
            case "%YAML": {
              if (this.yaml.explicit = true, n23.length !== 1) return t6(0, "%YAML directive should contain exactly one part"), false;
              let [r8] = n23;
              if (r8 === "1.1" || r8 === "1.2") return this.yaml.version = r8, true;
              {
                let o9 = /^\d+\.\d+$/.test(r8);
                return t6(6, `Unsupported YAML version ${r8}`, o9), false;
              }
            }
            default:
              return t6(0, `Unknown directive ${i10}`, true), false;
          }
        }
        tagName(e7, t6) {
          if (e7 === "!") return "!";
          if (e7[0] !== "!") return t6(`Not a valid tag: ${e7}`), null;
          if (e7[1] === "<") {
            let o9 = e7.slice(2, -1);
            return o9 === "!" || o9 === "!!" ? (t6(`Verbatim tags aren't resolved, so ${e7} is invalid.`), null) : (e7[e7.length - 1] !== ">" && t6("Verbatim tags must end with a >"), o9);
          }
          let [, n23, i10] = e7.match(/^(.*!)([^!]*)$/s);
          i10 || t6(`The ${e7} tag has no suffix`);
          let r8 = this.tags[n23];
          if (r8) try {
            return r8 + decodeURIComponent(i10);
          } catch (o9) {
            return t6(String(o9)), null;
          }
          return n23 === "!" ? e7 : (t6(`Could not resolve tag: ${e7}`), null);
        }
        tagString(e7) {
          for (let [t6, n23] of Object.entries(this.tags)) if (e7.startsWith(n23)) return t6 + nc(e7.substring(n23.length));
          return e7[0] === "!" ? e7 : `!<${e7}>`;
        }
        toString(e7) {
          let t6 = this.yaml.explicit ? [`%YAML ${this.yaml.version || "1.2"}`] : [], n23 = Object.entries(this.tags), i10;
          if (e7 && n23.length > 0 && rr3.isNode(e7.contents)) {
            let r8 = {};
            tc.visit(e7.contents, (o9, a7) => {
              rr3.isNode(a7) && a7.tag && (r8[a7.tag] = true);
            }), i10 = Object.keys(r8);
          } else i10 = [];
          for (let [r8, o9] of n23) r8 === "!!" && o9 === "tag:yaml.org,2002:" || (!e7 || i10.some((a7) => a7.startsWith(o9))) && t6.push(`%TAG ${r8} ${o9}`);
          return t6.join(`
`);
        }
      };
      Ke7.defaultYaml = { explicit: false, version: "1.2" };
      Ke7.defaultTags = { "!!": "tag:yaml.org,2002:" };
      or3.Directives = Ke7;
    });
    Lt3 = o((Re8) => {
      "use strict";
      var ar3 = O13(), ic = Ve5();
      function rc(s9) {
        if (/[\x00-\x19\s,[\]{}]/.test(s9)) {
          let t6 = `Anchor must not contain whitespace or control characters: ${JSON.stringify(s9)}`;
          throw new Error(t6);
        }
        return true;
      }
      function lr3(s9) {
        let e7 = /* @__PURE__ */ new Set();
        return ic.visit(s9, { Value(t6, n23) {
          n23.anchor && e7.add(n23.anchor);
        } }), e7;
      }
      function cr3(s9, e7) {
        for (let t6 = 1; ; ++t6) {
          let n23 = `${s9}${t6}`;
          if (!e7.has(n23)) return n23;
        }
      }
      function oc(s9, e7) {
        let t6 = [], n23 = /* @__PURE__ */ new Map(), i10 = null;
        return { onAnchor: (r8) => {
          t6.push(r8), i10 ?? (i10 = lr3(s9));
          let o9 = cr3(e7, i10);
          return i10.add(o9), o9;
        }, setAnchors: () => {
          for (let r8 of t6) {
            let o9 = n23.get(r8);
            if (typeof o9 == "object" && o9.anchor && (ar3.isScalar(o9.node) || ar3.isCollection(o9.node))) o9.node.anchor = o9.anchor;
            else {
              let a7 = new Error("Failed to resolve repeated object (this should not happen)");
              throw a7.source = r8, a7;
            }
          }
        }, sourceObjects: n23 };
      }
      Re8.anchorIsValid = rc;
      Re8.anchorNames = lr3;
      Re8.createNodeAnchors = oc;
      Re8.findNewAnchor = cr3;
    });
    Rs2 = o((fr3) => {
      "use strict";
      function Ye6(s9, e7, t6, n23) {
        if (n23 && typeof n23 == "object") if (Array.isArray(n23)) for (let i10 = 0, r8 = n23.length; i10 < r8; ++i10) {
          let o9 = n23[i10], a7 = Ye6(s9, n23, String(i10), o9);
          a7 === void 0 ? delete n23[i10] : a7 !== o9 && (n23[i10] = a7);
        }
        else if (n23 instanceof Map) for (let i10 of Array.from(n23.keys())) {
          let r8 = n23.get(i10), o9 = Ye6(s9, n23, i10, r8);
          o9 === void 0 ? n23.delete(i10) : o9 !== r8 && n23.set(i10, o9);
        }
        else if (n23 instanceof Set) for (let i10 of Array.from(n23)) {
          let r8 = Ye6(s9, n23, i10, i10);
          r8 === void 0 ? n23.delete(i10) : r8 !== i10 && (n23.delete(i10), n23.add(r8));
        }
        else for (let [i10, r8] of Object.entries(n23)) {
          let o9 = Ye6(s9, n23, i10, r8);
          o9 === void 0 ? delete n23[i10] : o9 !== r8 && (n23[i10] = o9);
        }
        return s9.call(e7, t6, n23);
      }
      fr3.applyReviver = Ye6;
    });
    D14 = o((dr4) => {
      "use strict";
      var ac = O13();
      function ur4(s9, e7, t6) {
        if (Array.isArray(s9)) return s9.map((n23, i10) => ur4(n23, String(i10), t6));
        if (s9 && typeof s9.toJSON == "function") {
          if (!t6 || !ac.hasAnchor(s9)) return s9.toJSON(e7, t6);
          let n23 = { aliasCount: 0, count: 1, res: void 0 };
          t6.anchors.set(s9, n23), t6.onCreate = (r8) => {
            n23.res = r8, delete t6.onCreate;
          };
          let i10 = s9.toJSON(e7, t6);
          return t6.onCreate && t6.onCreate(i10), i10;
        }
        return typeof s9 == "bigint" && !t6?.keep ? Number(s9) : s9;
      }
      dr4.toJS = ur4;
    });
    Pt3 = o((pr3) => {
      "use strict";
      var lc = Rs2(), hr3 = O13(), cc = D14(), Ys2 = class {
        constructor(e7) {
          Object.defineProperty(this, hr3.NODE_TYPE, { value: e7 });
        }
        clone() {
          let e7 = Object.create(Object.getPrototypeOf(this), Object.getOwnPropertyDescriptors(this));
          return this.range && (e7.range = this.range.slice()), e7;
        }
        toJS(e7, { mapAsMap: t6, maxAliasCount: n23, onAnchor: i10, reviver: r8 } = {}) {
          if (!hr3.isDocument(e7)) throw new TypeError("A document argument is required");
          let o9 = { anchors: /* @__PURE__ */ new Map(), doc: e7, keep: true, mapAsMap: t6 === true, mapKeyWarned: false, maxAliasCount: typeof n23 == "number" ? n23 : 100 }, a7 = cc.toJS(this, "", o9);
          if (typeof i10 == "function") for (let { count: l8, res: c15 } of o9.anchors.values()) i10(c15, l8);
          return typeof r8 == "function" ? lc.applyReviver(r8, { "": a7 }, "", a7) : a7;
        }
      };
      pr3.NodeBase = Ys2;
    });
    Ue4 = o((mr3) => {
      "use strict";
      var fc = Lt3(), uc = Ve5(), Ee7 = O13(), dc = Pt3(), hc = D14(), Us2 = class extends dc.NodeBase {
        constructor(e7) {
          super(Ee7.ALIAS), this.source = e7, Object.defineProperty(this, "tag", { set() {
            throw new Error("Alias nodes cannot have tags");
          } });
        }
        resolve(e7, t6) {
          let n23;
          t6?.aliasResolveCache ? n23 = t6.aliasResolveCache : (n23 = [], uc.visit(e7, { Node: (r8, o9) => {
            (Ee7.isAlias(o9) || Ee7.hasAnchor(o9)) && n23.push(o9);
          } }), t6 && (t6.aliasResolveCache = n23));
          let i10;
          for (let r8 of n23) {
            if (r8 === this) break;
            r8.anchor === this.source && (i10 = r8);
          }
          return i10;
        }
        toJSON(e7, t6) {
          if (!t6) return { source: this.source };
          let { anchors: n23, doc: i10, maxAliasCount: r8 } = t6, o9 = this.resolve(i10, t6);
          if (!o9) {
            let l8 = `Unresolved alias (the anchor must be set before the alias): ${this.source}`;
            throw new ReferenceError(l8);
          }
          let a7 = n23.get(o9);
          if (a7 || (hc.toJS(o9, null, t6), a7 = n23.get(o9)), a7?.res === void 0) {
            let l8 = "This should not happen: Alias anchor was not resolved?";
            throw new ReferenceError(l8);
          }
          if (r8 >= 0 && (a7.count += 1, a7.aliasCount === 0 && (a7.aliasCount = Mt4(i10, o9, n23)), a7.count * a7.aliasCount > r8)) {
            let l8 = "Excessive alias count indicates a resource exhaustion attack";
            throw new ReferenceError(l8);
          }
          return a7.res;
        }
        toString(e7, t6, n23) {
          let i10 = `*${this.source}`;
          if (e7) {
            if (fc.anchorIsValid(this.source), e7.options.verifyAliasOrder && !e7.anchors.has(this.source)) {
              let r8 = `Unresolved alias (the anchor must be set before the alias): ${this.source}`;
              throw new Error(r8);
            }
            if (e7.implicitKey) return `${i10} `;
          }
          return i10;
        }
      };
      function Mt4(s9, e7, t6) {
        if (Ee7.isAlias(e7)) {
          let n23 = e7.resolve(s9), i10 = t6 && n23 && t6.get(n23);
          return i10 ? i10.count * i10.aliasCount : 0;
        } else if (Ee7.isCollection(e7)) {
          let n23 = 0;
          for (let i10 of e7.items) {
            let r8 = Mt4(s9, i10, t6);
            r8 > n23 && (n23 = r8);
          }
          return n23;
        } else if (Ee7.isPair(e7)) {
          let n23 = Mt4(s9, e7.key, t6), i10 = Mt4(s9, e7.value, t6);
          return Math.max(n23, i10);
        }
        return 1;
      }
      mr3.Alias = Us2;
    });
    C17 = o((Js2) => {
      "use strict";
      var pc = O13(), mc = Pt3(), gc = D14(), yc = (s9) => !s9 || typeof s9 != "function" && typeof s9 != "object", z10 = class extends mc.NodeBase {
        constructor(e7) {
          super(pc.SCALAR), this.value = e7;
        }
        toJSON(e7, t6) {
          return t6?.keep ? this.value : gc.toJS(this.value, e7, t6);
        }
        toString() {
          return String(this.value);
        }
      };
      z10.BLOCK_FOLDED = "BLOCK_FOLDED";
      z10.BLOCK_LITERAL = "BLOCK_LITERAL";
      z10.PLAIN = "PLAIN";
      z10.QUOTE_DOUBLE = "QUOTE_DOUBLE";
      z10.QUOTE_SINGLE = "QUOTE_SINGLE";
      Js2.Scalar = z10;
      Js2.isScalarValue = yc;
    });
    Je5 = o((yr3) => {
      "use strict";
      var bc = Ue4(), fe10 = O13(), gr3 = C17(), wc = "tag:yaml.org,2002:";
      function Sc(s9, e7, t6) {
        if (e7) {
          let n23 = t6.filter((r8) => r8.tag === e7), i10 = n23.find((r8) => !r8.format) ?? n23[0];
          if (!i10) throw new Error(`Tag ${e7} not found`);
          return i10;
        }
        return t6.find((n23) => n23.identify?.(s9) && !n23.format);
      }
      function Nc(s9, e7, t6) {
        if (fe10.isDocument(s9) && (s9 = s9.contents), fe10.isNode(s9)) return s9;
        if (fe10.isPair(s9)) {
          let f11 = t6.schema[fe10.MAP].createNode?.(t6.schema, null, t6);
          return f11.items.push(s9), f11;
        }
        (s9 instanceof String || s9 instanceof Number || s9 instanceof Boolean || typeof BigInt < "u" && s9 instanceof BigInt) && (s9 = s9.valueOf());
        let { aliasDuplicateObjects: n23, onAnchor: i10, onTagObj: r8, schema: o9, sourceObjects: a7 } = t6, l8;
        if (n23 && s9 && typeof s9 == "object") {
          if (l8 = a7.get(s9), l8) return l8.anchor ?? (l8.anchor = i10(s9)), new bc.Alias(l8.anchor);
          l8 = { anchor: null, node: null }, a7.set(s9, l8);
        }
        e7?.startsWith("!!") && (e7 = wc + e7.slice(2));
        let c15 = Sc(s9, e7, o9.tags);
        if (!c15) {
          if (s9 && typeof s9.toJSON == "function" && (s9 = s9.toJSON()), !s9 || typeof s9 != "object") {
            let f11 = new gr3.Scalar(s9);
            return l8 && (l8.node = f11), f11;
          }
          c15 = s9 instanceof Map ? o9[fe10.MAP] : Symbol.iterator in Object(s9) ? o9[fe10.SEQ] : o9[fe10.MAP];
        }
        r8 && (r8(c15), delete t6.onTagObj);
        let u11 = c15?.createNode ? c15.createNode(t6.schema, s9, t6) : typeof c15?.nodeClass?.from == "function" ? c15.nodeClass.from(t6.schema, s9, t6) : new gr3.Scalar(s9);
        return e7 ? u11.tag = e7 : c15.default || (u11.tag = c15.tag), l8 && (l8.node = u11), u11;
      }
      yr3.createNode = Nc;
    });
    _t3 = o(($t4) => {
      "use strict";
      var Ec = Je5(), W15 = O13(), vc = Pt3();
      function Ws3(s9, e7, t6) {
        let n23 = t6;
        for (let i10 = e7.length - 1; i10 >= 0; --i10) {
          let r8 = e7[i10];
          if (typeof r8 == "number" && Number.isInteger(r8) && r8 >= 0) {
            let o9 = [];
            o9[r8] = n23, n23 = o9;
          } else n23 = /* @__PURE__ */ new Map([[r8, n23]]);
        }
        return Ec.createNode(n23, void 0, { aliasDuplicateObjects: false, keepUndefined: false, onAnchor: () => {
          throw new Error("This should not happen, please report a bug.");
        }, schema: s9, sourceObjects: /* @__PURE__ */ new Map() });
      }
      var br3 = (s9) => s9 == null || typeof s9 == "object" && !!s9[Symbol.iterator]().next().done, Gs2 = class extends vc.NodeBase {
        constructor(e7, t6) {
          super(e7), Object.defineProperty(this, "schema", { value: t6, configurable: true, enumerable: false, writable: true });
        }
        clone(e7) {
          let t6 = Object.create(Object.getPrototypeOf(this), Object.getOwnPropertyDescriptors(this));
          return e7 && (t6.schema = e7), t6.items = t6.items.map((n23) => W15.isNode(n23) || W15.isPair(n23) ? n23.clone(e7) : n23), this.range && (t6.range = this.range.slice()), t6;
        }
        addIn(e7, t6) {
          if (br3(e7)) this.add(t6);
          else {
            let [n23, ...i10] = e7, r8 = this.get(n23, true);
            if (W15.isCollection(r8)) r8.addIn(i10, t6);
            else if (r8 === void 0 && this.schema) this.set(n23, Ws3(this.schema, i10, t6));
            else throw new Error(`Expected YAML collection at ${n23}. Remaining path: ${i10}`);
          }
        }
        deleteIn(e7) {
          let [t6, ...n23] = e7;
          if (n23.length === 0) return this.delete(t6);
          let i10 = this.get(t6, true);
          if (W15.isCollection(i10)) return i10.deleteIn(n23);
          throw new Error(`Expected YAML collection at ${t6}. Remaining path: ${n23}`);
        }
        getIn(e7, t6) {
          let [n23, ...i10] = e7, r8 = this.get(n23, true);
          return i10.length === 0 ? !t6 && W15.isScalar(r8) ? r8.value : r8 : W15.isCollection(r8) ? r8.getIn(i10, t6) : void 0;
        }
        hasAllNullValues(e7) {
          return this.items.every((t6) => {
            if (!W15.isPair(t6)) return false;
            let n23 = t6.value;
            return n23 == null || e7 && W15.isScalar(n23) && n23.value == null && !n23.commentBefore && !n23.comment && !n23.tag;
          });
        }
        hasIn(e7) {
          let [t6, ...n23] = e7;
          if (n23.length === 0) return this.has(t6);
          let i10 = this.get(t6, true);
          return W15.isCollection(i10) ? i10.hasIn(n23) : false;
        }
        setIn(e7, t6) {
          let [n23, ...i10] = e7;
          if (i10.length === 0) this.set(n23, t6);
          else {
            let r8 = this.get(n23, true);
            if (W15.isCollection(r8)) r8.setIn(i10, t6);
            else if (r8 === void 0 && this.schema) this.set(n23, Ws3(this.schema, i10, t6));
            else throw new Error(`Expected YAML collection at ${n23}. Remaining path: ${i10}`);
          }
        }
      };
      $t4.Collection = Gs2;
      $t4.collectionFromPath = Ws3;
      $t4.isEmptyPath = br3;
    });
    We5 = o((xt3) => {
      "use strict";
      var Ac = (s9) => s9.replace(/^(?!$)(?: $)?/gm, "#");
      function Xs2(s9, e7) {
        return /^\n+$/.test(s9) ? s9.substring(1) : e7 ? s9.replace(/^(?! *$)/gm, e7) : s9;
      }
      var Tc = (s9, e7, t6) => s9.endsWith(`
`) ? Xs2(t6, e7) : t6.includes(`
`) ? `
` + Xs2(t6, e7) : (s9.endsWith(" ") ? "" : " ") + t6;
      xt3.indentComment = Xs2;
      xt3.lineComment = Tc;
      xt3.stringifyComment = Ac;
    });
    Sr2 = o((Ge7) => {
      "use strict";
      var Oc = "flow", Qs2 = "block", Bt3 = "quoted";
      function kc(s9, e7, t6 = "flow", { indentAtStart: n23, lineWidth: i10 = 80, minContentWidth: r8 = 20, onFold: o9, onOverflow: a7 } = {}) {
        if (!i10 || i10 < 0) return s9;
        i10 < r8 && (r8 = 0);
        let l8 = Math.max(1 + r8, 1 + i10 - e7.length);
        if (s9.length <= l8) return s9;
        let c15 = [], u11 = {}, f11 = i10 - e7.length;
        typeof n23 == "number" && (n23 > i10 - Math.max(2, r8) ? c15.push(0) : f11 = i10 - n23);
        let d16, p17, g18 = false, h17 = -1, m25 = -1, y18 = -1;
        t6 === Qs2 && (h17 = wr3(s9, h17, e7.length), h17 !== -1 && (f11 = h17 + l8));
        for (let N15; N15 = s9[h17 += 1]; ) {
          if (t6 === Bt3 && N15 === "\\") {
            switch (m25 = h17, s9[h17 + 1]) {
              case "x":
                h17 += 3;
                break;
              case "u":
                h17 += 5;
                break;
              case "U":
                h17 += 9;
                break;
              default:
                h17 += 1;
            }
            y18 = h17;
          }
          if (N15 === `
`) t6 === Qs2 && (h17 = wr3(s9, h17, e7.length)), f11 = h17 + e7.length + l8, d16 = void 0;
          else {
            if (N15 === " " && p17 && p17 !== " " && p17 !== `
` && p17 !== "	") {
              let E13 = s9[h17 + 1];
              E13 && E13 !== " " && E13 !== `
` && E13 !== "	" && (d16 = h17);
            }
            if (h17 >= f11) if (d16) c15.push(d16), f11 = d16 + l8, d16 = void 0;
            else if (t6 === Bt3) {
              for (; p17 === " " || p17 === "	"; ) p17 = N15, N15 = s9[h17 += 1], g18 = true;
              let E13 = h17 > y18 + 1 ? h17 - 2 : m25 - 1;
              if (u11[E13]) return s9;
              c15.push(E13), u11[E13] = true, f11 = E13 + l8, d16 = void 0;
            } else g18 = true;
          }
          p17 = N15;
        }
        if (g18 && a7 && a7(), c15.length === 0) return s9;
        o9 && o9();
        let S17 = s9.slice(0, c15[0]);
        for (let N15 = 0; N15 < c15.length; ++N15) {
          let E13 = c15[N15], v21 = c15[N15 + 1] || s9.length;
          E13 === 0 ? S17 = `
${e7}${s9.slice(0, v21)}` : (t6 === Bt3 && u11[E13] && (S17 += `${s9[E13]}\\`), S17 += `
${e7}${s9.slice(E13 + 1, v21)}`);
        }
        return S17;
      }
      function wr3(s9, e7, t6) {
        let n23 = e7, i10 = e7 + 1, r8 = s9[i10];
        for (; r8 === " " || r8 === "	"; ) if (e7 < i10 + t6) r8 = s9[++e7];
        else {
          do
            r8 = s9[++e7];
          while (r8 && r8 !== `
`);
          n23 = e7, i10 = e7 + 1, r8 = s9[i10];
        }
        return n23;
      }
      Ge7.FOLD_BLOCK = Qs2;
      Ge7.FOLD_FLOW = Oc;
      Ge7.FOLD_QUOTED = Bt3;
      Ge7.foldFlowLines = kc;
    });
    Qe5 = o((Nr2) => {
      "use strict";
      var Y11 = C17(), Z13 = Sr2(), jt4 = (s9, e7) => ({ indentAtStart: e7 ? s9.indent.length : s9.indentAtStart, lineWidth: s9.options.lineWidth, minContentWidth: s9.options.minContentWidth }), Vt3 = (s9) => /^(%|---|\.\.\.)/m.test(s9);
      function Ic(s9, e7, t6) {
        if (!e7 || e7 < 0) return false;
        let n23 = e7 - t6, i10 = s9.length;
        if (i10 <= n23) return false;
        for (let r8 = 0, o9 = 0; r8 < i10; ++r8) if (s9[r8] === `
`) {
          if (r8 - o9 > n23) return true;
          if (o9 = r8 + 1, i10 - o9 <= n23) return false;
        }
        return true;
      }
      function Xe6(s9, e7) {
        let t6 = JSON.stringify(s9);
        if (e7.options.doubleQuotedAsJSON) return t6;
        let { implicitKey: n23 } = e7, i10 = e7.options.doubleQuotedMinMultiLineLength, r8 = e7.indent || (Vt3(s9) ? "  " : ""), o9 = "", a7 = 0;
        for (let l8 = 0, c15 = t6[l8]; c15; c15 = t6[++l8]) if (c15 === " " && t6[l8 + 1] === "\\" && t6[l8 + 2] === "n" && (o9 += t6.slice(a7, l8) + "\\ ", l8 += 1, a7 = l8, c15 = "\\"), c15 === "\\") switch (t6[l8 + 1]) {
          case "u":
            {
              o9 += t6.slice(a7, l8);
              let u11 = t6.substr(l8 + 2, 4);
              switch (u11) {
                case "0000":
                  o9 += "\\0";
                  break;
                case "0007":
                  o9 += "\\a";
                  break;
                case "000b":
                  o9 += "\\v";
                  break;
                case "001b":
                  o9 += "\\e";
                  break;
                case "0085":
                  o9 += "\\N";
                  break;
                case "00a0":
                  o9 += "\\_";
                  break;
                case "2028":
                  o9 += "\\L";
                  break;
                case "2029":
                  o9 += "\\P";
                  break;
                default:
                  u11.substr(0, 2) === "00" ? o9 += "\\x" + u11.substr(2) : o9 += t6.substr(l8, 6);
              }
              l8 += 5, a7 = l8 + 1;
            }
            break;
          case "n":
            if (n23 || t6[l8 + 2] === '"' || t6.length < i10) l8 += 1;
            else {
              for (o9 += t6.slice(a7, l8) + `

`; t6[l8 + 2] === "\\" && t6[l8 + 3] === "n" && t6[l8 + 4] !== '"'; ) o9 += `
`, l8 += 2;
              o9 += r8, t6[l8 + 2] === " " && (o9 += "\\"), l8 += 1, a7 = l8 + 1;
            }
            break;
          default:
            l8 += 1;
        }
        return o9 = a7 ? o9 + t6.slice(a7) : t6, n23 ? o9 : Z13.foldFlowLines(o9, r8, Z13.FOLD_QUOTED, jt4(e7, false));
      }
      function Hs2(s9, e7) {
        if (e7.options.singleQuote === false || e7.implicitKey && s9.includes(`
`) || /[ \t]\n|\n[ \t]/.test(s9)) return Xe6(s9, e7);
        let t6 = e7.indent || (Vt3(s9) ? "  " : ""), n23 = "'" + s9.replace(/'/g, "''").replace(/\n+/g, `$&
${t6}`) + "'";
        return e7.implicitKey ? n23 : Z13.foldFlowLines(n23, t6, Z13.FOLD_FLOW, jt4(e7, false));
      }
      function ve8(s9, e7) {
        let { singleQuote: t6 } = e7.options, n23;
        if (t6 === false) n23 = Xe6;
        else {
          let i10 = s9.includes('"'), r8 = s9.includes("'");
          i10 && !r8 ? n23 = Hs2 : r8 && !i10 ? n23 = Xe6 : n23 = t6 ? Hs2 : Xe6;
        }
        return n23(s9, e7);
      }
      var Ds3;
      try {
        Ds3 = new RegExp(`(^|(?<!
))
+(?!
|$)`, "g");
      } catch {
        Ds3 = /\n+(?!\n|$)/g;
      }
      function Ft4({ comment: s9, type: e7, value: t6 }, n23, i10, r8) {
        let { blockQuote: o9, commentString: a7, lineWidth: l8 } = n23.options;
        if (!o9 || /\n[\t ]+$/.test(t6)) return ve8(t6, n23);
        let c15 = n23.indent || (n23.forceBlockIndent || Vt3(t6) ? "  " : ""), u11 = o9 === "literal" ? true : o9 === "folded" || e7 === Y11.Scalar.BLOCK_FOLDED ? false : e7 === Y11.Scalar.BLOCK_LITERAL ? true : !Ic(t6, l8, c15.length);
        if (!t6) return u11 ? `|
` : `>
`;
        let f11, d16;
        for (d16 = t6.length; d16 > 0; --d16) {
          let v21 = t6[d16 - 1];
          if (v21 !== `
` && v21 !== "	" && v21 !== " ") break;
        }
        let p17 = t6.substring(d16), g18 = p17.indexOf(`
`);
        g18 === -1 ? f11 = "-" : t6 === p17 || g18 !== p17.length - 1 ? (f11 = "+", r8 && r8()) : f11 = "", p17 && (t6 = t6.slice(0, -p17.length), p17[p17.length - 1] === `
` && (p17 = p17.slice(0, -1)), p17 = p17.replace(Ds3, `$&${c15}`));
        let h17 = false, m25, y18 = -1;
        for (m25 = 0; m25 < t6.length; ++m25) {
          let v21 = t6[m25];
          if (v21 === " ") h17 = true;
          else if (v21 === `
`) y18 = m25;
          else break;
        }
        let S17 = t6.substring(0, y18 < m25 ? y18 + 1 : m25);
        S17 && (t6 = t6.substring(S17.length), S17 = S17.replace(/\n+/g, `$&${c15}`));
        let E13 = (h17 ? c15 ? "2" : "1" : "") + f11;
        if (s9 && (E13 += " " + a7(s9.replace(/ ?[\r\n]+/g, " ")), i10 && i10()), !u11) {
          let v21 = t6.replace(/\n+/g, `
$&`).replace(/(?:^|\n)([\t ].*)(?:([\n\t ]*)\n(?![\n\t ]))?/g, "$1$2").replace(/\n+/g, `$&${c15}`), A14 = false, I18 = jt4(n23, true);
          o9 !== "folded" && e7 !== Y11.Scalar.BLOCK_FOLDED && (I18.onOverflow = () => {
            A14 = true;
          });
          let w19 = Z13.foldFlowLines(`${S17}${v21}${p17}`, c15, Z13.FOLD_BLOCK, I18);
          if (!A14) return `>${E13}
${c15}${w19}`;
        }
        return t6 = t6.replace(/\n+/g, `$&${c15}`), `|${E13}
${c15}${S17}${t6}${p17}`;
      }
      function qc(s9, e7, t6, n23) {
        let { type: i10, value: r8 } = s9, { actualString: o9, implicitKey: a7, indent: l8, indentStep: c15, inFlow: u11 } = e7;
        if (a7 && r8.includes(`
`) || u11 && /[[\]{},]/.test(r8)) return ve8(r8, e7);
        if (/^[\n\t ,[\]{}#&*!|>'"%@`]|^[?-]$|^[?-][ \t]|[\n:][ \t]|[ \t]\n|[\n\t ]#|[\n\t :]$/.test(r8)) return a7 || u11 || !r8.includes(`
`) ? ve8(r8, e7) : Ft4(s9, e7, t6, n23);
        if (!a7 && !u11 && i10 !== Y11.Scalar.PLAIN && r8.includes(`
`)) return Ft4(s9, e7, t6, n23);
        if (Vt3(r8)) {
          if (l8 === "") return e7.forceBlockIndent = true, Ft4(s9, e7, t6, n23);
          if (a7 && l8 === c15) return ve8(r8, e7);
        }
        let f11 = r8.replace(/\n+/g, `$&
${l8}`);
        if (o9) {
          let d16 = (h17) => h17.default && h17.tag !== "tag:yaml.org,2002:str" && h17.test?.test(f11), { compat: p17, tags: g18 } = e7.doc.schema;
          if (g18.some(d16) || p17?.some(d16)) return ve8(r8, e7);
        }
        return a7 ? f11 : Z13.foldFlowLines(f11, l8, Z13.FOLD_FLOW, jt4(e7, false));
      }
      function Cc(s9, e7, t6, n23) {
        let { implicitKey: i10, inFlow: r8 } = e7, o9 = typeof s9.value == "string" ? s9 : Object.assign({}, s9, { value: String(s9.value) }), { type: a7 } = s9;
        a7 !== Y11.Scalar.QUOTE_DOUBLE && /[\x00-\x08\x0b-\x1f\x7f-\x9f\u{D800}-\u{DFFF}]/u.test(o9.value) && (a7 = Y11.Scalar.QUOTE_DOUBLE);
        let l8 = (u11) => {
          switch (u11) {
            case Y11.Scalar.BLOCK_FOLDED:
            case Y11.Scalar.BLOCK_LITERAL:
              return i10 || r8 ? ve8(o9.value, e7) : Ft4(o9, e7, t6, n23);
            case Y11.Scalar.QUOTE_DOUBLE:
              return Xe6(o9.value, e7);
            case Y11.Scalar.QUOTE_SINGLE:
              return Hs2(o9.value, e7);
            case Y11.Scalar.PLAIN:
              return qc(o9, e7, t6, n23);
            default:
              return null;
          }
        }, c15 = l8(a7);
        if (c15 === null) {
          let { defaultKeyType: u11, defaultStringType: f11 } = e7.options, d16 = i10 && u11 || f11;
          if (c15 = l8(d16), c15 === null) throw new Error(`Unsupported default string type ${d16}`);
        }
        return c15;
      }
      Nr2.stringifyString = Cc;
    });
    He5 = o((zs2) => {
      "use strict";
      var Lc = Lt3(), ee7 = O13(), Pc = We5(), Mc = Qe5();
      function $c(s9, e7) {
        let t6 = Object.assign({ blockQuote: true, commentString: Pc.stringifyComment, defaultKeyType: null, defaultStringType: "PLAIN", directives: null, doubleQuotedAsJSON: false, doubleQuotedMinMultiLineLength: 40, falseStr: "false", flowCollectionPadding: true, indentSeq: true, lineWidth: 80, minContentWidth: 20, nullStr: "null", simpleKeys: false, singleQuote: null, trueStr: "true", verifyAliasOrder: true }, s9.schema.toStringOptions, e7), n23;
        switch (t6.collectionStyle) {
          case "block":
            n23 = false;
            break;
          case "flow":
            n23 = true;
            break;
          default:
            n23 = null;
        }
        return { anchors: /* @__PURE__ */ new Set(), doc: s9, flowCollectionPadding: t6.flowCollectionPadding ? " " : "", indent: "", indentStep: typeof t6.indent == "number" ? " ".repeat(t6.indent) : "  ", inFlow: n23, options: t6 };
      }
      function _c(s9, e7) {
        if (e7.tag) {
          let i10 = s9.filter((r8) => r8.tag === e7.tag);
          if (i10.length > 0) return i10.find((r8) => r8.format === e7.format) ?? i10[0];
        }
        let t6, n23;
        if (ee7.isScalar(e7)) {
          n23 = e7.value;
          let i10 = s9.filter((r8) => r8.identify?.(n23));
          if (i10.length > 1) {
            let r8 = i10.filter((o9) => o9.test);
            r8.length > 0 && (i10 = r8);
          }
          t6 = i10.find((r8) => r8.format === e7.format) ?? i10.find((r8) => !r8.format);
        } else n23 = e7, t6 = s9.find((i10) => i10.nodeClass && n23 instanceof i10.nodeClass);
        if (!t6) {
          let i10 = n23?.constructor?.name ?? (n23 === null ? "null" : typeof n23);
          throw new Error(`Tag not resolved for ${i10} value`);
        }
        return t6;
      }
      function xc(s9, e7, { anchors: t6, doc: n23 }) {
        if (!n23.directives) return "";
        let i10 = [], r8 = (ee7.isScalar(s9) || ee7.isCollection(s9)) && s9.anchor;
        r8 && Lc.anchorIsValid(r8) && (t6.add(r8), i10.push(`&${r8}`));
        let o9 = s9.tag ?? (e7.default ? null : e7.tag);
        return o9 && i10.push(n23.directives.tagString(o9)), i10.join(" ");
      }
      function Bc(s9, e7, t6, n23) {
        if (ee7.isPair(s9)) return s9.toString(e7, t6, n23);
        if (ee7.isAlias(s9)) {
          if (e7.doc.directives) return s9.toString(e7);
          if (e7.resolvedAliases?.has(s9)) throw new TypeError("Cannot stringify circular structure without alias nodes");
          e7.resolvedAliases ? e7.resolvedAliases.add(s9) : e7.resolvedAliases = /* @__PURE__ */ new Set([s9]), s9 = s9.resolve(e7.doc);
        }
        let i10, r8 = ee7.isNode(s9) ? s9 : e7.doc.createNode(s9, { onTagObj: (l8) => i10 = l8 });
        i10 ?? (i10 = _c(e7.doc.schema.tags, r8));
        let o9 = xc(r8, i10, e7);
        o9.length > 0 && (e7.indentAtStart = (e7.indentAtStart ?? 0) + o9.length + 1);
        let a7 = typeof i10.stringify == "function" ? i10.stringify(r8, e7, t6, n23) : ee7.isScalar(r8) ? Mc.stringifyString(r8, e7, t6, n23) : r8.toString(e7, t6, n23);
        return o9 ? ee7.isScalar(r8) || a7[0] === "{" || a7[0] === "[" ? `${o9} ${a7}` : `${o9}
${e7.indent}${a7}` : a7;
      }
      zs2.createStringifyContext = $c;
      zs2.stringify = Bc;
    });
    Tr2 = o((Ar2) => {
      "use strict";
      var Q13 = O13(), Er4 = C17(), vr3 = He5(), De7 = We5();
      function Fc({ key: s9, value: e7 }, t6, n23, i10) {
        let { allNullValues: r8, doc: o9, indent: a7, indentStep: l8, options: { commentString: c15, indentSeq: u11, simpleKeys: f11 } } = t6, d16 = Q13.isNode(s9) && s9.comment || null;
        if (f11) {
          if (d16) throw new Error("With simple keys, key nodes cannot have comments");
          if (Q13.isCollection(s9) || !Q13.isNode(s9) && typeof s9 == "object") {
            let I18 = "With simple keys, collection cannot be used as a key value";
            throw new Error(I18);
          }
        }
        let p17 = !f11 && (!s9 || d16 && e7 == null && !t6.inFlow || Q13.isCollection(s9) || (Q13.isScalar(s9) ? s9.type === Er4.Scalar.BLOCK_FOLDED || s9.type === Er4.Scalar.BLOCK_LITERAL : typeof s9 == "object"));
        t6 = Object.assign({}, t6, { allNullValues: false, implicitKey: !p17 && (f11 || !r8), indent: a7 + l8 });
        let g18 = false, h17 = false, m25 = vr3.stringify(s9, t6, () => g18 = true, () => h17 = true);
        if (!p17 && !t6.inFlow && m25.length > 1024) {
          if (f11) throw new Error("With simple keys, single line scalar must not span more than 1024 characters");
          p17 = true;
        }
        if (t6.inFlow) {
          if (r8 || e7 == null) return g18 && n23 && n23(), m25 === "" ? "?" : p17 ? `? ${m25}` : m25;
        } else if (r8 && !f11 || e7 == null && p17) return m25 = `? ${m25}`, d16 && !g18 ? m25 += De7.lineComment(m25, t6.indent, c15(d16)) : h17 && i10 && i10(), m25;
        g18 && (d16 = null), p17 ? (d16 && (m25 += De7.lineComment(m25, t6.indent, c15(d16))), m25 = `? ${m25}
${a7}:`) : (m25 = `${m25}:`, d16 && (m25 += De7.lineComment(m25, t6.indent, c15(d16))));
        let y18, S17, N15;
        Q13.isNode(e7) ? (y18 = !!e7.spaceBefore, S17 = e7.commentBefore, N15 = e7.comment) : (y18 = false, S17 = null, N15 = null, e7 && typeof e7 == "object" && (e7 = o9.createNode(e7))), t6.implicitKey = false, !p17 && !d16 && Q13.isScalar(e7) && (t6.indentAtStart = m25.length + 1), h17 = false, !u11 && l8.length >= 2 && !t6.inFlow && !p17 && Q13.isSeq(e7) && !e7.flow && !e7.tag && !e7.anchor && (t6.indent = t6.indent.substring(2));
        let E13 = false, v21 = vr3.stringify(e7, t6, () => E13 = true, () => h17 = true), A14 = " ";
        if (d16 || y18 || S17) {
          if (A14 = y18 ? `
` : "", S17) {
            let I18 = c15(S17);
            A14 += `
${De7.indentComment(I18, t6.indent)}`;
          }
          v21 === "" && !t6.inFlow ? A14 === `
` && N15 && (A14 = `

`) : A14 += `
${t6.indent}`;
        } else if (!p17 && Q13.isCollection(e7)) {
          let I18 = v21[0], w19 = v21.indexOf(`
`), L18 = w19 !== -1, H16 = t6.inFlow ?? e7.flow ?? e7.items.length === 0;
          if (L18 || !H16) {
            let ge8 = false;
            if (L18 && (I18 === "&" || I18 === "!")) {
              let P20 = v21.indexOf(" ");
              I18 === "&" && P20 !== -1 && P20 < w19 && v21[P20 + 1] === "!" && (P20 = v21.indexOf(" ", P20 + 1)), (P20 === -1 || w19 < P20) && (ge8 = true);
            }
            ge8 || (A14 = `
${t6.indent}`);
          }
        } else (v21 === "" || v21[0] === `
`) && (A14 = "");
        return m25 += A14 + v21, t6.inFlow ? E13 && n23 && n23() : N15 && !E13 ? m25 += De7.lineComment(m25, t6.indent, c15(N15)) : h17 && i10 && i10(), m25;
      }
      Ar2.stringifyPair = Fc;
    });
    en2 = o((Zs2) => {
      "use strict";
      var Or2 = m4("process");
      function jc(s9, ...e7) {
        s9 === "debug" && console.log(...e7);
      }
      function Vc(s9, e7) {
        (s9 === "debug" || s9 === "warn") && (typeof Or2.emitWarning == "function" ? Or2.emitWarning(e7) : console.warn(e7));
      }
      Zs2.debug = jc;
      Zs2.warn = Vc;
    });
    Ut2 = o((Yt3) => {
      "use strict";
      var ze6 = O13(), kr2 = C17(), Kt3 = "<<", Rt2 = { identify: (s9) => s9 === Kt3 || typeof s9 == "symbol" && s9.description === Kt3, default: "key", tag: "tag:yaml.org,2002:merge", test: /^<<$/, resolve: () => Object.assign(new kr2.Scalar(Symbol(Kt3)), { addToJSMap: Ir2 }), stringify: () => Kt3 }, Kc = (s9, e7) => (Rt2.identify(e7) || ze6.isScalar(e7) && (!e7.type || e7.type === kr2.Scalar.PLAIN) && Rt2.identify(e7.value)) && s9?.doc.schema.tags.some((t6) => t6.tag === Rt2.tag && t6.default);
      function Ir2(s9, e7, t6) {
        if (t6 = s9 && ze6.isAlias(t6) ? t6.resolve(s9.doc) : t6, ze6.isSeq(t6)) for (let n23 of t6.items) tn2(s9, e7, n23);
        else if (Array.isArray(t6)) for (let n23 of t6) tn2(s9, e7, n23);
        else tn2(s9, e7, t6);
      }
      function tn2(s9, e7, t6) {
        let n23 = s9 && ze6.isAlias(t6) ? t6.resolve(s9.doc) : t6;
        if (!ze6.isMap(n23)) throw new Error("Merge sources must be maps or map aliases");
        let i10 = n23.toJSON(null, s9, Map);
        for (let [r8, o9] of i10) e7 instanceof Map ? e7.has(r8) || e7.set(r8, o9) : e7 instanceof Set ? e7.add(r8) : Object.prototype.hasOwnProperty.call(e7, r8) || Object.defineProperty(e7, r8, { value: o9, writable: true, enumerable: true, configurable: true });
        return e7;
      }
      Yt3.addMergeToJSMap = Ir2;
      Yt3.isMergeKey = Kc;
      Yt3.merge = Rt2;
    });
    nn2 = o((Lr2) => {
      "use strict";
      var Rc = en2(), qr3 = Ut2(), Yc = He5(), Cr2 = O13(), sn3 = D14();
      function Uc(s9, e7, { key: t6, value: n23 }) {
        if (Cr2.isNode(t6) && t6.addToJSMap) t6.addToJSMap(s9, e7, n23);
        else if (qr3.isMergeKey(s9, t6)) qr3.addMergeToJSMap(s9, e7, n23);
        else {
          let i10 = sn3.toJS(t6, "", s9);
          if (e7 instanceof Map) e7.set(i10, sn3.toJS(n23, i10, s9));
          else if (e7 instanceof Set) e7.add(i10);
          else {
            let r8 = Jc(t6, i10, s9), o9 = sn3.toJS(n23, r8, s9);
            r8 in e7 ? Object.defineProperty(e7, r8, { value: o9, writable: true, enumerable: true, configurable: true }) : e7[r8] = o9;
          }
        }
        return e7;
      }
      function Jc(s9, e7, t6) {
        if (e7 === null) return "";
        if (typeof e7 != "object") return String(e7);
        if (Cr2.isNode(s9) && t6?.doc) {
          let n23 = Yc.createStringifyContext(t6.doc, {});
          n23.anchors = /* @__PURE__ */ new Set();
          for (let r8 of t6.anchors.keys()) n23.anchors.add(r8.anchor);
          n23.inFlow = true, n23.inStringifyKey = true;
          let i10 = s9.toString(n23);
          if (!t6.mapKeyWarned) {
            let r8 = JSON.stringify(i10);
            r8.length > 40 && (r8 = r8.substring(0, 36) + '..."'), Rc.warn(t6.doc.options.logLevel, `Keys with collection values will be stringified due to JS Object restrictions: ${r8}. Set mapAsMap: true to use object keys.`), t6.mapKeyWarned = true;
          }
          return i10;
        }
        return JSON.stringify(e7);
      }
      Lr2.addPairToJSMap = Uc;
    });
    te8 = o((rn3) => {
      "use strict";
      var Pr2 = Je5(), Wc = Tr2(), Gc = nn2(), Jt4 = O13();
      function Xc(s9, e7, t6) {
        let n23 = Pr2.createNode(s9, void 0, t6), i10 = Pr2.createNode(e7, void 0, t6);
        return new Wt4(n23, i10);
      }
      var Wt4 = class s9 {
        constructor(e7, t6 = null) {
          Object.defineProperty(this, Jt4.NODE_TYPE, { value: Jt4.PAIR }), this.key = e7, this.value = t6;
        }
        clone(e7) {
          let { key: t6, value: n23 } = this;
          return Jt4.isNode(t6) && (t6 = t6.clone(e7)), Jt4.isNode(n23) && (n23 = n23.clone(e7)), new s9(t6, n23);
        }
        toJSON(e7, t6) {
          let n23 = t6?.mapAsMap ? /* @__PURE__ */ new Map() : {};
          return Gc.addPairToJSMap(t6, n23, this);
        }
        toString(e7, t6, n23) {
          return e7?.doc ? Wc.stringifyPair(this, e7, t6, n23) : JSON.stringify(this);
        }
      };
      rn3.Pair = Wt4;
      rn3.createPair = Xc;
    });
    on2 = o(($r3) => {
      "use strict";
      var ue11 = O13(), Mr3 = He5(), Gt4 = We5();
      function Qc(s9, e7, t6) {
        return (e7.inFlow ?? s9.flow ? Dc : Hc)(s9, e7, t6);
      }
      function Hc({ comment: s9, items: e7 }, t6, { blockItemPrefix: n23, flowChars: i10, itemIndent: r8, onChompKeep: o9, onComment: a7 }) {
        let { indent: l8, options: { commentString: c15 } } = t6, u11 = Object.assign({}, t6, { indent: r8, type: null }), f11 = false, d16 = [];
        for (let g18 = 0; g18 < e7.length; ++g18) {
          let h17 = e7[g18], m25 = null;
          if (ue11.isNode(h17)) !f11 && h17.spaceBefore && d16.push(""), Xt4(t6, d16, h17.commentBefore, f11), h17.comment && (m25 = h17.comment);
          else if (ue11.isPair(h17)) {
            let S17 = ue11.isNode(h17.key) ? h17.key : null;
            S17 && (!f11 && S17.spaceBefore && d16.push(""), Xt4(t6, d16, S17.commentBefore, f11));
          }
          f11 = false;
          let y18 = Mr3.stringify(h17, u11, () => m25 = null, () => f11 = true);
          m25 && (y18 += Gt4.lineComment(y18, r8, c15(m25))), f11 && m25 && (f11 = false), d16.push(n23 + y18);
        }
        let p17;
        if (d16.length === 0) p17 = i10.start + i10.end;
        else {
          p17 = d16[0];
          for (let g18 = 1; g18 < d16.length; ++g18) {
            let h17 = d16[g18];
            p17 += h17 ? `
${l8}${h17}` : `
`;
          }
        }
        return s9 ? (p17 += `
` + Gt4.indentComment(c15(s9), l8), a7 && a7()) : f11 && o9 && o9(), p17;
      }
      function Dc({ items: s9 }, e7, { flowChars: t6, itemIndent: n23 }) {
        let { indent: i10, indentStep: r8, flowCollectionPadding: o9, options: { commentString: a7 } } = e7;
        n23 += r8;
        let l8 = Object.assign({}, e7, { indent: n23, inFlow: true, type: null }), c15 = false, u11 = 0, f11 = [];
        for (let g18 = 0; g18 < s9.length; ++g18) {
          let h17 = s9[g18], m25 = null;
          if (ue11.isNode(h17)) h17.spaceBefore && f11.push(""), Xt4(e7, f11, h17.commentBefore, false), h17.comment && (m25 = h17.comment);
          else if (ue11.isPair(h17)) {
            let S17 = ue11.isNode(h17.key) ? h17.key : null;
            S17 && (S17.spaceBefore && f11.push(""), Xt4(e7, f11, S17.commentBefore, false), S17.comment && (c15 = true));
            let N15 = ue11.isNode(h17.value) ? h17.value : null;
            N15 ? (N15.comment && (m25 = N15.comment), N15.commentBefore && (c15 = true)) : h17.value == null && S17?.comment && (m25 = S17.comment);
          }
          m25 && (c15 = true);
          let y18 = Mr3.stringify(h17, l8, () => m25 = null);
          g18 < s9.length - 1 && (y18 += ","), m25 && (y18 += Gt4.lineComment(y18, n23, a7(m25))), !c15 && (f11.length > u11 || y18.includes(`
`)) && (c15 = true), f11.push(y18), u11 = f11.length;
        }
        let { start: d16, end: p17 } = t6;
        if (f11.length === 0) return d16 + p17;
        if (!c15) {
          let g18 = f11.reduce((h17, m25) => h17 + m25.length + 2, 2);
          c15 = e7.options.lineWidth > 0 && g18 > e7.options.lineWidth;
        }
        if (c15) {
          let g18 = d16;
          for (let h17 of f11) g18 += h17 ? `
${r8}${i10}${h17}` : `
`;
          return `${g18}
${i10}${p17}`;
        } else return `${d16}${o9}${f11.join(" ")}${o9}${p17}`;
      }
      function Xt4({ indent: s9, options: { commentString: e7 } }, t6, n23, i10) {
        if (n23 && i10 && (n23 = n23.replace(/^\n+/, "")), n23) {
          let r8 = Gt4.indentComment(e7(n23), s9);
          t6.push(r8.trimStart());
        }
      }
      $r3.stringifyCollection = Qc;
    });
    ne7 = o((ln3) => {
      "use strict";
      var zc = on2(), Zc = nn2(), ef = _t3(), se9 = O13(), Qt4 = te8(), tf = C17();
      function Ze7(s9, e7) {
        let t6 = se9.isScalar(e7) ? e7.value : e7;
        for (let n23 of s9) if (se9.isPair(n23) && (n23.key === e7 || n23.key === t6 || se9.isScalar(n23.key) && n23.key.value === t6)) return n23;
      }
      var an3 = class extends ef.Collection {
        static get tagName() {
          return "tag:yaml.org,2002:map";
        }
        constructor(e7) {
          super(se9.MAP, e7), this.items = [];
        }
        static from(e7, t6, n23) {
          let { keepUndefined: i10, replacer: r8 } = n23, o9 = new this(e7), a7 = (l8, c15) => {
            if (typeof r8 == "function") c15 = r8.call(t6, l8, c15);
            else if (Array.isArray(r8) && !r8.includes(l8)) return;
            (c15 !== void 0 || i10) && o9.items.push(Qt4.createPair(l8, c15, n23));
          };
          if (t6 instanceof Map) for (let [l8, c15] of t6) a7(l8, c15);
          else if (t6 && typeof t6 == "object") for (let l8 of Object.keys(t6)) a7(l8, t6[l8]);
          return typeof e7.sortMapEntries == "function" && o9.items.sort(e7.sortMapEntries), o9;
        }
        add(e7, t6) {
          let n23;
          se9.isPair(e7) ? n23 = e7 : !e7 || typeof e7 != "object" || !("key" in e7) ? n23 = new Qt4.Pair(e7, e7?.value) : n23 = new Qt4.Pair(e7.key, e7.value);
          let i10 = Ze7(this.items, n23.key), r8 = this.schema?.sortMapEntries;
          if (i10) {
            if (!t6) throw new Error(`Key ${n23.key} already set`);
            se9.isScalar(i10.value) && tf.isScalarValue(n23.value) ? i10.value.value = n23.value : i10.value = n23.value;
          } else if (r8) {
            let o9 = this.items.findIndex((a7) => r8(n23, a7) < 0);
            o9 === -1 ? this.items.push(n23) : this.items.splice(o9, 0, n23);
          } else this.items.push(n23);
        }
        delete(e7) {
          let t6 = Ze7(this.items, e7);
          return t6 ? this.items.splice(this.items.indexOf(t6), 1).length > 0 : false;
        }
        get(e7, t6) {
          let i10 = Ze7(this.items, e7)?.value;
          return (!t6 && se9.isScalar(i10) ? i10.value : i10) ?? void 0;
        }
        has(e7) {
          return !!Ze7(this.items, e7);
        }
        set(e7, t6) {
          this.add(new Qt4.Pair(e7, t6), true);
        }
        toJSON(e7, t6, n23) {
          let i10 = n23 ? new n23() : t6?.mapAsMap ? /* @__PURE__ */ new Map() : {};
          t6?.onCreate && t6.onCreate(i10);
          for (let r8 of this.items) Zc.addPairToJSMap(t6, i10, r8);
          return i10;
        }
        toString(e7, t6, n23) {
          if (!e7) return JSON.stringify(this);
          for (let i10 of this.items) if (!se9.isPair(i10)) throw new Error(`Map items must all be pairs; found ${JSON.stringify(i10)} instead`);
          return !e7.allNullValues && this.hasAllNullValues(false) && (e7 = Object.assign({}, e7, { allNullValues: true })), zc.stringifyCollection(this, e7, { blockItemPrefix: "", flowChars: { start: "{", end: "}" }, itemIndent: e7.indent || "", onChompKeep: n23, onComment: t6 });
        }
      };
      ln3.YAMLMap = an3;
      ln3.findPair = Ze7;
    });
    Ae6 = o((xr3) => {
      "use strict";
      var sf = O13(), _r2 = ne7(), nf = { collection: "map", default: true, nodeClass: _r2.YAMLMap, tag: "tag:yaml.org,2002:map", resolve(s9, e7) {
        return sf.isMap(s9) || e7("Expected a mapping for this tag"), s9;
      }, createNode: (s9, e7, t6) => _r2.YAMLMap.from(s9, e7, t6) };
      xr3.map = nf;
    });
    ie4 = o((Br4) => {
      "use strict";
      var rf = Je5(), of = on2(), af = _t3(), Dt2 = O13(), lf = C17(), cf = D14(), cn4 = class extends af.Collection {
        static get tagName() {
          return "tag:yaml.org,2002:seq";
        }
        constructor(e7) {
          super(Dt2.SEQ, e7), this.items = [];
        }
        add(e7) {
          this.items.push(e7);
        }
        delete(e7) {
          let t6 = Ht4(e7);
          return typeof t6 != "number" ? false : this.items.splice(t6, 1).length > 0;
        }
        get(e7, t6) {
          let n23 = Ht4(e7);
          if (typeof n23 != "number") return;
          let i10 = this.items[n23];
          return !t6 && Dt2.isScalar(i10) ? i10.value : i10;
        }
        has(e7) {
          let t6 = Ht4(e7);
          return typeof t6 == "number" && t6 < this.items.length;
        }
        set(e7, t6) {
          let n23 = Ht4(e7);
          if (typeof n23 != "number") throw new Error(`Expected a valid index, not ${e7}.`);
          let i10 = this.items[n23];
          Dt2.isScalar(i10) && lf.isScalarValue(t6) ? i10.value = t6 : this.items[n23] = t6;
        }
        toJSON(e7, t6) {
          let n23 = [];
          t6?.onCreate && t6.onCreate(n23);
          let i10 = 0;
          for (let r8 of this.items) n23.push(cf.toJS(r8, String(i10++), t6));
          return n23;
        }
        toString(e7, t6, n23) {
          return e7 ? of.stringifyCollection(this, e7, { blockItemPrefix: "- ", flowChars: { start: "[", end: "]" }, itemIndent: (e7.indent || "") + "  ", onChompKeep: n23, onComment: t6 }) : JSON.stringify(this);
        }
        static from(e7, t6, n23) {
          let { replacer: i10 } = n23, r8 = new this(e7);
          if (t6 && Symbol.iterator in Object(t6)) {
            let o9 = 0;
            for (let a7 of t6) {
              if (typeof i10 == "function") {
                let l8 = t6 instanceof Set ? a7 : String(o9++);
                a7 = i10.call(t6, l8, a7);
              }
              r8.items.push(rf.createNode(a7, void 0, n23));
            }
          }
          return r8;
        }
      };
      function Ht4(s9) {
        let e7 = Dt2.isScalar(s9) ? s9.value : s9;
        return e7 && typeof e7 == "string" && (e7 = Number(e7)), typeof e7 == "number" && Number.isInteger(e7) && e7 >= 0 ? e7 : null;
      }
      Br4.YAMLSeq = cn4;
    });
    Te4 = o((jr3) => {
      "use strict";
      var ff = O13(), Fr2 = ie4(), uf = { collection: "seq", default: true, nodeClass: Fr2.YAMLSeq, tag: "tag:yaml.org,2002:seq", resolve(s9, e7) {
        return ff.isSeq(s9) || e7("Expected a sequence for this tag"), s9;
      }, createNode: (s9, e7, t6) => Fr2.YAMLSeq.from(s9, e7, t6) };
      jr3.seq = uf;
    });
    et6 = o((Vr2) => {
      "use strict";
      var df = Qe5(), hf = { identify: (s9) => typeof s9 == "string", default: true, tag: "tag:yaml.org,2002:str", resolve: (s9) => s9, stringify(s9, e7, t6, n23) {
        return e7 = Object.assign({ actualString: true }, e7), df.stringifyString(s9, e7, t6, n23);
      } };
      Vr2.string = hf;
    });
    zt2 = o((Yr3) => {
      "use strict";
      var Kr2 = C17(), Rr2 = { identify: (s9) => s9 == null, createNode: () => new Kr2.Scalar(null), default: true, tag: "tag:yaml.org,2002:null", test: /^(?:~|[Nn]ull|NULL)?$/, resolve: () => new Kr2.Scalar(null), stringify: ({ source: s9 }, e7) => typeof s9 == "string" && Rr2.test.test(s9) ? s9 : e7.options.nullStr };
      Yr3.nullTag = Rr2;
    });
    fn2 = o((Jr3) => {
      "use strict";
      var pf = C17(), Ur3 = { identify: (s9) => typeof s9 == "boolean", default: true, tag: "tag:yaml.org,2002:bool", test: /^(?:[Tt]rue|TRUE|[Ff]alse|FALSE)$/, resolve: (s9) => new pf.Scalar(s9[0] === "t" || s9[0] === "T"), stringify({ source: s9, value: e7 }, t6) {
        if (s9 && Ur3.test.test(s9)) {
          let n23 = s9[0] === "t" || s9[0] === "T";
          if (e7 === n23) return s9;
        }
        return e7 ? t6.options.trueStr : t6.options.falseStr;
      } };
      Jr3.boolTag = Ur3;
    });
    Oe4 = o((Wr2) => {
      "use strict";
      function mf({ format: s9, minFractionDigits: e7, tag: t6, value: n23 }) {
        if (typeof n23 == "bigint") return String(n23);
        let i10 = typeof n23 == "number" ? n23 : Number(n23);
        if (!isFinite(i10)) return isNaN(i10) ? ".nan" : i10 < 0 ? "-.inf" : ".inf";
        let r8 = Object.is(n23, -0) ? "-0" : JSON.stringify(n23);
        if (!s9 && e7 && (!t6 || t6 === "tag:yaml.org,2002:float") && /^\d/.test(r8)) {
          let o9 = r8.indexOf(".");
          o9 < 0 && (o9 = r8.length, r8 += ".");
          let a7 = e7 - (r8.length - o9 - 1);
          for (; a7-- > 0; ) r8 += "0";
        }
        return r8;
      }
      Wr2.stringifyNumber = mf;
    });
    dn2 = o((Zt4) => {
      "use strict";
      var gf = C17(), un3 = Oe4(), yf = { identify: (s9) => typeof s9 == "number", default: true, tag: "tag:yaml.org,2002:float", test: /^(?:[-+]?\.(?:inf|Inf|INF)|\.nan|\.NaN|\.NAN)$/, resolve: (s9) => s9.slice(-3).toLowerCase() === "nan" ? NaN : s9[0] === "-" ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY, stringify: un3.stringifyNumber }, bf = { identify: (s9) => typeof s9 == "number", default: true, tag: "tag:yaml.org,2002:float", format: "EXP", test: /^[-+]?(?:\.[0-9]+|[0-9]+(?:\.[0-9]*)?)[eE][-+]?[0-9]+$/, resolve: (s9) => parseFloat(s9), stringify(s9) {
        let e7 = Number(s9.value);
        return isFinite(e7) ? e7.toExponential() : un3.stringifyNumber(s9);
      } }, wf = { identify: (s9) => typeof s9 == "number", default: true, tag: "tag:yaml.org,2002:float", test: /^[-+]?(?:\.[0-9]+|[0-9]+\.[0-9]*)$/, resolve(s9) {
        let e7 = new gf.Scalar(parseFloat(s9)), t6 = s9.indexOf(".");
        return t6 !== -1 && s9[s9.length - 1] === "0" && (e7.minFractionDigits = s9.length - t6 - 1), e7;
      }, stringify: un3.stringifyNumber };
      Zt4.float = wf;
      Zt4.floatExp = bf;
      Zt4.floatNaN = yf;
    });
    pn2 = o((ts3) => {
      "use strict";
      var Gr2 = Oe4(), es3 = (s9) => typeof s9 == "bigint" || Number.isInteger(s9), hn3 = (s9, e7, t6, { intAsBigInt: n23 }) => n23 ? BigInt(s9) : parseInt(s9.substring(e7), t6);
      function Xr3(s9, e7, t6) {
        let { value: n23 } = s9;
        return es3(n23) && n23 >= 0 ? t6 + n23.toString(e7) : Gr2.stringifyNumber(s9);
      }
      var Sf = { identify: (s9) => es3(s9) && s9 >= 0, default: true, tag: "tag:yaml.org,2002:int", format: "OCT", test: /^0o[0-7]+$/, resolve: (s9, e7, t6) => hn3(s9, 2, 8, t6), stringify: (s9) => Xr3(s9, 8, "0o") }, Nf = { identify: es3, default: true, tag: "tag:yaml.org,2002:int", test: /^[-+]?[0-9]+$/, resolve: (s9, e7, t6) => hn3(s9, 0, 10, t6), stringify: Gr2.stringifyNumber }, Ef = { identify: (s9) => es3(s9) && s9 >= 0, default: true, tag: "tag:yaml.org,2002:int", format: "HEX", test: /^0x[0-9a-fA-F]+$/, resolve: (s9, e7, t6) => hn3(s9, 2, 16, t6), stringify: (s9) => Xr3(s9, 16, "0x") };
      ts3.int = Nf;
      ts3.intHex = Ef;
      ts3.intOct = Sf;
    });
    Hr2 = o((Qr3) => {
      "use strict";
      var vf = Ae6(), Af = zt2(), Tf = Te4(), Of = et6(), kf = fn2(), mn3 = dn2(), gn3 = pn2(), If = [vf.map, Tf.seq, Of.string, Af.nullTag, kf.boolTag, gn3.intOct, gn3.int, gn3.intHex, mn3.floatNaN, mn3.floatExp, mn3.float];
      Qr3.schema = If;
    });
    Zr2 = o((zr3) => {
      "use strict";
      var qf = C17(), Cf = Ae6(), Lf = Te4();
      function Dr3(s9) {
        return typeof s9 == "bigint" || Number.isInteger(s9);
      }
      var ss3 = ({ value: s9 }) => JSON.stringify(s9), Pf = [{ identify: (s9) => typeof s9 == "string", default: true, tag: "tag:yaml.org,2002:str", resolve: (s9) => s9, stringify: ss3 }, { identify: (s9) => s9 == null, createNode: () => new qf.Scalar(null), default: true, tag: "tag:yaml.org,2002:null", test: /^null$/, resolve: () => null, stringify: ss3 }, { identify: (s9) => typeof s9 == "boolean", default: true, tag: "tag:yaml.org,2002:bool", test: /^true$|^false$/, resolve: (s9) => s9 === "true", stringify: ss3 }, { identify: Dr3, default: true, tag: "tag:yaml.org,2002:int", test: /^-?(?:0|[1-9][0-9]*)$/, resolve: (s9, e7, { intAsBigInt: t6 }) => t6 ? BigInt(s9) : parseInt(s9, 10), stringify: ({ value: s9 }) => Dr3(s9) ? s9.toString() : JSON.stringify(s9) }, { identify: (s9) => typeof s9 == "number", default: true, tag: "tag:yaml.org,2002:float", test: /^-?(?:0|[1-9][0-9]*)(?:\.[0-9]*)?(?:[eE][-+]?[0-9]+)?$/, resolve: (s9) => parseFloat(s9), stringify: ss3 }], Mf = { default: true, tag: "", test: /^/, resolve(s9, e7) {
        return e7(`Unresolved plain scalar ${JSON.stringify(s9)}`), s9;
      } }, $f = [Cf.map, Lf.seq].concat(Pf, Mf);
      zr3.schema = $f;
    });
    bn3 = o((eo2) => {
      "use strict";
      var tt8 = m4("buffer"), yn3 = C17(), _f = Qe5(), xf = { identify: (s9) => s9 instanceof Uint8Array, default: false, tag: "tag:yaml.org,2002:binary", resolve(s9, e7) {
        if (typeof tt8.Buffer == "function") return tt8.Buffer.from(s9, "base64");
        if (typeof atob == "function") {
          let t6 = atob(s9.replace(/[\n\r]/g, "")), n23 = new Uint8Array(t6.length);
          for (let i10 = 0; i10 < t6.length; ++i10) n23[i10] = t6.charCodeAt(i10);
          return n23;
        } else return e7("This environment does not support reading binary tags; either Buffer or atob is required"), s9;
      }, stringify({ comment: s9, type: e7, value: t6 }, n23, i10, r8) {
        if (!t6) return "";
        let o9 = t6, a7;
        if (typeof tt8.Buffer == "function") a7 = o9 instanceof tt8.Buffer ? o9.toString("base64") : tt8.Buffer.from(o9.buffer).toString("base64");
        else if (typeof btoa == "function") {
          let l8 = "";
          for (let c15 = 0; c15 < o9.length; ++c15) l8 += String.fromCharCode(o9[c15]);
          a7 = btoa(l8);
        } else throw new Error("This environment does not support writing binary tags; either Buffer or btoa is required");
        if (e7 ?? (e7 = yn3.Scalar.BLOCK_LITERAL), e7 !== yn3.Scalar.QUOTE_DOUBLE) {
          let l8 = Math.max(n23.options.lineWidth - n23.indent.length, n23.options.minContentWidth), c15 = Math.ceil(a7.length / l8), u11 = new Array(c15);
          for (let f11 = 0, d16 = 0; f11 < c15; ++f11, d16 += l8) u11[f11] = a7.substr(d16, l8);
          a7 = u11.join(e7 === yn3.Scalar.BLOCK_LITERAL ? `
` : " ");
        }
        return _f.stringifyString({ comment: s9, type: e7, value: a7 }, n23, i10, r8);
      } };
      eo2.binary = xf;
    });
    rs2 = o((is4) => {
      "use strict";
      var ns3 = O13(), wn3 = te8(), Bf = C17(), Ff = ie4();
      function to2(s9, e7) {
        if (ns3.isSeq(s9)) for (let t6 = 0; t6 < s9.items.length; ++t6) {
          let n23 = s9.items[t6];
          if (!ns3.isPair(n23)) {
            if (ns3.isMap(n23)) {
              n23.items.length > 1 && e7("Each pair must have its own sequence indicator");
              let i10 = n23.items[0] || new wn3.Pair(new Bf.Scalar(null));
              if (n23.commentBefore && (i10.key.commentBefore = i10.key.commentBefore ? `${n23.commentBefore}
${i10.key.commentBefore}` : n23.commentBefore), n23.comment) {
                let r8 = i10.value ?? i10.key;
                r8.comment = r8.comment ? `${n23.comment}
${r8.comment}` : n23.comment;
              }
              n23 = i10;
            }
            s9.items[t6] = ns3.isPair(n23) ? n23 : new wn3.Pair(n23);
          }
        }
        else e7("Expected a sequence for this tag");
        return s9;
      }
      function so2(s9, e7, t6) {
        let { replacer: n23 } = t6, i10 = new Ff.YAMLSeq(s9);
        i10.tag = "tag:yaml.org,2002:pairs";
        let r8 = 0;
        if (e7 && Symbol.iterator in Object(e7)) for (let o9 of e7) {
          typeof n23 == "function" && (o9 = n23.call(e7, String(r8++), o9));
          let a7, l8;
          if (Array.isArray(o9)) if (o9.length === 2) a7 = o9[0], l8 = o9[1];
          else throw new TypeError(`Expected [key, value] tuple: ${o9}`);
          else if (o9 && o9 instanceof Object) {
            let c15 = Object.keys(o9);
            if (c15.length === 1) a7 = c15[0], l8 = o9[a7];
            else throw new TypeError(`Expected tuple with one key, not ${c15.length} keys`);
          } else a7 = o9;
          i10.items.push(wn3.createPair(a7, l8, t6));
        }
        return i10;
      }
      var jf = { collection: "seq", default: false, tag: "tag:yaml.org,2002:pairs", resolve: to2, createNode: so2 };
      is4.createPairs = so2;
      is4.pairs = jf;
      is4.resolvePairs = to2;
    });
    En2 = o((Nn3) => {
      "use strict";
      var no2 = O13(), Sn3 = D14(), st8 = ne7(), Vf = ie4(), io2 = rs2(), de10 = class s9 extends Vf.YAMLSeq {
        constructor() {
          super(), this.add = st8.YAMLMap.prototype.add.bind(this), this.delete = st8.YAMLMap.prototype.delete.bind(this), this.get = st8.YAMLMap.prototype.get.bind(this), this.has = st8.YAMLMap.prototype.has.bind(this), this.set = st8.YAMLMap.prototype.set.bind(this), this.tag = s9.tag;
        }
        toJSON(e7, t6) {
          if (!t6) return super.toJSON(e7);
          let n23 = /* @__PURE__ */ new Map();
          t6?.onCreate && t6.onCreate(n23);
          for (let i10 of this.items) {
            let r8, o9;
            if (no2.isPair(i10) ? (r8 = Sn3.toJS(i10.key, "", t6), o9 = Sn3.toJS(i10.value, r8, t6)) : r8 = Sn3.toJS(i10, "", t6), n23.has(r8)) throw new Error("Ordered maps must not include duplicate keys");
            n23.set(r8, o9);
          }
          return n23;
        }
        static from(e7, t6, n23) {
          let i10 = io2.createPairs(e7, t6, n23), r8 = new this();
          return r8.items = i10.items, r8;
        }
      };
      de10.tag = "tag:yaml.org,2002:omap";
      var Kf = { collection: "seq", identify: (s9) => s9 instanceof Map, nodeClass: de10, default: false, tag: "tag:yaml.org,2002:omap", resolve(s9, e7) {
        let t6 = io2.resolvePairs(s9, e7), n23 = [];
        for (let { key: i10 } of t6.items) no2.isScalar(i10) && (n23.includes(i10.value) ? e7(`Ordered maps must not include duplicate keys: ${i10.value}`) : n23.push(i10.value));
        return Object.assign(new de10(), t6);
      }, createNode: (s9, e7, t6) => de10.from(s9, e7, t6) };
      Nn3.YAMLOMap = de10;
      Nn3.omap = Kf;
    });
    co = o((vn3) => {
      "use strict";
      var ro2 = C17();
      function oo2({ value: s9, source: e7 }, t6) {
        return e7 && (s9 ? ao2 : lo2).test.test(e7) ? e7 : s9 ? t6.options.trueStr : t6.options.falseStr;
      }
      var ao2 = { identify: (s9) => s9 === true, default: true, tag: "tag:yaml.org,2002:bool", test: /^(?:Y|y|[Yy]es|YES|[Tt]rue|TRUE|[Oo]n|ON)$/, resolve: () => new ro2.Scalar(true), stringify: oo2 }, lo2 = { identify: (s9) => s9 === false, default: true, tag: "tag:yaml.org,2002:bool", test: /^(?:N|n|[Nn]o|NO|[Ff]alse|FALSE|[Oo]ff|OFF)$/, resolve: () => new ro2.Scalar(false), stringify: oo2 };
      vn3.falseTag = lo2;
      vn3.trueTag = ao2;
    });
    fo = o((os3) => {
      "use strict";
      var Rf = C17(), An3 = Oe4(), Yf = { identify: (s9) => typeof s9 == "number", default: true, tag: "tag:yaml.org,2002:float", test: /^(?:[-+]?\.(?:inf|Inf|INF)|\.nan|\.NaN|\.NAN)$/, resolve: (s9) => s9.slice(-3).toLowerCase() === "nan" ? NaN : s9[0] === "-" ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY, stringify: An3.stringifyNumber }, Uf = { identify: (s9) => typeof s9 == "number", default: true, tag: "tag:yaml.org,2002:float", format: "EXP", test: /^[-+]?(?:[0-9][0-9_]*)?(?:\.[0-9_]*)?[eE][-+]?[0-9]+$/, resolve: (s9) => parseFloat(s9.replace(/_/g, "")), stringify(s9) {
        let e7 = Number(s9.value);
        return isFinite(e7) ? e7.toExponential() : An3.stringifyNumber(s9);
      } }, Jf = { identify: (s9) => typeof s9 == "number", default: true, tag: "tag:yaml.org,2002:float", test: /^[-+]?(?:[0-9][0-9_]*)?\.[0-9_]*$/, resolve(s9) {
        let e7 = new Rf.Scalar(parseFloat(s9.replace(/_/g, ""))), t6 = s9.indexOf(".");
        if (t6 !== -1) {
          let n23 = s9.substring(t6 + 1).replace(/_/g, "");
          n23[n23.length - 1] === "0" && (e7.minFractionDigits = n23.length);
        }
        return e7;
      }, stringify: An3.stringifyNumber };
      os3.float = Jf;
      os3.floatExp = Uf;
      os3.floatNaN = Yf;
    });
    ho = o((it7) => {
      "use strict";
      var uo2 = Oe4(), nt8 = (s9) => typeof s9 == "bigint" || Number.isInteger(s9);
      function as3(s9, e7, t6, { intAsBigInt: n23 }) {
        let i10 = s9[0];
        if ((i10 === "-" || i10 === "+") && (e7 += 1), s9 = s9.substring(e7).replace(/_/g, ""), n23) {
          switch (t6) {
            case 2:
              s9 = `0b${s9}`;
              break;
            case 8:
              s9 = `0o${s9}`;
              break;
            case 16:
              s9 = `0x${s9}`;
              break;
          }
          let o9 = BigInt(s9);
          return i10 === "-" ? BigInt(-1) * o9 : o9;
        }
        let r8 = parseInt(s9, t6);
        return i10 === "-" ? -1 * r8 : r8;
      }
      function Tn3(s9, e7, t6) {
        let { value: n23 } = s9;
        if (nt8(n23)) {
          let i10 = n23.toString(e7);
          return n23 < 0 ? "-" + t6 + i10.substr(1) : t6 + i10;
        }
        return uo2.stringifyNumber(s9);
      }
      var Wf = { identify: nt8, default: true, tag: "tag:yaml.org,2002:int", format: "BIN", test: /^[-+]?0b[0-1_]+$/, resolve: (s9, e7, t6) => as3(s9, 2, 2, t6), stringify: (s9) => Tn3(s9, 2, "0b") }, Gf = { identify: nt8, default: true, tag: "tag:yaml.org,2002:int", format: "OCT", test: /^[-+]?0[0-7_]+$/, resolve: (s9, e7, t6) => as3(s9, 1, 8, t6), stringify: (s9) => Tn3(s9, 8, "0") }, Xf = { identify: nt8, default: true, tag: "tag:yaml.org,2002:int", test: /^[-+]?[0-9][0-9_]*$/, resolve: (s9, e7, t6) => as3(s9, 0, 10, t6), stringify: uo2.stringifyNumber }, Qf = { identify: nt8, default: true, tag: "tag:yaml.org,2002:int", format: "HEX", test: /^[-+]?0x[0-9a-fA-F_]+$/, resolve: (s9, e7, t6) => as3(s9, 2, 16, t6), stringify: (s9) => Tn3(s9, 16, "0x") };
      it7.int = Xf;
      it7.intBin = Wf;
      it7.intHex = Qf;
      it7.intOct = Gf;
    });
    kn2 = o((On4) => {
      "use strict";
      var fs3 = O13(), ls3 = te8(), cs3 = ne7(), he10 = class s9 extends cs3.YAMLMap {
        constructor(e7) {
          super(e7), this.tag = s9.tag;
        }
        add(e7) {
          let t6;
          fs3.isPair(e7) ? t6 = e7 : e7 && typeof e7 == "object" && "key" in e7 && "value" in e7 && e7.value === null ? t6 = new ls3.Pair(e7.key, null) : t6 = new ls3.Pair(e7, null), cs3.findPair(this.items, t6.key) || this.items.push(t6);
        }
        get(e7, t6) {
          let n23 = cs3.findPair(this.items, e7);
          return !t6 && fs3.isPair(n23) ? fs3.isScalar(n23.key) ? n23.key.value : n23.key : n23;
        }
        set(e7, t6) {
          if (typeof t6 != "boolean") throw new Error(`Expected boolean value for set(key, value) in a YAML set, not ${typeof t6}`);
          let n23 = cs3.findPair(this.items, e7);
          n23 && !t6 ? this.items.splice(this.items.indexOf(n23), 1) : !n23 && t6 && this.items.push(new ls3.Pair(e7));
        }
        toJSON(e7, t6) {
          return super.toJSON(e7, t6, Set);
        }
        toString(e7, t6, n23) {
          if (!e7) return JSON.stringify(this);
          if (this.hasAllNullValues(true)) return super.toString(Object.assign({}, e7, { allNullValues: true }), t6, n23);
          throw new Error("Set items must all have null values");
        }
        static from(e7, t6, n23) {
          let { replacer: i10 } = n23, r8 = new this(e7);
          if (t6 && Symbol.iterator in Object(t6)) for (let o9 of t6) typeof i10 == "function" && (o9 = i10.call(t6, o9, o9)), r8.items.push(ls3.createPair(o9, null, n23));
          return r8;
        }
      };
      he10.tag = "tag:yaml.org,2002:set";
      var Hf = { collection: "map", identify: (s9) => s9 instanceof Set, nodeClass: he10, default: false, tag: "tag:yaml.org,2002:set", createNode: (s9, e7, t6) => he10.from(s9, e7, t6), resolve(s9, e7) {
        if (fs3.isMap(s9)) {
          if (s9.hasAllNullValues(true)) return Object.assign(new he10(), s9);
          e7("Set items must all have null values");
        } else e7("Expected a mapping for this tag");
        return s9;
      } };
      On4.YAMLSet = he10;
      On4.set = Hf;
    });
    qn2 = o((us3) => {
      "use strict";
      var Df = Oe4();
      function In3(s9, e7) {
        let t6 = s9[0], n23 = t6 === "-" || t6 === "+" ? s9.substring(1) : s9, i10 = (o9) => e7 ? BigInt(o9) : Number(o9), r8 = n23.replace(/_/g, "").split(":").reduce((o9, a7) => o9 * i10(60) + i10(a7), i10(0));
        return t6 === "-" ? i10(-1) * r8 : r8;
      }
      function po2(s9) {
        let { value: e7 } = s9, t6 = (o9) => o9;
        if (typeof e7 == "bigint") t6 = (o9) => BigInt(o9);
        else if (isNaN(e7) || !isFinite(e7)) return Df.stringifyNumber(s9);
        let n23 = "";
        e7 < 0 && (n23 = "-", e7 *= t6(-1));
        let i10 = t6(60), r8 = [e7 % i10];
        return e7 < 60 ? r8.unshift(0) : (e7 = (e7 - r8[0]) / i10, r8.unshift(e7 % i10), e7 >= 60 && (e7 = (e7 - r8[0]) / i10, r8.unshift(e7))), n23 + r8.map((o9) => String(o9).padStart(2, "0")).join(":").replace(/000000\d*$/, "");
      }
      var zf = { identify: (s9) => typeof s9 == "bigint" || Number.isInteger(s9), default: true, tag: "tag:yaml.org,2002:int", format: "TIME", test: /^[-+]?[0-9][0-9_]*(?::[0-5]?[0-9])+$/, resolve: (s9, e7, { intAsBigInt: t6 }) => In3(s9, t6), stringify: po2 }, Zf = { identify: (s9) => typeof s9 == "number", default: true, tag: "tag:yaml.org,2002:float", format: "TIME", test: /^[-+]?[0-9][0-9_]*(?::[0-5]?[0-9])+\.[0-9_]*$/, resolve: (s9) => In3(s9, false), stringify: po2 }, mo2 = { identify: (s9) => s9 instanceof Date, default: true, tag: "tag:yaml.org,2002:timestamp", test: RegExp("^([0-9]{4})-([0-9]{1,2})-([0-9]{1,2})(?:(?:t|T|[ \\t]+)([0-9]{1,2}):([0-9]{1,2}):([0-9]{1,2}(\\.[0-9]+)?)(?:[ \\t]*(Z|[-+][012]?[0-9](?::[0-9]{2})?))?)?$"), resolve(s9) {
        let e7 = s9.match(mo2.test);
        if (!e7) throw new Error("!!timestamp expects a date, starting with yyyy-mm-dd");
        let [, t6, n23, i10, r8, o9, a7] = e7.map(Number), l8 = e7[7] ? Number((e7[7] + "00").substr(1, 3)) : 0, c15 = Date.UTC(t6, n23 - 1, i10, r8 || 0, o9 || 0, a7 || 0, l8), u11 = e7[8];
        if (u11 && u11 !== "Z") {
          let f11 = In3(u11, false);
          Math.abs(f11) < 30 && (f11 *= 60), c15 -= 6e4 * f11;
        }
        return new Date(c15);
      }, stringify: ({ value: s9 }) => s9?.toISOString().replace(/(T00:00:00)?\.000Z$/, "") ?? "" };
      us3.floatTime = Zf;
      us3.intTime = zf;
      us3.timestamp = mo2;
    });
    bo = o((yo2) => {
      "use strict";
      var eu = Ae6(), tu = zt2(), su = Te4(), nu = et6(), iu = bn3(), go2 = co(), Cn3 = fo(), ds2 = ho(), ru = Ut2(), ou = En2(), au = rs2(), lu = kn2(), Ln3 = qn2(), cu = [eu.map, su.seq, nu.string, tu.nullTag, go2.trueTag, go2.falseTag, ds2.intBin, ds2.intOct, ds2.int, ds2.intHex, Cn3.floatNaN, Cn3.floatExp, Cn3.float, iu.binary, ru.merge, ou.omap, au.pairs, lu.set, Ln3.intTime, Ln3.floatTime, Ln3.timestamp];
      yo2.schema = cu;
    });
    Io = o(($n3) => {
      "use strict";
      var Eo2 = Ae6(), fu = zt2(), vo2 = Te4(), uu = et6(), du = fn2(), Pn3 = dn2(), Mn3 = pn2(), hu = Hr2(), pu = Zr2(), Ao2 = bn3(), rt7 = Ut2(), To2 = En2(), Oo2 = rs2(), wo2 = bo(), ko2 = kn2(), hs2 = qn2(), So2 = /* @__PURE__ */ new Map([["core", hu.schema], ["failsafe", [Eo2.map, vo2.seq, uu.string]], ["json", pu.schema], ["yaml11", wo2.schema], ["yaml-1.1", wo2.schema]]), No2 = { binary: Ao2.binary, bool: du.boolTag, float: Pn3.float, floatExp: Pn3.floatExp, floatNaN: Pn3.floatNaN, floatTime: hs2.floatTime, int: Mn3.int, intHex: Mn3.intHex, intOct: Mn3.intOct, intTime: hs2.intTime, map: Eo2.map, merge: rt7.merge, null: fu.nullTag, omap: To2.omap, pairs: Oo2.pairs, seq: vo2.seq, set: ko2.set, timestamp: hs2.timestamp }, mu = { "tag:yaml.org,2002:binary": Ao2.binary, "tag:yaml.org,2002:merge": rt7.merge, "tag:yaml.org,2002:omap": To2.omap, "tag:yaml.org,2002:pairs": Oo2.pairs, "tag:yaml.org,2002:set": ko2.set, "tag:yaml.org,2002:timestamp": hs2.timestamp };
      function gu(s9, e7, t6) {
        let n23 = So2.get(e7);
        if (n23 && !s9) return t6 && !n23.includes(rt7.merge) ? n23.concat(rt7.merge) : n23.slice();
        let i10 = n23;
        if (!i10) if (Array.isArray(s9)) i10 = [];
        else {
          let r8 = Array.from(So2.keys()).filter((o9) => o9 !== "yaml11").map((o9) => JSON.stringify(o9)).join(", ");
          throw new Error(`Unknown schema "${e7}"; use one of ${r8} or define customTags array`);
        }
        if (Array.isArray(s9)) for (let r8 of s9) i10 = i10.concat(r8);
        else typeof s9 == "function" && (i10 = s9(i10.slice()));
        return t6 && (i10 = i10.concat(rt7.merge)), i10.reduce((r8, o9) => {
          let a7 = typeof o9 == "string" ? No2[o9] : o9;
          if (!a7) {
            let l8 = JSON.stringify(o9), c15 = Object.keys(No2).map((u11) => JSON.stringify(u11)).join(", ");
            throw new Error(`Unknown custom tag ${l8}; use one of ${c15}`);
          }
          return r8.includes(a7) || r8.push(a7), r8;
        }, []);
      }
      $n3.coreKnownTags = mu;
      $n3.getTags = gu;
    });
    Bn2 = o((qo2) => {
      "use strict";
      var _n3 = O13(), yu = Ae6(), bu = Te4(), wu = et6(), ps2 = Io(), Su = (s9, e7) => s9.key < e7.key ? -1 : s9.key > e7.key ? 1 : 0, xn3 = class s9 {
        constructor({ compat: e7, customTags: t6, merge: n23, resolveKnownTags: i10, schema: r8, sortMapEntries: o9, toStringDefaults: a7 }) {
          this.compat = Array.isArray(e7) ? ps2.getTags(e7, "compat") : e7 ? ps2.getTags(null, e7) : null, this.name = typeof r8 == "string" && r8 || "core", this.knownTags = i10 ? ps2.coreKnownTags : {}, this.tags = ps2.getTags(t6, this.name, n23), this.toStringOptions = a7 ?? null, Object.defineProperty(this, _n3.MAP, { value: yu.map }), Object.defineProperty(this, _n3.SCALAR, { value: wu.string }), Object.defineProperty(this, _n3.SEQ, { value: bu.seq }), this.sortMapEntries = typeof o9 == "function" ? o9 : o9 === true ? Su : null;
        }
        clone() {
          let e7 = Object.create(s9.prototype, Object.getOwnPropertyDescriptors(this));
          return e7.tags = this.tags.slice(), e7;
        }
      };
      qo2.Schema = xn3;
    });
    Lo = o((Co2) => {
      "use strict";
      var Nu = O13(), Fn3 = He5(), ot7 = We5();
      function Eu(s9, e7) {
        let t6 = [], n23 = e7.directives === true;
        if (e7.directives !== false && s9.directives) {
          let l8 = s9.directives.toString(s9);
          l8 ? (t6.push(l8), n23 = true) : s9.directives.docStart && (n23 = true);
        }
        n23 && t6.push("---");
        let i10 = Fn3.createStringifyContext(s9, e7), { commentString: r8 } = i10.options;
        if (s9.commentBefore) {
          t6.length !== 1 && t6.unshift("");
          let l8 = r8(s9.commentBefore);
          t6.unshift(ot7.indentComment(l8, ""));
        }
        let o9 = false, a7 = null;
        if (s9.contents) {
          if (Nu.isNode(s9.contents)) {
            if (s9.contents.spaceBefore && n23 && t6.push(""), s9.contents.commentBefore) {
              let u11 = r8(s9.contents.commentBefore);
              t6.push(ot7.indentComment(u11, ""));
            }
            i10.forceBlockIndent = !!s9.comment, a7 = s9.contents.comment;
          }
          let l8 = a7 ? void 0 : () => o9 = true, c15 = Fn3.stringify(s9.contents, i10, () => a7 = null, l8);
          a7 && (c15 += ot7.lineComment(c15, "", r8(a7))), (c15[0] === "|" || c15[0] === ">") && t6[t6.length - 1] === "---" ? t6[t6.length - 1] = `--- ${c15}` : t6.push(c15);
        } else t6.push(Fn3.stringify(s9.contents, i10));
        if (s9.directives?.docEnd) if (s9.comment) {
          let l8 = r8(s9.comment);
          l8.includes(`
`) ? (t6.push("..."), t6.push(ot7.indentComment(l8, ""))) : t6.push(`... ${l8}`);
        } else t6.push("...");
        else {
          let l8 = s9.comment;
          l8 && o9 && (l8 = l8.replace(/^\n+/, "")), l8 && ((!o9 || a7) && t6[t6.length - 1] !== "" && t6.push(""), t6.push(ot7.indentComment(r8(l8), "")));
        }
        return t6.join(`
`) + `
`;
      }
      Co2.stringifyDocument = Eu;
    });
    at5 = o((Po2) => {
      "use strict";
      var vu = Ue4(), ke6 = _t3(), K9 = O13(), Au = te8(), Tu = D14(), Ou = Bn2(), ku = Lo(), jn3 = Lt3(), Iu = Rs2(), qu = Je5(), Vn3 = Ks(), Kn3 = class s9 {
        constructor(e7, t6, n23) {
          this.commentBefore = null, this.comment = null, this.errors = [], this.warnings = [], Object.defineProperty(this, K9.NODE_TYPE, { value: K9.DOC });
          let i10 = null;
          typeof t6 == "function" || Array.isArray(t6) ? i10 = t6 : n23 === void 0 && t6 && (n23 = t6, t6 = void 0);
          let r8 = Object.assign({ intAsBigInt: false, keepSourceTokens: false, logLevel: "warn", prettyErrors: true, strict: true, stringKeys: false, uniqueKeys: true, version: "1.2" }, n23);
          this.options = r8;
          let { version: o9 } = r8;
          n23?._directives ? (this.directives = n23._directives.atDocument(), this.directives.yaml.explicit && (o9 = this.directives.yaml.version)) : this.directives = new Vn3.Directives({ version: o9 }), this.setSchema(o9, n23), this.contents = e7 === void 0 ? null : this.createNode(e7, i10, n23);
        }
        clone() {
          let e7 = Object.create(s9.prototype, { [K9.NODE_TYPE]: { value: K9.DOC } });
          return e7.commentBefore = this.commentBefore, e7.comment = this.comment, e7.errors = this.errors.slice(), e7.warnings = this.warnings.slice(), e7.options = Object.assign({}, this.options), this.directives && (e7.directives = this.directives.clone()), e7.schema = this.schema.clone(), e7.contents = K9.isNode(this.contents) ? this.contents.clone(e7.schema) : this.contents, this.range && (e7.range = this.range.slice()), e7;
        }
        add(e7) {
          Ie8(this.contents) && this.contents.add(e7);
        }
        addIn(e7, t6) {
          Ie8(this.contents) && this.contents.addIn(e7, t6);
        }
        createAlias(e7, t6) {
          if (!e7.anchor) {
            let n23 = jn3.anchorNames(this);
            e7.anchor = !t6 || n23.has(t6) ? jn3.findNewAnchor(t6 || "a", n23) : t6;
          }
          return new vu.Alias(e7.anchor);
        }
        createNode(e7, t6, n23) {
          let i10;
          if (typeof t6 == "function") e7 = t6.call({ "": e7 }, "", e7), i10 = t6;
          else if (Array.isArray(t6)) {
            let m25 = (S17) => typeof S17 == "number" || S17 instanceof String || S17 instanceof Number, y18 = t6.filter(m25).map(String);
            y18.length > 0 && (t6 = t6.concat(y18)), i10 = t6;
          } else n23 === void 0 && t6 && (n23 = t6, t6 = void 0);
          let { aliasDuplicateObjects: r8, anchorPrefix: o9, flow: a7, keepUndefined: l8, onTagObj: c15, tag: u11 } = n23 ?? {}, { onAnchor: f11, setAnchors: d16, sourceObjects: p17 } = jn3.createNodeAnchors(this, o9 || "a"), g18 = { aliasDuplicateObjects: r8 ?? true, keepUndefined: l8 ?? false, onAnchor: f11, onTagObj: c15, replacer: i10, schema: this.schema, sourceObjects: p17 }, h17 = qu.createNode(e7, u11, g18);
          return a7 && K9.isCollection(h17) && (h17.flow = true), d16(), h17;
        }
        createPair(e7, t6, n23 = {}) {
          let i10 = this.createNode(e7, null, n23), r8 = this.createNode(t6, null, n23);
          return new Au.Pair(i10, r8);
        }
        delete(e7) {
          return Ie8(this.contents) ? this.contents.delete(e7) : false;
        }
        deleteIn(e7) {
          return ke6.isEmptyPath(e7) ? this.contents == null ? false : (this.contents = null, true) : Ie8(this.contents) ? this.contents.deleteIn(e7) : false;
        }
        get(e7, t6) {
          return K9.isCollection(this.contents) ? this.contents.get(e7, t6) : void 0;
        }
        getIn(e7, t6) {
          return ke6.isEmptyPath(e7) ? !t6 && K9.isScalar(this.contents) ? this.contents.value : this.contents : K9.isCollection(this.contents) ? this.contents.getIn(e7, t6) : void 0;
        }
        has(e7) {
          return K9.isCollection(this.contents) ? this.contents.has(e7) : false;
        }
        hasIn(e7) {
          return ke6.isEmptyPath(e7) ? this.contents !== void 0 : K9.isCollection(this.contents) ? this.contents.hasIn(e7) : false;
        }
        set(e7, t6) {
          this.contents == null ? this.contents = ke6.collectionFromPath(this.schema, [e7], t6) : Ie8(this.contents) && this.contents.set(e7, t6);
        }
        setIn(e7, t6) {
          ke6.isEmptyPath(e7) ? this.contents = t6 : this.contents == null ? this.contents = ke6.collectionFromPath(this.schema, Array.from(e7), t6) : Ie8(this.contents) && this.contents.setIn(e7, t6);
        }
        setSchema(e7, t6 = {}) {
          typeof e7 == "number" && (e7 = String(e7));
          let n23;
          switch (e7) {
            case "1.1":
              this.directives ? this.directives.yaml.version = "1.1" : this.directives = new Vn3.Directives({ version: "1.1" }), n23 = { resolveKnownTags: false, schema: "yaml-1.1" };
              break;
            case "1.2":
            case "next":
              this.directives ? this.directives.yaml.version = e7 : this.directives = new Vn3.Directives({ version: e7 }), n23 = { resolveKnownTags: true, schema: "core" };
              break;
            case null:
              this.directives && delete this.directives, n23 = null;
              break;
            default: {
              let i10 = JSON.stringify(e7);
              throw new Error(`Expected '1.1', '1.2' or null as first argument, but found: ${i10}`);
            }
          }
          if (t6.schema instanceof Object) this.schema = t6.schema;
          else if (n23) this.schema = new Ou.Schema(Object.assign(n23, t6));
          else throw new Error("With a null YAML version, the { schema: Schema } option is required");
        }
        toJS({ json: e7, jsonArg: t6, mapAsMap: n23, maxAliasCount: i10, onAnchor: r8, reviver: o9 } = {}) {
          let a7 = { anchors: /* @__PURE__ */ new Map(), doc: this, keep: !e7, mapAsMap: n23 === true, mapKeyWarned: false, maxAliasCount: typeof i10 == "number" ? i10 : 100 }, l8 = Tu.toJS(this.contents, t6 ?? "", a7);
          if (typeof r8 == "function") for (let { count: c15, res: u11 } of a7.anchors.values()) r8(u11, c15);
          return typeof o9 == "function" ? Iu.applyReviver(o9, { "": l8 }, "", l8) : l8;
        }
        toJSON(e7, t6) {
          return this.toJS({ json: true, jsonArg: e7, mapAsMap: false, onAnchor: t6 });
        }
        toString(e7 = {}) {
          if (this.errors.length > 0) throw new Error("Document with errors cannot be stringified");
          if ("indent" in e7 && (!Number.isInteger(e7.indent) || Number(e7.indent) <= 0)) {
            let t6 = JSON.stringify(e7.indent);
            throw new Error(`"indent" option must be a positive integer, not ${t6}`);
          }
          return ku.stringifyDocument(this, e7);
        }
      };
      function Ie8(s9) {
        if (K9.isCollection(s9)) return true;
        throw new Error("Expected a YAML collection as document contents");
      }
      Po2.Document = Kn3;
    });
    ft5 = o((ct6) => {
      "use strict";
      var lt8 = class extends Error {
        constructor(e7, t6, n23, i10) {
          super(), this.name = e7, this.code = n23, this.message = i10, this.pos = t6;
        }
      }, Rn3 = class extends lt8 {
        constructor(e7, t6, n23) {
          super("YAMLParseError", e7, t6, n23);
        }
      }, Yn3 = class extends lt8 {
        constructor(e7, t6, n23) {
          super("YAMLWarning", e7, t6, n23);
        }
      }, Cu = (s9, e7) => (t6) => {
        if (t6.pos[0] === -1) return;
        t6.linePos = t6.pos.map((a7) => e7.linePos(a7));
        let { line: n23, col: i10 } = t6.linePos[0];
        t6.message += ` at line ${n23}, column ${i10}`;
        let r8 = i10 - 1, o9 = s9.substring(e7.lineStarts[n23 - 1], e7.lineStarts[n23]).replace(/[\n\r]+$/, "");
        if (r8 >= 60 && o9.length > 80) {
          let a7 = Math.min(r8 - 39, o9.length - 79);
          o9 = "\u2026" + o9.substring(a7), r8 -= a7 - 1;
        }
        if (o9.length > 80 && (o9 = o9.substring(0, 79) + "\u2026"), n23 > 1 && /^ *$/.test(o9.substring(0, r8))) {
          let a7 = s9.substring(e7.lineStarts[n23 - 2], e7.lineStarts[n23 - 1]);
          a7.length > 80 && (a7 = a7.substring(0, 79) + `\u2026
`), o9 = a7 + o9;
        }
        if (/[^ ]/.test(o9)) {
          let a7 = 1, l8 = t6.linePos[1];
          l8?.line === n23 && l8.col > i10 && (a7 = Math.max(1, Math.min(l8.col - i10, 80 - r8)));
          let c15 = " ".repeat(r8) + "^".repeat(a7);
          t6.message += `:

${o9}
${c15}
`;
        }
      };
      ct6.YAMLError = lt8;
      ct6.YAMLParseError = Rn3;
      ct6.YAMLWarning = Yn3;
      ct6.prettifyError = Cu;
    });
    ut5 = o((Mo2) => {
      "use strict";
      function Lu(s9, { flow: e7, indicator: t6, next: n23, offset: i10, onError: r8, parentIndent: o9, startOnNewline: a7 }) {
        let l8 = false, c15 = a7, u11 = a7, f11 = "", d16 = "", p17 = false, g18 = false, h17 = null, m25 = null, y18 = null, S17 = null, N15 = null, E13 = null, v21 = null;
        for (let w19 of s9) switch (g18 && (w19.type !== "space" && w19.type !== "newline" && w19.type !== "comma" && r8(w19.offset, "MISSING_CHAR", "Tags and anchors must be separated from the next token by white space"), g18 = false), h17 && (c15 && w19.type !== "comment" && w19.type !== "newline" && r8(h17, "TAB_AS_INDENT", "Tabs are not allowed as indentation"), h17 = null), w19.type) {
          case "space":
            !e7 && (t6 !== "doc-start" || n23?.type !== "flow-collection") && w19.source.includes("	") && (h17 = w19), u11 = true;
            break;
          case "comment": {
            u11 || r8(w19, "MISSING_CHAR", "Comments must be separated from other tokens by white space characters");
            let L18 = w19.source.substring(1) || " ";
            f11 ? f11 += d16 + L18 : f11 = L18, d16 = "", c15 = false;
            break;
          }
          case "newline":
            c15 ? f11 ? f11 += w19.source : (!E13 || t6 !== "seq-item-ind") && (l8 = true) : d16 += w19.source, c15 = true, p17 = true, (m25 || y18) && (S17 = w19), u11 = true;
            break;
          case "anchor":
            m25 && r8(w19, "MULTIPLE_ANCHORS", "A node can have at most one anchor"), w19.source.endsWith(":") && r8(w19.offset + w19.source.length - 1, "BAD_ALIAS", "Anchor ending in : is ambiguous", true), m25 = w19, v21 ?? (v21 = w19.offset), c15 = false, u11 = false, g18 = true;
            break;
          case "tag": {
            y18 && r8(w19, "MULTIPLE_TAGS", "A node can have at most one tag"), y18 = w19, v21 ?? (v21 = w19.offset), c15 = false, u11 = false, g18 = true;
            break;
          }
          case t6:
            (m25 || y18) && r8(w19, "BAD_PROP_ORDER", `Anchors and tags must be after the ${w19.source} indicator`), E13 && r8(w19, "UNEXPECTED_TOKEN", `Unexpected ${w19.source} in ${e7 ?? "collection"}`), E13 = w19, c15 = t6 === "seq-item-ind" || t6 === "explicit-key-ind", u11 = false;
            break;
          case "comma":
            if (e7) {
              N15 && r8(w19, "UNEXPECTED_TOKEN", `Unexpected , in ${e7}`), N15 = w19, c15 = false, u11 = false;
              break;
            }
          default:
            r8(w19, "UNEXPECTED_TOKEN", `Unexpected ${w19.type} token`), c15 = false, u11 = false;
        }
        let A14 = s9[s9.length - 1], I18 = A14 ? A14.offset + A14.source.length : i10;
        return g18 && n23 && n23.type !== "space" && n23.type !== "newline" && n23.type !== "comma" && (n23.type !== "scalar" || n23.source !== "") && r8(n23.offset, "MISSING_CHAR", "Tags and anchors must be separated from the next token by white space"), h17 && (c15 && h17.indent <= o9 || n23?.type === "block-map" || n23?.type === "block-seq") && r8(h17, "TAB_AS_INDENT", "Tabs are not allowed as indentation"), { comma: N15, found: E13, spaceBefore: l8, comment: f11, hasNewline: p17, anchor: m25, tag: y18, newlineAfterProp: S17, end: I18, start: v21 ?? I18 };
      }
      Mo2.resolveProps = Lu;
    });
    ms2 = o(($o2) => {
      "use strict";
      function Un3(s9) {
        if (!s9) return null;
        switch (s9.type) {
          case "alias":
          case "scalar":
          case "double-quoted-scalar":
          case "single-quoted-scalar":
            if (s9.source.includes(`
`)) return true;
            if (s9.end) {
              for (let e7 of s9.end) if (e7.type === "newline") return true;
            }
            return false;
          case "flow-collection":
            for (let e7 of s9.items) {
              for (let t6 of e7.start) if (t6.type === "newline") return true;
              if (e7.sep) {
                for (let t6 of e7.sep) if (t6.type === "newline") return true;
              }
              if (Un3(e7.key) || Un3(e7.value)) return true;
            }
            return false;
          default:
            return true;
        }
      }
      $o2.containsNewline = Un3;
    });
    Jn2 = o((_o2) => {
      "use strict";
      var Pu = ms2();
      function Mu(s9, e7, t6) {
        if (e7?.type === "flow-collection") {
          let n23 = e7.end[0];
          n23.indent === s9 && (n23.source === "]" || n23.source === "}") && Pu.containsNewline(e7) && t6(n23, "BAD_INDENT", "Flow end indicator should be more indented than parent", true);
        }
      }
      _o2.flowIndentCheck = Mu;
    });
    Wn2 = o((Bo2) => {
      "use strict";
      var xo2 = O13();
      function $u(s9, e7, t6) {
        let { uniqueKeys: n23 } = s9.options;
        if (n23 === false) return false;
        let i10 = typeof n23 == "function" ? n23 : (r8, o9) => r8 === o9 || xo2.isScalar(r8) && xo2.isScalar(o9) && r8.value === o9.value;
        return e7.some((r8) => i10(r8.key, t6));
      }
      Bo2.mapIncludes = $u;
    });
    Yo = o((Ro2) => {
      "use strict";
      var Fo2 = te8(), _u = ne7(), jo2 = ut5(), xu = ms2(), Vo2 = Jn2(), Bu = Wn2(), Ko2 = "All mapping items must start at the same column";
      function Fu({ composeNode: s9, composeEmptyNode: e7 }, t6, n23, i10, r8) {
        let o9 = r8?.nodeClass ?? _u.YAMLMap, a7 = new o9(t6.schema);
        t6.atRoot && (t6.atRoot = false);
        let l8 = n23.offset, c15 = null;
        for (let u11 of n23.items) {
          let { start: f11, key: d16, sep: p17, value: g18 } = u11, h17 = jo2.resolveProps(f11, { indicator: "explicit-key-ind", next: d16 ?? p17?.[0], offset: l8, onError: i10, parentIndent: n23.indent, startOnNewline: true }), m25 = !h17.found;
          if (m25) {
            if (d16 && (d16.type === "block-seq" ? i10(l8, "BLOCK_AS_IMPLICIT_KEY", "A block sequence may not be used as an implicit map key") : "indent" in d16 && d16.indent !== n23.indent && i10(l8, "BAD_INDENT", Ko2)), !h17.anchor && !h17.tag && !p17) {
              c15 = h17.end, h17.comment && (a7.comment ? a7.comment += `
` + h17.comment : a7.comment = h17.comment);
              continue;
            }
            (h17.newlineAfterProp || xu.containsNewline(d16)) && i10(d16 ?? f11[f11.length - 1], "MULTILINE_IMPLICIT_KEY", "Implicit keys need to be on a single line");
          } else h17.found?.indent !== n23.indent && i10(l8, "BAD_INDENT", Ko2);
          t6.atKey = true;
          let y18 = h17.end, S17 = d16 ? s9(t6, d16, h17, i10) : e7(t6, y18, f11, null, h17, i10);
          t6.schema.compat && Vo2.flowIndentCheck(n23.indent, d16, i10), t6.atKey = false, Bu.mapIncludes(t6, a7.items, S17) && i10(y18, "DUPLICATE_KEY", "Map keys must be unique");
          let N15 = jo2.resolveProps(p17 ?? [], { indicator: "map-value-ind", next: g18, offset: S17.range[2], onError: i10, parentIndent: n23.indent, startOnNewline: !d16 || d16.type === "block-scalar" });
          if (l8 = N15.end, N15.found) {
            m25 && (g18?.type === "block-map" && !N15.hasNewline && i10(l8, "BLOCK_AS_IMPLICIT_KEY", "Nested mappings are not allowed in compact mappings"), t6.options.strict && h17.start < N15.found.offset - 1024 && i10(S17.range, "KEY_OVER_1024_CHARS", "The : indicator must be at most 1024 chars after the start of an implicit block mapping key"));
            let E13 = g18 ? s9(t6, g18, N15, i10) : e7(t6, l8, p17, null, N15, i10);
            t6.schema.compat && Vo2.flowIndentCheck(n23.indent, g18, i10), l8 = E13.range[2];
            let v21 = new Fo2.Pair(S17, E13);
            t6.options.keepSourceTokens && (v21.srcToken = u11), a7.items.push(v21);
          } else {
            m25 && i10(S17.range, "MISSING_CHAR", "Implicit map keys need to be followed by map values"), N15.comment && (S17.comment ? S17.comment += `
` + N15.comment : S17.comment = N15.comment);
            let E13 = new Fo2.Pair(S17);
            t6.options.keepSourceTokens && (E13.srcToken = u11), a7.items.push(E13);
          }
        }
        return c15 && c15 < l8 && i10(c15, "IMPOSSIBLE", "Map comment with trailing content"), a7.range = [n23.offset, l8, c15 ?? l8], a7;
      }
      Ro2.resolveBlockMap = Fu;
    });
    Jo = o((Uo2) => {
      "use strict";
      var ju = ie4(), Vu = ut5(), Ku = Jn2();
      function Ru({ composeNode: s9, composeEmptyNode: e7 }, t6, n23, i10, r8) {
        let o9 = r8?.nodeClass ?? ju.YAMLSeq, a7 = new o9(t6.schema);
        t6.atRoot && (t6.atRoot = false), t6.atKey && (t6.atKey = false);
        let l8 = n23.offset, c15 = null;
        for (let { start: u11, value: f11 } of n23.items) {
          let d16 = Vu.resolveProps(u11, { indicator: "seq-item-ind", next: f11, offset: l8, onError: i10, parentIndent: n23.indent, startOnNewline: true });
          if (!d16.found) if (d16.anchor || d16.tag || f11) f11?.type === "block-seq" ? i10(d16.end, "BAD_INDENT", "All sequence items must start at the same column") : i10(l8, "MISSING_CHAR", "Sequence item without - indicator");
          else {
            c15 = d16.end, d16.comment && (a7.comment = d16.comment);
            continue;
          }
          let p17 = f11 ? s9(t6, f11, d16, i10) : e7(t6, d16.end, u11, null, d16, i10);
          t6.schema.compat && Ku.flowIndentCheck(n23.indent, f11, i10), l8 = p17.range[2], a7.items.push(p17);
        }
        return a7.range = [n23.offset, l8, c15 ?? l8], a7;
      }
      Uo2.resolveBlockSeq = Ru;
    });
    qe4 = o((Wo2) => {
      "use strict";
      function Yu(s9, e7, t6, n23) {
        let i10 = "";
        if (s9) {
          let r8 = false, o9 = "";
          for (let a7 of s9) {
            let { source: l8, type: c15 } = a7;
            switch (c15) {
              case "space":
                r8 = true;
                break;
              case "comment": {
                t6 && !r8 && n23(a7, "MISSING_CHAR", "Comments must be separated from other tokens by white space characters");
                let u11 = l8.substring(1) || " ";
                i10 ? i10 += o9 + u11 : i10 = u11, o9 = "";
                break;
              }
              case "newline":
                i10 && (o9 += l8), r8 = true;
                break;
              default:
                n23(a7, "UNEXPECTED_TOKEN", `Unexpected ${c15} at node end`);
            }
            e7 += l8.length;
          }
        }
        return { comment: i10, offset: e7 };
      }
      Wo2.resolveEnd = Yu;
    });
    Ho = o((Qo2) => {
      "use strict";
      var Uu = O13(), Ju = te8(), Go2 = ne7(), Wu = ie4(), Gu = qe4(), Xo2 = ut5(), Xu = ms2(), Qu = Wn2(), Gn3 = "Block collections are not allowed within flow collections", Xn3 = (s9) => s9 && (s9.type === "block-map" || s9.type === "block-seq");
      function Hu({ composeNode: s9, composeEmptyNode: e7 }, t6, n23, i10, r8) {
        let o9 = n23.start.source === "{", a7 = o9 ? "flow map" : "flow sequence", l8 = r8?.nodeClass ?? (o9 ? Go2.YAMLMap : Wu.YAMLSeq), c15 = new l8(t6.schema);
        c15.flow = true;
        let u11 = t6.atRoot;
        u11 && (t6.atRoot = false), t6.atKey && (t6.atKey = false);
        let f11 = n23.offset + n23.start.source.length;
        for (let m25 = 0; m25 < n23.items.length; ++m25) {
          let y18 = n23.items[m25], { start: S17, key: N15, sep: E13, value: v21 } = y18, A14 = Xo2.resolveProps(S17, { flow: a7, indicator: "explicit-key-ind", next: N15 ?? E13?.[0], offset: f11, onError: i10, parentIndent: n23.indent, startOnNewline: false });
          if (!A14.found) {
            if (!A14.anchor && !A14.tag && !E13 && !v21) {
              m25 === 0 && A14.comma ? i10(A14.comma, "UNEXPECTED_TOKEN", `Unexpected , in ${a7}`) : m25 < n23.items.length - 1 && i10(A14.start, "UNEXPECTED_TOKEN", `Unexpected empty item in ${a7}`), A14.comment && (c15.comment ? c15.comment += `
` + A14.comment : c15.comment = A14.comment), f11 = A14.end;
              continue;
            }
            !o9 && t6.options.strict && Xu.containsNewline(N15) && i10(N15, "MULTILINE_IMPLICIT_KEY", "Implicit keys of flow sequence pairs need to be on a single line");
          }
          if (m25 === 0) A14.comma && i10(A14.comma, "UNEXPECTED_TOKEN", `Unexpected , in ${a7}`);
          else if (A14.comma || i10(A14.start, "MISSING_CHAR", `Missing , between ${a7} items`), A14.comment) {
            let I18 = "";
            e: for (let w19 of S17) switch (w19.type) {
              case "comma":
              case "space":
                break;
              case "comment":
                I18 = w19.source.substring(1);
                break e;
              default:
                break e;
            }
            if (I18) {
              let w19 = c15.items[c15.items.length - 1];
              Uu.isPair(w19) && (w19 = w19.value ?? w19.key), w19.comment ? w19.comment += `
` + I18 : w19.comment = I18, A14.comment = A14.comment.substring(I18.length + 1);
            }
          }
          if (!o9 && !E13 && !A14.found) {
            let I18 = v21 ? s9(t6, v21, A14, i10) : e7(t6, A14.end, E13, null, A14, i10);
            c15.items.push(I18), f11 = I18.range[2], Xn3(v21) && i10(I18.range, "BLOCK_IN_FLOW", Gn3);
          } else {
            t6.atKey = true;
            let I18 = A14.end, w19 = N15 ? s9(t6, N15, A14, i10) : e7(t6, I18, S17, null, A14, i10);
            Xn3(N15) && i10(w19.range, "BLOCK_IN_FLOW", Gn3), t6.atKey = false;
            let L18 = Xo2.resolveProps(E13 ?? [], { flow: a7, indicator: "map-value-ind", next: v21, offset: w19.range[2], onError: i10, parentIndent: n23.indent, startOnNewline: false });
            if (L18.found) {
              if (!o9 && !A14.found && t6.options.strict) {
                if (E13) for (let P20 of E13) {
                  if (P20 === L18.found) break;
                  if (P20.type === "newline") {
                    i10(P20, "MULTILINE_IMPLICIT_KEY", "Implicit keys of flow sequence pairs need to be on a single line");
                    break;
                  }
                }
                A14.start < L18.found.offset - 1024 && i10(L18.found, "KEY_OVER_1024_CHARS", "The : indicator must be at most 1024 chars after the start of an implicit flow sequence key");
              }
            } else v21 && ("source" in v21 && v21.source?.[0] === ":" ? i10(v21, "MISSING_CHAR", `Missing space after : in ${a7}`) : i10(L18.start, "MISSING_CHAR", `Missing , or : between ${a7} items`));
            let H16 = v21 ? s9(t6, v21, L18, i10) : L18.found ? e7(t6, L18.end, E13, null, L18, i10) : null;
            H16 ? Xn3(v21) && i10(H16.range, "BLOCK_IN_FLOW", Gn3) : L18.comment && (w19.comment ? w19.comment += `
` + L18.comment : w19.comment = L18.comment);
            let ge8 = new Ju.Pair(w19, H16);
            if (t6.options.keepSourceTokens && (ge8.srcToken = y18), o9) {
              let P20 = c15;
              Qu.mapIncludes(t6, P20.items, w19) && i10(I18, "DUPLICATE_KEY", "Map keys must be unique"), P20.items.push(ge8);
            } else {
              let P20 = new Go2.YAMLMap(t6.schema);
              P20.flow = true, P20.items.push(ge8);
              let vi3 = (H16 ?? w19).range;
              P20.range = [w19.range[0], vi3[1], vi3[2]], c15.items.push(P20);
            }
            f11 = H16 ? H16.range[2] : L18.end;
          }
        }
        let d16 = o9 ? "}" : "]", [p17, ...g18] = n23.end, h17 = f11;
        if (p17?.source === d16) h17 = p17.offset + p17.source.length;
        else {
          let m25 = a7[0].toUpperCase() + a7.substring(1), y18 = u11 ? `${m25} must end with a ${d16}` : `${m25} in block collection must be sufficiently indented and end with a ${d16}`;
          i10(f11, u11 ? "MISSING_CHAR" : "BAD_INDENT", y18), p17 && p17.source.length !== 1 && g18.unshift(p17);
        }
        if (g18.length > 0) {
          let m25 = Gu.resolveEnd(g18, h17, t6.options.strict, i10);
          m25.comment && (c15.comment ? c15.comment += `
` + m25.comment : c15.comment = m25.comment), c15.range = [n23.offset, h17, m25.offset];
        } else c15.range = [n23.offset, h17, h17];
        return c15;
      }
      Qo2.resolveFlowCollection = Hu;
    });
    zo = o((Do2) => {
      "use strict";
      var Du = O13(), zu = C17(), Zu = ne7(), ed = ie4(), td = Yo(), sd = Jo(), nd = Ho();
      function Qn3(s9, e7, t6, n23, i10, r8) {
        let o9 = t6.type === "block-map" ? td.resolveBlockMap(s9, e7, t6, n23, r8) : t6.type === "block-seq" ? sd.resolveBlockSeq(s9, e7, t6, n23, r8) : nd.resolveFlowCollection(s9, e7, t6, n23, r8), a7 = o9.constructor;
        return i10 === "!" || i10 === a7.tagName ? (o9.tag = a7.tagName, o9) : (i10 && (o9.tag = i10), o9);
      }
      function id(s9, e7, t6, n23, i10) {
        let r8 = n23.tag, o9 = r8 ? e7.directives.tagName(r8.source, (d16) => i10(r8, "TAG_RESOLVE_FAILED", d16)) : null;
        if (t6.type === "block-seq") {
          let { anchor: d16, newlineAfterProp: p17 } = n23, g18 = d16 && r8 ? d16.offset > r8.offset ? d16 : r8 : d16 ?? r8;
          g18 && (!p17 || p17.offset < g18.offset) && i10(g18, "MISSING_CHAR", "Missing newline after block sequence props");
        }
        let a7 = t6.type === "block-map" ? "map" : t6.type === "block-seq" ? "seq" : t6.start.source === "{" ? "map" : "seq";
        if (!r8 || !o9 || o9 === "!" || o9 === Zu.YAMLMap.tagName && a7 === "map" || o9 === ed.YAMLSeq.tagName && a7 === "seq") return Qn3(s9, e7, t6, i10, o9);
        let l8 = e7.schema.tags.find((d16) => d16.tag === o9 && d16.collection === a7);
        if (!l8) {
          let d16 = e7.schema.knownTags[o9];
          if (d16?.collection === a7) e7.schema.tags.push(Object.assign({}, d16, { default: false })), l8 = d16;
          else return d16 ? i10(r8, "BAD_COLLECTION_TYPE", `${d16.tag} used for ${a7} collection, but expects ${d16.collection ?? "scalar"}`, true) : i10(r8, "TAG_RESOLVE_FAILED", `Unresolved tag: ${o9}`, true), Qn3(s9, e7, t6, i10, o9);
        }
        let c15 = Qn3(s9, e7, t6, i10, o9, l8), u11 = l8.resolve?.(c15, (d16) => i10(r8, "TAG_RESOLVE_FAILED", d16), e7.options) ?? c15, f11 = Du.isNode(u11) ? u11 : new zu.Scalar(u11);
        return f11.range = c15.range, f11.tag = o9, l8?.format && (f11.format = l8.format), f11;
      }
      Do2.composeCollection = id;
    });
    Dn2 = o((Zo2) => {
      "use strict";
      var Hn3 = C17();
      function rd(s9, e7, t6) {
        let n23 = e7.offset, i10 = od(e7, s9.options.strict, t6);
        if (!i10) return { value: "", type: null, comment: "", range: [n23, n23, n23] };
        let r8 = i10.mode === ">" ? Hn3.Scalar.BLOCK_FOLDED : Hn3.Scalar.BLOCK_LITERAL, o9 = e7.source ? ad(e7.source) : [], a7 = o9.length;
        for (let h17 = o9.length - 1; h17 >= 0; --h17) {
          let m25 = o9[h17][1];
          if (m25 === "" || m25 === "\r") a7 = h17;
          else break;
        }
        if (a7 === 0) {
          let h17 = i10.chomp === "+" && o9.length > 0 ? `
`.repeat(Math.max(1, o9.length - 1)) : "", m25 = n23 + i10.length;
          return e7.source && (m25 += e7.source.length), { value: h17, type: r8, comment: i10.comment, range: [n23, m25, m25] };
        }
        let l8 = e7.indent + i10.indent, c15 = e7.offset + i10.length, u11 = 0;
        for (let h17 = 0; h17 < a7; ++h17) {
          let [m25, y18] = o9[h17];
          if (y18 === "" || y18 === "\r") i10.indent === 0 && m25.length > l8 && (l8 = m25.length);
          else {
            m25.length < l8 && t6(c15 + m25.length, "MISSING_CHAR", "Block scalars with more-indented leading empty lines must use an explicit indentation indicator"), i10.indent === 0 && (l8 = m25.length), u11 = h17, l8 === 0 && !s9.atRoot && t6(c15, "BAD_INDENT", "Block scalar values in collections must be indented");
            break;
          }
          c15 += m25.length + y18.length + 1;
        }
        for (let h17 = o9.length - 1; h17 >= a7; --h17) o9[h17][0].length > l8 && (a7 = h17 + 1);
        let f11 = "", d16 = "", p17 = false;
        for (let h17 = 0; h17 < u11; ++h17) f11 += o9[h17][0].slice(l8) + `
`;
        for (let h17 = u11; h17 < a7; ++h17) {
          let [m25, y18] = o9[h17];
          c15 += m25.length + y18.length + 1;
          let S17 = y18[y18.length - 1] === "\r";
          if (S17 && (y18 = y18.slice(0, -1)), y18 && m25.length < l8) {
            let E13 = `Block scalar lines must not be less indented than their ${i10.indent ? "explicit indentation indicator" : "first line"}`;
            t6(c15 - y18.length - (S17 ? 2 : 1), "BAD_INDENT", E13), m25 = "";
          }
          r8 === Hn3.Scalar.BLOCK_LITERAL ? (f11 += d16 + m25.slice(l8) + y18, d16 = `
`) : m25.length > l8 || y18[0] === "	" ? (d16 === " " ? d16 = `
` : !p17 && d16 === `
` && (d16 = `

`), f11 += d16 + m25.slice(l8) + y18, d16 = `
`, p17 = true) : y18 === "" ? d16 === `
` ? f11 += `
` : d16 = `
` : (f11 += d16 + y18, d16 = " ", p17 = false);
        }
        switch (i10.chomp) {
          case "-":
            break;
          case "+":
            for (let h17 = a7; h17 < o9.length; ++h17) f11 += `
` + o9[h17][0].slice(l8);
            f11[f11.length - 1] !== `
` && (f11 += `
`);
            break;
          default:
            f11 += `
`;
        }
        let g18 = n23 + i10.length + e7.source.length;
        return { value: f11, type: r8, comment: i10.comment, range: [n23, g18, g18] };
      }
      function od({ offset: s9, props: e7 }, t6, n23) {
        if (e7[0].type !== "block-scalar-header") return n23(e7[0], "IMPOSSIBLE", "Block scalar header not found"), null;
        let { source: i10 } = e7[0], r8 = i10[0], o9 = 0, a7 = "", l8 = -1;
        for (let d16 = 1; d16 < i10.length; ++d16) {
          let p17 = i10[d16];
          if (!a7 && (p17 === "-" || p17 === "+")) a7 = p17;
          else {
            let g18 = Number(p17);
            !o9 && g18 ? o9 = g18 : l8 === -1 && (l8 = s9 + d16);
          }
        }
        l8 !== -1 && n23(l8, "UNEXPECTED_TOKEN", `Block scalar header includes extra characters: ${i10}`);
        let c15 = false, u11 = "", f11 = i10.length;
        for (let d16 = 1; d16 < e7.length; ++d16) {
          let p17 = e7[d16];
          switch (p17.type) {
            case "space":
              c15 = true;
            case "newline":
              f11 += p17.source.length;
              break;
            case "comment":
              t6 && !c15 && n23(p17, "MISSING_CHAR", "Comments must be separated from other tokens by white space characters"), f11 += p17.source.length, u11 = p17.source.substring(1);
              break;
            case "error":
              n23(p17, "UNEXPECTED_TOKEN", p17.message), f11 += p17.source.length;
              break;
            default: {
              let g18 = `Unexpected token in block scalar header: ${p17.type}`;
              n23(p17, "UNEXPECTED_TOKEN", g18);
              let h17 = p17.source;
              h17 && typeof h17 == "string" && (f11 += h17.length);
            }
          }
        }
        return { mode: r8, indent: o9, chomp: a7, comment: u11, length: f11 };
      }
      function ad(s9) {
        let e7 = s9.split(/\n( *)/), t6 = e7[0], n23 = t6.match(/^( *)/), r8 = [n23?.[1] ? [n23[1], t6.slice(n23[1].length)] : ["", t6]];
        for (let o9 = 1; o9 < e7.length; o9 += 2) r8.push([e7[o9], e7[o9 + 1]]);
        return r8;
      }
      Zo2.resolveBlockScalar = rd;
    });
    Zn2 = o((ta2) => {
      "use strict";
      var zn3 = C17(), ld = qe4();
      function cd(s9, e7, t6) {
        let { offset: n23, type: i10, source: r8, end: o9 } = s9, a7, l8, c15 = (d16, p17, g18) => t6(n23 + d16, p17, g18);
        switch (i10) {
          case "scalar":
            a7 = zn3.Scalar.PLAIN, l8 = fd(r8, c15);
            break;
          case "single-quoted-scalar":
            a7 = zn3.Scalar.QUOTE_SINGLE, l8 = ud(r8, c15);
            break;
          case "double-quoted-scalar":
            a7 = zn3.Scalar.QUOTE_DOUBLE, l8 = dd(r8, c15);
            break;
          default:
            return t6(s9, "UNEXPECTED_TOKEN", `Expected a flow scalar value, but found: ${i10}`), { value: "", type: null, comment: "", range: [n23, n23 + r8.length, n23 + r8.length] };
        }
        let u11 = n23 + r8.length, f11 = ld.resolveEnd(o9, u11, e7, t6);
        return { value: l8, type: a7, comment: f11.comment, range: [n23, u11, f11.offset] };
      }
      function fd(s9, e7) {
        let t6 = "";
        switch (s9[0]) {
          case "	":
            t6 = "a tab character";
            break;
          case ",":
            t6 = "flow indicator character ,";
            break;
          case "%":
            t6 = "directive indicator character %";
            break;
          case "|":
          case ">": {
            t6 = `block scalar indicator ${s9[0]}`;
            break;
          }
          case "@":
          case "`": {
            t6 = `reserved character ${s9[0]}`;
            break;
          }
        }
        return t6 && e7(0, "BAD_SCALAR_START", `Plain value cannot start with ${t6}`), ea2(s9);
      }
      function ud(s9, e7) {
        return (s9[s9.length - 1] !== "'" || s9.length === 1) && e7(s9.length, "MISSING_CHAR", "Missing closing 'quote"), ea2(s9.slice(1, -1)).replace(/''/g, "'");
      }
      function ea2(s9) {
        let e7, t6;
        try {
          e7 = new RegExp(`(.*?)(?<![ 	])[ 	]*\r?
`, "sy"), t6 = new RegExp(`[ 	]*(.*?)(?:(?<![ 	])[ 	]*)?\r?
`, "sy");
        } catch {
          e7 = /(.*?)[ \t]*\r?\n/sy, t6 = /[ \t]*(.*?)[ \t]*\r?\n/sy;
        }
        let n23 = e7.exec(s9);
        if (!n23) return s9;
        let i10 = n23[1], r8 = " ", o9 = e7.lastIndex;
        for (t6.lastIndex = o9; n23 = t6.exec(s9); ) n23[1] === "" ? r8 === `
` ? i10 += r8 : r8 = `
` : (i10 += r8 + n23[1], r8 = " "), o9 = t6.lastIndex;
        let a7 = /[ \t]*(.*)/sy;
        return a7.lastIndex = o9, n23 = a7.exec(s9), i10 + r8 + (n23?.[1] ?? "");
      }
      function dd(s9, e7) {
        let t6 = "";
        for (let n23 = 1; n23 < s9.length - 1; ++n23) {
          let i10 = s9[n23];
          if (!(i10 === "\r" && s9[n23 + 1] === `
`)) if (i10 === `
`) {
            let { fold: r8, offset: o9 } = hd(s9, n23);
            t6 += r8, n23 = o9;
          } else if (i10 === "\\") {
            let r8 = s9[++n23], o9 = pd[r8];
            if (o9) t6 += o9;
            else if (r8 === `
`) for (r8 = s9[n23 + 1]; r8 === " " || r8 === "	"; ) r8 = s9[++n23 + 1];
            else if (r8 === "\r" && s9[n23 + 1] === `
`) for (r8 = s9[++n23 + 1]; r8 === " " || r8 === "	"; ) r8 = s9[++n23 + 1];
            else if (r8 === "x" || r8 === "u" || r8 === "U") {
              let a7 = { x: 2, u: 4, U: 8 }[r8];
              t6 += md(s9, n23 + 1, a7, e7), n23 += a7;
            } else {
              let a7 = s9.substr(n23 - 1, 2);
              e7(n23 - 1, "BAD_DQ_ESCAPE", `Invalid escape sequence ${a7}`), t6 += a7;
            }
          } else if (i10 === " " || i10 === "	") {
            let r8 = n23, o9 = s9[n23 + 1];
            for (; o9 === " " || o9 === "	"; ) o9 = s9[++n23 + 1];
            o9 !== `
` && !(o9 === "\r" && s9[n23 + 2] === `
`) && (t6 += n23 > r8 ? s9.slice(r8, n23 + 1) : i10);
          } else t6 += i10;
        }
        return (s9[s9.length - 1] !== '"' || s9.length === 1) && e7(s9.length, "MISSING_CHAR", 'Missing closing "quote'), t6;
      }
      function hd(s9, e7) {
        let t6 = "", n23 = s9[e7 + 1];
        for (; (n23 === " " || n23 === "	" || n23 === `
` || n23 === "\r") && !(n23 === "\r" && s9[e7 + 2] !== `
`); ) n23 === `
` && (t6 += `
`), e7 += 1, n23 = s9[e7 + 1];
        return t6 || (t6 = " "), { fold: t6, offset: e7 };
      }
      var pd = { 0: "\0", a: "\x07", b: "\b", e: "\x1B", f: "\f", n: `
`, r: "\r", t: "	", v: "\v", N: "\x85", _: "\xA0", L: "\u2028", P: "\u2029", " ": " ", '"': '"', "/": "/", "\\": "\\", "	": "	" };
      function md(s9, e7, t6, n23) {
        let i10 = s9.substr(e7, t6), o9 = i10.length === t6 && /^[0-9a-fA-F]+$/.test(i10) ? parseInt(i10, 16) : NaN;
        if (isNaN(o9)) {
          let a7 = s9.substr(e7 - 2, t6 + 2);
          return n23(e7 - 2, "BAD_DQ_ESCAPE", `Invalid escape sequence ${a7}`), a7;
        }
        return String.fromCodePoint(o9);
      }
      ta2.resolveFlowScalar = cd;
    });
    ia = o((na2) => {
      "use strict";
      var pe8 = O13(), sa2 = C17(), gd = Dn2(), yd = Zn2();
      function bd(s9, e7, t6, n23) {
        let { value: i10, type: r8, comment: o9, range: a7 } = e7.type === "block-scalar" ? gd.resolveBlockScalar(s9, e7, n23) : yd.resolveFlowScalar(e7, s9.options.strict, n23), l8 = t6 ? s9.directives.tagName(t6.source, (f11) => n23(t6, "TAG_RESOLVE_FAILED", f11)) : null, c15;
        s9.options.stringKeys && s9.atKey ? c15 = s9.schema[pe8.SCALAR] : l8 ? c15 = wd(s9.schema, i10, l8, t6, n23) : e7.type === "scalar" ? c15 = Sd(s9, i10, e7, n23) : c15 = s9.schema[pe8.SCALAR];
        let u11;
        try {
          let f11 = c15.resolve(i10, (d16) => n23(t6 ?? e7, "TAG_RESOLVE_FAILED", d16), s9.options);
          u11 = pe8.isScalar(f11) ? f11 : new sa2.Scalar(f11);
        } catch (f11) {
          let d16 = f11 instanceof Error ? f11.message : String(f11);
          n23(t6 ?? e7, "TAG_RESOLVE_FAILED", d16), u11 = new sa2.Scalar(i10);
        }
        return u11.range = a7, u11.source = i10, r8 && (u11.type = r8), l8 && (u11.tag = l8), c15.format && (u11.format = c15.format), o9 && (u11.comment = o9), u11;
      }
      function wd(s9, e7, t6, n23, i10) {
        if (t6 === "!") return s9[pe8.SCALAR];
        let r8 = [];
        for (let a7 of s9.tags) if (!a7.collection && a7.tag === t6) if (a7.default && a7.test) r8.push(a7);
        else return a7;
        for (let a7 of r8) if (a7.test?.test(e7)) return a7;
        let o9 = s9.knownTags[t6];
        return o9 && !o9.collection ? (s9.tags.push(Object.assign({}, o9, { default: false, test: void 0 })), o9) : (i10(n23, "TAG_RESOLVE_FAILED", `Unresolved tag: ${t6}`, t6 !== "tag:yaml.org,2002:str"), s9[pe8.SCALAR]);
      }
      function Sd({ atKey: s9, directives: e7, schema: t6 }, n23, i10, r8) {
        let o9 = t6.tags.find((a7) => (a7.default === true || s9 && a7.default === "key") && a7.test?.test(n23)) || t6[pe8.SCALAR];
        if (t6.compat) {
          let a7 = t6.compat.find((l8) => l8.default && l8.test?.test(n23)) ?? t6[pe8.SCALAR];
          if (o9.tag !== a7.tag) {
            let l8 = e7.tagString(o9.tag), c15 = e7.tagString(a7.tag), u11 = `Value may be parsed as either ${l8} or ${c15}`;
            r8(i10, "TAG_RESOLVE_FAILED", u11, true);
          }
        }
        return o9;
      }
      na2.composeScalar = bd;
    });
    oa = o((ra2) => {
      "use strict";
      function Nd(s9, e7, t6) {
        if (e7) {
          t6 ?? (t6 = e7.length);
          for (let n23 = t6 - 1; n23 >= 0; --n23) {
            let i10 = e7[n23];
            switch (i10.type) {
              case "space":
              case "comment":
              case "newline":
                s9 -= i10.source.length;
                continue;
            }
            for (i10 = e7[++n23]; i10?.type === "space"; ) s9 += i10.source.length, i10 = e7[++n23];
            break;
          }
        }
        return s9;
      }
      ra2.emptyScalarPosition = Nd;
    });
    ca = o((ti2) => {
      "use strict";
      var Ed = Ue4(), vd = O13(), Ad = zo(), aa2 = ia(), Td = qe4(), Od = oa(), kd = { composeNode: la2, composeEmptyNode: ei2 };
      function la2(s9, e7, t6, n23) {
        let i10 = s9.atKey, { spaceBefore: r8, comment: o9, anchor: a7, tag: l8 } = t6, c15, u11 = true;
        switch (e7.type) {
          case "alias":
            c15 = Id(s9, e7, n23), (a7 || l8) && n23(e7, "ALIAS_PROPS", "An alias node must not specify any properties");
            break;
          case "scalar":
          case "single-quoted-scalar":
          case "double-quoted-scalar":
          case "block-scalar":
            c15 = aa2.composeScalar(s9, e7, l8, n23), a7 && (c15.anchor = a7.source.substring(1));
            break;
          case "block-map":
          case "block-seq":
          case "flow-collection":
            c15 = Ad.composeCollection(kd, s9, e7, t6, n23), a7 && (c15.anchor = a7.source.substring(1));
            break;
          default: {
            let f11 = e7.type === "error" ? e7.message : `Unsupported token (type: ${e7.type})`;
            n23(e7, "UNEXPECTED_TOKEN", f11), c15 = ei2(s9, e7.offset, void 0, null, t6, n23), u11 = false;
          }
        }
        return a7 && c15.anchor === "" && n23(a7, "BAD_ALIAS", "Anchor cannot be an empty string"), i10 && s9.options.stringKeys && (!vd.isScalar(c15) || typeof c15.value != "string" || c15.tag && c15.tag !== "tag:yaml.org,2002:str") && n23(l8 ?? e7, "NON_STRING_KEY", "With stringKeys, all keys must be strings"), r8 && (c15.spaceBefore = true), o9 && (e7.type === "scalar" && e7.source === "" ? c15.comment = o9 : c15.commentBefore = o9), s9.options.keepSourceTokens && u11 && (c15.srcToken = e7), c15;
      }
      function ei2(s9, e7, t6, n23, { spaceBefore: i10, comment: r8, anchor: o9, tag: a7, end: l8 }, c15) {
        let u11 = { type: "scalar", offset: Od.emptyScalarPosition(e7, t6, n23), indent: -1, source: "" }, f11 = aa2.composeScalar(s9, u11, a7, c15);
        return o9 && (f11.anchor = o9.source.substring(1), f11.anchor === "" && c15(o9, "BAD_ALIAS", "Anchor cannot be an empty string")), i10 && (f11.spaceBefore = true), r8 && (f11.comment = r8, f11.range[2] = l8), f11;
      }
      function Id({ options: s9 }, { offset: e7, source: t6, end: n23 }, i10) {
        let r8 = new Ed.Alias(t6.substring(1));
        r8.source === "" && i10(e7, "BAD_ALIAS", "Alias cannot be an empty string"), r8.source.endsWith(":") && i10(e7 + t6.length - 1, "BAD_ALIAS", "Alias ending in : is ambiguous", true);
        let o9 = e7 + t6.length, a7 = Td.resolveEnd(n23, o9, s9.strict, i10);
        return r8.range = [e7, o9, a7.offset], a7.comment && (r8.comment = a7.comment), r8;
      }
      ti2.composeEmptyNode = ei2;
      ti2.composeNode = la2;
    });
    da2 = o((ua2) => {
      "use strict";
      var qd = at5(), fa3 = ca(), Cd = qe4(), Ld = ut5();
      function Pd(s9, e7, { offset: t6, start: n23, value: i10, end: r8 }, o9) {
        let a7 = Object.assign({ _directives: e7 }, s9), l8 = new qd.Document(void 0, a7), c15 = { atKey: false, atRoot: true, directives: l8.directives, options: l8.options, schema: l8.schema }, u11 = Ld.resolveProps(n23, { indicator: "doc-start", next: i10 ?? r8?.[0], offset: t6, onError: o9, parentIndent: 0, startOnNewline: true });
        u11.found && (l8.directives.docStart = true, i10 && (i10.type === "block-map" || i10.type === "block-seq") && !u11.hasNewline && o9(u11.end, "MISSING_CHAR", "Block collection cannot start on same line with directives-end marker")), l8.contents = i10 ? fa3.composeNode(c15, i10, u11, o9) : fa3.composeEmptyNode(c15, u11.end, n23, null, u11, o9);
        let f11 = l8.contents.range[2], d16 = Cd.resolveEnd(r8, f11, false, o9);
        return d16.comment && (l8.comment = d16.comment), l8.range = [t6, f11, d16.offset], l8;
      }
      ua2.composeDoc = Pd;
    });
    ni = o((ma2) => {
      "use strict";
      var Md = m4("process"), $d = Ks(), _d = at5(), dt6 = ft5(), ha3 = O13(), xd = da2(), Bd = qe4();
      function ht4(s9) {
        if (typeof s9 == "number") return [s9, s9 + 1];
        if (Array.isArray(s9)) return s9.length === 2 ? s9 : [s9[0], s9[1]];
        let { offset: e7, source: t6 } = s9;
        return [e7, e7 + (typeof t6 == "string" ? t6.length : 1)];
      }
      function pa3(s9) {
        let e7 = "", t6 = false, n23 = false;
        for (let i10 = 0; i10 < s9.length; ++i10) {
          let r8 = s9[i10];
          switch (r8[0]) {
            case "#":
              e7 += (e7 === "" ? "" : n23 ? `

` : `
`) + (r8.substring(1) || " "), t6 = true, n23 = false;
              break;
            case "%":
              s9[i10 + 1]?.[0] !== "#" && (i10 += 1), t6 = false;
              break;
            default:
              t6 || (n23 = true), t6 = false;
          }
        }
        return { comment: e7, afterEmptyLine: n23 };
      }
      var si2 = class {
        constructor(e7 = {}) {
          this.doc = null, this.atDirectives = false, this.prelude = [], this.errors = [], this.warnings = [], this.onError = (t6, n23, i10, r8) => {
            let o9 = ht4(t6);
            r8 ? this.warnings.push(new dt6.YAMLWarning(o9, n23, i10)) : this.errors.push(new dt6.YAMLParseError(o9, n23, i10));
          }, this.directives = new $d.Directives({ version: e7.version || "1.2" }), this.options = e7;
        }
        decorate(e7, t6) {
          let { comment: n23, afterEmptyLine: i10 } = pa3(this.prelude);
          if (n23) {
            let r8 = e7.contents;
            if (t6) e7.comment = e7.comment ? `${e7.comment}
${n23}` : n23;
            else if (i10 || e7.directives.docStart || !r8) e7.commentBefore = n23;
            else if (ha3.isCollection(r8) && !r8.flow && r8.items.length > 0) {
              let o9 = r8.items[0];
              ha3.isPair(o9) && (o9 = o9.key);
              let a7 = o9.commentBefore;
              o9.commentBefore = a7 ? `${n23}
${a7}` : n23;
            } else {
              let o9 = r8.commentBefore;
              r8.commentBefore = o9 ? `${n23}
${o9}` : n23;
            }
          }
          t6 ? (Array.prototype.push.apply(e7.errors, this.errors), Array.prototype.push.apply(e7.warnings, this.warnings)) : (e7.errors = this.errors, e7.warnings = this.warnings), this.prelude = [], this.errors = [], this.warnings = [];
        }
        streamInfo() {
          return { comment: pa3(this.prelude).comment, directives: this.directives, errors: this.errors, warnings: this.warnings };
        }
        *compose(e7, t6 = false, n23 = -1) {
          for (let i10 of e7) yield* this.next(i10);
          yield* this.end(t6, n23);
        }
        *next(e7) {
          switch (Md.env.LOG_STREAM && console.dir(e7, { depth: null }), e7.type) {
            case "directive":
              this.directives.add(e7.source, (t6, n23, i10) => {
                let r8 = ht4(e7);
                r8[0] += t6, this.onError(r8, "BAD_DIRECTIVE", n23, i10);
              }), this.prelude.push(e7.source), this.atDirectives = true;
              break;
            case "document": {
              let t6 = xd.composeDoc(this.options, this.directives, e7, this.onError);
              this.atDirectives && !t6.directives.docStart && this.onError(e7, "MISSING_CHAR", "Missing directives-end/doc-start indicator line"), this.decorate(t6, false), this.doc && (yield this.doc), this.doc = t6, this.atDirectives = false;
              break;
            }
            case "byte-order-mark":
            case "space":
              break;
            case "comment":
            case "newline":
              this.prelude.push(e7.source);
              break;
            case "error": {
              let t6 = e7.source ? `${e7.message}: ${JSON.stringify(e7.source)}` : e7.message, n23 = new dt6.YAMLParseError(ht4(e7), "UNEXPECTED_TOKEN", t6);
              this.atDirectives || !this.doc ? this.errors.push(n23) : this.doc.errors.push(n23);
              break;
            }
            case "doc-end": {
              if (!this.doc) {
                let n23 = "Unexpected doc-end without preceding document";
                this.errors.push(new dt6.YAMLParseError(ht4(e7), "UNEXPECTED_TOKEN", n23));
                break;
              }
              this.doc.directives.docEnd = true;
              let t6 = Bd.resolveEnd(e7.end, e7.offset + e7.source.length, this.doc.options.strict, this.onError);
              if (this.decorate(this.doc, true), t6.comment) {
                let n23 = this.doc.comment;
                this.doc.comment = n23 ? `${n23}
${t6.comment}` : t6.comment;
              }
              this.doc.range[2] = t6.offset;
              break;
            }
            default:
              this.errors.push(new dt6.YAMLParseError(ht4(e7), "UNEXPECTED_TOKEN", `Unsupported token ${e7.type}`));
          }
        }
        *end(e7 = false, t6 = -1) {
          if (this.doc) this.decorate(this.doc, true), yield this.doc, this.doc = null;
          else if (e7) {
            let n23 = Object.assign({ _directives: this.directives }, this.options), i10 = new _d.Document(void 0, n23);
            this.atDirectives && this.onError(t6, "MISSING_CHAR", "Missing directives-end indicator line"), i10.range = [0, t6, t6], this.decorate(i10, false), yield i10;
          }
        }
      };
      ma2.Composer = si2;
    });
    ba = o((gs2) => {
      "use strict";
      var Fd = Dn2(), jd = Zn2(), Vd = ft5(), ga2 = Qe5();
      function Kd(s9, e7 = true, t6) {
        if (s9) {
          let n23 = (i10, r8, o9) => {
            let a7 = typeof i10 == "number" ? i10 : Array.isArray(i10) ? i10[0] : i10.offset;
            if (t6) t6(a7, r8, o9);
            else throw new Vd.YAMLParseError([a7, a7 + 1], r8, o9);
          };
          switch (s9.type) {
            case "scalar":
            case "single-quoted-scalar":
            case "double-quoted-scalar":
              return jd.resolveFlowScalar(s9, e7, n23);
            case "block-scalar":
              return Fd.resolveBlockScalar({ options: { strict: e7 } }, s9, n23);
          }
        }
        return null;
      }
      function Rd(s9, e7) {
        let { implicitKey: t6 = false, indent: n23, inFlow: i10 = false, offset: r8 = -1, type: o9 = "PLAIN" } = e7, a7 = ga2.stringifyString({ type: o9, value: s9 }, { implicitKey: t6, indent: n23 > 0 ? " ".repeat(n23) : "", inFlow: i10, options: { blockQuote: true, lineWidth: -1 } }), l8 = e7.end ?? [{ type: "newline", offset: -1, indent: n23, source: `
` }];
        switch (a7[0]) {
          case "|":
          case ">": {
            let c15 = a7.indexOf(`
`), u11 = a7.substring(0, c15), f11 = a7.substring(c15 + 1) + `
`, d16 = [{ type: "block-scalar-header", offset: r8, indent: n23, source: u11 }];
            return ya2(d16, l8) || d16.push({ type: "newline", offset: -1, indent: n23, source: `
` }), { type: "block-scalar", offset: r8, indent: n23, props: d16, source: f11 };
          }
          case '"':
            return { type: "double-quoted-scalar", offset: r8, indent: n23, source: a7, end: l8 };
          case "'":
            return { type: "single-quoted-scalar", offset: r8, indent: n23, source: a7, end: l8 };
          default:
            return { type: "scalar", offset: r8, indent: n23, source: a7, end: l8 };
        }
      }
      function Yd(s9, e7, t6 = {}) {
        let { afterKey: n23 = false, implicitKey: i10 = false, inFlow: r8 = false, type: o9 } = t6, a7 = "indent" in s9 ? s9.indent : null;
        if (n23 && typeof a7 == "number" && (a7 += 2), !o9) switch (s9.type) {
          case "single-quoted-scalar":
            o9 = "QUOTE_SINGLE";
            break;
          case "double-quoted-scalar":
            o9 = "QUOTE_DOUBLE";
            break;
          case "block-scalar": {
            let c15 = s9.props[0];
            if (c15.type !== "block-scalar-header") throw new Error("Invalid block scalar header");
            o9 = c15.source[0] === ">" ? "BLOCK_FOLDED" : "BLOCK_LITERAL";
            break;
          }
          default:
            o9 = "PLAIN";
        }
        let l8 = ga2.stringifyString({ type: o9, value: e7 }, { implicitKey: i10 || a7 === null, indent: a7 !== null && a7 > 0 ? " ".repeat(a7) : "", inFlow: r8, options: { blockQuote: true, lineWidth: -1 } });
        switch (l8[0]) {
          case "|":
          case ">":
            Ud(s9, l8);
            break;
          case '"':
            ii2(s9, l8, "double-quoted-scalar");
            break;
          case "'":
            ii2(s9, l8, "single-quoted-scalar");
            break;
          default:
            ii2(s9, l8, "scalar");
        }
      }
      function Ud(s9, e7) {
        let t6 = e7.indexOf(`
`), n23 = e7.substring(0, t6), i10 = e7.substring(t6 + 1) + `
`;
        if (s9.type === "block-scalar") {
          let r8 = s9.props[0];
          if (r8.type !== "block-scalar-header") throw new Error("Invalid block scalar header");
          r8.source = n23, s9.source = i10;
        } else {
          let { offset: r8 } = s9, o9 = "indent" in s9 ? s9.indent : -1, a7 = [{ type: "block-scalar-header", offset: r8, indent: o9, source: n23 }];
          ya2(a7, "end" in s9 ? s9.end : void 0) || a7.push({ type: "newline", offset: -1, indent: o9, source: `
` });
          for (let l8 of Object.keys(s9)) l8 !== "type" && l8 !== "offset" && delete s9[l8];
          Object.assign(s9, { type: "block-scalar", indent: o9, props: a7, source: i10 });
        }
      }
      function ya2(s9, e7) {
        if (e7) for (let t6 of e7) switch (t6.type) {
          case "space":
          case "comment":
            s9.push(t6);
            break;
          case "newline":
            return s9.push(t6), true;
        }
        return false;
      }
      function ii2(s9, e7, t6) {
        switch (s9.type) {
          case "scalar":
          case "double-quoted-scalar":
          case "single-quoted-scalar":
            s9.type = t6, s9.source = e7;
            break;
          case "block-scalar": {
            let n23 = s9.props.slice(1), i10 = e7.length;
            s9.props[0].type === "block-scalar-header" && (i10 -= s9.props[0].source.length);
            for (let r8 of n23) r8.offset += i10;
            delete s9.props, Object.assign(s9, { type: t6, source: e7, end: n23 });
            break;
          }
          case "block-map":
          case "block-seq": {
            let i10 = { type: "newline", offset: s9.offset + e7.length, indent: s9.indent, source: `
` };
            delete s9.items, Object.assign(s9, { type: t6, source: e7, end: [i10] });
            break;
          }
          default: {
            let n23 = "indent" in s9 ? s9.indent : -1, i10 = "end" in s9 && Array.isArray(s9.end) ? s9.end.filter((r8) => r8.type === "space" || r8.type === "comment" || r8.type === "newline") : [];
            for (let r8 of Object.keys(s9)) r8 !== "type" && r8 !== "offset" && delete s9[r8];
            Object.assign(s9, { type: t6, indent: n23, source: e7, end: i10 });
          }
        }
      }
      gs2.createScalarToken = Rd;
      gs2.resolveAsScalar = Kd;
      gs2.setScalarValue = Yd;
    });
    Sa = o((wa2) => {
      "use strict";
      var Jd = (s9) => "type" in s9 ? bs3(s9) : ys2(s9);
      function bs3(s9) {
        switch (s9.type) {
          case "block-scalar": {
            let e7 = "";
            for (let t6 of s9.props) e7 += bs3(t6);
            return e7 + s9.source;
          }
          case "block-map":
          case "block-seq": {
            let e7 = "";
            for (let t6 of s9.items) e7 += ys2(t6);
            return e7;
          }
          case "flow-collection": {
            let e7 = s9.start.source;
            for (let t6 of s9.items) e7 += ys2(t6);
            for (let t6 of s9.end) e7 += t6.source;
            return e7;
          }
          case "document": {
            let e7 = ys2(s9);
            if (s9.end) for (let t6 of s9.end) e7 += t6.source;
            return e7;
          }
          default: {
            let e7 = s9.source;
            if ("end" in s9 && s9.end) for (let t6 of s9.end) e7 += t6.source;
            return e7;
          }
        }
      }
      function ys2({ start: s9, key: e7, sep: t6, value: n23 }) {
        let i10 = "";
        for (let r8 of s9) i10 += r8.source;
        if (e7 && (i10 += bs3(e7)), t6) for (let r8 of t6) i10 += r8.source;
        return n23 && (i10 += bs3(n23)), i10;
      }
      wa2.stringify = Jd;
    });
    Aa = o((va2) => {
      "use strict";
      var ri2 = Symbol("break visit"), Wd = Symbol("skip children"), Na2 = Symbol("remove item");
      function me6(s9, e7) {
        "type" in s9 && s9.type === "document" && (s9 = { start: s9.start, value: s9.value }), Ea2(Object.freeze([]), s9, e7);
      }
      me6.BREAK = ri2;
      me6.SKIP = Wd;
      me6.REMOVE = Na2;
      me6.itemAtPath = (s9, e7) => {
        let t6 = s9;
        for (let [n23, i10] of e7) {
          let r8 = t6?.[n23];
          if (r8 && "items" in r8) t6 = r8.items[i10];
          else return;
        }
        return t6;
      };
      me6.parentCollection = (s9, e7) => {
        let t6 = me6.itemAtPath(s9, e7.slice(0, -1)), n23 = e7[e7.length - 1][0], i10 = t6?.[n23];
        if (i10 && "items" in i10) return i10;
        throw new Error("Parent collection not found");
      };
      function Ea2(s9, e7, t6) {
        let n23 = t6(e7, s9);
        if (typeof n23 == "symbol") return n23;
        for (let i10 of ["key", "value"]) {
          let r8 = e7[i10];
          if (r8 && "items" in r8) {
            for (let o9 = 0; o9 < r8.items.length; ++o9) {
              let a7 = Ea2(Object.freeze(s9.concat([[i10, o9]])), r8.items[o9], t6);
              if (typeof a7 == "number") o9 = a7 - 1;
              else {
                if (a7 === ri2) return ri2;
                a7 === Na2 && (r8.items.splice(o9, 1), o9 -= 1);
              }
            }
            typeof n23 == "function" && i10 === "key" && (n23 = n23(e7, s9));
          }
        }
        return typeof n23 == "function" ? n23(e7, s9) : n23;
      }
      va2.visit = me6;
    });
    ws2 = o((j12) => {
      "use strict";
      var oi2 = ba(), Gd = Sa(), Xd = Aa(), ai2 = "\uFEFF", li2 = "", ci2 = "", fi2 = "", Qd = (s9) => !!s9 && "items" in s9, Hd = (s9) => !!s9 && (s9.type === "scalar" || s9.type === "single-quoted-scalar" || s9.type === "double-quoted-scalar" || s9.type === "block-scalar");
      function Dd(s9) {
        switch (s9) {
          case ai2:
            return "<BOM>";
          case li2:
            return "<DOC>";
          case ci2:
            return "<FLOW_END>";
          case fi2:
            return "<SCALAR>";
          default:
            return JSON.stringify(s9);
        }
      }
      function zd(s9) {
        switch (s9) {
          case ai2:
            return "byte-order-mark";
          case li2:
            return "doc-mode";
          case ci2:
            return "flow-error-end";
          case fi2:
            return "scalar";
          case "---":
            return "doc-start";
          case "...":
            return "doc-end";
          case "":
          case `
`:
          case `\r
`:
            return "newline";
          case "-":
            return "seq-item-ind";
          case "?":
            return "explicit-key-ind";
          case ":":
            return "map-value-ind";
          case "{":
            return "flow-map-start";
          case "}":
            return "flow-map-end";
          case "[":
            return "flow-seq-start";
          case "]":
            return "flow-seq-end";
          case ",":
            return "comma";
        }
        switch (s9[0]) {
          case " ":
          case "	":
            return "space";
          case "#":
            return "comment";
          case "%":
            return "directive-line";
          case "*":
            return "alias";
          case "&":
            return "anchor";
          case "!":
            return "tag";
          case "'":
            return "single-quoted-scalar";
          case '"':
            return "double-quoted-scalar";
          case "|":
          case ">":
            return "block-scalar-header";
        }
        return null;
      }
      j12.createScalarToken = oi2.createScalarToken;
      j12.resolveAsScalar = oi2.resolveAsScalar;
      j12.setScalarValue = oi2.setScalarValue;
      j12.stringify = Gd.stringify;
      j12.visit = Xd.visit;
      j12.BOM = ai2;
      j12.DOCUMENT = li2;
      j12.FLOW_END = ci2;
      j12.SCALAR = fi2;
      j12.isCollection = Qd;
      j12.isScalar = Hd;
      j12.prettyToken = Dd;
      j12.tokenType = zd;
    });
    hi2 = o((Oa) => {
      "use strict";
      var pt4 = ws2();
      function U14(s9) {
        switch (s9) {
          case void 0:
          case " ":
          case `
`:
          case "\r":
          case "	":
            return true;
          default:
            return false;
        }
      }
      var Ta = new Set("0123456789ABCDEFabcdef"), Zd = new Set("0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-#;/?:@&=+$_.!~*'()"), Ss3 = new Set(",[]{}"), eh = new Set(` ,[]{}
\r	`), ui2 = (s9) => !s9 || eh.has(s9), di2 = class {
        constructor() {
          this.atEnd = false, this.blockScalarIndent = -1, this.blockScalarKeep = false, this.buffer = "", this.flowKey = false, this.flowLevel = 0, this.indentNext = 0, this.indentValue = 0, this.lineEndPos = null, this.next = null, this.pos = 0;
        }
        *lex(e7, t6 = false) {
          if (e7) {
            if (typeof e7 != "string") throw TypeError("source is not a string");
            this.buffer = this.buffer ? this.buffer + e7 : e7, this.lineEndPos = null;
          }
          this.atEnd = !t6;
          let n23 = this.next ?? "stream";
          for (; n23 && (t6 || this.hasChars(1)); ) n23 = yield* this.parseNext(n23);
        }
        atLineEnd() {
          let e7 = this.pos, t6 = this.buffer[e7];
          for (; t6 === " " || t6 === "	"; ) t6 = this.buffer[++e7];
          return !t6 || t6 === "#" || t6 === `
` ? true : t6 === "\r" ? this.buffer[e7 + 1] === `
` : false;
        }
        charAt(e7) {
          return this.buffer[this.pos + e7];
        }
        continueScalar(e7) {
          let t6 = this.buffer[e7];
          if (this.indentNext > 0) {
            let n23 = 0;
            for (; t6 === " "; ) t6 = this.buffer[++n23 + e7];
            if (t6 === "\r") {
              let i10 = this.buffer[n23 + e7 + 1];
              if (i10 === `
` || !i10 && !this.atEnd) return e7 + n23 + 1;
            }
            return t6 === `
` || n23 >= this.indentNext || !t6 && !this.atEnd ? e7 + n23 : -1;
          }
          if (t6 === "-" || t6 === ".") {
            let n23 = this.buffer.substr(e7, 3);
            if ((n23 === "---" || n23 === "...") && U14(this.buffer[e7 + 3])) return -1;
          }
          return e7;
        }
        getLine() {
          let e7 = this.lineEndPos;
          return (typeof e7 != "number" || e7 !== -1 && e7 < this.pos) && (e7 = this.buffer.indexOf(`
`, this.pos), this.lineEndPos = e7), e7 === -1 ? this.atEnd ? this.buffer.substring(this.pos) : null : (this.buffer[e7 - 1] === "\r" && (e7 -= 1), this.buffer.substring(this.pos, e7));
        }
        hasChars(e7) {
          return this.pos + e7 <= this.buffer.length;
        }
        setNext(e7) {
          return this.buffer = this.buffer.substring(this.pos), this.pos = 0, this.lineEndPos = null, this.next = e7, null;
        }
        peek(e7) {
          return this.buffer.substr(this.pos, e7);
        }
        *parseNext(e7) {
          switch (e7) {
            case "stream":
              return yield* this.parseStream();
            case "line-start":
              return yield* this.parseLineStart();
            case "block-start":
              return yield* this.parseBlockStart();
            case "doc":
              return yield* this.parseDocument();
            case "flow":
              return yield* this.parseFlowCollection();
            case "quoted-scalar":
              return yield* this.parseQuotedScalar();
            case "block-scalar":
              return yield* this.parseBlockScalar();
            case "plain-scalar":
              return yield* this.parsePlainScalar();
          }
        }
        *parseStream() {
          let e7 = this.getLine();
          if (e7 === null) return this.setNext("stream");
          if (e7[0] === pt4.BOM && (yield* this.pushCount(1), e7 = e7.substring(1)), e7[0] === "%") {
            let t6 = e7.length, n23 = e7.indexOf("#");
            for (; n23 !== -1; ) {
              let r8 = e7[n23 - 1];
              if (r8 === " " || r8 === "	") {
                t6 = n23 - 1;
                break;
              } else n23 = e7.indexOf("#", n23 + 1);
            }
            for (; ; ) {
              let r8 = e7[t6 - 1];
              if (r8 === " " || r8 === "	") t6 -= 1;
              else break;
            }
            let i10 = (yield* this.pushCount(t6)) + (yield* this.pushSpaces(true));
            return yield* this.pushCount(e7.length - i10), this.pushNewline(), "stream";
          }
          if (this.atLineEnd()) {
            let t6 = yield* this.pushSpaces(true);
            return yield* this.pushCount(e7.length - t6), yield* this.pushNewline(), "stream";
          }
          return yield pt4.DOCUMENT, yield* this.parseLineStart();
        }
        *parseLineStart() {
          let e7 = this.charAt(0);
          if (!e7 && !this.atEnd) return this.setNext("line-start");
          if (e7 === "-" || e7 === ".") {
            if (!this.atEnd && !this.hasChars(4)) return this.setNext("line-start");
            let t6 = this.peek(3);
            if ((t6 === "---" || t6 === "...") && U14(this.charAt(3))) return yield* this.pushCount(3), this.indentValue = 0, this.indentNext = 0, t6 === "---" ? "doc" : "stream";
          }
          return this.indentValue = yield* this.pushSpaces(false), this.indentNext > this.indentValue && !U14(this.charAt(1)) && (this.indentNext = this.indentValue), yield* this.parseBlockStart();
        }
        *parseBlockStart() {
          let [e7, t6] = this.peek(2);
          if (!t6 && !this.atEnd) return this.setNext("block-start");
          if ((e7 === "-" || e7 === "?" || e7 === ":") && U14(t6)) {
            let n23 = (yield* this.pushCount(1)) + (yield* this.pushSpaces(true));
            return this.indentNext = this.indentValue + 1, this.indentValue += n23, yield* this.parseBlockStart();
          }
          return "doc";
        }
        *parseDocument() {
          yield* this.pushSpaces(true);
          let e7 = this.getLine();
          if (e7 === null) return this.setNext("doc");
          let t6 = yield* this.pushIndicators();
          switch (e7[t6]) {
            case "#":
              yield* this.pushCount(e7.length - t6);
            case void 0:
              return yield* this.pushNewline(), yield* this.parseLineStart();
            case "{":
            case "[":
              return yield* this.pushCount(1), this.flowKey = false, this.flowLevel = 1, "flow";
            case "}":
            case "]":
              return yield* this.pushCount(1), "doc";
            case "*":
              return yield* this.pushUntil(ui2), "doc";
            case '"':
            case "'":
              return yield* this.parseQuotedScalar();
            case "|":
            case ">":
              return t6 += yield* this.parseBlockScalarHeader(), t6 += yield* this.pushSpaces(true), yield* this.pushCount(e7.length - t6), yield* this.pushNewline(), yield* this.parseBlockScalar();
            default:
              return yield* this.parsePlainScalar();
          }
        }
        *parseFlowCollection() {
          let e7, t6, n23 = -1;
          do
            e7 = yield* this.pushNewline(), e7 > 0 ? (t6 = yield* this.pushSpaces(false), this.indentValue = n23 = t6) : t6 = 0, t6 += yield* this.pushSpaces(true);
          while (e7 + t6 > 0);
          let i10 = this.getLine();
          if (i10 === null) return this.setNext("flow");
          if ((n23 !== -1 && n23 < this.indentNext && i10[0] !== "#" || n23 === 0 && (i10.startsWith("---") || i10.startsWith("...")) && U14(i10[3])) && !(n23 === this.indentNext - 1 && this.flowLevel === 1 && (i10[0] === "]" || i10[0] === "}"))) return this.flowLevel = 0, yield pt4.FLOW_END, yield* this.parseLineStart();
          let r8 = 0;
          for (; i10[r8] === ","; ) r8 += yield* this.pushCount(1), r8 += yield* this.pushSpaces(true), this.flowKey = false;
          switch (r8 += yield* this.pushIndicators(), i10[r8]) {
            case void 0:
              return "flow";
            case "#":
              return yield* this.pushCount(i10.length - r8), "flow";
            case "{":
            case "[":
              return yield* this.pushCount(1), this.flowKey = false, this.flowLevel += 1, "flow";
            case "}":
            case "]":
              return yield* this.pushCount(1), this.flowKey = true, this.flowLevel -= 1, this.flowLevel ? "flow" : "doc";
            case "*":
              return yield* this.pushUntil(ui2), "flow";
            case '"':
            case "'":
              return this.flowKey = true, yield* this.parseQuotedScalar();
            case ":": {
              let o9 = this.charAt(1);
              if (this.flowKey || U14(o9) || o9 === ",") return this.flowKey = false, yield* this.pushCount(1), yield* this.pushSpaces(true), "flow";
            }
            default:
              return this.flowKey = false, yield* this.parsePlainScalar();
          }
        }
        *parseQuotedScalar() {
          let e7 = this.charAt(0), t6 = this.buffer.indexOf(e7, this.pos + 1);
          if (e7 === "'") for (; t6 !== -1 && this.buffer[t6 + 1] === "'"; ) t6 = this.buffer.indexOf("'", t6 + 2);
          else for (; t6 !== -1; ) {
            let r8 = 0;
            for (; this.buffer[t6 - 1 - r8] === "\\"; ) r8 += 1;
            if (r8 % 2 === 0) break;
            t6 = this.buffer.indexOf('"', t6 + 1);
          }
          let n23 = this.buffer.substring(0, t6), i10 = n23.indexOf(`
`, this.pos);
          if (i10 !== -1) {
            for (; i10 !== -1; ) {
              let r8 = this.continueScalar(i10 + 1);
              if (r8 === -1) break;
              i10 = n23.indexOf(`
`, r8);
            }
            i10 !== -1 && (t6 = i10 - (n23[i10 - 1] === "\r" ? 2 : 1));
          }
          if (t6 === -1) {
            if (!this.atEnd) return this.setNext("quoted-scalar");
            t6 = this.buffer.length;
          }
          return yield* this.pushToIndex(t6 + 1, false), this.flowLevel ? "flow" : "doc";
        }
        *parseBlockScalarHeader() {
          this.blockScalarIndent = -1, this.blockScalarKeep = false;
          let e7 = this.pos;
          for (; ; ) {
            let t6 = this.buffer[++e7];
            if (t6 === "+") this.blockScalarKeep = true;
            else if (t6 > "0" && t6 <= "9") this.blockScalarIndent = Number(t6) - 1;
            else if (t6 !== "-") break;
          }
          return yield* this.pushUntil((t6) => U14(t6) || t6 === "#");
        }
        *parseBlockScalar() {
          let e7 = this.pos - 1, t6 = 0, n23;
          e: for (let r8 = this.pos; n23 = this.buffer[r8]; ++r8) switch (n23) {
            case " ":
              t6 += 1;
              break;
            case `
`:
              e7 = r8, t6 = 0;
              break;
            case "\r": {
              let o9 = this.buffer[r8 + 1];
              if (!o9 && !this.atEnd) return this.setNext("block-scalar");
              if (o9 === `
`) break;
            }
            default:
              break e;
          }
          if (!n23 && !this.atEnd) return this.setNext("block-scalar");
          if (t6 >= this.indentNext) {
            this.blockScalarIndent === -1 ? this.indentNext = t6 : this.indentNext = this.blockScalarIndent + (this.indentNext === 0 ? 1 : this.indentNext);
            do {
              let r8 = this.continueScalar(e7 + 1);
              if (r8 === -1) break;
              e7 = this.buffer.indexOf(`
`, r8);
            } while (e7 !== -1);
            if (e7 === -1) {
              if (!this.atEnd) return this.setNext("block-scalar");
              e7 = this.buffer.length;
            }
          }
          let i10 = e7 + 1;
          for (n23 = this.buffer[i10]; n23 === " "; ) n23 = this.buffer[++i10];
          if (n23 === "	") {
            for (; n23 === "	" || n23 === " " || n23 === "\r" || n23 === `
`; ) n23 = this.buffer[++i10];
            e7 = i10 - 1;
          } else if (!this.blockScalarKeep) do {
            let r8 = e7 - 1, o9 = this.buffer[r8];
            o9 === "\r" && (o9 = this.buffer[--r8]);
            let a7 = r8;
            for (; o9 === " "; ) o9 = this.buffer[--r8];
            if (o9 === `
` && r8 >= this.pos && r8 + 1 + t6 > a7) e7 = r8;
            else break;
          } while (true);
          return yield pt4.SCALAR, yield* this.pushToIndex(e7 + 1, true), yield* this.parseLineStart();
        }
        *parsePlainScalar() {
          let e7 = this.flowLevel > 0, t6 = this.pos - 1, n23 = this.pos - 1, i10;
          for (; i10 = this.buffer[++n23]; ) if (i10 === ":") {
            let r8 = this.buffer[n23 + 1];
            if (U14(r8) || e7 && Ss3.has(r8)) break;
            t6 = n23;
          } else if (U14(i10)) {
            let r8 = this.buffer[n23 + 1];
            if (i10 === "\r" && (r8 === `
` ? (n23 += 1, i10 = `
`, r8 = this.buffer[n23 + 1]) : t6 = n23), r8 === "#" || e7 && Ss3.has(r8)) break;
            if (i10 === `
`) {
              let o9 = this.continueScalar(n23 + 1);
              if (o9 === -1) break;
              n23 = Math.max(n23, o9 - 2);
            }
          } else {
            if (e7 && Ss3.has(i10)) break;
            t6 = n23;
          }
          return !i10 && !this.atEnd ? this.setNext("plain-scalar") : (yield pt4.SCALAR, yield* this.pushToIndex(t6 + 1, true), e7 ? "flow" : "doc");
        }
        *pushCount(e7) {
          return e7 > 0 ? (yield this.buffer.substr(this.pos, e7), this.pos += e7, e7) : 0;
        }
        *pushToIndex(e7, t6) {
          let n23 = this.buffer.slice(this.pos, e7);
          return n23 ? (yield n23, this.pos += n23.length, n23.length) : (t6 && (yield ""), 0);
        }
        *pushIndicators() {
          switch (this.charAt(0)) {
            case "!":
              return (yield* this.pushTag()) + (yield* this.pushSpaces(true)) + (yield* this.pushIndicators());
            case "&":
              return (yield* this.pushUntil(ui2)) + (yield* this.pushSpaces(true)) + (yield* this.pushIndicators());
            case "-":
            case "?":
            case ":": {
              let e7 = this.flowLevel > 0, t6 = this.charAt(1);
              if (U14(t6) || e7 && Ss3.has(t6)) return e7 ? this.flowKey && (this.flowKey = false) : this.indentNext = this.indentValue + 1, (yield* this.pushCount(1)) + (yield* this.pushSpaces(true)) + (yield* this.pushIndicators());
            }
          }
          return 0;
        }
        *pushTag() {
          if (this.charAt(1) === "<") {
            let e7 = this.pos + 2, t6 = this.buffer[e7];
            for (; !U14(t6) && t6 !== ">"; ) t6 = this.buffer[++e7];
            return yield* this.pushToIndex(t6 === ">" ? e7 + 1 : e7, false);
          } else {
            let e7 = this.pos + 1, t6 = this.buffer[e7];
            for (; t6; ) if (Zd.has(t6)) t6 = this.buffer[++e7];
            else if (t6 === "%" && Ta.has(this.buffer[e7 + 1]) && Ta.has(this.buffer[e7 + 2])) t6 = this.buffer[e7 += 3];
            else break;
            return yield* this.pushToIndex(e7, false);
          }
        }
        *pushNewline() {
          let e7 = this.buffer[this.pos];
          return e7 === `
` ? yield* this.pushCount(1) : e7 === "\r" && this.charAt(1) === `
` ? yield* this.pushCount(2) : 0;
        }
        *pushSpaces(e7) {
          let t6 = this.pos - 1, n23;
          do
            n23 = this.buffer[++t6];
          while (n23 === " " || e7 && n23 === "	");
          let i10 = t6 - this.pos;
          return i10 > 0 && (yield this.buffer.substr(this.pos, i10), this.pos = t6), i10;
        }
        *pushUntil(e7) {
          let t6 = this.pos, n23 = this.buffer[t6];
          for (; !e7(n23); ) n23 = this.buffer[++t6];
          return yield* this.pushToIndex(t6, false);
        }
      };
      Oa.Lexer = di2;
    });
    mi = o((ka2) => {
      "use strict";
      var pi2 = class {
        constructor() {
          this.lineStarts = [], this.addNewLine = (e7) => this.lineStarts.push(e7), this.linePos = (e7) => {
            let t6 = 0, n23 = this.lineStarts.length;
            for (; t6 < n23; ) {
              let r8 = t6 + n23 >> 1;
              this.lineStarts[r8] < e7 ? t6 = r8 + 1 : n23 = r8;
            }
            if (this.lineStarts[t6] === e7) return { line: t6 + 1, col: 1 };
            if (t6 === 0) return { line: 0, col: e7 };
            let i10 = this.lineStarts[t6 - 1];
            return { line: t6, col: e7 - i10 + 1 };
          };
        }
      };
      ka2.LineCounter = pi2;
    });
    yi = o((Pa2) => {
      "use strict";
      var th = m4("process"), Ia = ws2(), sh = hi2();
      function re5(s9, e7) {
        for (let t6 = 0; t6 < s9.length; ++t6) if (s9[t6].type === e7) return true;
        return false;
      }
      function qa(s9) {
        for (let e7 = 0; e7 < s9.length; ++e7) switch (s9[e7].type) {
          case "space":
          case "comment":
          case "newline":
            break;
          default:
            return e7;
        }
        return -1;
      }
      function La(s9) {
        switch (s9?.type) {
          case "alias":
          case "scalar":
          case "single-quoted-scalar":
          case "double-quoted-scalar":
          case "flow-collection":
            return true;
          default:
            return false;
        }
      }
      function Ns3(s9) {
        switch (s9.type) {
          case "document":
            return s9.start;
          case "block-map": {
            let e7 = s9.items[s9.items.length - 1];
            return e7.sep ?? e7.start;
          }
          case "block-seq":
            return s9.items[s9.items.length - 1].start;
          default:
            return [];
        }
      }
      function Ce6(s9) {
        if (s9.length === 0) return [];
        let e7 = s9.length;
        e: for (; --e7 >= 0; ) switch (s9[e7].type) {
          case "doc-start":
          case "explicit-key-ind":
          case "map-value-ind":
          case "seq-item-ind":
          case "newline":
            break e;
        }
        for (; s9[++e7]?.type === "space"; ) ;
        return s9.splice(e7, s9.length);
      }
      function Ca2(s9) {
        if (s9.start.type === "flow-seq-start") for (let e7 of s9.items) e7.sep && !e7.value && !re5(e7.start, "explicit-key-ind") && !re5(e7.sep, "map-value-ind") && (e7.key && (e7.value = e7.key), delete e7.key, La(e7.value) ? e7.value.end ? Array.prototype.push.apply(e7.value.end, e7.sep) : e7.value.end = e7.sep : Array.prototype.push.apply(e7.start, e7.sep), delete e7.sep);
      }
      var gi2 = class {
        constructor(e7) {
          this.atNewLine = true, this.atScalar = false, this.indent = 0, this.offset = 0, this.onKeyLine = false, this.stack = [], this.source = "", this.type = "", this.lexer = new sh.Lexer(), this.onNewLine = e7;
        }
        *parse(e7, t6 = false) {
          this.onNewLine && this.offset === 0 && this.onNewLine(0);
          for (let n23 of this.lexer.lex(e7, t6)) yield* this.next(n23);
          t6 || (yield* this.end());
        }
        *next(e7) {
          if (this.source = e7, th.env.LOG_TOKENS && console.log("|", Ia.prettyToken(e7)), this.atScalar) {
            this.atScalar = false, yield* this.step(), this.offset += e7.length;
            return;
          }
          let t6 = Ia.tokenType(e7);
          if (t6) if (t6 === "scalar") this.atNewLine = false, this.atScalar = true, this.type = "scalar";
          else {
            switch (this.type = t6, yield* this.step(), t6) {
              case "newline":
                this.atNewLine = true, this.indent = 0, this.onNewLine && this.onNewLine(this.offset + e7.length);
                break;
              case "space":
                this.atNewLine && e7[0] === " " && (this.indent += e7.length);
                break;
              case "explicit-key-ind":
              case "map-value-ind":
              case "seq-item-ind":
                this.atNewLine && (this.indent += e7.length);
                break;
              case "doc-mode":
              case "flow-error-end":
                return;
              default:
                this.atNewLine = false;
            }
            this.offset += e7.length;
          }
          else {
            let n23 = `Not a YAML token: ${e7}`;
            yield* this.pop({ type: "error", offset: this.offset, message: n23, source: e7 }), this.offset += e7.length;
          }
        }
        *end() {
          for (; this.stack.length > 0; ) yield* this.pop();
        }
        get sourceToken() {
          return { type: this.type, offset: this.offset, indent: this.indent, source: this.source };
        }
        *step() {
          let e7 = this.peek(1);
          if (this.type === "doc-end" && e7?.type !== "doc-end") {
            for (; this.stack.length > 0; ) yield* this.pop();
            this.stack.push({ type: "doc-end", offset: this.offset, source: this.source });
            return;
          }
          if (!e7) return yield* this.stream();
          switch (e7.type) {
            case "document":
              return yield* this.document(e7);
            case "alias":
            case "scalar":
            case "single-quoted-scalar":
            case "double-quoted-scalar":
              return yield* this.scalar(e7);
            case "block-scalar":
              return yield* this.blockScalar(e7);
            case "block-map":
              return yield* this.blockMap(e7);
            case "block-seq":
              return yield* this.blockSequence(e7);
            case "flow-collection":
              return yield* this.flowCollection(e7);
            case "doc-end":
              return yield* this.documentEnd(e7);
          }
          yield* this.pop();
        }
        peek(e7) {
          return this.stack[this.stack.length - e7];
        }
        *pop(e7) {
          let t6 = e7 ?? this.stack.pop();
          if (!t6) yield { type: "error", offset: this.offset, source: "", message: "Tried to pop an empty stack" };
          else if (this.stack.length === 0) yield t6;
          else {
            let n23 = this.peek(1);
            switch (t6.type === "block-scalar" ? t6.indent = "indent" in n23 ? n23.indent : 0 : t6.type === "flow-collection" && n23.type === "document" && (t6.indent = 0), t6.type === "flow-collection" && Ca2(t6), n23.type) {
              case "document":
                n23.value = t6;
                break;
              case "block-scalar":
                n23.props.push(t6);
                break;
              case "block-map": {
                let i10 = n23.items[n23.items.length - 1];
                if (i10.value) {
                  n23.items.push({ start: [], key: t6, sep: [] }), this.onKeyLine = true;
                  return;
                } else if (i10.sep) i10.value = t6;
                else {
                  Object.assign(i10, { key: t6, sep: [] }), this.onKeyLine = !i10.explicitKey;
                  return;
                }
                break;
              }
              case "block-seq": {
                let i10 = n23.items[n23.items.length - 1];
                i10.value ? n23.items.push({ start: [], value: t6 }) : i10.value = t6;
                break;
              }
              case "flow-collection": {
                let i10 = n23.items[n23.items.length - 1];
                !i10 || i10.value ? n23.items.push({ start: [], key: t6, sep: [] }) : i10.sep ? i10.value = t6 : Object.assign(i10, { key: t6, sep: [] });
                return;
              }
              default:
                yield* this.pop(), yield* this.pop(t6);
            }
            if ((n23.type === "document" || n23.type === "block-map" || n23.type === "block-seq") && (t6.type === "block-map" || t6.type === "block-seq")) {
              let i10 = t6.items[t6.items.length - 1];
              i10 && !i10.sep && !i10.value && i10.start.length > 0 && qa(i10.start) === -1 && (t6.indent === 0 || i10.start.every((r8) => r8.type !== "comment" || r8.indent < t6.indent)) && (n23.type === "document" ? n23.end = i10.start : n23.items.push({ start: i10.start }), t6.items.splice(-1, 1));
            }
          }
        }
        *stream() {
          switch (this.type) {
            case "directive-line":
              yield { type: "directive", offset: this.offset, source: this.source };
              return;
            case "byte-order-mark":
            case "space":
            case "comment":
            case "newline":
              yield this.sourceToken;
              return;
            case "doc-mode":
            case "doc-start": {
              let e7 = { type: "document", offset: this.offset, start: [] };
              this.type === "doc-start" && e7.start.push(this.sourceToken), this.stack.push(e7);
              return;
            }
          }
          yield { type: "error", offset: this.offset, message: `Unexpected ${this.type} token in YAML stream`, source: this.source };
        }
        *document(e7) {
          if (e7.value) return yield* this.lineEnd(e7);
          switch (this.type) {
            case "doc-start": {
              qa(e7.start) !== -1 ? (yield* this.pop(), yield* this.step()) : e7.start.push(this.sourceToken);
              return;
            }
            case "anchor":
            case "tag":
            case "space":
            case "comment":
            case "newline":
              e7.start.push(this.sourceToken);
              return;
          }
          let t6 = this.startBlockValue(e7);
          t6 ? this.stack.push(t6) : yield { type: "error", offset: this.offset, message: `Unexpected ${this.type} token in YAML document`, source: this.source };
        }
        *scalar(e7) {
          if (this.type === "map-value-ind") {
            let t6 = Ns3(this.peek(2)), n23 = Ce6(t6), i10;
            e7.end ? (i10 = e7.end, i10.push(this.sourceToken), delete e7.end) : i10 = [this.sourceToken];
            let r8 = { type: "block-map", offset: e7.offset, indent: e7.indent, items: [{ start: n23, key: e7, sep: i10 }] };
            this.onKeyLine = true, this.stack[this.stack.length - 1] = r8;
          } else yield* this.lineEnd(e7);
        }
        *blockScalar(e7) {
          switch (this.type) {
            case "space":
            case "comment":
            case "newline":
              e7.props.push(this.sourceToken);
              return;
            case "scalar":
              if (e7.source = this.source, this.atNewLine = true, this.indent = 0, this.onNewLine) {
                let t6 = this.source.indexOf(`
`) + 1;
                for (; t6 !== 0; ) this.onNewLine(this.offset + t6), t6 = this.source.indexOf(`
`, t6) + 1;
              }
              yield* this.pop();
              break;
            default:
              yield* this.pop(), yield* this.step();
          }
        }
        *blockMap(e7) {
          let t6 = e7.items[e7.items.length - 1];
          switch (this.type) {
            case "newline":
              if (this.onKeyLine = false, t6.value) {
                let n23 = "end" in t6.value ? t6.value.end : void 0;
                (Array.isArray(n23) ? n23[n23.length - 1] : void 0)?.type === "comment" ? n23?.push(this.sourceToken) : e7.items.push({ start: [this.sourceToken] });
              } else t6.sep ? t6.sep.push(this.sourceToken) : t6.start.push(this.sourceToken);
              return;
            case "space":
            case "comment":
              if (t6.value) e7.items.push({ start: [this.sourceToken] });
              else if (t6.sep) t6.sep.push(this.sourceToken);
              else {
                if (this.atIndentedComment(t6.start, e7.indent)) {
                  let i10 = e7.items[e7.items.length - 2]?.value?.end;
                  if (Array.isArray(i10)) {
                    Array.prototype.push.apply(i10, t6.start), i10.push(this.sourceToken), e7.items.pop();
                    return;
                  }
                }
                t6.start.push(this.sourceToken);
              }
              return;
          }
          if (this.indent >= e7.indent) {
            let n23 = !this.onKeyLine && this.indent === e7.indent, i10 = n23 && (t6.sep || t6.explicitKey) && this.type !== "seq-item-ind", r8 = [];
            if (i10 && t6.sep && !t6.value) {
              let o9 = [];
              for (let a7 = 0; a7 < t6.sep.length; ++a7) {
                let l8 = t6.sep[a7];
                switch (l8.type) {
                  case "newline":
                    o9.push(a7);
                    break;
                  case "space":
                    break;
                  case "comment":
                    l8.indent > e7.indent && (o9.length = 0);
                    break;
                  default:
                    o9.length = 0;
                }
              }
              o9.length >= 2 && (r8 = t6.sep.splice(o9[1]));
            }
            switch (this.type) {
              case "anchor":
              case "tag":
                i10 || t6.value ? (r8.push(this.sourceToken), e7.items.push({ start: r8 }), this.onKeyLine = true) : t6.sep ? t6.sep.push(this.sourceToken) : t6.start.push(this.sourceToken);
                return;
              case "explicit-key-ind":
                !t6.sep && !t6.explicitKey ? (t6.start.push(this.sourceToken), t6.explicitKey = true) : i10 || t6.value ? (r8.push(this.sourceToken), e7.items.push({ start: r8, explicitKey: true })) : this.stack.push({ type: "block-map", offset: this.offset, indent: this.indent, items: [{ start: [this.sourceToken], explicitKey: true }] }), this.onKeyLine = true;
                return;
              case "map-value-ind":
                if (t6.explicitKey) if (t6.sep) if (t6.value) e7.items.push({ start: [], key: null, sep: [this.sourceToken] });
                else if (re5(t6.sep, "map-value-ind")) this.stack.push({ type: "block-map", offset: this.offset, indent: this.indent, items: [{ start: r8, key: null, sep: [this.sourceToken] }] });
                else if (La(t6.key) && !re5(t6.sep, "newline")) {
                  let o9 = Ce6(t6.start), a7 = t6.key, l8 = t6.sep;
                  l8.push(this.sourceToken), delete t6.key, delete t6.sep, this.stack.push({ type: "block-map", offset: this.offset, indent: this.indent, items: [{ start: o9, key: a7, sep: l8 }] });
                } else r8.length > 0 ? t6.sep = t6.sep.concat(r8, this.sourceToken) : t6.sep.push(this.sourceToken);
                else if (re5(t6.start, "newline")) Object.assign(t6, { key: null, sep: [this.sourceToken] });
                else {
                  let o9 = Ce6(t6.start);
                  this.stack.push({ type: "block-map", offset: this.offset, indent: this.indent, items: [{ start: o9, key: null, sep: [this.sourceToken] }] });
                }
                else t6.sep ? t6.value || i10 ? e7.items.push({ start: r8, key: null, sep: [this.sourceToken] }) : re5(t6.sep, "map-value-ind") ? this.stack.push({ type: "block-map", offset: this.offset, indent: this.indent, items: [{ start: [], key: null, sep: [this.sourceToken] }] }) : t6.sep.push(this.sourceToken) : Object.assign(t6, { key: null, sep: [this.sourceToken] });
                this.onKeyLine = true;
                return;
              case "alias":
              case "scalar":
              case "single-quoted-scalar":
              case "double-quoted-scalar": {
                let o9 = this.flowScalar(this.type);
                i10 || t6.value ? (e7.items.push({ start: r8, key: o9, sep: [] }), this.onKeyLine = true) : t6.sep ? this.stack.push(o9) : (Object.assign(t6, { key: o9, sep: [] }), this.onKeyLine = true);
                return;
              }
              default: {
                let o9 = this.startBlockValue(e7);
                if (o9) {
                  if (o9.type === "block-seq") {
                    if (!t6.explicitKey && t6.sep && !re5(t6.sep, "newline")) {
                      yield* this.pop({ type: "error", offset: this.offset, message: "Unexpected block-seq-ind on same line with key", source: this.source });
                      return;
                    }
                  } else n23 && e7.items.push({ start: r8 });
                  this.stack.push(o9);
                  return;
                }
              }
            }
          }
          yield* this.pop(), yield* this.step();
        }
        *blockSequence(e7) {
          let t6 = e7.items[e7.items.length - 1];
          switch (this.type) {
            case "newline":
              if (t6.value) {
                let n23 = "end" in t6.value ? t6.value.end : void 0;
                (Array.isArray(n23) ? n23[n23.length - 1] : void 0)?.type === "comment" ? n23?.push(this.sourceToken) : e7.items.push({ start: [this.sourceToken] });
              } else t6.start.push(this.sourceToken);
              return;
            case "space":
            case "comment":
              if (t6.value) e7.items.push({ start: [this.sourceToken] });
              else {
                if (this.atIndentedComment(t6.start, e7.indent)) {
                  let i10 = e7.items[e7.items.length - 2]?.value?.end;
                  if (Array.isArray(i10)) {
                    Array.prototype.push.apply(i10, t6.start), i10.push(this.sourceToken), e7.items.pop();
                    return;
                  }
                }
                t6.start.push(this.sourceToken);
              }
              return;
            case "anchor":
            case "tag":
              if (t6.value || this.indent <= e7.indent) break;
              t6.start.push(this.sourceToken);
              return;
            case "seq-item-ind":
              if (this.indent !== e7.indent) break;
              t6.value || re5(t6.start, "seq-item-ind") ? e7.items.push({ start: [this.sourceToken] }) : t6.start.push(this.sourceToken);
              return;
          }
          if (this.indent > e7.indent) {
            let n23 = this.startBlockValue(e7);
            if (n23) {
              this.stack.push(n23);
              return;
            }
          }
          yield* this.pop(), yield* this.step();
        }
        *flowCollection(e7) {
          let t6 = e7.items[e7.items.length - 1];
          if (this.type === "flow-error-end") {
            let n23;
            do
              yield* this.pop(), n23 = this.peek(1);
            while (n23?.type === "flow-collection");
          } else if (e7.end.length === 0) {
            switch (this.type) {
              case "comma":
              case "explicit-key-ind":
                !t6 || t6.sep ? e7.items.push({ start: [this.sourceToken] }) : t6.start.push(this.sourceToken);
                return;
              case "map-value-ind":
                !t6 || t6.value ? e7.items.push({ start: [], key: null, sep: [this.sourceToken] }) : t6.sep ? t6.sep.push(this.sourceToken) : Object.assign(t6, { key: null, sep: [this.sourceToken] });
                return;
              case "space":
              case "comment":
              case "newline":
              case "anchor":
              case "tag":
                !t6 || t6.value ? e7.items.push({ start: [this.sourceToken] }) : t6.sep ? t6.sep.push(this.sourceToken) : t6.start.push(this.sourceToken);
                return;
              case "alias":
              case "scalar":
              case "single-quoted-scalar":
              case "double-quoted-scalar": {
                let i10 = this.flowScalar(this.type);
                !t6 || t6.value ? e7.items.push({ start: [], key: i10, sep: [] }) : t6.sep ? this.stack.push(i10) : Object.assign(t6, { key: i10, sep: [] });
                return;
              }
              case "flow-map-end":
              case "flow-seq-end":
                e7.end.push(this.sourceToken);
                return;
            }
            let n23 = this.startBlockValue(e7);
            n23 ? this.stack.push(n23) : (yield* this.pop(), yield* this.step());
          } else {
            let n23 = this.peek(2);
            if (n23.type === "block-map" && (this.type === "map-value-ind" && n23.indent === e7.indent || this.type === "newline" && !n23.items[n23.items.length - 1].sep)) yield* this.pop(), yield* this.step();
            else if (this.type === "map-value-ind" && n23.type !== "flow-collection") {
              let i10 = Ns3(n23), r8 = Ce6(i10);
              Ca2(e7);
              let o9 = e7.end.splice(1, e7.end.length);
              o9.push(this.sourceToken);
              let a7 = { type: "block-map", offset: e7.offset, indent: e7.indent, items: [{ start: r8, key: e7, sep: o9 }] };
              this.onKeyLine = true, this.stack[this.stack.length - 1] = a7;
            } else yield* this.lineEnd(e7);
          }
        }
        flowScalar(e7) {
          if (this.onNewLine) {
            let t6 = this.source.indexOf(`
`) + 1;
            for (; t6 !== 0; ) this.onNewLine(this.offset + t6), t6 = this.source.indexOf(`
`, t6) + 1;
          }
          return { type: e7, offset: this.offset, indent: this.indent, source: this.source };
        }
        startBlockValue(e7) {
          switch (this.type) {
            case "alias":
            case "scalar":
            case "single-quoted-scalar":
            case "double-quoted-scalar":
              return this.flowScalar(this.type);
            case "block-scalar-header":
              return { type: "block-scalar", offset: this.offset, indent: this.indent, props: [this.sourceToken], source: "" };
            case "flow-map-start":
            case "flow-seq-start":
              return { type: "flow-collection", offset: this.offset, indent: this.indent, start: this.sourceToken, items: [], end: [] };
            case "seq-item-ind":
              return { type: "block-seq", offset: this.offset, indent: this.indent, items: [{ start: [this.sourceToken] }] };
            case "explicit-key-ind": {
              this.onKeyLine = true;
              let t6 = Ns3(e7), n23 = Ce6(t6);
              return n23.push(this.sourceToken), { type: "block-map", offset: this.offset, indent: this.indent, items: [{ start: n23, explicitKey: true }] };
            }
            case "map-value-ind": {
              this.onKeyLine = true;
              let t6 = Ns3(e7), n23 = Ce6(t6);
              return { type: "block-map", offset: this.offset, indent: this.indent, items: [{ start: n23, key: null, sep: [this.sourceToken] }] };
            }
          }
          return null;
        }
        atIndentedComment(e7, t6) {
          return this.type !== "comment" || this.indent <= t6 ? false : e7.every((n23) => n23.type === "newline" || n23.type === "space");
        }
        *documentEnd(e7) {
          this.type !== "doc-mode" && (e7.end ? e7.end.push(this.sourceToken) : e7.end = [this.sourceToken], this.type === "newline" && (yield* this.pop()));
        }
        *lineEnd(e7) {
          switch (this.type) {
            case "comma":
            case "doc-start":
            case "doc-end":
            case "flow-seq-end":
            case "flow-map-end":
            case "map-value-ind":
              yield* this.pop(), yield* this.step();
              break;
            case "newline":
              this.onKeyLine = false;
            default:
              e7.end ? e7.end.push(this.sourceToken) : e7.end = [this.sourceToken], this.type === "newline" && (yield* this.pop());
          }
        }
      };
      Pa2.Parser = gi2;
    });
    Ba = o((gt4) => {
      "use strict";
      var Ma = ni(), nh = at5(), mt5 = ft5(), ih = en2(), rh = O13(), oh = mi(), $a2 = yi();
      function _a3(s9) {
        let e7 = s9.prettyErrors !== false;
        return { lineCounter: s9.lineCounter || e7 && new oh.LineCounter() || null, prettyErrors: e7 };
      }
      function ah(s9, e7 = {}) {
        let { lineCounter: t6, prettyErrors: n23 } = _a3(e7), i10 = new $a2.Parser(t6?.addNewLine), r8 = new Ma.Composer(e7), o9 = Array.from(r8.compose(i10.parse(s9)));
        if (n23 && t6) for (let a7 of o9) a7.errors.forEach(mt5.prettifyError(s9, t6)), a7.warnings.forEach(mt5.prettifyError(s9, t6));
        return o9.length > 0 ? o9 : Object.assign([], { empty: true }, r8.streamInfo());
      }
      function xa2(s9, e7 = {}) {
        let { lineCounter: t6, prettyErrors: n23 } = _a3(e7), i10 = new $a2.Parser(t6?.addNewLine), r8 = new Ma.Composer(e7), o9 = null;
        for (let a7 of r8.compose(i10.parse(s9), true, s9.length)) if (!o9) o9 = a7;
        else if (o9.options.logLevel !== "silent") {
          o9.errors.push(new mt5.YAMLParseError(a7.range.slice(0, 2), "MULTIPLE_DOCS", "Source contains multiple documents; please use YAML.parseAllDocuments()"));
          break;
        }
        return n23 && t6 && (o9.errors.forEach(mt5.prettifyError(s9, t6)), o9.warnings.forEach(mt5.prettifyError(s9, t6))), o9;
      }
      function lh(s9, e7, t6) {
        let n23;
        typeof e7 == "function" ? n23 = e7 : t6 === void 0 && e7 && typeof e7 == "object" && (t6 = e7);
        let i10 = xa2(s9, t6);
        if (!i10) return null;
        if (i10.warnings.forEach((r8) => ih.warn(i10.options.logLevel, r8)), i10.errors.length > 0) {
          if (i10.options.logLevel !== "silent") throw i10.errors[0];
          i10.errors = [];
        }
        return i10.toJS(Object.assign({ reviver: n23 }, t6));
      }
      function ch(s9, e7, t6) {
        let n23 = null;
        if (typeof e7 == "function" || Array.isArray(e7) ? n23 = e7 : t6 === void 0 && e7 && (t6 = e7), typeof t6 == "string" && (t6 = t6.length), typeof t6 == "number") {
          let i10 = Math.round(t6);
          t6 = i10 < 1 ? void 0 : i10 > 8 ? { indent: 8 } : { indent: i10 };
        }
        if (s9 === void 0) {
          let { keepUndefined: i10 } = t6 ?? e7 ?? {};
          if (!i10) return;
        }
        return rh.isDocument(s9) && !n23 ? s9.toString(t6) : new nh.Document(s9, n23, t6).toString(t6);
      }
      gt4.parse = lh;
      gt4.parseAllDocuments = ah;
      gt4.parseDocument = xa2;
      gt4.stringify = ch;
    });
    ja = o((k17) => {
      "use strict";
      var fh = ni(), uh = at5(), dh = Bn2(), bi2 = ft5(), hh = Ue4(), oe9 = O13(), ph = te8(), mh = C17(), gh = ne7(), yh = ie4(), bh = ws2(), wh = hi2(), Sh = mi(), Nh = yi(), Es3 = Ba(), Fa2 = Ve5();
      k17.Composer = fh.Composer;
      k17.Document = uh.Document;
      k17.Schema = dh.Schema;
      k17.YAMLError = bi2.YAMLError;
      k17.YAMLParseError = bi2.YAMLParseError;
      k17.YAMLWarning = bi2.YAMLWarning;
      k17.Alias = hh.Alias;
      k17.isAlias = oe9.isAlias;
      k17.isCollection = oe9.isCollection;
      k17.isDocument = oe9.isDocument;
      k17.isMap = oe9.isMap;
      k17.isNode = oe9.isNode;
      k17.isPair = oe9.isPair;
      k17.isScalar = oe9.isScalar;
      k17.isSeq = oe9.isSeq;
      k17.Pair = ph.Pair;
      k17.Scalar = mh.Scalar;
      k17.YAMLMap = gh.YAMLMap;
      k17.YAMLSeq = yh.YAMLSeq;
      k17.CST = bh;
      k17.Lexer = wh.Lexer;
      k17.LineCounter = Sh.LineCounter;
      k17.Parser = Nh.Parser;
      k17.parse = Es3.parse;
      k17.parseAllDocuments = Es3.parseAllDocuments;
      k17.parseDocument = Es3.parseDocument;
      k17.stringify = Es3.stringify;
      k17.visit = Fa2.visit;
      k17.visitAsync = Fa2.visitAsync;
    });
    ki = ":A-Za-z_\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
    Wa = ki + "\\-.\\d\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
    Ga = "[" + ki + "][" + Wa + "]*";
    Xa = new RegExp("^" + Ga + "$");
    ye5 = function(s9) {
      let e7 = Xa.exec(s9);
      return !(e7 === null || typeof e7 > "u");
    };
    Qa = { allowBooleanAttributes: false, unpairedTags: [] };
    Ha = '"';
    Da = "'";
    Za = new RegExp(`(\\s*)([^\\s=]+)(\\s*=)?(\\s*(['"])(([\\s\\S])*?)\\5)?`, "g");
    il = { preserveOrder: false, attributeNamePrefix: "@_", attributesGroupName: false, textNodeName: "#text", ignoreAttributes: true, removeNSPrefix: false, allowBooleanAttributes: false, parseTagValue: true, parseAttributeValue: false, trimValues: true, cdataPropName: false, numberParseOptions: { hex: true, leadingZeros: true, eNotation: true }, tagValueProcessor: function(s9, e7) {
      return e7;
    }, attributeValueProcessor: function(s9, e7) {
      return e7;
    }, stopNodes: [], alwaysCreateTextNode: false, isArray: () => false, commentPropName: false, unpairedTags: [], processEntities: true, htmlEntities: false, ignoreDeclaration: false, ignorePiTags: false, transformTagName: false, transformAttributeName: false, updateTag: function(s9, e7, t6) {
      return s9;
    }, captureMetaData: false };
    $i2 = function(s9) {
      return Object.assign({}, il, s9);
    };
    typeof Symbol != "function" ? St4 = "@@xmlMetadata" : St4 = Symbol("XML Node Metadata");
    V10 = class {
      constructor(e7) {
        this.tagname = e7, this.child = [], this[":@"] = {};
      }
      add(e7, t6) {
        e7 === "__proto__" && (e7 = "#__proto__"), this.child.push({ [e7]: t6 });
      }
      addChild(e7, t6) {
        e7.tagname === "__proto__" && (e7.tagname = "#__proto__"), e7[":@"] && Object.keys(e7[":@"]).length > 0 ? this.child.push({ [e7.tagname]: e7.child, ":@": e7[":@"] }) : this.child.push({ [e7.tagname]: e7.child }), t6 !== void 0 && (this.child[this.child.length - 1][St4] = { startIndex: t6 });
      }
      static getMetaDataSymbol() {
        return St4;
      }
    };
    $e5 = class {
      constructor(e7) {
        this.suppressValidationErr = !e7;
      }
      readDocType(e7, t6) {
        let n23 = {};
        if (e7[t6 + 3] === "O" && e7[t6 + 4] === "C" && e7[t6 + 5] === "T" && e7[t6 + 6] === "Y" && e7[t6 + 7] === "P" && e7[t6 + 8] === "E") {
          t6 = t6 + 9;
          let i10 = 1, r8 = false, o9 = false, a7 = "";
          for (; t6 < e7.length; t6++) if (e7[t6] === "<" && !o9) {
            if (r8 && le7(e7, "!ENTITY", t6)) {
              t6 += 7;
              let l8, c15;
              [l8, c15, t6] = this.readEntityExp(e7, t6 + 1, this.suppressValidationErr), c15.indexOf("&") === -1 && (n23[l8] = { regx: RegExp(`&${l8};`, "g"), val: c15 });
            } else if (r8 && le7(e7, "!ELEMENT", t6)) {
              t6 += 8;
              let { index: l8 } = this.readElementExp(e7, t6 + 1);
              t6 = l8;
            } else if (r8 && le7(e7, "!ATTLIST", t6)) t6 += 8;
            else if (r8 && le7(e7, "!NOTATION", t6)) {
              t6 += 9;
              let { index: l8 } = this.readNotationExp(e7, t6 + 1, this.suppressValidationErr);
              t6 = l8;
            } else if (le7(e7, "!--", t6)) o9 = true;
            else throw new Error("Invalid DOCTYPE");
            i10++, a7 = "";
          } else if (e7[t6] === ">") {
            if (o9 ? e7[t6 - 1] === "-" && e7[t6 - 2] === "-" && (o9 = false, i10--) : i10--, i10 === 0) break;
          } else e7[t6] === "[" ? r8 = true : a7 += e7[t6];
          if (i10 !== 0) throw new Error("Unclosed DOCTYPE");
        } else throw new Error("Invalid Tag instead of DOCTYPE");
        return { entities: n23, i: t6 };
      }
      readEntityExp(e7, t6) {
        t6 = x22(e7, t6);
        let n23 = "";
        for (; t6 < e7.length && !/\s/.test(e7[t6]) && e7[t6] !== '"' && e7[t6] !== "'"; ) n23 += e7[t6], t6++;
        if (Me5(n23), t6 = x22(e7, t6), !this.suppressValidationErr) {
          if (e7.substring(t6, t6 + 6).toUpperCase() === "SYSTEM") throw new Error("External entities are not supported");
          if (e7[t6] === "%") throw new Error("Parameter entities are not supported");
        }
        let i10 = "";
        return [t6, i10] = this.readIdentifierVal(e7, t6, "entity"), t6--, [n23, i10, t6];
      }
      readNotationExp(e7, t6) {
        t6 = x22(e7, t6);
        let n23 = "";
        for (; t6 < e7.length && !/\s/.test(e7[t6]); ) n23 += e7[t6], t6++;
        !this.suppressValidationErr && Me5(n23), t6 = x22(e7, t6);
        let i10 = e7.substring(t6, t6 + 6).toUpperCase();
        if (!this.suppressValidationErr && i10 !== "SYSTEM" && i10 !== "PUBLIC") throw new Error(`Expected SYSTEM or PUBLIC, found "${i10}"`);
        t6 += i10.length, t6 = x22(e7, t6);
        let r8 = null, o9 = null;
        if (i10 === "PUBLIC") [t6, r8] = this.readIdentifierVal(e7, t6, "publicIdentifier"), t6 = x22(e7, t6), (e7[t6] === '"' || e7[t6] === "'") && ([t6, o9] = this.readIdentifierVal(e7, t6, "systemIdentifier"));
        else if (i10 === "SYSTEM" && ([t6, o9] = this.readIdentifierVal(e7, t6, "systemIdentifier"), !this.suppressValidationErr && !o9)) throw new Error("Missing mandatory system identifier for SYSTEM notation");
        return { notationName: n23, publicIdentifier: r8, systemIdentifier: o9, index: --t6 };
      }
      readIdentifierVal(e7, t6, n23) {
        let i10 = "", r8 = e7[t6];
        if (r8 !== '"' && r8 !== "'") throw new Error(`Expected quoted string, found "${r8}"`);
        for (t6++; t6 < e7.length && e7[t6] !== r8; ) i10 += e7[t6], t6++;
        if (e7[t6] !== r8) throw new Error(`Unterminated ${n23} value`);
        return t6++, [t6, i10];
      }
      readElementExp(e7, t6) {
        t6 = x22(e7, t6);
        let n23 = "";
        for (; t6 < e7.length && !/\s/.test(e7[t6]); ) n23 += e7[t6], t6++;
        if (!this.suppressValidationErr && !ye5(n23)) throw new Error(`Invalid element name: "${n23}"`);
        t6 = x22(e7, t6);
        let i10 = "";
        if (e7[t6] === "E" && le7(e7, "MPTY", t6)) t6 += 4;
        else if (e7[t6] === "A" && le7(e7, "NY", t6)) t6 += 2;
        else if (e7[t6] === "(") {
          for (t6++; t6 < e7.length && e7[t6] !== ")"; ) i10 += e7[t6], t6++;
          if (e7[t6] !== ")") throw new Error("Unterminated content model");
        } else if (!this.suppressValidationErr) throw new Error(`Invalid Element Expression, found "${e7[t6]}"`);
        return { elementName: n23, contentModel: i10.trim(), index: t6 };
      }
      readAttlistExp(e7, t6) {
        t6 = x22(e7, t6);
        let n23 = "";
        for (; t6 < e7.length && !/\s/.test(e7[t6]); ) n23 += e7[t6], t6++;
        Me5(n23), t6 = x22(e7, t6);
        let i10 = "";
        for (; t6 < e7.length && !/\s/.test(e7[t6]); ) i10 += e7[t6], t6++;
        if (!Me5(i10)) throw new Error(`Invalid attribute name: "${i10}"`);
        t6 = x22(e7, t6);
        let r8 = "";
        if (e7.substring(t6, t6 + 8).toUpperCase() === "NOTATION") {
          if (r8 = "NOTATION", t6 += 8, t6 = x22(e7, t6), e7[t6] !== "(") throw new Error(`Expected '(', found "${e7[t6]}"`);
          t6++;
          let a7 = [];
          for (; t6 < e7.length && e7[t6] !== ")"; ) {
            let l8 = "";
            for (; t6 < e7.length && e7[t6] !== "|" && e7[t6] !== ")"; ) l8 += e7[t6], t6++;
            if (l8 = l8.trim(), !Me5(l8)) throw new Error(`Invalid notation name: "${l8}"`);
            a7.push(l8), e7[t6] === "|" && (t6++, t6 = x22(e7, t6));
          }
          if (e7[t6] !== ")") throw new Error("Unterminated list of notations");
          t6++, r8 += " (" + a7.join("|") + ")";
        } else {
          for (; t6 < e7.length && !/\s/.test(e7[t6]); ) r8 += e7[t6], t6++;
          let a7 = ["CDATA", "ID", "IDREF", "IDREFS", "ENTITY", "ENTITIES", "NMTOKEN", "NMTOKENS"];
          if (!this.suppressValidationErr && !a7.includes(r8.toUpperCase())) throw new Error(`Invalid attribute type: "${r8}"`);
        }
        t6 = x22(e7, t6);
        let o9 = "";
        return e7.substring(t6, t6 + 8).toUpperCase() === "#REQUIRED" ? (o9 = "#REQUIRED", t6 += 8) : e7.substring(t6, t6 + 7).toUpperCase() === "#IMPLIED" ? (o9 = "#IMPLIED", t6 += 7) : [t6, o9] = this.readIdentifierVal(e7, t6, "ATTLIST"), { elementName: n23, attributeName: i10, attributeType: r8, defaultValue: o9, index: t6 };
      }
    };
    x22 = (s9, e7) => {
      for (; e7 < s9.length && /\s/.test(s9[e7]); ) e7++;
      return e7;
    };
    rl = /^[-+]?0x[a-fA-F0-9]+$/;
    ol = /^([\-\+])?(0*)([0-9]*(\.[0-9]*)?)$/;
    al = { hex: true, leadingZeros: true, decimalPoint: ".", eNotation: true };
    ll = /^([-+])?(0*)(\d*(\.\d*)?[eE][-\+]?\d+)$/;
    xe8 = class {
      constructor(e7) {
        if (this.options = e7, this.currentNode = null, this.tagsNodeStack = [], this.docTypeEntities = {}, this.lastEntities = { apos: { regex: /&(apos|#39|#x27);/g, val: "'" }, gt: { regex: /&(gt|#62|#x3E);/g, val: ">" }, lt: { regex: /&(lt|#60|#x3C);/g, val: "<" }, quot: { regex: /&(quot|#34|#x22);/g, val: '"' } }, this.ampEntity = { regex: /&(amp|#38|#x26);/g, val: "&" }, this.htmlEntities = { space: { regex: /&(nbsp|#160);/g, val: " " }, cent: { regex: /&(cent|#162);/g, val: "\xA2" }, pound: { regex: /&(pound|#163);/g, val: "\xA3" }, yen: { regex: /&(yen|#165);/g, val: "\xA5" }, euro: { regex: /&(euro|#8364);/g, val: "\u20AC" }, copyright: { regex: /&(copy|#169);/g, val: "\xA9" }, reg: { regex: /&(reg|#174);/g, val: "\xAE" }, inr: { regex: /&(inr|#8377);/g, val: "\u20B9" }, num_dec: { regex: /&#([0-9]{1,7});/g, val: (t6, n23) => String.fromCodePoint(Number.parseInt(n23, 10)) }, num_hex: { regex: /&#x([0-9a-fA-F]{1,6});/g, val: (t6, n23) => String.fromCodePoint(Number.parseInt(n23, 16)) } }, this.addExternalEntities = dl, this.parseXml = yl2, this.parseTextData = hl, this.resolveNameSpace = pl, this.buildAttributesMap = gl, this.isItStopNode = Nl, this.replaceEntitiesValue = wl, this.readStopNodeData = vl, this.saveTextToParentTag = Sl2, this.addChild = bl2, this.ignoreAttributesFn = _e5(this.options.ignoreAttributes), this.options.stopNodes && this.options.stopNodes.length > 0) {
          this.stopNodesExact = /* @__PURE__ */ new Set(), this.stopNodesWildcard = /* @__PURE__ */ new Set();
          for (let t6 = 0; t6 < this.options.stopNodes.length; t6++) {
            let n23 = this.options.stopNodes[t6];
            typeof n23 == "string" && (n23.startsWith("*.") ? this.stopNodesWildcard.add(n23.substring(2)) : this.stopNodesExact.add(n23));
          }
        }
      }
    };
    ml = new RegExp(`([^\\s=]+)\\s*(=\\s*(['"])([\\s\\S]*?)\\3)?`, "gm");
    yl2 = function(s9) {
      s9 = s9.replace(/\r\n?/g, `
`);
      let e7 = new V10("!xml"), t6 = e7, n23 = "", i10 = "", r8 = new $e5(this.options.processEntities);
      for (let o9 = 0; o9 < s9.length; o9++) if (s9[o9] === "<") if (s9[o9 + 1] === "/") {
        let l8 = ce7(s9, ">", o9, "Closing Tag is not closed."), c15 = s9.substring(o9 + 2, l8).trim();
        if (this.options.removeNSPrefix) {
          let d16 = c15.indexOf(":");
          d16 !== -1 && (c15 = c15.substr(d16 + 1));
        }
        this.options.transformTagName && (c15 = this.options.transformTagName(c15)), t6 && (n23 = this.saveTextToParentTag(n23, t6, i10));
        let u11 = i10.substring(i10.lastIndexOf(".") + 1);
        if (c15 && this.options.unpairedTags.indexOf(c15) !== -1) throw new Error(`Unpaired tag can not be used as closing tag: </${c15}>`);
        let f11 = 0;
        u11 && this.options.unpairedTags.indexOf(u11) !== -1 ? (f11 = i10.lastIndexOf(".", i10.lastIndexOf(".") - 1), this.tagsNodeStack.pop()) : f11 = i10.lastIndexOf("."), i10 = i10.substring(0, f11), t6 = this.tagsNodeStack.pop(), n23 = "", o9 = l8;
      } else if (s9[o9 + 1] === "?") {
        let l8 = ks2(s9, o9, false, "?>");
        if (!l8) throw new Error("Pi Tag is not closed.");
        if (n23 = this.saveTextToParentTag(n23, t6, i10), !(this.options.ignoreDeclaration && l8.tagName === "?xml" || this.options.ignorePiTags)) {
          let c15 = new V10(l8.tagName);
          c15.add(this.options.textNodeName, ""), l8.tagName !== l8.tagExp && l8.attrExpPresent && (c15[":@"] = this.buildAttributesMap(l8.tagExp, i10)), this.addChild(t6, c15, i10, o9);
        }
        o9 = l8.closeIndex + 1;
      } else if (s9.substr(o9 + 1, 3) === "!--") {
        let l8 = ce7(s9, "-->", o9 + 4, "Comment is not closed.");
        if (this.options.commentPropName) {
          let c15 = s9.substring(o9 + 4, l8 - 2);
          n23 = this.saveTextToParentTag(n23, t6, i10), t6.add(this.options.commentPropName, [{ [this.options.textNodeName]: c15 }]);
        }
        o9 = l8;
      } else if (s9.substr(o9 + 1, 2) === "!D") {
        let l8 = r8.readDocType(s9, o9);
        this.docTypeEntities = l8.entities, o9 = l8.i;
      } else if (s9.substr(o9 + 1, 2) === "![") {
        let l8 = ce7(s9, "]]>", o9, "CDATA is not closed.") - 2, c15 = s9.substring(o9 + 9, l8);
        n23 = this.saveTextToParentTag(n23, t6, i10);
        let u11 = this.parseTextData(c15, t6.tagname, i10, true, false, true, true);
        u11 == null && (u11 = ""), this.options.cdataPropName ? t6.add(this.options.cdataPropName, [{ [this.options.textNodeName]: c15 }]) : t6.add(this.options.textNodeName, u11), o9 = l8 + 2;
      } else {
        let l8 = ks2(s9, o9, this.options.removeNSPrefix), c15 = l8.tagName, u11 = l8.rawTagName, f11 = l8.tagExp, d16 = l8.attrExpPresent, p17 = l8.closeIndex;
        if (this.options.transformTagName) {
          let m25 = this.options.transformTagName(c15);
          f11 === c15 && (f11 = m25), c15 = m25;
        }
        t6 && n23 && t6.tagname !== "!xml" && (n23 = this.saveTextToParentTag(n23, t6, i10, false));
        let g18 = t6;
        g18 && this.options.unpairedTags.indexOf(g18.tagname) !== -1 && (t6 = this.tagsNodeStack.pop(), i10 = i10.substring(0, i10.lastIndexOf("."))), c15 !== e7.tagname && (i10 += i10 ? "." + c15 : c15);
        let h17 = o9;
        if (this.isItStopNode(this.stopNodesExact, this.stopNodesWildcard, i10, c15)) {
          let m25 = "";
          if (f11.length > 0 && f11.lastIndexOf("/") === f11.length - 1) c15[c15.length - 1] === "/" ? (c15 = c15.substr(0, c15.length - 1), i10 = i10.substr(0, i10.length - 1), f11 = c15) : f11 = f11.substr(0, f11.length - 1), o9 = l8.closeIndex;
          else if (this.options.unpairedTags.indexOf(c15) !== -1) o9 = l8.closeIndex;
          else {
            let S17 = this.readStopNodeData(s9, u11, p17 + 1);
            if (!S17) throw new Error(`Unexpected end of ${u11}`);
            o9 = S17.i, m25 = S17.tagContent;
          }
          let y18 = new V10(c15);
          c15 !== f11 && d16 && (y18[":@"] = this.buildAttributesMap(f11, i10)), m25 && (m25 = this.parseTextData(m25, c15, i10, true, d16, true, true)), i10 = i10.substr(0, i10.lastIndexOf(".")), y18.add(this.options.textNodeName, m25), this.addChild(t6, y18, i10, h17);
        } else {
          if (f11.length > 0 && f11.lastIndexOf("/") === f11.length - 1) {
            if (c15[c15.length - 1] === "/" ? (c15 = c15.substr(0, c15.length - 1), i10 = i10.substr(0, i10.length - 1), f11 = c15) : f11 = f11.substr(0, f11.length - 1), this.options.transformTagName) {
              let y18 = this.options.transformTagName(c15);
              f11 === c15 && (f11 = y18), c15 = y18;
            }
            let m25 = new V10(c15);
            c15 !== f11 && d16 && (m25[":@"] = this.buildAttributesMap(f11, i10)), this.addChild(t6, m25, i10, h17), i10 = i10.substr(0, i10.lastIndexOf("."));
          } else {
            let m25 = new V10(c15);
            this.tagsNodeStack.push(t6), c15 !== f11 && d16 && (m25[":@"] = this.buildAttributesMap(f11, i10)), this.addChild(t6, m25, i10, h17), t6 = m25;
          }
          n23 = "", o9 = p17;
        }
      }
      else n23 += s9[o9];
      return e7.child;
    };
    wl = function(s9) {
      if (this.options.processEntities) {
        for (let e7 in this.docTypeEntities) {
          let t6 = this.docTypeEntities[e7];
          s9 = s9.replace(t6.regx, t6.val);
        }
        for (let e7 in this.lastEntities) {
          let t6 = this.lastEntities[e7];
          s9 = s9.replace(t6.regex, t6.val);
        }
        if (this.options.htmlEntities) for (let e7 in this.htmlEntities) {
          let t6 = this.htmlEntities[e7];
          s9 = s9.replace(t6.regex, t6.val);
        }
        s9 = s9.replace(this.ampEntity.regex, this.ampEntity.val);
      }
      return s9;
    };
    qs2 = V10.getMetaDataSymbol();
    be5 = class {
      constructor(e7) {
        this.externalEntities = {}, this.options = $i2(e7);
      }
      parse(e7, t6) {
        if (typeof e7 != "string" && e7.toString) e7 = e7.toString();
        else if (typeof e7 != "string") throw new Error("XML data is accepted in String or Bytes[] form.");
        if (t6) {
          t6 === true && (t6 = {});
          let r8 = Mi2(e7, t6);
          if (r8 !== true) throw Error(`${r8.err.msg}:${r8.err.line}:${r8.err.col}`);
        }
        let n23 = new xe8(this.options);
        n23.addExternalEntities(this.externalEntities);
        let i10 = n23.parseXml(e7);
        return this.options.preserveOrder || i10 === void 0 ? i10 : Cs2(i10, this.options);
      }
      addEntity(e7, t6) {
        if (t6.indexOf("&") !== -1) throw new Error("Entity value can't have '&'");
        if (e7.indexOf("&") !== -1 || e7.indexOf(";") !== -1) throw new Error("An entity must be set without '&' and ';'. Eg. use '#xD' for '&#xD;'");
        if (t6 === "&") throw new Error("An entity with value '&' is not permitted");
        this.externalEntities[e7] = t6;
      }
      static getMetaDataSymbol() {
        return V10.getMetaDataSymbol();
      }
    };
    ql = { attributeNamePrefix: "@_", attributesGroupName: false, textNodeName: "#text", ignoreAttributes: true, cdataPropName: false, format: false, indentBy: "  ", suppressEmptyNode: false, suppressUnpairedNode: true, suppressBooleanAttributes: true, tagValueProcessor: function(s9, e7) {
      return e7;
    }, attributeValueProcessor: function(s9, e7) {
      return e7;
    }, preserveOrder: false, commentPropName: false, unpairedTags: [], entities: [{ regex: new RegExp("&", "g"), val: "&amp;" }, { regex: new RegExp(">", "g"), val: "&gt;" }, { regex: new RegExp("<", "g"), val: "&lt;" }, { regex: new RegExp("'", "g"), val: "&apos;" }, { regex: new RegExp('"', "g"), val: "&quot;" }], processEntities: true, stopNodes: [], oneListGroup: false };
    R8.prototype.build = function(s9) {
      return this.options.preserveOrder ? Ls2(s9, this.options) : (Array.isArray(s9) && this.options.arrayNodeName && this.options.arrayNodeName.length > 1 && (s9 = { [this.options.arrayNodeName]: s9 }), this.j2x(s9, 0, []).val);
    };
    R8.prototype.j2x = function(s9, e7, t6) {
      let n23 = "", i10 = "", r8 = t6.join(".");
      for (let o9 in s9) if (Object.prototype.hasOwnProperty.call(s9, o9)) if (typeof s9[o9] > "u") this.isAttribute(o9) && (i10 += "");
      else if (s9[o9] === null) this.isAttribute(o9) || o9 === this.options.cdataPropName ? i10 += "" : o9[0] === "?" ? i10 += this.indentate(e7) + "<" + o9 + "?" + this.tagEndChar : i10 += this.indentate(e7) + "<" + o9 + "/" + this.tagEndChar;
      else if (s9[o9] instanceof Date) i10 += this.buildTextValNode(s9[o9], o9, "", e7);
      else if (typeof s9[o9] != "object") {
        let a7 = this.isAttribute(o9);
        if (a7 && !this.ignoreAttributesFn(a7, r8)) n23 += this.buildAttrPairStr(a7, "" + s9[o9]);
        else if (!a7) if (o9 === this.options.textNodeName) {
          let l8 = this.options.tagValueProcessor(o9, "" + s9[o9]);
          i10 += this.replaceEntitiesValue(l8);
        } else i10 += this.buildTextValNode(s9[o9], o9, "", e7);
      } else if (Array.isArray(s9[o9])) {
        let a7 = s9[o9].length, l8 = "", c15 = "";
        for (let u11 = 0; u11 < a7; u11++) {
          let f11 = s9[o9][u11];
          if (!(typeof f11 > "u")) if (f11 === null) o9[0] === "?" ? i10 += this.indentate(e7) + "<" + o9 + "?" + this.tagEndChar : i10 += this.indentate(e7) + "<" + o9 + "/" + this.tagEndChar;
          else if (typeof f11 == "object") if (this.options.oneListGroup) {
            let d16 = this.j2x(f11, e7 + 1, t6.concat(o9));
            l8 += d16.val, this.options.attributesGroupName && f11.hasOwnProperty(this.options.attributesGroupName) && (c15 += d16.attrStr);
          } else l8 += this.processTextOrObjNode(f11, o9, e7, t6);
          else if (this.options.oneListGroup) {
            let d16 = this.options.tagValueProcessor(o9, f11);
            d16 = this.replaceEntitiesValue(d16), l8 += d16;
          } else l8 += this.buildTextValNode(f11, o9, "", e7);
        }
        this.options.oneListGroup && (l8 = this.buildObjectNode(l8, o9, c15, e7)), i10 += l8;
      } else if (this.options.attributesGroupName && o9 === this.options.attributesGroupName) {
        let a7 = Object.keys(s9[o9]), l8 = a7.length;
        for (let c15 = 0; c15 < l8; c15++) n23 += this.buildAttrPairStr(a7[c15], "" + s9[o9][a7[c15]]);
      } else i10 += this.processTextOrObjNode(s9[o9], o9, e7, t6);
      return { attrStr: n23, val: i10 };
    };
    R8.prototype.buildAttrPairStr = function(s9, e7) {
      return e7 = this.options.attributeValueProcessor(s9, "" + e7), e7 = this.replaceEntitiesValue(e7), this.options.suppressBooleanAttributes && e7 === "true" ? " " + s9 : " " + s9 + '="' + e7 + '"';
    };
    R8.prototype.buildObjectNode = function(s9, e7, t6, n23) {
      if (s9 === "") return e7[0] === "?" ? this.indentate(n23) + "<" + e7 + t6 + "?" + this.tagEndChar : this.indentate(n23) + "<" + e7 + t6 + this.closeTag(e7) + this.tagEndChar;
      {
        let i10 = "</" + e7 + this.tagEndChar, r8 = "";
        return e7[0] === "?" && (r8 = "?", i10 = ""), (t6 || t6 === "") && s9.indexOf("<") === -1 ? this.indentate(n23) + "<" + e7 + t6 + r8 + ">" + s9 + i10 : this.options.commentPropName !== false && e7 === this.options.commentPropName && r8.length === 0 ? this.indentate(n23) + `<!--${s9}-->` + this.newLine : this.indentate(n23) + "<" + e7 + t6 + r8 + this.tagEndChar + s9 + this.indentate(n23) + i10;
      }
    };
    R8.prototype.closeTag = function(s9) {
      let e7 = "";
      return this.options.unpairedTags.indexOf(s9) !== -1 ? this.options.suppressUnpairedNode || (e7 = "/") : this.options.suppressEmptyNode ? e7 = "/" : e7 = `></${s9}`, e7;
    };
    R8.prototype.buildTextValNode = function(s9, e7, t6, n23) {
      if (this.options.cdataPropName !== false && e7 === this.options.cdataPropName) return this.indentate(n23) + `<![CDATA[${s9}]]>` + this.newLine;
      if (this.options.commentPropName !== false && e7 === this.options.commentPropName) return this.indentate(n23) + `<!--${s9}-->` + this.newLine;
      if (e7[0] === "?") return this.indentate(n23) + "<" + e7 + t6 + "?" + this.tagEndChar;
      {
        let i10 = this.options.tagValueProcessor(e7, s9);
        return i10 = this.replaceEntitiesValue(i10), i10 === "" ? this.indentate(n23) + "<" + e7 + t6 + this.closeTag(e7) + this.tagEndChar : this.indentate(n23) + "<" + e7 + t6 + ">" + i10 + "</" + e7 + this.tagEndChar;
      }
    };
    R8.prototype.replaceEntitiesValue = function(s9) {
      if (s9 && s9.length > 0 && this.options.processEntities) for (let e7 = 0; e7 < this.options.entities.length; e7++) {
        let t6 = this.options.entities[e7];
        s9 = s9.replace(t6.regex, t6.val);
      }
      return s9;
    };
    vs2 = q3(Yi(), 1);
    wi = q3(xe7(), 1);
    T9 = class extends Error {
      line;
      column;
      codeblock;
      constructor(e7, t6) {
        let [n23, i10] = Ml(t6.toml, t6.ptr), r8 = $l(t6.toml, n23, i10);
        super(`Invalid TOML document: ${e7}

${r8}`, t6), this.line = n23, this.column = i10, this.codeblock = r8;
      }
    };
    xl = /^(\d{4}-\d{2}-\d{2})?[T ]?(?:(\d{2}):\d{2}(?::\d{2}(?:\.\d+)?)?)?(Z|[-+]\d{2}:\d{2})?$/i;
    Be4 = class s8 extends Date {
      #t = false;
      #s = false;
      #e = null;
      constructor(e7) {
        let t6 = true, n23 = true, i10 = "Z";
        if (typeof e7 == "string") {
          let r8 = e7.match(xl);
          r8 ? (r8[1] || (t6 = false, e7 = `0000-01-01T${e7}`), n23 = !!r8[2], n23 && e7[10] === " " && (e7 = e7.replace(" ", "T")), r8[2] && +r8[2] > 23 ? e7 = "" : (i10 = r8[3] || null, e7 = e7.toUpperCase(), !i10 && n23 && (e7 += "Z"))) : e7 = "";
        }
        super(e7), isNaN(this.getTime()) || (this.#t = t6, this.#s = n23, this.#e = i10);
      }
      isDateTime() {
        return this.#t && this.#s;
      }
      isLocal() {
        return !this.#t || !this.#s || !this.#e;
      }
      isDate() {
        return this.#t && !this.#s;
      }
      isTime() {
        return this.#s && !this.#t;
      }
      isValid() {
        return this.#t || this.#s;
      }
      toISOString() {
        let e7 = super.toISOString();
        if (this.isDate()) return e7.slice(0, 10);
        if (this.isTime()) return e7.slice(11, 23);
        if (this.#e === null) return e7.slice(0, -1);
        if (this.#e === "Z") return e7;
        let t6 = +this.#e.slice(1, 3) * 60 + +this.#e.slice(4, 6);
        return t6 = this.#e[0] === "-" ? t6 : -t6, new Date(this.getTime() - t6 * 6e4).toISOString().slice(0, -1) + this.#e;
      }
      static wrapAsOffsetDateTime(e7, t6 = "Z") {
        let n23 = new s8(e7);
        return n23.#e = t6, n23;
      }
      static wrapAsLocalDateTime(e7) {
        let t6 = new s8(e7);
        return t6.#e = null, t6;
      }
      static wrapAsLocalDate(e7) {
        let t6 = new s8(e7);
        return t6.#s = false, t6.#e = null, t6;
      }
      static wrapAsLocalTime(e7) {
        let t6 = new s8(e7);
        return t6.#t = false, t6.#e = null, t6;
      }
    };
    Bl = /^((0x[0-9a-fA-F](_?[0-9a-fA-F])*)|(([+-]|0[ob])?\d(_?\d)*))$/;
    Fl = /^[+-]?\d(_?\d)*(\.\d(_?\d)*)?([eE][+-]?\d(_?\d)*)?$/;
    jl = /^[+-]?0[0-9_]/;
    Vl = /^[0-9a-f]{2,8}$/i;
    Ji = { b: "\b", t: "	", n: `
`, f: "\f", r: "\r", e: "\x1B", '"': '"', "\\": "\\" };
    Rl = /^[a-zA-Z0-9-_]+[ \t]*$/;
    Hi = /^[a-z0-9-_]+$/i;
    yt4 = q3(ja(), 1);
    Eh = ["yaml", "xml", "json", "ini", "csv", "toml"];
    vh = ["yaml", "json", "xml", "ini", "csv", "toml"];
    Va = { inputFormat: "yaml", outputFormat: "yaml", raw: false, compact: false, prettyPrint: false, indent: 2, xmlAttributePrefix: "+@", xmlContentName: "+content", csvDelimiter: "", csvHeader: true };
    kh = { name: "yq", summary: "command-line YAML/XML/INI/CSV/TOML processor", usage: "yq [OPTIONS] [FILTER] [FILE]", description: `yq uses jq-style expressions to query and transform data in various formats.
Supports YAML, JSON, XML, INI, CSV, and TOML with automatic format conversion.

EXAMPLES:
  # Extract a value from YAML
  yq '.name' config.yaml
  yq '.users[0].email' data.yaml

  # Filter arrays
  yq '.items[] | select(.active == true)' data.yaml
  yq '[.users[] | select(.age > 30)]' users.yaml

  # Transform data
  yq '.users | map({name, email})' data.yaml
  yq '.items | sort_by(.price) | reverse' products.yaml

  # Modify file in-place
  yq -i '.version = "2.0"' config.yaml

  # Read JSON, output YAML
  yq -p json '.' config.json

  # Read YAML, output JSON
  yq -o json '.' config.yaml
  yq -o json -c '.' config.yaml  # compact JSON

  # Parse TOML config files
  yq '.package.name' Cargo.toml
  yq -o json '.' pyproject.toml

  # Parse XML (attributes use +@ prefix, text uses +content)
  yq -p xml '.root.items.item[].name' data.xml
  yq -p xml '.root.user["+@id"]' data.xml  # XML attributes

  # Parse INI config files
  yq -p ini '.database.host' config.ini
  yq -p ini '.server' config.ini -o json

  # Parse CSV/TSV (auto-detects delimiter)
  yq -p csv '.[0].name' data.csv
  yq '.[0].name' data.tsv              # auto-detected as CSV
  yq -p csv '[.[] | select(.category == "A")]' data.csv

  # Extract front-matter from markdown/content files
  yq --front-matter '.title' post.md

  # Convert between formats
  yq -p json -o csv '.users' data.json   # JSON to CSV
  yq -p csv -o yaml '.' data.csv         # CSV to YAML
  yq -p ini -o json '.' config.ini       # INI to JSON
  yq -p xml -o json '.' data.xml         # XML to JSON
  yq -o toml '.' config.yaml             # YAML to TOML

  # Common jq functions work in yq:
  yq 'keys' data.yaml                    # get object keys
  yq 'length' data.yaml                  # array/string length
  yq '.items | first' data.yaml          # first element
  yq '.items | last' data.yaml           # last element
  yq '.nums | add' data.yaml             # sum numbers
  yq '.nums | min' data.yaml             # minimum
  yq '.nums | max' data.yaml             # maximum
  yq '.items | unique' data.yaml         # unique values
  yq '.items | group_by(.type)' data.yaml`, options: ["-p, --input-format=FMT   input format: yaml (default), xml, json, ini, csv, toml", "-o, --output-format=FMT  output format: yaml (default), json, xml, ini, csv, toml", "-i, --inplace            modify file in-place", "-r, --raw-output         output strings without quotes (json only)", "-c, --compact            compact output (json only)", "-e, --exit-status        set exit status based on output", "-s, --slurp              read entire input into array", "-n, --null-input         don't read any input", "-j, --join-output        don't print newlines after each output", "-f, --front-matter       extract and process front-matter only", "-P, --prettyPrint        pretty print output", "-I, --indent=N           set indent level (default: 2)", "    --xml-attribute-prefix=STR  XML attribute prefix (default: +@)", "    --xml-content-name=STR  XML text content name (default: +content)", "    --csv-delimiter=CHAR CSV delimiter (default: auto-detect)", "    --csv-header         CSV has header row (default: true)", "    --help               display this help and exit"] };
    ig = { name: "yq", async execute(s9, e7) {
      if (o2(s9)) return s(kh);
      let t6 = Ih(s9);
      if ("exitCode" in t6) return t6;
      let { options: n23, filter: i10, files: r8, inputFormatExplicit: o9 } = t6;
      if (!o9 && r8.length > 0 && r8[0] !== "-") {
        let c15 = Ka(r8[0]);
        c15 && (n23.inputFormat = c15);
      }
      if (n23.inplace && (r8.length === 0 || r8[0] === "-")) return { stdout: "", stderr: `yq: -i/--inplace requires a file argument
`, exitCode: 1 };
      let a7, l8;
      if (n23.nullInput) a7 = "";
      else if (r8.length === 0 || r8.length === 1 && r8[0] === "-") a7 = e7.stdin;
      else try {
        l8 = e7.fs.resolvePath(e7.cwd, r8[0]), a7 = await e7.fs.readFile(l8);
      } catch {
        return { stdout: "", stderr: `yq: ${r8[0]}: No such file or directory
`, exitCode: 2 };
      }
      try {
        let c15 = ge4(i10), u11, f11 = { limits: e7.limits ? { maxIterations: e7.limits.maxJqIterations } : void 0, env: e7.env, coverage: e7.coverage };
        if (n23.nullInput) u11 = d11(null, c15, f11);
        else if (n23.frontMatter) {
          let y18 = Ya(a7);
          if (!y18) return { stdout: "", stderr: `yq: no front-matter found
`, exitCode: 1 };
          u11 = d11(y18.frontMatter, c15, f11);
        } else if (n23.slurp) {
          let y18;
          n23.inputFormat === "yaml" ? y18 = Ra(a7) : y18 = [Ei(a7, n23)], u11 = d11(y18, c15, f11);
        } else {
          let y18 = Ei(a7, n23);
          u11 = d11(y18, c15, f11);
        }
        let d16 = u11.map((y18) => Ua(y18, n23)), p17 = n23.joinOutput ? "" : `
`, g18 = d16.filter((y18) => y18 !== "").join(p17), h17 = g18 ? n23.joinOutput ? g18 : `${g18}
` : "";
        if (n23.inplace && l8) return await e7.fs.writeFile(l8, h17), { stdout: "", stderr: "", exitCode: 0 };
        let m25 = n23.exitStatus && (u11.length === 0 || u11.every((y18) => y18 == null || y18 === false)) ? 1 : 0;
        return { stdout: h17, stderr: "", exitCode: m25 };
      } catch (c15) {
        if (c15 instanceof b2) return { stdout: "", stderr: `yq: ${c15.message}
`, exitCode: b2.EXIT_CODE };
        let u11 = c15.message;
        return u11.includes("Unknown function") ? { stdout: "", stderr: `yq: error: ${u11}
`, exitCode: 3 } : { stdout: "", stderr: `yq: parse error: ${u11}
`, exitCode: 5 };
      }
    } };
    rg = { name: "yq", flags: [{ flag: "-r", type: "boolean" }, { flag: "-c", type: "boolean" }, { flag: "-s", type: "boolean" }, { flag: "-i", type: "value", valueHint: "string" }, { flag: "-o", type: "value", valueHint: "string" }], stdinType: "text", needsArgs: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/yq-FD5F3WOJ.js
var yq_FD5F3WOJ_exports = {};
__export(yq_FD5F3WOJ_exports, {
  flagsForFuzzing: () => rg,
  yqCommand: () => ig
});
var init_yq_FD5F3WOJ = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/yq-FD5F3WOJ.js"() {
    init_chunk_XMDVFEVC();
    init_chunk_SYMJJMQ4();
    init_chunk_FRDGR5VK();
    init_chunk_7MKBHGLS();
    init_chunk_OJDRYQWQ();
    init_chunk_YNYSPYQ5();
    init_chunk_PSW6BMXW();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-F55TLFGB.js
function j9() {
  return /* @__PURE__ */ Object.create(null);
}
function S12(e7, o9, r8) {
  e7[o9] = r8;
}
function C18(e7) {
  let o9 = j9();
  for (let r8 of Object.keys(e7)) {
    let s9 = e7[r8];
    (typeof s9 == "string" || typeof s9 == "number" || typeof s9 == "boolean" || s9 === null) && (o9[r8] = s9);
  }
  return o9;
}
function b23(e7) {
  let o9 = w17.default.parse(e7.trim(), { header: true, dynamicTyping: true, skipEmptyLines: true }), r8 = o9.data.map((s9) => C18(s9));
  return { headers: o9.meta.fields || [], data: r8 };
}
function R9(e7, o9) {
  return o9.length === 0 ? `${e7.join(",")}
` : `${w17.default.unparse(o9, { columns: e7 }).replace(/\r\n/g, `
`)}
`;
}
async function g16(e7, o9) {
  let r8 = e7.find((p17) => !p17.startsWith("-")), s9;
  if (!r8 || r8 === "-") s9 = o9.stdin;
  else try {
    let p17 = o9.fs.resolvePath(o9.cwd, r8);
    s9 = await o9.fs.readFile(p17);
  } catch {
    return { headers: [], data: [], error: { stdout: "", stderr: `xan: ${r8}: No such file or directory
`, exitCode: 1 } };
  }
  let { headers: i10, data: f11 } = b23(s9);
  return { headers: i10, data: f11 };
}
async function W11(e7, o9) {
  let r8 = 0, s9 = [], i10 = [];
  for (let t6 = 0; t6 < e7.length; t6++) {
    let n23 = e7[t6];
    (n23 === "-l" || n23 === "--limit") && t6 + 1 < e7.length ? r8 = Number.parseInt(e7[++t6], 10) : (n23 === "-s" || n23 === "--select") && t6 + 1 < e7.length ? s9 = e7[++t6].split(",") : n23.startsWith("-") || i10.push(n23);
  }
  let { headers: f11, data: p17, error: d16 } = await g16(i10, o9);
  if (d16) return d16;
  let c15 = s9.length > 0 ? s9.filter((t6) => f11.includes(t6)) : f11, l8 = r8 > 0 ? p17.slice(0, r8) : p17, h17 = Math.max(...c15.map((t6) => t6.length)), a7 = [], $18 = "\u2500".repeat(80);
  for (let t6 = 0; t6 < l8.length; t6++) {
    let n23 = l8[t6];
    a7.push(`Row n\xB0${t6}`), a7.push($18);
    for (let u11 of c15) {
      let m25 = n23[u11], y18 = m25 == null ? "" : String(m25);
      a7.push(`${u11.padEnd(h17)} ${y18}`);
    }
    t6 < l8.length - 1 && a7.push("");
  }
  return { stdout: `${a7.join(`
`)}
`, stderr: "", exitCode: 0 };
}
async function k12(e7, o9) {
  let r8 = 0, s9 = [];
  for (let t6 = 0; t6 < e7.length; t6++) {
    let n23 = e7[t6];
    n23 === "-n" && t6 + 1 < e7.length ? r8 = Number.parseInt(e7[++t6], 10) : n23.startsWith("-") || s9.push(n23);
  }
  let { headers: i10, data: f11, error: p17 } = await g16(s9, o9);
  if (p17) return p17;
  let d16 = r8 > 0 ? f11.slice(0, r8) : f11, c15 = i10.map((t6) => t6.length);
  for (let t6 of d16) for (let n23 = 0; n23 < i10.length; n23++) {
    let u11 = String(t6[i10[n23]] ?? "");
    c15[n23] = Math.max(c15[n23], u11.length);
  }
  let l8 = [], h17 = "\u2500", a7 = "\u2502";
  l8.push(`\u250C${c15.map((t6) => h17.repeat(t6 + 2)).join("\u252C")}\u2510`);
  let $18 = i10.map((t6, n23) => ` ${t6.padEnd(c15[n23])} `).join(a7);
  l8.push(`${a7}${$18}${a7}`), l8.push(`\u251C${c15.map((t6) => h17.repeat(t6 + 2)).join("\u253C")}\u2524`);
  for (let t6 of d16) {
    let n23 = i10.map((u11, m25) => ` ${String(t6[u11] ?? "").padEnd(c15[m25])} `).join(a7);
    l8.push(`${a7}${n23}${a7}`);
  }
  return l8.push(`\u2514${c15.map((t6) => h17.repeat(t6 + 2)).join("\u2534")}\u2518`), { stdout: `${l8.join(`
`)}
`, stderr: "", exitCode: 0 };
}
var w17;
var init_chunk_F55TLFGB = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-F55TLFGB.js"() {
    init_chunk_SYMJJMQ4();
    init_chunk_DXB73IDG();
    w17 = q3(xe7(), 1);
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/xan-view-ECQUO7AJ.js
var xan_view_ECQUO7AJ_exports = {};
__export(xan_view_ECQUO7AJ_exports, {
  cmdFlatten: () => W11,
  cmdView: () => k12
});
var init_xan_view_ECQUO7AJ = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/xan-view-ECQUO7AJ.js"() {
    init_chunk_F55TLFGB();
    init_chunk_SYMJJMQ4();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-JI3KJ32H.js
function V11(e7) {
  let n23 = [], s9 = new q14(e7).tokenize(), r8 = 0, o9 = () => s9[r8] || { type: "eof", value: "", pos: 0 }, i10 = () => s9[r8++];
  for (; o9().type !== "eof"; ) {
    if (o9().type === "," && n23.length > 0) {
      i10();
      continue;
    }
    let h17 = [], u11 = 0, p17 = r8;
    for (; o9().type !== "eof"; ) {
      let a7 = o9();
      if ((a7.type === "," || a7.type === "as") && u11 === 0) break;
      (a7.type === "(" || a7.type === "[" || a7.type === "{") && u11++, (a7.type === ")" || a7.type === "]" || a7.type === "}") && u11--, h17.push(i10());
    }
    h17.push({ type: "eof", value: "", pos: 0 });
    let f11 = new J12(h17).parse(), c15;
    if (o9().type === "as") if (i10(), o9().type === "(") {
      i10();
      let a7 = [];
      for (; o9().type !== ")" && o9().type !== "eof"; ) (o9().type === "ident" || o9().type === "string") && (a7.push(o9().value), i10()), o9().type === "," && i10();
      o9().type === ")" && i10(), c15 = a7;
    } else if (o9().type === "ident" || o9().type === "string") c15 = o9().value, i10();
    else throw new Error(`Expected name after 'as', got ${o9().type}`);
    else c15 = e7.slice(s9[p17].pos, s9[r8 - 1]?.pos || e7.length).trim(), f11.type === "identifier" && (c15 = f11.name);
    n23.push({ expr: f11, name: c15 });
  }
  return n23;
}
function _11(e7) {
  let t6 = new q14(e7).tokenize();
  return new J12(t6).parse();
}
function E9(e7, n23) {
  return n23.length === 0 ? k13(e7, []) : n23.length === 1 ? { type: "Pipe", left: n23[0], right: k13(e7, []) } : { type: "Pipe", left: n23[0], right: k13(e7, n23.slice(1)) };
}
function S13(e7, n23, t6) {
  return { type: "BinaryOp", op: e7, left: n23, right: t6 };
}
function k13(e7, n23) {
  return { type: "Call", name: e7, args: n23 };
}
function Je6(e7, n23, t6) {
  let s9 = { type: "Cond", cond: e7, elifs: [], else: t6 || { type: "Literal", value: null } };
  return s9[tt5] = n23, s9;
}
function P16(e7) {
  return { type: "Pipe", left: e7, right: { type: "Call", name: "tostring", args: [] } };
}
function O14(e7, n23 = true) {
  switch (e7.type) {
    case "int":
    case "float":
      return { type: "Literal", value: e7.value };
    case "string":
      return { type: "Literal", value: e7.value };
    case "bool":
      return { type: "Literal", value: e7.value };
    case "null":
      return { type: "Literal", value: null };
    case "underscore":
      return { type: "Index", base: { type: "Identity" }, index: { type: "Literal", value: "_" } };
    case "identifier":
      return n23 ? { type: "Field", name: e7.name } : { type: "VarRef", name: e7.name };
    case "lambdaBinding":
      return { type: "VarRef", name: e7.name };
    case "func": {
      let t6 = e7.args.map((r8) => O14(r8.expr, n23)), s9 = Object.hasOwn(B10, e7.name) ? B10[e7.name] : void 0;
      return typeof s9 == "function" ? s9(t6) : k13(typeof s9 == "string" ? s9 : e7.name, t6);
    }
    case "list":
      return e7.elements.length === 0 ? { type: "Array" } : { type: "Array", elements: e7.elements.reduce((t6, s9, r8) => {
        let o9 = O14(s9, n23);
        return r8 === 0 ? o9 : { type: "Comma", left: t6, right: o9 };
      }, null) };
    case "map":
      return { type: "Object", entries: e7.entries.map((t6) => ({ key: t6.key, value: O14(t6.value, n23) })) };
    case "regex":
      return { type: "Literal", value: e7.pattern };
    case "slice":
      return { type: "Slice", start: e7.start ? O14(e7.start, n23) : void 0, end: e7.end ? O14(e7.end, n23) : void 0 };
    case "lambda":
      return O14(e7.body, n23);
    case "pipeline":
      return { type: "Identity" };
    default:
      throw new Error(`Unknown moonblade expression type: ${e7.type}`);
  }
}
function Q11(e7) {
  let n23 = [], t6 = 0;
  for (; t6 < e7.length; ) {
    for (; t6 < e7.length && (e7[t6] === " " || e7[t6] === ","); ) t6++;
    if (t6 >= e7.length) break;
    let s9 = t6;
    for (; t6 < e7.length && /\w/.test(e7[t6]); ) t6++;
    let r8 = e7.slice(s9, t6);
    for (; t6 < e7.length && e7[t6] === " "; ) t6++;
    if (e7[t6] !== "(") break;
    t6++;
    let o9 = 1, i10 = t6;
    for (; t6 < e7.length && o9 > 0; ) e7[t6] === "(" ? o9++ : e7[t6] === ")" && o9--, o9 > 0 && t6++;
    let h17 = e7.slice(i10, t6).trim();
    for (t6++; t6 < e7.length && e7[t6] === " "; ) t6++;
    let u11 = "";
    if (e7.slice(t6, t6 + 3).toLowerCase() === "as ") {
      for (t6 += 3; t6 < e7.length && e7[t6] === " "; ) t6++;
      let p17 = t6;
      for (; t6 < e7.length && /\w/.test(e7[t6]); ) t6++;
      u11 = e7.slice(p17, t6);
    }
    u11 || (u11 = h17 ? `${r8}(${h17})` : `${r8}()`), n23.push({ func: r8, expr: h17, alias: u11 });
  }
  return n23;
}
function ze5(e7) {
  return /^\w+$/.test(e7);
}
function Z11(e7, n23, t6) {
  let s9 = O14(_11(n23)), r8 = d11(e7, s9, t6);
  return r8.length > 0 ? r8[0] : null;
}
function ee6(e7, n23, t6 = {}) {
  let { func: s9, expr: r8 } = n23;
  if (s9 === "count" && !r8) return e7.length;
  let o9;
  switch (ze5(r8) ? o9 = e7.map((i10) => i10[r8]).filter((i10) => i10 != null) : o9 = e7.map((i10) => Z11(i10, r8, t6)).filter((i10) => i10 != null), s9) {
    case "count":
      return ze5(r8) ? o9.length : o9.filter((i10) => !!i10).length;
    case "sum":
      return o9.map((h17) => typeof h17 == "number" ? h17 : Number.parseFloat(String(h17))).reduce((h17, u11) => h17 + u11, 0);
    case "mean":
    case "avg": {
      let i10 = o9.map((h17) => typeof h17 == "number" ? h17 : Number.parseFloat(String(h17)));
      return i10.length > 0 ? i10.reduce((h17, u11) => h17 + u11, 0) / i10.length : 0;
    }
    case "min": {
      let i10 = o9.map((h17) => typeof h17 == "number" ? h17 : Number.parseFloat(String(h17)));
      return i10.length > 0 ? Math.min(...i10) : null;
    }
    case "max": {
      let i10 = o9.map((h17) => typeof h17 == "number" ? h17 : Number.parseFloat(String(h17)));
      return i10.length > 0 ? Math.max(...i10) : null;
    }
    case "first":
      return o9.length > 0 ? o9[0] : null;
    case "last":
      return o9.length > 0 ? o9[o9.length - 1] : null;
    case "median": {
      let i10 = o9.map((u11) => typeof u11 == "number" ? u11 : Number.parseFloat(String(u11))).filter((u11) => !Number.isNaN(u11)).sort((u11, p17) => u11 - p17);
      if (i10.length === 0) return null;
      let h17 = Math.floor(i10.length / 2);
      return i10.length % 2 === 0 ? (i10[h17 - 1] + i10[h17]) / 2 : i10[h17];
    }
    case "mode": {
      let i10 = /* @__PURE__ */ new Map();
      for (let p17 of o9) {
        let l8 = String(p17);
        i10.set(l8, (i10.get(l8) || 0) + 1);
      }
      let h17 = 0, u11 = null;
      for (let [p17, l8] of i10) l8 > h17 && (h17 = l8, u11 = p17);
      return u11;
    }
    case "cardinality":
      return new Set(o9.map((h17) => String(h17))).size;
    case "values":
      return o9.map((i10) => String(i10)).join("|");
    case "distinct_values":
      return [...new Set(o9.map((h17) => String(h17)))].sort().join("|");
    case "all": {
      if (e7.length === 0) return true;
      for (let i10 of e7) if (!Z11(i10, r8, t6)) return false;
      return true;
    }
    case "any": {
      for (let i10 of e7) if (Z11(i10, r8, t6)) return true;
      return false;
    }
    default:
      return null;
  }
}
function Ke5(e7, n23, t6 = {}) {
  let s9 = j9();
  for (let r8 of n23) S12(s9, r8.alias, ee6(e7, r8, t6));
  return s9;
}
async function te9(e7, n23) {
  let t6 = "", s9 = [];
  for (let l8 of e7) l8.startsWith("-") || (t6 ? s9.push(l8) : t6 = l8);
  if (!t6) return { stdout: "", stderr: `xan agg: no aggregation expression
`, exitCode: 1 };
  let { data: r8, error: o9 } = await g16(s9, n23);
  if (o9) return o9;
  let i10 = { limits: n23.limits ? { maxIterations: n23.limits.maxJqIterations } : void 0 }, h17 = Q11(t6), u11 = h17.map((l8) => l8.alias), p17 = Ke5(r8, h17, i10);
  return { stdout: R9(u11, [p17]), stderr: "", exitCode: 0 };
}
async function ne8(e7, n23) {
  let t6 = "", s9 = "", r8 = [];
  for (let d16 = 0; d16 < e7.length; d16++) {
    let m25 = e7[d16];
    m25 === "--sorted" || m25.startsWith("-") || (t6 ? s9 ? r8.push(m25) : s9 = m25 : t6 = m25);
  }
  if (!t6 || !s9) return { stdout: "", stderr: `xan groupby: usage: xan groupby COLS EXPR [FILE]
`, exitCode: 1 };
  let { data: o9, error: i10 } = await g16(r8, n23);
  if (i10) return i10;
  let h17 = { limits: n23.limits ? { maxIterations: n23.limits.maxJqIterations } : void 0 }, u11 = t6.split(","), p17 = Q11(s9), l8 = [], f11 = /* @__PURE__ */ new Map();
  for (let d16 of o9) {
    let m25 = u11.map((g18) => String(d16[g18])).join("\0");
    f11.has(m25) || (f11.set(m25, []), l8.push(m25)), f11.get(m25)?.push(d16);
  }
  let c15 = [...u11, ...p17.map((d16) => d16.alias)], a7 = [];
  for (let d16 of l8) {
    let m25 = f11.get(d16);
    if (!m25) continue;
    let g18 = j9();
    for (let y18 of u11) S12(g18, y18, m25[0][y18]);
    for (let y18 of p17) S12(g18, y18.alias, ee6(m25, y18, h17));
    a7.push(g18);
  }
  return { stdout: R9(c15, a7), stderr: "", exitCode: 0 };
}
async function se7(e7, n23) {
  let t6 = [], s9 = "", r8 = 10, o9 = false, i10 = [];
  for (let a7 = 0; a7 < e7.length; a7++) {
    let d16 = e7[a7];
    (d16 === "-s" || d16 === "--select") && a7 + 1 < e7.length ? t6 = e7[++a7].split(",") : (d16 === "-g" || d16 === "--groupby") && a7 + 1 < e7.length ? s9 = e7[++a7] : (d16 === "-l" || d16 === "--limit") && a7 + 1 < e7.length ? r8 = Number.parseInt(e7[++a7], 10) : d16 === "--no-extra" ? o9 = true : d16 === "-A" || d16 === "--all" ? r8 = 0 : d16.startsWith("-") || i10.push(d16);
  }
  let { headers: h17, data: u11, error: p17 } = await g16(i10, n23);
  if (p17) return p17;
  let l8 = t6.length > 0 ? t6 : h17.filter((a7) => a7 !== s9);
  s9 && t6.length === 0 && (l8 = h17.filter((a7) => a7 !== s9));
  let f11 = [], c15 = s9 ? ["field", s9, "value", "count"] : ["field", "value", "count"];
  if (s9) {
    let a7 = /* @__PURE__ */ new Map();
    for (let d16 of u11) {
      let m25 = String(d16[s9] ?? "");
      a7.has(m25) || a7.set(m25, []), a7.get(m25)?.push(d16);
    }
    for (let d16 of l8) for (let [m25, g18] of a7) {
      let y18 = /* @__PURE__ */ new Map();
      for (let I18 of g18) {
        let N15 = I18[d16], C19 = N15 === "" || N15 === null || N15 === void 0 ? "" : String(N15);
        y18.set(C19, (y18.get(C19) || 0) + 1);
      }
      let x23 = [...y18.entries()].sort((I18, N15) => N15[1] !== I18[1] ? N15[1] - I18[1] : I18[0].localeCompare(N15[0]));
      o9 && (x23 = x23.filter(([I18]) => I18 !== "")), r8 > 0 && (x23 = x23.slice(0, r8));
      for (let [I18, N15] of x23) f11.push({ field: d16, [s9]: m25, value: I18 === "" ? "<empty>" : I18, count: N15 });
    }
  } else for (let a7 of l8) {
    let d16 = /* @__PURE__ */ new Map();
    for (let g18 of u11) {
      let y18 = g18[a7], x23 = y18 === "" || y18 === null || y18 === void 0 ? "" : String(y18);
      d16.set(x23, (d16.get(x23) || 0) + 1);
    }
    let m25 = [...d16.entries()].sort((g18, y18) => y18[1] !== g18[1] ? y18[1] - g18[1] : g18[0].localeCompare(y18[0]));
    o9 && (m25 = m25.filter(([g18]) => g18 !== "")), r8 > 0 && (m25 = m25.slice(0, r8));
    for (let [g18, y18] of m25) f11.push({ field: a7, value: g18 === "" ? "<empty>" : g18, count: y18 });
  }
  return { stdout: R9(c15, f11), stderr: "", exitCode: 0 };
}
async function re4(e7, n23) {
  let t6 = [], s9 = [];
  for (let l8 = 0; l8 < e7.length; l8++) {
    let f11 = e7[l8];
    f11 === "-s" && l8 + 1 < e7.length ? t6 = e7[++l8].split(",") : f11.startsWith("-") || s9.push(f11);
  }
  let { headers: r8, data: o9, error: i10 } = await g16(s9, n23);
  if (i10) return i10;
  let h17 = t6.length > 0 ? t6 : r8, u11 = ["field", "type", "count", "min", "max", "mean"], p17 = [];
  for (let l8 of h17) {
    let f11 = o9.map((d16) => d16[l8]).filter((d16) => d16 != null), c15 = f11.map((d16) => typeof d16 == "number" ? d16 : Number.parseFloat(String(d16))).filter((d16) => !Number.isNaN(d16)), a7 = c15.length === f11.length && c15.length > 0;
    p17.push({ field: l8, type: a7 ? "Number" : "String", count: f11.length, min: a7 ? Math.min(...c15) : "", max: a7 ? Math.max(...c15) : "", mean: a7 ? Math.round(c15.reduce((d16, m25) => d16 + m25, 0) / c15.length * 1e10) / 1e10 : "" });
  }
  return { stdout: R9(u11, p17), stderr: "", exitCode: 0 };
}
function Ge5(e7) {
  let n23 = _11(e7);
  return O14(n23);
}
function nt6(e7) {
  let t6 = e7.replace(/[.+?^${}()|[\]\\]/g, "\\$&").replace(/\*/g, ".*");
  return b1(`^${t6}$`);
}
function z8(e7, n23) {
  let t6 = [], s9 = /* @__PURE__ */ new Set();
  for (let r8 of e7.split(",")) {
    let o9 = r8.trim();
    if (o9.startsWith("!")) {
      let p17 = o9.slice(1), l8 = z8(p17, n23);
      for (let f11 of l8) s9.add(f11);
      continue;
    }
    if (o9 === "*") {
      for (let p17 of n23) t6.includes(p17) || t6.push(p17);
      continue;
    }
    if (o9.includes("*")) {
      let p17 = nt6(o9);
      for (let l8 of n23) p17.test(l8) && !t6.includes(l8) && t6.push(l8);
      continue;
    }
    let i10 = o9.match(/^([^:]*):([^:]*)$/);
    if (i10 && (i10[1] || i10[2])) {
      let p17 = i10[1], l8 = i10[2], f11 = p17 ? n23.indexOf(p17) : 0, c15 = l8 ? n23.indexOf(l8) : n23.length - 1;
      if (f11 !== -1 && c15 !== -1) {
        let a7 = f11 <= c15 ? 1 : -1;
        for (let d16 = f11; a7 > 0 ? d16 <= c15 : d16 >= c15; d16 += a7) t6.includes(n23[d16]) || t6.push(n23[d16]);
      }
      continue;
    }
    let h17 = o9.match(/^(\d+)-(\d+)$/);
    if (h17) {
      let p17 = Number.parseInt(h17[1], 10), l8 = Number.parseInt(h17[2], 10);
      for (let f11 = p17; f11 <= l8 && f11 < n23.length; f11++) t6.push(n23[f11]);
      continue;
    }
    let u11 = Number.parseInt(o9, 10);
    if (!Number.isNaN(u11) && u11 >= 0 && u11 < n23.length) {
      t6.push(n23[u11]);
      continue;
    }
    n23.includes(o9) && t6.push(o9);
  }
  return s9.size > 0 ? t6.filter((r8) => !s9.has(r8)) : t6;
}
async function oe7(e7, n23) {
  let t6 = "", s9 = [];
  for (let p17 of e7) p17.startsWith("-") || (t6 ? s9.push(p17) : t6 = p17);
  if (!t6) return { stdout: "", stderr: `xan select: no columns specified
`, exitCode: 1 };
  let { headers: r8, data: o9, error: i10 } = await g16(s9, n23);
  if (i10) return i10;
  let h17 = z8(t6, r8), u11 = o9.map((p17) => {
    let l8 = j9();
    for (let f11 of h17) S12(l8, f11, p17[f11]);
    return l8;
  });
  return { stdout: R9(h17, u11), stderr: "", exitCode: 0 };
}
async function ie5(e7, n23) {
  let t6 = "", s9 = [];
  for (let l8 of e7) l8.startsWith("-") || (t6 ? s9.push(l8) : t6 = l8);
  if (!t6) return { stdout: "", stderr: `xan drop: no columns specified
`, exitCode: 1 };
  let { headers: r8, data: o9, error: i10 } = await g16(s9, n23);
  if (i10) return i10;
  let h17 = new Set(z8(t6, r8)), u11 = r8.filter((l8) => !h17.has(l8)), p17 = o9.map((l8) => {
    let f11 = j9();
    for (let c15 of u11) S12(f11, c15, l8[c15]);
    return f11;
  });
  return { stdout: R9(u11, p17), stderr: "", exitCode: 0 };
}
async function ae7(e7, n23) {
  let t6 = "", s9 = "", r8 = [];
  for (let l8 = 0; l8 < e7.length; l8++) {
    let f11 = e7[l8];
    f11 === "-s" && l8 + 1 < e7.length ? s9 = e7[++l8] : f11.startsWith("-") || (t6 ? r8.push(f11) : t6 = f11);
  }
  if (!t6) return { stdout: "", stderr: `xan rename: no new name(s) specified
`, exitCode: 1 };
  let { headers: o9, data: i10, error: h17 } = await g16(r8, n23);
  if (h17) return h17;
  let u11;
  if (s9) {
    let l8 = s9.split(","), f11 = t6.split(","), c15 = /* @__PURE__ */ new Map();
    for (let a7 = 0; a7 < l8.length && a7 < f11.length; a7++) c15.set(l8[a7], f11[a7]);
    u11 = o9.map((a7) => c15.get(a7) || a7);
  } else {
    let l8 = t6.split(",");
    u11 = o9.map((f11, c15) => c15 < l8.length ? l8[c15] : f11);
  }
  let p17 = i10.map((l8) => {
    let f11 = j9();
    for (let c15 = 0; c15 < o9.length; c15++) S12(f11, u11[c15], l8[o9[c15]]);
    return f11;
  });
  return { stdout: R9(u11, p17), stderr: "", exitCode: 0 };
}
async function le8(e7, n23) {
  let t6 = "index", s9 = [];
  for (let p17 = 0; p17 < e7.length; p17++) e7[p17] === "-c" && p17 + 1 < e7.length ? t6 = e7[++p17] : s9.push(e7[p17]);
  let { headers: r8, data: o9, error: i10 } = await g16(s9, n23);
  if (i10) return i10;
  let h17 = [t6, ...r8], u11 = o9.map((p17, l8) => {
    let f11 = j9();
    S12(f11, t6, l8);
    for (let c15 of r8) S12(f11, c15, p17[c15]);
    return f11;
  });
  return { stdout: R9(h17, u11), stderr: "", exitCode: 0 };
}
async function ue9(e7, n23) {
  let t6 = e7.includes("-j") || e7.includes("--just-names"), { headers: s9, error: r8 } = await g16(e7.filter((i10) => i10 !== "-j" && i10 !== "--just-names"), n23);
  return r8 || { stdout: t6 ? `${s9.map((i10) => i10).join(`
`)}
` : `${s9.map((i10, h17) => `${h17}   ${i10}`).join(`
`)}
`, stderr: "", exitCode: 0 };
}
async function ce8(e7, n23) {
  let { data: t6, error: s9 } = await g16(e7, n23);
  return s9 || { stdout: `${t6.length}
`, stderr: "", exitCode: 0 };
}
async function pe7(e7, n23) {
  let t6 = 10, s9 = [];
  for (let u11 = 0; u11 < e7.length; u11++) (e7[u11] === "-l" || e7[u11] === "-n") && u11 + 1 < e7.length ? t6 = Number.parseInt(e7[++u11], 10) : s9.push(e7[u11]);
  let { headers: r8, data: o9, error: i10 } = await g16(s9, n23);
  if (i10) return i10;
  let h17 = o9.slice(0, t6);
  return { stdout: R9(r8, h17), stderr: "", exitCode: 0 };
}
async function fe9(e7, n23) {
  let t6 = 10, s9 = [];
  for (let u11 = 0; u11 < e7.length; u11++) (e7[u11] === "-l" || e7[u11] === "-n") && u11 + 1 < e7.length ? t6 = Number.parseInt(e7[++u11], 10) : s9.push(e7[u11]);
  let { headers: r8, data: o9, error: i10 } = await g16(s9, n23);
  if (i10) return i10;
  let h17 = o9.slice(-t6);
  return { stdout: R9(r8, h17), stderr: "", exitCode: 0 };
}
async function de9(e7, n23) {
  let t6, s9, r8, o9 = [];
  for (let c15 = 0; c15 < e7.length; c15++) {
    let a7 = e7[c15];
    (a7 === "-s" || a7 === "--start") && c15 + 1 < e7.length ? t6 = Number.parseInt(e7[++c15], 10) : (a7 === "-e" || a7 === "--end") && c15 + 1 < e7.length ? s9 = Number.parseInt(e7[++c15], 10) : (a7 === "-l" || a7 === "--len") && c15 + 1 < e7.length ? r8 = Number.parseInt(e7[++c15], 10) : a7.startsWith("-") || o9.push(a7);
  }
  let { headers: i10, data: h17, error: u11 } = await g16(o9, n23);
  if (u11) return u11;
  let p17 = t6 ?? 0, l8;
  r8 !== void 0 ? l8 = p17 + r8 : s9 !== void 0 ? l8 = s9 : l8 = h17.length;
  let f11 = h17.slice(p17, l8);
  return { stdout: R9(i10, f11), stderr: "", exitCode: 0 };
}
async function he9(e7, n23) {
  let { headers: t6, data: s9, error: r8 } = await g16(e7, n23);
  if (r8) return r8;
  let o9 = [...s9].reverse();
  return { stdout: R9(t6, o9), stderr: "", exitCode: 0 };
}
async function ge7(e7, n23) {
  let t6 = e7.filter((p17) => !p17.startsWith("-")), { headers: s9, data: r8, error: o9 } = await g16(t6, n23);
  if (o9) return o9;
  if (r8.length === 0) {
    let p17 = ["column"], l8 = s9.map((f11) => ({ column: f11 }));
    return { stdout: R9(p17, l8), stderr: "", exitCode: 0 };
  }
  let i10 = s9[0], h17 = [i10, ...r8.map((p17, l8) => String(p17[i10] ?? `row_${l8}`))], u11 = [];
  for (let p17 = 1; p17 < s9.length; p17++) {
    let l8 = s9[p17], f11 = j9();
    S12(f11, i10, l8);
    for (let c15 = 0; c15 < r8.length; c15++) S12(f11, h17[c15 + 1], r8[c15][l8]);
    u11.push(f11);
  }
  return { stdout: R9(h17, u11), stderr: "", exitCode: 0 };
}
async function ye6(e7, n23) {
  let t6 = null, s9 = [];
  for (let l8 = 0; l8 < e7.length; l8++) {
    let f11 = e7[l8];
    f11 === "--seed" && l8 + 1 < e7.length ? t6 = Number.parseInt(e7[++l8], 10) : f11.startsWith("-") || s9.push(f11);
  }
  let { headers: r8, data: o9, error: i10 } = await g16(s9, n23);
  if (i10) return i10;
  let h17 = t6 !== null ? t6 : Date.now(), u11 = () => (h17 = h17 * 1103515245 + 12345 & 2147483647, h17 / 2147483647), p17 = [...o9];
  for (let l8 = p17.length - 1; l8 > 0; l8--) {
    let f11 = Math.floor(u11() * (l8 + 1));
    [p17[l8], p17[f11]] = [p17[f11], p17[l8]];
  }
  return { stdout: R9(r8, p17), stderr: "", exitCode: 0 };
}
async function xe9(e7, n23) {
  let t6 = null, s9 = "", r8 = [];
  for (let a7 = 0; a7 < e7.length; a7++) {
    let d16 = e7[a7];
    (d16 === "-l" || d16 === "--length") && a7 + 1 < e7.length ? t6 = Number.parseInt(e7[++a7], 10) : (d16 === "-d" || d16 === "--default") && a7 + 1 < e7.length ? s9 = e7[++a7] : d16.startsWith("-") || r8.push(d16);
  }
  let o9 = r8[0], i10;
  if (!o9 || o9 === "-") i10 = n23.stdin;
  else try {
    let a7 = n23.fs.resolvePath(n23.cwd, o9);
    i10 = await n23.fs.readFile(a7);
  } catch {
    return { stdout: "", stderr: `xan fixlengths: ${o9}: No such file or directory
`, exitCode: 1 };
  }
  let u11 = me5.default.parse(i10.trim(), { header: false, skipEmptyLines: true }).data;
  if (u11.length === 0) return { stdout: "", stderr: "", exitCode: 0 };
  let p17 = Math.max(...u11.map((a7) => a7.length)), l8 = t6 ?? p17, f11 = u11.map((a7) => a7.length === l8 ? a7 : a7.length < l8 ? [...a7, ...Array(l8 - a7.length).fill(s9)] : a7.slice(0, l8));
  return { stdout: `${me5.default.unparse(f11).replace(/\r\n/g, `
`)}
`, stderr: "", exitCode: 0 };
}
async function we5(e7, n23) {
  let t6 = null, s9 = null, r8 = ".", o9 = [];
  for (let c15 = 0; c15 < e7.length; c15++) {
    let a7 = e7[c15];
    (a7 === "-c" || a7 === "--chunks") && c15 + 1 < e7.length ? t6 = Number.parseInt(e7[++c15], 10) : (a7 === "-S" || a7 === "--size") && c15 + 1 < e7.length ? s9 = Number.parseInt(e7[++c15], 10) : (a7 === "-o" || a7 === "--output") && c15 + 1 < e7.length ? r8 = e7[++c15] : a7.startsWith("-") || o9.push(a7);
  }
  if (!t6 && !s9) return { stdout: "", stderr: `xan split: must specify -c or -S
`, exitCode: 1 };
  let { headers: i10, data: h17, error: u11 } = await g16(o9, n23);
  if (u11) return u11;
  let p17 = [];
  if (t6) {
    let c15 = Math.ceil(h17.length / t6);
    for (let a7 = 0; a7 < t6; a7++) p17.push(h17.slice(a7 * c15, (a7 + 1) * c15));
  } else if (s9) for (let c15 = 0; c15 < h17.length; c15 += s9) p17.push(h17.slice(c15, c15 + s9));
  let l8 = p17.filter((c15) => c15.length > 0), f11 = o9[0]?.replace(/\.csv$/, "") || "part";
  try {
    let c15 = n23.fs.resolvePath(n23.cwd, r8);
    for (let a7 = 0; a7 < l8.length; a7++) {
      let d16 = `${f11}_${String(a7 + 1).padStart(3, "0")}.csv`, m25 = n23.fs.resolvePath(c15, d16);
      await n23.fs.writeFile(m25, R9(i10, l8[a7]));
    }
    return { stdout: `Split into ${l8.length} parts
`, stderr: "", exitCode: 0 };
  } catch {
    return { stdout: `${l8.map((a7, d16) => `Part ${d16 + 1}: ${a7.length} rows`).join(`
`)}
`, stderr: "", exitCode: 0 };
  }
}
async function ve6(e7, n23) {
  let t6 = "", s9 = ".", r8 = [];
  for (let p17 = 0; p17 < e7.length; p17++) {
    let l8 = e7[p17];
    (l8 === "-o" || l8 === "--output") && p17 + 1 < e7.length ? s9 = e7[++p17] : l8.startsWith("-") || (t6 ? r8.push(l8) : t6 = l8);
  }
  if (!t6) return { stdout: "", stderr: `xan partition: usage: xan partition COLUMN [FILE]
`, exitCode: 1 };
  let { headers: o9, data: i10, error: h17 } = await g16(r8, n23);
  if (h17) return h17;
  if (!o9.includes(t6)) return { stdout: "", stderr: `xan partition: column '${t6}' not found
`, exitCode: 1 };
  let u11 = /* @__PURE__ */ new Map();
  for (let p17 of i10) {
    let l8 = String(p17[t6] ?? "");
    u11.has(l8) || u11.set(l8, []), u11.get(l8)?.push(p17);
  }
  try {
    let p17 = n23.fs.resolvePath(n23.cwd, s9);
    for (let [l8, f11] of u11) {
      let a7 = `${l8.replace(/[^a-zA-Z0-9_-]/g, "_") || "empty"}.csv`, d16 = n23.fs.resolvePath(p17, a7);
      await n23.fs.writeFile(d16, R9(o9, f11));
    }
    return { stdout: `Partitioned into ${u11.size} files by '${t6}'
`, stderr: "", exitCode: 0 };
  } catch {
    return { stdout: `${Array.from(u11.entries()).map(([l8, f11]) => `${l8}: ${f11.length} rows`).join(`
`)}
`, stderr: "", exitCode: 0 };
  }
}
async function Ce4(e7, n23) {
  if (e7.length === 0) return { stdout: "", stderr: `xan to: usage: xan to <format> [FILE]
`, exitCode: 1 };
  let t6 = e7[0], s9 = e7.slice(1);
  return t6 === "json" ? st6(s9, n23) : { stdout: "", stderr: `xan to: unsupported format '${t6}'
`, exitCode: 1 };
}
async function st6(e7, n23) {
  let t6 = e7.filter((i10) => !i10.startsWith("-")), { data: s9, error: r8 } = await g16(t6, n23);
  return r8 || { stdout: `${JSON.stringify(s9, null, 2)}
`, stderr: "", exitCode: 0 };
}
async function be6(e7, n23) {
  let t6 = "", s9 = [];
  for (let r8 = 0; r8 < e7.length; r8++) {
    let o9 = e7[r8];
    (o9 === "-f" || o9 === "--format") && r8 + 1 < e7.length ? t6 = e7[++r8] : o9.startsWith("-") || s9.push(o9);
  }
  return t6 ? t6 === "json" ? rt5(s9, n23) : { stdout: "", stderr: `xan from: unsupported format '${t6}'
`, exitCode: 1 } : { stdout: "", stderr: `xan from: usage: xan from -f <format> [FILE]
`, exitCode: 1 };
}
async function rt5(e7, n23) {
  let t6 = e7[0], s9;
  if (!t6 || t6 === "-") s9 = n23.stdin;
  else try {
    let r8 = n23.fs.resolvePath(n23.cwd, t6);
    s9 = await n23.fs.readFile(r8);
  } catch {
    return { stdout: "", stderr: `xan from: ${t6}: No such file or directory
`, exitCode: 1 };
  }
  try {
    let r8 = JSON.parse(s9.trim());
    if (!Array.isArray(r8)) return { stdout: "", stderr: `xan from: JSON input must be an array
`, exitCode: 1 };
    if (r8.length === 0) return { stdout: `
`, stderr: "", exitCode: 0 };
    if (Array.isArray(r8[0])) {
      let [i10, ...h17] = r8, u11 = h17.map((p17) => {
        let l8 = j9();
        for (let f11 = 0; f11 < i10.length; f11++) S12(l8, i10[f11], p17[f11]);
        return l8;
      });
      return { stdout: R9(i10, u11), stderr: "", exitCode: 0 };
    }
    let o9 = Object.keys(r8[0]).sort();
    return { stdout: R9(o9, r8), stderr: "", exitCode: 0 };
  } catch {
    return { stdout: "", stderr: `xan from: invalid JSON input
`, exitCode: 1 };
  }
}
async function Se5(e7, n23) {
  let t6 = false, s9 = 0, r8 = "", o9 = [];
  for (let c15 = 0; c15 < e7.length; c15++) {
    let a7 = e7[c15];
    if (a7 === "-v" || a7 === "--invert") t6 = true;
    else if ((a7 === "-l" || a7 === "--limit") && c15 + 1 < e7.length) s9 = Number.parseInt(e7[++c15], 10);
    else {
      if (a7 === "--help") return s({ name: "xan filter", summary: "Filter rows by expression", usage: "xan filter [OPTIONS] EXPR [FILE]", description: "Filter CSV rows using moonblade expressions.", options: ["-v, --invert    invert match", "-l, --limit N   limit output to N rows", "    --help      display help"] });
      a7.startsWith("-") || (r8 ? o9.push(a7) : r8 = a7);
    }
  }
  if (!r8) return { stdout: "", stderr: `xan filter: no expression specified
`, exitCode: 1 };
  let { headers: i10, data: h17, error: u11 } = await g16(o9, n23);
  if (u11) return u11;
  let p17 = { limits: n23.limits ? { maxIterations: n23.limits.maxJqIterations } : void 0 }, l8 = Ge5(r8), f11 = [];
  for (let c15 of h17) {
    if (s9 > 0 && f11.length >= s9) break;
    let a7 = d11(c15, l8, p17), d16 = a7.length > 0 && a7.some((m25) => !!m25);
    (t6 ? !d16 : d16) && f11.push(c15);
  }
  return { stdout: R9(i10, f11), stderr: "", exitCode: 0 };
}
async function Ie6(e7, n23) {
  let t6 = "", s9 = false, r8 = false, o9 = [];
  for (let l8 = 0; l8 < e7.length; l8++) {
    let f11 = e7[l8];
    f11 === "-N" || f11 === "--numeric" ? s9 = true : f11 === "-R" || f11 === "-r" || f11 === "--reverse" ? r8 = true : f11 === "-s" && l8 + 1 < e7.length ? t6 = e7[++l8] : f11.startsWith("-") || o9.push(f11);
  }
  let { headers: i10, data: h17, error: u11 } = await g16(o9, n23);
  if (u11) return u11;
  !t6 && i10.length > 0 && (t6 = i10[0]);
  let p17 = [...h17].sort((l8, f11) => {
    let c15 = l8[t6], a7 = f11[t6], d16;
    if (s9) {
      let m25 = typeof c15 == "number" ? c15 : Number.parseFloat(String(c15)), g18 = typeof a7 == "number" ? a7 : Number.parseFloat(String(a7));
      d16 = m25 - g18;
    } else d16 = String(c15).localeCompare(String(a7));
    return r8 ? -d16 : d16;
  });
  return { stdout: R9(i10, p17), stderr: "", exitCode: 0 };
}
async function ke5(e7, n23) {
  let t6 = "", s9 = [];
  for (let p17 = 0; p17 < e7.length; p17++) {
    let l8 = e7[p17];
    l8 === "-s" && p17 + 1 < e7.length ? t6 = e7[++p17] : l8.startsWith("-") || s9.push(l8);
  }
  let { headers: r8, data: o9, error: i10 } = await g16(s9, n23);
  if (i10) return i10;
  let h17 = /* @__PURE__ */ new Set(), u11 = o9.filter((p17) => {
    let l8 = t6 ? String(p17[t6]) : JSON.stringify(p17);
    return h17.has(l8) ? false : (h17.add(l8), true);
  });
  return { stdout: R9(r8, u11), stderr: "", exitCode: 0 };
}
async function Ne5(e7, n23) {
  let t6 = 10, s9 = "", r8 = false, o9 = [];
  for (let f11 = 0; f11 < e7.length; f11++) {
    let c15 = e7[f11];
    (c15 === "-l" || c15 === "-n") && f11 + 1 < e7.length ? t6 = Number.parseInt(e7[++f11], 10) : c15 === "-R" || c15 === "-r" || c15 === "--reverse" ? r8 = true : c15.startsWith("-") || (s9 ? o9.push(c15) : s9 = c15);
  }
  let { headers: i10, data: h17, error: u11 } = await g16(o9, n23);
  if (u11) return u11;
  !s9 && i10.length > 0 && (s9 = i10[0]);
  let l8 = [...h17].sort((f11, c15) => {
    let a7 = f11[s9], d16 = c15[s9], m25 = typeof a7 == "number" ? a7 : Number.parseFloat(String(a7)), g18 = typeof d16 == "number" ? d16 : Number.parseFloat(String(d16));
    return r8 ? m25 - g18 : g18 - m25;
  }).slice(0, t6);
  return { stdout: R9(i10, l8), stderr: "", exitCode: 0 };
}
async function Ee6(e7, n23) {
  let t6 = "", s9 = false, r8 = false, o9 = [];
  for (let d16 = 0; d16 < e7.length; d16++) {
    let m25 = e7[d16];
    m25 === "-O" || m25 === "--overwrite" ? s9 = true : m25 === "--filter" ? r8 = true : m25.startsWith("-") || (t6 ? o9.push(m25) : t6 = m25);
  }
  if (!t6) return { stdout: "", stderr: `xan map: no expression specified
`, exitCode: 1 };
  let { headers: i10, data: h17, error: u11 } = await g16(o9, n23);
  if (u11) return u11;
  let l8 = V11(t6).map(({ expr: d16, name: m25 }) => ({ alias: typeof m25 == "string" ? m25 : m25[0], ast: O14(d16) })), f11 = { limits: n23.limits ? { maxIterations: n23.limits.maxJqIterations } : void 0 }, c15;
  if (s9) {
    c15 = [...i10];
    for (let d16 of l8) i10.includes(d16.alias) || c15.push(d16.alias);
  } else c15 = [...i10, ...l8.map((d16) => d16.alias)];
  let a7 = [];
  for (let d16 = 0; d16 < h17.length; d16++) {
    let m25 = h17[d16], g18 = C18(m25), y18 = false, x23 = Object.assign(s4(m25), { _row_index: d16 });
    for (let I18 of l8) {
      let N15 = d11(x23, I18.ast, f11), C19 = N15.length > 0 ? N15[0] : null;
      if (r8 && C19 == null) {
        y18 = true;
        break;
      }
      S12(g18, I18.alias, C19);
    }
    y18 || a7.push(g18);
  }
  return { stdout: R9(c15, a7), stderr: "", exitCode: 0 };
}
async function Ae7(e7, n23) {
  let t6 = "", s9 = "", r8 = "", o9 = [];
  for (let m25 = 0; m25 < e7.length; m25++) {
    let g18 = e7[m25];
    (g18 === "-r" || g18 === "--rename") && m25 + 1 < e7.length ? r8 = e7[++m25] : g18.startsWith("-") || (t6 ? s9 ? o9.push(g18) : s9 = g18 : t6 = g18);
  }
  if (!t6 || !s9) return { stdout: "", stderr: `xan transform: usage: xan transform COLUMN EXPR [FILE]
`, exitCode: 1 };
  let { headers: i10, data: h17, error: u11 } = await g16(o9, n23);
  if (u11) return u11;
  let p17 = t6.split(",").map((m25) => m25.trim()), l8 = r8 ? r8.split(",").map((m25) => m25.trim()) : [];
  for (let m25 of p17) if (!i10.includes(m25)) return { stdout: "", stderr: `xan transform: column '${m25}' not found
`, exitCode: 1 };
  let f11 = O14(V11(s9)[0]?.expr || (U13(), r2(He6)).parseMoonblade(s9)), c15 = { limits: n23.limits ? { maxIterations: n23.limits.maxJqIterations } : void 0 }, a7 = i10.map((m25) => {
    let g18 = p17.indexOf(m25);
    return g18 !== -1 && l8[g18] ? l8[g18] : m25;
  }), d16 = [];
  for (let m25 of h17) {
    let g18 = C18(m25);
    for (let y18 = 0; y18 < p17.length; y18++) {
      let x23 = p17[y18], I18 = Object.assign(s4(m25), { _: m25[x23] }), N15 = d11(I18, f11, c15), C19 = N15.length > 0 ? N15[0] : null, A14 = l8[y18] || x23;
      A14 !== x23 && delete g18[x23], S12(g18, A14, C19);
    }
    d16.push(g18);
  }
  return { stdout: R9(a7, d16), stderr: "", exitCode: 0 };
}
async function Fe6(e7, n23) {
  let t6 = "", s9 = "|", r8 = false, o9 = "", i10 = [];
  for (let a7 = 0; a7 < e7.length; a7++) {
    let d16 = e7[a7];
    (d16 === "-s" || d16 === "--separator") && a7 + 1 < e7.length ? s9 = e7[++a7] : d16 === "--drop-empty" ? r8 = true : (d16 === "-r" || d16 === "--rename") && a7 + 1 < e7.length ? o9 = e7[++a7] : d16.startsWith("-") || (t6 ? i10.push(d16) : t6 = d16);
  }
  if (!t6) return { stdout: "", stderr: `xan explode: usage: xan explode COLUMN [FILE]
`, exitCode: 1 };
  let { headers: h17, data: u11, error: p17 } = await g16(i10, n23);
  if (p17) return p17;
  if (!h17.includes(t6)) return { stdout: "", stderr: `xan explode: column '${t6}' not found
`, exitCode: 1 };
  let l8 = o9 ? h17.map((a7) => a7 === t6 ? o9 : a7) : h17, f11 = o9 || t6, c15 = [];
  for (let a7 of u11) {
    let d16 = a7[t6], m25 = d16 == null ? "" : String(d16);
    if (m25 === "") {
      if (!r8) {
        let g18 = C18(a7);
        o9 && (delete g18[t6], S12(g18, f11, "")), c15.push(g18);
      }
    } else {
      let g18 = m25.split(s9);
      for (let y18 of g18) {
        let x23 = C18(a7);
        o9 && delete x23[t6], S12(x23, f11, y18), c15.push(x23);
      }
    }
  }
  return { stdout: R9(l8, c15), stderr: "", exitCode: 0 };
}
async function Oe5(e7, n23) {
  let t6 = "", s9 = "|", r8 = "", o9 = [];
  for (let g18 = 0; g18 < e7.length; g18++) {
    let y18 = e7[g18];
    (y18 === "-s" || y18 === "--sep") && g18 + 1 < e7.length ? s9 = e7[++g18] : (y18 === "-r" || y18 === "--rename") && g18 + 1 < e7.length ? r8 = e7[++g18] : y18.startsWith("-") || (t6 ? o9.push(y18) : t6 = y18);
  }
  if (!t6) return { stdout: "", stderr: `xan implode: usage: xan implode COLUMN [FILE]
`, exitCode: 1 };
  let { headers: i10, data: h17, error: u11 } = await g16(o9, n23);
  if (u11) return u11;
  if (!i10.includes(t6)) return { stdout: "", stderr: `xan implode: column '${t6}' not found
`, exitCode: 1 };
  let p17 = i10.filter((g18) => g18 !== t6), l8 = r8 ? i10.map((g18) => g18 === t6 ? r8 : g18) : i10, f11 = r8 || t6, c15 = [], a7 = null, d16 = [], m25 = null;
  for (let g18 of h17) {
    let y18 = p17.map((N15) => String(g18[N15] ?? "")).join("\0"), x23 = g18[t6], I18 = x23 == null ? "" : String(x23);
    if (y18 !== a7) {
      if (m25 !== null) {
        let N15 = C18(m25);
        r8 && delete N15[t6], S12(N15, f11, d16.join(s9)), c15.push(N15);
      }
      a7 = y18, d16 = [I18], m25 = g18;
    } else d16.push(I18);
  }
  if (m25 !== null) {
    let g18 = C18(m25);
    r8 && delete g18[t6], S12(g18, f11, d16.join(s9)), c15.push(g18);
  }
  return { stdout: R9(l8, c15), stderr: "", exitCode: 0 };
}
async function Le6(e7, n23) {
  let t6 = "", s9 = "", r8 = "", o9 = "", i10 = "inner", h17 = "", u11 = 0;
  for (let C19 = 0; C19 < e7.length; C19++) {
    let A14 = e7[C19];
    A14 === "--left" ? i10 = "left" : A14 === "--right" ? i10 = "right" : A14 === "--full" ? i10 = "full" : (A14 === "-D" || A14 === "--default") && C19 + 1 < e7.length ? h17 = e7[++C19] : A14.startsWith("-") || (u11++, u11 === 1 ? t6 = A14 : u11 === 2 ? s9 = A14 : u11 === 3 ? r8 = A14 : u11 === 4 && (o9 = A14));
  }
  if (!t6 || !s9 || !r8 || !o9) return { stdout: "", stderr: `xan join: usage: xan join KEY1 FILE1 KEY2 FILE2 [OPTIONS]
`, exitCode: 1 };
  let p17 = await g16([s9], n23);
  if (p17.error) return p17.error;
  let l8 = await g16([o9], n23);
  if (l8.error) return l8.error;
  let { headers: f11, data: c15 } = p17, { headers: a7, data: d16 } = l8;
  if (!f11.includes(t6)) return { stdout: "", stderr: `xan join: column '${t6}' not found in first file
`, exitCode: 1 };
  if (!a7.includes(r8)) return { stdout: "", stderr: `xan join: column '${r8}' not found in second file
`, exitCode: 1 };
  let m25 = /* @__PURE__ */ new Map();
  for (let C19 of d16) {
    let A14 = String(C19[r8] ?? "");
    m25.has(A14) || m25.set(A14, []), m25.get(A14)?.push(C19);
  }
  let g18 = new Set(f11), y18 = a7.filter((C19) => !g18.has(C19)), x23 = [...f11, ...y18], I18 = [], N15 = /* @__PURE__ */ new Set();
  for (let C19 of c15) {
    let A14 = String(C19[t6] ?? ""), j12 = m25.get(A14);
    if (j12 && j12.length > 0) {
      N15.add(A14);
      for (let L18 of j12) {
        let T10 = j9();
        for (let W15 of f11) S12(T10, W15, C19[W15]);
        for (let W15 of y18) S12(T10, W15, L18[W15]);
        I18.push(T10);
      }
    } else if (i10 === "left" || i10 === "full") {
      let L18 = j9();
      for (let T10 of f11) S12(L18, T10, C19[T10]);
      for (let T10 of y18) S12(L18, T10, h17);
      I18.push(L18);
    }
  }
  if (i10 === "right" || i10 === "full") for (let C19 of d16) {
    let A14 = String(C19[r8] ?? "");
    if (!N15.has(A14)) {
      let j12 = j9();
      for (let L18 of f11) S12(j12, L18, a7.includes(L18) ? C19[L18] : h17);
      for (let L18 of y18) S12(j12, L18, C19[L18]);
      I18.push(j12);
    }
  }
  return { stdout: R9(x23, I18), stderr: "", exitCode: 0 };
}
async function Pe5(e7, n23) {
  let t6 = "", s9 = "", r8 = [], o9 = [];
  for (let y18 = 0; y18 < e7.length; y18++) {
    let x23 = e7[y18];
    (x23 === "-g" || x23 === "--groupby") && y18 + 1 < e7.length ? r8 = e7[++y18].split(",").map((I18) => I18.trim()) : x23.startsWith("-") || (t6 ? s9 ? o9.push(x23) : s9 = x23 : t6 = x23);
  }
  if (!t6 || !s9) return { stdout: "", stderr: `xan pivot: usage: xan pivot COLUMN AGG_EXPR [OPTIONS] [FILE]
`, exitCode: 1 };
  let { headers: i10, data: h17, error: u11 } = await g16(o9, n23);
  if (u11) return u11;
  if (!i10.includes(t6)) return { stdout: "", stderr: `xan pivot: column '${t6}' not found
`, exitCode: 1 };
  let p17 = s9.match(/^(\w+)\((\w+)\)$/);
  if (!p17) return { stdout: "", stderr: `xan pivot: invalid aggregation expression '${s9}'
`, exitCode: 1 };
  let [, l8, f11] = p17;
  r8.length === 0 && (r8 = i10.filter((y18) => y18 !== t6 && y18 !== f11));
  let c15 = [];
  for (let y18 of h17) {
    let x23 = String(y18[t6] ?? "");
    c15.includes(x23) || c15.push(x23);
  }
  let a7 = /* @__PURE__ */ new Map(), d16 = [];
  for (let y18 of h17) {
    let x23 = r8.map((A14) => String(y18[A14] ?? "")).join("\0"), I18 = String(y18[t6] ?? ""), N15 = y18[f11];
    a7.has(x23) || (a7.set(x23, /* @__PURE__ */ new Map()), d16.push(x23));
    let C19 = a7.get(x23);
    C19 && (C19.has(I18) || C19.set(I18, []), C19.get(I18)?.push(N15));
  }
  let m25 = [...r8, ...c15], g18 = [];
  for (let y18 of d16) {
    let x23 = y18.split("\0"), I18 = a7.get(y18);
    if (!I18) continue;
    let N15 = j9();
    for (let C19 = 0; C19 < r8.length; C19++) S12(N15, r8[C19], x23[C19]);
    for (let C19 of c15) {
      let A14 = I18.get(C19) || [];
      S12(N15, C19, ot5(l8, A14));
    }
    g18.push(N15);
  }
  return { stdout: R9(m25, g18), stderr: "", exitCode: 0 };
}
function ot5(e7, n23) {
  let t6 = n23.filter((s9) => s9 != null).map((s9) => typeof s9 == "number" ? s9 : Number.parseFloat(String(s9))).filter((s9) => !Number.isNaN(s9));
  switch (e7) {
    case "count":
      return n23.length;
    case "sum":
      return t6.reduce((s9, r8) => s9 + r8, 0);
    case "mean":
    case "avg":
      return t6.length > 0 ? t6.reduce((s9, r8) => s9 + r8, 0) / t6.length : null;
    case "min":
      return t6.length > 0 ? Math.min(...t6) : null;
    case "max":
      return t6.length > 0 ? Math.max(...t6) : null;
    case "first":
      return n23.length > 0 ? String(n23[0] ?? "") : null;
    case "last":
      return n23.length > 0 ? String(n23[n23.length - 1] ?? "") : null;
    default:
      return null;
  }
}
async function Re6(e7, n23) {
  let t6 = "", s9 = [];
  for (let h17 = 0; h17 < e7.length; h17++) {
    let u11 = e7[h17];
    (u11 === "-s" || u11 === "--sort") && h17 + 1 < e7.length ? t6 = e7[++h17] : u11.startsWith("-") || s9.push(u11);
  }
  if (s9.length < 2) return { stdout: "", stderr: `xan merge: usage: xan merge [OPTIONS] FILE1 FILE2 ...
`, exitCode: 1 };
  let r8 = [], o9 = null;
  for (let h17 of s9) {
    let u11 = await g16([h17], n23);
    if (u11.error) return u11.error;
    if (o9 === null) o9 = u11.headers;
    else if (JSON.stringify(o9) !== JSON.stringify(u11.headers)) return { stdout: "", stderr: `xan merge: all files must have the same headers
`, exitCode: 1 };
    r8.push({ headers: u11.headers, data: u11.data });
  }
  if (!o9) return { stdout: "", stderr: "", exitCode: 0 };
  let i10 = [];
  for (let { data: h17 } of r8) i10 = i10.concat(h17);
  if (t6) {
    if (!o9.includes(t6)) return { stdout: "", stderr: `xan merge: column '${t6}' not found
`, exitCode: 1 };
    i10.sort((h17, u11) => {
      let p17 = h17[t6], l8 = u11[t6], f11 = typeof p17 == "number" ? p17 : Number.parseFloat(String(p17)), c15 = typeof l8 == "number" ? l8 : Number.parseFloat(String(l8));
      return !Number.isNaN(f11) && !Number.isNaN(c15) ? f11 - c15 : String(p17 ?? "").localeCompare(String(l8 ?? ""));
    });
  }
  return { stdout: R9(o9, i10), stderr: "", exitCode: 0 };
}
async function Me6(e7, n23) {
  let t6 = e7.filter((u11) => !u11.startsWith("-")), { headers: s9, data: r8, error: o9 } = await g16(t6, n23);
  return o9 || (r8.length === 0 ? { stdout: "", stderr: "", exitCode: 0 } : { stdout: r8.map((u11) => s9.map((p17) => u11[p17])).map((u11) => u11.map((p17) => it5(p17)).join(",")).join(`
`) + `
`, stderr: "", exitCode: 0 });
}
function it5(e7) {
  if (e7 == null) return "";
  let n23 = String(e7);
  return n23.includes(",") || n23.includes('"') || n23.includes(`
`) ? `"${n23.replace(/"/g, '""')}"` : n23;
}
async function $e6(e7, n23) {
  let t6 = null, s9 = null, r8 = [];
  for (let c15 = 0; c15 < e7.length; c15++) {
    let a7 = e7[c15];
    if (a7 === "--seed" && c15 + 1 < e7.length) s9 = Number.parseInt(e7[++c15], 10);
    else if (!a7.startsWith("-")) {
      let d16 = Number.parseInt(a7, 10);
      t6 === null && !Number.isNaN(d16) && d16 > 0 ? t6 = d16 : r8.push(a7);
    }
  }
  if (t6 === null) return { stdout: "", stderr: `xan sample: usage: xan sample <sample-size> [FILE]
`, exitCode: 1 };
  let { headers: o9, data: i10, error: h17 } = await g16(r8, n23);
  if (h17) return h17;
  if (i10.length <= t6) return { stdout: R9(o9, i10), stderr: "", exitCode: 0 };
  let u11 = s9 !== null ? s9 : Date.now(), p17 = () => (u11 = u11 * 1103515245 + 12345 & 2147483647, u11 / 2147483647), l8 = i10.map((c15, a7) => a7);
  for (let c15 = l8.length - 1; c15 > 0; c15--) {
    let a7 = Math.floor(p17() * (c15 + 1));
    [l8[c15], l8[a7]] = [l8[a7], l8[c15]];
  }
  let f11 = l8.slice(0, t6).sort((c15, a7) => c15 - a7).map((c15) => i10[c15]);
  return { stdout: R9(o9, f11), stderr: "", exitCode: 0 };
}
async function Te5(e7, n23) {
  let t6 = false, s9 = [];
  for (let u11 = 0; u11 < e7.length; u11++) {
    let p17 = e7[u11];
    p17 === "-p" || p17 === "--pad" ? t6 = true : p17.startsWith("-") || s9.push(p17);
  }
  if (s9.length === 0) return { stdout: "", stderr: `xan cat: no files specified
`, exitCode: 1 };
  let r8 = await y3(n23, s9, { cmdName: "xan cat", stopOnError: true });
  if (r8.exitCode !== 0) return { stdout: "", stderr: r8.stderr, exitCode: r8.exitCode };
  let o9 = [], i10 = [];
  for (let { content: u11 } of r8.files) {
    let { headers: p17, data: l8 } = b23(u11);
    o9.push({ headers: p17, data: l8 });
    for (let f11 of p17) i10.includes(f11) || i10.push(f11);
  }
  if (!t6) {
    let u11 = JSON.stringify(o9[0].headers);
    for (let p17 = 1; p17 < o9.length; p17++) if (JSON.stringify(o9[p17].headers) !== u11) return { stdout: "", stderr: `xan cat: headers do not match (use -p to pad)
`, exitCode: 1 };
    i10 = o9[0].headers;
  }
  let h17 = [];
  for (let { headers: u11, data: p17 } of o9) for (let l8 of p17) {
    let f11 = j9();
    for (let c15 of i10) S12(f11, c15, u11.includes(c15) ? l8[c15] : "");
    h17.push(f11);
  }
  return { stdout: R9(i10, h17), stderr: "", exitCode: 0 };
}
async function je7(e7, n23) {
  let t6 = "", s9 = [], r8 = false, o9 = false, i10 = [];
  for (let a7 = 0; a7 < e7.length; a7++) {
    let d16 = e7[a7];
    (d16 === "-s" || d16 === "--select") && a7 + 1 < e7.length ? s9 = e7[++a7].split(",") : d16 === "-v" || d16 === "--invert" ? r8 = true : d16 === "-i" || d16 === "--ignore-case" ? o9 = true : d16 === "-r" || d16 === "--regex" || d16.startsWith("-") || (t6 ? i10.push(d16) : t6 = d16);
  }
  if (!t6) return { stdout: "", stderr: `xan search: no pattern specified
`, exitCode: 1 };
  let { headers: h17, data: u11, error: p17 } = await g16(i10, n23);
  if (p17) return p17;
  let l8 = s9.length > 0 ? s9 : h17, f11;
  try {
    f11 = b1(t6, o9 ? "i" : "");
  } catch {
    return { stdout: "", stderr: `xan search: invalid regex pattern '${t6}'
`, exitCode: 1 };
  }
  let c15 = u11.filter((a7) => {
    let d16 = l8.some((m25) => {
      let g18 = a7[m25];
      return g18 != null && f11.test(String(g18));
    });
    return r8 ? !d16 : d16;
  });
  return { stdout: R9(h17, c15), stderr: "", exitCode: 0 };
}
async function De5(e7, n23) {
  let t6 = "", s9 = [];
  for (let c15 of e7) c15.startsWith("-") || (t6 ? s9.push(c15) : t6 = c15);
  if (!t6) return { stdout: "", stderr: `xan flatmap: no expression specified
`, exitCode: 1 };
  let { headers: r8, data: o9, error: i10 } = await g16(s9, n23);
  if (i10) return i10;
  let u11 = V11(t6).map(({ expr: c15, name: a7 }) => ({ alias: typeof a7 == "string" ? a7 : a7[0], ast: O14(c15) })), p17 = { limits: n23.limits ? { maxIterations: n23.limits.maxJqIterations } : void 0 }, l8 = [...r8, ...u11.map((c15) => c15.alias)], f11 = [];
  for (let c15 of o9) {
    let a7 = [], d16 = 1;
    for (let m25 of u11) {
      let g18 = d11(c15, m25.ast, p17), y18 = g18.length > 0 && Array.isArray(g18[0]) ? g18[0] : g18;
      a7.push(y18), d16 = Math.max(d16, y18.length);
    }
    for (let m25 = 0; m25 < d16; m25++) {
      let g18 = C18(c15);
      for (let y18 = 0; y18 < u11.length; y18++) {
        let x23 = a7[y18][m25] ?? null;
        S12(g18, u11[y18].alias, x23);
      }
      f11.push(g18);
    }
  }
  return { stdout: R9(l8, f11), stderr: "", exitCode: 0 };
}
async function Ve6(e7, n23) {
  let { cmdView: t6 } = await Promise.resolve().then(() => (init_xan_view_ECQUO7AJ(), xan_view_ECQUO7AJ_exports));
  return t6(e7, n23);
}
var q14, _e6, He6, R10, J12, U13, B10, tt5, me5, Ye5, at6, Xe5, lt6, cn2, pn3;
var init_chunk_JI3KJ32H = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-JI3KJ32H.js"() {
    init_chunk_F55TLFGB();
    init_chunk_SYMJJMQ4();
    init_chunk_FRDGR5VK();
    init_chunk_7MKBHGLS();
    init_chunk_YNYSPYQ5();
    init_chunk_7L36YK2X();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
    _e6 = n18(() => {
      "use strict";
      q14 = class {
        input;
        pos = 0;
        tokens = [];
        constructor(n23) {
          this.input = n23;
        }
        tokenize() {
          for (; this.pos < this.input.length && (this.skipWhitespace(), !(this.pos >= this.input.length)); ) {
            let n23 = this.nextToken();
            n23 && this.tokens.push(n23);
          }
          return this.tokens.push({ type: "eof", value: "", pos: this.pos }), this.tokens;
        }
        skipWhitespace() {
          for (; this.pos < this.input.length; ) {
            let n23 = this.input[this.pos];
            if (n23 === " " || n23 === "	" || n23 === `
` || n23 === "\r") this.pos++;
            else if (n23 === "#") for (; this.pos < this.input.length && this.input[this.pos] !== `
`; ) this.pos++;
            else break;
          }
        }
        nextToken() {
          let n23 = this.pos, t6 = this.input[this.pos];
          if (t6 >= "0" && t6 <= "9") return this.readNumber();
          if (t6 === '"' || t6 === "'" || t6 === "`") return this.readString(t6);
          if (t6 === "b" && this.pos + 1 < this.input.length) {
            let o9 = this.input[this.pos + 1];
            if (o9 === '"' || o9 === "'" || o9 === "`") return this.pos++, this.readString(o9);
          }
          if (t6 === "/") {
            let o9 = this.tokens[this.tokens.length - 1];
            return o9 && (o9.type === "int" || o9.type === "float" || o9.type === "string" || o9.type === "ident" || o9.type === ")" || o9.type === "]") ? this.input[this.pos + 1] === "/" ? (this.pos += 2, { type: "//", value: "//", pos: n23 }) : (this.pos++, { type: "/", value: "/", pos: n23 }) : this.readRegex();
          }
          if (this.match("not in")) return { type: "not in", value: "not in", pos: n23 };
          if (this.match("=>")) return { type: "=>", value: "=>", pos: n23 };
          if (this.match("**")) return { type: "**", value: "**", pos: n23 };
          if (this.match("++")) return { type: "++", value: "++", pos: n23 };
          if (this.match("//")) return { type: "//", value: "//", pos: n23 };
          if (this.match("==")) return { type: "==", value: "==", pos: n23 };
          if (this.match("!=")) return { type: "!=", value: "!=", pos: n23 };
          if (this.match("<=")) return { type: "<=", value: "<=", pos: n23 };
          if (this.match(">=")) return { type: ">=", value: ">=", pos: n23 };
          if (this.match("&&")) return { type: "&&", value: "&&", pos: n23 };
          if (this.match("||")) return { type: "||", value: "||", pos: n23 };
          let r8 = (/* @__PURE__ */ new Map([["(", "("], [")", ")"], ["[", "["], ["]", "]"], ["{", "{"], ["}", "}"], [",", ","], [":", ":"], [";", ";"], ["+", "+"], ["-", "-"], ["*", "*"], ["%", "%"], ["<", "<"], [">", ">"], ["!", "!"], [".", "."], ["|", "|"], ["=", "="]])).get(t6);
          if (r8 !== void 0) return this.pos++, { type: r8, value: t6, pos: n23 };
          if (this.isIdentStart(t6)) return this.readIdentifier();
          throw new Error(`Unexpected character '${t6}' at position ${this.pos}`);
        }
        match(n23) {
          if (this.input.slice(this.pos, this.pos + n23.length) === n23) {
            if (/^[a-zA-Z]/.test(n23)) {
              let t6 = this.input[this.pos + n23.length];
              if (t6 && this.isIdentChar(t6)) return false;
            }
            return this.pos += n23.length, true;
          }
          return false;
        }
        isIdentStart(n23) {
          return n23 >= "a" && n23 <= "z" || n23 >= "A" && n23 <= "Z" || n23 === "_";
        }
        isIdentChar(n23) {
          return this.isIdentStart(n23) || n23 >= "0" && n23 <= "9";
        }
        readNumber() {
          let n23 = this.pos, t6 = false, s9 = false;
          for (; this.pos < this.input.length; ) {
            let o9 = this.input[this.pos];
            if (o9 >= "0" && o9 <= "9") this.pos++;
            else if (o9 === "_") this.pos++;
            else if (o9 === "." && !t6 && !s9) t6 = true, this.pos++;
            else if ((o9 === "e" || o9 === "E") && !s9) s9 = true, t6 = true, this.pos++, this.pos < this.input.length && (this.input[this.pos] === "+" || this.input[this.pos] === "-") && this.pos++;
            else break;
          }
          let r8 = this.input.slice(n23, this.pos).replace(/_/g, "");
          return { type: t6 ? "float" : "int", value: r8, pos: n23 };
        }
        readString(n23) {
          let t6 = this.pos;
          this.pos++;
          let s9 = "";
          for (; this.pos < this.input.length; ) {
            let r8 = this.input[this.pos];
            if (r8 === n23) return this.pos++, { type: "string", value: s9, pos: t6 };
            if (r8 === "\\") {
              if (this.pos++, this.pos < this.input.length) {
                let o9 = this.input[this.pos];
                switch (o9) {
                  case "n":
                    s9 += `
`;
                    break;
                  case "r":
                    s9 += "\r";
                    break;
                  case "t":
                    s9 += "	";
                    break;
                  case "\\":
                    s9 += "\\";
                    break;
                  case '"':
                    s9 += '"';
                    break;
                  case "'":
                    s9 += "'";
                    break;
                  case "`":
                    s9 += "`";
                    break;
                  case "0":
                    s9 += "\0";
                    break;
                  default:
                    s9 += o9;
                }
                this.pos++;
              }
            } else s9 += r8, this.pos++;
          }
          throw new Error(`Unterminated string starting at position ${t6}`);
        }
        readRegex() {
          let n23 = this.pos;
          this.pos++;
          let t6 = "", s9 = "";
          for (; this.pos < this.input.length; ) {
            let r8 = this.input[this.pos];
            if (r8 === "/") {
              for (this.pos++; this.pos < this.input.length && this.input[this.pos] === "i"; ) s9 += this.input[this.pos], this.pos++;
              return { type: "regex", value: t6 + (s9 ? `/${s9}` : ""), pos: n23 };
            }
            r8 === "\\" ? (t6 += r8, this.pos++, this.pos < this.input.length && (t6 += this.input[this.pos], this.pos++)) : (t6 += r8, this.pos++);
          }
          throw new Error(`Unterminated regex starting at position ${n23}`);
        }
        readIdentifier() {
          let n23 = this.pos;
          for (; this.pos < this.input.length && this.isIdentChar(this.input[this.pos]); ) this.pos++;
          let t6 = false;
          this.pos < this.input.length && this.input[this.pos] === "?" && (t6 = true, this.pos++);
          let s9 = this.input.slice(n23, t6 ? this.pos - 1 : this.pos);
          t6 && (s9 += "?");
          let r8 = /* @__PURE__ */ new Map([["true", "true"], ["false", "false"], ["null", "null"], ["and", "and"], ["or", "or"], ["eq", "eq"], ["ne", "ne"], ["lt", "lt"], ["le", "le"], ["gt", "gt"], ["ge", "ge"], ["in", "in"], ["as", "as"], ["_", "_"]]), o9 = s9.replace(/\?$/, ""), i10 = r8.get(o9);
          return i10 !== void 0 && !t6 ? { type: i10, value: o9, pos: n23 } : { type: "ident", value: s9, pos: n23 };
        }
      };
    });
    He6 = {};
    p3(He6, { parseMoonblade: () => _11, parseNamedExpressions: () => V11 });
    U13 = n18(() => {
      "use strict";
      _e6();
      R10 = { PIPE: 1, OR: 2, AND: 3, EQUALITY: 4, COMPARISON: 5, ADDITIVE: 6, MULTIPLICATIVE: 7, POWER: 8, UNARY: 9, POSTFIX: 10 }, J12 = class {
        pos = 0;
        tokens;
        constructor(n23) {
          this.tokens = n23;
        }
        parse() {
          let n23 = this.parseExpr(0);
          if (this.peek().type !== "eof") throw new Error(`Unexpected token: ${this.peek().value}`);
          return n23;
        }
        parseExpr(n23) {
          let t6 = this.parsePrefix();
          for (; ; ) {
            let s9 = this.peek(), r8 = this.getInfixPrec(s9.type);
            if (r8 < n23) break;
            t6 = this.parseInfix(t6, r8);
          }
          return t6;
        }
        parsePrefix() {
          let n23 = this.peek();
          switch (n23.type) {
            case "int":
              return this.advance(), { type: "int", value: Number.parseInt(n23.value, 10) };
            case "float":
              return this.advance(), { type: "float", value: Number.parseFloat(n23.value) };
            case "string":
              return this.advance(), { type: "string", value: n23.value };
            case "regex": {
              this.advance();
              let t6 = n23.value.split("/"), s9 = t6.length > 1 ? t6[t6.length - 1] : "";
              return { type: "regex", pattern: t6.slice(0, -1).join("/") || n23.value, caseInsensitive: s9.includes("i") };
            }
            case "true":
              return this.advance(), { type: "bool", value: true };
            case "false":
              return this.advance(), { type: "bool", value: false };
            case "null":
              return this.advance(), { type: "null" };
            case "_":
              return this.advance(), { type: "underscore" };
            case "ident": {
              let t6 = n23.value, s9 = t6.endsWith("?"), r8 = s9 ? t6.slice(0, -1) : t6;
              if (this.advance(), this.peek().type === "(") return this.parseFunctionCall(r8);
              if (this.peek().type === "=>") {
                this.advance();
                let o9 = this.parseExpr(0);
                return this.bindLambdaArgs({ type: "lambda", params: [r8], body: o9 }, [r8]);
              }
              return { type: "identifier", name: r8, unsure: s9 };
            }
            case "(": {
              this.advance();
              let t6 = [];
              if (this.peek().type === ")") {
                if (this.advance(), this.peek().type === "=>") {
                  this.advance();
                  let r8 = this.parseExpr(0);
                  return { type: "lambda", params: [], body: r8 };
                }
                throw new Error("Empty parentheses not allowed");
              }
              if (this.peek().type === "ident") {
                let r8 = this.peek().value;
                if (this.advance(), this.peek().type === "," || this.peek().type === ")") {
                  for (t6.push(r8); this.peek().type === "," && (this.advance(), this.peek().type === "ident"); ) t6.push(this.peek().value), this.advance();
                  if (this.peek().type === ")" && (this.advance(), this.peek().type === "=>")) {
                    this.advance();
                    let o9 = this.parseExpr(0);
                    return this.bindLambdaArgs({ type: "lambda", params: t6, body: o9 }, t6);
                  }
                  this.pos -= t6.length * 2, t6.length > 1 && (this.pos = this.pos);
                }
                this.pos--;
              }
              let s9 = this.parseExpr(0);
              return this.expect(")"), this.peek().type, s9;
            }
            case "[":
              return this.parseList();
            case "{":
              return this.parseMap();
            case "-": {
              this.advance();
              let t6 = this.parseExpr(R10.UNARY);
              return t6.type === "int" ? { type: "int", value: -t6.value } : t6.type === "float" ? { type: "float", value: -t6.value } : { type: "func", name: "neg", args: [{ expr: t6 }] };
            }
            case "!":
              return this.advance(), { type: "func", name: "not", args: [{ expr: this.parseExpr(R10.UNARY) }] };
            default:
              throw new Error(`Unexpected token: ${n23.type} (${n23.value})`);
          }
        }
        parseFunctionCall(n23) {
          this.expect("(");
          let t6 = [];
          if (this.peek().type !== ")") do {
            t6.length > 0 && this.peek().type === "," && this.advance();
            let s9;
            if (this.peek().type === "ident") {
              let o9 = this.peek().value, i10 = this.pos + 1;
              i10 < this.tokens.length && this.tokens[i10].type === "=" && (s9 = o9, this.advance(), this.advance());
            }
            let r8 = this.parseExpr(0);
            t6.push({ name: s9, expr: r8 });
          } while (this.peek().type === ",");
          return this.expect(")"), { type: "func", name: n23.toLowerCase(), args: t6 };
        }
        parseList() {
          this.expect("[");
          let n23 = [];
          if (this.peek().type !== "]") do
            n23.length > 0 && this.peek().type === "," && this.advance(), n23.push(this.parseExpr(0));
          while (this.peek().type === ",");
          return this.expect("]"), { type: "list", elements: n23 };
        }
        parseMap() {
          this.expect("{");
          let n23 = [];
          if (this.peek().type !== "}") do {
            n23.length > 0 && this.peek().type === "," && this.advance();
            let t6;
            if (this.peek().type === "ident") t6 = this.peek().value, this.advance();
            else if (this.peek().type === "string") t6 = this.peek().value, this.advance();
            else throw new Error(`Expected map key, got ${this.peek().type}`);
            this.expect(":");
            let s9 = this.parseExpr(0);
            n23.push({ key: t6, value: s9 });
          } while (this.peek().type === ",");
          return this.expect("}"), { type: "map", entries: n23 };
        }
        parseInfix(n23, t6) {
          let s9 = this.peek(), o9 = (/* @__PURE__ */ new Map([["+", "add"], ["-", "sub"], ["*", "mul"], ["/", "div"], ["//", "idiv"], ["%", "mod"], ["**", "pow"], ["++", "concat"], ["==", "=="], ["!=", "!="], ["<", "<"], ["<=", "<="], [">", ">"], [">=", ">="], ["eq", "eq"], ["ne", "ne"], ["lt", "lt"], ["le", "le"], ["gt", "gt"], ["ge", "ge"], ["&&", "and"], ["and", "and"], ["||", "or"], ["or", "or"]])).get(s9.type);
          if (o9 !== void 0) {
            this.advance();
            let i10 = this.parseExpr(t6 + (this.isRightAssoc(s9.type) ? 0 : 1));
            return { type: "func", name: o9, args: [{ expr: n23 }, { expr: i10 }] };
          }
          if (s9.type === "|") {
            this.advance();
            let i10 = this.parseExpr(t6);
            return this.handlePipe(n23, i10);
          }
          if (s9.type === ".") return this.advance(), this.handleDot(n23);
          if (s9.type === "[") return this.advance(), this.handleIndexing(n23);
          if (s9.type === "in") return this.advance(), { type: "func", name: "contains", args: [{ expr: this.parseExpr(t6 + 1) }, { expr: n23 }] };
          if (s9.type === "not in") return this.advance(), { type: "func", name: "not", args: [{ expr: { type: "func", name: "contains", args: [{ expr: this.parseExpr(t6 + 1) }, { expr: n23 }] } }] };
          throw new Error(`Unexpected infix token: ${s9.type}`);
        }
        handlePipe(n23, t6) {
          if (t6.type === "identifier") return { type: "func", name: t6.name, args: [{ expr: n23 }] };
          if (t6.type === "func") {
            let s9 = this.countUnderscores(t6);
            return s9 === 0 ? t6 : s9 === 1 ? this.fillUnderscore(t6, n23) : { type: "pipeline", exprs: [n23, t6] };
          }
          return this.countUnderscores(t6) === 1 ? this.fillUnderscore(t6, n23) : t6;
        }
        handleDot(n23) {
          let t6 = this.peek();
          if (t6.type === "ident") {
            let s9 = t6.value;
            if (this.advance(), this.peek().type === "(") {
              let r8 = this.parseFunctionCall(s9);
              return r8.type === "func" && r8.args.unshift({ expr: n23 }), r8;
            }
            return { type: "func", name: "get", args: [{ expr: n23 }, { expr: { type: "string", value: s9 } }] };
          }
          if (t6.type === "int") {
            let s9 = Number.parseInt(t6.value, 10);
            return this.advance(), { type: "func", name: "get", args: [{ expr: n23 }, { expr: { type: "int", value: s9 } }] };
          }
          if (t6.type === "string") {
            let s9 = t6.value;
            return this.advance(), { type: "func", name: "get", args: [{ expr: n23 }, { expr: { type: "string", value: s9 } }] };
          }
          throw new Error(`Expected identifier, number, or string after dot, got ${t6.type}`);
        }
        handleIndexing(n23) {
          if (this.peek().type === ":") {
            if (this.advance(), this.peek().type === "]") return this.advance(), { type: "func", name: "slice", args: [{ expr: n23 }] };
            let s9 = this.parseExpr(0);
            return this.expect("]"), { type: "func", name: "slice", args: [{ expr: n23 }, { expr: { type: "int", value: 0 } }, { expr: s9 }] };
          }
          let t6 = this.parseExpr(0);
          if (this.peek().type === ":") {
            if (this.advance(), this.peek().type === "]") return this.advance(), { type: "func", name: "slice", args: [{ expr: n23 }, { expr: t6 }] };
            let s9 = this.parseExpr(0);
            return this.expect("]"), { type: "func", name: "slice", args: [{ expr: n23 }, { expr: t6 }, { expr: s9 }] };
          }
          return this.expect("]"), { type: "func", name: "get", args: [{ expr: n23 }, { expr: t6 }] };
        }
        countUnderscores(n23) {
          return n23.type === "underscore" ? 1 : n23.type === "func" ? n23.args.reduce((t6, s9) => t6 + this.countUnderscores(s9.expr), 0) : n23.type === "list" ? n23.elements.reduce((t6, s9) => t6 + this.countUnderscores(s9), 0) : n23.type === "map" ? n23.entries.reduce((t6, s9) => t6 + this.countUnderscores(s9.value), 0) : 0;
        }
        fillUnderscore(n23, t6) {
          return n23.type === "underscore" ? t6 : n23.type === "func" ? { ...n23, args: n23.args.map((s9) => ({ ...s9, expr: this.fillUnderscore(s9.expr, t6) })) } : n23.type === "list" ? { ...n23, elements: n23.elements.map((s9) => this.fillUnderscore(s9, t6)) } : n23.type === "map" ? { ...n23, entries: n23.entries.map((s9) => ({ ...s9, value: this.fillUnderscore(s9.value, t6) })) } : n23;
        }
        bindLambdaArgs(n23, t6) {
          return { ...n23, body: this.bindLambdaArgsInExpr(n23.body, t6) };
        }
        bindLambdaArgsInExpr(n23, t6) {
          return n23.type === "identifier" && t6.includes(n23.name) ? { type: "lambdaBinding", name: n23.name } : n23.type === "func" ? { ...n23, args: n23.args.map((s9) => ({ ...s9, expr: this.bindLambdaArgsInExpr(s9.expr, t6) })) } : n23.type === "list" ? { ...n23, elements: n23.elements.map((s9) => this.bindLambdaArgsInExpr(s9, t6)) } : n23.type === "map" ? { ...n23, entries: n23.entries.map((s9) => ({ ...s9, value: this.bindLambdaArgsInExpr(s9.value, t6) })) } : n23;
        }
        getInfixPrec(n23) {
          switch (n23) {
            case "|":
              return R10.PIPE;
            case "||":
            case "or":
              return R10.OR;
            case "&&":
            case "and":
              return R10.AND;
            case "==":
            case "!=":
            case "eq":
            case "ne":
              return R10.EQUALITY;
            case "<":
            case "<=":
            case ">":
            case ">=":
            case "lt":
            case "le":
            case "gt":
            case "ge":
            case "in":
            case "not in":
              return R10.COMPARISON;
            case "+":
            case "-":
            case "++":
              return R10.ADDITIVE;
            case "*":
            case "/":
            case "//":
            case "%":
              return R10.MULTIPLICATIVE;
            case "**":
              return R10.POWER;
            case ".":
            case "[":
              return R10.POSTFIX;
            default:
              return -1;
          }
        }
        isRightAssoc(n23) {
          return n23 === "**";
        }
        peek() {
          return this.tokens[this.pos] || { type: "eof", value: "", pos: 0 };
        }
        advance() {
          return this.tokens[this.pos++];
        }
        expect(n23) {
          let t6 = this.peek();
          if (t6.type !== n23) throw new Error(`Expected ${n23}, got ${t6.type}`);
          return this.advance();
        }
      };
    });
    U13();
    B10 = { add: (e7) => S13("+", e7[0], e7[1]), sub: (e7) => S13("-", e7[0], e7[1]), mul: (e7) => S13("*", e7[0], e7[1]), div: (e7) => S13("/", e7[0], e7[1]), mod: (e7) => S13("%", e7[0], e7[1]), idiv: (e7) => k13("floor", [S13("/", e7[0], e7[1])]), pow: (e7) => E9("pow", e7), neg: (e7) => ({ type: "UnaryOp", op: "-", operand: e7[0] }), "==": (e7) => S13("==", e7[0], e7[1]), "!=": (e7) => S13("!=", e7[0], e7[1]), "<": (e7) => S13("<", e7[0], e7[1]), "<=": (e7) => S13("<=", e7[0], e7[1]), ">": (e7) => S13(">", e7[0], e7[1]), ">=": (e7) => S13(">=", e7[0], e7[1]), eq: (e7) => S13("==", P16(e7[0]), P16(e7[1])), ne: (e7) => S13("!=", P16(e7[0]), P16(e7[1])), lt: (e7) => S13("<", P16(e7[0]), P16(e7[1])), le: (e7) => S13("<=", P16(e7[0]), P16(e7[1])), gt: (e7) => S13(">", P16(e7[0]), P16(e7[1])), ge: (e7) => S13(">=", P16(e7[0]), P16(e7[1])), and: (e7) => S13("and", e7[0], e7[1]), or: (e7) => S13("or", e7[0], e7[1]), not: (e7) => ({ type: "UnaryOp", op: "not", operand: e7[0] }), len: (e7) => E9("length", e7), length: (e7) => E9("length", e7), upper: (e7) => E9("ascii_upcase", e7), lower: (e7) => E9("ascii_downcase", e7), trim: (e7) => E9("trim", e7), ltrim: (e7) => e7.length === 0 ? k13("ltrimstr", [{ type: "Literal", value: " " }]) : { type: "Pipe", left: e7[0], right: k13("ltrimstr", [{ type: "Literal", value: " " }]) }, rtrim: (e7) => e7.length === 0 ? k13("rtrimstr", [{ type: "Literal", value: " " }]) : { type: "Pipe", left: e7[0], right: k13("rtrimstr", [{ type: "Literal", value: " " }]) }, split: (e7) => E9("split", e7), join: (e7) => e7.length === 1 ? k13("join", [{ type: "Literal", value: "" }]) : E9("join", e7), concat: (e7) => S13("+", e7[0], e7[1]), startswith: (e7) => E9("startswith", e7), endswith: (e7) => E9("endswith", e7), contains: (e7) => E9("contains", e7), replace: (e7) => E9("gsub", e7), substr: (e7) => e7.length === 2 ? { type: "Slice", base: e7[0], start: e7[1] } : { type: "Slice", base: e7[0], start: e7[1], end: S13("+", e7[1], e7[2]) }, abs: (e7) => E9("fabs", e7), floor: (e7) => E9("floor", e7), ceil: (e7) => E9("ceil", e7), round: (e7) => E9("round", e7), sqrt: (e7) => E9("sqrt", e7), log: (e7) => E9("log", e7), log10: (e7) => E9("log10", e7), log2: (e7) => E9("log2", e7), exp: (e7) => E9("exp", e7), sin: (e7) => E9("sin", e7), cos: (e7) => E9("cos", e7), tan: (e7) => E9("tan", e7), asin: (e7) => E9("asin", e7), acos: (e7) => E9("acos", e7), atan: (e7) => E9("atan", e7), min: (e7) => E9("min", e7), max: (e7) => E9("max", e7), first: (e7) => e7.length === 0 ? { type: "Index", index: { type: "Literal", value: 0 } } : { type: "Index", index: { type: "Literal", value: 0 }, base: e7[0] }, last: (e7) => e7.length === 0 ? { type: "Index", index: { type: "Literal", value: -1 } } : { type: "Index", index: { type: "Literal", value: -1 }, base: e7[0] }, get: (e7) => e7.length === 1 ? { type: "Index", index: e7[0] } : { type: "Index", index: e7[1], base: e7[0] }, slice: (e7) => e7.length === 1 ? { type: "Slice", base: e7[0] } : e7.length === 2 ? { type: "Slice", base: e7[0], start: e7[1] } : { type: "Slice", base: e7[0], start: e7[1], end: e7[2] }, keys: "keys", values: "values", entries: (e7) => k13("to_entries", e7), from_entries: "from_entries", reverse: "reverse", sort: "sort", sort_by: "sort_by", group_by: "group_by", unique: "unique", unique_by: "unique_by", flatten: "flatten", map: (e7) => ({ type: "Pipe", left: e7[0], right: { type: "Array", elements: e7[1] } }), select: (e7) => k13("select", e7), empty: () => k13("empty", []), count: () => k13("length", []), sum: (e7) => e7.length === 0 ? k13("add", []) : { type: "Pipe", left: { type: "Array", elements: e7[0] }, right: k13("add", []) }, mean: (e7) => e7.length === 0 ? { type: "Pipe", left: { type: "Identity" }, right: S13("/", k13("add", []), k13("length", [])) } : { type: "Pipe", left: { type: "Array", elements: e7[0] }, right: S13("/", k13("add", []), k13("length", [])) }, avg: (e7) => e7.length === 0 ? { type: "Pipe", left: { type: "Identity" }, right: S13("/", k13("add", []), k13("length", [])) } : { type: "Pipe", left: { type: "Array", elements: e7[0] }, right: S13("/", k13("add", []), k13("length", [])) }, type: "type", isnull: (e7) => e7.length === 0 ? S13("==", { type: "Identity" }, { type: "Literal", value: null }) : S13("==", e7[0], { type: "Literal", value: null }), isempty: (e7) => e7.length === 0 ? S13("==", { type: "Identity" }, { type: "Literal", value: "" }) : S13("==", e7[0], { type: "Literal", value: "" }), tonumber: (e7) => e7.length === 0 ? k13("tonumber", []) : k13("tonumber", e7), tostring: (e7) => e7.length === 0 ? k13("tostring", []) : k13("tostring", e7), if: (e7) => Je6(e7[0], e7[1], e7[2]), coalesce: (e7) => {
      if (e7.length === 0) return { type: "Literal", value: null };
      if (e7.length === 1) return e7[0];
      let [n23, ...t6] = e7, s9 = S13("and", S13("!=", n23, { type: "Literal", value: null }), S13("!=", n23, { type: "Literal", value: "" }));
      return Je6(s9, n23, t6.length === 1 ? t6[0] : B10.coalesce(t6));
    }, index: () => ({ type: "Field", name: "_row_index" }), now: () => k13("now", []), fmt: (e7) => k13("tostring", e7), format: (e7) => k13("tostring", e7) };
    tt5 = "then";
    U13();
    me5 = q3(xe7(), 1);
    U13();
    U13();
    Ye5 = /* @__PURE__ */ new Set(["fuzzy-join", "glob", "hist", "input", "parallel", "plot", "progress", "range", "scrape", "tokenize", "union-find"]);
    at6 = /* @__PURE__ */ new Set(["agg", "behead", "cat", "count", "dedup", "drop", "enum", "explode", "f", "filter", "fixlengths", "flatmap", "flatten", "fmt", "frequency", "freq", "from", "groupby", "head", "headers", "implode", "join", "map", "merge", "partition", "pivot", "rename", "reverse", "sample", "search", "select", "shuffle", "slice", "sort", "split", "stats", "tail", "to", "top", "transform", "transpose", "view", ...Ye5]);
    Xe5 = { name: "xan", summary: "CSV toolkit for data manipulation", usage: "xan <COMMAND> [OPTIONS] [FILE]", description: `xan is a collection of commands for working with CSV data.
It provides a simple, ergonomic interface for common data operations.

COMMANDS:
  Core:
    headers    Show column names
    count      Count rows
    head       Show first N rows
    tail       Show last N rows
    slice      Extract row range
    reverse    Reverse row order
    behead     Remove header row
    sample     Random sample of rows

  Column operations:
    select     Select columns (supports glob, ranges, negation)
    drop       Drop columns
    rename     Rename columns
    enum       Add row index column

  Row operations:
    filter     Filter rows by expression
    search     Filter rows by regex match
    sort       Sort rows
    dedup      Remove duplicates
    top        Get top N by column

  Transformations:
    map        Add computed columns
    transform  Modify existing columns
    explode    Split column into multiple rows
    implode    Combine rows, join column values
    flatmap    Map returning multiple rows
    pivot      Reshape rows into columns
    transpose  Swap rows and columns

  Aggregation:
    agg        Aggregate values
    groupby    Group and aggregate
    frequency  Count value occurrences
    stats      Show column statistics

  Multi-file:
    cat        Concatenate CSV files
    join       Join two CSV files on key
    merge      Merge sorted CSV files
    split      Split into multiple files
    partition  Split by column value

  Data conversion:
    to         Convert CSV to other formats (json)
    from       Convert other formats to CSV (json)
    shuffle    Randomly reorder rows
    fixlengths Fix ragged CSV files

  Output:
    view       Pretty print as table
    flatten    Display records vertically (alias: f)
    fmt        Format output

EXAMPLES:
  xan headers data.csv
  xan count data.csv
  xan head -n 5 data.csv
  xan select name,email data.csv
  xan select 'vec_*' data.csv          # glob pattern
  xan select 'a:c' data.csv            # column range
  xan filter 'age > 30' data.csv
  xan search -r '^foo' data.csv
  xan sort -N price data.csv
  xan agg 'sum(amount) as total' data.csv
  xan groupby region 'count() as n' data.csv
  xan explode tags data.csv
  xan join id file1.csv id file2.csv
  xan pivot year 'sum(sales)' data.csv`, options: ["    --help    display this help and exit"] };
    lt6 = { headers: { name: "xan headers", summary: "Show column names", usage: "xan headers [OPTIONS] [FILE]", description: "Display column names from a CSV file.", options: ["-j, --just-names    show names only (no index)"] }, count: { name: "xan count", summary: "Count rows", usage: "xan count [FILE]", description: "Count the number of data rows (excluding header).", options: [] }, filter: { name: "xan filter", summary: "Filter rows by expression", usage: "xan filter [OPTIONS] EXPR [FILE]", description: "Filter CSV rows using moonblade expressions.", options: ["-v, --invert    invert match", "-l, --limit N   limit output rows"] }, search: { name: "xan search", summary: "Filter rows by regex", usage: "xan search [OPTIONS] PATTERN [FILE]", description: "Filter CSV rows by regex match on columns.", options: ["-s, --select COLS   search only these columns", "-v, --invert        invert match", "-i, --ignore-case   case insensitive"] }, select: { name: "xan select", summary: "Select columns", usage: "xan select COLS [FILE]", description: "Select columns by name, index, glob, or range.", options: ["Supports: col names, indices (0,1), ranges (a:c), globs (vec_*), negation (!col)"] }, explode: { name: "xan explode", summary: "Split column into rows", usage: "xan explode COLUMN [OPTIONS] [FILE]", description: "Split delimited column values into multiple rows.", options: ["-s, --separator SEP  separator (default: |)", "--drop-empty         drop empty values", "-r, --rename NAME    rename column"] }, implode: { name: "xan implode", summary: "Combine rows", usage: "xan implode COLUMN [OPTIONS] [FILE]", description: "Combine consecutive rows, joining column values.", options: ["-s, --sep SEP        separator (default: |)", "-r, --rename NAME    rename column"] }, join: { name: "xan join", summary: "Join CSV files", usage: "xan join KEY1 FILE1 KEY2 FILE2 [OPTIONS]", description: "Join two CSV files on key columns.", options: ["--left               left outer join", "--right              right outer join", "--full               full outer join", "-D, --default VAL    default for missing"] }, pivot: { name: "xan pivot", summary: "Reshape to columns", usage: "xan pivot COLUMN AGG_EXPR [OPTIONS] [FILE]", description: "Turn row values into columns.", options: ["-g, --groupby COLS   group by columns"] } };
    cn2 = { name: "xan", async execute(e7, n23) {
      if (e7.length === 0 || o2(e7)) return s(Xe5);
      let t6 = e7[0], s9 = e7.slice(1);
      if (o2(s9)) {
        let r8 = lt6[t6];
        return r8 ? s(r8) : s(Xe5);
      }
      if (Ye5.has(t6)) return { stdout: "", stderr: `xan ${t6}: not yet implemented
`, exitCode: 1 };
      switch (t6) {
        case "headers":
          return ue9(s9, n23);
        case "count":
          return ce8(s9, n23);
        case "head":
          return pe7(s9, n23);
        case "tail":
          return fe9(s9, n23);
        case "slice":
          return de9(s9, n23);
        case "reverse":
          return he9(s9, n23);
        case "behead":
          return Me6(s9, n23);
        case "sample":
          return $e6(s9, n23);
        case "select":
          return oe7(s9, n23);
        case "drop":
          return ie5(s9, n23);
        case "rename":
          return ae7(s9, n23);
        case "enum":
          return le8(s9, n23);
        case "filter":
          return Se5(s9, n23);
        case "search":
          return je7(s9, n23);
        case "sort":
          return Ie6(s9, n23);
        case "dedup":
          return ke5(s9, n23);
        case "top":
          return Ne5(s9, n23);
        case "map":
          return Ee6(s9, n23);
        case "transform":
          return Ae7(s9, n23);
        case "explode":
          return Fe6(s9, n23);
        case "implode":
          return Oe5(s9, n23);
        case "flatmap":
          return De5(s9, n23);
        case "pivot":
          return Pe5(s9, n23);
        case "agg":
          return te9(s9, n23);
        case "groupby":
          return ne8(s9, n23);
        case "frequency":
        case "freq":
          return se7(s9, n23);
        case "stats":
          return re4(s9, n23);
        case "cat":
          return Te5(s9, n23);
        case "join":
          return Le6(s9, n23);
        case "merge":
          return Re6(s9, n23);
        case "split":
          return we5(s9, n23);
        case "partition":
          return ve6(s9, n23);
        case "to":
          return Ce4(s9, n23);
        case "from":
          return be6(s9, n23);
        case "transpose":
          return ge7(s9, n23);
        case "shuffle":
          return ye6(s9, n23);
        case "fixlengths":
          return xe9(s9, n23);
        case "view":
          return k12(s9, n23);
        case "flatten":
        case "f":
          return W11(s9, n23);
        case "fmt":
          return Ve6(s9, n23);
        default:
          return at6.has(t6) ? { stdout: "", stderr: `xan ${t6}: not yet implemented
`, exitCode: 1 } : { stdout: "", stderr: `xan: unknown command '${t6}'
Run 'xan --help' for usage.
`, exitCode: 1 };
      }
    } };
    pn3 = { name: "xan", flags: [], stdinType: "text", needsArgs: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/xan-Z6KVJKEE.js
var xan_Z6KVJKEE_exports = {};
__export(xan_Z6KVJKEE_exports, {
  flagsForFuzzing: () => pn3,
  xanCommand: () => cn2
});
var init_xan_Z6KVJKEE = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/xan-Z6KVJKEE.js"() {
    init_chunk_JI3KJ32H();
    init_chunk_F55TLFGB();
    init_chunk_SYMJJMQ4();
    init_chunk_FRDGR5VK();
    init_chunk_7MKBHGLS();
    init_chunk_OJDRYQWQ();
    init_chunk_YNYSPYQ5();
    init_chunk_7L36YK2X();
    init_chunk_PSW6BMXW();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// stub-node:node:url
var fileURLToPath;
var init_node_url = __esm({
  "stub-node:node:url"() {
    fileURLToPath = (u11) => u11;
  }
});

// stub-node:node:worker_threads
var Worker;
var init_node_worker_threads = __esm({
  "stub-node:node:worker_threads"() {
    Worker = class {
      constructor() {
        throw new Error("node:worker_threads stubbed for browser");
      }
    };
  }
});

// stub-native:sql.js
var sql_default;
var init_sql = __esm({
  "stub-native:sql.js"() {
    sql_default = {};
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-HDZ4QEVJ.js
function q15(e7, r8, n23) {
  switch (n23.mode) {
    case "list":
      return y17(e7, r8, n23);
    case "csv":
      return L16(e7, r8, n23);
    case "json":
      return V12(e7, r8);
    case "line":
      return O15(e7, r8, n23);
    case "column":
      return A11(e7, r8, n23);
    case "table":
      return N14(e7, r8, n23);
    case "markdown":
      return P17(e7, r8, n23);
    case "tabs":
      return I17(e7, r8, n23);
    case "box":
      return M12(e7, r8, n23);
    case "quote":
      return R11(e7, r8, n23);
    case "html":
      return F19(e7, r8, n23);
    case "ascii":
      return Q12(e7, r8, n23);
  }
}
function u8(e7, r8) {
  return e7 == null ? r8 : e7 instanceof Uint8Array || Buffer.isBuffer(e7) ? Buffer.from(e7).toString("utf8") : typeof e7 == "number" && !Number.isInteger(e7) ? e7.toPrecision(17).replace(/\.?0+$/, "") : String(e7);
}
function y17(e7, r8, n23) {
  let t6 = [];
  n23.header && e7.length > 0 && t6.push(e7.join(n23.separator));
  for (let l8 of r8) t6.push(l8.map((i10) => u8(i10, n23.nullValue)).join(n23.separator));
  return t6.length > 0 ? `${t6.join(n23.newline)}${n23.newline}` : "";
}
function L16(e7, r8, n23) {
  let t6 = [];
  n23.header && e7.length > 0 && t6.push(e7.map(j10).join(","));
  for (let l8 of r8) t6.push(l8.map((i10) => j10(u8(i10, n23.nullValue))).join(","));
  return t6.length > 0 ? `${t6.join(`
`)}
` : "";
}
function j10(e7) {
  return e7.includes(",") || e7.includes('"') || e7.includes("'") || e7.includes(`
`) ? `"${e7.replace(/"/g, '""')}"` : e7;
}
function E10(e7) {
  return e7.toPrecision(17).replace(/\.?0+$/, "");
}
function k14(e7) {
  return e7 === null ? "null" : typeof e7 == "number" ? Number.isInteger(e7) ? String(e7) : E10(e7) : JSON.stringify(e7);
}
function V12(e7, r8) {
  return r8.length === 0 ? "" : `[${r8.map((t6) => `{${e7.map((i10, s9) => `${JSON.stringify(i10)}:${k14(t6[s9])}`).join(",")}}`).join(`,
`)}]
`;
}
function O15(e7, r8, n23) {
  if (e7.length === 0 || r8.length === 0) return "";
  let t6 = Math.max(5, ...e7.map((i10) => i10.length)), l8 = [];
  for (let i10 of r8) for (let s9 = 0; s9 < e7.length; s9++) {
    let o9 = e7[s9].padStart(t6);
    l8.push(`${o9} = ${u8(i10[s9], n23.nullValue)}`);
  }
  return `${l8.join(`
`)}
`;
}
function A11(e7, r8, n23) {
  if (e7.length === 0) return "";
  let t6 = e7.map((i10) => i10.length);
  for (let i10 of r8) for (let s9 = 0; s9 < i10.length; s9++) {
    let o9 = u8(i10[s9], n23.nullValue).length;
    o9 > t6[s9] && (t6[s9] = o9);
  }
  let l8 = [];
  n23.header && (l8.push(e7.map((i10, s9) => i10.padEnd(t6[s9])).join("  ")), l8.push(t6.map((i10) => "-".repeat(i10)).join("  ")));
  for (let i10 of r8) l8.push(i10.map((s9, o9) => u8(s9, n23.nullValue).padEnd(t6[o9])).join("  "));
  return l8.length > 0 ? `${l8.join(`
`)}
` : "";
}
function N14(e7, r8, n23) {
  if (e7.length === 0) return "";
  let t6 = e7.map((s9) => s9.length);
  for (let s9 of r8) for (let o9 = 0; o9 < s9.length; o9++) {
    let f11 = u8(s9[o9], n23.nullValue).length;
    f11 > t6[o9] && (t6[o9] = f11);
  }
  let l8 = [], i10 = `+${t6.map((s9) => "-".repeat(s9 + 2)).join("+")}+`;
  l8.push(i10), n23.header && (l8.push(`| ${e7.map((s9, o9) => s9.padEnd(t6[o9])).join(" | ")} |`), l8.push(i10));
  for (let s9 of r8) l8.push(`| ${s9.map((o9, f11) => u8(o9, n23.nullValue).padEnd(t6[f11])).join(" | ")} |`);
  return l8.push(i10), `${l8.join(`
`)}
`;
}
function P17(e7, r8, n23) {
  if (e7.length === 0) return "";
  let t6 = [];
  n23.header && (t6.push(`| ${e7.join(" | ")} |`), t6.push(`|${e7.map(() => "---").join("|")}|`));
  for (let l8 of r8) t6.push(`| ${l8.map((i10) => u8(i10, n23.nullValue)).join(" | ")} |`);
  return t6.length > 0 ? `${t6.join(`
`)}
` : "";
}
function I17(e7, r8, n23) {
  let t6 = [];
  n23.header && e7.length > 0 && t6.push(e7.join("	"));
  for (let l8 of r8) t6.push(l8.map((i10) => u8(i10, n23.nullValue)).join("	"));
  return t6.length > 0 ? `${t6.join(n23.newline)}${n23.newline}` : "";
}
function M12(e7, r8, n23) {
  if (e7.length === 0) return "";
  let t6 = e7.map((i10) => i10.length);
  for (let i10 of r8) for (let s9 = 0; s9 < i10.length; s9++) {
    let o9 = u8(i10[s9], n23.nullValue).length;
    o9 > t6[s9] && (t6[s9] = o9);
  }
  let l8 = [];
  l8.push(`\u250C${t6.map((i10) => "\u2500".repeat(i10 + 2)).join("\u252C")}\u2510`), l8.push(`\u2502 ${e7.map((i10, s9) => i10.padEnd(t6[s9])).join(" \u2502 ")} \u2502`), l8.push(`\u251C${t6.map((i10) => "\u2500".repeat(i10 + 2)).join("\u253C")}\u2524`);
  for (let i10 of r8) l8.push(`\u2502 ${i10.map((s9, o9) => u8(s9, n23.nullValue).padEnd(t6[o9])).join(" \u2502 ")} \u2502`);
  return l8.push(`\u2514${t6.map((i10) => "\u2500".repeat(i10 + 2)).join("\u2534")}\u2518`), `${l8.join(`
`)}
`;
}
function R11(e7, r8, n23) {
  let t6 = [];
  n23.header && e7.length > 0 && t6.push(e7.map((l8) => `'${l8}'`).join(","));
  for (let l8 of r8) t6.push(l8.map((i10) => i10 == null ? "NULL" : typeof i10 == "number" ? Number.isInteger(i10) ? String(i10) : E10(i10) : `'${String(i10)}'`).join(","));
  return t6.length > 0 ? `${t6.join(n23.newline)}${n23.newline}` : "";
}
function F19(e7, r8, n23) {
  let t6 = [];
  n23.header && e7.length > 0 && (t6.push(`<TR>${e7.map((l8) => `<TH>${S14(l8)}</TH>`).join("")}`), t6.push("</TR>"));
  for (let l8 of r8) t6.push(`<TR>${l8.map((i10) => `<TD>${S14(u8(i10, n23.nullValue))}</TD>`).join("")}`), t6.push("</TR>");
  return t6.length > 0 ? `${t6.join(`
`)}
` : "";
}
function S14(e7) {
  return e7.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}
function Q12(e7, r8, n23) {
  let i10 = [];
  n23.header && e7.length > 0 && i10.push(e7.join(""));
  for (let s9 of r8) i10.push(s9.map((o9) => u8(o9, n23.nullValue)).join(""));
  return i10.length > 0 ? i10.join("") + "" : "";
}
function _12(e7) {
  let r8 = { mode: "list", header: false, separator: "|", newline: `
`, nullValue: "", readonly: false, bail: false, echo: false, cmd: null }, n23 = null, t6 = null, l8 = false, i10 = false;
  for (let s9 = 0; s9 < e7.length; s9++) {
    let o9 = e7[s9];
    if (i10) {
      n23 === null ? n23 = o9 : t6 === null && (t6 = o9);
      continue;
    }
    if (o9 === "--") i10 = true;
    else if (o9 === "-version") l8 = true;
    else if (o9 === "-list") r8.mode = "list";
    else if (o9 === "-csv") r8.mode = "csv";
    else if (o9 === "-json") r8.mode = "json";
    else if (o9 === "-line") r8.mode = "line";
    else if (o9 === "-column") r8.mode = "column";
    else if (o9 === "-table") r8.mode = "table";
    else if (o9 === "-markdown") r8.mode = "markdown";
    else if (o9 === "-tabs") r8.mode = "tabs";
    else if (o9 === "-box") r8.mode = "box";
    else if (o9 === "-quote") r8.mode = "quote";
    else if (o9 === "-html") r8.mode = "html";
    else if (o9 === "-ascii") r8.mode = "ascii";
    else if (o9 === "-header") r8.header = true;
    else if (o9 === "-noheader") r8.header = false;
    else if (o9 === "-readonly") r8.readonly = true;
    else if (o9 === "-bail") r8.bail = true;
    else if (o9 === "-echo") r8.echo = true;
    else if (o9 === "-separator") {
      if (s9 + 1 >= e7.length) return { stdout: "", stderr: `sqlite3: Error: missing argument to -separator
`, exitCode: 1 };
      r8.separator = e7[++s9];
    } else if (o9 === "-newline") {
      if (s9 + 1 >= e7.length) return { stdout: "", stderr: `sqlite3: Error: missing argument to -newline
`, exitCode: 1 };
      r8.newline = e7[++s9];
    } else if (o9 === "-nullvalue") {
      if (s9 + 1 >= e7.length) return { stdout: "", stderr: `sqlite3: Error: missing argument to -nullvalue
`, exitCode: 1 };
      r8.nullValue = e7[++s9];
    } else if (o9 === "-cmd") {
      if (s9 + 1 >= e7.length) return { stdout: "", stderr: `sqlite3: Error: missing argument to -cmd
`, exitCode: 1 };
      r8.cmd = e7[++s9];
    } else {
      if (o9.startsWith("-")) return { stdout: "", stderr: `sqlite3: Error: unknown option: ${o9.startsWith("--") ? o9.slice(1) : o9}
Use -help for a list of options.
`, exitCode: 1 };
      n23 === null ? n23 = o9 : t6 === null && (t6 = o9);
    }
  }
  return { options: r8, database: n23, sql: t6, showVersion: l8 };
}
async function z9() {
  let e7 = await sql_default(), r8 = new e7.Database();
  try {
    let n23 = r8.exec("SELECT sqlite_version()");
    return n23.length > 0 && n23[0].values.length > 0 ? String(n23[0].values[0][0]) : "unknown";
  } finally {
    r8.close();
  }
}
function X9() {
  let e7 = dirname(fileURLToPath(import.meta.url)), r8 = join(e7, "../../commands/sqlite3/worker.js");
  if (existsSync(r8)) return r8;
  let n23 = join(e7, "worker.js");
  if (existsSync(n23)) return n23;
  let t6 = join(e7, "../../../dist/commands/sqlite3/worker.js");
  if (existsSync(t6)) return t6;
  throw new Error("sqlite3 worker not found. Run 'pnpm build' to compile the worker.");
}
async function Y9(e7, r8) {
  try {
    let n23 = X9();
    return await new Promise((t6, l8) => {
      let i10 = new Worker(n23, { workerData: e7 }), s9 = setTimeout(() => {
        i10.terminate(), t6({ success: false, error: `Query timeout: execution exceeded ${r8}ms limit` });
      }, r8);
      i10.on("message", (o9) => {
        clearTimeout(s9), t6(o9);
      }), i10.on("error", (o9) => {
        clearTimeout(s9), l8(o9);
      }), i10.on("exit", (o9) => {
        clearTimeout(s9), o9 !== 0 && t6({ success: false, error: `Worker exited with code ${o9}` });
      });
    });
  } catch (n23) {
    throw new Error(`sqlite3 worker failed to load: ${n23.message}`);
  }
}
var J13, W12, oe8, ie6;
var init_chunk_HDZ4QEVJ = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-HDZ4QEVJ.js"() {
    init_chunk_74CEPOFO();
    init_node_fs();
    init_node_path();
    init_node_url();
    init_node_worker_threads();
    init_sql();
    J13 = 5e3;
    W12 = { name: "sqlite3", summary: "SQLite database CLI", usage: "sqlite3 [OPTIONS] DATABASE [SQL]", options: ["-list           output in list mode (default)", "-csv            output in CSV mode", "-json           output in JSON mode", "-line           output in line mode", "-column         output in column mode", "-table          output as ASCII table", "-markdown       output as markdown table", "-tabs           output in tab-separated mode", "-box            output in Unicode box mode", "-quote          output in SQL quote mode", "-html           output as HTML table", "-ascii          output in ASCII mode (control chars)", "-header         show column headers", "-noheader       hide column headers", "-separator SEP  field separator for list mode (default: |)", "-newline SEP    row separator (default: \\n)", "-nullvalue TEXT text for NULL values (default: empty)", "-readonly       open database read-only (no writeback)", "-bail           stop on first error", "-echo           print SQL before execution", "-cmd COMMAND    run SQL command before main SQL", "-version        show SQLite version", "--              end of options", "--help          show this help"], examples: ['sqlite3 :memory: "CREATE TABLE t(x); INSERT INTO t VALUES(1); SELECT * FROM t"', 'sqlite3 -json data.db "SELECT * FROM users"', 'sqlite3 -csv -header data.db "SELECT id, name FROM products"', 'sqlite3 -box data.db "SELECT * FROM users"'] };
    oe8 = { name: "sqlite3", async execute(e7, r8) {
      if (o2(e7) || e7.includes("-help")) return s(W12);
      let n23 = _12(e7);
      if ("exitCode" in n23) return n23;
      let { options: t6, database: l8, sql: i10, showVersion: s9 } = n23;
      if (s9) return { stdout: `${await z9()}
`, stderr: "", exitCode: 0 };
      if (!l8) return { stdout: "", stderr: `sqlite3: missing database argument
`, exitCode: 1 };
      let o9 = i10 || r8.stdin.trim();
      if (t6.cmd && (o9 = t6.cmd + (o9 ? `; ${o9}` : "")), !o9) return { stdout: "", stderr: `sqlite3: no SQL provided
`, exitCode: 1 };
      let f11 = l8 === ":memory:", m25 = "", g18 = null;
      try {
        f11 || (m25 = r8.fs.resolvePath(r8.cwd, l8), await r8.fs.exists(m25) && (g18 = await r8.fs.readFileBuffer(m25)));
      } catch (a7) {
        return { stdout: "", stderr: `sqlite3: unable to open database "${l8}": ${a7.message}
`, exitCode: 1 };
      }
      let x23 = r8.limits?.maxSqliteTimeoutMs ?? J13, T10 = { dbBuffer: g18, sql: o9, options: { bail: t6.bail, echo: t6.echo } }, d16;
      try {
        d16 = await Y9(T10, x23);
      } catch (a7) {
        return { stdout: "", stderr: `sqlite3: worker error: ${a7.message}
`, exitCode: 1 };
      }
      if (!d16.success) return { stdout: "", stderr: `sqlite3: ${d16.error}
`, exitCode: 1 };
      let C19 = { mode: t6.mode, header: t6.header, separator: t6.separator, newline: t6.newline, nullValue: t6.nullValue }, c15 = "";
      t6.echo && (c15 += `${o9}
`);
      let w19 = false;
      for (let a7 of d16.results) if (a7.type === "error") {
        if (t6.bail) return { stdout: c15, stderr: `Error: ${a7.error}
`, exitCode: 1 };
        c15 += `Error: ${a7.error}
`, w19 = true;
      } else a7.columns && a7.rows && (a7.rows.length > 0 || t6.header) && (c15 += q15(a7.columns, a7.rows, C19));
      if (d16.hasModifications && !t6.readonly && !f11 && m25 && d16.dbBuffer) try {
        await r8.fs.writeFile(m25, d16.dbBuffer);
      } catch (a7) {
        return { stdout: c15, stderr: `sqlite3: failed to write database: ${a7.message}
`, exitCode: 1 };
      }
      return { stdout: c15, stderr: "", exitCode: w19 && t6.bail ? 1 : 0 };
    } };
    ie6 = { name: "sqlite3", flags: [], needsArgs: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/sqlite3-Z2IGWYCE.js
var sqlite3_Z2IGWYCE_exports = {};
__export(sqlite3_Z2IGWYCE_exports, {
  flagsForFuzzing: () => ie6,
  sqlite3Command: () => oe8
});
var init_sqlite3_Z2IGWYCE = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/sqlite3-Z2IGWYCE.js"() {
    init_chunk_HDZ4QEVJ();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/python3-W2D6SNQF.js
var python3_W2D6SNQF_exports = {};
__export(python3_W2D6SNQF_exports, {
  python3Command: () => G7,
  pythonCommand: () => tt6
});
function _13() {
  return new SharedArrayBuffer(p16.TOTAL);
}
function b24(r8) {
  let t6 = { code: null, module: null, scriptFile: null, showVersion: false, scriptArgs: [] };
  if (r8.length === 0) return t6;
  let e7 = r8.findIndex((s9) => !s9.startsWith("-") || s9 === "-" || s9 === "--");
  for (let s9 = 0; s9 < (e7 === -1 ? r8.length : e7); s9++) {
    let o9 = r8[s9];
    if (o9 === "-c") return s9 + 1 >= r8.length ? { stdout: "", stderr: `python3: option requires an argument -- 'c'
`, exitCode: 2 } : (t6.code = r8[s9 + 1], t6.scriptArgs = r8.slice(s9 + 2), t6);
    if (o9 === "-m") return s9 + 1 >= r8.length ? { stdout: "", stderr: `python3: option requires an argument -- 'm'
`, exitCode: 2 } : (t6.module = r8[s9 + 1], t6.scriptArgs = r8.slice(s9 + 2), t6);
    if (o9 === "--version" || o9 === "-V") return t6.showVersion = true, t6;
    if (o9.startsWith("-") && o9 !== "-") return { stdout: "", stderr: `python3: unrecognized option '${o9}'
`, exitCode: 2 };
  }
  if (e7 !== -1) {
    let s9 = r8[e7];
    s9 === "--" ? e7 + 1 < r8.length && (t6.scriptFile = r8[e7 + 1], t6.scriptArgs = r8.slice(e7 + 2)) : (t6.scriptFile = s9, t6.scriptArgs = r8.slice(e7 + 1));
  }
  return t6;
}
function P18() {
  if (E11 || S15.length === 0) return;
  let r8 = S15.shift();
  if (!r8) return;
  E11 = r8, v20().postMessage(E11.input);
}
function v20() {
  return g17 && (clearTimeout(g17), g17 = null), l7 || (l7 = new Worker(B11), l7.on("message", (r8) => {
    E11 && (E11.resolve(r8), E11 = null), S15.length > 0 ? P18() : H15();
  }), l7.on("error", (r8) => {
    E11 && (E11.resolve({ success: false, error: r8.message }), E11 = null);
    for (let t6 of S15) t6.resolve({ success: false, error: "Worker crashed" });
    S15.length = 0, l7 = null;
  }), l7.on("exit", () => {
    l7 = null;
  }), l7);
}
function H15() {
  g17 = setTimeout(() => {
    l7 && !E11 && S15.length === 0 && (l7.terminate(), l7 = null);
  }, 5e3);
}
async function W13(r8, t6, e7, s9 = []) {
  let o9 = _13(), a7 = new A12(o9, t6.fs, t6.cwd, t6.fetch), d16 = t6.limits?.maxPythonTimeoutMs ?? M13, y18 = { sharedBuffer: o9, pythonCode: r8, cwd: t6.cwd, env: r(t6.env), args: s9, scriptPath: e7 }, I18 = new Promise((T10) => {
    let U14 = setTimeout(() => {
      T10({ success: false, error: `Execution timeout: exceeded ${d16}ms limit` });
    }, d16), x23 = (L18) => {
      clearTimeout(U14), T10(L18);
    };
    S15.push({ input: y18, resolve: x23 }), P18();
  }), [m25, F21] = await Promise.all([a7.run(d16), I18.catch((T10) => ({ success: false, error: T10.message }))]);
  return !F21.success && F21.error ? { stdout: m25.stdout, stderr: `${m25.stderr}python3: ${F21.error}
`, exitCode: m25.exitCode || 1 } : m25;
}
var h15, n22, u9, i9, p16, R12, c13, w18, A12, M13, k15, l7, g17, S15, E11, B11, G7, tt6;
var init_python3_W2D6SNQF = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/python3-W2D6SNQF.js"() {
    init_chunk_YYAPW4OA();
    init_chunk_OJDRYQWQ();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
    init_node_url();
    init_node_worker_threads();
    h15 = { NOOP: 0, READ_FILE: 1, WRITE_FILE: 2, STAT: 3, READDIR: 4, MKDIR: 5, RM: 6, EXISTS: 7, APPEND_FILE: 8, SYMLINK: 9, READLINK: 10, LSTAT: 11, CHMOD: 12, REALPATH: 13, WRITE_STDOUT: 100, WRITE_STDERR: 101, EXIT: 102, HTTP_REQUEST: 200 };
    n22 = { PENDING: 0, READY: 1, SUCCESS: 2, ERROR: 3 };
    u9 = { NONE: 0, NOT_FOUND: 1, IS_DIRECTORY: 2, NOT_DIRECTORY: 3, EXISTS: 4, PERMISSION_DENIED: 5, INVALID_PATH: 6, IO_ERROR: 7, TIMEOUT: 8, NETWORK_ERROR: 9, NETWORK_NOT_CONFIGURED: 10 };
    i9 = { OP_CODE: 0, STATUS: 4, PATH_LENGTH: 8, DATA_LENGTH: 12, RESULT_LENGTH: 16, ERROR_CODE: 20, FLAGS: 24, MODE: 28, PATH_BUFFER: 32, DATA_BUFFER: 4128 };
    p16 = { CONTROL_REGION: 32, PATH_BUFFER: 4096, DATA_BUFFER: 1048576, TOTAL: 1052704 };
    R12 = { NONE: 0, RECURSIVE: 1, FORCE: 2, MKDIR_RECURSIVE: 1 };
    c13 = { IS_FILE: 0, IS_DIRECTORY: 1, IS_SYMLINK: 2, MODE: 4, SIZE: 8, MTIME: 16, TOTAL: 24 };
    w18 = class {
      int32View;
      uint8View;
      dataView;
      constructor(t6) {
        this.int32View = new Int32Array(t6), this.uint8View = new Uint8Array(t6), this.dataView = new DataView(t6);
      }
      getOpCode() {
        return Atomics.load(this.int32View, i9.OP_CODE / 4);
      }
      setOpCode(t6) {
        Atomics.store(this.int32View, i9.OP_CODE / 4, t6);
      }
      getStatus() {
        return Atomics.load(this.int32View, i9.STATUS / 4);
      }
      setStatus(t6) {
        Atomics.store(this.int32View, i9.STATUS / 4, t6);
      }
      getPathLength() {
        return Atomics.load(this.int32View, i9.PATH_LENGTH / 4);
      }
      setPathLength(t6) {
        Atomics.store(this.int32View, i9.PATH_LENGTH / 4, t6);
      }
      getDataLength() {
        return Atomics.load(this.int32View, i9.DATA_LENGTH / 4);
      }
      setDataLength(t6) {
        Atomics.store(this.int32View, i9.DATA_LENGTH / 4, t6);
      }
      getResultLength() {
        return Atomics.load(this.int32View, i9.RESULT_LENGTH / 4);
      }
      setResultLength(t6) {
        Atomics.store(this.int32View, i9.RESULT_LENGTH / 4, t6);
      }
      getErrorCode() {
        return Atomics.load(this.int32View, i9.ERROR_CODE / 4);
      }
      setErrorCode(t6) {
        Atomics.store(this.int32View, i9.ERROR_CODE / 4, t6);
      }
      getFlags() {
        return Atomics.load(this.int32View, i9.FLAGS / 4);
      }
      setFlags(t6) {
        Atomics.store(this.int32View, i9.FLAGS / 4, t6);
      }
      getMode() {
        return Atomics.load(this.int32View, i9.MODE / 4);
      }
      setMode(t6) {
        Atomics.store(this.int32View, i9.MODE / 4, t6);
      }
      getPath() {
        let t6 = this.getPathLength(), e7 = this.uint8View.slice(i9.PATH_BUFFER, i9.PATH_BUFFER + t6);
        return new TextDecoder().decode(e7);
      }
      setPath(t6) {
        let e7 = new TextEncoder().encode(t6);
        if (e7.length > p16.PATH_BUFFER) throw new Error(`Path too long: ${e7.length} > ${p16.PATH_BUFFER}`);
        this.uint8View.set(e7, i9.PATH_BUFFER), this.setPathLength(e7.length);
      }
      getData() {
        let t6 = this.getDataLength();
        return this.uint8View.slice(i9.DATA_BUFFER, i9.DATA_BUFFER + t6);
      }
      setData(t6) {
        if (t6.length > p16.DATA_BUFFER) throw new Error(`Data too large: ${t6.length} > ${p16.DATA_BUFFER}`);
        this.uint8View.set(t6, i9.DATA_BUFFER), this.setDataLength(t6.length);
      }
      getDataAsString() {
        let t6 = this.getData();
        return new TextDecoder().decode(t6);
      }
      setDataFromString(t6) {
        let e7 = new TextEncoder().encode(t6);
        this.setData(e7);
      }
      getResult() {
        let t6 = this.getResultLength();
        return this.uint8View.slice(i9.DATA_BUFFER, i9.DATA_BUFFER + t6);
      }
      setResult(t6) {
        if (t6.length > p16.DATA_BUFFER) throw new Error(`Result too large: ${t6.length} > ${p16.DATA_BUFFER}`);
        this.uint8View.set(t6, i9.DATA_BUFFER), this.setResultLength(t6.length);
      }
      getResultAsString() {
        let t6 = this.getResult();
        return new TextDecoder().decode(t6);
      }
      setResultFromString(t6) {
        let e7 = new TextEncoder().encode(t6);
        this.setResult(e7);
      }
      encodeStat(t6) {
        this.uint8View[i9.DATA_BUFFER + c13.IS_FILE] = t6.isFile ? 1 : 0, this.uint8View[i9.DATA_BUFFER + c13.IS_DIRECTORY] = t6.isDirectory ? 1 : 0, this.uint8View[i9.DATA_BUFFER + c13.IS_SYMLINK] = t6.isSymbolicLink ? 1 : 0, this.dataView.setInt32(i9.DATA_BUFFER + c13.MODE, t6.mode, true);
        let e7 = Math.min(t6.size, Number.MAX_SAFE_INTEGER);
        this.dataView.setFloat64(i9.DATA_BUFFER + c13.SIZE, e7, true), this.dataView.setFloat64(i9.DATA_BUFFER + c13.MTIME, t6.mtime.getTime(), true), this.setResultLength(c13.TOTAL);
      }
      decodeStat() {
        return { isFile: this.uint8View[i9.DATA_BUFFER + c13.IS_FILE] === 1, isDirectory: this.uint8View[i9.DATA_BUFFER + c13.IS_DIRECTORY] === 1, isSymbolicLink: this.uint8View[i9.DATA_BUFFER + c13.IS_SYMLINK] === 1, mode: this.dataView.getInt32(i9.DATA_BUFFER + c13.MODE, true), size: this.dataView.getFloat64(i9.DATA_BUFFER + c13.SIZE, true), mtime: new Date(this.dataView.getFloat64(i9.DATA_BUFFER + c13.MTIME, true)) };
      }
      waitForReady(t6) {
        return Atomics.wait(this.int32View, i9.STATUS / 4, n22.PENDING, t6);
      }
      waitForReadyAsync(t6) {
        return Atomics.waitAsync(this.int32View, i9.STATUS / 4, n22.PENDING, t6);
      }
      async waitUntilReady(t6) {
        let e7 = Date.now();
        for (; ; ) {
          let s9 = this.getStatus();
          if (s9 === n22.READY) return true;
          let o9 = Date.now() - e7;
          if (o9 >= t6) return false;
          let a7 = t6 - o9, d16 = Atomics.waitAsync(this.int32View, i9.STATUS / 4, s9, a7);
          if (d16.async && await d16.value === "timed-out") return false;
        }
      }
      waitForResult(t6) {
        return Atomics.wait(this.int32View, i9.STATUS / 4, n22.READY, t6);
      }
      notify() {
        return Atomics.notify(this.int32View, i9.STATUS / 4);
      }
      reset() {
        this.setOpCode(h15.NOOP), this.setStatus(n22.PENDING), this.setPathLength(0), this.setDataLength(0), this.setResultLength(0), this.setErrorCode(u9.NONE), this.setFlags(R12.NONE), this.setMode(0);
      }
    };
    A12 = class {
      fs;
      cwd;
      secureFetch;
      protocol;
      running = false;
      output = { stdout: "", stderr: "", exitCode: 0 };
      constructor(t6, e7, s9, o9 = void 0) {
        this.fs = e7, this.cwd = s9, this.secureFetch = o9, this.protocol = new w18(t6);
      }
      async run(t6) {
        this.running = true;
        let e7 = Date.now();
        for (; this.running; ) {
          let s9 = Date.now() - e7;
          if (s9 >= t6) {
            this.output.stderr += `
python3: execution timeout exceeded
`, this.output.exitCode = 124;
            break;
          }
          let o9 = t6 - s9;
          if (!await this.protocol.waitUntilReady(o9)) {
            this.output.stderr += `
python3: execution timeout exceeded
`, this.output.exitCode = 124;
            break;
          }
          let d16 = this.protocol.getOpCode();
          await this.handleOperation(d16), this.protocol.notify();
        }
        return this.output;
      }
      stop() {
        this.running = false;
      }
      async handleOperation(t6) {
        try {
          switch (t6) {
            case h15.READ_FILE:
              await this.handleReadFile();
              break;
            case h15.WRITE_FILE:
              await this.handleWriteFile();
              break;
            case h15.STAT:
              await this.handleStat();
              break;
            case h15.LSTAT:
              await this.handleLstat();
              break;
            case h15.READDIR:
              await this.handleReaddir();
              break;
            case h15.MKDIR:
              await this.handleMkdir();
              break;
            case h15.RM:
              await this.handleRm();
              break;
            case h15.EXISTS:
              await this.handleExists();
              break;
            case h15.APPEND_FILE:
              await this.handleAppendFile();
              break;
            case h15.SYMLINK:
              await this.handleSymlink();
              break;
            case h15.READLINK:
              await this.handleReadlink();
              break;
            case h15.CHMOD:
              await this.handleChmod();
              break;
            case h15.REALPATH:
              await this.handleRealpath();
              break;
            case h15.WRITE_STDOUT:
              this.handleWriteStdout();
              break;
            case h15.WRITE_STDERR:
              this.handleWriteStderr();
              break;
            case h15.EXIT:
              this.handleExit();
              break;
            case h15.HTTP_REQUEST:
              await this.handleHttpRequest();
              break;
            default:
              this.protocol.setErrorCode(u9.IO_ERROR), this.protocol.setStatus(n22.ERROR);
          }
        } catch (e7) {
          this.setErrorFromException(e7);
        }
      }
      resolvePath(t6) {
        return t6.startsWith("/mnt/host/") ? t6.slice(9) : t6.startsWith("/mnt/host") ? t6.slice(9) || "/" : this.fs.resolvePath(this.cwd, t6);
      }
      async handleReadFile() {
        let t6 = this.resolvePath(this.protocol.getPath());
        try {
          let e7 = await this.fs.readFileBuffer(t6);
          this.protocol.setResult(e7), this.protocol.setStatus(n22.SUCCESS);
        } catch (e7) {
          this.setErrorFromException(e7);
        }
      }
      async handleWriteFile() {
        let t6 = this.resolvePath(this.protocol.getPath()), e7 = this.protocol.getData();
        try {
          await this.fs.writeFile(t6, e7), this.protocol.setStatus(n22.SUCCESS);
        } catch (s9) {
          this.setErrorFromException(s9);
        }
      }
      async handleStat() {
        let t6 = this.resolvePath(this.protocol.getPath());
        try {
          let e7 = await this.fs.stat(t6);
          this.protocol.encodeStat(e7), this.protocol.setStatus(n22.SUCCESS);
        } catch (e7) {
          this.setErrorFromException(e7);
        }
      }
      async handleLstat() {
        let t6 = this.resolvePath(this.protocol.getPath());
        try {
          let e7 = await this.fs.lstat(t6);
          this.protocol.encodeStat(e7), this.protocol.setStatus(n22.SUCCESS);
        } catch (e7) {
          this.setErrorFromException(e7);
        }
      }
      async handleReaddir() {
        let t6 = this.resolvePath(this.protocol.getPath());
        try {
          let e7 = await this.fs.readdir(t6);
          this.protocol.setResultFromString(JSON.stringify(e7)), this.protocol.setStatus(n22.SUCCESS);
        } catch (e7) {
          this.setErrorFromException(e7);
        }
      }
      async handleMkdir() {
        let t6 = this.resolvePath(this.protocol.getPath()), s9 = (this.protocol.getFlags() & R12.MKDIR_RECURSIVE) !== 0;
        try {
          await this.fs.mkdir(t6, { recursive: s9 }), this.protocol.setStatus(n22.SUCCESS);
        } catch (o9) {
          this.setErrorFromException(o9);
        }
      }
      async handleRm() {
        let t6 = this.resolvePath(this.protocol.getPath()), e7 = this.protocol.getFlags(), s9 = (e7 & R12.RECURSIVE) !== 0, o9 = (e7 & R12.FORCE) !== 0;
        try {
          await this.fs.rm(t6, { recursive: s9, force: o9 }), this.protocol.setStatus(n22.SUCCESS);
        } catch (a7) {
          this.setErrorFromException(a7);
        }
      }
      async handleExists() {
        let t6 = this.resolvePath(this.protocol.getPath());
        try {
          let e7 = await this.fs.exists(t6);
          this.protocol.setResult(new Uint8Array([e7 ? 1 : 0])), this.protocol.setStatus(n22.SUCCESS);
        } catch (e7) {
          this.setErrorFromException(e7);
        }
      }
      async handleAppendFile() {
        let t6 = this.resolvePath(this.protocol.getPath()), e7 = this.protocol.getData();
        try {
          await this.fs.appendFile(t6, e7), this.protocol.setStatus(n22.SUCCESS);
        } catch (s9) {
          this.setErrorFromException(s9);
        }
      }
      async handleSymlink() {
        let t6 = this.protocol.getPath(), e7 = this.protocol.getDataAsString(), s9 = this.resolvePath(t6);
        try {
          await this.fs.symlink(e7, s9), this.protocol.setStatus(n22.SUCCESS);
        } catch (o9) {
          this.setErrorFromException(o9);
        }
      }
      async handleReadlink() {
        let t6 = this.resolvePath(this.protocol.getPath());
        try {
          let e7 = await this.fs.readlink(t6);
          this.protocol.setResultFromString(e7), this.protocol.setStatus(n22.SUCCESS);
        } catch (e7) {
          this.setErrorFromException(e7);
        }
      }
      async handleChmod() {
        let t6 = this.resolvePath(this.protocol.getPath()), e7 = this.protocol.getMode();
        try {
          await this.fs.chmod(t6, e7), this.protocol.setStatus(n22.SUCCESS);
        } catch (s9) {
          this.setErrorFromException(s9);
        }
      }
      async handleRealpath() {
        let t6 = this.resolvePath(this.protocol.getPath());
        try {
          let e7 = await this.fs.realpath(t6);
          this.protocol.setResultFromString(e7), this.protocol.setStatus(n22.SUCCESS);
        } catch (e7) {
          this.setErrorFromException(e7);
        }
      }
      handleWriteStdout() {
        let t6 = this.protocol.getDataAsString();
        this.output.stdout += t6, this.protocol.setStatus(n22.SUCCESS);
      }
      handleWriteStderr() {
        let t6 = this.protocol.getDataAsString();
        this.output.stderr += t6, this.protocol.setStatus(n22.SUCCESS);
      }
      handleExit() {
        let t6 = this.protocol.getFlags();
        this.output.exitCode = t6, this.protocol.setStatus(n22.SUCCESS), this.running = false;
      }
      async handleHttpRequest() {
        if (!this.secureFetch) {
          this.protocol.setErrorCode(u9.NETWORK_NOT_CONFIGURED), this.protocol.setResultFromString("Network access not configured. Enable network in Bash options."), this.protocol.setStatus(n22.ERROR);
          return;
        }
        let t6 = this.protocol.getPath(), e7 = this.protocol.getDataAsString();
        try {
          let s9 = e7 ? JSON.parse(e7) : {}, o9 = await this.secureFetch(t6, { method: s9.method, headers: s9.headers, body: s9.body }), a7 = JSON.stringify({ status: o9.status, statusText: o9.statusText, headers: o9.headers, body: o9.body, url: o9.url });
          this.protocol.setResultFromString(a7), this.protocol.setStatus(n22.SUCCESS);
        } catch (s9) {
          let o9 = d3(s9 instanceof Error ? s9.message : String(s9));
          this.protocol.setErrorCode(u9.NETWORK_ERROR), this.protocol.setResultFromString(o9), this.protocol.setStatus(n22.ERROR);
        }
      }
      setErrorFromException(t6) {
        let e7 = t6 instanceof Error ? t6.message : String(t6), s9 = d3(e7), o9 = u9.IO_ERROR, a7 = e7.toLowerCase();
        a7.includes("no such file") || a7.includes("not found") || a7.includes("enoent") ? o9 = u9.NOT_FOUND : a7.includes("is a directory") || a7.includes("eisdir") ? o9 = u9.IS_DIRECTORY : a7.includes("not a directory") || a7.includes("enotdir") ? o9 = u9.NOT_DIRECTORY : a7.includes("already exists") || a7.includes("eexist") ? o9 = u9.EXISTS : (a7.includes("permission") || a7.includes("eperm") || a7.includes("eacces")) && (o9 = u9.PERMISSION_DENIED), this.protocol.setErrorCode(o9), this.protocol.setResultFromString(s9), this.protocol.setStatus(n22.ERROR);
      }
    };
    M13 = 3e4;
    k15 = { name: "python3", summary: "Execute Python code via Pyodide", usage: "python3 [OPTIONS] [-c CODE | -m MODULE | FILE] [ARGS...]", description: ["Execute Python code using Pyodide (Python compiled to WebAssembly).", "", "This command runs Python in a sandboxed environment with access to", "the virtual filesystem. Only Pyodide-bundled packages are available."], options: ["-c CODE     Execute CODE as Python script", "-m MODULE   Run library module as a script", "--version   Show Python version", "--help      Show this help"], examples: ['python3 -c "print(1 + 2)"', 'python3 -c "import sys; print(sys.version)"', "python3 script.py", "python3 script.py arg1 arg2", `echo 'print("hello")' | python3`], notes: ["Pyodide runs in WebAssembly, so execution may be slower than native Python.", "Only packages bundled with Pyodide are available (no pip install).", "First execution loads Pyodide (~30MB), subsequent calls are faster.", "Maximum execution time is 30 seconds by default."] };
    l7 = null;
    g17 = null;
    S15 = [];
    E11 = null;
    B11 = fileURLToPath(new URL("./worker.js", import.meta.url));
    G7 = { name: "python3", async execute(r8, t6) {
      if (o2(r8)) return s(k15);
      let e7 = b24(r8);
      if ("exitCode" in e7) return e7;
      if (e7.showVersion) return { stdout: `Python 3.12.1 (Pyodide)
`, stderr: "", exitCode: 0 };
      let s9, o9;
      if (e7.code !== null) s9 = e7.code, o9 = "-c";
      else if (e7.module !== null) s9 = `import runpy; runpy.run_module('${e7.module}', run_name='__main__')`, o9 = e7.module;
      else if (e7.scriptFile !== null) {
        let a7 = t6.fs.resolvePath(t6.cwd, e7.scriptFile);
        if (!await t6.fs.exists(a7)) return { stdout: "", stderr: `python3: can't open file '${e7.scriptFile}': [Errno 2] No such file or directory
`, exitCode: 2 };
        try {
          s9 = await t6.fs.readFile(a7), o9 = e7.scriptFile;
        } catch (d16) {
          return { stdout: "", stderr: `python3: can't open file '${e7.scriptFile}': ${d16.message}
`, exitCode: 2 };
        }
      } else if (t6.stdin.trim()) s9 = t6.stdin, o9 = "<stdin>";
      else return { stdout: "", stderr: `python3: no input provided (use -c CODE, -m MODULE, or provide a script file)
`, exitCode: 2 };
      return W13(s9, t6, o9, e7.scriptArgs);
    } };
    tt6 = { name: "python", async execute(r8, t6) {
      return G7.execute(r8, t6);
    } };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/curl-6L7YZUIH.js
var curl_6L7YZUIH_exports = {};
__export(curl_6L7YZUIH_exports, {
  curlCommand: () => j11
});
function u10(s9) {
  let t6 = s9.indexOf("=");
  if (t6 >= 0) {
    let r8 = s9.slice(0, t6), e7 = s9.slice(t6 + 1);
    return r8 ? `${encodeURIComponent(r8)}=${encodeURIComponent(e7)}` : encodeURIComponent(e7);
  }
  return encodeURIComponent(s9);
}
function c14(s9) {
  let t6 = s9.indexOf("=");
  if (t6 < 0) return null;
  let r8 = s9.slice(0, t6), e7 = s9.slice(t6 + 1), i10, o9, a7 = e7.match(/;type=([^;]+)$/);
  a7 && (o9 = a7[1], e7 = e7.slice(0, -a7[0].length));
  let n23 = e7.match(/;filename=([^;]+)/);
  return n23 && (i10 = n23[1], e7 = e7.replace(n23[0], "")), (e7.startsWith("@") || e7.startsWith("<")) && (i10 = i10 ?? e7.slice(1).split("/").pop()), { name: r8, value: e7, filename: i10, contentType: o9 };
}
function O16(s9, t6) {
  let r8 = `----CurlFormBoundary${Date.now().toString(36)}`, e7 = [];
  for (let i10 of s9) {
    let o9 = i10.value;
    if (o9.startsWith("@") || o9.startsWith("<")) {
      let n23 = o9.slice(1);
      o9 = t6.get(n23) ?? "";
    }
    let a7 = `--${r8}\r
`;
    i10.filename ? (a7 += `Content-Disposition: form-data; name="${i10.name}"; filename="${i10.filename}"\r
`, i10.contentType && (a7 += `Content-Type: ${i10.contentType}\r
`)) : a7 += `Content-Disposition: form-data; name="${i10.name}"\r
`, a7 += `\r
${o9}\r
`, e7.push(a7);
  }
  return e7.push(`--${r8}--\r
`), { body: e7.join(""), boundary: r8 };
}
function E12(s9) {
  let t6 = { method: "GET", headers: /* @__PURE__ */ Object.create(null), dataBinary: false, formFields: [], useRemoteName: false, headOnly: false, includeHeaders: false, silent: false, showError: false, failSilently: false, followRedirects: true, verbose: false };
  for (let r8 = 0; r8 < s9.length; r8++) {
    let e7 = s9[r8];
    if (e7 === "-X" || e7 === "--request") t6.method = s9[++r8] ?? "GET";
    else if (e7.startsWith("-X")) t6.method = e7.slice(2);
    else if (e7.startsWith("--request=")) t6.method = e7.slice(10);
    else if (e7 === "-H" || e7 === "--header") {
      let i10 = s9[++r8];
      if (i10) {
        let o9 = i10.indexOf(":");
        if (o9 > 0) {
          let a7 = i10.slice(0, o9).trim(), n23 = i10.slice(o9 + 1).trim();
          t6.headers[a7] = n23;
        }
      }
    } else if (e7.startsWith("--header=")) {
      let i10 = e7.slice(9), o9 = i10.indexOf(":");
      if (o9 > 0) {
        let a7 = i10.slice(0, o9).trim(), n23 = i10.slice(o9 + 1).trim();
        t6.headers[a7] = n23;
      }
    } else if (e7 === "-d" || e7 === "--data" || e7 === "--data-raw") t6.data = s9[++r8] ?? "", t6.method === "GET" && (t6.method = "POST");
    else if (e7.startsWith("-d")) t6.data = e7.slice(2), t6.method === "GET" && (t6.method = "POST");
    else if (e7.startsWith("--data=")) t6.data = e7.slice(7), t6.method === "GET" && (t6.method = "POST");
    else if (e7.startsWith("--data-raw=")) t6.data = e7.slice(11), t6.method === "GET" && (t6.method = "POST");
    else if (e7 === "--data-binary") t6.data = s9[++r8] ?? "", t6.dataBinary = true, t6.method === "GET" && (t6.method = "POST");
    else if (e7.startsWith("--data-binary=")) t6.data = e7.slice(14), t6.dataBinary = true, t6.method === "GET" && (t6.method = "POST");
    else if (e7 === "--data-urlencode") {
      let i10 = s9[++r8] ?? "";
      t6.data = (t6.data ? `${t6.data}&` : "") + u10(i10), t6.method === "GET" && (t6.method = "POST");
    } else if (e7.startsWith("--data-urlencode=")) {
      let i10 = e7.slice(17);
      t6.data = (t6.data ? `${t6.data}&` : "") + u10(i10), t6.method === "GET" && (t6.method = "POST");
    } else if (e7 === "-F" || e7 === "--form") {
      let i10 = s9[++r8] ?? "", o9 = c14(i10);
      o9 && t6.formFields.push(o9), t6.method === "GET" && (t6.method = "POST");
    } else if (e7.startsWith("--form=")) {
      let i10 = e7.slice(7), o9 = c14(i10);
      o9 && t6.formFields.push(o9), t6.method === "GET" && (t6.method = "POST");
    } else if (e7 === "-u" || e7 === "--user") t6.user = s9[++r8];
    else if (e7.startsWith("-u")) t6.user = e7.slice(2);
    else if (e7.startsWith("--user=")) t6.user = e7.slice(7);
    else if (e7 === "-A" || e7 === "--user-agent") t6.headers["User-Agent"] = s9[++r8] ?? "";
    else if (e7.startsWith("-A")) t6.headers["User-Agent"] = e7.slice(2);
    else if (e7.startsWith("--user-agent=")) t6.headers["User-Agent"] = e7.slice(13);
    else if (e7 === "-e" || e7 === "--referer") t6.headers.Referer = s9[++r8] ?? "";
    else if (e7.startsWith("-e")) t6.headers.Referer = e7.slice(2);
    else if (e7.startsWith("--referer=")) t6.headers.Referer = e7.slice(10);
    else if (e7 === "-b" || e7 === "--cookie") t6.headers.Cookie = s9[++r8] ?? "";
    else if (e7.startsWith("-b")) t6.headers.Cookie = e7.slice(2);
    else if (e7.startsWith("--cookie=")) t6.headers.Cookie = e7.slice(9);
    else if (e7 === "-c" || e7 === "--cookie-jar") t6.cookieJar = s9[++r8];
    else if (e7.startsWith("--cookie-jar=")) t6.cookieJar = e7.slice(13);
    else if (e7 === "-T" || e7 === "--upload-file") t6.uploadFile = s9[++r8], t6.method === "GET" && (t6.method = "PUT");
    else if (e7.startsWith("--upload-file=")) t6.uploadFile = e7.slice(14), t6.method === "GET" && (t6.method = "PUT");
    else if (e7 === "-m" || e7 === "--max-time") {
      let i10 = parseFloat(s9[++r8] ?? "0");
      !Number.isNaN(i10) && i10 > 0 && (t6.timeoutMs = i10 * 1e3);
    } else if (e7.startsWith("--max-time=")) {
      let i10 = parseFloat(e7.slice(11));
      !Number.isNaN(i10) && i10 > 0 && (t6.timeoutMs = i10 * 1e3);
    } else if (e7 === "--connect-timeout") {
      let i10 = parseFloat(s9[++r8] ?? "0");
      !Number.isNaN(i10) && i10 > 0 && t6.timeoutMs === void 0 && (t6.timeoutMs = i10 * 1e3);
    } else if (e7.startsWith("--connect-timeout=")) {
      let i10 = parseFloat(e7.slice(18));
      !Number.isNaN(i10) && i10 > 0 && t6.timeoutMs === void 0 && (t6.timeoutMs = i10 * 1e3);
    } else if (e7 === "-o" || e7 === "--output") t6.outputFile = s9[++r8];
    else if (e7.startsWith("--output=")) t6.outputFile = e7.slice(9);
    else if (e7 === "-O" || e7 === "--remote-name") t6.useRemoteName = true;
    else if (e7 === "-I" || e7 === "--head") t6.headOnly = true, t6.method = "HEAD";
    else if (e7 === "-i" || e7 === "--include") t6.includeHeaders = true;
    else if (e7 === "-s" || e7 === "--silent") t6.silent = true;
    else if (e7 === "-S" || e7 === "--show-error") t6.showError = true;
    else if (e7 === "-f" || e7 === "--fail") t6.failSilently = true;
    else if (e7 === "-L" || e7 === "--location") t6.followRedirects = true;
    else if (e7 === "--max-redirs") r8++;
    else if (!e7.startsWith("--max-redirs=")) if (e7 === "-w" || e7 === "--write-out") t6.writeOut = s9[++r8];
    else if (e7.startsWith("--write-out=")) t6.writeOut = e7.slice(12);
    else if (e7 === "-v" || e7 === "--verbose") t6.verbose = true;
    else {
      if (e7.startsWith("--") && e7 !== "--") return r3("curl", e7);
      if (e7.startsWith("-") && e7 !== "-") for (let i10 of e7.slice(1)) switch (i10) {
        case "s":
          t6.silent = true;
          break;
        case "S":
          t6.showError = true;
          break;
        case "f":
          t6.failSilently = true;
          break;
        case "L":
          t6.followRedirects = true;
          break;
        case "I":
          t6.headOnly = true, t6.method = "HEAD";
          break;
        case "i":
          t6.includeHeaders = true;
          break;
        case "O":
          t6.useRemoteName = true;
          break;
        case "v":
          t6.verbose = true;
          break;
        default:
          return r3("curl", `-${i10}`);
      }
      else e7.startsWith("-") || (t6.url = e7);
    }
  }
  return t6;
}
function m24(s9) {
  return Object.entries(s9).map(([t6, r8]) => `${t6}: ${r8}`).join(`\r
`);
}
function P19(s9) {
  try {
    return new URL(s9).pathname.split("/").pop() || "index.html";
  } catch {
    return "index.html";
  }
}
function h16(s9, t6) {
  let r8 = s9;
  return r8 = r8.replace(/%\{http_code\}/g, String(t6.status)), r8 = r8.replace(/%\{content_type\}/g, t6.headers["content-type"] || ""), r8 = r8.replace(/%\{url_effective\}/g, t6.url), r8 = r8.replace(/%\{size_download\}/g, String(t6.bodyLength)), r8 = r8.replace(/\\n/g, `
`), r8;
}
async function F20(s9, t6) {
  if (s9.uploadFile) {
    let r8 = t6.fs.resolvePath(t6.cwd, s9.uploadFile);
    return { body: await t6.fs.readFile(r8) };
  }
  if (s9.formFields.length > 0) {
    let r8 = /* @__PURE__ */ new Map();
    for (let o9 of s9.formFields) if (o9.value.startsWith("@") || o9.value.startsWith("<")) {
      let a7 = t6.fs.resolvePath(t6.cwd, o9.value.slice(1));
      try {
        let n23 = await t6.fs.readFile(a7);
        r8.set(o9.value.slice(1), n23);
      } catch {
        r8.set(o9.value.slice(1), "");
      }
    }
    let { body: e7, boundary: i10 } = O16(s9.formFields, r8);
    return { body: e7, contentType: `multipart/form-data; boundary=${i10}` };
  }
  return s9.data !== void 0 ? { body: s9.data } : {};
}
function W14(s9, t6) {
  let r8 = s4(s9.headers ?? {});
  if (s9.user) {
    let e7 = Buffer.from(s9.user).toString("base64");
    r8.Authorization = `Basic ${e7}`;
  }
  return t6 && !r8["Content-Type"] && (r8["Content-Type"] = t6), r8;
}
async function $17(s9, t6, r8) {
  if (!s9.cookieJar) return;
  let e7 = t6["set-cookie"];
  if (!e7) return;
  let i10 = r8.fs.resolvePath(r8.cwd, s9.cookieJar);
  await r8.fs.writeFile(i10, e7);
}
function k16(s9, t6, r8) {
  let e7 = "";
  if (s9.verbose) {
    e7 += `> ${s9.method} ${r8}
`;
    for (let [i10, o9] of Object.entries(s9.headers)) e7 += `> ${i10}: ${o9}
`;
    e7 += `>
`, e7 += `< HTTP/1.1 ${t6.status} ${t6.statusText}
`;
    for (let [i10, o9] of Object.entries(t6.headers)) e7 += `< ${i10}: ${o9}
`;
    e7 += `<
`;
  }
  return s9.includeHeaders && !s9.verbose && (e7 += `HTTP/1.1 ${t6.status} ${t6.statusText}\r
`, e7 += m24(t6.headers), e7 += `\r
\r
`), s9.headOnly ? s9.includeHeaders || s9.verbose || (e7 += `HTTP/1.1 ${t6.status} ${t6.statusText}\r
`, e7 += m24(t6.headers), e7 += `\r
`) : e7 += t6.body, s9.writeOut && (e7 += h16(s9.writeOut, { status: t6.status, headers: t6.headers, url: t6.url, bodyLength: t6.body.length })), e7;
}
var S16, j11;
var init_curl_6L7YZUIH = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/curl-6L7YZUIH.js"() {
    init_chunk_7MKBHGLS();
    init_chunk_44UOCSGV();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
    S16 = { name: "curl", summary: "transfer a URL", usage: "curl [OPTIONS] URL", options: ["-X, --request METHOD  HTTP method (GET, POST, PUT, DELETE, etc.)", "-H, --header HEADER   Add header (can be used multiple times)", "-d, --data DATA       HTTP POST data", "    --data-raw DATA   HTTP POST data (no @ interpretation)", "    --data-binary DATA  HTTP POST binary data", "    --data-urlencode DATA  URL-encode and POST data", "-F, --form NAME=VALUE  Multipart form data", "-u, --user USER:PASS  HTTP authentication", "-A, --user-agent STR  Set User-Agent header", "-e, --referer URL     Set Referer header", "-b, --cookie DATA     Send cookies (name=value or @file)", "-c, --cookie-jar FILE Save cookies to file", "-T, --upload-file FILE  Upload file (PUT)", "-o, --output FILE     Write output to file", "-O, --remote-name     Write to file named from URL", "-I, --head            Show headers only (HEAD request)", "-i, --include         Include response headers in output", "-s, --silent          Silent mode (no progress)", "-S, --show-error      Show errors even when silent", "-f, --fail            Fail silently on HTTP errors (no output)", "-L, --location        Follow redirects (default)", "    --max-redirs NUM  Maximum redirects (default: 20)", "-m, --max-time SECS   Maximum time for request", "    --connect-timeout SECS  Connection timeout", "-w, --write-out FMT   Output format after completion", "-v, --verbose         Verbose output", "    --help            Display this help and exit", "", "Note: Network access must be configured via BashEnv network option.", "      curl is not available by default for security reasons."] };
    j11 = { name: "curl", async execute(s9, t6) {
      if (o2(s9)) return s(S16);
      let r8 = E12(s9);
      if ("exitCode" in r8) return r8;
      let e7 = r8;
      if (!e7.url) return { stdout: "", stderr: `curl: no URL specified
`, exitCode: 2 };
      if (!t6.fetch) return { stdout: "", stderr: `curl: internal error: fetch not available
`, exitCode: 1 };
      let i10 = e7.url;
      i10.match(/^https?:\/\//) || (i10 = `https://${i10}`);
      try {
        let { body: o9, contentType: a7 } = await F20(e7, t6), n23 = W14(e7, a7), l8 = await t6.fetch(i10, { method: e7.method, headers: Object.keys(n23).length > 0 ? n23 : void 0, body: o9, followRedirects: e7.followRedirects, timeoutMs: e7.timeoutMs });
        if (await $17(e7, l8.headers, t6), e7.failSilently && l8.status >= 400) return { stdout: "", stderr: e7.showError || !e7.silent ? `curl: (22) The requested URL returned error: ${l8.status}
` : "", exitCode: 22 };
        let d16 = k16(e7, l8, i10);
        if (e7.outputFile || e7.useRemoteName) {
          let p17 = e7.outputFile || P19(i10), v21 = t6.fs.resolvePath(t6.cwd, p17);
          await t6.fs.writeFile(v21, e7.headOnly ? "" : l8.body), e7.verbose || (d16 = ""), e7.writeOut && (d16 = h16(e7.writeOut, { status: l8.status, headers: l8.headers, url: l8.url, bodyLength: l8.body.length }));
        }
        return { stdout: d16, stderr: "", exitCode: 0 };
      } catch (o9) {
        let a7 = n17(o9), n23 = 1;
        return a7.includes("Network access denied") ? n23 = 7 : a7.includes("HTTP method") && a7.includes("not allowed") ? n23 = 3 : a7.includes("Redirect target not in allow-list") || a7.includes("Too many redirects") ? n23 = 47 : a7.includes("aborted") && (n23 = 28), { stdout: "", stderr: !e7.silent || e7.showError ? `curl: (${n23}) ${a7}
` : "", exitCode: n23 };
      }
    } };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/flag-coverage-YHMPSZHK.js
var flag_coverage_YHMPSZHK_exports = {};
__export(flag_coverage_YHMPSZHK_exports, {
  emitFlagCoverage: () => Fa
});
function Tr3() {
  return Er2;
}
function Fa(r8, o9, Dr3) {
  let a7 = Br2.get(o9);
  if (!(!a7 || a7.size === 0)) for (let s9 of Dr3) a7.has(s9) && r8.hit(`cmd:flag:${o9}:${s9}`);
}
var Er2, Br2;
var init_flag_coverage_YHMPSZHK = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/flag-coverage-YHMPSZHK.js"() {
    init_chunk_VZWXH2PZ();
    init_chunk_XMDVFEVC();
    init_chunk_JI3KJ32H();
    init_chunk_F55TLFGB();
    init_chunk_SYMJJMQ4();
    init_chunk_HDZ4QEVJ();
    init_chunk_MDLLFABN();
    init_chunk_ZKLK6C7H();
    init_chunk_UYGR3CFC();
    init_chunk_NQOQ2Q77();
    init_chunk_4HHKTUW3();
    init_chunk_HJQJAYMS();
    init_chunk_PP6PSHAB();
    init_chunk_DZ33S2U7();
    init_chunk_XNL7YAHW();
    init_chunk_CSBFBYLD();
    init_chunk_A7A2DBEE();
    init_chunk_U7QI5ZS5();
    init_chunk_APT7OOP2();
    init_chunk_XKQRETAK();
    init_chunk_5V6VZH6T();
    init_chunk_EIZGF4BS();
    init_chunk_CR5AFCPT();
    init_chunk_R6QSAL5T();
    init_chunk_LL3S3NLB();
    init_chunk_JP44OYZS();
    init_chunk_2OCD45J4();
    init_chunk_FRDGR5VK();
    init_chunk_7MKBHGLS();
    init_chunk_IBFD7QQD();
    init_chunk_TLSUDHID();
    init_chunk_D7MEQ3VN();
    init_chunk_WMLBQOWO();
    init_chunk_ALLTKNUZ();
    init_chunk_4Q4SM6WR();
    init_chunk_XVDPCNWR();
    init_chunk_K3PAWJ7V();
    init_chunk_OGDTSM2Q();
    init_chunk_VOBGTVA6();
    init_chunk_NCNPKYJZ();
    init_chunk_SXR3EI72();
    init_chunk_VJFXDYWH();
    init_chunk_PYSFUGCK();
    init_chunk_VYOJP4TV();
    init_chunk_KTGH7NTP();
    init_chunk_LWEGUNWT();
    init_chunk_A7ICOL4V();
    init_chunk_55VFSPNA();
    init_chunk_YYB54I7F();
    init_chunk_7C6RBHP3();
    init_chunk_Z7JVV2SM();
    init_chunk_6NY2AP72();
    init_chunk_JVPRLUMK();
    init_chunk_X6JMGGW2();
    init_chunk_QCDB2VPH();
    init_chunk_F23WWYKW();
    init_chunk_D4J545R4();
    init_chunk_DCAAORBQ();
    init_chunk_GXVXFKBA();
    init_chunk_OFJTSXN6();
    init_chunk_S6BBC45K();
    init_chunk_IJXFPKNC();
    init_chunk_QOENL5UZ();
    init_chunk_VLGZJRPG();
    init_chunk_MZLOTDD7();
    init_chunk_3KWUDRIP();
    init_chunk_KAEMRWOH();
    init_chunk_27LMNKBP();
    init_chunk_NUYSJFDK();
    init_chunk_A4JSPFCI();
    init_chunk_SL4FN3A5();
    init_chunk_GZ2N3SXD();
    init_chunk_A4HU7SVR();
    init_chunk_IKZ5LEGB();
    init_chunk_64BAICW3();
    init_chunk_HDQ56CKY();
    init_chunk_OJDRYQWQ();
    init_chunk_YNYSPYQ5();
    init_chunk_GCTKCWKD();
    init_chunk_7DBA735O();
    init_chunk_7L36YK2X();
    init_chunk_L4KW73FJ();
    init_chunk_EEXR5ZDP();
    init_chunk_PSW6BMXW();
    init_chunk_KY5VPZXG();
    init_chunk_XZ3MZS57();
    init_chunk_OCS6LSEM();
    init_chunk_HWKDQ44K();
    init_chunk_OCLXQMOG();
    init_chunk_44UOCSGV();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
    Er2 = [f3, F3, he2, Y2, v5, $4, b6, h5, F5, x7, b8, b9, f5, y5, g8, c5, I4, w4, fe2, ue2, ce2, Ae2, Le2, bn2, U7, P7, I9, S5, T4, q10, m9, x12, x13, v11, F9, N7, I11, P9, U8, w10, Ze3, h10, c8, L10, v15, O10, j6, p12, h11, u5, P11, s2, r7, o5, b15, P12, U9, F12, x16, D10, m19, k9, F13, b19, b20, o7, m20, m21, Mr2, x19, m22, F16, u7, s7, n21, v18, G5, Z9, M10, Ct4, rg, pn3, ie6];
    Br2 = /* @__PURE__ */ new Map();
    for (let r8 of Tr3()) Br2.set(r8.name, new Set(r8.flags.map((o9) => o9.flag)));
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/expansion-5HXXJ2SG.js
var expansion_5HXXJ2SG_exports = {};
__export(expansion_5HXXJ2SG_exports, {
  escapeGlobChars: () => X2,
  escapeRegexChars: () => St,
  expandRedirectTarget: () => bl,
  expandWord: () => kt,
  expandWordForPattern: () => Al,
  expandWordForRegex: () => El,
  expandWordWithGlob: () => Sl,
  getArrayElements: () => P2,
  getVariable: () => v2,
  hasQuotedMultiValueAt: () => qs,
  isArray: () => Se,
  isWordFullyQuoted: () => yl
});
var init_expansion_5HXXJ2SG = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/expansion-5HXXJ2SG.js"() {
    init_chunk_V4CDPGZH();
    init_chunk_YNYSPYQ5();
    init_chunk_PSW6BMXW();
    init_chunk_DXB73IDG();
  }
});

// stub-node:node:module
var node_module_exports = {};
__export(node_module_exports, {
  createRequire: () => createRequire,
  default: () => node_module_default
});
function createRequire() {
  return () => {
    throw new Error("node:module stubbed for browser");
  };
}
var node_module_default;
var init_node_module = __esm({
  "stub-node:node:module"() {
    node_module_default = { createRequire };
  }
});

// ../../node_modules/just-bash/dist/bundle/index.js
init_chunk_V4CDPGZH();
init_chunk_YYAPW4OA();
init_chunk_OJDRYQWQ();
init_chunk_YNYSPYQ5();
init_chunk_PSW6BMXW();
init_chunk_44UOCSGV();
init_chunk_DXB73IDG();
init_node_fs();
init_node_path();
init_node_fs();
init_node_path();
var He7 = [{ name: "echo", load: async () => (await Promise.resolve().then(() => (init_echo_O45JWWI2(), echo_O45JWWI2_exports))).echoCommand }, { name: "cat", load: async () => (await Promise.resolve().then(() => (init_cat_C2OBLGHA(), cat_C2OBLGHA_exports))).catCommand }, { name: "printf", load: async () => (await Promise.resolve().then(() => (init_printf_KGN6BDCY(), printf_KGN6BDCY_exports))).printfCommand }, { name: "ls", load: async () => (await Promise.resolve().then(() => (init_ls_OTONBH2E(), ls_OTONBH2E_exports))).lsCommand }, { name: "mkdir", load: async () => (await Promise.resolve().then(() => (init_mkdir_QWGXDWUS(), mkdir_QWGXDWUS_exports))).mkdirCommand }, { name: "rmdir", load: async () => (await Promise.resolve().then(() => (init_rmdir_XTQXT7RK(), rmdir_XTQXT7RK_exports))).rmdirCommand }, { name: "touch", load: async () => (await Promise.resolve().then(() => (init_touch_DX2IJOQ4(), touch_DX2IJOQ4_exports))).touchCommand }, { name: "rm", load: async () => (await Promise.resolve().then(() => (init_rm_KPTLPKPH(), rm_KPTLPKPH_exports))).rmCommand }, { name: "cp", load: async () => (await Promise.resolve().then(() => (init_cp_XOYR4ABJ(), cp_XOYR4ABJ_exports))).cpCommand }, { name: "mv", load: async () => (await Promise.resolve().then(() => (init_mv_Z6MORUFL(), mv_Z6MORUFL_exports))).mvCommand }, { name: "ln", load: async () => (await Promise.resolve().then(() => (init_ln_YAIFIHCT(), ln_YAIFIHCT_exports))).lnCommand }, { name: "chmod", load: async () => (await Promise.resolve().then(() => (init_chmod_MIKE3OIT(), chmod_MIKE3OIT_exports))).chmodCommand }, { name: "pwd", load: async () => (await Promise.resolve().then(() => (init_pwd_D4OZ7N27(), pwd_D4OZ7N27_exports))).pwdCommand }, { name: "readlink", load: async () => (await Promise.resolve().then(() => (init_readlink_IEQO24KU(), readlink_IEQO24KU_exports))).readlinkCommand }, { name: "head", load: async () => (await Promise.resolve().then(() => (init_head_HT2B6D2J(), head_HT2B6D2J_exports))).headCommand }, { name: "tail", load: async () => (await Promise.resolve().then(() => (init_tail_S5ULNTJU(), tail_S5ULNTJU_exports))).tailCommand }, { name: "wc", load: async () => (await Promise.resolve().then(() => (init_wc_TQB3VNOX(), wc_TQB3VNOX_exports))).wcCommand }, { name: "stat", load: async () => (await Promise.resolve().then(() => (init_stat_74KBZFAX(), stat_74KBZFAX_exports))).statCommand }, { name: "grep", load: async () => (await Promise.resolve().then(() => (init_grep_BPEMMINR(), grep_BPEMMINR_exports))).grepCommand }, { name: "fgrep", load: async () => (await Promise.resolve().then(() => (init_grep_BPEMMINR(), grep_BPEMMINR_exports))).fgrepCommand }, { name: "egrep", load: async () => (await Promise.resolve().then(() => (init_grep_BPEMMINR(), grep_BPEMMINR_exports))).egrepCommand }, { name: "rg", load: async () => (await Promise.resolve().then(() => (init_rg_ORQK4GVH(), rg_ORQK4GVH_exports))).rgCommand }, { name: "sed", load: async () => (await Promise.resolve().then(() => (init_sed_7HX4RAZG(), sed_7HX4RAZG_exports))).sedCommand }, { name: "awk", load: async () => (await Promise.resolve().then(() => (init_awk2_BDPR2JPZ(), awk2_BDPR2JPZ_exports))).awkCommand2 }, { name: "sort", load: async () => (await Promise.resolve().then(() => (init_sort_T7TNLWXL(), sort_T7TNLWXL_exports))).sortCommand }, { name: "uniq", load: async () => (await Promise.resolve().then(() => (init_uniq_ZXE4O5XB(), uniq_ZXE4O5XB_exports))).uniqCommand }, { name: "comm", load: async () => (await Promise.resolve().then(() => (init_comm_5SLSESQG(), comm_5SLSESQG_exports))).commCommand }, { name: "cut", load: async () => (await Promise.resolve().then(() => (init_cut_LO6YYY5P(), cut_LO6YYY5P_exports))).cutCommand }, { name: "paste", load: async () => (await Promise.resolve().then(() => (init_paste_7N6AFSDS(), paste_7N6AFSDS_exports))).pasteCommand }, { name: "tr", load: async () => (await Promise.resolve().then(() => (init_tr_RYO2EDCA(), tr_RYO2EDCA_exports))).trCommand }, { name: "rev", load: async () => (await Promise.resolve().then(() => (init_rev_XOSYPP45(), rev_XOSYPP45_exports))).rev }, { name: "nl", load: async () => (await Promise.resolve().then(() => (init_nl_U5YJDM32(), nl_U5YJDM32_exports))).nl }, { name: "fold", load: async () => (await Promise.resolve().then(() => (init_fold_LDSORVYE(), fold_LDSORVYE_exports))).fold }, { name: "expand", load: async () => (await Promise.resolve().then(() => (init_expand_DTNXU4LQ(), expand_DTNXU4LQ_exports))).expand }, { name: "unexpand", load: async () => (await Promise.resolve().then(() => (init_unexpand_RGTMIGZM(), unexpand_RGTMIGZM_exports))).unexpand }, { name: "strings", load: async () => (await Promise.resolve().then(() => (init_strings_7PLOGTPD(), strings_7PLOGTPD_exports))).strings }, { name: "split", load: async () => (await Promise.resolve().then(() => (init_split_EZOC5IIZ(), split_EZOC5IIZ_exports))).split }, { name: "column", load: async () => (await Promise.resolve().then(() => (init_column_WLPMMSTS(), column_WLPMMSTS_exports))).column }, { name: "join", load: async () => (await Promise.resolve().then(() => (init_join_GG2LDHE5(), join_GG2LDHE5_exports))).join }, { name: "tee", load: async () => (await Promise.resolve().then(() => (init_tee_O7VXZDCO(), tee_O7VXZDCO_exports))).teeCommand }, { name: "find", load: async () => (await Promise.resolve().then(() => (init_find_74OP3M7S(), find_74OP3M7S_exports))).findCommand }, { name: "basename", load: async () => (await Promise.resolve().then(() => (init_basename_AA2KJYZQ(), basename_AA2KJYZQ_exports))).basenameCommand }, { name: "dirname", load: async () => (await Promise.resolve().then(() => (init_dirname_LEMTZZFS(), dirname_LEMTZZFS_exports))).dirnameCommand }, { name: "tree", load: async () => (await Promise.resolve().then(() => (init_tree_LYXBS7DC(), tree_LYXBS7DC_exports))).treeCommand }, { name: "du", load: async () => (await Promise.resolve().then(() => (init_du_DM4QX4XA(), du_DM4QX4XA_exports))).duCommand }, { name: "env", load: async () => (await Promise.resolve().then(() => (init_env_S547XMN7(), env_S547XMN7_exports))).envCommand }, { name: "printenv", load: async () => (await Promise.resolve().then(() => (init_env_S547XMN7(), env_S547XMN7_exports))).printenvCommand }, { name: "alias", load: async () => (await Promise.resolve().then(() => (init_alias_JE7RI5QX(), alias_JE7RI5QX_exports))).aliasCommand }, { name: "unalias", load: async () => (await Promise.resolve().then(() => (init_alias_JE7RI5QX(), alias_JE7RI5QX_exports))).unaliasCommand }, { name: "history", load: async () => (await Promise.resolve().then(() => (init_history_J4QRNGRO(), history_J4QRNGRO_exports))).historyCommand }, { name: "xargs", load: async () => (await Promise.resolve().then(() => (init_xargs_OGI2NN6J(), xargs_OGI2NN6J_exports))).xargsCommand }, { name: "true", load: async () => (await Promise.resolve().then(() => (init_true_WHJNXCHG(), true_WHJNXCHG_exports))).trueCommand }, { name: "false", load: async () => (await Promise.resolve().then(() => (init_true_WHJNXCHG(), true_WHJNXCHG_exports))).falseCommand }, { name: "clear", load: async () => (await Promise.resolve().then(() => (init_clear_5CZ5X4YR(), clear_5CZ5X4YR_exports))).clearCommand }, { name: "bash", load: async () => (await Promise.resolve().then(() => (init_bash_DYXMG247(), bash_DYXMG247_exports))).bashCommand }, { name: "sh", load: async () => (await Promise.resolve().then(() => (init_bash_DYXMG247(), bash_DYXMG247_exports))).shCommand }, { name: "jq", load: async () => (await Promise.resolve().then(() => (init_jq_OJYNICKX(), jq_OJYNICKX_exports))).jqCommand }, { name: "base64", load: async () => (await Promise.resolve().then(() => (init_base64_A3SGWC34(), base64_A3SGWC34_exports))).base64Command }, { name: "diff", load: async () => (await Promise.resolve().then(() => (init_diff_HJF2MPDN(), diff_HJF2MPDN_exports))).diffCommand }, { name: "date", load: async () => (await Promise.resolve().then(() => (init_date_DD7FVA2V(), date_DD7FVA2V_exports))).dateCommand }, { name: "sleep", load: async () => (await Promise.resolve().then(() => (init_sleep_JHK4I472(), sleep_JHK4I472_exports))).sleepCommand }, { name: "timeout", load: async () => (await Promise.resolve().then(() => (init_timeout_5UJUQXOE(), timeout_5UJUQXOE_exports))).timeoutCommand }, { name: "time", load: async () => (await Promise.resolve().then(() => (init_time_BPT76IHZ(), time_BPT76IHZ_exports))).timeCommand }, { name: "seq", load: async () => (await Promise.resolve().then(() => (init_seq_RN5ZUASB(), seq_RN5ZUASB_exports))).seqCommand }, { name: "expr", load: async () => (await Promise.resolve().then(() => (init_expr_3572LAOT(), expr_3572LAOT_exports))).exprCommand }, { name: "md5sum", load: async () => (await Promise.resolve().then(() => (init_md5sum_INMIK4DX(), md5sum_INMIK4DX_exports))).md5sumCommand }, { name: "sha1sum", load: async () => (await Promise.resolve().then(() => (init_sha1sum_VJPNLNU6(), sha1sum_VJPNLNU6_exports))).sha1sumCommand }, { name: "sha256sum", load: async () => (await Promise.resolve().then(() => (init_sha256sum_PI32XWXY(), sha256sum_PI32XWXY_exports))).sha256sumCommand }, { name: "file", load: async () => (await Promise.resolve().then(() => (init_file_ZIGAJ4YS(), file_ZIGAJ4YS_exports))).fileCommand }, { name: "html-to-markdown", load: async () => (await Promise.resolve().then(() => (init_html_to_markdown_TFCECAGV(), html_to_markdown_TFCECAGV_exports))).htmlToMarkdownCommand }, { name: "help", load: async () => (await Promise.resolve().then(() => (init_help_T2NGLTSG(), help_T2NGLTSG_exports))).helpCommand }, { name: "which", load: async () => (await Promise.resolve().then(() => (init_which_NCIYTMAT(), which_NCIYTMAT_exports))).whichCommand }, { name: "tac", load: async () => (await Promise.resolve().then(() => (init_tac_T7YAU2Y6(), tac_T7YAU2Y6_exports))).tac }, { name: "hostname", load: async () => (await Promise.resolve().then(() => (init_hostname_BK6HG2DE(), hostname_BK6HG2DE_exports))).hostname }, { name: "whoami", load: async () => (await Promise.resolve().then(() => (init_whoami_DGKU3D2X(), whoami_DGKU3D2X_exports))).whoami }, { name: "od", load: async () => (await Promise.resolve().then(() => (init_od_VJEF2UR5(), od_VJEF2UR5_exports))).od }, { name: "gzip", load: async () => (await Promise.resolve().then(() => (init_gzip_UTSGNF5Z(), gzip_UTSGNF5Z_exports))).gzipCommand }, { name: "gunzip", load: async () => (await Promise.resolve().then(() => (init_gzip_UTSGNF5Z(), gzip_UTSGNF5Z_exports))).gunzipCommand }, { name: "zcat", load: async () => (await Promise.resolve().then(() => (init_gzip_UTSGNF5Z(), gzip_UTSGNF5Z_exports))).zcatCommand }];
(typeof __BROWSER__ > "u" || !__BROWSER__) && (He7.push({ name: "tar", load: async () => (await Promise.resolve().then(() => (init_tar_K7K7BL55(), tar_K7K7BL55_exports))).tarCommand }), He7.push({ name: "yq", load: async () => (await Promise.resolve().then(() => (init_yq_FD5F3WOJ(), yq_FD5F3WOJ_exports))).yqCommand }), He7.push({ name: "xan", load: async () => (await Promise.resolve().then(() => (init_xan_Z6KVJKEE(), xan_Z6KVJKEE_exports))).xanCommand }), He7.push({ name: "sqlite3", load: async () => (await Promise.resolve().then(() => (init_sqlite3_Z2IGWYCE(), sqlite3_Z2IGWYCE_exports))).sqlite3Command }));
var Lt4 = [];
(typeof __BROWSER__ > "u" || !__BROWSER__) && (Lt4.push({ name: "python3", load: async () => (await Promise.resolve().then(() => (init_python3_W2D6SNQF(), python3_W2D6SNQF_exports))).python3Command }), Lt4.push({ name: "python", load: async () => (await Promise.resolve().then(() => (init_python3_W2D6SNQF(), python3_W2D6SNQF_exports))).pythonCommand }));
var Wr = [{ name: "curl", load: async () => (await Promise.resolve().then(() => (init_curl_6L7YZUIH(), curl_6L7YZUIH_exports))).curlCommand }];
var zr2 = /* @__PURE__ */ new Map();
function vs3(e7) {
  return { name: e7.name, async execute(t6, s9) {
    let r8 = zr2.get(e7.name);
    if (r8 || (r8 = await e7.load(), zr2.set(e7.name, r8)), s9.coverage && (typeof __BROWSER__ > "u" || !__BROWSER__)) {
      let { emitFlagCoverage: n23 } = await Promise.resolve().then(() => (init_flag_coverage_YHMPSZHK(), flag_coverage_YHMPSZHK_exports));
      n23(s9.coverage, e7.name, t6);
    }
    return r8.execute(t6, s9);
  } };
}
function Ai() {
  return He7.map((e7) => e7.name);
}
function ki2() {
  return Wr.map((e7) => e7.name);
}
function Vr(e7) {
  return (e7 ? He7.filter((s9) => e7.includes(s9.name)) : He7).map(vs3);
}
function Br3() {
  return Wr.map(vs3);
}
function _i3() {
  return Lt4.map((e7) => e7.name);
}
function jr2() {
  return Lt4.map(vs3);
}
function Ur2(e7) {
  return "load" in e7 && typeof e7.load == "function";
}
function Ci2(e7, t6) {
  return { name: e7, execute: t6 };
}
function Hr3(e7) {
  let t6 = null;
  return { name: e7.name, async execute(s9, r8) {
    return t6 || (t6 = await e7.load()), t6.execute(s9, r8);
  } };
}
var xi2 = new TextEncoder();
var Ni2 = new TextDecoder();
function De6(e7, t6) {
  if (e7 instanceof Uint8Array) return e7;
  if (t6 === "base64") return Uint8Array.from(atob(e7), (s9) => s9.charCodeAt(0));
  if (t6 === "hex") {
    let s9 = new Uint8Array(e7.length / 2);
    for (let r8 = 0; r8 < e7.length; r8 += 2) s9[r8 / 2] = parseInt(e7.slice(r8, r8 + 2), 16);
    return s9;
  }
  if (t6 === "binary" || t6 === "latin1") {
    if (e7.length <= 65536) return Uint8Array.from(e7, (n23) => n23.charCodeAt(0));
    let r8 = new Uint8Array(e7.length);
    for (let n23 = 0; n23 < e7.length; n23++) r8[n23] = e7.charCodeAt(n23);
    return r8;
  }
  return xi2.encode(e7);
}
function Qe6(e7, t6) {
  if (t6 === "base64") {
    if (typeof Buffer < "u") return Buffer.from(e7).toString("base64");
    let s9 = 65536, r8 = "";
    for (let n23 = 0; n23 < e7.length; n23 += s9) {
      let i10 = e7.subarray(n23, n23 + s9);
      r8 += String.fromCharCode(...i10);
    }
    return btoa(r8);
  }
  if (t6 === "hex") return Array.from(e7).map((s9) => s9.toString(16).padStart(2, "0")).join("");
  if (t6 === "binary" || t6 === "latin1") {
    if (typeof Buffer < "u") return Buffer.from(e7).toString(t6);
    let s9 = 65536;
    if (e7.length <= s9) return String.fromCharCode(...e7);
    let r8 = "";
    for (let n23 = 0; n23 < e7.length; n23 += s9) {
      let i10 = e7.subarray(n23, n23 + s9);
      r8 += String.fromCharCode(...i10);
    }
    return r8;
  }
  return Ni2.decode(e7);
}
function ve7(e7) {
  if (e7 != null) return typeof e7 == "string" ? e7 : e7.encoding ?? void 0;
}
var Je7 = new TextEncoder();
function Oi2(e7) {
  return typeof e7 == "object" && e7 !== null && !(e7 instanceof Uint8Array) && "content" in e7;
}
function ne9(e7, t6) {
  if (e7.includes("\0")) throw new Error(`ENOENT: path contains null byte, ${t6} '${e7}'`);
}
var Ie7 = class {
  data = /* @__PURE__ */ new Map();
  constructor(t6) {
    if (this.data.set("/", { type: "directory", mode: 493, mtime: /* @__PURE__ */ new Date() }), t6) for (let [s9, r8] of Object.entries(t6)) typeof r8 == "function" ? this.writeFileLazy(s9, r8) : Oi2(r8) ? this.writeFileSync(s9, r8.content, void 0, { mode: r8.mode, mtime: r8.mtime }) : this.writeFileSync(s9, r8);
  }
  normalizePath(t6) {
    if (!t6 || t6 === "/") return "/";
    let s9 = t6.endsWith("/") && t6 !== "/" ? t6.slice(0, -1) : t6;
    s9.startsWith("/") || (s9 = `/${s9}`);
    let r8 = s9.split("/").filter((i10) => i10 && i10 !== "."), n23 = [];
    for (let i10 of r8) i10 === ".." ? n23.pop() : n23.push(i10);
    return `/${n23.join("/")}` || "/";
  }
  dirname(t6) {
    let s9 = this.normalizePath(t6);
    if (s9 === "/") return "/";
    let r8 = s9.lastIndexOf("/");
    return r8 === 0 ? "/" : s9.slice(0, r8);
  }
  ensureParentDirs(t6) {
    let s9 = this.dirname(t6);
    s9 !== "/" && (this.data.has(s9) || (this.ensureParentDirs(s9), this.data.set(s9, { type: "directory", mode: 493, mtime: /* @__PURE__ */ new Date() })));
  }
  writeFileSync(t6, s9, r8, n23) {
    ne9(t6, "write");
    let i10 = this.normalizePath(t6);
    this.ensureParentDirs(i10);
    let o9 = ve7(r8), a7 = De6(s9, o9);
    this.data.set(i10, { type: "file", content: a7, mode: n23?.mode ?? 420, mtime: n23?.mtime ?? /* @__PURE__ */ new Date() });
  }
  writeFileLazy(t6, s9, r8) {
    ne9(t6, "write");
    let n23 = this.normalizePath(t6);
    this.ensureParentDirs(n23), this.data.set(n23, { type: "file", lazy: s9, mode: r8?.mode ?? 420, mtime: r8?.mtime ?? /* @__PURE__ */ new Date() });
  }
  async materializeLazy(t6, s9) {
    let r8 = await s9.lazy(), i10 = { type: "file", content: typeof r8 == "string" ? Je7.encode(r8) : r8, mode: s9.mode, mtime: s9.mtime };
    return this.data.set(t6, i10), i10;
  }
  async readFile(t6, s9) {
    let r8 = await this.readFileBuffer(t6), n23 = ve7(s9);
    return Qe6(r8, n23);
  }
  async readFileBuffer(t6) {
    ne9(t6, "open");
    let s9 = this.resolvePathWithSymlinks(t6), r8 = this.data.get(s9);
    if (!r8) throw new Error(`ENOENT: no such file or directory, open '${t6}'`);
    if (r8.type !== "file") throw new Error(`EISDIR: illegal operation on a directory, read '${t6}'`);
    if ("lazy" in r8) {
      let n23 = await this.materializeLazy(s9, r8);
      return n23.content instanceof Uint8Array ? n23.content : Je7.encode(n23.content);
    }
    return r8.content instanceof Uint8Array ? r8.content : Je7.encode(r8.content);
  }
  async writeFile(t6, s9, r8) {
    this.writeFileSync(t6, s9, r8);
  }
  async appendFile(t6, s9, r8) {
    ne9(t6, "append");
    let n23 = this.normalizePath(t6), i10 = this.data.get(n23);
    if (i10 && i10.type === "directory") throw new Error(`EISDIR: illegal operation on a directory, write '${t6}'`);
    let o9 = ve7(r8), a7 = De6(s9, o9);
    if (i10?.type === "file") {
      let l8 = i10;
      "lazy" in l8 && (l8 = await this.materializeLazy(n23, l8));
      let c15 = "content" in l8 && l8.content instanceof Uint8Array ? l8.content : Je7.encode("content" in l8 ? l8.content : ""), u11 = new Uint8Array(c15.length + a7.length);
      u11.set(c15), u11.set(a7, c15.length), this.data.set(n23, { type: "file", content: u11, mode: l8.mode, mtime: /* @__PURE__ */ new Date() });
    } else this.writeFileSync(t6, s9, r8);
  }
  async exists(t6) {
    if (t6.includes("\0")) return false;
    try {
      let s9 = this.resolvePathWithSymlinks(t6);
      return this.data.has(s9);
    } catch {
      return false;
    }
  }
  async stat(t6) {
    ne9(t6, "stat");
    let s9 = this.resolvePathWithSymlinks(t6), r8 = this.data.get(s9);
    if (!r8) throw new Error(`ENOENT: no such file or directory, stat '${t6}'`);
    r8.type === "file" && "lazy" in r8 && (r8 = await this.materializeLazy(s9, r8));
    let n23 = 0;
    return r8.type === "file" && "content" in r8 && r8.content && (r8.content instanceof Uint8Array ? n23 = r8.content.length : n23 = Je7.encode(r8.content).length), { isFile: r8.type === "file", isDirectory: r8.type === "directory", isSymbolicLink: false, mode: r8.mode, size: n23, mtime: r8.mtime || /* @__PURE__ */ new Date() };
  }
  async lstat(t6) {
    ne9(t6, "lstat");
    let s9 = this.resolveIntermediateSymlinks(t6), r8 = this.data.get(s9);
    if (!r8) throw new Error(`ENOENT: no such file or directory, lstat '${t6}'`);
    if (r8.type === "symlink") return { isFile: false, isDirectory: false, isSymbolicLink: true, mode: r8.mode, size: r8.target.length, mtime: r8.mtime || /* @__PURE__ */ new Date() };
    r8.type === "file" && "lazy" in r8 && (r8 = await this.materializeLazy(s9, r8));
    let n23 = 0;
    return r8.type === "file" && "content" in r8 && r8.content && (r8.content instanceof Uint8Array ? n23 = r8.content.length : n23 = Je7.encode(r8.content).length), { isFile: r8.type === "file", isDirectory: r8.type === "directory", isSymbolicLink: false, mode: r8.mode, size: n23, mtime: r8.mtime || /* @__PURE__ */ new Date() };
  }
  resolveSymlink(t6, s9) {
    if (s9.startsWith("/")) return this.normalizePath(s9);
    let r8 = this.dirname(t6);
    return this.normalizePath(r8 === "/" ? `/${s9}` : `${r8}/${s9}`);
  }
  resolveIntermediateSymlinks(t6) {
    let s9 = this.normalizePath(t6);
    if (s9 === "/") return "/";
    let r8 = s9.slice(1).split("/");
    if (r8.length <= 1) return s9;
    let n23 = "", i10 = /* @__PURE__ */ new Set();
    for (let o9 = 0; o9 < r8.length - 1; o9++) {
      let a7 = r8[o9];
      n23 = `${n23}/${a7}`;
      let l8 = this.data.get(n23), c15 = 0, u11 = 40;
      for (; l8 && l8.type === "symlink" && c15 < u11; ) {
        if (i10.has(n23)) throw new Error(`ELOOP: too many levels of symbolic links, lstat '${t6}'`);
        i10.add(n23), n23 = this.resolveSymlink(n23, l8.target), l8 = this.data.get(n23), c15++;
      }
      if (c15 >= u11) throw new Error(`ELOOP: too many levels of symbolic links, lstat '${t6}'`);
    }
    return `${n23}/${r8[r8.length - 1]}`;
  }
  resolvePathWithSymlinks(t6) {
    let s9 = this.normalizePath(t6);
    if (s9 === "/") return "/";
    let r8 = s9.slice(1).split("/"), n23 = "", i10 = /* @__PURE__ */ new Set();
    for (let o9 of r8) {
      n23 = `${n23}/${o9}`;
      let a7 = this.data.get(n23), l8 = 0, c15 = 40;
      for (; a7 && a7.type === "symlink" && l8 < c15; ) {
        if (i10.has(n23)) throw new Error(`ELOOP: too many levels of symbolic links, open '${t6}'`);
        i10.add(n23), n23 = this.resolveSymlink(n23, a7.target), a7 = this.data.get(n23), l8++;
      }
      if (l8 >= c15) throw new Error(`ELOOP: too many levels of symbolic links, open '${t6}'`);
    }
    return n23;
  }
  async mkdir(t6, s9) {
    this.mkdirSync(t6, s9);
  }
  mkdirSync(t6, s9) {
    ne9(t6, "mkdir");
    let r8 = this.normalizePath(t6);
    if (this.data.has(r8)) {
      if (this.data.get(r8)?.type === "file") throw new Error(`EEXIST: file already exists, mkdir '${t6}'`);
      if (!s9?.recursive) throw new Error(`EEXIST: directory already exists, mkdir '${t6}'`);
      return;
    }
    let n23 = this.dirname(r8);
    if (n23 !== "/" && !this.data.has(n23)) if (s9?.recursive) this.mkdirSync(n23, { recursive: true });
    else throw new Error(`ENOENT: no such file or directory, mkdir '${t6}'`);
    this.data.set(r8, { type: "directory", mode: 493, mtime: /* @__PURE__ */ new Date() });
  }
  async readdir(t6) {
    return (await this.readdirWithFileTypes(t6)).map((r8) => r8.name);
  }
  async readdirWithFileTypes(t6) {
    ne9(t6, "scandir");
    let s9 = this.normalizePath(t6), r8 = this.data.get(s9);
    if (!r8) throw new Error(`ENOENT: no such file or directory, scandir '${t6}'`);
    let n23 = /* @__PURE__ */ new Set();
    for (; r8 && r8.type === "symlink"; ) {
      if (n23.has(s9)) throw new Error(`ELOOP: too many levels of symbolic links, scandir '${t6}'`);
      n23.add(s9), s9 = this.resolveSymlink(s9, r8.target), r8 = this.data.get(s9);
    }
    if (!r8) throw new Error(`ENOENT: no such file or directory, scandir '${t6}'`);
    if (r8.type !== "directory") throw new Error(`ENOTDIR: not a directory, scandir '${t6}'`);
    let i10 = s9 === "/" ? "/" : `${s9}/`, o9 = /* @__PURE__ */ new Map();
    for (let [a7, l8] of this.data.entries()) if (a7 !== s9 && a7.startsWith(i10)) {
      let c15 = a7.slice(i10.length), u11 = c15.split("/")[0];
      u11 && !c15.includes("/", u11.length) && !o9.has(u11) && o9.set(u11, { name: u11, isFile: l8.type === "file", isDirectory: l8.type === "directory", isSymbolicLink: l8.type === "symlink" });
    }
    return Array.from(o9.values()).sort((a7, l8) => a7.name < l8.name ? -1 : a7.name > l8.name ? 1 : 0);
  }
  async rm(t6, s9) {
    ne9(t6, "rm");
    let r8 = this.normalizePath(t6), n23 = this.data.get(r8);
    if (!n23) {
      if (s9?.force) return;
      throw new Error(`ENOENT: no such file or directory, rm '${t6}'`);
    }
    if (n23.type === "directory") {
      let i10 = await this.readdir(r8);
      if (i10.length > 0) {
        if (!s9?.recursive) throw new Error(`ENOTEMPTY: directory not empty, rm '${t6}'`);
        for (let o9 of i10) {
          let a7 = r8 === "/" ? `/${o9}` : `${r8}/${o9}`;
          await this.rm(a7, s9);
        }
      }
    }
    this.data.delete(r8);
  }
  async cp(t6, s9, r8) {
    ne9(t6, "cp"), ne9(s9, "cp");
    let n23 = this.normalizePath(t6), i10 = this.normalizePath(s9), o9 = this.data.get(n23);
    if (!o9) throw new Error(`ENOENT: no such file or directory, cp '${t6}'`);
    if (o9.type === "file") if (this.ensureParentDirs(i10), "content" in o9) {
      let a7 = o9.content instanceof Uint8Array ? new Uint8Array(o9.content) : o9.content;
      this.data.set(i10, { ...o9, content: a7 });
    } else this.data.set(i10, { ...o9 });
    else if (o9.type === "symlink") this.ensureParentDirs(i10), this.data.set(i10, { ...o9 });
    else if (o9.type === "directory") {
      if (!r8?.recursive) throw new Error(`EISDIR: is a directory, cp '${t6}'`);
      await this.mkdir(i10, { recursive: true });
      let a7 = await this.readdir(n23);
      for (let l8 of a7) {
        let c15 = n23 === "/" ? `/${l8}` : `${n23}/${l8}`, u11 = i10 === "/" ? `/${l8}` : `${i10}/${l8}`;
        await this.cp(c15, u11, r8);
      }
    }
  }
  async mv(t6, s9) {
    await this.cp(t6, s9, { recursive: true }), await this.rm(t6, { recursive: true });
  }
  getAllPaths() {
    return Array.from(this.data.keys());
  }
  resolvePath(t6, s9) {
    if (s9.startsWith("/")) return this.normalizePath(s9);
    let r8 = t6 === "/" ? `/${s9}` : `${t6}/${s9}`;
    return this.normalizePath(r8);
  }
  async chmod(t6, s9) {
    ne9(t6, "chmod");
    let r8 = this.normalizePath(t6), n23 = this.data.get(r8);
    if (!n23) throw new Error(`ENOENT: no such file or directory, chmod '${t6}'`);
    n23.mode = s9;
  }
  async symlink(t6, s9) {
    ne9(s9, "symlink");
    let r8 = this.normalizePath(s9);
    if (this.data.has(r8)) throw new Error(`EEXIST: file already exists, symlink '${s9}'`);
    this.ensureParentDirs(r8), this.data.set(r8, { type: "symlink", target: t6, mode: 511, mtime: /* @__PURE__ */ new Date() });
  }
  async link(t6, s9) {
    ne9(t6, "link"), ne9(s9, "link");
    let r8 = this.normalizePath(t6), n23 = this.normalizePath(s9), i10 = this.data.get(r8);
    if (!i10) throw new Error(`ENOENT: no such file or directory, link '${t6}'`);
    if (i10.type !== "file") throw new Error(`EPERM: operation not permitted, link '${t6}'`);
    if (this.data.has(n23)) throw new Error(`EEXIST: file already exists, link '${s9}'`);
    let o9 = i10;
    "lazy" in o9 && (o9 = await this.materializeLazy(r8, o9)), this.ensureParentDirs(n23), this.data.set(n23, { type: "file", content: o9.content, mode: o9.mode, mtime: o9.mtime });
  }
  async readlink(t6) {
    ne9(t6, "readlink");
    let s9 = this.normalizePath(t6), r8 = this.data.get(s9);
    if (!r8) throw new Error(`ENOENT: no such file or directory, readlink '${t6}'`);
    if (r8.type !== "symlink") throw new Error(`EINVAL: invalid argument, readlink '${t6}'`);
    return r8.target;
  }
  async realpath(t6) {
    ne9(t6, "realpath");
    let s9 = this.resolvePathWithSymlinks(t6);
    if (!this.data.has(s9)) throw new Error(`ENOENT: no such file or directory, realpath '${t6}'`);
    return s9;
  }
  async utimes(t6, s9, r8) {
    ne9(t6, "utimes");
    let n23 = this.normalizePath(t6), i10 = this.resolvePathWithSymlinks(n23), o9 = this.data.get(i10);
    if (!o9) throw new Error(`ENOENT: no such file or directory, utimes '${t6}'`);
    o9.mtime = r8;
  }
};
function Ti2(e7) {
  let t6 = e7;
  return typeof t6.mkdirSync == "function" && typeof t6.writeFileSync == "function";
}
function Di2(e7, t6) {
  e7.mkdirSync("/bin", { recursive: true }), e7.mkdirSync("/usr/bin", { recursive: true }), t6 && (e7.mkdirSync("/home/user", { recursive: true }), e7.mkdirSync("/tmp", { recursive: true }));
}
function Ii2(e7) {
  e7.mkdirSync("/dev", { recursive: true }), e7.writeFileSync("/dev/null", ""), e7.writeFileSync("/dev/zero", new Uint8Array(0)), e7.writeFileSync("/dev/stdin", ""), e7.writeFileSync("/dev/stdout", ""), e7.writeFileSync("/dev/stderr", "");
}
function Ri(e7, t6) {
  e7.mkdirSync("/proc/self/fd", { recursive: true }), e7.writeFileSync("/proc/version", `${vi}
`), e7.writeFileSync("/proc/self/exe", "/bin/bash"), e7.writeFileSync("/proc/self/cmdline", "bash\0"), e7.writeFileSync("/proc/self/comm", `bash
`), e7.writeFileLazy ? e7.writeFileLazy("/proc/self/status", () => Di(t6)) : e7.writeFileSync("/proc/self/status", Di(t6)), e7.writeFileSync("/proc/self/fd/0", "/dev/stdin"), e7.writeFileSync("/proc/self/fd/1", "/dev/stdout"), e7.writeFileSync("/proc/self/fd/2", "/dev/stderr");
}
function qr2(e7, t6, s9 = { pid: 1, ppid: 0, uid: 1e3, gid: 1e3 }) {
  Ti2(e7) && (Di2(e7, t6), Ii2(e7), Ri(e7, s9));
}
var Li3 = ["allexport", "errexit", "noglob", "noclobber", "noexec", "nounset", "pipefail", "posix", "verbose", "xtrace"];
var Mi3 = ["braceexpand", "hashall", "interactive-comments"];
function bs2(e7) {
  let t6 = [], s9 = [...Mi3.map((r8) => ({ name: r8, enabled: true })), ...Li3.map((r8) => ({ name: r8, enabled: e7[r8] }))].sort((r8, n23) => r8.name.localeCompare(n23.name));
  for (let r8 of s9) r8.enabled && t6.push(r8.name);
  return t6.join(":");
}
function et7(e7) {
  e7.state.env.set("SHELLOPTS", bs2(e7.state.options));
}
var Fi2 = ["dotglob", "expand_aliases", "extglob", "failglob", "globskipdots", "globstar", "lastpipe", "nocaseglob", "nocasematch", "nullglob", "xpg_echo"];
function Es2(e7) {
  let t6 = [];
  for (let s9 of Fi2) e7[s9] && t6.push(s9);
  return t6.join(":");
}
function $s3(e7) {
  e7.state.env.set("BASHOPTS", Es2(e7.state.shoptOptions));
}
var zi = "BASH_ALIAS_";
function Gr(e7) {
  return e7.parts.length !== 1 ? false : e7.parts[0].type === "Literal";
}
function Zr3(e7) {
  if (e7.parts.length !== 1) return null;
  let t6 = e7.parts[0];
  return t6.type === "Literal" ? t6.value : null;
}
function Kr(e7, t6) {
  return e7.env.get(`${zi}${t6}`);
}
function Ss2(e7, t6, s9) {
  if (!t6.name || !Gr(t6.name)) return t6;
  let r8 = Zr3(t6.name);
  if (!r8) return t6;
  let n23 = Kr(e7, r8);
  if (!n23 || s9.has(r8)) return t6;
  try {
    s9.add(r8);
    let i10 = new V2(), o9 = n23, a7 = n23.endsWith(" ");
    if (!a7) for (let f11 of t6.args) {
      let d16 = Yr2(f11);
      o9 += ` ${d16}`;
    }
    let l8;
    try {
      l8 = i10.parse(o9);
    } catch (f11) {
      if (f11 instanceof Q2) throw f11;
      return t6;
    }
    if (l8.statements.length !== 1 || l8.statements[0].pipelines.length !== 1 || l8.statements[0].pipelines[0].commands.length !== 1) return Xr2(t6, n23);
    let c15 = l8.statements[0].pipelines[0].commands[0];
    if (c15.type !== "SimpleCommand") return Xr2(t6, n23);
    let u11 = { ...c15, assignments: [...t6.assignments, ...c15.assignments], redirections: [...c15.redirections, ...t6.redirections], line: t6.line };
    if (a7 && t6.args.length > 0 && (u11 = { ...u11, args: [...u11.args, ...t6.args] }, u11.args.length > 0)) {
      let f11 = u11.args[0];
      if (Gr(f11)) {
        let d16 = Zr3(f11);
        if (d16 && Kr(e7, d16)) {
          let h17 = { type: "SimpleCommand", name: f11, args: u11.args.slice(1), assignments: [], redirections: [] }, m25 = Ss2(e7, h17, s9);
          m25 !== h17 && (u11 = { ...u11, name: m25.name, args: [...m25.args] });
        }
      }
    }
    return u11;
  } catch (i10) {
    throw s9.delete(r8), i10;
  }
}
function Xr2(e7, t6) {
  let s9 = t6;
  for (let o9 of e7.args) {
    let a7 = Yr2(o9);
    s9 += ` ${a7}`;
  }
  let r8 = new V2(), n23 = r8.parseWordFromString("eval", false, false), i10 = r8.parseWordFromString(`'${s9.replace(/'/g, "'\\''")}'`, false, false);
  return { type: "SimpleCommand", name: n23, args: [i10], assignments: e7.assignments, redirections: e7.redirections, line: e7.line };
}
function Yr2(e7) {
  let t6 = "";
  for (let s9 of e7.parts) switch (s9.type) {
    case "Literal":
      t6 += s9.value.replace(/([\s"'$`\\*?[\]{}()<>|&;#!])/g, "\\$1");
      break;
    case "SingleQuoted":
      t6 += `'${s9.value}'`;
      break;
    case "DoubleQuoted":
      t6 += `"${s9.parts.map((r8) => r8.type === "Literal" ? r8.value : `$${r8.type}`).join("")}"`;
      break;
    case "ParameterExpansion":
      t6 += `\${${s9.parameter}}`;
      break;
    case "CommandSubstitution":
      t6 += "$(...)";
      break;
    case "ArithmeticExpansion":
      t6 += `$((${s9.expression}))`;
      break;
    case "Glob":
      t6 += s9.pattern;
      break;
    default:
      break;
  }
  return t6;
}
async function Qr2(e7, t6) {
  let s9 = t6.parts.map((u11) => u11.type === "Literal" ? u11.value : "\0").join(""), r8 = s9.match(/^([a-zA-Z_][a-zA-Z0-9_]*)=\(/);
  if (!r8 || !s9.endsWith(")")) return null;
  let n23 = r8[1], i10 = [], o9 = false, a7 = "", l8 = false;
  for (let u11 of t6.parts) if (u11.type === "Literal") {
    let f11 = u11.value;
    if (!o9) {
      let d16 = f11.indexOf("=(");
      d16 !== -1 && (o9 = true, f11 = f11.slice(d16 + 2));
    }
    if (o9) {
      f11.endsWith(")") && (f11 = f11.slice(0, -1));
      let d16 = f11.split(/(\s+)/);
      for (let h17 of d16) /^\s+$/.test(h17) ? (a7 || l8) && (i10.push(a7), a7 = "", l8 = false) : h17 && (a7 += h17);
    }
  } else if (o9) if (u11.type === "BraceExpansion") if (/^\[.+\]=/.test(a7)) a7 += gn({ type: "Word", parts: [u11] });
  else {
    (a7 || l8) && (i10.push(a7), a7 = "", l8 = false);
    let d16 = await Sl(e7, { type: "Word", parts: [u11] });
    i10.push(...d16.values);
  }
  else {
    (u11.type === "SingleQuoted" || u11.type === "DoubleQuoted" || u11.type === "Escaped") && (l8 = true);
    let f11 = await kt(e7, { type: "Word", parts: [u11] });
    a7 += f11;
  }
  (a7 || l8) && i10.push(a7);
  let c15 = i10.map((u11) => /^\[.+\]=/.test(u11) ? u11 : u11 === "" ? "''" : /[\s"'\\$`!*?[\]{}|&;<>()]/.test(u11) && !u11.startsWith("'") && !u11.startsWith('"') ? `'${u11.replace(/'/g, "'\\''")}'` : u11);
  return `${n23}=(${c15.join(" ")})`;
}
async function Jr2(e7, t6) {
  let s9 = -1, r8 = -1, n23 = false;
  for (let p17 = 0; p17 < t6.parts.length; p17++) {
    let g18 = t6.parts[p17];
    if (g18.type === "Literal") {
      let S17 = g18.value.indexOf("+=");
      if (S17 !== -1) {
        let P20 = g18.value.slice(0, S17);
        if (/^[a-zA-Z_][a-zA-Z0-9_]*$/.test(P20)) {
          s9 = p17, r8 = S17, n23 = true;
          break;
        }
        if (/^[a-zA-Z_][a-zA-Z0-9_]*\[[^\]]+\]$/.test(P20)) {
          s9 = p17, r8 = S17, n23 = true;
          break;
        }
      }
      let v21 = g18.value.indexOf("=");
      if (v21 !== -1 && (v21 === 0 || g18.value[v21 - 1] !== "+")) {
        let P20 = g18.value.slice(0, v21);
        if (/^[a-zA-Z_][a-zA-Z0-9_]*$/.test(P20) || /^[a-zA-Z_][a-zA-Z0-9_]*\[[^\]]+\]$/.test(P20)) {
          s9 = p17, r8 = v21;
          break;
        }
      }
    }
  }
  if (s9 === -1) return null;
  let i10 = t6.parts.slice(0, s9), o9 = t6.parts[s9];
  if (o9.type !== "Literal") return null;
  let a7 = n23 ? 2 : 1, l8 = o9.value.slice(0, r8), c15 = o9.value.slice(r8 + a7), u11 = t6.parts.slice(s9 + 1), f11 = "";
  for (let p17 of i10) f11 += await kt(e7, { type: "Word", parts: [p17] });
  f11 += l8;
  let d16 = { type: "Word", parts: c15 !== "" ? [{ type: "Literal", value: c15 }, ...u11] : u11 }, h17 = d16.parts.length > 0 ? await kt(e7, d16) : "";
  return `${f11}${n23 ? "+=" : "="}${h17}`;
}
var Wi2 = ["tar", "yq", "xan", "sqlite3", "python3", "python"];
function en3(e7) {
  return Wi2.includes(e7);
}
var L17 = Object.freeze({ stdout: "", stderr: "", exitCode: 0 });
function M14(e7 = "") {
  return { stdout: e7, stderr: "", exitCode: 0 };
}
function A13(e7, t6 = 1) {
  return { stdout: "", stderr: e7, exitCode: t6 };
}
function _14(e7, t6, s9) {
  return { stdout: e7, stderr: t6, exitCode: s9 };
}
function Y10(e7) {
  return { stdout: "", stderr: "", exitCode: e7 ? 0 : 1 };
}
function Re7(e7, t6, s9 = "", r8 = "") {
  throw new b2(e7, t6, s9, r8);
}
function Ps2(e7, t6) {
  if (e7.state.loopDepth === 0) {
    if (e7.state.parentHasLoopContext) throw new $2();
    return L17;
  }
  if (t6.length > 1) throw new d2(1, "", `bash: break: too many arguments
`);
  let s9 = 1;
  if (t6.length > 0) {
    let r8 = Number.parseInt(t6[0], 10);
    if (Number.isNaN(r8) || r8 < 1) throw new d2(128, "", `bash: break: ${t6[0]}: numeric argument required
`);
    s9 = r8;
  }
  throw new c2(s9);
}
async function As2(e7, t6) {
  let s9, r8 = false, n23 = false, i10 = 0;
  for (; i10 < t6.length; ) if (t6[i10] === "--") {
    i10++;
    break;
  } else if (t6[i10] === "-L") n23 = false, i10++;
  else if (t6[i10] === "-P") n23 = true, i10++;
  else if (t6[i10].startsWith("-") && t6[i10] !== "-") i10++;
  else break;
  let o9 = t6.slice(i10);
  if (o9.length === 0 || o9[0] === "~" ? s9 = e7.state.env.get("HOME") || "/" : o9[0] === "-" ? (s9 = e7.state.previousDir, r8 = true) : s9 = o9[0], !s9.startsWith("/") && !s9.startsWith("./") && !s9.startsWith("../") && s9 !== "." && s9 !== "..") {
    let f11 = e7.state.env.get("CDPATH");
    if (f11) {
      let d16 = f11.split(":").filter((h17) => h17);
      for (let h17 of d16) {
        let m25 = h17.startsWith("/") ? `${h17}/${s9}` : `${e7.state.cwd}/${h17}/${s9}`;
        try {
          if ((await e7.fs.stat(m25)).isDirectory) {
            s9 = m25, r8 = true;
            break;
          }
        } catch {
        }
      }
    }
  }
  let l8 = (s9.startsWith("/") ? s9 : `${e7.state.cwd}/${s9}`).split("/").filter((f11) => f11 && f11 !== "."), c15 = "";
  for (let f11 of l8) if (f11 === "..") c15 = c15.split("/").slice(0, -1).join("/") || "/";
  else {
    c15 = c15 ? `${c15}/${f11}` : `/${f11}`;
    try {
      if (!(await e7.fs.stat(c15)).isDirectory) return A13(`bash: cd: ${s9}: Not a directory
`);
    } catch {
      return A13(`bash: cd: ${s9}: No such file or directory
`);
    }
  }
  let u11 = c15 || "/";
  if (n23) try {
    u11 = await e7.fs.realpath(u11);
  } catch {
  }
  return e7.state.previousDir = e7.state.cwd, e7.state.cwd = u11, e7.state.env.set("PWD", e7.state.cwd), e7.state.env.set("OLDPWD", e7.state.previousDir), M14(r8 ? `${u11}
` : "");
}
function ks3(e7, t6) {
  return e7.fs.resolvePath(e7.state.cwd, t6);
}
var Vi2 = ["-e", "-a", "-f", "-d", "-r", "-w", "-x", "-s", "-L", "-h", "-k", "-g", "-u", "-G", "-O", "-b", "-c", "-p", "-S", "-t", "-N"];
function Mt3(e7) {
  return Vi2.includes(e7);
}
async function Ft3(e7, t6, s9) {
  let r8 = ks3(e7, s9);
  switch (t6) {
    case "-e":
    case "-a":
      return e7.fs.exists(r8);
    case "-f":
      return await e7.fs.exists(r8) ? (await e7.fs.stat(r8)).isFile : false;
    case "-d":
      return await e7.fs.exists(r8) ? (await e7.fs.stat(r8)).isDirectory : false;
    case "-r":
      return await e7.fs.exists(r8) ? ((await e7.fs.stat(r8)).mode & 256) !== 0 : false;
    case "-w":
      return await e7.fs.exists(r8) ? ((await e7.fs.stat(r8)).mode & 128) !== 0 : false;
    case "-x":
      return await e7.fs.exists(r8) ? ((await e7.fs.stat(r8)).mode & 64) !== 0 : false;
    case "-s":
      return await e7.fs.exists(r8) ? (await e7.fs.stat(r8)).size > 0 : false;
    case "-L":
    case "-h":
      try {
        return (await e7.fs.lstat(r8)).isSymbolicLink;
      } catch {
        return false;
      }
    case "-k":
      return await e7.fs.exists(r8) ? ((await e7.fs.stat(r8)).mode & 512) !== 0 : false;
    case "-g":
      return await e7.fs.exists(r8) ? ((await e7.fs.stat(r8)).mode & 1024) !== 0 : false;
    case "-u":
      return await e7.fs.exists(r8) ? ((await e7.fs.stat(r8)).mode & 2048) !== 0 : false;
    case "-G":
    case "-O":
      return e7.fs.exists(r8);
    case "-b":
      return false;
    case "-c":
      return ["/dev/null", "/dev/zero", "/dev/random", "/dev/urandom", "/dev/tty", "/dev/stdin", "/dev/stdout", "/dev/stderr"].includes(r8);
    case "-p":
      return false;
    case "-S":
      return false;
    case "-t":
      return false;
    case "-N":
      return e7.fs.exists(r8);
    default:
      return false;
  }
}
var Bi3 = ["-nt", "-ot", "-ef"];
function zt3(e7) {
  return Bi3.includes(e7);
}
async function Wt3(e7, t6, s9, r8) {
  let n23 = ks3(e7, s9), i10 = ks3(e7, r8);
  switch (t6) {
    case "-nt":
      try {
        let o9 = await e7.fs.stat(n23), a7 = await e7.fs.stat(i10);
        return o9.mtime > a7.mtime;
      } catch {
        return false;
      }
    case "-ot":
      try {
        let o9 = await e7.fs.stat(n23), a7 = await e7.fs.stat(i10);
        return o9.mtime < a7.mtime;
      } catch {
        return false;
      }
    case "-ef":
      try {
        if (!await e7.fs.exists(n23) || !await e7.fs.exists(i10)) return false;
        let o9 = e7.fs.resolvePath(e7.state.cwd, n23), a7 = e7.fs.resolvePath(e7.state.cwd, i10);
        return o9 === a7;
      } catch {
        return false;
      }
    default:
      return false;
  }
}
var ji = /* @__PURE__ */ new Set(["-eq", "-ne", "-lt", "-le", "-gt", "-ge"]);
function Vt2(e7) {
  return ji.has(e7);
}
function Bt2(e7, t6, s9) {
  switch (e7) {
    case "-eq":
      return t6 === s9;
    case "-ne":
      return t6 !== s9;
    case "-lt":
      return t6 < s9;
    case "-le":
      return t6 <= s9;
    case "-gt":
      return t6 > s9;
    case "-ge":
      return t6 >= s9;
  }
}
function yt5(e7) {
  return e7 === "=" || e7 === "==" || e7 === "!=";
}
function jt3(e7, t6, s9, r8 = false, n23 = false, i10 = false) {
  if (r8) {
    let a7 = tt7(t6, s9, n23, i10);
    return e7 === "!=" ? !a7 : a7;
  }
  if (n23) {
    let a7 = t6.toLowerCase() === s9.toLowerCase();
    return e7 === "!=" ? !a7 : a7;
  }
  let o9 = t6 === s9;
  return e7 === "!=" ? !o9 : o9;
}
var Ui2 = /* @__PURE__ */ new Set(["-z", "-n"]);
function Ut3(e7) {
  return Ui2.has(e7);
}
function Ht3(e7, t6) {
  switch (e7) {
    case "-z":
      return t6 === "";
    case "-n":
      return t6 !== "";
  }
}
async function qt3(e7, t6) {
  let s9 = t6.match(/^([a-zA-Z_][a-zA-Z0-9_]*)\[(.+)\]$/);
  if (s9) {
    let r8 = s9[1], n23 = s9[2];
    if (e7.state.associativeArrays?.has(r8)) {
      let a7 = n23;
      return (a7.startsWith("'") && a7.endsWith("'") || a7.startsWith('"') && a7.endsWith('"')) && (a7 = a7.slice(1, -1)), a7 = a7.replace(/\$([a-zA-Z_][a-zA-Z0-9_]*)/g, (l8, c15) => e7.state.env.get(c15) || ""), e7.state.env.has(`${r8}_${a7}`);
    }
    let o9;
    try {
      let a7 = new V2(), l8 = M2(a7, n23);
      o9 = await R(e7, l8.expression);
    } catch {
      if (/^-?\d+$/.test(n23)) o9 = Number.parseInt(n23, 10);
      else {
        let a7 = e7.state.env.get(n23);
        o9 = a7 ? Number.parseInt(a7, 10) : 0;
      }
    }
    if (o9 < 0) {
      let a7 = dt(e7, r8), l8 = e7.state.currentLine;
      if (a7.length === 0) return e7.state.expansionStderr = (e7.state.expansionStderr || "") + `bash: line ${l8}: ${r8}: bad array subscript
`, false;
      if (o9 = Math.max(...a7) + 1 + o9, o9 < 0) return e7.state.expansionStderr = (e7.state.expansionStderr || "") + `bash: line ${l8}: ${r8}: bad array subscript
`, false;
    }
    return e7.state.env.has(`${r8}_${o9}`);
  }
  return e7.state.env.has(t6) ? true : e7.state.associativeArrays?.has(t6) ? mt(e7, t6).length > 0 : dt(e7, t6).length > 0;
}
async function We6(e7, t6) {
  switch (t6.type) {
    case "CondBinary": {
      let s9 = await kt(e7, t6.left), r8 = t6.right.parts.length > 0 && t6.right.parts.every((i10) => i10.type === "SingleQuoted" || i10.type === "DoubleQuoted" || i10.type === "Escaped" && t6.operator !== "=~"), n23;
      if (t6.operator === "=~") if (r8) {
        let i10 = await kt(e7, t6.right);
        n23 = St(i10);
      } else n23 = await El(e7, t6.right);
      else yt5(t6.operator) && !r8 ? n23 = await Al(e7, t6.right) : n23 = await kt(e7, t6.right);
      if (yt5(t6.operator)) {
        let i10 = e7.state.shoptOptions.nocasematch;
        return jt3(t6.operator, s9, n23, !r8, i10, true);
      }
      if (Vt2(t6.operator)) return Bt2(t6.operator, await sn2(e7, s9), await sn2(e7, n23));
      if (zt3(t6.operator)) return Wt3(e7, t6.operator, s9, n23);
      switch (t6.operator) {
        case "=~":
          try {
            let i10 = e7.state.shoptOptions.nocasematch, o9 = Zi(n23), l8 = b1(o9, i10 ? "i" : "").match(s9);
            if (_i(e7, "BASH_REMATCH"), l8) for (let c15 = 0; c15 < l8.length; c15++) e7.state.env.set(`BASH_REMATCH_${c15}`, l8[c15] || "");
            return l8 !== null;
          } catch {
            throw new Error("syntax error in regular expression");
          }
        case "<":
          return s9 < n23;
        case ">":
          return s9 > n23;
        default:
          return false;
      }
    }
    case "CondUnary": {
      let s9 = await kt(e7, t6.operand);
      return Mt3(t6.operator) ? Ft3(e7, t6.operator, s9) : Ut3(t6.operator) ? Ht3(t6.operator, s9) : t6.operator === "-v" ? await qt3(e7, s9) : t6.operator === "-o" ? Cs3(e7, s9) : false;
    }
    case "CondNot":
      return e7.state.shoptOptions.extglob && t6.operand.type === "CondGroup" && t6.operand.expression.type === "CondWord" ? `!(${await kt(e7, t6.operand.expression.word)})` !== "" : !await We6(e7, t6.operand);
    case "CondAnd":
      return await We6(e7, t6.left) ? await We6(e7, t6.right) : false;
    case "CondOr":
      return await We6(e7, t6.left) ? true : await We6(e7, t6.right);
    case "CondGroup":
      return await We6(e7, t6.expression);
    case "CondWord":
      return await kt(e7, t6.word) !== "";
    default:
      return false;
  }
}
async function gt3(e7, t6) {
  if (t6.length === 0) return _14("", "", 1);
  if (t6.length === 1) return Y10(!!t6[0]);
  if (t6.length === 2) {
    let r8 = t6[0], n23 = t6[1];
    return r8 === "(" ? A13(`test: '(' without matching ')'
`, 2) : Mt3(r8) ? Y10(await Ft3(e7, r8, n23)) : Ut3(r8) ? Y10(Ht3(r8, n23)) : r8 === "!" ? Y10(!n23) : r8 === "-v" ? Y10(await qt3(e7, n23)) : r8 === "-o" ? Y10(Cs3(e7, n23)) : r8 === "=" || r8 === "==" || r8 === "!=" || r8 === "<" || r8 === ">" || r8 === "-eq" || r8 === "-ne" || r8 === "-lt" || r8 === "-le" || r8 === "-gt" || r8 === "-ge" || r8 === "-nt" || r8 === "-ot" || r8 === "-ef" ? A13(`test: ${r8}: unary operator expected
`, 2) : _14("", "", 1);
  }
  if (t6.length === 3) {
    let r8 = t6[0], n23 = t6[1], i10 = t6[2];
    if (yt5(n23)) return Y10(jt3(n23, r8, i10));
    if (Vt2(n23)) {
      let o9 = Gt3(r8), a7 = Gt3(i10);
      return !o9.valid || !a7.valid ? _14("", "", 2) : Y10(Bt2(n23, o9.value, a7.value));
    }
    if (zt3(n23)) return Y10(await Wt3(e7, n23, r8, i10));
    switch (n23) {
      case "-a":
        return Y10(r8 !== "" && i10 !== "");
      case "-o":
        return Y10(r8 !== "" || i10 !== "");
      case ">":
        return Y10(r8 > i10);
      case "<":
        return Y10(r8 < i10);
    }
    if (r8 === "!") {
      let o9 = await gt3(e7, [n23, i10]);
      return _14("", o9.stderr, o9.exitCode === 0 ? 1 : o9.exitCode === 1 ? 0 : o9.exitCode);
    }
    if (r8 === "(" && i10 === ")") return Y10(n23 !== "");
  }
  if (t6.length === 4) {
    if (t6[0] === "!") {
      let r8 = await gt3(e7, t6.slice(1));
      return _14("", r8.stderr, r8.exitCode === 0 ? 1 : r8.exitCode === 1 ? 0 : r8.exitCode);
    }
    if (t6[0] === "(" && t6[3] === ")") return gt3(e7, [t6[1], t6[2]]);
  }
  let s9 = await nn3(e7, t6, 0);
  return s9.pos < t6.length ? A13(`test: too many arguments
`, 2) : Y10(s9.value);
}
async function nn3(e7, t6, s9) {
  return Hi2(e7, t6, s9);
}
async function Hi2(e7, t6, s9) {
  let { value: r8, pos: n23 } = await tn(e7, t6, s9);
  for (; t6[n23] === "-o"; ) {
    let i10 = await tn(e7, t6, n23 + 1);
    r8 = r8 || i10.value, n23 = i10.pos;
  }
  return { value: r8, pos: n23 };
}
async function tn(e7, t6, s9) {
  let { value: r8, pos: n23 } = await _s3(e7, t6, s9);
  for (; t6[n23] === "-a"; ) {
    let i10 = await _s3(e7, t6, n23 + 1);
    r8 = r8 && i10.value, n23 = i10.pos;
  }
  return { value: r8, pos: n23 };
}
async function _s3(e7, t6, s9) {
  if (t6[s9] === "!") {
    let { value: r8, pos: n23 } = await _s3(e7, t6, s9 + 1);
    return { value: !r8, pos: n23 };
  }
  return qi3(e7, t6, s9);
}
async function qi3(e7, t6, s9) {
  let r8 = t6[s9];
  if (r8 === "(") {
    let { value: i10, pos: o9 } = await nn3(e7, t6, s9 + 1);
    return { value: i10, pos: t6[o9] === ")" ? o9 + 1 : o9 };
  }
  let n23 = t6[s9 + 1];
  if (yt5(n23)) {
    let i10 = r8, o9 = t6[s9 + 2] ?? "";
    return { value: jt3(n23, i10, o9), pos: s9 + 3 };
  }
  if (Vt2(n23)) {
    let i10 = Gt3(r8), o9 = Gt3(t6[s9 + 2] ?? "0");
    return !i10.valid || !o9.valid ? { value: false, pos: s9 + 3 } : { value: Bt2(n23, i10.value, o9.value), pos: s9 + 3 };
  }
  if (zt3(n23)) {
    let i10 = r8, o9 = t6[s9 + 2] ?? "";
    return { value: await Wt3(e7, n23, i10, o9), pos: s9 + 3 };
  }
  if (Mt3(r8)) {
    let i10 = t6[s9 + 1] ?? "";
    return { value: await Ft3(e7, r8, i10), pos: s9 + 2 };
  }
  if (Ut3(r8)) {
    let i10 = t6[s9 + 1] ?? "";
    return { value: Ht3(r8, i10), pos: s9 + 2 };
  }
  if (r8 === "-v") {
    let i10 = t6[s9 + 1] ?? "";
    return { value: await qt3(e7, i10), pos: s9 + 2 };
  }
  if (r8 === "-o") {
    let i10 = t6[s9 + 1] ?? "";
    return { value: Cs3(e7, i10), pos: s9 + 2 };
  }
  return { value: r8 !== void 0 && r8 !== "", pos: s9 + 1 };
}
function tt7(e7, t6, s9 = false, r8 = false) {
  let n23 = `^${on3(t6, r8)}$`;
  return b1(n23, s9 ? "is" : "s").test(e7);
}
function on3(e7, t6) {
  let s9 = "";
  for (let r8 = 0; r8 < e7.length; r8++) {
    let n23 = e7[r8];
    if (t6 && (n23 === "@" || n23 === "*" || n23 === "+" || n23 === "?" || n23 === "!") && r8 + 1 < e7.length && e7[r8 + 1] === "(") {
      let i10 = an2(e7, r8 + 1);
      if (i10 !== -1) {
        let o9 = e7.slice(r8 + 2, i10), a7 = ln2(o9), l8 = a7.map((u11) => on3(u11, t6)), c15 = l8.length > 0 ? l8.join("|") : "(?:)";
        if (n23 === "@") s9 += `(?:${c15})`;
        else if (n23 === "*") s9 += `(?:${c15})*`;
        else if (n23 === "+") s9 += `(?:${c15})+`;
        else if (n23 === "?") s9 += `(?:${c15})?`;
        else if (n23 === "!") if (i10 < e7.length - 1) {
          let f11 = a7.map((h17) => cn3(h17, t6));
          if (f11.every((h17) => h17 !== null) && f11.every((h17) => h17 === f11[0]) && f11[0] !== null) {
            let h17 = f11[0];
            if (h17 === 0) s9 += "(?:.+)";
            else {
              let m25 = [];
              h17 > 0 && m25.push(`.{0,${h17 - 1}}`), m25.push(`.{${h17 + 1},}`), m25.push(`(?!(?:${c15})).{${h17}}`), s9 += `(?:${m25.join("|")})`;
            }
          } else s9 += `(?:(?!(?:${c15})).)*?`;
        } else s9 += `(?!(?:${c15})$).*`;
        r8 = i10;
        continue;
      }
    }
    if (n23 === "\\") if (r8 + 1 < e7.length) {
      let i10 = e7[r8 + 1];
      /[\\^$.|+(){}[\]*?]/.test(i10) ? s9 += `\\${i10}` : s9 += i10, r8++;
    } else s9 += "\\\\";
    else if (n23 === "*") s9 += ".*";
    else if (n23 === "?") s9 += ".";
    else if (n23 === "[") {
      let i10 = e7.indexOf("]", r8 + 1);
      i10 !== -1 ? (s9 += e7.slice(r8, i10 + 1), r8 = i10) : s9 += "\\[";
    } else /[\\^$.|+(){}]/.test(n23) ? s9 += `\\${n23}` : s9 += n23;
  }
  return s9;
}
function an2(e7, t6) {
  let s9 = 1, r8 = t6 + 1;
  for (; r8 < e7.length && s9 > 0; ) {
    let n23 = e7[r8];
    if (n23 === "\\") {
      r8 += 2;
      continue;
    }
    if (n23 === "(") s9++;
    else if (n23 === ")" && (s9--, s9 === 0)) return r8;
    r8++;
  }
  return -1;
}
function ln2(e7) {
  let t6 = [], s9 = "", r8 = 0, n23 = 0;
  for (; n23 < e7.length; ) {
    let i10 = e7[n23];
    if (i10 === "\\") {
      s9 += i10, n23 + 1 < e7.length ? (s9 += e7[n23 + 1], n23 += 2) : n23++;
      continue;
    }
    i10 === "(" ? (r8++, s9 += i10) : i10 === ")" ? (r8--, s9 += i10) : i10 === "|" && r8 === 0 ? (t6.push(s9), s9 = "") : s9 += i10, n23++;
  }
  return t6.push(s9), t6;
}
function cn3(e7, t6) {
  let s9 = 0, r8 = 0;
  for (; r8 < e7.length; ) {
    let n23 = e7[r8];
    if (t6 && (n23 === "@" || n23 === "*" || n23 === "+" || n23 === "?" || n23 === "!") && r8 + 1 < e7.length && e7[r8 + 1] === "(") {
      let i10 = an2(e7, r8 + 1);
      if (i10 !== -1) {
        if (n23 === "@") {
          let o9 = e7.slice(r8 + 2, i10), l8 = ln2(o9).map((c15) => cn3(c15, t6));
          if (l8.every((c15) => c15 !== null) && l8.every((c15) => c15 === l8[0])) {
            s9 += l8[0], r8 = i10 + 1;
            continue;
          }
          return null;
        }
        return null;
      }
    }
    if (n23 === "*") return null;
    if (n23 === "?") {
      s9 += 1, r8++;
      continue;
    }
    if (n23 === "[") {
      let i10 = e7.indexOf("]", r8 + 1);
      if (i10 !== -1) {
        s9 += 1, r8 = i10 + 1;
        continue;
      }
      s9 += 1, r8++;
      continue;
    }
    if (n23 === "\\") {
      s9 += 1, r8 += 2;
      continue;
    }
    s9 += 1, r8++;
  }
  return s9;
}
function Cs3(e7, t6) {
  let r8 = (/* @__PURE__ */ new Map([["errexit", () => e7.state.options.errexit === true], ["nounset", () => e7.state.options.nounset === true], ["pipefail", () => e7.state.options.pipefail === true], ["xtrace", () => e7.state.options.xtrace === true], ["e", () => e7.state.options.errexit === true], ["u", () => e7.state.options.nounset === true], ["x", () => e7.state.options.xtrace === true]])).get(t6);
  return r8 ? r8() : false;
}
async function sn2(e7, t6) {
  if (t6 = t6.trim(), t6 === "") return 0;
  if (/^[+-]?(\d+#[a-zA-Z0-9@_]+|0[xX][0-9a-fA-F]+|0[0-7]+|\d+)$/.test(t6)) return rn2(t6);
  try {
    let s9 = new V2(), r8 = M2(s9, t6);
    return await R(e7, r8.expression);
  } catch {
    return rn2(t6);
  }
}
function Gi2(e7, t6) {
  let s9 = 0;
  for (let r8 of e7) {
    let n23;
    if (r8 >= "0" && r8 <= "9") n23 = r8.charCodeAt(0) - 48;
    else if (r8 >= "a" && r8 <= "z") n23 = r8.charCodeAt(0) - 97 + 10;
    else if (r8 >= "A" && r8 <= "Z") n23 = r8.charCodeAt(0) - 65 + 36;
    else if (r8 === "@") n23 = 62;
    else if (r8 === "_") n23 = 63;
    else return Number.NaN;
    if (n23 >= t6) return Number.NaN;
    s9 = s9 * t6 + n23;
  }
  return s9;
}
function rn2(e7) {
  if (e7 = e7.trim(), e7 === "") return 0;
  let t6 = false;
  e7.startsWith("-") ? (t6 = true, e7 = e7.slice(1)) : e7.startsWith("+") && (e7 = e7.slice(1));
  let s9, r8 = e7.match(/^(\d+)#([a-zA-Z0-9@_]+)$/);
  if (r8) {
    let n23 = Number.parseInt(r8[1], 10);
    n23 >= 2 && n23 <= 64 ? s9 = Gi2(r8[2], n23) : s9 = 0;
  } else /^0[xX][0-9a-fA-F]+$/.test(e7) ? s9 = Number.parseInt(e7, 16) : /^0[0-7]+$/.test(e7) ? s9 = Number.parseInt(e7, 8) : s9 = Number.parseInt(e7, 10);
  return Number.isNaN(s9) && (s9 = 0), t6 ? -s9 : s9;
}
function Gt3(e7) {
  if (e7 = e7.trim(), e7 === "") return { value: 0, valid: true };
  let t6 = false;
  if (e7.startsWith("-") ? (t6 = true, e7 = e7.slice(1)) : e7.startsWith("+") && (e7 = e7.slice(1)), !/^\d+$/.test(e7)) return { value: 0, valid: false };
  let s9 = Number.parseInt(e7, 10);
  return Number.isNaN(s9) ? { value: 0, valid: false } : { value: t6 ? -s9 : s9, valid: true };
}
function Zi(e7) {
  let t6 = "", s9 = 0;
  for (; s9 < e7.length; ) if (e7[s9] === "\\" && s9 + 1 < e7.length) t6 += e7[s9] + e7[s9 + 1], s9 += 2;
  else if (e7[s9] === "[") {
    let r8 = Ki(e7, s9);
    t6 += r8.converted, s9 = r8.endIndex;
  } else t6 += e7[s9], s9++;
  return t6;
}
function Ki(e7, t6) {
  let s9 = t6 + 1, r8 = "[";
  s9 < e7.length && (e7[s9] === "^" || e7[s9] === "!") && (r8 += "^", s9++);
  let n23 = false;
  s9 < e7.length && e7[s9] === "]" && (n23 = true, s9++);
  let i10 = false;
  s9 < e7.length && e7[s9] === "[" && s9 + 1 < e7.length && e7[s9 + 1] !== ":" && (i10 = true, s9++);
  let o9 = "", a7 = false;
  for (; s9 < e7.length; ) {
    let l8 = e7[s9];
    if (l8 === "]") {
      a7 = true, s9++;
      break;
    }
    if (l8 === "[" && s9 + 1 < e7.length && e7[s9 + 1] === ":") {
      let c15 = e7.indexOf(":]", s9 + 2);
      if (c15 !== -1) {
        let u11 = e7.slice(s9 + 2, c15);
        o9 += Xi2(u11), s9 = c15 + 2;
        continue;
      }
    }
    if (l8 === "[" && s9 + 1 < e7.length) {
      let c15 = e7[s9 + 1];
      if (c15 === "." || c15 === "=") {
        let u11 = `${c15}]`, f11 = e7.indexOf(u11, s9 + 2);
        if (f11 !== -1) {
          let d16 = e7.slice(s9 + 2, f11);
          o9 += d16, s9 = f11 + 2;
          continue;
        }
      }
    }
    if (l8 === "\\" && s9 + 1 < e7.length) {
      o9 += l8 + e7[s9 + 1], s9 += 2;
      continue;
    }
    o9 += l8, s9++;
  }
  return a7 ? (n23 && (r8 += "\\]"), i10 && (r8 += "\\["), r8 += o9, r8 += "]", { converted: r8, endIndex: s9 }) : { converted: "\\[", endIndex: t6 + 1 };
}
function Xi2(e7) {
  return (/* @__PURE__ */ new Map([["alnum", "a-zA-Z0-9"], ["alpha", "a-zA-Z"], ["ascii", "\\x00-\\x7F"], ["blank", " \\t"], ["cntrl", "\\x00-\\x1F\\x7F"], ["digit", "0-9"], ["graph", "!-~"], ["lower", "a-z"], ["print", " -~"], ["punct", "!-/:-@\\[-`{-~"], ["space", " \\t\\n\\r\\f\\v"], ["upper", "A-Z"], ["word", "a-zA-Z0-9_"], ["xdigit", "0-9A-Fa-f"]])).get(e7) ?? "";
}
function Ce5(e7) {
  let t6 = [], s9 = "", r8 = false, n23 = false, i10 = false, o9 = false;
  for (let a7 of e7) {
    if (i10) {
      s9 += a7, i10 = false, o9 = true;
      continue;
    }
    if (a7 === "\\") {
      i10 = true;
      continue;
    }
    if (a7 === "'" && !n23) {
      r8 || (o9 = true), r8 = !r8;
      continue;
    }
    if (a7 === '"' && !r8) {
      n23 || (o9 = true), n23 = !n23;
      continue;
    }
    if ((a7 === " " || a7 === "	" || a7 === `
`) && !r8 && !n23) {
      o9 && (t6.push(s9), s9 = "", o9 = false);
      continue;
    }
    s9 += a7, o9 = true;
  }
  return o9 && t6.push(s9), t6;
}
function Zt3(e7) {
  let t6 = [], s9 = 0;
  for (; s9 < e7.length; ) {
    for (; s9 < e7.length && /\s/.test(e7[s9]); ) s9++;
    if (s9 >= e7.length) break;
    if (e7[s9] !== "[") {
      s9++;
      continue;
    }
    s9++;
    let r8 = "";
    if (e7[s9] === "'" || e7[s9] === '"') {
      let i10 = e7[s9];
      for (s9++; s9 < e7.length && e7[s9] !== i10; ) r8 += e7[s9], s9++;
      e7[s9] === i10 && s9++;
    } else for (; s9 < e7.length && e7[s9] !== "]" && e7[s9] !== "="; ) r8 += e7[s9], s9++;
    for (; s9 < e7.length && e7[s9] !== "]"; ) s9++;
    if (e7[s9] === "]" && s9++, e7[s9] !== "=") continue;
    s9++;
    let n23 = "";
    if (e7[s9] === "'" || e7[s9] === '"') {
      let i10 = e7[s9];
      for (s9++; s9 < e7.length && e7[s9] !== i10; ) e7[s9] === "\\" && s9 + 1 < e7.length && s9++, n23 += e7[s9], s9++;
      e7[s9] === i10 && s9++;
    } else for (; s9 < e7.length && !/\s/.test(e7[s9]); ) n23 += e7[s9], s9++;
    t6.push([r8, n23]);
  }
  return t6;
}
function un2(e7) {
  let t6 = e7.match(/^([a-zA-Z_][a-zA-Z0-9_]*)=\((.*)\)$/s);
  if (t6) return { name: t6[1], isArray: true, arrayElements: Ce5(t6[2]) };
  let s9 = e7.match(/^([a-zA-Z_][a-zA-Z0-9_]*)\[([^\]]+)\]=(.*)$/s);
  if (s9) return { name: s9[1], isArray: false, arrayIndex: s9[2], value: s9[3] };
  if (e7.includes("=")) {
    let r8 = e7.indexOf("=");
    return { name: e7.slice(0, r8), isArray: false, value: e7.slice(r8 + 1) };
  }
  return { name: e7, isArray: false };
}
async function Yi2(e7, t6) {
  try {
    let s9 = new V2(), r8 = M2(s9, t6);
    return await R(e7, r8.expression);
  } catch {
    let s9 = parseInt(t6, 10);
    return Number.isNaN(s9) ? 0 : s9;
  }
}
async function fn3(e7, t6, s9 = {}) {
  let { name: r8, isArray: n23, arrayElements: i10, value: o9, arrayIndex: a7 } = t6, { makeReadonly: l8 = false, checkReadonly: c15 = true } = s9;
  if (c15) {
    let u11 = ha(e7, r8);
    if (u11) return u11;
  }
  if (n23 && i10) {
    for (let u11 = 0; u11 < i10.length; u11++) e7.state.env.set(`${r8}_${u11}`, i10[u11]);
    e7.state.env.set(`${r8}__length`, String(i10.length));
  } else if (a7 !== void 0 && o9 !== void 0) {
    let u11 = await Yi2(e7, a7);
    e7.state.env.set(`${r8}_${u11}`, o9);
    let f11 = parseInt(e7.state.env.get(`${r8}__length`) ?? "0", 10);
    u11 >= f11 && e7.state.env.set(`${r8}__length`, String(u11 + 1));
  } else o9 !== void 0 && e7.state.env.set(r8, o9);
  return l8 && fa(e7, r8), null;
}
function Ve7(e7, t6) {
  e7.state.localVarDepth = e7.state.localVarDepth || /* @__PURE__ */ new Map(), e7.state.localVarDepth.set(t6, e7.state.callDepth);
}
function st7(e7, t6) {
  return e7.state.localVarDepth?.get(t6);
}
function Kt2(e7, t6) {
  e7.state.localVarDepth?.delete(t6);
}
function dn3(e7, t6, s9) {
  e7.state.localVarStack = e7.state.localVarStack || /* @__PURE__ */ new Map();
  let r8 = e7.state.localVarStack.get(t6) || [];
  r8.push({ value: s9, scopeIndex: e7.state.localScopes.length - 1 }), e7.state.localVarStack.set(t6, r8);
}
function Xt3(e7, t6) {
  let s9 = e7.state.localVarStack?.get(t6);
  if (!(!s9 || s9.length === 0)) return s9.pop();
}
function hn2(e7, t6) {
  if (e7.state.localVarStack) for (let [s9, r8] of e7.state.localVarStack.entries()) {
    for (; r8.length > 0 && r8[r8.length - 1].scopeIndex === t6; ) r8.pop();
    r8.length === 0 && e7.state.localVarStack.delete(s9);
  }
}
var xs3 = /* @__PURE__ */ new Set([":", ".", "break", "continue", "eval", "exec", "exit", "export", "readonly", "return", "set", "shift", "trap", "unset"]);
function pn4(e7) {
  return xs3.has(e7);
}
var Ns2 = /* @__PURE__ */ new Set(["if", "then", "else", "elif", "fi", "case", "esac", "for", "select", "while", "until", "do", "done", "in", "function", "{", "}", "time", "[[", "]]", "!"]);
var rt6 = /* @__PURE__ */ new Set([":", "true", "false", "cd", "export", "unset", "exit", "local", "set", "break", "continue", "return", "eval", "shift", "getopts", "compgen", "complete", "compopt", "pushd", "popd", "dirs", "source", ".", "read", "mapfile", "readarray", "declare", "typeset", "readonly", "let", "command", "shopt", "exec", "test", "[", "echo", "printf", "pwd", "alias", "unalias", "type", "hash", "ulimit", "umask", "trap", "times", "wait", "kill", "jobs", "fg", "bg", "disown", "suspend", "fc", "history", "help", "enable", "builtin", "caller"]);
async function qe5(e7, t6, s9, r8) {
  try {
    if ((await e7.fs.stat(t6)).isDirectory) return `bash: ${s9}: Is a directory
`;
    if (r8.checkNoclobber && e7.state.options.noclobber && !r8.isClobber && s9 !== "/dev/null") return `bash: ${s9}: cannot overwrite existing file
`;
  } catch {
  }
  return null;
}
function se8(e7) {
  let s9 = Math.min(e7.length, 8192);
  for (let r8 = 0; r8 < s9; r8++) if (e7.charCodeAt(r8) > 255) return "utf8";
  return "binary";
}
function Qi2(e7) {
  if (!e7.startsWith("__rw__:")) return null;
  let t6 = e7.slice(7), s9 = t6.indexOf(":");
  if (s9 === -1) return null;
  let r8 = Number.parseInt(t6.slice(0, s9), 10);
  if (Number.isNaN(r8) || r8 < 0) return null;
  let n23 = s9 + 1, i10 = t6.slice(n23, n23 + r8), o9 = n23 + r8 + 1, a7 = t6.slice(o9), l8 = a7.indexOf(":");
  if (l8 === -1) return null;
  let c15 = Number.parseInt(a7.slice(0, l8), 10);
  if (Number.isNaN(c15) || c15 < 0) return null;
  let u11 = a7.slice(l8 + 1);
  return { path: i10, position: c15, content: u11 };
}
async function mn2(e7, t6) {
  let s9 = /* @__PURE__ */ new Map();
  for (let r8 = 0; r8 < t6.length; r8++) {
    let n23 = t6[r8];
    if (n23.target.type === "HereDoc") continue;
    if (n23.operator === ">&" || n23.operator === "<&") {
      if (qs(e7, n23.target)) return { targets: s9, error: `bash: $@: ambiguous redirect
` };
      s9.set(r8, await kt(e7, n23.target));
    } else {
      let o9 = await bl(e7, n23.target);
      if ("error" in o9) return { targets: s9, error: o9.error };
      s9.set(r8, o9.target);
    }
  }
  return { targets: s9 };
}
function Ji2(e7) {
  e7.state.nextFd === void 0 && (e7.state.nextFd = 10);
  let t6 = e7.state.nextFd;
  return e7.state.nextFd++, t6;
}
async function Yt2(e7, t6) {
  for (let s9 of t6) {
    if (!s9.fdVariable) continue;
    if (e7.state.fileDescriptors || (e7.state.fileDescriptors = /* @__PURE__ */ new Map()), (s9.operator === ">&" || s9.operator === "<&") && s9.target.type === "Word" && await kt(e7, s9.target) === "-") {
      let i10 = e7.state.env.get(s9.fdVariable);
      if (i10 !== void 0) {
        let o9 = Number.parseInt(i10, 10);
        Number.isNaN(o9) || e7.state.fileDescriptors.delete(o9);
      }
      continue;
    }
    let r8 = Ji2(e7);
    if (e7.state.env.set(s9.fdVariable, String(r8)), s9.target.type === "Word") {
      let n23 = await kt(e7, s9.target);
      if (s9.operator === ">&" || s9.operator === "<&") {
        let i10 = Number.parseInt(n23, 10);
        if (!Number.isNaN(i10)) {
          let o9 = e7.state.fileDescriptors.get(i10);
          o9 !== void 0 && e7.state.fileDescriptors.set(r8, o9);
          continue;
        }
      }
      if (s9.operator === ">" || s9.operator === ">>" || s9.operator === ">|" || s9.operator === "&>" || s9.operator === "&>>") {
        let i10 = e7.fs.resolvePath(e7.state.cwd, n23);
        (s9.operator === ">" || s9.operator === ">|" || s9.operator === "&>") && await e7.fs.writeFile(i10, "", "binary"), e7.state.fileDescriptors.set(r8, `__file__:${i10}`);
      } else if (s9.operator === "<<<") e7.state.fileDescriptors.set(r8, `${n23}
`);
      else if (s9.operator === "<" || s9.operator === "<>") try {
        let i10 = e7.fs.resolvePath(e7.state.cwd, n23), o9 = await e7.fs.readFile(i10);
        e7.state.fileDescriptors.set(r8, o9);
      } catch {
        return _14("", `bash: ${n23}: No such file or directory
`, 1);
      }
    }
  }
  return null;
}
async function xe10(e7, t6) {
  for (let s9 of t6) {
    if (s9.target.type === "HereDoc") continue;
    let r8 = s9.operator === ">&";
    if (s9.operator !== ">" && s9.operator !== ">|" && s9.operator !== "&>" && !r8) continue;
    let n23;
    if (r8) {
      if (n23 = await kt(e7, s9.target), n23 === "-" || !Number.isNaN(Number.parseInt(n23, 10)) || s9.fd != null) continue;
    } else {
      let a7 = await bl(e7, s9.target);
      if ("error" in a7) return _14("", a7.error, 1);
      n23 = a7.target;
    }
    let i10 = e7.fs.resolvePath(e7.state.cwd, n23), o9 = s9.operator === ">|";
    if (i10.includes("\0")) return _14("", `bash: ${n23}: No such file or directory
`, 1);
    try {
      let a7 = await e7.fs.stat(i10);
      if (a7.isDirectory) return _14("", `bash: ${n23}: Is a directory
`, 1);
      if (e7.state.options.noclobber && !o9 && !a7.isDirectory && n23 !== "/dev/null") return _14("", `bash: ${n23}: cannot overwrite existing file
`, 1);
    } catch {
    }
    if (n23 !== "/dev/null" && n23 !== "/dev/stdout" && n23 !== "/dev/stderr" && n23 !== "/dev/full" && await e7.fs.writeFile(i10, "", "binary"), n23 === "/dev/full") return _14("", `bash: /dev/full: No space left on device
`, 1);
  }
  return null;
}
async function G8(e7, t6, s9, r8) {
  let { stdout: n23, stderr: i10, exitCode: o9 } = t6;
  for (let c15 = 0; c15 < s9.length; c15++) {
    let u11 = s9[c15];
    if (u11.target.type === "HereDoc") continue;
    let f11, d16 = r8?.get(c15);
    if (d16 !== void 0) f11 = d16;
    else if (u11.operator === ">&" || u11.operator === "<&") {
      if (qs(e7, u11.target)) {
        i10 += `bash: $@: ambiguous redirect
`, o9 = 1, n23 = "";
        continue;
      }
      f11 = await kt(e7, u11.target);
    } else {
      let m25 = await bl(e7, u11.target);
      if ("error" in m25) {
        i10 += m25.error, o9 = 1, n23 = "";
        continue;
      }
      f11 = m25.target;
    }
    if (!u11.fdVariable) {
      if (f11.includes("\0")) {
        i10 += `bash: ${f11.replace(/\0/g, "")}: No such file or directory
`, o9 = 1, n23 = "";
        continue;
      }
      switch (u11.operator) {
        case ">":
        case ">|": {
          let h17 = u11.fd ?? 1, m25 = u11.operator === ">|";
          if (h17 === 1) {
            if (f11 === "/dev/stdout") break;
            if (f11 === "/dev/stderr") {
              i10 += n23, n23 = "";
              break;
            }
            if (f11 === "/dev/full") {
              i10 += `bash: echo: write error: No space left on device
`, o9 = 1, n23 = "";
              break;
            }
            let p17 = e7.fs.resolvePath(e7.state.cwd, f11), g18 = await qe5(e7, p17, f11, { checkNoclobber: true, isClobber: m25 });
            if (g18) {
              i10 += g18, o9 = 1, n23 = "";
              break;
            }
            await e7.fs.writeFile(p17, n23, se8(n23)), n23 = "";
          } else if (h17 === 2) {
            if (f11 === "/dev/stderr") break;
            if (f11 === "/dev/stdout") {
              n23 += i10, i10 = "";
              break;
            }
            if (f11 === "/dev/full") {
              i10 += `bash: echo: write error: No space left on device
`, o9 = 1;
              break;
            }
            if (f11 === "/dev/null") i10 = "";
            else {
              let p17 = e7.fs.resolvePath(e7.state.cwd, f11), g18 = await qe5(e7, p17, f11, { checkNoclobber: true, isClobber: m25 });
              if (g18) {
                i10 += g18, o9 = 1;
                break;
              }
              await e7.fs.writeFile(p17, i10, se8(i10)), i10 = "";
            }
          }
          break;
        }
        case ">>": {
          let h17 = u11.fd ?? 1;
          if (h17 === 1) {
            if (f11 === "/dev/stdout") break;
            if (f11 === "/dev/stderr") {
              i10 += n23, n23 = "";
              break;
            }
            if (f11 === "/dev/full") {
              i10 += `bash: echo: write error: No space left on device
`, o9 = 1, n23 = "";
              break;
            }
            let m25 = e7.fs.resolvePath(e7.state.cwd, f11), p17 = await qe5(e7, m25, f11, {});
            if (p17) {
              i10 += p17, o9 = 1, n23 = "";
              break;
            }
            await e7.fs.appendFile(m25, n23, se8(n23)), n23 = "";
          } else if (h17 === 2) {
            if (f11 === "/dev/stderr") break;
            if (f11 === "/dev/stdout") {
              n23 += i10, i10 = "";
              break;
            }
            if (f11 === "/dev/full") {
              i10 += `bash: echo: write error: No space left on device
`, o9 = 1;
              break;
            }
            let m25 = e7.fs.resolvePath(e7.state.cwd, f11), p17 = await qe5(e7, m25, f11, {});
            if (p17) {
              i10 += p17, o9 = 1;
              break;
            }
            await e7.fs.appendFile(m25, i10, se8(i10)), i10 = "";
          }
          break;
        }
        case ">&":
        case "<&": {
          let h17 = u11.fd ?? 1;
          if (f11 === "-") break;
          if (f11.endsWith("-")) {
            let m25 = f11.slice(0, -1), p17 = Number.parseInt(m25, 10);
            if (!Number.isNaN(p17)) {
              let g18 = e7.state.fileDescriptors?.get(p17);
              g18 !== void 0 ? (e7.state.fileDescriptors || (e7.state.fileDescriptors = /* @__PURE__ */ new Map()), e7.state.fileDescriptors.set(h17, g18), p17 >= 3 && e7.state.fileDescriptors?.delete(p17)) : p17 === 1 || p17 === 2 ? (e7.state.fileDescriptors || (e7.state.fileDescriptors = /* @__PURE__ */ new Map()), e7.state.fileDescriptors.set(h17, `__dupout__:${p17}`)) : p17 === 0 ? (e7.state.fileDescriptors || (e7.state.fileDescriptors = /* @__PURE__ */ new Map()), e7.state.fileDescriptors.set(h17, `__dupin__:${p17}`)) : p17 >= 3 && (i10 += `bash: ${p17}: Bad file descriptor
`, o9 = 1);
            }
            break;
          }
          if (f11 === "2" || f11 === "&2") h17 === 1 && (i10 += n23, n23 = "");
          else if (f11 === "1" || f11 === "&1") n23 += i10, i10 = "";
          else {
            let m25 = Number.parseInt(f11, 10);
            if (Number.isNaN(m25)) {
              if (u11.operator === ">&") {
                let p17 = e7.fs.resolvePath(e7.state.cwd, f11), g18 = await qe5(e7, p17, f11, { checkNoclobber: true });
                if (g18) {
                  i10 = g18, o9 = 1, n23 = "";
                  break;
                }
                if (u11.fd == null) {
                  let S17 = n23 + i10;
                  await e7.fs.writeFile(p17, S17, se8(S17)), n23 = "", i10 = "";
                } else h17 === 1 ? (await e7.fs.writeFile(p17, n23, se8(n23)), n23 = "") : h17 === 2 && (await e7.fs.writeFile(p17, i10, se8(i10)), i10 = "");
              }
            } else {
              let p17 = e7.state.fileDescriptors?.get(m25);
              if (p17?.startsWith("__file__:")) {
                let g18 = p17.slice(9);
                h17 === 1 ? (await e7.fs.appendFile(g18, n23, se8(n23)), n23 = "") : h17 === 2 && (await e7.fs.appendFile(g18, i10, se8(i10)), i10 = "");
              } else if (p17?.startsWith("__rw__:")) {
                let g18 = Qi2(p17);
                g18 && (h17 === 1 ? (await e7.fs.appendFile(g18.path, n23, se8(n23)), n23 = "") : h17 === 2 && (await e7.fs.appendFile(g18.path, i10, se8(i10)), i10 = ""));
              } else if (p17?.startsWith("__dupout__:")) {
                let g18 = Number.parseInt(p17.slice(11), 10);
                if (g18 !== 1) if (g18 === 2) h17 === 1 && (i10 += n23, n23 = "");
                else {
                  let S17 = e7.state.fileDescriptors?.get(g18);
                  if (S17?.startsWith("__file__:")) {
                    let v21 = S17.slice(9);
                    h17 === 1 ? (await e7.fs.appendFile(v21, n23, se8(n23)), n23 = "") : h17 === 2 && (await e7.fs.appendFile(v21, i10, se8(i10)), i10 = "");
                  }
                }
              } else p17?.startsWith("__dupin__:") ? (i10 += `bash: ${m25}: Bad file descriptor
`, o9 = 1, n23 = "") : m25 >= 3 && (i10 += `bash: ${m25}: Bad file descriptor
`, o9 = 1, n23 = "");
            }
          }
          break;
        }
        case "&>": {
          if (f11 === "/dev/full") {
            i10 = `bash: echo: write error: No space left on device
`, o9 = 1, n23 = "";
            break;
          }
          let h17 = e7.fs.resolvePath(e7.state.cwd, f11), m25 = await qe5(e7, h17, f11, { checkNoclobber: true });
          if (m25) {
            i10 = m25, o9 = 1, n23 = "";
            break;
          }
          let p17 = n23 + i10;
          await e7.fs.writeFile(h17, p17, se8(p17)), n23 = "", i10 = "";
          break;
        }
        case "&>>": {
          if (f11 === "/dev/full") {
            i10 = `bash: echo: write error: No space left on device
`, o9 = 1, n23 = "";
            break;
          }
          let h17 = e7.fs.resolvePath(e7.state.cwd, f11), m25 = await qe5(e7, h17, f11, {});
          if (m25) {
            i10 = m25, o9 = 1, n23 = "";
            break;
          }
          let p17 = n23 + i10;
          await e7.fs.appendFile(h17, p17, se8(p17)), n23 = "", i10 = "";
          break;
        }
      }
    }
  }
  let a7 = e7.state.fileDescriptors?.get(1);
  if (a7) {
    if (a7 === "__dupout__:2") i10 += n23, n23 = "";
    else if (a7.startsWith("__file__:")) {
      let c15 = a7.slice(9);
      await e7.fs.appendFile(c15, n23, se8(n23)), n23 = "";
    } else if (a7.startsWith("__file_append__:")) {
      let c15 = a7.slice(16);
      await e7.fs.appendFile(c15, n23, se8(n23)), n23 = "";
    }
  }
  let l8 = e7.state.fileDescriptors?.get(2);
  if (l8) {
    if (l8 === "__dupout__:1") n23 += i10, i10 = "";
    else if (l8.startsWith("__file__:")) {
      let c15 = l8.slice(9);
      await e7.fs.appendFile(c15, i10, se8(i10)), i10 = "";
    } else if (l8.startsWith("__file_append__:")) {
      let c15 = l8.slice(16);
      await e7.fs.appendFile(c15, i10, se8(i10)), i10 = "";
    }
  }
  return _14(n23, i10, o9);
}
function yn2(e7, t6) {
  if (e7.state.options.posix && xs3.has(t6.name)) {
    let r8 = `bash: line ${e7.state.currentLine}: \`${t6.name}': is a special builtin
`;
    throw new d2(2, "", r8);
  }
  let s9 = { ...t6, sourceFile: t6.sourceFile ?? e7.state.currentSource ?? "main" };
  return e7.state.functions.set(t6.name, s9), L17;
}
async function eo(e7, t6) {
  let s9 = "";
  for (let r8 of t6) if ((r8.operator === "<<" || r8.operator === "<<-") && r8.target.type === "HereDoc") {
    let n23 = r8.target, i10 = await kt(e7, n23.content);
    n23.stripTabs && (i10 = i10.split(`
`).map((a7) => a7.replace(/^\t+/, "")).join(`
`)), (r8.fd ?? 0) === 0 && (s9 = i10);
  } else if (r8.operator === "<<<" && r8.target.type === "Word") s9 = `${await kt(e7, r8.target)}
`;
  else if (r8.operator === "<" && r8.target.type === "Word") {
    let n23 = await kt(e7, r8.target), i10 = e7.fs.resolvePath(e7.state.cwd, n23);
    try {
      s9 = await e7.fs.readFile(i10);
    } catch {
    }
  }
  return s9;
}
async function Qt3(e7, t6, s9, r8 = "", n23) {
  e7.state.callDepth++, e7.state.callDepth > e7.limits.maxCallDepth && (e7.state.callDepth--, Re7(`${t6.name}: maximum recursion depth (${e7.limits.maxCallDepth}) exceeded, increase executionLimits.maxCallDepth`, "recursion")), e7.state.funcNameStack || (e7.state.funcNameStack = []), e7.state.callLineStack || (e7.state.callLineStack = []), e7.state.sourceStack || (e7.state.sourceStack = []), e7.state.funcNameStack.unshift(t6.name), e7.state.callLineStack.unshift(n23 ?? e7.state.currentLine), e7.state.sourceStack.unshift(t6.sourceFile ?? "main"), e7.state.localScopes.push(/* @__PURE__ */ new Map()), e7.state.localExportedVars || (e7.state.localExportedVars = []), e7.state.localExportedVars.push(/* @__PURE__ */ new Set());
  let i10 = /* @__PURE__ */ new Map();
  for (let c15 = 0; c15 < s9.length; c15++) i10.set(String(c15 + 1), e7.state.env.get(String(c15 + 1))), e7.state.env.set(String(c15 + 1), s9[c15]);
  i10.set("@", e7.state.env.get("@")), i10.set("#", e7.state.env.get("#")), e7.state.env.set("@", s9.join(" ")), e7.state.env.set("#", String(s9.length));
  let o9 = () => {
    let c15 = e7.state.localScopes.length - 1, u11 = e7.state.localScopes.pop();
    if (u11) for (let [f11, d16] of u11) d16 === void 0 ? e7.state.env.delete(f11) : e7.state.env.set(f11, d16);
    if (hn2(e7, c15), e7.state.fullyUnsetLocals) for (let [f11, d16] of e7.state.fullyUnsetLocals.entries()) d16 === c15 && e7.state.fullyUnsetLocals.delete(f11);
    if (e7.state.localExportedVars && e7.state.localExportedVars.length > 0) {
      let f11 = e7.state.localExportedVars.pop();
      if (f11) for (let d16 of f11) e7.state.exportedVars?.delete(d16);
    }
    for (let [f11, d16] of i10) d16 === void 0 ? e7.state.env.delete(f11) : e7.state.env.set(f11, d16);
    e7.state.funcNameStack?.shift(), e7.state.callLineStack?.shift(), e7.state.sourceStack?.shift(), e7.state.callDepth--;
  }, { targets: a7, error: l8 } = await mn2(e7, t6.redirections);
  if (l8) return o9(), _14("", l8, 1);
  try {
    let c15 = await eo(e7, t6.redirections), u11 = r8 || c15, f11 = await e7.executeCommand(t6.body, u11);
    return o9(), G8(e7, f11, t6.redirections, a7);
  } catch (c15) {
    if (o9(), c15 instanceof i) {
      let u11 = _14(c15.stdout, c15.stderr, c15.exitCode);
      return G8(e7, u11, t6.redirections, a7);
    }
    throw c15;
  }
}
var wn2 = ["!", "[[", "]]", "case", "do", "done", "elif", "else", "esac", "fi", "for", "function", "if", "in", "then", "time", "until", "while", "{", "}"];
var Ts2 = [".", ":", "[", "alias", "bg", "bind", "break", "builtin", "caller", "cd", "command", "compgen", "complete", "compopt", "continue", "declare", "dirs", "disown", "echo", "enable", "eval", "exec", "exit", "export", "false", "fc", "fg", "getopts", "hash", "help", "history", "jobs", "kill", "let", "local", "logout", "mapfile", "popd", "printf", "pushd", "pwd", "read", "readarray", "readonly", "return", "set", "shift", "shopt", "source", "suspend", "test", "times", "trap", "true", "type", "typeset", "ulimit", "umask", "unalias", "unset", "wait"];
var to = ["autocd", "assoc_expand_once", "cdable_vars", "cdspell", "checkhash", "checkjobs", "checkwinsize", "cmdhist", "compat31", "compat32", "compat40", "compat41", "compat42", "compat43", "compat44", "complete_fullquote", "direxpand", "dirspell", "dotglob", "execfail", "expand_aliases", "extdebug", "extglob", "extquote", "failglob", "force_fignore", "globasciiranges", "globstar", "gnu_errfmt", "histappend", "histreedit", "histverify", "hostcomplete", "huponexit", "inherit_errexit", "interactive_comments", "lastpipe", "lithist", "localvar_inherit", "localvar_unset", "login_shell", "mailwarn", "no_empty_cmd_completion", "nocaseglob", "nocasematch", "nullglob", "progcomp", "progcomp_alias", "promptvars", "restricted_shell", "shift_verbose", "sourcepath", "xpg_echo"];
var so = Ts2;
async function Ds2(e7, t6) {
  let s9 = [], r8 = null, n23 = "", i10 = "", o9 = null, a7 = false, l8 = false, c15 = false, u11 = null, f11 = null, d16 = null, h17 = [], m25 = ["alias", "arrayvar", "binding", "builtin", "command", "directory", "disabled", "enabled", "export", "file", "function", "group", "helptopic", "hostname", "job", "keyword", "running", "service", "setopt", "shopt", "signal", "stopped", "user", "variable"];
  for (let y18 = 0; y18 < t6.length; y18++) {
    let w19 = t6[y18];
    if (w19 === "-v") s9.push("variable");
    else if (w19 === "-e") s9.push("export");
    else if (w19 === "-f") s9.push("file");
    else if (w19 === "-d") s9.push("directory");
    else if (w19 === "-k") s9.push("keyword");
    else if (w19 === "-A") {
      if (y18++, y18 >= t6.length) return A13(`compgen: -A: option requires an argument
`, 2);
      let b25 = t6[y18];
      if (!m25.includes(b25)) return A13(`compgen: ${b25}: invalid action name
`, 2);
      s9.push(b25);
    } else if (w19 === "-W") {
      if (y18++, y18 >= t6.length) return A13(`compgen: -W: option requires an argument
`, 2);
      r8 = t6[y18];
    } else if (w19 === "-P") {
      if (y18++, y18 >= t6.length) return A13(`compgen: -P: option requires an argument
`, 2);
      n23 = t6[y18];
    } else if (w19 === "-S") {
      if (y18++, y18 >= t6.length) return A13(`compgen: -S: option requires an argument
`, 2);
      i10 = t6[y18];
    } else if (w19 === "-o") {
      if (y18++, y18 >= t6.length) return A13(`compgen: -o: option requires an argument
`, 2);
      let b25 = t6[y18];
      if (b25 === "plusdirs") a7 = true;
      else if (b25 === "dirnames") l8 = true;
      else if (b25 === "default") c15 = true;
      else if (!(b25 === "filenames" || b25 === "nospace" || b25 === "bashdefault" || b25 === "noquote")) return A13(`compgen: ${b25}: invalid option name
`, 2);
    } else if (w19 === "-F") {
      if (y18++, y18 >= t6.length) return A13(`compgen: -F: option requires an argument
`, 2);
      f11 = t6[y18];
    } else if (w19 === "-C") {
      if (y18++, y18 >= t6.length) return A13(`compgen: -C: option requires an argument
`, 2);
      d16 = t6[y18];
    } else if (w19 === "-X") {
      if (y18++, y18 >= t6.length) return A13(`compgen: -X: option requires an argument
`, 2);
      u11 = t6[y18];
    } else if (w19 === "-G") {
      if (y18++, y18 >= t6.length) return A13(`compgen: -G: option requires an argument
`, 2);
    } else if (w19 === "--") {
      h17.push(...t6.slice(y18 + 1));
      break;
    } else w19.startsWith("-") || h17.push(w19);
  }
  o9 = h17[0] ?? null;
  let p17 = [];
  if (l8) {
    let y18 = await Os3(e7, o9);
    p17.push(...y18);
  }
  if (c15) {
    let y18 = await gn2(e7, o9);
    p17.push(...y18);
  }
  for (let y18 of s9) if (y18 === "variable") {
    let w19 = ro(e7, o9);
    p17.push(...w19);
  } else if (y18 === "export") {
    let w19 = no(e7, o9);
    p17.push(...w19);
  } else if (y18 === "function") {
    let w19 = io(e7, o9);
    p17.push(...w19);
  } else if (y18 === "builtin") {
    let w19 = oo(o9);
    p17.push(...w19);
  } else if (y18 === "keyword") {
    let w19 = ao(o9);
    p17.push(...w19);
  } else if (y18 === "alias") {
    let w19 = lo(e7, o9);
    p17.push(...w19);
  } else if (y18 === "shopt") {
    let w19 = co2(o9);
    p17.push(...w19);
  } else if (y18 === "helptopic") {
    let w19 = uo(o9);
    p17.push(...w19);
  } else if (y18 === "directory") {
    let w19 = await Os3(e7, o9);
    p17.push(...w19);
  } else if (y18 === "file") {
    let w19 = await gn2(e7, o9);
    p17.push(...w19);
  } else if (y18 === "user") {
    let w19 = fo2(o9);
    p17.push(...w19);
  } else if (y18 === "command") {
    let w19 = await ho2(e7, o9);
    p17.push(...w19);
  }
  if (r8 !== null) try {
    let y18 = await po(e7, r8), w19 = mo(e7, y18);
    for (let b25 of w19) (o9 === null || b25.startsWith(o9)) && p17.push(b25);
  } catch {
    return _14("", "", 1);
  }
  if (a7) {
    let y18 = await Os3(e7, o9);
    for (let w19 of y18) p17.includes(w19) || p17.push(w19);
  }
  let g18 = "";
  if (f11 !== null) {
    let y18 = e7.state.functions.get(f11);
    if (y18) {
      let w19 = /* @__PURE__ */ new Map();
      w19.set("COMP_WORDS__length", e7.state.env.get("COMP_WORDS__length")), e7.state.env.set("COMP_WORDS__length", "0"), w19.set("COMP_CWORD", e7.state.env.get("COMP_CWORD")), e7.state.env.set("COMP_CWORD", "-1"), w19.set("COMP_LINE", e7.state.env.get("COMP_LINE")), e7.state.env.set("COMP_LINE", ""), w19.set("COMP_POINT", e7.state.env.get("COMP_POINT")), e7.state.env.set("COMP_POINT", "0");
      let b25 = /* @__PURE__ */ new Map();
      for (let T10 of e7.state.env.keys()) (T10 === "COMPREPLY" || T10.startsWith("COMPREPLY_") || T10 === "COMPREPLY__length") && (b25.set(T10, e7.state.env.get(T10)), e7.state.env.delete(T10));
      let E13 = ["compgen", h17[0] ?? "", ""];
      try {
        let T10 = await Qt3(e7, y18, E13, "");
        if (T10.exitCode !== 0) return nt7(e7, w19), nt7(e7, b25), _14("", T10.stderr, 1);
        g18 = T10.stdout;
        let x23 = yo(e7);
        p17.push(...x23);
      } catch {
        return nt7(e7, w19), nt7(e7, b25), _14("", "", 1);
      }
      nt7(e7, w19), nt7(e7, b25);
    }
  }
  if (d16 !== null) try {
    let y18 = hi(d16), w19 = await e7.executeScript(y18);
    if (w19.exitCode !== 0) return _14("", w19.stderr, w19.exitCode);
    if (w19.stdout) {
      let b25 = w19.stdout.split(`
`);
      for (let E13 of b25) E13.length > 0 && p17.push(E13);
    }
  } catch (y18) {
    if (y18.name === "ParseException") return A13(`compgen: -C: ${y18.message}
`, 2);
    throw y18;
  }
  let S17 = p17;
  if (u11 !== null) {
    let y18 = u11.startsWith("!"), w19 = y18 ? u11.slice(1) : u11;
    S17 = p17.filter((b25) => {
      let E13 = tt7(b25, w19, false, true);
      return y18 ? E13 : !E13;
    });
  }
  if (S17.length === 0 && o9 !== null) return _14(g18, "", 1);
  let v21 = S17.map((y18) => `${n23}${y18}${i10}`).join(`
`), P20 = g18 + (v21 ? `${v21}
` : "");
  return M14(P20);
}
function ro(e7, t6) {
  let s9 = /* @__PURE__ */ new Set();
  for (let n23 of e7.state.env.keys()) {
    if (n23.includes("_") && /^[a-zA-Z_][a-zA-Z0-9_]*_\d+$/.test(n23) || n23.endsWith("__length")) continue;
    let i10 = n23.split("_")[0];
    /^[a-zA-Z_][a-zA-Z0-9_]*$/.test(n23) ? s9.add(n23) : i10 && /^[a-zA-Z_][a-zA-Z0-9_]*$/.test(i10) && e7.state.env.has(`${i10}__length`) && s9.add(i10);
  }
  let r8 = Array.from(s9);
  return t6 !== null && (r8 = r8.filter((n23) => n23.startsWith(t6))), r8.sort();
}
function no(e7, t6) {
  let s9 = e7.state.exportedVars ?? /* @__PURE__ */ new Set(), r8 = Array.from(s9);
  return t6 !== null && (r8 = r8.filter((n23) => n23.startsWith(t6))), r8 = r8.filter((n23) => n23.includes("_") && /^[a-zA-Z_][a-zA-Z0-9_]*_\d+$/.test(n23) || n23.endsWith("__length") ? false : e7.state.env.has(n23)), r8.sort();
}
function io(e7, t6) {
  let s9 = Array.from(e7.state.functions.keys());
  return t6 !== null && (s9 = s9.filter((r8) => r8.startsWith(t6))), s9.sort();
}
function oo(e7) {
  let t6 = [...Ts2];
  return e7 !== null && (t6 = t6.filter((s9) => s9.startsWith(e7))), t6.sort();
}
function ao(e7) {
  let t6 = [...wn2];
  return e7 !== null && (t6 = t6.filter((s9) => s9.startsWith(e7))), t6.sort();
}
function lo(e7, t6) {
  let s9 = [];
  for (let n23 of e7.state.env.keys()) if (n23.startsWith("BASH_ALIAS_")) {
    let i10 = n23.slice(11);
    s9.push(i10);
  }
  let r8 = s9;
  return t6 !== null && (r8 = r8.filter((n23) => n23.startsWith(t6))), r8.sort();
}
function co2(e7) {
  let t6 = [...to];
  return e7 !== null && (t6 = t6.filter((s9) => s9.startsWith(e7))), t6.sort();
}
function uo(e7) {
  let t6 = [...so];
  return e7 !== null && (t6 = t6.filter((s9) => s9.startsWith(e7))), t6.sort();
}
async function Os3(e7, t6) {
  let s9 = [];
  try {
    let r8 = e7.state.cwd, n23 = t6 ?? "";
    if (t6) {
      let o9 = t6.lastIndexOf("/");
      if (o9 !== -1) {
        let a7 = t6.slice(0, o9) || "/";
        n23 = t6.slice(o9 + 1), a7.startsWith("/") ? r8 = a7 : r8 = `${e7.state.cwd}/${a7}`;
      }
    }
    let i10 = await e7.fs.readdir(r8);
    for (let o9 of i10) {
      let a7 = `${r8}/${o9}`;
      try {
        if ((await e7.fs.stat(a7)).isDirectory && (!n23 || o9.startsWith(n23))) if (t6?.includes("/")) {
          let c15 = t6.lastIndexOf("/"), u11 = t6.slice(0, c15 + 1);
          s9.push(u11 + o9);
        } else s9.push(o9);
      } catch {
      }
    }
  } catch {
  }
  return s9.sort();
}
async function gn2(e7, t6) {
  let s9 = [];
  try {
    let r8 = e7.state.cwd, n23 = t6 ?? "";
    if (t6) {
      let o9 = t6.lastIndexOf("/");
      if (o9 !== -1) {
        let a7 = t6.slice(0, o9) || "/";
        n23 = t6.slice(o9 + 1), a7.startsWith("/") ? r8 = a7 : r8 = `${e7.state.cwd}/${a7}`;
      }
    }
    let i10 = await e7.fs.readdir(r8);
    for (let o9 of i10) if (!n23 || o9.startsWith(n23)) if (t6?.includes("/")) {
      let a7 = t6.lastIndexOf("/"), l8 = t6.slice(0, a7 + 1);
      s9.push(l8 + o9);
    } else s9.push(o9);
  } catch {
  }
  return s9.sort();
}
function fo2(e7) {
  return ["root", "nobody"];
}
async function ho2(e7, t6) {
  let s9 = /* @__PURE__ */ new Set();
  for (let i10 of Ts2) s9.add(i10);
  for (let i10 of e7.state.functions.keys()) s9.add(i10);
  for (let i10 of e7.state.env.keys()) i10.startsWith("BASH_ALIAS_") && s9.add(i10.slice(11));
  for (let i10 of wn2) s9.add(i10);
  let r8 = e7.state.env.get("PATH") ?? "/usr/bin:/bin";
  for (let i10 of r8.split(":")) if (i10) try {
    let o9 = await e7.fs.readdir(i10);
    for (let a7 of o9) s9.add(a7);
  } catch {
  }
  let n23 = Array.from(s9);
  return t6 !== null && (n23 = n23.filter((i10) => i10.startsWith(t6))), n23.sort();
}
async function po(e7, t6) {
  let r8 = new V2().parseWordFromString(t6, false, false);
  return await kt(e7, r8);
}
function mo(e7, t6) {
  let s9 = e7.state.env.get("IFS") ?? ` 	
`;
  if (s9.length === 0) return [t6];
  let r8 = new Set(s9.split("")), n23 = [], i10 = "", o9 = 0;
  for (; o9 < t6.length; ) {
    let a7 = t6[o9];
    if (a7 === "\\" && o9 + 1 < t6.length) {
      let l8 = t6[o9 + 1];
      i10 += l8, o9 += 2;
    } else r8.has(a7) ? (i10.length > 0 && (n23.push(i10), i10 = ""), o9++) : (i10 += a7, o9++);
  }
  return i10.length > 0 && n23.push(i10), n23;
}
function nt7(e7, t6) {
  for (let [s9, r8] of t6) r8 === void 0 ? e7.state.env.delete(s9) : e7.state.env.set(s9, r8);
}
function yo(e7) {
  let t6 = [];
  if (e7.state.env.get("COMPREPLY__length") !== void 0) {
    let n23 = P2(e7, "COMPREPLY");
    for (let [, i10] of n23) t6.push(i10);
  } else {
    let n23 = e7.state.env.get("COMPREPLY");
    n23 !== void 0 && t6.push(n23);
  }
  return t6;
}
var go = ["bashdefault", "default", "dirnames", "filenames", "noquote", "nosort", "nospace", "plusdirs"];
function Rs3(e7, t6) {
  e7.state.completionSpecs || (e7.state.completionSpecs = /* @__PURE__ */ new Map());
  let s9 = false, r8 = false, n23 = false, i10, o9, a7, l8 = [], c15 = [], u11 = [];
  for (let f11 = 0; f11 < t6.length; f11++) {
    let d16 = t6[f11];
    if (d16 === "-p") s9 = true;
    else if (d16 === "-r") r8 = true;
    else if (d16 === "-D") n23 = true;
    else if (d16 === "-W") {
      if (f11++, f11 >= t6.length) return A13(`complete: -W: option requires an argument
`, 2);
      i10 = t6[f11];
    } else if (d16 === "-F") {
      if (f11++, f11 >= t6.length) return A13(`complete: -F: option requires an argument
`, 2);
      o9 = t6[f11];
    } else if (d16 === "-o") {
      if (f11++, f11 >= t6.length) return A13(`complete: -o: option requires an argument
`, 2);
      let h17 = t6[f11];
      if (!go.includes(h17)) return A13(`complete: ${h17}: invalid option name
`, 2);
      l8.push(h17);
    } else if (d16 === "-A") {
      if (f11++, f11 >= t6.length) return A13(`complete: -A: option requires an argument
`, 2);
      c15.push(t6[f11]);
    } else if (d16 === "-C") {
      if (f11++, f11 >= t6.length) return A13(`complete: -C: option requires an argument
`, 2);
      a7 = t6[f11];
    } else if (d16 === "-G") {
      if (f11++, f11 >= t6.length) return A13(`complete: -G: option requires an argument
`, 2);
    } else if (d16 === "-P") {
      if (f11++, f11 >= t6.length) return A13(`complete: -P: option requires an argument
`, 2);
    } else if (d16 === "-S") {
      if (f11++, f11 >= t6.length) return A13(`complete: -S: option requires an argument
`, 2);
    } else if (d16 === "-X") {
      if (f11++, f11 >= t6.length) return A13(`complete: -X: option requires an argument
`, 2);
    } else if (d16 === "--") {
      u11.push(...t6.slice(f11 + 1));
      break;
    } else d16.startsWith("-") || u11.push(d16);
  }
  if (r8) {
    if (u11.length === 0) return e7.state.completionSpecs.clear(), M14("");
    for (let f11 of u11) e7.state.completionSpecs.delete(f11);
    return M14("");
  }
  if (s9) return u11.length === 0 ? Is3(e7) : Is3(e7, u11);
  if (t6.length === 0 || u11.length === 0 && !i10 && !o9 && !a7 && l8.length === 0 && c15.length === 0 && !n23) return Is3(e7);
  if (o9 && u11.length === 0 && !n23) return A13(`complete: -F: option requires a command name
`, 2);
  if (n23) {
    let f11 = { isDefault: true };
    return i10 !== void 0 && (f11.wordlist = i10), o9 !== void 0 && (f11.function = o9), a7 !== void 0 && (f11.command = a7), l8.length > 0 && (f11.options = l8), c15.length > 0 && (f11.actions = c15), e7.state.completionSpecs.set("__default__", f11), M14("");
  }
  for (let f11 of u11) {
    let d16 = /* @__PURE__ */ Object.create(null);
    i10 !== void 0 && (d16.wordlist = i10), o9 !== void 0 && (d16.function = o9), a7 !== void 0 && (d16.command = a7), l8.length > 0 && (d16.options = l8), c15.length > 0 && (d16.actions = c15), e7.state.completionSpecs.set(f11, d16);
  }
  return M14("");
}
function Is3(e7, t6) {
  let s9 = e7.state.completionSpecs;
  if (!s9 || s9.size === 0) {
    if (t6 && t6.length > 0) {
      let i10 = "";
      for (let o9 of t6) i10 += `complete: ${o9}: no completion specification
`;
      return _14("", i10, 1);
    }
    return M14("");
  }
  let r8 = [], n23 = t6 || Array.from(s9.keys());
  for (let i10 of n23) {
    if (i10 === "__default__") continue;
    let o9 = s9.get(i10);
    if (!o9) {
      if (t6) return _14(r8.join(`
`) + (r8.length > 0 ? `
` : ""), `complete: ${i10}: no completion specification
`, 1);
      continue;
    }
    let a7 = "complete";
    if (o9.options) for (let l8 of o9.options) a7 += ` -o ${l8}`;
    if (o9.actions) for (let l8 of o9.actions) a7 += ` -A ${l8}`;
    o9.wordlist !== void 0 && (o9.wordlist.includes(" ") || o9.wordlist.includes("'") ? a7 += ` -W '${o9.wordlist}'` : a7 += ` -W ${o9.wordlist}`), o9.function !== void 0 && (a7 += ` -F ${o9.function}`), o9.isDefault && (a7 += " -D"), a7 += ` ${i10}`, r8.push(a7);
  }
  return r8.length === 0 ? M14("") : M14(`${r8.join(`
`)}
`);
}
var vn2 = ["bashdefault", "default", "dirnames", "filenames", "noquote", "nosort", "nospace", "plusdirs"];
function Ls3(e7, t6) {
  e7.state.completionSpecs || (e7.state.completionSpecs = /* @__PURE__ */ new Map());
  let s9 = false, r8 = false, n23 = [], i10 = [], o9 = [];
  for (let a7 = 0; a7 < t6.length; a7++) {
    let l8 = t6[a7];
    if (l8 === "-D") s9 = true;
    else if (l8 === "-E") r8 = true;
    else if (l8 === "-o") {
      if (a7++, a7 >= t6.length) return A13(`compopt: -o: option requires an argument
`, 2);
      let c15 = t6[a7];
      if (!vn2.includes(c15)) return A13(`compopt: ${c15}: invalid option name
`, 2);
      n23.push(c15);
    } else if (l8 === "+o") {
      if (a7++, a7 >= t6.length) return A13(`compopt: +o: option requires an argument
`, 2);
      let c15 = t6[a7];
      if (!vn2.includes(c15)) return A13(`compopt: ${c15}: invalid option name
`, 2);
      i10.push(c15);
    } else if (l8 === "--") {
      o9.push(...t6.slice(a7 + 1));
      break;
    } else !l8.startsWith("-") && !l8.startsWith("+") && o9.push(l8);
  }
  if (s9) {
    let a7 = e7.state.completionSpecs.get("__default__") ?? { isDefault: true }, l8 = new Set(a7.options ?? []);
    for (let c15 of n23) l8.add(c15);
    for (let c15 of i10) l8.delete(c15);
    return a7.options = l8.size > 0 ? Array.from(l8) : void 0, e7.state.completionSpecs.set("__default__", a7), M14("");
  }
  if (r8) {
    let a7 = e7.state.completionSpecs.get("__empty__") ?? {}, l8 = new Set(a7.options ?? []);
    for (let c15 of n23) l8.add(c15);
    for (let c15 of i10) l8.delete(c15);
    return a7.options = l8.size > 0 ? Array.from(l8) : void 0, e7.state.completionSpecs.set("__empty__", a7), M14("");
  }
  if (o9.length > 0) {
    for (let a7 of o9) {
      let l8 = e7.state.completionSpecs.get(a7) ?? {}, c15 = new Set(l8.options ?? []);
      for (let u11 of n23) c15.add(u11);
      for (let u11 of i10) c15.delete(u11);
      l8.options = c15.size > 0 ? Array.from(c15) : void 0, e7.state.completionSpecs.set(a7, l8);
    }
    return M14("");
  }
  return A13(`compopt: not currently executing completion function
`, 1);
}
function Ms2(e7, t6) {
  if (e7.state.loopDepth === 0) {
    if (e7.state.parentHasLoopContext) throw new $2();
    return L17;
  }
  if (t6.length > 1) throw new d2(1, "", `bash: continue: too many arguments
`);
  let s9 = 1;
  if (t6.length > 0) {
    let r8 = Number.parseInt(t6[0], 10);
    if (Number.isNaN(r8) || r8 < 1) throw new d2(1, "", `bash: continue: ${t6[0]}: numeric argument required
`);
    s9 = r8;
  }
  throw new a2(s9);
}
function Z12(e7, t6) {
  let s9 = e7.state.env.get("HOME") || "/home/user";
  return t6.split(":").map((i10) => i10 === "~" ? s9 : i10 === "~root" ? "/root" : i10.startsWith("~/") ? s9 + i10.slice(1) : i10.startsWith("~root/") ? `/root${i10.slice(5)}` : i10).join(":");
}
function Fs(e7) {
  for (let t6 = 0; t6 < e7.length; t6++) {
    let s9 = e7.charCodeAt(t6);
    if (s9 < 32 || s9 === 127) return true;
  }
  return false;
}
function zs(e7) {
  let t6 = "$'";
  for (let s9 = 0; s9 < e7.length; s9++) {
    let r8 = e7[s9], n23 = e7.charCodeAt(s9);
    n23 === 7 ? t6 += "\\a" : n23 === 8 ? t6 += "\\b" : n23 === 9 ? t6 += "\\t" : n23 === 10 ? t6 += "\\n" : n23 === 11 ? t6 += "\\v" : n23 === 12 ? t6 += "\\f" : n23 === 13 ? t6 += "\\r" : n23 === 27 ? t6 += "\\e" : n23 === 39 ? t6 += "\\'" : n23 === 92 ? t6 += "\\\\" : n23 < 32 || n23 === 127 ? t6 += `\\${n23.toString(8).padStart(3, "0")}` : t6 += r8;
  }
  return t6 += "'", t6;
}
function Jt3(e7) {
  return Fs(e7) ? zs(e7) : /^[a-zA-Z0-9_/.:\-@%+,=]*$/.test(e7) ? e7 : `'${e7.replace(/'/g, "'\\''")}'`;
}
function Ge6(e7) {
  return Fs(e7) ? zs(e7) : `"${e7.replace(/\\/g, "\\\\").replace(/"/g, '\\"')}"`;
}
function Ws2(e7) {
  return Fs(e7) ? zs(e7) : `"${e7.replace(/\\/g, "\\\\").replace(/"/g, '\\"')}"`;
}
function bn4(e7, t6) {
  let s9 = "";
  return e7.state.integerVars?.has(t6) && (s9 += "i"), e7.state.lowercaseVars?.has(t6) && (s9 += "l"), L2(e7, t6) && (s9 += "n"), e7.state.readonlyVars?.has(t6) && (s9 += "r"), e7.state.uppercaseVars?.has(t6) && (s9 += "u"), e7.state.exportedVars?.has(t6) && (s9 += "x"), s9 === "" ? "--" : `-${s9}`;
}
function Vs2(e7) {
  return e7 === "" ? "''" : /[\s'\\]/.test(e7) ? `'${e7.replace(/'/g, "'\\''")}'` : e7;
}
function En3(e7, t6) {
  let s9 = "", r8 = "", n23 = false;
  for (let i10 of t6) {
    let o9 = bn4(e7, i10);
    if (e7.state.associativeArrays?.has(i10)) {
      let u11 = mt(e7, i10);
      if (u11.length === 0) s9 += `declare -A ${i10}=()
`;
      else {
        let f11 = u11.map((d16) => {
          let h17 = e7.state.env.get(`${i10}_${d16}`) ?? "", m25 = Vs2(h17);
          return `['${d16}']=${m25}`;
        });
        s9 += `declare -A ${i10}=(${f11.join(" ")})
`;
      }
      continue;
    }
    let l8 = dt(e7, i10);
    if (l8.length > 0) {
      let u11 = l8.map((f11) => {
        let d16 = e7.state.env.get(`${i10}_${f11}`) ?? "";
        return `[${f11}]=${Ge6(d16)}`;
      });
      s9 += `declare -a ${i10}=(${u11.join(" ")})
`;
      continue;
    }
    if (e7.state.env.has(`${i10}__length`)) {
      s9 += `declare -a ${i10}=()
`;
      continue;
    }
    let c15 = e7.state.env.get(i10);
    if (c15 !== void 0) s9 += `declare ${o9} ${i10}=${Ws2(c15)}
`;
    else {
      let u11 = e7.state.declaredVars?.has(i10), f11 = e7.state.localVarDepth?.has(i10);
      u11 || f11 ? s9 += `declare ${o9} ${i10}
` : (r8 += `bash: declare: ${i10}: not found
`, n23 = true);
    }
  }
  return _14(s9, r8, n23 ? 1 : 0);
}
function $n2(e7, t6) {
  let { filterExport: s9, filterReadonly: r8, filterNameref: n23, filterIndexedArray: i10, filterAssocArray: o9 } = t6, a7 = s9 || r8 || n23 || i10 || o9, l8 = "", c15 = /* @__PURE__ */ new Set();
  for (let f11 of e7.state.env.keys()) {
    if (f11.startsWith("BASH_")) continue;
    if (f11.endsWith("__length")) {
      let h17 = f11.slice(0, -8);
      c15.add(h17);
      continue;
    }
    let d16 = f11.lastIndexOf("_");
    if (d16 > 0) {
      let h17 = f11.slice(0, d16), m25 = f11.slice(d16 + 1);
      if (/^\d+$/.test(m25) || e7.state.associativeArrays?.has(h17)) {
        c15.add(h17);
        continue;
      }
    }
    c15.add(f11);
  }
  if (e7.state.localVarDepth) for (let f11 of e7.state.localVarDepth.keys()) c15.add(f11);
  if (e7.state.associativeArrays) for (let f11 of e7.state.associativeArrays) c15.add(f11);
  let u11 = Array.from(c15).sort();
  for (let f11 of u11) {
    let d16 = bn4(e7, f11), h17 = e7.state.associativeArrays?.has(f11), m25 = dt(e7, f11), p17 = !h17 && (m25.length > 0 || e7.state.env.has(`${f11}__length`));
    if (a7 && (o9 && !h17 || i10 && !p17 || s9 && !e7.state.exportedVars?.has(f11) || r8 && !e7.state.readonlyVars?.has(f11) || n23 && !L2(e7, f11))) continue;
    if (h17) {
      let S17 = mt(e7, f11);
      if (S17.length === 0) l8 += `declare -A ${f11}=()
`;
      else {
        let v21 = S17.map((P20) => {
          let y18 = e7.state.env.get(`${f11}_${P20}`) ?? "", w19 = Vs2(y18);
          return `['${P20}']=${w19}`;
        });
        l8 += `declare -A ${f11}=(${v21.join(" ")})
`;
      }
      continue;
    }
    if (m25.length > 0) {
      let S17 = m25.map((v21) => {
        let P20 = e7.state.env.get(`${f11}_${v21}`) ?? "";
        return `[${v21}]=${Ge6(P20)}`;
      });
      l8 += `declare -a ${f11}=(${S17.join(" ")})
`;
      continue;
    }
    if (e7.state.env.has(`${f11}__length`)) {
      l8 += `declare -a ${f11}=()
`;
      continue;
    }
    let g18 = e7.state.env.get(f11);
    g18 !== void 0 && (l8 += `declare ${d16} ${f11}=${Ws2(g18)}
`);
  }
  return M14(l8);
}
function Sn2(e7) {
  let t6 = "", s9 = Array.from(e7.state.associativeArrays ?? []).sort();
  for (let r8 of s9) {
    let n23 = mt(e7, r8);
    if (n23.length === 0) t6 += `declare -A ${r8}=()
`;
    else {
      let i10 = n23.map((o9) => {
        let a7 = e7.state.env.get(`${r8}_${o9}`) ?? "", l8 = Vs2(a7);
        return `['${o9}']=${l8}`;
      });
      t6 += `declare -A ${r8}=(${i10.join(" ")})
`;
    }
  }
  return M14(t6);
}
function Pn2(e7) {
  let t6 = "", s9 = /* @__PURE__ */ new Set();
  for (let n23 of e7.state.env.keys()) {
    if (n23.startsWith("BASH_")) continue;
    if (n23.endsWith("__length")) {
      let o9 = n23.slice(0, -8);
      e7.state.associativeArrays?.has(o9) || s9.add(o9);
      continue;
    }
    let i10 = n23.lastIndexOf("_");
    if (i10 > 0) {
      let o9 = n23.slice(0, i10), a7 = n23.slice(i10 + 1);
      /^\d+$/.test(a7) && (e7.state.associativeArrays?.has(o9) || s9.add(o9));
    }
  }
  let r8 = Array.from(s9).sort();
  for (let n23 of r8) {
    let i10 = dt(e7, n23);
    if (i10.length === 0) t6 += `declare -a ${n23}=()
`;
    else {
      let o9 = i10.map((a7) => {
        let l8 = e7.state.env.get(`${n23}_${a7}`) ?? "";
        return `[${a7}]=${Ge6(l8)}`;
      });
      t6 += `declare -a ${n23}=(${o9.join(" ")})
`;
    }
  }
  return M14(t6);
}
function An2(e7) {
  let t6 = "", s9 = /* @__PURE__ */ new Set();
  for (let n23 of e7.state.env.keys()) {
    if (n23.startsWith("BASH_")) continue;
    if (n23.endsWith("__length")) {
      let o9 = n23.slice(0, -8);
      s9.add(o9);
      continue;
    }
    let i10 = n23.lastIndexOf("_");
    if (i10 > 0) {
      let o9 = n23.slice(0, i10), a7 = n23.slice(i10 + 1);
      if (/^\d+$/.test(a7) || e7.state.associativeArrays?.has(o9)) {
        s9.add(o9);
        continue;
      }
    }
    s9.add(n23);
  }
  let r8 = Array.from(s9).sort();
  for (let n23 of r8) {
    if (e7.state.associativeArrays?.has(n23) || dt(e7, n23).length > 0 || e7.state.env.has(`${n23}__length`)) continue;
    let a7 = e7.state.env.get(n23);
    a7 !== void 0 && (t6 += `${n23}=${Jt3(a7)}
`);
  }
  return M14(t6);
}
function Bs2(e7, t6) {
  e7.state.integerVars ??= /* @__PURE__ */ new Set(), e7.state.integerVars.add(t6);
}
function wt5(e7, t6) {
  return e7.state.integerVars?.has(t6) ?? false;
}
function js(e7, t6) {
  e7.state.lowercaseVars ??= /* @__PURE__ */ new Set(), e7.state.lowercaseVars.add(t6), e7.state.uppercaseVars?.delete(t6);
}
function wo(e7, t6) {
  return e7.state.lowercaseVars?.has(t6) ?? false;
}
function Us(e7, t6) {
  e7.state.uppercaseVars ??= /* @__PURE__ */ new Set(), e7.state.uppercaseVars.add(t6), e7.state.lowercaseVars?.delete(t6);
}
function vo(e7, t6) {
  return e7.state.uppercaseVars?.has(t6) ?? false;
}
function it6(e7, t6, s9) {
  return wo(e7, t6) ? s9.toLowerCase() : vo(e7, t6) ? s9.toUpperCase() : s9;
}
async function kn3(e7, t6) {
  try {
    let s9 = new V2(), r8 = M2(s9, t6), n23 = await R(e7, r8.expression);
    return String(n23);
  } catch {
    return "0";
  }
}
function bo2(e7) {
  let t6 = e7.match(/^[a-zA-Z_][a-zA-Z0-9_]*/);
  if (!t6) return null;
  let s9 = t6[0], r8 = s9.length;
  if (e7[r8] !== "[") return null;
  let n23 = 0, i10 = r8 + 1;
  for (; r8 < e7.length; r8++) if (e7[r8] === "[") n23++;
  else if (e7[r8] === "]" && (n23--, n23 === 0)) break;
  if (n23 !== 0) return null;
  let o9 = e7.slice(i10, r8);
  if (r8++, e7[r8] !== "=") return null;
  r8++;
  let a7 = e7.slice(r8);
  return { name: s9, indexExpr: o9, value: a7 };
}
async function Hs(e7, t6) {
  let s9 = false, r8 = false, n23 = false, i10 = false, o9 = false, a7 = false, l8 = false, c15 = false, u11 = false, f11 = false, d16 = false, h17 = false, m25 = false, p17 = false, g18 = false, S17 = [];
  for (let x23 = 0; x23 < t6.length; x23++) {
    let I18 = t6[x23];
    if (I18 === "-a") s9 = true;
    else if (I18 === "-A") r8 = true;
    else if (I18 === "-r") n23 = true;
    else if (I18 === "-x") i10 = true;
    else if (I18 === "-p") o9 = true;
    else if (I18 === "-n") a7 = true;
    else if (I18 === "+n") l8 = true;
    else if (I18 === "+a") c15 = true;
    else if (I18 === "+x") u11 = true;
    else if (I18 === "--") {
      S17.push(...t6.slice(x23 + 1));
      break;
    } else if (I18.startsWith("+")) {
      for (let k17 of I18.slice(1)) if (k17 === "n") l8 = true;
      else if (k17 === "a") c15 = true;
      else if (k17 === "x") u11 = true;
      else if (k17 !== "r") {
        if (k17 !== "i") {
          if (!(k17 === "f" || k17 === "F")) return _14("", `bash: typeset: +${k17}: invalid option
`, 2);
        }
      }
    } else if (I18 === "-i") f11 = true;
    else if (I18 === "-l") d16 = true;
    else if (I18 === "-u") h17 = true;
    else if (I18 === "-f") m25 = true;
    else if (I18 === "-F") p17 = true;
    else if (I18 === "-g") g18 = true;
    else if (I18.startsWith("-")) for (let k17 of I18.slice(1)) if (k17 === "a") s9 = true;
    else if (k17 === "A") r8 = true;
    else if (k17 === "r") n23 = true;
    else if (k17 === "x") i10 = true;
    else if (k17 === "p") o9 = true;
    else if (k17 === "n") a7 = true;
    else if (k17 === "i") f11 = true;
    else if (k17 === "l") d16 = true;
    else if (k17 === "u") h17 = true;
    else if (k17 === "f") m25 = true;
    else if (k17 === "F") p17 = true;
    else if (k17 === "g") g18 = true;
    else return _14("", `bash: typeset: -${k17}: invalid option
`, 2);
    else S17.push(I18);
  }
  let P20 = e7.state.localScopes.length > 0 && !g18, y18 = (x23) => {
    if (!P20) return;
    let I18 = e7.state.localScopes[e7.state.localScopes.length - 1];
    I18.has(x23) || I18.set(x23, e7.state.env.get(x23));
  }, w19 = (x23) => {
    if (!P20) return;
    let I18 = e7.state.localScopes[e7.state.localScopes.length - 1];
    I18.has(x23) || I18.set(x23, e7.state.env.get(x23));
    let k17 = `${x23}_`;
    for (let N15 of e7.state.env.keys()) N15.startsWith(k17) && !N15.includes("__") && (I18.has(N15) || I18.set(N15, e7.state.env.get(N15)));
    let C19 = `${x23}__length`;
    e7.state.env.has(C19) && !I18.has(C19) && I18.set(C19, e7.state.env.get(C19));
  }, b25 = (x23) => {
    P20 && Ve7(e7, x23);
  };
  if (p17) {
    if (S17.length === 0) {
      let k17 = Array.from(e7.state.functions.keys()).sort(), C19 = "";
      for (let N15 of k17) C19 += `declare -f ${N15}
`;
      return M14(C19);
    }
    let x23 = true, I18 = "";
    for (let k17 of S17) e7.state.functions.has(k17) ? I18 += `${k17}
` : x23 = false;
    return _14(I18, "", x23 ? 0 : 1);
  }
  if (m25) {
    if (S17.length === 0) {
      let I18 = "", k17 = Array.from(e7.state.functions.keys()).sort();
      for (let C19 of k17) I18 += `${C19} ()
{
    # function body
}
`;
      return M14(I18);
    }
    let x23 = true;
    for (let I18 of S17) e7.state.functions.has(I18) || (x23 = false);
    return _14("", "", x23 ? 0 : 1);
  }
  if (o9 && S17.length > 0) return En3(e7, S17);
  if (o9 && S17.length === 0) return $n2(e7, { filterExport: i10, filterReadonly: n23, filterNameref: a7, filterIndexedArray: s9, filterAssocArray: r8 });
  if (S17.length === 0 && r8 && !o9) return Sn2(e7);
  if (S17.length === 0 && s9 && !o9) return Pn2(e7);
  if (S17.length === 0 && !o9) return An2(e7);
  let E13 = "", T10 = 0;
  for (let x23 of S17) {
    let I18 = x23.match(/^([a-zA-Z_][a-zA-Z0-9_]*)=\((.*)\)$/s);
    if (I18 && !c15) {
      let $18 = I18[1], O17 = I18[2];
      if (r8 && dt(e7, $18).length > 0) {
        E13 += `bash: declare: ${$18}: cannot convert indexed to associative array
`, T10 = 1;
        continue;
      }
      if ((s9 || !r8 && !s9) && e7.state.associativeArrays?.has($18)) {
        E13 += `bash: declare: ${$18}: cannot convert associative to indexed array
`, T10 = 1;
        continue;
      }
      if (w19($18), r8 && (e7.state.associativeArrays ??= /* @__PURE__ */ new Set(), e7.state.associativeArrays.add($18)), _i(e7, $18), e7.state.env.delete($18), e7.state.env.delete(`${$18}__length`), r8 && O17.includes("[")) {
        let R13 = Zt3(O17);
        for (let [ee7, V13] of R13) {
          let K9 = Z12(e7, V13);
          e7.state.env.set(`${$18}_${ee7}`, K9);
        }
      } else if (r8) {
        let R13 = Ce5(O17);
        for (let ee7 = 0; ee7 < R13.length; ee7 += 2) {
          let V13 = R13[ee7], K9 = ee7 + 1 < R13.length ? Z12(e7, R13[ee7 + 1]) : "";
          e7.state.env.set(`${$18}_${V13}`, K9);
        }
      } else {
        let R13 = Ce5(O17);
        if (R13.some((V13) => /^\[[^\]]+\]=/.test(V13))) {
          let V13 = 0;
          for (let K9 of R13) {
            let oe9 = K9.match(/^\[([^\]]+)\]=(.*)$/);
            if (oe9) {
              let pe8 = oe9[1], Xe6 = oe9[2], $i3 = Z12(e7, Xe6), ht4;
              if (/^-?\d+$/.test(pe8)) ht4 = Number.parseInt(pe8, 10);
              else try {
                let Si2 = new V2(), Pi2 = M2(Si2, pe8);
                ht4 = await R(e7, Pi2.expression);
              } catch {
                ht4 = 0;
              }
              e7.state.env.set(`${$18}_${ht4}`, $i3), V13 = ht4 + 1;
            } else {
              let pe8 = Z12(e7, K9);
              e7.state.env.set(`${$18}_${V13}`, pe8), V13++;
            }
          }
        } else {
          for (let V13 = 0; V13 < R13.length; V13++) e7.state.env.set(`${$18}_${V13}`, R13[V13]);
          e7.state.env.set(`${$18}__length`, String(R13.length));
        }
      }
      b25($18), n23 && fa(e7, $18), i10 && pa(e7, $18);
      continue;
    }
    if (l8) {
      let $18 = x23.includes("=") ? x23.slice(0, x23.indexOf("=")) : x23;
      if (Mi(e7, $18), !x23.includes("=")) continue;
    }
    if (u11) {
      let $18 = x23.includes("=") ? x23.slice(0, x23.indexOf("=")) : x23;
      if (da(e7, $18), !x23.includes("=")) continue;
    }
    let k17 = bo2(x23);
    if (k17) {
      let { name: $18, indexExpr: O17, value: R13 } = k17, ee7 = ha(e7, $18);
      if (ee7) return ee7;
      w19($18);
      let V13;
      try {
        let oe9 = new V2(), pe8 = M2(oe9, O17);
        V13 = await R(e7, pe8.expression);
      } catch {
        let oe9 = parseInt(O17, 10);
        V13 = Number.isNaN(oe9) ? 0 : oe9;
      }
      e7.state.env.set(`${$18}_${V13}`, R13);
      let K9 = parseInt(e7.state.env.get(`${$18}__length`) ?? "0", 10);
      V13 >= K9 && e7.state.env.set(`${$18}__length`, String(V13 + 1)), b25($18), n23 && fa(e7, $18), i10 && pa(e7, $18);
      continue;
    }
    let C19 = x23.match(/^([a-zA-Z_][a-zA-Z0-9_]*)\+=\((.*)\)$/s);
    if (C19 && !c15) {
      let $18 = C19[1], O17 = C19[2], R13 = ha(e7, $18);
      if (R13) return R13;
      w19($18);
      let ee7 = Ce5(O17);
      if (e7.state.associativeArrays?.has($18)) {
        let V13 = Zt3(O17);
        for (let [K9, oe9] of V13) {
          let pe8 = Z12(e7, oe9);
          e7.state.env.set(`${$18}_${K9}`, pe8);
        }
      } else {
        let V13 = dt(e7, $18), K9 = 0, oe9 = e7.state.env.get($18);
        V13.length === 0 && oe9 !== void 0 ? (e7.state.env.set(`${$18}_0`, oe9), e7.state.env.delete($18), K9 = 1) : V13.length > 0 && (K9 = Math.max(...V13) + 1);
        for (let Xe6 = 0; Xe6 < ee7.length; Xe6++) e7.state.env.set(`${$18}_${K9 + Xe6}`, Z12(e7, ee7[Xe6]));
        let pe8 = K9 + ee7.length;
        e7.state.env.set(`${$18}__length`, String(pe8));
      }
      b25($18), n23 && fa(e7, $18), i10 && pa(e7, $18);
      continue;
    }
    let N15 = x23.match(/^([a-zA-Z_][a-zA-Z0-9_]*)\+=(.*)$/);
    if (N15) {
      let $18 = N15[1], O17 = Z12(e7, N15[2]), R13 = ha(e7, $18);
      if (R13) return R13;
      y18($18), f11 && Bs2(e7, $18), d16 && js(e7, $18), h17 && Us(e7, $18);
      let V13 = dt(e7, $18).length > 0 || e7.state.associativeArrays?.has($18);
      if (wt5(e7, $18)) {
        let K9 = e7.state.env.get($18) ?? "0", oe9 = parseInt(K9, 10) || 0, pe8 = parseInt(await kn3(e7, O17), 10) || 0;
        O17 = String(oe9 + pe8), e7.state.env.set($18, O17);
      } else if (V13) {
        O17 = it6(e7, $18, O17);
        let K9 = `${$18}_0`, oe9 = e7.state.env.get(K9) ?? "";
        e7.state.env.set(K9, oe9 + O17);
      } else {
        O17 = it6(e7, $18, O17);
        let K9 = e7.state.env.get($18) ?? "";
        e7.state.env.set($18, K9 + O17);
      }
      b25($18), n23 && fa(e7, $18), i10 && pa(e7, $18), e7.state.options.allexport && !u11 && (e7.state.exportedVars = e7.state.exportedVars || /* @__PURE__ */ new Set(), e7.state.exportedVars.add($18));
      continue;
    }
    if (x23.includes("=")) {
      let $18 = x23.indexOf("="), O17 = x23.slice(0, $18), R13 = x23.slice($18 + 1);
      if (!/^[a-zA-Z_][a-zA-Z0-9_]*$/.test(O17)) {
        E13 += `bash: typeset: \`${O17}': not a valid identifier
`, T10 = 1;
        continue;
      }
      let ee7 = ha(e7, O17);
      if (ee7) return ee7;
      if (y18(O17), a7) {
        if (R13 !== "" && !/^[a-zA-Z_][a-zA-Z0-9_]*(\[.+\])?$/.test(R13)) {
          E13 += `bash: declare: \`${R13}': invalid variable name for name reference
`, T10 = 1;
          continue;
        }
        e7.state.env.set(O17, R13), Ti(e7, O17), R13 !== "" && os(e7, R13) && qi(e7, O17), b25(O17), n23 && fa(e7, O17), i10 && pa(e7, O17);
        continue;
      }
      if (f11 && Bs2(e7, O17), d16 && js(e7, O17), h17 && Us(e7, O17), wt5(e7, O17) && (R13 = await kn3(e7, R13)), R13 = it6(e7, O17, R13), L2(e7, O17)) {
        let V13 = he(e7, O17);
        V13 && V13 !== O17 ? e7.state.env.set(V13, R13) : e7.state.env.set(O17, R13);
      } else e7.state.env.set(O17, R13);
      b25(O17), n23 && fa(e7, O17), i10 && pa(e7, O17), e7.state.options.allexport && !u11 && (e7.state.exportedVars = e7.state.exportedVars || /* @__PURE__ */ new Set(), e7.state.exportedVars.add(O17));
    } else {
      let $18 = x23;
      if (!/^[a-zA-Z_][a-zA-Z0-9_]*$/.test($18)) {
        E13 += `bash: typeset: \`${$18}': not a valid identifier
`, T10 = 1;
        continue;
      }
      if (s9 || r8 ? w19($18) : y18($18), a7) {
        Ti(e7, $18);
        let R13 = e7.state.env.get($18);
        R13 !== void 0 && R13 !== "" && !/^[a-zA-Z_][a-zA-Z0-9_]*(\[.+\])?$/.test(R13) ? Vi(e7, $18) : R13 && os(e7, R13) && qi(e7, $18), b25($18), n23 && fa(e7, $18), i10 && pa(e7, $18);
        continue;
      }
      if (f11 && Bs2(e7, $18), d16 && js(e7, $18), h17 && Us(e7, $18), r8) {
        if (dt(e7, $18).length > 0) {
          E13 += `bash: declare: ${$18}: cannot convert indexed to associative array
`, T10 = 1;
          continue;
        }
        e7.state.associativeArrays ??= /* @__PURE__ */ new Set(), e7.state.associativeArrays.add($18);
      }
      let O17 = Array.from(e7.state.env.keys()).some((R13) => R13.startsWith(`${$18}_`) && !R13.startsWith(`${$18}__length`));
      !e7.state.env.has($18) && !O17 && (s9 || r8 ? e7.state.env.set(`${$18}__length`, "0") : (e7.state.declaredVars ??= /* @__PURE__ */ new Set(), e7.state.declaredVars.add($18))), b25($18), n23 && fa(e7, $18), i10 && pa(e7, $18);
    }
  }
  return _14("", E13, T10);
}
async function qs3(e7, t6) {
  let s9 = false, r8 = false, n23 = false, i10 = [];
  for (let o9 = 0; o9 < t6.length; o9++) {
    let a7 = t6[o9];
    if (a7 === "-a") s9 = true;
    else if (a7 === "-A") r8 = true;
    else if (a7 === "-p") n23 = true;
    else if (a7 === "--") {
      i10.push(...t6.slice(o9 + 1));
      break;
    } else a7.startsWith("-") || i10.push(a7);
  }
  if (i10.length === 0) {
    let o9 = "", a7 = Array.from(e7.state.readonlyVars || []).sort();
    for (let l8 of a7) {
      let c15 = e7.state.env.get(l8);
      if (c15 !== void 0) {
        let u11 = c15.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
        o9 += `declare -r ${l8}="${u11}"
`;
      }
    }
    return M14(o9);
  }
  for (let o9 of i10) {
    let a7 = o9.match(/^([a-zA-Z_][a-zA-Z0-9_]*)\+=\((.*)\)$/s);
    if (a7) {
      let f11 = a7[1], d16 = a7[2], h17 = ha(e7, f11);
      if (h17) return h17;
      let m25 = Ce5(d16);
      if (e7.state.associativeArrays?.has(f11)) {
        let p17 = Zt3(d16);
        for (let [g18, S17] of p17) {
          let v21 = Z12(e7, S17);
          e7.state.env.set(`${f11}_${g18}`, v21);
        }
      } else {
        let p17 = dt(e7, f11), g18 = 0, S17 = e7.state.env.get(f11);
        p17.length === 0 && S17 !== void 0 ? (e7.state.env.set(`${f11}_0`, S17), e7.state.env.delete(f11), g18 = 1) : p17.length > 0 && (g18 = Math.max(...p17) + 1);
        for (let P20 = 0; P20 < m25.length; P20++) e7.state.env.set(`${f11}_${g18 + P20}`, Z12(e7, m25[P20]));
        let v21 = g18 + m25.length;
        e7.state.env.set(`${f11}__length`, String(v21));
      }
      fa(e7, f11);
      continue;
    }
    let l8 = o9.match(/^([a-zA-Z_][a-zA-Z0-9_]*)\+=(.*)$/);
    if (l8) {
      let f11 = l8[1], d16 = Z12(e7, l8[2]), h17 = ha(e7, f11);
      if (h17) return h17;
      let m25 = e7.state.env.get(f11) ?? "";
      e7.state.env.set(f11, m25 + d16), fa(e7, f11);
      continue;
    }
    let c15 = un2(o9);
    if (c15.value === void 0 && !c15.isArray) {
      fa(e7, c15.name);
      continue;
    }
    let u11 = await fn3(e7, c15, { makeReadonly: true });
    if (u11) return u11;
  }
  return L17;
}
function Gs(e7) {
  return e7.state.directoryStack ??= [], e7.state.directoryStack;
}
function vt4(e7, t6) {
  return t6 && e7 === t6 ? "~" : t6 && e7.startsWith(`${t6}/`) ? `~${e7.slice(t6.length)}` : e7;
}
function Eo(e7) {
  let t6 = e7.split("/").filter((r8) => r8 && r8 !== "."), s9 = [];
  for (let r8 of t6) r8 === ".." ? s9.pop() : s9.push(r8);
  return `/${s9.join("/")}`;
}
async function Zs(e7, t6) {
  let s9 = Gs(e7), r8;
  for (let a7 = 0; a7 < t6.length; a7++) {
    let l8 = t6[a7];
    if (l8 === "--") {
      if (a7 + 1 < t6.length) {
        if (r8 !== void 0) return A13(`bash: pushd: too many arguments
`, 2);
        r8 = t6[a7 + 1], a7++;
      }
    } else {
      if (l8.startsWith("-") && l8 !== "-") return A13(`bash: pushd: ${l8}: invalid option
`, 2);
      if (r8 !== void 0) return A13(`bash: pushd: too many arguments
`, 2);
      r8 = l8;
    }
  }
  if (r8 === void 0) {
    if (s9.length < 2) return A13(`bash: pushd: no other directory
`, 1);
    let a7 = s9[0];
    s9[0] = s9[1], s9[1] = a7, r8 = s9[0];
  }
  let n23;
  if (r8.startsWith("/")) n23 = r8;
  else if (r8 === "..") {
    let a7 = e7.state.cwd.split("/").filter((l8) => l8);
    a7.pop(), n23 = `/${a7.join("/")}`;
  } else r8 === "." ? n23 = e7.state.cwd : r8.startsWith("~") ? n23 = (e7.state.env.get("HOME") || "/") + r8.slice(1) : n23 = `${e7.state.cwd}/${r8}`;
  n23 = Eo(n23);
  try {
    if (!(await e7.fs.stat(n23)).isDirectory) return A13(`bash: pushd: ${r8}: Not a directory
`, 1);
  } catch {
    return A13(`bash: pushd: ${r8}: No such file or directory
`, 1);
  }
  s9.unshift(e7.state.cwd), e7.state.previousDir = e7.state.cwd, e7.state.cwd = n23, e7.state.env.set("PWD", n23), e7.state.env.set("OLDPWD", e7.state.previousDir);
  let i10 = e7.state.env.get("HOME") || "", o9 = `${[n23, ...s9].map((a7) => vt4(a7, i10)).join(" ")}
`;
  return M14(o9);
}
function Ks2(e7, t6) {
  let s9 = Gs(e7);
  for (let o9 of t6) if (o9 !== "--") return o9.startsWith("-") && o9 !== "-" ? A13(`bash: popd: ${o9}: invalid option
`, 2) : A13(`bash: popd: too many arguments
`, 2);
  if (s9.length === 0) return A13(`bash: popd: directory stack empty
`, 1);
  let r8 = s9.shift();
  if (!r8) return A13(`bash: popd: directory stack empty
`, 1);
  e7.state.previousDir = e7.state.cwd, e7.state.cwd = r8, e7.state.env.set("PWD", r8), e7.state.env.set("OLDPWD", e7.state.previousDir);
  let n23 = e7.state.env.get("HOME") || "", i10 = `${[r8, ...s9].map((o9) => vt4(o9, n23)).join(" ")}
`;
  return M14(i10);
}
function Xs(e7, t6) {
  let s9 = Gs(e7), r8 = false, n23 = false, i10 = false, o9 = false;
  for (let u11 of t6) if (u11 !== "--") if (u11.startsWith("-")) for (let f11 of u11.slice(1)) if (f11 === "c") r8 = true;
  else if (f11 === "l") n23 = true;
  else if (f11 === "p") i10 = true;
  else if (f11 === "v") i10 = true, o9 = true;
  else return A13(`bash: dirs: -${f11}: invalid option
`, 2);
  else return A13(`bash: dirs: too many arguments
`, 1);
  if (r8) return e7.state.directoryStack = [], L17;
  let a7 = [e7.state.cwd, ...s9], l8 = e7.state.env.get("HOME") || "", c15;
  return o9 ? (c15 = a7.map((u11, f11) => {
    let d16 = n23 ? u11 : vt4(u11, l8);
    return ` ${f11}  ${d16}`;
  }).join(`
`), c15 += `
`) : i10 ? c15 = a7.map((u11) => n23 ? u11 : vt4(u11, l8)).join(`
`) + `
` : c15 = a7.map((u11) => n23 ? u11 : vt4(u11, l8)).join(" ") + `
`, M14(c15);
}
async function es2(e7, t6, s9) {
  let r8 = t6;
  if (r8.length > 0) {
    let a7 = r8[0];
    if (a7 === "--") r8 = r8.slice(1);
    else if (a7.startsWith("-") && a7 !== "-" && a7.length > 1) return A13(`bash: eval: ${a7}: invalid option
eval: usage: eval [arg ...]
`, 2);
  }
  if (r8.length === 0) return L17;
  let n23 = r8.join(" ");
  if (n23.trim() === "") return L17;
  let i10 = e7.state.groupStdin, o9 = s9 ?? e7.state.groupStdin;
  o9 !== void 0 && (e7.state.groupStdin = o9);
  try {
    let a7 = hi(n23);
    return await e7.executeScript(a7);
  } catch (a7) {
    if (a7 instanceof c2 || a7 instanceof a2 || a7 instanceof i || a7 instanceof d2) throw a7;
    if (a7.name === "ParseException") return A13(`bash: eval: ${a7.message}
`);
    throw a7;
  } finally {
    e7.state.groupStdin = i10;
  }
}
function Ys(e7, t6) {
  let s9, r8 = "";
  if (t6.length === 0) s9 = e7.state.lastExitCode;
  else {
    let n23 = t6[0], i10 = Number.parseInt(n23, 10);
    n23 === "" || Number.isNaN(i10) || !/^-?\d+$/.test(n23) ? (r8 = `bash: exit: ${n23}: numeric argument required
`, s9 = 2) : s9 = (i10 % 256 + 256) % 256;
  }
  throw new d2(s9, "", r8);
}
function Qs(e7, t6) {
  let s9 = false, r8 = [];
  for (let o9 of t6) o9 === "-n" ? s9 = true : o9 === "-p" || o9 === "--" || r8.push(o9);
  if (r8.length === 0 && !s9) {
    let o9 = "", a7 = e7.state.exportedVars ?? /* @__PURE__ */ new Set(), l8 = Array.from(a7).sort();
    for (let c15 of l8) {
      let u11 = e7.state.env.get(c15);
      if (u11 !== void 0) {
        let f11 = u11.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
        o9 += `declare -x ${c15}="${f11}"
`;
      }
    }
    return M14(o9);
  }
  if (s9) {
    for (let o9 of r8) {
      let a7, l8;
      if (o9.includes("=")) {
        let c15 = o9.indexOf("=");
        a7 = o9.slice(0, c15), l8 = Z12(e7, o9.slice(c15 + 1)), e7.state.env.set(a7, l8);
      } else a7 = o9;
      da(e7, a7);
    }
    return L17;
  }
  let n23 = "", i10 = 0;
  for (let o9 of r8) {
    let a7, l8, c15 = false, u11 = o9.match(/^([a-zA-Z_][a-zA-Z0-9_]*)\+=(.*)$/);
    if (u11) a7 = u11[1], l8 = Z12(e7, u11[2]), c15 = true;
    else if (o9.includes("=")) {
      let f11 = o9.indexOf("=");
      a7 = o9.slice(0, f11), l8 = Z12(e7, o9.slice(f11 + 1));
    } else a7 = o9;
    if (!/^[a-zA-Z_][a-zA-Z0-9_]*$/.test(a7)) {
      n23 += `bash: export: \`${o9}': not a valid identifier
`, i10 = 1;
      continue;
    }
    if (l8 !== void 0) if (c15) {
      let f11 = e7.state.env.get(a7) ?? "";
      e7.state.env.set(a7, f11 + l8);
    } else e7.state.env.set(a7, l8);
    else e7.state.env.has(a7) || e7.state.env.set(a7, "");
    pa(e7, a7);
  }
  return _14("", n23, i10);
}
function ts2(e7, t6) {
  if (t6.length < 2) return A13(`bash: getopts: usage: getopts optstring name [arg ...]
`);
  let s9 = t6[0], r8 = t6[1], n23 = !/^[a-zA-Z_][a-zA-Z0-9_]*$/.test(r8), i10 = s9.startsWith(":"), o9 = i10 ? s9.slice(1) : s9, a7;
  if (t6.length > 2) a7 = t6.slice(2);
  else {
    let p17 = Number.parseInt(e7.state.env.get("#") || "0", 10);
    a7 = [];
    for (let g18 = 1; g18 <= p17; g18++) a7.push(e7.state.env.get(String(g18)) || "");
  }
  let l8 = Number.parseInt(e7.state.env.get("OPTIND") || "1", 10);
  l8 < 1 && (l8 = 1);
  let c15 = Number.parseInt(e7.state.env.get("__GETOPTS_CHARINDEX") || "0", 10);
  if (e7.state.env.set("OPTARG", ""), l8 > a7.length) return n23 || e7.state.env.set(r8, "?"), e7.state.env.set("OPTIND", String(a7.length + 1)), e7.state.env.set("__GETOPTS_CHARINDEX", "0"), { exitCode: n23 ? 2 : 1, stdout: "", stderr: "" };
  let u11 = a7[l8 - 1];
  if (!u11 || u11 === "-" || !u11.startsWith("-")) return n23 || e7.state.env.set(r8, "?"), { exitCode: n23 ? 2 : 1, stdout: "", stderr: "" };
  if (u11 === "--") return e7.state.env.set("OPTIND", String(l8 + 1)), e7.state.env.set("__GETOPTS_CHARINDEX", "0"), n23 || e7.state.env.set(r8, "?"), { exitCode: n23 ? 2 : 1, stdout: "", stderr: "" };
  let f11 = c15 === 0 ? 1 : c15, d16 = u11[f11];
  if (!d16) return e7.state.env.set("OPTIND", String(l8 + 1)), e7.state.env.set("__GETOPTS_CHARINDEX", "0"), ts2(e7, t6);
  let h17 = o9.indexOf(d16);
  if (h17 === -1) {
    let p17 = "";
    return i10 ? e7.state.env.set("OPTARG", d16) : p17 = `bash: illegal option -- ${d16}
`, n23 || e7.state.env.set(r8, "?"), f11 + 1 < u11.length ? (e7.state.env.set("__GETOPTS_CHARINDEX", String(f11 + 1)), e7.state.env.set("OPTIND", String(l8))) : (e7.state.env.set("OPTIND", String(l8 + 1)), e7.state.env.set("__GETOPTS_CHARINDEX", "0")), { exitCode: n23 ? 2 : 0, stdout: "", stderr: p17 };
  }
  if (h17 + 1 < o9.length && o9[h17 + 1] === ":") if (f11 + 1 < u11.length) e7.state.env.set("OPTARG", u11.slice(f11 + 1)), e7.state.env.set("OPTIND", String(l8 + 1)), e7.state.env.set("__GETOPTS_CHARINDEX", "0");
  else {
    if (l8 >= a7.length) {
      let p17 = "";
      return i10 ? (e7.state.env.set("OPTARG", d16), n23 || e7.state.env.set(r8, ":")) : (p17 = `bash: option requires an argument -- ${d16}
`, n23 || e7.state.env.set(r8, "?")), e7.state.env.set("OPTIND", String(l8 + 1)), e7.state.env.set("__GETOPTS_CHARINDEX", "0"), { exitCode: n23 ? 2 : 0, stdout: "", stderr: p17 };
    }
    e7.state.env.set("OPTARG", a7[l8]), e7.state.env.set("OPTIND", String(l8 + 2)), e7.state.env.set("__GETOPTS_CHARINDEX", "0");
  }
  else f11 + 1 < u11.length ? (e7.state.env.set("__GETOPTS_CHARINDEX", String(f11 + 1)), e7.state.env.set("OPTIND", String(l8))) : (e7.state.env.set("OPTIND", String(l8 + 1)), e7.state.env.set("__GETOPTS_CHARINDEX", "0"));
  return n23 || e7.state.env.set(r8, d16), { exitCode: n23 ? 2 : 0, stdout: "", stderr: "" };
}
async function Js(e7, t6) {
  e7.state.hashTable || (e7.state.hashTable = /* @__PURE__ */ new Map());
  let s9 = false, r8 = false, n23 = false, i10 = false, o9 = false, a7 = "", l8 = [], c15 = 0;
  for (; c15 < t6.length; ) {
    let m25 = t6[c15];
    if (m25 === "--") {
      c15++, l8.push(...t6.slice(c15));
      break;
    }
    if (m25 === "-r") s9 = true, c15++;
    else if (m25 === "-d") r8 = true, c15++;
    else if (m25 === "-l") n23 = true, c15++;
    else if (m25 === "-t") o9 = true, c15++;
    else if (m25 === "-p") {
      if (i10 = true, c15++, c15 >= t6.length) return A13(`bash: hash: -p: option requires an argument
`, 1);
      a7 = t6[c15], c15++;
    } else if (m25.startsWith("-") && m25.length > 1) {
      for (let p17 of m25.slice(1)) if (p17 === "r") s9 = true;
      else if (p17 === "d") r8 = true;
      else if (p17 === "l") n23 = true;
      else if (p17 === "t") o9 = true;
      else return p17 === "p" ? A13(`bash: hash: -p: option requires an argument
`, 1) : A13(`bash: hash: -${p17}: invalid option
`, 1);
      c15++;
    } else l8.push(m25), c15++;
  }
  if (s9) return e7.state.hashTable.clear(), L17;
  if (r8) {
    if (l8.length === 0) return A13(`bash: hash: -d: option requires an argument
`, 1);
    let m25 = false, p17 = "";
    for (let g18 of l8) e7.state.hashTable.has(g18) ? e7.state.hashTable.delete(g18) : (p17 += `bash: hash: ${g18}: not found
`, m25 = true);
    return m25 ? A13(p17, 1) : L17;
  }
  if (o9) {
    if (l8.length === 0) return A13(`bash: hash: -t: option requires an argument
`, 1);
    let m25 = "", p17 = false, g18 = "";
    for (let S17 of l8) {
      let v21 = e7.state.hashTable.get(S17);
      v21 ? l8.length > 1 ? m25 += `${S17}	${v21}
` : m25 += `${v21}
` : (g18 += `bash: hash: ${S17}: not found
`, p17 = true);
    }
    return p17 ? { exitCode: 1, stdout: m25, stderr: g18 } : M14(m25);
  }
  if (i10) {
    if (l8.length === 0) return A13(`bash: hash: usage: hash [-lr] [-p pathname] [-dt] [name ...]
`, 1);
    let m25 = l8[0];
    return e7.state.hashTable.set(m25, a7), L17;
  }
  if (l8.length === 0) {
    if (e7.state.hashTable.size === 0) return M14(`hash: hash table empty
`);
    let m25 = "";
    if (n23) for (let [p17, g18] of e7.state.hashTable) m25 += `builtin hash -p ${g18} ${p17}
`;
    else {
      m25 = `hits	command
`;
      for (let [, p17] of e7.state.hashTable) m25 += `   1	${p17}
`;
    }
    return M14(m25);
  }
  let u11 = false, f11 = "", h17 = (e7.state.env.get("PATH") || "/usr/bin:/bin").split(":");
  for (let m25 of l8) {
    if (m25.includes("/")) {
      f11 += `bash: hash: ${m25}: cannot use / in name
`, u11 = true;
      continue;
    }
    let p17 = false;
    for (let g18 of h17) {
      if (!g18) continue;
      let S17 = `${g18}/${m25}`;
      if (await e7.fs.exists(S17)) {
        e7.state.hashTable.set(m25, S17), p17 = true;
        break;
      }
    }
    p17 || (f11 += `bash: hash: ${m25}: not found
`, u11 = true);
  }
  return u11 ? A13(f11, 1) : L17;
}
var _n2 = /* @__PURE__ */ new Map([[":", [": [arguments]", `Null command.
    No effect; the command does nothing.
    Exit Status:
    Always succeeds.`]], [".", [". filename [arguments]", `Execute commands from a file in the current shell.
    Read and execute commands from FILENAME in the current shell.
    The entries in $PATH are used to find the directory containing FILENAME.
    Exit Status:
    Returns the status of the last command executed in FILENAME.`]], ["[", ["[ arg... ]", `Evaluate conditional expression.
    This is a synonym for the "test" builtin, but the last argument must
    be a literal \`]', to match the opening \`['.`]], ["alias", ["alias [-p] [name[=value] ... ]", `Define or display aliases.
    Without arguments, \`alias' prints the list of aliases in the reusable
    form \`alias NAME=VALUE' on standard output.
    Exit Status:
    alias returns true unless a NAME is supplied for which no alias has been
    defined.`]], ["bg", ["bg [job_spec ...]", `Move jobs to the background.
    Place the jobs identified by each JOB_SPEC in the background, as if they
    had been started with \`&'.`]], ["break", ["break [n]", `Exit for, while, or until loops.
    Exit a FOR, WHILE or UNTIL loop.  If N is specified, break N enclosing
    loops.
    Exit Status:
    The exit status is 0 unless N is not greater than or equal to 1.`]], ["builtin", ["builtin [shell-builtin [arg ...]]", `Execute shell builtins.
    Execute SHELL-BUILTIN with arguments ARGs without performing command
    lookup.  This is useful when you wish to reimplement a shell builtin
    as a shell function, but need to execute the builtin within the function.
    Exit Status:
    Returns the exit status of SHELL-BUILTIN, or false if SHELL-BUILTIN is
    not a shell builtin.`]], ["caller", ["caller [expr]", `Return the context of the current subroutine call.
    Without EXPR, returns "$line $filename".  With EXPR, returns
    "$line $subroutine $filename"; this extra information can be used to
    provide a stack trace.
    Exit Status:
    Returns 0 unless the shell is not executing a subroutine call or
    EXPR is invalid.`]], ["cd", ["cd [-L|-P] [dir]", `Change the shell working directory.
    Change the current directory to DIR.  The default DIR is the value of the
    HOME shell variable.

    The variable CDPATH defines the search path for the directory containing
    DIR.  Alternative directory names in CDPATH are separated by a colon (:).
    A null directory name is the same as the current directory.  If DIR begins
    with a slash (/), then CDPATH is not used.

    If the directory is not found, and the shell option \`cdable_vars' is set,
    the word is assumed to be a variable name.  If that variable has a value,
    its value is used for DIR.

    Options:
      -L	force symbolic links to be followed
      -P	use the physical directory structure without following symbolic
    	links

    The default is to follow symbolic links, as if \`-L' were specified.

    Exit Status:
    Returns 0 if the directory is changed; non-zero otherwise.`]], ["command", ["command [-pVv] command [arg ...]", `Execute a simple command or display information about commands.
    Runs COMMAND with ARGS suppressing shell function lookup, or display
    information about the specified COMMANDs.

    Options:
      -p	use a default value for PATH that is guaranteed to find all of
    	the standard utilities
      -v	print a description of COMMAND similar to the \`type' builtin
      -V	print a more verbose description of each COMMAND

    Exit Status:
    Returns exit status of COMMAND, or failure if COMMAND is not found.`]], ["compgen", ["compgen [-abcdefgjksuv] [-o option] [-A action] [-G globpat] [-W wordlist]  [-F function] [-C command] [-X filterpat] [-P prefix] [-S suffix] [word]", `Display possible completions depending on the options.
    Intended to be used from within a shell function generating possible
    completions.  If the optional WORD argument is supplied, matches against
    WORD are generated.
    Exit Status:
    Returns success unless an invalid option is supplied or an error occurs.`]], ["complete", ["complete [-abcdefgjksuv] [-pr] [-DEI] [-o option] [-A action] [-G globpat] [-W wordlist]  [-F function] [-C command] [-X filterpat] [-P prefix] [-S suffix] [name ...]", `Specify how arguments are to be completed.
    For each NAME, specify how arguments are to be completed.
    Exit Status:
    Returns success unless an invalid option is supplied or an error occurs.`]], ["continue", ["continue [n]", `Resume for, while, or until loops.
    Resumes the next iteration of the enclosing FOR, WHILE or UNTIL loop.
    If N is specified, resumes the Nth enclosing loop.
    Exit Status:
    The exit status is 0 unless N is not greater than or equal to 1.`]], ["declare", ["declare [-aAfFgilnrtux] [-p] [name[=value] ...]", `Set variable values and attributes.
    Declare variables and give them attributes.  If no NAMEs are given,
    display the attributes and values of all variables.

    Options:
      -a	to make NAMEs indexed arrays (if supported)
      -A	to make NAMEs associative arrays (if supported)
      -i	to make NAMEs have the \`integer' attribute
      -l	to convert the value of each NAME to lower case on assignment
      -n	make NAME a reference to the variable named by its value
      -r	to make NAMEs readonly
      -t	to make NAMEs have the \`trace' attribute
      -u	to convert the value of each NAME to upper case on assignment
      -x	to make NAMEs export

    Exit Status:
    Returns success unless an invalid option is supplied or a variable
    assignment error occurs.`]], ["dirs", ["dirs [-clpv] [+N] [-N]", `Display directory stack.
    Display the list of currently remembered directories.  Directories
    find their way onto the list with the \`pushd' command; you can get
    back up through the list with the \`popd' command.
    Exit Status:
    Returns success unless an invalid option is supplied or an error occurs.`]], ["disown", ["disown [-h] [-ar] [jobspec ...]", `Remove jobs from current shell.
    Without any JOBSPECs, remove the current job.`]], ["echo", ["echo [-neE] [arg ...]", `Write arguments to the standard output.
    Display the ARGs, separated by a single space character and followed by a
    newline, on the standard output.

    Options:
      -n	do not append a newline
      -e	enable interpretation of the following backslash escapes
      -E	explicitly suppress interpretation of backslash escapes

    Exit Status:
    Returns success unless a write error occurs.`]], ["enable", ["enable [-a] [-dnps] [-f filename] [name ...]", `Enable and disable shell builtins.
    Enables and disables builtin shell commands.
    Exit Status:
    Returns success unless NAME is not a shell builtin or an error occurs.`]], ["eval", ["eval [arg ...]", `Execute arguments as a shell command.
    Combine ARGs into a single string, use the result as input to the shell,
    and execute the resulting commands.
    Exit Status:
    Returns exit status of command or success if command is null.`]], ["exec", ["exec [-cl] [-a name] [command [arguments ...]] [redirection ...]", `Replace the shell with the given command.
    Execute COMMAND, replacing this shell with the specified program.
    ARGUMENTS become the arguments to COMMAND.  If COMMAND is not specified,
    any redirections take effect in the current shell.
    Exit Status:
    Returns success unless COMMAND is not found or a redirection error occurs.`]], ["exit", ["exit [n]", `Exit the shell.
    Exits the shell with a status of N.  If N is omitted, the exit status
    is that of the last command executed.`]], ["export", ["export [-fn] [name[=value] ...] or export -p", `Set export attribute for shell variables.
    Marks each NAME for automatic export to the environment of subsequently
    executed commands.  If VALUE is supplied, assign VALUE before exporting.

    Options:
      -f	refer to shell functions
      -n	remove the export property from each NAME
      -p	display a list of all exported variables and functions

    Exit Status:
    Returns success unless an invalid option is given or NAME is invalid.`]], ["false", ["false", `Return an unsuccessful result.
    Exit Status:
    Always fails.`]], ["fc", ["fc [-e ename] [-lnr] [first] [last] or fc -s [pat=rep] [command]", `Display or execute commands from the history list.
    Exit Status:
    Returns success or status of executed command.`]], ["fg", ["fg [job_spec]", `Move job to the foreground.
    Place the job identified by JOB_SPEC in the foreground, making it the
    current job.`]], ["getopts", ["getopts optstring name [arg]", `Parse option arguments.
    Getopts is used by shell procedures to parse positional parameters
    as options.

    OPTSTRING contains the option letters to be recognized; if a letter
    is followed by a colon, the option is expected to have an argument,
    which should be separated from it by white space.
    Exit Status:
    Returns success if an option is found; fails if the end of options is
    encountered or an error occurs.`]], ["hash", ["hash [-lr] [-p pathname] [-dt] [name ...]", `Remember or display program locations.
    Determine and remember the full pathname of each command NAME.
    Exit Status:
    Returns success unless NAME is not found or an invalid option is given.`]], ["help", ["help [-s] [pattern ...]", `Display information about builtin commands.
    Displays brief summaries of builtin commands.  If PATTERN is
    specified, gives detailed help on all commands matching PATTERN,
    otherwise the list of help topics is printed.

    Options:
      -s	output only a short usage synopsis for each topic matching
    	PATTERN

    Exit Status:
    Returns success unless PATTERN is not found.`]], ["history", ["history [-c] [-d offset] [n] or history -anrw [filename] or history -ps arg [arg...]", `Display or manipulate the history list.
    Display the history list with line numbers, prefixing each modified
    entry with a \`*'.
    Exit Status:
    Returns success unless an invalid option is given or an error occurs.`]], ["jobs", ["jobs [-lnprs] [jobspec ...] or jobs -x command [args]", `Display status of jobs.
    Lists the active jobs.
    Exit Status:
    Returns success unless an invalid option is given or an error occurs.`]], ["kill", ["kill [-s sigspec | -n signum | -sigspec] pid | jobspec ... or kill -l [sigspec]", `Send a signal to a job.
    Send the processes identified by PID or JOBSPEC the signal named by
    SIGSPEC or SIGNUM.
    Exit Status:
    Returns success unless an invalid option is given or an error occurs.`]], ["let", ["let arg [arg ...]", `Evaluate arithmetic expressions.
    Evaluate each ARG as an arithmetic expression.  Evaluation is done in
    fixed-width integers with no check for overflow, though division by 0
    is trapped and flagged as an error.
    Exit Status:
    If the last ARG evaluates to 0, let returns 1; 0 is returned otherwise.`]], ["local", ["local [option] name[=value] ...", `Define local variables.
    Create a local variable called NAME, and give it VALUE.  OPTION can
    be any option accepted by \`declare'.

    Local can only be used within a function; it makes the variable NAME
    have a visible scope restricted to that function and its children.
    Exit Status:
    Returns success unless an invalid option is supplied, a variable
    assignment error occurs, or the shell is not executing a function.`]], ["logout", ["logout [n]", `Exit a login shell.
    Exits a login shell with exit status N.  Returns an error if not executed
    in a login shell.`]], ["mapfile", ["mapfile [-d delim] [-n count] [-O origin] [-s count] [-t] [-u fd] [-C callback] [-c quantum] [array]", `Read lines from the standard input into an indexed array variable.
    Read lines from the standard input into the indexed array variable ARRAY,
    or from file descriptor FD if the -u option is supplied.

    Options:
      -d delim	Use DELIM to terminate lines, instead of newline
      -n count	Copy at most COUNT lines
      -O origin	Begin assigning to ARRAY at index ORIGIN
      -s count	Discard the first COUNT lines read
      -t	Remove a trailing DELIM from each line read (default newline)
      -u fd	Read lines from file descriptor FD instead of standard input

    Exit Status:
    Returns success unless an invalid option is given or ARRAY is readonly.`]], ["popd", ["popd [-n] [+N | -N]", `Remove directories from stack.
    Removes entries from the directory stack.
    Exit Status:
    Returns success unless an invalid argument is supplied or the directory
    change fails.`]], ["printf", ["printf [-v var] format [arguments]", `Formats and prints ARGUMENTS under control of the FORMAT.

    Options:
      -v var	assign the output to shell variable VAR rather than
    		display it on the standard output

    FORMAT is a character string which contains three types of objects: plain
    characters, which are simply copied to standard output; character escape
    sequences, which are converted and copied to the standard output; and
    format specifications, each of which causes printing of the next successive
    argument.
    Exit Status:
    Returns success unless an invalid option is given or a write or assignment
    error occurs.`]], ["pushd", ["pushd [-n] [+N | -N | dir]", `Add directories to stack.
    Adds a directory to the top of the directory stack, or rotates
    the stack, making the new top of the stack the current working
    directory.
    Exit Status:
    Returns success unless an invalid argument is supplied or the directory
    change fails.`]], ["pwd", ["pwd [-LP]", `Print the name of the current working directory.

    Options:
      -L	print the value of $PWD if it names the current working
    	directory
      -P	print the physical directory, without any symbolic links

    By default, \`pwd' behaves as if \`-L' were specified.
    Exit Status:
    Returns 0 unless an invalid option is given or the current directory
    cannot be read.`]], ["read", ["read [-ers] [-a array] [-d delim] [-i text] [-n nchars] [-N nchars] [-p prompt] [-t timeout] [-u fd] [name ...]", `Read a line from the standard input and split it into fields.
    Reads a single line from the standard input, or from file descriptor FD
    if the -u option is supplied.  The line is split into fields as with word
    splitting, and the first word is assigned to the first NAME, the second
    word to the second NAME, and so on, with any leftover words assigned to
    the last NAME.
    Exit Status:
    The return code is zero, unless end-of-file is encountered, read times out,
    or an invalid file descriptor is supplied as the argument to -u.`]], ["readarray", ["readarray [-d delim] [-n count] [-O origin] [-s count] [-t] [-u fd] [-C callback] [-c quantum] [array]", "Read lines from a file into an array variable.\n    A synonym for `mapfile'."]], ["readonly", ["readonly [-aAf] [name[=value] ...] or readonly -p", `Mark shell variables as unchangeable.
    Mark each NAME as read-only; the values of these NAMEs may not be
    changed by subsequent assignment.
    Exit Status:
    Returns success unless an invalid option is given or NAME is invalid.`]], ["return", ["return [n]", `Return from a shell function.
    Causes a function or sourced script to exit with the return value
    specified by N.  If N is omitted, the return status is that of the
    last command executed within the function or script.
    Exit Status:
    Returns N, or failure if the shell is not executing a function or script.`]], ["set", ["set [-abefhkmnptuvxBCHP] [-o option-name] [--] [arg ...]", `Set or unset values of shell options and positional parameters.
    Change the value of shell attributes and positional parameters, or
    display the names and values of shell variables.

    Options:
      -e  Exit immediately if a command exits with a non-zero status.
      -u  Treat unset variables as an error when substituting.
      -x  Print commands and their arguments as they are executed.
      -o option-name
          Set the variable corresponding to option-name

    Exit Status:
    Returns success unless an invalid option is given.`]], ["shift", ["shift [n]", `Shift positional parameters.
    Rename the positional parameters $N+1,$N+2 ... to $1,$2 ...  If N is
    not given, it is assumed to be 1.
    Exit Status:
    Returns success unless N is negative or greater than $#.`]], ["shopt", ["shopt [-pqsu] [-o] [optname ...]", `Set and unset shell options.
    Change the setting of each shell option OPTNAME.  Without any option
    arguments, list each supplied OPTNAME, or all shell options if no
    OPTNAMEs are given, with an indication of whether or not each is set.

    Options:
      -o	restrict OPTNAMEs to those defined for use with \`set -o'
      -p	print each shell option with an indication of its status
      -q	suppress output
      -s	enable (set) each OPTNAME
      -u	disable (unset) each OPTNAME

    Exit Status:
    Returns success if OPTNAME is enabled; fails if an invalid option is
    given or OPTNAME is disabled.`]], ["source", ["source filename [arguments]", `Execute commands from a file in the current shell.
    Read and execute commands from FILENAME in the current shell.
    The entries in $PATH are used to find the directory containing FILENAME.
    Exit Status:
    Returns the status of the last command executed in FILENAME.`]], ["suspend", ["suspend [-f]", `Suspend shell execution.
    Suspend the execution of this shell until it receives a SIGCONT signal.`]], ["test", ["test [expr]", `Evaluate conditional expression.
    Exits with a status of 0 (true) or 1 (false) depending on
    the evaluation of EXPR.  Expressions may be unary or binary.
    Exit Status:
    Returns success if EXPR evaluates to true; fails if EXPR evaluates to
    false or an invalid argument is given.`]], ["times", ["times", `Display process times.
    Prints the accumulated user and system times for the shell and all of its
    child processes.
    Exit Status:
    Always succeeds.`]], ["trap", ["trap [-lp] [[arg] signal_spec ...]", `Trap signals and other events.
    Defines and activates handlers to be run when the shell receives signals
    or other conditions.
    Exit Status:
    Returns success unless a SIGSPEC is invalid or an invalid option is given.`]], ["true", ["true", `Return a successful result.
    Exit Status:
    Always succeeds.`]], ["type", ["type [-afptP] name [name ...]", `Display information about command type.
    For each NAME, indicate how it would be interpreted if used as a
    command name.

    Options:
      -a	display all locations containing an executable named NAME
      -f	suppress shell function lookup
      -P	force a PATH search for each NAME, even if it is an alias,
    	builtin, or function, and returns the name of the disk file
    	that would be executed
      -p	returns either the name of the disk file that would be executed,
    	or nothing if \`type -t NAME' would not return \`file'
      -t	output a single word which is one of \`alias', \`keyword',
    	\`function', \`builtin', \`file' or \`', if NAME is an alias,
    	shell reserved word, shell function, shell builtin, disk file,
    	or not found, respectively

    Exit Status:
    Returns success if all of the NAMEs are found; fails if any are not found.`]], ["typeset", ["typeset [-aAfFgilnrtux] [-p] name[=value] ...", "Set variable values and attributes.\n    A synonym for `declare'."]], ["ulimit", ["ulimit [-SHabcdefiklmnpqrstuvxPT] [limit]", `Modify shell resource limits.
    Provides control over the resources available to the shell and processes
    it creates, on systems that allow such control.
    Exit Status:
    Returns success unless an invalid option is supplied or an error occurs.`]], ["umask", ["umask [-p] [-S] [mode]", `Display or set file mode mask.
    Sets the user file-creation mask to MODE.  If MODE is omitted, prints
    the current value of the mask.
    Exit Status:
    Returns success unless MODE is invalid or an invalid option is given.`]], ["unalias", ["unalias [-a] name [name ...]", `Remove each NAME from the list of defined aliases.
    Exit Status:
    Returns success unless a NAME is not an existing alias.`]], ["unset", ["unset [-f] [-v] [-n] [name ...]", `Unset values and attributes of shell variables and functions.
    For each NAME, remove the corresponding variable or function.

    Options:
      -f	treat each NAME as a shell function
      -v	treat each NAME as a shell variable
      -n	treat each NAME as a name reference and unset the variable itself
    	rather than the variable it references

    Without options, unset first tries to unset a variable, and if that fails,
    tries to unset a function.
    Exit Status:
    Returns success unless an invalid option is given or a NAME is read-only.`]], ["wait", ["wait [-fn] [id ...]", `Wait for job completion and return exit status.
    Waits for each process identified by an ID, which may be a process ID or a
    job specification, and reports its termination status.
    Exit Status:
    Returns the status of the last ID; fails if ID is invalid or an invalid
    option is given.`]]]);
var Cn2 = [..._n2.keys()].sort();
function er2(e7, t6) {
  let s9 = false, r8 = [], n23 = 0;
  for (; n23 < t6.length; ) {
    let l8 = t6[n23];
    if (l8 === "--") {
      for (n23++; n23 < t6.length; ) r8.push(t6[n23]), n23++;
      break;
    }
    if (l8.startsWith("-") && l8.length > 1) {
      for (let c15 = 1; c15 < l8.length; c15++) {
        let u11 = l8[c15];
        if (u11 === "s") s9 = true;
        else return A13(`bash: help: -${u11}: invalid option
`, 2);
      }
      n23++;
    } else r8.push(l8), n23++;
  }
  if (r8.length === 0) return So();
  let i10 = "", o9 = false, a7 = "";
  for (let l8 of r8) {
    let c15 = $o(l8);
    if (c15.length === 0) {
      a7 += `bash: help: no help topics match \`${l8}'.  Try \`help help' or \`man -k ${l8}' or \`info ${l8}'.
`, o9 = true;
      continue;
    }
    for (let u11 of c15) {
      let f11 = _n2.get(u11);
      if (!f11) continue;
      let [d16, h17] = f11;
      s9 ? i10 += `${u11}: ${d16}
` : i10 += `${u11}: ${d16}
${h17}
`;
    }
  }
  return { exitCode: o9 ? 1 : 0, stdout: i10, stderr: a7 };
}
function $o(e7) {
  let t6 = e7.replace(/[.+^${}()|[\]\\]/g, "\\$&").replace(/\*/g, ".*").replace(/\?/g, "."), s9 = b1(`^${t6}$`);
  return Cn2.filter((r8) => s9.test(r8));
}
function So() {
  let e7 = [];
  e7.push("just-bash shell builtins"), e7.push("These shell commands are defined internally. Type `help' to see this list."), e7.push("Type `help name' to find out more about the function `name'."), e7.push("");
  let t6 = 36, s9 = Cn2.slice(), r8 = Math.ceil(s9.length / 2);
  for (let n23 = 0; n23 < r8; n23++) {
    let i10 = s9[n23] || "", o9 = s9[n23 + r8] || "", a7 = i10.padEnd(t6);
    e7.push(o9 ? `${a7}${o9}` : i10);
  }
  return M14(`${e7.join(`
`)}
`);
}
function Po(e7) {
  let t6 = [], s9 = "", r8 = 0;
  for (let n23 of e7) {
    for (let i10 of n23) i10 === "(" ? r8++ : i10 === ")" && r8--;
    s9 ? s9 += ` ${n23}` : s9 = n23, r8 === 0 && (t6.push(s9), s9 = "");
  }
  return s9 && t6.push(s9), t6;
}
async function tr2(e7, t6) {
  if (t6.length === 0) return A13(`bash: let: expression expected
`);
  let s9 = Po(t6), r8 = 0;
  for (let n23 of s9) try {
    let o9 = hi(`(( ${n23} ))`).statements[0];
    if (o9 && o9.pipelines.length > 0 && o9.pipelines[0].commands.length > 0) {
      let a7 = o9.pipelines[0].commands[0];
      a7.type === "ArithmeticCommand" && (r8 = await R(e7, a7.expression.expression));
    }
  } catch (i10) {
    return A13(`bash: let: ${n23}: ${i10.message}
`);
  }
  return _14("", "", r8 === 0 ? 1 : 0);
}
async function sr2(e7, t6) {
  if (e7.state.localScopes.length === 0) return A13(`bash: local: can only be used in a function
`);
  let s9 = e7.state.localScopes[e7.state.localScopes.length - 1], r8 = "", n23 = 0, i10 = false, o9 = false, a7 = false, l8 = [];
  for (let c15 of t6) if (c15 === "-n") i10 = true;
  else if (c15 === "-a") o9 = true;
  else if (c15 === "-p") a7 = true;
  else if (c15.startsWith("-") && !c15.includes("=")) for (let u11 of c15.slice(1)) u11 === "n" ? i10 = true : u11 === "a" ? o9 = true : u11 === "p" && (a7 = true);
  else l8.push(c15);
  if (l8.length === 0) {
    let c15 = "", u11 = Array.from(s9.keys()).filter((f11) => !f11.includes("_") || !f11.match(/_\d+$/)).filter((f11) => !f11.includes("__length")).sort();
    for (let f11 of u11) {
      let d16 = e7.state.env.get(f11);
      d16 !== void 0 && (c15 += `${f11}=${d16}
`);
    }
    return _14(c15, "", 0);
  }
  for (let c15 of l8) {
    let u11, f11, d16 = c15.match(/^([a-zA-Z_][a-zA-Z0-9_]*)=\((.*)\)$/s);
    if (d16) {
      u11 = d16[1];
      let S17 = d16[2];
      if (!/^[a-zA-Z_][a-zA-Z0-9_]*$/.test(u11)) {
        r8 += `bash: local: \`${c15}': not a valid identifier
`, n23 = 1;
        continue;
      }
      if (ha(e7, u11, "bash"), !s9.has(u11)) {
        s9.set(u11, e7.state.env.get(u11));
        let y18 = `${u11}_`;
        for (let w19 of e7.state.env.keys()) w19.startsWith(y18) && !w19.includes("__") && (s9.has(w19) || s9.set(w19, e7.state.env.get(w19)));
      }
      let v21 = `${u11}_`;
      for (let y18 of e7.state.env.keys()) y18.startsWith(v21) && !y18.includes("__") && e7.state.env.delete(y18);
      let P20 = Ce5(S17);
      for (let y18 = 0; y18 < P20.length; y18++) e7.state.env.set(`${u11}_${y18}`, P20[y18]);
      e7.state.env.set(`${u11}__length`, String(P20.length)), Ve7(e7, u11), i10 && Ti(e7, u11);
      continue;
    }
    let h17 = c15.match(/^([a-zA-Z_][a-zA-Z0-9_]*)\+=\((.*)\)$/s);
    if (h17) {
      u11 = h17[1];
      let S17 = h17[2];
      if (ha(e7, u11, "bash"), !s9.has(u11)) {
        s9.set(u11, e7.state.env.get(u11));
        let E13 = `${u11}_`;
        for (let x23 of e7.state.env.keys()) x23.startsWith(E13) && !x23.includes("__") && (s9.has(x23) || s9.set(x23, e7.state.env.get(x23)));
        let T10 = `${u11}__length`;
        e7.state.env.has(T10) && !s9.has(T10) && s9.set(T10, e7.state.env.get(T10));
      }
      let v21 = Ce5(S17), P20 = dt(e7, u11), y18 = 0, w19 = e7.state.env.get(u11);
      P20.length === 0 && w19 !== void 0 ? (e7.state.env.set(`${u11}_0`, w19), e7.state.env.delete(u11), y18 = 1) : P20.length > 0 && (y18 = Math.max(...P20) + 1);
      for (let E13 = 0; E13 < v21.length; E13++) e7.state.env.set(`${u11}_${y18 + E13}`, Z12(e7, v21[E13]));
      let b25 = y18 + v21.length;
      e7.state.env.set(`${u11}__length`, String(b25)), Ve7(e7, u11), i10 && Ti(e7, u11);
      continue;
    }
    let m25 = c15.match(/^([a-zA-Z_][a-zA-Z0-9_]*)\+=(.*)$/);
    if (m25) {
      u11 = m25[1];
      let S17 = Z12(e7, m25[2]);
      ha(e7, u11, "bash"), s9.has(u11) || s9.set(u11, e7.state.env.get(u11));
      let v21 = e7.state.env.get(u11) ?? "";
      e7.state.env.set(u11, v21 + S17), Ve7(e7, u11), i10 && Ti(e7, u11);
      continue;
    }
    let p17 = c15.match(/^([a-zA-Z_][a-zA-Z0-9_]*)\[([^\]]+)\]=(.*)$/s);
    if (p17) {
      u11 = p17[1];
      let S17 = p17[2], v21 = Z12(e7, p17[3]);
      if (ha(e7, u11, "bash"), !s9.has(u11)) {
        s9.set(u11, e7.state.env.get(u11));
        let w19 = `${u11}_`;
        for (let E13 of e7.state.env.keys()) E13.startsWith(w19) && !E13.includes("__") && (s9.has(E13) || s9.set(E13, e7.state.env.get(E13)));
        let b25 = `${u11}__length`;
        e7.state.env.has(b25) && !s9.has(b25) && s9.set(b25, e7.state.env.get(b25));
      }
      let P20;
      try {
        let w19 = new V2(), b25 = M2(w19, S17);
        P20 = await R(e7, b25.expression);
      } catch {
        let w19 = parseInt(S17, 10);
        P20 = Number.isNaN(w19) ? 0 : w19;
      }
      e7.state.env.set(`${u11}_${P20}`, v21);
      let y18 = parseInt(e7.state.env.get(`${u11}__length`) ?? "0", 10);
      P20 >= y18 && e7.state.env.set(`${u11}__length`, String(P20 + 1)), Ve7(e7, u11), i10 && Ti(e7, u11);
      continue;
    }
    if (c15.includes("=")) {
      let S17 = c15.indexOf("=");
      u11 = c15.slice(0, S17), f11 = Z12(e7, c15.slice(S17 + 1));
    } else u11 = c15;
    if (!/^[a-zA-Z_][a-zA-Z0-9_]*$/.test(u11)) {
      r8 += `bash: local: \`${c15}': not a valid identifier
`, n23 = 1;
      continue;
    }
    let g18 = s9.has(u11);
    if (f11 !== void 0) {
      let S17 = e7.state.env.get(u11);
      if (e7.state.tempEnvBindings) {
        let v21 = e7.state.accessedTempEnvVars?.has(u11), P20 = e7.state.mutatedTempEnvVars?.has(u11);
        if (!v21 && !P20) for (let y18 = e7.state.tempEnvBindings.length - 1; y18 >= 0; y18--) {
          let w19 = e7.state.tempEnvBindings[y18];
          if (w19.has(u11)) {
            S17 = w19.get(u11);
            break;
          }
        }
      }
      dn3(e7, u11, S17);
    }
    if (!g18) {
      let S17 = e7.state.env.get(u11);
      if (e7.state.tempEnvBindings) for (let v21 = e7.state.tempEnvBindings.length - 1; v21 >= 0; v21--) {
        let P20 = e7.state.tempEnvBindings[v21];
        if (P20.has(u11)) {
          S17 = P20.get(u11);
          break;
        }
      }
      if (s9.set(u11, S17), o9) {
        let v21 = `${u11}_`;
        for (let y18 of e7.state.env.keys()) y18.startsWith(v21) && !y18.includes("__") && (s9.has(y18) || s9.set(y18, e7.state.env.get(y18)));
        let P20 = `${u11}__length`;
        e7.state.env.has(P20) && !s9.has(P20) && s9.set(P20, e7.state.env.get(P20));
      }
    }
    if (o9 && f11 === void 0) {
      let S17 = `${u11}_`;
      for (let v21 of e7.state.env.keys()) v21.startsWith(S17) && !v21.includes("__") && e7.state.env.delete(v21);
      e7.state.env.set(`${u11}__length`, "0");
    } else if (f11 !== void 0) {
      if (ha(e7, u11, "bash"), i10 && f11 !== "" && !/^[a-zA-Z_][a-zA-Z0-9_]*(\[.+\])?$/.test(f11)) {
        r8 += `bash: local: \`${f11}': invalid variable name for name reference
`, n23 = 1;
        continue;
      }
      e7.state.env.set(u11, f11), e7.state.options.allexport && (e7.state.exportedVars = e7.state.exportedVars || /* @__PURE__ */ new Set(), e7.state.exportedVars.add(u11));
    } else {
      let S17 = e7.state.tempEnvBindings?.some((v21) => v21.has(u11));
      !g18 && !S17 && e7.state.env.delete(u11);
    }
    Ve7(e7, u11), i10 && Ti(e7, u11);
  }
  return _14("", r8, n23);
}
function rr2(e7, t6, s9) {
  let r8 = `
`, n23 = 0, i10 = 0, o9 = 0, a7 = false, l8 = "MAPFILE", c15 = 0;
  for (; c15 < t6.length; ) {
    let v21 = t6[c15];
    v21 === "-d" && c15 + 1 < t6.length ? (r8 = t6[c15 + 1] === "" ? "\0" : t6[c15 + 1] || `
`, c15 += 2) : v21 === "-n" && c15 + 1 < t6.length ? (n23 = Number.parseInt(t6[c15 + 1], 10) || 0, c15 += 2) : v21 === "-O" && c15 + 1 < t6.length ? (i10 = Number.parseInt(t6[c15 + 1], 10) || 0, c15 += 2) : v21 === "-s" && c15 + 1 < t6.length ? (o9 = Number.parseInt(t6[c15 + 1], 10) || 0, c15 += 2) : v21 === "-t" ? (a7 = true, c15++) : v21 === "-u" || v21 === "-C" || v21 === "-c" ? c15 += 2 : (v21.startsWith("-") || (l8 = v21), c15++);
  }
  let u11 = s9;
  !u11 && e7.state.groupStdin !== void 0 && (u11 = e7.state.groupStdin);
  let f11 = [], d16 = u11, h17 = 0, m25 = 0, p17 = e7.limits?.maxArrayElements ?? 1e5;
  for (; d16.length > 0; ) {
    let v21 = d16.indexOf(r8);
    if (v21 === -1) {
      if (d16.length > 0) {
        if (m25 < o9) m25++;
        else if (n23 === 0 || h17 < n23) {
          if (i10 + h17 >= p17) return _14("", `mapfile: array element limit exceeded (${p17})
`, 1);
          let w19 = d16, b25 = w19.indexOf("\0");
          b25 !== -1 && (w19 = w19.substring(0, b25)), f11.push(w19), h17++;
        }
      }
      break;
    }
    let P20 = d16.substring(0, v21), y18 = P20.indexOf("\0");
    if (y18 !== -1 && (P20 = P20.substring(0, y18)), !a7 && r8 !== "\0" && (P20 += r8), d16 = d16.substring(v21 + r8.length), m25 < o9) {
      m25++;
      continue;
    }
    if (n23 > 0 && h17 >= n23) break;
    if (i10 + h17 >= p17) return _14("", `mapfile: array element limit exceeded (${p17})
`, 1);
    f11.push(P20), h17++;
  }
  i10 === 0 && _i(e7, l8);
  for (let v21 = 0; v21 < f11.length; v21++) e7.state.env.set(`${l8}_${i10 + v21}`, f11[v21]);
  let g18 = parseInt(e7.state.env.get(`${l8}__length`) || "0", 10), S17 = i10 + f11.length;
  return e7.state.env.set(`${l8}__length`, String(Math.max(g18, S17))), e7.state.groupStdin !== void 0 && !s9 && (e7.state.groupStdin = ""), _14("", "", 0);
}
function Ao(e7) {
  if (!e7.startsWith("__rw__:")) return null;
  let t6 = e7.slice(7), s9 = t6.indexOf(":");
  if (s9 === -1) return null;
  let r8 = Number.parseInt(t6.slice(0, s9), 10);
  if (Number.isNaN(r8) || r8 < 0) return null;
  let n23 = s9 + 1, i10 = t6.slice(n23, n23 + r8), o9 = n23 + r8 + 1, a7 = t6.slice(o9), l8 = a7.indexOf(":");
  if (l8 === -1) return null;
  let c15 = Number.parseInt(a7.slice(0, l8), 10);
  if (Number.isNaN(c15) || c15 < 0) return null;
  let u11 = a7.slice(l8 + 1);
  return { path: i10, position: c15, content: u11 };
}
function ko(e7, t6, s9) {
  return `__rw__:${e7.length}:${e7}:${t6}:${s9}`;
}
function nr2(e7, t6, s9, r8 = -1) {
  let n23 = false, i10 = `
`, o9 = "", a7 = -1, l8 = -1, c15 = null, u11 = -1, f11 = -1, d16 = [], h17 = 0, m25 = false, p17 = (k17, C19) => {
    let N15 = 1;
    for (; N15 < k17.length; ) {
      let $18 = k17[N15];
      if ($18 === "r") n23 = true, N15++;
      else if ($18 === "s") N15++;
      else {
        if ($18 === "d") return N15 + 1 < k17.length ? (i10 = k17.substring(N15 + 1), { nextArgIndex: C19 + 1 }) : C19 + 1 < t6.length ? (i10 = t6[C19 + 1], { nextArgIndex: C19 + 2 }) : { nextArgIndex: C19 + 1 };
        if ($18 === "n") {
          if (N15 + 1 < k17.length) {
            let O17 = k17.substring(N15 + 1);
            return a7 = Number.parseInt(O17, 10), (Number.isNaN(a7) || a7 < 0) && (m25 = true, a7 = 0), { nextArgIndex: C19 + 1 };
          } else if (C19 + 1 < t6.length) return a7 = Number.parseInt(t6[C19 + 1], 10), (Number.isNaN(a7) || a7 < 0) && (m25 = true, a7 = 0), { nextArgIndex: C19 + 2 };
          return { nextArgIndex: C19 + 1 };
        } else if ($18 === "N") {
          if (N15 + 1 < k17.length) {
            let O17 = k17.substring(N15 + 1);
            return l8 = Number.parseInt(O17, 10), (Number.isNaN(l8) || l8 < 0) && (m25 = true, l8 = 0), { nextArgIndex: C19 + 1 };
          } else if (C19 + 1 < t6.length) return l8 = Number.parseInt(t6[C19 + 1], 10), (Number.isNaN(l8) || l8 < 0) && (m25 = true, l8 = 0), { nextArgIndex: C19 + 2 };
          return { nextArgIndex: C19 + 1 };
        } else {
          if ($18 === "a") return N15 + 1 < k17.length ? (c15 = k17.substring(N15 + 1), { nextArgIndex: C19 + 1 }) : C19 + 1 < t6.length ? (c15 = t6[C19 + 1], { nextArgIndex: C19 + 2 }) : { nextArgIndex: C19 + 1 };
          if ($18 === "p") return N15 + 1 < k17.length ? (o9 = k17.substring(N15 + 1), { nextArgIndex: C19 + 1 }) : C19 + 1 < t6.length ? (o9 = t6[C19 + 1], { nextArgIndex: C19 + 2 }) : { nextArgIndex: C19 + 1 };
          if ($18 === "u") {
            if (N15 + 1 < k17.length) {
              let O17 = k17.substring(N15 + 1);
              return u11 = Number.parseInt(O17, 10), Number.isNaN(u11) || u11 < 0 ? { nextArgIndex: -2 } : { nextArgIndex: C19 + 1 };
            } else if (C19 + 1 < t6.length) return u11 = Number.parseInt(t6[C19 + 1], 10), Number.isNaN(u11) || u11 < 0 ? { nextArgIndex: -2 } : { nextArgIndex: C19 + 2 };
            return { nextArgIndex: C19 + 1 };
          } else if ($18 === "t") {
            if (N15 + 1 < k17.length) {
              let O17 = k17.substring(N15 + 1);
              return f11 = Number.parseFloat(O17), Number.isNaN(f11) && (f11 = 0), { nextArgIndex: C19 + 1 };
            } else if (C19 + 1 < t6.length) return f11 = Number.parseFloat(t6[C19 + 1]), Number.isNaN(f11) && (f11 = 0), { nextArgIndex: C19 + 2 };
            return { nextArgIndex: C19 + 1 };
          } else if ($18 === "e" || $18 === "i" || $18 === "P") {
            if ($18 === "i" && C19 + 1 < t6.length) return { nextArgIndex: C19 + 2 };
            N15++;
          } else N15++;
        }
      }
    }
    return { nextArgIndex: C19 + 1 };
  };
  for (; h17 < t6.length; ) {
    let k17 = t6[h17];
    if (k17.startsWith("-") && k17.length > 1 && k17 !== "--") {
      let C19 = p17(k17, h17);
      if (C19.nextArgIndex === -1) return { stdout: "", stderr: "", exitCode: 2 };
      if (C19.nextArgIndex === -2) return { stdout: "", stderr: "", exitCode: 1 };
      h17 = C19.nextArgIndex;
    } else if (k17 === "--") for (h17++; h17 < t6.length; ) d16.push(t6[h17]), h17++;
    else d16.push(k17), h17++;
  }
  if (m25) return _14("", "", 1);
  if (d16.length === 0 && c15 === null && d16.push("REPLY"), f11 === 0) {
    if (c15) _i(e7, c15);
    else {
      for (let k17 of d16) e7.state.env.set(k17, "");
      d16.length === 0 && e7.state.env.set("REPLY", "");
    }
    return _14("", "", 0);
  }
  if (f11 < 0 && f11 !== -1) return _14("", "", 1);
  let g18 = s9;
  u11 >= 0 ? e7.state.fileDescriptors ? g18 = e7.state.fileDescriptors.get(u11) || "" : g18 = "" : !g18 && e7.state.groupStdin !== void 0 && (g18 = e7.state.groupStdin);
  let S17 = i10 === "" ? "\0" : i10, v21 = "", P20 = 0, y18 = true, w19 = (k17) => {
    if (u11 >= 0 && e7.state.fileDescriptors) e7.state.fileDescriptors.set(u11, g18.substring(k17));
    else if (r8 >= 0 && e7.state.fileDescriptors) {
      let C19 = e7.state.fileDescriptors.get(r8);
      if (C19?.startsWith("__rw__:")) {
        let N15 = Ao(C19);
        if (N15) {
          let $18 = N15.position + k17;
          e7.state.fileDescriptors.set(r8, ko(N15.path, $18, N15.content));
        }
      }
    } else e7.state.groupStdin !== void 0 && !s9 && (e7.state.groupStdin = g18.substring(k17));
  };
  if (l8 >= 0) {
    let k17 = Math.min(l8, g18.length);
    v21 = g18.substring(0, k17), P20 = k17, y18 = k17 >= l8, w19(P20);
    let C19 = d16[0] || "REPLY";
    e7.state.env.set(C19, v21);
    for (let N15 = 1; N15 < d16.length; N15++) e7.state.env.set(d16[N15], "");
    return _14("", "", y18 ? 0 : 1);
  } else if (a7 >= 0) {
    let k17 = 0, C19 = 0, N15 = false;
    for (; C19 < g18.length && k17 < a7; ) {
      let $18 = g18[C19];
      if ($18 === S17) {
        P20 = C19 + 1, N15 = true;
        break;
      }
      if (!n23 && $18 === "\\" && C19 + 1 < g18.length) {
        let O17 = g18[C19 + 1];
        if (O17 === S17 && S17 === `
`) {
          C19 += 2, P20 = C19;
          continue;
        }
        if (O17 === S17) {
          C19 += 2, k17++, v21 += O17, P20 = C19;
          continue;
        }
        v21 += O17, C19 += 2, k17++, P20 = C19;
      } else v21 += $18, C19++, k17++, P20 = C19;
    }
    y18 = k17 >= a7 || N15, w19(P20);
  } else {
    P20 = 0;
    let k17 = 0;
    for (; k17 < g18.length; ) {
      let C19 = g18[k17];
      if (C19 === S17) {
        P20 = k17 + S17.length, y18 = true;
        break;
      }
      if (!n23 && C19 === "\\" && k17 + 1 < g18.length) {
        let N15 = g18[k17 + 1];
        if (N15 === `
`) {
          k17 += 2;
          continue;
        }
        if (N15 === S17) {
          v21 += N15, k17 += 2;
          continue;
        }
        v21 += C19, v21 += N15, k17 += 2;
        continue;
      }
      v21 += C19, k17++;
    }
    if (k17 >= g18.length && (y18 = false, P20 = k17, v21.length === 0 && g18.length === 0)) {
      for (let C19 of d16) e7.state.env.set(C19, "");
      return c15 && _i(e7, c15), _14("", "", 1);
    }
    w19(P20);
  }
  S17 === `
` && v21.endsWith(`
`) && (v21 = v21.slice(0, -1));
  let b25 = (k17) => n23 ? k17 : k17.replace(/\\(.)/g, "$1");
  if (d16.length === 1 && d16[0] === "REPLY") return e7.state.env.set("REPLY", b25(v21)), _14("", "", y18 ? 0 : 1);
  let E13 = T(e7.state.env);
  if (c15) {
    let { words: k17 } = Oi(v21, E13, void 0, n23), C19 = e7.limits?.maxArrayElements ?? 1e5;
    if (k17.length > C19) return _14("", `read: array element limit exceeded (${C19})
`, 1);
    _i(e7, c15);
    for (let N15 = 0; N15 < k17.length; N15++) e7.state.env.set(`${c15}_${N15}`, b25(k17[N15]));
    return _14("", "", y18 ? 0 : 1);
  }
  let T10 = d16.length, { words: x23, wordStarts: I18 } = Oi(v21, E13, T10, n23);
  for (let k17 = 0; k17 < d16.length; k17++) {
    let C19 = d16[k17];
    if (k17 < d16.length - 1) e7.state.env.set(C19, b25(x23[k17] ?? ""));
    else if (k17 < I18.length) {
      let N15 = v21.substring(I18[k17]);
      N15 = Li(N15, E13, n23), N15 = b25(N15), e7.state.env.set(C19, N15);
    } else e7.state.env.set(C19, "");
  }
  return _14("", "", y18 ? 0 : 1);
}
function ir2(e7, t6) {
  if (e7.state.callDepth === 0 && e7.state.sourceDepth === 0) return A13("bash: return: can only `return' from a function or sourced script\n");
  let s9 = e7.state.lastExitCode;
  if (t6.length > 0) {
    let r8 = t6[0], n23 = Number.parseInt(r8, 10);
    if (r8 === "" || Number.isNaN(n23) || !/^-?\d+$/.test(r8)) return A13(`bash: return: ${r8}: numeric argument required
`, 2);
    s9 = (n23 % 256 + 256) % 256;
  }
  throw new i(s9);
}
var ss2 = `set: usage: set [-eux] [+eux] [-o option] [+o option]
Options:
  -e            Exit immediately if a command exits with non-zero status
  +e            Disable -e
  -u            Treat unset variables as an error when substituting
  +u            Disable -u
  -x            Print commands and their arguments as they are executed
  +x            Disable -x
  -o errexit    Same as -e
  +o errexit    Disable errexit
  -o nounset    Same as -u
  +o nounset    Disable nounset
  -o pipefail   Return status of last failing command in pipeline
  +o pipefail   Disable pipefail
  -o xtrace     Same as -x
  +o xtrace     Disable xtrace
`;
var xn2 = /* @__PURE__ */ new Map([["e", "errexit"], ["u", "nounset"], ["x", "xtrace"], ["v", "verbose"], ["f", "noglob"], ["C", "noclobber"], ["a", "allexport"], ["n", "noexec"], ["h", null], ["b", null], ["m", null], ["B", null], ["H", null], ["P", null], ["T", null], ["E", null], ["p", null]]);
var Nn2 = /* @__PURE__ */ new Map([["errexit", "errexit"], ["pipefail", "pipefail"], ["nounset", "nounset"], ["xtrace", "xtrace"], ["verbose", "verbose"], ["noclobber", "noclobber"], ["noglob", "noglob"], ["allexport", "allexport"], ["noexec", "noexec"], ["posix", "posix"], ["vi", "vi"], ["emacs", "emacs"], ["notify", null], ["monitor", null], ["braceexpand", null], ["histexpand", null], ["physical", null], ["functrace", null], ["errtrace", null], ["privileged", null], ["hashall", null], ["ignoreeof", null], ["interactive-comments", null], ["keyword", null], ["onecmd", null]]);
var On3 = ["errexit", "nounset", "pipefail", "verbose", "xtrace", "posix", "allexport", "noclobber", "noglob", "noexec", "vi", "emacs"];
var Tn2 = ["braceexpand", "errtrace", "functrace", "hashall", "histexpand", "history", "ignoreeof", "interactive-comments", "keyword", "monitor", "nolog", "notify", "onecmd", "physical", "privileged"];
function Dn3(e7, t6, s9) {
  t6 !== null && (s9 && (t6 === "vi" ? e7.state.options.emacs = false : t6 === "emacs" && (e7.state.options.vi = false)), e7.state.options[t6] = s9, et7(e7));
}
function _o(e7, t6) {
  return t6 + 1 < e7.length && !e7[t6 + 1].startsWith("-") && !e7[t6 + 1].startsWith("+");
}
function Co(e7, t6) {
  let s9 = dt(e7, t6);
  if (s9.length === 0) return `${t6}=()`;
  let r8 = s9.map((n23) => {
    let i10 = e7.state.env.get(`${t6}_${n23}`) ?? "";
    return `[${n23}]=${Ge6(i10)}`;
  });
  return `${t6}=(${r8.join(" ")})`;
}
function xo(e7) {
  return /^[a-zA-Z0-9_]+$/.test(e7) ? e7 : `"${e7.replace(/\\/g, "\\\\").replace(/"/g, '\\"')}"`;
}
function No(e7, t6) {
  let s9 = mt(e7, t6);
  if (s9.length === 0) return `${t6}=()`;
  let r8 = s9.map((n23) => {
    let i10 = e7.state.env.get(`${t6}_${n23}`) ?? "";
    return `[${xo(n23)}]=${Ge6(i10)}`;
  });
  return `${t6}=(${r8.join(" ")} )`;
}
function Oo(e7) {
  let t6 = /* @__PURE__ */ new Set(), s9 = e7.state.associativeArrays ?? /* @__PURE__ */ new Set();
  for (let r8 of e7.state.env.keys()) {
    let n23 = r8.match(/^([a-zA-Z_][a-zA-Z0-9_]*)_(\d+)$/);
    if (n23) {
      let i10 = n23[1];
      s9.has(i10) || t6.add(i10);
    }
  }
  return t6;
}
function To(e7) {
  return e7.state.associativeArrays ?? /* @__PURE__ */ new Set();
}
function ar2(e7, t6) {
  if (t6.includes("--help")) return M14(ss2);
  if (t6.length === 0) {
    let r8 = Oo(e7), n23 = To(e7), i10 = (l8) => {
      for (let c15 of n23) {
        let u11 = `${c15}_`, f11 = `${c15}__length`;
        if (l8 !== f11 && l8.startsWith(u11)) {
          if (l8.slice(u11.length).startsWith("_length")) continue;
          return true;
        }
      }
      return false;
    }, o9 = [];
    for (let [l8, c15] of e7.state.env) {
      if (!/^[a-zA-Z_][a-zA-Z0-9_]*$/.test(l8) || r8.has(l8) || n23.has(l8)) continue;
      let u11 = l8.match(/^([a-zA-Z_][a-zA-Z0-9_]*)_(\d+)$/);
      if (u11 && r8.has(u11[1])) continue;
      let f11 = l8.match(/^([a-zA-Z_][a-zA-Z0-9_]*)__length$/);
      f11 && r8.has(f11[1]) || i10(l8) || f11 && n23.has(f11[1]) || o9.push([l8, c15]);
    }
    let a7 = [];
    for (let [l8, c15] of o9.sort(([u11], [f11]) => u11 < f11 ? -1 : u11 > f11 ? 1 : 0)) a7.push(`${l8}=${Jt3(c15)}`);
    for (let l8 of [...r8].sort((c15, u11) => c15 < u11 ? -1 : c15 > u11 ? 1 : 0)) a7.push(Co(e7, l8));
    for (let l8 of [...n23].sort((c15, u11) => c15 < u11 ? -1 : c15 > u11 ? 1 : 0)) a7.push(No(e7, l8));
    return a7.sort((l8, c15) => {
      let u11 = l8.split("=")[0], f11 = c15.split("=")[0];
      return u11 < f11 ? -1 : u11 > f11 ? 1 : 0;
    }), M14(a7.length > 0 ? `${a7.join(`
`)}
` : "");
  }
  let s9 = 0;
  for (; s9 < t6.length; ) {
    let r8 = t6[s9];
    if ((r8 === "-o" || r8 === "+o") && _o(t6, s9)) {
      let n23 = t6[s9 + 1];
      if (!Nn2.has(n23)) {
        let i10 = `bash: set: ${n23}: invalid option name
${ss2}`;
        if (e7.state.options.posix) throw new f(1, "", i10);
        return A13(i10);
      }
      Dn3(e7, Nn2.get(n23) ?? null, r8 === "-o"), s9 += 2;
      continue;
    }
    if (r8 === "-o") {
      let n23 = On3.map((a7) => `${a7.padEnd(16)}${e7.state.options[a7] ? "on" : "off"}`), i10 = Tn2.map((a7) => `${a7.padEnd(16)}off`), o9 = [...n23, ...i10].sort();
      return M14(`${o9.join(`
`)}
`);
    }
    if (r8 === "+o") {
      let n23 = On3.map((a7) => `set ${e7.state.options[a7] ? "-o" : "+o"} ${a7}`), i10 = Tn2.map((a7) => `set +o ${a7}`), o9 = [...n23, ...i10].sort();
      return M14(`${o9.join(`
`)}
`);
    }
    if (r8.length > 1 && (r8[0] === "-" || r8[0] === "+") && r8[1] !== "-") {
      let n23 = r8[0] === "-";
      for (let i10 = 1; i10 < r8.length; i10++) {
        let o9 = r8[i10];
        if (!xn2.has(o9)) {
          let a7 = `bash: set: ${r8[0]}${o9}: invalid option
${ss2}`;
          if (e7.state.options.posix) throw new f(1, "", a7);
          return A13(a7);
        }
        Dn3(e7, xn2.get(o9) ?? null, n23);
      }
      s9++;
      continue;
    }
    if (r8 === "--") return or2(e7, t6.slice(s9 + 1)), L17;
    if (r8 === "-") {
      if (e7.state.options.xtrace = false, e7.state.options.verbose = false, et7(e7), s9 + 1 < t6.length) return or2(e7, t6.slice(s9 + 1)), L17;
      s9++;
      continue;
    }
    if (r8 === "+") {
      s9++;
      continue;
    }
    if (r8.startsWith("-") || r8.startsWith("+")) {
      let n23 = `bash: set: ${r8}: invalid option
${ss2}`;
      if (e7.state.options.posix) throw new f(1, "", n23);
      return A13(n23);
    }
    return or2(e7, t6.slice(s9)), L17;
  }
  return L17;
}
function or2(e7, t6) {
  let s9 = 1;
  for (; e7.state.env.has(String(s9)); ) e7.state.env.delete(String(s9)), s9++;
  for (let r8 = 0; r8 < t6.length; r8++) e7.state.env.set(String(r8 + 1), t6[r8]);
  e7.state.env.set("#", String(t6.length)), e7.state.env.set("@", t6.join(" ")), e7.state.env.set("*", t6.join(" "));
}
function lr2(e7, t6) {
  let s9 = 1;
  if (t6.length > 0) {
    let o9 = Number.parseInt(t6[0], 10);
    if (Number.isNaN(o9) || o9 < 0) {
      let a7 = `bash: shift: ${t6[0]}: numeric argument required
`;
      if (e7.state.options.posix) throw new f(1, "", a7);
      return A13(a7);
    }
    s9 = o9;
  }
  let r8 = Number.parseInt(e7.state.env.get("#") || "0", 10);
  if (s9 > r8) {
    let o9 = `bash: shift: shift count out of range
`;
    if (e7.state.options.posix) throw new f(1, "", o9);
    return A13(o9);
  }
  if (s9 === 0) return L17;
  let n23 = [];
  for (let o9 = 1; o9 <= r8; o9++) n23.push(e7.state.env.get(String(o9)) || "");
  let i10 = n23.slice(s9);
  for (let o9 = 1; o9 <= r8; o9++) e7.state.env.delete(String(o9));
  for (let o9 = 0; o9 < i10.length; o9++) e7.state.env.set(String(o9 + 1), i10[o9]);
  return e7.state.env.set("#", String(i10.length)), e7.state.env.set("@", i10.join(" ")), L17;
}
async function cr2(e7, t6) {
  let s9 = t6;
  if (s9.length > 0 && s9[0] === "--" && (s9 = s9.slice(1)), s9.length === 0) return _14("", `bash: source: filename argument required
`, 2);
  let r8 = s9[0], n23 = null, i10 = null;
  if (r8.includes("/")) {
    let c15 = e7.fs.resolvePath(e7.state.cwd, r8);
    try {
      i10 = await e7.fs.readFile(c15), n23 = c15;
    } catch {
    }
  } else {
    let u11 = (e7.state.env.get("PATH") || "").split(":").filter((f11) => f11);
    for (let f11 of u11) {
      let d16 = e7.fs.resolvePath(e7.state.cwd, `${f11}/${r8}`);
      try {
        if ((await e7.fs.stat(d16)).isDirectory) continue;
        i10 = await e7.fs.readFile(d16), n23 = d16;
        break;
      } catch {
      }
    }
    if (i10 === null) {
      let f11 = e7.fs.resolvePath(e7.state.cwd, r8);
      try {
        i10 = await e7.fs.readFile(f11), n23 = f11;
      } catch {
      }
    }
  }
  if (i10 === null) return A13(`bash: ${r8}: No such file or directory
`);
  let o9 = /* @__PURE__ */ new Map();
  if (s9.length > 1) {
    for (let u11 = 1; u11 <= 9; u11++) o9.set(String(u11), e7.state.env.get(String(u11)));
    o9.set("#", e7.state.env.get("#")), o9.set("@", e7.state.env.get("@"));
    let c15 = s9.slice(1);
    e7.state.env.set("#", String(c15.length)), e7.state.env.set("@", c15.join(" "));
    for (let u11 = 0; u11 < c15.length && u11 < 9; u11++) e7.state.env.set(String(u11 + 1), c15[u11]);
    for (let u11 = c15.length + 1; u11 <= 9; u11++) e7.state.env.delete(String(u11));
  }
  let a7 = e7.state.currentSource, l8 = () => {
    if (e7.state.sourceDepth--, e7.state.currentSource = a7, s9.length > 1) for (let [c15, u11] of o9) u11 === void 0 ? e7.state.env.delete(c15) : e7.state.env.set(c15, u11);
  };
  e7.state.sourceDepth++, e7.state.currentSource = r8;
  try {
    let c15 = hi(i10), u11 = await e7.executeScript(c15);
    return l8(), u11;
  } catch (c15) {
    if (l8(), c15 instanceof d2) throw c15;
    if (c15 instanceof i) return _14(c15.stdout, c15.stderr, c15.exitCode);
    if (c15.name === "ParseException") return A13(`bash: ${r8}: ${c15.message}
`);
    throw c15;
  }
}
function In2(e7) {
  return /^[a-zA-Z_][a-zA-Z0-9_]*$/.test(e7);
}
function Do(e7) {
  return e7.startsWith("'") && e7.endsWith("'") || e7.startsWith('"') && e7.endsWith('"');
}
async function Rn2(e7, t6) {
  if (Do(t6)) return null;
  try {
    let s9 = new V2(), r8 = M2(s9, t6);
    return await R(e7, r8.expression);
  } catch {
    let s9 = parseInt(t6, 10);
    return Number.isNaN(s9) ? 0 : s9;
  }
}
function Ln2(e7, t6) {
  if (e7.state.localVarStack?.has(t6)) {
    let r8 = Xt3(e7, t6);
    if (r8) {
      r8.value === void 0 ? e7.state.env.delete(t6) : e7.state.env.set(t6, r8.value);
      let n23 = e7.state.localVarStack?.get(t6);
      if (!n23 || n23.length === 0) Kt2(e7, t6), e7.state.localVarStack?.delete(t6), e7.state.fullyUnsetLocals = e7.state.fullyUnsetLocals || /* @__PURE__ */ new Map(), e7.state.fullyUnsetLocals.set(t6, r8.scopeIndex), ur3(e7, t6);
      else {
        let i10 = n23[n23.length - 1];
        e7.state.localVarDepth = e7.state.localVarDepth || /* @__PURE__ */ new Map(), e7.state.localVarDepth.set(t6, i10.scopeIndex + 1);
      }
      return true;
    }
    return e7.state.env.delete(t6), Kt2(e7, t6), e7.state.localVarStack?.delete(t6), e7.state.fullyUnsetLocals = e7.state.fullyUnsetLocals || /* @__PURE__ */ new Map(), e7.state.fullyUnsetLocals.set(t6, 0), true;
  }
  for (let r8 = e7.state.localScopes.length - 1; r8 >= 0; r8--) {
    let n23 = e7.state.localScopes[r8];
    if (n23.has(t6)) {
      let i10 = n23.get(t6);
      i10 === void 0 ? e7.state.env.delete(t6) : e7.state.env.set(t6, i10), n23.delete(t6);
      let o9 = false;
      for (let a7 = r8 - 1; a7 >= 0; a7--) if (e7.state.localScopes[a7].has(t6)) {
        e7.state.localVarDepth && e7.state.localVarDepth.set(t6, a7 + 1), o9 = true;
        break;
      }
      return o9 || Kt2(e7, t6), true;
    }
  }
  return false;
}
function ur3(e7, t6) {
  if (!e7.state.tempEnvBindings || e7.state.tempEnvBindings.length === 0) return false;
  for (let s9 = e7.state.tempEnvBindings.length - 1; s9 >= 0; s9--) {
    let r8 = e7.state.tempEnvBindings[s9];
    if (r8.has(t6)) {
      let n23 = r8.get(t6);
      return n23 === void 0 ? e7.state.env.delete(t6) : e7.state.env.set(t6, n23), r8.delete(t6), true;
    }
  }
  return false;
}
async function Mn2(e7, t6) {
  if (t6.startsWith("'") && t6.endsWith("'")) return t6.slice(1, -1);
  if (t6.startsWith('"') && t6.endsWith('"')) {
    let s9 = t6.slice(1, -1), n23 = new V2().parseWordFromString(s9, true, false);
    return kt(e7, n23);
  }
  if (t6.includes("$")) {
    let r8 = new V2().parseWordFromString(t6, false, false);
    return kt(e7, r8);
  }
  return t6;
}
async function fr2(e7, t6) {
  let s9 = "both", r8 = "", n23 = 0;
  for (let i10 of t6) {
    if (i10 === "-v") {
      s9 = "variable";
      continue;
    }
    if (i10 === "-f") {
      s9 = "function";
      continue;
    }
    if (s9 === "function") {
      e7.state.functions.delete(i10);
      continue;
    }
    if (s9 === "variable") {
      let c15 = i10.match(/^([a-zA-Z_][a-zA-Z0-9_]*)\[(.+)\]$/);
      if (c15) {
        let d16 = c15[1], h17 = c15[2];
        if (h17 === "@" || h17 === "*") {
          let P20 = P2(e7, d16);
          for (let [y18] of P20) e7.state.env.delete(`${d16}_${y18}`);
          e7.state.env.delete(d16);
          continue;
        }
        let m25 = e7.state.associativeArrays?.has(d16);
        if (m25) {
          let P20 = await Mn2(e7, h17);
          e7.state.env.delete(`${d16}_${P20}`);
          continue;
        }
        let p17 = Se(e7, d16), g18 = e7.state.declaredVars?.has(d16);
        if ((e7.state.env.has(d16) || g18) && !p17 && !m25) {
          r8 += `bash: unset: ${d16}: not an array variable
`, n23 = 1;
          continue;
        }
        let v21 = await Rn2(e7, h17);
        if (v21 === null && p17) {
          r8 += `bash: unset: ${h17}: not a valid identifier
`, n23 = 1;
          continue;
        }
        if (v21 === null) continue;
        if (v21 < 0) {
          let P20 = P2(e7, d16), y18 = P20.length, w19 = e7.state.currentLine;
          if (y18 === 0) {
            r8 += `bash: line ${w19}: unset: [${v21}]: bad array subscript
`, n23 = 1;
            continue;
          }
          let b25 = y18 + v21;
          if (b25 < 0) {
            r8 += `bash: line ${w19}: unset: [${v21}]: bad array subscript
`, n23 = 1;
            continue;
          }
          let E13 = P20[b25][0];
          e7.state.env.delete(`${d16}_${E13}`);
          continue;
        }
        e7.state.env.delete(`${d16}_${v21}`);
        continue;
      }
      if (!In2(i10)) {
        r8 += `bash: unset: \`${i10}': not a valid identifier
`, n23 = 1;
        continue;
      }
      let u11 = i10;
      if (L2(e7, i10)) {
        let d16 = he(e7, i10);
        d16 && d16 !== i10 && (u11 = d16);
      }
      if (bt(e7, u11)) {
        r8 += `bash: unset: ${u11}: cannot unset: readonly variable
`, n23 = 1;
        continue;
      }
      let f11 = st7(e7, u11);
      if (f11 !== void 0 && f11 !== e7.state.callDepth) Ln2(e7, u11);
      else if (e7.state.fullyUnsetLocals?.has(u11)) e7.state.env.delete(u11);
      else if (f11 !== void 0) {
        let d16 = e7.state.accessedTempEnvVars?.has(u11), h17 = e7.state.mutatedTempEnvVars?.has(u11);
        if ((d16 || h17) && e7.state.localVarStack?.has(u11)) {
          let m25 = Xt3(e7, u11);
          m25 ? m25.value === void 0 ? e7.state.env.delete(u11) : e7.state.env.set(u11, m25.value) : e7.state.env.delete(u11);
        } else e7.state.env.delete(u11);
      } else ur3(e7, u11) || e7.state.env.delete(u11);
      e7.state.exportedVars?.delete(u11);
      continue;
    }
    let o9 = i10.match(/^([a-zA-Z_][a-zA-Z0-9_]*)\[(.+)\]$/);
    if (o9) {
      let c15 = o9[1], u11 = o9[2];
      if (u11 === "@" || u11 === "*") {
        let p17 = P2(e7, c15);
        for (let [g18] of p17) e7.state.env.delete(`${c15}_${g18}`);
        e7.state.env.delete(c15);
        continue;
      }
      let f11 = e7.state.associativeArrays?.has(c15);
      if (f11) {
        let p17 = await Mn2(e7, u11);
        e7.state.env.delete(`${c15}_${p17}`);
        continue;
      }
      let d16 = Se(e7, c15);
      if (e7.state.env.has(c15) && !d16 && !f11) {
        r8 += `bash: unset: ${c15}: not an array variable
`, n23 = 1;
        continue;
      }
      let m25 = await Rn2(e7, u11);
      if (m25 === null && d16) {
        r8 += `bash: unset: ${u11}: not a valid identifier
`, n23 = 1;
        continue;
      }
      if (m25 === null) continue;
      if (m25 < 0) {
        let p17 = P2(e7, c15), g18 = p17.length, S17 = e7.state.currentLine;
        if (g18 === 0) {
          r8 += `bash: line ${S17}: unset: [${m25}]: bad array subscript
`, n23 = 1;
          continue;
        }
        let v21 = g18 + m25;
        if (v21 < 0) {
          r8 += `bash: line ${S17}: unset: [${m25}]: bad array subscript
`, n23 = 1;
          continue;
        }
        let P20 = p17[v21][0];
        e7.state.env.delete(`${c15}_${P20}`);
        continue;
      }
      e7.state.env.delete(`${c15}_${m25}`);
      continue;
    }
    if (!In2(i10)) {
      r8 += `bash: unset: \`${i10}': not a valid identifier
`, n23 = 1;
      continue;
    }
    let a7 = i10;
    if (L2(e7, i10)) {
      let c15 = he(e7, i10);
      c15 && c15 !== i10 && (a7 = c15);
    }
    if (bt(e7, a7)) {
      r8 += `bash: unset: ${a7}: cannot unset: readonly variable
`, n23 = 1;
      continue;
    }
    let l8 = st7(e7, a7);
    if (l8 !== void 0 && l8 !== e7.state.callDepth) Ln2(e7, a7);
    else if (e7.state.fullyUnsetLocals?.has(a7)) e7.state.env.delete(a7);
    else if (l8 !== void 0) {
      let c15 = e7.state.accessedTempEnvVars?.has(a7), u11 = e7.state.mutatedTempEnvVars?.has(a7);
      if ((c15 || u11) && e7.state.localVarStack?.has(a7)) {
        let f11 = Xt3(e7, a7);
        f11 ? f11.value === void 0 ? e7.state.env.delete(a7) : e7.state.env.set(a7, f11.value) : e7.state.env.delete(a7);
      } else e7.state.env.delete(a7);
    } else ur3(e7, a7) || e7.state.env.delete(a7);
    e7.state.exportedVars?.delete(a7), e7.state.functions.delete(i10);
  }
  return _14("", r8, n23);
}
var dr3 = ["extglob", "dotglob", "nullglob", "failglob", "globstar", "globskipdots", "nocaseglob", "nocasematch", "expand_aliases", "lastpipe", "xpg_echo"];
var Io2 = ["autocd", "cdable_vars", "cdspell", "checkhash", "checkjobs", "checkwinsize", "cmdhist", "compat31", "compat32", "compat40", "compat41", "compat42", "compat43", "compat44", "complete_fullquote", "direxpand", "dirspell", "execfail", "extdebug", "extquote", "force_fignore", "globasciiranges", "gnu_errfmt", "histappend", "histreedit", "histverify", "hostcomplete", "huponexit", "inherit_errexit", "interactive_comments", "lithist", "localvar_inherit", "localvar_unset", "login_shell", "mailwarn", "no_empty_cmd_completion", "progcomp", "progcomp_alias", "promptvars", "restricted_shell", "shift_verbose", "sourcepath"];
function rs3(e7) {
  return dr3.includes(e7);
}
function Ro(e7) {
  return Io2.includes(e7);
}
function Fn2(e7, t6) {
  let s9 = false, r8 = false, n23 = false, i10 = false, o9 = false, a7 = [], l8 = 0;
  for (; l8 < t6.length; ) {
    let d16 = t6[l8];
    if (d16 === "--") {
      l8++;
      break;
    }
    if (d16.startsWith("-") && d16.length > 1) {
      for (let h17 = 1; h17 < d16.length; h17++) {
        let m25 = d16[h17];
        switch (m25) {
          case "s":
            s9 = true;
            break;
          case "u":
            r8 = true;
            break;
          case "p":
            n23 = true;
            break;
          case "q":
            i10 = true;
            break;
          case "o":
            o9 = true;
            break;
          default:
            return { exitCode: 2, stdout: "", stderr: `shopt: -${m25}: invalid option
` };
        }
      }
      l8++;
    } else break;
  }
  for (; l8 < t6.length; ) a7.push(t6[l8]), l8++;
  if (o9) return Lo2(e7, a7, s9, r8, n23, i10);
  if (s9 && r8) return { exitCode: 1, stdout: "", stderr: `shopt: cannot set and unset shell options simultaneously
` };
  if (a7.length === 0) {
    if (s9 || r8) {
      let h17 = [];
      for (let m25 of dr3) {
        let p17 = e7.state.shoptOptions[m25];
        s9 && p17 ? h17.push(n23 ? `shopt -s ${m25}` : `${m25}		on`) : r8 && !p17 && h17.push(n23 ? `shopt -u ${m25}` : `${m25}		off`);
      }
      return { exitCode: 0, stdout: h17.length > 0 ? `${h17.join(`
`)}
` : "", stderr: "" };
    }
    let d16 = [];
    for (let h17 of dr3) {
      let m25 = e7.state.shoptOptions[h17];
      d16.push(n23 ? `shopt ${m25 ? "-s" : "-u"} ${h17}` : `${h17}		${m25 ? "on" : "off"}`);
    }
    return { exitCode: 0, stdout: `${d16.join(`
`)}
`, stderr: "" };
  }
  let c15 = false, u11 = "", f11 = [];
  for (let d16 of a7) {
    if (!rs3(d16) && !Ro(d16)) {
      u11 += `shopt: ${d16}: invalid shell option name
`, c15 = true;
      continue;
    }
    if (s9) rs3(d16) && (e7.state.shoptOptions[d16] = true, $s3(e7));
    else if (r8) rs3(d16) && (e7.state.shoptOptions[d16] = false, $s3(e7));
    else if (rs3(d16)) {
      let h17 = e7.state.shoptOptions[d16];
      i10 ? h17 || (c15 = true) : n23 ? (f11.push(`shopt ${h17 ? "-s" : "-u"} ${d16}`), h17 || (c15 = true)) : (f11.push(`${d16}		${h17 ? "on" : "off"}`), h17 || (c15 = true));
    } else i10 ? c15 = true : n23 ? (f11.push(`shopt -u ${d16}`), c15 = true) : (f11.push(`${d16}		off`), c15 = true);
  }
  return { exitCode: c15 ? 1 : 0, stdout: f11.length > 0 ? `${f11.join(`
`)}
` : "", stderr: u11 };
}
function Lo2(e7, t6, s9, r8, n23, i10) {
  let o9 = /* @__PURE__ */ new Map([["errexit", "errexit"], ["pipefail", "pipefail"], ["nounset", "nounset"], ["xtrace", "xtrace"], ["verbose", "verbose"], ["posix", "posix"], ["allexport", "allexport"], ["noclobber", "noclobber"], ["noglob", "noglob"], ["noexec", "noexec"], ["vi", "vi"], ["emacs", "emacs"]]), a7 = ["braceexpand", "errtrace", "functrace", "hashall", "histexpand", "history", "ignoreeof", "interactive-comments", "keyword", "monitor", "nolog", "notify", "onecmd", "physical", "privileged"], l8 = [...o9.keys(), ...a7].sort();
  if (t6.length === 0) {
    let d16 = [];
    for (let h17 of l8) {
      let m25 = a7.includes(h17), p17 = o9.get(h17), g18 = m25 || !p17 ? false : e7.state.options[p17];
      s9 && !g18 || r8 && g18 || d16.push(n23 ? `set ${g18 ? "-o" : "+o"} ${h17}` : `${h17}		${g18 ? "on" : "off"}`);
    }
    return { exitCode: 0, stdout: d16.length > 0 ? `${d16.join(`
`)}
` : "", stderr: "" };
  }
  let c15 = false, u11 = "", f11 = [];
  for (let d16 of t6) {
    let h17 = o9.has(d16), m25 = a7.includes(d16);
    if (!h17 && !m25) {
      u11 += `shopt: ${d16}: invalid option name
`, c15 = true;
      continue;
    }
    if (m25) {
      s9 || r8 || (i10 ? c15 = true : n23 ? (f11.push(`set +o ${d16}`), c15 = true) : (f11.push(`${d16}		off`), c15 = true));
      continue;
    }
    let p17 = o9.get(d16);
    if (p17) if (s9) p17 === "vi" ? e7.state.options.emacs = false : p17 === "emacs" && (e7.state.options.vi = false), e7.state.options[p17] = true, et7(e7);
    else if (r8) e7.state.options[p17] = false, et7(e7);
    else {
      let g18 = e7.state.options[p17];
      i10 ? g18 || (c15 = true) : n23 ? (f11.push(`set ${g18 ? "-o" : "+o"} ${d16}`), g18 || (c15 = true)) : (f11.push(`${d16}		${g18 ? "on" : "off"}`), g18 || (c15 = true));
    }
  }
  return { exitCode: c15 ? 1 : 0, stdout: f11.length > 0 ? `${f11.join(`
`)}
` : "", stderr: u11 };
}
async function zn2(e7, t6, s9) {
  if (t6.includes("/")) {
    let o9 = e7.fs.resolvePath(e7.state.cwd, t6);
    if (!await e7.fs.exists(o9)) return { error: "not_found", path: o9 };
    let a7 = o9.split("/").pop() || t6, l8 = e7.commands.get(a7);
    try {
      let c15 = await e7.fs.stat(o9);
      return c15.isDirectory ? { error: "permission_denied", path: o9 } : l8 ? { cmd: l8, path: o9 } : (c15.mode & 73) !== 0 ? { script: true, path: o9 } : { error: "permission_denied", path: o9 };
    } catch {
      return { error: "not_found", path: o9 };
    }
  }
  if (!s9 && e7.state.hashTable) {
    let o9 = e7.state.hashTable.get(t6);
    if (o9) if (await e7.fs.exists(o9)) {
      let a7 = e7.commands.get(t6);
      if (a7) return { cmd: a7, path: o9 };
      try {
        let l8 = await e7.fs.stat(o9);
        if (!l8.isDirectory && (l8.mode & 73) !== 0) return { script: true, path: o9 };
      } catch {
      }
    } else e7.state.hashTable.delete(t6);
  }
  let n23 = (s9 ?? e7.state.env.get("PATH") ?? "/usr/bin:/bin").split(":");
  for (let o9 of n23) {
    if (!o9) continue;
    let l8 = `${o9.startsWith("/") ? o9 : e7.fs.resolvePath(e7.state.cwd, o9)}/${t6}`;
    if (await e7.fs.exists(l8)) try {
      let c15 = await e7.fs.stat(l8);
      if (c15.isDirectory) continue;
      let u11 = (c15.mode & 73) !== 0, f11 = e7.commands.get(t6), d16 = o9 === "/bin" || o9 === "/usr/bin";
      if (f11 && d16) return { cmd: f11, path: l8 };
      if (u11) {
        if (f11 && !d16) return { script: true, path: l8 };
        if (!f11) return { script: true, path: l8 };
      }
    } catch {
    }
  }
  if (!await e7.fs.exists("/usr/bin")) {
    let o9 = e7.commands.get(t6);
    if (o9) return { cmd: o9, path: `/usr/bin/${t6}` };
  }
  return null;
}
async function ns2(e7, t6) {
  let s9 = [];
  if (t6.includes("/")) {
    let i10 = e7.fs.resolvePath(e7.state.cwd, t6);
    if (await e7.fs.exists(i10)) try {
      let o9 = await e7.fs.stat(i10);
      o9.isDirectory || (o9.mode & 73) !== 0 && s9.push(t6);
    } catch {
    }
    return s9;
  }
  let n23 = (e7.state.env.get("PATH") || "/usr/bin:/bin").split(":");
  for (let i10 of n23) {
    if (!i10) continue;
    let a7 = `${i10.startsWith("/") ? i10 : e7.fs.resolvePath(e7.state.cwd, i10)}/${t6}`;
    if (await e7.fs.exists(a7)) {
      try {
        if ((await e7.fs.stat(a7)).isDirectory) continue;
      } catch {
        continue;
      }
      s9.push(i10.startsWith("/") ? a7 : `${i10}/${t6}`);
    }
  }
  return s9;
}
async function jn2(e7, t6, s9, r8) {
  let n23 = false, i10 = false, o9 = false, a7 = false, l8 = false, c15 = [];
  for (let p17 of t6) if (p17.startsWith("-") && p17.length > 1) for (let g18 of p17.slice(1)) g18 === "t" ? n23 = true : g18 === "p" ? i10 = true : g18 === "P" ? o9 = true : g18 === "a" ? a7 = true : g18 === "f" && (l8 = true);
  else c15.push(p17);
  let u11 = "", f11 = "", d16 = 0, h17 = false, m25 = false;
  for (let p17 of c15) {
    let g18 = false;
    if (o9) {
      if (a7) {
        let b25 = await r8(p17);
        if (b25.length > 0) {
          for (let E13 of b25) u11 += `${E13}
`;
          h17 = true, g18 = true;
        }
      } else {
        let b25 = await s9(p17);
        b25 && (u11 += `${b25}
`, h17 = true, g18 = true);
      }
      g18 || (m25 = true);
      continue;
    }
    let S17 = !l8 && e7.state.functions.has(p17);
    if (a7 && S17) {
      if (!i10) if (n23) u11 += `function
`;
      else {
        let b25 = e7.state.functions.get(p17), E13 = b25 ? Wn3(p17, b25) : `${p17} is a function
`;
        u11 += E13;
      }
      g18 = true;
    }
    let v21 = e7.state.env.get(`BASH_ALIAS_${p17}`);
    if (v21 !== void 0 && (a7 || !g18) && (i10 || (n23 ? u11 += `alias
` : u11 += `${p17} is aliased to \`${v21}'
`), g18 = true, !a7) || Ns2.has(p17) && (a7 || !g18) && (i10 || (n23 ? u11 += `keyword
` : u11 += `${p17} is a shell keyword
`), g18 = true, !a7)) continue;
    if (!a7 && S17 && !g18) {
      if (!i10) if (n23) u11 += `function
`;
      else {
        let b25 = e7.state.functions.get(p17), E13 = b25 ? Wn3(p17, b25) : `${p17} is a function
`;
        u11 += E13;
      }
      g18 = true;
      continue;
    }
    if (!(rt6.has(p17) && (a7 || !g18) && (i10 || (n23 ? u11 += `builtin
` : u11 += `${p17} is a shell builtin
`), g18 = true, !a7))) {
      if (a7) {
        let b25 = await r8(p17);
        for (let E13 of b25) i10 ? u11 += `${E13}
` : n23 ? u11 += `file
` : u11 += `${p17} is ${E13}
`, h17 = true, g18 = true;
      } else if (!g18) {
        let b25 = await s9(p17);
        b25 && (i10 ? u11 += `${b25}
` : n23 ? u11 += `file
` : u11 += `${p17} is ${b25}
`, h17 = true, g18 = true);
      }
      if (!g18 && (m25 = true, !n23 && !i10)) {
        let b25 = true;
        if (p17.includes("/")) {
          let E13 = e7.fs.resolvePath(e7.state.cwd, p17);
          await e7.fs.exists(E13) && (b25 = false);
        }
        b25 && (f11 += `bash: type: ${p17}: not found
`);
      }
    }
  }
  return i10 ? d16 = m25 && !h17 ? 1 : 0 : d16 = m25 ? 1 : 0, _14(u11, f11, d16);
}
function Wn3(e7, t6) {
  let s9;
  return t6.body.type === "Group" ? s9 = t6.body.body.map((n23) => bt3(n23)).join("; ") : s9 = bt3(t6.body), `${e7} is a function
${e7} () 
{ 
    ${s9}
}
`;
}
function bt3(e7) {
  if (Array.isArray(e7)) return e7.map((t6) => bt3(t6)).join("; ");
  if (e7.type === "Statement") {
    let t6 = [];
    for (let s9 = 0; s9 < e7.pipelines.length; s9++) {
      let r8 = e7.pipelines[s9];
      t6.push(Mo(r8)), e7.operators[s9] && t6.push(e7.operators[s9]);
    }
    return t6.join(" ");
  }
  if (e7.type === "SimpleCommand") {
    let t6 = e7, s9 = [];
    t6.name && s9.push(Vn2(t6.name));
    for (let r8 of t6.args) s9.push(Vn2(r8));
    return s9.join(" ");
  }
  return e7.type === "Group" ? `{ ${e7.body.map((r8) => bt3(r8)).join("; ")}; }` : "...";
}
function Mo(e7) {
  let t6 = e7.commands.map((s9) => bt3(s9));
  return (e7.negated ? "! " : "") + t6.join(" | ");
}
function Vn2(e7) {
  let t6 = "";
  for (let s9 of e7.parts) s9.type === "Literal" ? t6 += s9.value : s9.type === "DoubleQuoted" ? t6 += `"${s9.parts.map((r8) => Bn3(r8)).join("")}"` : s9.type === "SingleQuoted" ? t6 += `'${s9.value}'` : t6 += Bn3(s9);
  return t6;
}
function Bn3(e7) {
  let t6 = e7;
  return t6.type === "Literal" ? t6.value ?? "" : t6.type === "Variable" ? `$${t6.name}` : "";
}
async function Un2(e7, t6, s9, r8) {
  let n23 = "", i10 = "", o9 = 0;
  for (let a7 of t6) {
    if (!a7) {
      o9 = 1;
      continue;
    }
    let l8 = e7.state.env.get(`BASH_ALIAS_${a7}`);
    if (l8 !== void 0) r8 ? n23 += `${a7} is an alias for "${l8}"
` : n23 += `alias ${a7}='${l8}'
`;
    else if (Ns2.has(a7)) r8 ? n23 += `${a7} is a shell keyword
` : n23 += `${a7}
`;
    else if (rt6.has(a7)) r8 ? n23 += `${a7} is a shell builtin
` : n23 += `${a7}
`;
    else if (e7.state.functions.has(a7)) r8 ? n23 += `${a7} is a function
` : n23 += `${a7}
`;
    else if (a7.includes("/")) {
      let c15 = e7.fs.resolvePath(e7.state.cwd, a7), u11 = false;
      if (await e7.fs.exists(c15)) try {
        let f11 = await e7.fs.stat(c15);
        f11.isDirectory || (f11.mode & 73) !== 0 && (r8 ? n23 += `${a7} is ${a7}
` : n23 += `${a7}
`, u11 = true);
      } catch {
      }
      u11 || (r8 && (i10 += `${a7}: not found
`), o9 = 1);
    } else if (e7.commands.has(a7)) {
      let u11 = (e7.state.env.get("PATH") ?? "/usr/bin:/bin").split(":"), f11 = null;
      for (let d16 of u11) {
        if (!d16) continue;
        let h17 = `${d16}/${a7}`;
        try {
          let m25 = await e7.fs.stat(h17);
          if (!m25.isDirectory && (m25.mode & 73) !== 0) {
            f11 = h17;
            break;
          }
        } catch {
        }
      }
      f11 || (f11 = `/usr/bin/${a7}`), r8 ? n23 += `${a7} is ${f11}
` : n23 += `${f11}
`;
    } else r8 && (i10 += `${a7}: not found
`), o9 = 1;
  }
  return _14(n23, i10, o9);
}
async function Hn2(e7, t6) {
  if (t6.includes("/")) {
    let n23 = e7.fs.resolvePath(e7.state.cwd, t6);
    if (await e7.fs.exists(n23)) {
      try {
        let i10 = await e7.fs.stat(n23);
        if (i10.isDirectory || !((i10.mode & 73) !== 0)) return null;
      } catch {
        return null;
      }
      return t6;
    }
    return null;
  }
  let r8 = (e7.state.env.get("PATH") ?? "/usr/bin:/bin").split(":");
  for (let n23 of r8) {
    if (!n23) continue;
    let o9 = `${n23.startsWith("/") ? n23 : e7.fs.resolvePath(e7.state.cwd, n23)}/${t6}`;
    if (await e7.fs.exists(o9)) {
      try {
        if ((await e7.fs.stat(o9)).isDirectory) continue;
      } catch {
        continue;
      }
      return `${n23}/${t6}`;
    }
  }
  if (e7.commands.has(t6)) {
    for (let n23 of r8) if (n23 === "/usr/bin" || n23 === "/bin") return `${n23}/${t6}`;
    return `/usr/bin/${t6}`;
  }
  return null;
}
async function qn3(e7, t6, s9, r8, n23, i10, o9, a7) {
  let { ctx: l8, runCommand: c15 } = e7;
  if (l8.coverage && rt6.has(t6) && l8.coverage.hit(`bash:builtin:${t6}`), t6 === "export") return Qs(l8, s9);
  if (t6 === "unset") return fr2(l8, s9);
  if (t6 === "exit") return Ys(l8, s9);
  if (t6 === "local") return sr2(l8, s9);
  if (t6 === "set") return ar2(l8, s9);
  if (t6 === "break") return Ps2(l8, s9);
  if (t6 === "continue") return Ms2(l8, s9);
  if (t6 === "return") return ir2(l8, s9);
  if (t6 === "eval" && l8.state.options.posix) return es2(l8, s9, n23);
  if (t6 === "shift") return lr2(l8, s9);
  if (t6 === "getopts") return ts2(l8, s9);
  if (t6 === "compgen") return Ds2(l8, s9);
  if (t6 === "complete") return Rs3(l8, s9);
  if (t6 === "compopt") return Ls3(l8, s9);
  if (t6 === "pushd") return await Zs(l8, s9);
  if (t6 === "popd") return Ks2(l8, s9);
  if (t6 === "dirs") return Xs(l8, s9);
  if (t6 === "source" || t6 === ".") return cr2(l8, s9);
  if (t6 === "read") return nr2(l8, s9, n23, a7);
  if (t6 === "mapfile" || t6 === "readarray") return rr2(l8, s9, n23);
  if (t6 === "declare" || t6 === "typeset") return Hs(l8, s9);
  if (t6 === "readonly") return qs3(l8, s9);
  if (!i10) {
    let u11 = l8.state.functions.get(t6);
    if (u11) return Qt3(l8, u11, s9, n23);
  }
  if (t6 === "eval") return es2(l8, s9, n23);
  if (t6 === "cd") return await As2(l8, s9);
  if (t6 === ":" || t6 === "true") return L17;
  if (t6 === "false") return Y10(false);
  if (t6 === "let") return tr2(l8, s9);
  if (t6 === "command") return Fo(e7, s9, n23);
  if (t6 === "builtin") return zo2(e7, s9, n23);
  if (t6 === "shopt") return Fn2(l8, s9);
  if (t6 === "exec") {
    if (s9.length === 0) return L17;
    let [u11, ...f11] = s9;
    return c15(u11, f11, [], n23, false, false, -1);
  }
  if (t6 === "wait") return L17;
  if (t6 === "type") return await jn2(l8, s9, (u11) => Hn2(l8, u11), (u11) => ns2(l8, u11));
  if (t6 === "hash") return Js(l8, s9);
  if (t6 === "help") return er2(l8, s9);
  if (t6 === "[" || t6 === "test") {
    let u11 = s9;
    if (t6 === "[") {
      if (s9[s9.length - 1] !== "]") return A13("[: missing `]'\n", 2);
      u11 = s9.slice(0, -1);
    }
    return gt3(l8, u11);
  }
  return null;
}
async function Fo(e7, t6, s9) {
  let { ctx: r8, runCommand: n23 } = e7;
  if (t6.length === 0) return L17;
  let i10 = false, o9 = false, a7 = false, l8 = t6;
  for (; l8.length > 0 && l8[0].startsWith("-"); ) {
    let f11 = l8[0];
    if (f11 === "--") {
      l8 = l8.slice(1);
      break;
    }
    for (let d16 of f11.slice(1)) d16 === "p" ? i10 = true : d16 === "V" ? o9 = true : d16 === "v" && (a7 = true);
    l8 = l8.slice(1);
  }
  if (l8.length === 0) return L17;
  if (a7 || o9) return await Un2(r8, l8, a7, o9);
  let [c15, ...u11] = l8;
  return n23(c15, u11, [], s9, true, i10, -1);
}
async function zo2(e7, t6, s9) {
  let { runCommand: r8 } = e7;
  if (t6.length === 0) return L17;
  let n23 = t6;
  if (n23[0] === "--" && (n23 = n23.slice(1), n23.length === 0)) return L17;
  let i10 = n23[0];
  if (!rt6.has(i10)) return A13(`bash: builtin: ${i10}: not a shell builtin
`);
  let [, ...o9] = n23;
  return r8(i10, o9, [], s9, true, false, -1);
}
async function Gn2(e7, t6, s9, r8, n23) {
  let { ctx: i10, buildExportedEnv: o9, executeUserScript: a7 } = e7, c15 = await zn2(i10, t6, n23 ? "/usr/bin:/bin" : void 0);
  if (!c15) return en3(t6) ? A13(`bash: ${t6}: command not available in browser environments. Exclude '${t6}' from your commands or use the Node.js bundle.
`, 127) : A13(`bash: ${t6}: command not found
`, 127);
  if ("error" in c15) return c15.error === "permission_denied" ? A13(`bash: ${t6}: Permission denied
`, 126) : A13(`bash: ${t6}: No such file or directory
`, 127);
  if ("script" in c15) return t6.includes("/") || (i10.state.hashTable || (i10.state.hashTable = /* @__PURE__ */ new Map()), i10.state.hashTable.set(t6, c15.path)), await a7(c15.path, s9, r8);
  let { cmd: u11, path: f11 } = c15;
  t6.includes("/") || (i10.state.hashTable || (i10.state.hashTable = /* @__PURE__ */ new Map()), i10.state.hashTable.set(t6, f11));
  let d16 = r8 || i10.state.groupStdin || "", h17 = o9(), m25 = { fs: i10.fs, cwd: i10.state.cwd, env: i10.state.env, exportedEnv: h17, stdin: d16, limits: i10.limits, exec: i10.execFn, fetch: i10.fetch, getRegisteredCommands: () => Array.from(i10.commands.keys()), sleep: i10.sleep, trace: i10.trace, fileDescriptors: i10.state.fileDescriptors, xpgEcho: i10.state.shoptOptions.xpg_echo, coverage: i10.coverage };
  try {
    return await u11.execute(s9, m25);
  } catch (p17) {
    if (p17 instanceof b2) throw p17;
    return A13(`${t6}: ${d3(n17(p17))}
`);
  }
}
async function hr2(e7, t6) {
  let s9 = e7.state.inCondition;
  e7.state.inCondition = true;
  let r8 = "", n23 = "", i10 = 0;
  try {
    for (let o9 of t6) {
      let a7 = await e7.executeStatement(o9);
      r8 += a7.stdout, n23 += a7.stderr, i10 = a7.exitCode;
    }
  } finally {
    e7.state.inCondition = s9;
  }
  return { stdout: r8, stderr: n23, exitCode: i10 };
}
function Et5(e7, t6, s9, r8) {
  if (e7 instanceof c2) return t6 += e7.stdout, s9 += e7.stderr, e7.levels > 1 && r8 > 1 ? (e7.levels--, e7.stdout = t6, e7.stderr = s9, { action: "rethrow", stdout: t6, stderr: s9, error: e7 }) : { action: "break", stdout: t6, stderr: s9 };
  if (e7 instanceof a2) return t6 += e7.stdout, s9 += e7.stderr, e7.levels > 1 && r8 > 1 ? (e7.levels--, e7.stdout = t6, e7.stderr = s9, { action: "rethrow", stdout: t6, stderr: s9, error: e7 }) : { action: "continue", stdout: t6, stderr: s9 };
  if (e7 instanceof i || e7 instanceof u2 || e7 instanceof d2 || e7 instanceof b2) return e7.prependOutput(t6, s9), { action: "rethrow", stdout: t6, stderr: s9, error: e7 };
  let n23 = n17(e7);
  return { action: "error", stdout: t6, stderr: `${s9}${n23}
`, exitCode: 1 };
}
async function is3(e7, t6, s9 = "", r8 = "") {
  let n23 = s9, i10 = r8, o9 = 0;
  try {
    for (let a7 of t6) {
      let l8 = await e7.executeStatement(a7);
      n23 += l8.stdout, i10 += l8.stderr, o9 = l8.exitCode;
    }
  } catch (a7) {
    if (C(a7) || a7 instanceof u2 || a7 instanceof d2 || a7 instanceof b2 || a7 instanceof $2) throw a7.prependOutput(n23, i10), a7;
    return { stdout: n23, stderr: `${i10}${n17(a7)}
`, exitCode: 1 };
  }
  return { stdout: n23, stderr: i10, exitCode: o9 };
}
async function Zn3(e7, t6) {
  let s9 = "", r8 = "";
  for (let n23 of t6.clauses) {
    let i10 = await hr2(e7, n23.condition);
    if (s9 += i10.stdout, r8 += i10.stderr, i10.exitCode === 0) return is3(e7, n23.body, s9, r8);
  }
  return t6.elseBody ? is3(e7, t6.elseBody, s9, r8) : _14(s9, r8, 0);
}
async function Kn2(e7, t6) {
  let s9 = await xe10(e7, t6.redirections);
  if (s9) return s9;
  let r8 = "", n23 = "", i10 = 0, o9 = 0;
  if (!/^[a-zA-Z_][a-zA-Z0-9_]*$/.test(t6.variable)) return A13(`bash: \`${t6.variable}': not a valid identifier
`);
  let a7 = [];
  if (t6.words === null) a7 = (e7.state.env.get("@") || "").split(" ").filter(Boolean);
  else if (t6.words.length === 0) a7 = [];
  else try {
    for (let c15 of t6.words) {
      let u11 = await Sl(e7, c15);
      a7.push(...u11.values);
    }
  } catch (c15) {
    if (c15 instanceof l) return { stdout: "", stderr: c15.stderr, exitCode: 1 };
    throw c15;
  }
  e7.state.loopDepth++;
  try {
    for (let c15 of a7) {
      o9++, o9 > e7.limits.maxLoopIterations && Re7(`for loop: too many iterations (${e7.limits.maxLoopIterations}), increase executionLimits.maxLoopIterations`, "iterations", r8, n23), e7.state.env.set(t6.variable, c15);
      try {
        for (let u11 of t6.body) {
          let f11 = await e7.executeStatement(u11);
          r8 += f11.stdout, n23 += f11.stderr, i10 = f11.exitCode;
        }
      } catch (u11) {
        let f11 = Et5(u11, r8, n23, e7.state.loopDepth);
        if (r8 = f11.stdout, n23 = f11.stderr, f11.action === "break") break;
        if (f11.action === "continue") continue;
        if (f11.action === "error") {
          let d16 = _14(r8, n23, f11.exitCode ?? 1);
          return G8(e7, d16, t6.redirections);
        }
        throw f11.error;
      }
    }
  } finally {
    e7.state.loopDepth--;
  }
  let l8 = _14(r8, n23, i10);
  return G8(e7, l8, t6.redirections);
}
async function Xn2(e7, t6) {
  let s9 = await xe10(e7, t6.redirections);
  if (s9) return s9;
  let r8 = t6.line;
  r8 !== void 0 && (e7.state.currentLine = r8);
  let n23 = "", i10 = "", o9 = 0, a7 = 0;
  t6.init && await R(e7, t6.init.expression), e7.state.loopDepth++;
  try {
    for (; a7++, a7 > e7.limits.maxLoopIterations && Re7(`for loop: too many iterations (${e7.limits.maxLoopIterations}), increase executionLimits.maxLoopIterations`, "iterations", n23, i10), !(t6.condition && (r8 !== void 0 && (e7.state.currentLine = r8), await R(e7, t6.condition.expression) === 0)); ) {
      try {
        for (let c15 of t6.body) {
          let u11 = await e7.executeStatement(c15);
          n23 += u11.stdout, i10 += u11.stderr, o9 = u11.exitCode;
        }
      } catch (c15) {
        let u11 = Et5(c15, n23, i10, e7.state.loopDepth);
        if (n23 = u11.stdout, i10 = u11.stderr, u11.action === "break") break;
        if (u11.action === "continue") {
          t6.update && await R(e7, t6.update.expression);
          continue;
        }
        if (u11.action === "error") {
          let f11 = _14(n23, i10, u11.exitCode ?? 1);
          return G8(e7, f11, t6.redirections);
        }
        throw u11.error;
      }
      t6.update && await R(e7, t6.update.expression);
    }
  } finally {
    e7.state.loopDepth--;
  }
  let l8 = _14(n23, i10, o9);
  return G8(e7, l8, t6.redirections);
}
async function Yn2(e7, t6, s9 = "") {
  let r8 = "", n23 = "", i10 = 0, o9 = 0, a7 = s9;
  for (let c15 of t6.redirections) if ((c15.operator === "<<" || c15.operator === "<<-") && c15.target.type === "HereDoc") {
    let u11 = c15.target, f11 = await kt(e7, u11.content);
    u11.stripTabs && (f11 = f11.split(`
`).map((d16) => d16.replace(/^\t+/, "")).join(`
`)), a7 = f11;
  } else if (c15.operator === "<<<" && c15.target.type === "Word") a7 = `${await kt(e7, c15.target)}
`;
  else if (c15.operator === "<" && c15.target.type === "Word") try {
    let u11 = await kt(e7, c15.target), f11 = e7.fs.resolvePath(e7.state.cwd, u11);
    a7 = await e7.fs.readFile(f11);
  } catch {
    let u11 = await kt(e7, c15.target);
    return A13(`bash: ${u11}: No such file or directory
`);
  }
  let l8 = e7.state.groupStdin;
  a7 && (e7.state.groupStdin = a7), e7.state.loopDepth++;
  try {
    for (; ; ) {
      o9++, o9 > e7.limits.maxLoopIterations && Re7(`while loop: too many iterations (${e7.limits.maxLoopIterations}), increase executionLimits.maxLoopIterations`, "iterations", r8, n23);
      let c15 = 0, u11 = false, f11 = false, d16 = e7.state.inCondition;
      e7.state.inCondition = true;
      try {
        for (let h17 of t6.condition) {
          let m25 = await e7.executeStatement(h17);
          r8 += m25.stdout, n23 += m25.stderr, c15 = m25.exitCode;
        }
      } catch (h17) {
        if (h17 instanceof c2) {
          if (r8 += h17.stdout, n23 += h17.stderr, h17.levels > 1 && e7.state.loopDepth > 1) throw h17.levels--, h17.stdout = r8, h17.stderr = n23, e7.state.inCondition = d16, h17;
          u11 = true;
        } else if (h17 instanceof a2) {
          if (r8 += h17.stdout, n23 += h17.stderr, h17.levels > 1 && e7.state.loopDepth > 1) throw h17.levels--, h17.stdout = r8, h17.stderr = n23, e7.state.inCondition = d16, h17;
          f11 = true;
        } else throw e7.state.inCondition = d16, h17;
      } finally {
        e7.state.inCondition = d16;
      }
      if (u11) break;
      if (!f11) {
        if (c15 !== 0) break;
        try {
          for (let h17 of t6.body) {
            let m25 = await e7.executeStatement(h17);
            r8 += m25.stdout, n23 += m25.stderr, i10 = m25.exitCode;
          }
        } catch (h17) {
          let m25 = Et5(h17, r8, n23, e7.state.loopDepth);
          if (r8 = m25.stdout, n23 = m25.stderr, m25.action === "break") break;
          if (m25.action === "continue") continue;
          if (m25.action === "error") return _14(r8, n23, m25.exitCode ?? 1);
          throw m25.error;
        }
      }
    }
  } finally {
    e7.state.loopDepth--, e7.state.groupStdin = l8;
  }
  return _14(r8, n23, i10);
}
async function Qn2(e7, t6) {
  let s9 = "", r8 = "", n23 = 0, i10 = 0;
  e7.state.loopDepth++;
  try {
    for (; ; ) {
      i10++, i10 > e7.limits.maxLoopIterations && Re7(`until loop: too many iterations (${e7.limits.maxLoopIterations}), increase executionLimits.maxLoopIterations`, "iterations", s9, r8);
      let o9 = await hr2(e7, t6.condition);
      if (s9 += o9.stdout, r8 += o9.stderr, o9.exitCode === 0) break;
      try {
        for (let a7 of t6.body) {
          let l8 = await e7.executeStatement(a7);
          s9 += l8.stdout, r8 += l8.stderr, n23 = l8.exitCode;
        }
      } catch (a7) {
        let l8 = Et5(a7, s9, r8, e7.state.loopDepth);
        if (s9 = l8.stdout, r8 = l8.stderr, l8.action === "break") break;
        if (l8.action === "continue") continue;
        if (l8.action === "error") return _14(s9, r8, l8.exitCode ?? 1);
        throw l8.error;
      }
    }
  } finally {
    e7.state.loopDepth--;
  }
  return _14(s9, r8, n23);
}
async function Jn3(e7, t6) {
  let s9 = await xe10(e7, t6.redirections);
  if (s9) return s9;
  let r8 = "", n23 = "", i10 = 0, o9 = await kt(e7, t6.word), a7 = false;
  for (let c15 = 0; c15 < t6.items.length; c15++) {
    let u11 = t6.items[c15], f11 = a7;
    if (!a7) for (let d16 of u11.patterns) {
      let h17 = await kt(e7, d16);
      yl(d16) && (h17 = X2(h17));
      let m25 = e7.state.shoptOptions.nocasematch, p17 = e7.state.shoptOptions.extglob;
      if (tt7(o9, h17, m25, p17)) {
        f11 = true;
        break;
      }
    }
    if (f11) {
      let d16 = await is3(e7, u11.body, r8, n23);
      if (r8 = d16.stdout, n23 = d16.stderr, i10 = d16.exitCode, u11.terminator === ";;") break;
      u11.terminator === ";&" ? a7 = true : a7 = false;
    } else a7 = false;
  }
  let l8 = _14(r8, n23, i10);
  return G8(e7, l8, t6.redirections);
}
function pr2(e7, t6) {
  if (e7.parts.length !== 1) return false;
  let s9 = e7.parts[0];
  return s9.type !== "Literal" ? false : t6.includes(s9.value);
}
function ei(e7) {
  if (!e7.startsWith("__rw__:")) return null;
  let t6 = e7.slice(7), s9 = t6.indexOf(":");
  if (s9 === -1) return null;
  let r8 = Number.parseInt(t6.slice(0, s9), 10);
  if (Number.isNaN(r8) || r8 < 0) return null;
  let n23 = s9 + 1, i10 = t6.slice(n23, n23 + r8), o9 = n23 + r8 + 1, a7 = t6.slice(o9), l8 = a7.indexOf(":");
  if (l8 === -1) return null;
  let c15 = Number.parseInt(a7.slice(0, l8), 10);
  if (Number.isNaN(c15) || c15 < 0) return null;
  let u11 = a7.slice(l8 + 1);
  return { path: i10, position: c15, content: u11 };
}
var ti = "+ ";
async function si(e7) {
  let t6 = e7.state.env.get("PS4");
  if (t6 === void 0) return ti;
  if (t6 === "") return "";
  try {
    let r8 = new V2().parseWordFromString(t6, false, false);
    return await kt(e7, r8);
  } catch {
    return e7.state.expansionStderr = `${e7.state.expansionStderr || ""}bash: ${t6}: bad substitution
`, t6 || ti;
  }
}
function Wo(e7) {
  return e7.map((t6) => Vo(t6)).join(" ");
}
function Vo(e7) {
  if (e7 === "") return "''";
  if (!/[\s'"\\$`!*?[\]{}|&;<>()~#\n\t]/.test(e7)) return e7;
  let s9 = /[\x00-\x1f\x7f]/.test(e7), r8 = e7.includes(`
`), n23 = e7.includes("	"), i10 = e7.includes("\\"), o9 = e7.includes("'");
  if (s9 || r8 || n23 || i10) {
    let l8 = "";
    for (let c15 of e7) {
      let u11 = c15.charCodeAt(0);
      c15 === `
` ? l8 += "\\n" : c15 === "	" ? l8 += "\\t" : c15 === "\\" ? l8 += "\\\\" : c15 === "'" ? l8 += "'" : c15 === '"' ? l8 += '"' : u11 < 32 || u11 === 127 ? u11 < 256 ? l8 += `\\x${u11.toString(16).padStart(2, "0")}` : l8 += `\\u${u11.toString(16).padStart(4, "0")}` : l8 += c15;
    }
    return `$'${l8}'`;
  }
  return o9 ? `"${e7.replace(/([\\$`"])/g, "\\$1")}"` : `'${e7}'`;
}
async function ri(e7, t6, s9) {
  if (!e7.state.options.xtrace) return "";
  let r8 = await si(e7), n23 = [t6, ...s9], i10 = Wo(n23);
  return `${r8}${i10}
`;
}
async function ni2(e7, t6, s9) {
  return e7.state.options.xtrace ? `${await si(e7)}${t6}=${s9}
` : "";
}
async function ii(e7, t6, s9) {
  let r8 = t6.timed ? performance.now() : 0, n23 = "", i10 = L17, o9 = 0, a7 = [], l8 = "", c15 = t6.commands.length > 1, u11 = e7.state.lastArg;
  for (let d16 = 0; d16 < t6.commands.length; d16++) {
    let h17 = t6.commands[d16], m25 = d16 === t6.commands.length - 1, p17 = d16 === 0;
    c15 && (e7.state.lastArg = "", p17 || (e7.state.groupStdin = void 0));
    let S17 = c15 && (!m25 || !e7.state.shoptOptions.lastpipe) ? new Map(e7.state.env) : null, v21;
    try {
      v21 = await s9(h17, n23);
    } catch (P20) {
      if (P20 instanceof h) v21 = { stdout: P20.stdout, stderr: P20.stderr, exitCode: 1 };
      else if (P20 instanceof d2 && t6.commands.length > 1) v21 = { stdout: P20.stdout, stderr: P20.stderr, exitCode: P20.exitCode };
      else if (P20 instanceof u2 && t6.commands.length > 1) v21 = { stdout: P20.stdout, stderr: P20.stderr, exitCode: P20.exitCode };
      else throw S17 && (e7.state.env = S17), P20;
    }
    S17 && (e7.state.env = S17), a7.push(v21.exitCode), v21.exitCode !== 0 && (o9 = v21.exitCode), m25 ? i10 = v21 : (t6.pipeStderr?.[d16] ?? false ? n23 = v21.stderr + v21.stdout : (n23 = v21.stdout, l8 += v21.stderr), i10 = { stdout: "", stderr: "", exitCode: v21.exitCode });
  }
  if (l8 && (i10 = { ...i10, stderr: l8 + i10.stderr }), t6.commands.length > 1 || t6.commands.length === 1 && t6.commands[0].type === "SimpleCommand") {
    for (let d16 of e7.state.env.keys()) d16.startsWith("PIPESTATUS_") && e7.state.env.delete(d16);
    for (let d16 = 0; d16 < a7.length; d16++) e7.state.env.set(`PIPESTATUS_${d16}`, String(a7[d16]));
    e7.state.env.set("PIPESTATUS__length", String(a7.length));
  }
  if (e7.state.options.pipefail && o9 !== 0 && (i10 = { ...i10, exitCode: o9 }), t6.negated && (i10 = { ...i10, exitCode: i10.exitCode === 0 ? 1 : 0 }), t6.timed) {
    let h17 = (performance.now() - r8) / 1e3, m25 = Math.floor(h17 / 60), p17 = h17 % 60, g18;
    t6.timePosix ? g18 = `real ${h17.toFixed(2)}
user 0.00
sys 0.00
` : g18 = `
real	${`${m25}m${p17.toFixed(3)}s`}
user	0m0.000s
sys	0m0.000s
`, i10 = { ...i10, stderr: i10.stderr + g18 };
  }
  return c15 && !e7.state.shoptOptions.lastpipe && (e7.state.lastArg = u11), i10;
}
async function oi(e7, t6) {
  let s9 = /* @__PURE__ */ new Map(), r8 = "";
  for (let n23 of t6.assignments) {
    let i10 = n23.name;
    if (n23.array) {
      let u11 = await Bo(e7, t6, i10, n23.array, n23.append, s9);
      if (u11.error) return { continueToNext: false, xtraceOutput: r8, tempAssignments: s9, error: u11.error };
      if (r8 += u11.xtraceOutput, u11.continueToNext) continue;
    }
    let o9 = n23.value ? await kt(e7, n23.value) : "";
    if (i10.match(/^([a-zA-Z_][a-zA-Z0-9_]*)\[\]$/)) return { continueToNext: false, xtraceOutput: r8, tempAssignments: s9, error: _14("", `bash: ${i10}: bad array subscript
`, 1) };
    let l8 = i10.match(/^([a-zA-Z_][a-zA-Z0-9_]*)\[(.+)\]$/);
    if (l8) {
      let u11 = await Go(e7, t6, l8[1], l8[2], o9, n23.append, s9);
      if (u11.error) return { continueToNext: false, xtraceOutput: r8, tempAssignments: s9, error: u11.error };
      if (u11.continueToNext) continue;
    }
    let c15 = await Ko(e7, t6, i10, o9, n23.append, s9);
    if (c15.error) return { continueToNext: false, xtraceOutput: r8, tempAssignments: s9, error: c15.error };
    r8 += c15.xtraceOutput, c15.continueToNext;
  }
  return { continueToNext: false, xtraceOutput: r8, tempAssignments: s9 };
}
async function Bo(e7, t6, s9, r8, n23, i10) {
  let o9 = "";
  if (/\[.+\]$/.test(s9)) return { continueToNext: false, xtraceOutput: "", error: _14("", `bash: ${s9}: cannot assign list to array member
`, 1) };
  if (L2(e7, s9)) {
    let u11 = Ae(e7, s9);
    if (u11 === void 0 || u11 === "") throw new d2(1, "", "");
    let f11 = he(e7, s9);
    if (f11 && /^[a-zA-Z_][a-zA-Z0-9_]*\[@\]$/.test(f11)) return { continueToNext: false, xtraceOutput: "", error: _14("", `bash: ${s9}: cannot assign list to array member
`, 1) };
  }
  if (bt(e7, s9)) {
    if (t6.name) return o9 += `bash: ${s9}: readonly variable
`, { continueToNext: true, xtraceOutput: o9 };
    let u11 = ha(e7, s9);
    if (u11) return { continueToNext: false, xtraceOutput: "", error: u11 };
  }
  let a7 = e7.state.associativeArrays?.has(s9), l8 = jo(r8), c15 = () => {
    let u11 = `${s9}_`;
    for (let f11 of e7.state.env.keys()) f11.startsWith(u11) && !f11.includes("__") && e7.state.env.delete(f11);
    e7.state.env.delete(s9);
  };
  if (a7 && l8 ? await Uo(e7, t6, s9, r8, n23, c15, (u11) => {
    o9 += u11;
  }) : l8 ? await Ho2(e7, s9, r8, n23, c15) : await qo(e7, s9, r8, n23, c15), t6.name) {
    i10.set(s9, e7.state.env.get(s9));
    let f11 = `(${r8.map((d16) => gn(d16)).join(" ")})`;
    e7.state.env.set(s9, f11);
  }
  return { continueToNext: true, xtraceOutput: o9 };
}
function jo(e7) {
  return e7.some((t6) => {
    if (t6.parts.length >= 2) {
      let s9 = t6.parts[0], r8 = t6.parts[1];
      if (s9.type !== "Glob" || !s9.pattern.startsWith("[")) return false;
      if (s9.pattern === "[" && (r8.type === "DoubleQuoted" || r8.type === "SingleQuoted")) {
        if (t6.parts.length < 3) return false;
        let n23 = t6.parts[2];
        return n23.type !== "Literal" ? false : n23.value.startsWith("]=") || n23.value.startsWith("]+=");
      }
      return r8.type !== "Literal" ? false : r8.value.startsWith("]") ? r8.value.startsWith("]=") || r8.value.startsWith("]+=") : s9.pattern.endsWith("]") ? r8.value.startsWith("=") || r8.value.startsWith("+=") : false;
    }
    return false;
  });
}
async function Uo(e7, t6, s9, r8, n23, i10, o9) {
  let a7 = [];
  for (let l8 of r8) {
    let c15 = $i(l8);
    if (c15) {
      let { key: u11, valueParts: f11, append: d16 } = c15, h17;
      f11.length > 0 ? h17 = await kt(e7, { type: "Word", parts: f11 }) : h17 = "", h17 = Z12(e7, h17), a7.push({ type: "keyed", key: u11, value: h17, append: d16 });
    } else {
      let u11 = await kt(e7, l8);
      a7.push({ type: "invalid", expandedValue: u11 });
    }
  }
  n23 || i10();
  for (let l8 of a7) if (l8.type === "keyed") if (l8.append) {
    let c15 = e7.state.env.get(`${s9}_${l8.key}`) ?? "";
    e7.state.env.set(`${s9}_${l8.key}`, c15 + l8.value);
  } else e7.state.env.set(`${s9}_${l8.key}`, l8.value);
  else {
    let c15 = t6.line ?? e7.state.currentLine ?? 1;
    o9(`bash: line ${c15}: ${s9}: ${l8.expandedValue}: must use subscript when assigning associative array
`);
  }
}
async function Ho2(e7, t6, s9, r8, n23) {
  let i10 = [];
  for (let a7 of s9) {
    let l8 = $i(a7);
    if (l8) {
      let { key: c15, valueParts: u11, append: f11 } = l8, d16;
      u11.length > 0 ? d16 = await kt(e7, { type: "Word", parts: u11 }) : d16 = "", d16 = Z12(e7, d16), i10.push({ type: "keyed", indexExpr: c15, value: d16, append: f11 });
    } else {
      let c15 = await Sl(e7, a7);
      i10.push({ type: "non-keyed", values: c15.values });
    }
  }
  r8 || n23();
  let o9 = 0;
  for (let a7 of i10) if (a7.type === "keyed") {
    let l8;
    try {
      let c15 = new V2(), u11 = M2(c15, a7.indexExpr);
      l8 = await R(e7, u11.expression, false);
    } catch {
      if (/^-?\d+$/.test(a7.indexExpr)) l8 = Number.parseInt(a7.indexExpr, 10);
      else {
        let c15 = e7.state.env.get(a7.indexExpr);
        l8 = c15 ? Number.parseInt(c15, 10) : 0, Number.isNaN(l8) && (l8 = 0);
      }
    }
    if (a7.append) {
      let c15 = e7.state.env.get(`${t6}_${l8}`) ?? "";
      e7.state.env.set(`${t6}_${l8}`, c15 + a7.value);
    } else e7.state.env.set(`${t6}_${l8}`, a7.value);
    o9 = l8 + 1;
  } else for (let l8 of a7.values) e7.state.env.set(`${t6}_${o9++}`, l8);
}
async function qo(e7, t6, s9, r8, n23) {
  let i10 = [];
  for (let a7 of s9) {
    let l8 = await Sl(e7, a7);
    i10.push(...l8.values);
  }
  let o9 = 0;
  if (r8) {
    let a7 = P2(e7, t6);
    if (a7.length > 0) o9 = Math.max(...a7.map(([c15]) => typeof c15 == "number" ? c15 : 0)) + 1;
    else {
      let l8 = e7.state.env.get(t6);
      l8 !== void 0 && (e7.state.env.set(`${t6}_0`, l8), e7.state.env.delete(t6), o9 = 1);
    }
  } else n23();
  for (let a7 = 0; a7 < i10.length; a7++) e7.state.env.set(`${t6}_${o9 + a7}`, i10[a7]);
  r8 || e7.state.env.set(`${t6}__length`, String(i10.length));
}
async function Go(e7, t6, s9, r8, n23, i10, o9) {
  let a7 = s9;
  if (L2(e7, s9)) {
    let f11 = he(e7, s9);
    if (f11 && f11 !== s9) {
      if (f11.includes("[")) return { continueToNext: false, xtraceOutput: "", error: _14("", `bash: \`${f11}': not a valid identifier
`, 1) };
      a7 = f11;
    }
  }
  if (bt(e7, a7)) {
    if (t6.name) return { continueToNext: true, xtraceOutput: "" };
    let f11 = ha(e7, a7);
    if (f11) return { continueToNext: false, xtraceOutput: "", error: f11 };
  }
  let l8 = e7.state.associativeArrays?.has(a7), c15;
  if (l8) c15 = await ai(e7, a7, r8);
  else {
    let f11 = await Zo(e7, a7, r8);
    if (f11.error) return { continueToNext: false, xtraceOutput: "", error: f11.error };
    c15 = `${a7}_${f11.index}`;
  }
  let u11 = i10 ? (e7.state.env.get(c15) || "") + n23 : n23;
  if (t6.name) o9.set(c15, e7.state.env.get(c15)), e7.state.env.set(c15, u11);
  else {
    let f11 = st7(e7, a7);
    if (f11 !== void 0 && f11 === e7.state.callDepth && e7.state.localScopes.length > 0) {
      let d16 = e7.state.localScopes[e7.state.localScopes.length - 1];
      d16.has(c15) || d16.set(c15, e7.state.env.get(c15));
    }
    e7.state.env.set(c15, u11);
  }
  return { continueToNext: true, xtraceOutput: "" };
}
async function ai(e7, t6, s9) {
  let r8;
  if (s9.startsWith("'") && s9.endsWith("'")) r8 = s9.slice(1, -1);
  else if (s9.startsWith('"') && s9.endsWith('"')) {
    let n23 = s9.slice(1, -1), o9 = new V2().parseWordFromString(n23, true, false);
    r8 = await kt(e7, o9);
  } else if (s9.includes("$")) {
    let i10 = new V2().parseWordFromString(s9, false, false);
    r8 = await kt(e7, i10);
  } else r8 = s9;
  return `${t6}_${r8}`;
}
async function Zo(e7, t6, s9) {
  let r8 = s9;
  s9.startsWith('"') && s9.endsWith('"') && s9.length >= 2 && (r8 = s9.slice(1, -1));
  let n23;
  if (/^-?\d+$/.test(r8)) n23 = Number.parseInt(r8, 10);
  else {
    try {
      let i10 = new V2(), o9 = M2(i10, r8);
      n23 = await R(e7, o9.expression, false);
    } catch (i10) {
      if (i10 instanceof p) {
        let l8 = `bash: line ${e7.state.currentLine}: ${s9}: ${i10.message}
`;
        if (i10.fatal) throw new d2(1, "", l8);
        return { index: 0, error: _14("", l8, 1) };
      }
      let o9 = e7.state.env.get(s9);
      n23 = o9 ? Number.parseInt(o9, 10) : 0;
    }
    Number.isNaN(n23) && (n23 = 0);
  }
  if (n23 < 0) {
    let i10 = P2(e7, t6);
    if (i10.length === 0) {
      let a7 = e7.state.currentLine;
      return { index: 0, error: _14("", `bash: line ${a7}: ${t6}[${s9}]: bad array subscript
`, 1) };
    }
    if (n23 = Math.max(...i10.map(([a7]) => typeof a7 == "number" ? a7 : 0)) + 1 + n23, n23 < 0) {
      let a7 = e7.state.currentLine;
      return { index: 0, error: _14("", `bash: line ${a7}: ${t6}[${s9}]: bad array subscript
`, 1) };
    }
  }
  return { index: n23 };
}
async function Ko(e7, t6, s9, r8, n23, i10) {
  let o9 = "", a7 = s9, l8 = null;
  if (L2(e7, s9)) {
    let f11 = Bi(e7, s9, r8);
    if (f11 === void 0) return { continueToNext: false, xtraceOutput: "", error: _14("", `bash: ${s9}: circular name reference
`, 1) };
    if (f11 === null) return { continueToNext: true, xtraceOutput: "" };
    a7 = f11;
    let d16 = a7.match(/^([a-zA-Z_][a-zA-Z0-9_]*)\[(.+)\]$/);
    d16 && (l8 = { arrayName: d16[1], subscriptExpr: d16[2] }, a7 = d16[1]);
  }
  if (bt(e7, a7)) {
    if (t6.name) return o9 += `bash: ${a7}: readonly variable
`, { continueToNext: true, xtraceOutput: o9 };
    let f11 = ha(e7, a7);
    if (f11) return { continueToNext: false, xtraceOutput: "", error: f11 };
  }
  let c15;
  if (wt5(e7, a7)) try {
    let f11 = new V2();
    if (n23) {
      let h17 = `(${e7.state.env.get(a7) || "0"}) + (${r8})`, m25 = M2(f11, h17);
      c15 = String(await R(e7, m25.expression));
    } else {
      let d16 = M2(f11, r8);
      c15 = String(await R(e7, d16.expression));
    }
  } catch {
    c15 = "0";
  }
  else {
    let { isArray: f11 } = await Promise.resolve().then(() => (init_expansion_5HXXJ2SG(), expansion_5HXXJ2SG_exports)), d16 = f11(e7, a7) ? `${a7}_0` : a7;
    c15 = n23 ? (e7.state.env.get(d16) || "") + r8 : r8;
  }
  c15 = it6(e7, a7, c15), o9 += await ni2(e7, a7, c15);
  let u11 = a7;
  if (l8) u11 = await Xo(e7, l8);
  else {
    let { isArray: f11 } = await Promise.resolve().then(() => (init_expansion_5HXXJ2SG(), expansion_5HXXJ2SG_exports));
    f11(e7, a7) && (u11 = `${a7}_0`);
  }
  return t6.name ? (i10.set(u11, e7.state.env.get(u11)), e7.state.env.set(u11, c15)) : (e7.state.env.set(u11, c15), e7.state.options.allexport && (e7.state.exportedVars = e7.state.exportedVars || /* @__PURE__ */ new Set(), e7.state.exportedVars.add(a7)), e7.state.tempEnvBindings?.some((f11) => f11.has(a7)) && (e7.state.mutatedTempEnvVars = e7.state.mutatedTempEnvVars || /* @__PURE__ */ new Set(), e7.state.mutatedTempEnvVars.add(a7))), { continueToNext: false, xtraceOutput: o9 };
}
async function Xo(e7, t6) {
  let { arrayName: s9, subscriptExpr: r8 } = t6;
  if (e7.state.associativeArrays?.has(s9)) return ai(e7, s9, r8);
  let i10;
  if (/^-?\d+$/.test(r8)) i10 = Number.parseInt(r8, 10);
  else {
    try {
      let o9 = new V2(), a7 = M2(o9, r8);
      i10 = await R(e7, a7.expression, false);
    } catch {
      let o9 = e7.state.env.get(r8);
      i10 = o9 ? Number.parseInt(o9, 10) : 0;
    }
    Number.isNaN(i10) && (i10 = 0);
  }
  if (i10 < 0) {
    let o9 = P2(e7, s9);
    o9.length > 0 && (i10 = Math.max(...o9.map((l8) => l8[0])) + 1 + i10);
  }
  return `${s9}_${i10}`;
}
async function li(e7, t6, s9, r8) {
  let n23 = await xe10(e7, t6.redirections);
  if (n23) return n23;
  let i10 = new Map(e7.state.env), o9 = e7.state.cwd, a7 = { ...e7.state.options }, l8 = new Map(e7.state.functions), c15 = e7.state.localScopes, u11 = e7.state.localVarStack, f11 = e7.state.localVarDepth, d16 = e7.state.fullyUnsetLocals;
  if (e7.state.localScopes = c15.map((E13) => new Map(E13)), u11) {
    e7.state.localVarStack = /* @__PURE__ */ new Map();
    for (let [E13, T10] of u11.entries()) e7.state.localVarStack.set(E13, T10.map((x23) => ({ ...x23 })));
  }
  f11 && (e7.state.localVarDepth = new Map(f11)), d16 && (e7.state.fullyUnsetLocals = new Map(d16));
  let h17 = e7.state.loopDepth, m25 = e7.state.parentHasLoopContext;
  e7.state.parentHasLoopContext = h17 > 0, e7.state.loopDepth = 0;
  let p17 = e7.state.lastArg, g18 = e7.state.bashPid;
  e7.state.bashPid = e7.state.nextVirtualPid++;
  let S17 = e7.state.groupStdin;
  s9 && (e7.state.groupStdin = s9);
  let v21 = "", P20 = "", y18 = 0, w19 = () => {
    e7.state.env = i10, e7.state.cwd = o9, e7.state.options = a7, e7.state.functions = l8, e7.state.localScopes = c15, e7.state.localVarStack = u11, e7.state.localVarDepth = f11, e7.state.fullyUnsetLocals = d16, e7.state.loopDepth = h17, e7.state.parentHasLoopContext = m25, e7.state.groupStdin = S17, e7.state.bashPid = g18, e7.state.lastArg = p17;
  };
  try {
    for (let E13 of t6.body) {
      let T10 = await r8(E13);
      v21 += T10.stdout, P20 += T10.stderr, y18 = T10.exitCode;
    }
  } catch (E13) {
    if (w19(), E13 instanceof b2) throw E13;
    if (E13 instanceof $2) {
      v21 += E13.stdout, P20 += E13.stderr;
      let x23 = _14(v21, P20, 0);
      return G8(e7, x23, t6.redirections);
    }
    if (E13 instanceof c2 || E13 instanceof a2) {
      v21 += E13.stdout, P20 += E13.stderr;
      let x23 = _14(v21, P20, 0);
      return G8(e7, x23, t6.redirections);
    }
    if (E13 instanceof d2) {
      v21 += E13.stdout, P20 += E13.stderr;
      let x23 = _14(v21, P20, E13.exitCode);
      return G8(e7, x23, t6.redirections);
    }
    if (E13 instanceof i) {
      v21 += E13.stdout, P20 += E13.stderr;
      let x23 = _14(v21, P20, E13.exitCode);
      return G8(e7, x23, t6.redirections);
    }
    if (E13 instanceof u2) {
      let x23 = _14(v21 + E13.stdout, P20 + E13.stderr, E13.exitCode);
      return G8(e7, x23, t6.redirections);
    }
    let T10 = _14(v21, `${P20}${n17(E13)}
`, 1);
    return G8(e7, T10, t6.redirections);
  }
  w19();
  let b25 = _14(v21, P20, y18);
  return G8(e7, b25, t6.redirections);
}
async function ci(e7, t6, s9, r8) {
  let n23 = "", i10 = "", o9 = 0, a7 = await Yt2(e7, t6.redirections);
  if (a7) return a7;
  let l8 = s9;
  for (let f11 of t6.redirections) if ((f11.operator === "<<" || f11.operator === "<<-") && f11.target.type === "HereDoc") {
    let d16 = f11.target, h17 = await kt(e7, d16.content);
    d16.stripTabs && (h17 = h17.split(`
`).map((p17) => p17.replace(/^\t+/, "")).join(`
`));
    let m25 = f11.fd ?? 0;
    m25 !== 0 ? (e7.state.fileDescriptors || (e7.state.fileDescriptors = /* @__PURE__ */ new Map()), e7.state.fileDescriptors.set(m25, h17)) : l8 = h17;
  } else if (f11.operator === "<<<" && f11.target.type === "Word") l8 = `${await kt(e7, f11.target)}
`;
  else if (f11.operator === "<" && f11.target.type === "Word") try {
    let d16 = await kt(e7, f11.target), h17 = e7.fs.resolvePath(e7.state.cwd, d16);
    l8 = await e7.fs.readFile(h17);
  } catch {
    let d16 = await kt(e7, f11.target);
    return _14("", `bash: ${d16}: No such file or directory
`, 1);
  }
  let c15 = e7.state.groupStdin;
  l8 && (e7.state.groupStdin = l8);
  try {
    for (let f11 of t6.body) {
      let d16 = await r8(f11);
      n23 += d16.stdout, i10 += d16.stderr, o9 = d16.exitCode;
    }
  } catch (f11) {
    if (e7.state.groupStdin = c15, f11 instanceof b2) throw f11;
    if (C(f11) || f11 instanceof u2 || f11 instanceof d2) throw f11.prependOutput(n23, i10), f11;
    return _14(n23, `${i10}${n17(f11)}
`, 1);
  }
  e7.state.groupStdin = c15;
  let u11 = _14(n23, i10, o9);
  return G8(e7, u11, t6.redirections);
}
async function ui(e7, t6, s9, r8, n23) {
  let i10;
  try {
    i10 = await e7.fs.readFile(t6);
  } catch {
    return A13(`bash: ${t6}: No such file or directory
`, 127);
  }
  if (i10.startsWith("#!")) {
    let g18 = i10.indexOf(`
`);
    g18 !== -1 && (i10 = i10.slice(g18 + 1));
  }
  let o9 = new Map(e7.state.env), a7 = e7.state.cwd, l8 = { ...e7.state.options }, c15 = e7.state.loopDepth, u11 = e7.state.parentHasLoopContext, f11 = e7.state.lastArg, d16 = e7.state.bashPid, h17 = e7.state.groupStdin, m25 = e7.state.currentSource;
  e7.state.parentHasLoopContext = c15 > 0, e7.state.loopDepth = 0, e7.state.bashPid = e7.state.nextVirtualPid++, r8 && (e7.state.groupStdin = r8), e7.state.currentSource = t6, e7.state.env.set("0", t6), e7.state.env.set("#", String(s9.length)), e7.state.env.set("@", s9.join(" ")), e7.state.env.set("*", s9.join(" "));
  for (let g18 = 0; g18 < s9.length && g18 < 9; g18++) e7.state.env.set(String(g18 + 1), s9[g18]);
  for (let g18 = s9.length + 1; g18 <= 9; g18++) e7.state.env.delete(String(g18));
  let p17 = () => {
    e7.state.env = o9, e7.state.cwd = a7, e7.state.options = l8, e7.state.loopDepth = c15, e7.state.parentHasLoopContext = u11, e7.state.lastArg = f11, e7.state.bashPid = d16, e7.state.groupStdin = h17, e7.state.currentSource = m25;
  };
  try {
    let S17 = new V2().parse(i10), v21 = await n23(S17);
    return p17(), v21;
  } catch (g18) {
    if (p17(), g18 instanceof d2 || g18 instanceof b2) throw g18;
    if (g18.name === "ParseException") return A13(`bash: ${t6}: ${g18.message}
`);
    throw g18;
  }
}
var $t3 = class {
  ctx;
  constructor(t6, s9) {
    this.ctx = { state: s9, fs: t6.fs, commands: t6.commands, limits: t6.limits, execFn: t6.exec, executeScript: this.executeScript.bind(this), executeStatement: this.executeStatement.bind(this), executeCommand: this.executeCommand.bind(this), fetch: t6.fetch, sleep: t6.sleep, trace: t6.trace, coverage: t6.coverage };
  }
  buildExportedEnv() {
    let t6 = this.ctx.state.exportedVars, s9 = this.ctx.state.tempExportedVars, r8 = /* @__PURE__ */ new Set();
    if (t6) for (let i10 of t6) r8.add(i10);
    if (s9) for (let i10 of s9) r8.add(i10);
    if (r8.size === 0) return /* @__PURE__ */ Object.create(null);
    let n23 = /* @__PURE__ */ Object.create(null);
    for (let i10 of r8) {
      let o9 = this.ctx.state.env.get(i10);
      o9 !== void 0 && (n23[i10] = o9);
    }
    return n23;
  }
  async executeScript(t6) {
    let s9 = "", r8 = "", n23 = 0;
    for (let i10 of t6.statements) try {
      let o9 = await this.executeStatement(i10);
      s9 += o9.stdout, r8 += o9.stderr, n23 = o9.exitCode, this.ctx.state.lastExitCode = n23, this.ctx.state.env.set("?", String(n23));
    } catch (o9) {
      if (o9 instanceof d2) throw o9.prependOutput(s9, r8), o9;
      if (o9 instanceof f) return s9 += o9.stdout, r8 += o9.stderr, n23 = o9.exitCode, this.ctx.state.lastExitCode = n23, this.ctx.state.env.set("?", String(n23)), { stdout: s9, stderr: r8, exitCode: n23, env: r(this.ctx.state.env) };
      if (o9 instanceof b2) throw o9;
      if (o9 instanceof u2) return s9 += o9.stdout, r8 += o9.stderr, n23 = o9.exitCode, this.ctx.state.lastExitCode = n23, this.ctx.state.env.set("?", String(n23)), { stdout: s9, stderr: r8, exitCode: n23, env: r(this.ctx.state.env) };
      if (o9 instanceof x2) return s9 += o9.stdout, r8 += o9.stderr, n23 = 1, this.ctx.state.lastExitCode = n23, this.ctx.state.env.set("?", String(n23)), { stdout: s9, stderr: r8, exitCode: n23, env: r(this.ctx.state.env) };
      if (o9 instanceof h) return s9 += o9.stdout, r8 += o9.stderr, n23 = 1, this.ctx.state.lastExitCode = n23, this.ctx.state.env.set("?", String(n23)), { stdout: s9, stderr: r8, exitCode: n23, env: r(this.ctx.state.env) };
      if (o9 instanceof p) {
        s9 += o9.stdout, r8 += o9.stderr, n23 = 1, this.ctx.state.lastExitCode = n23, this.ctx.state.env.set("?", String(n23));
        continue;
      }
      if (o9 instanceof m2) {
        s9 += o9.stdout, r8 += o9.stderr, n23 = 1, this.ctx.state.lastExitCode = n23, this.ctx.state.env.set("?", String(n23));
        continue;
      }
      if (o9 instanceof c2 || o9 instanceof a2) {
        if (this.ctx.state.loopDepth > 0) throw o9.prependOutput(s9, r8), o9;
        s9 += o9.stdout, r8 += o9.stderr;
        continue;
      }
      throw o9 instanceof i && o9.prependOutput(s9, r8), o9;
    }
    return { stdout: s9, stderr: r8, exitCode: n23, env: r(this.ctx.state.env) };
  }
  async executeUserScript(t6, s9, r8 = "") {
    return ui(this.ctx, t6, s9, r8, (n23) => this.executeScript(n23));
  }
  async executeStatement(t6) {
    if (this.ctx.state.commandCount++, this.ctx.state.commandCount > this.ctx.limits.maxCommandCount && Re7(`too many commands executed (>${this.ctx.limits.maxCommandCount}), increase executionLimits.maxCommandCount`, "commands"), t6.deferredError) throw new Q2(t6.deferredError.message, t6.line ?? 1, 1);
    if (this.ctx.state.options.noexec) return L17;
    this.ctx.state.errexitSafe = false;
    let s9 = "", r8 = "";
    this.ctx.state.options.verbose && !this.ctx.state.suppressVerbose && t6.sourceText && (r8 += `${t6.sourceText}
`);
    let n23 = 0, i10 = -1, o9 = false;
    for (let c15 = 0; c15 < t6.pipelines.length; c15++) {
      let u11 = t6.pipelines[c15], f11 = c15 > 0 ? t6.operators[c15 - 1] : null;
      if (f11 === "&&" && n23 !== 0 || f11 === "||" && n23 === 0) continue;
      let d16 = await this.executePipeline(u11);
      s9 += d16.stdout, r8 += d16.stderr, n23 = d16.exitCode, i10 = c15, o9 = u11.negated, this.ctx.state.lastExitCode = n23, this.ctx.state.env.set("?", String(n23));
    }
    let a7 = i10 < t6.pipelines.length - 1, l8 = this.ctx.state.errexitSafe;
    if (this.ctx.state.errexitSafe = a7 || o9 || l8, this.ctx.state.options.errexit && n23 !== 0 && i10 === t6.pipelines.length - 1 && !o9 && !this.ctx.state.inCondition && !l8) throw new u2(n23, s9, r8);
    return _14(s9, r8, n23);
  }
  async executePipeline(t6) {
    return ii(this.ctx, t6, (s9, r8) => this.executeCommand(s9, r8));
  }
  async executeCommand(t6, s9) {
    switch (this.ctx.coverage?.hit(`bash:cmd:${t6.type}`), t6.type) {
      case "SimpleCommand":
        return this.executeSimpleCommand(t6, s9);
      case "If":
        return Zn3(this.ctx, t6);
      case "For":
        return Kn2(this.ctx, t6);
      case "CStyleFor":
        return Xn2(this.ctx, t6);
      case "While":
        return Yn2(this.ctx, t6, s9);
      case "Until":
        return Qn2(this.ctx, t6);
      case "Case":
        return Jn3(this.ctx, t6);
      case "Subshell":
        return this.executeSubshell(t6, s9);
      case "Group":
        return this.executeGroup(t6, s9);
      case "FunctionDef":
        return yn2(this.ctx, t6);
      case "ArithmeticCommand":
        return this.executeArithmeticCommand(t6);
      case "ConditionalCommand":
        return this.executeConditionalCommand(t6);
      default:
        return L17;
    }
  }
  async executeSimpleCommand(t6, s9) {
    try {
      return await this.executeSimpleCommandInner(t6, s9);
    } catch (r8) {
      if (r8 instanceof l) return A13(r8.stderr);
      throw r8;
    }
  }
  async executeSimpleCommandInner(t6, s9) {
    if (t6.line !== void 0 && (this.ctx.state.currentLine = t6.line), this.ctx.state.shoptOptions.expand_aliases && t6.name) {
      let y18 = t6, w19 = 100;
      for (; w19 > 0; ) {
        let b25 = this.expandAlias(y18);
        if (b25 === y18) break;
        y18 = b25, w19--;
      }
      this.aliasExpansionStack.clear(), y18 !== t6 && (t6 = y18);
    }
    this.ctx.state.expansionStderr = "";
    let r8 = await oi(this.ctx, t6);
    if (r8.error) return r8.error;
    let n23 = r8.tempAssignments, i10 = r8.xtraceOutput;
    if (!t6.name) {
      if (t6.redirections.length > 0) {
        let w19 = await xe10(this.ctx, t6.redirections);
        if (w19) return w19;
        let b25 = _14("", i10, 0);
        return G8(this.ctx, b25, t6.redirections);
      }
      this.ctx.state.lastArg = "";
      let y18 = (this.ctx.state.expansionStderr || "") + i10;
      return this.ctx.state.expansionStderr = "", _14("", y18, this.ctx.state.lastExitCode);
    }
    let o9 = t6.name && pr2(t6.name, ["local", "declare", "typeset", "export", "readonly"]), a7 = Array.from(n23.keys());
    if (a7.length > 0 && !o9) {
      this.ctx.state.tempExportedVars = this.ctx.state.tempExportedVars || /* @__PURE__ */ new Set();
      for (let y18 of a7) this.ctx.state.tempExportedVars.add(y18);
    }
    let l8 = await Yt2(this.ctx, t6.redirections);
    if (l8) {
      for (let [y18, w19] of n23) w19 === void 0 ? this.ctx.state.env.delete(y18) : this.ctx.state.env.set(y18, w19);
      return l8;
    }
    let c15 = -1;
    for (let y18 of t6.redirections) {
      if ((y18.operator === "<<" || y18.operator === "<<-") && y18.target.type === "HereDoc") {
        let w19 = y18.target, b25 = await kt(this.ctx, w19.content);
        w19.stripTabs && (b25 = b25.split(`
`).map((T10) => T10.replace(/^\t+/, "")).join(`
`));
        let E13 = y18.fd ?? 0;
        E13 !== 0 ? (this.ctx.state.fileDescriptors || (this.ctx.state.fileDescriptors = /* @__PURE__ */ new Map()), this.ctx.state.fileDescriptors.set(E13, b25)) : s9 = b25;
        continue;
      }
      if (y18.operator === "<<<" && y18.target.type === "Word") {
        s9 = `${await kt(this.ctx, y18.target)}
`;
        continue;
      }
      if (y18.operator === "<" && y18.target.type === "Word") try {
        let w19 = await kt(this.ctx, y18.target), b25 = this.ctx.fs.resolvePath(this.ctx.state.cwd, w19);
        s9 = await this.ctx.fs.readFile(b25);
      } catch {
        let w19 = await kt(this.ctx, y18.target);
        for (let [b25, E13] of n23) E13 === void 0 ? this.ctx.state.env.delete(b25) : this.ctx.state.env.set(b25, E13);
        return A13(`bash: ${w19}: No such file or directory
`);
      }
      if (y18.operator === "<&" && y18.target.type === "Word") {
        let w19 = await kt(this.ctx, y18.target), b25 = Number.parseInt(w19, 10);
        if (!Number.isNaN(b25) && this.ctx.state.fileDescriptors) {
          let E13 = this.ctx.state.fileDescriptors.get(b25);
          if (E13 !== void 0) if (E13.startsWith("__rw__:")) {
            let T10 = ei(E13);
            T10 && (s9 = T10.content.slice(T10.position), c15 = b25);
          } else E13.startsWith("__file__:") || E13.startsWith("__file_append__:") || (s9 = E13);
        }
      }
    }
    let u11 = await kt(this.ctx, t6.name), f11 = [], d16 = [];
    if (pr2(t6.name, ["local", "declare", "typeset", "export", "readonly"]) && (u11 === "local" || u11 === "declare" || u11 === "typeset" || u11 === "export" || u11 === "readonly")) for (let y18 of t6.args) {
      let w19 = await Qr2(this.ctx, y18);
      if (w19) f11.push(w19), d16.push(true);
      else {
        let b25 = await Jr2(this.ctx, y18);
        if (b25 !== null) f11.push(b25), d16.push(true);
        else {
          let E13 = await Sl(this.ctx, y18);
          for (let T10 of E13.values) f11.push(T10), d16.push(E13.quoted);
        }
      }
    }
    else for (let y18 of t6.args) {
      let w19 = await Sl(this.ctx, y18);
      for (let b25 of w19.values) f11.push(b25), d16.push(w19.quoted);
    }
    if (!u11) {
      if (t6.name.parts.every((w19) => w19.type === "CommandSubstitution" || w19.type === "ParameterExpansion" || w19.type === "ArithmeticExpansion")) {
        if (f11.length > 0) {
          let w19 = f11.shift();
          return d16.shift(), await this.runCommand(w19, f11, d16, s9, false, false, c15);
        }
        return _14("", "", this.ctx.state.lastExitCode);
      }
      return A13(`bash: : command not found
`, 127);
    }
    if (u11 === "exec" && (f11.length === 0 || f11[0] === "--")) {
      for (let y18 of t6.redirections) {
        if (y18.target.type === "HereDoc" || y18.fdVariable) continue;
        let w19 = await kt(this.ctx, y18.target), b25 = y18.fd ?? (y18.operator === "<" || y18.operator === "<>" ? 0 : 1);
        switch (this.ctx.state.fileDescriptors || (this.ctx.state.fileDescriptors = /* @__PURE__ */ new Map()), y18.operator) {
          case ">":
          case ">|": {
            let E13 = this.ctx.fs.resolvePath(this.ctx.state.cwd, w19);
            await this.ctx.fs.writeFile(E13, "", "utf8"), this.ctx.state.fileDescriptors.set(b25, `__file__:${E13}`);
            break;
          }
          case ">>": {
            let E13 = this.ctx.fs.resolvePath(this.ctx.state.cwd, w19);
            this.ctx.state.fileDescriptors.set(b25, `__file_append__:${E13}`);
            break;
          }
          case "<": {
            let E13 = this.ctx.fs.resolvePath(this.ctx.state.cwd, w19);
            try {
              let T10 = await this.ctx.fs.readFile(E13);
              this.ctx.state.fileDescriptors.set(b25, T10);
            } catch {
              return A13(`bash: ${w19}: No such file or directory
`);
            }
            break;
          }
          case "<>": {
            let E13 = this.ctx.fs.resolvePath(this.ctx.state.cwd, w19);
            try {
              let T10 = await this.ctx.fs.readFile(E13);
              this.ctx.state.fileDescriptors.set(b25, `__rw__:${E13.length}:${E13}:0:${T10}`);
            } catch {
              await this.ctx.fs.writeFile(E13, "", "utf8"), this.ctx.state.fileDescriptors.set(b25, `__rw__:${E13.length}:${E13}:0:`);
            }
            break;
          }
          case ">&": {
            if (w19 === "-") this.ctx.state.fileDescriptors.delete(b25);
            else if (w19.endsWith("-")) {
              let E13 = w19.slice(0, -1), T10 = Number.parseInt(E13, 10);
              if (!Number.isNaN(T10)) {
                let x23 = this.ctx.state.fileDescriptors.get(T10);
                x23 !== void 0 ? this.ctx.state.fileDescriptors.set(b25, x23) : this.ctx.state.fileDescriptors.set(b25, `__dupout__:${T10}`), this.ctx.state.fileDescriptors.delete(T10);
              }
            } else {
              let E13 = Number.parseInt(w19, 10);
              Number.isNaN(E13) || this.ctx.state.fileDescriptors.set(b25, `__dupout__:${E13}`);
            }
            break;
          }
          case "<&": {
            if (w19 === "-") this.ctx.state.fileDescriptors.delete(b25);
            else if (w19.endsWith("-")) {
              let E13 = w19.slice(0, -1), T10 = Number.parseInt(E13, 10);
              if (!Number.isNaN(T10)) {
                let x23 = this.ctx.state.fileDescriptors.get(T10);
                x23 !== void 0 ? this.ctx.state.fileDescriptors.set(b25, x23) : this.ctx.state.fileDescriptors.set(b25, `__dupin__:${T10}`), this.ctx.state.fileDescriptors.delete(T10);
              }
            } else {
              let E13 = Number.parseInt(w19, 10);
              Number.isNaN(E13) || this.ctx.state.fileDescriptors.set(b25, `__dupin__:${E13}`);
            }
            break;
          }
        }
      }
      for (let [y18, w19] of n23) w19 === void 0 ? this.ctx.state.env.delete(y18) : this.ctx.state.env.set(y18, w19);
      if (this.ctx.state.tempExportedVars) for (let y18 of n23.keys()) this.ctx.state.tempExportedVars.delete(y18);
      return L17;
    }
    let m25 = await ri(this.ctx, u11, f11);
    n23.size > 0 && (this.ctx.state.tempEnvBindings = this.ctx.state.tempEnvBindings || [], this.ctx.state.tempEnvBindings.push(new Map(n23)));
    let p17, g18 = null;
    try {
      p17 = await this.runCommand(u11, f11, d16, s9, false, false, c15);
    } catch (y18) {
      if (y18 instanceof c2 || y18 instanceof a2) g18 = y18, p17 = L17;
      else throw y18;
    }
    let S17 = i10 + m25;
    if (S17 && (p17 = { ...p17, stderr: S17 + p17.stderr }), p17 = await G8(this.ctx, p17, t6.redirections), g18) throw g18;
    if (f11.length > 0) {
      let y18 = f11[f11.length - 1];
      if ((u11 === "declare" || u11 === "local" || u11 === "typeset") && /^[a-zA-Z_][a-zA-Z0-9_]*=\(/.test(y18)) {
        let w19 = y18.match(/^([a-zA-Z_][a-zA-Z0-9_]*)=\(/);
        w19 && (y18 = w19[1]);
      }
      this.ctx.state.lastArg = y18;
    } else this.ctx.state.lastArg = u11;
    let v21 = pn4(u11) && u11 !== "unset" && u11 !== "eval";
    if (!this.ctx.state.options.posix || !v21) for (let [y18, w19] of n23) this.ctx.state.fullyUnsetLocals?.has(y18) || (w19 === void 0 ? this.ctx.state.env.delete(y18) : this.ctx.state.env.set(y18, w19));
    if (this.ctx.state.tempExportedVars) for (let y18 of n23.keys()) this.ctx.state.tempExportedVars.delete(y18);
    return n23.size > 0 && this.ctx.state.tempEnvBindings && this.ctx.state.tempEnvBindings.pop(), this.ctx.state.expansionStderr && (p17 = { ...p17, stderr: this.ctx.state.expansionStderr + p17.stderr }, this.ctx.state.expansionStderr = ""), p17;
  }
  async runCommand(t6, s9, r8, n23, i10 = false, o9 = false, a7 = -1) {
    let l8 = { ctx: this.ctx, runCommand: (u11, f11, d16, h17, m25, p17, g18) => this.runCommand(u11, f11, d16, h17, m25, p17, g18), buildExportedEnv: () => this.buildExportedEnv(), executeUserScript: (u11, f11, d16) => this.executeUserScript(u11, f11, d16) }, c15 = await qn3(l8, t6, s9, r8, n23, i10, o9, a7);
    return c15 !== null ? c15 : Gn2(l8, t6, s9, n23, o9);
  }
  aliasExpansionStack = /* @__PURE__ */ new Set();
  expandAlias(t6) {
    return Ss2(this.ctx.state, t6, this.aliasExpansionStack);
  }
  async findCommandInPath(t6) {
    return ns2(this.ctx, t6);
  }
  async executeSubshell(t6, s9 = "") {
    return li(this.ctx, t6, s9, (r8) => this.executeStatement(r8));
  }
  async executeGroup(t6, s9 = "") {
    return ci(this.ctx, t6, s9, (r8) => this.executeStatement(r8));
  }
  async executeArithmeticCommand(t6) {
    t6.line !== void 0 && (this.ctx.state.currentLine = t6.line);
    let s9 = await xe10(this.ctx, t6.redirections);
    if (s9) return s9;
    try {
      let r8 = await R(this.ctx, t6.expression.expression), n23 = Y10(r8 !== 0);
      return this.ctx.state.expansionStderr && (n23 = { ...n23, stderr: this.ctx.state.expansionStderr + n23.stderr }, this.ctx.state.expansionStderr = ""), G8(this.ctx, n23, t6.redirections);
    } catch (r8) {
      let n23 = A13(`bash: arithmetic expression: ${r8.message}
`);
      return G8(this.ctx, n23, t6.redirections);
    }
  }
  async executeConditionalCommand(t6) {
    t6.line !== void 0 && (this.ctx.state.currentLine = t6.line);
    let s9 = await xe10(this.ctx, t6.redirections);
    if (s9) return s9;
    try {
      let r8 = await We6(this.ctx, t6.expression), n23 = Y10(r8);
      return this.ctx.state.expansionStderr && (n23 = { ...n23, stderr: this.ctx.state.expansionStderr + n23.stderr }, this.ctx.state.expansionStderr = ""), G8(this.ctx, n23, t6.redirections);
    } catch (r8) {
      let n23 = r8 instanceof p ? 1 : 2, i10 = A13(`bash: conditional expression: ${r8.message}
`, n23);
      return G8(this.ctx, i10, t6.redirections);
    }
  }
};
var ue10 = { maxCallDepth: 100, maxCommandCount: 1e4, maxLoopIterations: 1e4, maxAwkIterations: 1e4, maxSedIterations: 1e4, maxJqIterations: 1e4, maxSqliteTimeoutMs: 5e3, maxPythonTimeoutMs: 3e4, maxGlobOperations: 1e5, maxStringLength: 10485760, maxArrayElements: 1e5, maxHeredocSize: 10485760, maxSubstitutionDepth: 50, maxBraceExpansionResults: 1e4 };
function fi(e7) {
  return e7 ? { maxCallDepth: e7.maxCallDepth ?? ue10.maxCallDepth, maxCommandCount: e7.maxCommandCount ?? ue10.maxCommandCount, maxLoopIterations: e7.maxLoopIterations ?? ue10.maxLoopIterations, maxAwkIterations: e7.maxAwkIterations ?? ue10.maxAwkIterations, maxSedIterations: e7.maxSedIterations ?? ue10.maxSedIterations, maxJqIterations: e7.maxJqIterations ?? ue10.maxJqIterations, maxSqliteTimeoutMs: e7.maxSqliteTimeoutMs ?? ue10.maxSqliteTimeoutMs, maxPythonTimeoutMs: e7.maxPythonTimeoutMs ?? ue10.maxPythonTimeoutMs, maxGlobOperations: e7.maxGlobOperations ?? ue10.maxGlobOperations, maxStringLength: e7.maxStringLength ?? ue10.maxStringLength, maxArrayElements: e7.maxArrayElements ?? ue10.maxArrayElements, maxHeredocSize: e7.maxHeredocSize ?? ue10.maxHeredocSize, maxSubstitutionDepth: e7.maxSubstitutionDepth ?? ue10.maxSubstitutionDepth, maxBraceExpansionResults: e7.maxBraceExpansionResults ?? ue10.maxBraceExpansionResults } : { ...ue10 };
}
function di(e7) {
  try {
    let t6 = new URL(e7);
    return { origin: t6.origin, pathname: t6.pathname, href: t6.href };
  } catch {
    return null;
  }
}
function Yo2(e7) {
  let t6 = di(e7);
  return t6 ? { origin: t6.origin, pathPrefix: t6.pathname } : null;
}
function Qo(e7, t6) {
  let s9 = di(e7);
  if (!s9) return false;
  let r8 = Yo2(t6);
  return !r8 || s9.origin !== r8.origin ? false : r8.pathPrefix === "/" || r8.pathPrefix === "" ? true : s9.pathname.startsWith(r8.pathPrefix);
}
function mr2(e7, t6) {
  return !t6 || t6.length === 0 ? false : t6.some((s9) => Qo(e7, s9));
}
var ot6 = class extends Error {
  constructor(t6) {
    super(`Network access denied: URL not in allow-list: ${t6}`), this.name = "NetworkAccessDeniedError";
  }
};
var at7 = class extends Error {
  constructor(t6) {
    super(`Too many redirects (max: ${t6})`), this.name = "TooManyRedirectsError";
  }
};
var lt7 = class extends Error {
  constructor(t6) {
    super(`Redirect target not in allow-list: ${t6}`), this.name = "RedirectNotAllowedError";
  }
};
var os2 = class extends Error {
  constructor(t6, s9) {
    super(`HTTP method '${t6}' not allowed. Allowed methods: ${s9.join(", ")}`), this.name = "MethodNotAllowedError";
  }
};
var St5 = class extends Error {
  constructor(t6) {
    super(`Response body too large (max: ${t6} bytes)`), this.name = "ResponseTooLargeError";
  }
};
var Jo2 = 20;
var ea = 3e4;
var ta = 10485760;
var sa = ["GET", "HEAD"];
var ra = /* @__PURE__ */ new Set(["GET", "HEAD", "OPTIONS"]);
var na = /* @__PURE__ */ new Set([301, 302, 303, 307, 308]);
function yr2(e7) {
  let t6 = e7.maxRedirects ?? Jo2, s9 = e7.timeoutMs ?? ea, r8 = e7.maxResponseSize ?? ta, n23 = e7.dangerouslyAllowFullInternetAccess ? ["GET", "HEAD", "POST", "PUT", "DELETE", "PATCH", "OPTIONS"] : e7.allowedMethods ?? sa;
  function i10(l8) {
    if (!e7.dangerouslyAllowFullInternetAccess && !mr2(l8, e7.allowedUrlPrefixes ?? [])) throw new ot6(l8);
  }
  function o9(l8) {
    if (e7.dangerouslyAllowFullInternetAccess) return;
    let c15 = l8.toUpperCase();
    if (!n23.includes(c15)) throw new os2(c15, n23);
  }
  async function a7(l8, c15 = {}) {
    let u11 = c15.method?.toUpperCase() ?? "GET";
    i10(l8), o9(u11);
    let f11 = l8, d16 = 0, h17 = c15.followRedirects ?? true, m25 = c15.timeoutMs !== void 0 ? Math.min(c15.timeoutMs, s9) : s9;
    for (; ; ) {
      let p17 = new AbortController(), g18 = setTimeout(() => p17.abort(), m25);
      try {
        let S17 = { method: u11, headers: c15.headers, signal: p17.signal, redirect: "manual" };
        c15.body && !ra.has(u11) && (S17.body = c15.body);
        let v21 = await fetch(f11, S17);
        if (na.has(v21.status) && h17) {
          let P20 = v21.headers.get("location");
          if (!P20) return await hi3(v21, f11, r8);
          let y18 = new URL(P20, f11).href;
          if (!e7.dangerouslyAllowFullInternetAccess && !mr2(y18, e7.allowedUrlPrefixes ?? [])) throw new lt7(y18);
          if (d16++, d16 > t6) throw new at7(t6);
          f11 = y18;
          continue;
        }
        return await hi3(v21, f11, r8);
      } finally {
        clearTimeout(g18);
      }
    }
  }
  return a7;
}
async function hi3(e7, t6, s9) {
  let r8 = /* @__PURE__ */ Object.create(null);
  if (e7.headers.forEach((i10, o9) => {
    r8[o9.toLowerCase()] = i10;
  }), s9 > 0) {
    let i10 = e7.headers.get("content-length");
    if (i10) {
      let o9 = parseInt(i10, 10);
      if (!Number.isNaN(o9) && o9 > s9) throw new St5(s9);
    }
  }
  let n23;
  if (s9 > 0 && e7.body) {
    let i10 = e7.body.getReader(), o9 = new TextDecoder(), a7 = [], l8 = 0;
    for (; ; ) {
      let { done: c15, value: u11 } = await i10.read();
      if (c15) break;
      if (l8 += u11.byteLength, l8 > s9) throw i10.cancel(), new St5(s9);
      a7.push(o9.decode(u11, { stream: true }));
    }
    a7.push(o9.decode()), n23 = a7.join("");
  } else n23 = await e7.text();
  return { status: e7.status, statusText: e7.statusText, headers: r8, body: n23, url: t6 };
}
function gr2() {
  let e7 = [{ prop: "Function", target: globalThis, violationType: "function_constructor", strategy: "throw", reason: "Function constructor allows arbitrary code execution" }, { prop: "eval", target: globalThis, violationType: "eval", strategy: "throw", reason: "eval() allows arbitrary code execution" }, { prop: "setTimeout", target: globalThis, violationType: "setTimeout", strategy: "throw", reason: "setTimeout with string argument allows code execution" }, { prop: "setInterval", target: globalThis, violationType: "setInterval", strategy: "throw", reason: "setInterval with string argument allows code execution" }, { prop: "setImmediate", target: globalThis, violationType: "setImmediate", strategy: "throw", reason: "setImmediate could be used to escape sandbox context" }, { prop: "env", target: process, violationType: "process_env", strategy: "throw", reason: "process.env could leak sensitive environment variables" }, { prop: "binding", target: process, violationType: "process_binding", strategy: "throw", reason: "process.binding provides access to native Node.js modules" }, { prop: "_linkedBinding", target: process, violationType: "process_binding", strategy: "throw", reason: "process._linkedBinding provides access to native Node.js modules" }, { prop: "dlopen", target: process, violationType: "process_dlopen", strategy: "throw", reason: "process.dlopen allows loading native addons" }, { prop: "exit", target: process, violationType: "process_exit", strategy: "throw", reason: "process.exit could terminate the interpreter" }, { prop: "abort", target: process, violationType: "process_exit", strategy: "throw", reason: "process.abort could crash the interpreter" }, { prop: "kill", target: process, violationType: "process_kill", strategy: "throw", reason: "process.kill could signal other processes" }, { prop: "setuid", target: process, violationType: "process_setuid", strategy: "throw", reason: "process.setuid could escalate privileges" }, { prop: "setgid", target: process, violationType: "process_setuid", strategy: "throw", reason: "process.setgid could escalate privileges" }, { prop: "umask", target: process, violationType: "process_umask", strategy: "throw", reason: "process.umask could modify file creation permissions" }, { prop: "argv", target: process, violationType: "process_argv", strategy: "throw", reason: "process.argv may contain secrets in CLI arguments" }, { prop: "chdir", target: process, violationType: "process_chdir", strategy: "throw", reason: "process.chdir could confuse the interpreter's CWD tracking" }, { prop: "send", target: process, violationType: "process_send", strategy: "throw", reason: "process.send could communicate with parent process in IPC contexts" }, { prop: "channel", target: process, violationType: "process_channel", strategy: "throw", reason: "process.channel could access IPC channel to parent process" }, { prop: "cpuUsage", target: process, violationType: "process_timing", strategy: "throw", reason: "process.cpuUsage could enable timing side-channel attacks" }, { prop: "memoryUsage", target: process, violationType: "process_timing", strategy: "throw", reason: "process.memoryUsage could enable timing side-channel attacks" }, { prop: "hrtime", target: process, violationType: "process_timing", strategy: "throw", reason: "process.hrtime could enable timing side-channel attacks" }, { prop: "WeakRef", target: globalThis, violationType: "weak_ref", strategy: "throw", reason: "WeakRef could be used to leak references outside sandbox" }, { prop: "FinalizationRegistry", target: globalThis, violationType: "finalization_registry", strategy: "throw", reason: "FinalizationRegistry could be used to leak references outside sandbox" }, { prop: "Reflect", target: globalThis, violationType: "reflect", strategy: "freeze", reason: "Reflect provides introspection capabilities" }, { prop: "Proxy", target: globalThis, violationType: "proxy", strategy: "throw", reason: "Proxy allows intercepting and modifying object behavior" }, { prop: "WebAssembly", target: globalThis, violationType: "webassembly", strategy: "throw", reason: "WebAssembly allows executing arbitrary compiled code" }, { prop: "SharedArrayBuffer", target: globalThis, violationType: "shared_array_buffer", strategy: "throw", reason: "SharedArrayBuffer could enable side-channel communication or timing attacks" }, { prop: "Atomics", target: globalThis, violationType: "atomics", strategy: "throw", reason: "Atomics could enable side-channel communication or timing attacks" }];
  try {
    let t6 = Object.getPrototypeOf(async () => {
    }).constructor;
    t6 && t6 !== Function && e7.push({ prop: "constructor", target: Object.getPrototypeOf(async () => {
    }), violationType: "async_function_constructor", strategy: "throw", reason: "AsyncFunction constructor allows arbitrary async code execution" });
  } catch {
  }
  try {
    let t6 = Object.getPrototypeOf(function* () {
    }).constructor;
    t6 && t6 !== Function && e7.push({ prop: "constructor", target: Object.getPrototypeOf(function* () {
    }), violationType: "generator_function_constructor", strategy: "throw", reason: "GeneratorFunction constructor allows arbitrary generator code execution" });
  } catch {
  }
  try {
    let t6 = Object.getPrototypeOf(async function* () {
    }).constructor;
    t6 && t6 !== Function && t6 !== Object.getPrototypeOf(async () => {
    }).constructor && e7.push({ prop: "constructor", target: Object.getPrototypeOf(async function* () {
    }), violationType: "async_generator_function_constructor", strategy: "throw", reason: "AsyncGeneratorFunction constructor allows arbitrary async generator code execution" });
  } catch {
  }
  return e7.filter((t6) => {
    try {
      return t6.target[t6.prop] !== void 0;
    } catch {
      return false;
    }
  });
}
var ct5 = typeof __BROWSER__ < "u" && __BROWSER__;
function pi() {
  return typeof crypto < "u" && crypto.randomUUID ? crypto.randomUUID() : "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (e7) => {
    let t6 = Math.random() * 16 | 0;
    return (e7 === "x" ? t6 : t6 & 3 | 8).toString(16);
  });
}
var vr2 = null;
if (!ct5) try {
  let { createRequire: e7 } = await Promise.resolve().then(() => (init_node_module(), node_module_exports));
  vr2 = e7(import.meta.url)("node:async_hooks").AsyncLocalStorage;
} catch (e7) {
  console.warn("[DefenseInDepthBox] WARNING: AsyncLocalStorage not available, defense-in-depth security layer is DISABLED. This means script execution will NOT be protected by runtime security patches. Reason:", e7 instanceof Error ? e7.message : e7);
}
var ia2 = `

This is a defense-in-depth measure and indicates a bug in just-bash. Please report this at security@vercel.com`;
var J14 = class extends Error {
  violation;
  constructor(t6, s9) {
    super(t6 + ia2), this.violation = s9, this.name = "SecurityViolationError";
  }
};
var ce9 = !ct5 && vr2 ? new vr2() : null;
var oa2 = 1e3;
var wr2 = { enabled: true, auditMode: false };
function aa(e7) {
  return e7 === void 0 ? { ...wr2, enabled: false } : typeof e7 == "boolean" ? { ...wr2, enabled: e7 } : { ...wr2, ...e7 };
}
var ut6 = class e5 {
  static instance = null;
  config;
  refCount = 0;
  originalDescriptors = [];
  violations = [];
  activationTime = 0;
  totalActiveTimeMs = 0;
  constructor(t6) {
    this.config = t6;
  }
  static getInstance(t6) {
    return e5.instance || (e5.instance = new e5(aa(t6))), e5.instance;
  }
  static resetInstance() {
    e5.instance && (e5.instance.forceDeactivate(), e5.instance = null);
  }
  static isInSandboxedContext() {
    return ce9 ? ce9?.getStore()?.sandboxActive === true : false;
  }
  static getCurrentExecutionId() {
    if (ce9) return ce9?.getStore()?.executionId;
  }
  isEnabled() {
    return this.config.enabled === true && ce9 !== null && !ct5;
  }
  updateConfig(t6) {
    this.config = { ...this.config, ...t6 };
  }
  activate() {
    if (ct5 || !this.config.enabled) {
      let s9 = pi();
      return { run: (r8) => r8(), deactivate: () => {
      }, executionId: s9 };
    }
    this.refCount++, this.refCount === 1 && (this.applyPatches(), this.activationTime = Date.now());
    let t6 = pi();
    return { run: (s9) => ce9.run({ sandboxActive: true, executionId: t6 }, s9), deactivate: () => {
      this.refCount--, this.refCount === 0 && (this.restorePatches(), this.totalActiveTimeMs += Date.now() - this.activationTime), this.refCount < 0 && (this.refCount = 0);
    }, executionId: t6 };
  }
  forceDeactivate() {
    this.refCount > 0 && (this.restorePatches(), this.totalActiveTimeMs += Date.now() - this.activationTime), this.refCount = 0;
  }
  isActive() {
    return this.refCount > 0;
  }
  getStats() {
    return { violationsBlocked: this.violations.length, violations: [...this.violations], activeTimeMs: this.totalActiveTimeMs + (this.refCount > 0 ? Date.now() - this.activationTime : 0), refCount: this.refCount };
  }
  clearViolations() {
    this.violations = [];
  }
  getPathForTarget(t6, s9) {
    return t6 === globalThis ? `globalThis.${s9}` : t6 === process ? `process.${s9}` : t6 === Error ? `Error.${s9}` : t6 === Function.prototype ? `Function.prototype.${s9}` : t6 === Object.prototype ? `Object.prototype.${s9}` : `<object>.${s9}`;
  }
  shouldBlock() {
    return ct5 || this.config.auditMode || !ce9 ? false : ce9?.getStore()?.sandboxActive === true;
  }
  recordViolation(t6, s9, r8) {
    let n23 = { timestamp: Date.now(), type: t6, message: r8, path: s9, stack: new Error().stack, executionId: ce9?.getStore()?.executionId };
    if (this.violations.length < oa2 && this.violations.push(n23), this.config.onViolation) try {
      this.config.onViolation(n23);
    } catch (i10) {
      console.debug("[DefenseInDepthBox] onViolation callback threw:", i10 instanceof Error ? i10.message : i10);
    }
    return n23;
  }
  createBlockingProxy(t6, s9, r8) {
    let n23 = this;
    return new Proxy(t6, { apply(i10, o9, a7) {
      if (n23.shouldBlock()) {
        let l8 = `${s9} is blocked during script execution`, c15 = n23.recordViolation(r8, s9, l8);
        throw new J14(l8, c15);
      }
      return n23.config.auditMode && ce9?.getStore()?.sandboxActive === true && n23.recordViolation(r8, s9, `${s9} called (audit mode)`), Reflect.apply(i10, o9, a7);
    }, construct(i10, o9, a7) {
      if (n23.shouldBlock()) {
        let l8 = `${s9} constructor is blocked during script execution`, c15 = n23.recordViolation(r8, s9, l8);
        throw new J14(l8, c15);
      }
      return n23.config.auditMode && ce9?.getStore()?.sandboxActive === true && n23.recordViolation(r8, s9, `${s9} constructor called (audit mode)`), Reflect.construct(i10, o9, a7);
    } });
  }
  createBlockingObjectProxy(t6, s9, r8) {
    let n23 = this;
    return new Proxy(t6, { get(i10, o9, a7) {
      if (n23.shouldBlock()) {
        let l8 = `${s9}.${String(o9)}`, c15 = `${l8} is blocked during script execution`, u11 = n23.recordViolation(r8, l8, c15);
        throw new J14(c15, u11);
      }
      if (n23.config.auditMode && ce9?.getStore()?.sandboxActive === true) {
        let l8 = `${s9}.${String(o9)}`;
        n23.recordViolation(r8, l8, `${l8} accessed (audit mode)`);
      }
      return Reflect.get(i10, o9, a7);
    }, set(i10, o9, a7, l8) {
      if (n23.shouldBlock()) {
        let c15 = `${s9}.${String(o9)}`, u11 = `${c15} modification is blocked during script execution`, f11 = n23.recordViolation(r8, c15, u11);
        throw new J14(u11, f11);
      }
      return Reflect.set(i10, o9, a7, l8);
    }, ownKeys(i10) {
      if (n23.shouldBlock()) {
        let o9 = `${s9} enumeration is blocked during script execution`, a7 = n23.recordViolation(r8, s9, o9);
        throw new J14(o9, a7);
      }
      return Reflect.ownKeys(i10);
    }, getOwnPropertyDescriptor(i10, o9) {
      if (n23.shouldBlock()) {
        let a7 = `${s9}.${String(o9)}`, l8 = `${a7} descriptor access is blocked during script execution`, c15 = n23.recordViolation(r8, a7, l8);
        throw new J14(l8, c15);
      }
      return Reflect.getOwnPropertyDescriptor(i10, o9);
    }, has(i10, o9) {
      if (n23.shouldBlock()) {
        let a7 = `${s9}.${String(o9)}`, l8 = `${a7} existence check is blocked during script execution`, c15 = n23.recordViolation(r8, a7, l8);
        throw new J14(l8, c15);
      }
      return Reflect.has(i10, o9);
    } });
  }
  applyPatches() {
    let t6 = gr2(), s9 = /* @__PURE__ */ new Set(["process_send", "process_channel"]);
    for (let r8 of t6) s9.has(r8.violationType) || this.applyPatch(r8);
    this.protectConstructorChain(), this.protectErrorPrepareStackTrace(), this.protectModuleLoad(), this.protectProcessMainModule(), this.protectProcessExecPath();
  }
  protectConstructorChain() {
    this.patchPrototypeConstructor(Function.prototype, "Function.prototype.constructor", "function_constructor");
    try {
      let t6 = Object.getPrototypeOf(async () => {
      }).constructor;
      t6 && t6 !== Function && this.patchPrototypeConstructor(t6.prototype, "AsyncFunction.prototype.constructor", "async_function_constructor");
    } catch (t6) {
      console.debug("[DefenseInDepthBox] Could not patch AsyncFunction.prototype.constructor:", t6 instanceof Error ? t6.message : t6);
    }
    try {
      let t6 = Object.getPrototypeOf(function* () {
      }).constructor;
      t6 && t6 !== Function && this.patchPrototypeConstructor(t6.prototype, "GeneratorFunction.prototype.constructor", "generator_function_constructor");
    } catch (t6) {
      console.debug("[DefenseInDepthBox] Could not patch GeneratorFunction.prototype.constructor:", t6 instanceof Error ? t6.message : t6);
    }
    try {
      let t6 = Object.getPrototypeOf(async function* () {
      }).constructor, s9 = Object.getPrototypeOf(async () => {
      }).constructor;
      t6 && t6 !== Function && t6 !== s9 && this.patchPrototypeConstructor(t6.prototype, "AsyncGeneratorFunction.prototype.constructor", "async_generator_function_constructor");
    } catch (t6) {
      console.debug("[DefenseInDepthBox] Could not patch AsyncGeneratorFunction.prototype.constructor:", t6 instanceof Error ? t6.message : t6);
    }
  }
  protectErrorPrepareStackTrace() {
    let t6 = this;
    try {
      let s9 = Object.getOwnPropertyDescriptor(Error, "prepareStackTrace");
      this.originalDescriptors.push({ target: Error, prop: "prepareStackTrace", descriptor: s9 });
      let r8 = s9?.value;
      Object.defineProperty(Error, "prepareStackTrace", { get() {
        return r8;
      }, set(n23) {
        if (t6.shouldBlock()) {
          let i10 = "Error.prepareStackTrace modification is blocked during script execution", o9 = t6.recordViolation("error_prepare_stack_trace", "Error.prepareStackTrace", i10);
          throw new J14(i10, o9);
        }
        t6.config.auditMode && ce9?.getStore()?.sandboxActive === true && t6.recordViolation("error_prepare_stack_trace", "Error.prepareStackTrace", "Error.prepareStackTrace set (audit mode)"), r8 = n23;
      }, configurable: true });
    } catch (s9) {
      console.debug("[DefenseInDepthBox] Could not protect Error.prepareStackTrace:", s9 instanceof Error ? s9.message : s9);
    }
  }
  patchPrototypeConstructor(t6, s9, r8) {
    let n23 = this;
    try {
      let i10 = Object.getOwnPropertyDescriptor(t6, "constructor");
      this.originalDescriptors.push({ target: t6, prop: "constructor", descriptor: i10 });
      let o9 = i10?.value;
      Object.defineProperty(t6, "constructor", { get() {
        if (n23.shouldBlock()) {
          let a7 = `${s9} access is blocked during script execution`, l8 = n23.recordViolation(r8, s9, a7);
          throw new J14(a7, l8);
        }
        return n23.config.auditMode && ce9?.getStore()?.sandboxActive === true && n23.recordViolation(r8, s9, `${s9} accessed (audit mode)`), o9;
      }, set(a7) {
        if (n23.shouldBlock()) {
          let l8 = `${s9} modification is blocked during script execution`, c15 = n23.recordViolation(r8, s9, l8);
          throw new J14(l8, c15);
        }
        Object.defineProperty(this, "constructor", { value: a7, writable: true, configurable: true });
      }, configurable: true });
    } catch (i10) {
      console.debug(`[DefenseInDepthBox] Could not patch ${s9}:`, i10 instanceof Error ? i10.message : i10);
    }
  }
  protectProcessMainModule() {
    if (typeof process > "u") return;
    let t6 = this;
    try {
      let s9 = Object.getOwnPropertyDescriptor(process, "mainModule");
      this.originalDescriptors.push({ target: process, prop: "mainModule", descriptor: s9 });
      let r8 = s9?.value;
      r8 !== void 0 && Object.defineProperty(process, "mainModule", { get() {
        if (t6.shouldBlock()) {
          let n23 = "process.mainModule access is blocked during script execution", i10 = t6.recordViolation("process_main_module", "process.mainModule", n23);
          throw new J14(n23, i10);
        }
        return t6.config.auditMode && ce9?.getStore()?.sandboxActive === true && t6.recordViolation("process_main_module", "process.mainModule", "process.mainModule accessed (audit mode)"), r8;
      }, set(n23) {
        if (t6.shouldBlock()) {
          let i10 = "process.mainModule modification is blocked during script execution", o9 = t6.recordViolation("process_main_module", "process.mainModule", i10);
          throw new J14(i10, o9);
        }
        Object.defineProperty(process, "mainModule", { value: n23, writable: true, configurable: true });
      }, configurable: true });
    } catch (s9) {
      console.debug("[DefenseInDepthBox] Could not protect process.mainModule:", s9 instanceof Error ? s9.message : s9);
    }
  }
  protectProcessExecPath() {
    if (typeof process > "u") return;
    let t6 = this;
    try {
      let s9 = Object.getOwnPropertyDescriptor(process, "execPath");
      this.originalDescriptors.push({ target: process, prop: "execPath", descriptor: s9 });
      let r8 = s9?.value ?? process.execPath;
      Object.defineProperty(process, "execPath", { get() {
        if (t6.shouldBlock()) {
          let n23 = "process.execPath access is blocked during script execution", i10 = t6.recordViolation("process_exec_path", "process.execPath", n23);
          throw new J14(n23, i10);
        }
        return t6.config.auditMode && ce9?.getStore()?.sandboxActive === true && t6.recordViolation("process_exec_path", "process.execPath", "process.execPath accessed (audit mode)"), r8;
      }, set(n23) {
        if (t6.shouldBlock()) {
          let i10 = "process.execPath modification is blocked during script execution", o9 = t6.recordViolation("process_exec_path", "process.execPath", i10);
          throw new J14(i10, o9);
        }
        Object.defineProperty(process, "execPath", { value: n23, writable: true, configurable: true });
      }, configurable: true });
    } catch (s9) {
      console.debug("[DefenseInDepthBox] Could not protect process.execPath:", s9 instanceof Error ? s9.message : s9);
    }
  }
  protectModuleLoad() {
    if (!ct5) try {
      let t6 = null;
      if (typeof process < "u") {
        let o9 = process.mainModule;
        o9 && typeof o9 == "object" && (t6 = o9.constructor);
      }
      if (!t6 && typeof m4 < "u" && typeof m4.main < "u" && (t6 = m4.main.constructor), !t6 || typeof t6._load != "function") return;
      let s9 = t6._load, r8 = Object.getOwnPropertyDescriptor(t6, "_load");
      this.originalDescriptors.push({ target: t6, prop: "_load", descriptor: r8 });
      let i10 = this.createBlockingProxy(s9, "Module._load", "module_load");
      Object.defineProperty(t6, "_load", { value: i10, writable: true, configurable: true });
    } catch (t6) {
      console.debug("[DefenseInDepthBox] Could not protect Module._load:", t6 instanceof Error ? t6.message : t6);
    }
  }
  applyPatch(t6) {
    let { target: s9, prop: r8, violationType: n23, strategy: i10 } = t6;
    try {
      let o9 = s9[r8];
      if (o9 === void 0) return;
      let a7 = Object.getOwnPropertyDescriptor(s9, r8);
      if (this.originalDescriptors.push({ target: s9, prop: r8, descriptor: a7 }), i10 === "freeze") typeof o9 == "object" && o9 !== null && Object.freeze(o9);
      else {
        let l8 = this.getPathForTarget(s9, r8), c15 = typeof o9 == "function" ? this.createBlockingProxy(o9, l8, n23) : this.createBlockingObjectProxy(o9, l8, n23);
        Object.defineProperty(s9, r8, { value: c15, writable: true, configurable: true });
      }
    } catch (o9) {
      let a7 = this.getPathForTarget(s9, r8);
      console.debug(`[DefenseInDepthBox] Could not patch ${a7}:`, o9 instanceof Error ? o9.message : o9);
    }
  }
  restorePatches() {
    for (let t6 = this.originalDescriptors.length - 1; t6 >= 0; t6--) {
      let { target: s9, prop: r8, descriptor: n23 } = this.originalDescriptors[t6];
      try {
        n23 ? Object.defineProperty(s9, r8, n23) : delete s9[r8];
      } catch (i10) {
        let o9 = this.getPathForTarget(s9, r8);
        console.debug(`[DefenseInDepthBox] Could not restore ${o9}:`, i10 instanceof Error ? i10.message : i10);
      }
    }
    this.originalDescriptors = [];
  }
};
function Pt4(e7) {
  return Ke6(e7);
}
function Ke6(e7) {
  return e7.statements.map(mi2).join(`
`);
}
function mi2(e7) {
  let t6 = [];
  for (let r8 = 0; r8 < e7.pipelines.length; r8++) t6.push(la(e7.pipelines[r8])), r8 < e7.operators.length && t6.push(e7.operators[r8]);
  let s9 = t6.join(" ");
  return e7.background && (s9 += " &"), s9;
}
function la(e7) {
  let t6 = [];
  e7.timed && t6.push(e7.timePosix ? "time -p" : "time"), e7.negated && t6.push("!");
  let s9 = [];
  for (let n23 = 0; n23 < e7.commands.length; n23++) if (s9.push(yi2(e7.commands[n23])), n23 < e7.commands.length - 1) {
    let i10 = e7.pipeStderr?.[n23];
    s9.push(i10 ? "|&" : "|");
  }
  return (t6.length > 0 ? `${t6.join(" ")} ` : "") + s9.join(" ");
}
function yi2(e7) {
  switch (e7.type) {
    case "SimpleCommand":
      return ca2(e7);
    case "If":
      return wa(e7);
    case "For":
      return va(e7);
    case "CStyleFor":
      return ba2(e7);
    case "While":
      return Ea(e7);
    case "Until":
      return $a(e7);
    case "Case":
      return Sa2(e7);
    case "Subshell":
      return Aa2(e7);
    case "Group":
      return ka(e7);
    case "ArithmeticCommand":
      return _a2(e7);
    case "ConditionalCommand":
      return Ca(e7);
    case "FunctionDef":
      return xa(e7);
    default: {
      let t6 = e7;
      throw new Error(`Unsupported command type: ${t6.type}`);
    }
  }
}
function ca2(e7) {
  let t6 = [];
  for (let s9 of e7.assignments) t6.push(ua(s9));
  e7.name && t6.push(ie7(e7.name));
  for (let s9 of e7.args) t6.push(ie7(s9));
  for (let s9 of e7.redirections) t6.push(vi2(s9));
  return t6.join(" ");
}
function ua(e7) {
  let t6 = e7.append ? "+=" : "=";
  if (e7.array) {
    let s9 = e7.array.map(ie7).join(" ");
    return `${e7.name}${t6}(${s9})`;
  }
  return e7.value ? `${e7.name}${t6}${ie7(e7.value)}` : `${e7.name}${t6}`;
}
function ie7(e7) {
  return e7.parts.map((t6) => as2(t6, false)).join("");
}
function Be5(e7) {
  return e7.parts.map((t6) => as2(t6, true)).join("");
}
function as2(e7, t6) {
  switch (e7.type) {
    case "Literal":
      return t6 ? da3(e7.value) : fa2(e7.value);
    case "SingleQuoted":
      return `'${e7.value}'`;
    case "DoubleQuoted":
      return `"${e7.parts.map((s9) => as2(s9, true)).join("")}"`;
    case "Escaped":
      return `\\${e7.value}`;
    case "ParameterExpansion":
      return gi(e7);
    case "CommandSubstitution":
      return e7.legacy ? `\`${Ke6(e7.body)}\`` : `$(${Ke6(e7.body)})`;
    case "ArithmeticExpansion":
      return `$((${q16(e7.expression.expression)}))`;
    case "ProcessSubstitution":
      return e7.direction === "input" ? `<(${Ke6(e7.body)})` : `>(${Ke6(e7.body)})`;
    case "BraceExpansion":
      return ya(e7);
    case "TildeExpansion":
      return e7.user !== null ? `~${e7.user}` : "~";
    case "Glob":
      return e7.pattern;
    default: {
      let s9 = e7;
      throw new Error(`Unsupported word part type: ${s9.type}`);
    }
  }
}
function fa2(e7) {
  return e7.replace(/[\s\\'"`!|&;()<>{}[\]*?~#]/g, "\\$&");
}
function da3(e7) {
  return e7.replace(/[$`"\\]/g, "\\$&");
}
function ha2(e7, t6) {
  return e7.parts.map((s9) => pa2(s9, t6)).join("");
}
function pa2(e7, t6) {
  switch (e7.type) {
    case "Literal":
      return t6 ? e7.value : e7.value.replace(/[$`]/g, "\\$&");
    case "Escaped":
      return `\\${e7.value}`;
    case "ParameterExpansion":
      return gi(e7);
    case "CommandSubstitution":
      return e7.legacy ? `\`${Ke6(e7.body)}\`` : `$(${Ke6(e7.body)})`;
    case "ArithmeticExpansion":
      return `$((${q16(e7.expression.expression)}))`;
    default:
      return as2(e7, false);
  }
}
function gi(e7) {
  return e7.operation ? `\${${wi2(e7.parameter, e7.operation)}}` : ma(e7.parameter) ? `\${${e7.parameter}}` : `$${e7.parameter}`;
}
function ma(e7) {
  return !(/^[?#@*$!\-0-9]$/.test(e7) || /^[a-zA-Z_][a-zA-Z0-9_]*$/.test(e7));
}
function wi2(e7, t6) {
  switch (t6.type) {
    case "Length":
      return `#${e7}`;
    case "LengthSliceError":
      return `#${e7}:`;
    case "BadSubstitution":
      return t6.text;
    case "DefaultValue":
      return `${e7}${t6.checkEmpty ? ":" : ""}-${Be5(t6.word)}`;
    case "AssignDefault":
      return `${e7}${t6.checkEmpty ? ":" : ""}=${Be5(t6.word)}`;
    case "ErrorIfUnset":
      return `${e7}${t6.checkEmpty ? ":" : ""}?${t6.word ? Be5(t6.word) : ""}`;
    case "UseAlternative":
      return `${e7}${t6.checkEmpty ? ":" : ""}+${Be5(t6.word)}`;
    case "Substring": {
      let s9 = q16(t6.offset.expression);
      return t6.length ? `${e7}:${s9}:${q16(t6.length.expression)}` : `${e7}:${s9}`;
    }
    case "PatternRemoval": {
      let s9 = t6.side === "prefix" ? "#" : "%", r8 = t6.greedy ? `${s9}${s9}` : s9;
      return `${e7}${r8}${Be5(t6.pattern)}`;
    }
    case "PatternReplacement": {
      let s9 = "/";
      t6.all ? s9 = "//" : t6.anchor === "start" ? s9 = "/#" : t6.anchor === "end" && (s9 = "/%");
      let r8 = t6.replacement ? `/${Be5(t6.replacement)}` : "";
      return `${e7}${s9}${Be5(t6.pattern)}${r8}`;
    }
    case "CaseModification": {
      let s9 = t6.direction === "upper" ? "^" : ",", r8 = t6.all ? `${s9}${s9}` : s9, n23 = t6.pattern ? Be5(t6.pattern) : "";
      return `${e7}${r8}${n23}`;
    }
    case "Transform":
      return `${e7}@${t6.operator}`;
    case "Indirection":
      return t6.innerOp ? `!${wi2(e7, t6.innerOp)}` : `!${e7}`;
    case "ArrayKeys":
      return `!${t6.array}[${t6.star ? "*" : "@"}]`;
    case "VarNamePrefix":
      return `!${t6.prefix}${t6.star ? "*" : "@"}`;
    default: {
      let s9 = t6;
      throw new Error(`Unsupported parameter operation type: ${s9.type}`);
    }
  }
}
function ya(e7) {
  return `{${e7.items.map(ga).join(",")}}`;
}
function ga(e7) {
  if (e7.type === "Word") return ie7(e7.word);
  let t6 = e7.startStr ?? String(e7.start), s9 = e7.endStr ?? String(e7.end);
  return e7.step !== void 0 ? `${t6}..${s9}..${e7.step}` : `${t6}..${s9}`;
}
function vi2(e7) {
  let t6 = e7.fdVariable ? `{${e7.fdVariable}}` : e7.fd !== null ? String(e7.fd) : "";
  if (e7.operator === "<<" || e7.operator === "<<-") {
    let s9 = e7.target, r8 = s9.quoted ? `'${s9.delimiter}'` : s9.delimiter, n23 = ha2(s9.content, s9.quoted);
    return `${t6}${e7.operator}${r8}
${n23}${s9.delimiter}`;
  }
  return e7.operator === "<<<" ? `${t6}<<< ${ie7(e7.target)}` : e7.operator === "&>" || e7.operator === "&>>" ? `${e7.operator} ${ie7(e7.target)}` : `${t6}${e7.operator} ${ie7(e7.target)}`;
}
function Ae8(e7) {
  return e7.length === 0 ? "" : ` ${e7.map(vi2).join(" ")}`;
}
function be7(e7) {
  return e7.map(mi2).join(`
`);
}
function wa(e7) {
  let t6 = [];
  for (let s9 = 0; s9 < e7.clauses.length; s9++) {
    let r8 = e7.clauses[s9], n23 = s9 === 0 ? "if" : "elif";
    t6.push(`${n23} ${be7(r8.condition)}; then
${be7(r8.body)}`);
  }
  return e7.elseBody && t6.push(`else
${be7(e7.elseBody)}`), `${t6.join(`
`)}
fi${Ae8(e7.redirections)}`;
}
function va(e7) {
  let t6;
  if (e7.words === null) t6 = `for ${e7.variable}`;
  else {
    let s9 = e7.words.map(ie7).join(" ");
    t6 = `for ${e7.variable} in ${s9}`;
  }
  return `${t6}; do
${be7(e7.body)}
done${Ae8(e7.redirections)}`;
}
function ba2(e7) {
  let t6 = e7.init ? q16(e7.init.expression) : "", s9 = e7.condition ? q16(e7.condition.expression) : "", r8 = e7.update ? q16(e7.update.expression) : "";
  return `for ((${t6}; ${s9}; ${r8})); do
${be7(e7.body)}
done${Ae8(e7.redirections)}`;
}
function Ea(e7) {
  return `while ${be7(e7.condition)}; do
${be7(e7.body)}
done${Ae8(e7.redirections)}`;
}
function $a(e7) {
  return `until ${be7(e7.condition)}; do
${be7(e7.body)}
done${Ae8(e7.redirections)}`;
}
function Sa2(e7) {
  let t6 = e7.items.map(Pa).join(`
`);
  return `case ${ie7(e7.word)} in
${t6}
esac${Ae8(e7.redirections)}`;
}
function Pa(e7) {
  let t6 = e7.patterns.map(ie7).join(" | "), s9 = be7(e7.body);
  return s9 ? `${t6})
${s9}
${e7.terminator}` : `${t6})
${e7.terminator}`;
}
function Aa2(e7) {
  return `(${be7(e7.body)})${Ae8(e7.redirections)}`;
}
function ka(e7) {
  return `{ ${be7(e7.body)}; }${Ae8(e7.redirections)}`;
}
function _a2(e7) {
  return `((${q16(e7.expression.expression)}))${Ae8(e7.redirections)}`;
}
function Ca(e7) {
  return `[[ ${Ze6(e7.expression)} ]]${Ae8(e7.redirections)}`;
}
function xa(e7) {
  let t6 = yi2(e7.body);
  return `${e7.name}() ${t6}${Ae8(e7.redirections)}`;
}
function q16(e7) {
  switch (e7.type) {
    case "ArithNumber":
      return String(e7.value);
    case "ArithVariable":
      return e7.hasDollarPrefix ? `$${e7.name}` : e7.name;
    case "ArithSpecialVar":
      return `$${e7.name}`;
    case "ArithBinary":
      return `${q16(e7.left)} ${e7.operator} ${q16(e7.right)}`;
    case "ArithUnary":
      return e7.prefix ? `${e7.operator}${q16(e7.operand)}` : `${q16(e7.operand)}${e7.operator}`;
    case "ArithTernary":
      return `${q16(e7.condition)} ? ${q16(e7.consequent)} : ${q16(e7.alternate)}`;
    case "ArithAssignment":
      return `${e7.subscript ? `${e7.variable}[${q16(e7.subscript)}]` : e7.stringKey !== void 0 ? `${e7.variable}[${e7.stringKey}]` : e7.variable} ${e7.operator} ${q16(e7.value)}`;
    case "ArithDynamicAssignment":
      return `${e7.subscript ? `${q16(e7.target)}[${q16(e7.subscript)}]` : q16(e7.target)} ${e7.operator} ${q16(e7.value)}`;
    case "ArithDynamicElement":
      return `${q16(e7.nameExpr)}[${q16(e7.subscript)}]`;
    case "ArithGroup":
      return `(${q16(e7.expression)})`;
    case "ArithNested":
      return `$((${q16(e7.expression)}))`;
    case "ArithCommandSubst":
      return `$(${e7.command})`;
    case "ArithBracedExpansion":
      return `\${${e7.content}}`;
    case "ArithArrayElement":
      return e7.stringKey !== void 0 ? `${e7.array}[${e7.stringKey}]` : e7.index ? `${e7.array}[${q16(e7.index)}]` : e7.array;
    case "ArithDynamicBase":
      return `\${${e7.baseExpr}}#${e7.value}`;
    case "ArithDynamicNumber":
      return `\${${e7.prefix}}${e7.suffix}`;
    case "ArithConcat":
      return e7.parts.map(q16).join("");
    case "ArithDoubleSubscript":
      return `${e7.array}[${q16(e7.index)}]`;
    case "ArithNumberSubscript":
      return `${e7.number}[${e7.errorToken}]`;
    case "ArithSyntaxError":
      return e7.errorToken;
    case "ArithSingleQuote":
      return `'${e7.content}'`;
    default: {
      let t6 = e7;
      throw new Error(`Unsupported arithmetic expression type: ${t6.type}`);
    }
  }
}
function Ze6(e7) {
  switch (e7.type) {
    case "CondBinary":
      return `${ie7(e7.left)} ${e7.operator} ${ie7(e7.right)}`;
    case "CondUnary":
      return `${e7.operator} ${ie7(e7.operand)}`;
    case "CondNot":
      return `! ${Ze6(e7.operand)}`;
    case "CondAnd":
      return `${Ze6(e7.left)} && ${Ze6(e7.right)}`;
    case "CondOr":
      return `${Ze6(e7.left)} || ${Ze6(e7.right)}`;
    case "CondGroup":
      return `( ${Ze6(e7.expression)} )`;
    case "CondWord":
      return ie7(e7.word);
    default: {
      let t6 = e7;
      throw new Error(`Unsupported conditional expression type: ${t6.type}`);
    }
  }
}
var At5 = class {
  fs;
  commands = /* @__PURE__ */ new Map();
  useDefaultLayout = false;
  limits;
  secureFetch;
  sleepFn;
  traceFn;
  logger;
  defenseInDepthConfig;
  coverageWriter;
  transformPlugins = [];
  state;
  constructor(t6 = {}) {
    let s9 = t6.fs ?? new Ie7(t6.files);
    this.fs = s9, this.useDefaultLayout = !t6.cwd && !t6.files;
    let r8 = t6.cwd || (this.useDefaultLayout ? "/home/user" : "/"), n23 = new Map([["HOME", this.useDefaultLayout ? "/home/user" : "/"], ["PATH", "/usr/bin:/bin"], ["IFS", ` 	
`], ["OSTYPE", "linux-gnu"], ["MACHTYPE", "x86_64-pc-linux-gnu"], ["HOSTTYPE", "x86_64"], ["HOSTNAME", "localhost"], ["PWD", r8], ["OLDPWD", r8], ["OPTIND", "1"], ...Object.entries(t6.env ?? {})]);
    if (this.limits = fi({ ...t6.executionLimits, ...t6.maxCallDepth !== void 0 && { maxCallDepth: t6.maxCallDepth }, ...t6.maxCommandCount !== void 0 && { maxCommandCount: t6.maxCommandCount }, ...t6.maxLoopIterations !== void 0 && { maxLoopIterations: t6.maxLoopIterations } }), t6.fetch ? this.secureFetch = t6.fetch : t6.network && (this.secureFetch = yr2(t6.network)), this.sleepFn = t6.sleep, this.traceFn = t6.trace, this.logger = t6.logger, this.defenseInDepthConfig = t6.defenseInDepth, this.coverageWriter = t6.coverage, this.state = { env: n23, cwd: r8, previousDir: "/home/user", functions: /* @__PURE__ */ new Map(), localScopes: [], callDepth: 0, sourceDepth: 0, commandCount: 0, lastExitCode: 0, lastArg: "", startTime: Date.now(), lastBackgroundPid: 0, virtualPid: t6.processInfo?.pid ?? 1, virtualPpid: t6.processInfo?.ppid ?? 0, virtualUid: t6.processInfo?.uid ?? 1e3, virtualGid: t6.processInfo?.gid ?? 1e3, bashPid: t6.processInfo?.pid ?? 1, nextVirtualPid: (t6.processInfo?.pid ?? 1) + 1, currentLine: 1, options: { errexit: false, pipefail: false, nounset: false, xtrace: false, verbose: false, posix: false, allexport: false, noclobber: false, noglob: false, noexec: false, vi: false, emacs: false }, shoptOptions: { extglob: false, dotglob: false, nullglob: false, failglob: false, globstar: false, globskipdots: true, nocaseglob: false, nocasematch: false, expand_aliases: false, lastpipe: false, xpg_echo: false }, inCondition: false, loopDepth: 0, exportedVars: /* @__PURE__ */ new Set(["HOME", "PATH", "PWD", "OLDPWD", ...Object.keys(t6.env || {})]), readonlyVars: /* @__PURE__ */ new Set(["SHELLOPTS", "BASHOPTS"]), hashTable: /* @__PURE__ */ new Map() }, this.state.env.set("SHELLOPTS", bs2(this.state.options)), this.state.env.set("BASHOPTS", Es2(this.state.shoptOptions)), qr2(s9, this.useDefaultLayout, { pid: this.state.virtualPid, ppid: this.state.virtualPpid, uid: this.state.virtualUid, gid: this.state.virtualGid }), r8 !== "/" && s9 instanceof Ie7) try {
      s9.mkdirSync(r8, { recursive: true });
    } catch {
    }
    for (let i10 of Vr(t6.commands)) this.registerCommand(i10);
    if (t6.fetch || t6.network) for (let i10 of Br3()) this.registerCommand(i10);
    if (t6.python) for (let i10 of jr2()) this.registerCommand(i10);
    if (t6.customCommands) for (let i10 of t6.customCommands) Ur2(i10) ? this.registerCommand(Hr3(i10)) : this.registerCommand(i10);
  }
  registerCommand(t6) {
    this.commands.set(t6.name, t6);
    let s9 = this.fs;
    if (typeof s9.writeFileSync == "function") {
      let r8 = `#!/bin/bash
# Built-in command: ${t6.name}
`;
      try {
        s9.writeFileSync(`/bin/${t6.name}`, r8);
      } catch {
      }
      try {
        s9.writeFileSync(`/usr/bin/${t6.name}`, r8);
      } catch {
      }
    }
  }
  logResult(t6) {
    return this.logger && (t6.stdout && this.logger.debug("stdout", { output: t6.stdout }), t6.stderr && this.logger.info("stderr", { output: t6.stderr }), this.logger.info("exit", { exitCode: t6.exitCode })), t6;
  }
  async exec(t6, s9) {
    if (this.state.callDepth === 0 && (this.state.commandCount = 0), this.state.commandCount++, this.state.commandCount > this.limits.maxCommandCount) return { stdout: "", stderr: `bash: maximum command count (${this.limits.maxCommandCount}) exceeded (possible infinite loop). Increase with executionLimits.maxCommandCount option.
`, exitCode: 1, env: n16(this.state.env, s9?.env) };
    if (!t6.trim()) return { stdout: "", stderr: "", exitCode: 0, env: n16(this.state.env, s9?.env) };
    this.logger?.info("exec", { command: t6 });
    let r8 = s9?.cwd ?? this.state.cwd, n23, i10 = r8;
    if (s9?.cwd) if (s9.env && "PWD" in s9.env) n23 = s9.env.PWD;
    else if (s9?.env && !("PWD" in s9.env)) try {
      n23 = await this.fs.realpath(r8), i10 = n23;
    } catch {
      n23 = r8;
    }
    else n23 = r8;
    let o9 = new Map(this.state.env);
    if (s9?.env) for (let [f11, d16] of Object.entries(s9.env)) o9.set(f11, d16);
    n23 !== void 0 && o9.set("PWD", n23);
    let a7 = { ...this.state, env: o9, cwd: i10, functions: new Map(this.state.functions), localScopes: [...this.state.localScopes], options: { ...this.state.options }, hashTable: this.state.hashTable, groupStdin: s9?.stdin }, l8 = t6;
    s9?.rawScript || (l8 = bi(t6));
    let u11 = (this.defenseInDepthConfig ? ut6.getInstance(this.defenseInDepthConfig) : null)?.activate();
    try {
      let f11 = async () => {
        let d16 = hi(l8, { maxHeredocSize: this.limits.maxHeredocSize }), h17;
        if (this.transformPlugins.length > 0) {
          let v21 = /* @__PURE__ */ Object.create(null);
          for (let P20 of this.transformPlugins) {
            let y18 = P20.transform({ ast: d16, metadata: v21 });
            d16 = y18.ast, y18.metadata && (v21 = { ...v21, ...y18.metadata });
          }
          h17 = v21;
        }
        let m25 = { fs: this.fs, commands: this.commands, limits: this.limits, exec: this.exec.bind(this), fetch: this.secureFetch, sleep: this.sleepFn, trace: this.traceFn, coverage: this.coverageWriter }, S17 = await new $t3(m25, a7).executeScript(d16);
        return h17 && (S17.metadata = h17), this.logResult(S17);
      };
      return u11 ? await u11.run(f11) : await f11();
    } catch (f11) {
      if (f11 instanceof d2) return this.logResult({ stdout: f11.stdout, stderr: f11.stderr, exitCode: f11.exitCode, env: n16(this.state.env, s9?.env) });
      if (f11 instanceof f) return this.logResult({ stdout: f11.stdout, stderr: f11.stderr, exitCode: f11.exitCode, env: n16(this.state.env, s9?.env) });
      if (f11 instanceof p) return this.logResult({ stdout: f11.stdout, stderr: f11.stderr, exitCode: 1, env: n16(this.state.env, s9?.env) });
      if (f11 instanceof b2) return this.logResult({ stdout: f11.stdout, stderr: f11.stderr, exitCode: b2.EXIT_CODE, env: n16(this.state.env, s9?.env) });
      if (f11 instanceof J14) return this.logResult({ stdout: "", stderr: `bash: security violation: ${f11.message}
`, exitCode: 1, env: n16(this.state.env, s9?.env) });
      if (f11.name === "ParseException") return this.logResult({ stdout: "", stderr: `bash: syntax error: ${d3(f11.message)}
`, exitCode: 2, env: n16(this.state.env, s9?.env) });
      if (f11 instanceof pe) return this.logResult({ stdout: "", stderr: `bash: ${d3(f11.message)}
`, exitCode: 2, env: n16(this.state.env, s9?.env) });
      if (f11 instanceof RangeError) return this.logResult({ stdout: "", stderr: `bash: ${d3(f11.message)}
`, exitCode: 1, env: n16(this.state.env, s9?.env) });
      throw f11;
    } finally {
      u11?.deactivate();
    }
  }
  async readFile(t6) {
    return this.fs.readFile(this.fs.resolvePath(this.state.cwd, t6));
  }
  async writeFile(t6, s9) {
    return this.fs.writeFile(this.fs.resolvePath(this.state.cwd, t6), s9);
  }
  getCwd() {
    return this.state.cwd;
  }
  getEnv() {
    return r(this.state.env);
  }
  registerTransformPlugin(t6) {
    this.transformPlugins.push(t6);
  }
  transform(t6) {
    let s9 = bi(t6), r8 = hi(s9, { maxHeredocSize: this.limits.maxHeredocSize }), n23 = /* @__PURE__ */ Object.create(null);
    for (let i10 of this.transformPlugins) {
      let o9 = i10.transform({ ast: r8, metadata: n23 });
      r8 = o9.ast, o9.metadata && (n23 = { ...n23, ...o9.metadata });
    }
    return { script: Pt4(r8), ast: r8, metadata: n23 };
  }
};
function bi(e7) {
  let t6 = e7.split(`
`), s9 = [], r8 = [];
  for (let n23 = 0; n23 < t6.length; n23++) {
    let i10 = t6[n23];
    if (r8.length > 0) {
      let l8 = r8[r8.length - 1];
      if ((l8.stripTabs ? i10.replace(/^\t+/, "") : i10) === l8.delimiter) {
        s9.push(i10.trimStart()), r8.pop();
        continue;
      }
      s9.push(i10);
      continue;
    }
    let o9 = i10.trimStart();
    s9.push(o9);
    let a7 = /<<(-?)\s*(['"]?)([\w-]+)\2/g;
    for (let l8 of o9.matchAll(a7)) {
      let c15 = l8[1] === "-", u11 = l8[3];
      r8.push({ delimiter: u11, stripTabs: c15 });
    }
  }
  return s9.join(`
`);
}
var ls2 = class {
  baseFs;
  mounts = /* @__PURE__ */ new Map();
  constructor(t6) {
    if (this.baseFs = t6?.base ?? new Ie7(), t6?.mounts) for (let { mountPoint: s9, filesystem: r8 } of t6.mounts) this.mount(s9, r8);
  }
  mount(t6, s9) {
    this.validateMountPath(t6);
    let r8 = this.normalizePath(t6);
    this.validateMount(r8), this.mounts.set(r8, { mountPoint: r8, filesystem: s9 });
  }
  unmount(t6) {
    let s9 = this.normalizePath(t6);
    if (!this.mounts.has(s9)) throw new Error(`No filesystem mounted at '${t6}'`);
    this.mounts.delete(s9);
  }
  getMounts() {
    return Array.from(this.mounts.values()).map((t6) => ({ mountPoint: t6.mountPoint, filesystem: t6.filesystem }));
  }
  isMountPoint(t6) {
    let s9 = this.normalizePath(t6);
    return this.mounts.has(s9);
  }
  validateMountPath(t6) {
    let s9 = t6.split("/");
    for (let r8 of s9) if (r8 === "." || r8 === "..") throw new Error(`Invalid mount point '${t6}': contains '.' or '..' segments`);
  }
  validateMount(t6) {
    if (t6 === "/") throw new Error("Cannot mount at root '/'");
    for (let s9 of this.mounts.keys()) if (s9 !== t6) {
      if (t6.startsWith(`${s9}/`)) throw new Error(`Cannot mount at '${t6}': inside existing mount '${s9}'`);
      if (s9.startsWith(`${t6}/`)) throw new Error(`Cannot mount at '${t6}': would contain existing mount '${s9}'`);
    }
  }
  normalizePath(t6) {
    if (!t6 || t6 === "/") return "/";
    let s9 = t6.endsWith("/") && t6 !== "/" ? t6.slice(0, -1) : t6;
    s9.startsWith("/") || (s9 = `/${s9}`);
    let r8 = s9.split("/").filter((i10) => i10 && i10 !== "."), n23 = [];
    for (let i10 of r8) i10 === ".." ? n23.pop() : n23.push(i10);
    return `/${n23.join("/")}`;
  }
  routePath(t6) {
    let s9 = this.normalizePath(t6), r8 = null, n23 = 0;
    for (let i10 of this.mounts.values()) {
      let o9 = i10.mountPoint;
      if (s9 === o9) return { fs: i10.filesystem, relativePath: "/" };
      s9.startsWith(`${o9}/`) && o9.length > n23 && (r8 = i10, n23 = o9.length);
    }
    if (r8) {
      let i10 = s9.slice(n23);
      return { fs: r8.filesystem, relativePath: i10 || "/" };
    }
    return { fs: this.baseFs, relativePath: s9 };
  }
  getChildMountPoints(t6) {
    let s9 = this.normalizePath(t6), r8 = s9 === "/" ? "/" : `${s9}/`, n23 = [];
    for (let i10 of this.mounts.keys()) if (i10.startsWith(r8)) {
      let a7 = i10.slice(r8.length).split("/")[0];
      a7 && !n23.includes(a7) && n23.push(a7);
    }
    return n23;
  }
  async readFile(t6, s9) {
    let { fs: r8, relativePath: n23 } = this.routePath(t6);
    return r8.readFile(n23, s9);
  }
  async readFileBuffer(t6) {
    let { fs: s9, relativePath: r8 } = this.routePath(t6);
    return s9.readFileBuffer(r8);
  }
  async writeFile(t6, s9, r8) {
    let { fs: n23, relativePath: i10 } = this.routePath(t6);
    return n23.writeFile(i10, s9, r8);
  }
  async appendFile(t6, s9, r8) {
    let { fs: n23, relativePath: i10 } = this.routePath(t6);
    return n23.appendFile(i10, s9, r8);
  }
  async exists(t6) {
    let s9 = this.normalizePath(t6);
    if (this.mounts.has(s9) || this.getChildMountPoints(s9).length > 0) return true;
    let { fs: n23, relativePath: i10 } = this.routePath(t6);
    return n23.exists(i10);
  }
  async stat(t6) {
    let s9 = this.normalizePath(t6), r8 = this.mounts.get(s9);
    if (r8) try {
      return await r8.filesystem.stat("/");
    } catch {
      return { isFile: false, isDirectory: true, isSymbolicLink: false, mode: 493, size: 0, mtime: /* @__PURE__ */ new Date() };
    }
    if (this.getChildMountPoints(s9).length > 0) try {
      return await this.baseFs.stat(s9);
    } catch {
      return { isFile: false, isDirectory: true, isSymbolicLink: false, mode: 493, size: 0, mtime: /* @__PURE__ */ new Date() };
    }
    let { fs: i10, relativePath: o9 } = this.routePath(t6);
    return i10.stat(o9);
  }
  async lstat(t6) {
    let s9 = this.normalizePath(t6), r8 = this.mounts.get(s9);
    if (r8) try {
      return await r8.filesystem.lstat("/");
    } catch {
      return { isFile: false, isDirectory: true, isSymbolicLink: false, mode: 493, size: 0, mtime: /* @__PURE__ */ new Date() };
    }
    if (this.getChildMountPoints(s9).length > 0) try {
      return await this.baseFs.lstat(s9);
    } catch {
      return { isFile: false, isDirectory: true, isSymbolicLink: false, mode: 493, size: 0, mtime: /* @__PURE__ */ new Date() };
    }
    let { fs: i10, relativePath: o9 } = this.routePath(t6);
    return i10.lstat(o9);
  }
  async mkdir(t6, s9) {
    let r8 = this.normalizePath(t6);
    if (this.mounts.has(r8)) {
      if (s9?.recursive) return;
      throw new Error(`EEXIST: directory already exists, mkdir '${t6}'`);
    }
    if (this.getChildMountPoints(r8).length > 0 && s9?.recursive) return;
    let { fs: i10, relativePath: o9 } = this.routePath(t6);
    return i10.mkdir(o9, s9);
  }
  async readdir(t6) {
    let s9 = this.normalizePath(t6), r8 = /* @__PURE__ */ new Set(), n23 = null, { fs: i10, relativePath: o9 } = this.routePath(t6);
    try {
      let l8 = await i10.readdir(o9);
      for (let c15 of l8) r8.add(c15);
    } catch (l8) {
      let c15 = l8.code, u11 = l8.message || "";
      if (c15 !== "ENOENT" && !u11.includes("ENOENT")) throw l8;
      n23 = l8;
    }
    let a7 = this.getChildMountPoints(s9);
    for (let l8 of a7) r8.add(l8);
    if (r8.size === 0 && n23 && !this.mounts.has(s9)) throw n23;
    return Array.from(r8).sort();
  }
  async rm(t6, s9) {
    let r8 = this.normalizePath(t6);
    if (this.mounts.has(r8)) throw new Error(`EBUSY: mount point, cannot remove '${t6}'`);
    if (this.getChildMountPoints(r8).length > 0) throw new Error(`EBUSY: contains mount points, cannot remove '${t6}'`);
    let { fs: i10, relativePath: o9 } = this.routePath(t6);
    return i10.rm(o9, s9);
  }
  async cp(t6, s9, r8) {
    let n23 = this.routePath(t6), i10 = this.routePath(s9);
    return n23.fs === i10.fs ? n23.fs.cp(n23.relativePath, i10.relativePath, r8) : this.crossMountCopy(t6, s9, r8);
  }
  async mv(t6, s9) {
    let r8 = this.normalizePath(t6);
    if (this.mounts.has(r8)) throw new Error(`EBUSY: mount point, cannot move '${t6}'`);
    let n23 = this.routePath(t6), i10 = this.routePath(s9);
    if (n23.fs === i10.fs) return n23.fs.mv(n23.relativePath, i10.relativePath);
    await this.cp(t6, s9, { recursive: true }), await this.rm(t6, { recursive: true });
  }
  resolvePath(t6, s9) {
    if (s9.startsWith("/")) return this.normalizePath(s9);
    let r8 = t6 === "/" ? `/${s9}` : `${t6}/${s9}`;
    return this.normalizePath(r8);
  }
  getAllPaths() {
    let t6 = /* @__PURE__ */ new Set();
    for (let s9 of this.baseFs.getAllPaths()) t6.add(s9);
    for (let s9 of this.mounts.keys()) {
      let r8 = s9.split("/").filter(Boolean), n23 = "";
      for (let o9 of r8) n23 = `${n23}/${o9}`, t6.add(n23);
      let i10 = this.mounts.get(s9);
      if (i10) for (let o9 of i10.filesystem.getAllPaths()) o9 === "/" ? t6.add(s9) : t6.add(`${s9}${o9}`);
    }
    return Array.from(t6).sort();
  }
  async chmod(t6, s9) {
    let r8 = this.normalizePath(t6), n23 = this.mounts.get(r8);
    if (n23) return n23.filesystem.chmod("/", s9);
    let { fs: i10, relativePath: o9 } = this.routePath(t6);
    return i10.chmod(o9, s9);
  }
  async symlink(t6, s9) {
    let { fs: r8, relativePath: n23 } = this.routePath(s9);
    return r8.symlink(t6, n23);
  }
  async link(t6, s9) {
    let r8 = this.routePath(t6), n23 = this.routePath(s9);
    if (r8.fs !== n23.fs) throw new Error(`EXDEV: cross-device link not permitted, link '${t6}' -> '${s9}'`);
    return r8.fs.link(r8.relativePath, n23.relativePath);
  }
  async readlink(t6) {
    let { fs: s9, relativePath: r8 } = this.routePath(t6);
    return s9.readlink(r8);
  }
  async realpath(t6) {
    let s9 = this.normalizePath(t6);
    if (this.mounts.get(s9)) return s9;
    let { fs: n23, relativePath: i10 } = this.routePath(t6), o9 = await n23.realpath(i10);
    for (let [a7, l8] of this.mounts) if (s9 === a7 || s9.startsWith(`${a7}/`)) return o9 === "/" ? a7 : `${a7}${o9}`;
    return o9;
  }
  async crossMountCopy(t6, s9, r8) {
    let n23 = await this.lstat(t6);
    if (n23.isFile) {
      let i10 = await this.readFileBuffer(t6);
      await this.writeFile(s9, i10), await this.chmod(s9, n23.mode);
    } else if (n23.isDirectory) {
      if (!r8?.recursive) throw new Error(`cp: ${t6} is a directory (not copied)`);
      await this.mkdir(s9, { recursive: true });
      let i10 = await this.readdir(t6);
      for (let o9 of i10) {
        let a7 = t6 === "/" ? `/${o9}` : `${t6}/${o9}`, l8 = s9 === "/" ? `/${o9}` : `${s9}/${o9}`;
        await this.crossMountCopy(a7, l8, r8);
      }
    } else if (n23.isSymbolicLink) {
      let i10 = await this.readlink(t6);
      await this.symlink(i10, s9);
    }
  }
  async utimes(t6, s9, r8) {
    let { fs: n23, relativePath: i10 } = this.routePath(t6);
    return n23.utimes(i10, s9, r8);
  }
};
var Na = "/home/user/project";
var ft6 = class {
  root;
  canonicalRoot;
  mountPoint;
  readOnly;
  maxFileReadSize;
  allowSymlinks;
  memory = /* @__PURE__ */ new Map();
  deleted = /* @__PURE__ */ new Set();
  constructor(t6) {
    this.root = resolve(t6.root);
    let s9 = t6.mountPoint ?? Na;
    if (this.mountPoint = s9 === "/" ? "/" : s9.replace(/\/+$/, ""), !this.mountPoint.startsWith("/")) throw new Error(`Mount point must be an absolute path: ${s9}`);
    this.readOnly = t6.readOnly ?? false, this.maxFileReadSize = t6.maxFileReadSize ?? 10485760, this.allowSymlinks = t6.allowSymlinks ?? false, m3(this.root, "OverlayFs"), this.canonicalRoot = (void 0)(this.root), this.createMountPointDirs();
  }
  assertWritable(t6) {
    if (this.readOnly) throw new Error(`EROFS: read-only file system, ${t6}`);
  }
  createMountPointDirs() {
    let t6 = this.mountPoint.split("/").filter(Boolean), s9 = "";
    for (let r8 of t6) s9 += `/${r8}`, this.memory.has(s9) || this.memory.set(s9, { type: "directory", mode: 493, mtime: /* @__PURE__ */ new Date() });
    this.memory.has("/") || this.memory.set("/", { type: "directory", mode: 493, mtime: /* @__PURE__ */ new Date() });
  }
  getMountPoint() {
    return this.mountPoint;
  }
  mkdirSync(t6, s9) {
    let n23 = y2(t6).split("/").filter(Boolean), i10 = "";
    for (let o9 of n23) i10 += `/${o9}`, this.memory.has(i10) || this.memory.set(i10, { type: "directory", mode: 493, mtime: /* @__PURE__ */ new Date() });
  }
  writeFileSync(t6, s9) {
    let r8 = y2(t6), n23 = this.getDirname(r8);
    n23 !== "/" && this.mkdirSync(n23);
    let i10 = s9 instanceof Uint8Array ? s9 : new TextEncoder().encode(s9);
    this.memory.set(r8, { type: "file", content: i10, mode: 420, mtime: /* @__PURE__ */ new Date() });
  }
  getDirname(t6) {
    let s9 = t6.lastIndexOf("/");
    return s9 === 0 ? "/" : t6.slice(0, s9);
  }
  getRelativeToMount(t6) {
    return this.mountPoint === "/" ? t6 : t6 === this.mountPoint ? "/" : t6.startsWith(`${this.mountPoint}/`) ? t6.slice(this.mountPoint.length) : null;
  }
  toRealPath(t6) {
    let s9 = y2(t6), r8 = this.getRelativeToMount(s9);
    if (r8 === null) return null;
    let n23 = join(this.root, r8), i10 = resolve(n23);
    return f2(i10, this.root) ? i10 : null;
  }
  dirname(t6) {
    let s9 = y2(t6);
    if (s9 === "/") return "/";
    let r8 = s9.lastIndexOf("/");
    return r8 === 0 ? "/" : s9.slice(0, r8);
  }
  resolveRealPath_(t6) {
    return t6 ? this.allowSymlinks ? a3(t6, this.canonicalRoot) : v3(t6, this.root, this.canonicalRoot) : null;
  }
  resolveRealPathParent_(t6) {
    if (!t6) return null;
    let s9 = dirname(t6), r8 = this.resolveRealPath_(s9);
    return r8 === null ? null : join(r8, basename(t6));
  }
  sanitizeError(t6, s9, r8) {
    let n23 = t6;
    if (n23.path === void 0 && (n23.message?.includes("ELOOP") || n23.message?.includes("EFBIG") || n23.message?.includes("EPERM"))) throw t6;
    let i10 = n23.code || "EIO";
    throw new Error(`${i10}: ${r8} '${s9}'`);
  }
  ensureParentDirs(t6) {
    let s9 = this.dirname(t6);
    s9 !== "/" && (this.memory.has(s9) || (this.ensureParentDirs(s9), this.memory.set(s9, { type: "directory", mode: 493, mtime: /* @__PURE__ */ new Date() })), this.deleted.delete(s9));
  }
  async existsInOverlay(t6) {
    let s9 = y2(t6);
    if (this.deleted.has(s9)) return false;
    if (this.memory.has(s9)) return true;
    let r8 = this.resolveRealPathParent_(this.toRealPath(s9));
    if (!r8) return false;
    try {
      return await promises.lstat(r8), true;
    } catch {
      return false;
    }
  }
  async readFile(t6, s9) {
    let r8 = await this.readFileBuffer(t6), n23 = ve7(s9);
    return Qe6(r8, n23);
  }
  async readFileBuffer(t6, s9 = /* @__PURE__ */ new Set()) {
    S(t6, "open");
    let r8 = y2(t6);
    if (s9.has(r8)) throw new Error(`ELOOP: too many levels of symbolic links, open '${t6}'`);
    if (s9.add(r8), this.deleted.has(r8)) throw new Error(`ENOENT: no such file or directory, open '${t6}'`);
    let n23 = this.memory.get(r8);
    if (n23) {
      if (n23.type === "symlink") {
        let o9 = this.resolveSymlink(r8, n23.target);
        return this.readFileBuffer(o9, s9);
      }
      if (n23.type !== "file") throw new Error(`EISDIR: illegal operation on a directory, read '${t6}'`);
      return n23.content;
    }
    let i10 = this.resolveRealPath_(this.toRealPath(r8));
    if (!i10) throw new Error(`ENOENT: no such file or directory, open '${t6}'`);
    try {
      let o9 = await promises.lstat(i10);
      if (o9.isSymbolicLink()) {
        if (!this.allowSymlinks) throw new Error(`ENOENT: no such file or directory, open '${t6}'`);
        let l8 = await promises.readlink(i10), c15 = this.realTargetToVirtual(r8, l8), u11 = this.resolveSymlink(r8, c15);
        return this.readFileBuffer(u11, s9);
      }
      if (o9.isDirectory()) throw new Error(`EISDIR: illegal operation on a directory, read '${t6}'`);
      if (this.maxFileReadSize > 0 && o9.size > this.maxFileReadSize) throw new Error(`EFBIG: file too large, read '${t6}' (${o9.size} bytes, max ${this.maxFileReadSize})`);
      let a7 = await promises.readFile(i10);
      return new Uint8Array(a7);
    } catch (o9) {
      if (o9.code === "ENOENT") throw new Error(`ENOENT: no such file or directory, open '${t6}'`);
      this.sanitizeError(o9, t6, "open");
    }
  }
  async writeFile(t6, s9, r8) {
    S(t6, "write"), this.assertWritable(`write '${t6}'`);
    let n23 = y2(t6);
    this.ensureParentDirs(n23);
    let i10 = ve7(r8), o9 = De6(s9, i10);
    this.memory.set(n23, { type: "file", content: o9, mode: 420, mtime: /* @__PURE__ */ new Date() }), this.deleted.delete(n23);
  }
  async appendFile(t6, s9, r8) {
    S(t6, "append"), this.assertWritable(`append '${t6}'`);
    let n23 = y2(t6), i10 = ve7(r8), o9 = De6(s9, i10), a7;
    try {
      a7 = await this.readFileBuffer(n23);
    } catch {
      a7 = new Uint8Array(0);
    }
    let l8 = new Uint8Array(a7.length + o9.length);
    l8.set(a7), l8.set(o9, a7.length), this.ensureParentDirs(n23), this.memory.set(n23, { type: "file", content: l8, mode: 420, mtime: /* @__PURE__ */ new Date() }), this.deleted.delete(n23);
  }
  async exists(t6) {
    return t6.includes("\0") ? false : this.existsInOverlay(t6);
  }
  async stat(t6, s9 = /* @__PURE__ */ new Set()) {
    S(t6, "stat");
    let r8 = y2(t6);
    if (s9.has(r8)) throw new Error(`ELOOP: too many levels of symbolic links, stat '${t6}'`);
    if (s9.add(r8), this.deleted.has(r8)) throw new Error(`ENOENT: no such file or directory, stat '${t6}'`);
    let n23 = this.memory.get(r8);
    if (n23) {
      if (n23.type === "symlink") {
        let a7 = this.resolveSymlink(r8, n23.target);
        return this.stat(a7, s9);
      }
      let o9 = 0;
      return n23.type === "file" && (o9 = n23.content.length), { isFile: n23.type === "file", isDirectory: n23.type === "directory", isSymbolicLink: false, mode: n23.mode, size: o9, mtime: n23.mtime };
    }
    let i10 = this.resolveRealPath_(this.toRealPath(r8));
    if (!i10) throw new Error(`ENOENT: no such file or directory, stat '${t6}'`);
    try {
      let o9 = await promises.lstat(i10);
      if (o9.isSymbolicLink()) {
        if (!this.allowSymlinks) throw new Error(`ENOENT: no such file or directory, stat '${t6}'`);
        let a7 = await promises.readlink(i10), l8 = this.realTargetToVirtual(r8, a7), c15 = this.resolveSymlink(r8, l8);
        return this.stat(c15, s9);
      }
      return { isFile: o9.isFile(), isDirectory: o9.isDirectory(), isSymbolicLink: false, mode: o9.mode, size: o9.size, mtime: o9.mtime };
    } catch (o9) {
      if (o9.code === "ENOENT") throw new Error(`ENOENT: no such file or directory, stat '${t6}'`);
      this.sanitizeError(o9, t6, "stat");
    }
  }
  async lstat(t6) {
    S(t6, "lstat");
    let s9 = y2(t6);
    if (this.deleted.has(s9)) throw new Error(`ENOENT: no such file or directory, lstat '${t6}'`);
    let r8 = this.memory.get(s9);
    if (r8) {
      if (r8.type === "symlink") return { isFile: false, isDirectory: false, isSymbolicLink: true, mode: r8.mode, size: r8.target.length, mtime: r8.mtime };
      let i10 = 0;
      return r8.type === "file" && (i10 = r8.content.length), { isFile: r8.type === "file", isDirectory: r8.type === "directory", isSymbolicLink: false, mode: r8.mode, size: i10, mtime: r8.mtime };
    }
    let n23 = this.resolveRealPathParent_(this.toRealPath(s9));
    if (!n23) throw new Error(`ENOENT: no such file or directory, lstat '${t6}'`);
    try {
      let i10 = await promises.lstat(n23);
      return { isFile: i10.isFile(), isDirectory: i10.isDirectory(), isSymbolicLink: i10.isSymbolicLink(), mode: i10.mode, size: i10.size, mtime: i10.mtime };
    } catch (i10) {
      if (i10.code === "ENOENT") throw new Error(`ENOENT: no such file or directory, lstat '${t6}'`);
      this.sanitizeError(i10, t6, "lstat");
    }
  }
  resolveSymlink(t6, s9) {
    if (s9.startsWith("/")) return y2(s9);
    let r8 = this.dirname(t6);
    return y2(r8 === "/" ? `/${s9}` : `${r8}/${s9}`);
  }
  realTargetToVirtual(t6, s9) {
    let r8 = x4(s9, this.canonicalRoot);
    if (r8.withinRoot) {
      if (!(void 0)(s9)) return s9;
      let n23 = r8.relativePath;
      return this.mountPoint === "/" ? n23 : `${this.mountPoint}${n23}`;
    }
    return r8.safeName;
  }
  async mkdir(t6, s9) {
    S(t6, "mkdir"), this.assertWritable(`mkdir '${t6}'`);
    let r8 = y2(t6);
    if (await this.existsInOverlay(r8)) {
      if (!s9?.recursive) throw new Error(`EEXIST: file already exists, mkdir '${t6}'`);
      return;
    }
    let i10 = this.dirname(r8);
    if (i10 !== "/" && !await this.existsInOverlay(i10)) if (s9?.recursive) await this.mkdir(i10, { recursive: true });
    else throw new Error(`ENOENT: no such file or directory, mkdir '${t6}'`);
    this.memory.set(r8, { type: "directory", mode: 493, mtime: /* @__PURE__ */ new Date() }), this.deleted.delete(r8);
  }
  async readdirCore(t6, s9) {
    if (this.deleted.has(s9)) throw new Error(`ENOENT: no such file or directory, scandir '${t6}'`);
    let r8 = /* @__PURE__ */ new Map(), n23 = /* @__PURE__ */ new Set(), i10 = s9 === "/" ? "/" : `${s9}/`;
    for (let a7 of this.deleted) if (a7.startsWith(i10)) {
      let l8 = a7.slice(i10.length), c15 = l8.split("/")[0];
      c15 && !l8.includes("/", c15.length) && n23.add(c15);
    }
    for (let [a7, l8] of this.memory) if (a7 !== s9 && a7.startsWith(i10)) {
      let c15 = a7.slice(i10.length), u11 = c15.split("/")[0];
      u11 && !n23.has(u11) && !c15.includes("/", 1) && r8.set(u11, { name: u11, isFile: l8.type === "file", isDirectory: l8.type === "directory", isSymbolicLink: l8.type === "symlink" });
    }
    let o9 = this.resolveRealPath_(this.toRealPath(s9));
    if (o9) try {
      let a7 = await promises.readdir(o9, { withFileTypes: true });
      for (let l8 of a7) !n23.has(l8.name) && !r8.has(l8.name) && r8.set(l8.name, { name: l8.name, isFile: l8.isFile(), isDirectory: l8.isDirectory(), isSymbolicLink: l8.isSymbolicLink() });
    } catch (a7) {
      if (a7.code === "ENOENT") {
        if (!this.memory.has(s9)) throw new Error(`ENOENT: no such file or directory, scandir '${t6}'`);
      } else a7.code !== "ENOTDIR" && this.sanitizeError(a7, t6, "scandir");
    }
    return r8;
  }
  async resolveForReaddir(t6, s9 = false) {
    let r8 = y2(t6), n23 = /* @__PURE__ */ new Set(), i10 = s9, o9 = this.memory.get(r8);
    for (; o9 && o9.type === "symlink"; ) {
      if (n23.has(r8)) throw new Error(`ELOOP: too many levels of symbolic links, scandir '${t6}'`);
      n23.add(r8), i10 = true, r8 = this.resolveSymlink(r8, o9.target), o9 = this.memory.get(r8);
    }
    if (o9) return { normalized: r8, outsideOverlay: false };
    if (this.getRelativeToMount(r8) === null) return { normalized: r8, outsideOverlay: true };
    let l8 = this.resolveRealPath_(this.toRealPath(r8));
    if (!l8) return { normalized: r8, outsideOverlay: true };
    try {
      if ((await promises.lstat(l8)).isSymbolicLink()) {
        if (!this.allowSymlinks) return { normalized: r8, outsideOverlay: true };
        let u11 = await promises.readlink(l8), f11 = this.realTargetToVirtual(r8, u11), d16 = this.resolveSymlink(r8, f11);
        return this.resolveForReaddir(d16, true);
      }
      return { normalized: r8, outsideOverlay: false };
    } catch {
      return i10 ? { normalized: r8, outsideOverlay: true } : { normalized: r8, outsideOverlay: false };
    }
  }
  async readdir(t6) {
    S(t6, "scandir");
    let { normalized: s9, outsideOverlay: r8 } = await this.resolveForReaddir(t6);
    if (r8) return [];
    let n23 = await this.readdirCore(t6, s9);
    return Array.from(n23.keys()).sort((i10, o9) => i10 < o9 ? -1 : i10 > o9 ? 1 : 0);
  }
  async readdirWithFileTypes(t6) {
    S(t6, "scandir");
    let { normalized: s9, outsideOverlay: r8 } = await this.resolveForReaddir(t6);
    if (r8) return [];
    let n23 = await this.readdirCore(t6, s9);
    return Array.from(n23.values()).sort((i10, o9) => i10.name < o9.name ? -1 : i10.name > o9.name ? 1 : 0);
  }
  async rm(t6, s9) {
    S(t6, "rm"), this.assertWritable(`rm '${t6}'`);
    let r8 = y2(t6);
    if (!await this.existsInOverlay(r8)) {
      if (s9?.force) return;
      throw new Error(`ENOENT: no such file or directory, rm '${t6}'`);
    }
    try {
      if ((await this.stat(r8)).isDirectory) {
        let o9 = await this.readdir(r8);
        if (o9.length > 0) {
          if (!s9?.recursive) throw new Error(`ENOTEMPTY: directory not empty, rm '${t6}'`);
          for (let a7 of o9) {
            let l8 = r8 === "/" ? `/${a7}` : `${r8}/${a7}`;
            await this.rm(l8, s9);
          }
        }
      }
    } catch (i10) {
      if (i10 instanceof Error && (i10.message.includes("ENOTEMPTY") || i10.message.includes("EISDIR"))) throw i10;
    }
    this.deleted.add(r8), this.memory.delete(r8);
  }
  async cp(t6, s9, r8) {
    S(t6, "cp"), S(s9, "cp"), this.assertWritable(`cp '${s9}'`);
    let n23 = y2(t6), i10 = y2(s9);
    if (!await this.existsInOverlay(n23)) throw new Error(`ENOENT: no such file or directory, cp '${t6}'`);
    let a7 = await this.stat(n23);
    if (a7.isFile) {
      let l8 = await this.readFileBuffer(n23);
      await this.writeFile(i10, l8);
    } else if (a7.isDirectory) {
      if (!r8?.recursive) throw new Error(`EISDIR: is a directory, cp '${t6}'`);
      await this.mkdir(i10, { recursive: true });
      let l8 = await this.readdir(n23);
      for (let c15 of l8) {
        let u11 = n23 === "/" ? `/${c15}` : `${n23}/${c15}`, f11 = i10 === "/" ? `/${c15}` : `${i10}/${c15}`;
        await this.cp(u11, f11, r8);
      }
    }
  }
  async mv(t6, s9) {
    this.assertWritable(`mv '${s9}'`), await this.cp(t6, s9, { recursive: true }), await this.rm(t6, { recursive: true });
  }
  resolvePath(t6, s9) {
    if (s9.startsWith("/")) return y2(s9);
    let r8 = t6 === "/" ? `/${s9}` : `${t6}/${s9}`;
    return y2(r8);
  }
  getAllPaths() {
    let t6 = new Set(this.memory.keys());
    for (let s9 of this.deleted) t6.delete(s9);
    return this.scanRealFs("/", t6), Array.from(t6);
  }
  scanRealFs(t6, s9) {
    if (this.deleted.has(t6)) return;
    let r8 = this.resolveRealPath_(this.toRealPath(t6));
    if (r8) try {
      let n23 = readdirSync(r8);
      for (let i10 of n23) {
        let o9 = t6 === "/" ? `/${i10}` : `${t6}/${i10}`;
        if (this.deleted.has(o9)) continue;
        s9.add(o9);
        let a7 = join(r8, i10);
        (void 0)(a7).isDirectory() && this.scanRealFs(o9, s9);
      }
    } catch {
    }
  }
  async chmod(t6, s9) {
    S(t6, "chmod"), this.assertWritable(`chmod '${t6}'`);
    let r8 = y2(t6);
    if (!await this.existsInOverlay(r8)) throw new Error(`ENOENT: no such file or directory, chmod '${t6}'`);
    let i10 = this.memory.get(r8);
    if (i10) {
      i10.mode = s9;
      return;
    }
    let o9 = await this.stat(r8);
    if (o9.isFile) {
      let a7 = await this.readFileBuffer(r8);
      this.memory.set(r8, { type: "file", content: a7, mode: s9, mtime: /* @__PURE__ */ new Date() });
    } else o9.isDirectory && this.memory.set(r8, { type: "directory", mode: s9, mtime: /* @__PURE__ */ new Date() });
  }
  async symlink(t6, s9) {
    if (!this.allowSymlinks) throw new Error(`EPERM: operation not permitted, symlink '${s9}'`);
    S(s9, "symlink"), this.assertWritable(`symlink '${s9}'`);
    let r8 = y2(s9);
    if (await this.existsInOverlay(r8)) throw new Error(`EEXIST: file already exists, symlink '${s9}'`);
    this.ensureParentDirs(r8), this.memory.set(r8, { type: "symlink", target: t6, mode: 511, mtime: /* @__PURE__ */ new Date() }), this.deleted.delete(r8);
  }
  async link(t6, s9) {
    S(t6, "link"), S(s9, "link"), this.assertWritable(`link '${s9}'`);
    let r8 = y2(t6), n23 = y2(s9);
    if (!await this.existsInOverlay(r8)) throw new Error(`ENOENT: no such file or directory, link '${t6}'`);
    let o9 = await this.stat(r8);
    if (!o9.isFile) throw new Error(`EPERM: operation not permitted, link '${t6}'`);
    if (await this.existsInOverlay(n23)) throw new Error(`EEXIST: file already exists, link '${s9}'`);
    let l8 = await this.readFileBuffer(r8);
    this.ensureParentDirs(n23), this.memory.set(n23, { type: "file", content: l8, mode: o9.mode, mtime: /* @__PURE__ */ new Date() }), this.deleted.delete(n23);
  }
  async readlink(t6) {
    S(t6, "readlink");
    let s9 = y2(t6);
    if (this.deleted.has(s9)) throw new Error(`ENOENT: no such file or directory, readlink '${t6}'`);
    let r8 = this.memory.get(s9);
    if (r8) {
      if (r8.type !== "symlink") throw new Error(`EINVAL: invalid argument, readlink '${t6}'`);
      return r8.target;
    }
    let n23 = this.resolveRealPathParent_(this.toRealPath(s9));
    if (!n23) throw new Error(`ENOENT: no such file or directory, readlink '${t6}'`);
    try {
      let i10 = await promises.readlink(n23);
      if (!(void 0)(i10)) {
        let o9 = resolve(dirname(n23), i10), a7;
        try {
          a7 = (void 0)(o9);
        } catch {
          a7 = o9;
        }
        if (!f2(a7, this.canonicalRoot)) return basename(i10);
      }
      return this.realTargetToVirtual(s9, i10);
    } catch (i10) {
      if (i10.code === "ENOENT") throw new Error(`ENOENT: no such file or directory, readlink '${t6}'`);
      if (i10.code === "EINVAL") throw new Error(`EINVAL: invalid argument, readlink '${t6}'`);
      this.sanitizeError(i10, t6, "readlink");
    }
  }
  async realpath(t6) {
    S(t6, "realpath");
    let s9 = y2(t6), r8 = /* @__PURE__ */ new Set(), n23 = async (a7) => {
      let l8 = a7 === "/" ? [] : a7.slice(1).split("/"), c15 = "";
      for (let u11 of l8) {
        if (c15 = `${c15}/${u11}`, r8.has(c15)) throw new Error(`ELOOP: too many levels of symbolic links, realpath '${t6}'`);
        if (this.deleted.has(c15)) throw new Error(`ENOENT: no such file or directory, realpath '${t6}'`);
        let f11 = this.memory.get(c15), d16 = 0, h17 = 40;
        for (; f11 && f11.type === "symlink" && d16 < h17; ) {
          if (r8.add(c15), c15 = this.resolveSymlink(c15, f11.target), d16++, r8.has(c15)) throw new Error(`ELOOP: too many levels of symbolic links, realpath '${t6}'`);
          if (this.deleted.has(c15)) throw new Error(`ENOENT: no such file or directory, realpath '${t6}'`);
          f11 = this.memory.get(c15);
        }
        if (d16 >= h17) throw new Error(`ELOOP: too many levels of symbolic links, realpath '${t6}'`);
        if (!f11) {
          let m25 = this.toRealPath(c15), p17 = this.resolveRealPath_(m25);
          if (p17) try {
            if ((await promises.lstat(p17)).isSymbolicLink()) {
              if (!this.allowSymlinks) throw new Error(`ENOENT: no such file or directory, realpath '${t6}'`);
              let S17 = await promises.readlink(p17), v21 = this.realTargetToVirtual(c15, S17);
              return r8.add(c15), c15 = this.resolveSymlink(c15, v21), n23(c15);
            }
          } catch (g18) {
            if (g18.code === "ENOENT") throw new Error(`ENOENT: no such file or directory, realpath '${t6}'`);
            this.sanitizeError(g18, t6, "realpath");
          }
          else if (!this.allowSymlinks) {
            let g18 = this.resolveRealPathParent_(m25);
            if (g18) try {
              if ((await promises.lstat(g18)).isSymbolicLink()) throw new Error(`ENOENT: no such file or directory, realpath '${t6}'`);
            } catch (S17) {
              if (S17.message?.includes("ENOENT") || S17.message?.includes("ELOOP")) throw new Error(`ENOENT: no such file or directory, realpath '${t6}'`);
              this.sanitizeError(S17, t6, "realpath");
            }
          }
        }
      }
      return c15 || "/";
    }, i10 = await n23(s9);
    if (!await this.existsInOverlay(i10)) throw new Error(`ENOENT: no such file or directory, realpath '${t6}'`);
    return i10;
  }
  async utimes(t6, s9, r8) {
    S(t6, "utimes"), this.assertWritable(`utimes '${t6}'`);
    let n23 = y2(t6);
    if (!await this.existsInOverlay(n23)) throw new Error(`ENOENT: no such file or directory, utimes '${t6}'`);
    let o9 = this.memory.get(n23);
    if (o9) {
      o9.mtime = r8;
      return;
    }
    let a7 = await this.stat(n23);
    if (a7.isFile) {
      let l8 = await this.readFileBuffer(n23);
      this.memory.set(n23, { type: "file", content: l8, mode: a7.mode, mtime: r8 });
    } else a7.isDirectory && this.memory.set(n23, { type: "directory", mode: a7.mode, mtime: r8 });
  }
};
var cs2 = class {
  root;
  canonicalRoot;
  maxFileReadSize;
  allowSymlinks;
  constructor(t6) {
    this.root = resolve(t6.root), this.maxFileReadSize = t6.maxFileReadSize ?? 10485760, this.allowSymlinks = t6.allowSymlinks ?? false, m3(this.root, "ReadWriteFs"), this.canonicalRoot = (void 0)(this.root);
  }
  resolveAndValidate(t6, s9) {
    let r8 = this.allowSymlinks ? a3(t6, this.canonicalRoot) : v3(t6, this.root, this.canonicalRoot);
    if (r8 === null) throw new Error(`EACCES: permission denied, '${s9}' resolves outside sandbox`);
    return r8;
  }
  validateParent(t6, s9) {
    let r8 = dirname(t6), n23 = this.resolveAndValidate(r8, s9);
    return join(n23, basename(t6));
  }
  toRealPath(t6) {
    let s9 = y2(t6), r8 = join(this.root, s9);
    return resolve(r8);
  }
  async readFile(t6, s9) {
    let r8 = await this.readFileBuffer(t6), n23 = ve7(s9);
    return Qe6(r8, n23);
  }
  async readFileBuffer(t6) {
    S(t6, "open");
    let s9 = this.toRealPath(t6), r8 = this.resolveAndValidate(s9, t6);
    try {
      if (this.maxFileReadSize > 0) {
        let i10 = await promises.stat(r8);
        if (i10.size > this.maxFileReadSize) throw new Error(`EFBIG: file too large, read '${t6}' (${i10.size} bytes, max ${this.maxFileReadSize})`);
      }
      let n23 = await promises.readFile(r8);
      return new Uint8Array(n23);
    } catch (n23) {
      let i10 = n23;
      if (i10.code === "ENOENT") throw new Error(`ENOENT: no such file or directory, open '${t6}'`);
      if (i10.code === "EISDIR") throw new Error(`EISDIR: illegal operation on a directory, read '${t6}'`);
      this.sanitizeError(n23, t6, "open");
    }
  }
  async writeFile(t6, s9, r8) {
    S(t6, "write");
    let n23 = this.toRealPath(t6), i10 = this.resolveAndValidate(n23, t6), o9 = ve7(r8), a7 = De6(s9, o9), l8 = dirname(i10);
    try {
      await promises.mkdir(l8, { recursive: true }), await promises.writeFile(i10, a7);
    } catch (c15) {
      this.sanitizeError(c15, t6, "write");
    }
  }
  async appendFile(t6, s9, r8) {
    S(t6, "append");
    let n23 = this.toRealPath(t6), i10 = this.resolveAndValidate(n23, t6), o9 = ve7(r8), a7 = De6(s9, o9), l8 = dirname(i10);
    try {
      await promises.mkdir(l8, { recursive: true }), await promises.appendFile(i10, a7);
    } catch (c15) {
      this.sanitizeError(c15, t6, "append");
    }
  }
  async exists(t6) {
    if (t6.includes("\0")) return false;
    let s9 = this.toRealPath(t6);
    try {
      let r8 = this.resolveAndValidate(s9, t6);
      return await promises.access(r8), true;
    } catch {
      return false;
    }
  }
  async stat(t6) {
    S(t6, "stat");
    let s9 = this.toRealPath(t6), r8 = this.resolveAndValidate(s9, t6);
    try {
      let n23 = await promises.stat(r8);
      return { isFile: n23.isFile(), isDirectory: n23.isDirectory(), isSymbolicLink: false, mode: n23.mode, size: n23.size, mtime: n23.mtime };
    } catch (n23) {
      if (n23.code === "ENOENT") throw new Error(`ENOENT: no such file or directory, stat '${t6}'`);
      this.sanitizeError(n23, t6, "stat");
    }
  }
  async lstat(t6) {
    S(t6, "lstat");
    let s9 = this.toRealPath(t6), r8 = this.validateParent(s9, t6);
    try {
      let n23 = await promises.lstat(r8);
      return { isFile: n23.isFile(), isDirectory: n23.isDirectory(), isSymbolicLink: n23.isSymbolicLink(), mode: n23.mode, size: n23.size, mtime: n23.mtime };
    } catch (n23) {
      if (n23.code === "ENOENT") throw new Error(`ENOENT: no such file or directory, lstat '${t6}'`);
      this.sanitizeError(n23, t6, "lstat");
    }
  }
  async mkdir(t6, s9) {
    S(t6, "mkdir");
    let r8 = this.toRealPath(t6), n23 = this.resolveAndValidate(r8, t6);
    try {
      await promises.mkdir(n23, { recursive: s9?.recursive });
    } catch (i10) {
      let o9 = i10;
      if (o9.code === "EEXIST") throw new Error(`EEXIST: file already exists, mkdir '${t6}'`);
      if (o9.code === "ENOENT") throw new Error(`ENOENT: no such file or directory, mkdir '${t6}'`);
      this.sanitizeError(i10, t6, "mkdir");
    }
  }
  async readdir(t6) {
    return (await this.readdirWithFileTypes(t6)).map((r8) => r8.name);
  }
  async readdirWithFileTypes(t6) {
    S(t6, "scandir");
    let s9 = this.toRealPath(t6), r8 = this.resolveAndValidate(s9, t6);
    try {
      return (await promises.readdir(r8, { withFileTypes: true })).map((i10) => ({ name: i10.name, isFile: i10.isFile(), isDirectory: i10.isDirectory(), isSymbolicLink: i10.isSymbolicLink() })).sort((i10, o9) => i10.name < o9.name ? -1 : i10.name > o9.name ? 1 : 0);
    } catch (n23) {
      let i10 = n23;
      if (i10.code === "ENOENT") throw new Error(`ENOENT: no such file or directory, scandir '${t6}'`);
      if (i10.code === "ENOTDIR") throw new Error(`ENOTDIR: not a directory, scandir '${t6}'`);
      this.sanitizeError(n23, t6, "scandir");
    }
  }
  async rm(t6, s9) {
    S(t6, "rm");
    let r8 = this.toRealPath(t6), n23 = this.resolveAndValidate(r8, t6);
    try {
      await promises.rm(n23, { recursive: s9?.recursive ?? false, force: s9?.force ?? false });
    } catch (i10) {
      let o9 = i10;
      if (o9.code === "ENOENT" && !s9?.force) throw new Error(`ENOENT: no such file or directory, rm '${t6}'`);
      if (o9.code === "ENOTEMPTY") throw new Error(`ENOTEMPTY: directory not empty, rm '${t6}'`);
      this.sanitizeError(i10, t6, "rm");
    }
  }
  async cp(t6, s9, r8) {
    S(t6, "cp"), S(s9, "cp");
    let n23 = this.toRealPath(t6), i10 = this.toRealPath(s9), o9 = this.resolveAndValidate(n23, t6), a7 = this.resolveAndValidate(i10, s9);
    try {
      await promises.cp(o9, a7, { recursive: r8?.recursive ?? false, filter: async (l8) => {
        try {
          if ((void 0)(l8).isSymbolicLink()) {
            let u11 = await promises.realpath(l8).catch(() => null);
            return u11 === null ? false : f2(u11, this.canonicalRoot);
          }
          return true;
        } catch (c15) {
          return c15.code === "ENOENT";
        }
      } });
    } catch (l8) {
      let c15 = l8;
      if (c15.code === "ENOENT") throw new Error(`ENOENT: no such file or directory, cp '${t6}'`);
      if (c15.code === "EISDIR") throw new Error(`EISDIR: is a directory, cp '${t6}'`);
      this.sanitizeError(l8, t6, "cp");
    }
  }
  async mv(t6, s9) {
    S(t6, "mv"), S(s9, "mv");
    let r8 = this.toRealPath(t6), n23 = this.toRealPath(s9), i10 = this.validateParent(r8, t6), o9 = this.validateParent(n23, s9);
    try {
      if ((await promises.lstat(i10)).isSymbolicLink()) {
        let c15 = await promises.readlink(i10), u11 = resolve(dirname(o9), c15), f11 = await promises.realpath(u11).catch(() => u11);
        if (!f2(f11, this.canonicalRoot)) throw new Error(`EACCES: permission denied, mv '${t6}' -> '${s9}' would create symlink escaping sandbox`);
      }
    } catch (l8) {
      let c15 = l8;
      if (c15.code === "ENOENT") throw new Error(`ENOENT: no such file or directory, mv '${t6}'`);
      if (c15.message?.includes("EACCES") || c15.message?.includes("escaping sandbox")) throw l8;
    }
    let a7 = dirname(o9);
    try {
      await promises.mkdir(a7, { recursive: true });
    } catch (l8) {
      this.sanitizeError(l8, s9, "mv");
    }
    try {
      await promises.rename(i10, o9);
    } catch (l8) {
      let c15 = l8;
      if (c15.code === "ENOENT") throw new Error(`ENOENT: no such file or directory, mv '${t6}'`);
      if (c15.code === "EXDEV") {
        await this.cp(t6, s9, { recursive: true }), await this.rm(t6, { recursive: true });
        return;
      }
      this.sanitizeError(l8, t6, "mv");
    }
    try {
      if ((void 0)(o9).isDirectory() && this.findEscapingSymlinks(o9).length > 0) throw await promises.rename(o9, i10), new Error(`EACCES: permission denied, mv '${t6}' -> '${s9}' would create symlinks escaping sandbox`);
    } catch (l8) {
      if (l8.message?.includes("EACCES") || l8.message?.includes("escaping sandbox")) throw l8;
    }
  }
  resolvePath(t6, s9) {
    if (s9.startsWith("/")) return y2(s9);
    let r8 = t6 === "/" ? `/${s9}` : `${t6}/${s9}`;
    return y2(r8);
  }
  getAllPaths() {
    let t6 = [];
    return this.scanDir("/", t6), t6;
  }
  sanitizeError(t6, s9, r8) {
    let n23 = t6;
    if (n23.path === void 0 && (n23.message?.includes("EACCES") || n23.message?.includes("escaping sandbox") || n23.message?.includes("EFBIG"))) throw t6;
    let i10 = n23.code || "EIO";
    throw new Error(`${i10}: ${r8} '${s9}'`);
  }
  findEscapingSymlinks(t6) {
    let s9 = [];
    try {
      let r8 = readdirSync(t6);
      for (let n23 of r8) {
        let i10 = join(t6, n23);
        try {
          let o9 = (void 0)(i10);
          if (o9.isSymbolicLink()) {
            let a7 = (void 0)(i10), l8 = resolve(t6, a7), c15;
            try {
              c15 = (void 0)(l8);
            } catch {
              c15 = l8;
            }
            f2(c15, this.canonicalRoot) || s9.push(i10);
          } else o9.isDirectory() && s9.push(...this.findEscapingSymlinks(i10));
        } catch {
        }
      }
    } catch {
    }
    return s9;
  }
  scanDir(t6, s9) {
    let r8 = this.toRealPath(t6), n23;
    try {
      n23 = this.resolveAndValidate(r8, t6);
    } catch {
      return;
    }
    try {
      let i10 = readdirSync(n23);
      for (let o9 of i10) {
        let a7 = t6 === "/" ? `/${o9}` : `${t6}/${o9}`;
        s9.push(a7);
        let l8 = join(n23, o9);
        (void 0)(l8).isDirectory() && this.scanDir(a7, s9);
      }
    } catch {
    }
  }
  async chmod(t6, s9) {
    S(t6, "chmod");
    let r8 = this.toRealPath(t6), n23 = this.resolveAndValidate(r8, t6);
    try {
      await promises.chmod(n23, s9);
    } catch (i10) {
      if (i10.code === "ENOENT") throw new Error(`ENOENT: no such file or directory, chmod '${t6}'`);
      this.sanitizeError(i10, t6, "chmod");
    }
  }
  async symlink(t6, s9) {
    if (!this.allowSymlinks) throw new Error(`EPERM: operation not permitted, symlink '${s9}'`);
    S(s9, "symlink");
    let r8 = this.toRealPath(s9), n23 = this.validateParent(r8, s9), i10 = y2(s9), o9 = y2(dirname(i10)), a7 = t6.startsWith("/") ? y2(t6) : y2(o9 === "/" ? `/${t6}` : `${o9}/${t6}`), l8 = join(this.canonicalRoot, a7), c15 = dirname(n23), u11 = t6.startsWith("/") ? l8 : (void 0)(c15, l8) || ".";
    try {
      await promises.symlink(u11, n23);
    } catch (f11) {
      if (f11.code === "EEXIST") throw new Error(`EEXIST: file already exists, symlink '${s9}'`);
      this.sanitizeError(f11, s9, "symlink");
    }
  }
  async link(t6, s9) {
    S(t6, "link"), S(s9, "link");
    let r8 = this.toRealPath(t6), n23 = this.toRealPath(s9), i10 = this.resolveAndValidate(r8, t6), o9 = this.resolveAndValidate(n23, s9);
    try {
      await promises.link(i10, o9);
    } catch (a7) {
      let l8 = a7;
      if (l8.code === "ENOENT") throw new Error(`ENOENT: no such file or directory, link '${t6}'`);
      if (l8.code === "EEXIST") throw new Error(`EEXIST: file already exists, link '${s9}'`);
      if (l8.code === "EPERM") throw new Error(`EPERM: operation not permitted, link '${t6}'`);
      this.sanitizeError(a7, t6, "link");
    }
  }
  async readlink(t6) {
    S(t6, "readlink");
    let s9 = this.toRealPath(t6), r8 = this.validateParent(s9, t6);
    try {
      let n23 = await promises.readlink(r8), i10 = y2(t6), o9 = dirname(i10), a7 = (void 0)(n23) ? n23 : resolve(dirname(r8), n23), l8 = await promises.realpath(a7).catch(() => a7);
      if (f2(l8, this.canonicalRoot)) {
        let c15 = l8.slice(this.canonicalRoot.length) || "/";
        return o9 === "/" ? c15.startsWith("/") ? c15.slice(1) || "." : c15 : (void 0)(o9, c15);
      }
      return basename(n23);
    } catch (n23) {
      let i10 = n23;
      if (i10.code === "ENOENT") throw new Error(`ENOENT: no such file or directory, readlink '${t6}'`);
      if (i10.code === "EINVAL") throw new Error(`EINVAL: invalid argument, readlink '${t6}'`);
      this.sanitizeError(n23, t6, "readlink");
    }
  }
  async realpath(t6) {
    S(t6, "realpath");
    let s9 = this.toRealPath(t6);
    try {
      this.resolveAndValidate(s9, t6);
    } catch {
      throw new Error(`ENOENT: no such file or directory, realpath '${t6}'`);
    }
    let r8;
    try {
      r8 = await promises.realpath(s9);
    } catch (n23) {
      let i10 = n23;
      if (i10.code === "ENOENT") throw new Error(`ENOENT: no such file or directory, realpath '${t6}'`);
      if (i10.code === "ELOOP") throw new Error(`ELOOP: too many levels of symbolic links, realpath '${t6}'`);
      this.sanitizeError(n23, t6, "realpath");
    }
    if (f2(r8, this.canonicalRoot)) return r8.slice(this.canonicalRoot.length) || "/";
    throw new Error(`ENOENT: no such file or directory, realpath '${t6}'`);
  }
  async utimes(t6, s9, r8) {
    S(t6, "utimes");
    let n23 = this.toRealPath(t6), i10 = this.resolveAndValidate(n23, t6);
    try {
      await promises.utimes(i10, s9, r8);
    } catch (o9) {
      if (o9.code === "ENOENT") throw new Error(`ENOENT: no such file or directory, utimes '${t6}'`);
      this.sanitizeError(o9, t6, "utimes");
    }
  }
};
var dt5 = class {
  cmdId;
  cwd;
  startedAt;
  exitCode;
  bashEnv;
  cmdLine;
  env;
  explicitCwd;
  resultPromise;
  constructor(t6, s9, r8, n23, i10 = false) {
    this.cmdId = crypto.randomUUID(), this.cwd = r8, this.startedAt = /* @__PURE__ */ new Date(), this.bashEnv = t6, this.cmdLine = s9, this.env = n23, this.explicitCwd = i10, this.resultPromise = this.execute();
  }
  async execute() {
    let t6 = this.env || this.explicitCwd ? { cwd: this.explicitCwd ? this.cwd : void 0, env: this.env } : void 0, s9 = await this.bashEnv.exec(this.cmdLine, t6);
    return this.exitCode = s9.exitCode, s9;
  }
  async *logs() {
    let t6 = await this.resultPromise;
    t6.stdout && (yield { type: "stdout", data: t6.stdout, timestamp: /* @__PURE__ */ new Date() }), t6.stderr && (yield { type: "stderr", data: t6.stderr, timestamp: /* @__PURE__ */ new Date() });
  }
  async wait() {
    return await this.resultPromise, this;
  }
  async output() {
    let t6 = await this.resultPromise;
    return t6.stdout + t6.stderr;
  }
  async stdout() {
    return (await this.resultPromise).stdout;
  }
  async stderr() {
    return (await this.resultPromise).stderr;
  }
  async kill() {
  }
};
var us2 = class e6 {
  bashEnv;
  constructor(t6) {
    this.bashEnv = t6;
  }
  static async create(t6) {
    let s9 = t6?.fs;
    if (t6?.overlayRoot) {
      if (t6?.fs) throw new Error("Cannot specify both 'fs' and 'overlayRoot' options");
      s9 = new ft6({ root: t6.overlayRoot });
    }
    let r8 = new At5({ env: t6?.env, cwd: t6?.cwd, fs: s9, maxCallDepth: t6?.maxCallDepth, maxCommandCount: t6?.maxCommandCount, maxLoopIterations: t6?.maxLoopIterations, network: t6?.network });
    return new e6(r8);
  }
  async runCommand(t6, s9) {
    let r8 = s9?.cwd ?? this.bashEnv.getCwd(), n23 = s9?.cwd !== void 0;
    return new dt5(this.bashEnv, t6, r8, s9?.env, n23);
  }
  async writeFiles(t6) {
    for (let [s9, r8] of Object.entries(t6)) {
      let n23;
      typeof r8 == "string" ? n23 = r8 : r8.encoding === "base64" ? n23 = Buffer.from(r8.content, "base64").toString("utf-8") : n23 = r8.content;
      let i10 = s9.substring(0, s9.lastIndexOf("/")) || "/";
      i10 !== "/" && await this.bashEnv.exec(`mkdir -p ${i10}`), await this.bashEnv.writeFile(s9, n23);
    }
  }
  async readFile(t6, s9) {
    let r8 = await this.bashEnv.readFile(t6);
    return s9 === "base64" ? Buffer.from(r8).toString("base64") : r8;
  }
  async mkDir(t6, s9) {
    let r8 = s9?.recursive ? "-p" : "";
    await this.bashEnv.exec(`mkdir ${r8} ${t6}`);
  }
  async stop() {
  }
  async extendTimeout(t6) {
  }
  get domain() {
  }
  get bashEnvInstance() {
    return this.bashEnv;
  }
};
var fs2 = class {
  violations = [];
  violationsByType = /* @__PURE__ */ new Map();
  options;
  constructor(t6 = {}) {
    this.options = { maxViolationsPerType: t6.maxViolationsPerType ?? 100, includeStackTraces: t6.includeStackTraces ?? true, onViolation: t6.onViolation ?? (() => {
    }), logToConsole: t6.logToConsole ?? false };
  }
  record(t6) {
    let s9 = this.options.includeStackTraces ? t6 : { ...t6, stack: void 0 };
    this.violations.unshift(s9);
    let r8 = this.violationsByType.get(t6.type);
    r8 || (r8 = [], this.violationsByType.set(t6.type, r8)), r8.length < this.options.maxViolationsPerType && r8.push(s9), this.options.logToConsole && console.warn(`[SecurityViolation] ${t6.type}: ${t6.message}`, t6.path), this.options.onViolation(s9);
  }
  getViolations() {
    return [...this.violations];
  }
  getViolationsByType(t6) {
    return [...this.violationsByType.get(t6) ?? []];
  }
  getSummary() {
    let t6 = [];
    for (let [s9, r8] of this.violationsByType) {
      if (r8.length === 0) continue;
      let n23 = /* @__PURE__ */ new Set(), i10 = Number.POSITIVE_INFINITY, o9 = 0;
      for (let a7 of r8) n23.add(a7.path), i10 = Math.min(i10, a7.timestamp), o9 = Math.max(o9, a7.timestamp);
      t6.push({ type: s9, count: r8.length, firstSeen: i10, lastSeen: o9, paths: Array.from(n23) });
    }
    return t6.sort((s9, r8) => r8.count - s9.count), t6;
  }
  getTotalCount() {
    return this.violations.length;
  }
  hasViolations() {
    return this.violations.length > 0;
  }
  clear() {
    this.violations = [], this.violationsByType.clear();
  }
  createCallback() {
    return (t6) => this.record(t6);
  }
};
function Ei2() {
  return (e7) => {
    console.warn("[DefenseInDepth] Security violation detected:", `
  Type: ${e7.type}`, `
  Path: ${e7.path}`, `
  Message: ${e7.message}`, e7.executionId ? `
  ExecutionId: ${e7.executionId}` : "");
  };
}
var br2 = class {
  plugins = [];
  use(t6) {
    return this.plugins.push(t6), this;
  }
  transform(t6) {
    let s9 = hi(t6), r8 = /* @__PURE__ */ Object.create(null);
    for (let n23 of this.plugins) {
      let i10 = n23.transform({ ast: s9, metadata: r8 });
      s9 = i10.ast, i10.metadata && (r8 = { ...r8, ...i10.metadata });
    }
    return { script: Pt4(s9), ast: s9, metadata: r8 };
  }
};
var Er3 = class {
  name = "command-collector";
  transform(t6) {
    let s9 = /* @__PURE__ */ new Set();
    return this.walkScript(t6.ast, s9), { ast: t6.ast, metadata: { commands: [...s9].sort() } };
  }
  walkScript(t6, s9) {
    for (let r8 of t6.statements) this.walkStatement(r8, s9);
  }
  walkStatement(t6, s9) {
    for (let r8 of t6.pipelines) this.walkPipeline(r8, s9);
  }
  walkPipeline(t6, s9) {
    for (let r8 of t6.commands) this.walkCommand(r8, s9);
  }
  walkCommand(t6, s9) {
    switch (t6.type) {
      case "SimpleCommand":
        if (t6.name) {
          let r8 = this.extractName(t6.name);
          r8 && s9.add(r8);
        }
        t6.name && this.walkWordParts(t6.name.parts, s9);
        for (let r8 of t6.args) this.walkWordParts(r8.parts, s9);
        for (let r8 of t6.assignments) if (r8.value && this.walkWordParts(r8.value.parts, s9), r8.array) for (let n23 of r8.array) this.walkWordParts(n23.parts, s9);
        break;
      case "If":
        for (let r8 of t6.clauses) {
          for (let n23 of r8.condition) this.walkStatement(n23, s9);
          for (let n23 of r8.body) this.walkStatement(n23, s9);
        }
        if (t6.elseBody) for (let r8 of t6.elseBody) this.walkStatement(r8, s9);
        break;
      case "For":
        if (t6.words) for (let r8 of t6.words) this.walkWordParts(r8.parts, s9);
        for (let r8 of t6.body) this.walkStatement(r8, s9);
        break;
      case "CStyleFor":
        for (let r8 of t6.body) this.walkStatement(r8, s9);
        break;
      case "While":
      case "Until":
        for (let r8 of t6.condition) this.walkStatement(r8, s9);
        for (let r8 of t6.body) this.walkStatement(r8, s9);
        break;
      case "Case":
        this.walkWordParts(t6.word.parts, s9);
        for (let r8 of t6.items) for (let n23 of r8.body) this.walkStatement(n23, s9);
        break;
      case "Subshell":
      case "Group":
        for (let r8 of t6.body) this.walkStatement(r8, s9);
        break;
      case "ArithmeticCommand":
      case "ConditionalCommand":
        break;
      case "FunctionDef":
        this.walkCommand(t6.body, s9);
        break;
    }
  }
  walkWordParts(t6, s9) {
    for (let r8 of t6) switch (r8.type) {
      case "CommandSubstitution":
        this.walkScript(r8.body, s9);
        break;
      case "ProcessSubstitution":
        this.walkScript(r8.body, s9);
        break;
      case "DoubleQuoted":
        this.walkWordParts(r8.parts, s9);
        break;
      case "ParameterExpansion":
        r8.operation && this.walkParameterOp(r8.operation, s9);
        break;
    }
  }
  walkParameterOp(t6, s9) {
    switch (t6.type) {
      case "DefaultValue":
      case "AssignDefault":
      case "UseAlternative":
        this.walkWordParts(t6.word.parts, s9);
        break;
      case "ErrorIfUnset":
        t6.word && this.walkWordParts(t6.word.parts, s9);
        break;
      case "PatternRemoval":
        this.walkWordParts(t6.pattern.parts, s9);
        break;
      case "PatternReplacement":
        this.walkWordParts(t6.pattern.parts, s9), t6.replacement && this.walkWordParts(t6.replacement.parts, s9);
        break;
      case "CaseModification":
        t6.pattern && this.walkWordParts(t6.pattern.parts, s9);
        break;
      case "Indirection":
        t6.innerOp && this.walkParameterOp(t6.innerOp, s9);
        break;
    }
  }
  extractName(t6) {
    return t6.parts.length === 1 && t6.parts[0].type === "Literal" ? t6.parts[0].value : null;
  }
};
var $r2 = class {
  name = "tee";
  options;
  counter = 0;
  constructor(t6) {
    this.options = t6;
  }
  transform(t6) {
    let s9 = [], r8 = this.options.timestamp ?? /* @__PURE__ */ new Date();
    return { ast: this.transformScript(t6.ast, s9, r8), metadata: { teeFiles: s9 } };
  }
  formatTimestamp(t6) {
    return t6.toISOString().replace(/:/g, "-");
  }
  generateStdoutPath(t6, s9, r8) {
    let n23 = this.formatTimestamp(r8), i10 = String(t6).padStart(3, "0");
    return `${this.options.outputDir}/${n23}-${i10}-${s9}.stdout.txt`;
  }
  transformScript(t6, s9, r8) {
    return { ...t6, statements: t6.statements.map((n23) => this.transformStatement(n23, s9, r8)) };
  }
  transformStatement(t6, s9, r8) {
    let n23 = [], i10 = [];
    for (let o9 = 0; o9 < t6.pipelines.length; o9++) {
      let a7 = t6.pipelines[o9];
      o9 > 0 && i10.push(t6.operators[o9 - 1]);
      let l8 = this.transformPipeline(a7, s9, r8);
      if (n23.push(l8.pipeline), l8.origCmdNewIndices !== null) {
        let c15 = l8.origCmdNewIndices;
        i10.push(";"), n23.push(this.makePipestatusSave(c15)), i10.push(";"), n23.push(this.makePipestatusRestore(c15.length, l8.negated));
      }
    }
    return { ...t6, pipelines: n23, operators: i10 };
  }
  transformPipeline(t6, s9, r8) {
    if (t6.commands.length <= 1) return { pipeline: t6, origCmdNewIndices: null, negated: false };
    let n23 = [], i10 = [], o9 = [], a7 = false;
    for (let l8 = 0; l8 < t6.commands.length; l8++) {
      let c15 = t6.commands[l8], u11 = l8 === t6.commands.length - 1;
      if (c15.type !== "SimpleCommand" || !c15.name || !this.shouldTarget(c15)) {
        o9.push(n23.length), n23.push(c15), u11 || i10.push(t6.pipeStderr?.[l8] ?? false);
        continue;
      }
      let f11 = this.getCommandName(c15.name) ?? "unknown", d16 = this.counter++, h17 = this.generateStdoutPath(d16, f11, r8), m25 = this.makeTeeCommand(h17), p17 = this.serializeCommand(c15);
      s9.push({ commandIndex: d16, commandName: f11, command: p17, stdoutFile: h17 }), o9.push(n23.length), n23.push(c15), i10.push(t6.pipeStderr?.[l8] ?? false), n23.push(m25), u11 || i10.push(false), a7 = true;
    }
    return a7 ? { pipeline: { ...t6, negated: false, commands: n23, pipeStderr: i10.length > 0 ? i10 : void 0 }, origCmdNewIndices: o9, negated: t6.negated } : { pipeline: t6, origCmdNewIndices: null, negated: false };
  }
  makePipestatusSave(t6) {
    return { type: "Pipeline", commands: [{ type: "SimpleCommand", assignments: t6.map((s9, r8) => ({ type: "Assignment", name: `__tps${r8}`, value: { type: "Word", parts: [{ type: "ParameterExpansion", parameter: `PIPESTATUS[${s9}]`, operation: null }] }, append: false, array: null })), name: null, args: [], redirections: [] }], negated: false };
  }
  makePipestatusRestore(t6, s9) {
    let r8 = [];
    for (let n23 = 0; n23 < t6; n23++) r8.push({ type: "Subshell", body: [{ type: "Statement", pipelines: [{ type: "Pipeline", commands: [{ type: "SimpleCommand", assignments: [], name: { type: "Word", parts: [{ type: "Literal", value: "exit" }] }, args: [{ type: "Word", parts: [{ type: "ParameterExpansion", parameter: `__tps${n23}`, operation: null }] }], redirections: [] }], negated: false }], operators: [], background: false }], redirections: [] });
    return { type: "Pipeline", commands: r8, negated: s9 };
  }
  shouldTarget(t6) {
    if (!this.options.targetCommandPattern) return true;
    let s9 = this.getCommandName(t6.name);
    return s9 !== null && this.options.targetCommandPattern.test(s9);
  }
  getCommandName(t6) {
    return t6 && t6.parts.length === 1 && t6.parts[0].type === "Literal" ? t6.parts[0].value : null;
  }
  serializeCommand(t6) {
    let s9 = [];
    t6.name && s9.push(ie7(t6.name));
    for (let r8 of t6.args) s9.push(ie7(r8));
    return s9.join(" ");
  }
  makeTeeCommand(t6) {
    return { type: "SimpleCommand", assignments: [], name: { type: "Word", parts: [{ type: "Literal", value: "tee" }] }, args: [{ type: "Word", parts: [{ type: "Literal", value: t6 }] }], redirections: [] };
  }
};
export {
  At5 as Bash,
  br2 as BashTransformPipeline,
  Er3 as CommandCollectorPlugin,
  ut6 as DefenseInDepthBox,
  Ie7 as InMemoryFs,
  ls2 as MountableFs,
  ot6 as NetworkAccessDeniedError,
  ft6 as OverlayFs,
  cs2 as ReadWriteFs,
  lt7 as RedirectNotAllowedError,
  us2 as Sandbox,
  dt5 as SandboxCommand,
  J14 as SecurityViolationError,
  fs2 as SecurityViolationLogger,
  $r2 as TeePlugin,
  at7 as TooManyRedirectsError,
  Ei2 as createConsoleViolationCallback,
  Ci2 as defineCommand,
  Ai as getCommandNames,
  ki2 as getNetworkCommandNames,
  _i3 as getPythonCommandNames,
  hi as parse,
  Pt4 as serialize
};
/*! Bundled license information:

just-bash/dist/bundle/chunks/chunk-YNYSPYQ5.js:
  (*! Bundled license information:
  
  re2js/build/index.esm.js:
    (*!
     * re2js
     * RE2JS is the JavaScript port of RE2, a regular expression engine that provides linear time matching
     *
     * @version v1.2.1
     * @author Alexey Vasiliev
     * @homepage https://github.com/le0pard/re2js#readme
     * @repository github:le0pard/re2js
     * @license MIT
     *)
  *)

just-bash/dist/bundle/chunks/chunk-CR5AFCPT.js:
  (*! Bundled license information:
  
  ieee754/index.js:
    (*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> *)
  *)

just-bash/dist/bundle/chunks/chunk-SYMJJMQ4.js:
  (*! Bundled license information:
  
  papaparse/papaparse.js:
    (* @license
    Papa Parse
    v5.5.3
    https://github.com/mholt/PapaParse
    License: MIT
    *)
  *)

just-bash/dist/bundle/chunks/chunk-XMDVFEVC.js:
  (*! Bundled license information:
  
  smol-toml/dist/error.js:
  smol-toml/dist/util.js:
  smol-toml/dist/date.js:
  smol-toml/dist/primitive.js:
  smol-toml/dist/extract.js:
  smol-toml/dist/struct.js:
  smol-toml/dist/parse.js:
  smol-toml/dist/stringify.js:
  smol-toml/dist/index.js:
    (*!
     * Copyright (c) Squirrel Chat et al., All rights reserved.
     * SPDX-License-Identifier: BSD-3-Clause
     *
     * Redistribution and use in source and binary forms, with or without
     * modification, are permitted provided that the following conditions are met:
     *
     * 1. Redistributions of source code must retain the above copyright notice, this
     *    list of conditions and the following disclaimer.
     * 2. Redistributions in binary form must reproduce the above copyright notice,
     *    this list of conditions and the following disclaimer in the
     *    documentation and/or other materials provided with the distribution.
     * 3. Neither the name of the copyright holder nor the names of its contributors
     *    may be used to endorse or promote products derived from this software without
     *    specific prior written permission.
     *
     * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
     * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
     * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
     * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
     * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
     * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
     * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
     * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
     * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
     * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
     *)
  *)
*/
